/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		76: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"0":"771c2b1e4a5c525539d2","1":"1609f9fd19f057739ff5","2":"de10bbe15f855b9427fb","3":"fa5b858c7aa6b10413cf","4":"f32e0cbfdce045181656","5":"a843d9ba0df63d0af5aa","6":"c29d59b661314a960812","7":"34f861553f6fd7d15682","8":"bb1d628b8eb82cc7c295","9":"ff50a82d4ad441b11265","10":"5ab897a00181cbdc1ac0","11":"1bb17a22ff1d2f6def3e","12":"cf3b805e8f11b2a32737","13":"0802e8aca40555c0be35","14":"28feabdfef6fd01276f7","15":"14ed9109ae4cdb8c2232","16":"c4141d3c79d06fb2ba07","17":"0c047a001fb5985b6046","18":"f70d5b78e93d5b994eab","19":"57a31cd1082b2d08fe5a","20":"c8963a9bf6e9a7287812","21":"b3110a54b018e89b6044","22":"ea11b61f3931f7976420","23":"c434da3ada01367e005f","24":"9309f3cb2c849e6a7c14","25":"9fb3a51d712c1fe86afb","26":"cb5048758958f34108ae","27":"fee3235bcf90fb9d0cd1","28":"21e3064a8b82646959c3","29":"d97ae28f05c38957ac30","30":"91a29c3fcdaa79aee175","31":"cd982645ecb87069c0a5","32":"ab6aa9945800f2f3aabc","33":"9b084ead347ba567bfc9","34":"ac9c792ebc3b8cd2e937","35":"3e8ae71b1a72f4e9d12d","36":"6a6f6593109726b980e9","37":"646824fbbd3e71a50599","38":"2b340106b2c92fafe00d","39":"9bbd216046e68cd40f3b","40":"b93545093a0a9a885bf0","41":"5f94f1320b15a0a48985","42":"fdb9cfd4a846a261e043","43":"0b9dfb9c99aecb29560f","44":"c1993e429ed5b7dff8c9","45":"cf9e638a21a26dd06f2e","46":"2c1c9851ae25983b0647","47":"8c857558fb34493b3e4c","48":"5c3779cd71460a9e674e","49":"b6e274afa686c2a11f19","50":"508d3d9a458e623abecd","51":"f8994d0de737b3080037","52":"ba08e0171fa94769e5da","53":"6eedcdae694ef04684c4","54":"3bb8a36a43b057f19971","55":"75d5b4c79c464984bfc8","56":"58b096c39594f1ef7ecf","57":"a7376e8f156c9ca63542","58":"d77622c3d456059747f1","59":"13005f8e69fc1f64d457","60":"1e24252a53db76ed5feb","61":"3a07c02031acb5694aec","62":"f67ca309e3bf4d4c06a6","63":"fb726f6dbe6b920159be","64":"fe40e04fc83096e605b6","65":"f8e78e37436be63cfb95","66":"4514d873133a3b3a6f02","67":"3f38f81c312d0689140b","68":"9e8026d534b259edafaf","69":"65a347a9349260af00db","70":"6b9027593ec136e82349","71":"ce29b749b080ef87319f","72":"b44ded4f759e4a15fe05","73":"c71b9d972b3ca66f5d3e","74":"d89ccdafe89bd913c98c","75":"b654b2d8f79c0fa9861b"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 553);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );



/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global    = __webpack_require__(6)
  , core      = __webpack_require__(80)
  , hide      = __webpack_require__(41)
  , redefine  = __webpack_require__(42)
  , ctx       = __webpack_require__(81)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchTypes = exports.JobTypes = exports.AlertTypes = exports.AdminTypes = exports.EmojiTypes = exports.IntegrationTypes = exports.PreferenceTypes = exports.FileTypes = exports.PostTypes = exports.ChannelTypes = exports.TeamTypes = exports.UserTypes = exports.GeneralTypes = exports.ErrorTypes = undefined;

var _channels = __webpack_require__(997);

var _channels2 = _interopRequireDefault(_channels);

var _errors = __webpack_require__(998);

var _errors2 = _interopRequireDefault(_errors);

var _general = __webpack_require__(999);

var _general2 = _interopRequireDefault(_general);

var _users = __webpack_require__(1000);

var _users2 = _interopRequireDefault(_users);

var _teams = __webpack_require__(1001);

var _teams2 = _interopRequireDefault(_teams);

var _posts = __webpack_require__(1002);

var _posts2 = _interopRequireDefault(_posts);

var _files = __webpack_require__(1003);

var _files2 = _interopRequireDefault(_files);

var _preferences = __webpack_require__(1004);

var _preferences2 = _interopRequireDefault(_preferences);

var _integrations = __webpack_require__(1005);

var _integrations2 = _interopRequireDefault(_integrations);

var _emojis = __webpack_require__(1006);

var _emojis2 = _interopRequireDefault(_emojis);

var _admin = __webpack_require__(1007);

var _admin2 = _interopRequireDefault(_admin);

var _alerts = __webpack_require__(1008);

var _alerts2 = _interopRequireDefault(_alerts);

var _jobs = __webpack_require__(1009);

var _jobs2 = _interopRequireDefault(_jobs);

var _search = __webpack_require__(1010);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.ErrorTypes = _errors2.default;
exports.GeneralTypes = _general2.default;
exports.UserTypes = _users2.default;
exports.TeamTypes = _teams2.default;
exports.ChannelTypes = _channels2.default;
exports.PostTypes = _posts2.default;
exports.FileTypes = _files2.default;
exports.PreferenceTypes = _preferences2.default;
exports.IntegrationTypes = _integrations2.default;
exports.EmojiTypes = _emojis2.default;
exports.AdminTypes = _admin2.default;
exports.AlertTypes = _alerts2.default;
exports.JobTypes = _jobs2.default;
exports.SearchTypes = _search2.default;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(13);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);








/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;



/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Stats = exports.Teams = exports.Alerts = exports.WebsocketEvents = exports.RequestStatus = exports.Files = exports.Posts = exports.Preferences = exports.General = undefined;

var _general = __webpack_require__(986);

var _general2 = _interopRequireDefault(_general);

var _request_status = __webpack_require__(987);

var _request_status2 = _interopRequireDefault(_request_status);

var _websocket = __webpack_require__(988);

var _websocket2 = _interopRequireDefault(_websocket);

var _preferences = __webpack_require__(989);

var _preferences2 = _interopRequireDefault(_preferences);

var _posts = __webpack_require__(990);

var _posts2 = _interopRequireDefault(_posts);

var _files = __webpack_require__(991);

var _files2 = _interopRequireDefault(_files);

var _alerts = __webpack_require__(992);

var _alerts2 = _interopRequireDefault(_alerts);

var _teams = __webpack_require__(993);

var _teams2 = _interopRequireDefault(_teams);

var _stats = __webpack_require__(994);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.General = _general2.default;
exports.Preferences = _preferences2.default;
exports.Posts = _posts2.default;
exports.Files = _files2.default;
exports.RequestStatus = _request_status2.default;
exports.WebsocketEvents = _websocket2.default;
exports.Alerts = _alerts2.default;
exports.Teams = _teams2.default;
exports.Stats = _stats2.default; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var emptyFunction = __webpack_require__(53);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
'use strict';

/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Constants = exports.ErrorBarTypes = exports.JobStatuses = exports.JobTypes = exports.ErrorPageTypes = exports.StatTypes = exports.PostTypes = exports.TutorialSteps = exports.SocketEvents = exports.UserSearchOptions = exports.UserStatuses = exports.WVCDefault = exports.WebrtcActionTypes = exports.ActionTypes = exports.Preferences = undefined;

var _keyMirror = __webpack_require__(409);

var _keyMirror2 = _interopRequireDefault(_keyMirror);

var _audio = __webpack_require__(410);

var _audio2 = _interopRequireDefault(_audio);

var _video = __webpack_require__(411);

var _video2 = _interopRequireDefault(_video);

var _excel = __webpack_require__(412);

var _excel2 = _interopRequireDefault(_excel);

var _ppt = __webpack_require__(413);

var _ppt2 = _interopRequireDefault(_ppt);

var _pdf = __webpack_require__(414);

var _pdf2 = _interopRequireDefault(_pdf);

var _code = __webpack_require__(415);

var _code2 = _interopRequireDefault(_code);

var _word = __webpack_require__(416);

var _word2 = _interopRequireDefault(_word);

var _patch = __webpack_require__(417);

var _patch2 = _interopRequireDefault(_patch);

var _generic = __webpack_require__(418);

var _generic2 = _interopRequireDefault(_generic);

var _logo_compact = __webpack_require__(925);

var _logo_compact2 = _interopRequireDefault(_logo_compact);

var _webhook_icon = __webpack_require__(926);

var _webhook_icon2 = _interopRequireDefault(_webhook_icon);

var _solarizedDark = __webpack_require__(927);

var _solarizedDark2 = _interopRequireDefault(_solarizedDark);

var _solarizedDark3 = __webpack_require__(928);

var _solarizedDark4 = _interopRequireDefault(_solarizedDark3);

var _solarizedLight = __webpack_require__(929);

var _solarizedLight2 = _interopRequireDefault(_solarizedLight);

var _solarizedLight3 = __webpack_require__(930);

var _solarizedLight4 = _interopRequireDefault(_solarizedLight3);

var _github = __webpack_require__(931);

var _github2 = _interopRequireDefault(_github);

var _github3 = __webpack_require__(932);

var _github4 = _interopRequireDefault(_github3);

var _monokai = __webpack_require__(933);

var _monokai2 = _interopRequireDefault(_monokai);

var _monokai3 = __webpack_require__(934);

var _monokai4 = _interopRequireDefault(_monokai3);

var _organization = __webpack_require__(935);

var _organization2 = _interopRequireDefault(_organization);

var _smart_dark = __webpack_require__(936);

var _smart_dark2 = _interopRequireDefault(_smart_dark);

var _default = __webpack_require__(540);

var _default2 = _interopRequireDefault(_default);

var _windows_dark = __webpack_require__(937);

var _windows_dark2 = _interopRequireDefault(_windows_dark);

var _family = __webpack_require__(938);

var _family2 = _interopRequireDefault(_family);

var _work = __webpack_require__(939);

var _work2 = _interopRequireDefault(_work);

var _fun = __webpack_require__(940);

var _fun2 = _interopRequireDefault(_fun);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/* eslint-disable no-magic-numbers */

var Preferences = exports.Preferences = {
    CATEGORY_DIRECT_CHANNEL_SHOW: 'direct_channel_show',
    CATEGORY_GROUP_CHANNEL_SHOW: 'group_channel_show',
    CATEGORY_DISPLAY_SETTINGS: 'display_settings',
    CATEGORY_ADVANCED_SETTINGS: 'advanced_settings',
    TUTORIAL_STEP: 'tutorial_step',
    CHANNEL_DISPLAY_MODE: 'channel_display_mode',
    CHANNEL_DISPLAY_MODE_CENTERED: 'centered',
    CHANNEL_DISPLAY_MODE_FULL_SCREEN: 'full',
    CHANNEL_DISPLAY_MODE_DEFAULT: 'full',
    MESSAGE_DISPLAY: 'message_display',
    MESSAGE_DISPLAY_CLEAN: 'clean',
    MESSAGE_DISPLAY_COMPACT: 'compact',
    MESSAGE_DISPLAY_DEFAULT: 'clean',
    COLLAPSE_DISPLAY: 'collapse_previews',
    COLLAPSE_DISPLAY_DEFAULT: 'false',
    USE_MILITARY_TIME: 'use_military_time',
    CATEGORY_THEME: 'theme',
    CATEGORY_FLAGGED_POST: 'flagged_post',
    CATEGORY_NOTIFICATIONS: 'notifications',
    CATEGORY_FAVORITE_CHANNEL: 'favorite_channel',
    CATEGORY_VISITED: 'visited',
    CATEGORY_SCREEN_SHARE_VISITED: 'screen_sharing_visited',
    EMAIL_INTERVAL: 'email_interval',
    CATEGORY_CONTACT_SENSITIVE: 'contact_sensitive',
    CATEGORY_DISCLOSE_SENSITIVE_INFO_TO: 'disclose_sensitive_info_to',
    COMPANY_NAME_SENSITIVE: 'companyname',
    MOBILE_SENSITIVE: 'mobile',
    TEL_SENSITIVE: 'tel',
    POSITION_SENSITIVE: 'position',
    INTERVAL_IMMEDIATE: 30, // "immediate" is a 30 second interval
    INTERVAL_FIFTEEN_MINUTES: 15 * 60,
    INTERVAL_HOUR: 60 * 60,
    IMAGE_WATERMARK: 'image_watermark',
    IMAGE_WATERMARK_YES: 'yes',
    IMAGE_WATERMARK_NO: 'no',
    IMAGE_WATERMARK_ASK: 'ask',
    CLASSIC_LAYOUT: 'classic_layout'

};

var ActionTypes = exports.ActionTypes = (0, _keyMirror2.default)({
    RECEIVED_ERROR: null,

    CLICK_CHANNEL: null,
    CREATE_CHANNEL: null,
    CREATE_POST: null,
    CREATE_COMMENT: null,
    POST_DELETED: null,
    POST_UPDATED: null,
    REMOVE_POST: null,

    RECEIVED_CHANNELS: null,
    RECEIVED_CHANNEL: null,
    RECEIVED_CHANNEL_MEMBER: null,
    RECEIVED_MORE_CHANNELS: null,
    RECEIVED_CHANNEL_STATS: null,
    RECEIVED_MY_CHANNEL_MEMBERS: null,
    RECEIVED_MEMBERS_IN_CHANNEL: null,

    FOCUS_POST: null,
    RECEIVED_POSTS: null,
    RECEIVED_FOCUSED_POST: null,
    RECEIVED_POST: null,
    RECEIVED_EDIT_POST: null,
    RECEIVED_SEARCH: null,
    RECEIVED_SEARCH_TERM: null,
    SELECT_POST: null,
    RECEIVED_POST_SELECTED: null,
    RECEIVED_MENTION_DATA: null,
    RECEIVED_ADD_MENTION: null,
    RECEIVED_POST_PINNED: null,
    RECEIVED_POST_UNPINNED: null,
    INCREASE_POST_VISIBILITY: null,
    LOADING_POSTS: null,

    RECEIVED_PROFILES: null,
    RECEIVED_PROFILES_IN_TEAM: null,
    RECEIVED_PROFILES_NOT_IN_TEAM: null,
    RECEIVED_PROFILE: null,
    RECEIVED_PROFILES_IN_CHANNEL: null,
    RECEIVED_PROFILES_NOT_IN_CHANNEL: null,
    RECEIVED_PROFILES_WITHOUT_TEAM: null,
    RECEIVED_ME: null,
    RECEIVED_SESSIONS: null,
    RECEIVED_AUDITS: null,
    RECEIVED_TEAMS: null,
    RECEIVED_STATUSES: null,
    RECEIVED_PREFERENCE: null,
    RECEIVED_PREFERENCES: null,
    DELETED_PREFERENCES: null,
    RECEIVED_FILE_INFOS: null,
    RECEIVED_ANALYTICS: null,

    RECEIVED_INCOMING_WEBHOOKS: null,
    RECEIVED_INCOMING_WEBHOOK: null,
    UPDATED_INCOMING_WEBHOOK: null,
    REMOVED_INCOMING_WEBHOOK: null,
    RECEIVED_OUTGOING_WEBHOOKS: null,
    RECEIVED_OUTGOING_WEBHOOK: null,
    UPDATED_OUTGOING_WEBHOOK: null,
    REMOVED_OUTGOING_WEBHOOK: null,
    RECEIVED_COMMANDS: null,
    RECEIVED_COMMAND: null,
    UPDATED_COMMAND: null,
    REMOVED_COMMAND: null,
    RECEIVED_OAUTHAPPS: null,
    RECEIVED_OAUTHAPP: null,
    REMOVED_OAUTHAPP: null,

    RECEIVED_CUSTOM_EMOJIS: null,
    RECEIVED_CUSTOM_EMOJI: null,
    UPDATED_CUSTOM_EMOJI: null,
    REMOVED_CUSTOM_EMOJI: null,

    RECEIVED_REACTIONS: null,
    ADDED_REACTION: null,
    REMOVED_REACTION: null,

    RECEIVED_MSG: null,

    RECEIVED_TEAM: null,
    RECEIVED_MY_TEAM: null,
    CREATED_TEAM: null,
    UPDATE_TEAM: null,

    RECEIVED_CONFIG: null,
    RECEIVED_LOGS: null,
    RECEIVED_SERVER_AUDITS: null,
    RECEIVED_SERVER_COMPLIANCE_REPORTS: null,
    RECEIVED_ALL_TEAMS: null,
    RECEIVED_ALL_TEAM_LISTINGS: null,
    RECEIVED_MY_TEAM_MEMBERS: null,
    RECEIVED_MY_TEAMS_UNREAD: null,
    RECEIVED_MEMBERS_IN_TEAM: null,
    RECEIVED_TEAM_STATS: null,

    RECEIVED_LOCALE: null,

    UPDATE_OPEN_GRAPH_METADATA: null,
    RECIVED_OPEN_GRAPH_METADATA: null,

    SHOW_SEARCH: null,

    USER_TYPING: null,

    TOGGLE_ACCOUNT_SETTINGS_MODAL: null,
    TOGGLE_TEAM_SETTINGS_MODAL: null,
    TOGGLE_IMPORT_THEME_MODAL: null,
    TOGGLE_INVITE_MEMBER_MODAL: null,
    TOGGLE_INVITE_MEETING_MODAL: null,
    TOGGLE_LEAVE_TEAM_MODAL: null,
    TOGGLE_DELETE_TEAM_MODAL: null,
    TOGGLE_DELETE_POST_MODAL: null,
    TOGGLE_GET_POST_LINK_MODAL: null,
    TOGGLE_FORWARD_POST_MODAL: null,
    TOGGLE_FORWARD_POST_TO_DIRECT_MODAL: null,
    TOGGLE_GET_TEAM_INVITE_LINK_MODAL: null,
    TOGGLE_GET_PUBLIC_LINK_MODAL: null,
    TOGGLE_DM_MODAL: null,
    TOGGLE_QUICK_SWITCH_MODAL: null,
    TOGGLE_CHANNEL_HEADER_UPDATE_MODAL: null,
    TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL: null,
    TOGGLE_CHANNEL_NAME_UPDATE_MODAL: null,
    TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL: null,
    TOGGLE_CHANNEL_IMAGE_UPDATE_MODAL: null,
    // +++ Alan - Add Facebook constant
    TOGGLE_CHANNEL_SELF_DESTRUCT_TIME_UPDATE_MODAL: null,
    TOGGLE_CHANNEL_NEW_MORE_CHANNELS_MODAL: null,
    TOGGLE_STATUS_DESC_MODAL: null,
    // TOGGLE_SWITCH_TEAM_MODAL: null,

    // ---
    TOGGLE_INVITE_ARRIVED_MODAL: null,

    TOGGLE_REACH_USER_LIMIT_MODAL: null,
    TOGGLE_SHORTCUTS_MODAL: null,
    SUGGESTION_PRETEXT_CHANGED: null,
    SUGGESTION_RECEIVED_SUGGESTIONS: null,
    SUGGESTION_CLEAR_SUGGESTIONS: null,
    SUGGESTION_COMPLETE_WORD: null,
    SUGGESTION_SELECT_NEXT: null,
    SUGGESTION_SELECT_PREVIOUS: null,

    BROWSER_CHANGE_FOCUS: null,

    EMOJI_POSTED: null,

    RECEIVED_UDF_STATUS: null,
    DELETED_UDF_STATUS: null,
    RECEIVED_UDF_STATUSES: null
});

var WebrtcActionTypes = exports.WebrtcActionTypes = (0, _keyMirror2.default)({
    INITIALIZE: null,
    NOTIFY: null,
    CHANGED: null,
    ANSWER: null,
    DECLINE: null,
    CANCEL: null,
    NO_ANSWER: null,
    BUSY: null,
    FAILED: null,
    UNSUPPORTED: null,
    MUTED: null,
    IN_PROGRESS: null,
    DISABLED: null,
    RHS: null,
    STATUS_REJECT: null,
    HANG_UP: null,
    VIEWER_JOIN: null,
    OFFLINE: null,
    LIVE_END: null
});

var WVCDefault = exports.WVCDefault = {
    greetingMessage: 'Hi,how can I help you ?',
    titleLabel: 'Welcome on my website! ',
    messagePlaceholder: 'Send the message...'
};

var UserStatuses = exports.UserStatuses = {
    OFFLINE: 'offline',
    AWAY: 'away',
    ONLINE: 'online'
};

var UserSearchOptions = exports.UserSearchOptions = {
    ALLOW_INACTIVE: 'allow_inactive',
    WITHOUT_TEAM: 'without_team'
};

var SocketEvents = exports.SocketEvents = {
    POSTED: 'posted',
    POST_EDITED: 'post_edited',
    POST_DELETED: 'post_deleted',
    // +++ alan - add socket event
    SELF_DESTRUCTED: 'self_destructed',
    POSTS_DELETED: 'posts_deleted',
    // ---
    POST_UPDATED: 'post_updated',
    CHANNEL_CREATED: 'channel_created',
    CHANNEL_DELETED: 'channel_deleted',
    CHANNEL_UPDATED: 'channel_updated',
    CHANNEL_VIEWED: 'channel_viewed',
    DIRECT_ADDED: 'direct_added',
    GROUP_ADDED: 'group_added',
    NEW_USER: 'new_user',
    ADDED_TO_TEAM: 'added_to_team',
    LEAVE_TEAM: 'leave_team',
    DELETE_TEAM: 'delete_team',
    UPDATE_TEAM: 'update_team',
    USER_ADDED: 'user_added',
    USER_REMOVED: 'user_removed',
    USER_UPDATED: 'user_updated',
    MEMBERROLE_UPDATED: 'memberrole_updated',
    TYPING: 'typing',
    PREFERENCE_CHANGED: 'preference_changed',
    PREFERENCES_CHANGED: 'preferences_changed',
    PREFERENCES_DELETED: 'preferences_deleted',
    EPHEMERAL_MESSAGE: 'ephemeral_message',
    STATUS_CHANGED: 'status_change',
    HELLO: 'hello',
    WEBRTC: 'webrtc',
    REACTION_ADDED: 'reaction_added',
    REACTION_REMOVED: 'reaction_removed',
    EMOJI_ADDED: 'emoji_added',
    INVITE_ARRIVED: 'invite_arrived',
    UDF_STATUS_CREATED: 'udf_status_created',
    UDF_STATUS_DELETED: 'udf_status_deleted',
    UDF_STATUS_UPDATED: 'udf_status_updated',
    UDF_STATUS_AFTER_POSTED: 'udf_status_after_posted',
    SWITCH_MAP_TYPE: 'switch_map_type',

    // +++ Cordchat - file security scan
    FILE_SCANNED: 'file_scanned'
    // ---
};

var TutorialSteps = exports.TutorialSteps = {
    INTRO_SCREENS: 0,
    POST_POPOVER: 1,
    CHANNEL_POPOVER: 2,
    MENU_POPOVER: 3
};

var PostTypes = exports.PostTypes = {
    JOIN_LEAVE: 'system_join_leave',
    JOIN_CHANNEL: 'system_join_channel',
    LEAVE_CHANNEL: 'system_leave_channel',
    ADD_TO_CHANNEL: 'system_add_to_channel',
    REMOVE_FROM_CHANNEL: 'system_remove_from_channel',
    MISSING_CALL: 'missing_call',
    ADD_REMOVE: 'system_add_remove',
    HEADER_CHANGE: 'system_header_change',
    DISPLAYNAME_CHANGE: 'system_displayname_change',
    PURPOSE_CHANGE: 'system_purpose_change',
    CHANNEL_DELETED: 'system_channel_deleted',
    EPHEMERAL: 'system_ephemeral',
    REMOVE_LINK_PREVIEW: 'remove_link_preview',
    FORMAT_LOCATION: 'format_location',
    FORMAT_NAMECARD: 'format_namecard',
    WEBRTC: 'webrtc',
    LIVE_END: 'system_live_end',
    CREATE_CHANNEL: 'system_create_channel'
};

var StatTypes = exports.StatTypes = (0, _keyMirror2.default)({
    TOTAL_USERS: null,
    TOTAL_PUBLIC_CHANNELS: null,
    TOTAL_PRIVATE_GROUPS: null,
    TOTAL_POSTS: null,
    TOTAL_TEAMS: null,
    TOTAL_FILE_POSTS: null,
    TOTAL_HASHTAG_POSTS: null,
    TOTAL_IHOOKS: null,
    TOTAL_OHOOKS: null,
    TOTAL_COMMANDS: null,
    TOTAL_SESSIONS: null,
    POST_PER_DAY: null,
    USERS_WITH_POSTS_PER_DAY: null,
    RECENTLY_ACTIVE_USERS: null,
    NEWLY_CREATED_USERS: null,
    TOTAL_WEBSOCKET_CONNECTIONS: null,
    TOTAL_MASTER_DB_CONNECTIONS: null,
    TOTAL_READ_DB_CONNECTIONS: null,
    DAILY_ACTIVE_USERS: null,
    MONTHLY_ACTIVE_USERS: null
});

var ErrorPageTypes = exports.ErrorPageTypes = {
    LOCAL_STORAGE: 'local_storage'
};

var JobTypes = exports.JobTypes = {
    DATA_RETENTION: 'data_retention',
    ELASTICSEARCH_POST_INDEXING: 'elasticsearch_post_indexing'
};

var JobStatuses = exports.JobStatuses = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    SUCCESS: 'success',
    ERROR: 'error',
    CANCEL_REQUESTED: 'cancel_requested',
    CANCELED: 'canceled'
};

var ErrorBarTypes = exports.ErrorBarTypes = {
    LICENSE_EXPIRING: 'error_bar.license_expiring',
    LICENSE_EXPIRED: 'error_bar.license_expired',
    LICENSE_PAST_GRACE: 'error_bar.past_grace',
    PREVIEW_MODE: 'error_bar.preview_mode',
    SITE_URL: 'error_bar.site_url',
    WEBSOCKET_PORT_ERROR: 'channel_loader.socketError'
};

var Constants = exports.Constants = {
    Preferences: Preferences,
    SocketEvents: SocketEvents,
    ActionTypes: ActionTypes,
    WebrtcActionTypes: WebrtcActionTypes,
    UserStatuses: UserStatuses,
    UserSearchOptions: UserSearchOptions,
    TutorialSteps: TutorialSteps,
    PostTypes: PostTypes,
    ErrorPageTypes: ErrorPageTypes,
    ErrorBarTypes: ErrorBarTypes,

    MAX_POST_VISIBILITY: 1000000,

    IGNORE_POST_TYPES: [PostTypes.JOIN_LEAVE, PostTypes.JOIN_CHANNEL, PostTypes.LEAVE_CHANNEL, PostTypes.REMOVE_FROM_CHANNEL, PostTypes.ADD_TO_CHANNEL, PostTypes.ADD_REMOVE, PostTypes.WEBRTC],

    PayloadSources: (0, _keyMirror2.default)({
        SERVER_ACTION: null,
        VIEW_ACTION: null
    }),

    StatTypes: StatTypes,
    STAT_MAX_ACTIVE_USERS: 20,
    STAT_MAX_NEW_USERS: 20,

    UserUpdateEvents: {
        USERNAME: 'username',
        FULLNAME: 'fullname',
        NICKNAME: 'nickname',
        EMAIL: 'email',
        LANGUAGE: 'language',
        POSITION: 'position',
        CONTACT: 'contact'
    },

    ScrollTypes: {
        FREE: 1,
        BOTTOM: 2,
        SIDEBBAR_OPEN: 3,
        NEW_MESSAGE: 4,
        POST: 5
    },

    SPECIAL_MENTIONS: ['all', 'channel', 'here'],
    NOTIFY_ALL_MEMBERS: 5,
    CHARACTER_LIMIT: 4000,
    IMAGE_TYPES: ['jpg', 'gif', 'bmp', 'png', 'jpeg'],
    AUDIO_TYPES: ['mp3', 'wav', 'wma', 'm4a', 'flac', 'aac', 'ogg'],
    VIDEO_TYPES: ['mp4', 'avi', 'webm', 'mkv', 'wmv', 'mpg', 'mov', 'flv'],
    PRESENTATION_TYPES: ['ppt', 'pptx'],
    SPREADSHEET_TYPES: ['xlsx', 'csv'],
    WORD_TYPES: ['doc', 'docx'],
    CODE_TYPES: ['as', 'applescript', 'osascript', 'scpt', 'bash', 'sh', 'zsh', 'clj', 'boot', 'cl2', 'cljc', 'cljs', 'cljs.hl', 'cljscm', 'cljx', 'hic', 'coffee', '_coffee', 'cake', 'cjsx', 'cson', 'iced', 'cpp', 'c', 'cc', 'h', 'c++', 'h++', 'hpp', 'cs', 'csharp', 'css', 'd', 'di', 'dart', 'delphi', 'dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm', 'diff', 'django', 'jinja', 'dockerfile', 'docker', 'erl', 'f90', 'f95', 'fsharp', 'fs', 'gcode', 'nc', 'go', 'groovy', 'handlebars', 'hbs', 'html.hbs', 'html.handlebars', 'hs', 'hx', 'java', 'jsp', 'js', 'jsx', 'json', 'jl', 'kt', 'ktm', 'kts', 'less', 'lisp', 'lua', 'mk', 'mak', 'md', 'mkdown', 'mkd', 'matlab', 'm', 'mm', 'objc', 'obj-c', 'ml', 'perl', 'pl', 'php', 'php3', 'php4', 'php5', 'php6', 'ps', 'ps1', 'pp', 'py', 'gyp', 'r', 'ruby', 'rb', 'gemspec', 'podspec', 'thor', 'irb', 'rs', 'scala', 'scm', 'sld', 'scss', 'st', 'sql', 'swift', 'tex', 'txt', 'vbnet', 'vb', 'bas', 'vbs', 'v', 'veo', 'xml', 'html', 'xhtml', 'rss', 'atom', 'xsl', 'plist', 'yaml'],
    PDF_TYPES: ['pdf'],
    PATCH_TYPES: ['patch'],
    SVG_TYPES: ['svg'],
    ICON_FROM_TYPE: {
        audio: _audio2.default,
        video: _video2.default,
        spreadsheet: _excel2.default,
        presentation: _ppt2.default,
        pdf: _pdf2.default,
        code: _code2.default,
        word: _word2.default,
        patch: _patch2.default,
        other: _generic2.default
    },
    ICON_NAME_FROM_TYPE: {
        audio: 'audio',
        video: 'video',
        spreadsheet: 'excel',
        presentation: 'ppt',
        pdf: 'pdf',
        code: 'code',
        word: 'word',
        patch: 'patch',
        other: 'generic'
    },
    MAX_DISPLAY_FILES: 10,
    MAX_UPLOAD_FILES: 10,
    THUMBNAIL_WIDTH: 128,
    THUMBNAIL_HEIGHT: 100,
    PROFILE_WIDTH: 128,
    PROFILE_HEIGHT: 128,
    WEB_VIDEO_WIDTH: 640,
    WEB_VIDEO_HEIGHT: 480,
    MOBILE_VIDEO_WIDTH: 480,
    MOBILE_VIDEO_HEIGHT: 360,
    MOBILE_SCREEN_WIDTH: 768,
    SCROLL_DELAY: 2000,
    SCROLL_PAGE_FRACTION: 3,
    DEFAULT_CHANNEL: 'town-square',
    DEFAULT_CHANNEL_UI_NAME: 'Town Square',
    OFFTOPIC_CHANNEL: 'off-topic',
    OFFTOPIC_CHANNEL_UI_NAME: 'Off-Topic',
    GITLAB_SERVICE: 'gitlab',
    GOOGLE_SERVICE: 'google',
    APPLE_SERVICE: 'apple',
    OFFICE365_SERVICE: 'office365',
    // +++ Alan - Add Facebook constant
    FACEBOOK_SERVICE: 'facebook',
    // ---
    EMAIL_SERVICE: 'email',
    LDAP_SERVICE: 'ldap',
    SAML_SERVICE: 'saml',
    USERNAME_SERVICE: 'username',
    SIGNIN_CHANGE: 'signin_change',
    PASSWORD_CHANGE: 'password_change',
    SIGNIN_VERIFIED: 'verified',
    SIGNIN_MOBILE_VERIFIED: 'mobile_verified',
    SIGNIN_REDIRECT: 'signin_redirect',
    SESSION_EXPIRED: 'expired',
    POST_CHUNK_SIZE: 60,
    PROFILE_CHUNK_SIZE: 100,
    POST_FOCUS_CONTEXT_RADIUS: 10,
    POST_LOADING: 'loading',
    POST_FAILED: 'failed',
    POST_DELETED: 'deleted',
    POST_UPDATED: 'updated',
    SYSTEM_MESSAGE_PREFIX: 'system_',
    WVC_MESSAGE_PREFIX: 'wvc_',
    SYSTEM_MESSAGE_PROFILE_IMAGE: _logo_compact2.default,
    RESERVED_TEAM_NAMES: ['signup', 'login', 'admin', 'channel', 'post', 'api', 'oauth'],
    RESERVED_USERNAMES: ['valet', 'all', 'channel', 'here', 'matterbot'],
    MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    MAX_DMS: 20,
    MAX_USERS_IN_GM: 8,
    MIN_USERS_IN_GM: 3,
    MAX_CHANNEL_POPOVER_COUNT: 100,
    DM_CHANNEL: 'D',
    GM_CHANNEL: 'G',
    OPEN_CHANNEL: 'O',
    WVC_CHANNEL: 'W',
    PRIVATE_CHANNEL: 'P',
    INVITE_TEAM: 'I',
    OPEN_TEAM: 'O',
    MAX_POST_LEN: 4000,
    EMOJI_SIZE: 16,
    UNREAD_ICON_SVG: "<svg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'><g transform='matrix(1,0,0,1,-20,-18)'><g transform='matrix(0.0330723,0,0,0.0322634,15.8132,12.3164)'><path d='M245.803,377.493C245.803,377.493 204.794,336.485 179.398,311.088C168.55,300.24 150.962,300.24 140.114,311.088C138.327,312.875 136.517,314.686 134.73,316.473C123.882,327.321 123.882,344.908 134.73,355.756C167.972,388.998 233.949,454.975 256.949,477.975C262.158,483.184 269.223,486.111 276.591,486.111C277.38,486.111 278.176,486.111 278.965,486.111C286.332,486.111 293.397,483.184 298.607,477.975C321.607,454.975 387.584,388.998 420.826,355.756C431.674,344.908 431.674,327.321 420.826,316.473C419.039,314.686 417.228,312.875 415.441,311.088C404.593,300.24 387.005,300.24 376.158,311.088C350.761,336.485 309.753,377.493 309.753,377.493C309.753,377.493 309.753,279.687 309.753,203.94C309.753,196.573 306.826,189.508 301.617,184.298C296.408,179.089 289.342,176.162 281.975,176.162C279.191,176.162 276.364,176.162 273.58,176.162C266.213,176.162 259.148,179.089 253.939,184.298C248.729,189.508 245.803,196.573 245.803,203.94L245.803,377.493Z'/></g></g></svg>",
    MEMBERS_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Symbols' stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g id='Channel-Header/Web-HD' transform='translate(-725.000000, -32.000000)' fill-rule='nonzero' fill='inherit'> <g id='Channel-Header'> <g id='user-count' transform='translate(676.000000, 22.000000)'> <path d='M64.9481342,24 C64.6981342,20.955 63.2551342,19.076 60.6731342,18.354 C61.4831342,17.466 61.9881342,16.296 61.9881342,15 C61.9881342,12.238 59.7501342,10 56.9881342,10 C54.2261342,10 51.9881342,12.238 51.9881342,15 C51.9881342,16.297 52.4941342,17.467 53.3031342,18.354 C50.7221342,19.076 49.2771342,20.955 49.0271342,24 C49.0161342,24.146 49.0061342,24.577 49.0001342,25.001 C48.9911342,25.553 49.4361342,26 49.9881342,26 L63.9881342,26 C64.5411342,26 64.9851342,25.553 64.9761342,25.001 C64.9701342,24.577 64.9601342,24.146 64.9481342,24 Z M56.9881342,12 C58.6421342,12 59.9881342,13.346 59.9881342,15 C59.9881342,16.654 58.6421342,18 56.9881342,18 C55.3341342,18 53.9881342,16.654 53.9881342,15 C53.9881342,13.346 55.3341342,12 56.9881342,12 Z M51.0321342,24 C51.2981342,21.174 52.7911342,20 55.9881342,20 L57.9881342,20 C61.1851342,20 62.6781342,21.174 62.9441342,24 L51.0321342,24 Z' id='User_4_x2C__Profile_5-Copy-9'></path> </g> </g> </g> </g> </svg>",
    TEAM_INFO_SVG: "<svg width='100%' height='100%' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'> <g transform='matrix(1.17647,0,0,1.17647,-1.55431e-15,-1.00573e-14)'> <path d='M8.5,0C3.797,0 0,3.797 0,8.5C0,13.203 3.797,17 8.5,17C13.203,17 17,13.203 17,8.5C17,3.797 13.203,0 8.5,0ZM10,8.5C10,7.672 9.328,7 8.5,7C7.672,7 7,7.672 7,8.5L7,12.45C7,13.278 7.672,13.95 8.5,13.95C9.328,13.95 10,13.278 10,12.45L10,8.5ZM8.5,3C9.328,3 10,3.672 10,4.5C10,5.328 9.328,6 8.5,6C7.672,6 7,5.328 7,4.5C7,3.672 7.672,3 8.5,3Z'/> </g> </svg>",
    FLAG_FILLED_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-1073.000000, -33.000000)' fill-rule='nonzero' fill='inherit'> <g transform='translate(-1.000000, 0.000000)'> <g transform='translate(1064.000000, 22.000000)'> <g transform='translate(10.000000, 11.000000)'> <path d='M8,1 L2,1 C2,0.447 1.553,0 1,0 C0.447,0 0,0.447 0,1 L0,15.5 C0,15.776 0.224,16 0.5,16 L1.5,16 C1.776,16 2,15.776 2,15.5 L2,11 L7,11 L7,12 C7,12.553 7.447,13 8,13 L15,13 C15.553,13 16,12.553 16,12 L16,4 C16,3.447 15.553,3 15,3 L9,3 L9,2 C9,1.447 8.553,1 8,1 Z'></path> </g> </g> </g> </g> </g> </svg>",
    FLAG_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-1106.000000, -33.000000)' fill-rule='nonzero' fill='inherit'> <g> <g transform='translate(1096.000000, 22.000000)'> <g transform='translate(10.000000, 11.000000)'> <path d='M8,1 L2,1 C2,0.447 1.553,0 1,0 C0.447,0 0,0.447 0,1 L0,15.5 C0,15.776 0.224,16 0.5,16 L1.5,16 C1.776,16 2,15.776 2,15.5 L2,11 L7,11 L7,12 C7,12.553 7.447,13 8,13 L15,13 C15.553,13 16,12.553 16,12 L16,4 C16,3.447 15.553,3 15,3 L9,3 L9,2 C9,1.447 8.553,1 8,1 Z M9,11 L9,9.5 C9,9.224 8.776,9 8.5,9 L2,9 L2,3 L7,3 L7,4.5 C7,4.776 7.224,5 7.5,5 L14,5 L14,11 L9,11 Z'></path> </g> </g> </g> </g> </g> </svg>",
    ATTACHMENT_ICON_SVG: "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' x='0px' y='0px' viewBox='0 0 48 48' enable-background='new 0 0 48 48' xml:space='preserve'><g><path d='M43.922,6.653c-2.643-2.644-6.201-4.107-9.959-4.069c-3.774,0.019-7.32,1.497-9.983,4.161l-12.3,12.3l-8.523,8.521   c-4.143,4.144-4.217,10.812-0.167,14.862c1.996,1.996,4.626,2.989,7.277,2.989c2.73,0,5.482-1.055,7.583-3.156l15.547-15.545   c0.002-0.002,0.002-0.004,0.004-0.005l5.358-5.358c1.394-1.393,2.176-3.24,2.201-5.2c0.026-1.975-0.716-3.818-2.09-5.192   c-2.834-2.835-7.496-2.787-10.394,0.108L9.689,29.857c-0.563,0.563-0.563,1.474,0,2.036c0.281,0.28,0.649,0.421,1.018,0.421   c0.369,0,0.737-0.141,1.018-0.421l18.787-18.788c1.773-1.774,4.609-1.824,6.322-0.11c0.82,0.82,1.263,1.928,1.247,3.119   c-0.017,1.205-0.497,2.342-1.357,3.201l-5.55,5.551c-0.002,0.002-0.002,0.004-0.004,0.005L15.814,40.225   c-3.02,3.02-7.86,3.094-10.789,0.167c-2.928-2.929-2.854-7.77,0.167-10.791l0.958-0.958c0.001-0.002,0.004-0.002,0.005-0.004   L26.016,8.78c2.123-2.124,4.951-3.303,7.961-3.317c2.998,0.02,5.814,1.13,7.91,3.226c4.35,4.351,4.309,11.472-0.093,15.873   L25.459,40.895c-0.563,0.562-0.563,1.473,0,2.035c0.281,0.281,0.65,0.422,1.018,0.422c0.369,0,0.737-0.141,1.018-0.422   L43.83,26.596C49.354,21.073,49.395,12.126,43.922,6.653z'></path></g></svg>",
    MATTERMOST_ICON_SVG: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='0 0 500 500' style='enable-background:new 0 0 500 500;' xml:space='preserve'> <style type='text/css'> .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;} </style> <g id='XMLID_1_'> <g id='XMLID_3_'> <path id='XMLID_4_' class='st0' d='M396.9,47.7l2.6,53.1c43,47.5,60,114.8,38.6,178.1c-32,94.4-137.4,144.1-235.4,110.9 S51.1,253.1,83,158.7C104.5,95.2,159.2,52,222.5,40.5l34.2-40.4C150-2.8,49.3,63.4,13.3,169.9C-31,300.6,39.1,442.5,169.9,486.7 s272.6-25.8,316.9-156.6C522.7,223.9,483.1,110.3,396.9,47.7z'/> </g> <path id='XMLID_2_' class='st0' d='M335.6,204.3l-1.8-74.2l-1.5-42.7l-1-37c0,0,0.2-17.8-0.4-22c-0.1-0.9-0.4-1.6-0.7-2.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.7-1.2-1.8-2.1-3.1-2.6c-1.4-0.5-2.9-0.4-4.2,0.2c0,0-0.1,0-0.1,0 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.6,0.3-1.2,0.7-1.8,1.3c-3,3-13.7,17.2-13.7,17.2l-23.2,28.8l-27.1,33l-46.5,57.8 c0,0-21.3,26.6-16.6,59.4s29.1,48.7,48,55.1c18.9,6.4,48,8.5,71.6-14.7C336.4,238.4,335.6,204.3,335.6,204.3z'/> </g> </svg>",
    ONLINE_AVATAR_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-243 245 12 12'style='enable-background:new -243 245 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <path class='online--icon' d='M-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5z'/> <ellipse class='online--icon' cx='-238.5' cy='248' rx='2.5' ry='2.5'/> </g> <path class='online--icon' d='M-238.9,253.8c0-0.4,0.1-0.9,0.2-1.3c-2.2-0.2-2.2-2-2.2-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5c0,0.1-0.1,0.5,0,0.6 c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C-238.7,255.7-238.9,254.8-238.9,253.8z'/> <g> <g> <path class='online--icon' d='M-232.3,250.1l1.3,1.3c0,0,0,0.1,0,0.1l-4.1,4.1c0,0,0,0-0.1,0c0,0,0,0,0,0l-2.7-2.7c0,0,0-0.1,0-0.1l1.2-1.2 c0,0,0.1,0,0.1,0l1.4,1.4l2.9-2.9C-232.4,250.1-232.3,250.1-232.3,250.1z'/> </g> </g> </svg>",
    AWAY_AVATAR_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-299 391 12 12'style='enable-background:new -299 391 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <ellipse class='away--icon' cx='-294.6' cy='394' rx='2.5' ry='2.5'/> <path class='away--icon' d='M-293.8,399.4c0-0.4,0.1-0.7,0.2-1c-0.3,0.1-0.6,0.2-1,0.2c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0,1.4-0.1,2-0.3 C-293.3,401.5-293.8,400.5-293.8,399.4z'/> </g> <path class='away--icon' d='M-287,400c0,0.1-0.1,0.1-0.1,0.1l-4.9,0c-0.1,0-0.1-0.1-0.1-0.1v-1.6c0-0.1,0.1-0.1,0.1-0.1l4.9,0c0.1,0,0.1,0.1,0.1,0.1 V400z'/> </svg>",
    OFFLINE_AVATAR_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-299 391 12 12'style='enable-background:new -299 391 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <g> <ellipse class='offline--icon' cx='-294.5' cy='394' rx='2.5' ry='2.5'/> <path class='offline--icon' d='M-294.3,399.7c0-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.2,0-0.4,0c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4h0.1h0.1c0.3,0,0.7,0,1-0.1C-293.9,401.6-294.3,400.7-294.3,399.7z'/> </g> </g> <g> <path class='offline--icon' d='M-288.9,399.4l1.8-1.8c0.1-0.1,0.1-0.3,0-0.3l-0.7-0.7c-0.1-0.1-0.3-0.1-0.3,0l-1.8,1.8l-1.8-1.8c-0.1-0.1-0.3-0.1-0.3,0 l-0.7,0.7c-0.1,0.1-0.1,0.3,0,0.3l1.8,1.8l-1.8,1.8c-0.1,0.1-0.1,0.3,0,0.3l0.7,0.7c0.1,0.1,0.3,0.1,0.3,0l1.8-1.8l1.8,1.8 c0.1,0.1,0.3,0.1,0.3,0l0.7-0.7c0.1-0.1,0.1-0.3,0-0.3L-288.9,399.4z'/> </g> </svg>",
    ONLINE_ICON_SVG: "<div class='icon__container'><svg width='100%' height='100%' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'><path class='online--icon' d='M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm6.19,7.18c0,0.208 -0.075,0.384 -0.224,0.53l-5.782,5.64l-1.087,1.059c-0.149,0.146 -0.33,0.218 -0.543,0.218c-0.213,0 -0.394,-0.072 -0.543,-0.218l-1.086,-1.059l-2.891,-2.82c-0.149,-0.146 -0.224,-0.322 -0.224,-0.53c0,-0.208 0.075,-0.384 0.224,-0.53l1.086,-1.059c0.149,-0.146 0.33,-0.218 0.543,-0.218c0.213,0 0.394,0.072 0.543,0.218l2.348,2.298l5.24,-5.118c0.149,-0.146 0.33,-0.218 0.543,-0.218c0.213,0 0.394,0.072 0.543,0.218l1.086,1.059c0.149,0.146 0.224,0.322 0.224,0.53Z'/></svg></div>",
    AWAY_ICON_SVG: "<div class='icon__container'><svg width='100%' height='100%' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'><path class='away--icon' d='M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm5.25,8.5l-10.5,0c-0.414,0 -0.75,0.336 -0.75,0.75l0,1.5c0,0.414 0.336,0.75 0.75,0.75l10.5,0c0.414,0 0.75,-0.336 0.75,-0.75l0,-1.5c0,-0.414 -0.336,-0.75 -0.75,-0.75Z'/></svg></div>",
    OFFLINE_ICON_SVG: "<svg class='offline--icon' width='100%' height='100%' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'><path d='M10,0c5.519,0 10,4.481 10,10c0,5.519 -4.481,10 -10,10c-5.519,0 -10,-4.481 -10,-10c0,-5.519 4.481,-10 10,-10Zm0,2c4.415,0 8,3.585 8,8c0,4.415 -3.585,8 -8,8c-4.415,0 -8,-3.585 -8,-8c0,-4.415 3.585,-8 8,-8Z'/></svg>",
    MENU_ICON: "<svg width='16px' height='10px' viewBox='0 0 16 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-188.000000, -38.000000)' fill-rule='nonzero' fill='inherit'> <g> <g> <g transform='translate(188.000000, 38.000000)'> <path d='M15.5,0 C15.776,0 16,0.224 16,0.5 L16,1.5 C16,1.776 15.776,2 15.5,2 L0.5,2 C0.224,2 0,1.776 0,1.5 L0,0.5 C0,0.224 0.224,0 0.5,0 L15.5,0 Z M15.5,4 C15.776,4 16,4.224 16,4.5 L16,5.5 C16,5.776 15.776,6 15.5,6 L0.5,6 C0.224,6 0,5.776 0,5.5 L0,4.5 C0,4.224 0.224,4 0.5,4 L15.5,4 Z M15.5,8 C15.776,8 16,8.224 16,8.5 L16,9.5 C16,9.776 15.776,10 15.5,10 L0.5,10 C0.224,10 0,9.776 0,9.5 L0,8.5 C0,8.224 0.224,8 0.5,8 L15.5,8 Z'></path> </g> </g> </g> </g> </g> </svg>",
    COMMENT_ICON: "<svg version='1.1' id='Layer_2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'width='15px' height='15px' viewBox='1 1.5 15 15' enable-background='new 1 1.5 15 15' xml:space='preserve'> <g> <g> <path fill='#211B1B' d='M14,1.5H3c-1.104,0-2,0.896-2,2v8c0,1.104,0.896,2,2,2h1.628l1.884,3l1.866-3H14c1.104,0,2-0.896,2-2v-8 C16,2.396,15.104,1.5,14,1.5z M15,11.5c0,0.553-0.447,1-1,1H8l-1.493,2l-1.504-1.991L5,12.5H3c-0.552,0-1-0.447-1-1v-8 c0-0.552,0.448-1,1-1h11c0.553,0,1,0.448,1,1V11.5z'/> </g> </g> </svg>",
    REPLY_ICON: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='-158 242 18 18' style='enable-background:new -158 242 18 18;' xml:space='preserve'> <path d='M-142.2,252.6c-2-3-4.8-4.7-8.3-4.8v-3.3c0-0.2-0.1-0.3-0.2-0.3s-0.3,0-0.4,0.1l-6.9,6.2c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0.1,0,0.2,0.1,0.3l6.9,6.4c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.1,0.2-0.2,0.2-0.4v-3.8c4.2,0,7.4,0.4,9.6,4.4c0.1,0.1,0.2,0.2,0.3,0.2 c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.3,0.2-0.4C-140.2,257.3-140.6,255-142.2,252.6z M-150.8,252.5c-0.2,0-0.4,0.2-0.4,0.4v3.3l-6-5.5 l6-5.3v2.8c0,0.2,0.2,0.4,0.4,0.4c3.3,0,6,1.5,8,4.5c0.5,0.8,0.9,1.6,1.2,2.3C-144,252.8-147.1,252.5-150.8,252.5z'/> </svg>",
    SCROLL_BOTTOM_ICON: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='-239 239 21 23' style='enable-background:new -239 239 21 23;' xml:space='preserve'> <path d='M-239,241.4l2.4-2.4l8.1,8.2l8.1-8.2l2.4,2.4l-10.5,10.6L-239,241.4z M-228.5,257.2l8.1-8.2l2.4,2.4l-10.5,10.6l-10.5-10.6 l2.4-2.4L-228.5,257.2z'/> </svg>",
    //VIDEO_ICON: "<svg width='16px' height='12px' viewBox='0 0 16 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-696.000000, -34.000000)' fill-rule='nonzero' fill='inherit'> <g transform='translate(-1.000000, 0.000000)'> <g transform='translate(687.000000, 22.000000)'> <g transform='translate(10.000000, 12.000000)'> <path d='M15.105,1.447 L12,3 L12,1 C12,0.447 11.553,0 11,0 L1,0 C0.447,0 0,0.447 0,1 L0,11 C0,11.553 0.447,12 1,12 L11,12 C11.553,12 12,11.553 12,11 L12,9 L15.105,10.553 C15.6,10.8 16,10.553 16,10 L16,2 C16,1.447 15.6,1.2 15.105,1.447 Z M12.895,7.211 C12.612,7.07 12.306,7 12,7 L10.5,7 C10.224,7 10,7.224 10,7.5 L10,10 L2,10 L2,2 L10,2 L10,4.5 C10,4.776 10.224,5 10.5,5 L12,5 C12.306,5 12.612,4.93 12.895,4.789 L14,4.236 L14,7.763 L12.895,7.211 Z'></path> </g> </g> </g> </g> </g> </svg>",
    VIDEO_ICON: "<svg width='24px' height='20px' version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16;' xml:space='preserve'> <path d='M15.5,3.5c-0.3-0.1-0.7-0.1-0.9,0.2l-1.7,1.7V3.2c0-0.5-0.4-0.8-0.8-0.8H0.8C0.4,2.4,0,2.7,0,3.2v9.6c0,0.5,0.4,0.8,0.8,0.8 H12c0.5,0,0.8-0.4,0.8-0.8v-2.2l1.7,1.7c0.2,0.2,0.6,0.3,0.9,0.2c0.3-0.1,0.5-0.4,0.5-0.8V4.2C16,3.9,15.8,3.6,15.5,3.5z M14.3,6.2 v3.5l-1.5-1.5V7.7L14.3,6.2z M1.6,12V4h9.6v8H1.6z'/></svg>",
    VOICE_ICON: "<svg width='24px' height='20px' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16;' xml:space='preserve'> <path d='M14.9,10.9l-1.8-1.8c-0.8-0.8-1.9-0.8-2.7,0L9.6,10l0,0C9.5,9.9,9.4,9.9,9.3,9.8C8.4,9.2,7.5,8.5,6.8,7.5 C6.4,7.1,6.2,6.7,6,6.4C6.2,6.2,6.4,6,6.6,5.8l0.3-0.3c0.4-0.4,0.6-0.9,0.6-1.4s-0.2-1-0.6-1.4L6,2C5.9,1.9,5.8,1.8,5.7,1.7 C5.5,1.5,5.3,1.3,5.1,1.1c-0.8-0.8-1.9-0.8-2.7,0L1.3,2.2c-0.5,0.5-0.7,1-0.8,1.7c-0.1,1,0.2,1.9,0.4,2.5c0.5,1.5,1.3,2.8,2.5,4.2 c1.4,1.7,3.2,3.1,5.2,4c0.8,0.4,1.8,0.8,3,0.9h0.2c0.8,0,1.6-0.3,2.1-0.9c0.1-0.2,0.3-0.3,0.5-0.6c0.1-0.1,0.3-0.3,0.4-0.4 c0.4-0.4,0.6-0.9,0.6-1.4C15.5,11.8,15.3,11.3,14.9,10.9z M4.7,5.5L4.7,5.5C4.3,5.9,4.3,6.2,4.4,6.7C4.7,7.3,5,7.8,5.5,8.5 c0.9,1.1,1.9,2,2.9,2.7c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0.1,0.2,0.1,0.4,0.2c0.4,0.2,0.9,0.1,1.2-0.2l1.1-1.1c0.2-0.2,0.3-0.1,0.4,0 l1.8,1.8c0.2,0.2,0.2,0.3,0.1,0.4h-0.1v0.2c-0.1,0.1-0.1,0.1-0.2,0.2L13.4,13c-0.2,0.2-0.4,0.4-0.6,0.7c-0.3,0.3-0.5,0.4-0.9,0.4 h-0.1c-0.9-0.1-1.7-0.4-2.4-0.7c-1.9-1-3.4-2.2-4.7-3.8C3.6,8.4,2.9,7.2,2.4,5.9C2.2,5.1,2,4.6,2.1,4c0-0.3,0.1-0.5,0.3-0.7l1.1-1.1 c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1c0.2,0.2,0.4,0.4,0.6,0.6L5.8,4C6,4.2,6,4.3,5.8,4.5L5.5,4.7C5.2,5,5,5.3,4.7,5.5z'/></svg>",
    LIVE_ICON: "<svg width='24px' height='20px' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16;' xml:space='preserve'> <g><path class='st0' d='M8.9,11.5c0.3,0,0.6-0.2,0.6-0.6c0-0.8-0.3-1.6-0.8-2.1C8.1,8.2,7.4,7.9,6.6,8C6.4,8,6.3,8.1,6.2,8.2 C6.1,8.3,6,8.5,6,8.7C6,9,6.3,9.3,6.6,9.3c0.5,0,0.9,0.1,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2C8.3,11.2,8.5,11.5,8.9,11.5z'/><path class='st0' d='M9.3,8.3c0.7,0.7,1.1,1.6,1.1,2.5c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6c0-1.3-0.5-2.5-1.4-3.4 C9.3,6.5,8.1,6,6.8,6C6.6,6,6.5,6.1,6.4,6.2C6.3,6.3,6.2,6.5,6.2,6.6c0,0.3,0.3,0.6,0.6,0.6C7.7,7.2,8.6,7.6,9.3,8.3z'/></g><path d='M14.2,6.3c0-0.1,0-0.2,0-0.3c0-2.3-1.9-4.2-4.2-4.2c-1.2,0-2.4,0.5-3.2,1.5c-0.2,0-0.4,0-0.6,0c-2,0-3.7,1.6-3.8,3.6 C1,7.5,0,8.9,0,10.4c0,2.1,1.7,3.8,3.8,3.8h8c2.3,0,4.2-1.9,4.2-4.2C16.1,8.4,15.4,7,14.2,6.3z M3.9,8.4L3.9,8.4l0.9,0.1L4.5,7.8 C4.4,7.6,4.3,7.3,4.3,7c0-1,0.8-1.9,1.9-1.9c0.3,0,0.6,0.1,0.9,0.3l0.5,0.3l0.2-0.5C8.2,4.3,9,3.8,10,3.8c1.3,0,2.4,1.1,2.4,2.4 c0,0.3-0.1,0.6-0.2,0.9L12,7.6l0.5,0.1c1,0.3,1.7,1.2,1.7,2.3c0,1.3-1.1,2.4-2.4,2.4h-8c-1,0-1.9-0.8-1.9-1.9C2,9.2,2.8,8.4,3.9,8.4 z'/></svg>",
    PIN_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Symbols' stroke='inherit' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-775.000000, -32.000000)' fill-rule='nonzero' fill='inherit'> <g> <g transform='translate(764.000000, 22.000000)'> <g transform='translate(10.000000, 10.000000)'> <path d='M16.456,7.291 L9.483,0.25 C9.31,0.078 9.178,0 9.08,0 C8.896,0 8.831,0.276 8.831,0.732 L8.831,3.044 L5.831,5.96 L2.578,6.268 C1.887,6.405 1.668,6.917 2.167,7.41 L4.781,10.011 L3.83,10.961 L1.05,15.511 C0.93,15.761 1.03,15.862 1.28,15.74 L5.83,12.961 L6.786,12.005 L9.359,14.565 C9.556,14.76 9.754,14.854 9.929,14.854 C10.197,14.854 10.413,14.634 10.497,14.219 L10.83,10.961 L13.746,7.961 L16.082,7.961 C16.788,7.961 16.955,7.785 16.456,7.291 Z M12.312,6.567 L9.396,9.567 L8.911,10.065 L8.84,10.757 L8.797,11.184 L5.589,7.992 L6.018,7.952 L6.72,7.886 L7.225,7.396 L10.225,4.48 L10.547,4.167 L12.616,6.256 L12.312,6.567 Z'></path> </g> </g> </g> </g> </g> </svg>",
    LEAVE_TEAM_SVG: "<svg width='100%' height='100%' viewBox='0 0 164 164' version='1.1' xmlns='http://www.w3.org/2000/svg'    xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round; stroke-miterlimit:1.41421;'> <path d='M26.023,164L26.023,7.035L26.022,0.32L137.658,0.32L137.658,164L124.228,164L124.228, 13.749L39.452,13.749L39.452,164L26.023, 164ZM118.876,164L118.876,18.619L58.137,32.918L58.137,149.701L118.876,164Z'/></svg>",
    SEARCH_ICON_SVG: "<svg width='19px' height='18px' viewBox='0 0 19 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='inherit' stroke-width='1' fill='none' fill-rule='evenodd'> <g transform='translate(-719.000000, -20.000000)' stroke-width='1.5'> <g transform='translate(0.000000, 1.000000)'> <g transform='translate(63.000000, 10.000000)'> <g transform='translate(657.000000, 10.000000)'> <circle cx='7' cy='7' r='7'></circle> <path d='M12.5,11.5 L16.5,15.5' stroke-linecap='round'></path> </g> </g> </g> </g> </g> </svg>",
    MENTIONS_ICON_SVG: "<svg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-1057.000000, -31.000000)' fill='inherit'> <g> <g transform='translate(1049.000000, 22.000000)'> <path d='M17.4296875,15.8867188 C15.9882812,15.8867188 15.1210938,17.0351562 15.1210938,18.96875 C15.1210938,20.8789062 15.9882812,22.0507812 17.4179688,22.0507812 C18.8945312,22.0507812 19.84375,20.8554688 19.84375,18.96875 C19.84375,17.0820312 18.90625,15.8867188 17.4296875,15.8867188 Z M17.8398438,9.125 C23.3242188,9.125 27.25,12.59375 27.25,17.7734375 C27.25,21.5117188 25.5625,23.9609375 22.7734375,23.9609375 C21.4023438,23.9609375 20.265625,23.1992188 20.078125,22.0390625 L19.9609375,22.0390625 C19.46875,23.2226562 18.4140625,23.8789062 17.0429688,23.8789062 C14.6054687,23.8789062 12.9648438,21.8867188 12.9648438,18.9101562 C12.9648438,16.0625 14.6171875,14.09375 16.9960938,14.09375 C18.25,14.09375 19.3632812,14.7382812 19.8085938,15.7460938 L19.9375,15.7460938 L19.9375,14.328125 L21.9179688,14.328125 L21.9179688,20.984375 C21.9179688,21.7578125 22.328125,22.2851562 23.171875,22.2851562 C24.4726562,22.2851562 25.421875,20.6679688 25.421875,17.8320312 C25.421875,13.5664062 22.2929688,10.7421875 17.7109375,10.7421875 C13.1640625,10.7421875 9.90625,14.140625 9.90625,18.96875 C9.90625,24.1367188 13.3515625,27.0429688 18.109375,27.0429688 C19.5625,27.0429688 21.0507812,26.84375 21.7773438,26.5390625 L21.7773438,28.15625 C20.78125,28.484375 19.4570312,28.671875 18.0273438,28.671875 C12.2382812,28.671875 8.078125,25.109375 8.078125,18.8984375 C8.078125,13.0625 12.0859375,9.125 17.8398438,9.125 Z'></path> </g> </g> </g></g></svg>",
    UNREAD_HEADER_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-1106.000000, -33.000000)' fill-rule='nonzero' fill='inherit'> <g> <g transform='translate(1096.000000, 22.000000)'> <g transform='translate(10.000000, 11.000000)'> <path d='M14.6,1.4c-1-1-2.2-1.4-3.5-1.4H5C2.2,0,0,2.2,0,5v3.5c0,2.5,1.8,4.6,4.2,5v1.7c0,0.3,0.2,0.6,0.6,0.8 C5,16,5,16,5.1,16c0.2,0,0.5-0.1,0.6-0.2l0.5-0.5c0.5-0.5,1-0.8,1.5-1.1c0.3-0.2,0.5-0.6,0.3-1c-0.2-0.2-0.4-0.4-0.6-0.4 c-0.1,0-0.2,0-0.3,0.1c-0.5,0.2-1,0.6-1.4,1V12H5c-2,0-3.6-1.6-3.6-3.6V5C1.4,3,3,1.4,5,1.4h6c2,0,3.6,1.6,3.6,3.6v3.5 c0,0.5-0.1,1-0.3,1.5c-0.2,0.3,0,0.8,0.3,1c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.6-0.2,0.6-0.4C15.8,10,16,9.3,16,8.6V5 C16,3.7,15.5,2.4,14.6,1.4z'></path><path d='M12.7,13.5l1.7-0.9l-5.2-1.9l1.9,5.3l0.9-1.8l1.3,1.3c0.1,0.1,0.2,0.2,0.3,0.2s0.2-0.1,0.3-0.2 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2-0.1-0.2-0.2-0.3L12.7,13.5z'></path> </g> </g> </g> </g> </g> </svg>",
    LIVESTREAM_HEADER_ICON_SVG: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16;' xml:space='preserve'><g><path d='M13.6,3.3H10c0,0,0,0,0,0l2-2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5C11.9,0.1,11.7,0,11.5,0 c-0.2,0-0.4,0.1-0.5,0.2L8.7,2.5C8.5,2.4,8.3,2.4,8,2.4c-0.3,0-0.5,0-0.7,0.1L5,0.2C4.9,0.1,4.7,0,4.5,0h0C4.3,0,4.1,0.1,4,0.2 C3.8,0.4,3.8,0.5,3.8,0.7c0,0.2,0.1,0.4,0.2,0.5l2,2c0,0,0,0,0,0H2.4c-1,0-1.9,0.8-1.9,1.9v9c0,1,0.8,1.9,1.9,1.9H4l2.1,0h3.9 l2.1,0h1.6c1,0,1.9-0.8,1.9-1.9v-9C15.5,4.2,14.6,3.3,13.6,3.3z M14,5.2v9c0,0.2-0.2,0.3-0.4,0.3H2.4c-0.2,0-0.4-0.2-0.4-0.4v-9 C2,5,2.2,4.8,2.4,4.8h11.2C13.8,4.8,14,5,14,5.2z'/><path d='M10.5,9.3L6,6.7c-0.1-0.1-0.3-0.1-0.4,0C5.4,6.8,5.3,6.9,5.3,7.1v5.2c0,0.1,0.1,0.3,0.2,0.4c0.1,0,0.1,0.1,0.2,0.1 s0.1,0,0.2-0.1l4.5-2.6c0.1-0.1,0.2-0.2,0.2-0.4C10.7,9.5,10.6,9.4,10.5,9.3z'/></g></svg>",
    MENU_ICON_SVG: "<svg width='16px' height='10px' viewBox='0 0 16 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-26.000000, -24.000000)' fill-rule='nonzero' fill='inherit'> <g transform='translate(26.000000, 24.000000)'> <path d='M1.5,0 L0.5,0 C0.224,0 0,0.224 0,0.5 L0,1.5 C0,1.776 0.224,2 0.5,2 L1.5,2 C1.776,2 2,1.776 2,1.5 L2,0.5 C2,0.224 1.776,0 1.5,0 Z'></path> <path d='M15.5,0 L3.5,0 C3.224,0 3,0.224 3,0.5 L3,1.5 C3,1.776 3.224,2 3.5,2 L15.5,2 C15.776,2 16,1.776 16,1.5 L16,0.5 C16,0.224 15.776,0 15.5,0 Z'></path> <path d='M1.5,4 L0.5,4 C0.224,4 0,4.224 0,4.5 L0,5.5 C0,5.776 0.224,6 0.5,6 L1.5,6 C1.776,6 2,5.776 2,5.5 L2,4.5 C2,4.224 1.776,4 1.5,4 Z'></path> <path d='M3.5,6 L11.5,6 C11.776,6 12,5.776 12,5.5 L12,4.5 C12,4.224 11.776,4 11.5,4 L3.5,4 C3.224,4 3,4.224 3,4.5 L3,5.5 C3,5.776 3.224,6 3.5,6 Z'></path> <path d='M1.5,8 L0.5,8 C0.224,8 0,8.224 0,8.5 L0,9.5 C0,9.776 0.224,10 0.5,10 L1.5,10 C1.776,10 2,9.776 2,9.5 L2,8.5 C2,8.224 1.776,8 1.5,8 Z'></path> <path d='M13.5,8 L3.5,8 C3.224,8 3,8.224 3,8.5 L3,9.5 C3,9.776 3.224,10 3.5,10 L13.5,10 C13.776,10 14,9.776 14,9.5 L14,8.5 C14,8.224 13.776,8 13.5,8 Z'></path> </g> </g> </g> </svg>",
    INFO_ICON_SVG: "<svg width='22px' height='22px' viewBox='0 0 22 22' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-388.000000, -18.000000)' fill='inherit'> <g> <g transform='translate(381.000000, 11.000000)'> <g transform='translate(7.000000, 7.000000)'> <path d='M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11,20.7924685 C16.408231,20.7924685 20.7924685,16.408231 20.7924685,11 C20.7924685,5.59176898 16.408231,1.20753149 11,1.20753149 C5.59176898,1.20753149 1.20753149,5.59176898 1.20753149,11 C1.20753149,16.408231 5.59176898,20.7924685 11,20.7924685 Z M10.1572266,16.0625 L10.1572266,8.69335938 L11.3466797,8.69335938 L11.3466797,16.0625 L10.1572266,16.0625 Z M10.7519531,7.50390625 C10.3417969,7.50390625 10,7.16210938 10,6.75195312 C10,6.33496094 10.3417969,6 10.7519531,6 C11.1689453,6 11.5039062,6.33496094 11.5039062,6.75195312 C11.5039062,7.16210938 11.1689453,7.50390625 10.7519531,7.50390625 Z'></path> </g> </g> </g> </g> </g> </svg>",
    MESSAGE_ICON_SVG: "<svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-202.000000, -176.000000)' fill-rule='nonzero' fill='inherit'> <g> <g transform='translate(202.000000, 176.000000)'> <path d='M15,0 C15.553,0 16,0.496 16,1.048 L16,8.048 C16,8.601 15.553,9 15,9 L14,9 L14,7.048 L14,3.048 C14,2.496 13.553,2 13,2 L5,2 L3,2 L3,1.048 C3,0.496 3.447,0 4,0 L15,0 Z M12,3 C12.55,3 13,3.508 13,4.07 L13,12.048 C13,12.61 12.55,13 12,13 L11,13 L11,15.376 C11,15.94 10.596,16.035 10.098,15.791 L4.72,13 L1,13 C0.45,13 0,12.61 0,12.048 L0,4.07 C0,3.508 0.45,3 1,3 L12,3 Z'></path> </g> </g> </g> </g> </svg>",
    SWITCH_CHANNEL_ICON_SVG: "<svg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-32.000000, -982.000000)' fill-rule='nonzero' fill='inherit'> <g> <g transform='translate(0.000000, 961.000000)'> <g transform='translate(32.000000, 21.000000)'> <path d='M21.5,0.5 L2.5,0.5 C1.121,0.5 0,1.622 0,3 L0,21 C0,22.378 1.121,23.5 2.5,23.5 L21.5,23.5 C22.879,23.5 24,22.378 24,21 L24,3 C24,1.622 22.879,0.5 21.5,0.5 Z M2.5,1.5 L21.5,1.5 C22.327,1.5 23,2.173 23,3 L23,4.5 L1,4.5 L1,3 C1,2.173 1.673,1.5 2.5,1.5 Z M21.5,22.5 L2.5,22.5 C1.673,22.5 1,21.827 1,21 L1,5.5 L23,5.5 L23,21 C23,21.827 22.327,22.5 21.5,22.5 Z'></path> <circle cx='2.5' cy='3' r='1'></circle> <circle cx='4.5' cy='3' r='1'></circle> <circle cx='6.5' cy='3' r='1'></circle> <path d='M19.146,16.94 C19.673,16.263 20,15.423 20,14.5 C20,12.294 18.206,10.5 16,10.5 C13.794,10.5 12,12.294 12,14.5 C12,16.706 13.794,18.5 16,18.5 C16.922,18.5 17.762,18.174 18.439,17.647 L21.146,20.354 C21.244,20.451 21.372,20.5 21.5,20.5 C21.628,20.5 21.756,20.451 21.853,20.354 C22.048,20.159 22.048,19.842 21.853,19.647 L19.146,16.94 Z M13,14.5 C13,12.846 14.346,11.5 16,11.5 C17.654,11.5 19,12.846 19,14.5 C19,16.154 17.654,17.5 16,17.5 C14.346,17.5 13,16.154 13,14.5 Z'></path> <path d='M2.5,8.5 L7.5,8.5 C7.776,8.5 8,8.276 8,8 C8,7.724 7.776,7.5 7.5,7.5 L2.5,7.5 C2.224,7.5 2,7.724 2,8 C2,8.276 2.224,8.5 2.5,8.5 Z'></path> <path d='M10.5,8.5 L13.5,8.5 C13.776,8.5 14,8.276 14,8 C14,7.724 13.776,7.5 13.5,7.5 L10.5,7.5 C10.224,7.5 10,7.724 10,8 C10,8.276 10.224,8.5 10.5,8.5 Z'></path> <path d='M21.5,7.5 L16.5,7.5 C16.224,7.5 16,7.724 16,8 C16,8.276 16.224,8.5 16.5,8.5 L21.5,8.5 C21.776,8.5 22,8.276 22,8 C22,7.724 21.776,7.5 21.5,7.5 Z'></path> <path d='M2.5,11.5 L5.5,11.5 C5.776,11.5 6,11.276 6,11 C6,10.724 5.776,10.5 5.5,10.5 L2.5,10.5 C2.224,10.5 2,10.724 2,11 C2,11.276 2.224,11.5 2.5,11.5 Z'></path> <path d='M8.5,11.5 L12.5,11.5 C12.776,11.5 13,11.276 13,11 C13,10.724 12.776,10.5 12.5,10.5 L8.5,10.5 C8.224,10.5 8,10.724 8,11 C8,11.276 8.224,11.5 8.5,11.5 Z'></path> <path d='M10.5,13.5 L7.5,13.5 C7.224,13.5 7,13.724 7,14 C7,14.276 7.224,14.5 7.5,14.5 L10.5,14.5 C10.776,14.5 11,14.276 11,14 C11,13.724 10.776,13.5 10.5,13.5 Z'></path> <path d='M2.5,14.5 L4.5,14.5 C4.776,14.5 5,14.276 5,14 C5,13.724 4.776,13.5 4.5,13.5 L2.5,13.5 C2.224,13.5 2,13.724 2,14 C2,14.276 2.224,14.5 2.5,14.5 Z'></path> <path d='M2.5,17.5 L8.5,17.5 C8.776,17.5 9,17.276 9,17 C9,16.724 8.776,16.5 8.5,16.5 L2.5,16.5 C2.224,16.5 2,16.724 2,17 C2,17.276 2.224,17.5 2.5,17.5 Z'></path> <path d='M10.5,19.5 L2.5,19.5 C2.224,19.5 2,19.724 2,20 C2,20.276 2.224,20.5 2.5,20.5 L10.5,20.5 C10.776,20.5 11,20.276 11,20 C11,19.724 10.776,19.5 10.5,19.5 Z'></path> </g> </g> </g> </g> </g> </svg>",
    GLOBE_ICON_SVG: "<svg width='13px' height='13px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-115.000000, -147.000000)' fill-rule='nonzero' fill='inherit'> <g transform='translate(95.000000, 0.000000)'> <g transform='translate(20.000000, 113.000000)'> <g transform='translate(0.000000, 34.000000)'> <path d='M10.409,0.893375 C9.40275,0.329875 8.24075,0.00875 7,0 C3.13075,0 0,3.140375 0,7 C0,10.521875 2.594375,13.42775 5.97625,13.93 C6.314875,13.974625 6.6535,14 7,14 C8.24075,14 9.40275,13.678875 10.409,13.1145 C12.551875,11.918375 14,9.6285 14,7 C13.99125,4.3715 12.551875,2.090375 10.409,0.893375 Z M11.554375,4.375 L9.431625,4.375 C9.302125,3.5 9.10875,2.736125 8.86725,2.085125 C10.003875,2.519125 10.9515,3.5 11.554375,4.375 Z M6.941375,1.73775 C6.960625,1.736875 6.979875,1.73425 7,1.73425 C7.020125,1.73425 7.039375,1.736875 7.058625,1.73775 C7.340375,2.172625 7.697375,3.5 7.92225,4.375 L6.07775,4.375 C6.302625,3.5 6.659625,2.172625 6.941375,1.73775 Z M1.81475,7.875 C1.7675,7.875 1.73425,7.29925 1.73425,7 C1.73425,6.70075 1.764875,6.125 1.813,6.125 L4.396875,6.125 C4.384625,6.125 4.375,6.7025 4.375,7 C4.375,7.2975 4.384625,7.875 4.396875,7.875 L1.81475,7.875 Z M4.354875,11.54475 C4.346125,11.54475 4.337375,11.54475 4.337375,11.536 C3.548125,11.07575 2.893625,10.5 2.436875,9.625 L4.568375,9.625 C4.697875,10.5 4.890375,11.262125 5.131875,11.91225 C4.8615,11.81075 4.599875,11.692625 4.354875,11.54475 Z M4.568375,4.375 L2.443875,4.375 C3.045875,3.5 3.994375,2.517375 5.131875,2.083375 C4.89125,2.734375 4.697875,3.5 4.568375,4.375 Z M7.0595,12.26225 C7.039375,12.26225 7.020125,12.26575 7,12.26575 C6.979875,12.26575 6.960625,12.26225 6.9405,12.26225 C6.65875,11.8265 6.302625,11.375 6.07775,9.625 L7.921375,9.625 C7.697375,11.375 7.34125,11.8265 7.0595,12.26225 Z M8.11125,7.875 L5.88875,7.875 C5.873875,7.875 5.8625,7.30625 5.8625,7 C5.8625,6.69375 5.873875,6.125 5.88875,6.125 L8.11125,6.125 C8.126125,6.125 8.1375,6.69375 8.1375,7 C8.1375,7.30625 8.126125,7.875 8.11125,7.875 Z M10.409,11.0075 C10.13075,11.242 9.828,11.45025 9.506875,11.631375 C9.30125,11.74075 9.086875,11.839625 8.8655,11.923625 C9.107,11.270875 9.30125,10.5 9.431625,9.625 L11.557875,9.625 C11.25425,10.5 10.8675,10.618125 10.409,11.0075 Z M9.603125,7.875 C9.615375,7.875 9.625,7.2975 9.625,7 C9.625,6.7025 9.615375,6.125 9.603125,6.125 L12.186125,6.125 C12.235125,6.125 12.26575,6.70075 12.26575,7 C12.26575,7.29925 12.233375,7.875 12.18525,7.875 L9.603125,7.875 Z'></path> </g> </g> </g> </g> </g> </svg>",
    LOCK_ICON_SVG: "<svg width='12px' height='13px' viewBox='0 0 13 15' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'> <g transform='translate(-116.000000, -175.000000)' fill-rule='nonzero' fill='inherit'> <g transform='translate(95.000000, 0.000000)'> <g transform='translate(20.000000, 113.000000)'> <g transform='translate(1.000000, 62.000000)'> <path d='M12.0714286,6.5 L11.1428571,6.5 L11.1428571,4.64285714 C11.1428571,2.07814286 9.06471429,0 6.5,0 C3.93528571,0 1.85714286,2.07814286 1.85714286,4.64285714 L1.85714286,6.5 L0.928571429,6.5 C0.415071429,6.5 0,7.00792857 0,7.52142857 L0,13.9285714 C0,14.4420714 0.415071429,14.8571429 0.928571429,14.8571429 L12.0714286,14.8571429 C12.5849286,14.8571429 13,14.4420714 13,13.9285714 L13,7.52142857 C13,7.00792857 12.5849286,6.5 12.0714286,6.5 Z M6.5,1.85714286 C8.03585714,1.85714286 9.28571429,3.107 9.28571429,4.64285714 L9.28571429,6.5 L8.35714286,6.5 L4.64285714,6.5 L3.71428571,6.5 L3.71428571,4.64285714 C3.71428571,3.107 4.96414286,1.85714286 6.5,1.85714286 Z'></path> </g> </g> </g> </g> </g> </svg>",
    // WVC_ICON_SVG: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'\t viewBox='0 0 13 13' style='enable-background:new 0 0 13 13;' xml:space='preserve'><style type='text/css'>\t.st0{fill:#CACACA;}</style><path class='st0' d='M1.5,2.6C1.4,1.2,2.7,0,4.1,0s2.7,1.2,2.6,2.7C6.7,3.4,6.4,4,6,4.4C5.5,5,4.8,5.2,4.1,5.2\tC3.3,5.2,2.7,5,2.2,4.5C1.8,4,1.4,3.4,1.5,2.6z'/><path class='st0' d='M9.8,7.1C8.7,7.1,8,6.2,8,5.3s0.8-1.7,1.8-1.8c0.9,0,1.8,0.9,1.8,1.8S10.8,7.1,9.8,7.1z'/><path class='st0' d='M9.2,8.6c0.1,0.7,0.1,1.4,0.1,2.1c0,0.8,0,1.5,0,2.3H13c0-0.8,0.1-1.5-0.1-2.3c0-0.3-0.1-0.5-0.2-0.8\tc-0.1-0.4-0.2-0.8-0.4-1.1c-0.2-0.4-0.4-0.6-0.8-0.9c-0.3-0.2-0.7-0.4-1.1-0.4c-0.5-0.1-1,0-1.5,0.2C9,7.7,9,7.8,9,7.8\tC9.1,8.1,9.2,8.3,9.2,8.6z'/><path class='st0' d='M8,8.5c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.6-0.6-1-1-1.4C6.5,6.3,6.1,6.1,5.8,6C5.4,5.8,4.9,5.7,4.5,5.7\tc-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0.1-1,0.3c-0.4,0.1-0.7,0.2-1,0.4C1.3,6.6,1.1,6.8,0.9,7S0.5,7.5,0.4,7.8C0.2,8,0.1,8.3,0.1,8.6\tc0,0.7-0.1,1.5-0.1,2.2s0,1.4,0,2.2h8.1c0-0.8,0-1.6,0-2.4C8.1,9.9,8.1,9.2,8,8.5z'/></svg>",
    WVC_ICON_SVG: "<svg width='13px' height='13px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 13 13' xml:space='preserve'><g stroke='none' stroke-width='1' fill='inherit' fill-rule='evenodd'><path class='st0' d='M1.5,2.6C1.4,1.2,2.7,0,4.1,0s2.7,1.2,2.6,2.7C6.7,3.4,6.4,4,6,4.4C5.5,5,4.8,5.2,4.1,5.2\tC3.3,5.2,2.7,5,2.2,4.5C1.8,4,1.4,3.4,1.5,2.6z'/><path class='st0' d='M9.8,7.1C8.7,7.1,8,6.2,8,5.3s0.8-1.7,1.8-1.8c0.9,0,1.8,0.9,1.8,1.8S10.8,7.1,9.8,7.1z'/><path class='st0' d='M9.2,8.6c0.1,0.7,0.1,1.4,0.1,2.1c0,0.8,0,1.5,0,2.3H13c0-0.8,0.1-1.5-0.1-2.3c0-0.3-0.1-0.5-0.2-0.8\tc-0.1-0.4-0.2-0.8-0.4-1.1c-0.2-0.4-0.4-0.6-0.8-0.9c-0.3-0.2-0.7-0.4-1.1-0.4c-0.5-0.1-1,0-1.5,0.2C9,7.7,9,7.8,9,7.8\tC9.1,8.1,9.2,8.3,9.2,8.6z'/><path class='st0' d='M8,8.5c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.6-0.6-1-1-1.4C6.5,6.3,6.1,6.1,5.8,6C5.4,5.8,4.9,5.7,4.5,5.7\tc-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0.1-1,0.3c-0.4,0.1-0.7,0.2-1,0.4C1.3,6.6,1.1,6.8,0.9,7S0.5,7.5,0.4,7.8C0.2,8,0.1,8.3,0.1,8.6\tc0,0.7-0.1,1.5-0.1,2.2s0,1.4,0,2.2h8.1c0-0.8,0-1.6,0-2.4C8.1,9.9,8.1,9.2,8,8.5z'/></g></svg>",
    GOOGLE_DRIVE_SVG: "<svg aria-hidden='true' data-fa-processed='' data-prefix='fab' data-icon='google-drive' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' class='svg-inline--fa fa-google-drive fa-w-16 fa-2x'><path fill='currentColor' d='M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z' class=''></path></svg>",
    TEAM_ADD_ICON_SVG: "<svg width='16px' height='16px' version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17 17' style='enable-background:new 0 0 17 17;' xml:space='preserve'><g><path class='st0' d='M1.6,6.9C0.7,6.9,0,7.6,0,8.5c0,0.9,0.7,1.6,1.6,1.6h5.3v5.3c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-5.3h5.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6h-5.3V1.6C10.1,0.7,9.4,0,8.5,0C7.6,0,6.9,0.7,6.9,1.6v5.3L1.6,6.9L1.6,6.9z'/></g></svg>",
    SWITCH_TEAM_ICON_SVG: "<svg width='20px' height='20px' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17 17' style='enable-background:new 0 0 17 17;' xml:space='preserve'><g id='Layer_1'></g><g id='Layer_2'><g><g><path class='st0' d='M4,4.9H0.6C0.3,4.9,0,4.6,0,4.3s0.3-0.6,0.6-0.6H4c0.3,0,0.6,0.3,0.6,0.6S4.4,4.9,4,4.9z'/></g><g><path class='st0' d='M3.3,7.8H0.7c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h2.5c0.3,0,0.6,0.3,0.6,0.6S3.6,7.8,3.3,7.8z'/></g><g><path class='st0' d='M3.7,10.5H0.7c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.1c0.3,0,0.6,0.3,0.6,0.6S4.1,10.5,3.7,10.5z'/></g><g><path class='st0' d='M5.7,13.3H0.7c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h5.1c0.3,0,0.6,0.3,0.6,0.6C6.4,13.1,6.1,13.3,5.7,13.3z'/></g><g><path class='st0' d='M16.4,14.4c-0.2,0-0.3-0.1-0.4-0.2l-2.4-2.4c-0.2-0.2-0.2-0.6,0-0.9c0.7-0.8,1.1-1.8,1.1-2.8c0-2.3-1.9-4.2-4.2-4.2S6.1,5.8,6.1,8.1c0,2.3,1.9,4.2,4.2,4.2c0.6,0,1.3-0.1,1.8-0.4c0.3-0.1,0.7,0,0.8,0.3c0.1,0.3,0,0.7-0.3,0.8c-0.7,0.4-1.5,0.5-2.4,0.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5c0,1.2-0.4,2.3-1,3.2l2,2c0.2,0.2,0.2,0.6,0,0.9C16.7,14.3,16.5,14.4,16.4,14.4z'/></g></g></g></svg>",
    CHANNEL_INFO_ICON_SVG: "<svg width='20px' height='20px' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17 17' style='enable-background:new 0 0 17 17;' xml:space='preserve'><g><path class='st0' d='M8.5,0C3.8,0,0,3.8,0,8.5S3.8,17,8.5,17S17,13.2,17,8.5S13.2,0,8.5,0z M8.5,15.5c-3.8,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S12.3,15.5,8.5,15.5z'/><path class='st0' d='M8.5,3.6c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C9.5,4.1,9.1,3.6,8.5,3.6z'/><path class='st0' d='M8.5,7.2C8.1,7.2,7.7,7.6,7.7,8v4.6c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8V8C9.3,7.6,8.9,7.2,8.5,7.2z'/></g></svg>",
    UPLOAD_BACKGROUND_ICON_SVG: "<svg width='96px' height='96px' version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17 17' style='enable-background:new 0 0 17 17;' xml:space='preserve'><g><g><path class='st0' d='M0.6,14.8c-0.3,0-0.6-0.3-0.6-0.6V2.5c0-0.3,0.3-0.6,0.6-0.6h13.3c0.3,0,0.6,0.3,0.6,0.6v6.5h-0.9h-0.5V3.3H1.4v7.8h0.7l2.7-4.2l1.8,2.8l0.9,1.4h0.8L7,9.1l0.8-1.3l2.1,3.3h0.9v0.7v1.4V14h0.9h1.1v0.7H0.6L0.6,14.8z M12.1,5.9c0,0.7-0.6,1.3-1.3,1.3S9.6,6.6,9.6,5.9s0.6-1.3,1.3-1.3C11.5,4.6,12.1,5.2,12.1,5.9z M15,13.2v2h-1.4v-0.4v-1.6h-2v-1.4h2v-2h0.9H15v2h2v1.4L15,13.2L15,13.2z'/></g></g></svg>",
    QUICK_DM_ICON: "<svg width='28px' height='28px' version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 20 20'  xml:space='preserve'><g><g><path d='M19.6,5.5H6.7c-0.2,0-0.4,0.2-0.4,0.4v0.8H2.5C2.3,6.6,2.1,6.8,2.1,7c0,0.2,0.2,0.4,0.4,0.4h3.8v5.2H4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3v0.8c0,0.2,0.2,0.4,0.4,0.4h12.9c0.2,0,0.4-0.2,0.4-0.4V5.9C20,5.6,19.8,5.5,19.6,5.5z M18.6,6.3l-5.5,4.5L7.7,6.3H18.6z M19.2,13.7H7.1V6.8l5.8,4.8c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l5.8-4.8V13.7z'/></g></g><g><g><path d='M4.7,9.6H0.4C0.2,9.6,0,9.7,0,10s0.2,0.4,0.4,0.4h4.3c0.2,0,0.4-0.2,0.4-0.4C5.1,9.7,4.9,9.6,4.7,9.6z'/></g></g></svg>",
    SWAP_LAYOUT_ICON: "<svg width='20px' height='20px' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'><g><path class='st0' d='M254.3,352c59.1,0,109.3-40.1,128-96c-18.6-55.9-68.8-96-128-96c-59.1,0-109.3,40.1-128,96 C145,311.9,195.2,352,254.3,352z M254.3,192c35.3,0,64,28.7,64,64s-28.6,64-64,64c-35.3,0-64-28.7-64-64S219,192,254.3,192z'/><circle class='st0' cx='254.4' cy='256' r='32'/><path class='st0' d='M428.8,252.8c-5.5-2.2-11.6,0.6-13.8,6.1c-2.1,5.5,0.6,11.7,6.1,13.8c36.3,14,57.2,31.7,57.2,48.5 c0,26.6-56.3,60.7-160.7,71.5c-5.8,0.6-10.1,5.8-9.5,11.7c0.6,5.5,5.2,9.6,10.6,9.6c0.4,0,0.7,0,1.1,0 c109.2-11.3,179.8-47.7,179.8-92.7C499.7,294.3,475.2,270.7,428.8,252.8z'/><path class='st0' d='M261.6,398.7l-42.4-42.4c-4.2-4.2-10.9-4.2-15.1,0s-4.2,10.9,0,15.1l23.9,23.9 C110.2,390.5,30.3,354,30.3,321.1c0-16.8,20.8-34.5,57.2-48.5c5.5-2.1,8.2-8.3,6.1-13.8c-2.1-5.5-8.3-8.2-13.8-6.1 C33.5,270.6,9,294.3,9,321.2c0,58,109.2,91.1,220,95.5l-24.9,24.9c-4.2,4.2-4.2,10.9,0,15.1c2.1,2.1,4.8,3.1,7.6,3.1 c2.8,0,5.5-1,7.6-3.1L262,414c3.9-3.9,4.1-10.1,0.6-14.3C262.3,399.4,261.9,399,261.6,398.7z'/></g></svg>",
    THEMES: {
        default: {
            type: 'Default',
            awayIndicator: "#db950b",
            buttonBg: "#007aff",
            buttonColor: "#ffffff",
            centerChannelBg: "#ffffff",
            centerChannelColor: "#222222",
            codeTheme: "solarized-dark",
            errorTextColor: "#e62739",
            linkColor: "#007aff",
            mentionBj: "#e62739",
            mentionColor: "#ffffff",
            mentionHighlightBg: "#e8ce00",
            mentionHighlightLink: "#296fc2",
            newMessageSeparator: "#296fc2",
            onlineIndicator: "#377fd1",
            sidebarBg: "#fafafa",
            sidebarHeaderBg: "#4d96e9",
            sidebarHeaderTextColor: "#ffffff",
            sidebarText: "#000000",
            sidebarTextActiveBorder: "#ebb139",
            sidebarTextActiveColor: "#296fc2",
            sidebarTextHoverBg: "#93cce5",
            sidebarUnreadText: "#ff2d55",
            image: _default2.default
        },
        work: {
            type: 'Work',
            awayIndicator: "#e6af4b",
            buttonBg: "#5634d1",
            buttonColor: "#ffffff",
            centerChannelBg: "#435c61",
            centerChannelColor: "#ffffff",
            codeTheme: "monokai",
            errorTextColor: "#dc322f",
            linkColor: "#91e5cc",
            mentionBj: "#dc322f",
            mentionColor: "#ffffff",
            mentionHighlightBg: "#ec66f8",
            mentionHighlightLink: "#ffffff",
            newMessageSeparator: "#e6af4b",
            onlineIndicator: "#28dde0",
            sidebarBg: "#000fa3",
            sidebarHeaderBg: "#4ca7a8",
            sidebarHeaderTextColor: "#ffffff",
            sidebarText: "#ffffff",
            sidebarTextActiveBorder: "#28dde0",
            sidebarTextActiveColor: "#ffffff",
            sidebarTextHoverBg: "#ec66f8",
            sidebarUnreadText: "#5634d1",
            image: _work2.default
        },
        family: {
            type: 'Family',
            awayIndicator: "#e59500",
            buttonBg: "#c94b63",
            buttonColor: "#ffffff",
            centerChannelBg: "#ebebeb",
            centerChannelColor: "#111111",
            codeTheme: "monokai",
            errorTextColor: "#dc322f",
            linkColor: "#e16c3b",
            mentionBj: "#dc322f",
            mentionColor: "#ffffff",
            mentionHighlightBg: "#c94b63",
            mentionHighlightLink: "#ffffff",
            newMessageSeparator: "#e6af4b",
            onlineIndicator: "#0b9799",
            sidebarBg: "#f0e3cf",
            sidebarHeaderBg: "#f2b963",
            sidebarHeaderTextColor: "#000000",
            sidebarText: "#000000",
            sidebarTextActiveBorder: "#de0b3e",
            sidebarTextActiveColor: "#2604ff",
            sidebarTextHoverBg: "#e6983f",
            sidebarUnreadText: "#c94b63",
            image: _family2.default
        },
        fun: {
            type: 'Fun',
            awayIndicator: "#245ef7",
            buttonBg: "#5634d1",
            buttonColor: "#ffffff",
            centerChannelBg: "#000000",
            centerChannelColor: "#ffffff",
            codeTheme: "monokai",
            errorTextColor: "#dc322f",
            linkColor: "#bcabff",
            mentionBj: "#dc322f",
            mentionColor: "#ffffff",
            mentionHighlightBg: "#ffc705",
            mentionHighlightLink: "#000000",
            newMessageSeparator: "#e6af4b",
            onlineIndicator: "#fff500",
            sidebarBg: "#02c792",
            sidebarHeaderBg: "#09b576",
            sidebarHeaderTextColor: "#000000",
            sidebarText: "#000000",
            sidebarTextActiveBorder: "#bd3c3c",
            sidebarTextActiveColor: "#3412bd",
            sidebarTextHoverBg: "#d4bafa",
            sidebarUnreadText: "#5634d1",
            image: _fun2.default
        }
    },
    // +++ Alan - Add WVC Theme elements
    WVC_THEME_ELEMENTS: [{
        group: 'wvcElements',
        id: 'titleBarColor',
        uiName: 'Title Bar Color',
        defaultColor: "#1153ab"
    }, {
        group: 'wvcElements',
        id: 'titleFontColor',
        uiName: 'Title Font Color',
        defaultColor: '#fff'
    }],
    // ---
    THEME_ELEMENTS: [{
        group: 'sidebarElements',
        id: 'sidebarBg',
        uiName: 'Sidebar BG'
    }, {
        group: 'sidebarElements',
        id: 'sidebarText',
        uiName: 'Sidebar Text'
    }, {
        group: 'sidebarElements',
        id: 'sidebarHeaderBg',
        uiName: 'Sidebar Header BG'
    }, {
        group: 'sidebarElements',
        id: 'sidebarHeaderTextColor',
        uiName: 'Sidebar Header Text'
    }, {
        group: 'sidebarElements',
        id: 'sidebarUnreadText',
        uiName: 'Sidebar Unread Text'
    }, {
        group: 'sidebarElements',
        id: 'sidebarTextHoverBg',
        uiName: 'Sidebar Text Hover BG'
    }, {
        group: 'sidebarElements',
        id: 'sidebarTextActiveBorder',
        uiName: 'Sidebar Text Active Border'
    }, {
        group: 'sidebarElements',
        id: 'sidebarTextActiveColor',
        uiName: 'Sidebar Text Active Color'
    }, {
        group: 'sidebarElements',
        id: 'onlineIndicator',
        uiName: 'Online Indicator'
    }, {
        group: 'sidebarElements',
        id: 'awayIndicator',
        uiName: 'Away Indicator'
    }, {
        group: 'sidebarElements',
        id: 'mentionBj',
        uiName: 'Mention Jewel BG'
    }, {
        group: 'sidebarElements',
        id: 'mentionColor',
        uiName: 'Mention Jewel Text'
    }, {
        group: 'centerChannelElements',
        id: 'centerChannelBg',
        uiName: 'Center Channel BG'
    }, {
        group: 'centerChannelElements',
        id: 'centerChannelColor',
        uiName: 'Center Channel Text'
    }, {
        group: 'centerChannelElements',
        id: 'newMessageSeparator',
        uiName: 'New Message Separator'
    }, {
        group: 'centerChannelElements',
        id: 'errorTextColor',
        uiName: 'Error Text Color'
    }, {
        group: 'centerChannelElements',
        id: 'mentionHighlightBg',
        uiName: 'Mention Highlight BG'
    }, {
        group: 'linkAndButtonElements',
        id: 'linkColor',
        uiName: 'Link Color'
    }, {
        group: 'centerChannelElements',
        id: 'mentionHighlightLink',
        uiName: 'Mention Highlight Link'
    }, {
        group: 'linkAndButtonElements',
        id: 'buttonBg',
        uiName: 'Button BG'
    }, {
        group: 'linkAndButtonElements',
        id: 'buttonColor',
        uiName: 'Button Text'
    }, {
        group: 'centerChannelElements',
        id: 'codeTheme',
        uiName: 'Code Theme',
        themes: [{
            id: 'solarized-dark',
            uiName: 'Solarized Dark',
            cssURL: _solarizedDark2.default,
            iconURL: _solarizedDark4.default
        }, {
            id: 'solarized-light',
            uiName: 'Solarized Light',
            cssURL: _solarizedLight2.default,
            iconURL: _solarizedLight4.default
        }, {
            id: 'github',
            uiName: 'GitHub',
            cssURL: _github2.default,
            iconURL: _github4.default
        }, {
            id: 'monokai',
            uiName: 'Monokai',
            cssURL: _monokai2.default,
            iconURL: _monokai4.default
        }]
    }],
    DEFAULT_CODE_THEME: 'default',
    KeyCodes: {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        CAPS_LOCK: 20,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        INSERT: 45,
        DELETE: 46,
        ZERO: 48,
        ONE: 49,
        TWO: 50,
        THREE: 51,
        FOUR: 52,
        FIVE: 53,
        SIX: 54,
        SEVEN: 55,
        EIGHT: 56,
        NINE: 57,
        A: 65,
        B: 66,
        C: 67,
        D: 68,
        E: 69,
        F: 70,
        G: 71,
        H: 72,
        I: 73,
        J: 74,
        K: 75,
        L: 76,
        M: 77,
        N: 78,
        O: 79,
        P: 80,
        Q: 81,
        R: 82,
        S: 83,
        T: 84,
        U: 85,
        V: 86,
        W: 87,
        X: 88,
        Y: 89,
        Z: 90,
        CMD: 91,
        MENU: 93,
        NUMPAD_0: 96,
        NUMPAD_1: 97,
        NUMPAD_2: 98,
        NUMPAD_3: 99,
        NUMPAD_4: 100,
        NUMPAD_5: 101,
        NUMPAD_6: 102,
        NUMPAD_7: 103,
        NUMPAD_8: 104,
        NUMPAD_9: 105,
        MULTIPLY: 106,
        ADD: 107,
        SUBTRACT: 109,
        DECIMAL: 110,
        DIVIDE: 111,
        F1: 112,
        F2: 113,
        F3: 114,
        F4: 115,
        F5: 116,
        F6: 117,
        F7: 118,
        F8: 119,
        F9: 120,
        F10: 121,
        F11: 122,
        F12: 123,
        NUM_LOCK: 144,
        SEMICOLON: 186,
        EQUAL: 187,
        COMMA: 188,
        DASH: 189,
        PERIOD: 190,
        FORWARD_SLASH: 191,
        TILDE: 192,
        OPEN_BRACKET: 219,
        BACK_SLASH: 220,
        CLOSE_BRACKET: 221
    },
    CODE_PREVIEW_MAX_FILE_SIZE: 500000, // 500 KB
    HighlightedLanguages: {
        actionscript: { name: 'ActionScript', extensions: ['as'], aliases: ['as', 'as3'] },
        applescript: { name: 'AppleScript', extensions: ['applescript', 'osascript', 'scpt'] },
        bash: { name: 'Bash', extensions: ['bash', 'sh', 'zsh'] },
        clojure: { name: 'Clojure', extensions: ['clj', 'boot', 'cl2', 'cljc', 'cljs', 'cljs.hl', 'cljscm', 'cljx', 'hic'] },
        coffeescript: { name: 'CoffeeScript', extensions: ['coffee', '_coffee', 'cake', 'cjsx', 'cson', 'iced'], aliases: ['coffee', 'coffee-script'] },
        cpp: { name: 'C/C++', extensions: ['cpp', 'c', 'cc', 'h', 'c++', 'h++', 'hpp'], aliases: ['c++'] },
        cs: { name: 'C#', extensions: ['cs', 'csharp'], aliases: ['c#', 'csharp'] },
        css: { name: 'CSS', extensions: ['css'] },
        d: { name: 'D', extensions: ['d', 'di'], aliases: ['dlang'] },
        dart: { name: 'Dart', extensions: ['dart'] },
        delphi: { name: 'Delphi', extensions: ['delphi', 'dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'] },
        diff: { name: 'Diff', extensions: ['diff', 'patch'], aliases: ['patch', 'udiff'] },
        django: { name: 'Django', extensions: ['django', 'jinja'] },
        dockerfile: { name: 'Dockerfile', extensions: ['dockerfile', 'docker'], aliases: ['docker'] },
        erlang: { name: 'Erlang', extensions: ['erl'], aliases: ['erl'] },
        fortran: { name: 'Fortran', extensions: ['f90', 'f95'] },
        fsharp: { name: 'F#', extensions: ['fsharp', 'fs'] },
        gcode: { name: 'G-Code', extensions: ['gcode', 'nc'] },
        go: { name: 'Go', extensions: ['go'], aliases: ['golang'] },
        groovy: { name: 'Groovy', extensions: ['groovy'] },
        handlebars: { name: 'Handlebars', extensions: ['handlebars', 'hbs', 'html.hbs', 'html.handlebars'], aliases: ['hbs', 'mustache'] },
        haskell: { name: 'Haskell', extensions: ['hs'], aliases: ['hs'] },
        haxe: { name: 'Haxe', extensions: ['hx'] },
        java: { name: 'Java', extensions: ['java', 'jsp'] },
        javascript: { name: 'JavaScript', extensions: ['js', 'jsx'], aliases: ['js'] },
        json: { name: 'JSON', extensions: ['json'] },
        julia: { name: 'Julia', extensions: ['jl'], aliases: ['jl'] },
        kotlin: { name: 'Kotlin', extensions: ['kt', 'ktm', 'kts'] },
        less: { name: 'Less', extensions: ['less'] },
        lisp: { name: 'Lisp', extensions: ['lisp'] },
        lua: { name: 'Lua', extensions: ['lua'] },
        makefile: { name: 'Makefile', extensions: ['mk', 'mak'], aliases: ['make', 'mf', 'gnumake', 'bsdmake'] },
        markdown: { name: 'Markdown', extensions: ['md', 'mkdown', 'mkd'], aliases: ['md', 'mkd'] },
        matlab: { name: 'Matlab', extensions: ['matlab', 'm'], aliases: ['m'] },
        objectivec: { name: 'Objective C', extensions: ['mm', 'objc', 'obj-c'], aliases: ['objective_c', 'objc'] },
        ocaml: { name: 'OCaml', extensions: ['ml'] },
        perl: { name: 'Perl', extensions: ['perl', 'pl'], aliases: ['pl'] },
        php: { name: 'PHP', extensions: ['php', 'php3', 'php4', 'php5', 'php6'], aliases: ['php3', 'php4', 'php5'] },
        powershell: { name: 'PowerShell', extensions: ['ps', 'ps1'], aliases: ['posh'] },
        puppet: { name: 'Puppet', extensions: ['pp'], aliases: ['pp'] },
        python: { name: 'Python', extensions: ['py', 'gyp'], aliases: ['py'] },
        r: { name: 'R', extensions: ['r'], aliases: ['r', 's'] },
        ruby: { name: 'Ruby', extensions: ['ruby', 'rb', 'gemspec', 'podspec', 'thor', 'irb'], aliases: ['rb'] },
        rust: { name: 'Rust', extensions: ['rs'], aliases: ['rs'] },
        scala: { name: 'Scala', extensions: ['scala'] },
        scheme: { name: 'Scheme', extensions: ['scm', 'sld'] },
        scss: { name: 'SCSS', extensions: ['scss'] },
        smalltalk: { name: 'Smalltalk', extensions: ['st'], aliases: ['st', 'squeak'] },
        sql: { name: 'SQL', extensions: ['sql'] },
        swift: { name: 'Swift', extensions: ['swift'] },
        tex: { name: 'TeX', extensions: ['tex'], aliases: ['latex'] },
        text: { name: 'Text', extensions: ['txt'] },
        vbnet: { name: 'VB.Net', extensions: ['vbnet', 'vb', 'bas'], aliases: ['vb', 'visualbasic'] },
        vbscript: { name: 'VBScript', extensions: ['vbs'] },
        verilog: { name: 'Verilog', extensions: ['v', 'veo'] },
        xml: { name: 'HTML, XML', extensions: ['xml', 'html', 'xhtml', 'rss', 'atom', 'xsl', 'plist'] },
        yaml: { name: 'YAML', extensions: ['yaml'], aliases: ['yml'] }
    },
    PostsViewJumpTypes: {
        BOTTOM: 1,
        POST: 2,
        SIDEBAR_OPEN: 3
    },
    NotificationPrefs: {
        MENTION: 'mention'
    },
    Integrations: {
        COMMAND: 'commands',
        INCOMING_WEBHOOK: 'incoming_webhooks',
        OUTGOING_WEBHOOK: 'outgoing_webhooks',
        OAUTH_APP: 'oauth2-apps'
    },
    FeatureTogglePrefix: 'feature_enabled_',
    PRE_RELEASE_FEATURES: {
        MARKDOWN_PREVIEW: {
            label: 'markdown_preview', // github issue: https://github.com/mattermost/platform/pull/1389
            description: 'Show markdown preview option in message input box'
        },
        EMBED_PREVIEW: {
            label: 'embed_preview',
            description: 'Show preview snippet of links below message'
        },
        WEBRTC_PREVIEW: {
            label: 'webrtc_preview',
            description: 'Enable WebRTC one on one calls'
        }
    },
    OVERLAY_TIME_DELAY_SMALL: 100,
    OVERLAY_TIME_DELAY: 400,
    WEBRTC_TIME_DELAY: 750,
    WEBRTC_CLEAR_ERROR_DELAY: 5000,
    DEFAULT_MAX_USERS_PER_TEAM: 50,
    MIN_TEAMNAME_LENGTH: 2,
    DEFAULT_MAX_CHANNELS_PER_TEAM: 2000,
    DEFAULT_MAX_NOTIFICATIONS_PER_CHANNEL: 1000,
    MAX_TEAMNAME_LENGTH: 32,
    MAX_TEAMDESCRIPTION_LENGTH: 200,
    MIN_CHANNELNAME_LENGTH: 2,
    MAX_CHANNELNAME_LENGTH: 22,
    // +++ alan
    MAX_VISITOR_LABEL_LENGTH: 22,
    MAX_GREETING_MSG_LENGTH: 64,
    MAX_MSG_PLACEHOLDER_LENGTH: 64,
    // ---
    MIN_USERNAME_LENGTH: 3,
    MAX_USERNAME_LENGTH: 22,
    MAX_NICKNAME_LENGTH: 22,
    MIN_PASSWORD_LENGTH: 5,
    MAX_PASSWORD_LENGTH: 64,
    MAX_POSITION_LENGTH: 35,
    MAX_COMPANY_NAME_LENGTH: 128,
    MAX_MOBILE_LENGTH: 32,
    MAX_TEL_LENGTH: 32,
    MAX_TEL_EXTENSION_LENGTH: 8,
    MAX_STATUS_NAME_LENGTH: 64,
    MAX_STATUS_DESC_LENGTH: 200,
    MIN_TRIGGER_LENGTH: 1,
    MAX_TRIGGER_LENGTH: 128,
    MAX_SITENAME_LENGTH: 30,
    TIME_SINCE_UPDATE_INTERVAL: 30000,
    MIN_HASHTAG_LINK_LENGTH: 3,
    CHANNEL_SCROLL_ADJUSTMENT: 180,
    NEW_CHANNEL_SCROLL_ADJUSTMENT: 300,
    EMOJI_PATH: '/static/emoji',
    RECENT_EMOJI_KEY: 'recentEmojis',
    DEFAULT_WEBHOOK_LOGO: _webhook_icon2.default,
    MHPNS: '',
    MTPNS: '',
    BOT_NAME: 'BOT',
    WVC_CLIENT_NAME: 'WEB VISITOR',
    OFFICIAL_NAME: 'OFFICIAL',
    MAX_PREV_MSGS: 100,
    POST_COLLAPSE_TIMEOUT: 1000 * 60 * 5, // five minutes
    PERMISSIONS_ALL: 'all',
    PERMISSIONS_CHANNEL_ADMIN: 'channel_admin',
    PERMISSIONS_TEAM_ADMIN: 'team_admin',
    PERMISSIONS_SYSTEM_ADMIN: 'system_admin',
    PERMISSIONS_NOBODY: 'nobody',
    PERMISSIONS_DELETE_POST_ALL: 'all',
    PERMISSIONS_DELETE_POST_TEAM_ADMIN: 'team_admin',
    PERMISSIONS_DELETE_POST_SYSTEM_ADMIN: 'system_admin',
    ALLOW_EDIT_POST_ALWAYS: 'always',
    ALLOW_EDIT_POST_NEVER: 'never',
    ALLOW_EDIT_POST_TIME_LIMIT: 'time_limit',
    DEFAULT_POST_EDIT_TIME_LIMIT: 300,
    MENTION_CHANNELS: 'mention.channels',
    MENTION_MORE_CHANNELS: 'mention.morechannels',
    MENTION_MEMBERS: 'mention.members',
    MENTION_NONMEMBERS: 'mention.nonmembers',
    MENTION_SPECIAL: 'mention.special',
    DEFAULT_NOTIFICATION_DURATION: 5000,
    STATUS_INTERVAL: 60000,
    AUTOCOMPLETE_TIMEOUT: 100,
    ANIMATION_TIMEOUT: 1000,
    SEARCH_TIMEOUT_MILLISECONDS: 100,
    DIAGNOSTICS_SEGMENT_KEY: '',
    TEST_ID_COUNT: 0,
    CENTER: 'center',
    RHS: 'rhs',
    RHS_ROOT: 'rhsroot',
    TEAMMATE_NAME_DISPLAY: {
        SHOW_USERNAME: 'username',
        SHOW_NICKNAME_FULLNAME: 'nickname_full_name',
        SHOW_FULLNAME: 'full_name'
    },
    SEARCH_POST: 'searchpost',
    ORDER_TYPE_BUSINESS: 'B',
    ORDER_TYPE_STARTUP: 'S',
    ORDER: {
        MIN_STORAGE: 10
    },
    GOOGLE_DRIVE: {
        TIMEOUT: 15,
        SCOPE: 'https://www.googleapis.com/auth/drive.readonly',
        DISCOVERY_DOCS: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
    },
    DROPBOX: {
        TIMEOUT: (3 * 60 + 45) * 1000
    },
    SEND_SMS_INTERVAL: 90, // 90 seconds
    SMS_TOKEN_LENGTH: 6,
    CHANNEL_USER_TYPES: {
        MEMBER: 'member',
        GUEST: 'guest'
    },
    SENSITIVE_VALUE: '**********'
};

exports.default = Constants;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var store      = __webpack_require__(178)('wks')
  , uid        = __webpack_require__(106)
  , Symbol     = __webpack_require__(6).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = __webpack_require__(133);



/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};



/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(9)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var anObject       = __webpack_require__(4)
  , IE8_DOM_DEFINE = __webpack_require__(310)
  , toPrimitive    = __webpack_require__(72)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var DOMProperty = __webpack_require__(135);
var ReactDOMComponentFlags = __webpack_require__(345);

var invariant = __webpack_require__(3);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _users = __webpack_require__(88);

var Selectors = _interopRequireWildcard(_users);

var _action_types = __webpack_require__(2);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserStatuses = _constants2.default.UserStatuses;

var CHANGE_EVENT_NOT_IN_CHANNEL = 'change_not_in_channel';
var CHANGE_EVENT_IN_CHANNEL = 'change_in_channel';
var CHANGE_EVENT_NOT_IN_TEAM = 'change_not_in_team';
var CHANGE_EVENT_IN_TEAM = 'change_in_team';
var CHANGE_EVENT_WITHOUT_TEAM = 'change_without_team';
var CHANGE_EVENT = 'change';
var CHANGE_EVENT_SESSIONS = 'change_sessions';
var CHANGE_EVENT_AUDITS = 'change_audits';
var CHANGE_EVENT_STATUSES = 'change_statuses';

var Utils;

var UserStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(UserStoreClass, _EventEmitter);

    function UserStoreClass() {
        (0, _classCallCheck3.default)(this, UserStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserStoreClass.__proto__ || (0, _getPrototypeOf2.default)(UserStoreClass)).call(this));

        _this.noAccounts = false;
        _this.entities = {};
        _this.lastPendingPostId = "";

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.users;

            if (newEntities.profiles !== _this.entities.profiles) {
                _this.emitChange();
            }
            if (newEntities.profilesInChannel !== _this.entities.profilesInChannel) {
                _this.emitInChannelChange();
            }
            if (newEntities.profilesNotInChannel !== _this.entities.profilesNotInChannel) {
                _this.emitNotInChannelChange();
            }
            if (newEntities.profilesInTeam !== _this.entities.profilesInTeam) {
                _this.emitInTeamChange();
            }
            if (newEntities.profilesNotInTeam !== _this.entities.profilesNotInTeam) {
                _this.emitNotInTeamChange();
            }
            if (newEntities.profilesWithoutTeam !== _this.entities.profilesWithoutTeam) {
                _this.emitWithoutTeamChange();
            }
            if (newEntities.statuses !== _this.entities.statuses) {
                _this.emitStatusesChange();
            }
            if (newEntities.myAudits !== _this.entities.myAudits) {
                _this.emitAuditsChange();
            }
            if (newEntities.mySessions !== _this.entities.mySessions) {
                _this.emitSessionsChange();
            }

            _this.entities = newEntities;
        });
        return _this;
    }

    (0, _createClass3.default)(UserStoreClass, [{
        key: 'emitChange',
        value: function emitChange(userId) {
            this.emit(CHANGE_EVENT, userId);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitInTeamChange',
        value: function emitInTeamChange() {
            this.emit(CHANGE_EVENT_IN_TEAM);
        }
    }, {
        key: 'addInTeamChangeListener',
        value: function addInTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_IN_TEAM, callback);
        }
    }, {
        key: 'removeInTeamChangeListener',
        value: function removeInTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_IN_TEAM, callback);
        }
    }, {
        key: 'emitNotInTeamChange',
        value: function emitNotInTeamChange() {
            this.emit(CHANGE_EVENT_NOT_IN_TEAM);
        }
    }, {
        key: 'addNotInTeamChangeListener',
        value: function addNotInTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_NOT_IN_TEAM, callback);
        }
    }, {
        key: 'removeNotInTeamChangeListener',
        value: function removeNotInTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_NOT_IN_TEAM, callback);
        }
    }, {
        key: 'emitInChannelChange',
        value: function emitInChannelChange() {
            this.emit(CHANGE_EVENT_IN_CHANNEL);
        }
    }, {
        key: 'addInChannelChangeListener',
        value: function addInChannelChangeListener(callback) {
            this.on(CHANGE_EVENT_IN_CHANNEL, callback);
        }
    }, {
        key: 'removeInChannelChangeListener',
        value: function removeInChannelChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_IN_CHANNEL, callback);
        }
    }, {
        key: 'emitNotInChannelChange',
        value: function emitNotInChannelChange() {
            this.emit(CHANGE_EVENT_NOT_IN_CHANNEL);
        }
    }, {
        key: 'addNotInChannelChangeListener',
        value: function addNotInChannelChangeListener(callback) {
            this.on(CHANGE_EVENT_NOT_IN_CHANNEL, callback);
        }
    }, {
        key: 'removeNotInChannelChangeListener',
        value: function removeNotInChannelChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_NOT_IN_CHANNEL, callback);
        }
    }, {
        key: 'emitWithoutTeamChange',
        value: function emitWithoutTeamChange() {
            this.emit(CHANGE_EVENT_WITHOUT_TEAM);
        }
    }, {
        key: 'addWithoutTeamChangeListener',
        value: function addWithoutTeamChangeListener(callback) {
            this.on(CHANGE_EVENT_WITHOUT_TEAM, callback);
        }
    }, {
        key: 'removeWithoutTeamChangeListener',
        value: function removeWithoutTeamChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_WITHOUT_TEAM, callback);
        }
    }, {
        key: 'emitSessionsChange',
        value: function emitSessionsChange() {
            this.emit(CHANGE_EVENT_SESSIONS);
        }
    }, {
        key: 'addSessionsChangeListener',
        value: function addSessionsChangeListener(callback) {
            this.on(CHANGE_EVENT_SESSIONS, callback);
        }
    }, {
        key: 'removeSessionsChangeListener',
        value: function removeSessionsChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_SESSIONS, callback);
        }
    }, {
        key: 'emitAuditsChange',
        value: function emitAuditsChange() {
            this.emit(CHANGE_EVENT_AUDITS);
        }
    }, {
        key: 'addAuditsChangeListener',
        value: function addAuditsChangeListener(callback) {
            this.on(CHANGE_EVENT_AUDITS, callback);
        }
    }, {
        key: 'removeAuditsChangeListener',
        value: function removeAuditsChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_AUDITS, callback);
        }
    }, {
        key: 'emitStatusesChange',
        value: function emitStatusesChange() {
            this.emit(CHANGE_EVENT_STATUSES);
        }
    }, {
        key: 'addStatusesChangeListener',
        value: function addStatusesChangeListener(callback) {
            this.on(CHANGE_EVENT_STATUSES, callback);
        }
    }, {
        key: 'removeStatusesChangeListener',
        value: function removeStatusesChangeListener(callback) {
            this.removeListener(CHANGE_EVENT_STATUSES, callback);
        }

        // General

    }, {
        key: 'getCurrentUser',
        value: function getCurrentUser() {
            return Selectors.getCurrentUser(_redux_store2.default.getState());
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentUserId(_redux_store2.default.getState());
        }

        // System-Wide Profiles

    }, {
        key: 'getProfiles',
        value: function getProfiles() {
            return Selectors.getUsers(_redux_store2.default.getState());
        }
    }, {
        key: 'getProfile',
        value: function getProfile(userId) {
            return Selectors.getUser(_redux_store2.default.getState(), userId);
        }
    }, {
        key: 'getProfileListForIds',
        value: function getProfileListForIds(userIds) {
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var profiles = [];
            var currentId = this.getCurrentId();

            for (var i = 0; i < userIds.length; i++) {
                var profile = this.getProfile(userIds[i]);

                if (!profile) {
                    continue;
                }

                if (skipCurrent && profile.id === currentId) {
                    continue;
                }

                if (skipInactive && profile.delete_at > 0) {
                    continue;
                }

                profiles.push(profile);
            }

            return profiles;
        }
    }, {
        key: 'hasProfile',
        value: function hasProfile(userId) {
            return this.getProfiles().hasOwnProperty(userId);
        }
    }, {
        key: 'getProfileByUsername',
        value: function getProfileByUsername(username) {
            return this.getProfilesUsernameMap()[username];
        }
    }, {
        key: 'getProfilesUsernameMap',
        value: function getProfilesUsernameMap() {
            return Selectors.getUsersByUsername(_redux_store2.default.getState());
        }
    }, {
        key: 'getProfileByEmail',
        value: function getProfileByEmail(email) {
            return Selectors.getUsersByEmail(_redux_store2.default.getState())[email];
        }
    }, {
        key: 'getActiveOnlyProfiles',
        value: function getActiveOnlyProfiles(skipCurrent) {
            var active = {};
            var profiles = this.getProfiles();
            var currentId = this.getCurrentId();

            for (var key in profiles) {
                if (!(profiles[key].id === currentId && skipCurrent) && profiles[key].delete_at === 0) {
                    active[key] = profiles[key];
                }
            }

            return active;
        }
    }, {
        key: 'getActiveOnlyProfileList',
        value: function getActiveOnlyProfileList() {
            var profileMap = this.getActiveOnlyProfiles();
            var profiles = [];

            for (var id in profileMap) {
                if (profileMap.hasOwnProperty(id)) {
                    profiles.push(profileMap[id]);
                }
            }

            profiles.sort(function (a, b) {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }
                return 0;
            });

            return profiles;
        }
    }, {
        key: 'getProfileList',
        value: function getProfileList() {
            var skipCurrent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var allowInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var profiles = [];
            var currentId = this.getCurrentId();
            var profileMap = this.getProfiles();

            for (var id in profileMap) {
                if (profileMap.hasOwnProperty(id)) {
                    var profile = profileMap[id];

                    if (skipCurrent && id === currentId) {
                        continue;
                    }

                    if (allowInactive || profile.delete_at === 0) {
                        profiles.push(profile);
                    }
                }
            }

            profiles.sort(function (a, b) {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }
                return 0;
            });

            return profiles;
        }
    }, {
        key: 'saveProfile',
        value: function saveProfile(profile) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE,
                data: profile
            });
        }

        // Team-Wide Profiles

    }, {
        key: 'getProfileListInTeam',
        value: function getProfileListInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsInTeams(_redux_store2.default.getState())[teamId] || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }
    }, {
        key: 'removeProfileFromTeam',
        value: function removeProfileFromTeam(teamId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
                data: { user_id: userId },
                id: teamId
            });
        }

        // Not In Team Profiles

    }, {
        key: 'getProfileListNotInTeam',
        value: function getProfileListNotInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsNotInTeams(_redux_store2.default.getState())[teamId] || []);
            var profiles = [];
            var currentId = this.getCurrentId();

            for (var i = 0; i < userIds.length; i++) {
                var profile = this.getProfile(userIds[i]);

                if (!profile) {
                    continue;
                }

                if (skipCurrent && profile.id === currentId) {
                    continue;
                }

                if (skipInactive && profile.delete_at > 0) {
                    continue;
                }

                profiles.push(profile);
            }

            return profiles;
        }
    }, {
        key: 'removeProfileNotInTeam',
        value: function removeProfileNotInTeam(teamId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                data: { user_id: userId },
                id: teamId
            });
        }

        // Channel-Wide Profiles

    }, {
        key: 'saveProfileInChannel',
        value: function saveProfileInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var profile = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: profile.id },
                id: channelId
            });
        }
    }, {
        key: 'saveUserIdInChannel',
        value: function saveUserIdInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var userId = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'removeProfileInChannel',
        value: function removeProfileInChannel(channelId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'getProfileListInChannel',
        value: function getProfileListInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var skipCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var skipInactive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsInChannels(_redux_store2.default.getState())[channelId] || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }
    }, {
        key: 'saveProfileNotInChannel',
        value: function saveProfileNotInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var profile = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                data: { user_id: profile.id },
                id: channelId
            });
        }
    }, {
        key: 'removeProfileNotInChannel',
        value: function removeProfileNotInChannel(channelId, userId) {
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: { user_id: userId },
                id: channelId
            });
        }
    }, {
        key: 'getProfileListNotInChannel',
        value: function getProfileListNotInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();
            var skipInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsNotInChannels(_redux_store2.default.getState())[channelId] || []);

            return this.getProfileListForIds(userIds, false, skipInactive);
        }

        // Profiles without any teams

    }, {
        key: 'getProfileListWithoutTeam',
        value: function getProfileListWithoutTeam() {
            var skipCurrent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var skipInactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var userIds = (0, _from2.default)(Selectors.getUserIdsWithoutTeam(_redux_store2.default.getState()) || []);

            return this.getProfileListForIds(userIds, skipCurrent, skipInactive);
        }

        // Other

    }, {
        key: 'getSessions',
        value: function getSessions() {
            return _redux_store2.default.getState().entities.users.mySessions;
        }
    }, {
        key: 'getAudits',
        value: function getAudits() {
            return _redux_store2.default.getState().entities.users.myAudits;
        }
    }, {
        key: 'getCurrentMentionKeys',
        value: function getCurrentMentionKeys() {
            return this.getMentionKeys(this.getCurrentId());
        }
    }, {
        key: 'getMentionKeys',
        value: function getMentionKeys(id) {
            var user = this.getProfile(id);

            var keys = [];

            if (!user || !user.notify_props) {
                return keys;
            }

            if (user.notify_props.mention_keys) {
                keys = keys.concat(user.notify_props.mention_keys.split(','));
            }

            if (user.notify_props.first_name === 'true' && user.first_name) {
                keys.push(user.first_name);
            }

            if (user.notify_props.channel === 'true') {
                keys.push('@channel');
                keys.push('@all');
            }

            var usernameKey = '@' + user.username;
            if (keys.indexOf(usernameKey) === -1) {
                keys.push(usernameKey);
            }

            return keys;
        }
    }, {
        key: 'setStatus',
        value: function setStatus(userId, status, extra) {

            var props = {};

            try {
                props = JSON.parse(extra);
            } catch (e) {}

            var data = [{ user_id: userId, status: status, props: props }];
            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_STATUSES,
                data: data
            });
        }
    }, {
        key: 'getStatuses',
        value: function getStatuses() {
            return _redux_store2.default.getState().entities.users.statuses;
        }
    }, {
        key: 'getStatus',
        value: function getStatus(id) {
            return this.getStatuses()[id] || UserStatuses.OFFLINE;
        }
    }, {
        key: 'getStatusesDetail',
        value: function getStatusesDetail() {
            return _redux_store2.default.getState().entities.users.statusesDetail || {};
        }
    }, {
        key: 'getStatusDetail',
        value: function getStatusDetail(id) {
            return this.getStatusesDetail()[id] || { status: UserStatuses.OFFLINE };
        }
    }, {
        key: 'getNoAccounts',
        value: function getNoAccounts() {
            return global.window.mm_config.NoAccounts === 'true';
        }
    }, {
        key: 'isPaidUser',
        value: function isPaidUser() {
            var teams = _team_store2.default.getAll();
            var reg = false;
            (0, _keys2.default)(teams).forEach(function (key) {
                if (teams[key].is_paid) {
                    reg = true;
                }
            });
            return reg;
        }
    }, {
        key: 'setNoAccounts',
        value: function setNoAccounts(noAccounts) {
            this.noAccounts = noAccounts;
        }
    }, {
        key: 'setLastPendingPostId',
        value: function setLastPendingPostId(id) {
            this.lastPendingPostId = id;
        }
    }, {
        key: 'getLastPendingPostId',
        value: function getLastPendingPostId() {
            return this.lastPendingPostId;
        }
    }, {
        key: 'isSystemAdminForCurrentUser',
        value: function isSystemAdminForCurrentUser() {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var current = this.getCurrentUser();

            if (current) {
                return Utils.isSystemAdmin(current.roles);
            }

            return false;
        }
    }]);
    return UserStoreClass;
}(_events2.default);

var UserStore = new UserStoreClass();
UserStore.setMaxListeners(600);

exports.default = UserStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Client4 = exports.Client = undefined;

var _client = __webpack_require__(1072);

var _client2 = _interopRequireDefault(_client);

var _client3 = __webpack_require__(1073);

var _client4 = _interopRequireDefault(_client3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Client = new _client2.default();
var Client4 = new _client4.default();

exports.Client = Client;
exports.Client4 = Client4;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(12);

var _post_utils = __webpack_require__(173);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _channels = __webpack_require__(175);

var Selectors = _interopRequireWildcard(_channels);

var _channels2 = __webpack_require__(541);

var _action_types = __webpack_require__(2);

var _reduxBatchedActions = __webpack_require__(30);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelUtils;
var Utils;

var NotificationPrefs = _constants.Constants.NotificationPrefs;

var CHANGE_EVENT = 'change';
var STATS_EVENT = 'stats';
var LAST_VIEVED_EVENT = 'last_viewed';

var ChannelStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(ChannelStoreClass, _EventEmitter);

    function ChannelStoreClass(props) {
        (0, _classCallCheck3.default)(this, ChannelStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelStoreClass.__proto__ || (0, _getPrototypeOf2.default)(ChannelStoreClass)).call(this, props));

        _this.setMaxListeners(600);
        _this.clear();

        _this.entities = _redux_store2.default.getState().entities.channels;

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.channels;
            var doEmit = false;

            if (newEntities.currentChannelId !== _this.entities.currentChannelId) {
                doEmit = true;
            }
            if (newEntities.channels !== _this.entities.channels) {
                _this.setUnreadCountsByChannels((0, _values2.default)(newEntities.channels));
                doEmit = true;
            }
            if (newEntities.myMembers !== _this.entities.myMembers) {
                _this.setUnreadCountsByMembers((0, _values2.default)(newEntities.myMembers));
                _this.emitLastViewed();
                doEmit = true;
            }
            if (newEntities.membersInChannel !== _this.entities.membersInChannel) {
                doEmit = true;
            }
            if (newEntities.stats !== _this.entities.stats) {
                _this.emitStatsChange();
            }

            if (doEmit) {
                _this.emitChange();
            }

            _this.entities = newEntities;
        });
        return _this;
    }

    (0, _createClass3.default)(ChannelStoreClass, [{
        key: 'clear',
        value: function clear() {
            this.postMode = this.POST_MODE_CHANNEL;
            this.unreadCounts = {};
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitStatsChange',
        value: function emitStatsChange() {
            this.emit(STATS_EVENT);
        }
    }, {
        key: 'addStatsChangeListener',
        value: function addStatsChangeListener(callback) {
            this.on(STATS_EVENT, callback);
        }
    }, {
        key: 'removeStatsChangeListener',
        value: function removeStatsChangeListener(callback) {
            this.removeListener(STATS_EVENT, callback);
        }
    }, {
        key: 'emitLastViewed',
        value: function emitLastViewed() {
            this.emit(LAST_VIEVED_EVENT);
        }
    }, {
        key: 'addLastViewedListener',
        value: function addLastViewedListener(callback) {
            this.on(LAST_VIEVED_EVENT, callback);
        }
    }, {
        key: 'removeLastViewedListener',
        value: function removeLastViewedListener(callback) {
            this.removeListener(LAST_VIEVED_EVENT, callback);
        }
    }, {
        key: 'findFirstBy',
        value: function findFirstBy(field, value) {
            return this.doFindFirst(field, value, this.getChannels());
        }
    }, {
        key: 'findFirstMoreBy',
        value: function findFirstMoreBy(field, value) {
            return this.doFindFirst(field, value, this.getMoreChannels());
        }
    }, {
        key: 'doFindFirst',
        value: function doFindFirst(field, value, channels) {
            for (var i = 0; i < channels.length; i++) {
                if (channels[i][field] === value) {
                    return channels[i];
                }
            }

            return null;
        }
    }, {
        key: 'get',
        value: function get(id) {
            return this.findFirstBy('id', id);
        }
    }, {
        key: 'getMyMember',
        value: function getMyMember(id) {
            return this.getMyMembers()[id];
        }
    }, {
        key: 'getByName',
        value: function getByName(name) {
            return this.findFirstBy('name', name);
        }
    }, {
        key: 'getByTeamIdAndName',
        value: function getByTeamIdAndName(teamId, name) {
            var channel = {};
            var channels = this.getChannels();
            for (var i = 0; i < channels.length; i++) {
                if (channels[i].team_id === teamId && channels[i].name === name) {
                    channel = (0, _assign2.default)({}, channels[i]);
                    break;
                }
            }
            return channel;
        }
    }, {
        key: 'getByDisplayName',
        value: function getByDisplayName(displayName) {
            return this.findFirstBy('display_name', displayName);
        }
    }, {
        key: 'getMoreByName',
        value: function getMoreByName(name) {
            return this.findFirstMoreBy('name', name);
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            return this.getChannels();
        }
    }, {
        key: 'getMoreAll',
        value: function getMoreAll() {
            return this.getMoreChannels();
        }
    }, {
        key: 'setCurrentId',
        value: function setCurrentId(id) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.SELECT_CHANNEL,
                data: id,
                member: this.getMyMember(id)
            });
        }
    }, {
        key: 'resetCounts',
        value: function resetCounts(ids) {
            var _this2 = this;

            var membersToStore = [];
            ids.forEach(function (id) {
                var member = _this2.getMyMember(id);
                var channel = _this2.get(id);
                if (member && channel) {
                    var memberToStore = (0, _extends3.default)({}, member);
                    memberToStore.msg_count = channel.total_msg_count;
                    memberToStore.mention_count = 0;
                    membersToStore.push(memberToStore);
                    _this2.setUnreadCountByChannel(id);
                }
            });

            this.storeMyChannelMembersList(membersToStore);
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentChannelId(_redux_store2.default.getState());
        }
    }, {
        key: 'getCurrent',
        value: function getCurrent() {
            var currentId = this.getCurrentId();

            if (currentId) {
                return this.get(currentId);
            }

            return null;
        }
    }, {
        key: 'getCurrentMember',
        value: function getCurrentMember() {
            var currentId = this.getCurrentId();

            if (currentId) {
                return this.getMyMembers()[currentId];
            }

            return null;
        }
    }, {
        key: 'getCurrentStats',
        value: function getCurrentStats() {
            return this.getStats(this.getCurrentId());
        }
    }, {
        key: 'getStats',
        value: function getStats(channelId) {
            var stats = void 0;

            if (channelId) {
                stats = Selectors.getAllChannelStats(_redux_store2.default.getState())[channelId];
            }

            if (stats) {
                // create a defensive copy
                stats = (0, _assign2.default)({}, stats);
            } else {
                stats = { member_count: 0 };
            }

            return stats;
        }
    }, {
        key: 'updateLocalChannelLastPostAt',
        value: function updateLocalChannelLastPostAt(id, lastPostAt) {
            var channel = {};
            var channels = this.getChannels();
            for (var i = 0; i < channels.length; i++) {
                if (channels[i].id === id) {
                    channel = (0, _assign2.default)({}, channels[i]);
                    channel.last_post_at = lastPostAt;
                    break;
                }
            }
            this.storeChannel(channel);
        }
    }, {
        key: 'storeChannel',
        value: function storeChannel(channel) {
            var channels = this.getChannels();
            var found;

            for (var i = 0; i < channels.length; i++) {
                if (channels[i].id === channel.id) {
                    channels[i] = channel;
                    found = true;
                    break;
                }
            }

            if (!found) {
                channels.push(channel);
            }

            if (!ChannelUtils) {
                ChannelUtils = __webpack_require__(214); //eslint-disable-line global-require
            }

            channels = channels.sort(ChannelUtils.sortChannelsByDisplayName);
            this.storeChannels(channels);
        }
    }, {
        key: 'storeChannels',
        value: function storeChannels(channels) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                data: channels,
                teamId: channels[0].team_id
            });
        }
    }, {
        key: 'getChannels',
        value: function getChannels() {
            // return Selectors.getMyChannels(store.getState());
            return (0, _channels2.getMyAllChannels)(_redux_store2.default.getState());
        }
    }, {
        key: 'getTeamChannelIds',
        value: function getTeamChannelIds() {
            var channelIds = [];
            var channels = this.getChannels();
            for (var key in channels) {
                if (channels.hasOwnProperty(key)) {
                    var channel = channels[key];
                    channelIds.push(channel.id);
                }
            }
            return channelIds;
        }
    }, {
        key: 'getXTeamChannels',
        value: function getXTeamChannels() {
            var channelsArray = [];
            var channels = Selectors.getAllChannels(_redux_store2.default.getState());
            for (var key in channels) {
                if (channels.hasOwnProperty(key)) {
                    var channel = channels[key];
                    channelsArray.push(channel);
                }
            }
            return channelsArray;
        }
    }, {
        key: 'getAllPublicAndPrivateChannels',
        value: function getAllPublicAndPrivateChannels() {
            var channelsArray = [];
            var channels = Selectors.getAllChannels(_redux_store2.default.getState());
            for (var key in channels) {
                if (channels.hasOwnProperty(key)) {
                    var channel = channels[key];
                    if (channel.type === 'O' || channel.type === 'P') {
                        channelsArray.push(channel);
                    }
                }
            }
            return channelsArray;
        }
    }, {
        key: 'getChannelById',
        value: function getChannelById(id) {
            return this.get(id);
        }
    }, {
        key: 'storeMyChannelMember',
        value: function storeMyChannelMember(channelMember) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                data: channelMember
            });
        }
    }, {
        key: 'storeMyChannelMembers',
        value: function storeMyChannelMembers(channelMembers) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                data: (0, _values2.default)(channelMembers)
            });
        }
    }, {
        key: 'storeMyChannelMembersList',
        value: function storeMyChannelMembersList(channelMembers) {
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                data: channelMembers
            });
        }
    }, {
        key: 'getMyMembers',
        value: function getMyMembers() {
            return Selectors.getMyChannelMemberships(_redux_store2.default.getState());
        }
    }, {
        key: 'saveMembersInChannel',
        value: function saveMembersInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var members = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                data: (0, _values2.default)(members)
            });
        }
    }, {
        key: 'removeMemberInChannel',
        value: function removeMemberInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                data: { id: channelId, user_id: userId }
            });
        }
    }, {
        key: 'getMembersInChannel',
        value: function getMembersInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();

            return Selectors.getChannelMembersInChannels(_redux_store2.default.getState())[channelId] || {};
        }
    }, {
        key: 'hasActiveMemberInChannel',
        value: function hasActiveMemberInChannel() {
            var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            var members = this.getMembersInChannel(channelId);
            if (members && members[userId]) {
                return true;
            }

            return false;
        }
    }, {
        key: 'storeMoreChannels',
        value: function storeMoreChannels(channels) {
            var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();

            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                data: channels,
                teamId: teamId
            });
        }
    }, {
        key: 'getMoreChannels',
        value: function getMoreChannels() {
            var channels = Selectors.getOtherChannels(_redux_store2.default.getState());
            var channelMap = {};
            channels.forEach(function (c) {
                channelMap[c.id] = c;
            });
            return channelMap;
        }
    }, {
        key: 'getMoreChannelsList',
        value: function getMoreChannelsList() {
            return Selectors.getOtherChannels(_redux_store2.default.getState());
        }
    }, {
        key: 'isDefault',
        value: function isDefault(channel) {
            return channel.name === _constants.Constants.DEFAULT_CHANNEL;
        }
    }, {
        key: 'setPostMode',
        value: function setPostMode(mode) {
            this.postMode = mode;
        }
    }, {
        key: 'getPostMode',
        value: function getPostMode() {
            return this.postMode;
        }
    }, {
        key: 'setUnreadCountsByMembers',
        value: function setUnreadCountsByMembers(members) {
            var _this3 = this;

            members.forEach(function (m) {
                _this3.setUnreadCountByChannel(m.channel_id);
            });
        }
    }, {
        key: 'setUnreadCountsByCurrentMembers',
        value: function setUnreadCountsByCurrentMembers() {
            var _this4 = this;

            (0, _keys2.default)(this.getMyMembers()).forEach(function (key) {
                _this4.setUnreadCountByChannel(_this4.getMyMember(key).channel_id);
            });
        }
    }, {
        key: 'setUnreadCountsByChannels',
        value: function setUnreadCountsByChannels(channels) {
            var _this5 = this;

            channels.forEach(function (c) {
                _this5.setUnreadCountByChannel(c.id);
            });
        }
    }, {
        key: 'setUnreadCountByChannel',
        value: function setUnreadCountByChannel(id) {
            var ch = this.get(id);
            var chMember = this.getMyMember(id);

            if (ch == null || chMember == null) {
                return;
            }

            var chMentionCount = chMember.mention_count;
            var chUnreadCount = ch.total_msg_count - chMember.msg_count;

            if (chMember.notify_props && chMember.notify_props.mark_unread === NotificationPrefs.MENTION) {
                chUnreadCount = 0;
            }

            this.unreadCounts[id] = { msgs: chUnreadCount, mentions: chMentionCount };
        }
    }, {
        key: 'clearUnreadCountByChannel',
        value: function clearUnreadCountByChannel(id) {
            var ch = this.get(id);
            var chMember = this.getMyMember(id);

            if (ch == null || chMember == null) {
                return;
            }

            this.unreadCounts[id] = { msgs: 0, mentions: 0 };
        }
    }, {
        key: 'getChannelIdsInTeam',
        value: function getChannelIdsInTeam(teamId) {
            var result = [];
            var channels = this.getChannels();
            for (var i = 0; i < channels.length; i++) {
                if (channels[i].team_id === teamId) {
                    result.push(channels[i].id);
                }
            }
            return result;
        }
    }, {
        key: 'getUnreadCount',
        value: function getUnreadCount(id) {
            return this.unreadCounts[id] || { msgs: 0, mentions: 0 };
        }
    }, {
        key: 'getUnreadCounts',
        value: function getUnreadCounts() {
            return this.unreadCounts;
        }
    }, {
        key: 'getChannelNamesMap',
        value: function getChannelNamesMap() {
            var channelNamesMap = {};

            var channels = this.getChannels();
            for (var key in channels) {
                if (channels.hasOwnProperty(key)) {
                    var channel = channels[key];
                    channelNamesMap[channel.name] = channel;
                }
            }

            var moreChannels = this.getMoreChannels();
            for (var moreKey in moreChannels) {
                if (moreChannels.hasOwnProperty(moreKey)) {
                    var moreChannel = moreChannels[moreKey];
                    channelNamesMap[moreChannel.name] = moreChannel;
                }
            }

            return channelNamesMap;
        }
    }, {
        key: 'isChannelAdminForCurrentChannel',
        value: function isChannelAdminForCurrentChannel() {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var member = this.getMyMember(this.getCurrentId());

            if (!member) {
                return false;
            }

            return Utils.isChannelAdmin(member.roles);
        }
    }, {
        key: 'isChannelGuestForCurrentChannel',
        value: function isChannelGuestForCurrentChannel() {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var member = this.getMyMember(this.getCurrentId());

            if (!member) {
                return false;
            }

            return Utils.isGuest(member.roles);
        }
    }, {
        key: 'isChannelAdmin',
        value: function isChannelAdmin(userId, channelId) {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var channelMembers = this.getMembersInChannel(channelId);
            var channelMember = channelMembers[userId];

            if (channelMember) {
                return Utils.isChannelAdmin(channelMember.roles);
            }

            return false;
        }
    }, {
        key: 'isChannelGuest',
        value: function isChannelGuest(userId, channelId) {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var channelMembers = this.getMembersInChannel(channelId);
            var channelMember = channelMembers[userId];

            if (channelMember) {
                return Utils.isGuest(channelMember.roles);
            }

            return false;
        }
    }, {
        key: 'incrementMessages',
        value: function incrementMessages(id) {
            var markRead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.unreadCounts[id]) {
                // Should never happen
                console.log('Missing channel_id=' + id + ' in unreads object'); //eslint-disable-line no-console
            }

            var member = this.getMyMember(id);
            if (member && member.notify_props && member.notify_props.mark_unread === NotificationPrefs.MENTION) {
                return;
            }

            var channel = (0, _extends3.default)({}, this.get(id));
            channel.total_msg_count++;

            var actions = [];
            if (markRead) {
                actions.push({
                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                    data: (0, _extends3.default)({}, member, { msg_count: channel.total_msg_count })
                });
            }

            actions.push({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                data: channel
            });
            _redux_store2.default.dispatch((0, _reduxBatchedActions.batchActions)(actions));
        }
    }, {
        key: 'incrementMentionsIfNeeded',
        value: function incrementMentionsIfNeeded(id, msgProps) {
            var mentions = [];
            if (msgProps && msgProps.mentions) {
                mentions = JSON.parse(msgProps.mentions);
            }

            if (!this.unreadCounts[id]) {
                // Should never happen
                console.log('Missing channel_id=' + id + ' in unreads object'); //eslint-disable-line no-console
            }

            if (mentions.indexOf(_user_store2.default.getCurrentId()) !== -1) {
                var member = (0, _extends3.default)({}, this.getMyMember(id));
                member.mention_count++;
                _redux_store2.default.dispatch({
                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                    data: member
                });
            }
        }
    }, {
        key: 'POST_MODE_CHANNEL',
        get: function get() {
            return 1;
        }
    }, {
        key: 'POST_MODE_FOCUS',
        get: function get() {
            return 2;
        }
    }]);
    return ChannelStoreClass;
}(_events2.default);

var ChannelStore = new ChannelStoreClass();

ChannelStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case _constants.ActionTypes.CLICK_CHANNEL:
            ChannelStore.setCurrentId(action.id);
            ChannelStore.setPostMode(ChannelStore.POST_MODE_CHANNEL);
            break;

        case _constants.ActionTypes.RECEIVED_FOCUSED_POST:
            {
                var post = action.post_list.posts[action.postId];
                ChannelStore.setCurrentId(post.channel_id);
                ChannelStore.setPostMode(ChannelStore.POST_MODE_FOCUS);
                ChannelStore.emitChange();
                break;
            }

        case _constants.ActionTypes.RECEIVED_CHANNELS:
            ChannelStore.storeChannels(action.channels);
            break;

        case _constants.ActionTypes.RECEIVED_CHANNEL:
            ChannelStore.storeChannel(action.channel);
            if (action.member) {
                ChannelStore.storeMyChannelMember(action.member);
            }
            break;

        case _constants.ActionTypes.RECEIVED_MY_CHANNEL_MEMBERS:
            ChannelStore.storeMyChannelMembersList(action.members);
            break;
        case _constants.ActionTypes.RECEIVED_CHANNEL_MEMBER:
            ChannelStore.storeMyChannelMember(action.member);
            break;
        case _constants.ActionTypes.RECEIVED_MORE_CHANNELS:
            ChannelStore.storeMoreChannels(action.channels);
            break;
        case _constants.ActionTypes.RECEIVED_MEMBERS_IN_CHANNEL:
            ChannelStore.saveMembersInChannel(action.channel_id, action.channel_members);
            break;
        case _constants.ActionTypes.RECEIVED_CHANNEL_STATS:
            _redux_store2.default.dispatch({
                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS,
                data: action.stats
            });
            break;

        case _constants.ActionTypes.RECEIVED_POST:
            if (_constants.Constants.IGNORE_POST_TYPES.indexOf(action.post.type) !== -1) {
                return;
            }

            if (action.post.user_id === _user_store2.default.getCurrentId() && !(0, _post_utils.isSystemMessage)(action.post) && !(0, _post_utils.isFromWebhook)(action.post)) {
                var member = ChannelStore.getMyMember(action.post.channel_id);
                if (member) {
                    var memberToStore = (0, _extends3.default)({}, member);
                    memberToStore.last_posted_at = action.post.create_at;
                    ChannelStore.storeMyChannelMember(memberToStore);
                    ChannelStore.updateLocalChannelLastPostAt(action.post.channel_id, action.post.create_at);
                    ChannelStore.emitChange();
                }
                return;
            }

            var id = action.post.channel_id;
            var teamId = action.websocketMessageProps ? action.websocketMessageProps.team_id : null;
            var markRead = id === ChannelStore.getCurrentId() && window.isActive;

            // if (TeamStore.getCurrentId() === teamId || teamId === '') {
            if (!markRead) {
                ChannelStore.incrementMentionsIfNeeded(id, action.websocketMessageProps);
            }
            ChannelStore.incrementMessages(id, markRead);
            // }

            ChannelStore.updateLocalChannelLastPostAt(id, action.post.create_at);
            break;

        case _constants.ActionTypes.CREATE_POST:
            ChannelStore.incrementMessages(action.post.channel_id, true);
            break;

        case _constants.ActionTypes.CREATE_COMMENT:
            ChannelStore.incrementMessages(action.post.channel_id, true);
            break;

        default:
            break;
    }
});

exports.default = ChannelStore;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _apply = __webpack_require__(1063);

var _apply2 = _interopRequireDefault(_apply);

var _slicedToArray2 = __webpack_require__(170);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(169);

var _typeof3 = _interopRequireDefault(_typeof2);

var _map = __webpack_require__(165);

var _map2 = _interopRequireDefault(_map);

exports.isEmail = isEmail;
exports.isDigitsText = isDigitsText;
exports.isPhone = isPhone;
exports.isPositiveNumber = isPositiveNumber;
exports.isMac = isMac;
exports.createSafeId = createSafeId;
exports.cmdOrCtrlPressed = cmdOrCtrlPressed;
exports.isInRole = isInRole;
exports.isChannelAdmin = isChannelAdmin;
exports.isAdmin = isAdmin;
exports.isTeamMaster = isTeamMaster;
exports.isSystemAdmin = isSystemAdmin;
exports.isWebVisitor = isWebVisitor;
exports.isVerifiedUser = isVerifiedUser;
exports.isCordchatOfficial = isCordchatOfficial;
exports.isGuest = isGuest;
exports.isTeamGuest = isTeamGuest;
exports.getCookie = getCookie;
exports.notifyMe = notifyMe;
exports.ding = ding;
exports.hasSoundOptions = hasSoundOptions;
exports.getDateForUnixTicks = getDateForUnixTicks;
exports.displayDate = displayDate;
exports.displayTime = displayTime;
exports.getTimestamp = getTimestamp;
exports.extractFirstLink = extractFirstLink;
exports.escapeRegExp = escapeRegExp;
exports.areObjectsEqual = areObjectsEqual;
exports.areMapsEqual = areMapsEqual;
exports.replaceHtmlEntities = replaceHtmlEntities;
exports.insertHtmlEntities = insertHtmlEntities;
exports.getFileType = getFileType;
exports.getFileIconPath = getFileIconPath;
exports.getIconClassName = getIconClassName;
exports.splitFileLocation = splitFileLocation;
exports.sortFilesByName = sortFilesByName;
exports.toTitleCase = toTitleCase;
exports.isHexColor = isHexColor;
exports.applyTheme = applyTheme;
exports.resetTheme = resetTheme;
exports.changeCss = changeCss;
exports.updateCodeTheme = updateCodeTheme;
exports.placeCaretAtEnd = placeCaretAtEnd;
exports.getCaretPosition = getCaretPosition;
exports.setSelectionRange = setSelectionRange;
exports.setCaretPosition = setCaretPosition;
exports.getSelectedText = getSelectedText;
exports.isValidUsername = isValidUsername;
exports.isValidCompanyName = isValidCompanyName;
exports.isValidMobileOrTel = isValidMobileOrTel;
exports.isValidTelExtension = isValidTelExtension;
exports.isMobile = isMobile;
exports.getDirectTeammate = getDirectTeammate;
exports.changeColor = changeColor;
exports.changeOpacity = changeOpacity;
exports.getFullName = getFullName;
exports.getDisplayName = getDisplayName;
exports.displayUsername = displayUsername;
exports.displayUsernameForUser = displayUsernameForUser;
exports.displayEntireName = displayEntireName;
exports.displayEntireNameForUser = displayEntireNameForUser;
exports.imageURLForUser = imageURLForUser;
exports.imageappURLForUser = imageappURLForUser;
exports.imageURLForTeam = imageURLForTeam;
exports.imageURLForChannel = imageURLForChannel;
exports.watermarkURLForUser = watermarkURLForUser;
exports.backgroundURLForUser = backgroundURLForUser;
exports.backgroundURLForTeam = backgroundURLForTeam;
exports.backgroundURLForChannel = backgroundURLForChannel;
exports.fileSizeToString = fileSizeToString;
exports.fileSizeToFixedToString = fileSizeToFixedToString;
exports.getWebsocketPort = getWebsocketPort;
exports.generateId = generateId;
exports.getDirectChannelName = getDirectChannelName;
exports.getUserIdFromChannelName = getUserIdFromChannelName;
exports.getUserIdFromChannelId = getUserIdFromChannelId;
exports.isDirectChannelForUser = isDirectChannelForUser;
exports.importSlack = importSlack;
exports.windowWidth = windowWidth;
exports.windowHeight = windowHeight;
exports.getChannelTerm = getChannelTerm;
exports.getPostTerm = getPostTerm;
exports.isFeatureEnabled = isFeatureEnabled;
exports.fillArray = fillArray;
exports.isFileTransfer = isFileTransfer;
exports.clearFileInput = clearFileInput;
exports.isPostEphemeral = isPostEphemeral;
exports.getRootId = getRootId;
exports.localizeMessage = localizeMessage;
exports.mod = mod;
exports.canCreateCustomEmoji = canCreateCustomEmoji;
exports.isValidPassword = isValidPassword;
exports.handleFormattedTextClick = handleFormattedTextClick;
exports.isEmptyObject = isEmptyObject;
exports.updateWindowDimensions = updateWindowDimensions;
exports.removePrefixFromLocalStorage = removePrefixFromLocalStorage;
exports.calculateExpiresAt = calculateExpiresAt;
exports.addToDate = addToDate;
exports.wgs2gcj = wgs2gcj;
exports.getSiteName = getSiteName;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _localization_store = __webpack_require__(172);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _user_agent = __webpack_require__(167);

var UserAgent = _interopRequireWildcard(_user_agent);

var _constants3 = __webpack_require__(8);

var _client = __webpack_require__(22);

var _es = __webpack_require__(49);

var _reactIntl = __webpack_require__(212);

var _icon50x = __webpack_require__(498);

var _icon50x2 = _interopRequireDefault(_icon50x);

var _bing = __webpack_require__(1093);

var _bing2 = _interopRequireDefault(_bing);

var _react = __webpack_require__(16);

var _react2 = _interopRequireDefault(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;
function isEmail(email) {
    // writing a regex to match all valid email addresses is really, really hard (see http://stackoverflow.com/a/201378)
    // so we just do a simple check and rely on a verification email to tell if it's a real address
    return (/^.+@.+$/.test(email)
    );
}

function isDigitsText(digits) {
    return (/^\d+$/.test(digits)
    );
}

function isPhone(digits) {
    return digits.startsWith("+") && /^\d+$/.test(digits.substring(1));
}

function isPositiveNumber(integer) {
    return (/^\d+\.?\d*$/.test(integer)
    );
}

function isMac() {
    return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}

function createSafeId(prop) {
    if (prop === null) {
        return null;
    }

    var str = '';

    if (prop.props && prop.props.defaultMessage) {
        str = prop.props.defaultMessage;
    } else {
        str = prop.toString();
    }

    return str.replace(new RegExp(' ', 'g'), '_');
}

function cmdOrCtrlPressed(e) {
    var allowAlt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (allowAlt) {
        return isMac() && e.metaKey || !isMac() && e.ctrlKey;
    }
    return isMac() && e.metaKey || !isMac() && e.ctrlKey && !e.altKey;
}

function isInRole(roles, inRole) {
    if (typeof roles === 'string') {
        var parts = roles.split(' ');
        for (var i = 0; i < parts.length; i++) {
            if (parts[i] === inRole) {
                return true;
            }
        }
    }

    return false;
}

function isChannelAdmin(roles) {
    if (global.mm_license.IsLicensed !== 'true') {
        return false;
    }

    if (isInRole(roles, 'channel_admin')) {
        return true;
    }

    return false;
}

function isAdmin(roles) {
    if (isInRole(roles, 'team_admin')) {
        return true;
    }

    if (isInRole(roles, 'system_admin')) {
        return true;
    }

    return false;
}

function isTeamMaster(roles) {
    if (isInRole(roles, 'team_master')) {
        return true;
    }

    if (isInRole(roles, 'system_admin')) {
        return true;
    }

    return false;
}

function isSystemAdmin(roles) {
    if (isInRole(roles, 'system_admin')) {
        return true;
    }

    return false;
}

function isWebVisitor(roles) {
    if (isInRole(roles, 'web_visitor')) {
        return true;
    }

    return false;
}

function isVerifiedUser(roles) {
    if (isInRole(roles, 'system_verified_user')) {
        return true;
    }

    return false;
}

function isCordchatOfficial(roles) {
    return isInRole(roles, 'system_cordchat_official_user');
}

function isGuest(roles) {
    if (isInRole(roles, 'channel_guest')) {
        return true;
    }

    return false;
}

function isTeamGuest(roles) {
    if (isInRole(roles, 'team_guest')) {
        return true;
    }

    return false;
}

function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return '';
}

var requestedNotificationPermission = false;

function notifyMe(title, body, channel, teamId, duration, silent) {
    if (!('Notification' in window)) {
        return;
    }

    var notificationDuration = _constants2.default.DEFAULT_NOTIFICATION_DURATION;
    if (duration != null) {
        notificationDuration = duration;
    }

    if (Notification.permission === 'granted' || Notification.permission === 'default' && !requestedNotificationPermission) {
        requestedNotificationPermission = true;

        Notification.requestPermission(function (permission) {
            if (permission === 'granted') {
                try {
                    var notification = new Notification(title, { body: body, tag: body, icon: _icon50x2.default, requireInteraction: notificationDuration === 0, silent: silent });
                    notification.onclick = function () {
                        window.focus();
                        if (channel && (channel.type === _constants2.default.DM_CHANNEL || channel.type === _constants2.default.GM_CHANNEL)) {
                            _es.browserHistory.push(_team_store2.default.getCurrentTeamUrl() + '/channels/' + channel.name);
                        } else if (channel) {
                            _es.browserHistory.push(_team_store2.default.getTeamUrl(teamId) + '/channels/' + channel.name);
                        } else if (teamId) {
                            _es.browserHistory.push(_team_store2.default.getTeamUrl(teamId) + '/channels/town-square');
                        } else {
                            _es.browserHistory.push(_team_store2.default.getCurrentTeamUrl() + '/channels/town-square');
                        }
                    };

                    if (notificationDuration > 0) {
                        setTimeout(function () {
                            notification.close();
                        }, notificationDuration);
                    }
                } catch (e) {
                    console.error(e); //eslint-disable-line no-console
                }
            }
        });
    }
}

var canDing = true;

function ding() {
    if (hasSoundOptions() && canDing) {
        var audio = new Audio(_bing2.default);
        audio.play();
        canDing = false;
        setTimeout(function () {
            canDing = true;
        }, 3000);
    }
}

function hasSoundOptions() {
    return !UserAgent.isFirefox() && !UserAgent.isEdge();
}

function getDateForUnixTicks(ticks) {
    return new Date(ticks);
}

function displayDate(ticks) {
    var d = new Date(ticks);
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
}

function displayTime(ticks, utc) {
    var d = new Date(ticks);
    var hours = void 0;
    var minutes = void 0;
    var ampm = '';
    var timezone = '';

    if (utc) {
        hours = d.getUTCHours();
        minutes = d.getUTCMinutes();
        timezone = ' UTC';
    } else {
        hours = d.getHours();
        minutes = d.getMinutes();
    }

    if (minutes <= 9) {
        minutes = '0' + minutes;
    }

    var useMilitaryTime = _preference_store2.default.getBool(_constants2.default.Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time');
    if (!useMilitaryTime) {
        ampm = ' AM';
        if (hours >= 12) {
            ampm = ' PM';
        }

        hours %= 12;
        if (!hours) {
            hours = '12';
        }
    }

    return hours + ':' + minutes + ampm + timezone;
}

// returns Unix timestamp in milliseconds
function getTimestamp() {
    return Date.now();
}

// extracts links not styled by Markdown
function extractFirstLink(text) {
    var pattern = /(^|[\s\n]|<br\/?>)((?:https?|ftp):\/\/[-A-Z0-9+\u0026\u2019@#/%?=()~_|!:,.;]*[-A-Z0-9+\u0026@#/%=~()_|])/i;
    var inText = text;

    // strip out code blocks
    inText = inText.replace(/`[^`]*`/g, '');

    // strip out inline markdown images
    inText = inText.replace(/!\[[^\]]*]\([^)]*\)/g, '');

    var match = pattern.exec(inText);
    if (match) {
        return match[0].trim();
    }

    return '';
}

function escapeRegExp(string) {
    return string.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}

// Taken from http://stackoverflow.com/questions/1068834/object-comparison-in-javascript and modified slightly
function areObjectsEqual(x, y) {
    var p = void 0;
    var leftChain = [];
    var rightChain = [];

    // Remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
        return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on step when comparing prototypes
    if (x === y) {
        return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (typeof x === 'function' && typeof y === 'function' || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || x instanceof String && y instanceof String || x instanceof Number && y instanceof Number) {
        return x.toString() === y.toString();
    }

    if (x instanceof _map2.default && y instanceof _map2.default) {
        return areMapsEqual(x, y);
    }

    // At last checking prototypes as good a we can
    if (!(x instanceof Object && y instanceof Object)) {
        return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
    }

    if (x.constructor !== y.constructor) {
        return false;
    }

    if (x.prototype !== y.prototype) {
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
    }

    // Quick checking of one object beeing a subset of another.
    for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if ((0, _typeof3.default)(y[p]) !== (0, _typeof3.default)(x[p])) {
            return false;
        }
    }

    for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        } else if ((0, _typeof3.default)(y[p]) !== (0, _typeof3.default)(x[p])) {
            return false;
        }

        switch ((0, _typeof3.default)(x[p])) {
            case 'object':
            case 'function':

                leftChain.push(x);
                rightChain.push(y);

                if (!areObjectsEqual(x[p], y[p])) {
                    return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

            default:
                if (x[p] !== y[p]) {
                    return false;
                }
                break;
        }
    }

    return true;
}

function areMapsEqual(a, b) {
    if (a.size !== b.size) {
        return false;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(a), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (!b.has(key)) {
                return false;
            }

            if (!areObjectsEqual(value, b.get(key))) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return true;
}

function replaceHtmlEntities(text) {
    var tagsToReplace = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>'
    };
    var newtext = text;
    for (var tag in tagsToReplace) {
        if ((0, _apply2.default)({}.hasOwnProperty, this, [tagsToReplace, tag])) {
            var regex = new RegExp(tag, 'g');
            newtext = newtext.replace(regex, tagsToReplace[tag]);
        }
    }
    return newtext;
}

function insertHtmlEntities(text) {
    var tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
    };
    var newtext = text;
    for (var tag in tagsToReplace) {
        if ((0, _apply2.default)({}.hasOwnProperty, this, [tagsToReplace, tag])) {
            var regex = new RegExp(tag, 'g');
            newtext = newtext.replace(regex, tagsToReplace[tag]);
        }
    }
    return newtext;
}

function getFileType(extin) {
    var ext = extin.toLowerCase();
    if (_constants2.default.IMAGE_TYPES.indexOf(ext) > -1) {
        return 'image';
    }

    if (_constants2.default.AUDIO_TYPES.indexOf(ext) > -1) {
        return 'audio';
    }

    if (_constants2.default.VIDEO_TYPES.indexOf(ext) > -1) {
        return 'video';
    }

    if (_constants2.default.SPREADSHEET_TYPES.indexOf(ext) > -1) {
        return 'spreadsheet';
    }

    if (_constants2.default.CODE_TYPES.indexOf(ext) > -1) {
        return 'code';
    }

    if (_constants2.default.WORD_TYPES.indexOf(ext) > -1) {
        return 'word';
    }

    if (_constants2.default.PRESENTATION_TYPES.indexOf(ext) > -1) {
        return 'presentation';
    }

    if (_constants2.default.PDF_TYPES.indexOf(ext) > -1) {
        return 'pdf';
    }

    if (_constants2.default.PATCH_TYPES.indexOf(ext) > -1) {
        return 'patch';
    }

    if (_constants2.default.SVG_TYPES.indexOf(ext) > -1) {
        return 'svg';
    }

    return 'other';
}

function getFileIconPath(fileInfo) {
    var fileType = getFileType(fileInfo.extension);

    var icon;
    if (fileType in _constants2.default.ICON_FROM_TYPE) {
        icon = _constants2.default.ICON_FROM_TYPE[fileType];
    } else {
        icon = _constants2.default.ICON_FROM_TYPE.other;
    }

    return icon;
}

function getIconClassName(fileTypeIn) {
    var fileType = fileTypeIn.toLowerCase();

    if (fileType in _constants2.default.ICON_NAME_FROM_TYPE) {
        return _constants2.default.ICON_NAME_FROM_TYPE[fileType];
    }

    return 'generic';
}

function splitFileLocation(fileLocation) {
    var fileSplit = fileLocation.split('.');

    var ext = '';
    if (fileSplit.length > 1) {
        ext = fileSplit[fileSplit.length - 1];
        fileSplit.splice(fileSplit.length - 1, 1);
    }

    var filePath = fileSplit.join('.');
    var filename = filePath.split('/')[filePath.split('/').length - 1];

    return { ext: ext, name: filename, path: filePath };
}

function sortFilesByName(files) {
    var locale = _localization_store2.default.getLocale();
    return (0, _from2.default)(files).sort(function (a, b) {
        return a.name.localeCompare(b.name, locale, { numeric: true });
    });
}

function toTitleCase(str) {
    function doTitleCase(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
    return str.replace(/\w\S*/g, doTitleCase);
}

function isHexColor(value) {
    return value && /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(value);
}

function applyTheme(oriTheme) {

    var theme = (0, _assign2.default)({}, oriTheme);
    var themeType = theme.type.toLocaleLowerCase();

    if (theme.type && _constants2.default.THEMES.hasOwnProperty(themeType)) {
        theme = (0, _assign2.default)({}, _constants2.default.THEMES[themeType]);
    }

    if (theme.sidebarBg) {
        changeCss('.app__body .sidebar--left .sidebar__switcher, .sidebar--left, .sidebar--left .sidebar__divider .sidebar__divider__text, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .sidebar--menu', 'background:' + theme.sidebarBg);
        changeCss('body.app__body', 'scrollbar-face-color:' + theme.sidebarBg);
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal:not(.settings-modal--tabless):not(.display--content) .modal-content', 'background:' + theme.sidebarBg);
        changeCss('.app__body .team-info-popover .fake-placeholder, .app__body .channel-info-popover .fake-placeholder, .app__body .user-popover__bg-placeholder', 'background:' + theme.sidebarBg);
        changeCss('.app__body .modal .new-channel__modal .profile-wrapper .profile-placeholder, .app__body .modal .new-channel__modal .profile-background-wrapper .background, .app__body .modal .settings-modal .profile-background-wrapper .background ', 'background:' + theme.sidebarBg);
    }

    if (theme.sidebarText) {
        changeCss('.app__body .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y', 'background:' + theme.sidebarText);
        changeCss('.app__body .ps-container:hover .ps-scrollbar-y-rail:hover, .app__body .sidebar__switcher button:hover', 'background:' + changeOpacity(theme.sidebarText, 0.15));
        changeCss('.app__body .sidebar--left .nav-pills__container li > h4, .app__body .sidebar--left .nav-pills__container li > a, .app__body .sidebar--right, .app__body .modal .settings-modal .nav-pills>li a', 'color:' + changeOpacity(theme.sidebarText, 0.6));
        changeCss('.app__body .sidebar--left .nav-pills__container li > div, .app__body .sidebar--left .nav-pills__container li > div.dropdown > a', 'color:' + changeOpacity(theme.sidebarText, 0.6));
        changeCss('.app__body .sidebar--left.new-sidebar .nav-pills__container li.new-list', 'border-color:' + changeOpacity(theme.sidebarText, 0.15));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>a, .app__body .sidebar--menu', 'color:' + changeOpacity(theme.sidebarText, 0.8));
        changeCss('.app__body .sidebar--left .add-channel-btn', 'color:' + changeOpacity(theme.sidebarText, 0.8));
        changeCss('.sidebar--left .add-channel-btn:hover, .sidebar--left .add-channel-btn:focus', 'color:' + theme.sidebarText);
        changeCss('.sidebar--left .status .offline--icon, .app__body .sidebar--menu svg, .app__body .sidebar-item .icon', 'fill:' + theme.sidebarText);
        changeCss('.sidebar--left .status.status--group', 'background:' + changeOpacity(theme.sidebarText, 0.3));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>a, .app__body .sidebar--menu .divider', 'border-color:' + changeOpacity(theme.sidebarText, 0.2));
        changeCss('.app__body .sidebar--left .sidebar__switcher', 'border-color:' + changeOpacity(theme.sidebarText, 0.2));
        changeCss('@media(max-width: 768px){.sidebar--left .add-channel-btn:hover, .sidebar--left .add-channel-btn:focus', 'color:' + changeOpacity(theme.sidebarText, 0.6));
        changeCss('@media(max-width: 768px){.app__body .search__icon svg', 'stroke:' + theme.sidebarText);
        changeCss('.app__body .sidebar--left .sidebar__switcher button', 'color:' + theme.sidebarText);
        changeCss('.app__body .sidebar--left .sidebar__switcher button svg', 'fill:' + theme.sidebarText);
        changeCss('.app__body .sidebar__switcher button', 'background:' + changeOpacity(theme.sidebarText, 0.08));
        changeCss('.app__body .modal .new-channel__modal .profile-wrapper .profile-placeholder svg, .app__body .modal .new-channel__modal .profile-background-wrapper .background svg, .app__body .modal .settings-modal .profile-background-wrapper .background svg', 'fill:' + changeOpacity(theme.sidebarText, 0.75));
        changeCss('.app__body .modal .new-channel__modal .profile-background-wrapper .background, .app__body .modal .settings-modal .profile-background-wrapper .background', 'border-color:' + changeOpacity(theme.sidebarText, 0.4));
        changeCss('.app__body .team__header-container .profile-background .background-placeholder svg', 'fill:' + changeOpacity(theme.sidebarText, 0.75));
    }

    if (theme.sidebarUnreadText) {
        changeCss('.sidebar--left .nav-pills__container li>a.unread-title', 'color:' + theme.sidebarUnreadText + '!important;');
        changeCss('.sidebar--left .nav li.wvc-sub-channel.unread-title>a', 'color:' + theme.sidebarUnreadText + '!important;');
    }

    if (theme.sidebarTextHoverBg) {
        changeCss('.sidebar--left .nav-pills__container li > a:hover, .app__body .modal .settings-modal .nav-pills>li:hover a', 'background:' + theme.sidebarTextHoverBg);
    }

    if (theme.sidebarTextActiveBorder) {
        changeCss('.sidebar--left .nav li.active a:before, .app__body .modal .settings-modal .nav-pills>li.active a:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.sidebar--left .sidebar__divider:before', 'background:' + changeOpacity(theme.sidebarTextActiveBorder, 0.5));
        changeCss('.sidebar--left .sidebar__divider', 'color:' + theme.sidebarTextActiveBorder);
        changeCss('.multi-teams .team-sidebar .team-wrapper .team-container.active:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.multi-teams .team-sidebar .team-wrapper .team-container.unread:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.app__body .suggestion-list .suggestion-list__item.active:before', 'background:' + theme.sidebarTextActiveBorder);
        changeCss('.app__body .suggestion-list .suggestion-list__item.unread:before', 'background:' + theme.sidebarTextActiveBorder);
    }

    if (theme.sidebarTextActiveColor) {
        changeCss('.sidebar--left .nav-pills__container li.active a, .sidebar--left .nav-pills__container li.active a:hover, .sidebar--left .nav-pills__container li.active a:focus, .app__body .modal .settings-modal .nav-pills>li.active a, .app__body .modal .settings-modal .nav-pills>li.active a:hover, .app__body .modal .settings-modal .nav-pills>li.active a:active', 'color:' + theme.sidebarTextActiveColor);
        changeCss('.sidebar--left .nav li.active a, .sidebar--left .nav li.active a:hover, .sidebar--left .nav li.active a:focus', 'background:' + changeOpacity(theme.sidebarTextActiveColor, 0.1));
        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .nav-pills > li.active a', 'color:' + changeOpacity(theme.sidebarText, 0.8));
    }

    if (theme.sidebarHeaderBg) {
        changeCss('.app__body .status-wrapper .status_dropdown__toggle .status, .sidebar--left.new-sidebar .new-list .status-wrapper .status, .sidebar--left .team__header, .sidebar--left .layout-switcher, .app__body .sidebar--menu .team__header, .app__body .post-list__timestamp > div', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .modal .modal-header', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .multi-teams .team-sidebar, .app__body #navbar .navbar-default', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .new-layout .new-sidebar .team-header, .app__body .modal .more-modal.can-switch-team .team-panel', 'background:' + theme.sidebarHeaderBg);
        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'background:' + theme.sidebarHeaderBg);
        changeCss('.app__body .attachment .attachment__container', 'border-left-color:' + theme.sidebarHeaderBg);
    }

    if (theme.sidebarHeaderTextColor) {
        changeCss('.app__body .status-wrapper .status_dropdown__toggle .status-edit, .multi-teams .team-sidebar .team-wrapper .team-container .team-btn, .sidebar--left .team__header .header__info, .app__body .sidebar--menu .team__header .header__info, .app__body .post-list__timestamp > div, .new-layout .team-header .team-switcher, .new-layout .team-header .team-btn', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.new-layout .team-header, .sidebar--left .layout-switcher, .app__body .modal .more-modal.can-switch-team .team-panel', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .multi-teams .team-sidebar svg, .app__body .new-layout .team-header svg, .layout-switcher svg', 'fill:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .icon--sidebarHeaderTextColor svg, .app__body .sidebar--left .status-wrapper .status_dropdown__toggle .offline--icon, .app__body .sidebar-header-dropdown__icon svg', 'fill:' + theme.sidebarHeaderTextColor);
        changeCss('.sidebar--left .team__header .user__name, .app__body .sidebar--menu .team__header .user__name', 'color:' + changeOpacity(theme.sidebarHeaderTextColor, 0.8));
        changeCss('.sidebar--left .team__header:hover .user__name, .app__body .sidebar--menu .team__header:hover .user__name, .sidebar--left .layout-switcher:hover', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .modal .modal-header .modal-title, .app__body .modal .modal-header .modal-title .name, .app__body .modal .modal-header button.close', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body #navbar .navbar-default .navbar-brand .dropdown-toggle', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body #navbar .navbar-default .navbar-toggle .icon-bar', 'background:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .post-list__timestamp > div', 'border-color:' + changeOpacity(theme.sidebarHeaderTextColor, 0.5));
        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'color:' + theme.sidebarHeaderTextColor);
        changeCss('@media(max-width: 768px){.app__body .search-bar__container .search__form', 'background:' + changeOpacity(theme.sidebarHeaderTextColor, 0.2));
        changeCss('.app__body .navbar-right__icon', 'background:' + changeOpacity(theme.sidebarHeaderTextColor, 0.2));
        changeCss('.app__body .navbar-right__icon svg', 'fill:' + theme.sidebarHeaderTextColor);
        changeCss('.app__body .navbar-right__icon svg', 'stroke:' + theme.sidebarHeaderTextColor);
    }

    if (theme.onlineIndicator) {
        changeCss('.app__body .status.status--online', 'color:' + theme.onlineIndicator);
        changeCss('.app__body .status .online--icon', 'fill:' + theme.onlineIndicator);
    }

    if (theme.awayIndicator) {
        changeCss('.app__body .status.status--away', 'color:' + theme.awayIndicator);
        changeCss('.app__body .status .away--icon', 'fill:' + theme.awayIndicator);
    }

    if (theme.mentionBj) {
        changeCss('.sidebar--left .nav-pills__unread-indicator', 'background:' + theme.mentionBj);
        changeCss('.app__body .sidebar--left .badge', 'background:' + theme.mentionBj);
        changeCss('.multi-teams .team-sidebar .badge', 'background:' + theme.mentionBj);
    }

    if (theme.mentionColor) {
        changeCss('.sidebar--left .nav-pills__unread-indicator svg', 'fill:' + theme.mentionColor);
        changeCss('.app__body .sidebar--left .nav-pills__unread-indicator', 'color:' + theme.mentionColor);
        changeCss('.app__body .sidebar--left .badge', 'color:' + theme.mentionColor);
        changeCss('.app__body .multi-teams .team-sidebar .badge', 'color:' + theme.mentionColor);
    }

    if (theme.centerChannelBg) {
        changeCss('@media(min-width: 768px){.app__body .post:hover .post__header .col__reply, .app__body .post.post--hovered .post__header .col__reply', 'background:' + theme.centerChannelBg);
        changeCss('@media(max-width: 320px){.tutorial-steps__container', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .channel-header__info .channel-header__description:before, .app__body .status-wrapper .status_dropdown__toggle .status .icon__container:after, .sidebar--left.new-sidebar .new-list .status-wrapper .status .icon__container:after, .app__body .app__content, .app__body .markdown__table, .app__body .markdown__table tbody tr, .app__body .suggestion-list__content, .app__body .modal .modal-content, .app__body .modal .modal-footer, .app__body .post.post--compact .post-image__column, .app__body .suggestion-list__divider > span, .app__body .status-wrapper .status, .app__body .alert.alert-transparent', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .tab-like', 'border-color: transparent transparent ' + changeOpacity(theme.centerChannelBg, 0.75) + ' transparent');
        changeCss('.app__body .tab-like.active', 'border-color: transparent transparent ' + theme.centerChannelBg + ' transparent');
        changeCss('#post-list .post-list-holder-by-time, .app__body .post .dropdown-menu a', 'background:' + theme.centerChannelBg);
        changeCss('#post-create', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .date-separator .separator__text, .app__body .new-separator .separator__text', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .post-image__details, .app__body .search-help-popover .search-autocomplete__divider span', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .sidebar--right, .app__body .dropdown-menu, .app__body .popover, .app__body .tip-overlay', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .popover.bottom>.arrow:after', 'border-bottom-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.right>.arrow:after, .app__body .tip-overlay.tip-overlay--sidebar .arrow, .app__body .tip-overlay.tip-overlay--header .arrow', 'border-right-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.left>.arrow:after', 'border-left-color:' + theme.centerChannelBg);
        changeCss('.app__body .popover.top>.arrow:after, .app__body .tip-overlay.tip-overlay--chat .arrow', 'border-top-color:' + theme.centerChannelBg);
        changeCss('@media(min-width: 768px){.app__body .form-control', 'background:' + theme.centerChannelBg);
        changeCss('@media(min-width: 768px){.app__body .sidebar--right.sidebar--right--expanded .sidebar-right-container', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .attachment__content', 'background:' + theme.centerChannelBg);
        changeCss('body.app__body', 'scrollbar-face-color:' + theme.centerChannelBg);
        changeCss('body.app__body', 'scrollbar-track-color:' + theme.centerChannelBg);
        // changeCss('.app__body .post-list__new-messages-below', 'color:' + theme.centerChannelBg);
        changeCss('.app__body .shortcut-key, .app__body .post-list__new-messages-below', 'color:' + theme.centerChannelBg);
        changeCss('.app__body .emoji-picker, .app__body .emoji-picker__search', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .nav-tabs, .app__body .nav-tabs > li.active > a', 'background:' + theme.centerChannelBg);
        changeCss('.app__body .country-list', 'background:' + theme.centerChannelBg);
    }

    if (theme.centerChannelColor) {
        changeCss('.app__body .mentions__name .status.status--group, .app__body .multi-select__note', 'background:' + changeOpacity(theme.centerChannelColor, 0.12));
        changeCss('.app__body .alert.alert-transparent, .app__body .channel-header .channel-header__icon, .app__body .search-bar__container .search__form', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.12));
        changeCss('.app__body .post-list__arrows, .app__body .post .flag-icon__container', 'fill:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('@media(min-width: 768px){.app__body .search__icon svg', 'stroke:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .channel-header__icon svg', 'fill:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .modal .status .offline--icon, .app__body .channel-header__links .icon, .app__body .sidebar--right .sidebar--right__subheader .usage__icon, .app__body .more-modal__header svg, .app__body .icon--body', 'fill:' + theme.centerChannelColor);
        changeCss('@media(min-width: 768px){.app__body .post:hover .post__header .col__reply, .app__body .post.post--hovered .post__header .col__reply', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        // changeCss('.app__body .sidebar--right .sidebar--right__header, .app__body .channel-header, .app__body .nav-tabs > li > a:hover, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:focus, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:hover, .app__body .post .dropdown-menu a, .sidebar--left, .app__body .suggestion-list__content .command', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .modal .shortcuts-modal .subsection, .app__body .sidebar--right .sidebar--right__header, .app__body .channel-header, .app__body .nav-tabs > li > a:hover, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:focus, .app__body .nav-tabs, .app__body .nav-tabs > li.active > a:hover, .app__body .post .dropdown-menu a, .sidebar--left, .app__body .suggestion-list__content .command', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.post--system .post__body, .app__body .modal .channel-switch-modal .modal-header .close', 'color:' + changeOpacity(theme.centerChannelColor, 0.6));
        changeCss('.app__body .nav-tabs, .app__body .nav-tabs > li.active > a, pp__body .input-group-addon, .app__body .app__content, .app__body .post-create__container .post-create-body .btn-file, .app__body .post-create__container .post-create-footer .msg-typing, .app__body .suggestion-list__content .command, .app__body .modal .modal-content, .app__body .dropdown-menu, .app__body .popover, .app__body .mentions__name, .app__body .tip-overlay, .app__body .form-control[disabled], .app__body .form-control[readonly], .app__body fieldset[disabled] .form-control', 'color:' + theme.centerChannelColor);
        // changeCss('.app__body .wvc-content .dropdown-menu', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .sidebar--left .nav li > div.dropdown li.wvc-sub-channel a', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .wvc-content .dropdown-menu .icon ', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .post .post__link', 'color:' + changeOpacity(theme.centerChannelColor, 0.65));
        changeCss('.app__body #archive-link-home, .video-div .video-thumbnail__error', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('.app__body #post-create', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', 'box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-webkit-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-moz-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px');
        changeCss('.app__body .dropdown-menu, .app__body .popover ', 'box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px');
        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-webkit-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px');
        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-moz-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px');
        // changeCss('.app__body .post__body hr, .app__body .loading-screen .loading__content .round, .app__body .tutorial__circles .circle', 'background:' + theme.centerChannelColor);
        changeCss('.app__body .shortcut-key, .app__body .post__body hr, .app__body .loading-screen .loading__content .round, .app__body .tutorial__circles .circle', 'background:' + theme.centerChannelColor);
        changeCss('.app__body .channel-header .heading', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .markdown__table tbody tr:nth-child(2n)', 'background:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('.app__body .channel-header__info>div.dropdown .header-dropdown__icon', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .channel-header__info .tab-like>div.dropdown .header-dropdown__icon', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .channel-header #member_popover', 'color:' + changeOpacity(theme.centerChannelColor, 0.4));
        changeCss('.app__body .channel-header .pinned-posts-button svg', 'fill:' + changeOpacity(theme.centerChannelColor, 0.6));
        changeCss('.app__body .custom-textarea, .app__body .custom-textarea:focus, .app__body .file-preview, .app__body .post-image__details, .app__body .sidebar--right .sidebar-right__body, .app__body .markdown__table th, .app__body .markdown__table td, .app__body .suggestion-list__content, .app__body .modal .modal-content, .app__body .modal .settings-modal .settings-table .settings-content .divider-light, .app__body .webhooks__container, .app__body .dropdown-menu, .app__body .modal .modal-header, .app__body .popover', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .popover.bottom>.arrow', 'border-bottom-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .search-help-popover .search-autocomplete__divider span, .app__body .suggestion-list__divider > span', 'color:' + changeOpacity(theme.centerChannelColor, 0.7));
        changeCss('.app__body .popover.right>.arrow', 'border-right-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .popover.left>.arrow', 'border-left-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .popover.top>.arrow', 'border-top-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .suggestion-list__content .command, .app__body .popover .popover-title', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .suggestion-list__content .command, .app__body .popover .popover__row', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .suggestion-list__divider:before, .app__body .dropdown-menu .divider, .app__body .search-help-popover .search-autocomplete__divider:before', 'background:' + theme.centerChannelColor);
        changeCss('.app__body .custom-textarea', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .post-image__details', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .post-image__column a, .app__body .post-image__column a:hover, .app__body .post-image__column a:focus', 'color:' + theme.centerChannelColor);
        changeCss('@media(min-width: 768px){.app__body .search-bar__container .search__form .search-bar, .app__body .form-control', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .input-group-addon, .app__body .form-control', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('@media(min-width: 768px){.app__body .post-list__table .post-list__content .dropdown-menu a:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .form-control:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .attachment .attachment__content', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .input-group-addon, .app__body .channel-intro .channel-intro__content, .app__body .webhooks__container, .app__body .member-list__popover .more-modal__header', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .date-separator .separator__text', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .date-separator .separator__hr, .app__body .modal-footer, .app__body .modal .custom-textarea', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .search-item-container, .app__body .post-right__container .post.post--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('.app__body .modal .custom-textarea:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .channel-intro, .app__body .modal .settings-modal .settings-table .settings-content .divider-dark, .app__body hr, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header, .app__body .user-settings .authorized-app:not(:last-child)', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.current--user .post__body, .app__body .post.post--comment.other--root.current--user .post-comment, .app__body pre, .app__body .post-right__container .post.post--root', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .post.post--comment.other--root.current--user .post-comment, .app__body .more-modal__list .more-modal__row, .app__body .member-div:first-child, .app__body .member-div, .app__body .access-history__table .access__report, .app__body .activity-log__table', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('@media(max-width: 1800px){.app__body .inner-wrap.move--left .post.post--comment.same--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('.app__body .post.post--hovered', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .attachment__body__wrap.btn-close', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .attachment__body__wrap.btn-close', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('@media(min-width: 768px){.app__body .post:hover, .app__body .more-modal__list .more-modal__row:hover, .app__body .modal .settings-modal .settings-table .settings-content .section-min:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.08));
        changeCss('.app__body .more-modal__row.more-modal__row--selected, .app__body .date-separator.hovered--before:after, .app__body .date-separator.hovered--after:before, .app__body .new-separator.hovered--after:before, .app__body .new-separator.hovered--before:after', 'background:' + changeOpacity(theme.centerChannelColor, 0.07));
        changeCss('@media(min-width: 768px){.app__body .suggestion-list__content .command:hover, .app__body .mentions__name:hover, .app__body .dropdown-menu>li>a:focus, .app__body .dropdown-menu>li>a:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('.app__body .suggestion--selected, .app__body .emoticon-suggestion:hover, .app__body .bot-indicator', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        changeCss('code, .app__body .form-control[disabled], .app__body .form-control[readonly], .app__body fieldset[disabled] .form-control', 'background:' + changeOpacity(theme.centerChannelColor, 0.1));
        changeCss('@media(min-width: 960px){.app__body .post.current--user:hover .post__body ', 'background: none;');
        changeCss('.app__body .sidebar--right', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .search-help-popover .search-autocomplete__item:hover, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body', 'background:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.app__body .search-help-popover .search-autocomplete__item.selected', 'background:' + changeOpacity(theme.centerChannelColor, 0.15));
        if (!UserAgent.isFirefox() && !UserAgent.isInternetExplorer() && !UserAgent.isEdge()) {
            changeCss('body.app__body ::-webkit-scrollbar-thumb', 'background:' + changeOpacity(theme.centerChannelColor, 0.4));
        }
        changeCss('body', 'scrollbar-arrow-color:' + theme.centerChannelColor);
        changeCss('.app__body .post-create__container .post-create-body .btn-file svg, .app__body .post.post--compact .post-image__column .post-image__details svg, .app__body .modal .about-modal .about-modal__logo svg, .app__body .post .post__img svg', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .scrollbar--horizontal, .app__body .scrollbar--vertical', 'background:' + changeOpacity(theme.centerChannelColor, 0.5));
        changeCss('.app__body .post-list__new-messages-below', 'background:' + changeColor(theme.centerChannelColor, 0.5));
        changeCss('.app__body .post.post--comment .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('@media(min-width: 768px){.app__body .post.post--compact.same--root.post--comment .post__content', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .post.post--comment.current--user .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .channel-header__info .status .offline--icon', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .navbar .status .offline--icon', 'fill:' + theme.centerChannelColor);
        changeCss('.app__body .post-reaction:not(.post-reaction--current-user)', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.25));
        changeCss('.app__body .post-reaction:not(.post-reaction--current-user)', 'color:' + changeOpacity(theme.centerChannelColor, 0.7));
        changeCss('.app__body .emoji-picker', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .emoji-picker', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .emoji-picker__preview, .app__body .emoji-picker__items, .app__body .emoji-picker__search-container', 'border-top-color:' + changeOpacity(theme.centerChannelColor, 0.2));
        changeCss('.app__body .emoji-picker__items', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.05));
        changeCss('.emoji-picker__category .fa:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .emoji-picker__category, .app__body .emoji-picker__category:focus, .app__body .emoji-picker__category:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.3));
        changeCss('.app__body .emoji-picker__category--selected, .app__body .emoji-picker__category--selected:focus, .app__body .emoji-picker__category--selected:hover', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .emoji-picker__item-wrapper:hover', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .emojisprite:hover', 'background-color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .icon__postcontent_picker:hover', 'color:' + changeOpacity(theme.centerChannelColor, 0.8));
        changeCss('.app__body .country-list', 'color:' + theme.centerChannelColor);
        changeCss('.app__body .channel-header #channelHeaderDropdown .icon svg, .app__body .channel-header .info-icon svg', 'fill:' + changeOpacity(theme.centerChannelColor, 0.4));
    }

    if (theme.newMessageSeparator) {
        changeCss('.app__body .new-separator .separator__text', 'color:' + theme.newMessageSeparator);
        changeCss('.app__body .new-separator .separator__hr', 'border-color:' + changeOpacity(theme.newMessageSeparator, 0.5));
    }

    if (theme.linkColor) {
        changeCss('.app__body .channel-header__links > a.active, .app__body a, .app__body a:focus, .app__body a:hover, .app__body .btn, .app__body .btn:focus, .app__body .btn:hover', 'color:' + theme.linkColor);
        changeCss('.app__body .attachment .attachment__container, .app__body .member-list__popover .more-modal__list .more-modal__row:hover', 'border-left-color:' + changeOpacity(theme.linkColor, 0.5));
        changeCss('.app__body .channel-header__links .icon:hover, .app__body .channel-header__links > a.active .icon, .app__body .post .flag-icon__container.visible, .app__body .post .reacticon__container, .app__body .post .comment-icon__container, .app__body .post .post__reply', 'fill:' + theme.linkColor);
        changeCss('@media(min-width: 768px){.app__body .search__form.focused .search__icon svg', 'stroke:' + theme.linkColor);
        changeCss('.app__body .channel-header__links .icon:hover, .app__body .post .flag-icon__container.visible, .app__body .post .comment-icon__container, .app__body .post .post__reply', 'fill:' + theme.linkColor);
        changeCss('.app__body .channel-header .channel-header__icon:hover #member_popover', 'color:' + theme.linkColor);
        changeCss('.app__body .channel-header .pinned-posts-button:hover svg', 'fill:' + changeOpacity(theme.linkColor, 0.6));
        changeCss('.app__body .member-list__popover .more-modal__actions svg, .app__body .channel-header .channel-header__icon:hover svg, .app__body .channel-header .channel-header__icon.active svg', 'fill:' + theme.linkColor);
        changeCss('.app__body .post-reaction.post-reaction--current-user', 'background:' + changeOpacity(theme.linkColor, 0.1));
        changeCss('.app__body .post-reaction.post-reaction--current-user', 'border-color:' + changeOpacity(theme.linkColor, 0.4));
        changeCss('.app__body .channel-header .channel-header__icon:hover, .app__body .channel-header .channel-header__icon.active, .app__body .search-bar__container .search__form.focused', 'border-color:' + theme.linkColor);
        changeCss('.app__body .post-reaction.post-reaction--current-user', 'color:' + theme.linkColor);
        changeCss('.app__body .channel-header #channelHeaderDropdown .icon:hover svg, .app__body .channel-header .info-icon:hover svg', 'fill:' + theme.linkColor);
    }

    if (theme.buttonBg) {
        changeCss('.app__body .new-messages__button div, .app__body .btn.btn-primary, .app__body .tutorial__circles .circle.active, .app__body .post__pinned-badge', 'background:' + theme.buttonBg);
        changeCss('.app__body .btn.btn-primary:hover, .app__body .btn.btn-primary:active, .app__body .btn.btn-primary:focus', 'background:' + changeColor(theme.buttonBg, -0.15));
    }

    if (theme.buttonColor) {
        changeCss('.app__body .new-messages__button div, .app__body .btn.btn-primary, .app__body .post__pinned-badge', 'color:' + theme.buttonColor);
        changeCss('.app__body .new-messages__button svg', 'fill:' + theme.buttonColor);
    }

    if (theme.errorTextColor) {
        changeCss('.app__body .has-error .help-block, .app__body .has-error .control-label, .app__body .has-error .radio, .app__body .has-error .checkbox, .app__body .has-error .radio-inline, .app__body .has-error .checkbox-inline, .app__body .has-error.radio label, .app__body .has-error.checkbox label, .app__body .has-error.radio-inline label, .app__body .has-error.checkbox-inline label', 'color:' + theme.errorTextColor);
    }

    if (theme.mentionHighlightBg) {
        changeCss('.app__body .mention--highlight, .app__body .search-highlight', 'background:' + theme.mentionHighlightBg);
        changeCss('.app__body .post.post--comment .post__body.mention-comment', 'border-color:' + theme.mentionHighlightBg);
        changeCss('.app__body .post.post--highlight', 'background:' + changeOpacity(theme.mentionHighlightBg, 0.5));
    }

    if (theme.mentionHighlightLink) {
        changeCss('.app__body .mention--highlight .mention-link, .app__body .mention--highlight, .app__body .search-highlight', 'color:' + theme.mentionHighlightLink);
    }

    if (!theme.codeTheme) {
        theme.codeTheme = _constants2.default.DEFAULT_CODE_THEME;
    }
    updateCodeTheme(theme.codeTheme);
}

function resetTheme() {
    applyTheme(_constants2.default.THEMES.default);
}

function changeCss(className, classValue) {
    var styleEl = document.querySelector('style[data-class="' + className + '"]');
    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.setAttribute('data-class', className);

        // Append style element to head
        document.head.appendChild(styleEl);
    }

    // Grab style sheet
    var styleSheet = styleEl.sheet;
    var rules = styleSheet.cssRules || styleSheet.rules;
    var style = classValue.substr(0, classValue.indexOf(':'));
    var value = classValue.substr(classValue.indexOf(':') + 1);

    for (var i = 0; i < rules.length; i++) {
        if (rules[i].selectorText === className) {
            rules[i].style[style] = value;
            return;
        }
    }

    var mediaQuery = '';
    if (className.indexOf('@media') >= 0) {
        mediaQuery = '}';
    }
    styleSheet.insertRule(className + '{' + classValue + '}' + mediaQuery, styleSheet.cssRules.length);
}

function updateCodeTheme(userTheme) {
    var cssPath = '';
    _constants2.default.THEME_ELEMENTS.forEach(function (element) {
        if (element.id === 'codeTheme') {
            element.themes.forEach(function (theme) {
                if (userTheme === theme.id) {
                    cssPath = theme.cssURL;
                }
            });
        }
    });
    var $link = (0, _jquery2.default)('link.code_theme');
    if (cssPath !== $link.attr('href')) {
        changeCss('code.hljs', 'visibility: hidden');
        var xmlHTTP = new XMLHttpRequest();
        xmlHTTP.open('GET', cssPath, true);
        xmlHTTP.onload = function onLoad() {
            $link.attr('href', cssPath);
            if (UserAgent.isFirefox()) {
                $link.one('load', function () {
                    changeCss('code.hljs', 'visibility: visible');
                });
            } else {
                changeCss('code.hljs', 'visibility: visible');
            }
        };
        xmlHTTP.send();
    }
}

function placeCaretAtEnd(el) {
    el.focus();
    el.selectionStart = el.value.length;
    el.selectionEnd = el.value.length;
}

function getCaretPosition(el) {
    if (el.selectionStart) {
        return el.selectionStart;
    } else if (document.selection) {
        el.focus();

        var r = document.selection.createRange();
        if (r == null) {
            return 0;
        }

        var re = el.createTextRange();
        var rc = re.duplicate();
        re.moveToBookmark(r.getBookmark());
        rc.setEndPoint('EndToStart', re);

        return rc.text.length;
    }
    return 0;
}

function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    }
}

function setCaretPosition(input, pos) {
    setSelectionRange(input, pos, pos);
}

function getSelectedText(input) {
    var selectedText;
    if (typeof document.selection !== 'undefined') {
        input.focus();
        var sel = document.selection.createRange();
        selectedText = sel.text;
    } else if (typeof input.selectionStart !== 'undefined') {
        var startPos = input.selectionStart;
        var endPos = input.selectionEnd;
        selectedText = input.value.substring(startPos, endPos);
    }

    return selectedText;
}

function isValidUsername(name) {
    var error = '';
    if (!name) {
        error = 'This field is required';
    } else if (name.length < _constants2.default.MIN_USERNAME_LENGTH || name.length > _constants2.default.MAX_USERNAME_LENGTH) {
        error = 'Invalid Length';
    } else if (!/^[a-z0-9.\-_]+$/.test(name)) {
        error = "Invalid Character";
    } else if (!/[a-z]/.test(name.charAt(0))) {
        //eslint-disable-line no-negated-condition
        error = 'Invalid First Character';
    } else {
        for (var i = 0; i < _constants2.default.RESERVED_USERNAMES.length; i++) {
            if (name === _constants2.default.RESERVED_USERNAMES[i]) {
                error = 'Cannot use a reserved word as a username.';
                break;
            }
        }
    }

    return error;
}

function isValidCompanyName(name) {
    var error = '';
    if (!name) {} else if (name.length > _constants2.default.MAX_COMPANY_NAME_LENGTH) {
        error = 'Invalid Length';
    }
    return error;
}

function isValidMobileOrTel(value) {
    var error = '';
    if (!value) {} else if (value.length > _constants2.default.MAX_MOBILE_LENGTH) {
        error = 'Invalid Length';
    }
    return error;
}

function isValidTelExtension(value) {
    var error = '';
    if (!value) {} else if (value.length > _constants2.default.MAX_TEL_EXTENSION_LENGTH) {
        error = 'Invalid Length';
    }
    return error;
}

function isMobile() {
    return window.innerWidth <= _constants2.default.MOBILE_SCREEN_WIDTH;
}

function getDirectTeammate(channelId) {
    var userIds = _channel_store2.default.get(channelId).name.split('__');
    var curUserId = _user_store2.default.getCurrentId();
    var teammate = {};

    if (userIds.length !== 2 || userIds.indexOf(curUserId) === -1) {
        return teammate;
    }

    for (var idx in userIds) {
        if (userIds[idx] !== curUserId) {
            teammate = _user_store2.default.getProfile(userIds[idx]);
            break;
        }
    }

    return teammate;
}

Image.prototype.load = function imageLoad(url, progressCallback) {
    var self = this;
    var xmlHTTP = new XMLHttpRequest();
    xmlHTTP.open('GET', url, true);
    xmlHTTP.responseType = 'arraybuffer';
    xmlHTTP.onload = function onLoad() {
        var h = xmlHTTP.getAllResponseHeaders();
        var m = h.match(/^Content-Type:\s*(.*?)$/mi);
        var mimeType = m[1] || 'image/png';

        var blob = new Blob([this.response], { type: mimeType });
        self.src = window.URL.createObjectURL(blob);
    };
    xmlHTTP.onprogress = function onprogress(e) {
        parseInt(self.completedPercentage = e.loaded / e.total * 100, 10);
        if (progressCallback) {
            progressCallback();
        }
    };
    xmlHTTP.onloadstart = function onloadstart() {
        self.completedPercentage = 0;
    };
    xmlHTTP.send();
};

Image.prototype.completedPercentage = 0;

function changeColor(colourIn, amt) {
    var hex = colourIn;
    var lum = amt;

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = '#';
    var c;
    var i;
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ('00' + c).substr(c.length);
    }

    return rgb;
}

function changeOpacity(oldColor, opacity) {
    var color = oldColor;
    if (color[0] === '#') {
        color = color.slice(1);
    }

    if (color.length === 3) {
        var tempColor = color;
        color = '';

        color += tempColor[0] + tempColor[0];
        color += tempColor[1] + tempColor[1];
        color += tempColor[2] + tempColor[2];
    }

    var r = parseInt(color.substring(0, 2), 16);
    var g = parseInt(color.substring(2, 4), 16);
    var b = parseInt(color.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
}

function getFullName(user) {
    if (user.first_name && user.last_name) {
        return user.first_name + ' ' + user.last_name;
    } else if (user.first_name) {
        return user.first_name;
    } else if (user.last_name) {
        return user.last_name;
    }

    return '';
}

function getDisplayName(user) {
    if (user.nickname && user.nickname.trim().length > 0) {
        return user.nickname;
    }
    var fullName = getFullName(user);

    if (fullName) {
        return fullName;
    }

    return user.username;
}

/**
 * Gets the display name of the user with the specified id, respecting the TeammateNameDisplay configuration setting
 */
function displayUsername(userId) {
    return displayUsernameForUser(_user_store2.default.getProfile(userId));
}

/**
 * Gets the display name of the specified user, respecting the TeammateNameDisplay configuration setting
 */
function displayUsernameForUser(user) {
    if (user) {
        var nameFormat = global.window.mm_config.TeammateNameDisplay;
        var name = user.username;
        if (nameFormat === _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_NICKNAME_FULLNAME && user.nickname && user.nickname !== '') {
            name = user.nickname;
        } else if ((user.first_name || user.last_name) && (nameFormat === _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_NICKNAME_FULLNAME || nameFormat === _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_FULLNAME)) {
            name = getFullName(user);
        }

        return name;
    }

    return '';
}

/**
 * Gets the entire name, including username, full name, and nickname, of the user with the specified id
 */
function displayEntireName(userId) {
    return displayEntireNameForUser(_user_store2.default.getProfile(userId));
}

/**
 * Gets the entire name, including username, full name, and nickname, of the specified user
 */
function displayEntireNameForUser(user) {
    if (!user) {
        return '';
    }

    var displayName = user.username;
    var fullName = getFullName(user);

    if (fullName && user.nickname) {
        displayName += ' - ' + fullName + ' (' + user.nickname + ')';
    } else if (fullName) {
        displayName += ' - ' + fullName;
    } else if (user.nickname) {
        displayName += ' - ' + user.nickname;
    }

    return displayName;
}

function imageURLForUser(userIdOrObject) {
    if (typeof userIdOrObject === 'string') {
        var profile = _user_store2.default.getProfile(userIdOrObject);
        if (profile) {
            return imageURLForUser(profile);
        }
        return _client.Client4.getUsersRoute() + '/' + userIdOrObject + '/image?_=' + Date.now();
    }
    return _client.Client4.getUsersRoute() + '/' + userIdOrObject.id + '/image?_=' + (userIdOrObject.last_picture_update || 0);
}

//just for cordchat native app
function imageappURLForUser(userIdOrObject) {
    if (typeof userIdOrObject === 'string') {
        var profile = _user_store2.default.getProfile(userIdOrObject);
        if (profile) {
            return imageURLForUser(profile);
        }
        return _client.Client4.getUsersRoute() + '/' + userIdOrObject + '/imageapp?_=' + Date.now();
    }
    return _client.Client4.getUsersRoute() + '/' + userIdOrObject.id + '/imageapp?_=' + (userIdOrObject.last_picture_update || 0);
}

function imageURLForTeam(teamIdOrObject) {
    if (typeof teamIdOrObject === 'string') {
        var team = _team_store2.default.get(teamIdOrObject);
        if (team) {
            return imageURLForTeam(team);
        }
        return _client.Client4.getTeamsRoute() + '/' + teamIdOrObject + '/image?_=' + Date.now();
    }
    return _client.Client4.getTeamsRoute() + '/' + teamIdOrObject.id + '/image?_=' + (teamIdOrObject.last_picture_update || 0);
}

function imageURLForChannel(channelIdOrObject) {
    if (typeof channelIdOrObject === 'string') {
        var channel = _channel_store2.default.get(channelIdOrObject);
        if (channel) {
            return imageURLForChannel(channel);
        }
        return _client.Client4.getChannelsRoute() + '/' + channelIdOrObject + '/image?_=' + Date.now();
    }
    return _client.Client4.getChannelsRoute() + '/' + channelIdOrObject.id + '/image?_=' + (channelIdOrObject.last_picture_update || 0);
}

function watermarkURLForUser(userIdOrObject) {
    if (typeof userIdOrObject === 'string') {
        var profile = _user_store2.default.getProfile(userIdOrObject);
        if (profile) {
            return watermarkURLForUser(profile);
        }
        return _client.Client4.getUsersRoute() + '/' + userIdOrObject + '/watermark?_=' + Date.now();
    }
    return _client.Client4.getUsersRoute() + '/' + userIdOrObject.id + '/watermark?_=' + (userIdOrObject.last_watermark_update || 0);
}

function backgroundURLForUser(userIdOrObject) {
    if (typeof userIdOrObject === 'string') {
        var profile = _user_store2.default.getProfile(userIdOrObject);
        if (profile) {
            return backgroundURLForUser(profile);
        }
        return _client.Client4.getUsersRoute() + '/' + userIdOrObject + '/background?_=' + Date.now();
    }
    return _client.Client4.getUsersRoute() + '/' + userIdOrObject.id + '/background?_=' + (userIdOrObject.last_background_update || 0);
}

function backgroundURLForTeam(teamIdOrObject) {
    if (typeof teamIdOrObject === 'string') {
        var team = _team_store2.default.get(teamIdOrObject);
        if (team) {
            return backgroundURLForTeam(team);
        }
        return _client.Client4.getTeamsRoute() + '/' + teamIdOrObject + '/background?_=' + Date.now();
    }
    return _client.Client4.getTeamsRoute() + '/' + teamIdOrObject.id + '/background?_=' + (teamIdOrObject.last_background_update || 0);
}

function backgroundURLForChannel(channelIdOrObject) {
    if (typeof channelIdOrObject === 'string') {
        var channel = _channel_store2.default.get(channelIdOrObject);
        if (channel) {
            return imageURLForChannel(channel);
        }
        return _client.Client4.getChannelsRoute() + '/' + channelIdOrObject + '/background?_=' + Date.now();
    }
    return _client.Client4.getChannelsRoute() + '/' + channelIdOrObject.id + '/background?_=' + (channelIdOrObject.last_background_update || 0);
}

// Converts a file size in bytes into a human-readable string of the form '123MB'.
function fileSizeToString(bytes) {
    // it's unlikely that we'll have files bigger than this
    if (bytes > 1024 * 1024 * 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024 * 1024 * 1024)) + 'TB';
    } else if (bytes > 1024 * 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024 * 1024)) + 'GB';
    } else if (bytes > 1024 * 1024) {
        return Math.floor(bytes / (1024 * 1024)) + 'MB';
    } else if (bytes > 1024) {
        return Math.floor(bytes / 1024) + 'KB';
    }

    return bytes + 'B';
}

// Converts a file size in bytes into a human-readable string of the form '123MB'.
function fileSizeToFixedToString(bytes) {
    // it's unlikely that we'll have files bigger than this
    if (bytes > 1024 * 1024 * 1024 * 1024) {
        return (bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + 'TB';
    } else if (bytes > 1024 * 1024 * 1024) {
        return (bytes / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
    } else if (bytes > 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB';
    } else if (bytes > 1024) {
        return (bytes / 1024).toFixed(2) + 'KB';
    }

    return bytes + 'B';
}

// Gets the websocket port to use. Configurable on the server.
function getWebsocketPort(protocol) {
    if (/^wss:/.test(protocol)) {
        // wss://
        return ':' + global.window.mm_config.WebsocketSecurePort;
    }
    if (/^ws:/.test(protocol)) {
        return ':' + global.window.mm_config.WebsocketPort;
    }
    return '';
}

// Generates a RFC-4122 version 4 compliant globally unique identifier.
function generateId() {
    // implementation taken from http://stackoverflow.com/a/2117523
    var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

    id = id.replace(/[xy]/g, function (c) {
        var r = Math.floor(Math.random() * 16);

        var v;
        if (c === 'x') {
            v = r;
        } else {
            v = r & 0x3 | 0x8;
        }

        return v.toString(16);
    });

    return id;
}

function getDirectChannelName(id, otherId) {
    var handle = void 0;

    if (otherId > id) {
        handle = id + '__' + otherId;
    } else {
        handle = otherId + '__' + id;
    }

    return handle;
}

// Used to get the id of the other user from a DM channel
function getUserIdFromChannelName(channel) {
    return getUserIdFromChannelId(channel.name);
}

// Used to get the id of the other user from a DM channel id (id1_id2)
function getUserIdFromChannelId(channelId) {
    var ids = channelId.split('__');
    var otherUserId = '';
    if (ids[0] === _user_store2.default.getCurrentId()) {
        otherUserId = ids[1];
    } else {
        otherUserId = ids[0];
    }

    return otherUserId;
}

// Returns true if the given channel is a direct channel between the current user and the given one
function isDirectChannelForUser(otherUserId, channel) {
    return channel.type === _constants2.default.DM_CHANNEL && getUserIdFromChannelName(channel) === otherUserId;
}

function importSlack(file, success, error) {
    _client.Client4.importTeam(_team_store2.default.getCurrent().id, file, 'slack').then(success).catch(error);
}

function windowWidth() {
    return (0, _jquery2.default)(window).width();
}

function windowHeight() {
    return (0, _jquery2.default)(window).height();
}

function getChannelTerm(channelType) {
    var channelTerm = 'Channel';
    if (channelType === _constants2.default.PRIVATE_CHANNEL) {
        channelTerm = 'Group';
    }

    return channelTerm;
}

function getPostTerm(post) {
    var postTerm = 'Post';
    if (post.root_id) {
        postTerm = 'Comment';
    }

    return postTerm;
}

function isFeatureEnabled(feature) {
    return _preference_store2.default.getBool(_constants2.default.Preferences.CATEGORY_ADVANCED_SETTINGS, _constants2.default.FeatureTogglePrefix + feature.label);
}

function fillArray(value, length) {
    var arr = [];

    for (var i = 0; i < length; i++) {
        arr.push(value);
    }

    return arr;
}

// Checks if a data transfer contains files not text, folders, etc..
// Slightly modified from http://stackoverflow.com/questions/6848043/how-do-i-detect-a-file-is-being-dragged-rather-than-a-draggable-element-on-my-pa
function isFileTransfer(files) {
    if (UserAgent.isInternetExplorer() || UserAgent.isEdge()) {
        return files.types != null && files.types.contains('Files');
    }

    return files.types != null && (files.types.indexOf ? files.types.indexOf('Files') !== -1 : files.types.contains('application/x-moz-file'));
}

function clearFileInput(elm) {
    // clear file input for all modern browsers
    try {
        elm.value = '';
        if (elm.value) {
            elm.type = 'text';
            elm.type = 'file';
        }
    } catch (e) {
        // Do nothing
    }
}

function isPostEphemeral(post) {
    return post.type === _constants2.default.PostTypes.EPHEMERAL || post.state === _constants3.Posts.POST_DELETED;
}

function getRootId(post) {
    return post.root_id === '' ? post.id : post.root_id;
}

function localizeMessage(id, defaultMessage) {
    var translations = _localization_store2.default.getTranslations();
    if (translations) {
        var value = translations[id];
        if (value) {
            return value;
        }
    }

    if (defaultMessage) {
        return defaultMessage;
    }

    return id;
}

function mod(a, b) {
    return (a % b + b) % b;
}

function canCreateCustomEmoji(user) {
    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (isSystemAdmin(user.roles)) {
        return true;
    }

    // already checked for system admin for both these cases
    if (window.mm_config.RestrictCustomEmojiCreation === 'system_admin') {
        return false;
    } else if (window.mm_config.RestrictCustomEmojiCreation === 'admin') {
        // check whether the user is an admin on any of their teams
        if (_team_store2.default.isTeamAdminForAnyTeam()) {
            return true;
        }

        return false;
    }

    return true;
}

function isValidPassword(password) {
    var errorMsg = '';
    var errorId = 'user.settings.security.passwordError';
    var error = false;
    var minimumLength = _constants2.default.MIN_PASSWORD_LENGTH;

    if (global.window.mm_config.BuildEnterpriseReady === 'true' && global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.PasswordRequirements === 'true') {
        if (password.length < parseInt(global.window.mm_config.PasswordMinimumLength, 10) || password.length > _constants2.default.MAX_PASSWORD_LENGTH) {
            error = true;
        }

        if (global.window.mm_config.PasswordRequireLowercase === 'true') {
            if (!password.match(/[a-z]/)) {
                error = true;
            }

            errorId += 'Lowercase';
        }

        if (global.window.mm_config.PasswordRequireUppercase === 'true') {
            if (!password.match(/[0-9]/)) {
                error = true;
            }

            errorId += 'Uppercase';
        }

        if (global.window.mm_config.PasswordRequireNumber === 'true') {
            if (!password.match(/[A-Z]/)) {
                error = true;
            }

            errorId += 'Number';
        }

        if (global.window.mm_config.PasswordRequireSymbol === 'true') {
            if (!password.match(/[ !"\\#$%&'()*+,-./:;<=>?@[\]^_`|~]/)) {
                error = true;
            }

            errorId += 'Symbol';
        }

        minimumLength = global.window.mm_config.PasswordMinimumLength;
    } else if (password.length < _constants2.default.MIN_PASSWORD_LENGTH || password.length > _constants2.default.MAX_PASSWORD_LENGTH) {
        error = true;
    }

    if (error) {
        errorMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: errorId,
            'default': 'Your password must contain between {min} and {max} characters.',
            values: {
                min: minimumLength,
                max: _constants2.default.MAX_PASSWORD_LENGTH
            }
        });
    }

    return errorMsg;
}

function handleFormattedTextClick(e) {
    var hashtagAttribute = e.target.getAttributeNode('data-hashtag');
    var linkAttribute = e.target.getAttributeNode('data-link');
    var channelMentionAttribute = e.target.getAttributeNode('data-channel-mention');

    if (hashtagAttribute) {
        e.preventDefault();

        searchForTerm(hashtagAttribute.value);
    } else if (linkAttribute) {
        var MIDDLE_MOUSE_BUTTON = 1;

        if (!(e.button === MIDDLE_MOUSE_BUTTON || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)) {
            e.preventDefault();

            _es.browserHistory.push(linkAttribute.value);
        }
    } else if (channelMentionAttribute) {
        e.preventDefault();
        _es.browserHistory.push('/' + _team_store2.default.getCurrent().name + '/channels/' + channelMentionAttribute.value);
    }
}

// This should eventually be removed once everywhere else calls the action
function searchForTerm(term) {
    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.RECEIVED_SEARCH_TERM,
        term: term,
        do_search: true
    });
}

function isEmptyObject(object) {
    if (!object) {
        return true;
    }

    if ((0, _keys2.default)(object).length === 0) {
        return true;
    }

    return false;
}

function updateWindowDimensions(component) {
    component.setState({ width: window.innerWidth, height: window.innerHeight });
}

function removePrefixFromLocalStorage(prefix) {
    var keys = [];
    for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).startsWith(prefix)) {
            keys.push(localStorage.key(i));
        }
    }

    for (var _i = 0; _i < keys.length; _i++) {
        localStorage.removeItem(keys[_i]);
    }
}

function calculateExpiresAt(oriDate) {

    var date = new Date(oriDate);

    var isSpecialDate = date.getMonth() === 1 && date.getDate() === 29;

    var expiresAt = new Date(date);
    expiresAt = expiresAt.setFullYear(expiresAt.getFullYear() + 1); //timestamp
    expiresAt = new Date(expiresAt);

    if (isSpecialDate) {
        expiresAt = expiresAt.setDate(expiresAt.getDate() - 1);
        expiresAt = new Date(expiresAt).getTime();
    }

    return expiresAt;
}

function addToDate(oriDate, days) {

    var date = new Date(oriDate);
    var result = new Date(oriDate);

    result.setDate(date.getDate() + parseInt(days));
    return result.getTime();
}

function wgs2gcj(wgsLat, wgsLng) {
    if (outOfChina(wgsLat, wgsLng)) {
        return { "lat": wgsLat, "lng": wgsLng };
    }
    var d = delta(wgsLat, wgsLng);
    return { "lat": wgsLat + d.lat, "lng": wgsLng + d.lng };
}

function outOfChina(lat, lng) {
    if (lng < 72.004 || lng > 137.8347) {
        return true;
    }
    if (lat < 0.8293 || lat > 55.8271) {
        return true;
    }
    return false;
}

function delta(lat, lng) {
    var a = 6378245.0;
    var ee = 0.00669342162296594323;
    var dLat = transformLat(lng - 105.0, lat - 35.0);
    var dLng = transformLon(lng - 105.0, lat - 35.0);
    var radLat = lat / 180.0 * Math.PI;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = dLat * 180.0 / (a * (1 - ee) / (magic * sqrtMagic) * Math.PI);
    dLng = dLng * 180.0 / (a / sqrtMagic * Math.cos(radLat) * Math.PI);
    return { "lat": dLat, "lng": dLng };
}

function transformLat(x, y) {
    var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
    return ret;
}

function transformLon(x, y) {
    var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
    return ret;
}

function getSiteName() {
    if (global.window.mm_license.IsCordchatEnterprise === 'true') {
        return global.window.mm_config.SiteName;
    } else {
        return localizeMessage('web.root.site.name', 'Cordchat');
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;



/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.15 ToLength
var toInteger = __webpack_require__(96)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _flux = __webpack_require__(923);

var Flux = _interopRequireWildcard(_flux);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PayloadSources = _constants2.default.PayloadSources;

var AppDispatcher = (0, _assign2.default)(new Flux.Dispatcher(), {
    handleServerAction: function performServerAction(action) {
        if (!action.type) {
            console.warn('handleServerAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action: action
        };
        this.dispatch(payload);
    },

    handleViewAction: function performViewAction(action) {
        if (!action.type) {
            console.warn('handleViewAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.VIEW_ACTION,
            action: action
        };
        this.dispatch(payload);
    }
});

exports.default = AppDispatcher;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(61);
module.exports = function(it){
  return Object(defined(it));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.batchActions = batchActions;
exports.enableBatching = enableBatching;
var BATCH = exports.BATCH = 'BATCHING_REDUCER.BATCH';

function batchActions(actions) {
	var type = arguments.length <= 1 || arguments[1] === undefined ? BATCH : arguments[1];

	return { type: type, meta: { batch: true }, payload: actions };
}

function enableBatching(reduce) {
	return function batchingReducer(state, action) {
		if (action && action.meta && action.meta.batch) {
			return action.payload.reduce(batchingReducer, state);
		} else {
			return reduce(state, action);
		}
	};
}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global    = __webpack_require__(38)
  , core      = __webpack_require__(15)
  , ctx       = __webpack_require__(98)
  , hide      = __webpack_require__(99)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var store      = __webpack_require__(284)('wks')
  , uid        = __webpack_require__(206)
  , Symbol     = __webpack_require__(38).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = keyMirror;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
function keyMirror(obj) {
    if (!(obj instanceof Object && !Array.isArray(obj))) {
        throw new Error('keyMirror(...): Argument must be an object.');
    }

    var ret = {};
    for (var key in obj) {
        if (!obj.hasOwnProperty(key)) {
            continue;
        }

        ret[key] = key;
    }

    return ret;
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.bindActionToRedux = bindActionToRedux;

var _store = __webpack_require__(966);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _store2.default)(); // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// This is a temporary store while we are transitioning from Flux to Redux. This file exports
// the configured Redux store for use by actions and selectors.

function bindActionToRedux(action) {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return action.apply(undefined, args)(store.dispatch, store.getState);

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));
}

window.store = store;

exports.default = store;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _defineProperty = __webpack_require__(419);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(920), __esModule: true };


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var dP         = __webpack_require__(19)
  , createDesc = __webpack_require__(94);
module.exports = __webpack_require__(18) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global    = __webpack_require__(6)
  , hide      = __webpack_require__(41)
  , has       = __webpack_require__(36)
  , SRC       = __webpack_require__(106)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(80).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(148)
  , defined = __webpack_require__(61);
module.exports = function(it){
  return IObject(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1)
  , fails   = __webpack_require__(9)
  , defined = __webpack_require__(61)
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var cls = __webpack_require__(211);
var defaultSettings = __webpack_require__(1229);
var dom = __webpack_require__(121);
var EventManager = __webpack_require__(1230);
var guid = __webpack_require__(1231);

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = _.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = dom.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps--focus');
  }

  function blur() {
    cls.remove(element, 'ps--focus');
  }

  i.scrollbarXRail = dom.appendTo(dom.e('div', 'ps__scrollbar-x-rail'), element);
  i.scrollbarX = dom.appendTo(dom.e('div', 'ps__scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  dom.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = dom.appendTo(dom.e('div', 'ps__scrollbar-y-rail'), element);
  i.scrollbarY = dom.appendTo(dom.e('div', 'ps__scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
  dom.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};



/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(299);

var _post_utils = __webpack_require__(173);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _teams = __webpack_require__(219);

var Selectors = _interopRequireWildcard(_teams);

var _action_types = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPrefs = _constants2.default.NotificationPrefs; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var CHANGE_EVENT = 'change';
var STATS_EVENT = 'stats';
var UNREAD_EVENT = 'unread';

var Utils;

var TeamStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(TeamStoreClass, _EventEmitter);

    function TeamStoreClass() {
        (0, _classCallCheck3.default)(this, TeamStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamStoreClass.__proto__ || (0, _getPrototypeOf2.default)(TeamStoreClass)).call(this));

        _this.entities = _redux_store2.default.getState().entities.teams;

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.teams;
            var doEmit = false;

            if (newEntities.currentTeamId !== _this.entities.currentTeamId) {
                doEmit = true;
            }
            if (newEntities.teams !== _this.entities.teams) {
                doEmit = true;
            }
            if (newEntities.myMembers !== _this.entities.myMembers) {
                doEmit = true;
                _this.emitUnreadChange();
            }
            if (newEntities.membersInTeam !== _this.entities.membersInTeam) {
                doEmit = true;
            }
            if (newEntities.stats !== _this.entities.stats) {
                _this.emitStatsChange();
            }

            if (doEmit) {
                _this.emitChange();
            }

            _this.entities = newEntities;
        });
        return _this;
    }

    (0, _createClass3.default)(TeamStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitStatsChange',
        value: function emitStatsChange() {
            this.emit(STATS_EVENT);
        }
    }, {
        key: 'addStatsChangeListener',
        value: function addStatsChangeListener(callback) {
            this.on(STATS_EVENT, callback);
        }
    }, {
        key: 'removeStatsChangeListener',
        value: function removeStatsChangeListener(callback) {
            this.removeListener(STATS_EVENT, callback);
        }
    }, {
        key: 'emitUnreadChange',
        value: function emitUnreadChange() {
            this.emit(UNREAD_EVENT);
        }
    }, {
        key: 'addUnreadChangeListener',
        value: function addUnreadChangeListener(callback) {
            this.on(UNREAD_EVENT, callback);
        }
    }, {
        key: 'removeUnreadChangeListener',
        value: function removeUnreadChangeListener(callback) {
            this.removeListener(UNREAD_EVENT, callback);
        }
    }, {
        key: 'get',
        value: function get(id) {
            var c = this.getAll();
            return c[id];
        }
    }, {
        key: 'getByName',
        value: function getByName(name) {
            var t = this.getAll();

            for (var id in t) {
                if (t.hasOwnProperty(id)) {
                    if (t[id].name === name) {
                        return t[id];
                    }
                }
            }

            return null;
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            var list = Selectors.getMyTeams(_redux_store2.default.getState());
            var teams = {};
            list.forEach(function (t) {
                teams[t.id] = t;
            });
            return teams;
        }
    }, {
        key: 'getCurrentId',
        value: function getCurrentId() {
            return Selectors.getCurrentTeamId(_redux_store2.default.getState());
        }
    }, {
        key: 'setCurrentId',
        value: function setCurrentId(id) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.SELECT_TEAM,
                data: id
            });
        }
    }, {
        key: 'getCurrent',
        value: function getCurrent() {
            var team = Selectors.getCurrentTeam(_redux_store2.default.getState());

            if (team) {
                return team;
            }

            return null;
        }
    }, {
        key: 'getCurrentTeamUrl',
        value: function getCurrentTeamUrl() {
            return this.getTeamUrl(this.getCurrentId());
        }
    }, {
        key: 'getCurrentTeamRelativeUrl',
        value: function getCurrentTeamRelativeUrl() {
            if (this.getCurrent()) {
                return '/' + this.getCurrent().name;
            }
            return '';
        }
    }, {
        key: 'getTeamRelativeUrl',
        value: function getTeamRelativeUrl(id) {
            if (this.get(id)) {
                return '/' + this.get(id).name;
            }
            return '';
        }
    }, {
        key: 'getCurrentInviteLink',
        value: function getCurrentInviteLink() {
            var current = this.getCurrent();

            if (current) {
                return (0, _url.getSiteURL)() + '/signup_user_complete/?id=' + current.invite_id;
            }

            return '';
        }
    }, {
        key: 'getCurrentGuestInviteLink',
        value: function getCurrentGuestInviteLink() {
            var current = this.getCurrent();

            if (current) {
                return (0, _url.getSiteURL)() + '/signup_user_complete/?id=' + current.guest_invite_id;
            }

            return '';
        }
    }, {
        key: 'getTeamUrl',
        value: function getTeamUrl(id) {
            var team = this.get(id);

            if (!team) {
                return '';
            }

            return (0, _url.getSiteURL)() + '/' + team.name;
        }
    }, {
        key: 'getCurrentStats',
        value: function getCurrentStats() {
            return this.getStats(this.getCurrentId());
        }
    }, {
        key: 'getStats',
        value: function getStats(teamId) {
            var stats = void 0;

            if (teamId) {
                stats = Selectors.getTeamStats(_redux_store2.default.getState())[teamId];
            }

            if (stats) {
                // create a defensive copy
                stats = (0, _assign2.default)({}, stats);
            } else {
                stats = { member_count: 0 };
            }

            return stats;
        }
    }, {
        key: 'saveTeam',
        value: function saveTeam(team) {
            var teams = {};
            teams[team.id] = team;
            this.saveTeams(teams);
        }
    }, {
        key: 'saveTeams',
        value: function saveTeams(teams) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_TEAMS,
                data: teams
            });
        }
    }, {
        key: 'updateTeam',
        value: function updateTeam(team) {
            var t = JSON.parse(team);
            var teams = (0, _assign2.default)({}, this.getAll(), this.getTeamListings());
            if (teams && teams[t.id]) {
                this.saveTeam(t);
            }
        }
    }, {
        key: 'saveMyTeam',
        value: function saveMyTeam(team) {
            this.saveTeam(team);
            this.setCurrentId(team.id);
        }
    }, {
        key: 'saveStats',
        value: function saveStats(teamId, stats) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_TEAM_STATS,
                data: stats
            });
        }
    }, {
        key: 'saveMyTeamMembers',
        value: function saveMyTeamMembers(members) {
            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS,
                data: members
            });
        }
    }, {
        key: 'appendMyTeamMember',
        value: function appendMyTeamMember(member) {
            var members = this.getMyTeamMembers();
            members.push(member);
            this.saveMyTeamMembers(members);
        }
    }, {
        key: 'saveMyTeamMembersUnread',
        value: function saveMyTeamMembersUnread(members) {
            var myMembers = this.getMyTeamMembers();

            var _loop = function _loop(i) {
                var team = myMembers[i];
                var member = members.filter(function (m) {
                    return m.team_id === team.team_id;
                })[0];

                if (member) {
                    myMembers[i] = (0, _assign2.default)({}, team, {
                        msg_count: member.msg_count,
                        mention_count: member.mention_count
                    });
                }
            };

            for (var i = 0; i < myMembers.length; i++) {
                _loop(i);
            }

            this.saveMyTeamMembers(myMembers);
        }
    }, {
        key: 'removeMyTeamMember',
        value: function removeMyTeamMember(teamId) {
            var myMembers = this.getMyTeamMembers();
            for (var i = 0; i < myMembers.length; i++) {
                if (myMembers[i].team_id === teamId) {
                    myMembers.splice(i, 1);
                }
            }

            this.saveMyTeamMembers(myMembers);
        }
    }, {
        key: 'removeTeam',
        value: function removeTeam(teamId) {
            var list = (0, _values2.default)(Selectors.getTeams(_redux_store2.default.getState()));
            var teams = {};
            for (var i = 0; i < list.length; i++) {
                if (list[i].id != teamId) {
                    teams[list[i].id] = list[i];
                }
            }
            this.saveTeams(teams);
        }
    }, {
        key: 'getMyTeamMembers',
        value: function getMyTeamMembers() {
            return (0, _values2.default)(Selectors.getTeamMemberships(_redux_store2.default.getState()));
        }
    }, {
        key: 'saveMembersInTeam',
        value: function saveMembersInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var members = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                data: (0, _values2.default)(members)
            });
        }
    }, {
        key: 'removeMemberInTeam',
        value: function removeMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
                data: { team_id: teamId, user_id: userId }
            });
        }
    }, {
        key: 'getMembersInTeam',
        value: function getMembersInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();

            return Selectors.getMembersInTeams(_redux_store2.default.getState())[teamId] || {};
        }
    }, {
        key: 'getMemberInTeam',
        value: function getMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            return Selectors.getTeamMember(_redux_store2.default.getState(), teamId, userId);
        }
    }, {
        key: 'hasActiveMemberInTeam',
        value: function hasActiveMemberInTeam() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentId();
            var userId = arguments[1];

            if (this.getMemberInTeam(teamId, userId)) {
                return true;
            }

            return false;
        }
    }, {
        key: 'getTeamListings',
        value: function getTeamListings() {
            return Selectors.getJoinableTeams(_redux_store2.default.getState());
        }
    }, {
        key: 'isTeamAdminForAnyTeam',
        value: function isTeamAdminForAnyTeam() {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.getMyTeamMembers()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var teamMember = _step.value;

                    if (Utils.isAdmin(teamMember.roles)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'isTeamAdminForCurrentTeam',
        value: function isTeamAdminForCurrentTeam() {
            return this.isTeamAdmin(_user_store2.default.getCurrentId(), this.getCurrentId());
        }
    }, {
        key: 'isTeamAdmin',
        value: function isTeamAdmin(userId, teamId) {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var teamMembers = this.getMyTeamMembers();
            var teamMember = teamMembers.find(function (m) {
                return m.user_id === userId && m.team_id === teamId;
            });

            if (teamMember) {
                return Utils.isAdmin(teamMember.roles);
            }

            return false;
        }
    }, {
        key: 'isTeamGuestForCurrentTeam',
        value: function isTeamGuestForCurrentTeam() {
            return this.isTeamGuest(_user_store2.default.getCurrentId(), this.getCurrentId());
        }
    }, {
        key: 'isTeamGuest',
        value: function isTeamGuest(userId, teamId) {
            if (!Utils) {
                Utils = __webpack_require__(24); //eslint-disable-line global-require
            }

            var teamMembers = this.getMyTeamMembers();
            var teamMember = teamMembers.find(function (m) {
                return m.user_id === userId && m.team_id === teamId;
            });

            if (teamMember) {
                return Utils.isTeamGuest(teamMember.roles);
            }

            return false;
        }
    }, {
        key: 'updateMyRoles',
        value: function updateMyRoles(member) {
            var teamMembers = this.getMyTeamMembers();
            var teamMember = teamMembers.find(function (m) {
                return m.user_id === member.user_id && m.team_id === member.team_id;
            });

            if (teamMember) {
                var newMember = (0, _assign2.default)({}, teamMember, {
                    roles: member.roles
                });

                _redux_store2.default.dispatch({
                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                    data: newMember
                });
            }
        }
    }, {
        key: 'subtractUnread',
        value: function subtractUnread(teamId, msgs, mentions) {
            var member = this.getMyTeamMembers().filter(function (m) {
                return m.team_id === teamId;
            })[0];
            if (member) {
                var msgCount = member.msg_count - msgs;
                var mentionCount = member.mention_count - mentions;

                member = (0, _assign2.default)({}, member);
                member.msg_count = msgCount > 0 ? msgCount : 0;
                member.mention_count = mentionCount > 0 ? mentionCount : 0;

                _redux_store2.default.dispatch({
                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                    data: member
                });
            }
        }
    }, {
        key: 'incrementMessages',
        value: function incrementMessages(id, channelId) {
            var channelMember = _channel_store2.default.getMyMember(channelId);
            if (channelMember && channelMember.notify_props && channelMember.notify_props.mark_unread === NotificationPrefs.MENTION) {
                return;
            }

            var member = (0, _assign2.default)({}, this.getMyTeamMembers().filter(function (m) {
                return m.team_id === id;
            })[0]);
            member.msg_count++;

            _redux_store2.default.dispatch({
                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                data: member
            });
        }
    }, {
        key: 'incrementMentionsIfNeeded',
        value: function incrementMentionsIfNeeded(id, msgProps) {
            var mentions = [];
            if (msgProps && msgProps.mentions) {
                mentions = JSON.parse(msgProps.mentions);
            }

            if (mentions.indexOf(_user_store2.default.getCurrentId()) !== -1) {
                var _member = (0, _assign2.default)({}, this.getMyTeamMembers().filter(function (m) {
                    return m.team_id === id;
                })[0]);
                _member.mention_count++;

                _redux_store2.default.dispatch({
                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                    data: _member
                });
            }
        }
    }]);
    return TeamStoreClass;
}(_events2.default);

var TeamStore = new TeamStoreClass();

TeamStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_MY_TEAM:
            TeamStore.saveMyTeam(action.team);
            break;
        case ActionTypes.RECEIVED_TEAM:
            TeamStore.saveTeam(action.team);
            break;
        case ActionTypes.CREATED_TEAM:
            TeamStore.saveTeam(action.team);
            TeamStore.appendMyTeamMember(action.member);
            break;
        case ActionTypes.UPDATE_TEAM:
            TeamStore.saveTeam(action.team);
            break;
        case ActionTypes.RECEIVED_ALL_TEAMS:
            TeamStore.saveTeams(action.teams);
            break;
        case ActionTypes.RECEIVED_MY_TEAM_MEMBERS:
            TeamStore.saveMyTeamMembers(action.team_members);
            break;
        case ActionTypes.RECEIVED_MY_TEAMS_UNREAD:
            TeamStore.saveMyTeamMembersUnread(action.team_members);
            break;
        case ActionTypes.RECEIVED_ALL_TEAM_LISTINGS:
            TeamStore.saveTeamListings(action.teams);
            break;
        case ActionTypes.RECEIVED_MEMBERS_IN_TEAM:
            TeamStore.saveMembersInTeam(action.team_id, action.team_members);
            break;
        case ActionTypes.RECEIVED_TEAM_STATS:
            TeamStore.saveStats(action.team_id, action.stats);
            break;
        case ActionTypes.RECEIVED_POST:
            if (_constants2.default.IGNORE_POST_TYPES.indexOf(action.post.type) !== -1) {
                return;
            }

            if (action.post.user_id === _user_store2.default.getCurrentId() && !(0, _post_utils.isSystemMessage)(action.post) && !(0, _post_utils.isFromWebhook)(action.post)) {
                return;
            }

            var id = action.websocketMessageProps ? action.websocketMessageProps.team_id : null;
            if (id && TeamStore.getCurrentId() !== id) {
                TeamStore.incrementMessages(id, action.post.channel_id);
                TeamStore.incrementMentionsIfNeeded(id, action.websocketMessageProps);
            }
            break;
        default:
    }
});

TeamStore.setMaxListeners(15);

window.TeamStore = TeamStore;
exports.default = TeamStore;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__History__ = __webpack_require__(878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "History", function() { return __WEBPACK_IMPORTED_MODULE_8__History__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Lifecycle__ = __webpack_require__(879);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Lifecycle", function() { return __WEBPACK_IMPORTED_MODULE_9__Lifecycle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RouteContext__ = __webpack_require__(880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouteContext", function() { return __WEBPACK_IMPORTED_MODULE_10__RouteContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useRoutes__ = __webpack_require__(881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRoutes", function() { return __WEBPACK_IMPORTED_MODULE_11__useRoutes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RouteUtils__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_12__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RouterContext__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_13__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RoutingContext__ = __webpack_require__(882);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RoutingContext", function() { return __WEBPACK_IMPORTED_MODULE_14__RoutingContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PropTypes__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_15__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_15__PropTypes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_15__PropTypes__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__match__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_16__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__useRouterHistory__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PatternUtils__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_18__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__applyRouterMiddleware__ = __webpack_require__(884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_19__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__browserHistory__ = __webpack_require__(885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_20__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hashHistory__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_21__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__createMemoryHistory__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_22__createMemoryHistory__["a"]; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* components */









/* components (configuration) */










/* mixins */








/* utils */






















/* histories */









/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}



/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var pIE            = __webpack_require__(149)
  , createDesc     = __webpack_require__(94)
  , toIObject      = __webpack_require__(44)
  , toPrimitive    = __webpack_require__(72)
  , has            = __webpack_require__(36)
  , IE8_DOM_DEFINE = __webpack_require__(310)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(36)
  , toObject    = __webpack_require__(29)
  , IE_PROTO    = __webpack_require__(229)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.initialRequestState = initialRequestState;
exports.handleRequest = handleRequest;

var _constants = __webpack_require__(8);

function initialRequestState() {
    return {
        status: _constants.RequestStatus.NOT_STARTED,
        error: null
    };
}

function handleRequest(REQUEST, SUCCESS, FAILURE, state, action) {
    switch (action.type) {
        case REQUEST:
            return _extends({}, state, {
                status: _constants.RequestStatus.STARTED
            });
        case SUCCESS:
            return _extends({}, state, {
                status: _constants.RequestStatus.SUCCESS,
                error: null
            });
        case FAILURE:
            {
                var error = action.error;
                if (error instanceof Error) {
                    error = error.hasOwnProperty('intl') ? JSON.parse(JSON.stringify(error)) : error.toString();
                }

                return _extends({}, state, {
                    status: _constants.RequestStatus.FAILURE,
                    error: error
                });
            }
        default:
            return state;
    }
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _typeof2 = __webpack_require__(169);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(959);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(963);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(169);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(946), __esModule: true };


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };



/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notFoundParams = undefined;
exports.importComponentSuccess = importComponentSuccess;
exports.createGetChildComponentsFunction = createGetChildComponentsFunction;
exports.checkIfMFARequired = checkIfMFARequired;

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function importComponentSuccess(callback) {
    return function (comp) {
        return callback(null, comp.default);
    };
}

function createGetChildComponentsFunction(arrayOfComponents) {
    return function (locaiton, callback) {
        return callback(null, arrayOfComponents);
    };
}

var notFoundParams = exports.notFoundParams = {
    title: Utils.localizeMessage('error.not_found.title', 'Page not found'),
    message: Utils.localizeMessage('error.not_found.message', 'The page you were trying to reach does not exist'),
    link: '/',
    linkmessage: Utils.localizeMessage('error.not_found.link_message', 'Back to Cordchat')
};

var mfaPaths = ['/mfa/setup', '/mfa/confirm'];

var mfaAuthServices = ['', 'email', 'ldap'];

function checkIfMFARequired(state) {
    if (window.mm_license.MFA === 'true' && window.mm_config.EnableMultifactorAuthentication === 'true' && window.mm_config.EnforceMultifactorAuthentication === 'true' && mfaPaths.indexOf(state.location.pathname) === -1) {
        var user = _user_store2.default.getCurrentUser();
        if (user && !user.mfa_active && mfaAuthServices.indexOf(user.auth_service) !== -1) {
            return true;
        }
    }

    return false;
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var fails = __webpack_require__(9);

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var anObject       = __webpack_require__(65)
  , IE8_DOM_DEFINE = __webpack_require__(398)
  , toPrimitive    = __webpack_require__(281)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(77) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(100);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1050), __esModule: true };


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormattedError = exports.forceLogoutIfNecessary = undefined;

var forceLogoutIfNecessary = exports.forceLogoutIfNecessary = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(err, dispatch) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(err.status_code === HTTP_UNAUTHORIZED && err.url.indexOf('/login') === -1)) {
                            _context.next = 11;
                            break;
                        }

                        dispatch({ type: _action_types.UserTypes.LOGOUT_REQUEST });
                        _context.prev = 2;
                        _context.next = 5;
                        return _client.Client4.logout();

                    case 5:
                        _context.next = 10;
                        break;

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](2);

                        (0, _errors.logError)(_context.t0)(dispatch);

                    case 10:
                        dispatch({ type: _action_types.UserTypes.LOGOUT_SUCCESS });

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[2, 7]]);
    }));

    return function forceLogoutIfNecessary(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.requestData = requestData;
exports.requestSuccess = requestSuccess;
exports.requestFailure = requestFailure;
exports.bindClientFunc = bindClientFunc;
exports.debounce = debounce;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _action_types = __webpack_require__(2);

var _errors = __webpack_require__(68);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HTTP_UNAUTHORIZED = 401;

function dispatcher(type, data, dispatch, getState) {
    if (type.indexOf('SUCCESS') === -1) {
        // we don't want to pass the data for the request types
        dispatch(requestSuccess(type, data), getState);
    } else {
        dispatch(requestData(type), getState);
    }
}

function requestData(type) {
    return {
        type: type
    };
}

function requestSuccess(type, data) {
    return {
        type: type,
        data: data
    };
}

function requestFailure(type, error) {
    return {
        type: type,
        error: error
    };
}

function bindClientFunc(clientFunc, request, success, failure) {
    for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
    }

    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch(requestData(request), getState);

                            data = null;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return clientFunc.apply(undefined, args);

                        case 5:
                            data = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            forceLogoutIfNecessary(_context2.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([requestFailure(failure, _context2.t0), (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', null);

                        case 13:

                            if (Array.isArray(success)) {
                                success.forEach(function (s) {
                                    dispatcher(s, data, dispatch, getState);
                                });
                            } else {
                                dispatcher(success, data, dispatch, getState);
                            }

                            return _context2.abrupt('return', data);

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

// Debounce function based on underscores modified to use es6 and a cb
function debounce(func, wait, immediate, cb) {
    var timeout = void 0;
    return function fx() {
        var _this2 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var runLater = function runLater() {
            timeout = null;
            if (!immediate) {
                Reflect.apply(func, _this2, args);
                if (cb) {
                    cb();
                }
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(runLater, wait);
        if (callNow) {
            Reflect.apply(func, this, args);
            if (cb) {
                cb();
            }
        }
    };
}

var FormattedError = exports.FormattedError = function (_Error) {
    _inherits(FormattedError, _Error);

    function FormattedError(id, defaultMessage) {
        var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, FormattedError);

        var _this3 = _possibleConstructorReturn(this, (FormattedError.__proto__ || Object.getPrototypeOf(FormattedError)).call(this, defaultMessage));

        _this3.intl = {
            id: id,
            defaultMessage: defaultMessage,
            values: values
        };
        return _this3;
    }

    return FormattedError;
}(Error);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dismissErrorObject = dismissErrorObject;
exports.dismissError = dismissError;
exports.getLogErrorAction = getLogErrorAction;
exports.logError = logError;
exports.clearErrors = clearErrors;

var _action_types = __webpack_require__(2);

var _serializeError = __webpack_require__(1099);

var _serializeError2 = _interopRequireDefault(_serializeError);

var _client = __webpack_require__(22);

var _event_emitter = __webpack_require__(210);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function dismissErrorObject(index) {
    return {
        type: _action_types.ErrorTypes.DISMISS_ERROR,
        index: index
    };
}

function dismissError(index) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch(dismissErrorObject(index));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getLogErrorAction(error) {
    var displayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return {
        type: _action_types.ErrorTypes.LOG_ERROR,
        displayable: displayable,
        error: error
    };
}

function logError(error) {
    var _this2 = this;

    var displayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
            var serializedError, stringifiedSerializedError;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            serializedError = (0, _serializeError2.default)(error);
                            _context2.prev = 1;
                            stringifiedSerializedError = JSON.stringify(serializedError).toString();
                            _context2.next = 5;
                            return _client.Client4.logClientError(stringifiedSerializedError);

                        case 5:
                            _context2.next = 9;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);

                        case 9:

                            _event_emitter2.default.emit(_action_types.ErrorTypes.LOG_ERROR, error);
                            dispatch(getLogErrorAction(serializedError, displayable));

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 7]]);
        }));

        return function (_x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function clearErrors() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ErrorTypes.CLEAR_ERRORS });

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5) {
            return _ref3.apply(this, arguments);
        };
    }();
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(941), __esModule: true };


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(907);



/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _promise = __webpack_require__(171);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1)
  , core    = __webpack_require__(80)
  , fails   = __webpack_require__(9);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(81)
  , IObject  = __webpack_require__(148)
  , toObject = __webpack_require__(29)
  , toLength = __webpack_require__(26)
  , asc      = __webpack_require__(645);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var CallbackQueue = __webpack_require__(349);
var PooledClass = __webpack_require__(115);
var ReactFeatureFlags = __webpack_require__(350);
var ReactReconciler = __webpack_require__(136);
var Transaction = __webpack_require__(190);

var invariant = __webpack_require__(3);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;



/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(101)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.checkMfa = checkMfa;
exports.generateMfaSecret = generateMfaSecret;
exports.createUser = createUser;
exports.login = login;
exports.loginById = loginById;
exports.loadMe = loadMe;
exports.logout = logout;
exports.getProfiles = getProfiles;
exports.getMissingProfilesByIds = getMissingProfilesByIds;
exports.getProfilesByIds = getProfilesByIds;
exports.getProfilesByUsernames = getProfilesByUsernames;
exports.getProfilesInTeam = getProfilesInTeam;
exports.getProfilesNotInTeam = getProfilesNotInTeam;
exports.getProfilesWithoutTeam = getProfilesWithoutTeam;
exports.getProfilesInChannel = getProfilesInChannel;
exports.getProfilesNotInChannel = getProfilesNotInChannel;
exports.getMe = getMe;
exports.getUser = getUser;
exports.getUserByUsername = getUserByUsername;
exports.getUserByEmail = getUserByEmail;
exports.getStatusesByIdsBatchedDebounced = getStatusesByIdsBatchedDebounced;
exports.getStatusesByIds = getStatusesByIds;
exports.getStatus = getStatus;
exports.setStatus = setStatus;
exports.getSessions = getSessions;
exports.revokeSession = revokeSession;
exports.loadProfilesForDirect = loadProfilesForDirect;
exports.getUserAudits = getUserAudits;
exports.autocompleteUsers = autocompleteUsers;
exports.searchProfiles = searchProfiles;
exports.startPeriodicStatusUpdates = startPeriodicStatusUpdates;
exports.stopPeriodicStatusUpdates = stopPeriodicStatusUpdates;
exports.updateMe = updateMe;
exports.updateUserRoles = updateUserRoles;
exports.updateUserMfa = updateUserMfa;
exports.updateUserPassword = updateUserPassword;
exports.updateUserActive = updateUserActive;
exports.verifyUserEmail = verifyUserEmail;
exports.sendVerificationEmail = sendVerificationEmail;
exports.resetUserPassword = resetUserPassword;
exports.sendPasswordResetEmail = sendPasswordResetEmail;
exports.uploadProfileImage = uploadProfileImage;
exports.switchEmailToOAuth = switchEmailToOAuth;
exports.switchOAuthToEmail = switchOAuthToEmail;
exports.switchEmailToLdap = switchEmailToLdap;
exports.switchLdapToEmail = switchLdapToEmail;
exports.createUserAccessToken = createUserAccessToken;
exports.getUserAccessToken = getUserAccessToken;
exports.getUserAccessTokensForUser = getUserAccessTokensForUser;
exports.revokeUserAccessToken = revokeUserAccessToken;
exports.clearUserAccessTokens = clearUserAccessTokens;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _emojis = __webpack_require__(484);

var _teams = __webpack_require__(144);

var _channel_utils = __webpack_require__(209);

var _user_utils = __webpack_require__(126);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

var _preferences = __webpack_require__(146);

var _general = __webpack_require__(174);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function checkMfa(loginId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CHECK_MFA_REQUEST }, getState);
                            _context.prev = 1;
                            _context.next = 4;
                            return _client.Client4.checkUserMfa(loginId);

                        case 4:
                            data = _context.sent;

                            dispatch({ type: _action_types.UserTypes.CHECK_MFA_SUCCESS }, getState);
                            return _context.abrupt('return', data.mfa_required);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.CHECK_MFA_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 9]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function generateMfaSecret(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.generateMfaSecret, _action_types.UserTypes.MFA_SECRET_REQUEST, _action_types.UserTypes.MFA_SECRET_SUCCESS, _action_types.UserTypes.MFA_SECRET_FAILURE, userId);
}

function createUser(user, data, hash, inviteId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var created, profiles;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CREATE_USER_REQUEST }, getState);

                            created = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.createUser(user, data, hash, inviteId);

                        case 5:
                            created = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.CREATE_USER_FAILURE,
                                error: _context2.t0
                            }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', null);

                        case 13:
                            profiles = {};

                            profiles[created.id] = created;
                            dispatch({ type: _action_types.UserTypes.RECEIVED_PROFILES, data: profiles });

                            return _context2.abrupt('return', created);

                        case 17:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function login(loginId, password) {
    var _this3 = this;

    var mfaToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var ldapOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var deviceId, data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.LOGIN_REQUEST }, getState);

                            deviceId = getState().entities.general.deviceToken;
                            data = void 0;
                            _context3.prev = 3;
                            _context3.next = 6;
                            return _client.Client4.login(loginId, password, mfaToken, deviceId, ldapOnly);

                        case 6:
                            data = _context3.sent;

                            _client.Client.setToken(_client.Client4.getToken());
                            _context3.next = 14;
                            break;

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.LOGIN_FAILURE,
                                error: _context3.t0
                            }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', false);

                        case 14:
                            _context3.next = 16;
                            return completeLogin(data)(dispatch, getState);

                        case 16:
                            return _context3.abrupt('return', _context3.sent);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[3, 10]]);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function loginById(id, password) {
    var _this4 = this;

    var mfaToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var deviceId, data;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.LOGIN_REQUEST }, getState);

                            deviceId = getState().entities.general.deviceToken;
                            data = void 0;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _client.Client4.loginById(id, password, mfaToken, deviceId);

                        case 6:
                            data = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.LOGIN_FAILURE,
                                error: _context4.t0
                            }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', null);

                        case 13:
                            _context4.next = 15;
                            return completeLogin(data)(dispatch, getState);

                        case 15:
                            return _context4.abrupt('return', _context4.sent);

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[3, 9]]);
        }));

        return function (_x10, _x11) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function completeLogin(data) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var teamMembers, teamUnreads, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, promises, state;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({
                                type: _action_types.UserTypes.RECEIVED_ME,
                                data: data
                            });

                            _client.Client4.setUserId(data.id);

                            teamMembers = void 0;
                            _context5.prev = 3;
                            _context5.next = 6;
                            return _client.Client4.getMyTeamMembers();

                        case 6:
                            teamMembers = _context5.sent;
                            _context5.next = 9;
                            return _client.Client4.getMyTeamUnreads();

                        case 9:
                            teamUnreads = _context5.sent;

                            if (!teamUnreads) {
                                _context5.next = 31;
                                break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context5.prev = 14;

                            _loop = function _loop() {
                                var u = _step.value;

                                var index = teamMembers.findIndex(function (m) {
                                    return m.team_id === u.team_id;
                                });
                                var member = teamMembers[index];
                                member.mention_count = u.mention_count;
                                member.msg_count = u.msg_count;
                            };

                            for (_iterator = teamUnreads[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                _loop();
                            }
                            _context5.next = 23;
                            break;

                        case 19:
                            _context5.prev = 19;
                            _context5.t0 = _context5['catch'](14);
                            _didIteratorError = true;
                            _iteratorError = _context5.t0;

                        case 23:
                            _context5.prev = 23;
                            _context5.prev = 24;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 26:
                            _context5.prev = 26;

                            if (!_didIteratorError) {
                                _context5.next = 29;
                                break;
                            }

                            throw _iteratorError;

                        case 29:
                            return _context5.finish(26);

                        case 30:
                            return _context5.finish(23);

                        case 31:
                            _context5.next = 37;
                            break;

                        case 33:
                            _context5.prev = 33;
                            _context5.t1 = _context5['catch'](3);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.LOGIN_FAILURE, error: _context5.t1 }, (0, _errors.logError)(_context5.t1)(dispatch)]), getState);
                            return _context5.abrupt('return', false);

                        case 37:
                            promises = [(0, _preferences.getMyPreferences)()(dispatch, getState), (0, _teams.getMyTeams)()(dispatch, getState)];
                            state = getState();

                            if ((0, _general.getConfig)(state).EnableCustomEmoji === 'true') {
                                promises.push((0, _emojis.getAllCustomEmojis)()(dispatch, getState));
                            }

                            _context5.prev = 40;
                            _context5.next = 43;
                            return Promise.all(promises);

                        case 43:
                            _context5.next = 49;
                            break;

                        case 45:
                            _context5.prev = 45;
                            _context5.t2 = _context5['catch'](40);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.LOGIN_FAILURE, error: _context5.t2 }, (0, _errors.logError)(_context5.t2)(dispatch)]), getState);
                            return _context5.abrupt('return', false);

                        case 49:
                            _context5.t3 = dispatch;
                            _context5.t4 = _reduxBatchedActions.batchActions;
                            _context5.t5 = _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS;
                            _context5.next = 54;
                            return teamMembers;

                        case 54:
                            _context5.t6 = _context5.sent;
                            _context5.t7 = {
                                type: _context5.t5,
                                data: _context5.t6
                            };
                            _context5.t8 = {
                                type: _action_types.UserTypes.LOGIN_SUCCESS
                            };
                            _context5.t9 = [_context5.t7, _context5.t8];
                            _context5.t10 = (0, _context5.t4)(_context5.t9);
                            _context5.t11 = getState;
                            (0, _context5.t3)(_context5.t10, _context5.t11);
                            return _context5.abrupt('return', true);

                        case 62:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[3, 33], [14, 19, 23, 31], [24,, 26, 30], [40, 45]]);
        }));

        return function (_x12, _x13) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function loadMe() {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var state, deviceId, promises, currentUserId;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            deviceId = state.entities.general.deviceToken;

                            if (deviceId) {
                                _client.Client4.attachDevice(deviceId);
                            }

                            promises = [getMe()(dispatch, getState), (0, _preferences.getMyPreferences)()(dispatch, getState), (0, _teams.getMyTeams)()(dispatch, getState), (0, _teams.getMyTeamMembers)()(dispatch, getState), (0, _teams.getMyTeamUnreads)()(dispatch, getState)];


                            if ((0, _general.getConfig)(state).EnableCustomEmoji === 'true') {
                                promises.push((0, _emojis.getAllCustomEmojis)()(dispatch, getState));
                            }

                            _context6.next = 7;
                            return Promise.all(promises);

                        case 7:
                            currentUserId = getState().entities.users.currentUserId;

                            _client.Client4.setUserId(currentUserId);

                        case 9:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x14, _x15) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function logout() {
    return (0, _helpers.bindClientFunc)(_client.Client4.logout, _action_types.UserTypes.LOGOUT_REQUEST, _action_types.UserTypes.LOGOUT_SUCCESS, _action_types.UserTypes.LOGOUT_FAILURE);
}

function getProfiles() {
    var _this7 = this;

    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context7.prev = 3;
                            _context7.next = 6;
                            return _client.Client4.getProfiles(page, perPage);

                        case 6:
                            profiles = _context7.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context7.next = 15;
                            break;

                        case 10:
                            _context7.prev = 10;
                            _context7.t0 = _context7['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', null);

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', profiles);

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[3, 10]]);
        }));

        return function (_x18, _x19) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getMissingProfilesByIds(userIds) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var profiles, missingIds;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            profiles = getState().entities.users.profiles;
                            missingIds = [];

                            userIds.forEach(function (id) {
                                if (!profiles[id]) {
                                    missingIds.push(id);
                                }
                            });

                            if (!(missingIds.length > 0)) {
                                _context8.next = 8;
                                break;
                            }

                            getStatusesByIds(missingIds)(dispatch, getState);
                            _context8.next = 7;
                            return getProfilesByIds(missingIds)(dispatch, getState);

                        case 7:
                            return _context8.abrupt('return', _context8.sent);

                        case 8:
                            return _context8.abrupt('return', []);

                        case 9:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }));

        return function (_x20, _x21) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getProfilesByIds(userIds) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context9.prev = 3;
                            _context9.next = 6;
                            return _client.Client4.getProfilesByIds(userIds);

                        case 6:
                            profiles = _context9.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context9.next = 15;
                            break;

                        case 10:
                            _context9.prev = 10;
                            _context9.t0 = _context9['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', null);

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context9.abrupt('return', profiles);

                        case 17:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[3, 10]]);
        }));

        return function (_x22, _x23) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function getProfilesByUsernames(usernames) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context10.prev = 3;
                            _context10.next = 6;
                            return _client.Client4.getProfilesByUsernames(usernames);

                        case 6:
                            profiles = _context10.sent;

                            (0, _user_utils.removeUserFromList)(currentUserId, profiles);
                            _context10.next = 15;
                            break;

                        case 10:
                            _context10.prev = 10;
                            _context10.t0 = _context10['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', null);

                        case 15:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_SUCCESS
                            }]), getState);

                            return _context10.abrupt('return', profiles);

                        case 17:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[3, 10]]);
        }));

        return function (_x24, _x25) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getProfilesInTeam(teamId, page) {
    var _this11 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return function () {
        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_IN_TEAM_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context11.prev = 3;
                            _context11.next = 6;
                            return _client.Client4.getProfilesInTeam(teamId, page, perPage, sort);

                        case 6:
                            profiles = _context11.sent;
                            _context11.next = 14;
                            break;

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_IN_TEAM_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_IN_TEAM_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', profiles);

                        case 16:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[3, 9]]);
        }));

        return function (_x28, _x29) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getProfilesNotInTeam(teamId, page) {
    var _this12 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var profiles;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_REQUEST }, getState);

                            profiles = void 0;
                            _context12.prev = 2;
                            _context12.next = 5;
                            return _client.Client4.getProfilesNotInTeam(teamId, page, perPage);

                        case 5:
                            profiles = _context12.sent;
                            _context12.next = 13;
                            break;

                        case 8:
                            _context12.prev = 8;
                            _context12.t0 = _context12['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_SUCCESS
                            }]), getState);

                            return _context12.abrupt('return', profiles);

                        case 15:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[2, 8]]);
        }));

        return function (_x31, _x32) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getProfilesWithoutTeam(page) {
    var _this13 = this;

    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var profiles;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_REQUEST }, getState);

                            profiles = void 0;
                            _context13.prev = 2;
                            _context13.next = 5;
                            return _client.Client4.getProfilesWithoutTeam(page, perPage);

                        case 5:
                            profiles = _context13.sent;
                            _context13.next = 13;
                            break;

                        case 8:
                            _context13.prev = 8;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_WITHOUT_TEAM,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_WITHOUT_TEAM_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', profiles);

                        case 15:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[2, 8]]);
        }));

        return function (_x34, _x35) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getProfilesInChannel(channelId, page) {
    var _this14 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context14.prev = 3;
                            _context14.next = 6;
                            return _client.Client4.getProfilesInChannel(channelId, page, perPage);

                        case 6:
                            profiles = _context14.sent;
                            _context14.next = 14;
                            break;

                        case 9:
                            _context14.prev = 9;
                            _context14.t0 = _context14['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context14.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_FAILURE, error: _context14.t0 }, (0, _errors.logError)(_context14.t0)(dispatch)]), getState);
                            return _context14.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                data: profiles,
                                id: channelId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_IN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context14.abrupt('return', profiles);

                        case 16:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[3, 9]]);
        }));

        return function (_x37, _x38) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function getProfilesNotInChannel(teamId, channelId, page) {
    var _this15 = this;

    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var currentUserId, profiles;
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context15.prev = 3;
                            _context15.next = 6;
                            return _client.Client4.getProfilesNotInChannel(teamId, channelId, page, perPage);

                        case 6:
                            profiles = _context15.sent;
                            _context15.next = 14;
                            break;

                        case 9:
                            _context15.prev = 9;
                            _context15.t0 = _context15['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                data: profiles,
                                id: channelId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context15.abrupt('return', profiles);

                        case 16:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[3, 9]]);
        }));

        return function (_x40, _x41) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getMe() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMe, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_ME, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE);
}

function getUser(id) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getUser, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE, id);
}

function getUserByUsername(username) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getUserByUsername, _action_types.UserTypes.USER_BY_USERNAME_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_BY_USERNAME_SUCCESS], _action_types.UserTypes.USER_BY_USERNAME_FAILURE, username);
}

function getUserByEmail(email) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getUserByEmail, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE, email);
}

// We create an array to hold the id's that we want to get a status for. We build our
// debounced function that will get called after a set period of idle time in which
// the array of id's will be passed to the getStatusesByIds with a cb that clears out
// the array. Helps with performance because instead of making 75 different calls for
// statuses, we are only making one call for 75 ids.
// We could maybe clean it up somewhat by storing the array of ids in redux state possbily?
var ids = [];
var debouncedGetStatusesByIds = (0, _helpers.debounce)(function () {
    var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(dispatch, getState) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        getStatusesByIds([].concat(_toConsumableArray(new Set(ids))))(dispatch, getState);

                    case 1:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, undefined);
    }));

    return function (_x42, _x43) {
        return _ref16.apply(this, arguments);
    };
}(), 20, false, function () {
    ids = [];
});
function getStatusesByIdsBatchedDebounced(id) {
    ids = [].concat(_toConsumableArray(ids), [id]);
    return debouncedGetStatusesByIds;
}

function getStatusesByIds(userIds) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getStatusesByIds, _action_types.UserTypes.PROFILES_STATUSES_REQUEST, [_action_types.UserTypes.RECEIVED_STATUSES, _action_types.UserTypes.PROFILES_STATUSES_SUCCESS], _action_types.UserTypes.PROFILES_STATUSES_FAILURE, userIds);
}

function getStatus(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getStatus, _action_types.UserTypes.PROFILE_STATUS_REQUEST, [_action_types.UserTypes.RECEIVED_STATUS, _action_types.UserTypes.PROFILE_STATUS_SUCCESS], _action_types.UserTypes.PROFILE_STATUS_FAILURE, userId);
}

function setStatus(status) {
    var _this16 = this;

    return function () {
        var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.SET_STATUS_REQUEST }, getState);

                            _context17.prev = 1;
                            _context17.next = 4;
                            return _client.Client4.updateStatus(status);

                        case 4:
                            _context17.next = 11;
                            break;

                        case 6:
                            _context17.prev = 6;
                            _context17.t0 = _context17['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.SET_STATUS_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', null);

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_STATUS,
                                data: status
                            }, {
                                type: _action_types.UserTypes.SET_STATUS_SUCCESS
                            }]), getState);

                            return _context17.abrupt('return', status);

                        case 13:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this16, [[1, 6]]);
        }));

        return function (_x44, _x45) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getSessions(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getSessions, _action_types.UserTypes.SESSIONS_REQUEST, [_action_types.UserTypes.RECEIVED_SESSIONS, _action_types.UserTypes.SESSIONS_SUCCESS], _action_types.UserTypes.SESSIONS_FAILURE, userId);
}

function revokeSession(userId, sessionId) {
    var _this17 = this;

    return function () {
        var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.REVOKE_SESSION_REQUEST }, getState);

                            _context18.prev = 1;
                            _context18.next = 4;
                            return _client.Client4.revokeSession(userId, sessionId);

                        case 4:
                            _context18.next = 11;
                            break;

                        case 6:
                            _context18.prev = 6;
                            _context18.t0 = _context18['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context18.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.REVOKE_SESSION_FAILURE, error: _context18.t0 }, (0, _errors.logError)(_context18.t0)(dispatch)]), getState);
                            return _context18.abrupt('return', false);

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_REVOKED_SESSION,
                                sessionId: sessionId
                            }, {
                                type: _action_types.UserTypes.REVOKE_SESSION_SUCCESS
                            }]), getState);

                            return _context18.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this17, [[1, 6]]);
        }));

        return function (_x46, _x47) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function loadProfilesForDirect() {
    var _this18 = this;

    return function () {
        var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            var state, _state$entities$chann, channels, myMembers, myPreferences, currentUserId, values, i, channel, member, otherUserId;

            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            state = getState();
                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            myPreferences = state.entities.preferences.myPreferences;
                            currentUserId = state.entities.users.currentUserId;
                            values = Object.values(channels);
                            i = 0;

                        case 6:
                            if (!(i < values.length)) {
                                _context19.next = 15;
                                break;
                            }

                            channel = values[i];
                            member = myMembers[channel.id];

                            if (!(!(0, _channel_utils.isDirectChannel)(channel) && !(0, _channel_utils.isGroupChannel)(channel))) {
                                _context19.next = 11;
                                break;
                            }

                            return _context19.abrupt('continue', 12);

                        case 11:

                            if (member) {
                                if (member.mention_count > 0 && (0, _channel_utils.isDirectChannel)(channel) && !(0, _channel_utils.isDirectChannelVisible)(currentUserId, myPreferences, channel)) {
                                    otherUserId = (0, _channel_utils.getUserIdFromChannelName)(currentUserId, channel.name);

                                    (0, _preferences.makeDirectChannelVisibleIfNecessary)(otherUserId)(dispatch, getState);
                                } else if ((member.mention_count > 0 || member.msg_count < channel.total_msg_count) && (0, _channel_utils.isGroupChannel)(channel) && !(0, _channel_utils.isGroupChannelVisible)(myPreferences, channel)) {
                                    (0, _preferences.makeGroupMessageVisibleIfNecessary)(channel.id)(dispatch, getState);
                                }
                            }

                        case 12:
                            i++;
                            _context19.next = 6;
                            break;

                        case 15:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this18);
        }));

        return function (_x48, _x49) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function getUserAudits(userId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.AUDITS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getUserAudits, _action_types.UserTypes.AUDITS_REQUEST, [_action_types.UserTypes.RECEIVED_AUDITS, _action_types.UserTypes.AUDITS_SUCCESS], _action_types.UserTypes.AUDITS_FAILURE, userId, page, perPage);
}

function autocompleteUsers(term) {
    var _this19 = this;

    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var channelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            var currentUserId, data, users, actions;
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.AUTOCOMPLETE_USERS_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            data = void 0;
                            _context20.prev = 3;
                            _context20.next = 6;
                            return _client.Client4.autocompleteUsers(term, teamId, channelId);

                        case 6:
                            data = _context20.sent;
                            _context20.next = 14;
                            break;

                        case 9:
                            _context20.prev = 9;
                            _context20.t0 = _context20['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context20.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.AUTOCOMPLETE_USERS_FAILURE, error: _context20.t0 }, (0, _errors.logError)(_context20.t0)(dispatch)]), getState);
                            return _context20.abrupt('return', null);

                        case 14:
                            users = [].concat(_toConsumableArray(data.users));

                            if (data.out_of_channel) {
                                users = [].concat(_toConsumableArray(users), _toConsumableArray(data.out_of_channel));
                            }
                            (0, _user_utils.removeUserFromList)(currentUserId, users);

                            actions = [{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: users
                            }, {
                                type: _action_types.UserTypes.AUTOCOMPLETE_USERS_SUCCESS
                            }];


                            if (channelId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                    data: data.users,
                                    id: channelId
                                });
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                    data: data.out_of_channel,
                                    id: channelId
                                });
                            }

                            if (teamId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                    data: users,
                                    id: teamId
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context20.abrupt('return', data);

                        case 22:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this19, [[3, 9]]);
        }));

        return function (_x54, _x55) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function searchProfiles(term) {
    var _this20 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function () {
        var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            var currentUserId, profiles, actions;
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.SEARCH_PROFILES_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context21.prev = 3;
                            _context21.next = 6;
                            return _client.Client4.searchUsers(term, options);

                        case 6:
                            profiles = _context21.sent;
                            _context21.next = 14;
                            break;

                        case 9:
                            _context21.prev = 9;
                            _context21.t0 = _context21['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context21.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.SEARCH_PROFILES_FAILURE, error: _context21.t0 }, (0, _errors.logError)(_context21.t0)(dispatch)]), getState);
                            return _context21.abrupt('return', null);

                        case 14:
                            actions = [{ type: _action_types.UserTypes.RECEIVED_PROFILES_LIST, data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat(_toConsumableArray(profiles))) }];


                            if (options.in_channel_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL,
                                    data: profiles,
                                    id: options.in_channel_id
                                });
                            }

                            if (options.not_in_channel_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                    data: profiles,
                                    id: options.not_in_channel_id
                                });
                            }

                            if (options.team_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                    data: profiles,
                                    id: options.team_id
                                });
                            }

                            if (options.not_in_team_id) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                                    data: profiles,
                                    id: options.not_in_team_id
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.UserTypes.SEARCH_PROFILES_SUCCESS
                            }])), getState);

                            return _context21.abrupt('return', profiles);

                        case 21:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this20, [[3, 9]]);
        }));

        return function (_x57, _x58) {
            return _ref21.apply(this, arguments);
        };
    }();
}

var statusIntervalId = '';
function startPeriodicStatusUpdates() {
    var _this21 = this;

    return function () {
        var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            clearInterval(statusIntervalId);

                            statusIntervalId = setInterval(function () {
                                var statuses = getState().entities.users.statuses;


                                if (!statuses) {
                                    return;
                                }

                                var userIds = Object.keys(statuses);
                                if (!userIds.length) {
                                    return;
                                }

                                getStatusesByIds(userIds)(dispatch, getState);
                            }, _constants.General.STATUS_INTERVAL);

                        case 2:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this21);
        }));

        return function (_x59, _x60) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function stopPeriodicStatusUpdates() {
    var _this22 = this;

    return _asyncToGenerator(regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        if (statusIntervalId) {
                            clearInterval(statusIntervalId);
                        }

                    case 1:
                    case 'end':
                        return _context23.stop();
                }
            }
        }, _callee23, _this22);
    }));
}

function updateMe(user) {
    var _this23 = this;

    return function () {
        var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_ME_REQUEST }, getState);

                            data = void 0;
                            _context24.prev = 2;
                            _context24.next = 5;
                            return _client.Client4.patchMe(user);

                        case 5:
                            data = _context24.sent;
                            _context24.next = 12;
                            break;

                        case 8:
                            _context24.prev = 8;
                            _context24.t0 = _context24['catch'](2);

                            dispatch({ type: _action_types.UserTypes.UPDATE_ME_FAILURE, error: _context24.t0 }, getState);
                            return _context24.abrupt('return', null);

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.RECEIVED_ME, data: data }, { type: _action_types.UserTypes.UPDATE_ME_SUCCESS }]), getState);

                            return _context24.abrupt('return', data);

                        case 14:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this23, [[2, 8]]);
        }));

        return function (_x61, _x62) {
            return _ref24.apply(this, arguments);
        };
    }();
}

function updateUserRoles(userId, roles) {
    var _this24 = this;

    return function () {
        var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context25.prev = 1;
                            _context25.next = 4;
                            return _client.Client4.updateUserRoles(userId, roles);

                        case 4:
                            _context25.next = 10;
                            break;

                        case 6:
                            _context25.prev = 6;
                            _context25.t0 = _context25['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context25.t0 }, getState);
                            return _context25.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { roles: roles }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context25.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this24, [[1, 6]]);
        }));

        return function (_x63, _x64) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function updateUserMfa(userId, activate) {
    var _this25 = this;

    var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return function () {
        var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee26(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context26.prev = 1;
                            _context26.next = 4;
                            return _client.Client4.updateUserMfa(userId, activate, code);

                        case 4:
                            _context26.next = 10;
                            break;

                        case 6:
                            _context26.prev = 6;
                            _context26.t0 = _context26['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context26.t0 }, getState);
                            return _context26.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { mfa_active: activate }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context26.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, _this25, [[1, 6]]);
        }));

        return function (_x66, _x67) {
            return _ref26.apply(this, arguments);
        };
    }();
}

function updateUserPassword(userId, currentPassword, newPassword) {
    var _this26 = this;

    return function () {
        var _ref27 = _asyncToGenerator(regeneratorRuntime.mark(function _callee27(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context27.prev = 1;
                            _context27.next = 4;
                            return _client.Client4.updateUserPassword(userId, currentPassword, newPassword);

                        case 4:
                            _context27.next = 10;
                            break;

                        case 6:
                            _context27.prev = 6;
                            _context27.t0 = _context27['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context27.t0 }, getState);
                            return _context27.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { last_password_update_at: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context27.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, _this26, [[1, 6]]);
        }));

        return function (_x68, _x69) {
            return _ref27.apply(this, arguments);
        };
    }();
}

function updateUserActive(userId, active) {
    var _this27 = this;

    return function () {
        var _ref28 = _asyncToGenerator(regeneratorRuntime.mark(function _callee28(dispatch, getState) {
            var actions, profile, deleteAt;
            return regeneratorRuntime.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context28.prev = 1;
                            _context28.next = 4;
                            return _client.Client4.updateUserActive(userId, active);

                        case 4:
                            _context28.next = 10;
                            break;

                        case 6:
                            _context28.prev = 6;
                            _context28.t0 = _context28['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context28.t0 }, getState);
                            return _context28.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                deleteAt = active ? 0 : new Date().getTime();

                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { delete_at: deleteAt }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context28.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, _this27, [[1, 6]]);
        }));

        return function (_x70, _x71) {
            return _ref28.apply(this, arguments);
        };
    }();
}

function verifyUserEmail(token) {
    return (0, _helpers.bindClientFunc)(_client.Client4.verifyUserEmail, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, token);
}

function sendVerificationEmail(email) {
    return (0, _helpers.bindClientFunc)(_client.Client4.sendVerificationEmail, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, email);
}

function resetUserPassword(token, newPassword) {
    return (0, _helpers.bindClientFunc)(_client.Client4.resetUserPassword, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, token, newPassword);
}

function sendPasswordResetEmail(email) {
    return (0, _helpers.bindClientFunc)(_client.Client4.sendPasswordResetEmail, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, email);
}

function uploadProfileImage(userId, imageData) {
    var _this28 = this;

    return function () {
        var _ref29 = _asyncToGenerator(regeneratorRuntime.mark(function _callee29(dispatch, getState) {
            var actions, profile;
            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context29.prev = 1;
                            _context29.next = 4;
                            return _client.Client4.uploadProfileImage(userId, imageData);

                        case 4:
                            _context29.next = 10;
                            break;

                        case 6:
                            _context29.prev = 6;
                            _context29.t0 = _context29['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context29.t0 }, getState);
                            return _context29.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: _extends({}, profile, { last_picture_update: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context29.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this28, [[1, 6]]);
        }));

        return function (_x72, _x73) {
            return _ref29.apply(this, arguments);
        };
    }();
}

function switchEmailToOAuth(service, email, password) {
    var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return (0, _helpers.bindClientFunc)(_client.Client4.switchEmailToOAuth, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, service, email, password, mfaCode);
}

function switchOAuthToEmail(currentService, email, password) {
    return (0, _helpers.bindClientFunc)(_client.Client4.switchOAuthToEmail, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, currentService, email, password);
}

function switchEmailToLdap(email, emailPassword, ldapId, ldapPassword) {
    var mfaCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return (0, _helpers.bindClientFunc)(_client.Client4.switchEmailToLdap, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, email, emailPassword, ldapId, ldapPassword, mfaCode);
}

function switchLdapToEmail(ldapPassword, email, emailPassword) {
    var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return (0, _helpers.bindClientFunc)(_client.Client4.switchLdapToEmail, _action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, ldapPassword, email, emailPassword, mfaCode);
}

function createUserAccessToken(userId, description) {
    var _this29 = this;

    return function () {
        var _ref30 = _asyncToGenerator(regeneratorRuntime.mark(function _callee30(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context30.prev = 2;
                            _context30.next = 5;
                            return _client.Client4.createUserAccessToken(userId, description);

                        case 5:
                            data = _context30.sent;
                            _context30.next = 13;
                            break;

                        case 8:
                            _context30.prev = 8;
                            _context30.t0 = _context30['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context30.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_FAILURE, error: _context30.t0 }, (0, _errors.logError)(_context30.t0)(dispatch)]), getState);
                            return _context30.abrupt('return', { error: _context30.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKEN,
                                data: _extends({}, data, { token: '' })
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (userId === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKEN,
                                    data: _extends({}, data, { token: '' })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context30.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, _this29, [[2, 8]]);
        }));

        return function (_x77, _x78) {
            return _ref30.apply(this, arguments);
        };
    }();
}

function getUserAccessToken(tokenId) {
    var _this30 = this;

    return function () {
        var _ref31 = _asyncToGenerator(regeneratorRuntime.mark(function _callee31(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context31.prev = 2;
                            _context31.next = 5;
                            return _client.Client4.getUserAccessToken(tokenId);

                        case 5:
                            data = _context31.sent;
                            _context31.next = 13;
                            break;

                        case 8:
                            _context31.prev = 8;
                            _context31.t0 = _context31['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context31.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, error: _context31.t0 }, (0, _errors.logError)(_context31.t0)(dispatch)]), getState);
                            return _context31.abrupt('return', { error: _context31.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKEN,
                                data: data
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (data.user_id === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKEN,
                                    data: data
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context31.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, _this30, [[2, 8]]);
        }));

        return function (_x79, _x80) {
            return _ref31.apply(this, arguments);
        };
    }();
}

function getUserAccessTokensForUser(userId) {
    var _this31 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref32 = _asyncToGenerator(regeneratorRuntime.mark(function _callee32(dispatch, getState) {
            var data, actions, currentUserId;
            return regeneratorRuntime.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST });

                            data = void 0;
                            _context32.prev = 2;
                            _context32.next = 5;
                            return _client.Client4.getUserAccessTokensForUser(userId, page, perPage);

                        case 5:
                            data = _context32.sent;
                            _context32.next = 13;
                            break;

                        case 8:
                            _context32.prev = 8;
                            _context32.t0 = _context32['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context32.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, error: _context32.t0 }, (0, _errors.logError)(_context32.t0)(dispatch)]), getState);
                            return _context32.abrupt('return', { error: _context32.t0 });

                        case 13:
                            actions = [{
                                type: _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKENS,
                                data: data,
                                userId: userId
                            }];
                            currentUserId = getState().entities.users.currentUserId;

                            if (userId === currentUserId) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKENS,
                                    data: data
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions));

                            return _context32.abrupt('return', { data: data });

                        case 18:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, _this31, [[2, 8]]);
        }));

        return function (_x83, _x84) {
            return _ref32.apply(this, arguments);
        };
    }();
}

function revokeUserAccessToken(tokenId) {
    var _this32 = this;

    return function () {
        var _ref33 = _asyncToGenerator(regeneratorRuntime.mark(function _callee33(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_REQUEST });

                            _context33.prev = 1;
                            _context33.next = 4;
                            return _client.Client4.revokeUserAccessToken(tokenId);

                        case 4:
                            _context33.next = 11;
                            break;

                        case 6:
                            _context33.prev = 6;
                            _context33.t0 = _context33['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context33.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_FAILURE, error: _context33.t0 }, (0, _errors.logError)(_context33.t0)(dispatch)]), getState);
                            return _context33.abrupt('return', { error: _context33.t0 });

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_SUCCESS
                            }, {
                                type: _action_types.UserTypes.REVOKED_USER_ACCESS_TOKEN,
                                data: tokenId
                            }]));

                            return _context33.abrupt('return', { data: true });

                        case 13:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, _this32, [[1, 6]]);
        }));

        return function (_x85, _x86) {
            return _ref33.apply(this, arguments);
        };
    }();
}

function clearUserAccessTokens() {
    var _this33 = this;

    return function () {
        var _ref34 = _asyncToGenerator(regeneratorRuntime.mark(function _callee34(dispatch) {
            return regeneratorRuntime.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.CLEAR_MY_USER_ACCESS_TOKENS });
                            return _context34.abrupt('return', { data: true });

                        case 2:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, _this33);
        }));

        return function (_x87) {
            return _ref34.apply(this, arguments);
        };
    }();
}

exports.default = {
    checkMfa: checkMfa,
    generateMfaSecret: generateMfaSecret,
    login: login,
    logout: logout,
    getProfiles: getProfiles,
    getProfilesByIds: getProfilesByIds,
    getProfilesInTeam: getProfilesInTeam,
    getProfilesInChannel: getProfilesInChannel,
    getProfilesNotInChannel: getProfilesNotInChannel,
    getUser: getUser,
    getMe: getMe,
    getUserByUsername: getUserByUsername,
    getStatus: getStatus,
    getStatusesByIds: getStatusesByIds,
    getSessions: getSessions,
    loadProfilesForDirect: loadProfilesForDirect,
    revokeSession: revokeSession,
    getUserAudits: getUserAudits,
    searchProfiles: searchProfiles,
    startPeriodicStatusUpdates: startPeriodicStatusUpdates,
    stopPeriodicStatusUpdates: stopPeriodicStatusUpdates,
    updateMe: updateMe,
    updateUserRoles: updateUserRoles,
    updateUserMfa: updateUserMfa,
    updateUserPassword: updateUserPassword,
    updateUserActive: updateUserActive,
    verifyUserEmail: verifyUserEmail,
    sendVerificationEmail: sendVerificationEmail,
    resetUserPassword: resetUserPassword,
    sendPasswordResetEmail: sendPasswordResetEmail,
    uploadProfileImage: uploadProfileImage,
    switchEmailToOAuth: switchEmailToOAuth,
    switchOAuthToEmail: switchOAuthToEmail,
    switchEmailToLdap: switchEmailToLdap,
    switchLdapToEmail: switchLdapToEmail,
    createUserAccessToken: createUserAccessToken,
    getUserAccessToken: getUserAccessToken,
    getUserAccessTokensForUser: getUserAccessTokensForUser,
    revokeUserAccessToken: revokeUserAccessToken
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = __webpack_require__(887)
var ieee754 = __webpack_require__(888)
var isArray = __webpack_require__(390)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// optional / simple context binding
var aFunction = __webpack_require__(43);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
if(__webpack_require__(18)){
  var LIBRARY             = __webpack_require__(107)
    , global              = __webpack_require__(6)
    , fails               = __webpack_require__(9)
    , $export             = __webpack_require__(1)
    , $typed              = __webpack_require__(187)
    , $buffer             = __webpack_require__(252)
    , ctx                 = __webpack_require__(81)
    , anInstance          = __webpack_require__(113)
    , propertyDesc        = __webpack_require__(94)
    , hide                = __webpack_require__(41)
    , redefineAll         = __webpack_require__(114)
    , toInteger           = __webpack_require__(96)
    , toLength            = __webpack_require__(26)
    , toIndex             = __webpack_require__(109)
    , toPrimitive         = __webpack_require__(72)
    , has                 = __webpack_require__(36)
    , same                = __webpack_require__(316)
    , classof             = __webpack_require__(150)
    , isObject            = __webpack_require__(13)
    , toObject            = __webpack_require__(29)
    , isArrayIter         = __webpack_require__(244)
    , create              = __webpack_require__(110)
    , getPrototypeOf      = __webpack_require__(52)
    , gOPN                = __webpack_require__(111).f
    , getIterFn           = __webpack_require__(246)
    , uid                 = __webpack_require__(106)
    , wks                 = __webpack_require__(14)
    , createArrayMethod   = __webpack_require__(74)
    , createArrayIncludes = __webpack_require__(179)
    , speciesConstructor  = __webpack_require__(249)
    , ArrayIterators      = __webpack_require__(248)
    , Iterators           = __webpack_require__(130)
    , $iterDetect         = __webpack_require__(183)
    , setSpecies          = __webpack_require__(112)
    , arrayFill           = __webpack_require__(247)
    , arrayCopyWithin     = __webpack_require__(325)
    , $DP                 = __webpack_require__(19)
    , $GOPD               = __webpack_require__(51)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var Map     = __webpack_require__(328)
  , $export = __webpack_require__(1)
  , shared  = __webpack_require__(178)('metadata')
  , store   = shared.store || (shared.store = new (__webpack_require__(331)));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(115);

var emptyFunction = __webpack_require__(53);
var warning = __webpack_require__(10);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var cls = __webpack_require__(211);
var dom = __webpack_require__(121);

var toInt = exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

var clone = exports.clone = function (obj) {
  if (!obj) {
    return null;
  } else if (Array.isArray(obj)) {
    return obj.map(clone);
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = clone(original);
  for (var key in source) {
    result[key] = clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return dom.matches(el, "input,[contenteditable]") ||
         dom.matches(el, "select,[contenteditable]") ||
         dom.matches(el, "textarea,[contenteditable]") ||
         dom.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return toInt(dom.css(element, 'width')) +
         toInt(dom.css(element, 'paddingLeft')) +
         toInt(dom.css(element, 'paddingRight')) +
         toInt(dom.css(element, 'borderLeftWidth')) +
         toInt(dom.css(element, 'borderRightWidth'));
};

function toggleScrolling(handler) {
  return function (element, axis) {
    handler(element, 'ps--in-scrolling');
    if (typeof axis !== 'undefined') {
      handler(element, 'ps--' + axis);
    } else {
      handler(element, 'ps--x');
      handler(element, 'ps--y');
    }
  };
}

exports.startScrolling = toggleScrolling(cls.add);

exports.stopScrolling = toggleScrolling(cls.remove);

exports.env = {
  isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: typeof window !== 'undefined' && (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof window !== 'undefined' && window.navigator.msMaxTouchPoints !== null
};



/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var cls = __webpack_require__(211);
var dom = __webpack_require__(121);
var instances = __webpack_require__(46);
var updateScroll = __webpack_require__(102);

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  dom.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  dom.css(i.scrollbarYRail, yRailOffset);

  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = dom.queryChildren(element, '.ps__scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = dom.queryChildren(element, '.ps__scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps--active-x');
  } else {
    cls.remove(element, 'ps--active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps--active-y');
  } else {
    cls.remove(element, 'ps--active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};



/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsersInVisibleDMs = exports.getProfilesWithoutTeam = exports.getProfilesNotInCurrentTeam = exports.getProfilesInTeam = exports.getProfilesInCurrentTeam = exports.getProfilesNotInCurrentChannel = exports.getProfilesInCurrentChannel = exports.getProfileSetNotInCurrentTeam = exports.getProfileSetInCurrentTeam = exports.getProfileSetNotInCurrentChannel = exports.getProfileSetInCurrentChannel = exports.getCurrentUserMentionKeys = exports.getCurrentUserRoles = exports.isCurrentUserSystemAdmin = exports.getUsersByEmail = exports.getUsersByUsername = undefined;
exports.getCurrentUserId = getCurrentUserId;
exports.getUserIdsInChannels = getUserIdsInChannels;
exports.getUserIdsNotInChannels = getUserIdsNotInChannels;
exports.getUserIdsInTeams = getUserIdsInTeams;
exports.getUserIdsNotInTeams = getUserIdsNotInTeams;
exports.getUserIdsWithoutTeam = getUserIdsWithoutTeam;
exports.getUserStatuses = getUserStatuses;
exports.getUser = getUser;
exports.getUsers = getUsers;
exports.getUserByUsername = getUserByUsername;
exports.getUserByEmail = getUserByEmail;
exports.getCurrentUser = getCurrentUser;
exports.getStatusForUserId = getStatusForUserId;
exports.searchProfiles = searchProfiles;
exports.searchProfilesInCurrentChannel = searchProfilesInCurrentChannel;
exports.searchProfilesNotInCurrentChannel = searchProfilesNotInCurrentChannel;
exports.searchProfilesInCurrentTeam = searchProfilesInCurrentTeam;
exports.searchProfilesInTeam = searchProfilesInTeam;
exports.searchProfilesNotInCurrentTeam = searchProfilesNotInCurrentTeam;
exports.searchProfilesWithoutTeam = searchProfilesWithoutTeam;
exports.makeGetProfilesForReactions = makeGetProfilesForReactions;

var _reselect = __webpack_require__(93);

var _channels = __webpack_require__(175);

var _teams = __webpack_require__(219);

var _preferences = __webpack_require__(105);

var _user_utils = __webpack_require__(126);

function getCurrentUserId(state) {
    return state.entities.users.currentUserId;
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getUserIdsInChannels(state) {
    return state.entities.users.profilesInChannel;
}

function getUserIdsNotInChannels(state) {
    return state.entities.users.profilesNotInChannel;
}

function getUserIdsInTeams(state) {
    return state.entities.users.profilesInTeam;
}

function getUserIdsNotInTeams(state) {
    return state.entities.users.profilesNotInTeam;
}

function getUserIdsWithoutTeam(state) {
    return state.entities.users.profilesWithoutTeam;
}

function getUserStatuses(state) {
    return state.entities.users.statuses;
}

function getUser(state, id) {
    return state.entities.users.profiles[id];
}

function getUsers(state) {
    return state.entities.users.profiles;
}

var getUsersByUsername = exports.getUsersByUsername = (0, _reselect.createSelector)(getUsers, function (users) {
    var usersByUsername = {};

    for (var id in users) {
        if (users.hasOwnProperty(id)) {
            var user = users[id];
            usersByUsername[user.username] = user;
        }
    }

    return usersByUsername;
});

function getUserByUsername(state, username) {
    return getUsersByUsername(state)[username];
}

var getUsersByEmail = exports.getUsersByEmail = (0, _reselect.createSelector)(getUsers, function (users) {
    var usersByEmail = {};

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.values(users)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var user = _step.value;

            usersByEmail[user.email] = user;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return usersByEmail;
});

function getUserByEmail(state, email) {
    return getUsersByEmail(state)[email];
}

function getCurrentUser(state) {
    return state.entities.users.profiles[getCurrentUserId(state)];
}

var isCurrentUserSystemAdmin = exports.isCurrentUserSystemAdmin = (0, _reselect.createSelector)(getCurrentUser, function (user) {
    var roles = user.roles || '';
    return (0, _user_utils.isSystemAdmin)(roles);
});

var getCurrentUserRoles = exports.getCurrentUserRoles = (0, _reselect.createSelector)(_channels.getMyCurrentChannelMembership, _teams.getCurrentTeamMembership, getCurrentUser, function (currentChannelMembership, currentTeamMembership, currentUser) {
    var roles = '';
    if (currentTeamMembership) {
        roles += currentTeamMembership.roles + ' ';
    }

    if (currentChannelMembership) {
        roles += currentChannelMembership.roles + ' ';
    }

    roles += currentUser.roles;
    return roles.trim();
});

var getCurrentUserMentionKeys = exports.getCurrentUserMentionKeys = (0, _reselect.createSelector)(getCurrentUser, function (user) {
    var keys = [];

    if (!user || !user.notify_props) {
        return keys;
    }

    if (user.notify_props.mention_keys) {
        keys = keys.concat(user.notify_props.mention_keys.split(','));
    }

    if (user.notify_props.first_name === 'true' && user.first_name) {
        keys.push(user.first_name);
    }

    if (user.notify_props.channel === 'true') {
        keys.push('@channel');
        keys.push('@all');
        keys.push('@here');
    }

    var usernameKey = '@' + user.username;
    if (keys.indexOf(usernameKey) === -1) {
        keys.push(usernameKey);
    }

    return keys;
});

var getProfileSetInCurrentChannel = exports.getProfileSetInCurrentChannel = (0, _reselect.createSelector)(_channels.getCurrentChannelId, getUserIdsInChannels, function (currentChannel, channelProfiles) {
    return channelProfiles[currentChannel];
});

var getProfileSetNotInCurrentChannel = exports.getProfileSetNotInCurrentChannel = (0, _reselect.createSelector)(_channels.getCurrentChannelId, getUserIdsNotInChannels, function (currentChannel, channelProfiles) {
    return channelProfiles[currentChannel];
});

var getProfileSetInCurrentTeam = exports.getProfileSetInCurrentTeam = (0, _reselect.createSelector)(_teams.getCurrentTeamId, getUserIdsInTeams, function (currentTeam, teamProfiles) {
    return teamProfiles[currentTeam];
});

var getProfileSetNotInCurrentTeam = exports.getProfileSetNotInCurrentTeam = (0, _reselect.createSelector)(_teams.getCurrentTeamId, getUserIdsNotInTeams, function (currentTeam, teamProfiles) {
    return teamProfiles[currentTeam];
});

function sortAndInjectProfiles(profiles, profileSet) {
    var currentProfiles = [];
    if (typeof profileSet === 'undefined') {
        return currentProfiles;
    }

    profileSet.forEach(function (p) {
        currentProfiles.push(profiles[p]);
    });

    var sortedCurrentProfiles = currentProfiles.sort(_user_utils.sortByUsername);

    return sortedCurrentProfiles;
}

var getProfilesInCurrentChannel = exports.getProfilesInCurrentChannel = (0, _reselect.createSelector)(getUsers, getProfileSetInCurrentChannel, function (profiles, currentChannelProfileSet) {
    return sortAndInjectProfiles(profiles, currentChannelProfileSet);
});

var getProfilesNotInCurrentChannel = exports.getProfilesNotInCurrentChannel = (0, _reselect.createSelector)(getUsers, getProfileSetNotInCurrentChannel, function (profiles, notInCurrentChannelProfileSet) {
    return sortAndInjectProfiles(profiles, notInCurrentChannelProfileSet);
});

var getProfilesInCurrentTeam = exports.getProfilesInCurrentTeam = (0, _reselect.createSelector)(getUsers, getProfileSetInCurrentTeam, function (profiles, currentTeamProfileSet) {
    return sortAndInjectProfiles(profiles, currentTeamProfileSet);
});

var getProfilesInTeam = exports.getProfilesInTeam = (0, _reselect.createSelector)(getUsers, getUserIdsInTeams, function (state, teamId) {
    return teamId;
}, function (profiles, usersInTeams, teamId) {
    return sortAndInjectProfiles(profiles, usersInTeams[teamId] || new Set());
});

var getProfilesNotInCurrentTeam = exports.getProfilesNotInCurrentTeam = (0, _reselect.createSelector)(getUsers, getProfileSetNotInCurrentTeam, function (profiles, notInCurrentTeamProfileSet) {
    return sortAndInjectProfiles(profiles, notInCurrentTeamProfileSet);
});

var getProfilesWithoutTeam = exports.getProfilesWithoutTeam = (0, _reselect.createSelector)(getUsers, getUserIdsWithoutTeam, function (profiles, withoutTeamProfileSet) {
    return sortAndInjectProfiles(profiles, withoutTeamProfileSet);
});

function getStatusForUserId(state, userId) {
    return getUserStatuses(state)[userId];
}

function searchProfiles(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(Object.values(getUsers(state)), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesInCurrentChannel(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInCurrentChannel(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesNotInCurrentChannel(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesNotInCurrentChannel(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesInCurrentTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInCurrentTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesInTeam(state, teamId, term) {
    var skipCurrent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesInTeam(state, teamId), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesNotInCurrentTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesNotInCurrentTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function searchProfilesWithoutTeam(state, term) {
    var skipCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var profiles = (0, _user_utils.filterProfilesMatchingTerm)(getProfilesWithoutTeam(state), term);
    if (skipCurrent) {
        removeCurrentUserFromList(profiles, getCurrentUserId(state));
    }

    return profiles;
}

function removeCurrentUserFromList(profiles, currentUserId) {
    var index = profiles.findIndex(function (p) {
        return p.id === currentUserId;
    });
    if (index >= 0) {
        profiles.splice(index, 1);
    }
}

var getUsersInVisibleDMs = exports.getUsersInVisibleDMs = (0, _reselect.createSelector)(getUsers, _preferences.getDirectShowPreferences, function (users, preferences) {
    var dmUsers = [];
    preferences.forEach(function (pref) {
        if (pref.value === 'true' && users[pref.name]) {
            dmUsers.push(users[pref.name]);
        }
    });
    return dmUsers;
});

function makeGetProfilesForReactions() {
    return (0, _reselect.createSelector)(getUsers, function (state, reactions) {
        return reactions;
    }, function (users, reactions) {
        var profiles = [];
        reactions.forEach(function (r) {
            if (users[r.user_id]) {
                profiles.push(users[r.user_id]);
            }
        });
        return profiles;
    });
}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.selectChannel = selectChannel;
exports.createChannel = createChannel;
exports.createDirectChannel = createDirectChannel;
exports.createGroupChannel = createGroupChannel;
exports.patchChannel = patchChannel;
exports.updateChannel = updateChannel;
exports.updateChannelNotifyProps = updateChannelNotifyProps;
exports.getChannel = getChannel;
exports.getChannelAndMyMember = getChannelAndMyMember;
exports.fetchMyChannelsAndMembers = fetchMyChannelsAndMembers;
exports.getMyChannelMembers = getMyChannelMembers;
exports.getChannelMembers = getChannelMembers;
exports.leaveChannel = leaveChannel;
exports.joinChannel = joinChannel;
exports.deleteChannel = deleteChannel;
exports.viewChannel = viewChannel;
exports.getChannels = getChannels;
exports.searchChannels = searchChannels;
exports.getChannelStats = getChannelStats;
exports.addChannelMember = addChannelMember;
exports.removeChannelMember = removeChannelMember;
exports.updateChannelMemberRoles = updateChannelMemberRoles;
exports.updateChannelHeader = updateChannelHeader;
exports.updateChannelPurpose = updateChannelPurpose;
exports.markChannelAsRead = markChannelAsRead;
exports.markChannelAsUnread = markChannelAsUnread;
exports.getChannelMembersByIds = getChannelMembersByIds;
exports.getChannelMember = getChannelMember;
exports.getMyChannelMember = getMyChannelMember;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _preferences = __webpack_require__(146);

var _channel_utils = __webpack_require__(209);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

var _users = __webpack_require__(78);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectChannel(channelId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                dispatch({
                                    type: _action_types.ChannelTypes.SELECT_CHANNEL,
                                    data: channelId
                                }, getState);
                            } catch (error) {
                                (0, _errors.logError)(error)(dispatch);
                            }

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function createChannel(channel, userId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var created, member, actions, _getState$entities$ch, channels, myMembers;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            created = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.createChannel(channel);

                        case 5:
                            created = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE,
                                error: _context2.t0
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE,
                                error: _context2.t0
                            }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', null);

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: _constants.General.CHANNEL_USER_ROLE + ' ' + _constants.General.CHANNEL_ADMIN_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            actions = [];
                            _getState$entities$ch = getState().entities.channels, channels = _getState$entities$ch.channels, myMembers = _getState$entities$ch.myMembers;


                            if (!channels[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: created });
                            }

                            if (!myMembers[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: member });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }])), getState);

                            return _context2.abrupt('return', created);

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function createDirectChannel(userId, otherUserId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member, preferences;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createDirectChannel([userId, otherUserId]);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: '' + _constants.General.CHANNEL_USER_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            preferences = [{ user_id: userId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: otherUserId, value: 'true' }];


                            (0, _preferences.savePreferences)(userId, preferences)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: created
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences
                            }, {
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', { data: created });

                        case 18:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function createGroupChannel(userIds) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var currentUserId, created, member, preferences;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            created = void 0;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _client.Client4.createGroupChannel(userIds);

                        case 6:
                            created = _context4.sent;
                            _context4.next = 14;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', { error: _context4.t0 });

                        case 14:
                            member = {
                                channel_id: created.id,
                                user_id: currentUserId,
                                roles: '' + _constants.General.CHANNEL_USER_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            preferences = [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, name: created.id, value: 'true' }];


                            (0, _preferences.savePreferences)(currentUserId, preferences)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: created
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences
                            }, {
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', { data: created });

                        case 19:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[3, 9]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function patchChannel(channelId, patch) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.patchChannel(channelId, patch);

                        case 5:
                            updated = _context5.sent;
                            _context5.next = 13;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[2, 8]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function updateChannel(channel) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.updateChannel(channel);

                        case 5:
                            updated = _context6.sent;
                            _context6.next = 13;
                            break;

                        case 8:
                            _context6.prev = 8;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[2, 8]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function updateChannelNotifyProps(userId, channelId, props) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var notifyProps, member, currentNotifyProps;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.NOTIFY_PROPS_REQUEST }, getState);

                            notifyProps = _extends({
                                user_id: userId,
                                channel_id: channelId
                            }, props);
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.updateChannelNotifyProps(notifyProps);

                        case 5:
                            _context7.next = 12;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.NOTIFY_PROPS_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', null);

                        case 12:
                            member = getState().entities.channels.myMembers[channelId] || {};
                            currentNotifyProps = member.notify_props || {};


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_PROPS,
                                data: {
                                    channel_id: channelId,
                                    notifyProps: _extends({}, currentNotifyProps, notifyProps)
                                }
                            }, {
                                type: _action_types.ChannelTypes.NOTIFY_PROPS_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[2, 7]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getChannel(channelId) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            data = void 0;
                            _context8.prev = 2;
                            _context8.next = 5;
                            return _client.Client4.getChannel(channelId);

                        case 5:
                            data = _context8.sent;
                            _context8.next = 13;
                            break;

                        case 8:
                            _context8.prev = 8;
                            _context8.t0 = _context8['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: data
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }]), getState);

                            return _context8.abrupt('return', data);

                        case 15:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[2, 8]]);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getChannelAndMyMember(channelId) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var channel, member;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            channel = void 0;
                            member = void 0;
                            _context9.prev = 3;
                            _context9.next = 6;
                            return _client.Client4.getChannel(channelId);

                        case 6:
                            channel = _context9.sent;
                            _context9.next = 9;
                            return _client.Client4.getMyChannelMember(channelId);

                        case 9:
                            member = _context9.sent;
                            _context9.next = 17;
                            break;

                        case 12:
                            _context9.prev = 12;
                            _context9.t0 = _context9['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', null);

                        case 17:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }]), getState);

                            return _context9.abrupt('return', { channel: channel, member: member });

                        case 19:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[3, 12]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function fetchMyChannelsAndMembers(teamId) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var channels, channelMembers, currentUserId;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CHANNELS_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            channels = void 0;
                            channelMembers = void 0;
                            _context10.prev = 3;
                            _context10.next = 6;
                            return _client.Client4.getMyChannels(teamId);

                        case 6:
                            channels = _context10.sent;
                            _context10.next = 14;
                            break;

                        case 9:
                            _context10.prev = 9;
                            _context10.t0 = _context10['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context10.t0 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', null);

                        case 14:
                            _context10.prev = 14;
                            _context10.next = 17;
                            return _client.Client4.getMyChannelMembers(teamId);

                        case 17:
                            channelMembers = _context10.sent;
                            _context10.next = 25;
                            break;

                        case 20:
                            _context10.prev = 20;
                            _context10.t1 = _context10['catch'](14);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t1, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context10.t1 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context10.t1 }, (0, _errors.logError)(_context10.t1)(dispatch)]), getState);
                            return _context10.abrupt('return', null);

                        case 25:
                            currentUserId = getState().entities.users.currentUserId;


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.CHANNELS_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers,
                                remove: (0, _channel_utils.getChannelsIdForTeam)(getState(), teamId),
                                currentUserId: currentUserId
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);

                            return _context10.abrupt('return', { channels: channels, members: channelMembers });

                        case 28:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[3, 9], [14, 20]]);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getMyChannelMembers(teamId) {
    var _this11 = this;

    return function () {
        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var channelMembers, channelMembersRequest, currentUserId;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context11.prev = 2;
                            channelMembersRequest = _client.Client4.getMyChannelMembers(teamId);
                            _context11.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context11.sent;
                            _context11.next = 14;
                            break;

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 14:
                            currentUserId = getState().entities.users.currentUserId;


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers,
                                remove: (0, _channel_utils.getChannelsIdForTeam)(getState(), teamId),
                                currentUserId: currentUserId
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', channelMembers);

                        case 17:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[2, 9]]);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getChannelMembers(channelId) {
    var _this12 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var channelMembers, channelMembersRequest, userIds;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context12.prev = 2;
                            channelMembersRequest = _client.Client4.getChannelMembers(channelId, page, perPage);
                            _context12.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context12.sent;
                            _context12.next = 14;
                            break;

                        case 9:
                            _context12.prev = 9;
                            _context12.t0 = _context12['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', null);

                        case 14:
                            userIds = channelMembers.map(function (cm) {
                                return cm.user_id;
                            });

                            (0, _users.getMissingProfilesByIds)(userIds)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: channelMembers
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);

                            return _context12.abrupt('return', channelMembers);

                        case 18:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[2, 9]]);
        }));

        return function (_x25, _x26) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function leaveChannel(channelId) {
    var _this13 = this;

    return function () {
        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var state, currentUserId, _state$entities$chann, channels, myMembers, channel, member;

            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            channel = channels[channelId];
                            member = myMembers[channelId];


                            dispatch({
                                type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                data: {
                                    id: channelId,
                                    user_id: currentUserId,
                                    team_id: channel.team_id,
                                    type: channel.type
                                },
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.removeFromChannel(currentUserId, channelId);
                                        },
                                        commit: { type: _action_types.ChannelTypes.LEAVE_CHANNEL },
                                        rollback: function rollback() {
                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                                data: channel
                                            }, {
                                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                                data: member
                                            }]));
                                        }
                                    }
                                }
                            });

                        case 6:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }));

        return function (_x27, _x28) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function joinChannel(userId, teamId, channelId, channelName) {
    var _this14 = this;

    return function () {
        var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            var member, channel;
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.JOIN_CHANNEL_REQUEST }, getState);

                            member = void 0;
                            channel = void 0;
                            _context14.prev = 3;

                            if (!channelId) {
                                _context14.next = 13;
                                break;
                            }

                            _context14.next = 7;
                            return _client.Client4.addToChannel(userId, channelId);

                        case 7:
                            member = _context14.sent;
                            _context14.next = 10;
                            return _client.Client4.getChannel(channelId);

                        case 10:
                            channel = _context14.sent;
                            _context14.next = 20;
                            break;

                        case 13:
                            if (!channelName) {
                                _context14.next = 20;
                                break;
                            }

                            _context14.next = 16;
                            return _client.Client4.getChannelByName(teamId, channelName);

                        case 16:
                            channel = _context14.sent;
                            _context14.next = 19;
                            return _client.Client4.addToChannel(userId, channel.id);

                        case 19:
                            member = _context14.sent;

                        case 20:
                            _context14.next = 27;
                            break;

                        case 22:
                            _context14.prev = 22;
                            _context14.t0 = _context14['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context14.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.JOIN_CHANNEL_FAILURE, error: _context14.t0 }, (0, _errors.logError)(_context14.t0)(dispatch)]), getState);
                            return _context14.abrupt('return', { error: _context14.t0 });

                        case 27:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.JOIN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context14.abrupt('return', { data: { channel: channel, member: member } });

                        case 29:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[3, 22]]);
        }));

        return function (_x29, _x30) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function deleteChannel(channelId) {
    var _this15 = this;

    return function () {
        var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var entities, _entities$channels, channels, currentChannelId, channel, defaultChannelId, teamId;

            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.DELETE_CHANNEL_REQUEST }, getState);

                            _context15.prev = 1;
                            _context15.next = 4;
                            return _client.Client4.deleteChannel(channelId);

                        case 4:
                            _context15.next = 11;
                            break;

                        case 6:
                            _context15.prev = 6;
                            _context15.t0 = _context15['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.DELETE_CHANNEL_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', { error: _context15.t0 });

                        case 11:
                            entities = getState().entities;
                            _entities$channels = entities.channels, channels = _entities$channels.channels, currentChannelId = _entities$channels.currentChannelId;

                            if (channelId === currentChannelId) {
                                channel = Object.keys(channels).filter(function (key) {
                                    return channels[key].name === _constants.General.DEFAULT_CHANNEL;
                                });
                                defaultChannelId = '';

                                if (channel.length) {
                                    defaultChannelId = channel[0];
                                }

                                dispatch({ type: _action_types.ChannelTypes.SELECT_CHANNEL, data: defaultChannelId }, getState);
                            }

                            teamId = channels[channelId] ? channels[channelId].team_id : '';


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED,
                                data: { id: channelId, team_id: teamId }
                            }, {
                                type: _action_types.ChannelTypes.DELETE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context15.abrupt('return', { data: true });

                        case 17:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[1, 6]]);
        }));

        return function (_x31, _x32) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function viewChannel(channelId) {
    var _this16 = this;

    var prevChannelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function () {
        var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            var actions, myMembers, member, prevMember;
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_REQUEST }, getState);

                            _context16.prev = 1;
                            _context16.next = 4;
                            return _client.Client4.viewMyChannel(channelId, prevChannelId);

                        case 4:
                            _context16.next = 11;
                            break;

                        case 6:
                            _context16.prev = 6;
                            _context16.t0 = _context16['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_FAILURE, error: _context16.t0 }, (0, _errors.logError)(_context16.t0)(dispatch)]), getState);
                            return _context16.abrupt('return', null);

                        case 11:
                            actions = [{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_SUCCESS }];
                            myMembers = getState().entities.channels.myMembers;
                            member = myMembers[channelId];

                            if (member) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, member, { last_viewed_at: new Date().getTime() })
                                });
                            }

                            prevMember = myMembers[prevChannelId];

                            if (prevMember) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: _extends({}, prevMember, { last_viewed_at: new Date().getTime() })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context16.abrupt('return', true);

                        case 19:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[1, 6]]);
        }));

        return function (_x34, _x35) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function getChannels(teamId) {
    var _this17 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context17.prev = 2;
                            _context17.next = 5;
                            return _client.Client4.getChannels(teamId, page, perPage);

                        case 5:
                            channels = _context17.sent;
                            _context17.next = 13;
                            break;

                        case 8:
                            _context17.prev = 8;
                            _context17.t0 = _context17['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', null);

                        case 13:
                            _context17.t1 = dispatch;
                            _context17.t2 = _reduxBatchedActions.batchActions;
                            _context17.t3 = _action_types.ChannelTypes.RECEIVED_CHANNELS;
                            _context17.t4 = teamId;
                            _context17.next = 19;
                            return channels;

                        case 19:
                            _context17.t5 = _context17.sent;
                            _context17.t6 = {
                                type: _context17.t3,
                                teamId: _context17.t4,
                                data: _context17.t5
                            };
                            _context17.t7 = {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            };
                            _context17.t8 = [_context17.t6, _context17.t7];
                            _context17.t9 = (0, _context17.t2)(_context17.t8);
                            _context17.t10 = getState;
                            (0, _context17.t1)(_context17.t9, _context17.t10);
                            return _context17.abrupt('return', channels);

                        case 27:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[2, 8]]);
        }));

        return function (_x38, _x39) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function searchChannels(teamId, term) {
    var _this18 = this;

    return function () {
        var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context18.prev = 2;
                            _context18.next = 5;
                            return _client.Client4.searchChannels(teamId, term);

                        case 5:
                            channels = _context18.sent;
                            _context18.next = 13;
                            break;

                        case 8:
                            _context18.prev = 8;
                            _context18.t0 = _context18['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context18.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context18.t0 }, (0, _errors.logError)(_context18.t0)(dispatch)]), getState);
                            return _context18.abrupt('return', null);

                        case 13:
                            _context18.t1 = dispatch;
                            _context18.t2 = _reduxBatchedActions.batchActions;
                            _context18.t3 = _action_types.ChannelTypes.RECEIVED_CHANNELS;
                            _context18.t4 = teamId;
                            _context18.next = 19;
                            return channels;

                        case 19:
                            _context18.t5 = _context18.sent;
                            _context18.t6 = {
                                type: _context18.t3,
                                teamId: _context18.t4,
                                data: _context18.t5
                            };
                            _context18.t7 = {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            };
                            _context18.t8 = [_context18.t6, _context18.t7];
                            _context18.t9 = (0, _context18.t2)(_context18.t8);
                            _context18.t10 = getState;
                            (0, _context18.t1)(_context18.t9, _context18.t10);
                            return _context18.abrupt('return', channels);

                        case 27:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18, [[2, 8]]);
        }));

        return function (_x40, _x41) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function getChannelStats(channelId) {
    var _this19 = this;

    return function () {
        var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            var stat;
            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_STATS_REQUEST }, getState);

                            stat = void 0;
                            _context19.prev = 2;
                            _context19.next = 5;
                            return _client.Client4.getChannelStats(channelId);

                        case 5:
                            stat = _context19.sent;
                            _context19.next = 13;
                            break;

                        case 8:
                            _context19.prev = 8;
                            _context19.t0 = _context19['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context19.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_STATS_FAILURE, error: _context19.t0 }, (0, _errors.logError)(_context19.t0)(dispatch)]), getState);
                            return _context19.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS,
                                data: stat
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_STATS_SUCCESS
                            }]), getState);

                            return _context19.abrupt('return', stat);

                        case 15:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19, [[2, 8]]);
        }));

        return function (_x42, _x43) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function addChannelMember(channelId, userId) {
    var _this20 = this;

    return function () {
        var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context20.prev = 2;
                            _context20.next = 5;
                            return _client.Client4.addToChannel(userId, channelId);

                        case 5:
                            member = _context20.sent;
                            _context20.next = 13;
                            break;

                        case 8:
                            _context20.prev = 8;
                            _context20.t0 = _context20['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context20.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context20.t0 }, (0, _errors.logError)(_context20.t0)(dispatch)]), getState);
                            return _context20.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                id: channelId
                            }], 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context20.abrupt('return', member);

                        case 15:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20, [[2, 8]]);
        }));

        return function (_x44, _x45) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function removeChannelMember(channelId, userId) {
    var _this21 = this;

    return function () {
        var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context21.prev = 1;
                            _context21.next = 4;
                            return _client.Client4.removeFromChannel(userId, channelId);

                        case 4:
                            _context21.next = 11;
                            break;

                        case 6:
                            _context21.prev = 6;
                            _context21.t0 = _context21['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context21.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_FAILURE, error: _context21.t0 }, (0, _errors.logError)(_context21.t0)(dispatch)]), getState);
                            return _context21.abrupt('return', null);

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_SUCCESS,
                                id: channelId
                            }], 'REMOVE_CHANNEL_MEMBER.BATCH'), getState);

                            return _context21.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this21, [[1, 6]]);
        }));

        return function (_x46, _x47) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function updateChannelMemberRoles(channelId, userId, roles) {
    var _this22 = this;

    return function () {
        var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            var actions, membersInChannel;
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context22.prev = 1;
                            _context22.next = 4;
                            return _client.Client4.updateChannelMemberRoles(channelId, userId, roles);

                        case 4:
                            _context22.next = 11;
                            break;

                        case 6:
                            _context22.prev = 6;
                            _context22.t0 = _context22['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context22.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_FAILURE, error: _context22.t0 }, (0, _errors.logError)(_context22.t0)(dispatch)]), getState);
                            return _context22.abrupt('return', null);

                        case 11:
                            actions = [{
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_SUCCESS
                            }];
                            membersInChannel = getState().entities.channels.membersInChannel[channelId];

                            if (membersInChannel && membersInChannel[userId]) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                    data: _extends({}, membersInChannel[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context22.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this22, [[1, 6]]);
        }));

        return function (_x48, _x49) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function updateChannelHeader(channelId, header) {
    var _this23 = this;

    return function () {
        var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            _client.Client4.trackEvent('action', 'action_channels_update_header', { channel_id: channelId });

                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_HEADER,
                                data: {
                                    channelId: channelId,
                                    header: header
                                }
                            }, getState);

                        case 2:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this23);
        }));

        return function (_x50, _x51) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function updateChannelPurpose(channelId, purpose) {
    var _this24 = this;

    return function () {
        var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            _client.Client4.trackEvent('action', 'action_channels_update_purpose', { channel_id: channelId });

                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_PURPOSE,
                                data: {
                                    channelId: channelId,
                                    purpose: purpose
                                }
                            }, getState);

                        case 2:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this24);
        }));

        return function (_x52, _x53) {
            return _ref24.apply(this, arguments);
        };
    }();
}

function markChannelAsRead(channelId, prevChannelId) {
    var _this25 = this;

    return function () {
        var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            var state, teamMembers, _state$entities$chann2, channels, myMembers, channel, channelMember, actions, totalMsgCount, teamMember, teamMsgCount, prevChannel, prevChannelMember, prevTotalMsgCount, _teamMsgCount;

            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            state = getState();
                            teamMembers = state.entities.teams.myMembers;
                            _state$entities$chann2 = state.entities.channels, channels = _state$entities$chann2.channels, myMembers = _state$entities$chann2.myMembers;
                            channel = channels[channelId];
                            channelMember = myMembers[channelId];
                            actions = [];
                            totalMsgCount = 0;
                            teamMember = void 0;

                            if (channel && channelMember) {
                                totalMsgCount = channel.total_msg_count;

                                if (channel.team_id) {
                                    teamMember = _extends({}, teamMembers[channel.team_id]);
                                    teamMember.mention_count = teamMember.mention_count - channelMember.mention_count;

                                    teamMsgCount = 0;

                                    if (totalMsgCount) {
                                        teamMsgCount = totalMsgCount - channelMember.msg_count;
                                    }
                                    teamMember.msg_count = teamMember.msg_count - teamMsgCount;
                                }

                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_LAST_VIEWED,
                                    data: {
                                        channel_id: channelId,
                                        last_viewed_at: channelMember.last_viewed_at,
                                        total_msg_count: totalMsgCount
                                    }
                                });
                            }

                            if (prevChannelId && channelId !== prevChannelId) {
                                prevChannel = channels[prevChannelId];
                                prevChannelMember = myMembers[prevChannelId];
                                prevTotalMsgCount = 0;

                                if (prevChannel && prevChannelMember) {
                                    prevTotalMsgCount = prevChannel.total_msg_count;

                                    if (prevChannel.team_id) {
                                        // if the channel is a GM or DM we don't have the teamMember
                                        if (!teamMember) {
                                            teamMember = _extends({}, teamMembers[prevChannel.team_id]);
                                        }
                                        teamMember.mention_count = teamMember.mention_count - prevChannelMember.mention_count;

                                        _teamMsgCount = 0;

                                        if (prevTotalMsgCount) {
                                            _teamMsgCount = prevTotalMsgCount - prevChannelMember.msg_count;
                                        }
                                        teamMember.msg_count = teamMember.msg_count - _teamMsgCount;
                                    }

                                    actions.push({
                                        type: _action_types.ChannelTypes.RECEIVED_LAST_VIEWED,
                                        data: {
                                            channel_id: prevChannelId,
                                            last_viewed_at: new Date().getTime(),
                                            total_msg_count: prevTotalMsgCount
                                        }
                                    });
                                }
                            }

                            if (teamMember) {
                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS,
                                    data: [teamMember]
                                });
                            }

                            if (actions.length) {
                                dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions)), getState);
                            }

                        case 12:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this25);
        }));

        return function (_x54, _x55) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function markChannelAsUnread(teamId, channelId, mentionsArray) {
    var _this26 = this;

    return function () {
        var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee26(dispatch, getState) {
            var state, _state$entities$chann3, channels, myMembers, teamMembers, currentUserId, actions, wasMentioned, mentions, channel, member, teamMember;

            return regeneratorRuntime.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            state = getState();
                            _state$entities$chann3 = state.entities.channels, channels = _state$entities$chann3.channels, myMembers = _state$entities$chann3.myMembers;
                            teamMembers = state.entities.teams.myMembers;
                            currentUserId = state.entities.users.currentUserId;
                            actions = [];
                            wasMentioned = false;

                            if (mentionsArray) {
                                mentions = JSON.parse(mentionsArray);

                                if (mentions.indexOf(currentUserId) !== -1) {
                                    wasMentioned = true;
                                }
                            }

                            // if we have the channel and the channel member in the store
                            if (channels[channelId] && myMembers[channelId]) {
                                channel = _extends({}, channels[channelId]);
                                member = _extends({}, myMembers[channelId]);


                                channel.total_msg_count++;
                                if (member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION) {
                                    member.msg_count++;
                                }

                                if (wasMentioned) {
                                    member.mention_count++;
                                }

                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: member
                                }, {
                                    type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                    data: channel
                                });
                            }

                            if (teamId) {
                                teamMember = _extends({}, teamMembers[teamId]);

                                teamMember.msg_count++;
                                if (wasMentioned) {
                                    teamMember.mention_count++;
                                }

                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS,
                                    data: [teamMember]
                                });
                            }

                            if (actions.length) {
                                dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
                            }

                        case 10:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, _this26);
        }));

        return function (_x56, _x57) {
            return _ref26.apply(this, arguments);
        };
    }();
}

function getChannelMembersByIds(channelId, userIds) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMembersByIds, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userIds);
}

function getChannelMember(channelId, userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userId);
}

function getMyChannelMember(channelId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId);
}

exports.default = {
    selectChannel: selectChannel,
    createChannel: createChannel,
    createDirectChannel: createDirectChannel,
    updateChannel: updateChannel,
    patchChannel: patchChannel,
    updateChannelNotifyProps: updateChannelNotifyProps,
    getChannel: getChannel,
    fetchMyChannelsAndMembers: fetchMyChannelsAndMembers,
    getMyChannelMembers: getMyChannelMembers,
    getChannelMembersByIds: getChannelMembersByIds,
    leaveChannel: leaveChannel,
    joinChannel: joinChannel,
    deleteChannel: deleteChannel,
    viewChannel: viewChannel,
    getChannels: getChannels,
    searchChannels: searchChannels,
    getChannelStats: getChannelStats,
    addChannelMember: addChannelMember,
    removeChannelMember: removeChannelMember,
    updateChannelHeader: updateChannelHeader,
    updateChannelPurpose: updateChannelPurpose,
    markChannelAsRead: markChannelAsRead,
    markChannelAsUnread: markChannelAsUnread
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(282)
  , defined = __webpack_require__(201);
module.exports = function(it){
  return IObject(defined(it));
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}



/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _es = __webpack_require__(49);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPrefix() {
    if (global.window.mm_current_user_id) {
        return global.window.mm_current_user_id + '_';
    }

    console.warn('BrowserStore tried to operate without user present'); //eslint-disable-line no-console

    return 'unknown_';
} // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BrowserStoreClass = function () {
    function BrowserStoreClass() {
        (0, _classCallCheck3.default)(this, BrowserStoreClass);

        this.hasCheckedLocalStorage = false;
        this.localStorageSupported = false;
    }

    (0, _createClass3.default)(BrowserStoreClass, [{
        key: 'setItem',
        value: function setItem(name, value) {
            this.setGlobalItem(getPrefix() + name, value);
        }
    }, {
        key: 'getItem',
        value: function getItem(name, defaultValue) {
            return this.getGlobalItem(getPrefix() + name, defaultValue);
        }
    }, {
        key: 'removeItem',
        value: function removeItem(name) {
            this.removeGlobalItem(getPrefix() + name);
        }
    }, {
        key: 'setGlobalItem',
        value: function setGlobalItem(name, value) {
            try {
                if (this.isLocalStorageSupported()) {
                    localStorage.setItem(name, (0, _stringify2.default)(value));
                } else {
                    sessionStorage.setItem(name, (0, _stringify2.default)(value));
                }
            } catch (err) {
                console.log('An error occurred while setting local storage, clearing all props'); //eslint-disable-line no-console
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload(true);
            }
        }
    }, {
        key: 'getGlobalItem',
        value: function getGlobalItem(name) {
            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var result = null;
            try {
                if (this.isLocalStorageSupported()) {
                    result = JSON.parse(localStorage.getItem(name));
                } else {
                    result = JSON.parse(sessionStorage.getItem(name));
                }
            } catch (err) {
                result = null;
            }

            if (!result) {
                result = defaultValue;
            }

            return result;
        }
    }, {
        key: 'removeGlobalItem',
        value: function removeGlobalItem(name) {
            if (this.isLocalStorageSupported()) {
                localStorage.removeItem(name);
            } else {
                sessionStorage.removeItem(name);
            }
        }
    }, {
        key: 'signalLogout',
        value: function signalLogout() {
            if (this.isLocalStorageSupported()) {
                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
                var logoutId = Utils.generateId();

                sessionStorage.setItem('__logout__', logoutId);
                localStorage.setItem('__logout__', logoutId);
                localStorage.removeItem('__logout__');
            }
        }
    }, {
        key: 'isSignallingLogout',
        value: function isSignallingLogout(logoutId) {
            return logoutId === sessionStorage.getItem('__logout__');
        }
    }, {
        key: 'signalLogin',
        value: function signalLogin() {
            if (this.isLocalStorageSupported()) {
                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
                var loginId = Utils.generateId();

                sessionStorage.setItem('__login__', loginId);
                localStorage.setItem('__login__', loginId);
                localStorage.removeItem('__login__');
            }
        }
    }, {
        key: 'isSignallingLogin',
        value: function isSignallingLogin(loginId) {
            return loginId === sessionStorage.getItem('__login__');
        }

        /**
         * Preforms the given action on each item that has the given prefix
         * Signature for action is action(key, value)
         */

    }, {
        key: 'actionOnGlobalItemsWithPrefix',
        value: function actionOnGlobalItemsWithPrefix(prefix, action) {
            var storage = sessionStorage;
            if (this.isLocalStorageSupported()) {
                storage = localStorage;
            }

            for (var key in storage) {
                if (key.lastIndexOf(prefix, 0) === 0) {
                    action(key, this.getGlobalItem(key));
                }
            }
        }
    }, {
        key: 'actionOnItemsWithPrefix',
        value: function actionOnItemsWithPrefix(prefix, action) {
            var globalPrefix = getPrefix();
            var globalPrefixiLen = globalPrefix.length;
            for (var key in sessionStorage) {
                if (key.lastIndexOf(globalPrefix + prefix, 0) === 0) {
                    var userkey = key.substring(globalPrefixiLen);
                    action(userkey, this.getGlobalItem(key));
                }
            }
        }
    }, {
        key: 'clear',
        value: function clear() {
            // persist some values through logout since they're independent of which user is logged in
            var logoutId = sessionStorage.getItem('__logout__');
            var landingPageSeen = this.hasSeenLandingPage();
            var selectedTeams = this.getItem('selected_teams');
            var recentEmojis = localStorage.getItem(_constants.Constants.RECENT_EMOJI_KEY);

            sessionStorage.clear();
            localStorage.clear();

            if (recentEmojis) {
                localStorage.setItem(_constants.Constants.RECENT_EMOJI_KEY, recentEmojis);
            }

            if (logoutId) {
                sessionStorage.setItem('__logout__', logoutId);
            }

            if (landingPageSeen) {
                this.setLandingPageSeen(landingPageSeen);
            }

            if (selectedTeams) {
                this.setItem('selected_teams', selectedTeams);
            }
        }
    }, {
        key: 'isLocalStorageSupported',
        value: function isLocalStorageSupported() {
            if (this.hasCheckedLocalStorage) {
                return this.localStorageSupported;
            }

            this.localStorageSupported = false;

            try {
                localStorage.setItem('__testLocal__', '1');
                if (localStorage.getItem('__testLocal__') === '1') {
                    this.localStorageSupported = true;
                }
                localStorage.removeItem('__testLocal__', '1');
            } catch (e) {
                this.localStorageSupported = false;
            }

            try {
                sessionStorage.setItem('__testSession__', '1');
                sessionStorage.removeItem('__testSession__');
            } catch (e) {
                // Session storage not usable, website is unusable
                _es.browserHistory.push('/error?type=' + _constants.ErrorPageTypes.LOCAL_STORAGE);
            }

            this.hasCheckedLocalStorage = true;

            return this.localStorageSupported;
        }
    }, {
        key: 'hasSeenLandingPage',
        value: function hasSeenLandingPage() {
            if (this.isLocalStorageSupported()) {
                return JSON.parse(sessionStorage.getItem('__landingPageSeen__'));
            }

            return true;
        }
    }, {
        key: 'setLandingPageSeen',
        value: function setLandingPageSeen(landingPageSeen) {
            return sessionStorage.setItem('__landingPageSeen__', (0, _stringify2.default)(landingPageSeen));
        }
    }]);
    return BrowserStoreClass;
}();

var BrowserStore = new BrowserStoreClass();
exports.default = BrowserStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var META     = __webpack_require__(106)('meta')
  , isObject = __webpack_require__(13)
  , has      = __webpack_require__(36)
  , setDesc  = __webpack_require__(19).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(9)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// optional / simple context binding
var aFunction = __webpack_require__(203);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var dP         = __webpack_require__(64)
  , createDesc = __webpack_require__(157);
module.exports = __webpack_require__(77) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var instances = __webpack_require__(46);

var createDOMEvent = function (name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return event;
};

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    // don't allow scroll past container
    value = i.contentHeight - i.containerHeight;
    if (value - element.scrollTop <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollTop;
    } else {
      element.scrollTop = value;
    }
    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    // don't allow scroll past container
    value = i.contentWidth - i.containerWidth;
    if (value - element.scrollLeft <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollLeft;
    } else {
      element.scrollLeft = value;
    }
    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
  }

  if (i.lastTop === undefined) {
    i.lastTop = element.scrollTop;
  }

  if (i.lastLeft === undefined) {
    i.lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < i.lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
  }

  if (axis === 'top' && value > i.lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
  }

  if (axis === 'left' && value < i.lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
  }

  if (axis === 'left' && value > i.lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
  }

  if (axis === 'top' && value !== i.lastTop) {
    element.scrollTop = i.lastTop = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
  }

  if (axis === 'left' && value !== i.lastLeft) {
    element.scrollLeft = i.lastLeft = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
  }

};



/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(170);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _map = __webpack_require__(165);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _preferences = __webpack_require__(105);

var Selectors = _interopRequireWildcard(_preferences);

var _action_types = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var PreferenceStore = function (_EventEmitter) {
    (0, _inherits3.default)(PreferenceStore, _EventEmitter);

    function PreferenceStore() {
        (0, _classCallCheck3.default)(this, PreferenceStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PreferenceStore.__proto__ || (0, _getPrototypeOf2.default)(PreferenceStore)).call(this));

        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload);

        _this.preferences = new _map2.default();
        _this.entities = Selectors.getMyPreferences(_redux_store2.default.getState());
        (0, _keys2.default)(_this.entities).forEach(function (key) {
            _this.preferences.set(key, _this.entities[key].value);
        });

        _redux_store2.default.subscribe(function () {
            var newEntities = Selectors.getMyPreferences(_redux_store2.default.getState());
            if (_this.entities !== newEntities) {
                _this.preferences = new _map2.default();
                (0, _keys2.default)(newEntities).forEach(function (key) {
                    _this.preferences.set(key, newEntities[key].value);
                });
                _this.emitChange();
            }

            _this.entities = newEntities;
        });

        _this.setMaxListeners(600);
        return _this;
    }

    (0, _createClass3.default)(PreferenceStore, [{
        key: 'getKey',
        value: function getKey(category, name) {
            return category + '--' + name;
        }
    }, {
        key: 'get',
        value: function get(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return this.preferences.get(key);
        }
    }, {
        key: 'getBool',
        value: function getBool(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return this.preferences.get(key) !== 'false';
        }
    }, {
        key: 'getInt',
        value: function getInt(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return parseInt(this.preferences.get(key), 10);
        }
    }, {
        key: 'getObject',
        value: function getObject(category, name) {
            var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var key = this.getKey(category, name);

            if (!this.preferences.has(key)) {
                return defaultValue;
            }

            return JSON.parse(this.preferences.get(key));
        }
    }, {
        key: 'getCategory',
        value: function getCategory(category) {
            var prefix = category + '--';

            var preferences = new _map2.default();

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.preferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    if (key.startsWith(prefix)) {
                        preferences.set(key.substring(prefix.length), value);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return preferences;
        }
    }, {
        key: 'setPreference',
        value: function setPreference(category, name, value) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                data: [{ category: category, name: name, value: value }]
            });
        }
    }, {
        key: 'setPreferencesFromServer',
        value: function setPreferencesFromServer(newPreferences) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                data: newPreferences
            });
        }
    }, {
        key: 'deletePreference',
        value: function deletePreference(preference) {
            _redux_store2.default.dispatch({
                type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                data: [preference]
            });
        }
    }, {
        key: 'emitChange',
        value: function emitChange(category) {
            this.emit(CHANGE_EVENT, category);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'getTheme',
        value: function getTheme(teamId) {
            if (this.preferences.has(this.getKey(_constants2.default.Preferences.CATEGORY_THEME, teamId))) {
                return this.getObject(_constants2.default.Preferences.CATEGORY_THEME, teamId);
            }

            if (this.preferences.has(this.getKey(_constants2.default.Preferences.CATEGORY_THEME, ''))) {
                return this.getObject(_constants2.default.Preferences.CATEGORY_THEME, '');
            }

            return (0, _assign2.default)({}, _constants2.default.THEMES.default);
        }
    }, {
        key: 'getLayout',
        value: function getLayout() {
            return this.getBool(_constants2.default.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants2.default.Preferences.CLASSIC_LAYOUT, false);
        }
    }, {
        key: 'handleEventPayload',
        value: function handleEventPayload(payload) {
            var action = payload.action;

            switch (action.type) {
                case ActionTypes.RECEIVED_PREFERENCE:
                    {
                        var preference = action.preference;
                        this.setPreference(preference.category, preference.name, preference.value);
                        this.emitChange(preference.category);
                        break;
                    }
                case ActionTypes.RECEIVED_PREFERENCES:
                    this.setPreferencesFromServer(action.preferences);
                    this.emitChange();
                    break;
                case ActionTypes.DELETED_PREFERENCES:
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(action.preferences), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _preference = _step2.value;

                            this.deletePreference(_preference);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    this.emitChange();
                    break;
                case ActionTypes.CLICK_CHANNEL:
                    this.setPreference(action.team_id, 'channel', action.id);
                    break;
            }
        }
    }]);
    return PreferenceStore;
}(_events2.default);

global.PreferenceStore = new PreferenceStore();
exports.default = global.PreferenceStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(943), __esModule: true };


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeammateNameDisplaySetting = undefined;
exports.getMyPreferences = getMyPreferences;
exports.get = get;
exports.getBool = getBool;
exports.makeGetCategory = makeGetCategory;
exports.getDirectShowPreferences = getDirectShowPreferences;
exports.getGroupShowPreferences = getGroupShowPreferences;

var _reselect = __webpack_require__(93);

var _constants = __webpack_require__(8);

var _general = __webpack_require__(174);

var _preference_utils = __webpack_require__(142);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getMyPreferences(state) {
    return state.entities.preferences.myPreferences;
}

function get(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var key = (0, _preference_utils.getPreferenceKey)(category, name);
    var prefs = getMyPreferences(state);

    if (!(key in prefs)) {
        return defaultValue;
    }

    return prefs[key].value;
}

function getBool(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var value = get(state, category, name, String(defaultValue));

    return value !== 'false';
}

function makeGetCategory() {
    return (0, _reselect.createSelector)(getMyPreferences, function (state, category) {
        return category;
    }, function (preferences, category) {
        var prefix = category + '--';
        var prefsInCategory = [];

        for (var key in preferences) {
            if (key.startsWith(prefix)) {
                prefsInCategory.push(preferences[key]);
            }
        }

        return prefsInCategory;
    });
}

var getDirectShowCategory = makeGetCategory();

function getDirectShowPreferences(state) {
    return getDirectShowCategory(state, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
}

var getGroupShowCategory = makeGetCategory();

function getGroupShowPreferences(state) {
    return getGroupShowCategory(state, _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW);
}

var getTeammateNameDisplaySetting = exports.getTeammateNameDisplaySetting = (0, _reselect.createSelector)(_general.getConfig, getMyPreferences, function (config, preferences) {
    if (config.TeammateNameDisplay) {
        return config.TeammateNameDisplay;
    }

    var key = (0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_DISPLAY_SETTINGS, _constants.Preferences.NAME_NAME_FORMAT);
    if (preferences[key]) {
        return preferences[key].value;
    }

    return _constants.General.TEAMMATE_NAME_DISPLAY.SHOW_USERNAME;
});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = false;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(312)
  , enumBugKeys = __webpack_require__(230);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toInteger = __webpack_require__(96)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(4)
  , dPs         = __webpack_require__(313)
  , enumBugKeys = __webpack_require__(230)
  , IE_PROTO    = __webpack_require__(229)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(227)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(232).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};



/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(312)
  , hiddenKeys = __webpack_require__(230).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global      = __webpack_require__(6)
  , dP          = __webpack_require__(19)
  , DESCRIPTORS = __webpack_require__(18)
  , SPECIES     = __webpack_require__(14)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var redefine = __webpack_require__(42);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



var func = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func;
var object = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object;
var arrayOf = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf;
var oneOfType = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType;
var element = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element;
var shape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape;
var string = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string;


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = oneOfType([func, string]);
var components = oneOfType([component, object]);
var route = oneOfType([object, element]);
var routes = oneOfType([route, arrayOf(route)]);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $at  = __webpack_require__(909)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(279)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(400)
  , enumBugKeys = __webpack_require__(285);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;



/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1060), __esModule: true };


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.savePreference = exports.loadMe = undefined;

var _slicedToArray2 = __webpack_require__(170);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _set = __webpack_require__(294);

var _set2 = _interopRequireDefault(_set);

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(171);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var loadMe = exports.loadMe = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return UserActions.loadMe()(dispatch, getState);

                    case 2:

                        if (window.mm_config) {
                            (0, _global_actions.loadCurrentLocale)();
                        }

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadMe() {
        return _ref.apply(this, arguments);
    };
}();

var savePreference = exports.savePreference = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(category, name, value) {
        var currentUserId;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        currentUserId = _user_store2.default.getCurrentId();
                        return _context2.abrupt('return', (0, _preferences2.savePreferences)(currentUserId, [{ user_id: currentUserId, category: category, name: name, value: value }])(dispatch, getState));

                    case 2:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function savePreference(_x13, _x14, _x15) {
        return _ref2.apply(this, arguments);
    };
}();

exports.loadMeAndConfig = loadMeAndConfig;
exports.switchFromLdapToEmail = switchFromLdapToEmail;
exports.loadProfilesAndTeamMembers = loadProfilesAndTeamMembers;
exports.loadProfilesAndTeamMembersAndChannelMembers = loadProfilesAndTeamMembersAndChannelMembers;
exports.loadTeamMembersForProfilesList = loadTeamMembersForProfilesList;
exports.loadProfilesWithoutTeam = loadProfilesWithoutTeam;
exports.loadChannelMembersForProfilesMap = loadChannelMembersForProfilesMap;
exports.loadTeamMembersAndChannelMembersForProfilesList = loadTeamMembersAndChannelMembersForProfilesList;
exports.loadChannelMembersForProfilesList = loadChannelMembersForProfilesList;
exports.loadNewDMIfNeeded = loadNewDMIfNeeded;
exports.loadNewGMIfNeeded = loadNewGMIfNeeded;
exports.loadProfilesForSidebar = loadProfilesForSidebar;
exports.loadProfilesForChannel = loadProfilesForChannel;
exports.loadProfilesForGM = loadProfilesForGM;
exports.loadProfilesForDM = loadProfilesForDM;
exports.loadProfilesForAllGM = loadProfilesForAllGM;
exports.loadProfilesForAllDM = loadProfilesForAllDM;
exports.saveTheme = saveTheme;
exports.searchUsers = searchUsers;
exports.searchUsersNotInTeam = searchUsersNotInTeam;
exports.autocompleteUsersInChannel = autocompleteUsersInChannel;
exports.autocompleteUsersInTeam = autocompleteUsersInTeam;
exports.autocompleteUsers = autocompleteUsers;
exports.updateUser = updateUser;
exports.generateMfaSecret = generateMfaSecret;
exports.updateUserNotifyProps = updateUserNotifyProps;
exports.updateUserRoles = updateUserRoles;
exports.activateMfa = activateMfa;
exports.deactivateMfa = deactivateMfa;
exports.checkMfa = checkMfa;
exports.updateActive = updateActive;
exports.updatePassword = updatePassword;
exports.verifyEmail = verifyEmail;
exports.resetPassword = resetPassword;
exports.resendVerification = resendVerification;
exports.loginById = loginById;
exports.createUserWithInvite = createUserWithInvite;
exports.webLogin = webLogin;
exports.webLoginByLdap = webLoginByLdap;
exports.getAuthorizedApps = getAuthorizedApps;
exports.deauthorizeOAuthApp = deauthorizeOAuthApp;
exports.uploadProfileImage = uploadProfileImage;
exports.uploadWatermarkImage = uploadWatermarkImage;
exports.uploadBackgroundImage = uploadBackgroundImage;
exports.loadProfiles = loadProfiles;
exports.getMissingProfiles = getMissingProfiles;
exports.loadMyTeamMembers = loadMyTeamMembers;
exports.savePreferences = savePreferences;
exports.autoResetStatus = autoResetStatus;
exports.sendPasswordResetEmail = sendPasswordResetEmail;
exports.blockSender = blockSender;
exports.checkBlockSender = checkBlockSender;
exports.unBlockSender = unBlockSender;
exports.getMyBlockSenders = getMyBlockSenders;
exports.inviteMeeting = inviteMeeting;
exports.incrementGoogleMapUsage = incrementGoogleMapUsage;

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _channel_actions = __webpack_require__(166);

var _global_actions = __webpack_require__(143);

var _status_actions = __webpack_require__(177);

var _utils = __webpack_require__(24);

var _constants = __webpack_require__(12);

var _es = __webpack_require__(49);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _users = __webpack_require__(88);

var Selectors = _interopRequireWildcard(_users);

var _preferences = __webpack_require__(105);

var _users2 = __webpack_require__(78);

var UserActions = _interopRequireWildcard(_users2);

var _users3 = __webpack_require__(482);

var _client = __webpack_require__(22);

var _general = __webpack_require__(296);

var _teams = __webpack_require__(144);

var _channels = __webpack_require__(89);

var _preferences2 = __webpack_require__(146);

var _constants2 = __webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function loadMeAndConfig(callback) {
    (0, _general.getClientConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState).then(function (config) {
        global.window.mm_config = config;

        if (global.window && global.window.analytics) {
            global.window.analytics.identify(global.window.mm_config.DiagnosticId, {}, {
                context: {
                    ip: '0.0.0.0'
                },
                page: {
                    path: '',
                    referrer: '',
                    search: '',
                    title: '',
                    url: ''
                },
                anonymousId: '00000000000000000000000000'
            });
        }

        _promise2.default.all([loadMe(), (0, _general.getLicenseConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState).then(function (license) {
            global.window.mm_license = license;
        })]).then(callback);
    });
}

function switchFromLdapToEmail(email, password, token, ldapPassword, success, error) {
    UserActions.switchLdapToEmail(ldapPassword, email, password, token)(dispatch, getState).then(function (data) {
        if (data) {
            if (data.follow_link) {
                (0, _global_actions.clientLogout)(data.follow_link);
            }
            if (success) {
                success(data);
            }
        } else if (data == null && error) {
            var serverError = getState().requests.users.switchLogin.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function loadProfilesAndTeamMembers(page, perPage) {
    var teamId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _team_store2.default.getCurrentId();
    var success = arguments[3];

    UserActions.getProfilesInTeam(teamId, page, perPage)(dispatch, getState).then(function (data) {
        loadTeamMembersForProfilesList(data, teamId, success);
        (0, _status_actions.loadStatusesForProfilesList)(data);
    });
}

function loadProfilesAndTeamMembersAndChannelMembers(page, perPage) {
    var teamId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _team_store2.default.getCurrentId();
    var channelId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _channel_store2.default.getCurrentId();
    var success = arguments[4];
    var error = arguments[5];

    UserActions.getProfilesInChannel(channelId, page, perPage)(dispatch, getState).then(function (data) {
        loadTeamMembersForProfilesList(data, teamId, function () {
            loadChannelMembersForProfilesList(data, channelId, success, error);
            (0, _status_actions.loadStatusesForProfilesList)(data);
        });
    });
}

function loadTeamMembersForProfilesList(profiles) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var i = 0; i < profiles.length; i++) {
        var pid = profiles[i].id;

        if (!_team_store2.default.hasActiveMemberInTeam(teamId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    loadTeamMembersForProfiles(list, teamId, success, error);
}

function loadProfilesWithoutTeam(page, perPage, success) {
    UserActions.getProfilesWithoutTeam(page, perPage)(dispatch, getState).then(function (data) {
        (0, _status_actions.loadStatusesForProfilesMap)(data);

        if (success) {
            success(data);
        }
    });
}

function loadTeamMembersForProfiles(userIds, teamId, success, error) {
    (0, _teams.getTeamMembersByIds)(teamId, userIds)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.teams.getTeamMembers.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function loadChannelMembersForProfilesMap(profiles) {
    var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _channel_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var pid in profiles) {
        if (!profiles.hasOwnProperty(pid)) {
            continue;
        }

        if (!_channel_store2.default.hasActiveMemberInChannel(channelId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    (0, _channel_actions.getChannelMembersForUserIds)(channelId, list, success, error);
}

function loadTeamMembersAndChannelMembersForProfilesList(profiles) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var channelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _channel_store2.default.getCurrentId();
    var success = arguments[3];
    var error = arguments[4];

    loadTeamMembersForProfilesList(profiles, teamId, function () {
        loadChannelMembersForProfilesList(profiles, channelId, success, error);
    }, error);
}

function loadChannelMembersForProfilesList(profiles) {
    var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _channel_store2.default.getCurrentId();
    var success = arguments[2];
    var error = arguments[3];

    var membersToLoad = {};
    for (var i = 0; i < profiles.length; i++) {
        var pid = profiles[i].id;

        if (!_channel_store2.default.hasActiveMemberInChannel(channelId, pid)) {
            membersToLoad[pid] = true;
        }
    }

    var list = (0, _keys2.default)(membersToLoad);
    if (list.length === 0) {
        if (success) {
            success({});
        }
        return;
    }

    (0, _channel_actions.getChannelMembersForUserIds)(channelId, list, success, error);
}

function populateDMChannelsWithProfiles(userIds) {
    var currentUserId = _user_store2.default.getCurrentId();

    for (var i = 0; i < userIds.length; i++) {
        var channelName = (0, _utils.getDirectChannelName)(currentUserId, userIds[i]);
        var channel = _channel_store2.default.getByName(channelName);
        var profilesInChannel = Selectors.getUserIdsInChannels(getState())[channel.id] || new _set2.default();
        if (channel && !profilesInChannel.has(userIds[i])) {
            _user_store2.default.saveUserIdInChannel(channel.id, userIds[i]);
        }
    }
}

function populateChannelWithProfiles(channelId, users) {
    for (var i = 0; i < users.length; i++) {
        _user_store2.default.saveUserIdInChannel(channelId, users[i].id);
    }
    _user_store2.default.emitInChannelChange();
}

function loadNewDMIfNeeded(channelId) {
    function checkPreference(channel) {
        var userId = (0, _utils.getUserIdFromChannelName)(channel);

        if (!userId) {
            return;
        }

        var pref = _preference_store2.default.getBool(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, false);
        if (pref === false) {
            _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, 'true');
            var currentUserId = _user_store2.default.getCurrentId();
            (0, _preferences2.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: userId, value: 'true' }])(dispatch, getState);
            loadProfilesForDM();
        }
    }

    var channel = _channel_store2.default.get(channelId);
    if (channel) {
        checkPreference(channel);
    } else {
        (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState).then(function (data) {
            if (data) {
                checkPreference(data.channel);
            }
        });
    }
}

function loadNewGMIfNeeded(channelId) {
    function checkPreference() {
        var pref = _preference_store2.default.getBool(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId, false);
        if (pref === false) {
            _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId, 'true');
            var currentUserId = _user_store2.default.getCurrentId();
            (0, _preferences2.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, name: channelId, value: 'true' }])(dispatch, getState);
            loadProfilesForGM();
        }
    }

    var channel = _channel_store2.default.get(channelId);
    if (channel) {
        checkPreference();
    } else {
        (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState).then(function () {
            checkPreference();
        });
    }
}

function loadProfilesForSidebar() {
    loadProfilesForDM();
    // loadProfilesForGM();

    loadProfilesForAllDM();
    loadProfilesForAllGM();
}

function loadProfilesForChannel(channelId) {
    UserActions.getProfilesInChannel(channelId, 0, _constants.Constants.MAX_USERS_IN_GM)(dispatch, getState).then(function (data) {
        populateChannelWithProfiles(channelId, data);
    });
}

function loadProfilesForGM() {
    var channels = _channel_store2.default.getChannels();
    var newPreferences = [];

    var _loop = function _loop(i) {
        var channel = channels[i];
        if (channel.type !== _constants.Constants.GM_CHANNEL) {
            return 'continue';
        }

        if (_user_store2.default.getProfileListInChannel(channel.id).length >= _constants.Constants.MIN_USERS_IN_GM) {
            return 'continue';
        }

        var isVisible = _preference_store2.default.getBool(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channel.id);

        if (!isVisible) {
            var member = _channel_store2.default.getMyMember(channel.id);
            if (!member || member.mention_count === 0 && member.msg_count >= channel.total_msg_count) {
                return 'continue';
            }

            newPreferences.push({
                user_id: _user_store2.default.getCurrentId(),
                category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW,
                name: channel.id,
                value: 'true'
            });
        }

        UserActions.getProfilesInChannel(channel.id, 0, _constants.Constants.MAX_USERS_IN_GM)(dispatch, getState).then(function (data) {
            populateChannelWithProfiles(channel.id, data);
        });
    };

    for (var i = 0; i < channels.length; i++) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
    }

    if (newPreferences.length > 0) {
        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences2.savePreferences)(currentUserId, newPreferences)(dispatch, getState);
    }
}

function loadProfilesForDM() {
    var channels = _channel_store2.default.getChannels();
    var newPreferences = [];
    var profilesToLoad = [];
    var profileIds = [];

    for (var i = 0; i < channels.length; i++) {
        var _channel = channels[i];
        if (_channel.type !== _constants.Constants.DM_CHANNEL) {
            continue;
        }

        var teammateId = _channel.name.replace(_user_store2.default.getCurrentId(), '').replace('__', '');
        var isVisible = _preference_store2.default.getBool(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, teammateId);

        if (!isVisible) {
            var member = _channel_store2.default.getMyMember(_channel.id);
            if (!member || member.mention_count === 0) {
                continue;
            }

            newPreferences.push({
                user_id: _user_store2.default.getCurrentId(),
                category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW,
                name: teammateId,
                value: 'true'
            });
        }

        if (!_user_store2.default.hasProfile(teammateId)) {
            profilesToLoad.push(teammateId);
        }
        profileIds.push(teammateId);
    }

    if (newPreferences.length > 0) {
        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences2.savePreferences)(currentUserId, newPreferences)(dispatch, getState);
    }

    if (profilesToLoad.length > 0) {
        UserActions.getProfilesByIds(profilesToLoad)(dispatch, getState).then(function () {
            populateDMChannelsWithProfiles(profileIds);
        });
    } else {
        populateDMChannelsWithProfiles(profileIds);
    }
}

function loadProfilesForAllGM() {
    var channels = _channel_store2.default.getChannels();
    var channelIds = [];
    var newPreferences = [];

    for (var i = 0; i < channels.length; i++) {
        var _channel2 = channels[i];
        if (_channel2.type !== _constants.Constants.GM_CHANNEL) {
            continue;
        }

        if (_user_store2.default.getProfileListInChannel(_channel2.id).length >= _constants.Constants.MIN_USERS_IN_GM) {
            continue;
        }

        var isVisible = _preference_store2.default.getBool(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, _channel2.id);

        if (!isVisible) {
            var member = _channel_store2.default.getMyMember(_channel2.id);

            if (member && (member.mention_count > 0 || member.msg_count < _channel2.total_msg_count)) {
                newPreferences.push({
                    user_id: _user_store2.default.getCurrentId(),
                    category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW,
                    name: _channel2.id,
                    value: 'true'
                });
            }
        }

        channelIds.push(_channel2.id);
    }

    if (channelIds.length > 0) {
        (0, _users3.getProfilesInChannels)(channelIds, 0, _constants.Constants.MAX_USERS_IN_GM)(dispatch, getState).then(function (data) {});
    }
    if (newPreferences.length > 0) {
        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences2.savePreferences)(currentUserId, newPreferences)(dispatch, getState);
    }
}

function loadProfilesForAllDM() {
    var channels = _channel_store2.default.getChannels();
    var profilesToLoad = [];
    for (var i = 0; i < channels.length; i++) {
        var _channel3 = channels[i];
        if (_channel3.type !== _constants.Constants.DM_CHANNEL) {
            continue;
        }

        var teammateId = _channel3.name.replace(_user_store2.default.getCurrentId(), '').replace('__', '');

        if (!_user_store2.default.hasProfile(teammateId)) {
            profilesToLoad.push(teammateId);
        }
    }

    if (profilesToLoad.length > 0) {
        UserActions.getProfilesByIds(profilesToLoad)(dispatch, getState).then(function () {});
        (0, _status_actions.loadStatusesByIds)(profilesToLoad);
    }
}

function saveTheme(teamId, theme, cb) {
    var currentUserId = _user_store2.default.getCurrentId();
    var preference = [{
        user_id: currentUserId,
        category: _constants.Preferences.CATEGORY_THEME,
        name: teamId,
        value: (0, _stringify2.default)(theme)
    }];

    (0, _preferences2.savePreferences)(currentUserId, preference)(dispatch, getState).then(function () {
        onThemeSaved(teamId, theme, cb);
    });
}

function onThemeSaved(teamId, theme, onSuccess) {
    var themePreferences = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_THEME);

    if (teamId !== '' && themePreferences.size > 1) {
        // no extra handling to be done to delete team-specific themes
        onSuccess();
        return;
    }

    var toDelete = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(themePreferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 1),
                name = _step$value[0];

            if (name === '' || name === teamId) {
                continue;
            }

            toDelete.push({
                user_id: _user_store2.default.getCurrentId(),
                category: _constants.Preferences.CATEGORY_THEME,
                name: name
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (toDelete.length > 0) {
        // we're saving a new global theme so delete any team-specific ones
        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences2.deletePreferences)(currentUserId, toDelete)(dispatch, getState);
    }

    onSuccess();
}

function searchUsers(term) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var success = arguments[3];

    UserActions.searchProfiles(term, (0, _extends3.default)({ team_id: teamId }, options))(dispatch, getState).then(function (data) {
        (0, _status_actions.loadStatusesForProfilesList)(data);

        if (success) {
            success(data);
        }
    });
}

function searchUsersNotInTeam(term) {
    var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getCurrentId();
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var success = arguments[3];

    UserActions.searchProfiles(term, (0, _extends3.default)({ not_in_team_id: teamId }, options))(dispatch, getState).then(function (data) {
        (0, _status_actions.loadStatusesForProfilesList)(data);

        if (success) {
            success(data);
        }
    });
}

function autocompleteUsersInChannel(username, channelId, success) {
    var channel = _channel_store2.default.get(channelId);
    var teamId = channel ? channel.team_id : _team_store2.default.getCurrentId();
    UserActions.autocompleteUsers(username, teamId, channelId)(dispatch, getState).then(function (data) {
        if (success) {
            success(data);
        }
    });
}

function autocompleteUsersInTeam(username, success) {
    UserActions.autocompleteUsers(username, _team_store2.default.getCurrentId())(dispatch, getState).then(function (data) {
        if (success) {
            success(data);
        }
    });
}

function autocompleteUsers(username, success) {
    UserActions.autocompleteUsers(username)(dispatch, getState).then(function (data) {
        if (success) {
            success(data);
        }
    });
}

function updateUser(user, type, success, error) {
    UserActions.updateMe(user)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateMe.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function generateMfaSecret(success, error) {
    UserActions.generateMfaSecret(_user_store2.default.getCurrentId())(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.generateMfaSecret.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateUserNotifyProps(props, success, error) {
    UserActions.updateMe({ notify_props: props })(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateMe.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateUserRoles(userId, newRoles, success, error) {
    UserActions.updateUserRoles(userId, newRoles)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function activateMfa(code, success, error) {
    UserActions.updateUserMfa(_user_store2.default.getCurrentId(), true, code)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function deactivateMfa(success, error) {
    UserActions.updateUserMfa(_user_store2.default.getCurrentId(), false)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function checkMfa(loginId, success, error) {
    if (global.window.mm_config.EnableMultifactorAuthentication !== 'true') {
        success(false);
        return;
    }

    UserActions.checkMfa(loginId)(dispatch, getState).then(function (data) {
        if (data != null && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.checkMfa.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateActive(userId, active, success, error) {
    UserActions.updateUserActive(userId, active)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updatePassword(userId, currentPassword, newPassword, success, error) {
    UserActions.updateUserPassword(userId, currentPassword, newPassword)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function verifyEmail(token, success, error) {
    UserActions.verifyUserEmail(token)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.verifyEmail.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function resetPassword(token, password, success, error) {
    UserActions.resetUserPassword(token, password)(dispatch, getState).then(function (data) {
        if (data) {
            _es.browserHistory.push('/login?extra=' + _constants.ActionTypes.PASSWORD_CHANGE);
            if (success) {
                success(data);
            }
        } else if (data == null && error) {
            var serverError = getState().requests.users.passwordReset.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function resendVerification(email, success, error) {
    UserActions.sendVerificationEmail(email)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.verifyEmail.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function loginById(userId, password, mfaToken, success, error) {
    UserActions.loginById(userId, password, mfaToken)(dispatch, getState).then(function (ok) {
        if (ok && success) {
            success();
        } else if (!ok && error) {
            var serverError = getState().requests.users.login.error;
            if (serverError.server_error_id === 'api.context.mfa_required.app_error') {
                if (success) {
                    success();
                }
                return;
            }
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function createUserWithInvite(user, data, emailHash, inviteId, success, error) {
    UserActions.createUser(user, data, emailHash, inviteId)(dispatch, getState).then(function (resp) {
        if (resp && success) {
            success(resp);
        } else if (resp == null && error) {
            var serverError = getState().requests.users.create.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function webLogin(loginId, password, token, success, error) {
    UserActions.login(loginId, password, token)(dispatch, getState).then(function (ok) {
        if (ok && success) {
            success();
        } else if (!ok && error) {
            var serverError = getState().requests.users.login.error;
            if (serverError.server_error_id === 'api.context.mfa_required.app_error') {
                if (success) {
                    success();
                }
                return;
            }
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function webLoginByLdap(loginId, password, token, success, error) {
    UserActions.login(loginId, password, token, true)(dispatch, getState).then(function (ok) {
        if (ok && success) {
            success();
        } else if (!ok && error) {
            var serverError = getState().requests.users.login.error;
            if (serverError.server_error_id === 'api.context.mfa_required.app_error') {
                if (success) {
                    success();
                }
                return;
            }
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function getAuthorizedApps(success, error) {
    _client.Client4.getAuthorizedOAuthApps(getState().entities.users.currentUserId).then(function (authorizedApps) {
        if (success) {
            success(authorizedApps);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function deauthorizeOAuthApp(appId, success, error) {
    _client.Client4.deauthorizeOAuthApp(appId).then(function () {
        if (success) {
            success();
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function uploadProfileImage(userPicture, success, error) {
    UserActions.uploadProfileImage(Selectors.getCurrentUserId(getState()), userPicture)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function uploadWatermarkImage(watermarkPicture, success, error) {
    (0, _users3.setWatermarkImage)(Selectors.getCurrentUserId(getState()), watermarkPicture)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function uploadBackgroundImage(picture, success, error) {
    (0, _users3.setBackgroundImage)(Selectors.getCurrentUserId(getState()), picture)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.updateUser.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function loadProfiles(page, perPage, success) {
    UserActions.getProfiles(page, perPage)(dispatch, getState).then(function (data) {
        if (success) {
            success(data);
        }
    });
}

function getMissingProfiles(ids) {
    var missingIds = ids.filter(function (id) {
        return !_user_store2.default.hasProfile(id);
    });

    if (missingIds.length === 0) {
        return;
    }

    UserActions.getProfilesByIds(missingIds)(dispatch, getState);
}

function loadMyTeamMembers() {
    (0, _teams.getMyTeamMembers)()(dispatch, getState).then(function () {
        (0, _teams.getMyTeamUnreads)()(dispatch, getState);
    });
}

function savePreferences(prefs, callback) {
    var currentUserId = _user_store2.default.getCurrentId();
    (0, _preferences2.savePreferences)(currentUserId, prefs)(dispatch, getState).then(function () {
        return callback();
    });
}

function autoResetStatus() {
    var _this = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(doDispatch, doGetState) {
            var currentUserId, userStatus, autoReset;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            _context3.next = 3;
                            return UserActions.getStatus(currentUserId)(doDispatch, doGetState);

                        case 3:
                            userStatus = _context3.sent;

                            if (userStatus.manual) {
                                _context3.next = 6;
                                break;
                            }

                            return _context3.abrupt('return', userStatus);

                        case 6:
                            autoReset = (0, _preferences.getBool)(getState(), _constants2.Preferences.CATEGORY_AUTO_RESET_MANUAL_STATUS, currentUserId, false);

                            if (!autoReset) {
                                _context3.next = 10;
                                break;
                            }

                            UserActions.setStatus({ user_id: currentUserId, status: 'online' })(doDispatch, doGetState);
                            return _context3.abrupt('return', userStatus);

                        case 10:
                            return _context3.abrupt('return', userStatus);

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function (_x16, _x17) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function sendPasswordResetEmail(email, success, error) {
    UserActions.sendPasswordResetEmail(email)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.users.passwordReset.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function blockSender(sender, success, error) {
    (0, _users3.blockUser)(sender)(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (error) {
            error(result);
        }
    });
}

function checkBlockSender(sender, success, error) {
    (0, _users3.checkBlockUser)(sender)(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (error) {
            error(result);
        }
    });
}

function unBlockSender(sender, success, error) {
    (0, _users3.unBlockUser)(sender)(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (error) {
            error(result);
        }
    });
}

function getMyBlockSenders(success, error) {
    (0, _users3.getBlockList)()(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (error) {
            error(result);
        }
    });
}

function inviteMeeting(category, invites, success, error) {
    (0, _users3.sendMeetingInviteToExternal)(category, invites)(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (result == null && error) {
            error();
        }
    });
}

function incrementGoogleMapUsage(success, error) {
    (0, _users3.incrementMapUsage)(_user_store2.default.getCurrentId())(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (error) {
            error(result);
        }
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1094), __esModule: true };


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Indicates that navigation was caused by a call to history.push.
 */
'use strict';

exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFullName = getFullName;
exports.displayUsername = displayUsername;
exports.rolesIncludePermission = rolesIncludePermission;
exports.isAdmin = isAdmin;
exports.isTeamAdmin = isTeamAdmin;
exports.isSystemAdmin = isSystemAdmin;
exports.isChannelAdmin = isChannelAdmin;
exports.hasUserAccessTokenRole = hasUserAccessTokenRole;
exports.hasPostAllRole = hasPostAllRole;
exports.hasPostAllPublicRole = hasPostAllPublicRole;
exports.profileListToMap = profileListToMap;
exports.removeUserFromList = removeUserFromList;
exports.filterProfilesMatchingTerm = filterProfilesMatchingTerm;
exports.sortByUsername = sortByUsername;

var _constants = __webpack_require__(8);

function getFullName(user) {
    if (user.first_name && user.last_name) {
        return user.first_name + ' ' + user.last_name;
    } else if (user.first_name) {
        return user.first_name;
    } else if (user.last_name) {
        return user.last_name;
    }

    return '';
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function displayUsername(user, teammateNameDisplay) {
    var name = '';

    if (user) {
        if (teammateNameDisplay === _constants.Preferences.DISPLAY_PREFER_NICKNAME) {
            name = user.nickname || getFullName(user);
        } else if (teammateNameDisplay === _constants.Preferences.DISPLAY_PREFER_FULL_NAME) {
            name = getFullName(user);
        }

        if (!name.trim().length) {
            name = user.username;
        }
    }

    return name;
}

function rolesIncludePermission(roles, permission) {
    var rolesArray = roles.split(' ');
    return rolesArray.includes(permission);
}

function isAdmin(roles) {
    return isSystemAdmin(roles) || isTeamAdmin(roles);
}

function isTeamAdmin(roles) {
    return rolesIncludePermission(roles, _constants.General.TEAM_ADMIN_ROLE);
}

function isSystemAdmin(roles) {
    return rolesIncludePermission(roles, _constants.General.SYSTEM_ADMIN_ROLE);
}

function isChannelAdmin(roles) {
    return rolesIncludePermission(roles, _constants.General.CHANNEL_ADMIN_ROLE);
}

function hasUserAccessTokenRole(roles) {
    return rolesIncludePermission(roles, _constants.General.SYSTEM_USER_ACCESS_TOKEN_ROLE);
}

function hasPostAllRole(roles) {
    return rolesIncludePermission(roles, _constants.General.SYSTEM_POST_ALL_ROLE);
}

function hasPostAllPublicRole(roles) {
    return rolesIncludePermission(roles, _constants.General.SYSTEM_POST_ALL_PUBLIC_ROLE);
}

function profileListToMap(profileList) {
    var profiles = {};
    for (var i = 0; i < profileList.length; i++) {
        profiles[profileList[i].id] = profileList[i];
    }
    return profiles;
}

function removeUserFromList(userId, list) {
    for (var i = list.length - 1; i >= 0; i--) {
        if (list[i].id === userId) {
            list.splice(i, 1);
            return list;
        }
    }

    return list;
}

function filterProfilesMatchingTerm(users, term) {
    var lowercasedTerm = term.toLowerCase();

    return users.filter(function (user) {
        if (!user) {
            return false;
        }
        var username = (user.username || '').toLowerCase();
        var first = (user.first_name || '').toLowerCase();
        var last = (user.last_name || '').toLowerCase();
        var full = first + ' ' + last;
        var email = (user.email || '').toLowerCase();
        var nickname = (user.nickname || '').toLowerCase();

        var emailPrefix = '';
        var emailDomain = '';
        var split = email.split('@');
        emailPrefix = split[0];
        if (split.length > 1) {
            emailDomain = split[1];
        }

        return username.startsWith(lowercasedTerm) || first.startsWith(lowercasedTerm) || last.startsWith(lowercasedTerm) || full.startsWith(lowercasedTerm) || nickname.startsWith(term) || emailPrefix.startsWith(term) || emailDomain.startsWith(term);
    });
}

function sortByUsername(a, b) {
    var nameA = a.username;
    var nameB = b.username;

    return nameA.localeCompare(nameB);
}


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(276);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(156);
util.inherits = __webpack_require__(147);
/*</replacement>*/

var Readable = __webpack_require__(391);
var Writable = __webpack_require__(307);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var def = __webpack_require__(19).f
  , has = __webpack_require__(36)
  , TAG = __webpack_require__(14)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1)
  , defined = __webpack_require__(61)
  , fails   = __webpack_require__(9)
  , spaces  = __webpack_require__(234)
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = {};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(14)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(41)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ctx         = __webpack_require__(81)
  , call        = __webpack_require__(323)
  , isArrayIter = __webpack_require__(244)
  , anObject    = __webpack_require__(4)
  , toLength    = __webpack_require__(26)
  , getIterFn   = __webpack_require__(246)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var ReactBaseClasses = __webpack_require__(339);
var ReactChildren = __webpack_require__(739);
var ReactDOMFactories = __webpack_require__(744);
var ReactElement = __webpack_require__(134);
var ReactPropTypes = __webpack_require__(745);
var ReactVersion = __webpack_require__(748);

var createReactClass = __webpack_require__(749);
var onlyChild = __webpack_require__(750);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var ReactCurrentOwner = __webpack_require__(84);

var warning = __webpack_require__(10);
var canDefineProperty = __webpack_require__(341);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(342);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactRef = __webpack_require__(759);
var ReactInstrumentation = __webpack_require__(63);

var warning = __webpack_require__(10);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMNamespaces = __webpack_require__(260);
var setInnerHTML = __webpack_require__(192);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(261);
var setTextContent = __webpack_require__(354);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern);

  var regexpSource = _compilePattern2.regexpSource;
  var paramNames = _compilePattern2.paramNames;
  var tokens = _compilePattern2.tokens;


  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames;
  var paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern);

  var tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = {};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(201);
module.exports = function(it){
  return Object(defined(it));
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(914);
var global        = __webpack_require__(38)
  , hide          = __webpack_require__(99)
  , Iterators     = __webpack_require__(139)
  , TO_STRING_TAG = __webpack_require__(32)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPreferenceKey = getPreferenceKey;
exports.getPreferencesByCategory = getPreferencesByCategory;
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getPreferenceKey(category, name) {
    return category + "--" + name;
}

function getPreferencesByCategory(myPreferences, category) {
    var prefix = category + "--";
    var preferences = new Map();
    Object.keys(myPreferences).forEach(function (key) {
        if (key.startsWith(prefix)) {
            preferences.set(key.substring(prefix.length), myPreferences[key]);
        }
    });

    return preferences;
}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doFocusPost = undefined;

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var doFocusPost = exports.doFocusPost = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(channelId, postId, data) {
        var member;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _app_dispatcher2.default.handleServerAction({
                            type: ActionTypes.RECEIVED_FOCUSED_POST,
                            postId: postId,
                            channelId: channelId,
                            post_list: data
                        });

                        dispatch({
                            type: ActionTypes.RECEIVED_FOCUSED_POST,
                            data: postId,
                            channelId: channelId
                        });

                        member = getState().entities.channels.myMembers[channelId];

                        if (!(member == null)) {
                            _context.next = 6;
                            break;
                        }

                        _context.next = 6;
                        return (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), null, channelId)(dispatch, getState);

                    case 6:

                        (0, _channel_actions.loadChannelsForCurrentUser)();
                        (0, _channels.getChannelStats)(channelId)(dispatch, getState);

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function doFocusPost(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();

exports.emitChannelClickEvent = emitChannelClickEvent;
exports.emitPostFocusEvent = emitPostFocusEvent;
exports.emitSwitchTeamForSearch = emitSwitchTeamForSearch;
exports.emitCloseRightHandSide = emitCloseRightHandSide;
exports.emitPostFocusRightHandSideFromSearch = emitPostFocusRightHandSideFromSearch;
exports.emitLeaveTeam = emitLeaveTeam;
exports.emitDeleteTeam = emitDeleteTeam;
exports.emitUserPostedEvent = emitUserPostedEvent;
exports.emitUserCommentedEvent = emitUserCommentedEvent;
exports.showAccountSettingsModal = showAccountSettingsModal;
exports.showTeamSettingsModal = showTeamSettingsModal;
exports.showShortcutsModal = showShortcutsModal;
exports.showDeletePostModal = showDeletePostModal;
exports.showChannelHeaderUpdateModal = showChannelHeaderUpdateModal;
exports.showChannelPurposeUpdateModal = showChannelPurposeUpdateModal;
exports.showChannelNameUpdateModal = showChannelNameUpdateModal;
exports.showGetPostLinkModal = showGetPostLinkModal;
exports.showForwardPostModal = showForwardPostModal;
exports.showForwardPostToDirectModal = showForwardPostToDirectModal;
exports.showGetPublicLinkModal = showGetPublicLinkModal;
exports.showGetTeamInviteLinkModal = showGetTeamInviteLinkModal;
exports.showInviteMemberModal = showInviteMemberModal;
exports.showInviteMeetingModal = showInviteMeetingModal;
exports.showLeaveTeamModal = showLeaveTeamModal;
exports.showDeleteTeamModal = showDeleteTeamModal;
exports.showLeavePrivateChannelModal = showLeavePrivateChannelModal;
exports.showSwitchTeamModal = showSwitchTeamModal;
exports.emitSuggestionPretextChanged = emitSuggestionPretextChanged;
exports.emitSelectNextSuggestion = emitSelectNextSuggestion;
exports.emitSelectPreviousSuggestion = emitSelectPreviousSuggestion;
exports.emitCompleteWordSuggestion = emitCompleteWordSuggestion;
exports.emitClearSuggestions = emitClearSuggestions;
exports.emitPreferenceChangedEvent = emitPreferenceChangedEvent;
exports.emitPreferencesChangedEvent = emitPreferencesChangedEvent;
exports.emitPreferencesDeletedEvent = emitPreferencesDeletedEvent;
exports.sendEphemeralPost = sendEphemeralPost;
exports.newLocalizationSelected = newLocalizationSelected;
exports.loadCurrentLocale = loadCurrentLocale;
exports.loadDefaultLocale = loadDefaultLocale;
exports.emitLocalUserTypingEvent = emitLocalUserTypingEvent;
exports.emitRemoteUserTypingEvent = emitRemoteUserTypingEvent;
exports.emitUserLoggedOutEvent = emitUserLoggedOutEvent;
exports.clientLogout = clientLogout;
exports.emitSearchMentionsEvent = emitSearchMentionsEvent;
exports.toggleSideBarAction = toggleSideBarAction;
exports.toggleSideBarRightMenuAction = toggleSideBarRightMenuAction;
exports.emitBrowserFocus = emitBrowserFocus;
exports.redirectUserToDefaultTeam = redirectUserToDefaultTeam;
exports.postListScrollChange = postListScrollChange;
exports.emitPopoverMentionKeyClick = emitPopoverMentionKeyClick;
exports.reloadIfServerVersionChanged = reloadIfServerVersionChanged;

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _error_store = __webpack_require__(216);

var _error_store2 = _interopRequireDefault(_error_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _search_store = __webpack_require__(303);

var _search_store2 = _interopRequireDefault(_search_store);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _post_actions = __webpack_require__(213);

var _user_actions = __webpack_require__(123);

var _channel_actions = __webpack_require__(166);

var _status_actions = __webpack_require__(177);

var _websocket_actions = __webpack_require__(223);

var WebsocketActions = _interopRequireWildcard(_websocket_actions);

var _diagnostics_actions = __webpack_require__(302);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _event_types = __webpack_require__(495);

var _event_types2 = _interopRequireDefault(_event_types);

var _web_websocket_client = __webpack_require__(305);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _team_utils = __webpack_require__(487);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _en = __webpack_require__(1102);

var _en2 = _interopRequireDefault(_en);

var _i18n = __webpack_require__(306);

var I18n = _interopRequireWildcard(_i18n);

var _es = __webpack_require__(49);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _client = __webpack_require__(22);

var _teams = __webpack_require__(144);

var _teams2 = __webpack_require__(481);

var _channels = __webpack_require__(89);

var _posts = __webpack_require__(217);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// Redux actions

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

function emitChannelClickEvent(channel) {
    var _this = this;

    function userVisitedFakeChannel(chan, success, fail) {
        var currentUserId = _user_store2.default.getCurrentId();
        var otherUserId = Utils.getUserIdFromChannelName(chan);
        (0, _channels.createDirectChannel)(currentUserId, otherUserId)(dispatch, getState).then(function (result) {
            var receivedChannel = result.data;

            if (receivedChannel) {
                success(receivedChannel);
            } else {
                fail();
            }
        });
    }
    function switchToChannel(chan) {
        var channelMember = _channel_store2.default.getMyMember(chan.id);
        var getMyChannelMemberPromise = (0, _channels.getMyChannelMember)(chan.id)(dispatch, getState);
        var oldChannelId = _channel_store2.default.getCurrentId();

        getMyChannelMemberPromise.then(function () {
            (0, _channels.getChannelStats)(chan.id)(dispatch, getState);
            (0, _channels.viewChannel)(chan.id, oldChannelId)(dispatch, getState);

            // Mark previous and next channel as read
            _channel_store2.default.resetCounts([chan.id, oldChannelId]);
            reloadIfServerVersionChanged();
        });

        // Subtract mentions for the team

        var _ref = _channel_store2.default.getUnreadCounts()[chan.id] || { msgs: 0, mentions: 0 },
            msgs = _ref.msgs,
            mentions = _ref.mentions;

        _team_store2.default.subtractUnread(chan.team_id, msgs, mentions);

        _browser_store2.default.setGlobalItem(chan.team_id, chan.id);

        (0, _user_actions.loadProfilesForSidebar)();

        _app_dispatcher2.default.handleViewAction({
            type: ActionTypes.CLICK_CHANNEL,
            name: chan.name,
            id: chan.id,
            team_id: chan.team_id,
            total_msg_count: chan.total_msg_count,
            channelMember: channelMember,
            prev: oldChannelId
        });
        /*
        if(chan.name==='town-square'){ //check whether first time visit this team or not
            var visited = PreferenceStore.getBool(Constants.Preferences.CATEGORY_VISITED,TeamStore.getCurrentId(),false);
            if(!visited){//first visit this team
                const visitedPreference = {
                        user_id: UserStore.getCurrentId(),
                        category: Constants.Preferences.CATEGORY_VISITED,
                        name: TeamStore.getCurrentId(),
                        value: 'true'
                    };
                    savePreferences([visitedPreference], () => {
                        showAccountSettingsModal('display','theme');
                    });
            }
        }*/
    }

    if (channel.fake) {
        userVisitedFakeChannel(channel, function (data) {
            switchToChannel(data);
        }, function () {
            _es.browserHistory.push('/' + _this.state.currentTeam.name);
        });
    } else {
        switchToChannel(channel);
    }
}

function emitPostFocusEvent(postId, onSuccess) {
    (0, _channel_actions.loadChannelsForCurrentUser)();
    (0, _posts.getPostThread)(postId)(dispatch, getState).then(function (data) {
        if (data) {
            var channelId = data.posts[data.order[0]].channel_id;
            doFocusPost(channelId, postId, data).then(function () {
                if (onSuccess) {
                    onSuccess();
                }
            });
        } else {
            var link = _team_store2.default.getCurrentTeamRelativeUrl() + '/channels/';
            var channel = _channel_store2.default.getCurrent();
            if (channel) {
                link += channel.name;
            } else {
                link += 'town-square';
            }

            var message = encodeURIComponent(Utils.localizeMessage('permalink.error.access', 'Permalink belongs to a deleted message or to a channel to which you do not have access.'));
            var title = encodeURIComponent(Utils.localizeMessage('permalink.error.title', 'Message Not Found'));

            _es.browserHistory.push('/error?message=' + message + '&title=' + title + '&link=' + encodeURIComponent(link));
        }
    });
}

function emitSwitchTeamForSearch() {
    dispatch({
        type: ActionTypes.SELECT_POST,
        postId: ''
    });
}

function emitCloseRightHandSide() {
    _search_store2.default.storeSearchResults(null, false, false, false, false, false);
    _search_store2.default.emitSearchChange();

    dispatch({
        type: ActionTypes.SELECT_POST,
        postId: ''
    });
}

function emitPostFocusRightHandSideFromSearch(post, isMentionSearch) {
    (0, _posts.getPostThread)(post.id)(dispatch, getState).then(function () {
        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_POST_SELECTED,
            postId: Utils.getRootId(post),
            from_search: _search_store2.default.getSearchTerm(),
            from_flagged_posts: _search_store2.default.getIsFlaggedPosts(),
            from_pinned_posts: _search_store2.default.getIsPinnedPosts()
        });

        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_SEARCH,
            results: null,
            is_mention_search: isMentionSearch
        });
    });
}

function emitLeaveTeam() {
    (0, _teams.removeUserFromTeam)(_team_store2.default.getCurrentId(), _user_store2.default.getCurrentId())(dispatch, getState);
}

function emitDeleteTeam() {
    (0, _teams2.deleteTeam)(_team_store2.default.getCurrentId())(dispatch, getState);
}

function emitUserPostedEvent(post) {
    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.CREATE_POST,
        post: post
    });
}

function emitUserCommentedEvent(post) {
    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.CREATE_COMMENT,
        post: post
    });
}

function showAccountSettingsModal(active_tab, active_section) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL,
        value: true,
        active_tab: active_tab,
        active_section: active_section
    });
}

function showTeamSettingsModal(active_tab, active_section) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_TEAM_SETTINGS_MODAL,
        value: true,
        active_tab: active_tab,
        active_section: active_section
    });
}

function showShortcutsModal() {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_SHORTCUTS_MODAL,
        value: true
    });
}

function showDeletePostModal(post) {
    var commentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_DELETE_POST_MODAL,
        value: true,
        post: post,
        commentCount: commentCount
    });
}

function showChannelHeaderUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showChannelPurposeUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showChannelNameUpdateModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL,
        value: true,
        channel: channel
    });
}

function showGetPostLinkModal(post) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_GET_POST_LINK_MODAL,
        value: true,
        post: post
    });
}

function showForwardPostModal(post) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_FORWARD_POST_MODAL,
        value: true,
        post: post
    });
}

function showForwardPostToDirectModal(post) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_FORWARD_POST_TO_DIRECT_MODAL,
        value: true,
        post: post
    });
}

function showGetPublicLinkModal(fileId) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL,
        value: true,
        fileId: fileId
    });
}

function showGetTeamInviteLinkModal() {
    _app_dispatcher2.default.handleViewAction({
        type: _constants2.default.ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL,
        value: true
    });
}

function showInviteMemberModal() {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_INVITE_MEMBER_MODAL,
        value: true
    });
}

function showInviteMeetingModal(to) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_INVITE_MEETING_MODAL,
        value: true,
        target: to
    });
}

function showLeaveTeamModal() {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_LEAVE_TEAM_MODAL,
        value: true
    });
}

function showDeleteTeamModal() {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_DELETE_TEAM_MODAL,
        value: true
    });
}

function showLeavePrivateChannelModal(channel) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL,
        value: channel
    });
}

function showSwitchTeamModal() {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.TOGGLE_QUICK_SWITCH_MODAL,
        value: 'team'
    });
}

function emitSuggestionPretextChanged(suggestionId, pretext) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.SUGGESTION_PRETEXT_CHANGED,
        id: suggestionId,
        pretext: pretext
    });
}

function emitSelectNextSuggestion(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.SUGGESTION_SELECT_NEXT,
        id: suggestionId
    });
}

function emitSelectPreviousSuggestion(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.SUGGESTION_SELECT_PREVIOUS,
        id: suggestionId
    });
}

function emitCompleteWordSuggestion(suggestionId) {
    var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _app_dispatcher2.default.handleViewAction({
        type: _constants2.default.ActionTypes.SUGGESTION_COMPLETE_WORD,
        id: suggestionId,
        term: term
    });
}

function emitClearSuggestions(suggestionId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants2.default.ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS,
        id: suggestionId
    });
}

function emitPreferenceChangedEvent(preference) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants2.default.ActionTypes.RECEIVED_PREFERENCE,
        preference: preference
    });

    if (addedNewDmUser(preference) || isGroupChannel(preference)) {
        (0, _user_actions.loadProfilesForSidebar)();
    }
}

function emitPreferencesChangedEvent(preferences) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants2.default.ActionTypes.RECEIVED_PREFERENCES,
        preferences: preferences
    });

    if (preferences.findIndex(addedNewDmUser) !== -1) {
        (0, _user_actions.loadProfilesForSidebar)();
    } else if (preferences.findIndex(isGroupChannel) !== -1) {
        (0, _user_actions.loadProfilesForSidebar)();
    }
}

function addedNewDmUser(preference) {
    return preference.category === _constants2.default.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW && preference.value === 'true';
}

function isGroupChannel(preference) {
    return preference.category === _constants2.default.Preferences.CATEGORY_GROUP_CHANNEL_SHOW && preference.value === 'true';
}

function emitPreferencesDeletedEvent(preferences) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants2.default.ActionTypes.DELETED_PREFERENCES,
        preferences: preferences
    });
}

function sendEphemeralPost(message, channelId, parentId) {
    var timestamp = Utils.getTimestamp();
    var post = {
        id: Utils.generateId(),
        user_id: '0',
        channel_id: channelId || _channel_store2.default.getCurrentId(),
        message: message,
        type: _constants2.default.PostTypes.EPHEMERAL,
        create_at: timestamp,
        update_at: timestamp,
        root_id: parentId,
        parent_id: parentId,
        props: {}
    };

    (0, _post_actions.handleNewPost)(post);
}

function newLocalizationSelected(locale) {
    var localeInfo = I18n.getLanguageInfo(locale);

    if (locale === 'en' || !localeInfo) {
        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_LOCALE,
            locale: locale,
            translations: _en2.default
        });
    } else {
        _client.Client4.getTranslations(localeInfo.url).then(function (data, res) {
            var translations = data;
            if (!data && res.text) {
                translations = JSON.parse(res.text);
            }
            _app_dispatcher2.default.handleServerAction({
                type: ActionTypes.RECEIVED_LOCALE,
                locale: locale,
                translations: translations
            });
        }).catch(function () {} //eslint-disable-line no-empty-function
        );
    }
}

function loadCurrentLocale() {
    var user = _user_store2.default.getCurrentUser();

    if (user && user.locale) {
        newLocalizationSelected(user.locale);
    } else {
        loadDefaultLocale();
    }
}

function loadDefaultLocale() {
    var locale = global.window.mm_config.DefaultClientLocale;
    var browserLocale = navigator.language; // navigator.language;
    var check = browserLocale.toLowerCase();
    if (check === 'zh-tw' || check === 'zh-hk' || check === 'zh' || check === 'zh-mo' || check === 'zh-hant') {
        browserLocale = 'zh-TW';
    } else if (check === 'zh-sg' || check === 'zh-cn' || check === 'zh-hans') {
        browserLocale = 'zh-CN';
    }

    if (I18n.getLanguageInfo(browserLocale)) {
        locale = browserLocale;
    }

    if (!I18n.getLanguageInfo(locale)) {
        locale = 'en';
    }

    return newLocalizationSelected(locale);
}

var lastTimeTypingSent = 0;
function emitLocalUserTypingEvent(channelId, parentId) {
    var t = Date.now();
    var membersInChannel = _channel_store2.default.getStats(channelId).member_count;

    if (t - lastTimeTypingSent > global.window.mm_config.TimeBetweenUserTypingUpdatesMilliseconds && membersInChannel < global.window.mm_config.MaxNotificationsPerChannel && global.window.mm_config.EnableUserTypingMessages === 'true') {
        _web_websocket_client2.default.userTyping(channelId, parentId);
        lastTimeTypingSent = t;
    }
}

function emitRemoteUserTypingEvent(channelId, userId, postParentId) {
    _app_dispatcher2.default.handleViewAction({
        type: _constants2.default.ActionTypes.USER_TYPING,
        channelId: channelId,
        userId: userId,
        postParentId: postParentId
    });
}

function emitUserLoggedOutEvent() {
    var redirectTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    var shouldSignalLogout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _client.Client4.logout().then(function () {
        if (shouldSignalLogout) {
            _browser_store2.default.signalLogout();
        }

        clientLogout(redirectTo);
    }).catch(function () {
        _es.browserHistory.push(redirectTo);
    });
}

function clientLogout() {
    var redirectTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';


    // +++ Alan - add facebook logout
    var callback = function callback() {
        _browser_store2.default.clear();
        _error_store2.default.clearLastError();
        _channel_store2.default.clear();
        (0, _status_actions.stopPeriodicStatusUpdates)();
        WebsocketActions.close();
        document.cookie = 'MMUSERID=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        window.location.href = redirectTo;
    };
    callback();
    //facebook logout
    // if(typeof FB !== "undefined") {
    //     FB.getLoginStatus(function(response) {
    //         if (response.status === 'connected' && response.authResponse.accessToken) {
    //             FB.logout(function(response){
    //                 // User us now logged out
    //                 callback();
    //             });
    //
    //         }else{
    //             callback();
    //         }
    //     });
    // } else {
    //     callback();
    // }
    // ---
}

function emitSearchMentionsEvent(user) {
    var terms = '';
    if (user.notify_props) {
        var termKeys = _user_store2.default.getMentionKeys(user.id);

        if (termKeys.indexOf('@channel') !== -1) {
            termKeys[termKeys.indexOf('@channel')] = '';
        }

        if (termKeys.indexOf('@all') !== -1) {
            termKeys[termKeys.indexOf('@all')] = '';
        }

        terms = termKeys.join(' ');
    }

    (0, _diagnostics_actions.trackEvent)('api', 'api_posts_search_mention');

    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.RECEIVED_SEARCH_TERM,
        term: terms,
        do_search: true,
        is_mention_search: true
    });
}

function toggleSideBarAction(visible) {
    if (!visible) {
        //Array of actions resolving in the closing of the sidebar
        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_SEARCH,
            results: null
        });

        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: ActionTypes.RECEIVED_POST_SELECTED,
            postId: null
        });
    }
}

function toggleSideBarRightMenuAction() {
    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.RECEIVED_SEARCH,
        results: null
    });

    _app_dispatcher2.default.handleServerAction({
        type: ActionTypes.RECEIVED_POST_SELECTED,
        postId: null
    });

    document.querySelector('.app__body .inner-wrap').classList.remove('move--right', 'move--left', 'move--left-small');
    document.querySelector('.app__body .sidebar--left').classList.remove('move--right');
    document.querySelector('.app__body .sidebar--right').classList.remove('move--left');
    document.querySelector('.app__body .sidebar--menu').classList.remove('move--left');
}

function emitBrowserFocus(focus) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.BROWSER_CHANGE_FOCUS,
        focus: focus
    });
}

function redirectUserToDefaultTeam() {
    var teams = _team_store2.default.getAll();
    var teamMembers = _team_store2.default.getMyTeamMembers();
    var teamId = _browser_store2.default.getGlobalItem('team');

    function redirect(teamName, channelName) {
        _es.browserHistory.push('/' + teamName + '/channels/' + channelName);
    }

    if (!teams[teamId] && teamMembers.length > 0) {
        var myTeams = [];
        for (var index in teamMembers) {
            if (teamMembers.hasOwnProperty(index)) {
                var teamMember = teamMembers[index];
                myTeams.push(teams[teamMember.team_id]);
            }
        }

        if (myTeams.length > 0) {
            myTeams = myTeams.sort(_team_utils.sortTeamsByDisplayName);
            teamId = myTeams[0].id;
        }
    }

    if (teams[teamId]) {
        var channelId = _browser_store2.default.getGlobalItem(teamId);
        var channel = _channel_store2.default.getChannelById(channelId);
        if (channel) {
            redirect(teams[teamId].name, channel);
        } else if (channelId) {
            (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState).then(function (data) {
                if (data) {
                    redirect(teams[teamId].name, data.channel.name);
                } else {
                    redirect(teams[teamId].name, 'town-square');
                }
            });
        } else {
            redirect(teams[teamId].name, 'town-square');
        }
    } else {
        _es.browserHistory.push('/select_team');
    }
}

function postListScrollChange() {
    var forceScrollToBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _app_dispatcher2.default.handleViewAction({
        type: _event_types2.default.POST_LIST_SCROLL_CHANGE,
        value: forceScrollToBottom
    });
}

function emitPopoverMentionKeyClick(isRHS, mentionKey) {
    _app_dispatcher2.default.handleViewAction({
        type: ActionTypes.POPOVER_MENTION_KEY_CLICK,
        isRHS: isRHS,
        mentionKey: mentionKey
    });
}

var serverVersion = '';

function reloadIfServerVersionChanged() {
    var newServerVersion = _client.Client4.getServerVersion();
    if (serverVersion && serverVersion !== newServerVersion) {
        console.log('Detected version update refreshing the page'); //eslint-disable-line no-console
        window.location.reload(true);
    }

    serverVersion = newServerVersion;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getProfilesAndStatusesForMembers = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(userIds, dispatch, getState) {
        var _getState$entities$us, currentUserId, profiles, statuses, profilesToLoad, statusesToLoad;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _getState$entities$us = getState().entities.users, currentUserId = _getState$entities$us.currentUserId, profiles = _getState$entities$us.profiles, statuses = _getState$entities$us.statuses;
                        profilesToLoad = [];
                        statusesToLoad = [];


                        userIds.forEach(function (userId) {
                            if (!profiles[userId] && !profilesToLoad.includes(userId) && userId !== currentUserId) {
                                profilesToLoad.push(userId);
                            }

                            if (!statuses[userId] && !statusesToLoad.includes(userId) && userId !== currentUserId) {
                                statusesToLoad.push(userId);
                            }
                        });

                        if (!profilesToLoad.length) {
                            _context.next = 7;
                            break;
                        }

                        _context.next = 7;
                        return (0, _users.getProfilesByIds)(profilesToLoad)(dispatch, getState);

                    case 7:
                        if (!statusesToLoad.length) {
                            _context.next = 10;
                            break;
                        }

                        _context.next = 10;
                        return (0, _users.getStatusesByIds)(statusesToLoad)(dispatch, getState);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getProfilesAndStatusesForMembers(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

exports.selectTeam = selectTeam;
exports.getMyTeams = getMyTeams;
exports.getMyTeamUnreads = getMyTeamUnreads;
exports.getTeam = getTeam;
exports.getTeams = getTeams;
exports.createTeam = createTeam;
exports.updateTeam = updateTeam;
exports.getMyTeamMembers = getMyTeamMembers;
exports.getTeamMember = getTeamMember;
exports.getTeamMembersByIds = getTeamMembersByIds;
exports.getTeamsForUser = getTeamsForUser;
exports.getTeamMembersForUser = getTeamMembersForUser;
exports.getTeamStats = getTeamStats;
exports.addUserToTeam = addUserToTeam;
exports.addUsersToTeam = addUsersToTeam;
exports.removeUserFromTeam = removeUserFromTeam;
exports.updateTeamMemberRoles = updateTeamMemberRoles;
exports.sendEmailInvitesToTeam = sendEmailInvitesToTeam;
exports.checkIfTeamExists = checkIfTeamExists;
exports.joinTeam = joinTeam;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

var _users = __webpack_require__(78);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectTeam(team) {
    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', dispatch({
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: team.id
                            }, getState));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getMyTeams() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeams, _action_types.TeamTypes.MY_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.MY_TEAMS_SUCCESS], _action_types.TeamTypes.MY_TEAMS_FAILURE);
}

function getMyTeamUnreads() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamUnreads, _action_types.TeamTypes.MY_TEAM_UNREADS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS, _action_types.TeamTypes.MY_TEAM_UNREADS_SUCCESS], _action_types.TeamTypes.MY_TEAM_UNREADS_FAILURE);
}

function getTeam(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeam, _action_types.TeamTypes.GET_TEAM_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM, _action_types.TeamTypes.GET_TEAM_SUCCESS], _action_types.TeamTypes.GET_TEAM_FAILURE, teamId);
}

function getTeams() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.TEAMS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getTeams, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, page, perPage);
}

function createTeam(team) {
    var _this2 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.CREATE_TEAM_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createTeam(team);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.CREATE_TEAM_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:
                            member = {
                                team_id: created.id,
                                user_id: getState().entities.users.currentUserId,
                                roles: _constants.General.TEAM_ADMIN_ROLE + ' ' + _constants.General.TEAM_USER_ROLE,
                                delete_at: 0,
                                msg_count: 0,
                                mention_count: 0
                            };


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.CREATED_TEAM,
                                data: created
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: created.id
                            }, {
                                type: _action_types.TeamTypes.CREATE_TEAM_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', created);

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function updateTeam(team) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateTeam, _action_types.TeamTypes.UPDATE_TEAM_REQUEST, [_action_types.TeamTypes.UPDATED_TEAM, _action_types.TeamTypes.UPDATE_TEAM_SUCCESS], _action_types.TeamTypes.UPDATE_TEAM_FAILURE, team);
}

function getMyTeamMembers() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamMembers, _action_types.TeamTypes.MY_TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS, _action_types.TeamTypes.MY_TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.MY_TEAM_MEMBERS_FAILURE);
}

function getTeamMember(teamId, userId) {
    var _this3 = this;

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            member = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.getTeamMember(teamId, userId);

                        case 5:
                            member = _context4.sent;

                            getProfilesAndStatusesForMembers([userId], dispatch, getState);
                            _context4.next = 14;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: [member]
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', member);

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3, [[2, 9]]);
        }));

        return function (_x10, _x11) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getTeamMembersByIds(teamId, userIds) {
    var _this4 = this;

    return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var members;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            members = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.getTeamMembersByIds(teamId, userIds);

                        case 5:
                            members = _context5.sent;

                            getProfilesAndStatusesForMembers(userIds, dispatch, getState);
                            _context5.next = 14;
                            break;

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', members);

                        case 16:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[2, 9]]);
        }));

        return function (_x12, _x13) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function getTeamsForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamsForUser, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, userId);
}

function getTeamMembersForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamMembersForUser, _action_types.TeamTypes.TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_MEMBERS, _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, userId);
}

function getTeamStats(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamStats, _action_types.TeamTypes.TEAM_STATS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_STATS, _action_types.TeamTypes.TEAM_STATS_SUCCESS], _action_types.TeamTypes.TEAM_STATS_FAILURE, teamId);
}

function addUserToTeam(teamId, userId) {
    var _this5 = this;

    return function () {
        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.addToTeam(teamId, userId);

                        case 5:
                            member = _context6.sent;
                            _context6.next = 13;
                            break;

                        case 8:
                            _context6.prev = 8;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this5, [[2, 8]]);
        }));

        return function (_x14, _x15) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function addUsersToTeam(teamId, userIds) {
    var _this6 = this;

    return function () {
        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var members, profiles;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.addUsersToTeam(teamId, userIds);

                        case 5:
                            members = _context7.sent;
                            _context7.next = 13;
                            break;

                        case 8:
                            _context7.prev = 8;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', null);

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', members);

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this6, [[2, 8]]);
        }));

        return function (_x16, _x17) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function removeUserFromTeam(teamId, userId) {
    var _this7 = this;

    return function () {
        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var member, actions, state, currentUserId, _state$entities$chann, channels, myMembers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, channelMember, channel;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_REQUEST }, getState);

                            _context8.prev = 1;
                            _context8.next = 4;
                            return _client.Client4.removeFromTeam(teamId, userId);

                        case 4:
                            _context8.next = 11;
                            break;

                        case 6:
                            _context8.prev = 6;
                            _context8.t0 = _context8['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_FAILURE, error: _context8.t0 }, (0, _errors.logError)(_context8.t0)(dispatch)]), getState);
                            return _context8.abrupt('return', null);

                        case 11:
                            member = {
                                team_id: teamId,
                                user_id: userId
                            };
                            actions = [{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_SUCCESS
                            }];
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;

                            if (!(currentUserId === userId)) {
                                _context8.next = 36;
                                break;
                            }

                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context8.prev = 20;


                            for (_iterator = Object.values(myMembers)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                channelMember = _step.value;
                                channel = channels[channelMember.channel_id];

                                if (channel && channel.team_id === teamId) {
                                    actions.push({
                                        type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                        data: channel
                                    });
                                }
                            }
                            _context8.next = 28;
                            break;

                        case 24:
                            _context8.prev = 24;
                            _context8.t1 = _context8['catch'](20);
                            _didIteratorError = true;
                            _iteratorError = _context8.t1;

                        case 28:
                            _context8.prev = 28;
                            _context8.prev = 29;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 31:
                            _context8.prev = 31;

                            if (!_didIteratorError) {
                                _context8.next = 34;
                                break;
                            }

                            throw _iteratorError;

                        case 34:
                            return _context8.finish(31);

                        case 35:
                            return _context8.finish(28);

                        case 36:

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context8.abrupt('return', true);

                        case 38:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this7, [[1, 6], [20, 24, 28, 36], [29,, 31, 35]]);
        }));

        return function (_x18, _x19) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function updateTeamMemberRoles(teamId, userId, roles) {
    var _this8 = this;

    return function () {
        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var actions, membersInTeam;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_REQUEST }, getState);

                            _context9.prev = 1;
                            _context9.next = 4;
                            return _client.Client4.updateTeamMemberRoles(teamId, userId, roles);

                        case 4:
                            _context9.next = 11;
                            break;

                        case 6:
                            _context9.prev = 6;
                            _context9.t0 = _context9['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', null);

                        case 11:
                            actions = [{
                                type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_SUCCESS
                            }];
                            membersInTeam = getState().entities.teams.membersInTeam[teamId];

                            if (membersInTeam && membersInTeam[userId]) {
                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                    data: _extends({}, membersInTeam[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context9.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this8, [[1, 6]]);
        }));

        return function (_x20, _x21) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function sendEmailInvitesToTeam(teamId, emails) {
    return (0, _helpers.bindClientFunc)(_client.Client4.sendEmailInvitesToTeam, _action_types.TeamTypes.TEAM_EMAIL_INVITE_REQUEST, [_action_types.TeamTypes.TEAM_EMAIL_INVITE_SUCCESS], _action_types.TeamTypes.TEAM_EMAIL_INVITE_FAILURE, teamId, emails);
}

function checkIfTeamExists(teamName) {
    var _this9 = this;

    return function () {
        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_REQUEST }, getState);

                            data = void 0;
                            _context10.prev = 2;
                            _context10.next = 5;
                            return _client.Client4.checkIfTeamExists(teamName);

                        case 5:
                            data = _context10.sent;
                            _context10.next = 13;
                            break;

                        case 8:
                            _context10.prev = 8;
                            _context10.t0 = _context10['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.GET_TEAM_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]));
                            return _context10.abrupt('return', null);

                        case 13:

                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_SUCCESS });

                            return _context10.abrupt('return', data.exists);

                        case 15:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this9, [[2, 8]]);
        }));

        return function (_x22, _x23) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function joinTeam(inviteId, teamId) {
    var _this10 = this;

    return function () {
        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var serverVersion;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.JOIN_TEAM_REQUEST }, getState);

                            serverVersion = getState().entities.general.serverVersion;
                            _context11.prev = 2;

                            if (!(serverVersion.charAt(0) === '3')) {
                                _context11.next = 8;
                                break;
                            }

                            _context11.next = 6;
                            return _client.Client.joinTeamFromInvite(inviteId);

                        case 6:
                            _context11.next = 10;
                            break;

                        case 8:
                            _context11.next = 10;
                            return _client.Client4.joinTeam(inviteId);

                        case 10:
                            _context11.next = 17;
                            break;

                        case 12:
                            _context11.prev = 12;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.JOIN_TEAM_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 17:
                            _context11.next = 19;
                            return getTeam(teamId)(dispatch, getState);

                        case 19:
                            _context11.next = 21;
                            return getMyTeamMembers()(dispatch, getState);

                        case 21:
                            getMyTeamUnreads()(dispatch, getState);

                            dispatch({ type: _action_types.TeamTypes.JOIN_TEAM_SUCCESS }, getState);
                            return _context11.abrupt('return', true);

                        case 24:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this10, [[2, 12]]);
        }));

        return function (_x24, _x25) {
            return _ref11.apply(this, arguments);
        };
    }();
}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomClient4 = undefined;

var _custom_client = __webpack_require__(1098);

var _custom_client2 = _interopRequireDefault(_custom_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomClient4 = new _custom_client2.default();

exports.CustomClient4 = CustomClient4;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deletePreferences = deletePreferences;
exports.getMyPreferences = getMyPreferences;
exports.makeDirectChannelVisibleIfNecessary = makeDirectChannelVisibleIfNecessary;
exports.makeGroupMessageVisibleIfNecessary = makeGroupMessageVisibleIfNecessary;
exports.savePreferences = savePreferences;

var _client = __webpack_require__(22);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _preferences = __webpack_require__(105);

var _users = __webpack_require__(88);

var _preference_utils = __webpack_require__(142);

var _helpers = __webpack_require__(67);

var _users2 = __webpack_require__(78);

var _channels = __webpack_require__(89);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function deletePreferences(userId, preferences) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, myPreferences, currentPreferences;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentPreferences = preferences.map(function (pref) {
                                return myPreferences[(0, _preference_utils.getPreferenceKey)(pref.category, pref.name)];
                            });


                            dispatch({
                                type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                                data: preferences,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.deletePreferences(userId, preferences);
                                        },
                                        commit: {
                                            type: _action_types.PreferenceTypes.DELETED_PREFERENCES
                                        },
                                        rollback: {
                                            type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                            data: currentPreferences
                                        }
                                    }
                                }
                            });

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getMyPreferences() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyPreferences, _action_types.PreferenceTypes.MY_PREFERENCES_REQUEST, [_action_types.PreferenceTypes.RECEIVED_ALL_PREFERENCES, _action_types.PreferenceTypes.MY_PREFERENCES_SUCCESS], _action_types.PreferenceTypes.MY_PREFERENCES_FAILURE);
}

function makeDirectChannelVisibleIfNecessary(otherUserId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, myPreferences, currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentUserId = (0, _users.getCurrentUserId)(state);
                            preference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, otherUserId)];


                            if (!preference || preference.value === 'false') {
                                preference = {
                                    user_id: currentUserId,
                                    category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW,
                                    name: otherUserId,
                                    value: 'true'
                                };
                                (0, _users2.getProfilesByIds)([otherUserId])(dispatch, getState);
                                savePreferences(currentUserId, [preference])(dispatch, getState);
                            }

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function makeGroupMessageVisibleIfNecessary(channelId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var state, myPreferences, currentUserId, channels, preference;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            myPreferences = (0, _preferences.getMyPreferences)(state);
                            currentUserId = (0, _users.getCurrentUserId)(state);
                            channels = state.entities.channels.channels;
                            preference = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId)];


                            if (!preference || preference.value === 'false') {
                                preference = {
                                    user_id: currentUserId,
                                    category: _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW,
                                    name: channelId,
                                    value: 'true'
                                };

                                if (channels[channelId]) {
                                    (0, _channels.getMyChannelMember)(channelId)(dispatch, getState);
                                } else {
                                    (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);
                                }

                                (0, _users2.getProfilesInChannel)(channelId, 0)(dispatch, getState);
                                savePreferences(currentUserId, [preference])(dispatch, getState);
                            }

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function savePreferences(userId, preferences) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.savePreferences(userId, preferences);
                                        },
                                        commit: {
                                            type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES
                                        },
                                        rollback: {
                                            type: _action_types.PreferenceTypes.DELETED_PREFERENCES,
                                            data: preferences
                                        }
                                    }
                                }
                            });

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7) {
            return _ref4.apply(this, arguments);
        };
    }();
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}



/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(60);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(60)
  , TAG = __webpack_require__(14)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
'use strict';

/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(153);
var EventPluginUtils = __webpack_require__(254);

var accumulateInto = __webpack_require__(346);
var forEachAccumulated = __webpack_require__(347);
var warning = __webpack_require__(10);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var EventPluginRegistry = __webpack_require__(253);
var EventPluginUtils = __webpack_require__(254);
var ReactErrorUtils = __webpack_require__(255);

var accumulateInto = __webpack_require__(346);
var forEachAccumulated = __webpack_require__(347);
var invariant = __webpack_require__(3);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

var getEventTarget = __webpack_require__(256);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var def = __webpack_require__(64).f
  , has = __webpack_require__(119)
  , TAG = __webpack_require__(32)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REHYDRATE; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REHYDRATE; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(828)();
}



/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(865);

var _runTransitionHook = __webpack_require__(272);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(116);

var _deprecate = __webpack_require__(273);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1069), __esModule: true };


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteChannel = exports.joinChannel = undefined;

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var joinChannel = exports.joinChannel = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(channel, success, error) {
        var _ref2, data, serverError;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return ChannelActions.joinChannel(_user_store2.default.getCurrentId(), null, channel.id)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        serverError = _ref2.serverError;


                        if (data && success) {
                            success(data);
                        } else if (data == null && error) {
                            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function joinChannel(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var deleteChannel = exports.deleteChannel = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(channelId, success, error) {
        var _ref4, data, serverError;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return ChannelActions.deleteChannel(channelId)(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        serverError = _ref4.serverError;


                        if (data && success) {
                            success(data);
                        } else if (serverError && error) {
                            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function deleteChannel(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();

exports.goToChannel = goToChannel;
exports.executeCommand = executeCommand;
exports.setChannelAsRead = setChannelAsRead;
exports.addUserToChannel = addUserToChannel;
exports.removeUserFromChannel = removeUserFromChannel;
exports.makeUserChannelAdmin = makeUserChannelAdmin;
exports.makeUserChannelMember = makeUserChannelMember;
exports.makeUserChannelGuest = makeUserChannelGuest;
exports.openDirectChannelToUser = openDirectChannelToUser;
exports.openGroupChannelToUsers = openGroupChannelToUsers;
exports.markFavorite = markFavorite;
exports.unmarkFavorite = unmarkFavorite;
exports.loadChannelsForCurrentUser = loadChannelsForCurrentUser;
exports.loadAllChannelsForCurrentUser = loadAllChannelsForCurrentUser;
exports.loadDMsAndGMsForUnreads = loadDMsAndGMsForUnreads;
exports.updateChannel = updateChannel;
exports.searchMoreChannels = searchMoreChannels;
exports.searchAllChannels = searchAllChannels;
exports.autocompleteChannels = autocompleteChannels;
exports.updateChannelNotifyProps = updateChannelNotifyProps;
exports.createChannel = createChannel;
exports.updateChannelPurpose = updateChannelPurpose;
exports.updateChannelHeader = updateChannelHeader;
exports.getChannelMembersForUserIds = getChannelMembersForUserIds;
exports.leaveChannel = leaveChannel;

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _channel_utils = __webpack_require__(214);

var ChannelUtils = _interopRequireWildcard(_channel_utils);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _global_actions = __webpack_require__(143);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _post_actions = __webpack_require__(213);

var PostActions = _interopRequireWildcard(_post_actions);

var _user_actions = __webpack_require__(123);

var _diagnostics_actions = __webpack_require__(302);

var _user_agent = __webpack_require__(167);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(12);

var _es = __webpack_require__(49);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _channels = __webpack_require__(89);

var ChannelActions = _interopRequireWildcard(_channels);

var _channels2 = __webpack_require__(176);

var _preferences = __webpack_require__(146);

var _client = __webpack_require__(22);

var _channels3 = __webpack_require__(175);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

function goToChannel(channel) {
    if (channel.fake) {
        var user = _user_store2.default.getProfileByUsername(channel.display_name);
        if (!user) {
            return;
        }
        openDirectChannelToUser(user.id, function () {
            _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
        }, null);
    } else {
        _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
    }
}

function executeCommand(message, args, success, error) {
    var msg = message;

    var cmdLength = msg.indexOf(' ');
    if (cmdLength < 0) {
        cmdLength = msg.length;
    }
    var cmd = msg.substring(0, cmdLength).toLowerCase();
    msg = cmd + msg.substring(cmdLength, msg.length);

    switch (cmd) {
        case '/search':
            PostActions.searchForTerm(msg.substring(cmdLength + 1, msg.length));
            return;
        case '/shortcuts':
            if (UserAgent.isMobile()) {
                var err = { message: Utils.localizeMessage('create_post.shortcutsNotSupported', 'Keyboard shortcuts are not supported on your device') };
                error(err);
                return;
            }
            GlobalActions.showShortcutsModal();
            return;

            break;
        case '/leave':
            {
                // /leave command not supported in reply threads.
                if (args.channel_id && (args.root_id || args.parent_id)) {
                    GlobalActions.sendEphemeralPost('/leave is not supported in reply threads. Use it in the center channel instead.', args.channel_id, args.parent_id);
                    return;
                }
                var channel = _channel_store2.default.getCurrent();
                if (channel.type === _constants.Constants.PRIVATE_CHANNEL) {
                    GlobalActions.showLeavePrivateChannelModal(channel);
                    return;
                } else if (channel.type === _constants.Constants.DM_CHANNEL || channel.type === _constants.Constants.GM_CHANNEL) {
                    var name = void 0;
                    var category = void 0;
                    if (channel.type === _constants.Constants.DM_CHANNEL) {
                        name = Utils.getUserIdFromChannelName(channel);
                        category = _constants.Constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW;
                    } else {
                        name = channel.id;
                        category = _constants.Constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW;
                    }
                    var currentUserId = _user_store2.default.getCurrentId();
                    (0, _preferences.savePreferences)(currentUserId, [{ category: category, name: name, user_id: currentUserId, value: 'false' }])(dispatch, getState);
                    if (ChannelUtils.isFavoriteChannel(channel)) {
                        unmarkFavorite(channel.id);
                    }
                    _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/town-square');
                    return;
                }
                break;
            }
        case '/settings':
            GlobalActions.showAccountSettingsModal();
            return;
    }

    _client.Client4.executeCommand(msg, args).then(success).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function setChannelAsRead(channelIdParam) {
    var channelId = channelIdParam || _channel_store2.default.getCurrentId();
    ChannelActions.viewChannel(channelId)(dispatch, getState);
    _channel_store2.default.resetCounts([channelId]);
    _channel_store2.default.emitChange();
    if (channelId === _channel_store2.default.getCurrentId()) {
        _channel_store2.default.emitLastViewed(Number.MAX_VALUE, false);
    }
}

function addUserToChannel(channelId, userId, success, error) {
    ChannelActions.addChannelMember(channelId, userId)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.addChannelMember.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function removeUserFromChannel(channelId, userId, success, error) {
    ChannelActions.removeChannelMember(channelId, userId)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.removeChannelMember.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function makeUserChannelAdmin(channelId, userId, success, error) {
    ChannelActions.updateChannelMemberRoles(channelId, userId, 'channel_user channel_admin')(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannelMember.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function makeUserChannelMember(channelId, userId, success, error) {
    ChannelActions.updateChannelMemberRoles(channelId, userId, 'channel_user')(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannelMember.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function makeUserChannelGuest(channelId, userId, success, error) {
    ChannelActions.updateChannelMemberRoles(channelId, userId, 'channel_guest')(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannelMember.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function openDirectChannelToUser(userId, success, error) {
    var channelName = Utils.getDirectChannelName(_user_store2.default.getCurrentId(), userId);
    var channel = _channel_store2.default.getByName(channelName);

    if (channel) {
        (0, _diagnostics_actions.trackEvent)('api', 'api_channels_join_direct');
        _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, userId, 'true');
        (0, _user_actions.loadProfilesForSidebar)();

        var currentUserId = _user_store2.default.getCurrentId();
        (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: userId, value: 'true' }])(dispatch, getState);

        if (success) {
            success(channel, true);
        }

        return;
    }

    ChannelActions.createDirectChannel(_user_store2.default.getCurrentId(), userId)(dispatch, getState).then(function (result) {
        (0, _user_actions.loadProfilesForSidebar)();
        if (result.data && success) {
            success(result.data, false);
        } else if (result.error && error) {
            error((0, _extends3.default)({ id: result.error.server_error_id }, result.error));
        }
    });
}

function openGroupChannelToUsers(userIds, success, error) {
    ChannelActions.createGroupChannel(userIds)(dispatch, getState).then(function (result) {
        (0, _user_actions.loadProfilesForSidebar)();
        if (result.data && success) {
            success(result.data, false);
        } else if (result.error && error) {
            _es.browserHistory.push(_team_store2.default.getCurrentTeamUrl());
            error((0, _extends3.default)({ id: result.error.server_error_id }, result.error));
        }
    });
}

function markFavorite(channelId) {
    (0, _diagnostics_actions.trackEvent)('api', 'api_channels_favorited');
    var currentUserId = _user_store2.default.getCurrentId();
    (0, _preferences.savePreferences)(currentUserId, [{ user_id: currentUserId, category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL, name: channelId, value: 'true' }])(dispatch, getState);
}

function unmarkFavorite(channelId) {
    (0, _diagnostics_actions.trackEvent)('api', 'api_channels_unfavorited');
    var currentUserId = _user_store2.default.getCurrentId();

    var pref = {
        user_id: currentUserId,
        category: _constants.Preferences.CATEGORY_FAVORITE_CHANNEL,
        name: channelId
    };

    (0, _preferences.deletePreferences)(currentUserId, [pref])(dispatch, getState);
}

function loadChannelsForCurrentUser() {
    ChannelActions.fetchMyChannelsAndMembers(_team_store2.default.getCurrentId())(dispatch, getState).then(function () {
        loadDMsAndGMsForUnreads();
    });
}

function loadAllChannelsForCurrentUser() {
    (0, _channels2.fetchAllMyChannelsAndMembers)()(dispatch, getState).then(function () {
        loadDMsAndGMsForUnreads();
    });
}

function loadDMsAndGMsForUnreads() {
    var unreads = _channel_store2.default.getUnreadCounts();
    for (var id in unreads) {
        if (!unreads.hasOwnProperty(id)) {
            continue;
        }

        if (unreads[id].msgs > 0 || unreads[id].mentions > 0) {
            var channel = _channel_store2.default.get(id);
            if (channel && channel.type === _constants.Constants.DM_CHANNEL) {
                (0, _user_actions.loadNewDMIfNeeded)(channel.id);
            } else if (channel && channel.type === _constants.Constants.GM_CHANNEL) {
                (0, _user_actions.loadNewGMIfNeeded)(channel.id);
            }
        }
    }
}

function updateChannel(channel, success, error) {
    ChannelActions.updateChannel(channel)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannel.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function searchMoreChannels(term, success, error) {
    ChannelActions.searchChannels(_team_store2.default.getCurrentId(), term)(dispatch, getState).then(function (data) {
        if (data && success) {
            var myMembers = (0, _channels3.getMyChannelMemberships)(getState());
            var channels = data.filter(function (c) {
                return !myMembers[c.id];
            });
            success(channels);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.getChannels.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function searchAllChannels(term, success, error) {
    (0, _channels2.searchAllChannels)(term)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.getChannels.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function autocompleteChannels(term, success, error) {
    ChannelActions.searchChannels(_team_store2.default.getCurrentId(), term)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.getChannels.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateChannelNotifyProps(data, options, success, error) {
    ChannelActions.updateChannelNotifyProps(data.user_id, data.channel_id, (0, _assign2.default)({}, data, options))(dispatch, getState).then(function (result) {
        if (result && success) {
            success(result);
        } else if (result == null && error) {
            var serverError = getState().requests.channels.updateChannelNotifyProps.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function createChannel(channel, success, error) {
    ChannelActions.createChannel(channel)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.createChannel.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateChannelPurpose(channelId, purpose, success, error) {
    ChannelActions.patchChannel(channelId, { purpose: purpose })(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannel.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function updateChannelHeader(channelId, header, success, error) {
    ChannelActions.patchChannel(channelId, { header: header })(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.updateChannel.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function getChannelMembersForUserIds(channelId, userIds, success, error) {
    ChannelActions.getChannelMembersByIds(channelId, userIds)(dispatch, getState).then(function (data) {
        if (data && success) {
            success(data);
        } else if (data == null && error) {
            var serverError = getState().requests.channels.members.error;
            error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
        }
    });
}

function leaveChannel(channelId, success) {
    ChannelActions.leaveChannel(channelId)(dispatch, getState).then(function () {
        if (ChannelUtils.isFavoriteChannelId(channelId)) {
            unmarkFavorite(channelId);
        }

        var townsquare = _channel_store2.default.getByTeamIdAndName(_team_store2.default.getCurrentId(), 'town-square');
        _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + townsquare.name);

        if (success) {
            success();
        }
    });
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isChrome = isChrome;
exports.isSafari = isSafari;
exports.isIosSafari = isIosSafari;
exports.isIosChrome = isIosChrome;
exports.isIosWeb = isIosWeb;
exports.isIos = isIos;
exports.isAndroid = isAndroid;
exports.isAndroidChrome = isAndroidChrome;
exports.isAndroidWeb = isAndroidWeb;
exports.isMobileApp = isMobileApp;
exports.isMobile = isMobile;
exports.isFirefox = isFirefox;
exports.isInternetExplorer = isInternetExplorer;
exports.isEdge = isEdge;
exports.isDesktopApp = isDesktopApp;
exports.isWindowsApp = isWindowsApp;
exports.isMacApp = isMacApp;
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/*
Example User Agents
--------------------

Chrome:
    Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.103 Safari/537.36

Firefox:
    Mozilla/5.0 (Windows NT 10.0; WOW64; rv:47.0) Gecko/20100101 Firefox/47.0

IE11:
    Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko

Edge:
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586

Desktop App:
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/1.2.1 Chrome/49.0.2623.75 Electron/0.37.8 Safari/537.36
    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586
    Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_0) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/3.4.1 Chrome/53.0.2785.113 Electron/1.4.2 Safari/537.36
    Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Mattermost/3.4.1 Chrome/51.0.2704.106 Electron/1.2.8 Safari/537.36

Android Chrome:
    Mozilla/5.0 (Linux; Android 4.0.4; Galaxy Nexus Build/IMM76B) AppleWebKit/535.19 (KHTML, like Gecko) Chrome/18.0.1025.133 Mobile Safari/535.19

Android App:
    Mozilla/5.0 (Linux; U; Android 4.1.1; en-gb; Build/KLP) AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Safari/534.30
    Mozilla/5.0 (Linux; Android 4.4; Nexus 5 Build/_BuildID_) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Mobile Safari/537.36
    Mozilla/5.0 (Linux; Android 5.1.1; Nexus 5 Build/LMY48B; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/43.0.2357.65 Mobile Safari/537.36

iOS Safari:
    Mozilla/5.0 (iPhone; U; CPU like Mac OS X; en) AppleWebKit/420+ (KHTML, like Gecko) Version/3.0 Mobile/1A543 Safari/419.3

iOS Android:
    Mozilla/5.0 (iPhone; U; CPU iPhone OS 5_1_1 like Mac OS X; en) AppleWebKit/534.46.0 (KHTML, like Gecko) CriOS/19.0.1084.60 Mobile/9B206 Safari/7534.48.3

iOS App:
    Mozilla/5.0 (iPhone; CPU iPhone OS 9_3_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13F69
*/

var userAgent = window.navigator.userAgent;

function isChrome() {
    return userAgent.indexOf('Chrome') > -1;
}

function isSafari() {
    return userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1;
}

function isIosSafari() {
    return userAgent.indexOf('iPhone') !== -1 && userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('CriOS') === -1;
}

function isIosChrome() {
    return userAgent.indexOf('CriOS') !== -1;
}

function isIosWeb() {
    return isIosSafari() || isIosChrome();
}

function isIos() {
    return userAgent.indexOf('iPhone') !== -1;
}

function isAndroid() {
    return userAgent.indexOf('Android') !== -1;
}

function isAndroidChrome() {
    return userAgent.indexOf('Android') !== -1 && userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Version') === -1;
}

function isAndroidWeb() {
    return isAndroidChrome();
}

// Returns true if and only if the user is using a Mattermost mobile app. This will return false if the user is using the
// web browser on a mobile device.
function isMobileApp() {
    return isMobile() && !isIosWeb() && !isAndroidWeb();
}

// Returns true if and only if the user is using Mattermost from either the mobile app or the web browser on a mobile device.
function isMobile() {
    return isIos() || isAndroid();
}

function isFirefox() {
    return userAgent.indexOf('Firefox') !== -1;
}

function isInternetExplorer() {
    return userAgent.indexOf('Trident') !== -1;
}

function isEdge() {
    return userAgent.indexOf('Edge') !== -1;
}

function isDesktopApp() {
    return userAgent.indexOf('Mattermost') !== -1 && userAgent.indexOf('Electron') !== -1;
}

function isWindowsApp() {
    return isDesktopApp() && userAgent.indexOf('Windows') !== -1;
}

function isMacApp() {
    return isDesktopApp() && userAgent.indexOf('Macintosh') !== -1;
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _iterator = __webpack_require__(420);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(951);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _isIterable2 = __webpack_require__(1066);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(908), __esModule: true };


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var LocalizationStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(LocalizationStoreClass, _EventEmitter);

    function LocalizationStoreClass() {
        (0, _classCallCheck3.default)(this, LocalizationStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocalizationStoreClass.__proto__ || (0, _getPrototypeOf2.default)(LocalizationStoreClass)).call(this));

        _this.currentLocale = 'en';
        _this.currentTranslations = null;
        return _this;
    }

    (0, _createClass3.default)(LocalizationStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'setCurrentLocale',
        value: function setCurrentLocale(locale, translations) {
            this.currentLocale = locale;
            this.currentTranslations = translations;
        }
    }, {
        key: 'getLocale',
        value: function getLocale() {
            return this.currentLocale;
        }
    }, {
        key: 'getTranslations',
        value: function getTranslations() {
            return this.currentTranslations;
        }
    }]);
    return LocalizationStoreClass;
}(_events2.default);

var LocalizationStore = new LocalizationStoreClass();
LocalizationStore.setMaxListeners(0);

LocalizationStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_LOCALE:
            LocalizationStore.setCurrentLocale(action.locale, action.translations);
            LocalizationStore.emitChange();
            break;
        default:
    }
});

exports.default = LocalizationStore;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSystemMessage = isSystemMessage;
exports.isShowNotification = isShowNotification;
exports.isFromWebhook = isFromWebhook;
exports.isWVCMessage = isWVCMessage;
exports.isForwardMessage = isForwardMessage;
exports.isPostOwner = isPostOwner;
exports.isComment = isComment;
exports.isEdited = isEdited;
exports.getProfilePicSrcForPost = getProfilePicSrcForPost;
exports.canDeletePost = canDeletePost;
exports.canEditPost = canEditPost;
exports.shouldShowDotMenu = shouldShowDotMenu;
exports.containsAtMention = containsAtMention;

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSystemMessage(post) {
    return post.type && (post.type.lastIndexOf(_constants2.default.SYSTEM_MESSAGE_PREFIX) === 0 || post.type === _constants2.default.PostTypes.MISSING_CALL || post.type === _constants2.default.PostTypes.WEBRTC);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function isShowNotification(post) {
    return !isSystemMessage(post) || post.type === _constants2.default.PostTypes.CREATE_CHANNEL;
}

function isFromWebhook(post) {
    return post.props && post.props.from_webhook === 'true';
}

function isWVCMessage(post) {
    return post.type && post.type.lastIndexOf(_constants2.default.WVC_MESSAGE_PREFIX) === 0;
}

function isForwardMessage(post) {
    return post.props && post.props.is_forwarded_message;
}

function isPostOwner(post) {
    return _user_store2.default.getCurrentId() === post.user_id;
}

function isComment(post) {
    if ('root_id' in post) {
        return post.root_id !== '' && post.root_id != null;
    }
    return false;
}

function isEdited(post) {
    return post.edit_at > 0;
}

function getProfilePicSrcForPost(post, user) {
    var src = '';
    if (user && user.id === post.user_id) {
        src = Utils.imageURLForUser(user);
    } else {
        src = Utils.imageURLForUser(post.user_id);
    }

    if (post.props && post.props.from_webhook && global.window.mm_config.EnablePostIconOverride === 'true') {
        if (post.props.override_icon_url) {
            src = post.props.override_icon_url;
        } else {
            src = _constants2.default.DEFAULT_WEBHOOK_LOGO;
        }
    } else if (isSystemMessage(post)) {
        src = _constants2.default.SYSTEM_MESSAGE_PROFILE_IMAGE;
    }

    return src;
}

function canDeletePost(post) {
    var isOwner = isPostOwner(post);
    var isSystemAdmin = _user_store2.default.isSystemAdminForCurrentUser();
    var isTeamAdmin = _team_store2.default.isTeamAdminForCurrentTeam() || isSystemAdmin;
    var isChannelAdmin = _channel_store2.default.isChannelAdminForCurrentChannel() || isTeamAdmin;
    var isAdmin = isChannelAdmin || isTeamAdmin || isSystemAdmin;

    if (isWVCMessage(post)) {
        return false;
    }

    if (global.window.mm_license.IsLicensed === 'true') {
        return global.window.mm_config.RestrictPostDelete === _constants2.default.PERMISSIONS_DELETE_POST_ALL && (isOwner || isChannelAdmin) || global.window.mm_config.RestrictPostDelete === _constants2.default.PERMISSIONS_DELETE_POST_TEAM_ADMIN && isTeamAdmin || global.window.mm_config.RestrictPostDelete === _constants2.default.PERMISSIONS_DELETE_POST_SYSTEM_ADMIN && isSystemAdmin;
    }

    return isOwner || isAdmin;
}

function canEditPost(post, editDisableAction) {
    var isOwner = isPostOwner(post);

    var canEdit = isOwner && !isSystemMessage(post) && !isForwardMessage(post) && !isWVCMessage(post);

    if (canEdit && global.window.mm_license.IsLicensed === 'true') {
        if (global.window.mm_config.AllowEditPost === _constants2.default.ALLOW_EDIT_POST_NEVER) {
            canEdit = false;
        } else if (global.window.mm_config.AllowEditPost === _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT) {
            var timeLeft = post.create_at + global.window.mm_config.PostEditTimeLimit * 1000 - Utils.getTimestamp();
            if (timeLeft > 0) {
                editDisableAction.fireAfter(timeLeft + 1000);
            } else {
                canEdit = false;
            }
        }
    }
    return canEdit;
}

function shouldShowDotMenu(post) {
    if (Utils.isMobile()) {
        return true;
    }

    if (!isSystemMessage(post)) {
        return true;
    }

    if (canDeletePost(post)) {
        return true;
    }

    if (canEditPost(post)) {
        return true;
    }

    return false;
}

function containsAtMention(text, key) {
    if (!text || !key) {
        return false;
    }

    // This doesn't work for at mentions containing periods or hyphens
    return new RegExp('\\B' + key + '\\b', 'i').test(text);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canDownloadFilesOnMobile = exports.canUploadFilesOnMobile = undefined;
exports.getConfig = getConfig;
exports.getLicense = getLicense;
exports.getCurrentUrl = getCurrentUrl;

var _reselect = __webpack_require__(93);

function getConfig(state) {
    return state.entities.general.config;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getLicense(state) {
    return state.entities.general.license;
}

function getCurrentUrl(state) {
    return state.entities.general.credentials.url;
}

var canUploadFilesOnMobile = exports.canUploadFilesOnMobile = (0, _reselect.createSelector)(getConfig, getLicense, function (config, license) {
    // Defaults to true if either setting doesn't exist
    return config.EnableFileAttachments !== 'false' && (license.IsLicensed === 'false' || license.Compliance === 'false' || config.EnableMobileFileUpload !== 'false');
});

var canDownloadFilesOnMobile = exports.canDownloadFilesOnMobile = (0, _reselect.createSelector)(getConfig, getLicense, function (config, license) {
    // Defaults to true if the setting doesn't exist
    return license.IsLicensed === 'false' || license.Compliance === 'false' || config.EnableMobileFileDownload !== 'false';
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canManageChannelMembers = exports.getUnreadsInCurrentTeam = exports.getUnreads = exports.getMembersInCurrentChannel = exports.getDefaultChannel = exports.getChannelsWithUnreadSection = exports.getChannelsByCategory = exports.getOtherChannels = exports.getMyChannels = exports.getGroupChannels = exports.getDirectChannels = exports.getChannelsNameMapInCurrentTeam = exports.getChannelsInCurrentTeam = exports.getChannelSetInCurrentTeam = exports.getCurrentChannelStats = exports.getMyCurrentChannelMembership = exports.getMyChannelMember = exports.getCurrentChannel = exports.getChannel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getAllChannels = getAllChannels;
exports.getAllChannelStats = getAllChannelStats;
exports.getChannelsInTeam = getChannelsInTeam;
exports.getDirectChannelsSet = getDirectChannelsSet;
exports.getCurrentChannelId = getCurrentChannelId;
exports.getMyChannelMemberships = getMyChannelMemberships;
exports.getChannelMembersInChannels = getChannelMembersInChannels;
exports.makeGetChannel = makeGetChannel;

var _reselect = __webpack_require__(93);

var _general = __webpack_require__(174);

var _preferences = __webpack_require__(105);

var _teams = __webpack_require__(219);

var _users = __webpack_require__(88);

var _channel_utils = __webpack_require__(209);

var _constants = __webpack_require__(8);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getAllChannels(state) {
    return state.entities.channels.channels;
}

function getAllChannelStats(state) {
    return state.entities.channels.stats;
}

function getChannelsInTeam(state) {
    return state.entities.channels.channelsInTeam;
}

function getDirectChannelsSet(state) {
    return state.entities.channels.channelsInTeam[''] || new Set();
}

function getCurrentChannelId(state) {
    return state.entities.channels.currentChannelId;
}

function getMyChannelMemberships(state) {
    return state.entities.channels.myMembers;
}

function getChannelMembersInChannels(state) {
    return state.entities.channels.membersInChannel;
}

function makeGetChannel() {
    return (0, _reselect.createSelector)(getAllChannels, function (state, props) {
        return props.id;
    }, function (state) {
        return state.entities.users;
    }, _preferences.getTeammateNameDisplaySetting, function (allChannels, channelId, users, teammateNameDisplay) {
        var channel = allChannels[channelId];
        if (channel) {
            return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
        }
        return channel;
    });
}

var getChannel = exports.getChannel = (0, _reselect.createSelector)(getAllChannels, function (state, id) {
    return id;
}, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (allChannels, channelId, users, teammateNameDisplay) {
    var channel = allChannels[channelId];
    if (channel) {
        return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
    }
    return channel;
});

var getCurrentChannel = exports.getCurrentChannel = (0, _reselect.createSelector)(getAllChannels, getCurrentChannelId, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (allChannels, currentChannelId, users, teammateNameDisplay) {
    var channel = allChannels[currentChannelId];
    if (channel) {
        return (0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel);
    }
    return channel;
});

var getMyChannelMember = exports.getMyChannelMember = (0, _reselect.createSelector)(getMyChannelMemberships, function (state, channelId) {
    return channelId;
}, function (channelMemberships, channelId) {
    return channelMemberships[channelId] || {};
});

var getMyCurrentChannelMembership = exports.getMyCurrentChannelMembership = (0, _reselect.createSelector)(getCurrentChannelId, getMyChannelMemberships, function (currentChannelId, channelMemberships) {
    return channelMemberships[currentChannelId] || {};
});

var getCurrentChannelStats = exports.getCurrentChannelStats = (0, _reselect.createSelector)(getAllChannelStats, getCurrentChannelId, function (allChannelStats, currentChannelId) {
    return allChannelStats[currentChannelId];
});

var getChannelSetInCurrentTeam = exports.getChannelSetInCurrentTeam = (0, _reselect.createSelector)(_teams.getCurrentTeamId, getChannelsInTeam, function (currentTeamId, channelsInTeam) {
    return channelsInTeam[currentTeamId] || [];
});

function sortAndInjectChannels(channels, channelSet, locale) {
    var currentChannels = [];
    if (typeof channelSet === 'undefined') {
        return currentChannels;
    }

    channelSet.forEach(function (c) {
        currentChannels.push(channels[c]);
    });

    return currentChannels.sort(_channel_utils.sortChannelsByDisplayName.bind(null, locale));
}

var getChannelsInCurrentTeam = exports.getChannelsInCurrentTeam = (0, _reselect.createSelector)(getAllChannels, getChannelSetInCurrentTeam, _users.getCurrentUser, function (channels, currentTeamChannelSet, currentUser) {
    var locale = 'en';
    if (currentUser && currentUser.locale) {
        locale = currentUser.locale;
    }
    return sortAndInjectChannels(channels, currentTeamChannelSet, locale);
});

var getChannelsNameMapInCurrentTeam = exports.getChannelsNameMapInCurrentTeam = (0, _reselect.createSelector)(getAllChannels, getChannelSetInCurrentTeam, function (channels, currentTeamChannelSet) {
    var channelMap = {};
    currentTeamChannelSet.forEach(function (id) {
        var channel = channels[id];
        channelMap[channel.name] = channel;
    });
    return channelMap;
});

// Returns both DMs and GMs
var getDirectChannels = exports.getDirectChannels = (0, _reselect.createSelector)(getAllChannels, getDirectChannelsSet, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (channels, channelSet, users, teammateNameDisplay) {
    var dmChannels = [];
    channelSet.forEach(function (c) {
        dmChannels.push((0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channels[c]));
    });
    return dmChannels;
});

// Returns only GMs
var getGroupChannels = exports.getGroupChannels = (0, _reselect.createSelector)(getAllChannels, getDirectChannelsSet, function (state) {
    return state.entities.users;
}, _preferences.getTeammateNameDisplaySetting, function (channels, channelSet, users, teammateNameDisplay) {
    var gmChannels = [];
    channelSet.forEach(function (id) {
        var channel = channels[id];
        if (channel.type === _constants.General.GM_CHANNEL) {
            gmChannels.push((0, _channel_utils.completeDirectChannelInfo)(users, teammateNameDisplay, channel));
        }
    });
    return gmChannels;
});

var getMyChannels = exports.getMyChannels = (0, _reselect.createSelector)(getChannelsInCurrentTeam, getDirectChannels, getMyChannelMemberships, function (channels, directChannels, myMembers) {
    return [].concat(_toConsumableArray(channels), _toConsumableArray(directChannels)).filter(function (c) {
        return myMembers.hasOwnProperty(c.id);
    });
});

var getOtherChannels = exports.getOtherChannels = (0, _reselect.createSelector)(getChannelsInCurrentTeam, getMyChannelMemberships, function (channels, myMembers) {
    return channels.filter(function (c) {
        return !myMembers.hasOwnProperty(c.id) && c.type === _constants.General.OPEN_CHANNEL;
    });
});

var getChannelsByCategory = exports.getChannelsByCategory = (0, _reselect.createSelector)(getCurrentChannelId, getMyChannels, _preferences.getMyPreferences, _preferences.getTeammateNameDisplaySetting, function (state) {
    return state.entities.users;
}, function (currentChannelId, channels, myPreferences, teammateNameDisplay, usersState) {
    var allChannels = channels.map(function (c) {
        var channel = _extends({}, c);
        channel.isCurrent = c.id === currentChannelId;
        return channel;
    });

    return (0, _channel_utils.buildDisplayableChannelList)(usersState, allChannels, myPreferences, teammateNameDisplay);
});

var getChannelsWithUnreadSection = exports.getChannelsWithUnreadSection = (0, _reselect.createSelector)(getCurrentChannelId, getMyChannels, getMyChannelMemberships, _preferences.getMyPreferences, _preferences.getTeammateNameDisplaySetting, function (state) {
    return state.entities.users;
}, function (currentChannelId, channels, myMembers, myPreferences, teammateNameDisplay, usersState) {
    var allChannels = channels.map(function (c) {
        var channel = _extends({}, c);
        channel.isCurrent = c.id === currentChannelId;
        return channel;
    });

    return (0, _channel_utils.buildDisplayableChannelListWithUnreadSection)(usersState, allChannels, myMembers, myPreferences, teammateNameDisplay);
});

var getDefaultChannel = exports.getDefaultChannel = (0, _reselect.createSelector)(getAllChannels, _teams.getCurrentTeamId, function (channels, teamId) {
    return Object.values(channels).find(function (c) {
        return c.team_id === teamId && c.name === _constants.General.DEFAULT_CHANNEL;
    });
});

var getMembersInCurrentChannel = exports.getMembersInCurrentChannel = (0, _reselect.createSelector)(getCurrentChannelId, getChannelMembersInChannels, function (currentChannelId, members) {
    return members[currentChannelId];
});

var getUnreads = exports.getUnreads = (0, _reselect.createSelector)(getCurrentChannelId, getAllChannels, getMyChannelMemberships, function (currentChannelId, channels, myMembers) {
    var messageCount = 0;
    var mentionCount = 0;
    Object.keys(myMembers).forEach(function (channelId) {
        var channel = channels[channelId];
        var m = myMembers[channelId];
        if (channel && m && channel.id !== currentChannelId) {
            if (channel.type === 'D') {
                mentionCount += channel.total_msg_count - m.msg_count;
            } else if (m.mention_count > 0) {
                mentionCount += m.mention_count;
            }
            if (m.notify_props && m.notify_props.mark_unread !== 'mention' && channel.total_msg_count - m.msg_count > 0) {
                messageCount += 1;
            }
        }
    });

    return { messageCount: messageCount, mentionCount: mentionCount };
});

var getUnreadsInCurrentTeam = exports.getUnreadsInCurrentTeam = (0, _reselect.createSelector)(getCurrentChannelId, getMyChannels, getMyChannelMemberships, function (currentChannelId, channels, myMembers) {
    var messageCount = 0;
    var mentionCount = 0;

    channels.forEach(function (channel) {
        var m = myMembers[channel.id];
        if (m && channel.id !== currentChannelId) {
            if (channel.type === 'D') {
                mentionCount += channel.total_msg_count - m.msg_count;
            } else if (m.mention_count > 0) {
                mentionCount += m.mention_count;
            }
            if (m.notify_props && m.notify_props.mark_unread !== 'mention' && channel.total_msg_count - m.msg_count > 0) {
                messageCount += 1;
            }
        }
    });

    return { messageCount: messageCount, mentionCount: mentionCount };
});

var canManageChannelMembers = exports.canManageChannelMembers = (0, _reselect.createSelector)(getCurrentChannel, _users.getCurrentUser, _teams.getCurrentTeamMembership, getMyCurrentChannelMembership, _general.getConfig, _general.getLicense, _channel_utils.canManageMembers);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getChannelsForXTeamPosts = undefined;

var _defineProperty2 = __webpack_require__(221);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

var _set = __webpack_require__(294);

var _set2 = _interopRequireDefault(_set);

var _map = __webpack_require__(165);

var _map2 = _interopRequireDefault(_map);

var _promise = __webpack_require__(171);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getChannelsForXTeamPosts = exports.getChannelsForXTeamPosts = function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(posts, dispatch, getState) {
        var channels, AllChannels, channelIdsToLoad, promises;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        if (posts) {
                            _context8.next = 2;
                            break;
                        }

                        return _context8.abrupt('return', _promise2.default.resolve());

                    case 2:
                        channels = new _map2.default();
                        AllChannels = _channel_store2.default.getXTeamChannels();

                        AllChannels.forEach(function (channel) {
                            if (!channels.has(channel.id)) {
                                channels.set(channel.id, channel);
                            }
                        });

                        channelIdsToLoad = new _set2.default();

                        (0, _values2.default)(posts).forEach(function (post) {
                            var channelId = post.channel_id;
                            if (!channels.has(channelId)) {
                                channelIdsToLoad.add(channelId);
                            }
                        });

                        promises = [];

                        if (channelIdsToLoad.size > 0) {
                            promises.push(getChannelsByIds((0, _from2.default)(channelIdsToLoad))(dispatch, getState));
                        }
                        return _context8.abrupt('return', _promise2.default.all(promises));

                    case 10:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function getChannelsForXTeamPosts(_x15, _x16, _x17) {
        return _ref8.apply(this, arguments);
    };
}();

exports.updateSelfDestructTimer = updateSelfDestructTimer;
exports.batchUpdateSelfDestructTimer = batchUpdateSelfDestructTimer;
exports.initTalk2Site = initTalk2Site;
exports.getMyAllChannels = getMyAllChannels;
exports.getMyAllMembers = getMyAllMembers;
exports.getMyAllTeamUsers = getMyAllTeamUsers;
exports.getChannelsByIds = getChannelsByIds;
exports.addMembersToChannel = addMembersToChannel;
exports.addAllMembersToChannel = addAllMembersToChannel;
exports.addGuestsToChannel = addGuestsToChannel;
exports.addAllGuestsToChannel = addAllGuestsToChannel;
exports.uploadChannelImage = uploadChannelImage;
exports.uploadChannelBackground = uploadChannelBackground;
exports.createChannelWithImages = createChannelWithImages;
exports.fetchAllMyChannelsAndMembers = fetchAllMyChannelsAndMembers;
exports.getAllAccessibleChannels = getAllAccessibleChannels;
exports.searchAllChannels = searchAllChannels;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(145);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateSelfDestructTimer(channelId, patch) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
            var updated;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context.prev = 2;
                            _context.next = 5;
                            return _client.CustomClient4.updateSelfDestructTimer(channelId, patch);

                        case 5:
                            updated = _context.sent;
                            _context.next = 13;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState);
                            return _context.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 8]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function batchUpdateSelfDestructTimer(selfDestructProps) {
    var _this2 = this;

    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.CustomClient4.batchUpdateSelfDestructTimer(selfDestructProps);

                        case 4:
                            _context2.next = 11;
                            break;

                        case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context2.t0 }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', null);

                        case 11:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS }, getState);

                            return _context2.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 6]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function initTalk2Site(channelId) {
    var _this3 = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var updated;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.CustomClient4.initTalk2Site(channelId);

                        case 5:
                            updated = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function getMyAllChannels() {
    var _this4 = this;

    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var channels;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            channels = void 0;
                            _context4.prev = 1;
                            _context4.next = 4;
                            return _client.CustomClient4.getMyAllChannels();

                        case 4:
                            channels = _context4.sent;
                            _context4.next = 10;
                            break;

                        case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);

                        case 10:
                            return _context4.abrupt('return', channels);

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[1, 7]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getMyAllMembers() {
    var _this5 = this;

    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var users;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            users = void 0;
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _client.CustomClient4.getMyAllMembers();

                        case 4:
                            users = _context5.sent;
                            _context5.next = 10;
                            break;

                        case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);

                        case 10:
                            return _context5.abrupt('return', users);

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[1, 7]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function getMyAllTeamUsers() {
    var _this6 = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var users;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            users = void 0;
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _client.CustomClient4.getMyAllTeamUsers();

                        case 4:
                            users = _context6.sent;
                            _context6.next = 10;
                            break;

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);

                        case 10:
                            return _context6.abrupt('return', users);

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[1, 7]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function getChannelsByIds(channelIds) {
    var _this7 = this;

    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var channels;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            channels = void 0;
                            _context7.prev = 1;
                            _context7.next = 4;
                            return _client.CustomClient4.getChannelsByIds(channelIds);

                        case 4:
                            channels = _context7.sent;
                            _context7.next = 12;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', null);

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.RECEIVED_CHANNELS, data: channels }]), getState);

                            return _context7.abrupt('return', channels);

                        case 14:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[1, 7]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function addMembersToChannel(channelId, userIds) {
    var _this8 = this;

    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(dispatch, getState) {
            var members, actions;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context9.prev = 2;
                            _context9.next = 5;
                            return _client.CustomClient4.addMembersToChannel(channelId, userIds);

                        case 5:
                            members = _context9.sent;
                            _context9.next = 13;
                            break;

                        case 8:
                            _context9.prev = 8;
                            _context9.t0 = _context9['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', null);

                        case 13:
                            actions = [];

                            members.forEach(function (m) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                    data: { user_id: m.user_id },
                                    id: channelId
                                });
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: members
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                data: channelId
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context9.abrupt('return', members);

                        case 19:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this8, [[2, 8]]);
        }));

        return function (_x18, _x19) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function addAllMembersToChannel(channelId) {
    var _this9 = this;

    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(dispatch, getState) {
            var members, actions;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context10.prev = 2;
                            _context10.next = 5;
                            return _client.CustomClient4.addAllMembersToChannel(channelId);

                        case 5:
                            members = _context10.sent;
                            _context10.next = 13;
                            break;

                        case 8:
                            _context10.prev = 8;
                            _context10.t0 = _context10['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context10.t0 }, (0, _errors.logError)(_context10.t0)(dispatch)]), getState);
                            return _context10.abrupt('return', null);

                        case 13:
                            actions = [];

                            members.forEach(function (m) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                    data: { user_id: m.user_id },
                                    id: channelId
                                });
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: members
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                data: channelId
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context10.abrupt('return', members);

                        case 19:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this9, [[2, 8]]);
        }));

        return function (_x20, _x21) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function addGuestsToChannel(channelId, userIds) {
    var _this10 = this;

    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(dispatch, getState) {
            var members, actions;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context11.prev = 2;
                            _context11.next = 5;
                            return _client.CustomClient4.addGuestsToChannel(channelId, userIds);

                        case 5:
                            members = _context11.sent;
                            _context11.next = 13;
                            break;

                        case 8:
                            _context11.prev = 8;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 13:
                            actions = [];

                            members.forEach(function (m) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                    data: { user_id: m.user_id },
                                    id: channelId
                                });
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: members
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                data: channelId
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context11.abrupt('return', members);

                        case 19:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this10, [[2, 8]]);
        }));

        return function (_x22, _x23) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function addAllGuestsToChannel(channelId) {
    var _this11 = this;

    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(dispatch, getState) {
            var members, actions;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context12.prev = 2;
                            _context12.next = 5;
                            return _client.CustomClient4.addAllGuestsToChannel(channelId);

                        case 5:
                            members = _context12.sent;
                            _context12.next = 13;
                            break;

                        case 8:
                            _context12.prev = 8;
                            _context12.t0 = _context12['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', null);

                        case 13:
                            actions = [];

                            members.forEach(function (m) {
                                actions.push({
                                    type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                    data: { user_id: m.user_id },
                                    id: channelId
                                });
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: members
                            });

                            actions.push({
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
                                data: channelId
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context12.abrupt('return', members);

                        case 19:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this11, [[2, 8]]);
        }));

        return function (_x24, _x25) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function uploadChannelImage(channelId, imageData) {
    var _this12 = this;

    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            _context13.prev = 1;
                            _context13.next = 4;
                            return _client.CustomClient4.uploadChannelImage(channelId, imageData);

                        case 4:
                            _context13.next = 10;
                            break;

                        case 6:
                            _context13.prev = 6;
                            _context13.t0 = _context13['catch'](1);

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context13.t0 }, getState);
                            return _context13.abrupt('return', null);

                        case 10:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS }, getState);

                            return _context13.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this12, [[1, 6]]);
        }));

        return function (_x26, _x27) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function uploadChannelBackground(channelId, imageData) {
    var _this13 = this;

    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            _context14.prev = 1;
                            _context14.next = 4;
                            return _client.CustomClient4.uploadChannelBackgroundImage(channelId, imageData);

                        case 4:
                            _context14.next = 10;
                            break;

                        case 6:
                            _context14.prev = 6;
                            _context14.t0 = _context14['catch'](1);

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context14.t0 }, getState);
                            return _context14.abrupt('return', null);

                        case 10:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS }, getState);

                            return _context14.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this13, [[1, 6]]);
        }));

        return function (_x28, _x29) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function createChannelWithImages(channel, userId) {
    var _this14 = this;

    var request = (0, _assign2.default)({}, channel);
    delete request.file;
    delete request.backgroundFile;
    var image = channel.file;
    var background = channel.backgroundFile;

    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(dispatch, getState) {
            var created, member, actions, _getState$entities$ch, channels, myMembers;

            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            created = void 0;
                            _context15.prev = 2;
                            _context15.next = 5;
                            return _client.CustomClient4.createChannelWithImages(request, image, background);

                        case 5:
                            created = _context15.sent;
                            _context15.next = 13;
                            break;

                        case 8:
                            _context15.prev = 8;
                            _context15.t0 = _context15['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE,
                                error: _context15.t0
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE,
                                error: _context15.t0
                            }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', null);

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: _constants.General.CHANNEL_USER_ROLE + ' ' + _constants.General.CHANNEL_ADMIN_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            actions = [];
                            _getState$entities$ch = getState().entities.channels, channels = _getState$entities$ch.channels, myMembers = _getState$entities$ch.myMembers;


                            if (!channels[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: created });
                            }

                            if (!myMembers[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: member });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }])), getState);

                            return _context15.abrupt('return', created);

                        case 20:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this14, [[2, 8]]);
        }));

        return function (_x30, _x31) {
            return _ref15.apply(this, arguments);
        };
    }();
}

// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux actions/channels).
// Loads every channel and membership of the current user across all teams, plus the last post
// of each channel, in one go (used when entering a team and after the websocket reconnects).
function fetchAllMyChannelsAndMembers() {
    var _this15 = this;

    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(dispatch, getState) {
            var channels, channelMembers, lastPosts, postActions, i, post, currentUserId;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_REQUEST }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST }]), getState);

                            channels = void 0;
                            channelMembers = void 0;
                            lastPosts = void 0;
                            _context16.prev = 4;
                            _context16.next = 7;
                            return _client.CustomClient4.getMyAllChannels();

                        case 7:
                            channels = _context16.sent;
                            _context16.next = 15;
                            break;

                        case 10:
                            _context16.prev = 10;
                            _context16.t0 = _context16['catch'](4);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context16.t0 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context16.t0 }, (0, _errors.logError)(_context16.t0)(dispatch)]), getState);
                            return _context16.abrupt('return', null);

                        case 15:
                            _context16.prev = 15;
                            _context16.next = 18;
                            return _client.CustomClient4.getMyAllChannelMembers();

                        case 18:
                            channelMembers = _context16.sent;
                            _context16.next = 26;
                            break;

                        case 21:
                            _context16.prev = 21;
                            _context16.t1 = _context16['catch'](15);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t1, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context16.t1 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context16.t1 }, (0, _errors.logError)(_context16.t1)(dispatch)]), getState);
                            return _context16.abrupt('return', null);

                        case 26:
                            _context16.prev = 26;
                            _context16.next = 29;
                            return _client.CustomClient4.getLastPosts();

                        case 29:
                            lastPosts = _context16.sent;
                            _context16.next = 37;
                            break;

                        case 32:
                            _context16.prev = 32;
                            _context16.t2 = _context16['catch'](26);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t2, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_FAILURE, error: _context16.t2 }, (0, _errors.logError)(_context16.t2)(dispatch)]), getState);
                            return _context16.abrupt('return', null);

                        case 37:
                            postActions = [];

                            for (i = 0; i < lastPosts.length; i++) {
                                post = lastPosts[i];

                                postActions.push({
                                    type: _action_types.PostTypes.RECEIVED_POSTS,
                                    data: { order: [], posts: (0, _defineProperty3.default)({}, post.id, post) },
                                    channelId: post.channel_id
                                });
                            }
                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(postActions, [{ type: _action_types.PostTypes.GET_POSTS_SUCCESS }])), getState);

                            currentUserId = getState().entities.users.currentUserId;


                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.RECEIVED_CHANNELS, data: channels }, { type: _action_types.ChannelTypes.CHANNELS_SUCCESS }, { type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS, data: channelMembers, currentUserId: currentUserId }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS }]), getState);

                            return _context16.abrupt('return', { channels: channels, members: channelMembers });

                        case 43:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this15, [[4, 10], [15, 21], [26, 32]]);
        }));

        return function (_x32, _x33) {
            return _ref16.apply(this, arguments);
        };
    }();
}

// Public channels the current user may join, across all teams (paged).
function getAllAccessibleChannels() {
    var _this16 = this;

    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(dispatch, getState) {
            var channels, received;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context17.prev = 2;
                            _context17.next = 5;
                            return _client.CustomClient4.getAccessibleChannels(page, perPage);

                        case 5:
                            channels = _context17.sent;
                            _context17.next = 13;
                            break;

                        case 8:
                            _context17.prev = 8;
                            _context17.t0 = _context17['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', null);

                        case 13:
                            received = [];

                            channels.forEach(function (channel) {
                                received.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNELS, teamId: channel.team_id, data: [channel] });
                            });
                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(received, [{ type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS }])), getState);

                            return _context17.abrupt('return', channels);

                        case 17:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this16, [[2, 8]]);
        }));

        return function (_x36, _x37) {
            return _ref17.apply(this, arguments);
        };
    }();
}

// Search public channels the current user may join, across all teams.
function searchAllChannels(term) {
    var _this17 = this;

    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(dispatch, getState) {
            var channels, received;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context18.prev = 2;
                            _context18.next = 5;
                            return _client.CustomClient4.searchAccessibleChannels(term);

                        case 5:
                            channels = _context18.sent;
                            _context18.next = 13;
                            break;

                        case 8:
                            _context18.prev = 8;
                            _context18.t0 = _context18['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context18.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context18.t0 }, (0, _errors.logError)(_context18.t0)(dispatch)]), getState);
                            return _context18.abrupt('return', null);

                        case 13:
                            received = [];

                            channels.forEach(function (channel) {
                                received.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNELS, teamId: channel.team_id, data: [channel] });
                            });
                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(received, [{ type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS }])), getState);

                            return _context18.abrupt('return', channels);

                        case 17:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this17, [[2, 8]]);
        }));

        return function (_x38, _x39) {
            return _ref18.apply(this, arguments);
        };
    }();
}

// ---

exports.default = {
    updateSelfDestructTimer: updateSelfDestructTimer,
    batchUpdateSelfDestructTimer: batchUpdateSelfDestructTimer,
    fetchAllMyChannelsAndMembers: fetchAllMyChannelsAndMembers,
    getAllAccessibleChannels: getAllAccessibleChannels,
    searchAllChannels: searchAllChannels,
    getMyAllChannels: getMyAllChannels,
    getChannelsByIds: getChannelsByIds,
    addMembersToChannel: addMembersToChannel,
    addAllMembersToChannel: addAllMembersToChannel
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(170);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

exports.loadStatusesForChannel = loadStatusesForChannel;
exports.loadStatusesForDMSidebar = loadStatusesForDMSidebar;
exports.loadStatusesForChannelAndSidebar = loadStatusesForChannelAndSidebar;
exports.loadStatusesForProfilesList = loadStatusesForProfilesList;
exports.loadStatusesForProfilesMap = loadStatusesForProfilesMap;
exports.loadStatusesByIds = loadStatusesByIds;
exports.startPeriodicStatusUpdates = startPeriodicStatusUpdates;
exports.stopPeriodicStatusUpdates = stopPeriodicStatusUpdates;

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _post_store = __webpack_require__(304);

var _post_store2 = _interopRequireDefault(_post_store);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(12);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _users = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;

// Redux actions

var getState = _redux_store2.default.getState;

function loadStatusesForChannel() {
    var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();

    var postList = _post_store2.default.getVisiblePosts(channelId);
    if (!postList || !postList.posts) {
        return;
    }

    var statuses = _user_store2.default.getStatuses();
    var statusesToLoad = {};
    for (var pid in postList.posts) {
        if (!postList.posts.hasOwnProperty(pid)) {
            continue;
        }

        var post = postList.posts[pid];
        if (statuses[post.user_id] == null) {
            statusesToLoad[post.user_id] = true;
        }
    }

    loadStatusesByIds((0, _keys2.default)(statusesToLoad));
}

function loadStatusesForDMSidebar() {
    var dmPrefs = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
    var statusesToLoad = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(dmPrefs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (value === 'true') {
                statusesToLoad.push(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesForChannelAndSidebar() {
    var statusesToLoad = {};

    var channelId = _channel_store2.default.getCurrentId();
    var posts = _post_store2.default.getVisiblePosts(channelId) || [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var post = _step2.value;

            statusesToLoad[post.user_id] = true;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var dmPrefs = _preference_store2.default.getCategory(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = (0, _getIterator3.default)(dmPrefs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
                key = _step3$value[0],
                value = _step3$value[1];

            if (value === 'true') {
                statusesToLoad[key] = true;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var currentUserId = getState().entities.users.currentUserId;

    statusesToLoad[currentUserId] = true;

    loadStatusesByIds((0, _keys2.default)(statusesToLoad));
}

function loadStatusesForProfilesList(users) {
    if (users == null) {
        return;
    }

    var statusesToLoad = [];
    for (var i = 0; i < users.length; i++) {
        statusesToLoad.push(users[i].id);
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesForProfilesMap(users) {
    if (users == null) {
        return;
    }

    var statusesToLoad = [];
    for (var userId in users) {
        if (!users.hasOwnProperty(userId)) {
            return;
        }
        statusesToLoad.push(userId);
    }

    loadStatusesByIds(statusesToLoad);
}

function loadStatusesByIds(userIds) {
    if (userIds.length === 0) {
        return;
    }

    (0, _users.getStatusesByIds)(userIds)(dispatch, getState);
}

var intervalId = '';

function startPeriodicStatusUpdates() {
    clearInterval(intervalId);

    intervalId = setInterval(function () {
        loadStatusesForChannelAndSidebar();
    }, _constants.Constants.STATUS_INTERVAL);
}

function stopPeriodicStatusUpdates() {
    clearInterval(intervalId);
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global = __webpack_require__(6)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(44)
  , toLength  = __webpack_require__(26)
  , toIndex   = __webpack_require__(109);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(13)
  , cof      = __webpack_require__(60)
  , MATCH    = __webpack_require__(14)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ITERATOR     = __webpack_require__(14)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var hide     = __webpack_require__(41)
  , redefine = __webpack_require__(42)
  , fails    = __webpack_require__(9)
  , defined  = __webpack_require__(61)
  , wks      = __webpack_require__(14);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global            = __webpack_require__(6)
  , $export           = __webpack_require__(1)
  , redefine          = __webpack_require__(42)
  , redefineAll       = __webpack_require__(114)
  , meta              = __webpack_require__(95)
  , forOf             = __webpack_require__(132)
  , anInstance        = __webpack_require__(113)
  , isObject          = __webpack_require__(13)
  , fails             = __webpack_require__(9)
  , $iterDetect       = __webpack_require__(183)
  , setToStringTag    = __webpack_require__(128)
  , inheritIfRequired = __webpack_require__(235);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global = __webpack_require__(6)
  , hide   = __webpack_require__(41)
  , uid    = __webpack_require__(106)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(107)|| !__webpack_require__(9)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(6)[K];
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(154);
var ViewportMetrics = __webpack_require__(353);

var getEventModifierState = __webpack_require__(258);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);
var DOMNamespaces = __webpack_require__(260);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(261);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */

'use strict';

// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var EventPluginRegistry = __webpack_require__(253);
var ReactEventEmitterMixin = __webpack_require__(780);
var ViewportMetrics = __webpack_require__(353);

var getVendorPrefixedEventName = __webpack_require__(781);
var isEventSupported = __webpack_require__(257);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canUseMembrane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



var canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? warning(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? warning(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (deprecateObjectProperties);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deprecateObjectProperties__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRouteParams__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes;
var array = _React$PropTypes.array;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
  displayName: 'RouterContext',


  propTypes: {
    history: object,
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    history: object,
    location: object.isRequired,
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var router = _props.router;
    var history = _props.history;
    var location = _props.location;

    if (!router) {
       false ? warning(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = deprecateObjectProperties(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props;
    var history = _props2.history;
    var location = _props2.location;
    var routes = _props2.routes;
    var params = _props2.params;
    var components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_3__getRouteParams__["a" /* default */])(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationShape; });
/* unused harmony export falsy */
/* unused harmony export history */
/* unused harmony export location */
/* unused harmony export component */
/* unused harmony export components */
/* unused harmony export route */
/* unused harmony export routes */
/* unused harmony export router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deprecateObjectProperties__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);







var func = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func;
var object = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object;
var shape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape;
var string = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string;


var routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["c" /* falsy */];
var history = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["d" /* history */];
var location = locationShape;
var component = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["a" /* component */];
var components = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["b" /* components */];
var route = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["e" /* route */];
var routes = __WEBPACK_IMPORTED_MODULE_2__InternalPropTypes__["f" /* routes */];
var router = routerShape;

if (false) {
  (function () {
    var deprecatePropType = function deprecatePropType(propType, message) {
      return function () {
        process.env.NODE_ENV !== 'production' ? warning(false, message) : void 0;
        return propType.apply(undefined, arguments);
      };
    };

    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
    };

    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
    };

    falsy = deprecateInternalPropType(falsy);
    history = deprecateInternalPropType(history);
    component = deprecateInternalPropType(component);
    components = deprecateInternalPropType(components);
    route = deprecateInternalPropType(route);
    routes = deprecateInternalPropType(routes);

    location = deprecateRenamedPropType(location, 'location');
    router = deprecateRenamedPropType(router, 'router');
  })();
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = deprecateObjectProperties(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

/* harmony default export */ __webpack_exports__["a"] = (defaultExport);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);



/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = true;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(65)
  , dPs         = __webpack_require__(911)
  , enumBugKeys = __webpack_require__(285)
  , IE_PROTO    = __webpack_require__(283)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(280)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(401).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};



/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.15 ToLength
var toInteger = __webpack_require__(278)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(158)
  , TAG = __webpack_require__(32)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ctx         = __webpack_require__(98)
  , call        = __webpack_require__(404)
  , isArrayIter = __webpack_require__(405)
  , anObject    = __webpack_require__(65)
  , toLength    = __webpack_require__(205)
  , getIterFn   = __webpack_require__(287)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeToPrefixMap;

exports.buildDisplayableChannelList = buildDisplayableChannelList;
exports.buildDisplayableChannelListWithUnreadSection = buildDisplayableChannelListWithUnreadSection;
exports.completeDirectChannelInfo = completeDirectChannelInfo;
exports.cleanUpUrlable = cleanUpUrlable;
exports.getChannelByName = getChannelByName;
exports.getDirectChannelName = getDirectChannelName;
exports.getUserIdFromChannelName = getUserIdFromChannelName;
exports.isDirectChannel = isDirectChannel;
exports.isDirectChannelVisible = isDirectChannelVisible;
exports.isGroupChannel = isGroupChannel;
exports.isGroupChannelVisible = isGroupChannelVisible;
exports.showCreateOption = showCreateOption;
exports.showManagementOptions = showManagementOptions;
exports.showDeleteOption = showDeleteOption;
exports.canManageMembers = canManageMembers;
exports.getChannelsIdForTeam = getChannelsIdForTeam;
exports.getGroupDisplayNameFromUserIds = getGroupDisplayNameFromUserIds;
exports.sortChannelsByDisplayName = sortChannelsByDisplayName;

var _constants = __webpack_require__(8);

var _user_utils = __webpack_require__(126);

var _preference_utils = __webpack_require__(142);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var defaultPrefix = 'D'; // fallback for future types
var typeToPrefixMap = (_typeToPrefixMap = {}, _defineProperty(_typeToPrefixMap, _constants.General.OPEN_CHANNEL, 'A'), _defineProperty(_typeToPrefixMap, _constants.General.PRIVATE_CHANNEL, 'B'), _defineProperty(_typeToPrefixMap, _constants.General.DM_CHANNEL, 'C'), _defineProperty(_typeToPrefixMap, _constants.General.GM_CHANNEL, 'C'), _typeToPrefixMap);

/**
 * Returns list of sorted channels grouped by type. Favorites here is considered as separated type.
 *
 * Example: {
 *  publicChannels: [...],
 *  privateChannels: [...],
 *  directAndGroupChannels: [...],
 *  favoriteChannels: [...]
 * }
 */
function buildDisplayableChannelList(usersState, allChannels, myPreferences, teammateNameDisplay) {
    var missingDirectChannels = createMissingDirectChannels(usersState.currentUserId, allChannels, myPreferences);

    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles;

    var locale = getUserLocale(currentUserId, profiles);

    var channels = buildChannels(usersState, allChannels, missingDirectChannels, teammateNameDisplay, locale);
    var favoriteChannels = buildFavoriteChannels(channels, myPreferences, locale);
    var notFavoriteChannels = buildNotFavoriteChannels(channels, myPreferences);
    var directAndGroupChannels = buildDirectAndGroupChannels(notFavoriteChannels, myPreferences, currentUserId);

    return {
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

function buildDisplayableChannelListWithUnreadSection(usersState, myChannels, myMembers, myPreferences, teammateNameDisplay) {
    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles;

    var locale = getUserLocale(currentUserId, profiles);

    var missingDirectChannels = createMissingDirectChannels(currentUserId, myChannels, myPreferences);
    var channels = buildChannels(usersState, myChannels, missingDirectChannels, teammateNameDisplay, locale);
    var unreadChannels = [].concat(_toConsumableArray(buildChannelsWithMentions(channels, myMembers, locale)), _toConsumableArray(buildUnreadChannels(channels, myMembers, locale)));
    var notUnreadChannels = channels.filter(not(isUnreadChannel.bind(null, myMembers)));
    var favoriteChannels = buildFavoriteChannels(notUnreadChannels, myPreferences, locale);
    var notFavoriteChannels = buildNotFavoriteChannels(notUnreadChannels, myPreferences);
    var directAndGroupChannels = buildDirectAndGroupChannels(notFavoriteChannels, myPreferences, currentUserId);

    return {
        unreadChannels: unreadChannels,
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

function completeDirectChannelInfo(usersState, teammateNameDisplay, channel) {
    if (isDirectChannel(channel)) {
        var dmChannelClone = _extends({}, channel);
        var teammateId = getUserIdFromChannelName(usersState.currentUserId, channel.name);

        return Object.assign(dmChannelClone, {
            display_name: (0, _user_utils.displayUsername)(usersState.profiles[teammateId], teammateNameDisplay),
            teammate_id: teammateId,
            status: usersState.statuses[teammateId] || 'offline'
        });
    } else if (isGroupChannel(channel)) {
        return completeDirectGroupInfo(usersState, teammateNameDisplay, channel);
    }

    return channel;
}

function cleanUpUrlable(input) {
    var cleaned = input.trim().replace(/-/g, ' ').replace(/[^\w\s]/gi, '').toLowerCase().replace(/\s/g, '-');
    cleaned = cleaned.replace(/-{2,}/, '-');
    cleaned = cleaned.replace(/^-+/, '');
    cleaned = cleaned.replace(/-+$/, '');
    return cleaned;
}

function getChannelByName(channels, name) {
    var channelIds = Object.keys(channels);
    for (var i = 0; i < channelIds.length; i++) {
        var id = channelIds[i];
        if (channels[id].name === name) {
            return channels[id];
        }
    }
    return null;
}

function getDirectChannelName(id, otherId) {
    var handle = void 0;

    if (otherId > id) {
        handle = id + '__' + otherId;
    } else {
        handle = otherId + '__' + id;
    }

    return handle;
}

function getUserIdFromChannelName(userId, channelName) {
    var ids = channelName.split('__');
    var otherUserId = '';
    if (ids[0] === userId) {
        otherUserId = ids[1];
    } else {
        otherUserId = ids[0];
    }

    return otherUserId;
}

function isDirectChannel(channel) {
    return channel.type === _constants.General.DM_CHANNEL;
}

function isDirectChannelVisible(userId, myPreferences, channel) {
    var channelId = getUserIdFromChannelName(userId, channel.name);
    var dm = myPreferences[_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW + '--' + channelId];
    return dm && dm.value === 'true';
}

function isGroupChannel(channel) {
    return channel.type === _constants.General.GM_CHANNEL;
}

function isGroupChannelVisible(myPreferences, channel) {
    var gm = myPreferences[_constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW + '--' + channel.id];
    return gm && gm.value === 'true';
}

function showCreateOption(config, license, channelType, isAdmin, isSystemAdmin) {
    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channelType === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelCreation === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        } else if (config.RestrictPublicChannelCreation === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
    } else if (channelType === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelCreation === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        } else if (config.RestrictPrivateChannelCreation === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
    }

    return true;
}

function showManagementOptions(config, license, channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelManagement === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelManagement === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelManagement === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelManagement === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelManagement === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelManagement === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    return true;
}

function showDeleteOption(config, license, channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.OPEN_CHANNEL) {
        if (config.RestrictPublicChannelDeletion === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelDeletion === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPublicChannelDeletion === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        if (config.RestrictPrivateChannelDeletion === _constants.General.SYSTEM_ADMIN_ROLE && !isSystemAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelDeletion === _constants.General.TEAM_ADMIN_ROLE && !isAdmin) {
            return false;
        }
        if (config.RestrictPrivateChannelDeletion === _constants.General.CHANNEL_ADMIN_ROLE && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    return true;
}

function canManageMembers(channel, user, teamMember, channelMember, config, license) {
    if (channel.type === _constants.General.DM_CHANNEL || channel.type === _constants.General.GM_CHANNEL || channel.name === _constants.General.DEFAULT_CHANNEL) {
        return false;
    }

    if (license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants.General.PRIVATE_CHANNEL) {
        var isSystemAdmin = user.roles.includes(_constants.General.SYSTEM_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }

        var isTeamAdmin = teamMember.roles.includes(_constants.General.TEAM_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_TEAM_ADMIN && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }

        var isChannelAdmin = channelMember.roles.includes(_constants.General.CHANNEL_ADMIN_ROLE);
        if (config.RestrictPrivateChannelManageMembers === _constants.General.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }
    }

    return true;
}

function getChannelsIdForTeam(state, teamId) {
    var channels = state.entities.channels.channels;


    return Object.values(channels).reduce(function (res, channel) {
        if (channel.team_id === teamId) {
            res.push(channel.id);
        }
        return res;
    }, []);
}

function getGroupDisplayNameFromUserIds(userIds, profiles, currentUserId, teammateNameDisplay) {
    var names = [];
    userIds.forEach(function (id) {
        if (id !== currentUserId) {
            names.push((0, _user_utils.displayUsername)(profiles[id], teammateNameDisplay));
        }
    });

    function sortUsernames(a, b) {
        var locale = profiles[currentUserId].locale;
        return a.localeCompare(b, locale, { numeric: true });
    }

    return names.sort(sortUsernames).join(', ');
}

//====================================================

function createFakeChannel(userId, otherUserId) {
    return {
        name: getDirectChannelName(userId, otherUserId),
        last_post_at: 0,
        total_msg_count: 0,
        type: _constants.General.DM_CHANNEL,
        fake: true
    };
}

function createFakeChannelCurried(userId) {
    return function (otherUserId) {
        return createFakeChannel(userId, otherUserId);
    };
}

function createMissingDirectChannels(currentUserId, allChannels, myPreferences) {
    var directChannelsDisplayPreferences = (0, _preference_utils.getPreferencesByCategory)(myPreferences, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    return Array.from(directChannelsDisplayPreferences).filter(function (entry) {
        return entry[1] === 'true';
    }).map(function (entry) {
        return entry[0];
    }).filter(function (teammateId) {
        return !allChannels.some(isDirectChannelForUser.bind(null, currentUserId, teammateId));
    }).map(createFakeChannelCurried(currentUserId));
}

function completeDirectGroupInfo(usersState, teammateNameDisplay, channel) {
    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles,
        profilesInChannel = usersState.profilesInChannel;

    var profilesIds = profilesInChannel[channel.id];
    var gm = _extends({}, channel);

    if (profilesIds) {
        return Object.assign(gm, {
            display_name: getGroupDisplayNameFromUserIds(profilesIds, profiles, currentUserId, teammateNameDisplay)
        });
    }

    var usernames = gm.display_name.split(', ');
    var users = Object.values(profiles);
    var userIds = [];
    usernames.forEach(function (username) {
        var u = users.find(function (p) {
            return p.username === username;
        });
        if (u) {
            userIds.push(u.id);
        }
    });
    if (usernames.length === userIds.length) {
        return Object.assign(gm, {
            display_name: getGroupDisplayNameFromUserIds(userIds, profiles, currentUserId, teammateNameDisplay)
        });
    }

    return channel;
}

function isDirectChannelForUser(userId, otherUserId, channel) {
    return channel.type === _constants.General.DM_CHANNEL && getUserIdFromChannelName(userId, channel.name) === otherUserId;
}

function isFavoriteChannel(myPreferences, channel) {
    var fav = myPreferences[_constants.Preferences.CATEGORY_FAVORITE_CHANNEL + '--' + channel.id];
    channel.isFavorite = fav && fav.value === 'true';
    return channel.isFavorite;
}

function channelHasMentions(members, channel) {
    var member = members[channel.id];
    if (member) {
        return member.mention_count > 0;
    }
    return false;
}

function channelHasUnreadMessages(members, channel) {
    var member = members[channel.id];
    if (member) {
        var msgCount = channel.total_msg_count - member.msg_count;
        var onlyMentions = member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION;
        return msgCount && !onlyMentions && member.mention_count === 0;
    }

    return false;
}

function isUnreadChannel(members, channel) {
    var member = members[channel.id];
    if (member) {
        var msgCount = channel.total_msg_count - member.msg_count;
        var onlyMentions = member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION;
        return member.mention_count > 0 || msgCount && !onlyMentions;
    }

    return false;
}

function isNotDeletedChannel(channel) {
    return channel.delete_at === 0;
}

function isOpenChannel(channel) {
    return channel.type === _constants.General.OPEN_CHANNEL;
}

function isPrivateChannel(channel) {
    return channel.type === _constants.General.PRIVATE_CHANNEL;
}

function sortChannelsByDisplayName(locale, a, b) {
    if (a.type !== b.type && typeToPrefixMap[a.type] !== typeToPrefixMap[b.type]) {
        return (typeToPrefixMap[a.type] || defaultPrefix).localeCompare(typeToPrefixMap[b.type] || defaultPrefix, locale);
    }

    if (a.display_name !== b.display_name) {
        return a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase(), locale, { numeric: true });
    }

    return a.name.toLowerCase().localeCompare(b.name.toLowerCase(), locale, { numeric: true });
}

function sortFavorites(locale, a, b) {
    if (a.display_name !== b.display_name) {
        return a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase(), locale, { numeric: true });
    }

    return a.name.toLowerCase().localeCompare(b.name.toLowerCase(), locale, { numeric: true });
}

function not(f) {
    return function () {
        return !f.apply(undefined, arguments);
    };
}

function andX() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return fns.every(function (f) {
            return f.apply(undefined, args);
        });
    };
}

function orX() {
    for (var _len3 = arguments.length, fns = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        fns[_key3] = arguments[_key3];
    }

    return function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return fns.some(function (f) {
            return f.apply(undefined, args);
        });
    };
}

function buildChannels(usersState, channels, missingDirectChannels, teammateNameDisplay, locale) {
    return channels.concat(missingDirectChannels).map(completeDirectChannelInfo.bind(null, usersState, teammateNameDisplay)).filter(isNotDeletedChannel).sort(sortChannelsByDisplayName.bind(null, locale));
}

function buildFavoriteChannels(channels, myPreferences, locale) {
    return channels.filter(isFavoriteChannel.bind(null, myPreferences)).sort(sortFavorites.bind(null, locale));
}

function buildNotFavoriteChannels(channels, myPreferences) {
    return channels.filter(not(isFavoriteChannel.bind(null, myPreferences)));
}

function buildDirectAndGroupChannels(channels, myPreferences, currentUserId) {
    return channels.filter(orX(andX(isGroupChannel, isGroupChannelVisible.bind(null, myPreferences)), andX(isDirectChannel, isDirectChannelVisible.bind(null, currentUserId, myPreferences))));
}

function buildChannelsWithMentions(channels, members, locale) {
    return channels.filter(channelHasMentions.bind(null, members)).sort(sortFavorites.bind(null, locale));
}

function buildUnreadChannels(channels, members, locale) {
    return channels.filter(channelHasUnreadMessages.bind(null, members)).sort(sortFavorites.bind(null, locale));
}

function getUserLocale(userId, profiles) {
    var locale = 'en';
    if (profiles && profiles[userId] && profiles[userId].locale) {
        locale = profiles[userId].locale;
    }

    return locale;
}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function isFunction(obj) {
    return typeof obj === 'function';
}

var EventEmitter = function () {
    function EventEmitter() {
        _classCallCheck(this, EventEmitter);

        this.listeners = new Map();
    }

    _createClass(EventEmitter, [{
        key: 'addListener',
        value: function addListener(label, callback) {
            if (!this.listeners.has(label)) {
                this.listeners.set(label, []);
            }
            this.listeners.get(label).push(callback);
        }
    }, {
        key: 'on',
        value: function on(label, callback) {
            this.addListener(label, callback);
        }
    }, {
        key: 'removeListener',
        value: function removeListener(label, callback) {
            var listeners = this.listeners.get(label);
            var index = void 0;

            if (listeners && listeners.length) {
                index = listeners.reduce(function (i, listener, idx) {
                    return isFunction(listener) && listener === callback ? idx : i;
                }, -1);

                if (index > -1) {
                    listeners.splice(index, 1);
                    this.listeners.set(label, listeners);
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'off',
        value: function off(label, callback) {
            this.removeListener(label, callback);
        }
    }, {
        key: 'emit',
        value: function emit(label) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            var listeners = this.listeners.get(label);

            if (listeners && listeners.length) {
                listeners.forEach(function (listener) {
                    listener.apply(undefined, args);
                });
                return true;
            }
            return false;
        }
    }]);

    return EventEmitter;
}();

exports.default = new EventEmitter();


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};



/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var locales = Array.isArray(data) ? data : [data];

    locales.forEach(function (localeData) {
        if (localeData && localeData.locale) {
            __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
            __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
        }
    });
}

function hasLocaleData(locale) {
    var localeParts = (locale || '').split('-');

    while (localeParts.length > 0) {
        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
            return true;
        }

        localeParts.pop();
    }

    return false;
}

function hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();

    return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
    locale: string,
    formats: object,
    messages: object,
    textComponent: any,

    defaultLocale: string,
    defaultFormats: object
};

var intlFormatPropTypes = {
    formatDate: funcReq,
    formatTime: funcReq,
    formatRelative: funcReq,
    formatNumber: funcReq,
    formatPlural: funcReq,
    formatMessage: funcReq,
    formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
    formatters: object,
    now: funcReq
}));

var messageDescriptorPropTypes = {
    id: string.isRequired,
    description: string,
    defaultMessage: string
};

var dateTimeFormatPropTypes = {
    localeMatcher: localeMatcher,
    formatMatcher: oneOf(['basic', 'best fit']),

    timeZone: string,
    hour12: bool,

    weekday: narrowShortLong,
    era: narrowShortLong,
    year: numeric2digit,
    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    day: numeric2digit,
    hour: numeric2digit,
    minute: numeric2digit,
    second: numeric2digit,
    timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
    localeMatcher: localeMatcher,

    style: oneOf(['decimal', 'currency', 'percent']),
    currency: string,
    currencyDisplay: oneOf(['symbol', 'code', 'name']),
    useGrouping: bool,

    minimumIntegerDigits: number,
    minimumFractionDigits: number,
    maximumFractionDigits: number,
    minimumSignificantDigits: number,
    maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
    style: oneOf(['best fit', 'numeric']),
    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
    style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
    '&': '&amp;',
    '>': '&gt;',
    '<': '&lt;',
    '"': '&quot;',
    '\'': '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
        return ESCAPED_CHARS[match];
    });
}

function filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return whitelist.reduce(function (filtered, name) {
        if (props.hasOwnProperty(name)) {
            filtered[name] = props[name];
        } else if (defaults$$1.hasOwnProperty(name)) {
            filtered[name] = defaults$$1[name];
        }

        return filtered;
    }, {});
}

function invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        intl = _ref.intl;

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
    if (objA === objB) {
        return true;
    }

    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < keysA.length; i++) {
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }

    return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props,
        state = _ref2.state,
        _ref2$context = _ref2.context,
        context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl,
        intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl,
        nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName,
        intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
        _options$withRef = options.withRef,
        withRef = _options$withRef === undefined ? false : _options$withRef;

    var InjectIntl = function (_Component) {
        inherits(InjectIntl, _Component);

        function InjectIntl(props, context) {
            classCallCheck(this, InjectIntl);

            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

            invariantIntlContext(context);
            return _this;
        }

        createClass(InjectIntl, [{
            key: 'getWrappedInstance',
            value: function getWrappedInstance() {
                __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

                return this.refs.wrappedInstance;
            }
        }, {
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
                    ref: withRef ? 'wrappedInstance' : null
                }));
            }
        }]);
        return InjectIntl;
    }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
    InjectIntl.contextTypes = {
        intl: intlShape
    };
    InjectIntl.WrappedComponent = WrappedComponent;


    return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlPluralFormat);

    var useOrdinal = options.style === 'ordinal';
    var pluralFn = findPluralFunction(resolveLocale(locales));

    this.format = function (value) {
        return pluralFn(value, useOrdinal);
    };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
    second: 60, // seconds to minute
    minute: 60, // minutes to hour
    hour: 24, // hours to day
    day: 30, // days to month
    month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
    var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
    var format = formats && formats[type] && formats[type][name];
    if (format) {
        return format;
    }

    if (false) {
        console.error('[React Intl] No ' + type + ' format named: ' + name);
    }
}

function formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'date', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting date.\n' + e);
        }
    }

    return String(date);
}

function formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'time', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
    }

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting time.\n' + e);
        }
    }

    return String(date);
}

function formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting relative time.\n' + e);
        }
    } finally {
        updateRelativeFormatThresholds(oldThresholds);
    }

    return String(date);
}

function formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var defaults$$1 = format && getNamedFormat(formats, 'number', format);
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting number.\n' + e);
        }
    }

    return String(value);
}

function formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;


    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting plural.\n' + e);
        }
    }

    return 'other';
}

function formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats,
        messages = config.messages,
        defaultLocale = config.defaultLocale,
        defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;

    // `id` is a required field of a Message Descriptor.

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;

    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && "production" === 'production') {
        return message || defaultMessage || id;
    }

    var formattedMessage = void 0;

    if (message) {
        try {
            var formatter = state.getMessageFormat(message, locale, formats);

            formattedMessage = formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
            }
        }
    } else {
        if (false) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale, and a default message is in the source.
            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {

                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
            }
        }
    }

    if (!formattedMessage && defaultMessage) {
        try {
            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

            formattedMessage = _formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
            }
        }
    }

    if (!formattedMessage) {
        if (false) {
            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
        }
    }

    return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === 'string' ? escape(value) : value;
        return escaped;
    }, {});

    return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
    formats: {},
    messages: {},
    textComponent: 'span',

    defaultLocale: 'en',
    defaultFormats: {}
};

var IntlProvider = function (_Component) {
    inherits(IntlProvider, _Component);

    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, IntlProvider);

        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

        var intlContext = context.intl;

        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.

        var initialNow = void 0;
        if (isFinite(props.initialNow)) {
            initialNow = Number(props.initialNow);
        } else {
            // When an `initialNow` isn't provided via `props`, look to see an
            // <IntlProvider> exists in the ancestry and call its `now()`
            // function to propagate its value for "now".
            initialNow = intlContext ? intlContext.now() : Date.now();
        }

        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.

        var _ref = intlContext || {},
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
            getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
            getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
            getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
            getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
        } : _ref$formatters;

        _this.state = _extends({}, formatters, {

            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }

    createClass(IntlProvider, [{
        key: 'getConfig',
        value: function getConfig() {
            var intlContext = this.context.intl;

            // Build a whitelisted config object from `props`, defaults, and
            // `context.intl`, if an <IntlProvider> exists in the ancestry.

            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

            // Apply default props. This must be applied last after the props have
            // been resolved and inherited from any <IntlProvider> in the ancestry.
            // This matches how React resolves `defaultProps`.
            for (var propName in defaultProps) {
                if (config[propName] === undefined) {
                    config[propName] = defaultProps[propName];
                }
            }

            if (!hasLocaleData(config.locale)) {
                var _config = config,
                    locale = _config.locale,
                    defaultLocale = _config.defaultLocale,
                    defaultFormats = _config.defaultFormats;


                if (false) {
                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
                }

                // Since there's no registered locale data for `locale`, this will
                // fallback to the `defaultLocale` to make sure things can render.
                // The `messages` are overridden to the `defaultProps` empty object
                // to maintain referential equality across re-renders. It's assumed
                // each <FormattedMessage> contains a `defaultMessage` prop.
                config = _extends({}, config, {
                    locale: defaultLocale,
                    formats: defaultFormats,
                    messages: defaultProps.messages
                });
            }

            return config;
        }
    }, {
        key: 'getBoundFormatFns',
        value: function getBoundFormatFns(config, state) {
            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
                boundFormatFns[name] = format[name].bind(null, config, state);
                return boundFormatFns;
            }, {});
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var config = this.getConfig();

            // Bind intl factories and current config to the format functions.
            var boundFormatFns = this.getBoundFormatFns(config, this.state);

            var _state = this.state,
                now = _state.now,
                formatters = objectWithoutProperties(_state, ['now']);


            return {
                intl: _extends({}, config, boundFormatFns, {
                    formatters: formatters,
                    now: now
                })
            };
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._didDisplay = true;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
        }
    }]);
    return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
    intl: intlShape
};
IntlProvider.childContextTypes = {
    intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
    children: PropTypes.element.isRequired,
    initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
    inherits(FormattedDate, _Component);

    function FormattedDate(props, context) {
        classCallCheck(this, FormattedDate);

        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedDate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatDate = _context$intl.formatDate,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedDate = formatDate(value, this.props);

            if (typeof children === 'function') {
                return children(formattedDate);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedDate
            );
        }
    }]);
    return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
    intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
    inherits(FormattedTime, _Component);

    function FormattedTime(props, context) {
        classCallCheck(this, FormattedTime);

        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedTime, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatTime = _context$intl.formatTime,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedTime = formatTime(value, this.props);

            if (typeof children === 'function') {
                return children(formattedTime);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedTime
            );
        }
    }]);
    return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
    intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
    var absDelta = Math.abs(delta);

    if (absDelta < MINUTE) {
        return 'second';
    }

    if (absDelta < HOUR) {
        return 'minute';
    }

    if (absDelta < DAY) {
        return 'hour';
    }

    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return 'day';
}

function getUnitDelay(units) {
    switch (units) {
        case 'second':
            return SECOND;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        case 'day':
            return DAY;
        default:
            return MAX_TIMER_DELAY;
    }
}

function isSameDate(a, b) {
    if (a === b) {
        return true;
    }

    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();

    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
    inherits(FormattedRelative, _Component);

    function FormattedRelative(props, context) {
        classCallCheck(this, FormattedRelative);

        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

        invariantIntlContext(context);

        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = { now: now };
        return _this;
    }

    createClass(FormattedRelative, [{
        key: 'scheduleNextUpdate',
        value: function scheduleNextUpdate(props, state) {
            var _this2 = this;

            // Cancel and pending update because we're scheduling a new update.
            clearTimeout(this._timer);

            var value = props.value,
                units = props.units,
                updateInterval = props.updateInterval;

            var time = new Date(value).getTime();

            // If the `updateInterval` is falsy, including `0` or we don't have a
            // valid date, then auto updates have been turned off, so we bail and
            // skip scheduling an update.
            if (!updateInterval || !isFinite(time)) {
                return;
            }

            var delta = time - state.now;
            var unitDelay = getUnitDelay(units || selectUnits(delta));
            var unitRemainder = Math.abs(delta % unitDelay);

            // We want the largest possible timer delay which will still display
            // accurate information while reducing unnecessary re-renders. The delay
            // should be until the next "interesting" moment, like a tick from
            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

            this._timer = setTimeout(function () {
                _this2.setState({ now: _this2.context.intl.now() });
            }, delay);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scheduleNextUpdate(this.props, this.state);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextValue = _ref.value;

            // When the `props.value` date changes, `state.now` needs to be updated,
            // and the next update can be rescheduled.
            if (!isSameDate(nextValue, this.props.value)) {
                this.setState({ now: this.context.intl.now() });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.scheduleNextUpdate(nextProps, nextState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatRelative = _context$intl.formatRelative,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

            if (typeof children === 'function') {
                return children(formattedRelative);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedRelative
            );
        }
    }]);
    return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
    intl: intlShape
};
FormattedRelative.defaultProps = {
    updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    updateInterval: PropTypes.number,
    initialNow: PropTypes.any,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
    inherits(FormattedNumber, _Component);

    function FormattedNumber(props, context) {
        classCallCheck(this, FormattedNumber);

        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedNumber, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatNumber = _context$intl.formatNumber,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedNumber = formatNumber(value, this.props);

            if (typeof children === 'function') {
                return children(formattedNumber);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedNumber
            );
        }
    }]);
    return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
    intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
    inherits(FormattedPlural, _Component);

    function FormattedPlural(props, context) {
        classCallCheck(this, FormattedPlural);

        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedPlural, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatPlural = _context$intl.formatPlural,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                other = _props.other,
                children = _props.children;


            var pluralCategory = formatPlural(value, this.props);
            var formattedPlural = this.props[pluralCategory] || other;

            if (typeof children === 'function') {
                return children(formattedPlural);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedPlural
            );
        }
    }]);
    return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
    intl: intlShape
};
FormattedPlural.defaultProps = {
    style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
    value: PropTypes.any.isRequired,

    other: PropTypes.node.isRequired,
    zero: PropTypes.node,
    one: PropTypes.node,
    two: PropTypes.node,
    few: PropTypes.node,
    many: PropTypes.node,

    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
    inherits(FormattedMessage, _Component);

    function FormattedMessage(props, context) {
        classCallCheck(this, FormattedMessage);

        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatMessage = _context$intl.formatMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                values = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var tokenDelimiter = void 0;
            var tokenizedValues = void 0;
            var elements = void 0;

            var hasValues = values && Object.keys(values).length > 0;
            if (hasValues) {
                // Creates a token with a random UID that should not be guessable or
                // conflict with other parts of the `message` string.
                var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

                var generateToken = function () {
                    var counter = 0;
                    return function () {
                        return 'ELEMENT-' + uid + '-' + (counter += 1);
                    };
                }();

                // Splitting with a delimiter to support IE8. When using a regex
                // with a capture group IE8 does not include the capture group in
                // the resulting array.
                tokenDelimiter = '@__' + uid + '__@';
                tokenizedValues = {};
                elements = {};

                // Iterates over the `props` to keep track of any React Element
                // values so they can be represented by the `token` as a placeholder
                // when the `message` is formatted. This allows the formatted
                // message to then be broken-up into parts with references to the
                // React Elements inserted back in.
                Object.keys(values).forEach(function (name) {
                    var value = values[name];

                    if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
                        var token = generateToken();
                        tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                        elements[token] = value;
                    } else {
                        tokenizedValues[name] = value;
                    }
                });
            }

            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

            var nodes = void 0;

            var hasElements = elements && Object.keys(elements).length > 0;
            if (hasElements) {
                // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
                    return !!part;
                }).map(function (part) {
                    return elements[part] || part;
                });
            } else {
                nodes = [formattedMessage];
            }

            if (typeof children === 'function') {
                return children.apply(undefined, toConsumableArray(nodes));
            }

            // Needs to use `createElement()` instead of JSX, otherwise React will
            // warn about a missing `key` prop with rich-text message formatting.
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
        }
    }]);
    return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
    intl: intlShape
};
FormattedMessage.defaultProps = {
    values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
    inherits(FormattedHTMLMessage, _Component);

    function FormattedHTMLMessage(props, context) {
        classCallCheck(this, FormattedHTMLMessage);

        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedHTMLMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatHTMLMessage = _context$intl.formatHTMLMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                rawValues = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

            if (typeof children === 'function') {
                return children(formattedHTMLMessage);
            }

            // Since the message presumably has HTML in it, we need to set
            // `innerHTML` in order for it to be rendered and not escaped by React.
            // To be safe, all string prop values were escaped when formatting the
            // message. It is assumed that the message is not UGC, and came from the
            // developer making it more like a template.
            //
            // Note: There's a perf impact of using this component since there's no
            // way for React to do its virtual DOM diffing.
            var html = { __html: formattedHTMLMessage };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
        }
    }]);
    return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
    intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
    values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);





/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(221);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.handleNewPost = handleNewPost;
exports.flagPost = flagPost;
exports.unflagPost = unflagPost;
exports.getFlaggedPosts = getFlaggedPosts;
exports.getXTeamFlaggedPosts = getXTeamFlaggedPosts;
exports.getPinnedPosts = getPinnedPosts;
exports.getMyLiveStreamPosts = getMyLiveStreamPosts;
exports.getXTeamUnreadPosts = getXTeamUnreadPosts;
exports.getUnreadPosts = getUnreadPosts;
exports.addReaction = addReaction;
exports.removeReaction = removeReaction;
exports.createPost = createPost;
exports.updatePost = updatePost;
exports.emitEmojiPosted = emitEmojiPosted;
exports.deletePost = deletePost;
exports.performSearch = performSearch;
exports.performXTeamSearch = performXTeamSearch;
exports.increasePostVisibility = increasePostVisibility;
exports.getPostsSince = getPostsSince;
exports.searchForTerm = searchForTerm;
exports.pinPost = pinPost;
exports.unpinPost = unpinPost;

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _post_store = __webpack_require__(304);

var _post_store2 = _interopRequireDefault(_post_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_actions = __webpack_require__(123);

var _notification_actions = __webpack_require__(1100);

var _constants = __webpack_require__(12);

var _emoticons = __webpack_require__(478);

var _es = __webpack_require__(49);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _posts2 = __webpack_require__(217);

var PostActions = _interopRequireWildcard(_posts2);

var _channels = __webpack_require__(89);

var _client = __webpack_require__(22);

var _client2 = __webpack_require__(145);

var _action_types = __webpack_require__(2);

var _posts3 = __webpack_require__(218);

var Selectors = _interopRequireWildcard(_posts3);

var _reduxBatchedActions = __webpack_require__(30);

var _channels2 = __webpack_require__(176);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatch = _redux_store2.default.dispatch;

// Redux actions
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

function handleNewPost(post, msg) {
    var websocketMessageProps = {};
    if (msg) {
        websocketMessageProps = msg.data;
    }

    if (_channel_store2.default.getMyMember(post.channel_id)) {
        completePostReceive(post, websocketMessageProps);
    } else {
        (0, _channels.getMyChannelMember)(post.channel_id)(dispatch, getState).then(function () {
            return completePostReceive(post, websocketMessageProps);
        });
    }

    if (msg && msg.data) {
        if (msg.data.channel_type === _constants.Constants.DM_CHANNEL) {
            (0, _user_actions.loadNewDMIfNeeded)(post.channel_id);
        } else if (msg.data.channel_type === _constants.Constants.GM_CHANNEL) {
            (0, _user_actions.loadNewGMIfNeeded)(post.channel_id);
        }
    }
}

function completePostReceive(post, websocketMessageProps) {
    if (post.root_id && Selectors.getPost(getState(), post.root_id) == null) {
        PostActions.getPostThread(post.root_id)(dispatch, getState).then(function (data) {
            dispatchPostActions(post, websocketMessageProps);
            PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);
        });

        return;
    }

    dispatchPostActions(post, websocketMessageProps);
}

function dispatchPostActions(post, websocketMessageProps) {
    var currentChannelId = getState().entities.channels.currentChannelId;


    if (post.channel_id === currentChannelId) {
        dispatch({
            type: _constants.ActionTypes.INCREASE_POST_VISIBILITY,
            data: post.channel_id,
            amount: 1
        });
    }

    // Need manual dispatch to remove pending post
    dispatch({
        type: _action_types.PostTypes.RECEIVED_POSTS,
        data: {
            order: [],
            posts: (0, _defineProperty3.default)({}, post.id, post)
        },
        channelId: post.channel_id
    });

    // Still needed to update unreads
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.RECEIVED_POST,
        post: post,
        websocketMessageProps: websocketMessageProps
    });

    (0, _notification_actions.sendDesktopNotification)(post, websocketMessageProps);
}

function flagPost(postId) {
    PostActions.flagPost(postId)(dispatch, getState);
}

function unflagPost(postId) {
    PostActions.unflagPost(postId)(dispatch, getState);
}

function getFlaggedPosts() {
    _client.Client4.getFlaggedPosts(_user_store2.default.getCurrentId(), '', _team_store2.default.getCurrentId()).then(function (data) {
        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: true,
            is_pinned_posts: false,
            is_unread_posts: false
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getXTeamFlaggedPosts() {
    _client.Client4.getFlaggedPosts(_user_store2.default.getCurrentId(), '', '').then(function (data) {

        (0, _channels2.getChannelsForXTeamPosts)(data.posts, dispatch, getState);

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: true,
            is_pinned_posts: false,
            is_unread_posts: false
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getPinnedPosts() {
    var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel_store2.default.getCurrentId();

    _client.Client4.getPinnedPosts(channelId).then(function (data) {
        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: false,
            is_pinned_posts: true,
            is_unread_posts: false
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getMyLiveStreamPosts(success) {
    _client2.CustomClient4.getVcLivesPost(_user_store2.default.getCurrentId()).then(function (data) {

        (0, _channels2.getChannelsForXTeamPosts)(data.posts, dispatch, getState);

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: false,
            is_pinned_posts: false,
            is_unread_posts: false,
            is_livestream_posts: true
        });

        if (success) {
            success(data);
        }
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getXTeamUnreadPosts(success) {
    _client2.CustomClient4.getUnreadPosts(_user_store2.default.getCurrentId(), '').then(function (data) {

        (0, _channels2.getChannelsForXTeamPosts)(data.posts, dispatch, getState);

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: false,
            is_pinned_posts: false,
            is_unread_posts: true
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);

        if (success) {
            success(data);
        }
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function getUnreadPosts(success) {
    _client2.CustomClient4.getUnreadPosts(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId()).then(function (data) {
        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false
        });

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_flagged_posts: false,
            is_pinned_posts: false,
            is_unread_posts: true
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);

        if (success) {
            success(data);
        }
    }).catch(function () {} //eslint-disable-line no-empty-function
    );
}

function addReaction(channelId, postId, emojiName) {
    PostActions.addReaction(postId, emojiName)(dispatch, getState);
}

function removeReaction(channelId, postId, emojiName) {
    PostActions.removeReaction(postId, emojiName)(dispatch, getState);
}

function createPost(post, files, success) {
    // parse message and emit emoji event
    var emojis = post.message.match(_emoticons.EMOJI_PATTERN);
    if (emojis) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(emojis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var emoji = _step.value;

                var trimmed = emoji.substring(1, emoji.length - 1);
                emitEmojiPosted(trimmed);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    _user_store2.default.setLastPendingPostId(post.pending_post_id);
    PostActions.createPost(post, files)(dispatch, getState).then(function () {
        if (post.root_id) {
            _post_store2.default.storeCommentDraft(post.root_id, null);
        } else {
            _post_store2.default.storeDraft(post.channel_id, null);
        }

        if (success) {
            success();
        }
    });
}

function updatePost(post, success) {
    PostActions.editPost(post)(dispatch, getState).then(function (data) {
        if (data && success) {
            success();
        } else {
            var serverError = getState().requests.posts.editPost.error;
            _app_dispatcher2.default.handleServerAction({
                type: _constants.ActionTypes.RECEIVED_ERROR,
                err: (0, _extends3.default)({ id: serverError.server_error_id }, serverError),
                method: 'editPost'
            });
        }
    });
}

function emitEmojiPosted(emoji) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.EMOJI_POSTED,
        alias: emoji
    });
}

function deletePost(channelId, post, success) {
    var currentUserId = getState().entities.users.currentUserId;


    var hardDelete = false;
    if (post.user_id === currentUserId) {
        hardDelete = true;
    }

    PostActions.deletePost(post, hardDelete)(dispatch, getState).then(function () {
        if (post.id === getState().views.rhs.selectedPostId) {
            dispatch({
                type: _constants.ActionTypes.SELECT_POST,
                postId: ''
            });
        }

        dispatch({
            type: _action_types.PostTypes.REMOVE_POST,
            data: post
        });

        // Needed for search store
        _app_dispatcher2.default.handleViewAction({
            type: _constants.Constants.ActionTypes.REMOVE_POST,
            post: post
        });

        var focusedPostId = getState().views.channel.focusedPostId;

        var channel = getState().entities.channels.channels[post.channel_id];
        if (post.id === focusedPostId && channel) {
            _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + channel.name);
        }

        if (success) {
            success();
        }
    });
}

function performSearch(terms, isMentionSearch, success, error) {
    _client.Client4.searchPosts(_team_store2.default.getCurrentId(), terms, isMentionSearch).then(function (data) {
        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_mention_search: isMentionSearch
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);

        if (success) {
            success(data);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

function performXTeamSearch(terms, isMentionSearch, success, error) {
    _client2.CustomClient4.searchXTeamPosts(_team_store2.default.getCurrentId(), terms, isMentionSearch).then(function (data) {

        (0, _channels2.getChannelsForXTeamPosts)(data.posts, dispatch, getState);

        _app_dispatcher2.default.handleServerAction({
            type: _constants.ActionTypes.RECEIVED_SEARCH,
            results: data,
            is_mention_search: isMentionSearch
        });

        PostActions.getProfilesAndStatusesForPosts(data.posts, dispatch, getState);

        if (success) {
            success(data);
        }
    }).catch(function (err) {
        if (error) {
            error(err);
        }
    });
}

var POST_INCREASE_AMOUNT = _constants.Constants.POST_CHUNK_SIZE / 2;

// Returns true if there are more posts to load
function increasePostVisibility(channelId, focusedPostId) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(doDispatch, doGetState) {
            var currentPostVisibility, page, posts;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!doGetState().views.channel.loadingPosts[channelId]) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', true);

                        case 2:
                            currentPostVisibility = doGetState().views.channel.postVisibility[channelId];

                            if (!(currentPostVisibility >= _constants.Constants.MAX_POST_VISIBILITY)) {
                                _context.next = 5;
                                break;
                            }

                            return _context.abrupt('return', true);

                        case 5:

                            doDispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _constants.ActionTypes.LOADING_POSTS,
                                data: true,
                                channelId: channelId
                            }, {
                                type: _constants.ActionTypes.INCREASE_POST_VISIBILITY,
                                data: channelId,
                                amount: POST_INCREASE_AMOUNT
                            }]));

                            page = Math.floor(currentPostVisibility / POST_INCREASE_AMOUNT);
                            posts = void 0;

                            if (!focusedPostId) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 11;
                            return PostActions.getPostsBefore(channelId, focusedPostId, page, POST_INCREASE_AMOUNT)(dispatch, getState);

                        case 11:
                            posts = _context.sent;
                            _context.next = 17;
                            break;

                        case 14:
                            _context.next = 16;
                            return PostActions.getPosts(channelId, page, POST_INCREASE_AMOUNT)(doDispatch, doGetState);

                        case 16:
                            posts = _context.sent;

                        case 17:

                            doDispatch({
                                type: _constants.ActionTypes.LOADING_POSTS,
                                data: false,
                                channelId: channelId
                            });

                            return _context.abrupt('return', posts.order.length >= POST_INCREASE_AMOUNT);

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getPostsSince(channelId, since) {
    PostActions.getPostsSince(channelId, since)(dispatch, getState);
}

function searchForTerm(term) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.ActionTypes.RECEIVED_SEARCH_TERM,
        term: term,
        do_search: true
    });
}

function pinPost(postId) {
    var _this2 = this;

    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(doDispatch, doGetState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return PostActions.pinPost(postId)(doDispatch, doGetState);

                        case 2:

                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.RECEIVED_POST_PINNED,
                                postId: postId
                            });

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function unpinPost(postId) {
    var _this3 = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(doDispatch, doGetState) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return PostActions.unpinPost(postId)(doDispatch, doGetState);

                        case 2:

                            _app_dispatcher2.default.handleServerAction({
                                type: _constants.ActionTypes.RECEIVED_POST_UNPINNED,
                                postId: postId
                            });

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(221);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeToPrefixMap;

exports.buildDisplayableChannelList = buildDisplayableChannelList;
exports.isFavoriteChannel = isFavoriteChannel;
exports.isFavoriteChannelId = isFavoriteChannelId;
exports.isNotDeletedChannel = isNotDeletedChannel;
exports.isOpenChannel = isOpenChannel;
exports.isPrivateChannel = isPrivateChannel;
exports.isGroupChannel = isGroupChannel;
exports.isGroupChannelVisible = isGroupChannelVisible;
exports.isDirectChannel = isDirectChannel;
exports.isDirectChannelVisible = isDirectChannelVisible;
exports.isWVCChannel = isWVCChannel;
exports.isNotWVCChannel = isNotWVCChannel;
exports.isWVCChildChannel = isWVCChildChannel;
exports.completeDirectChannelInfo = completeDirectChannelInfo;
exports.sortChannelsByDisplayName = sortChannelsByDisplayName;
exports.getChannelDisplayName = getChannelDisplayName;
exports.showCreateOption = showCreateOption;
exports.showManagementOptions = showManagementOptions;
exports.canSetSelfDestructTimer = canSetSelfDestructTimer;
exports.showDeleteOption = showDeleteOption;
exports.canManageMembers = canManageMembers;
exports.buildGroupChannelName = buildGroupChannelName;
exports.getCountsStateFromStores = getCountsStateFromStores;

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _localization_store = __webpack_require__(172);

var _localization_store2 = _interopRequireDefault(_localization_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preferences = _constants2.default.Preferences;

/**
 * Returns list of sorted channels grouped by type. Favorites here is considered as separated type.
 *
 * Example: {
 *  publicChannels: [...],
 *  privateChannels: [...],
 *  directAndGroupChannels: [...],
 *  favoriteChannels: [...]
 * }
 */
function buildDisplayableChannelList(persistentChannels) {
    var missingDirectChannels = createMissingDirectChannels(persistentChannels);

    var channels = persistentChannels.concat(missingDirectChannels).map(completeDirectChannelInfo).filter(isNotDeletedChannel).sort(sortChannelsByDisplayName);

    var favoriteChannels = channels.filter(isFavoriteChannel);
    var notFavoriteChannels = channels.filter(not(isFavoriteChannel));
    var directAndGroupChannels = notFavoriteChannels.filter(orX(andX(isGroupChannel, isGroupChannelVisible), andX(isDirectChannel, isDirectChannelVisible)));

    return {
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

function isFavoriteChannel(channel) {
    return _preference_store2.default.getBool(Preferences.CATEGORY_FAVORITE_CHANNEL, channel.id);
}

function isFavoriteChannelId(channelId) {
    return _preference_store2.default.getBool(Preferences.CATEGORY_FAVORITE_CHANNEL, channelId);
}

function isNotDeletedChannel(channel) {
    return channel.delete_at === 0;
}

function isOpenChannel(channel) {
    return channel.type === _constants2.default.OPEN_CHANNEL;
}

function isPrivateChannel(channel) {
    return channel.type === _constants2.default.PRIVATE_CHANNEL;
}

function isGroupChannel(channel) {
    return channel.type === _constants2.default.GM_CHANNEL;
}

function isGroupChannelVisible(channel) {
    return _preference_store2.default.getBool(Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channel.id);
}

function isDirectChannel(channel) {
    return channel.type === _constants2.default.DM_CHANNEL;
}

function isDirectChannelVisible(channel) {
    var channelId = Utils.getUserIdFromChannelName(channel);

    return _preference_store2.default.getBool(Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, channelId);
}

function isWVCChannel(channel) {
    if (channel.site_id) {
        return true;
    } else {
        return false;
    }
}

function isNotWVCChannel(channel) {
    return !isWVCChannel(channel);
}

function isWVCChildChannel(channel) {
    return channel.site_id && channel.site_session_id && channel.site_session_id !== '';
}

function completeDirectChannelInfo(channel) {
    if (!isDirectChannel(channel)) {
        return channel;
    }

    var dmChannelClone = JSON.parse((0, _stringify2.default)(channel));
    var teammateId = Utils.getUserIdFromChannelName(channel);

    return (0, _assign2.default)(dmChannelClone, {
        display_name: Utils.displayUsername(teammateId),
        teammate_id: teammateId,
        status: _user_store2.default.getStatus(teammateId) || 'offline'
    });
}

var defaultPrefix = 'D'; // fallback for future types
var typeToPrefixMap = (_typeToPrefixMap = {}, (0, _defineProperty3.default)(_typeToPrefixMap, _constants2.default.OPEN_CHANNEL, 'A'), (0, _defineProperty3.default)(_typeToPrefixMap, _constants2.default.PRIVATE_CHANNEL, 'B'), (0, _defineProperty3.default)(_typeToPrefixMap, _constants2.default.DM_CHANNEL, 'C'), (0, _defineProperty3.default)(_typeToPrefixMap, _constants2.default.GM_CHANNEL, 'C'), _typeToPrefixMap);

function sortChannelsByDisplayName(a, b) {
    var locale = _localization_store2.default.getLocale();

    if (a.type !== b.type && typeToPrefixMap[a.type] !== typeToPrefixMap[b.type]) {
        return (typeToPrefixMap[a.type] || defaultPrefix).localeCompare(typeToPrefixMap[b.type] || defaultPrefix, locale);
    }

    var aDisplayName = getChannelDisplayName(a);
    var bDisplayName = getChannelDisplayName(b);

    if (aDisplayName !== null && bDisplayName !== null && aDisplayName !== bDisplayName) {
        return aDisplayName.localeCompare(bDisplayName, locale, { numeric: true });
    }

    return a.name.localeCompare(b.name, locale, { numeric: true });
}

var MAX_CHANNEL_NAME_LENGTH = 64;

function getChannelDisplayName(channel) {
    if (channel.type !== _constants2.default.GM_CHANNEL) {
        return channel.display_name;
    }

    var currentUser = _user_store2.default.getCurrentUser();

    if (currentUser) {
        var displayName = channel.display_name;
        if (displayName.length >= MAX_CHANNEL_NAME_LENGTH) {
            displayName += '...';
        }
        displayName = displayName.replace(currentUser.username + ', ', '').replace(currentUser.username, '').trim();
        if (displayName[displayName.length - 1] === ',') {
            return displayName.slice(0, -1);
        }
        return displayName;
    }

    return channel.display_name;
}

function showCreateOption(channelType, isAdmin, isSystemAdmin) {
    var isTeamGuest = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (channelType === _constants2.default.OPEN_CHANNEL) {
        if (global.window.mm_config.RestrictPublicChannelCreation === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        } else if (global.window.mm_config.RestrictPublicChannelCreation === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
    } else if (channelType === _constants2.default.PRIVATE_CHANNEL) {
        if (global.window.mm_config.RestrictPrivateChannelCreation === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        } else if (global.window.mm_config.RestrictPrivateChannelCreation === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
    } else if (channelType === _constants2.default.WVC_CHANNEL) {
        if (global.window.mm_config.RestrictWVCCreation === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        } else if (global.window.mm_config.RestrictWVCCreation === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
    }

    if (isTeamGuest && !isAdmin && !isSystemAdmin) {
        return false;
    }

    return true;
}

function showManagementOptions(channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    var isChannelGuest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants2.default.OPEN_CHANNEL) {
        if (global.window.mm_config.RestrictPublicChannelManagement === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelManagement === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelManagement === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants2.default.PRIVATE_CHANNEL) {
        if (global.window.mm_config.RestrictPrivateChannelManagement === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelManagement === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelManagement === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    if (isChannelGuest && !isAdmin && !isSystemAdmin) {
        return false;
    }

    return true;
}

function canSetSelfDestructTimer(channel, isAdmin, isSystemAdmin, isChannelAdmin) {
    var isChannelGuest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants2.default.OPEN_CHANNEL) {
        if (global.window.mm_config.RestrictPublicChannelSelfDestruct === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelSelfDestruct === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelSelfDestruct === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants2.default.PRIVATE_CHANNEL) {
        if (global.window.mm_config.RestrictPrivateChannelSelfDestruct === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelSelfDestruct === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelSelfDestruct === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    if (isChannelGuest && !isAdmin && !isSystemAdmin) {
        return false;
    }

    return true;
}

function showDeleteOption(channel, isAdmin, isSystemAdmin, isChannelAdmin, userCount) {
    var isChannelGuest = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (_channel_store2.default.isDefault(channel)) {
        return false;
    }

    if (channel.type === _constants2.default.OPEN_CHANNEL) {
        if (global.window.mm_config.RestrictPublicChannelDeletion === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelDeletion === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPublicChannelDeletion === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    } else if (channel.type === _constants2.default.PRIVATE_CHANNEL) {
        if (userCount === 1) {
            return true;
        }
        if (global.window.mm_config.RestrictPrivateChannelDeletion === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelDeletion === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelDeletion === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isAdmin) {
            return false;
        }
    }

    if (isChannelGuest && !isAdmin && !isSystemAdmin) {
        return false;
    }

    return true;
}

function canManageMembers(channel, isSystemAdmin, isTeamAdmin, isChannelAdmin) {
    var isChannelGuest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (global.window.mm_license.IsLicensed !== 'true') {
        return true;
    }

    if (channel.type === _constants2.default.PRIVATE_CHANNEL) {
        if (global.window.mm_config.RestrictPrivateChannelManageMembers === _constants2.default.PERMISSIONS_SYSTEM_ADMIN && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelManageMembers === _constants2.default.PERMISSIONS_TEAM_ADMIN && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }
        if (global.window.mm_config.RestrictPrivateChannelManageMembers === _constants2.default.PERMISSIONS_CHANNEL_ADMIN && !isChannelAdmin && !isTeamAdmin && !isSystemAdmin) {
            return false;
        }
    } else if (channel.type === _constants2.default.OPEN_CHANNEL) {
        return isSystemAdmin || isTeamAdmin || isChannelAdmin;
    }

    if (isChannelGuest && !isTeamAdmin && !isSystemAdmin) {
        return false;
    }

    return true;
}

function buildGroupChannelName(channelId) {
    var profiles = _user_store2.default.getProfileListInChannel(channelId, true);
    var displayName = '';
    for (var i = 0; i < profiles.length; i++) {
        displayName += Utils.displayUsernameForUser(profiles[i]);
        if (i !== profiles.length - 1) {
            displayName += ', ';
        }
    }

    return displayName;
}

function getCountsStateFromStores() {
    var team = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _team_store2.default.getCurrent();
    var teamMembers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _team_store2.default.getMyTeamMembers();
    var unreadCounts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _channel_store2.default.getUnreadCounts();

    var mentionCount = 0;
    var messageCount = 0;

    teamMembers.forEach(function (member) {
        if (member.team_id !== _team_store2.default.getCurrentId()) {
            mentionCount += member.mention_count || 0;
            messageCount += member.msg_count || 0;
        }
    });

    (0, _keys2.default)(unreadCounts).forEach(function (chId) {
        var channel = _channel_store2.default.get(chId);

        if (channel && (channel.type === _constants2.default.DM_CHANNEL || channel.type === _constants2.default.GM_CHANNEL || channel.team_id === team.id)) {
            messageCount += unreadCounts[chId].msgs;
            mentionCount += unreadCounts[chId].mentions;
        }
    });

    return { mentionCount: mentionCount, messageCount: messageCount };
}

/*
 * not exported helpers
 */

function createMissingDirectChannels(channels) {
    var directChannelsDisplayPreferences = _preference_store2.default.getCategory(Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    return (0, _from2.default)(directChannelsDisplayPreferences).filter(function (entry) {
        return entry[1] === 'true';
    }).map(function (entry) {
        return entry[0];
    }).filter(function (teammateId) {
        return !channels.some(Utils.isDirectChannelForUser.bind(null, teammateId));
    }).map(createFakeChannelCurried(_user_store2.default.getCurrentId()));
}

function createFakeChannel(userId, otherUserId) {
    return {
        name: Utils.getDirectChannelName(userId, otherUserId),
        last_post_at: 0,
        total_msg_count: 0,
        type: _constants2.default.DM_CHANNEL,
        fake: true
    };
}

function createFakeChannelCurried(userId) {
    return function (otherUserId) {
        return createFakeChannel(userId, otherUserId);
    };
}

function not(f) {
    return function () {
        return !f.apply(undefined, arguments);
    };
}

function orX() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return fns.some(function (f) {
            return f.apply(undefined, args);
        });
    };
}

function andX() {
    for (var _len3 = arguments.length, fns = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        fns[_key3] = arguments[_key3];
    }

    return function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return fns.every(function (f) {
            return f.apply(undefined, args);
        });
    };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var pIE            = __webpack_require__(160)
  , createDesc     = __webpack_require__(157)
  , toIObject      = __webpack_require__(90)
  , toPrimitive    = __webpack_require__(281)
  , has            = __webpack_require__(119)
  , IE8_DOM_DEFINE = __webpack_require__(398)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(77) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var ErrorStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(ErrorStoreClass, _EventEmitter);

    function ErrorStoreClass() {
        (0, _classCallCheck3.default)(this, ErrorStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorStoreClass.__proto__ || (0, _getPrototypeOf2.default)(ErrorStoreClass)).call(this));

        _this.emitChange = _this.emitChange.bind(_this);
        _this.addChangeListener = _this.addChangeListener.bind(_this);
        _this.removeChangeListener = _this.removeChangeListener.bind(_this);
        _this.getLastError = _this.getLastError.bind(_this);
        _this.storeLastError = _this.storeLastError.bind(_this);
        _this.getIgnoreNotification = _this.getIgnoreNotification.bind(_this);
        _this.ignore_notification = false;
        return _this;
    }

    (0, _createClass3.default)(ErrorStoreClass, [{
        key: 'getIgnoreNotification',
        value: function getIgnoreNotification() {
            return this.ignore_notification;
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'getLastError',
        value: function getLastError() {
            return _browser_store2.default.getGlobalItem('last_error');
        }
    }, {
        key: 'storeLastError',
        value: function storeLastError(error) {
            _browser_store2.default.setGlobalItem('last_error', error);
        }
    }, {
        key: 'getConnectionErrorCount',
        value: function getConnectionErrorCount() {
            var count = _browser_store2.default.getGlobalItem('last_error_conn');

            if (count == null) {
                return 0;
            }

            return count;
        }
    }, {
        key: 'setConnectionErrorCount',
        value: function setConnectionErrorCount(count) {
            _browser_store2.default.setGlobalItem('last_error_conn', count);
        }
    }, {
        key: 'clearError',
        value: function clearError(message) {
            var lastError = this.getLastError();

            if (lastError && lastError.message === message) {
                this.clearLastError(true);
            }
        }
    }, {
        key: 'clearLastError',
        value: function clearLastError(force) {
            var lastError = this.getLastError();

            // preview message can only be cleared by clearNotificationError
            if (!force && lastError && lastError.notification) {
                return;
            }

            _browser_store2.default.removeGlobalItem('last_error');
            _browser_store2.default.removeGlobalItem('last_error_conn');
            if (lastError) {
                this.emitChange();
            }
        }
    }, {
        key: 'clearNotificationError',
        value: function clearNotificationError() {
            this.ignore_notification = true;
            this.storeLastError('');
            this.clearLastError();
        }
    }]);
    return ErrorStoreClass;
}(_events2.default);

var ErrorStore = new ErrorStoreClass();

ErrorStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVED_ERROR:
            ErrorStore.storeLastError(action.err);
            ErrorStore.emitChange();
            break;

        default:
    }
});

exports.default = ErrorStore;

window.ErrorStore = ErrorStore;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProfilesAndStatusesForPosts = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Note that getProfilesAndStatusesForPosts can take either an array of posts or a map of ids to posts
var getProfilesAndStatusesForPosts = exports.getProfilesAndStatusesForPosts = function () {
    var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(posts, dispatch, getState) {
        var state, _state$entities$users, currentUserId, profiles, statuses, userIdsToLoad, statusesToLoad, promises, usernamesToLoad;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        if (posts) {
                            _context19.next = 2;
                            break;
                        }

                        return _context19.abrupt('return', Promise.resolve());

                    case 2:
                        state = getState();
                        _state$entities$users = state.entities.users, currentUserId = _state$entities$users.currentUserId, profiles = _state$entities$users.profiles, statuses = _state$entities$users.statuses;
                        userIdsToLoad = new Set();
                        statusesToLoad = new Set();


                        Object.values(posts).forEach(function (post) {
                            var userId = post.user_id;

                            if (!statuses[userId]) {
                                statusesToLoad.add(userId);
                            }

                            if (userId === currentUserId) {
                                return;
                            }

                            if (!profiles[userId]) {
                                userIdsToLoad.add(userId);
                            }
                        });

                        promises = [];

                        if (userIdsToLoad.size > 0) {
                            promises.push((0, _users2.getProfilesByIds)(Array.from(userIdsToLoad))(dispatch, getState));
                        }

                        if (statusesToLoad.size > 0) {
                            promises.push((0, _users2.getStatusesByIds)(Array.from(statusesToLoad))(dispatch, getState));
                        }

                        // Do this after firing the other requests as it's more expensive
                        usernamesToLoad = getNeededAtMentionedUsernames(state, posts);


                        if (usernamesToLoad.size > 0) {
                            promises.push((0, _users2.getProfilesByUsernames)(Array.from(usernamesToLoad))(dispatch, getState));
                        }

                        return _context19.abrupt('return', Promise.all(promises));

                    case 13:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function getProfilesAndStatusesForPosts(_x49, _x50, _x51) {
        return _ref19.apply(this, arguments);
    };
}();

exports.createPost = createPost;
exports.deletePost = deletePost;
exports.editPost = editPost;
exports.pinPost = pinPost;
exports.unpinPost = unpinPost;
exports.addReaction = addReaction;
exports.removeReaction = removeReaction;
exports.getReactionsForPost = getReactionsForPost;
exports.flagPost = flagPost;
exports.getPostThread = getPostThread;
exports.getPostThreadWithRetry = getPostThreadWithRetry;
exports.getPosts = getPosts;
exports.getPostsWithRetry = getPostsWithRetry;
exports.getPostsSince = getPostsSince;
exports.getPostsSinceWithRetry = getPostsSinceWithRetry;
exports.getPostsBefore = getPostsBefore;
exports.getPostsBeforeWithRetry = getPostsBeforeWithRetry;
exports.getPostsAfter = getPostsAfter;
exports.getPostsAfterWithRetry = getPostsAfterWithRetry;
exports.getNeededAtMentionedUsernames = getNeededAtMentionedUsernames;
exports.removePost = removePost;
exports.selectPost = selectPost;
exports.unflagPost = unflagPost;
exports.getOpenGraphMetadata = getOpenGraphMetadata;

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _users = __webpack_require__(88);

var _posts2 = __webpack_require__(218);

var Selectors = _interopRequireWildcard(_posts2);

var _helpers = __webpack_require__(67);

var _errors = __webpack_require__(68);

var _preferences = __webpack_require__(146);

var _users2 = __webpack_require__(78);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function createPost(post) {
    var _this = this;

    var files = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, currentUserId, timestamp, pendingPostId, newPost, fileIds;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            timestamp = Date.now();
                            pendingPostId = post.pending_post_id || currentUserId + ':' + timestamp;
                            newPost = _extends({}, post, {
                                pending_post_id: pendingPostId,
                                create_at: timestamp,
                                update_at: timestamp
                            });

                            // We are retrying a pending post that had files

                            if (newPost.file_ids && !files.length) {
                                files = newPost.file_ids.map(function (id) {
                                    return state.entities.files.files[id];
                                }); // eslint-disable-line
                            }

                            if (files.length) {
                                fileIds = files.map(function (file) {
                                    return file.id;
                                });


                                newPost = _extends({}, newPost, {
                                    file_ids: fileIds
                                });

                                dispatch({
                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                    postId: pendingPostId,
                                    data: files
                                });
                            }

                            dispatch({
                                type: _action_types.PostTypes.RECEIVED_POST,
                                data: _extends({
                                    id: pendingPostId
                                }, newPost),
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.createPost(_extends({}, newPost, { create_at: 0 }));
                                        },
                                        commit: function commit(success, payload) {
                                            // Use RECEIVED_POSTS to clear pending posts
                                            var actions = [{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: {
                                                    order: [],
                                                    posts: _defineProperty({}, payload.id, payload)
                                                },
                                                channelId: payload.channel_id
                                            }];

                                            if (files) {
                                                actions.push({
                                                    type: _action_types.FileTypes.RECEIVED_FILES_FOR_POST,
                                                    postId: payload.id,
                                                    data: files
                                                });
                                            }

                                            actions.push({
                                                type: _action_types.PostTypes.CREATE_POST_SUCCESS
                                            });

                                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
                                        },
                                        maxRetry: 0,
                                        offlineRollback: true,
                                        rollback: function rollback(success, error) {
                                            var data = _extends({}, newPost, {
                                                id: pendingPostId,
                                                failed: true
                                            });

                                            var actions = [{ type: _action_types.PostTypes.CREATE_POST_FAILURE, error: error }];

                                            // If the failure was because: the root post was deleted or
                                            // TownSquareIsReadOnly=true then remove the post
                                            if (error.server_error_id === 'api.post.create_post.root_id.app_error' || error.server_error_id === 'api.post.create_post.town_square_read_only') {
                                                removePost(data)(dispatch, getState);
                                            } else {
                                                actions.push({
                                                    type: _action_types.PostTypes.RECEIVED_POST,
                                                    data: data
                                                });
                                            }

                                            dispatch((0, _reduxBatchedActions.batchActions)(actions));
                                        }
                                    }
                                }
                            });

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function deletePost(post) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
            var delPost;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            delPost = _extends({}, post);


                            dispatch({
                                type: _action_types.PostTypes.POST_DELETED,
                                data: delPost,
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.deletePost(post.id);
                                        },
                                        commit: { type: _action_types.PostTypes.POST_DELETED },
                                        rollback: {
                                            type: _action_types.PostTypes.RECEIVED_POST,
                                            data: delPost
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function editPost(post) {
    return (0, _helpers.bindClientFunc)(_client.Client4.patchPost, _action_types.PostTypes.EDIT_POST_REQUEST, [_action_types.PostTypes.RECEIVED_POST, _action_types.PostTypes.EDIT_POST_SUCCESS], _action_types.PostTypes.EDIT_POST_FAILURE, post);
}

function pinPost(postId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var posts, actions, post;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.EDIT_POST_REQUEST }, getState);
                            posts = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.pinPost(postId);

                        case 5:
                            posts = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.EDIT_POST_FAILURE, error: _context3.t0 }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:
                            actions = [{
                                type: _action_types.PostTypes.EDIT_POST_SUCCESS
                            }];
                            post = Selectors.getPost(getState(), postId);

                            if (post) {
                                actions.push({
                                    type: _action_types.PostTypes.RECEIVED_POST,
                                    data: _extends({}, post, { is_pinned: true })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context3.abrupt('return', posts);

                        case 18:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function unpinPost(postId) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var posts, actions, post;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.EDIT_POST_REQUEST }, getState);
                            posts = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.unpinPost(postId);

                        case 5:
                            posts = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.EDIT_POST_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', null);

                        case 13:
                            actions = [{
                                type: _action_types.PostTypes.EDIT_POST_SUCCESS
                            }];
                            post = Selectors.getPost(getState(), postId);

                            if (post) {
                                actions.push({
                                    type: _action_types.PostTypes.RECEIVED_POST,
                                    data: _extends({}, post, { is_pinned: false })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context4.abrupt('return', posts);

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function addReaction(postId, emojiName) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var currentUserId, reaction;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            reaction = void 0;
                            _context5.prev = 3;
                            _context5.next = 6;
                            return _client.Client4.addReaction(currentUserId, postId, emojiName);

                        case 6:
                            reaction = _context5.sent;
                            _context5.next = 14;
                            break;

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context5.t0 }, (0, _errors.logError)(_context5.t0)(dispatch)]), getState);
                            return _context5.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.RECEIVED_REACTION,
                                data: reaction
                            }]));

                            return _context5.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[3, 9]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function removeReaction(postId, emojiName) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var currentUserId;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.removeReaction(currentUserId, postId, emojiName);

                        case 5:
                            _context6.next = 12;
                            break;

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context6.t0 }, (0, _errors.logError)(_context6.t0)(dispatch)]), getState);
                            return _context6.abrupt('return', null);

                        case 12:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.REACTION_DELETED,
                                data: { user_id: currentUserId, post_id: postId, emoji_name: emojiName }
                            }]));

                            return _context6.abrupt('return', true);

                        case 14:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[2, 7]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function getReactionsForPost(postId) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var reactions;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.REACTION_REQUEST }, getState);

                            reactions = void 0;
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.getReactionsForPost(postId);

                        case 5:
                            reactions = _context7.sent;
                            _context7.next = 13;
                            break;

                        case 8:
                            _context7.prev = 8;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.REACTION_FAILURE, error: _context7.t0 }, (0, _errors.logError)(_context7.t0)(dispatch)]), getState);
                            return _context7.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.REACTION_SUCCESS
                            }, {
                                type: _action_types.PostTypes.RECEIVED_REACTIONS,
                                data: reactions,
                                postId: postId
                            }]));

                            return _context7.abrupt('return', reactions);

                        case 15:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[2, 8]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function flagPost(postId) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FLAGGED_POST,
                                name: postId,
                                value: 'true'
                            };


                            _client.Client4.trackEvent('action', 'action_posts_flag');

                            (0, _preferences.savePreferences)(currentUserId, [preference])(dispatch, getState);

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getPostThread(postId) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var posts, post;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POST_THREAD_REQUEST }, getState);

                            posts = void 0;
                            _context9.prev = 2;
                            _context9.next = 5;
                            return _client.Client4.getPostThread(postId);

                        case 5:
                            posts = _context9.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context9.next = 14;
                            break;

                        case 9:
                            _context9.prev = 9;
                            _context9.t0 = _context9['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POST_THREAD_FAILURE, error: _context9.t0 }, (0, _errors.logError)(_context9.t0)(dispatch)]), getState);
                            return _context9.abrupt('return', null);

                        case 14:
                            post = posts.posts[postId];


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: post.channel_id,
                                skipAddToChannel: true
                            }, {
                                type: _action_types.PostTypes.GET_POST_THREAD_SUCCESS
                            }]), getState);

                            return _context9.abrupt('return', posts);

                        case 17:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[2, 9]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function getPostThreadWithRetry(postId) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POST_THREAD_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POST_THREAD_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostThread(postId);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            var post = posts[postId];
                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: post.channel_id,
                                                skipAddToChannel: true
                                            }, {
                                                type: _action_types.PostTypes.GET_POST_THREAD_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POST_THREAD_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POST_THREAD_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getPosts(channelId) {
    var _this11 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_REQUEST }, getState);
                            posts = void 0;
                            _context11.prev = 2;
                            _context11.next = 5;
                            return _client.Client4.getPosts(channelId, page, perPage);

                        case 5:
                            posts = _context11.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context11.next = 14;
                            break;

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', posts);

                        case 16:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[2, 9]]);
        }));

        return function (_x23, _x24) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getPostsWithRetry(channelId) {
    var _this12 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPosts(channelId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }));

        return function (_x27, _x28) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getPostsSince(channelId, since) {
    var _this13 = this;

    return function () {
        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_SINCE_REQUEST }, getState);

                            posts = void 0;
                            _context13.prev = 2;
                            _context13.next = 5;
                            return _client.Client4.getPostsSince(channelId, since);

                        case 5:
                            posts = _context13.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context13.next = 14;
                            break;

                        case 9:
                            _context13.prev = 9;
                            _context13.t0 = _context13['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, error: _context13.t0 }, (0, _errors.logError)(_context13.t0)(dispatch)]), getState);
                            return _context13.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', posts);

                        case 16:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[2, 9]]);
        }));

        return function (_x29, _x30) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getPostsSinceWithRetry(channelId, since) {
    var _this14 = this;

    return function () {
        var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_SINCE_REQUEST }, getState);

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_SINCE_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsSince(channelId, since);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_SINCE_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }));

        return function (_x31, _x32) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function getPostsBefore(channelId, postId) {
    var _this15 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_BEFORE_REQUEST }, getState);

                            posts = void 0;
                            _context15.prev = 2;
                            _context15.next = 5;
                            return _client.Client4.getPostsBefore(channelId, postId, page, perPage);

                        case 5:
                            posts = _context15.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context15.next = 14;
                            break;

                        case 9:
                            _context15.prev = 9;
                            _context15.t0 = _context15['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, error: _context15.t0 }, (0, _errors.logError)(_context15.t0)(dispatch)]), getState);
                            return _context15.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS
                            }]), getState);

                            return _context15.abrupt('return', posts);

                        case 16:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[2, 9]]);
        }));

        return function (_x35, _x36) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getPostsBeforeWithRetry(channelId, postId) {
    var _this16 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsBefore(channelId, postId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }));

        return function (_x39, _x40) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function getPostsAfter(channelId, postId) {
    var _this17 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var posts;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.GET_POSTS_AFTER_REQUEST }, getState);

                            posts = void 0;
                            _context17.prev = 2;
                            _context17.next = 5;
                            return _client.Client4.getPostsAfter(channelId, postId, page, perPage);

                        case 5:
                            posts = _context17.sent;

                            getProfilesAndStatusesForPosts(posts.posts, dispatch, getState);
                            _context17.next = 14;
                            break;

                        case 9:
                            _context17.prev = 9;
                            _context17.t0 = _context17['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, error: _context17.t0 }, (0, _errors.logError)(_context17.t0)(dispatch)]), getState);
                            return _context17.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                data: posts,
                                channelId: channelId
                            }, {
                                type: _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS
                            }]), getState);

                            return _context17.abrupt('return', posts);

                        case 16:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[2, 9]]);
        }));

        return function (_x43, _x44) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getPostsAfterWithRetry(channelId, postId) {
    var _this18 = this;

    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.Posts.POST_CHUNK_SIZE;

    return function () {
        var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_AFTER_REQUEST
                            });

                            dispatch({
                                type: _action_types.PostTypes.GET_POSTS_AFTER_WITH_RETRY_ATTEMPT,
                                data: {},
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.getPostsAfter(channelId, postId, page, perPage);
                                        },
                                        commit: function commit(success, payload) {
                                            var posts = payload.posts;

                                            getProfilesAndStatusesForPosts(posts, dispatch, getState);

                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.PostTypes.RECEIVED_POSTS,
                                                data: payload,
                                                channelId: channelId
                                            }, {
                                                type: _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS
                                            }]), getState);
                                        },
                                        maxRetry: 2,
                                        cancel: true,
                                        onRetryScheduled: function onRetryScheduled() {
                                            dispatch({
                                                type: _action_types.PostTypes.GET_POSTS_AFTER_WITH_RETRY_ATTEMPT
                                            });
                                        },
                                        rollback: function rollback(success, error) {
                                            (0, _helpers.forceLogoutIfNecessary)(error, dispatch);
                                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, error: error }, (0, _errors.logError)(error)(dispatch)]), getState);
                                        }
                                    }
                                }
                            });

                        case 2:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }));

        return function (_x47, _x48) {
            return _ref18.apply(this, arguments);
        };
    }();
}function getNeededAtMentionedUsernames(state, posts) {
    var usersByUsername = void 0; // Populate this lazily since it's relatively expensive

    var usernamesToLoad = new Set();

    Object.values(posts).forEach(function (post) {
        if (!post.message.includes('@')) {
            return;
        }

        if (!usersByUsername) {
            usersByUsername = (0, _users.getUsersByUsername)(state);
        }

        var pattern = /\B@(([a-z0-9_.-]*[a-z0-9_])[.-]*)/gi;

        var match = void 0;
        while ((match = pattern.exec(post.message)) !== null) {
            // match[1] is the matched mention including trailing punctuation
            // match[2] is the matched mention without trailing punctuation
            if (_constants.General.SPECIAL_MENTIONS.indexOf(match[2]) !== -1) {
                continue;
            }

            if (usersByUsername[match[1]] || usersByUsername[match[2]]) {
                // We have the user, go to the next match
                continue;
            }

            // If there's no trailing punctuation, this will only add 1 item to the set
            usernamesToLoad.add(match[1]);
            usernamesToLoad.add(match[2]);
        }
    });

    return usernamesToLoad;
}

function removePost(post) {
    var _this19 = this;

    return function () {
        var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.REMOVE_POST,
                                data: _extends({}, post)
                            }, getState);

                        case 1:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this19);
        }));

        return function (_x52, _x53) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function selectPost(postId) {
    var _this20 = this;

    return function () {
        var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({
                                type: _action_types.PostTypes.RECEIVED_POST_SELECTED,
                                data: postId
                            }, getState);

                        case 1:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this20);
        }));

        return function (_x54, _x55) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function unflagPost(postId) {
    var _this21 = this;

    return function () {
        var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            var currentUserId, preference;
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            currentUserId = getState().entities.users.currentUserId;
                            preference = {
                                user_id: currentUserId,
                                category: _constants.Preferences.CATEGORY_FLAGGED_POST,
                                name: postId
                            };


                            _client.Client4.trackEvent('action', 'action_posts_unflag');

                            (0, _preferences.deletePreferences)(currentUserId, [preference])(dispatch, getState);

                        case 4:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this21);
        }));

        return function (_x56, _x57) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function getOpenGraphMetadata(url) {
    var _this22 = this;

    return function () {
        var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({ type: _action_types.PostTypes.OPEN_GRAPH_REQUEST }, getState);

                            data = void 0;
                            _context23.prev = 2;
                            _context23.next = 5;
                            return _client.Client4.getOpenGraphMetadata(url);

                        case 5:
                            data = _context23.sent;
                            _context23.next = 13;
                            break;

                        case 8:
                            _context23.prev = 8;
                            _context23.t0 = _context23['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context23.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.PostTypes.OPEN_GRAPH_FAILURE, error: _context23.t0 }, (0, _errors.logError)(_context23.t0)(dispatch)]), getState);
                            return _context23.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.PostTypes.RECEIVED_OPEN_GRAPH_METADATA,
                                data: data,
                                url: url
                            }, {
                                type: _action_types.PostTypes.OPEN_GRAPH_SUCCESS
                            }]), getState);

                            return _context23.abrupt('return', data);

                        case 15:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this22, [[2, 8]]);
        }));

        return function (_x58, _x59) {
            return _ref23.apply(this, arguments);
        };
    }();
}

exports.default = {
    createPost: createPost,
    editPost: editPost,
    deletePost: deletePost,
    removePost: removePost,
    getPostThread: getPostThread,
    getPostThreadWithRetry: getPostThreadWithRetry,
    getPosts: getPosts,
    getPostsWithRetry: getPostsWithRetry,
    getPostsSince: getPostsSince,
    getPostsSinceWithRetry: getPostsSinceWithRetry,
    getPostsBefore: getPostsBefore,
    getPostsBeforeWithRetry: getPostsBeforeWithRetry,
    getPostsAfter: getPostsAfter,
    getPostsAfterWithRetry: getPostsAfterWithRetry,
    selectPost: selectPost
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSearchResults = exports.getPostsInCurrentChannel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.getAllPosts = getAllPosts;
exports.getPost = getPost;
exports.getReactionsForPosts = getReactionsForPosts;
exports.makeGetReactionsForPost = makeGetReactionsForPost;
exports.getOpenGraphMetadata = getOpenGraphMetadata;
exports.getOpenGraphMetadataForUrl = getOpenGraphMetadataForUrl;
exports.makeGetPostsInChannel = makeGetPostsInChannel;
exports.makeGetPostsAroundPost = makeGetPostsAroundPost;
exports.makeGetPostsForThread = makeGetPostsForThread;
exports.makeGetCommentCountForPost = makeGetCommentCountForPost;

var _reselect = __webpack_require__(93);

var _preferences = __webpack_require__(105);

var _users = __webpack_require__(88);

var _constants = __webpack_require__(8);

var _post_utils = __webpack_require__(434);

var _preference_utils = __webpack_require__(142);

function getAllPosts(state) {
    return state.entities.posts.posts;
}

function getPost(state, postId) {
    return getAllPosts(state)[postId];
}

function getReactionsForPosts(state) {
    return state.entities.posts.reactions;
}

function makeGetReactionsForPost() {
    return (0, _reselect.createSelector)(getReactionsForPosts, function (state, postId) {
        return postId;
    }, function (reactions, postId) {
        return Object.values(reactions[postId] || {});
    });
}

function getOpenGraphMetadata(state) {
    return state.entities.posts.openGraph;
}

function getOpenGraphMetadataForUrl(state, url) {
    return state.entities.posts.openGraph[url];
}

function getPostIdsInCurrentChannel(state) {
    return state.entities.posts.postsInChannel[state.entities.channels.currentChannelId] || [];
}

var getPostsInCurrentChannel = exports.getPostsInCurrentChannel = (0, _reselect.createSelector)(getAllPosts, getPostIdsInCurrentChannel, function (posts, postIds) {
    return postIds.map(function (id) {
        return posts[id];
    });
});

function formatPostInChannel(post, previousPost, index, allPosts, postIds, currentUser) {
    var isFirstReply = false;
    var isLastReply = false;
    var commentedOnPost = void 0;

    if (post.root_id) {
        if (previousPost.root_id !== post.root_id) {
            // Post is the first reply in a list of consecutive replies
            isFirstReply = true;

            if (previousPost.id !== post.root_id) {
                commentedOnPost = allPosts[post.root_id];
            }
        }

        if (index - 1 < 0 || allPosts[postIds[index - 1]].root_id !== post.root_id) {
            // Post is the last reply in a list of consecutive replies
            isLastReply = true;
        }
    }

    var previousPostIsComment = false;
    if (previousPost.root_id) {
        previousPostIsComment = true;
    }

    var postFromWebhook = Boolean(post.props && post.props.from_webhook);
    var prevPostFromWebhook = Boolean(previousPost.props && previousPost.props.from_webhook);
    var consecutivePostByUser = false;
    if (previousPost.user_id === post.user_id && post.create_at - previousPost.create_at <= _constants.Posts.POST_COLLAPSE_TIMEOUT && !postFromWebhook && !prevPostFromWebhook && !(0, _post_utils.isSystemMessage)(post) && !(0, _post_utils.isSystemMessage)(previousPost)) {
        // The last post and this post were made by the same user within some time
        consecutivePostByUser = true;
    }

    var replyCount = 0;
    var threadRepliedToByCurrentUser = false;
    var threadCreatedByCurrentUser = false;
    var rootId = post.root_id || post.id;
    postIds.forEach(function (pid) {
        var p = allPosts[pid];
        if (p.root_id === rootId) {
            replyCount += 1;

            if (p.user_id === currentUser.id) {
                threadRepliedToByCurrentUser = true;
            }
        }

        if (p.id === rootId && p.user_id === currentUser.id) {
            threadCreatedByCurrentUser = true;
        }
    });

    var isCommentMention = false;
    var commentsNotifyLevel = 'never';
    if (currentUser && currentUser.notify_props && currentUser.notify_props.comments) {
        commentsNotifyLevel = currentUser.notify_props.comments;
    }

    var notCurrentUser = post.user_id !== currentUser.id || post.props && post.props.from_webhook;
    if (notCurrentUser) {
        if (commentsNotifyLevel === 'any' && (threadCreatedByCurrentUser || threadRepliedToByCurrentUser)) {
            isCommentMention = true;
        } else if (commentsNotifyLevel === 'root' && threadCreatedByCurrentUser) {
            isCommentMention = true;
        }
    }

    return _extends({}, post, {
        isFirstReply: isFirstReply,
        isLastReply: isLastReply,
        previousPostIsComment: previousPostIsComment,
        commentedOnPost: commentedOnPost,
        consecutivePostByUser: consecutivePostByUser,
        replyCount: replyCount,
        isCommentMention: isCommentMention
    });
}

function makeGetPostsInChannel() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, channelId) {
        return state.entities.posts.postsInChannel[channelId];
    }, _users.getCurrentUser, _preferences.getMyPreferences, function (allPosts, postIds, currentUser, myPreferences) {
        if (!postIds) {
            return null;
        }

        var posts = [];

        var joinLeavePref = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave')];
        var filterJoinLeave = joinLeavePref ? joinLeavePref.value === 'false' : false;

        for (var i = 0; i < postIds.length; i++) {
            var post = allPosts[postIds[i]];
            if (!(0, _post_utils.shouldFilterPost)(post, { filterJoinLeave: filterJoinLeave })) {
                var previousPost = allPosts[postIds[i + 1]] || { create_at: 0 };
                posts.push(formatPostInChannel(post, previousPost, i, allPosts, postIds, currentUser));
            }
        }

        return posts;
    });
}

function makeGetPostsAroundPost() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, postId, channelId) {
        return state.entities.posts.postsInChannel[channelId];
    }, function (state, postId) {
        return postId;
    }, _users.getCurrentUser, _preferences.getMyPreferences, function (allPosts, postIds, focusedPostId, currentUser, myPreferences) {
        if (!postIds) {
            return null;
        }

        var focusedPostIndex = postIds.indexOf(focusedPostId);
        if (focusedPostIndex === -1) {
            return null;
        }

        var desiredPostIndexBefore = focusedPostIndex - _constants.Posts.POST_CHUNK_SIZE / 2;
        var minPostIndex = desiredPostIndexBefore < 0 ? 0 : desiredPostIndexBefore;

        var slicedPostIds = postIds.slice(minPostIndex);

        var posts = [];
        var joinLeavePref = myPreferences[(0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'join_leave')];
        var filterJoinLeave = joinLeavePref ? joinLeavePref.value === 'false' : false;

        for (var i = 0; i < slicedPostIds.length; i++) {
            var post = allPosts[slicedPostIds[i]];
            if (!(0, _post_utils.shouldFilterPost)(post, { filterJoinLeave: filterJoinLeave })) {
                var previousPost = allPosts[slicedPostIds[i + 1]] || { create_at: 0 };
                var formattedPost = formatPostInChannel(post, previousPost, i, allPosts, slicedPostIds, currentUser);

                if (post.id === focusedPostId) {
                    formattedPost.highlight = true;
                }

                posts.push(formattedPost);
            }
        }

        return posts;
    });
}

// Returns a function that creates a creates a selector that will get the posts for a given thread.
// That selector will take a props object (containing a channelId field and a rootId field) as its
// only argument and will be memoized based on that argument.
function makeGetPostsForThread() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, props) {
        return state.entities.posts.postsInChannel[props.channelId];
    }, function (state, props) {
        return props;
    }, function (posts, postIds, _ref) {
        var rootId = _ref.rootId;

        var thread = [];

        if (postIds) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = postIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    var post = posts[id];

                    if (id === rootId || post.root_id === rootId) {
                        thread.push(post);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        return thread;
    });
}

function makeGetCommentCountForPost() {
    return (0, _reselect.createSelector)(getAllPosts, function (state, props) {
        return props;
    }, function (posts, _ref2) {
        var currentPost = _ref2.post;

        var count = 0;
        for (var id in posts) {
            if (posts.hasOwnProperty(id)) {
                var post = posts[id];

                if (post.root_id === currentPost.id && post.state !== _constants.Posts.POST_DELETED) {
                    count += 1;
                }
            }
        }

        return count;
    });
}

var getSearchResults = exports.getSearchResults = (0, _reselect.createSelector)(getAllPosts, function (state) {
    return state.entities.search.results;
}, function (posts, postIds) {
    return postIds.map(function (id) {
        return posts[id];
    });
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getJoinableTeams = exports.getMembersInCurrentTeam = exports.getMyTeams = exports.getCurrentTeamStats = exports.getCurrentTeamUrl = exports.isCurrentUserCurrentTeamAdmin = exports.getCurrentTeamMembership = exports.getCurrentTeam = exports.getTeamsList = undefined;
exports.getCurrentTeamId = getCurrentTeamId;
exports.getTeams = getTeams;
exports.getTeamStats = getTeamStats;
exports.getTeamMemberships = getTeamMemberships;
exports.getMembersInTeams = getMembersInTeams;
exports.getTeamMember = getTeamMember;

var _reselect = __webpack_require__(93);

var _general = __webpack_require__(174);

var _user_utils = __webpack_require__(126);

function getCurrentTeamId(state) {
    return state.entities.teams.currentTeamId;
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getTeams(state) {
    return state.entities.teams.teams;
}

function getTeamStats(state) {
    return state.entities.teams.stats;
}

function getTeamMemberships(state) {
    return state.entities.teams.myMembers;
}

function getMembersInTeams(state) {
    return state.entities.teams.membersInTeam;
}

var getTeamsList = exports.getTeamsList = (0, _reselect.createSelector)(getTeams, function (teams) {
    return Object.values(teams);
});

var getCurrentTeam = exports.getCurrentTeam = (0, _reselect.createSelector)(getTeams, getCurrentTeamId, function (teams, currentTeamId) {
    return teams[currentTeamId];
});

var getCurrentTeamMembership = exports.getCurrentTeamMembership = (0, _reselect.createSelector)(getCurrentTeamId, getTeamMemberships, function (currentTeamId, teamMemberships) {
    return teamMemberships[currentTeamId];
});

var isCurrentUserCurrentTeamAdmin = exports.isCurrentUserCurrentTeamAdmin = (0, _reselect.createSelector)(getCurrentTeamMembership, function (member) {
    if (member) {
        var roles = member.roles || '';
        return (0, _user_utils.isTeamAdmin)(roles);
    }
    return false;
});

var getCurrentTeamUrl = exports.getCurrentTeamUrl = (0, _reselect.createSelector)(_general.getCurrentUrl, getCurrentTeam, function (currentUrl, currentTeam) {
    return currentUrl + '/' + currentTeam.name;
});

var getCurrentTeamStats = exports.getCurrentTeamStats = (0, _reselect.createSelector)(getCurrentTeamId, getTeamStats, function (currentTeamId, teamStats) {
    return teamStats[currentTeamId];
});

var getMyTeams = exports.getMyTeams = (0, _reselect.createSelector)(getTeams, getTeamMemberships, function (teams, members) {
    return Object.values(teams).filter(function (t) {
        return members[t.id];
    });
});

var getMembersInCurrentTeam = exports.getMembersInCurrentTeam = (0, _reselect.createSelector)(getCurrentTeamId, getMembersInTeams, function (currentTeamId, teamMembers) {
    return teamMembers[currentTeamId];
});

function getTeamMember(state, teamId, userId) {
    var members = getMembersInTeams(state)[teamId];
    if (members) {
        return members[userId];
    }

    return null;
}

var getJoinableTeams = exports.getJoinableTeams = (0, _reselect.createSelector)(getTeams, getTeamMemberships, function (teams, myMembers) {
    var openTeams = {};
    Object.values(teams).forEach(function (t) {
        if (t.allow_open_invite && !myMembers[t.id]) {
            openTeams[t.id] = t;
        }
    });

    return openTeams;
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1112);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;

var _defineProperty = __webpack_require__(419);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

// ---

var handleTeamAddedEvent = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(msg) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return TeamActions.getTeam(msg.data.team_id)(dispatch, getState);

                    case 2:
                        _context.next = 4;
                        return TeamActions.getMyTeamMembers()(dispatch, getState);

                    case 4:
                        _context.next = 6;
                        return TeamActions.getMyTeamUnreads()(dispatch, getState);

                    case 6:
                        (0, _channels2.fetchAllMyChannelsAndMembers)()(dispatch, getState);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function handleTeamAddedEvent(_x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.initialize = initialize;
exports.close = close;
exports.reconnect = reconnect;
exports.startPeriodicSync = startPeriodicSync;
exports.stopPeriodicSync = stopPeriodicSync;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _preference_store = __webpack_require__(103);

var _preference_store2 = _interopRequireDefault(_preference_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _error_store = __webpack_require__(216);

var _error_store2 = _interopRequireDefault(_error_store);

var _notification_store = __webpack_require__(448);

var _notification_store2 = _interopRequireDefault(_notification_store);

var _web_websocket_client = __webpack_require__(305);

var _web_websocket_client2 = _interopRequireDefault(_web_websocket_client);

var _webrtc_actions = __webpack_require__(486);

var WebrtcActions = _interopRequireWildcard(_webrtc_actions);

var _global_actions = __webpack_require__(143);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _post_actions = __webpack_require__(213);

var _user_actions = __webpack_require__(123);

var _channel_actions = __webpack_require__(166);

var _status_actions = __webpack_require__(177);

var StatusActions = _interopRequireWildcard(_status_actions);

var _constants = __webpack_require__(12);

var _es = __webpack_require__(49);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _users = __webpack_require__(78);

var _users2 = __webpack_require__(88);

var _url = __webpack_require__(299);

var _teams = __webpack_require__(144);

var TeamActions = _interopRequireWildcard(_teams);

var _channels = __webpack_require__(89);

var _channels2 = __webpack_require__(176);

var _posts = __webpack_require__(217);

var _general = __webpack_require__(296);

var _action_types = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//eslint-disable-line no-unused-vars

var dispatch = _redux_store2.default.dispatch; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getState = _redux_store2.default.getState;

var MAX_WEBSOCKET_FAILS = 7;

// +++ Alan
// var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// ---

function initialize() {
    if (!window.WebSocket) {
        console.log('Browser does not support websocket'); //eslint-disable-line no-console
        return;
    }

    var connUrl = (0, _url.getSiteURL)();

    // replace the protocol with a websocket one
    if (connUrl.startsWith('https:')) {
        connUrl = connUrl.replace(/^https:/, 'wss:');
    } else {
        connUrl = connUrl.replace(/^http:/, 'ws:');
    }

    // append a port number if one isn't already specified
    if (!/:\d+$/.test(connUrl)) {
        if (connUrl.startsWith('wss:')) {
            connUrl += ':' + global.window.mm_config.WebsocketSecurePort;
        } else {
            connUrl += ':' + global.window.mm_config.WebsocketPort;
        }
    }

    connUrl += _client.Client4.getUrlVersion() + '/websocket';

    _web_websocket_client2.default.setEventCallback(handleEvent);
    _web_websocket_client2.default.setFirstConnectCallback(handleFirstConnect);
    _web_websocket_client2.default.setReconnectCallback(function () {
        return reconnect(false);
    });
    _web_websocket_client2.default.setMissedEventCallback(function () {
        return reconnect(false);
    });
    _web_websocket_client2.default.setCloseCallback(handleClose);
    _web_websocket_client2.default.initialize(connUrl);
}

function close() {
    _web_websocket_client2.default.close();
}

function reconnectWebSocket() {
    close();
    initialize();
}

function reconnect() {
    var includeWebSocket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (includeWebSocket) {
        reconnectWebSocket();
    }

    (0, _channel_actions.loadChannelsForCurrentUser)();
    (0, _posts.getPosts)(_channel_store2.default.getCurrentId())(dispatch, getState);
    StatusActions.loadStatusesForChannelAndSidebar();

    _error_store2.default.clearLastError();
    _error_store2.default.emitChange();
}

var intervalId = '';
var SYNC_INTERVAL_MILLISECONDS = 1000 * 60 * 15; // 15 minutes

function startPeriodicSync() {
    clearInterval(intervalId);

    intervalId = setInterval(function () {
        if (_user_store2.default.getCurrentUser() != null) {
            reconnect(false);
        }
    }, SYNC_INTERVAL_MILLISECONDS);
}

function stopPeriodicSync() {
    clearInterval(intervalId);
}

function handleFirstConnect() {
    _error_store2.default.clearLastError();
    _error_store2.default.emitChange();
}

function handleClose(failCount) {
    if (failCount > MAX_WEBSOCKET_FAILS) {
        _error_store2.default.storeLastError({ message: _constants.ErrorBarTypes.WEBSOCKET_PORT_ERROR });
    }

    _error_store2.default.setConnectionErrorCount(failCount);
    _error_store2.default.emitChange();
}

function handleEvent(msg) {
    switch (msg.event) {
        case _constants.SocketEvents.POSTED:
        case _constants.SocketEvents.EPHEMERAL_MESSAGE:
            handleNewPostEvent(msg);
            break;

        case _constants.SocketEvents.POST_EDITED:
            handlePostEditEvent(msg);
            break;

        case _constants.SocketEvents.POST_DELETED:
            handlePostDeleteEvent(msg);
            break;

        case _constants.SocketEvents.INVITE_ARRIVED:
            handleInviteArrivedEvent(msg);
            break;
        // +++ Alan - self destruct and posts deleted
        case _constants.SocketEvents.SELF_DESTRUCTED:
            handleSelfDestructedEvent(msg);
            break;

        case _constants.SocketEvents.POSTS_DELETED:
            handlePostsDeleteEvent(msg);
            break;
        // ---

        case _constants.SocketEvents.LEAVE_TEAM:
            handleLeaveTeamEvent(msg);
            break;

        case _constants.SocketEvents.DELETE_TEAM:
            handleDeleteTeamEvent(msg);
            break;

        case _constants.SocketEvents.UPDATE_TEAM:
            handleUpdateTeamEvent(msg);
            break;

        case _constants.SocketEvents.ADDED_TO_TEAM:
            handleTeamAddedEvent(msg);
            break;

        case _constants.SocketEvents.USER_ADDED:
            handleUserAddedEvent(msg);
            break;

        case _constants.SocketEvents.USER_REMOVED:
            handleUserRemovedEvent(msg);
            break;

        case _constants.SocketEvents.USER_UPDATED:
            handleUserUpdatedEvent(msg);
            break;

        case _constants.SocketEvents.MEMBERROLE_UPDATED:
            handleUpdateMemberRoleEvent(msg);
            break;

        case _constants.SocketEvents.CHANNEL_CREATED:
            handleChannelCreatedEvent(msg);
            break;

        case _constants.SocketEvents.CHANNEL_DELETED:
            handleChannelDeletedEvent(msg);
            break;

        case _constants.SocketEvents.CHANNEL_UPDATED:
            handleChannelUpdatedEvent(msg);
            break;

        case _constants.SocketEvents.DIRECT_ADDED:
            handleDirectAddedEvent(msg);
            break;

        case _constants.SocketEvents.GROUP_ADDED:
            handleGroupAddedEvent(msg);
            break;

        case _constants.SocketEvents.PREFERENCE_CHANGED:
            handlePreferenceChangedEvent(msg);
            break;

        case _constants.SocketEvents.PREFERENCES_CHANGED:
            handlePreferencesChangedEvent(msg);
            break;

        case _constants.SocketEvents.PREFERENCES_DELETED:
            handlePreferencesDeletedEvent(msg);
            break;

        case _constants.SocketEvents.TYPING:
            handleUserTypingEvent(msg);
            break;

        case _constants.SocketEvents.STATUS_CHANGED:
            handleStatusChangedEvent(msg);
            break;

        case _constants.SocketEvents.HELLO:
            handleHelloEvent(msg);
            break;

        case _constants.SocketEvents.WEBRTC:
            handleWebrtc(msg);
            break;

        case _constants.SocketEvents.REACTION_ADDED:
            handleReactionAddedEvent(msg);
            break;

        case _constants.SocketEvents.REACTION_REMOVED:
            handleReactionRemovedEvent(msg);
            break;

        case _constants.SocketEvents.EMOJI_ADDED:
            handleAddEmoji(msg);
            break;

        // +++ Cordchat - file security scan finished
        case _constants.SocketEvents.FILE_SCANNED:
            handleFileScannedEvent(msg);
            break;
        // ---

        case _constants.SocketEvents.CHANNEL_VIEWED:
            handleChannelViewedEvent(msg);
            break;

        case _constants.SocketEvents.UDF_STATUS_CREATED:
        case _constants.SocketEvents.UDF_STATUS_UPDATED:
            handleUdfStatusReceivedEvent(msg);
            break;

        case _constants.SocketEvents.UDF_STATUS_DELETED:
            handleUdfStatusDeleteEvent(msg);
            break;
        case _constants.SocketEvents.UDF_STATUS_AFTER_POSTED:
            handleAfterPostEvent(msg);
            break;
        case _constants.SocketEvents.SWITCH_MAP_TYPE:
            global.window.mm_config.GoogleMapApiType = msg.data.type;
            break;
        default:
    }
}

function handleChannelUpdatedEvent(msg) {
    var channel = JSON.parse(msg.data.channel);
    dispatch({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: channel });
}

function handleNewPostEvent(msg) {
    var post = JSON.parse(msg.data.post);
    (0, _post_actions.handleNewPost)(post, msg);

    (0, _posts.getProfilesAndStatusesForPosts)([post], dispatch, getState);

    if (post.user_id !== _user_store2.default.getCurrentId()) {
        _user_store2.default.setStatus(post.user_id, _constants.UserStatuses.ONLINE);
    }
}

function handlePostEditEvent(msg) {
    // Store post
    var post = JSON.parse(msg.data.post);
    dispatch({ type: _action_types.PostTypes.RECEIVED_POST, data: post });

    // Update channel state
    if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        if (window.isActive) {
            (0, _channels.viewChannel)(_channel_store2.default.getCurrentId())(dispatch, getState);
        }
    }

    // Needed for search store
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.POST_UPDATED,
        post: post
    });
}

function handlePostDeleteEvent(msg) {
    var post = JSON.parse(msg.data.post);
    dispatch({ type: _action_types.PostTypes.POST_DELETED, data: post });

    // Needed for search store
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.POST_DELETED,
        post: post
    });
}

function handleInviteArrivedEvent(msg) {
    var data = msg.data;

    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.TOGGLE_INVITE_ARRIVED_MODAL,
        value: true,
        data: data
    });
}

// Alan - batch post delete event
function handleSelfDestructedEvent(msg) {
    var post = JSON.parse(msg.data.post);

    dispatch({
        type: _action_types.PostTypes.REMOVE_POST,
        data: (0, _assign2.default)({}, post)
    }, getState);

    // Needed for search store
    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.REMOVE_POST,
        post: post
    });
}

function handlePostsDeleteEvent(msg) {
    var data = JSON.parse(msg.data.posts);

    var postsObj = data.posts;

    for (var id in postsObj) {
        if (postsObj.hasOwnProperty(id)) {

            var post = postsObj[id];

            dispatch({
                type: _action_types.PostTypes.REMOVE_POST,
                data: (0, _assign2.default)({}, post)
            }, getState);

            // Needed for search store
            _app_dispatcher2.default.handleViewAction({
                type: _constants.Constants.ActionTypes.REMOVE_POST,
                post: post
            });
        }
    }
}

function handleUdfStatusReceivedEvent(msg) {
    var data = JSON.parse(msg.data.udfStatus);

    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.RECEIVED_UDF_STATUS,
        data: data
    });
}

function handleUdfStatusDeleteEvent(msg) {
    var data = JSON.parse(msg.data.udfStatus);

    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.DELETED_UDF_STATUS,
        data: data
    });
}

function handleAfterPostEvent(msg) {
    var statuses = JSON.parse(msg.data.statuses);

    _app_dispatcher2.default.handleViewAction({
        type: _constants.Constants.ActionTypes.TOGGLE_STATUS_DESC_MODAL,
        value: true,
        statuses: statuses,
        pendingPostId: msg.data.pending_post_id,
        postCreateAt: msg.data.post_create_at
    });
}

function handleDeleteTeamEvent(msg) {
    _team_store2.default.removeMyTeamMember(msg.data.team_id);
    _team_store2.default.removeTeam(msg.data.team_id);

    if (_team_store2.default.getCurrentId() === msg.data.team_id) {
        _browser_store2.default.removeGlobalItem('team');
        _browser_store2.default.removeGlobalItem(msg.data.team_id);

        if (!global.location.pathname.startsWith('/admin_console')) {
            GlobalActions.redirectUserToDefaultTeam();
        }
    }

    var channelIds = _channel_store2.default.getChannelIdsInTeam(msg.data.team_id);
    channelIds.forEach(function (channelId) {

        _channel_store2.default.clearUnreadCountByChannel(channelId);
        dispatch({
            type: _action_types.ChannelTypes.LEAVE_CHANNEL,
            data: { id: channelId, user_id: msg.broadcast.user_id }
        });
    });
}

function handleLeaveTeamEvent(msg) {
    if (_user_store2.default.getCurrentId() === msg.data.user_id) {

        _team_store2.default.removeMyTeamMember(msg.data.team_id);
        var channelIds = _channel_store2.default.getChannelIdsInTeam(msg.data.team_id);
        channelIds.forEach(function (channelId) {

            _channel_store2.default.clearUnreadCountByChannel(channelId);
            dispatch({
                type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                data: { id: channelId, user_id: msg.broadcast.user_id }
            });
        });

        // if they are on the team being removed redirect them to default team
        if (_team_store2.default.getCurrentId() === msg.data.team_id) {
            _browser_store2.default.removeGlobalItem('team');
            _browser_store2.default.removeGlobalItem(msg.data.team_id);

            if (!global.location.pathname.startsWith('/admin_console')) {
                GlobalActions.redirectUserToDefaultTeam();
            }
        }

        dispatch((0, _reduxBatchedActions.batchActions)([{
            type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
            data: { user_id: msg.data.user_id },
            id: msg.data.team_id
        }, {
            type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
            data: { team_id: msg.data.team_id, user_id: msg.data.user_id }
        }]));
    } else {
        _user_store2.default.removeProfileFromTeam(msg.data.team_id, msg.data.user_id);
        _team_store2.default.removeMemberInTeam(msg.data.team_id, msg.data.user_id);
        var _channelIds = _channel_store2.default.getTeamChannelIds();
        _channelIds.forEach(function (channelId) {

            var channel = _channel_store2.default.getChannelById(channelId);
            if (channel.team_id === msg.data.team_id) {
                _user_store2.default.removeProfileInChannel(channelId, msg.data.user_id);
            }
        });
    }
}

function handleUpdateTeamEvent(msg) {
    _team_store2.default.updateTeam(msg.data.team);
}

function handleUpdateMemberRoleEvent(msg) {
    var member = JSON.parse(msg.data.member);
    _team_store2.default.updateMyRoles(member);
}

function handleDirectAddedEvent(msg) {
    (0, _channels.getChannelAndMyMember)(msg.broadcast.channel_id)(dispatch, getState);
    _preference_store2.default.setPreference(_constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, msg.data.teammate_id, 'true');
    (0, _user_actions.loadProfilesForSidebar)();
}
function handleGroupAddedEvent(msg) {
    // getChannelAndMyMember(msg.broadcast.channel_id)(dispatch, getState);
    // PreferenceStore.setPreference(Preferences.CATEGORY_GROUP_CHANNEL_SHOW, msg.broadcast.channel_id, 'true');
    // loadProfilesForSidebar();
}
function handleUserAddedEvent(msg) {
    if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);
    }

    // if (TeamStore.getCurrentId() === msg.data.team_id && UserStore.getCurrentId() === msg.data.user_id) {
    //     getChannelAndMyMember(msg.broadcast.channel_id)(dispatch, getState);
    // }
    if (_user_store2.default.getCurrentId() === msg.data.user_id) {
        (0, _channels.getChannelAndMyMember)(msg.broadcast.channel_id)(dispatch, getState);
    }
}

function handleUserRemovedEvent(msg) {
    if (_user_store2.default.getCurrentId() === msg.broadcast.user_id) {
        (0, _channel_actions.loadChannelsForCurrentUser)();
        (0, _teams.getMyTeamUnreads)()(dispatch, getState);
        _channel_store2.default.clearUnreadCountByChannel(msg.data.channel_id);
        if (msg.data.channel_id === _channel_store2.default.getCurrentId()) {
            if (msg.data.remover_id !== msg.broadcast.user_id) {

                if ((0, _jquery2.default)('#removed_from_channel').length > 0) {
                    var sentState = {};
                    sentState.channelName = _channel_store2.default.getCurrent().display_name;
                    sentState.remover = _user_store2.default.getProfile(msg.data.remover_id).username;

                    _browser_store2.default.setItem('channel-removed-state', sentState);
                    (0, _jquery2.default)('#removed_from_channel').modal('show');
                }
            }
            var townsquare = _channel_store2.default.getByName('town-square');
            _es.browserHistory.push(_team_store2.default.getCurrentTeamRelativeUrl() + '/channels/' + townsquare.name);
            GlobalActions.toggleSideBarAction(false);
        }

        // GlobalActions.toggleSideBarAction(false);


        dispatch({
            type: _action_types.ChannelTypes.LEAVE_CHANNEL,
            data: { id: msg.data.channel_id, user_id: msg.broadcast.user_id }
        });

        // get unread of the team again
    } else if (_channel_store2.default.getCurrentId() === msg.broadcast.channel_id) {
        (0, _channels.getChannelStats)(_channel_store2.default.getCurrentId())(dispatch, getState);
    }
}

function handleUserUpdatedEvent(msg) {
    var currentUser = (0, _users2.getCurrentUser)(getState());
    var user = msg.data.user;

    if (currentUser.id === user.id) {
        if (user.update_at > currentUser.update_at) {
            // Need to request me to make sure we don't override with sanitized fields from the
            // websocket event
            (0, _users.getMe)()(dispatch, getState);
        }
    } else {
        _user_store2.default.saveProfile(user);
    }
}

function handleChannelCreatedEvent(msg) {
    var channelId = msg.data.channel_id;
    var teamId = msg.data.team_id;

    if (_team_store2.default.getCurrentId() === teamId && !_channel_store2.default.getChannelById(channelId)) {
        (0, _channels.getChannelAndMyMember)(channelId)(dispatch, getState);
    }
}

function handleChannelDeletedEvent(msg) {
    if (_channel_store2.default.getCurrentId() === msg.data.channel_id) {
        var teamUrl = _team_store2.default.getCurrentTeamRelativeUrl();
        _es.browserHistory.push(teamUrl + '/channels/' + _constants.Constants.DEFAULT_CHANNEL);
    }
    _channel_store2.default.clearUnreadCountByChannel(msg.data.channel_id);
    dispatch({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED, data: { id: msg.data.channel_id, team_id: msg.broadcast.team_id } }, getState);
    (0, _channel_actions.loadChannelsForCurrentUser)();
}

function handlePreferenceChangedEvent(msg) {
    var preference = JSON.parse(msg.data.preference);
    GlobalActions.emitPreferenceChangedEvent(preference);
}

function handlePreferencesChangedEvent(msg) {
    var preferences = JSON.parse(msg.data.preferences);
    GlobalActions.emitPreferencesChangedEvent(preferences);
}

function handlePreferencesDeletedEvent(msg) {
    var preferences = JSON.parse(msg.data.preferences);
    GlobalActions.emitPreferencesDeletedEvent(preferences);
}

function handleUserTypingEvent(msg) {
    GlobalActions.emitRemoteUserTypingEvent(msg.broadcast.channel_id, msg.data.user_id, msg.data.parent_id);

    if (msg.data.user_id !== _user_store2.default.getCurrentId()) {
        _user_store2.default.setStatus(msg.data.user_id, _constants.UserStatuses.ONLINE);
    }
}

function handleStatusChangedEvent(msg) {
    _user_store2.default.setStatus(msg.data.user_id, msg.data.status, msg.data.extra);
}

function handleHelloEvent(msg) {
    (0, _general.setServerVersion)(msg.data.server_version)(dispatch, getState);
}

function handleWebrtc(msg) {
    var data = msg.data;
    return WebrtcActions.handle(data);
}

function handleReactionAddedEvent(msg) {
    var reaction = JSON.parse(msg.data.reaction);

    dispatch({
        type: _action_types.PostTypes.RECEIVED_REACTION,
        data: reaction
    });
}

// +++ Cordchat - file security scan
function handleFileScannedEvent(msg) {
    if (!msg.data || !msg.data.file_info) {
        return;
    }

    var fileInfo = JSON.parse(msg.data.file_info);

    // refresh the file metadata held in redux; attachments re-render with the new scan status
    dispatch({
        type: _action_types.FileTypes.RECEIVED_UPLOAD_FILES,
        data: [fileInfo]
    });
}
// ---

function handleAddEmoji(msg) {
    var data = JSON.parse(msg.data.emoji);

    dispatch({
        type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI,
        data: data
    });
}

function handleReactionRemovedEvent(msg) {
    var reaction = JSON.parse(msg.data.reaction);

    dispatch({
        type: _action_types.PostTypes.REACTION_DELETED,
        data: reaction
    });
}

function handleChannelViewedEvent(msg) {
    // Useful for when multiple devices have the app open to different channels
    if (_channel_store2.default.getCurrentId() !== msg.data.channel_id && _user_store2.default.getCurrentId() === msg.broadcast.user_id) {
        // Mark previous and next channel as read
        _channel_store2.default.resetCounts([msg.data.channel_id]);
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(13)
  , document = __webpack_require__(6).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global         = __webpack_require__(6)
  , core           = __webpack_require__(80)
  , LIBRARY        = __webpack_require__(107)
  , wksExt         = __webpack_require__(311)
  , defineProperty = __webpack_require__(19).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var shared = __webpack_require__(178)('keys')
  , uid    = __webpack_require__(106);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(60);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(6).document && document.documentElement;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(13)
  , anObject = __webpack_require__(4);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(81)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject       = __webpack_require__(13)
  , setPrototypeOf = __webpack_require__(233).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var toInteger = __webpack_require__(96)
  , defined   = __webpack_require__(61);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toInteger = __webpack_require__(96)
  , defined   = __webpack_require__(61);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var LIBRARY        = __webpack_require__(107)
  , $export        = __webpack_require__(1)
  , redefine       = __webpack_require__(42)
  , hide           = __webpack_require__(41)
  , has            = __webpack_require__(36)
  , Iterators      = __webpack_require__(130)
  , $iterCreate    = __webpack_require__(241)
  , setToStringTag = __webpack_require__(128)
  , getPrototypeOf = __webpack_require__(52)
  , ITERATOR       = __webpack_require__(14)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var create         = __webpack_require__(110)
  , descriptor     = __webpack_require__(94)
  , setToStringTag = __webpack_require__(128)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(41)(IteratorPrototype, __webpack_require__(14)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(182)
  , defined  = __webpack_require__(61);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var MATCH = __webpack_require__(14)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// check on default Array iterator
var Iterators  = __webpack_require__(130)
  , ITERATOR   = __webpack_require__(14)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $defineProperty = __webpack_require__(19)
  , createDesc      = __webpack_require__(94);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var classof   = __webpack_require__(150)
  , ITERATOR  = __webpack_require__(14)('iterator')
  , Iterators = __webpack_require__(130);
module.exports = __webpack_require__(80).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = __webpack_require__(29)
  , toIndex  = __webpack_require__(109)
  , toLength = __webpack_require__(26);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var addToUnscopables = __webpack_require__(131)
  , step             = __webpack_require__(326)
  , Iterators        = __webpack_require__(130)
  , toIObject        = __webpack_require__(44);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(240)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(4)
  , aFunction = __webpack_require__(43)
  , SPECIES   = __webpack_require__(14)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ctx                = __webpack_require__(81)
  , invoke             = __webpack_require__(181)
  , html               = __webpack_require__(232)
  , cel                = __webpack_require__(227)
  , global             = __webpack_require__(6)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(60)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global    = __webpack_require__(6)
  , macrotask = __webpack_require__(250).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(60)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global         = __webpack_require__(6)
  , DESCRIPTORS    = __webpack_require__(18)
  , LIBRARY        = __webpack_require__(107)
  , $typed         = __webpack_require__(187)
  , hide           = __webpack_require__(41)
  , redefineAll    = __webpack_require__(114)
  , fails          = __webpack_require__(9)
  , anInstance     = __webpack_require__(113)
  , toInteger      = __webpack_require__(96)
  , toLength       = __webpack_require__(26)
  , gOPN           = __webpack_require__(111).f
  , dP             = __webpack_require__(19).f
  , arrayFill      = __webpack_require__(247)
  , setToStringTag = __webpack_require__(128)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactErrorUtils = __webpack_require__(255);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMLazyTree = __webpack_require__(137);
var Danger = __webpack_require__(765);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(63);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(261);
var setInnerHTML = __webpack_require__(192);
var setTextContent = __webpack_require__(354);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */

'use strict';

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactPropTypesSecret = __webpack_require__(783);
var propTypesFactory = __webpack_require__(343);

var React = __webpack_require__(133);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(84);
var ReactInstanceMap = __webpack_require__(155);
var ReactInstrumentation = __webpack_require__(63);
var ReactUpdates = __webpack_require__(75);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var emptyFunction = __webpack_require__(53);
var warning = __webpack_require__(10);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(854);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);



/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(871);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? warning(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState);

    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
    var changeRoutes = _computeChangedRoutes.changeRoutes;
    var enterRoutes = _computeChangedRoutes.enterRoutes;


    Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["c" /* runLeaveHooks */])(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* runChangeHooks */])(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["b" /* runEnterHooks */])(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? warning(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var buffer = __webpack_require__(79);
var Buffer = buffer.Buffer;
var SlowBuffer = buffer.SlowBuffer;
var MAX_LEN = buffer.kMaxLength || 2147483647;
exports.alloc = function alloc(size, fill, encoding) {
  if (typeof Buffer.alloc === 'function') {
    return Buffer.alloc(size, fill, encoding);
  }
  if (typeof encoding === 'number') {
    throw new TypeError('encoding must not be number');
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  var enc = encoding;
  var _fill = fill;
  if (_fill === undefined) {
    enc = undefined;
    _fill = 0;
  }
  var buf = new Buffer(size);
  if (typeof _fill === 'string') {
    var fillBuf = new Buffer(_fill, enc);
    var flen = fillBuf.length;
    var i = -1;
    while (++i < size) {
      buf[i] = fillBuf[i % flen];
    }
  } else {
    buf.fill(_fill);
  }
  return buf;
}
exports.allocUnsafe = function allocUnsafe(size) {
  if (typeof Buffer.allocUnsafe === 'function') {
    return Buffer.allocUnsafe(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new Buffer(size);
}
exports.from = function from(value, encodingOrOffset, length) {
  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
    return Buffer.from(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof value === 'string') {
    return new Buffer(value, encodingOrOffset);
  }
  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    var offset = encodingOrOffset;
    if (arguments.length === 1) {
      return new Buffer(value);
    }
    if (typeof offset === 'undefined') {
      offset = 0;
    }
    var len = length;
    if (typeof len === 'undefined') {
      len = value.byteLength - offset;
    }
    if (offset >= value.byteLength) {
      throw new RangeError('\'offset\' is out of bounds');
    }
    if (len > value.byteLength - offset) {
      throw new RangeError('\'length\' is out of bounds');
    }
    return new Buffer(value.slice(offset, offset + len));
  }
  if (Buffer.isBuffer(value)) {
    var out = new Buffer(value.length);
    value.copy(out, 0, 0, value.length);
    return out;
  }
  if (value) {
    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
      return new Buffer(value);
    }
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return new Buffer(value.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
}
exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
  if (typeof Buffer.allocUnsafeSlow === 'function') {
    return Buffer.allocUnsafeSlow(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size >= MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new SlowBuffer(size);
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var LIBRARY        = __webpack_require__(202)
  , $export        = __webpack_require__(31)
  , redefine       = __webpack_require__(399)
  , hide           = __webpack_require__(99)
  , has            = __webpack_require__(119)
  , Iterators      = __webpack_require__(139)
  , $iterCreate    = __webpack_require__(910)
  , setToStringTag = __webpack_require__(159)
  , getPrototypeOf = __webpack_require__(402)
  , ITERATOR       = __webpack_require__(32)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(100)
  , document = __webpack_require__(38).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(100);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(158);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var shared = __webpack_require__(284)('keys')
  , uid    = __webpack_require__(206);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global = __webpack_require__(38)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var classof   = __webpack_require__(207)
  , ITERATOR  = __webpack_require__(32)('iterator')
  , Iterators = __webpack_require__(139);
module.exports = __webpack_require__(15).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hide = __webpack_require__(99);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = __webpack_require__(32);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var META     = __webpack_require__(206)('meta')
  , isObject = __webpack_require__(100)
  , has      = __webpack_require__(119)
  , setDesc  = __webpack_require__(64).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(101)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global         = __webpack_require__(38)
  , core           = __webpack_require__(15)
  , LIBRARY        = __webpack_require__(202)
  , wksExt         = __webpack_require__(290)
  , defineProperty = __webpack_require__(64).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OFFLINE_STATUS_CHANGED = exports.OFFLINE_STATUS_CHANGED = 'Offline/STATUS_CHANGED';
var OFFLINE_SCHEDULE_RETRY = exports.OFFLINE_SCHEDULE_RETRY = 'Offline/SCHEDULE_RETRY';
var OFFLINE_COMPLETE_RETRY = exports.OFFLINE_COMPLETE_RETRY = 'Offline/COMPLETE_RETRY';
var OFFLINE_SEND = exports.OFFLINE_SEND = 'Offline/SEND';
var OFFLINE_BUSY = exports.OFFLINE_BUSY = 'Offline/BUSY';
var PERSIST_REHYDRATE = exports.PERSIST_REHYDRATE = 'persist/REHYDRATE';


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1053), __esModule: true };


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPing = getPing;
exports.resetPing = resetPing;
exports.getClientConfig = getClientConfig;
exports.getLicenseConfig = getLicenseConfig;
exports.logClientError = logClientError;
exports.setAppState = setAppState;
exports.setDeviceToken = setDeviceToken;
exports.setServerVersion = setServerVersion;
exports.setStoreFromLocalData = setStoreFromLocalData;
exports.setUrl = setUrl;

var _client = __webpack_require__(22);

var _helpers = __webpack_require__(67);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _users = __webpack_require__(78);

var _errors = __webpack_require__(68);

var _event_emitter = __webpack_require__(210);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

var _reduxBatchedActions = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getPing() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var data, pingError;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_REQUEST }, getState);

                            data = void 0;
                            pingError = new _helpers.FormattedError('mobile.server_ping_failed', 'Cannot connect to the server. Please check your server URL and internet connection.');
                            _context.prev = 3;
                            _context.next = 6;
                            return _client.Client.getPing();

                        case 6:
                            data = _context.sent;

                            if (data.version) {
                                _context.next = 10;
                                break;
                            }

                            // successful ping but not the right return data
                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return');

                        case 10:
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            dispatch({ type: _action_types.GeneralTypes.PING_FAILURE, error: pingError }, getState);
                            return _context.abrupt('return');

                        case 16:

                            dispatch({ type: _action_types.GeneralTypes.PING_SUCCESS, data: data }, getState);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 12]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function resetPing() {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.PING_RESET }, getState);

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getClientConfig() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.CLIENT_CONFIG_REQUEST }, getState);

                            data = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.getClientConfigOld();

                        case 5:
                            data = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.GeneralTypes.CLIENT_CONFIG_FAILURE,
                                error: _context3.t0
                            }, (0, _errors.logError)(_context3.t0)(dispatch)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:

                            _client.Client4.setEnableLogging(data.EnableDeveloper === 'true');

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.GeneralTypes.CLIENT_CONFIG_RECEIVED, data: data }, { type: _action_types.GeneralTypes.CLIENT_CONFIG_SUCCESS }]));

                            return _context3.abrupt('return', data);

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function getLicenseConfig() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getClientLicenseOld, _action_types.GeneralTypes.CLIENT_LICENSE_REQUEST, [_action_types.GeneralTypes.CLIENT_LICENSE_RECEIVED, _action_types.GeneralTypes.CLIENT_LICENSE_SUCCESS], _action_types.GeneralTypes.CLIENT_LICENSE_FAILURE);
}

function logClientError(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ERROR';

    return (0, _helpers.bindClientFunc)(_client.Client4.logClientError, _action_types.GeneralTypes.LOG_CLIENT_ERROR_REQUEST, _action_types.GeneralTypes.LOG_CLIENT_ERROR_SUCCESS, _action_types.GeneralTypes.LOG_CLIENT_ERROR_FAILURE, message, level);
}

function setAppState(state) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_STATE, data: state }, getState);

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x8, _x9) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function setDeviceToken(token) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_APP_DEVICE_TOKEN, data: token }, getState);

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x10, _x11) {
            return _ref5.apply(this, arguments);
        };
    }();
}

_event_emitter2.default.on(_constants.General.CONFIG_CHANGED, setServerVersion);

function setServerVersion(serverVersion) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.GeneralTypes.RECEIVED_SERVER_VERSION, data: serverVersion }, getState);

                        case 1:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x12, _x13) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function setStoreFromLocalData(data) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _client.Client.setToken(data.token);
                            _client.Client.setUrl(data.url);
                            _client.Client4.setToken(data.token);
                            _client.Client4.setUrl(data.url);

                            return _context7.abrupt('return', (0, _users.loadMe)()(dispatch, getState));

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }));

        return function (_x14, _x15) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function setUrl(url) {
    _client.Client.setUrl(url);
    _client.Client4.setUrl(url);
    return true;
}

exports.default = {
    getPing: getPing,
    getClientConfig: getClientConfig,
    getLicenseConfig: getLicenseConfig,
    logClientError: logClientError,
    setAppState: setAppState,
    setDeviceToken: setDeviceToken,
    setServerVersion: setServerVersion,
    setStoreFromLocalData: setStoreFromLocalData,
    setUrl: setUrl
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(125);

var _PathUtils = __webpack_require__(116);

var _ExecutionEnvironment = __webpack_require__(195);

var _DOMUtils = __webpack_require__(271);

var _DOMStateStorage = __webpack_require__(380);

var _createDOMHistory = __webpack_require__(381);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(195);

var _PathUtils = __webpack_require__(116);

var _runTransitionHook = __webpack_require__(272);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(273);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanUpUrlable = cleanUpUrlable;
exports.getShortenedURL = getShortenedURL;
exports.getSiteURL = getSiteURL;
exports.toDownloadUrl = toDownloadUrl;

var _latinise = __webpack_require__(1062);

function cleanUpUrlable(input) {
    var cleaned = (0, _latinise.latinise)(input);
    cleaned = cleaned.trim().replace(/-/g, ' ').replace(/[^\w\s]/gi, '').toLowerCase().replace(/\s/g, '-');
    cleaned = cleaned.replace(/-{2,}/, '-');
    cleaned = cleaned.replace(/^-+/, '');
    cleaned = cleaned.replace(/-+$/, '');
    return cleaned;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getShortenedURL() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var getLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 27;

    if (url.length > 35) {
        var subLength = getLength - 14;
        return url.substring(0, 10) + '...' + url.substring(url.length - subLength, url.length) + '/';
    }
    return url + '/';
}

function getSiteURL() {
    if (window.location.origin) {
        return window.location.origin;
    }

    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
function toDownloadUrl(fileUrl) {
    return fileUrl + '?download=1';
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(31)
  , core    = __webpack_require__(15)
  , fails   = __webpack_require__(101);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};



/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

exports.trackEvent = trackEvent;

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackEvent(category, event, props) {
    if (global.window && global.window.analytics) {
        var properties = (0, _assign2.default)({ category: category, type: event, user_actual_id: _user_store2.default.getCurrentId() }, props);
        var options = {
            context: {
                ip: '0.0.0.0'
            },
            page: {
                path: '',
                referrer: '',
                search: '',
                title: '',
                url: ''
            },
            anonymousId: '00000000000000000000000000'
        };
        global.window.analytics.track('event', properties, options);
    }
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ActionTypes = _constants2.default.ActionTypes;

var CHANGE_EVENT = 'change';
var SEARCH_CHANGE_EVENT = 'search_change';
var SEARCH_TERM_CHANGE_EVENT = 'search_term_change';
var SHOW_SEARCH_EVENT = 'show_search';

var SearchStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(SearchStoreClass, _EventEmitter);

    function SearchStoreClass() {
        (0, _classCallCheck3.default)(this, SearchStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchStoreClass.__proto__ || (0, _getPrototypeOf2.default)(SearchStoreClass)).call(this));

        _this.searchResults = null;
        _this.isMentionSearch = false;
        _this.isFlaggedPosts = false;
        _this.isPinnedPosts = false;
        _this.isUnreadPosts = false;
        _this.isLiveStreamPosts = false;
        _this.isVisible = false;
        _this.searchTerm = '';
        _this.loading = false;

        // 搜索筛选条件(两个 SearchBar 实例共用),提交时由前端拼成 from:/in:/team:/since: 语法
        _this.searchFilters = SearchStoreClass.emptyFilters();
        return _this;
    }

    (0, _createClass3.default)(SearchStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitSearchChange',
        value: function emitSearchChange() {
            this.emit(SEARCH_CHANGE_EVENT);
        }
    }, {
        key: 'addSearchChangeListener',
        value: function addSearchChangeListener(callback) {
            this.on(SEARCH_CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeSearchChangeListener',
        value: function removeSearchChangeListener(callback) {
            this.removeListener(SEARCH_CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitSearchTermChange',
        value: function emitSearchTermChange(doSearch, isMentionSearch) {
            this.emit(SEARCH_TERM_CHANGE_EVENT, doSearch, isMentionSearch);
        }
    }, {
        key: 'addSearchTermChangeListener',
        value: function addSearchTermChangeListener(callback) {
            this.on(SEARCH_TERM_CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeSearchTermChangeListener',
        value: function removeSearchTermChangeListener(callback) {
            this.removeListener(SEARCH_TERM_CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitShowSearch',
        value: function emitShowSearch() {
            this.emit(SHOW_SEARCH_EVENT);
        }
    }, {
        key: 'addShowSearchListener',
        value: function addShowSearchListener(callback) {
            this.on(SHOW_SEARCH_EVENT, callback);
        }
    }, {
        key: 'removeShowSearchListener',
        value: function removeShowSearchListener(callback) {
            this.removeListener(SHOW_SEARCH_EVENT, callback);
        }
    }, {
        key: 'getSearchResults',
        value: function getSearchResults() {
            return this.searchResults;
        }
    }, {
        key: 'getIsMentionSearch',
        value: function getIsMentionSearch() {
            return this.isMentionSearch;
        }
    }, {
        key: 'getIsFlaggedPosts',
        value: function getIsFlaggedPosts() {
            return this.isFlaggedPosts;
        }
    }, {
        key: 'getIsPinnedPosts',
        value: function getIsPinnedPosts() {
            return this.isPinnedPosts;
        }
    }, {
        key: 'getIsUnreadPosts',
        value: function getIsUnreadPosts() {
            return this.isUnreadPosts;
        }
    }, {
        key: 'getIsLiveStreamPosts',
        value: function getIsLiveStreamPosts() {
            return this.isLiveStreamPosts;
        }
    }, {
        key: 'storeSearchTerm',
        value: function storeSearchTerm(term) {
            this.searchTerm = term;
        }
    }, {
        key: 'getSearchTerm',
        value: function getSearchTerm() {
            return this.searchTerm;
        }
    }, {
        key: 'getSearchFilters',
        value: function getSearchFilters() {
            return this.searchFilters;
        }
    }, {
        key: 'setSearchFilters',
        value: function setSearchFilters(partial) {
            this.searchFilters = (0, _assign2.default)({}, this.searchFilters, partial);
            this.emitSearchTermChange(false);
        }
    }, {
        key: 'clearSearchFilters',
        value: function clearSearchFilters() {
            this.searchFilters = SearchStoreClass.emptyFilters();
            this.emitSearchTermChange(false);
        }
    }, {
        key: 'hasActiveFilters',
        value: function hasActiveFilters() {
            var f = this.searchFilters;
            return f.scope === 'current' || f.fromUsers.length > 0 || f.inChannels.length > 0 || Boolean(f.team) || Boolean(f.since);
        }
    }, {
        key: 'storeSearchResults',
        value: function storeSearchResults(results) {
            var isMentionSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var isFlaggedPosts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var isPinnedPosts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var isUnreadPosts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var isLiveStreamPosts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            this.searchResults = results;
            this.isMentionSearch = isMentionSearch;
            this.isFlaggedPosts = isFlaggedPosts;
            this.isPinnedPosts = isPinnedPosts;
            this.isUnreadPosts = isUnreadPosts;
            this.isLiveStreamPosts = isLiveStreamPosts;
        }
    }, {
        key: 'deletePost',
        value: function deletePost(post) {
            var results = this.getSearchResults();
            if (results == null) {
                return;
            }

            if (post.id in results.posts) {
                // make sure to copy the post so that component state changes work properly
                results.posts[post.id] = (0, _assign2.default)({}, post, {
                    state: _constants2.default.POST_DELETED,
                    file_ids: []
                });
            }
        }
    }, {
        key: 'updatePost',
        value: function updatePost(post) {
            var results = this.getSearchResults();
            if (!post || results == null) {
                return;
            }

            if (post.id in results.posts) {
                results.posts[post.id] = (0, _assign2.default)({}, post);
            }
        }
    }, {
        key: 'togglePinPost',
        value: function togglePinPost(postId, isPinned) {
            var results = this.getSearchResults();
            if (results == null || results.posts == null) {
                return;
            }

            if (postId in results.posts) {
                var post = results.posts[postId];
                results.posts[postId] = (0, _assign2.default)({}, post, {
                    is_pinned: isPinned
                });
            }
        }
    }, {
        key: 'removePost',
        value: function removePost(post) {
            var results = this.getSearchResults();
            if (results == null) {
                return;
            }

            var index = results.order.indexOf(post.id);
            if (index > -1) {
                delete results.posts[post.id];
                results.order.splice(index, 1);
            }
        }
    }, {
        key: 'setLoading',
        value: function setLoading(loading) {
            this.loading = loading;
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this.loading;
        }
    }], [{
        key: 'emptyFilters',
        value: function emptyFilters() {
            return {
                scope: 'all', // 'all' | 'current'
                fromUsers: [], // [{id, username, label}]
                inChannels: [], // [{id, name, type, label, teamName}]
                team: '', // team name
                since: '' // '' | today | thismonth | thisyear | withinNdays-N
            };
        }
    }]);
    return SearchStoreClass;
}(_events2.default);

var SearchStore = new SearchStoreClass();

SearchStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_SEARCH:
            {
                var results = SearchStore.getSearchResults() || {};
                var posts = (0, _values2.default)(results.posts || {});
                var channelId = posts.length > 0 ? posts[0].channel_id : '';
                if (SearchStore.getIsPinnedPosts() === action.is_pinned_posts && action.is_pinned_posts === true && channelId !== '' && _channel_store2.default.getCurrentId() !== channelId) {
                    // ignore pin posts update after switch to a new channel
                    return;
                }
                SearchStore.setLoading(false);
                SearchStore.storeSearchResults(action.results, action.is_mention_search, action.is_flagged_posts, action.is_pinned_posts, action.is_unread_posts, action.is_livestream_posts);
                SearchStore.emitSearchChange();
                break;
            }
        case ActionTypes.RECEIVED_SEARCH_TERM:
            if (action.do_search) {
                // while a search is in progress, hide results from previous search
                SearchStore.setLoading(true);
                SearchStore.storeSearchResults(null, false, false, false, false, false);
                SearchStore.emitSearchChange();
            }
            SearchStore.storeSearchTerm(action.term);
            SearchStore.emitSearchTermChange(action.do_search, action.is_mention_search);
            break;
        case ActionTypes.SHOW_SEARCH:
            SearchStore.emitShowSearch();
            break;
        case ActionTypes.POST_DELETED:
            SearchStore.deletePost(action.post);
            SearchStore.emitSearchChange();
            break;
        case ActionTypes.POST_UPDATED:
            SearchStore.updatePost(action.post);
            SearchStore.emitSearchChange();
            break;
        case ActionTypes.RECEIVED_POST_PINNED:
            SearchStore.togglePinPost(action.postId, true);
            SearchStore.emitSearchChange();
            break;
        case ActionTypes.RECEIVED_POST_UNPINNED:
            SearchStore.togglePinPost(action.postId, false);
            SearchStore.emitSearchChange();
            break;
        case ActionTypes.REMOVE_POST:
            SearchStore.removePost(action.post);
            SearchStore.emitSearchChange();
            break;
        default:
    }
});

exports.default = SearchStore;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _post_utils = __webpack_require__(173);

var PostUtils = _interopRequireWildcard(_post_utils);

var _constants = __webpack_require__(12);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _posts = __webpack_require__(218);

var Selectors = _interopRequireWildcard(_posts);

var _search_store = __webpack_require__(303);

var _search_store2 = _interopRequireDefault(_search_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants.Constants.ActionTypes; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOCUSED_POST_CHANGE = 'focused_post_change';
var EDIT_POST_EVENT = 'edit_post';
var DELETED_POST_EVENT = 'deleted_post';
var UPDATED_POST_EVENT = 'updated_post';
var POST_PINNED_CHANGE_EVENT = 'post_pinned_change';

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var PostStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(PostStoreClass, _EventEmitter);

    function PostStoreClass() {
        (0, _classCallCheck3.default)(this, PostStoreClass);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostStoreClass.__proto__ || (0, _getPrototypeOf2.default)(PostStoreClass)).call(this));

        _this.selectedPostId = null;
        _this.currentFocusedPostId = null;
        return _this;
    }

    (0, _createClass3.default)(PostStoreClass, [{
        key: 'emitPostFocused',
        value: function emitPostFocused() {
            this.emit(FOCUSED_POST_CHANGE);
        }
    }, {
        key: 'addPostFocusedListener',
        value: function addPostFocusedListener(callback) {
            this.on(FOCUSED_POST_CHANGE, callback);
        }
    }, {
        key: 'removePostFocusedListener',
        value: function removePostFocusedListener(callback) {
            this.removeListener(FOCUSED_POST_CHANGE, callback);
        }
    }, {
        key: 'emitEditPost',
        value: function emitEditPost(post) {
            this.emit(EDIT_POST_EVENT, post);
        }
    }, {
        key: 'addEditPostListener',
        value: function addEditPostListener(callback) {
            this.on(EDIT_POST_EVENT, callback);
        }
    }, {
        key: 'removeEditPostListner',
        value: function removeEditPostListner(callback) {
            this.removeListener(EDIT_POST_EVENT, callback);
        }
    }, {
        key: 'emitPostPinnedChange',
        value: function emitPostPinnedChange() {
            this.emit(POST_PINNED_CHANGE_EVENT);
        }
    }, {
        key: 'emitDeletedPost',
        value: function emitDeletedPost(post) {
            this.emit(DELETED_POST_EVENT, post);
        }
    }, {
        key: 'addDeletedPostListener',
        value: function addDeletedPostListener(callback) {
            this.on(DELETED_POST_EVENT, callback);
        }
    }, {
        key: 'removeDeletedPostListener',
        value: function removeDeletedPostListener(callback) {
            this.removeListener(DELETED_POST_EVENT, callback);
        }
    }, {
        key: 'emitUpdatedPost',
        value: function emitUpdatedPost(post) {
            this.emit(UPDATED_POST_EVENT, post);
        }
    }, {
        key: 'addUpdatedPostListener',
        value: function addUpdatedPostListener(callback) {
            this.on(UPDATED_POST_EVENT, callback);
        }
    }, {
        key: 'removeUpdatedPostListener',
        value: function removeUpdatedPostListener(callback) {
            this.removeListener(UPDATED_POST_EVENT, callback);
        }
    }, {
        key: 'addPostPinnedChangeListener',
        value: function addPostPinnedChangeListener(callback) {
            this.on(POST_PINNED_CHANGE_EVENT, callback);
        }
    }, {
        key: 'removePostPinnedChangeListener',
        value: function removePostPinnedChangeListener(callback) {
            this.removeListener(POST_PINNED_CHANGE_EVENT, callback);
        }
    }, {
        key: 'getLatestPostId',
        value: function getLatestPostId(channelId) {
            var postsInChannel = getState().entities.posts.postsInChannel[channelId] || [];
            return postsInChannel[0];
        }
    }, {
        key: 'getLatestVisiblePost',
        value: function getLatestVisiblePost(channelId) {
            // const postIds = getState().entities.posts.postsInChannel[channelId] || [];
            // const posts = getState().entities.posts.posts;
            var posts = Selectors.makeGetPostsInChannel()(getState(), channelId);
            if (posts) {
                for (var i = 0; i < posts.length; i++) {
                    var post = posts[i];
                    return post;
                    // if (post.state !== Constants.POST_DELETED && post.state !== Constants.POST_DELETED.toUpperCase() && post.delete_at === 0) {
                    //     return post;
                    // }
                }
            }

            return null;
        }
    }, {
        key: 'getLatestReplyablePost',
        value: function getLatestReplyablePost(channelId) {
            var postIds = getState().entities.posts.postsInChannel[channelId] || [];
            var posts = getState().entities.posts.posts;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(postIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var postId = _step.value;

                    var post = posts[postId] || {};
                    if (post.state !== _constants.Constants.POST_DELETED && !PostUtils.isSystemMessage(post)) {
                        return post;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return null;
        }
    }, {
        key: 'getVisiblePosts',
        value: function getVisiblePosts() {
            var posts = Selectors.getPostsInCurrentChannel(getState());
            var currentChannelId = getState().entities.channels.currentChannelId;
            return posts.slice(0, getState().views.channel.postVisibility[currentChannelId]);
        }
    }, {
        key: 'getFocusedPostId',
        value: function getFocusedPostId() {
            return this.currentFocusedPostId;
        }
    }, {
        key: 'storeFocusedPostId',
        value: function storeFocusedPostId(postId) {
            this.currentFocusedPostId = postId;
        }
    }, {
        key: 'clearFocusedPost',
        value: function clearFocusedPost() {
            this.currentFocusedPostId = null;
        }
    }, {
        key: 'getCurrentUsersLatestLiveStreamPost',
        value: function getCurrentUsersLatestLiveStreamPost(channelId) {
            var userId = _user_store2.default.getCurrentId();

            var postIds = getState().entities.posts.postsInChannel[channelId] || [];

            var lastPost = null;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(postIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var id = _step2.value;

                    var post = Selectors.getPost(getState(), id) || {};

                    if (post.user_id === userId && post.type && post.type === _constants.Constants.PostTypes.WEBRTC && post.state !== _constants.Constants.POST_DELETED) {
                        lastPost = post;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return lastPost;
        }
    }, {
        key: 'getCurrentUsersLatestPost',
        value: function getCurrentUsersLatestPost(channelId, rootId) {
            var userId = _user_store2.default.getCurrentId();

            var postIds = getState().entities.posts.postsInChannel[channelId] || [];

            var lastPost = null;

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(postIds), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var id = _step3.value;

                    var post = Selectors.getPost(getState(), id) || {};

                    // don't edit webhook posts, deleted posts, system messages, WVC message or forward message
                    if (post.user_id !== userId || post.props && post.props.from_webhook || post.props && post.props.is_forwarded_message || post.state === _constants.Constants.POST_DELETED || post.type && post.type.startsWith(_constants.Constants.SYSTEM_MESSAGE_PREFIX) || post.type && post.type.startsWith(_constants.Constants.WVC_MESSAGE_PREFIX)) {
                        continue;
                    }

                    if (rootId) {
                        if (post.root_id === rootId || post.id === rootId) {
                            lastPost = post;
                            break;
                        }
                    } else {
                        lastPost = post;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return lastPost;
        }
    }, {
        key: 'normalizeDraft',
        value: function normalizeDraft(originalDraft) {
            var draft = {
                message: '',
                uploadsInProgress: [],
                fileInfos: [],
                googleFileInfos: [],
                dropboxFileInfos: []
            };

            // Make sure that the post draft is non-null and has all the required fields
            if (originalDraft) {
                draft = {
                    message: originalDraft.message || draft.message,
                    uploadsInProgress: originalDraft.uploadsInProgress || draft.uploadsInProgress,
                    fileInfos: originalDraft.fileInfos || draft.fileInfos,
                    googleFileInfos: originalDraft.googleFileInfos || draft.googleFileInfos,
                    dropboxFileInfos: originalDraft.dropboxFileInfos || draft.dropboxFileInfos
                };
            }

            return draft;
        }
    }, {
        key: 'storeCurrentDraft',
        value: function storeCurrentDraft(draft) {
            var channelId = _channel_store2.default.getCurrentId();
            _browser_store2.default.setGlobalItem('draft_' + channelId, draft);
        }
    }, {
        key: 'getCurrentDraft',
        value: function getCurrentDraft() {
            var channelId = _channel_store2.default.getCurrentId();
            return this.getDraft(channelId);
        }
    }, {
        key: 'storeDraft',
        value: function storeDraft(channelId, draft) {
            _browser_store2.default.setGlobalItem('draft_' + channelId, draft);
        }
    }, {
        key: 'getDraft',
        value: function getDraft(channelId) {
            return this.normalizeDraft(_browser_store2.default.getGlobalItem('draft_' + channelId));
        }
    }, {
        key: 'storeCommentDraft',
        value: function storeCommentDraft(parentPostId, draft) {
            _browser_store2.default.setGlobalItem('comment_draft_' + parentPostId, draft);
        }
    }, {
        key: 'getCommentDraft',
        value: function getCommentDraft(parentPostId) {
            return this.normalizeDraft(_browser_store2.default.getGlobalItem('comment_draft_' + parentPostId));
        }
    }, {
        key: 'clearDraftUploads',
        value: function clearDraftUploads() {
            _browser_store2.default.actionOnGlobalItemsWithPrefix('draft_', function (key, value) {
                if (value) {
                    value.uploadsInProgress = [];
                    _browser_store2.default.setGlobalItem(key, value);
                }
            });
        }
    }, {
        key: 'clearCommentDraftUploads',
        value: function clearCommentDraftUploads() {
            _browser_store2.default.actionOnGlobalItemsWithPrefix('comment_draft_', function (key, value) {
                if (value) {
                    value.uploadsInProgress = [];
                    _browser_store2.default.setGlobalItem(key, value);
                }
            });
        }
    }, {
        key: 'getCommentCount',
        value: function getCommentCount(rootPost) {
            var postIds = getState().entities.posts.postsInChannel[rootPost.channel_id] || [];

            var commentCount = 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(postIds), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var postId = _step4.value;

                    var post = Selectors.getPost(getState(), postId) || {};
                    if (post.root_id === rootPost.id) {
                        commentCount += 1;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return commentCount;
        }
    }]);
    return PostStoreClass;
}(_events2.default);

var PostStore = new PostStoreClass();

PostStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.RECEIVED_FOCUSED_POST:
            PostStore.storeFocusedPostId(action.postId);
            PostStore.emitPostFocused();
            break;
        case ActionTypes.CLICK_CHANNEL:
            PostStore.clearFocusedPost();
            break;
        case ActionTypes.RECEIVED_EDIT_POST:
            PostStore.emitEditPost(action);
            break;
        case ActionTypes.RECEIVED_POST_SELECTED:
            dispatch((0, _extends3.default)({}, action, { type: ActionTypes.SELECT_POST }));
            break;
        case ActionTypes.RECEIVED_POST_PINNED:
        case ActionTypes.RECEIVED_POST_UNPINNED:
            PostStore.emitPostPinnedChange();
            break;
        case ActionTypes.POST_DELETED:
            PostStore.emitDeletedPost(action.post);
            break;
        case ActionTypes.POST_UPDATED:
            PostStore.emitUpdatedPost(action.post);
            break;
        default:
    }
});

exports.default = PostStore;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _websocket_client = __webpack_require__(1095);

var _websocket_client2 = _interopRequireDefault(_websocket_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebClient = new _websocket_client2.default(); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = WebClient;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

exports.getAllLanguages = getAllLanguages;
exports.getLanguages = getLanguages;
exports.getLanguageInfo = getLanguageInfo;
exports.isLanguageAvailable = isLanguageAvailable;
exports.safariFix = safariFix;
exports.doAddLocaleData = doAddLocaleData;

var _reactIntl = __webpack_require__(212);

var _en = __webpack_require__(1103);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(1104);

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


var zh_TW = __webpack_require__(1105); //eslint-disable-line camelcase
var zh_CN = __webpack_require__(1106); //eslint-disable-line camelcase

// should match the values in model/config.go
var languages = {
    en: {
        value: 'en',
        name: 'English',
        order: 1,
        url: ''
    },
    'zh-TW': {
        value: 'zh-TW',
        name: '中文 (繁體)',
        order: 12,
        url: zh_TW
    },
    'zh-CN': {
        value: 'zh-CN',
        name: '中文 (简体)',
        order: 11,
        url: zh_CN
    }
};

var availableLanguages = null;

function setAvailableLanguages() {
    var available = void 0;
    availableLanguages = {};

    if (global.window.mm_config.AvailableLocales) {
        available = global.window.mm_config.AvailableLocales.split(',');
    } else {
        available = (0, _keys2.default)(languages);
    }

    available.forEach(function (l) {
        if (languages[l]) {
            availableLanguages[l] = languages[l];
        }
    });
}

function getAllLanguages() {
    return languages;
}

function getLanguages() {
    if (!availableLanguages) {
        setAvailableLanguages();
    }
    return availableLanguages;
}

function getLanguageInfo(locale) {
    if (locale === 'zh_CN') {
        locale = 'zh-CN';
    } else if (locale === 'zh_TW') {
        locale = 'zh-TW';
    }
    return getAllLanguages()[locale];
}

function isLanguageAvailable(locale) {
    return Boolean(getLanguages()[locale]);
}

function safariFix(callback) {
    __webpack_require__.e/* require.ensure */(54).then((function (require) {
        __webpack_require__(542);
        __webpack_require__(543);
        __webpack_require__(544);
        callback();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

function doAddLocaleData() {
    (0, _reactIntl.addLocaleData)(_en2.default);
    (0, _reactIntl.addLocaleData)(_zh2.default);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(276);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(156);
util.inherits = __webpack_require__(147);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(894)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(392);
/*</replacement>*/

var Buffer = __webpack_require__(79).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(277);
/*</replacement>*/

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(127);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(127);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = Buffer.isBuffer(chunk);

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = bufferShim.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    chunk = decodeChunk(state, chunk, encoding);
    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(892).setImmediate))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__(79).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}



/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = !__webpack_require__(18) && !__webpack_require__(9)(function(){
  return Object.defineProperty(__webpack_require__(227)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.f = __webpack_require__(14);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var has          = __webpack_require__(36)
  , toIObject    = __webpack_require__(44)
  , arrayIndexOf = __webpack_require__(179)(false)
  , IE_PROTO     = __webpack_require__(229)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var dP       = __webpack_require__(19)
  , anObject = __webpack_require__(4)
  , getKeys  = __webpack_require__(108);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(44)
  , gOPN      = __webpack_require__(111).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};



/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(108)
  , gOPS     = __webpack_require__(180)
  , pIE      = __webpack_require__(149)
  , toObject = __webpack_require__(29)
  , IObject  = __webpack_require__(148)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(9)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var aFunction  = __webpack_require__(43)
  , isObject   = __webpack_require__(13)
  , invoke     = __webpack_require__(181)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $parseInt = __webpack_require__(6).parseInt
  , $trim     = __webpack_require__(129).trim
  , ws        = __webpack_require__(234)
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $parseFloat = __webpack_require__(6).parseFloat
  , $trim       = __webpack_require__(129).trim;

module.exports = 1 / $parseFloat(__webpack_require__(234) + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var cof = __webpack_require__(60);
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(13)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var aFunction = __webpack_require__(43)
  , toObject  = __webpack_require__(29)
  , IObject   = __webpack_require__(148)
  , toLength  = __webpack_require__(26);

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = __webpack_require__(29)
  , toIndex  = __webpack_require__(109)
  , toLength = __webpack_require__(26);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(done, value){
  return {value: value, done: !!done};
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(18) && /./g.flags != 'g')__webpack_require__(19).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(184)
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var strong = __webpack_require__(329);

// 23.1 Map Objects
module.exports = __webpack_require__(186)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var dP          = __webpack_require__(19).f
  , create      = __webpack_require__(110)
  , redefineAll = __webpack_require__(114)
  , ctx         = __webpack_require__(81)
  , anInstance  = __webpack_require__(113)
  , defined     = __webpack_require__(61)
  , forOf       = __webpack_require__(132)
  , $iterDefine = __webpack_require__(240)
  , step        = __webpack_require__(326)
  , setSpecies  = __webpack_require__(112)
  , DESCRIPTORS = __webpack_require__(18)
  , fastKey     = __webpack_require__(95).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var strong = __webpack_require__(329);

// 23.2 Set Objects
module.exports = __webpack_require__(186)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var each         = __webpack_require__(74)(0)
  , redefine     = __webpack_require__(42)
  , meta         = __webpack_require__(95)
  , assign       = __webpack_require__(315)
  , weak         = __webpack_require__(332)
  , isObject     = __webpack_require__(13)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(186)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var redefineAll       = __webpack_require__(114)
  , getWeak           = __webpack_require__(95).getWeak
  , anObject          = __webpack_require__(4)
  , isObject          = __webpack_require__(13)
  , anInstance        = __webpack_require__(113)
  , forOf             = __webpack_require__(132)
  , createArrayMethod = __webpack_require__(74)
  , $has              = __webpack_require__(36)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(111)
  , gOPS     = __webpack_require__(180)
  , anObject = __webpack_require__(4)
  , Reflect  = __webpack_require__(6).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(26)
  , repeat   = __webpack_require__(236)
  , defined  = __webpack_require__(61);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};



/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var getKeys   = __webpack_require__(108)
  , toIObject = __webpack_require__(44)
  , isEnum    = __webpack_require__(149).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(150)
  , from    = __webpack_require__(337);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var forOf = __webpack_require__(132);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};



/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(58)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(151),
    _assign = __webpack_require__(17);

var ReactNoopUpdateQueue = __webpack_require__(340);

var canDefineProperty = __webpack_require__(341);
var emptyObject = __webpack_require__(189);
var invariant = __webpack_require__(3);
var lowPriorityWarning = __webpack_require__(738);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(746);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};



/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;



/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(115);

var invariant = __webpack_require__(3);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactDOMComponentTree = __webpack_require__(20);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);
var escapeTextContentForBrowser = __webpack_require__(193);
var setInnerHTML = __webpack_require__(192);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(135);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(63);

var quoteAttributeValueForBrowser = __webpack_require__(779);
var warning = __webpack_require__(10);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var LinkedValueUtils = __webpack_require__(262);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactUpdates = __webpack_require__(75);

var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var ReactCompositeComponent = __webpack_require__(788);
var ReactEmptyComponent = __webpack_require__(361);
var ReactHostComponent = __webpack_require__(362);

var getNextDebugID = __webpack_require__(789);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var React = __webpack_require__(133);

var invariant = __webpack_require__(3);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(84);
var REACT_ELEMENT_TYPE = __webpack_require__(790);

var getIteratorFn = __webpack_require__(791);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(265);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(151);

var ReactCurrentOwner = __webpack_require__(84);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(53);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactDOMSelection = __webpack_require__(803);

var containsNode = __webpack_require__(805);
var focusNode = __webpack_require__(355);
var getActiveElement = __webpack_require__(367);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(137);
var DOMProperty = __webpack_require__(135);
var React = __webpack_require__(133);
var ReactBrowserEventEmitter = __webpack_require__(194);
var ReactCurrentOwner = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactDOMContainerInfo = __webpack_require__(820);
var ReactDOMFeatureFlags = __webpack_require__(821);
var ReactFeatureFlags = __webpack_require__(350);
var ReactInstanceMap = __webpack_require__(155);
var ReactInstrumentation = __webpack_require__(63);
var ReactMarkupChecksum = __webpack_require__(822);
var ReactReconciler = __webpack_require__(136);
var ReactUpdateQueue = __webpack_require__(266);
var ReactUpdates = __webpack_require__(75);

var emptyObject = __webpack_require__(189);
var instantiateReactComponent = __webpack_require__(359);
var invariant = __webpack_require__(3);
var setInnerHTML = __webpack_require__(192);
var shouldUpdateReactComponent = __webpack_require__(264);
var warning = __webpack_require__(10);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactNodeTypes = __webpack_require__(360);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(370);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(840);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);



/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(834);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);



/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(378);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(269);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(848);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);



/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*eslint-disable no-empty */
'use strict';

exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(195);

var _DOMUtils = __webpack_require__(271);

var _createHistory = __webpack_require__(382);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(860);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(116);

var _AsyncUtils = __webpack_require__(863);

var _Actions = __webpack_require__(125);

var _createLocation2 = __webpack_require__(864);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(272);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(273);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStateWithLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deprecateObjectProperties__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutingHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deprecateObjectProperties__ = __webpack_require__(196);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = deprecateObjectProperties(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PropTypes__ = __webpack_require__(198);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;
var bool = _React$PropTypes.bool;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query;
  var hash = _ref.hash;
  var state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Link',


  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3__PropTypes__["c" /* routerShape */]
  },

  propTypes: {
    to: oneOfType([string, object]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    !this.context.router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    var _props = this.props;
    var to = _props.to;
    var query = _props.query;
    var hash = _props.hash;
    var state = _props.state;

    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

    this.context.router.push(location);
  },
  render: function render() {
    var _props2 = this.props;
    var to = _props2.to;
    var query = _props2.query;
    var hash = _props2.hash;
    var state = _props2.state;
    var activeClassName = _props2.activeClassName;
    var activeStyle = _props2.activeStyle;
    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? warning(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PatternUtils__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(117);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);







var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_2__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location;
        var params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_3__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_3__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(388);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* harmony default export */ __webpack_exports__["a"] = (function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(276);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(390);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(50).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(392);
/*</replacement>*/

var Buffer = __webpack_require__(79).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(277);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(156);
util.inherits = __webpack_require__(147);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(890);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(891);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(127);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(308).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(127);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = bufferShim.from(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var _e = new Error('stream.unshift() after end event');
      stream.emit('error', _e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(308).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = bufferShim.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(50).EventEmitter;



/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = __webpack_require__(127);

/*<replacement>*/
var util = __webpack_require__(156);
util.inherits = __webpack_require__(147);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};



/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;



/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;



/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(904);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(905);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(58)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = !__webpack_require__(77) && !__webpack_require__(101)(function(){
  return Object.defineProperty(__webpack_require__(280)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(99);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var has          = __webpack_require__(119)
  , toIObject    = __webpack_require__(90)
  , arrayIndexOf = __webpack_require__(912)(false)
  , IE_PROTO     = __webpack_require__(283)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(38).document && document.documentElement;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(119)
  , toObject    = __webpack_require__(140)
  , IE_PROTO    = __webpack_require__(283)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(done, value){
  return {value: value, done: !!done};
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(65);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// check on default Array iterator
var Iterators  = __webpack_require__(139)
  , ITERATOR   = __webpack_require__(32)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ctx                = __webpack_require__(98)
  , invoke             = __webpack_require__(918)
  , html               = __webpack_require__(401)
  , cel                = __webpack_require__(280)
  , global             = __webpack_require__(38)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(158)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global      = __webpack_require__(38)
  , core        = __webpack_require__(15)
  , dP          = __webpack_require__(64)
  , DESCRIPTORS = __webpack_require__(77)
  , SPECIES     = __webpack_require__(32)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var ITERATOR     = __webpack_require__(32)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);


'use strict';

module.exports =

    /**
     * Takes in a {key:val} and returns a key:key
     *  
     * @param object {key1 : val1 ... keyn:valn}
     */
    function(obj) {
        var key;
        var mirrored = {};

        if ( obj && typeof obj === 'object' ) {
            for (key in obj) {
                if (obj.hasOwnProperty(key)) {
                    mirrored[key] = key;
                }
            }
        }
        return mirrored;
    };



/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2f51bb59fe7f4afe1f614e8ad431f4c6.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/60b86f79c18e1fdf64073ce34dbc5903.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fa44c89ddfe141733a9b014159b16a6e.png";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9f2f4cdae93ebe73045aec37eb210fda.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d54040ed5db8aec295180831de77c504.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b45481f508ec8b25036b2491d3c89305.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/409e5045b5864ba9254118f19cedbecf.png";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d663a5d3e4b08213cb00f5bfafecf160.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1a8791e49cc0ebcc96186ebc554cfc16.png";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(948), __esModule: true };


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(950), __esModule: true };


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(158);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(400)
  , hiddenKeys = __webpack_require__(285).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createPersistor__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTransform__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__persistStore__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createPersistor", function() { return __WEBPACK_IMPORTED_MODULE_1__createPersistor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return __WEBPACK_IMPORTED_MODULE_2__createTransform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredState", function() { return __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistStore", function() { return __WEBPACK_IMPORTED_MODULE_4__persistStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__["a"]; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);








// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};




/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__purgeStoredState__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);






function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__purgeStoredState__["a" /* default */])({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__ = __webpack_require__(426);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(161);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}



/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(425);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.busy = exports.completeRetry = exports.scheduleRetry = exports.networkStatusChanged = undefined;

var _constants = __webpack_require__(293);

var networkStatusChanged = exports.networkStatusChanged = function networkStatusChanged(online) {
  return {
    type: _constants.OFFLINE_STATUS_CHANGED,
    payload: {
      online: online
    }
  };
};

var scheduleRetry = exports.scheduleRetry = function scheduleRetry() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    type: _constants.OFFLINE_SCHEDULE_RETRY,
    payload: {
      delay: delay
    }
  };
};

var completeRetry = exports.completeRetry = function completeRetry(action, retryToken) {
  return {
    type: _constants.OFFLINE_COMPLETE_RETRY,
    payload: action,
    meta: { retryToken: retryToken }
  };
};

var busy = exports.busy = function busy(isBusy) {
  return {
    type: _constants.OFFLINE_BUSY,
    payload: { busy: isBusy }
  };
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _persist = __webpack_require__(980);

var _persist2 = _interopRequireDefault(_persist);

var _detectNetwork = __webpack_require__(981);

var _detectNetwork2 = _interopRequireDefault(_detectNetwork);

var _effect = __webpack_require__(432);

var _effect2 = _interopRequireDefault(_effect);

var _batch = __webpack_require__(982);

var _batch2 = _interopRequireDefault(_batch);

var _retry = __webpack_require__(983);

var _retry2 = _interopRequireDefault(_retry);

var _discard = __webpack_require__(984);

var _discard2 = _interopRequireDefault(_discard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  rehydrate: true,
  persist: _persist2.default,
  detectNetwork: _detectNetwork2.default,
  batch: _batch2.default,
  effect: _effect2.default,
  retry: _retry2.default,
  discard: _discard2.default
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.NetworkError = NetworkError;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NetworkError(response, status) {
  this.name = 'NetworkError';
  this.status = status;
  this.response = response;
}

//$FlowFixMe

/*global fetch*/

NetworkError.prototype = Error.prototype;
NetworkError.prototype.status = null;

var tryParseJSON = function tryParseJSON(json) {
  if (!json) {
    return null;
  }
  try {
    return JSON.parse(json);
  } catch (e) {
    throw new Error('Failed to parse unexpected JSON response: ' + json);
  }
};

var getResponseBody = function getResponseBody(res) {
  var contentType = res.headers.get('content-type');
  return contentType.indexOf('json') >= 0 ? res.text().then(tryParseJSON) : res.text();
};

exports.default = function (effect, _action) {
  var url = effect.url,
      options = _objectWithoutProperties(effect, ['url']);

  var headers = _extends({ 'content-type': 'application/json' }, options.headers);
  return fetch(url, _extends({}, options, { headers: headers })).then(function (res) {
    if (res.ok) {
      return getResponseBody(res);
    } else {
      return getResponseBody(res).then(function (body) {
        throw new NetworkError(body || '', res.status);
      });
    }
  });
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _channels = __webpack_require__(996);

var _channels2 = _interopRequireDefault(_channels);

var _general = __webpack_require__(1011);

var _general2 = _interopRequireDefault(_general);

var _users = __webpack_require__(1012);

var _users2 = _interopRequireDefault(_users);

var _teams = __webpack_require__(1013);

var _teams2 = _interopRequireDefault(_teams);

var _posts = __webpack_require__(1015);

var _posts2 = _interopRequireDefault(_posts);

var _files = __webpack_require__(1016);

var _files2 = _interopRequireDefault(_files);

var _preferences = __webpack_require__(1017);

var _preferences2 = _interopRequireDefault(_preferences);

var _typing = __webpack_require__(1018);

var _typing2 = _interopRequireDefault(_typing);

var _integrations = __webpack_require__(1019);

var _integrations2 = _interopRequireDefault(_integrations);

var _emojis = __webpack_require__(1020);

var _emojis2 = _interopRequireDefault(_emojis);

var _admin = __webpack_require__(1021);

var _admin2 = _interopRequireDefault(_admin);

var _alerts = __webpack_require__(1022);

var _alerts2 = _interopRequireDefault(_alerts);

var _jobs = __webpack_require__(1023);

var _jobs2 = _interopRequireDefault(_jobs);

var _search = __webpack_require__(1024);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    general: _general2.default,
    users: _users2.default,
    teams: _teams2.default,
    channels: _channels2.default,
    posts: _posts2.default,
    files: _files2.default,
    preferences: _preferences2.default,
    typing: _typing2.default,
    integrations: _integrations2.default,
    emojis: _emojis2.default,
    admin: _admin2.default,
    alerts: _alerts2.default,
    jobs: _jobs2.default,
    search: _search2.default
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addDatesToPostList = addDatesToPostList;
exports.isPostFlagged = isPostFlagged;
exports.isSystemMessage = isSystemMessage;
exports.isFromWebhook = isFromWebhook;
exports.isPostEphemeral = isPostEphemeral;
exports.shouldIgnorePost = shouldIgnorePost;
exports.isPostOwner = isPostOwner;
exports.isEdited = isEdited;
exports.canDeletePost = canDeletePost;
exports.canEditPost = canEditPost;
exports.getLastCreateAt = getLastCreateAt;
exports.shouldFilterPost = shouldFilterPost;
exports.isPostPendingOrFailed = isPostPendingOrFailed;

var _constants = __webpack_require__(8);

var _preference_utils = __webpack_require__(142);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function addDatesToPostList(posts) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var indicateNewMessages = options.indicateNewMessages,
        currentUserId = options.currentUserId,
        lastViewedAt = options.lastViewedAt;


    var out = [];

    var lastDate = null;
    var subsequentPostIsUnread = false;
    var subsequentPostUserId = void 0;
    var postIsUnread = void 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = posts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var post = _step.value;

            if (post.state === _constants.Posts.POST_DELETED && post.user_id === currentUserId) {
                continue;
            }
            postIsUnread = post.create_at > lastViewedAt;
            if (indicateNewMessages && subsequentPostIsUnread && !postIsUnread && subsequentPostUserId !== currentUserId) {
                out.push(_constants.General.START_OF_NEW_MESSAGES);
            }
            subsequentPostIsUnread = postIsUnread;
            subsequentPostUserId = post.user_id;

            var postDate = new Date(post.create_at);

            // Push on a date header if the last post was on a different day than the current one
            if (lastDate && lastDate.toDateString() !== postDate.toDateString()) {
                out.push(lastDate);
            }

            lastDate = postDate;
            out.push(post);
        }

        // Push on the date header for the oldest post
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (lastDate) {
        out.push(lastDate);
    }

    return out;
}

function isPostFlagged(postId, myPreferences) {
    var key = (0, _preference_utils.getPreferenceKey)(_constants.Preferences.CATEGORY_FLAGGED_POST, postId);
    return myPreferences.hasOwnProperty(key);
}

function isSystemMessage(post) {
    return post.type !== '' && post.type && post.type.startsWith(_constants.Posts.SYSTEM_MESSAGE_PREFIX);
}

function isFromWebhook(post) {
    return post.props && post.props.from_webhook;
}

function isPostEphemeral(post) {
    return post.type === _constants.Posts.POST_TYPES.EPHEMERAL || post.state === _constants.Posts.POST_DELETED;
}

function shouldIgnorePost(post) {
    return _constants.Posts.IGNORE_POST_TYPES.includes(post.type);
}

function isPostOwner(userId, post) {
    return userId === post.user_id;
}

function isEdited(post) {
    return post.edit_at > 0;
}

function canDeletePost(config, license, userId, post, isAdmin, isSystemAdmin) {
    var isOwner = isPostOwner(userId, post);

    if (license.IsLicensed === 'true') {
        return config.RestrictPostDelete === _constants.General.PERMISSIONS_ALL && (isOwner || isAdmin) || config.RestrictPostDelete === _constants.General.PERMISSIONS_TEAM_ADMIN && isAdmin || config.RestrictPostDelete === _constants.General.PERMISSIONS_SYSTEM_ADMIN && isSystemAdmin;
    }
    return isOwner || isAdmin;
}

function canEditPost(config, license, userId, post, editDisableAction) {
    var isOwner = isPostOwner(userId, post);
    var canEdit = isOwner && !isSystemMessage(post);

    if (canEdit && license.IsLicensed === 'true') {
        if (config.AllowEditPost === _constants.General.ALLOW_EDIT_POST_NEVER) {
            canEdit = false;
        } else if (config.AllowEditPost === _constants.General.ALLOW_EDIT_POST_TIME_LIMIT) {
            var timeLeft = post.create_at + config.PostEditTimeLimit * 1000 - Date.now();
            if (timeLeft > 0) {
                editDisableAction.fireAfter(timeLeft + 1000);
            } else {
                canEdit = false;
            }
        }
    }
    return canEdit;
}

function getLastCreateAt(postsArray) {
    var createAt = postsArray.map(function (p) {
        return p.create_at;
    });

    if (createAt.length) {
        return Reflect.apply(Math.max, null, createAt);
    }

    return 0;
}

function shouldFilterPost(post) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Add as much filters as needed here, if you want to filter the post return true
    var postTypes = _constants.Posts.POST_TYPES;

    if (options.filterJoinLeave && (post.type === postTypes.JOIN_LEAVE || post.type === postTypes.JOIN_CHANNEL || post.type === postTypes.LEAVE_CHANNEL)) {
        return true;
    }

    return false;
}

function isPostPendingOrFailed(post) {
    return post.failed || post.id === post.pending_post_id;
}


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var state = {
    entities: {
        general: {
            appState: false,
            credentials: {},
            config: {},
            deviceToken: '',
            license: {},
            serverVersion: ''
        },
        users: {
            currentUserId: '',
            mySessions: [],
            myAudits: [],
            profiles: {},
            profilesInTeam: {},
            profilesNotInTeam: {},
            profilesWithoutTeam: new Set(),
            profilesInChannel: {},
            profilesNotInChannel: {},
            statuses: {}
        },
        teams: {
            currentTeamId: '',
            teams: {},
            myMembers: {},
            membersInTeam: {},
            stats: {}
        },
        channels: {
            currentChannelId: '',
            channels: {},
            channelsInTeam: {},
            myMembers: {},
            members: {},
            stats: {}
        },
        posts: {
            posts: {},
            postsByChannel: {},
            selectedPostId: '',
            currentFocusedPostId: ''
        },
        preferences: {
            myPreferences: {}
        },
        admin: {
            logs: [],
            audits: {},
            config: {},
            complianceReports: {}
        },
        alerts: {
            alertStack: []
        },
        integrations: {
            incomingHooks: {},
            outgoingHooks: {},
            oauthApps: {},
            commands: {}
        },
        files: {
            files: {},
            fileIdsByPostId: {}
        },
        emojis: {
            customEmoji: {}
        },
        typing: {}
    },
    errors: [],
    requests: {
        channels: {
            getChannel: {
                status: 'not_started',
                error: null
            },
            getChannels: {
                status: 'not_started',
                error: null
            },
            myMembers: {
                status: 'not_started',
                error: null
            },
            members: {
                status: 'not_started',
                error: null
            },
            myChannels: {
                status: 'not_started',
                error: null
            },
            createChannel: {
                status: 'not_started',
                error: null
            },
            updateChannel: {
                status: 'not_started',
                error: null
            },
            updateChannelNotifyProps: {
                status: 'not_started',
                error: null
            },
            leaveChannel: {
                status: 'not_started',
                error: null
            },
            joinChannel: {
                status: 'not_started',
                error: null
            },
            deleteChannel: {
                status: 'not_started',
                error: null
            },
            updateLastViewedAt: {
                status: 'not_started',
                error: null
            },
            getChannelStats: {
                status: 'not_started',
                error: null
            },
            addChannelMember: {
                status: 'not_started',
                error: null
            },
            removeChannelMember: {
                status: 'not_started',
                error: null
            }
        },
        general: {
            server: {
                status: 'not_started',
                error: null
            },
            config: {
                status: 'not_started',
                error: null
            },
            license: {
                status: 'not_started',
                error: null
            },
            websocket: {
                status: 'not_started',
                error: null
            }
        },
        posts: {
            createPost: {
                status: 'not_started',
                error: null
            },
            editPost: {
                status: 'not_started',
                error: null
            },
            deletePost: {
                status: 'not_started',
                error: null
            },
            getPostThread: {
                status: 'not_started',
                error: null
            },
            getPostThreadRetryAttempts: 0,
            getPosts: {
                status: 'not_started',
                error: null
            },
            getPostsRetryAttempts: 0,
            getPostsSince: {
                status: 'not_started',
                error: null
            },
            getPostsSinceRetryAttempts: 0,
            getPostsBefore: {
                status: 'not_started',
                error: null
            },
            getPostsBeforeRetryAttempts: 0,
            getPostsAfter: {
                status: 'not_started',
                error: null
            },
            getPostsAfterRetryAttempts: 0
        },
        teams: {
            getMyTeams: {
                status: 'not_started',
                error: null
            },
            getTeams: {
                status: 'not_started',
                error: null
            },
            createTeam: {
                status: 'not_started',
                error: null
            },
            updateTeam: {
                status: 'not_started',
                error: null
            },
            getMyTeamMembers: {
                status: 'not_started',
                error: null
            },
            getTeamMembers: {
                status: 'not_started',
                error: null
            },
            getTeamStats: {
                status: 'not_started',
                error: null
            },
            addUserToTeam: {
                status: 'not_started',
                error: null
            },
            removeUserFromTeam: {
                status: 'not_started',
                error: null
            }
        },
        users: {
            checkMfa: {
                status: 'not_started',
                error: null
            },
            login: {
                status: 'not_started',
                error: null
            },
            logout: {
                status: 'not_started',
                error: null
            },
            create: {
                status: 'not_started',
                error: null
            },
            getProfiles: {
                status: 'not_started',
                error: null
            },
            getProfilesInTeam: {
                status: 'not_started',
                error: null
            },
            getProfilesInChannel: {
                status: 'not_started',
                error: null
            },
            getProfilesNotInChannel: {
                status: 'not_started',
                error: null
            },
            getUser: {
                status: 'not_started',
                error: null
            },
            getUserByUsername: {
                status: 'not_started',
                error: null
            },
            getStatusesByIds: {
                status: 'not_started',
                error: null
            },
            getSessions: {
                status: 'not_started',
                error: null
            },
            revokeSession: {
                status: 'not_started',
                error: null
            },
            getAudits: {
                status: 'not_started',
                error: null
            },
            autocompleteUsers: {
                status: 'not_started',
                error: null
            },
            searchProfiles: {
                status: 'not_started',
                error: null
            },
            updateMe: {
                status: 'not_started',
                error: null
            }
        },
        preferences: {
            getMyPreferences: {
                status: 'not_started',
                error: null
            },
            savePreferences: {
                status: 'not_started',
                error: null
            },
            deletePreferences: {
                status: 'not_started',
                error: null
            }
        },
        admin: {
            getLogs: {
                status: 'not_started',
                error: null
            },
            getAudits: {
                status: 'not_started',
                error: null
            },
            getConfig: {
                status: 'not_started',
                error: null
            },
            updateConfig: {
                status: 'not_started',
                error: null
            },
            reloadConfig: {
                status: 'not_started',
                error: null
            },
            testEmail: {
                status: 'not_started',
                error: null
            },
            invalidateCaches: {
                status: 'not_started',
                error: null
            },
            recycleDatabase: {
                status: 'not_started',
                error: null
            },
            createCompliance: {
                status: 'not_started',
                error: null
            },
            getCompliance: {
                status: 'not_started',
                error: null
            }
        },
        emojis: {
            createCustomEmoji: {
                status: 'not_started',
                error: null
            },
            getCustomEmojis: {
                status: 'not_started',
                error: null
            },
            deleteCustomEmoji: {
                status: 'not_started',
                error: null
            }
        },
        files: {
            getFilesForPost: {
                status: 'not_started',
                error: null
            },
            uploadFiles: {
                status: 'not_started',
                error: null
            }
        },
        integrations: {
            createIncomingHook: {
                status: 'not_started',
                error: null
            },
            getIncomingHooks: {
                status: 'not_started',
                error: null
            },
            deleteIncomingHook: {
                status: 'not_started',
                error: null
            },
            updateIncomingHook: {
                status: 'not_started',
                error: null
            },
            createOutgoingHook: {
                status: 'not_started',
                error: null
            },
            getOutgoingHooks: {
                status: 'not_started',
                error: null
            },
            deleteOutgoingHook: {
                status: 'not_started',
                error: null
            },
            updateOutgoingHook: {
                status: 'not_started',
                error: null
            },
            getCustomTeamCommands: {
                status: 'not_started',
                error: null
            },
            addCommand: {
                status: 'not_started',
                error: null
            },
            regenCommandToken: {
                status: 'not_started',
                error: null
            },
            editCommand: {
                status: 'not_started',
                error: null
            },
            deleteCommand: {
                status: 'not_started',
                error: null
            }
        }
    }
};

exports.default = state;


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__purgeStoredState__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);






function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__purgeStoredState__["a" /* default */])({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__ = __webpack_require__(438);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(162);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(437);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _views = __webpack_require__(1046);

var _views2 = _interopRequireDefault(_views);

var _entities = __webpack_require__(1049);

var _entities2 = _interopRequireDefault(_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ---

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    views: _views2.default,
    entities: _entities2.default
};

// +++ Cordchat - overrides the mattermost-redux `entities` reducer to add users.statusesDetail

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var dP          = __webpack_require__(64).f
  , create      = __webpack_require__(204)
  , redefineAll = __webpack_require__(288)
  , ctx         = __webpack_require__(98)
  , anInstance  = __webpack_require__(286)
  , defined     = __webpack_require__(201)
  , forOf       = __webpack_require__(208)
  , $iterDefine = __webpack_require__(279)
  , step        = __webpack_require__(403)
  , setSpecies  = __webpack_require__(407)
  , DESCRIPTORS = __webpack_require__(77)
  , fastKey     = __webpack_require__(291).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global         = __webpack_require__(38)
  , $export        = __webpack_require__(31)
  , meta           = __webpack_require__(291)
  , fails          = __webpack_require__(101)
  , hide           = __webpack_require__(99)
  , redefineAll    = __webpack_require__(288)
  , forOf          = __webpack_require__(208)
  , anInstance     = __webpack_require__(286)
  , isObject       = __webpack_require__(100)
  , setToStringTag = __webpack_require__(159)
  , dP             = __webpack_require__(64).f
  , each           = __webpack_require__(1055)(0)
  , DESCRIPTORS    = __webpack_require__(77);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(207)
  , from    = __webpack_require__(1059);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var data = {};
var etags = {};

exports.default = function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { headers: {} };

    url = url || options.url; // eslint-disable-line no-param-reassign

    if (options.method === 'GET' || !options.method) {
        var etag = etags[url];
        var cachedResponse = data['' + url + etag]; // ensure etag is for url
        if (etag) {
            options.headers['If-None-Match'] = etag;
        }

        return fetch(url, options).then(function (response) {
            if (response.status === 304) {
                return cachedResponse.clone();
            }

            if (response.status === 200) {
                var responseEtag = response.headers.get('Etag');

                if (responseEtag) {
                    data['' + url + responseEtag] = response.clone();
                    etags[url] = responseEtag;
                }
            }

            return response;
        });
    }

    // all other requests go straight to fetch
    return Reflect.apply(fetch, undefined, [url, options]); //eslint-disable-line no-undefined
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* jshint node:true */

'use strict';

var IntlMessageFormat = __webpack_require__(1075)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1082);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;



/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";
exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'change';

var NotificationStoreClass = function (_EventEmitter) {
    (0, _inherits3.default)(NotificationStoreClass, _EventEmitter);

    function NotificationStoreClass() {
        (0, _classCallCheck3.default)(this, NotificationStoreClass);
        return (0, _possibleConstructorReturn3.default)(this, (NotificationStoreClass.__proto__ || (0, _getPrototypeOf2.default)(NotificationStoreClass)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotificationStoreClass, [{
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'setFocus',
        value: function setFocus(focus) {
            this.inFocus = focus;
        }
    }, {
        key: 'getFocus',
        value: function getFocus() {
            return this.inFocus;
        }
    }]);
    return NotificationStoreClass;
}(_events2.default);

var NotificationStore = new NotificationStoreClass();

NotificationStore.dispatchToken = _app_dispatcher2.default.register(function (payload) {
    var action = payload.action;

    switch (action.type) {
        case ActionTypes.BROWSER_CHANGE_FOCUS:
            NotificationStore.setFocus(action.focus);
            break;
    }
});

exports.default = NotificationStore;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap Colorpicker v2.5.1\n * https://itsjavi.com/bootstrap-colorpicker/\n *\n * Originally written by (c) 2012 Stefan Petre\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0.txt\n *\n */.colorpicker-saturation{width:100px;height:100px;background-image:url(" + __webpack_require__(1108) + ");cursor:crosshair;float:left}.colorpicker-saturation i{display:block;height:5px;width:5px;border:1px solid #000;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;position:absolute;top:0;left:0;margin:-4px 0 0 -4px}.colorpicker-saturation i b{display:block;height:5px;width:5px;border:1px solid #fff;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.colorpicker-alpha,.colorpicker-hue{width:15px;height:100px;float:left;cursor:row-resize;margin-left:4px;margin-bottom:4px}.colorpicker-alpha i,.colorpicker-hue i{display:block;height:1px;background:#000;border-top:1px solid #fff;position:absolute;top:0;left:0;width:100%;margin-top:-1px}.colorpicker-hue{background-image:url(" + __webpack_require__(1109) + ")}.colorpicker-alpha{background-image:url(" + __webpack_require__(450) + ");display:none}.colorpicker-alpha,.colorpicker-hue,.colorpicker-saturation{background-size:contain}.colorpicker{padding:4px;min-width:130px;margin-top:1px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;z-index:2500}.colorpicker:after,.colorpicker:before{display:table;content:\"\";line-height:0}.colorpicker:after{clear:both}.colorpicker:before{border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);top:-7px;left:6px}.colorpicker:after,.colorpicker:before{content:\"\";display:inline-block;position:absolute}.colorpicker:after{border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;top:-6px;left:7px}.colorpicker div{position:relative}.colorpicker.colorpicker-with-alpha{min-width:140px}.colorpicker.colorpicker-with-alpha .colorpicker-alpha{display:block}.colorpicker-color{height:10px;margin-top:5px;clear:both;background-image:url(" + __webpack_require__(450) + ");background-position:0 100%}.colorpicker-color div{height:10px}.colorpicker-selectors{display:none;height:10px;margin-top:5px;clear:both}.colorpicker-selectors i{cursor:pointer;float:left;height:10px;width:10px}.colorpicker-selectors i+i{margin-left:3px}.colorpicker-element .add-on i,.colorpicker-element .input-group-addon i{display:inline-block;cursor:pointer;height:16px;vertical-align:text-top;width:16px}.colorpicker.colorpicker-inline{position:relative;display:inline-block;float:none;z-index:auto}.colorpicker.colorpicker-horizontal{width:110px;min-width:110px;height:auto}.colorpicker.colorpicker-horizontal .colorpicker-saturation{margin-bottom:4px}.colorpicker.colorpicker-horizontal .colorpicker-color{width:100px}.colorpicker.colorpicker-horizontal .colorpicker-alpha,.colorpicker.colorpicker-horizontal .colorpicker-hue{width:100px;height:15px;float:left;cursor:col-resize;margin-left:0;margin-bottom:4px}.colorpicker.colorpicker-horizontal .colorpicker-alpha i,.colorpicker.colorpicker-horizontal .colorpicker-hue i{display:block;height:15px;background:#fff;position:absolute;top:0;left:0;width:1px;border:none;margin-top:0}.colorpicker.colorpicker-horizontal .colorpicker-hue{background-image:url(" + __webpack_require__(1110) + ")}.colorpicker.colorpicker-horizontal .colorpicker-alpha{background-image:url(" + __webpack_require__(1111) + ")}.colorpicker-right:before{left:auto;right:6px}.colorpicker-right:after{left:auto;right:7px}.colorpicker-no-arrow:after,.colorpicker-no-arrow:before{border-right:0;border-left:0}.colorpicker-alpha.colorpicker-visible,.colorpicker-hue.colorpicker-visible,.colorpicker-saturation.colorpicker-visible,.colorpicker-selectors.colorpicker-visible,.colorpicker.colorpicker-visible{display:block}.colorpicker-alpha.colorpicker-hidden,.colorpicker-hue.colorpicker-hidden,.colorpicker-saturation.colorpicker-hidden,.colorpicker-selectors.colorpicker-hidden,.colorpicker.colorpicker-hidden{display:none}.colorpicker-inline.colorpicker-visible{display:inline-block}", ""]);

// exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5278808a4d6b13c98d9484109547b749.png";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/357d675366cce0fbb6ca5e1474ae489c.eot";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9a599f54797d2ae5a61a3243b4e816fb.eot";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/98255d04bb0ce821171ea055fdfcc53f.eot";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b07fc5b16bb5ecf336f31a8e993c9865.eot";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ce26ce4629f1e78f666544143a88c286.eot";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ca4e3b468e0d24ae948b162e83fc225d.eot";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/672c96197e82b9e38e0feb8267cf10d8.eot";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3c3fce5eb8b64ba21d19eaa6d40ff339.eot";

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a0ba2817318bda0e08e59e2f07416112.eot";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2b4454d6e2f687619cbd307e75102078.eot";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/dc81eae9effb44e3651c8f6fd9513818.eot";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d327c2105b014c15a277a56f54927e2e.eot";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2702ac35e78692e600011ed1c85ef060.eot";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/31ec4506469620df9b5295998a4bfead.eot";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/031026c46bba0e8de61c6efabd9b263a.eot";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a3319b736d9c1594add4dd56dcb002bf.eot";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/cf8394e808472179776070c3aa4d8169.eot";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5438d9d464a3973d450201211780eeb7.eot";

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1f5c2abfeea0beaf96c20fcada9ef082.eot";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1a6c0d68e798835afb71c745092d80f5.eot";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5a3cee2bf91471f8b0356195afde026c.eot";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b2e94149f3405c883c9af607c80bf42c.eot";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = __webpack_require__(751);



/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;



/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);








/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmojiMap = undefined;

var _typeof2 = __webpack_require__(169);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _iterator = __webpack_require__(420);

var _iterator2 = _interopRequireDefault(_iterator);

var _toConsumableArray2 = __webpack_require__(168);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _events = __webpack_require__(50);

var _events2 = _interopRequireDefault(_events);

var _emoji2 = __webpack_require__(489);

var Emoji = _interopRequireWildcard(_emoji2);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _emojis = __webpack_require__(488);

var _client = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'changed';
var MAXIMUM_RECENT_EMOJI = 27;

// Wrap the contents of the store so that we don't need to construct an ES6 map where most of the content
// (the system emojis) will never change. It provides the get/has functions of a map and an iterator so
// that it can be used in for..of loops

var EmojiMap = exports.EmojiMap = function () {
    function EmojiMap(customEmojis) {
        (0, _classCallCheck3.default)(this, EmojiMap);

        this.customEmojis = customEmojis;

        // Store customEmojis to an array so we can iterate it more easily
        this.customEmojisArray = [].concat((0, _toConsumableArray3.default)(customEmojis));
    }

    (0, _createClass3.default)(EmojiMap, [{
        key: 'has',
        value: function has(name) {
            return Emoji.EmojiIndicesByAlias.has(name) || this.customEmojis.has(name);
        }
    }, {
        key: 'get',
        value: function get(name) {
            if (Emoji.EmojiIndicesByAlias.has(name)) {
                return Emoji.Emojis[Emoji.EmojiIndicesByAlias.get(name)];
            }

            return this.customEmojis.get(name);
        }
    }, {
        key: _iterator2.default,
        value: function value() {
            var customEmojisArray = this.customEmojisArray;

            return {
                systemIndex: 0,
                customIndex: 0,
                next: function next() {
                    if (this.systemIndex < Emoji.Emojis.length) {
                        var emoji = Emoji.Emojis[this.systemIndex];

                        this.systemIndex += 1;

                        return { value: [emoji.aliases[0], emoji] };
                    }

                    if (this.customIndex < customEmojisArray.length) {
                        var _emoji = customEmojisArray[this.customIndex][1];

                        this.customIndex += 1;

                        return { value: [_emoji.name, _emoji] };
                    }

                    return { done: true };
                }
            };
        }
    }]);
    return EmojiMap;
}();

var EmojiStore = function (_EventEmitter) {
    (0, _inherits3.default)(EmojiStore, _EventEmitter);

    function EmojiStore() {
        (0, _classCallCheck3.default)(this, EmojiStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiStore.__proto__ || (0, _getPrototypeOf2.default)(EmojiStore)).call(this));

        _this.dispatchToken = _app_dispatcher2.default.register(_this.handleEventPayload.bind(_this));

        _this.setMaxListeners(600);

        _this.map = new EmojiMap((0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState()));

        _this.entities = {};

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.emojis.customEmoji;

            if (newEntities !== _this.entities) {
                _this.map = new EmojiMap((0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState()));
                _this.emitChange();
            }

            _this.entities = newEntities;
        });
        return _this;
    }

    (0, _createClass3.default)(EmojiStore, [{
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'hasSystemEmoji',
        value: function hasSystemEmoji(name) {
            return Emoji.EmojiIndicesByAlias.has(name);
        }
    }, {
        key: 'getCustomEmojiMap',
        value: function getCustomEmojiMap() {
            return (0, _emojis.getCustomEmojisByName)(_redux_store2.default.getState());
        }
    }, {
        key: 'getEmojis',
        value: function getEmojis() {
            return this.map;
        }
    }, {
        key: 'has',
        value: function has(name) {
            return this.map.has(name);
        }
    }, {
        key: 'get',
        value: function get(name) {
            return this.map.get(name);
        }
    }, {
        key: 'addRecentEmoji',
        value: function addRecentEmoji(alias) {
            var recentEmojis = this.getRecentEmojis();

            var name = void 0;
            var emoji = this.get(alias);
            if (!emoji) {
                return;
            } else if (emoji.name) {
                name = emoji.name;
            } else {
                name = emoji.aliases[0];
            }

            var index = recentEmojis.indexOf(name);
            if (index !== -1) {
                recentEmojis.splice(index, 1);
            }

            recentEmojis.push(name);

            if (recentEmojis.length > MAXIMUM_RECENT_EMOJI) {
                recentEmojis.splice(0, recentEmojis.length - MAXIMUM_RECENT_EMOJI);
            }

            localStorage.setItem(_constants2.default.RECENT_EMOJI_KEY, (0, _stringify2.default)(recentEmojis));
        }
    }, {
        key: 'getRecentEmojis',
        value: function getRecentEmojis() {
            var recentEmojis = void 0;
            try {
                recentEmojis = JSON.parse(localStorage.getItem(_constants2.default.RECENT_EMOJI_KEY));
            } catch (e) {
                // Errors are handled below
            }

            if (!recentEmojis) {
                return [];
            }

            if (recentEmojis.length > 0 && (0, _typeof3.default)(recentEmojis[0]) === 'object') {
                // Prior to PLT-7267, recent emojis were stored with the entire object for the emoji, but this
                // has been changed to store only the names of the emojis, so we need to change that
                recentEmojis = recentEmojis.map(function (emoji) {
                    return emoji.name || emoji.aliases[0];
                });
            }

            return recentEmojis;
        }
    }, {
        key: 'hasUnicode',
        value: function hasUnicode(codepoint) {
            return Emoji.EmojiIndicesByUnicode.has(codepoint);
        }
    }, {
        key: 'getUnicode',
        value: function getUnicode(codepoint) {
            return Emoji.Emojis[Emoji.EmojiIndicesByUnicode.get(codepoint)];
        }
    }, {
        key: 'getEmojiImageUrl',
        value: function getEmojiImageUrl(emoji) {
            if (emoji.id) {
                return _client.Client4.getUrlVersion() + '/emoji/' + emoji.id + '/image';
            }

            var filename = emoji.filename || emoji.aliases[0];

            return _constants2.default.EMOJI_PATH + '/' + filename + '.png';
        }
    }, {
        key: 'handleEventPayload',
        value: function handleEventPayload(payload) {
            var action = payload.action;

            switch (action.type) {
                case ActionTypes.EMOJI_POSTED:
                    this.addRecentEmoji(action.alias);
                    this.emitChange();
                    break;
            }
        }
    }]);
    return EmojiStore;
}(_events2.default);

exports.default = new EmojiStore();

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMOJI_PATTERN = exports.emoticonPatterns = undefined;

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.handleEmoticons = handleEmoticons;

var _emoji_store = __webpack_require__(477);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emoticonPatterns = exports.emoticonPatterns = {
    slightly_smiling_face: /(^|\s)(:-?\))(?=$|\s)/g, // :)
    wink: /(^|\s)(;-?\))(?=$|\s)/g, // ;)
    open_mouth: /(^|\s)(:o)(?=$|\s)/gi, // :o
    scream: /(^|\s)(:-o)(?=$|\s)/gi, // :-o
    smirk: /(^|\s)(:-?])(?=$|\s)/g, // :]
    smile: /(^|\s)(:-?d)(?=$|\s)/gi, // :D
    stuck_out_tongue_closed_eyes: /(^|\s)(x-d)(?=$|\s)/gi, // x-d
    stuck_out_tongue: /(^|\s)(:-?p)(?=$|\s)/gi, // :p
    rage: /(^|\s)(:-?[[@])(?=$|\s)/g, // :@
    slightly_frowning_face: /(^|\s)(:-?\()(?=$|\s)/g, // :(
    cry: /(^|\s)(:['’]-?\(|:&#x27;\(|:&#39;\()(?=$|\s)/g, // :`(
    confused: /(^|\s)(:-?\/)(?=$|\s)/g, // :/
    confounded: /(^|\s)(:-?s)(?=$|\s)/gi, // :s
    neutral_face: /(^|\s)(:-?\|)(?=$|\s)/g, // :|
    flushed: /(^|\s)(:-?\$)(?=$|\s)/g, // :$
    mask: /(^|\s)(:-x)(?=$|\s)/gi, // :-x
    heart: /(^|\s)(<3|&lt;3)(?=$|\s)/g, // <3
    broken_heart: /(^|\s)(<\/3|&lt;&#x2F;3)(?=$|\s)/g, // </3
    thumbsup: /(^|\s)(:\+1:)(?=$|\s)/g, // :+1:
    thumbsdown: /(^|\s)(:-1:)(?=$|\s)/g // :-1:
}; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EMOJI_PATTERN = exports.EMOJI_PATTERN = /(:([a-zA-Z0-9_-]+):)/g;

function handleEmoticons(text, tokens, emojis) {
    var output = text;

    function replaceEmoticonWithToken(fullMatch, prefix, matchText, name) {
        var index = tokens.size;
        var alias = '$MM_EMOTICON' + index;

        if (emojis.has(name)) {
            var path = _emoji_store2.default.getEmojiImageUrl(emojis.get(name));

            // we have an image path so we found a matching emoticon
            tokens.set(alias, {
                value: '<span alt="' + matchText + '" class="emoticon" title="' + matchText + '" style="background-image:url(' + path + ')"></span>',
                originalText: fullMatch
            });

            return prefix + alias;
        }

        return fullMatch;
    }

    // match named emoticons like :goat:
    output = output.replace(EMOJI_PATTERN, function (fullMatch, matchText, name) {
        return replaceEmoticonWithToken(fullMatch, '', matchText, name);
    });

    // match text smilies like :D
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var name = _step.value;

            var pattern = emoticonPatterns[name];

            // this might look a bit funny, but since the name isn't contained in the actual match
            // like with the named emoticons, we need to add it in manually
            output = output.replace(pattern, function (fullMatch, prefix, matchText) {
                return replaceEmoticonWithToken(fullMatch, prefix, matchText, name);
            });
        };

        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(emoticonPatterns)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return output;
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(116);

var _Actions = __webpack_require__(125);

var _createHistory = __webpack_require__(382);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(125);

var _PathUtils = __webpack_require__(116);

var _ExecutionEnvironment = __webpack_require__(195);

var _DOMUtils = __webpack_require__(271);

var _DOMStateStorage = __webpack_require__(380);

var _createDOMHistory = __webpack_require__(381);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.uploadTeamImage = uploadTeamImage;
exports.updateTeamPMR = updateTeamPMR;
exports.uploadTeamBackground = uploadTeamBackground;
exports.exportTeam = exportTeam;
exports.getTeamStorage = getTeamStorage;
exports.getTeamVcHour = getTeamVcHour;
exports.exportTeamDownload = exportTeamDownload;
exports.getQuotation = getQuotation;
exports.payByJetco = payByJetco;
exports.payByAlipay = payByAlipay;
exports.payByStripe = payByStripe;
exports.payZeroPayment = payZeroPayment;
exports.getContracts = getContracts;
exports.getOrderHist = getOrderHist;
exports.getInvoice = getInvoice;
exports.getInvitesByEmail = getInvitesByEmail;
exports.getInvitesByUserId = getInvitesByUserId;
exports.getBillingAddress = getBillingAddress;
exports.setBillingAddress = setBillingAddress;
exports.addGuestToTeam = addGuestToTeam;
exports.addAllUsersToTeam = addAllUsersToTeam;
exports.addGuestsToTeam = addGuestsToTeam;
exports.addAllGuestsToTeam = addAllGuestsToTeam;
exports.sendEmailInvitesGuestsToTeam = sendEmailInvitesGuestsToTeam;
exports.getTeamsWithMemberCount = getTeamsWithMemberCount;
exports.getTeamsStats = getTeamsStats;
exports.deleteTeam = deleteTeam;
exports.getTeamAdminUsers = getTeamAdminUsers;

var _client = __webpack_require__(145);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _helpers = __webpack_require__(67);

var _reduxBatchedActions = __webpack_require__(30);

var _errors = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function uploadTeamImage(teamId, imageData) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_REQUEST }, getState);

                            _context.prev = 1;
                            _context.next = 4;
                            return _client.CustomClient4.uploadTeamImage(teamId, imageData);

                        case 4:
                            _context.next = 10;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](1);

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_FAILURE, error: _context.t0 }, getState);
                            return _context.abrupt('return', null);

                        case 10:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_SUCCESS }, getState);

                            return _context.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 6]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function updateTeamPMR(team) {
    var _this2 = this;

    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_REQUEST }, getState);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.CustomClient4.configPMR(team);

                        case 4:
                            _context2.next = 10;
                            break;

                        case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2['catch'](1);

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_FAILURE, error: _context2.t0 }, getState);
                            return _context2.abrupt('return', null);

                        case 10:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_SUCCESS }, getState);

                            return _context2.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 6]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function uploadTeamBackground(teamId, imageData) {
    var _this3 = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_REQUEST }, getState);

                            _context3.prev = 1;
                            _context3.next = 4;
                            return _client.CustomClient4.uploadTeamBackgroundImage(teamId, imageData);

                        case 4:
                            _context3.next = 10;
                            break;

                        case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3['catch'](1);

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_FAILURE, error: _context3.t0 }, getState);
                            return _context3.abrupt('return', null);

                        case 10:

                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_SUCCESS }, getState);

                            return _context3.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[1, 6]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function exportTeam(teamId) {
    var _this4 = this;

    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var fileName;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            fileName = void 0;
                            _context4.prev = 1;
                            _context4.next = 4;
                            return _client.CustomClient4.exportTeam(teamId);

                        case 4:
                            fileName = _context4.sent;
                            _context4.next = 10;
                            break;

                        case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4['catch'](1);
                            return _context4.abrupt('return', null);

                        case 10:
                            return _context4.abrupt('return', fileName);

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[1, 7]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getTeamStorage(teamId) {
    var _this5 = this;

    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var storage;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            storage = void 0;
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _client.CustomClient4.getTeamStorage(teamId);

                        case 4:
                            storage = _context5.sent;
                            _context5.next = 10;
                            break;

                        case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](1);
                            return _context5.abrupt('return', null);

                        case 10:
                            return _context5.abrupt('return', storage);

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[1, 7]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function getTeamVcHour(teamId) {
    var _this6 = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var vchour;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            vchour = void 0;
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _client.CustomClient4.getTeamVcHour(teamId);

                        case 4:
                            vchour = _context6.sent;
                            _context6.next = 10;
                            break;

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](1);
                            return _context6.abrupt('return', null);

                        case 10:
                            return _context6.abrupt('return', vchour);

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[1, 7]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function exportTeamDownload(teamId, fileId) {
    var _this7 = this;

    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var file;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            file = void 0;
                            _context7.prev = 1;
                            _context7.next = 4;
                            return _client.CustomClient4.exportTeamDownload(teamId, fileId);

                        case 4:
                            file = _context7.sent;
                            _context7.next = 10;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](1);
                            return _context7.abrupt('return', null);

                        case 10:
                            return _context7.abrupt('return', file);

                        case 11:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[1, 7]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}
function getQuotation(teamId, enquiry) {
    var _this8 = this;

    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            result = void 0;
                            _context8.prev = 1;
                            _context8.next = 4;
                            return _client.CustomClient4.getQuotation(teamId, enquiry);

                        case 4:
                            result = _context8.sent;
                            _context8.next = 10;
                            break;

                        case 7:
                            _context8.prev = 7;
                            _context8.t0 = _context8['catch'](1);
                            return _context8.abrupt('return', _context8.t0);

                        case 10:
                            return _context8.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[1, 7]]);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function payByJetco(teamId, enquiry) {
    var _this9 = this;

    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            result = void 0;
                            _context9.prev = 1;
                            _context9.next = 4;
                            return _client.CustomClient4.payByJetco(teamId, enquiry);

                        case 4:
                            result = _context9.sent;
                            _context9.next = 10;
                            break;

                        case 7:
                            _context9.prev = 7;
                            _context9.t0 = _context9['catch'](1);
                            return _context9.abrupt('return', _context9.t0);

                        case 10:
                            return _context9.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[1, 7]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function payByAlipay(teamId, enquiry) {
    var _this10 = this;

    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            result = void 0;
                            _context10.prev = 1;
                            _context10.next = 4;
                            return _client.CustomClient4.payByAlipay(teamId, enquiry);

                        case 4:
                            result = _context10.sent;
                            _context10.next = 10;
                            break;

                        case 7:
                            _context10.prev = 7;
                            _context10.t0 = _context10['catch'](1);
                            return _context10.abrupt('return', _context10.t0);

                        case 10:
                            return _context10.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[1, 7]]);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function payByStripe(teamId, enquiry, token) {
    var _this11 = this;

    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            result = void 0;
                            _context11.prev = 1;
                            _context11.next = 4;
                            return _client.CustomClient4.payByStripe(teamId, enquiry, token);

                        case 4:
                            result = _context11.sent;
                            _context11.next = 10;
                            break;

                        case 7:
                            _context11.prev = 7;
                            _context11.t0 = _context11['catch'](1);
                            return _context11.abrupt('return', _context11.t0);

                        case 10:
                            return _context11.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[1, 7]]);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function payZeroPayment(teamId, enquiry) {
    var _this12 = this;

    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            result = void 0;
                            _context12.prev = 1;
                            _context12.next = 4;
                            return _client.CustomClient4.payZeroPayment(teamId, enquiry);

                        case 4:
                            result = _context12.sent;
                            _context12.next = 10;
                            break;

                        case 7:
                            _context12.prev = 7;
                            _context12.t0 = _context12['catch'](1);
                            return _context12.abrupt('return', _context12.t0);

                        case 10:
                            return _context12.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[1, 7]]);
        }));

        return function (_x23, _x24) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function getContracts(teamId) {
    var _this13 = this;

    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            result = void 0;
                            _context13.prev = 1;
                            _context13.next = 4;
                            return _client.CustomClient4.getContracts(teamId);

                        case 4:
                            result = _context13.sent;
                            _context13.next = 10;
                            break;

                        case 7:
                            _context13.prev = 7;
                            _context13.t0 = _context13['catch'](1);
                            return _context13.abrupt('return', _context13.t0);

                        case 10:
                            return _context13.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[1, 7]]);
        }));

        return function (_x25, _x26) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getOrderHist(teamId) {
    var _this14 = this;

    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            result = void 0;
                            _context14.prev = 1;
                            _context14.next = 4;
                            return _client.CustomClient4.getOrderHist(teamId);

                        case 4:
                            result = _context14.sent;
                            _context14.next = 10;
                            break;

                        case 7:
                            _context14.prev = 7;
                            _context14.t0 = _context14['catch'](1);
                            return _context14.abrupt('return', _context14.t0);

                        case 10:
                            return _context14.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[1, 7]]);
        }));

        return function (_x27, _x28) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function getInvoice(orderId) {
    var _this15 = this;

    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            result = void 0;
                            _context15.prev = 1;
                            _context15.next = 4;
                            return _client.CustomClient4.getInvoice(orderId);

                        case 4:
                            result = _context15.sent;
                            _context15.next = 10;
                            break;

                        case 7:
                            _context15.prev = 7;
                            _context15.t0 = _context15['catch'](1);
                            return _context15.abrupt('return', _context15.t0);

                        case 10:
                            return _context15.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[1, 7]]);
        }));

        return function (_x29, _x30) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getInvitesByEmail(email) {
    var _this16 = this;

    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            result = void 0;
                            _context16.prev = 1;
                            _context16.next = 4;
                            return _client.CustomClient4.getInvitesByEmail(email);

                        case 4:
                            result = _context16.sent;
                            _context16.next = 10;
                            break;

                        case 7:
                            _context16.prev = 7;
                            _context16.t0 = _context16['catch'](1);
                            return _context16.abrupt('return', _context16.t0);

                        case 10:
                            return _context16.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[1, 7]]);
        }));

        return function (_x31, _x32) {
            return _ref16.apply(this, arguments);
        };
    }();
}
function getInvitesByUserId() {
    var _this17 = this;

    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            result = void 0;
                            _context17.prev = 1;
                            _context17.next = 4;
                            return _client.CustomClient4.getInvitesByUserId();

                        case 4:
                            result = _context17.sent;
                            _context17.next = 10;
                            break;

                        case 7:
                            _context17.prev = 7;
                            _context17.t0 = _context17['catch'](1);
                            return _context17.abrupt('return', _context17.t0);

                        case 10:
                            return _context17.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[1, 7]]);
        }));

        return function (_x33, _x34) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getBillingAddress(teamId) {
    var _this18 = this;

    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            result = void 0;
                            _context18.prev = 1;
                            _context18.next = 4;
                            return _client.CustomClient4.getBillingAddress(teamId);

                        case 4:
                            result = _context18.sent;
                            _context18.next = 10;
                            break;

                        case 7:
                            _context18.prev = 7;
                            _context18.t0 = _context18['catch'](1);
                            return _context18.abrupt('return', _context18.t0);

                        case 10:
                            return _context18.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18, [[1, 7]]);
        }));

        return function (_x35, _x36) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function setBillingAddress(teamId, address) {
    var _this19 = this;

    return function () {
        var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            result = void 0;
                            _context19.prev = 1;
                            _context19.next = 4;
                            return _client.CustomClient4.setBillingAddress(teamId, address);

                        case 4:
                            result = _context19.sent;
                            _context19.next = 10;
                            break;

                        case 7:
                            _context19.prev = 7;
                            _context19.t0 = _context19['catch'](1);
                            return _context19.abrupt('return', _context19.t0);

                        case 10:
                            return _context19.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19, [[1, 7]]);
        }));

        return function (_x37, _x38) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function addGuestToTeam(teamId, userId) {
    var _this20 = this;

    return function () {
        var _ref20 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20(dispatch, getState) {
            var member;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context20.prev = 2;
                            _context20.next = 5;
                            return _client.CustomClient4.addGuestToTeam(teamId, userId);

                        case 5:
                            member = _context20.sent;
                            _context20.next = 13;
                            break;

                        case 8:
                            _context20.prev = 8;
                            _context20.t0 = _context20['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context20.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context20.t0 }, (0, _errors.logError)(_context20.t0)(dispatch)]), getState);
                            return _context20.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context20.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20, [[2, 8]]);
        }));

        return function (_x39, _x40) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function addAllUsersToTeam(teamId) {
    var _this21 = this;

    return function () {
        var _ref21 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21(dispatch, getState) {
            var members, profiles;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context21.prev = 2;
                            _context21.next = 5;
                            return _client.CustomClient4.addAllUsersToTeam(teamId);

                        case 5:
                            members = _context21.sent;
                            _context21.next = 13;
                            break;

                        case 8:
                            _context21.prev = 8;
                            _context21.t0 = _context21['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context21.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context21.t0 }, (0, _errors.logError)(_context21.t0)(dispatch)]), getState);
                            return _context21.abrupt('return', null);

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context21.abrupt('return', members);

                        case 17:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this21, [[2, 8]]);
        }));

        return function (_x41, _x42) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function addGuestsToTeam(teamId, userIds) {
    var _this22 = this;

    return function () {
        var _ref22 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(dispatch, getState) {
            var members, profiles;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context22.prev = 2;
                            _context22.next = 5;
                            return _client.CustomClient4.addGuestsToTeam(teamId, userIds);

                        case 5:
                            members = _context22.sent;
                            _context22.next = 13;
                            break;

                        case 8:
                            _context22.prev = 8;
                            _context22.t0 = _context22['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context22.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context22.t0 }, (0, _errors.logError)(_context22.t0)(dispatch)]), getState);
                            return _context22.abrupt('return', null);

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context22.abrupt('return', members);

                        case 17:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this22, [[2, 8]]);
        }));

        return function (_x43, _x44) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function addAllGuestsToTeam(teamId) {
    var _this23 = this;

    return function () {
        var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23(dispatch, getState) {
            var members, profiles;
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context23.prev = 2;
                            _context23.next = 5;
                            return _client.CustomClient4.addAllGuestsToTeam(teamId);

                        case 5:
                            members = _context23.sent;
                            _context23.next = 13;
                            break;

                        case 8:
                            _context23.prev = 8;
                            _context23.t0 = _context23['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context23.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context23.t0 }, (0, _errors.logError)(_context23.t0)(dispatch)]), getState);
                            return _context23.abrupt('return', null);

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context23.abrupt('return', members);

                        case 17:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this23, [[2, 8]]);
        }));

        return function (_x45, _x46) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function sendEmailInvitesGuestsToTeam(teamId, emails) {
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.sendEmailInvitesGuestsToTeam, _action_types.TeamTypes.TEAM_EMAIL_INVITE_REQUEST, [_action_types.TeamTypes.TEAM_EMAIL_INVITE_SUCCESS], _action_types.TeamTypes.TEAM_EMAIL_INVITE_FAILURE, teamId, emails);
}

function getTeamsWithMemberCount() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.TEAMS_CHUNK_SIZE;
    var needCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return (0, _helpers.bindClientFunc)(_client.CustomClient4.getTeamsWithMemberCount, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, page, perPage, needCount);
}

function getTeamsStats(teamIds) {
    var _this24 = this;

    return function () {
        var _ref24 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24(dispatch, getState) {
            var statsList, actions;
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            statsList = null;
                            _context24.prev = 1;
                            _context24.next = 4;
                            return _client.CustomClient4.getTeamsStats(teamIds);

                        case 4:
                            statsList = _context24.sent;
                            _context24.next = 11;
                            break;

                        case 7:
                            _context24.prev = 7;
                            _context24.t0 = _context24['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context24.t0, dispatch);
                            return _context24.abrupt('return', null);

                        case 11:
                            actions = [];


                            statsList.forEach(function (stat) {
                                actions.push({ type: _action_types.TeamTypes.RECEIVED_TEAM_STATS, data: stat });
                            });
                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context24.abrupt('return', statsList);

                        case 15:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this24, [[1, 7]]);
        }));

        return function (_x50, _x51) {
            return _ref24.apply(this, arguments);
        };
    }();
}

// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux actions/teams)
function deleteTeam(teamId) {
    var _this25 = this;

    return function () {
        var _ref25 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            _context25.prev = 0;
                            _context25.next = 3;
                            return _client.CustomClient4.deleteTeam(teamId);

                        case 3:
                            _context25.next = 10;
                            break;

                        case 5:
                            _context25.prev = 5;
                            _context25.t0 = _context25['catch'](0);

                            (0, _helpers.forceLogoutIfNecessary)(_context25.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([(0, _errors.logError)(_context25.t0)(dispatch)]), getState);
                            return _context25.abrupt('return', null);

                        case 10:
                            return _context25.abrupt('return', true);

                        case 11:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this25, [[0, 5]]);
        }));

        return function (_x52, _x53) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function getTeamAdminUsers(teamId) {
    var _this26 = this;

    return function () {
        var _ref26 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26(dispatch, getState) {
            var admins;
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            admins = void 0;
                            _context26.prev = 1;
                            _context26.next = 4;
                            return _client.CustomClient4.getTeamAdminUsers(teamId);

                        case 4:
                            admins = _context26.sent;
                            _context26.next = 12;
                            break;

                        case 7:
                            _context26.prev = 7;
                            _context26.t0 = _context26['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context26.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([(0, _errors.logError)(_context26.t0)(dispatch)]), getState);
                            return _context26.abrupt('return', null);

                        case 12:
                            return _context26.abrupt('return', admins);

                        case 13:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, _this26, [[1, 7]]);
        }));

        return function (_x54, _x55) {
            return _ref26.apply(this, arguments);
        };
    }();
}

// ---

exports.default = {
    uploadTeamImage: uploadTeamImage,
    exportTeam: exportTeam,
    deleteTeam: deleteTeam,
    getTeamAdminUsers: getTeamAdminUsers
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(168);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.getUserDefinedStatuses = getUserDefinedStatuses;
exports.saveOrUpdateUserDefinedStatus = saveOrUpdateUserDefinedStatus;
exports.deleteUserDefinedStatus = deleteUserDefinedStatus;
exports.setCustomStatus = setCustomStatus;
exports.blockUser = blockUser;
exports.checkBlockUser = checkBlockUser;
exports.unBlockUser = unBlockUser;
exports.getBlockList = getBlockList;
exports.setWatermarkImage = setWatermarkImage;
exports.setBackgroundImage = setBackgroundImage;
exports.getProfilesCanJoinTeam = getProfilesCanJoinTeam;
exports.getProfilesCanJoinChannel = getProfilesCanJoinChannel;
exports.sendVerificationSMS = sendVerificationSMS;
exports.verifyUserMobile = verifyUserMobile;
exports.resetUserPasswordBySMS = resetUserPasswordBySMS;
exports.incrementMapUsage = incrementMapUsage;
exports.sendPasswordResetSMS = sendPasswordResetSMS;
exports.sendOnRequestVerificationEmail = sendOnRequestVerificationEmail;
exports.getCountryCodeByIP = getCountryCodeByIP;
exports.findUserByCallee = findUserByCallee;
exports.lookupPossibleUsers = lookupPossibleUsers;
exports.sendMeetingInviteToExternal = sendMeetingInviteToExternal;
exports.getUserCleanUpTime = getUserCleanUpTime;
exports.getProfilesInChannels = getProfilesInChannels;

var _client = __webpack_require__(145);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _reduxBatchedActions = __webpack_require__(30);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

var _user_utils = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserDefinedStatuses(userId) {
    var _this = this;

    return function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatch, getState) {
            var udfStatuses;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            udfStatuses = void 0;
                            _context.prev = 1;
                            _context.next = 4;
                            return _client.CustomClient4.getUserDefinedStatuses(userId);

                        case 4:
                            udfStatuses = _context.sent;
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](1);
                            return _context.abrupt('return', { error: _context.t0 });

                        case 10:
                            return _context.abrupt('return', udfStatuses);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 7]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function saveOrUpdateUserDefinedStatus(userId, udfStatus) {
    var _this2 = this;

    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            result = void 0;
                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.CustomClient4.saveOrUpdateUserDefinedStatus(userId, udfStatus);

                        case 4:
                            result = _context2.sent;
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);
                            return _context2.abrupt('return', { error: _context2.t0 });

                        case 10:
                            return _context2.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 7]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function deleteUserDefinedStatus(userId, udfStatusId) {
    var _this3 = this;

    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            result = void 0;
                            _context3.prev = 1;
                            _context3.next = 4;
                            return _client.CustomClient4.deleteUserDefinedStatus(userId, udfStatusId);

                        case 4:
                            result = _context3.sent;
                            _context3.next = 10;
                            break;

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](1);
                            return _context3.abrupt('return', { error: _context3.t0 });

                        case 10:
                            return _context3.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[1, 7]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function setCustomStatus(userId, udfStatusId) {
    var _this4 = this;

    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var status;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            status = void 0;

                            dispatch({ type: _action_types.UserTypes.SET_STATUS_REQUEST }, getState);

                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.CustomClient4.updateCustomStatus(userId, udfStatusId);

                        case 5:
                            status = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.SET_STATUS_FAILURE, error: _context4.t0 }, (0, _errors.logError)(_context4.t0)(dispatch)]), getState);
                            return _context4.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_STATUS,
                                data: status
                            }, {
                                type: _action_types.UserTypes.SET_STATUS_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', status);

                        case 15:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function blockUser(sender) {
    var _this5 = this;

    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            result = void 0;
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _client.CustomClient4.blockUser(sender);

                        case 4:
                            result = _context5.sent;
                            _context5.next = 10;
                            break;

                        case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](1);
                            return _context5.abrupt('return', _context5.t0);

                        case 10:
                            return _context5.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[1, 7]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function checkBlockUser(sender) {
    var _this6 = this;

    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            result = void 0;
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _client.CustomClient4.checkBlockUser(sender);

                        case 4:
                            result = _context6.sent;
                            _context6.next = 10;
                            break;

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](1);
                            return _context6.abrupt('return', _context6.t0);

                        case 10:
                            return _context6.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[1, 7]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function unBlockUser(sender) {
    var _this7 = this;

    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            result = void 0;
                            _context7.prev = 1;
                            _context7.next = 4;
                            return _client.CustomClient4.unBlockUser(sender);

                        case 4:
                            result = _context7.sent;
                            _context7.next = 10;
                            break;

                        case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7['catch'](1);
                            return _context7.abrupt('return', _context7.t0);

                        case 10:
                            return _context7.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[1, 7]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getBlockList() {
    var _this8 = this;

    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            result = void 0;
                            _context8.prev = 1;
                            _context8.next = 4;
                            return _client.CustomClient4.getBlockList();

                        case 4:
                            result = _context8.sent;
                            _context8.next = 10;
                            break;

                        case 7:
                            _context8.prev = 7;
                            _context8.t0 = _context8['catch'](1);
                            return _context8.abrupt('return', _context8.t0);

                        case 10:
                            return _context8.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[1, 7]]);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function setWatermarkImage(userId, imageData) {
    var _this9 = this;

    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(dispatch, getState) {
            var actions, profile;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context9.prev = 1;
                            _context9.next = 4;
                            return _client.CustomClient4.uploadWatermarkImage(userId, imageData);

                        case 4:
                            _context9.next = 10;
                            break;

                        case 6:
                            _context9.prev = 6;
                            _context9.t0 = _context9['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context9.t0 }, getState);
                            return _context9.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: (0, _extends3.default)({}, profile, { last_watermark_update: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context9.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[1, 6]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function setBackgroundImage(userId, imageData) {
    var _this10 = this;

    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(dispatch, getState) {
            var actions, profile;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_REQUEST }, getState);

                            _context10.prev = 1;
                            _context10.next = 4;
                            return _client.CustomClient4.uploadBackgroundImage(userId, imageData);

                        case 4:
                            _context10.next = 10;
                            break;

                        case 6:
                            _context10.prev = 6;
                            _context10.t0 = _context10['catch'](1);

                            dispatch({ type: _action_types.UserTypes.UPDATE_USER_FAILURE, error: _context10.t0 }, getState);
                            return _context10.abrupt('return', null);

                        case 10:
                            actions = [{ type: _action_types.UserTypes.UPDATE_USER_SUCCESS }];
                            profile = getState().entities.users.profiles[userId];

                            if (profile) {
                                actions.push({ type: _action_types.UserTypes.RECEIVED_PROFILE, data: (0, _extends3.default)({}, profile, { last_background_update: new Date().getTime() }) });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context10.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[1, 6]]);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getProfilesCanJoinTeam(teamId, page) {
    var _this11 = this;

    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(dispatch, getState) {
            var profiles;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_REQUEST }, getState);

                            profiles = void 0;
                            _context11.prev = 2;
                            _context11.next = 5;
                            return _client.CustomClient4.getProfilesCanJoinTeam(teamId, page, perPage);

                        case 5:
                            profiles = _context11.sent;
                            _context11.next = 13;
                            break;

                        case 8:
                            _context11.prev = 8;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_FAILURE, error: _context11.t0 }, (0, _errors.logError)(_context11.t0)(dispatch)]), getState);
                            return _context11.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: profiles
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_TEAM_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', profiles);

                        case 15:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[2, 8]]);
        }));

        return function (_x22, _x23) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getProfilesCanJoinChannel(teamId, channelId, page) {
    var _this12 = this;

    var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(dispatch, getState) {
            var currentUserId, profiles;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profiles = void 0;
                            _context12.prev = 3;
                            _context12.next = 6;
                            return _client.CustomClient4.getProfilesCanJoinChannel(teamId, channelId, page, perPage);

                        case 6:
                            profiles = _context12.sent;
                            _context12.next = 14;
                            break;

                        case 9:
                            _context12.prev = 9;
                            _context12.t0 = _context12['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context12.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_FAILURE, error: _context12.t0 }, (0, _errors.logError)(_context12.t0)(dispatch)]), getState);
                            return _context12.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                                data: profiles,
                                id: channelId
                            }, {
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST,
                                data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat((0, _toConsumableArray3.default)(profiles)))
                            }, {
                                type: _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context12.abrupt('return', profiles);

                        case 16:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12, [[3, 9]]);
        }));

        return function (_x25, _x26) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function sendVerificationSMS(email) {
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.sendVerificationSMS, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, email);
}

function verifyUserMobile(token, loginId) {
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.verifyUserMobile, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, token, loginId);
}

function resetUserPasswordBySMS(token, loginId, newPassword) {

    return (0, _helpers.bindClientFunc)(_client.CustomClient4.resetUserPasswordBySMS, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, token, loginId, newPassword);
}

function incrementMapUsage(userId) {
    var _this13 = this;

    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            result = void 0;
                            _context13.prev = 1;
                            _context13.next = 4;
                            return _client.CustomClient4.incrementMapUsage(userId);

                        case 4:
                            result = _context13.sent;
                            _context13.next = 10;
                            break;

                        case 7:
                            _context13.prev = 7;
                            _context13.t0 = _context13['catch'](1);
                            return _context13.abrupt('return', _context13.t0);

                        case 10:
                            return _context13.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[1, 7]]);
        }));

        return function (_x27, _x28) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function sendPasswordResetSMS(loginId) {
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.sendPasswordResetSMS, _action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, loginId);
}

function sendOnRequestVerificationEmail(email) {

    var type = 'on_request';
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.sendOnRequestVerificationEmail, _action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, email, type);
}

function getCountryCodeByIP() {
    var _this14 = this;

    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(dispatch, getState) {
            var result;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            result = {};
                            _context14.prev = 1;
                            _context14.next = 4;
                            return _client.CustomClient4.getCountryCode();

                        case 4:
                            result = _context14.sent;
                            _context14.next = 10;
                            break;

                        case 7:
                            _context14.prev = 7;
                            _context14.t0 = _context14['catch'](1);
                            return _context14.abrupt('return', { error: _context14.t0 });

                        case 10:
                            return _context14.abrupt('return', result);

                        case 11:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[1, 7]]);
        }));

        return function (_x29, _x30) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function findUserByCallee(callee) {
    return (0, _helpers.bindClientFunc)(_client.CustomClient4.getUserByCallee, _action_types.UserTypes.USER_REQUEST, [_action_types.UserTypes.RECEIVED_PROFILE, _action_types.UserTypes.USER_SUCCESS], _action_types.UserTypes.USER_FAILURE, callee);
}

function lookupPossibleUsers(user) {
    var _this15 = this;

    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.prev = 0;
                            _context15.next = 3;
                            return _client.CustomClient4.lookupPossibleUsers(user);

                        case 3:
                            return _context15.abrupt('return', _context15.sent);

                        case 6:
                            _context15.prev = 6;
                            _context15.t0 = _context15['catch'](0);
                            return _context15.abrupt('return', { error: _context15.t0 });

                        case 9:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[0, 6]]);
        }));

        return function (_x31, _x32) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function sendMeetingInviteToExternal(category, invites) {
    var _this16 = this;

    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(dispatch, getState) {
            var roomId;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            roomId = void 0;
                            _context16.prev = 1;
                            _context16.next = 4;
                            return _client.CustomClient4.sendMeetingInviteToExternal(category, invites);

                        case 4:
                            roomId = _context16.sent;
                            _context16.next = 10;
                            break;

                        case 7:
                            _context16.prev = 7;
                            _context16.t0 = _context16['catch'](1);
                            return _context16.abrupt('return', { error: _context16.t0 });

                        case 10:
                            return _context16.abrupt('return', roomId);

                        case 11:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[1, 7]]);
        }));

        return function (_x33, _x34) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function getUserCleanUpTime(loginId) {
    var _this17 = this;

    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.prev = 0;
                            _context17.next = 3;
                            return _client.CustomClient4.getUserCleanUpTime(loginId);

                        case 3:
                            return _context17.abrupt('return', _context17.sent);

                        case 6:
                            _context17.prev = 6;
                            _context17.t0 = _context17['catch'](0);
                            return _context17.abrupt('return', { error: _context17.t0 });

                        case 9:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[0, 6]]);
        }));

        return function (_x35, _x36) {
            return _ref17.apply(this, arguments);
        };
    }();
}

// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux actions/users).
// Loads the member profiles of several channels in one request.
function getProfilesInChannels(channelIds) {
    var _this18 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.PROFILE_CHUNK_SIZE;

    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(dispatch, getState) {
            var currentUserId, profilesByChannel, received, result, allProfiles, i, channelId, profiles;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_REQUEST }, getState);

                            currentUserId = getState().entities.users.currentUserId;
                            profilesByChannel = void 0;
                            _context18.prev = 3;
                            _context18.next = 6;
                            return _client.CustomClient4.getProfilesInChannels(channelIds, page, perPage);

                        case 6:
                            profilesByChannel = _context18.sent;
                            _context18.next = 14;
                            break;

                        case 9:
                            _context18.prev = 9;
                            _context18.t0 = _context18['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context18.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.UserTypes.PROFILES_IN_CHANNEL_FAILURE, error: _context18.t0 }, (0, _errors.logError)(_context18.t0)(dispatch)]), getState);
                            return _context18.abrupt('return', null);

                        case 14:
                            received = [];
                            result = [];
                            allProfiles = {};

                            for (i = 0; i < channelIds.length; i++) {
                                channelId = channelIds[i];
                                profiles = profilesByChannel[channelId];

                                if (profiles && profiles.length > 0) {
                                    received.push({ type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL, data: profiles, id: channelId });
                                    result.push((0, _user_utils.removeUserFromList)(currentUserId, [].concat((0, _toConsumableArray3.default)(profiles))));
                                    profiles.forEach(function (p) {
                                        allProfiles[p.id] = p;
                                    });
                                }
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(received, [{ type: _action_types.UserTypes.RECEIVED_PROFILES_LIST, data: (0, _user_utils.removeUserFromList)(currentUserId, [].concat((0, _toConsumableArray3.default)((0, _values2.default)(allProfiles)))) }, { type: _action_types.UserTypes.PROFILES_IN_CHANNEL_SUCCESS }])), getState);

                            return _context18.abrupt('return', result);

                        case 20:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18, [[3, 9]]);
        }));

        return function (_x39, _x40) {
            return _ref18.apply(this, arguments);
        };
    }();
}

// ---

exports.default = {
    blockUser: blockUser,
    unBlockUser: unBlockUser,
    getProfilesInChannels: getProfilesInChannels
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var getKeys   = __webpack_require__(120)
  , toIObject = __webpack_require__(90)
  , isEnum    = __webpack_require__(160).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCustomEmoji = createCustomEmoji;
exports.getCustomEmojis = getCustomEmojis;
exports.getAllCustomEmojis = getAllCustomEmojis;
exports.deleteCustomEmoji = deleteCustomEmoji;

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _reduxBatchedActions = __webpack_require__(30);

var _client = __webpack_require__(22);

var _errors = __webpack_require__(68);

var _helpers = __webpack_require__(67);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function createCustomEmoji(emoji, image) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createCustomEmoji, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_REQUEST, [_action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_SUCCESS], _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_FAILURE, emoji, image);
}

// page and perPage to be used when converting to v4
function getCustomEmojis() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.PAGE_SIZE_DEFAULT;

    return (0, _helpers.bindClientFunc)(_client.Client4.getCustomEmojis, _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_REQUEST, [_action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS, _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_SUCCESS], _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_FAILURE, page, perPage);
}

function getAllCustomEmojis() {
    var _this = this;

    var perPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.General.PAGE_SIZE_MAXIMUM;

    return function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var hasMore, page, serverVersion, emojis;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_REQUEST }, { type: _action_types.EmojiTypes.CLEAR_CUSTOM_EMOJIS }]), getState);

                            hasMore = true;
                            page = 0;
                            serverVersion = getState().entities.general.serverVersion;

                        case 4:
                            _context.prev = 4;
                            emojis = [];

                            if (!(serverVersion.charAt(0) === '3')) {
                                _context.next = 13;
                                break;
                            }

                            _context.next = 9;
                            return _client.Client.getCustomEmojis();

                        case 9:
                            emojis = _context.sent;

                            hasMore = false;
                            _context.next = 17;
                            break;

                        case 13:
                            _context.next = 15;
                            return _client.Client4.getCustomEmojis(page, perPage);

                        case 15:
                            emojis = _context.sent;

                            if (emojis.length < perPage) {
                                hasMore = false;
                            } else {
                                page += 1;
                            }

                        case 17:

                            dispatch({
                                type: _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS,
                                data: emojis
                            });
                            _context.next = 24;
                            break;

                        case 20:
                            _context.prev = 20;
                            _context.t0 = _context['catch'](4);

                            (0, _helpers.forceLogoutIfNecessary)(_context.t0, dispatch);

                            return _context.abrupt('return', dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_FAILURE, error: _context.t0 }, (0, _errors.logError)(_context.t0)(dispatch)]), getState));

                        case 24:
                            if (hasMore) {
                                _context.next = 4;
                                break;
                            }

                        case 25:
                            return _context.abrupt('return', dispatch({ type: _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_SUCCESS }, getState));

                        case 26:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[4, 20]]);
        }));

        return function (_x4, _x5) {
            return _ref.apply(this, arguments);
        };
    }();
}

function deleteCustomEmoji(emojiId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({ type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_REQUEST }, getState);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _client.Client4.deleteCustomEmoji(emojiId);

                        case 4:
                            _context2.next = 11;
                            break;

                        case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_FAILURE, error: _context2.t0 }, (0, _errors.logError)(_context2.t0)(dispatch)]), getState);
                            return _context2.abrupt('return', null);

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.EmojiTypes.DELETED_CUSTOM_EMOJI,
                                data: { id: emojiId }
                            }, {
                                type: _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_SUCCESS
                            }]), getState);

                            return _context2.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 6]]);
        }));

        return function (_x6, _x7) {
            return _ref2.apply(this, arguments);
        };
    }();
}


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1096), __esModule: true };


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initWebrtc = initWebrtc;
exports.handle = handle;
exports.webrtcToken = webrtcToken;
exports.createVclog = createVclog;
exports.getVclog = getVclog;

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(12);

var _client = __webpack_require__(22);

var _client2 = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function initWebrtc(userIds, isCalling, callType) {
    _app_dispatcher2.default.handleServerAction({
        type: _constants.WebrtcActionTypes.INITIALIZE,
        user_ids: userIds,
        is_calling: isCalling,
        call_type: callType
    });
}

function handle(message) {
    _app_dispatcher2.default.handleServerAction({
        type: message.action,
        message: message
    });
}

function webrtcToken(success, error) {
    _client.Client4.webrtcToken().then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function () {
        if (error) {
            error();
        }
    });
}

function createVclog(vclog, success, error) {
    _client2.CustomClient4.createVclog(vclog).then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function () {
        if (error) {
            error();
        }
    });
}

function getVclog(userId, success, error) {
    _client2.CustomClient4.getVclog(userId).then(function (data) {
        if (success) {
            success(data);
        }
    }).catch(function () {
        if (error) {
            error();
        }
    });
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertTeamMapToList = convertTeamMapToList;
exports.sortTeamsByDisplayName = sortTeamsByDisplayName;
exports.getRedirectUserToDefaultTeamUrl = getRedirectUserToDefaultTeamUrl;

var _localization_store = __webpack_require__(172);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function convertTeamMapToList(teamMap) {
    var teams = [];

    for (var id in teamMap) {
        if (teamMap.hasOwnProperty(id)) {
            teams.push(teamMap[id]);
        }
    }

    return teams.sort(sortTeamsByDisplayName);
}

// Use when sorting multiple teams by their `display_name` field
function sortTeamsByDisplayName(a, b) {
    var locale = _localization_store2.default.getLocale();

    if (a.display_name !== b.display_name) {
        return a.display_name.localeCompare(b.display_name, locale, { numeric: true });
    }

    return a.name.localeCompare(b.name, locale, { numeric: true });
}

function getRedirectUserToDefaultTeamUrl() {
    var teams = _team_store2.default.getAll();
    var teamMembers = _team_store2.default.getMyTeamMembers();
    var teamId = _browser_store2.default.getGlobalItem('team');

    function redirectUrl(teamName, channelName) {
        return '/' + teamName + '/channels/' + channelName;
    }

    if (!teams[teamId] && teamMembers.length > 0) {
        var myTeams = [];
        for (var index in teamMembers) {
            if (teamMembers.hasOwnProperty(index)) {
                var teamMember = teamMembers[index];
                myTeams.push(teams[teamMember.team_id]);
            }
        }

        if (myTeams.length > 0) {
            myTeams = myTeams.sort(sortTeamsByDisplayName);
            teamId = myTeams[0].id;
        }
    }

    if (teams[teamId]) {
        var channelId = _browser_store2.default.getGlobalItem(teamId);
        var channel = _channel_store2.default.getChannelById(channelId);
        if (channel) {
            return redirectUrl(teams[teamId].name, channel);
        } else {
            return redirectUrl(teams[teamId].name, 'town-square');
        }
    } else {
        return '/select_team';
    }
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCustomEmojisByName = exports.getCustomEmojisAsMap = undefined;
exports.getCustomEmojis = getCustomEmojis;

var _reselect = __webpack_require__(93);

function getCustomEmojis(state) {
    return state.entities.emojis.customEmoji;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var getCustomEmojisAsMap = exports.getCustomEmojisAsMap = (0, _reselect.createSelector)(getCustomEmojis, function (emojis) {
    var map = new Map();
    Object.keys(emojis).forEach(function (key) {
        map.set(key, emojis[key]);
    });
    return map;
});

var getCustomEmojisByName = exports.getCustomEmojisByName = (0, _reselect.createSelector)(getCustomEmojis, function (emojis) {
    var map = new Map();

    Object.values(emojis).forEach(function (emoji) {
        map.set(emoji.name, emoji);
    });

    return map;
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiIndicesByCategory = exports.CategoryNames = exports.EmojiIndicesByUnicode = exports.EmojiIndicesByAlias = exports.Emojis = undefined;

var _map = __webpack_require__(165);

var _map2 = _interopRequireDefault(_map);

var _emoji = __webpack_require__(1101);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Emojis = exports.Emojis = _emoji2.default; // This file is automatically generated via `make emojis`. Do not modify it manually.

/* eslint-disable */

var EmojiIndicesByAlias = exports.EmojiIndicesByAlias = new _map2.default([["grinning", 0], ["smiley", 1], ["smile", 2], ["grin", 3], ["laughing", 4], ["satisfied", 4], ["sweat_smile", 5], ["rofl", 6], ["joy", 7], ["slightly_smiling_face", 8], ["upside_down_face", 9], ["wink", 10], ["blush", 11], ["innocent", 12], ["smiling_face_with_three_hearts", 13], ["heart_eyes", 14], ["star_struck", 15], ["kissing_heart", 16], ["kissing", 17], ["relaxed", 18], ["kissing_closed_eyes", 19], ["kissing_smiling_eyes", 20], ["yum", 21], ["stuck_out_tongue", 22], ["stuck_out_tongue_winking_eye", 23], ["zany_face", 24], ["stuck_out_tongue_closed_eyes", 25], ["money_mouth_face", 26], ["hugs", 27], ["hand_over_mouth", 28], ["shushing_face", 29], ["thinking", 30], ["zipper_mouth_face", 31], ["raised_eyebrow", 32], ["neutral_face", 33], ["expressionless", 34], ["no_mouth", 35], ["smirk", 36], ["unamused", 37], ["roll_eyes", 38], ["grimacing", 39], ["lying_face", 40], ["relieved", 41], ["pensive", 42], ["sleepy", 43], ["drooling_face", 44], ["sleeping", 45], ["mask", 46], ["face_with_thermometer", 47], ["face_with_head_bandage", 48], ["nauseated_face", 49], ["vomiting_face", 50], ["sneezing_face", 51], ["hot_face", 52], ["cold_face", 53], ["woozy_face", 54], ["dizzy_face", 55], ["exploding_head", 56], ["cowboy_hat_face", 57], ["partying_face", 58], ["sunglasses", 59], ["nerd_face", 60], ["monocle_face", 61], ["confused", 62], ["worried", 63], ["slightly_frowning_face", 64], ["frowning_face", 65], ["open_mouth", 66], ["hushed", 67], ["astonished", 68], ["flushed", 69], ["pleading_face", 70], ["frowning", 71], ["anguished", 72], ["fearful", 73], ["cold_sweat", 74], ["disappointed_relieved", 75], ["cry", 76], ["sob", 77], ["scream", 78], ["confounded", 79], ["persevere", 80], ["disappointed", 81], ["sweat", 82], ["weary", 83], ["tired_face", 84], ["yawning_face", 85], ["triumph", 86], ["rage", 87], ["pout", 87], ["angry", 88], ["cursing_face", 89], ["smiling_imp", 90], ["imp", 91], ["skull", 92], ["skull_and_crossbones", 93], ["hankey", 94], ["poop", 94], ["shit", 94], ["clown_face", 95], ["japanese_ogre", 96], ["japanese_goblin", 97], ["ghost", 98], ["alien", 99], ["space_invader", 100], ["robot", 101], ["smiley_cat", 102], ["smile_cat", 103], ["joy_cat", 104], ["heart_eyes_cat", 105], ["smirk_cat", 106], ["kissing_cat", 107], ["scream_cat", 108], ["crying_cat_face", 109], ["pouting_cat", 110], ["see_no_evil", 111], ["hear_no_evil", 112], ["speak_no_evil", 113], ["kiss", 114], ["love_letter", 115], ["cupid", 116], ["gift_heart", 117], ["sparkling_heart", 118], ["heartpulse", 119], ["heartbeat", 120], ["revolving_hearts", 121], ["two_hearts", 122], ["heart_decoration", 123], ["heavy_heart_exclamation", 124], ["broken_heart", 125], ["heart", 126], ["orange_heart", 127], ["yellow_heart", 128], ["green_heart", 129], ["blue_heart", 130], ["purple_heart", 131], ["brown_heart", 132], ["black_heart", 133], ["white_heart", 134], ["100", 135], ["anger", 136], ["boom", 137], ["collision", 137], ["dizzy", 138], ["sweat_drops", 139], ["dash", 140], ["hole", 141], ["bomb", 142], ["speech_balloon", 143], ["eye_speech_bubble", 144], ["left_speech_bubble", 145], ["right_anger_bubble", 146], ["thought_balloon", 147], ["zzz", 148], ["wave", 149], ["raised_back_of_hand", 150], ["raised_hand_with_fingers_splayed", 151], ["hand", 152], ["raised_hand", 152], ["vulcan_salute", 153], ["ok_hand", 154], ["pinching_hand", 155], ["v", 156], ["crossed_fingers", 157], ["love_you_gesture", 158], ["metal", 159], ["call_me_hand", 160], ["point_left", 161], ["point_right", 162], ["point_up_2", 163], ["middle_finger", 164], ["fu", 164], ["point_down", 165], ["point_up", 166], ["+1", 167], ["thumbsup", 167], ["-1", 168], ["thumbsdown", 168], ["fist_raised", 169], ["fist", 169], ["fist_oncoming", 170], ["facepunch", 170], ["punch", 170], ["fist_left", 171], ["fist_right", 172], ["clap", 173], ["raised_hands", 174], ["open_hands", 175], ["palms_up_together", 176], ["handshake", 177], ["pray", 178], ["writing_hand", 179], ["nail_care", 180], ["selfie", 181], ["muscle", 182], ["mechanical_arm", 183], ["mechanical_leg", 184], ["leg", 185], ["foot", 186], ["ear", 187], ["ear_with_hearing_aid", 188], ["nose", 189], ["brain", 190], ["tooth", 191], ["bone", 192], ["eyes", 193], ["eye", 194], ["tongue", 195], ["lips", 196], ["baby", 197], ["child", 198], ["boy", 199], ["girl", 200], ["adult", 201], ["blond_haired_person", 202], ["person_with_blond_hair", 202], ["man", 203], ["bearded_person", 204], ["red_haired_man", 205], ["curly_haired_man", 206], ["white_haired_man", 207], ["bald_man", 208], ["woman", 209], ["red_haired_woman", 210], ["person_red_hair", 211], ["curly_haired_woman", 212], ["person_curly_hair", 213], ["white_haired_woman", 214], ["person_white_hair", 215], ["bald_woman", 216], ["person_bald", 217], ["blond_haired_woman", 218], ["blonde_woman", 218], ["blond_haired_man", 219], ["blonde_man", 219], ["older_adult", 220], ["older_man", 221], ["older_woman", 222], ["frowning_person", 223], ["person_frowning", 223], ["frowning_man", 224], ["frowning_woman", 225], ["pouting_face", 226], ["person_with_pouting_face", 226], ["pouting_man", 227], ["pouting_woman", 228], ["no_good", 229], ["no_good_man", 230], ["ng_man", 230], ["no_good_woman", 231], ["ng_woman", 231], ["ok_person", 232], ["ok_man", 233], ["ok_woman", 234], ["tipping_hand_person", 235], ["information_desk_person", 235], ["tipping_hand_man", 236], ["sassy_man", 236], ["tipping_hand_woman", 237], ["sassy_woman", 237], ["raising_hand", 238], ["raising_hand_man", 239], ["raising_hand_woman", 240], ["deaf_person", 241], ["deaf_man", 242], ["deaf_woman", 243], ["bow", 244], ["bowing_man", 245], ["bowing_woman", 246], ["facepalm", 247], ["man_facepalming", 248], ["woman_facepalming", 249], ["shrug", 250], ["man_shrugging", 251], ["woman_shrugging", 252], ["health_worker", 253], ["man_health_worker", 254], ["woman_health_worker", 255], ["student", 256], ["man_student", 257], ["woman_student", 258], ["teacher", 259], ["man_teacher", 260], ["woman_teacher", 261], ["judge", 262], ["man_judge", 263], ["woman_judge", 264], ["farmer", 265], ["man_farmer", 266], ["woman_farmer", 267], ["cook", 268], ["man_cook", 269], ["woman_cook", 270], ["mechanic", 271], ["man_mechanic", 272], ["woman_mechanic", 273], ["factory_worker", 274], ["man_factory_worker", 275], ["woman_factory_worker", 276], ["office_worker", 277], ["man_office_worker", 278], ["woman_office_worker", 279], ["scientist", 280], ["man_scientist", 281], ["woman_scientist", 282], ["technologist", 283], ["man_technologist", 284], ["woman_technologist", 285], ["singer", 286], ["man_singer", 287], ["woman_singer", 288], ["artist", 289], ["man_artist", 290], ["woman_artist", 291], ["pilot", 292], ["man_pilot", 293], ["woman_pilot", 294], ["astronaut", 295], ["man_astronaut", 296], ["woman_astronaut", 297], ["firefighter", 298], ["man_firefighter", 299], ["woman_firefighter", 300], ["police_officer", 301], ["cop", 301], ["policeman", 302], ["policewoman", 303], ["detective", 304], ["male_detective", 305], ["female_detective", 306], ["guard", 307], ["guardsman", 308], ["guardswoman", 309], ["construction_worker", 310], ["construction_worker_man", 311], ["construction_worker_woman", 312], ["prince", 313], ["princess", 314], ["person_with_turban", 315], ["man_with_turban", 316], ["woman_with_turban", 317], ["man_with_gua_pi_mao", 318], ["woman_with_headscarf", 319], ["man_in_tuxedo", 320], ["bride_with_veil", 321], ["pregnant_woman", 322], ["breast_feeding", 323], ["angel", 324], ["santa", 325], ["mrs_claus", 326], ["superhero", 327], ["superhero_man", 328], ["superhero_woman", 329], ["supervillain", 330], ["supervillain_man", 331], ["supervillain_woman", 332], ["mage", 333], ["mage_man", 334], ["mage_woman", 335], ["fairy", 336], ["fairy_man", 337], ["fairy_woman", 338], ["vampire", 339], ["vampire_man", 340], ["vampire_woman", 341], ["merperson", 342], ["merman", 343], ["mermaid", 344], ["elf", 345], ["elf_man", 346], ["elf_woman", 347], ["genie", 348], ["genie_man", 349], ["genie_woman", 350], ["zombie", 351], ["zombie_man", 352], ["zombie_woman", 353], ["massage", 354], ["massage_man", 355], ["massage_woman", 356], ["haircut", 357], ["haircut_man", 358], ["haircut_woman", 359], ["walking", 360], ["walking_man", 361], ["walking_woman", 362], ["standing_person", 363], ["standing_man", 364], ["standing_woman", 365], ["kneeling_person", 366], ["kneeling_man", 367], ["kneeling_woman", 368], ["person_with_probing_cane", 369], ["man_with_probing_cane", 370], ["woman_with_probing_cane", 371], ["person_in_motorized_wheelchair", 372], ["man_in_motorized_wheelchair", 373], ["woman_in_motorized_wheelchair", 374], ["person_in_manual_wheelchair", 375], ["man_in_manual_wheelchair", 376], ["woman_in_manual_wheelchair", 377], ["runner", 378], ["running", 378], ["running_man", 379], ["running_woman", 380], ["woman_dancing", 381], ["dancer", 381], ["man_dancing", 382], ["business_suit_levitating", 383], ["dancers", 384], ["dancing_men", 385], ["dancing_women", 386], ["sauna_person", 387], ["sauna_man", 388], ["sauna_woman", 389], ["climbing", 390], ["climbing_man", 391], ["climbing_woman", 392], ["person_fencing", 393], ["horse_racing", 394], ["skier", 395], ["snowboarder", 396], ["golfing", 397], ["golfing_man", 398], ["golfing_woman", 399], ["surfer", 400], ["surfing_man", 401], ["surfing_woman", 402], ["rowboat", 403], ["rowing_man", 404], ["rowing_woman", 405], ["swimmer", 406], ["swimming_man", 407], ["swimming_woman", 408], ["bouncing_ball_person", 409], ["bouncing_ball_man", 410], ["basketball_man", 410], ["bouncing_ball_woman", 411], ["basketball_woman", 411], ["weight_lifting", 412], ["weight_lifting_man", 413], ["weight_lifting_woman", 414], ["bicyclist", 415], ["biking_man", 416], ["biking_woman", 417], ["mountain_bicyclist", 418], ["mountain_biking_man", 419], ["mountain_biking_woman", 420], ["cartwheeling", 421], ["man_cartwheeling", 422], ["woman_cartwheeling", 423], ["wrestling", 424], ["men_wrestling", 425], ["women_wrestling", 426], ["water_polo", 427], ["man_playing_water_polo", 428], ["woman_playing_water_polo", 429], ["handball_person", 430], ["man_playing_handball", 431], ["woman_playing_handball", 432], ["juggling_person", 433], ["man_juggling", 434], ["woman_juggling", 435], ["lotus_position", 436], ["lotus_position_man", 437], ["lotus_position_woman", 438], ["bath", 439], ["sleeping_bed", 440], ["people_holding_hands", 441], ["two_women_holding_hands", 442], ["couple", 443], ["two_men_holding_hands", 444], ["couplekiss", 445], ["couplekiss_man_woman", 446], ["couplekiss_man_man", 447], ["couplekiss_woman_woman", 448], ["couple_with_heart", 449], ["couple_with_heart_woman_man", 450], ["couple_with_heart_man_man", 451], ["couple_with_heart_woman_woman", 452], ["family", 453], ["family_man_woman_boy", 454], ["family_man_woman_girl", 455], ["family_man_woman_girl_boy", 456], ["family_man_woman_boy_boy", 457], ["family_man_woman_girl_girl", 458], ["family_man_man_boy", 459], ["family_man_man_girl", 460], ["family_man_man_girl_boy", 461], ["family_man_man_boy_boy", 462], ["family_man_man_girl_girl", 463], ["family_woman_woman_boy", 464], ["family_woman_woman_girl", 465], ["family_woman_woman_girl_boy", 466], ["family_woman_woman_boy_boy", 467], ["family_woman_woman_girl_girl", 468], ["family_man_boy", 469], ["family_man_boy_boy", 470], ["family_man_girl", 471], ["family_man_girl_boy", 472], ["family_man_girl_girl", 473], ["family_woman_boy", 474], ["family_woman_boy_boy", 475], ["family_woman_girl", 476], ["family_woman_girl_boy", 477], ["family_woman_girl_girl", 478], ["speaking_head", 479], ["bust_in_silhouette", 480], ["busts_in_silhouette", 481], ["footprints", 482], ["monkey_face", 483], ["monkey", 484], ["gorilla", 485], ["orangutan", 486], ["dog", 487], ["dog2", 488], ["guide_dog", 489], ["service_dog", 490], ["poodle", 491], ["wolf", 492], ["fox_face", 493], ["raccoon", 494], ["cat", 495], ["cat2", 496], ["lion", 497], ["tiger", 498], ["tiger2", 499], ["leopard", 500], ["horse", 501], ["racehorse", 502], ["unicorn", 503], ["zebra", 504], ["deer", 505], ["cow", 506], ["ox", 507], ["water_buffalo", 508], ["cow2", 509], ["pig", 510], ["pig2", 511], ["boar", 512], ["pig_nose", 513], ["ram", 514], ["sheep", 515], ["goat", 516], ["dromedary_camel", 517], ["camel", 518], ["llama", 519], ["giraffe", 520], ["elephant", 521], ["rhinoceros", 522], ["hippopotamus", 523], ["mouse", 524], ["mouse2", 525], ["rat", 526], ["hamster", 527], ["rabbit", 528], ["rabbit2", 529], ["chipmunk", 530], ["hedgehog", 531], ["bat", 532], ["bear", 533], ["koala", 534], ["panda_face", 535], ["sloth", 536], ["otter", 537], ["skunk", 538], ["kangaroo", 539], ["badger", 540], ["feet", 541], ["paw_prints", 541], ["turkey", 542], ["chicken", 543], ["rooster", 544], ["hatching_chick", 545], ["baby_chick", 546], ["hatched_chick", 547], ["bird", 548], ["penguin", 549], ["dove", 550], ["eagle", 551], ["duck", 552], ["swan", 553], ["owl", 554], ["flamingo", 555], ["peacock", 556], ["parrot", 557], ["frog", 558], ["crocodile", 559], ["turtle", 560], ["lizard", 561], ["snake", 562], ["dragon_face", 563], ["dragon", 564], ["sauropod", 565], ["t-rex", 566], ["whale", 567], ["whale2", 568], ["dolphin", 569], ["flipper", 569], ["fish", 570], ["tropical_fish", 571], ["blowfish", 572], ["shark", 573], ["octopus", 574], ["shell", 575], ["snail", 576], ["butterfly", 577], ["bug", 578], ["ant", 579], ["bee", 580], ["honeybee", 580], ["beetle", 581], ["cricket", 582], ["spider", 583], ["spider_web", 584], ["scorpion", 585], ["mosquito", 586], ["microbe", 587], ["bouquet", 588], ["cherry_blossom", 589], ["white_flower", 590], ["rosette", 591], ["rose", 592], ["wilted_flower", 593], ["hibiscus", 594], ["sunflower", 595], ["blossom", 596], ["tulip", 597], ["seedling", 598], ["evergreen_tree", 599], ["deciduous_tree", 600], ["palm_tree", 601], ["cactus", 602], ["ear_of_rice", 603], ["herb", 604], ["shamrock", 605], ["four_leaf_clover", 606], ["maple_leaf", 607], ["fallen_leaf", 608], ["leaves", 609], ["grapes", 610], ["melon", 611], ["watermelon", 612], ["tangerine", 613], ["orange", 613], ["mandarin", 613], ["lemon", 614], ["banana", 615], ["pineapple", 616], ["mango", 617], ["apple", 618], ["green_apple", 619], ["pear", 620], ["peach", 621], ["cherries", 622], ["strawberry", 623], ["kiwi_fruit", 624], ["tomato", 625], ["coconut", 626], ["avocado", 627], ["eggplant", 628], ["potato", 629], ["carrot", 630], ["corn", 631], ["hot_pepper", 632], ["cucumber", 633], ["leafy_green", 634], ["broccoli", 635], ["garlic", 636], ["onion", 637], ["mushroom", 638], ["peanuts", 639], ["chestnut", 640], ["bread", 641], ["croissant", 642], ["baguette_bread", 643], ["pretzel", 644], ["bagel", 645], ["pancakes", 646], ["waffle", 647], ["cheese", 648], ["meat_on_bone", 649], ["poultry_leg", 650], ["cut_of_meat", 651], ["bacon", 652], ["hamburger", 653], ["fries", 654], ["pizza", 655], ["hotdog", 656], ["sandwich", 657], ["taco", 658], ["burrito", 659], ["stuffed_flatbread", 660], ["falafel", 661], ["egg", 662], ["fried_egg", 663], ["shallow_pan_of_food", 664], ["stew", 665], ["bowl_with_spoon", 666], ["green_salad", 667], ["popcorn", 668], ["butter", 669], ["salt", 670], ["canned_food", 671], ["bento", 672], ["rice_cracker", 673], ["rice_ball", 674], ["rice", 675], ["curry", 676], ["ramen", 677], ["spaghetti", 678], ["sweet_potato", 679], ["oden", 680], ["sushi", 681], ["fried_shrimp", 682], ["fish_cake", 683], ["moon_cake", 684], ["dango", 685], ["dumpling", 686], ["fortune_cookie", 687], ["takeout_box", 688], ["crab", 689], ["lobster", 690], ["shrimp", 691], ["squid", 692], ["oyster", 693], ["icecream", 694], ["shaved_ice", 695], ["ice_cream", 696], ["doughnut", 697], ["cookie", 698], ["birthday", 699], ["cake", 700], ["cupcake", 701], ["pie", 702], ["chocolate_bar", 703], ["candy", 704], ["lollipop", 705], ["custard", 706], ["honey_pot", 707], ["baby_bottle", 708], ["milk_glass", 709], ["coffee", 710], ["tea", 711], ["sake", 712], ["champagne", 713], ["wine_glass", 714], ["cocktail", 715], ["tropical_drink", 716], ["beer", 717], ["beers", 718], ["clinking_glasses", 719], ["tumbler_glass", 720], ["cup_with_straw", 721], ["beverage_box", 722], ["mate", 723], ["ice_cube", 724], ["chopsticks", 725], ["plate_with_cutlery", 726], ["fork_and_knife", 727], ["spoon", 728], ["hocho", 729], ["knife", 729], ["amphora", 730], ["earth_africa", 731], ["earth_americas", 732], ["earth_asia", 733], ["globe_with_meridians", 734], ["world_map", 735], ["japan", 736], ["compass", 737], ["mountain_snow", 738], ["mountain", 739], ["volcano", 740], ["mount_fuji", 741], ["camping", 742], ["beach_umbrella", 743], ["desert", 744], ["desert_island", 745], ["national_park", 746], ["stadium", 747], ["classical_building", 748], ["building_construction", 749], ["bricks", 750], ["houses", 751], ["derelict_house", 752], ["house", 753], ["house_with_garden", 754], ["office", 755], ["post_office", 756], ["european_post_office", 757], ["hospital", 758], ["bank", 759], ["hotel", 760], ["love_hotel", 761], ["convenience_store", 762], ["school", 763], ["department_store", 764], ["factory", 765], ["japanese_castle", 766], ["european_castle", 767], ["wedding", 768], ["tokyo_tower", 769], ["statue_of_liberty", 770], ["church", 771], ["mosque", 772], ["hindu_temple", 773], ["synagogue", 774], ["shinto_shrine", 775], ["kaaba", 776], ["fountain", 777], ["tent", 778], ["foggy", 779], ["night_with_stars", 780], ["cityscape", 781], ["sunrise_over_mountains", 782], ["sunrise", 783], ["city_sunset", 784], ["city_sunrise", 785], ["bridge_at_night", 786], ["hotsprings", 787], ["carousel_horse", 788], ["ferris_wheel", 789], ["roller_coaster", 790], ["barber", 791], ["circus_tent", 792], ["steam_locomotive", 793], ["railway_car", 794], ["bullettrain_side", 795], ["bullettrain_front", 796], ["train2", 797], ["metro", 798], ["light_rail", 799], ["station", 800], ["tram", 801], ["monorail", 802], ["mountain_railway", 803], ["train", 804], ["bus", 805], ["oncoming_bus", 806], ["trolleybus", 807], ["minibus", 808], ["ambulance", 809], ["fire_engine", 810], ["police_car", 811], ["oncoming_police_car", 812], ["taxi", 813], ["oncoming_taxi", 814], ["car", 815], ["red_car", 815], ["oncoming_automobile", 816], ["blue_car", 817], ["truck", 818], ["articulated_lorry", 819], ["tractor", 820], ["racing_car", 821], ["motorcycle", 822], ["motor_scooter", 823], ["manual_wheelchair", 824], ["motorized_wheelchair", 825], ["auto_rickshaw", 826], ["bike", 827], ["kick_scooter", 828], ["skateboard", 829], ["busstop", 830], ["motorway", 831], ["railway_track", 832], ["oil_drum", 833], ["fuelpump", 834], ["rotating_light", 835], ["traffic_light", 836], ["vertical_traffic_light", 837], ["stop_sign", 838], ["construction", 839], ["anchor", 840], ["boat", 841], ["sailboat", 841], ["canoe", 842], ["speedboat", 843], ["passenger_ship", 844], ["ferry", 845], ["motor_boat", 846], ["ship", 847], ["airplane", 848], ["small_airplane", 849], ["flight_departure", 850], ["flight_arrival", 851], ["parachute", 852], ["seat", 853], ["helicopter", 854], ["suspension_railway", 855], ["mountain_cableway", 856], ["aerial_tramway", 857], ["artificial_satellite", 858], ["rocket", 859], ["flying_saucer", 860], ["bellhop_bell", 861], ["luggage", 862], ["hourglass", 863], ["hourglass_flowing_sand", 864], ["watch", 865], ["alarm_clock", 866], ["stopwatch", 867], ["timer_clock", 868], ["mantelpiece_clock", 869], ["clock12", 870], ["clock1230", 871], ["clock1", 872], ["clock130", 873], ["clock2", 874], ["clock230", 875], ["clock3", 876], ["clock330", 877], ["clock4", 878], ["clock430", 879], ["clock5", 880], ["clock530", 881], ["clock6", 882], ["clock630", 883], ["clock7", 884], ["clock730", 885], ["clock8", 886], ["clock830", 887], ["clock9", 888], ["clock930", 889], ["clock10", 890], ["clock1030", 891], ["clock11", 892], ["clock1130", 893], ["new_moon", 894], ["waxing_crescent_moon", 895], ["first_quarter_moon", 896], ["moon", 897], ["waxing_gibbous_moon", 897], ["full_moon", 898], ["waning_gibbous_moon", 899], ["last_quarter_moon", 900], ["waning_crescent_moon", 901], ["crescent_moon", 902], ["new_moon_with_face", 903], ["first_quarter_moon_with_face", 904], ["last_quarter_moon_with_face", 905], ["thermometer", 906], ["sunny", 907], ["full_moon_with_face", 908], ["sun_with_face", 909], ["ringed_planet", 910], ["star", 911], ["star2", 912], ["stars", 913], ["milky_way", 914], ["cloud", 915], ["partly_sunny", 916], ["cloud_with_lightning_and_rain", 917], ["sun_behind_small_cloud", 918], ["sun_behind_large_cloud", 919], ["sun_behind_rain_cloud", 920], ["cloud_with_rain", 921], ["cloud_with_snow", 922], ["cloud_with_lightning", 923], ["tornado", 924], ["fog", 925], ["wind_face", 926], ["cyclone", 927], ["rainbow", 928], ["closed_umbrella", 929], ["open_umbrella", 930], ["umbrella", 931], ["parasol_on_ground", 932], ["zap", 933], ["snowflake", 934], ["snowman_with_snow", 935], ["snowman", 936], ["comet", 937], ["fire", 938], ["droplet", 939], ["ocean", 940], ["jack_o_lantern", 941], ["christmas_tree", 942], ["fireworks", 943], ["sparkler", 944], ["firecracker", 945], ["sparkles", 946], ["balloon", 947], ["tada", 948], ["confetti_ball", 949], ["tanabata_tree", 950], ["bamboo", 951], ["dolls", 952], ["flags", 953], ["wind_chime", 954], ["rice_scene", 955], ["red_envelope", 956], ["ribbon", 957], ["gift", 958], ["reminder_ribbon", 959], ["tickets", 960], ["ticket", 961], ["medal_military", 962], ["trophy", 963], ["medal_sports", 964], ["1st_place_medal", 965], ["2nd_place_medal", 966], ["3rd_place_medal", 967], ["soccer", 968], ["baseball", 969], ["softball", 970], ["basketball", 971], ["volleyball", 972], ["football", 973], ["rugby_football", 974], ["tennis", 975], ["flying_disc", 976], ["bowling", 977], ["cricket_game", 978], ["field_hockey", 979], ["ice_hockey", 980], ["lacrosse", 981], ["ping_pong", 982], ["badminton", 983], ["boxing_glove", 984], ["martial_arts_uniform", 985], ["goal_net", 986], ["golf", 987], ["ice_skate", 988], ["fishing_pole_and_fish", 989], ["diving_mask", 990], ["running_shirt_with_sash", 991], ["ski", 992], ["sled", 993], ["curling_stone", 994], ["dart", 995], ["yo_yo", 996], ["kite", 997], ["8ball", 998], ["crystal_ball", 999], ["nazar_amulet", 1000], ["video_game", 1001], ["joystick", 1002], ["slot_machine", 1003], ["game_die", 1004], ["jigsaw", 1005], ["teddy_bear", 1006], ["spades", 1007], ["hearts", 1008], ["diamonds", 1009], ["clubs", 1010], ["chess_pawn", 1011], ["black_joker", 1012], ["mahjong", 1013], ["flower_playing_cards", 1014], ["performing_arts", 1015], ["framed_picture", 1016], ["art", 1017], ["thread", 1018], ["yarn", 1019], ["eyeglasses", 1020], ["dark_sunglasses", 1021], ["goggles", 1022], ["lab_coat", 1023], ["safety_vest", 1024], ["necktie", 1025], ["shirt", 1026], ["tshirt", 1026], ["jeans", 1027], ["scarf", 1028], ["gloves", 1029], ["coat", 1030], ["socks", 1031], ["dress", 1032], ["kimono", 1033], ["sari", 1034], ["one_piece_swimsuit", 1035], ["swim_brief", 1036], ["shorts", 1037], ["bikini", 1038], ["womans_clothes", 1039], ["purse", 1040], ["handbag", 1041], ["pouch", 1042], ["shopping", 1043], ["school_satchel", 1044], ["mans_shoe", 1045], ["shoe", 1045], ["athletic_shoe", 1046], ["hiking_boot", 1047], ["flat_shoe", 1048], ["high_heel", 1049], ["sandal", 1050], ["ballet_shoes", 1051], ["boot", 1052], ["crown", 1053], ["womans_hat", 1054], ["tophat", 1055], ["mortar_board", 1056], ["billed_cap", 1057], ["rescue_worker_helmet", 1058], ["prayer_beads", 1059], ["lipstick", 1060], ["ring", 1061], ["gem", 1062], ["mute", 1063], ["speaker", 1064], ["sound", 1065], ["loud_sound", 1066], ["loudspeaker", 1067], ["mega", 1068], ["postal_horn", 1069], ["bell", 1070], ["no_bell", 1071], ["musical_score", 1072], ["musical_note", 1073], ["notes", 1074], ["studio_microphone", 1075], ["level_slider", 1076], ["control_knobs", 1077], ["microphone", 1078], ["headphones", 1079], ["radio", 1080], ["saxophone", 1081], ["guitar", 1082], ["musical_keyboard", 1083], ["trumpet", 1084], ["violin", 1085], ["banjo", 1086], ["drum", 1087], ["iphone", 1088], ["calling", 1089], ["phone", 1090], ["telephone", 1090], ["telephone_receiver", 1091], ["pager", 1092], ["fax", 1093], ["battery", 1094], ["electric_plug", 1095], ["computer", 1096], ["desktop_computer", 1097], ["printer", 1098], ["keyboard", 1099], ["computer_mouse", 1100], ["trackball", 1101], ["minidisc", 1102], ["floppy_disk", 1103], ["cd", 1104], ["dvd", 1105], ["abacus", 1106], ["movie_camera", 1107], ["film_strip", 1108], ["film_projector", 1109], ["clapper", 1110], ["tv", 1111], ["camera", 1112], ["camera_flash", 1113], ["video_camera", 1114], ["vhs", 1115], ["mag", 1116], ["mag_right", 1117], ["candle", 1118], ["bulb", 1119], ["flashlight", 1120], ["izakaya_lantern", 1121], ["lantern", 1121], ["diya_lamp", 1122], ["notebook_with_decorative_cover", 1123], ["closed_book", 1124], ["book", 1125], ["open_book", 1125], ["green_book", 1126], ["blue_book", 1127], ["orange_book", 1128], ["books", 1129], ["notebook", 1130], ["ledger", 1131], ["page_with_curl", 1132], ["scroll", 1133], ["page_facing_up", 1134], ["newspaper", 1135], ["newspaper_roll", 1136], ["bookmark_tabs", 1137], ["bookmark", 1138], ["label", 1139], ["moneybag", 1140], ["yen", 1141], ["dollar", 1142], ["euro", 1143], ["pound", 1144], ["money_with_wings", 1145], ["credit_card", 1146], ["receipt", 1147], ["chart", 1148], ["currency_exchange", 1149], ["heavy_dollar_sign", 1150], ["email", 1151], ["envelope", 1151], ["e-mail", 1152], ["incoming_envelope", 1153], ["envelope_with_arrow", 1154], ["outbox_tray", 1155], ["inbox_tray", 1156], ["package", 1157], ["mailbox", 1158], ["mailbox_closed", 1159], ["mailbox_with_mail", 1160], ["mailbox_with_no_mail", 1161], ["postbox", 1162], ["ballot_box", 1163], ["pencil2", 1164], ["black_nib", 1165], ["fountain_pen", 1166], ["pen", 1167], ["paintbrush", 1168], ["crayon", 1169], ["memo", 1170], ["pencil", 1170], ["briefcase", 1171], ["file_folder", 1172], ["open_file_folder", 1173], ["card_index_dividers", 1174], ["date", 1175], ["calendar", 1176], ["spiral_notepad", 1177], ["spiral_calendar", 1178], ["card_index", 1179], ["chart_with_upwards_trend", 1180], ["chart_with_downwards_trend", 1181], ["bar_chart", 1182], ["clipboard", 1183], ["pushpin", 1184], ["round_pushpin", 1185], ["paperclip", 1186], ["paperclips", 1187], ["straight_ruler", 1188], ["triangular_ruler", 1189], ["scissors", 1190], ["card_file_box", 1191], ["file_cabinet", 1192], ["wastebasket", 1193], ["lock", 1194], ["unlock", 1195], ["lock_with_ink_pen", 1196], ["closed_lock_with_key", 1197], ["key", 1198], ["old_key", 1199], ["hammer", 1200], ["axe", 1201], ["pick", 1202], ["hammer_and_pick", 1203], ["hammer_and_wrench", 1204], ["dagger", 1205], ["crossed_swords", 1206], ["gun", 1207], ["bow_and_arrow", 1208], ["shield", 1209], ["wrench", 1210], ["nut_and_bolt", 1211], ["gear", 1212], ["clamp", 1213], ["balance_scale", 1214], ["probing_cane", 1215], ["link", 1216], ["chains", 1217], ["toolbox", 1218], ["magnet", 1219], ["alembic", 1220], ["test_tube", 1221], ["petri_dish", 1222], ["dna", 1223], ["microscope", 1224], ["telescope", 1225], ["satellite", 1226], ["syringe", 1227], ["drop_of_blood", 1228], ["pill", 1229], ["adhesive_bandage", 1230], ["stethoscope", 1231], ["door", 1232], ["bed", 1233], ["couch_and_lamp", 1234], ["chair", 1235], ["toilet", 1236], ["shower", 1237], ["bathtub", 1238], ["razor", 1239], ["lotion_bottle", 1240], ["safety_pin", 1241], ["broom", 1242], ["basket", 1243], ["roll_of_paper", 1244], ["soap", 1245], ["sponge", 1246], ["fire_extinguisher", 1247], ["shopping_cart", 1248], ["smoking", 1249], ["coffin", 1250], ["funeral_urn", 1251], ["moyai", 1252], ["atm", 1253], ["put_litter_in_its_place", 1254], ["potable_water", 1255], ["wheelchair", 1256], ["mens", 1257], ["womens", 1258], ["restroom", 1259], ["baby_symbol", 1260], ["wc", 1261], ["passport_control", 1262], ["customs", 1263], ["baggage_claim", 1264], ["left_luggage", 1265], ["warning", 1266], ["children_crossing", 1267], ["no_entry", 1268], ["no_entry_sign", 1269], ["no_bicycles", 1270], ["no_smoking", 1271], ["do_not_litter", 1272], ["non-potable_water", 1273], ["no_pedestrians", 1274], ["no_mobile_phones", 1275], ["underage", 1276], ["radioactive", 1277], ["biohazard", 1278], ["arrow_up", 1279], ["arrow_upper_right", 1280], ["arrow_right", 1281], ["arrow_lower_right", 1282], ["arrow_down", 1283], ["arrow_lower_left", 1284], ["arrow_left", 1285], ["arrow_upper_left", 1286], ["arrow_up_down", 1287], ["left_right_arrow", 1288], ["leftwards_arrow_with_hook", 1289], ["arrow_right_hook", 1290], ["arrow_heading_up", 1291], ["arrow_heading_down", 1292], ["arrows_clockwise", 1293], ["arrows_counterclockwise", 1294], ["back", 1295], ["end", 1296], ["on", 1297], ["soon", 1298], ["top", 1299], ["place_of_worship", 1300], ["atom_symbol", 1301], ["om", 1302], ["star_of_david", 1303], ["wheel_of_dharma", 1304], ["yin_yang", 1305], ["latin_cross", 1306], ["orthodox_cross", 1307], ["star_and_crescent", 1308], ["peace_symbol", 1309], ["menorah", 1310], ["six_pointed_star", 1311], ["aries", 1312], ["taurus", 1313], ["gemini", 1314], ["cancer", 1315], ["leo", 1316], ["virgo", 1317], ["libra", 1318], ["scorpius", 1319], ["sagittarius", 1320], ["capricorn", 1321], ["aquarius", 1322], ["pisces", 1323], ["ophiuchus", 1324], ["twisted_rightwards_arrows", 1325], ["repeat", 1326], ["repeat_one", 1327], ["arrow_forward", 1328], ["fast_forward", 1329], ["next_track_button", 1330], ["play_or_pause_button", 1331], ["arrow_backward", 1332], ["rewind", 1333], ["previous_track_button", 1334], ["arrow_up_small", 1335], ["arrow_double_up", 1336], ["arrow_down_small", 1337], ["arrow_double_down", 1338], ["pause_button", 1339], ["stop_button", 1340], ["record_button", 1341], ["eject_button", 1342], ["cinema", 1343], ["low_brightness", 1344], ["high_brightness", 1345], ["signal_strength", 1346], ["vibration_mode", 1347], ["mobile_phone_off", 1348], ["female_sign", 1349], ["male_sign", 1350], ["medical_symbol", 1351], ["infinity", 1352], ["recycle", 1353], ["fleur_de_lis", 1354], ["trident", 1355], ["name_badge", 1356], ["beginner", 1357], ["o", 1358], ["white_check_mark", 1359], ["ballot_box_with_check", 1360], ["heavy_check_mark", 1361], ["heavy_multiplication_x", 1362], ["x", 1363], ["negative_squared_cross_mark", 1364], ["heavy_plus_sign", 1365], ["heavy_minus_sign", 1366], ["heavy_division_sign", 1367], ["curly_loop", 1368], ["loop", 1369], ["part_alternation_mark", 1370], ["eight_spoked_asterisk", 1371], ["eight_pointed_black_star", 1372], ["sparkle", 1373], ["bangbang", 1374], ["interrobang", 1375], ["question", 1376], ["grey_question", 1377], ["grey_exclamation", 1378], ["exclamation", 1379], ["heavy_exclamation_mark", 1379], ["wavy_dash", 1380], ["copyright", 1381], ["registered", 1382], ["tm", 1383], ["hash", 1384], ["asterisk", 1385], ["zero", 1386], ["one", 1387], ["two", 1388], ["three", 1389], ["four", 1390], ["five", 1391], ["six", 1392], ["seven", 1393], ["eight", 1394], ["nine", 1395], ["keycap_ten", 1396], ["capital_abcd", 1397], ["abcd", 1398], ["1234", 1399], ["symbols", 1400], ["abc", 1401], ["a", 1402], ["ab", 1403], ["b", 1404], ["cl", 1405], ["cool", 1406], ["free", 1407], ["information_source", 1408], ["id", 1409], ["m", 1410], ["new", 1411], ["ng", 1412], ["o2", 1413], ["ok", 1414], ["parking", 1415], ["sos", 1416], ["up", 1417], ["vs", 1418], ["koko", 1419], ["sa", 1420], ["u6708", 1421], ["u6709", 1422], ["u6307", 1423], ["ideograph_advantage", 1424], ["u5272", 1425], ["u7121", 1426], ["u7981", 1427], ["accept", 1428], ["u7533", 1429], ["u5408", 1430], ["u7a7a", 1431], ["congratulations", 1432], ["secret", 1433], ["u55b6", 1434], ["u6e80", 1435], ["red_circle", 1436], ["orange_circle", 1437], ["yellow_circle", 1438], ["green_circle", 1439], ["large_blue_circle", 1440], ["purple_circle", 1441], ["brown_circle", 1442], ["black_circle", 1443], ["white_circle", 1444], ["red_square", 1445], ["orange_square", 1446], ["yellow_square", 1447], ["green_square", 1448], ["blue_square", 1449], ["purple_square", 1450], ["brown_square", 1451], ["black_large_square", 1452], ["white_large_square", 1453], ["black_medium_square", 1454], ["white_medium_square", 1455], ["black_medium_small_square", 1456], ["white_medium_small_square", 1457], ["black_small_square", 1458], ["white_small_square", 1459], ["large_orange_diamond", 1460], ["large_blue_diamond", 1461], ["small_orange_diamond", 1462], ["small_blue_diamond", 1463], ["small_red_triangle", 1464], ["small_red_triangle_down", 1465], ["diamond_shape_with_a_dot_inside", 1466], ["radio_button", 1467], ["white_square_button", 1468], ["black_square_button", 1469], ["checkered_flag", 1470], ["triangular_flag_on_post", 1471], ["crossed_flags", 1472], ["black_flag", 1473], ["white_flag", 1474], ["rainbow_flag", 1475], ["pirate_flag", 1476], ["ascension_island", 1477], ["andorra", 1478], ["united_arab_emirates", 1479], ["afghanistan", 1480], ["antigua_barbuda", 1481], ["anguilla", 1482], ["albania", 1483], ["armenia", 1484], ["angola", 1485], ["antarctica", 1486], ["argentina", 1487], ["american_samoa", 1488], ["austria", 1489], ["australia", 1490], ["aruba", 1491], ["aland_islands", 1492], ["azerbaijan", 1493], ["bosnia_herzegovina", 1494], ["barbados", 1495], ["bangladesh", 1496], ["belgium", 1497], ["burkina_faso", 1498], ["bulgaria", 1499], ["bahrain", 1500], ["burundi", 1501], ["benin", 1502], ["st_barthelemy", 1503], ["bermuda", 1504], ["brunei", 1505], ["bolivia", 1506], ["caribbean_netherlands", 1507], ["brazil", 1508], ["bahamas", 1509], ["bhutan", 1510], ["bouvet_island", 1511], ["botswana", 1512], ["belarus", 1513], ["belize", 1514], ["canada", 1515], ["ca", 1515], ["cocos_islands", 1516], ["congo_kinshasa", 1517], ["central_african_republic", 1518], ["congo_brazzaville", 1519], ["switzerland", 1520], ["cote_divoire", 1521], ["cook_islands", 1522], ["chile", 1523], ["cameroon", 1524], ["cn", 1525], ["colombia", 1526], ["clipperton_island", 1527], ["costa_rica", 1528], ["cuba", 1529], ["cape_verde", 1530], ["curacao", 1531], ["christmas_island", 1532], ["cyprus", 1533], ["czech_republic", 1534], ["de", 1535], ["diego_garcia", 1536], ["djibouti", 1537], ["denmark", 1538], ["dominica", 1539], ["dominican_republic", 1540], ["algeria", 1541], ["ceuta_melilla", 1542], ["ecuador", 1543], ["estonia", 1544], ["egypt", 1545], ["western_sahara", 1546], ["eritrea", 1547], ["es", 1548], ["ethiopia", 1549], ["eu", 1550], ["european_union", 1550], ["finland", 1551], ["fiji", 1552], ["falkland_islands", 1553], ["micronesia", 1554], ["faroe_islands", 1555], ["fr", 1556], ["gabon", 1557], ["gb", 1558], ["uk", 1558], ["grenada", 1559], ["georgia", 1560], ["french_guiana", 1561], ["guernsey", 1562], ["ghana", 1563], ["gibraltar", 1564], ["greenland", 1565], ["gambia", 1566], ["guinea", 1567], ["guadeloupe", 1568], ["equatorial_guinea", 1569], ["greece", 1570], ["south_georgia_south_sandwich_islands", 1571], ["guatemala", 1572], ["guam", 1573], ["guinea_bissau", 1574], ["guyana", 1575], ["hong_kong", 1576], ["heard_mcdonald_islands", 1577], ["honduras", 1578], ["croatia", 1579], ["haiti", 1580], ["hungary", 1581], ["canary_islands", 1582], ["indonesia", 1583], ["ireland", 1584], ["israel", 1585], ["isle_of_man", 1586], ["india", 1587], ["british_indian_ocean_territory", 1588], ["iraq", 1589], ["iran", 1590], ["iceland", 1591], ["it", 1592], ["jersey", 1593], ["jamaica", 1594], ["jordan", 1595], ["jp", 1596], ["kenya", 1597], ["kyrgyzstan", 1598], ["cambodia", 1599], ["kiribati", 1600], ["comoros", 1601], ["st_kitts_nevis", 1602], ["north_korea", 1603], ["kr", 1604], ["kuwait", 1605], ["cayman_islands", 1606], ["kazakhstan", 1607], ["laos", 1608], ["lebanon", 1609], ["st_lucia", 1610], ["liechtenstein", 1611], ["sri_lanka", 1612], ["liberia", 1613], ["lesotho", 1614], ["lithuania", 1615], ["luxembourg", 1616], ["latvia", 1617], ["libya", 1618], ["morocco", 1619], ["monaco", 1620], ["moldova", 1621], ["montenegro", 1622], ["st_martin", 1623], ["madagascar", 1624], ["marshall_islands", 1625], ["macedonia", 1626], ["mali", 1627], ["myanmar", 1628], ["mongolia", 1629], ["macau", 1630], ["northern_mariana_islands", 1631], ["martinique", 1632], ["mauritania", 1633], ["montserrat", 1634], ["malta", 1635], ["mauritius", 1636], ["maldives", 1637], ["malawi", 1638], ["mexico", 1639], ["malaysia", 1640], ["mozambique", 1641], ["namibia", 1642], ["new_caledonia", 1643], ["niger", 1644], ["norfolk_island", 1645], ["nigeria", 1646], ["nicaragua", 1647], ["netherlands", 1648], ["norway", 1649], ["nepal", 1650], ["nauru", 1651], ["niue", 1652], ["new_zealand", 1653], ["oman", 1654], ["panama", 1655], ["peru", 1656], ["french_polynesia", 1657], ["papua_new_guinea", 1658], ["philippines", 1659], ["pakistan", 1660], ["pk", 1660], ["poland", 1661], ["st_pierre_miquelon", 1662], ["pitcairn_islands", 1663], ["puerto_rico", 1664], ["palestinian_territories", 1665], ["portugal", 1666], ["palau", 1667], ["paraguay", 1668], ["qatar", 1669], ["reunion", 1670], ["romania", 1671], ["serbia", 1672], ["ru", 1673], ["rwanda", 1674], ["saudi_arabia", 1675], ["solomon_islands", 1676], ["seychelles", 1677], ["sudan", 1678], ["sweden", 1679], ["singapore", 1680], ["st_helena", 1681], ["slovenia", 1682], ["svalbard_jan_mayen", 1683], ["slovakia", 1684], ["sierra_leone", 1685], ["san_marino", 1686], ["senegal", 1687], ["somalia", 1688], ["suriname", 1689], ["south_sudan", 1690], ["sao_tome_principe", 1691], ["el_salvador", 1692], ["sint_maarten", 1693], ["syria", 1694], ["swaziland", 1695], ["tristan_da_cunha", 1696], ["turks_caicos_islands", 1697], ["chad", 1698], ["french_southern_territories", 1699], ["togo", 1700], ["thailand", 1701], ["tajikistan", 1702], ["tokelau", 1703], ["timor_leste", 1704], ["turkmenistan", 1705], ["tunisia", 1706], ["tonga", 1707], ["tr", 1708], ["trinidad_tobago", 1709], ["tuvalu", 1710], ["taiwan", 1711], ["tanzania", 1712], ["ukraine", 1713], ["uganda", 1714], ["us_outlying_islands", 1715], ["united_nations", 1716], ["us", 1717], ["uruguay", 1718], ["uzbekistan", 1719], ["vatican_city", 1720], ["st_vincent_grenadines", 1721], ["venezuela", 1722], ["british_virgin_islands", 1723], ["us_virgin_islands", 1724], ["vietnam", 1725], ["vanuatu", 1726], ["wallis_futuna", 1727], ["samoa", 1728], ["kosovo", 1729], ["yemen", 1730], ["mayotte", 1731], ["south_africa", 1732], ["za", 1732], ["zambia", 1733], ["zimbabwe", 1734], ["england", 1735], ["scotland", 1736], ["wales", 1737], ["cordchat", 1738]]);

var EmojiIndicesByUnicode = exports.EmojiIndicesByUnicode = new _map2.default([["1f600", 0], ["1f600-fe0f", 0], ["1f603", 1], ["1f603-fe0f", 1], ["1f604", 2], ["1f604-fe0f", 2], ["1f601", 3], ["1f601-fe0f", 3], ["1f606", 4], ["1f606-fe0f", 4], ["1f605", 5], ["1f605-fe0f", 5], ["1f923", 6], ["1f923-fe0f", 6], ["1f602", 7], ["1f602-fe0f", 7], ["1f642", 8], ["1f642-fe0f", 8], ["1f643", 9], ["1f643-fe0f", 9], ["1f609", 10], ["1f609-fe0f", 10], ["1f60a", 11], ["1f60a-fe0f", 11], ["1f607", 12], ["1f607-fe0f", 12], ["1f970", 13], ["1f970-fe0f", 13], ["1f60d", 14], ["1f60d-fe0f", 14], ["1f929", 15], ["1f929-fe0f", 15], ["1f618", 16], ["1f618-fe0f", 16], ["1f617", 17], ["1f617-fe0f", 17], ["263a-fe0f", 18], ["263a", 18], ["1f61a", 19], ["1f61a-fe0f", 19], ["1f619", 20], ["1f619-fe0f", 20], ["1f60b", 21], ["1f60b-fe0f", 21], ["1f61b", 22], ["1f61b-fe0f", 22], ["1f61c", 23], ["1f61c-fe0f", 23], ["1f92a", 24], ["1f92a-fe0f", 24], ["1f61d", 25], ["1f61d-fe0f", 25], ["1f911", 26], ["1f911-fe0f", 26], ["1f917", 27], ["1f917-fe0f", 27], ["1f92d", 28], ["1f92d-fe0f", 28], ["1f92b", 29], ["1f92b-fe0f", 29], ["1f914", 30], ["1f914-fe0f", 30], ["1f910", 31], ["1f910-fe0f", 31], ["1f928", 32], ["1f928-fe0f", 32], ["1f610", 33], ["1f610-fe0f", 33], ["1f611", 34], ["1f611-fe0f", 34], ["1f636", 35], ["1f636-fe0f", 35], ["1f60f", 36], ["1f60f-fe0f", 36], ["1f612", 37], ["1f612-fe0f", 37], ["1f644", 38], ["1f644-fe0f", 38], ["1f62c", 39], ["1f62c-fe0f", 39], ["1f925", 40], ["1f925-fe0f", 40], ["1f60c", 41], ["1f60c-fe0f", 41], ["1f614", 42], ["1f614-fe0f", 42], ["1f62a", 43], ["1f62a-fe0f", 43], ["1f924", 44], ["1f924-fe0f", 44], ["1f634", 45], ["1f634-fe0f", 45], ["1f637", 46], ["1f637-fe0f", 46], ["1f912", 47], ["1f912-fe0f", 47], ["1f915", 48], ["1f915-fe0f", 48], ["1f922", 49], ["1f922-fe0f", 49], ["1f92e", 50], ["1f92e-fe0f", 50], ["1f927", 51], ["1f927-fe0f", 51], ["1f975", 52], ["1f975-fe0f", 52], ["1f976", 53], ["1f976-fe0f", 53], ["1f974", 54], ["1f974-fe0f", 54], ["1f635", 55], ["1f635-fe0f", 55], ["1f92f", 56], ["1f92f-fe0f", 56], ["1f920", 57], ["1f920-fe0f", 57], ["1f973", 58], ["1f973-fe0f", 58], ["1f60e", 59], ["1f60e-fe0f", 59], ["1f913", 60], ["1f913-fe0f", 60], ["1f9d0", 61], ["1f9d0-fe0f", 61], ["1f615", 62], ["1f615-fe0f", 62], ["1f61f", 63], ["1f61f-fe0f", 63], ["1f641", 64], ["1f641-fe0f", 64], ["2639-fe0f", 65], ["2639", 65], ["1f62e", 66], ["1f62e-fe0f", 66], ["1f62f", 67], ["1f62f-fe0f", 67], ["1f632", 68], ["1f632-fe0f", 68], ["1f633", 69], ["1f633-fe0f", 69], ["1f97a", 70], ["1f97a-fe0f", 70], ["1f626", 71], ["1f626-fe0f", 71], ["1f627", 72], ["1f627-fe0f", 72], ["1f628", 73], ["1f628-fe0f", 73], ["1f630", 74], ["1f630-fe0f", 74], ["1f625", 75], ["1f625-fe0f", 75], ["1f622", 76], ["1f622-fe0f", 76], ["1f62d", 77], ["1f62d-fe0f", 77], ["1f631", 78], ["1f631-fe0f", 78], ["1f616", 79], ["1f616-fe0f", 79], ["1f623", 80], ["1f623-fe0f", 80], ["1f61e", 81], ["1f61e-fe0f", 81], ["1f613", 82], ["1f613-fe0f", 82], ["1f629", 83], ["1f629-fe0f", 83], ["1f62b", 84], ["1f62b-fe0f", 84], ["1f971", 85], ["1f971-fe0f", 85], ["1f624", 86], ["1f624-fe0f", 86], ["1f621", 87], ["1f621-fe0f", 87], ["1f620", 88], ["1f620-fe0f", 88], ["1f92c", 89], ["1f92c-fe0f", 89], ["1f608", 90], ["1f608-fe0f", 90], ["1f47f", 91], ["1f47f-fe0f", 91], ["1f480", 92], ["1f480-fe0f", 92], ["2620-fe0f", 93], ["2620", 93], ["1f4a9", 94], ["1f4a9-fe0f", 94], ["1f921", 95], ["1f921-fe0f", 95], ["1f479", 96], ["1f479-fe0f", 96], ["1f47a", 97], ["1f47a-fe0f", 97], ["1f47b", 98], ["1f47b-fe0f", 98], ["1f47d", 99], ["1f47d-fe0f", 99], ["1f47e", 100], ["1f47e-fe0f", 100], ["1f916", 101], ["1f916-fe0f", 101], ["1f63a", 102], ["1f63a-fe0f", 102], ["1f638", 103], ["1f638-fe0f", 103], ["1f639", 104], ["1f639-fe0f", 104], ["1f63b", 105], ["1f63b-fe0f", 105], ["1f63c", 106], ["1f63c-fe0f", 106], ["1f63d", 107], ["1f63d-fe0f", 107], ["1f640", 108], ["1f640-fe0f", 108], ["1f63f", 109], ["1f63f-fe0f", 109], ["1f63e", 110], ["1f63e-fe0f", 110], ["1f648", 111], ["1f648-fe0f", 111], ["1f649", 112], ["1f649-fe0f", 112], ["1f64a", 113], ["1f64a-fe0f", 113], ["1f48b", 114], ["1f48b-fe0f", 114], ["1f48c", 115], ["1f48c-fe0f", 115], ["1f498", 116], ["1f498-fe0f", 116], ["1f49d", 117], ["1f49d-fe0f", 117], ["1f496", 118], ["1f496-fe0f", 118], ["1f497", 119], ["1f497-fe0f", 119], ["1f493", 120], ["1f493-fe0f", 120], ["1f49e", 121], ["1f49e-fe0f", 121], ["1f495", 122], ["1f495-fe0f", 122], ["1f49f", 123], ["1f49f-fe0f", 123], ["2763-fe0f", 124], ["2763", 124], ["1f494", 125], ["1f494-fe0f", 125], ["2764-fe0f", 126], ["2764", 126], ["1f9e1", 127], ["1f9e1-fe0f", 127], ["1f49b", 128], ["1f49b-fe0f", 128], ["1f49a", 129], ["1f49a-fe0f", 129], ["1f499", 130], ["1f499-fe0f", 130], ["1f49c", 131], ["1f49c-fe0f", 131], ["1f90e", 132], ["1f90e-fe0f", 132], ["1f5a4", 133], ["1f5a4-fe0f", 133], ["1f90d", 134], ["1f90d-fe0f", 134], ["1f4af", 135], ["1f4af-fe0f", 135], ["1f4a2", 136], ["1f4a2-fe0f", 136], ["1f4a5", 137], ["1f4a5-fe0f", 137], ["1f4ab", 138], ["1f4ab-fe0f", 138], ["1f4a6", 139], ["1f4a6-fe0f", 139], ["1f4a8", 140], ["1f4a8-fe0f", 140], ["1f573-fe0f", 141], ["1f573", 141], ["1f4a3", 142], ["1f4a3-fe0f", 142], ["1f4ac", 143], ["1f4ac-fe0f", 143], ["1f441-fe0f-200d-1f5e8-fe0f", 144], ["1f441-200d-1f5e8-fe0f", 144], ["1f441-fe0f-200d-1f5e8", 144], ["1f441-200d-1f5e8", 144], ["1f5e8-fe0f", 145], ["1f5e8", 145], ["1f5ef-fe0f", 146], ["1f5ef", 146], ["1f4ad", 147], ["1f4ad-fe0f", 147], ["1f4a4", 148], ["1f4a4-fe0f", 148], ["1f44b", 149], ["1f44b-fe0f", 149], ["1f91a", 150], ["1f91a-fe0f", 150], ["1f590-fe0f", 151], ["1f590", 151], ["270b", 152], ["270b-fe0f", 152], ["1f596", 153], ["1f596-fe0f", 153], ["1f44c", 154], ["1f44c-fe0f", 154], ["1f90f", 155], ["1f90f-fe0f", 155], ["270c-fe0f", 156], ["270c", 156], ["1f91e", 157], ["1f91e-fe0f", 157], ["1f91f", 158], ["1f91f-fe0f", 158], ["1f918", 159], ["1f918-fe0f", 159], ["1f919", 160], ["1f919-fe0f", 160], ["1f448", 161], ["1f448-fe0f", 161], ["1f449", 162], ["1f449-fe0f", 162], ["1f446", 163], ["1f446-fe0f", 163], ["1f595", 164], ["1f595-fe0f", 164], ["1f447", 165], ["1f447-fe0f", 165], ["261d-fe0f", 166], ["261d", 166], ["1f44d", 167], ["1f44d-fe0f", 167], ["1f44e", 168], ["1f44e-fe0f", 168], ["270a", 169], ["270a-fe0f", 169], ["1f44a", 170], ["1f44a-fe0f", 170], ["1f91b", 171], ["1f91b-fe0f", 171], ["1f91c", 172], ["1f91c-fe0f", 172], ["1f44f", 173], ["1f44f-fe0f", 173], ["1f64c", 174], ["1f64c-fe0f", 174], ["1f450", 175], ["1f450-fe0f", 175], ["1f932", 176], ["1f932-fe0f", 176], ["1f91d", 177], ["1f91d-fe0f", 177], ["1f64f", 178], ["1f64f-fe0f", 178], ["270d-fe0f", 179], ["270d", 179], ["1f485", 180], ["1f485-fe0f", 180], ["1f933", 181], ["1f933-fe0f", 181], ["1f4aa", 182], ["1f4aa-fe0f", 182], ["1f9be", 183], ["1f9be-fe0f", 183], ["1f9bf", 184], ["1f9bf-fe0f", 184], ["1f9b5", 185], ["1f9b5-fe0f", 185], ["1f9b6", 186], ["1f9b6-fe0f", 186], ["1f442", 187], ["1f442-fe0f", 187], ["1f9bb", 188], ["1f9bb-fe0f", 188], ["1f443", 189], ["1f443-fe0f", 189], ["1f9e0", 190], ["1f9e0-fe0f", 190], ["1f9b7", 191], ["1f9b7-fe0f", 191], ["1f9b4", 192], ["1f9b4-fe0f", 192], ["1f440", 193], ["1f440-fe0f", 193], ["1f441-fe0f", 194], ["1f441", 194], ["1f445", 195], ["1f445-fe0f", 195], ["1f444", 196], ["1f444-fe0f", 196], ["1f476", 197], ["1f476-fe0f", 197], ["1f9d2", 198], ["1f9d2-fe0f", 198], ["1f466", 199], ["1f466-fe0f", 199], ["1f467", 200], ["1f467-fe0f", 200], ["1f9d1", 201], ["1f9d1-fe0f", 201], ["1f471", 202], ["1f471-fe0f", 202], ["1f468", 203], ["1f468-fe0f", 203], ["1f9d4", 204], ["1f9d4-fe0f", 204], ["1f468-200d-1f9b0", 205], ["1f468-200d-1f9b0-fe0f", 205], ["1f468-200d-1f9b1", 206], ["1f468-200d-1f9b1-fe0f", 206], ["1f468-200d-1f9b3", 207], ["1f468-200d-1f9b3-fe0f", 207], ["1f468-200d-1f9b2", 208], ["1f468-200d-1f9b2-fe0f", 208], ["1f469", 209], ["1f469-fe0f", 209], ["1f469-200d-1f9b0", 210], ["1f469-200d-1f9b0-fe0f", 210], ["1f9d1-200d-1f9b0", 211], ["1f9d1-200d-1f9b0-fe0f", 211], ["1f469-200d-1f9b1", 212], ["1f469-200d-1f9b1-fe0f", 212], ["1f9d1-200d-1f9b1", 213], ["1f9d1-200d-1f9b1-fe0f", 213], ["1f469-200d-1f9b3", 214], ["1f469-200d-1f9b3-fe0f", 214], ["1f9d1-200d-1f9b3", 215], ["1f9d1-200d-1f9b3-fe0f", 215], ["1f469-200d-1f9b2", 216], ["1f469-200d-1f9b2-fe0f", 216], ["1f9d1-200d-1f9b2", 217], ["1f9d1-200d-1f9b2-fe0f", 217], ["1f471-200d-2640-fe0f", 218], ["1f471-200d-2640", 218], ["1f471-200d-2642-fe0f", 219], ["1f471-200d-2642", 219], ["1f9d3", 220], ["1f9d3-fe0f", 220], ["1f474", 221], ["1f474-fe0f", 221], ["1f475", 222], ["1f475-fe0f", 222], ["1f64d", 223], ["1f64d-fe0f", 223], ["1f64d-200d-2642-fe0f", 224], ["1f64d-200d-2642", 224], ["1f64d-200d-2640-fe0f", 225], ["1f64d-200d-2640", 225], ["1f64e", 226], ["1f64e-fe0f", 226], ["1f64e-200d-2642-fe0f", 227], ["1f64e-200d-2642", 227], ["1f64e-200d-2640-fe0f", 228], ["1f64e-200d-2640", 228], ["1f645", 229], ["1f645-fe0f", 229], ["1f645-200d-2642-fe0f", 230], ["1f645-200d-2642", 230], ["1f645-200d-2640-fe0f", 231], ["1f645-200d-2640", 231], ["1f646", 232], ["1f646-fe0f", 232], ["1f646-200d-2642-fe0f", 233], ["1f646-200d-2642", 233], ["1f646-200d-2640-fe0f", 234], ["1f646-200d-2640", 234], ["1f481", 235], ["1f481-fe0f", 235], ["1f481-200d-2642-fe0f", 236], ["1f481-200d-2642", 236], ["1f481-200d-2640-fe0f", 237], ["1f481-200d-2640", 237], ["1f64b", 238], ["1f64b-fe0f", 238], ["1f64b-200d-2642-fe0f", 239], ["1f64b-200d-2642", 239], ["1f64b-200d-2640-fe0f", 240], ["1f64b-200d-2640", 240], ["1f9cf", 241], ["1f9cf-fe0f", 241], ["1f9cf-200d-2642-fe0f", 242], ["1f9cf-200d-2642", 242], ["1f9cf-200d-2640-fe0f", 243], ["1f9cf-200d-2640", 243], ["1f647", 244], ["1f647-fe0f", 244], ["1f647-200d-2642-fe0f", 245], ["1f647-200d-2642", 245], ["1f647-200d-2640-fe0f", 246], ["1f647-200d-2640", 246], ["1f926", 247], ["1f926-fe0f", 247], ["1f926-200d-2642-fe0f", 248], ["1f926-200d-2642", 248], ["1f926-200d-2640-fe0f", 249], ["1f926-200d-2640", 249], ["1f937", 250], ["1f937-fe0f", 250], ["1f937-200d-2642-fe0f", 251], ["1f937-200d-2642", 251], ["1f937-200d-2640-fe0f", 252], ["1f937-200d-2640", 252], ["1f9d1-200d-2695-fe0f", 253], ["1f9d1-200d-2695", 253], ["1f468-200d-2695-fe0f", 254], ["1f468-200d-2695", 254], ["1f469-200d-2695-fe0f", 255], ["1f469-200d-2695", 255], ["1f9d1-200d-1f393", 256], ["1f9d1-200d-1f393-fe0f", 256], ["1f468-200d-1f393", 257], ["1f468-200d-1f393-fe0f", 257], ["1f469-200d-1f393", 258], ["1f469-200d-1f393-fe0f", 258], ["1f9d1-200d-1f3eb", 259], ["1f9d1-200d-1f3eb-fe0f", 259], ["1f468-200d-1f3eb", 260], ["1f468-200d-1f3eb-fe0f", 260], ["1f469-200d-1f3eb", 261], ["1f469-200d-1f3eb-fe0f", 261], ["1f9d1-200d-2696-fe0f", 262], ["1f9d1-200d-2696", 262], ["1f468-200d-2696-fe0f", 263], ["1f468-200d-2696", 263], ["1f469-200d-2696-fe0f", 264], ["1f469-200d-2696", 264], ["1f9d1-200d-1f33e", 265], ["1f9d1-200d-1f33e-fe0f", 265], ["1f468-200d-1f33e", 266], ["1f468-200d-1f33e-fe0f", 266], ["1f469-200d-1f33e", 267], ["1f469-200d-1f33e-fe0f", 267], ["1f9d1-200d-1f373", 268], ["1f9d1-200d-1f373-fe0f", 268], ["1f468-200d-1f373", 269], ["1f468-200d-1f373-fe0f", 269], ["1f469-200d-1f373", 270], ["1f469-200d-1f373-fe0f", 270], ["1f9d1-200d-1f527", 271], ["1f9d1-200d-1f527-fe0f", 271], ["1f468-200d-1f527", 272], ["1f468-200d-1f527-fe0f", 272], ["1f469-200d-1f527", 273], ["1f469-200d-1f527-fe0f", 273], ["1f9d1-200d-1f3ed", 274], ["1f9d1-200d-1f3ed-fe0f", 274], ["1f468-200d-1f3ed", 275], ["1f468-200d-1f3ed-fe0f", 275], ["1f469-200d-1f3ed", 276], ["1f469-200d-1f3ed-fe0f", 276], ["1f9d1-200d-1f4bc", 277], ["1f9d1-200d-1f4bc-fe0f", 277], ["1f468-200d-1f4bc", 278], ["1f468-200d-1f4bc-fe0f", 278], ["1f469-200d-1f4bc", 279], ["1f469-200d-1f4bc-fe0f", 279], ["1f9d1-200d-1f52c", 280], ["1f9d1-200d-1f52c-fe0f", 280], ["1f468-200d-1f52c", 281], ["1f468-200d-1f52c-fe0f", 281], ["1f469-200d-1f52c", 282], ["1f469-200d-1f52c-fe0f", 282], ["1f9d1-200d-1f4bb", 283], ["1f9d1-200d-1f4bb-fe0f", 283], ["1f468-200d-1f4bb", 284], ["1f468-200d-1f4bb-fe0f", 284], ["1f469-200d-1f4bb", 285], ["1f469-200d-1f4bb-fe0f", 285], ["1f9d1-200d-1f3a4", 286], ["1f9d1-200d-1f3a4-fe0f", 286], ["1f468-200d-1f3a4", 287], ["1f468-200d-1f3a4-fe0f", 287], ["1f469-200d-1f3a4", 288], ["1f469-200d-1f3a4-fe0f", 288], ["1f9d1-200d-1f3a8", 289], ["1f9d1-200d-1f3a8-fe0f", 289], ["1f468-200d-1f3a8", 290], ["1f468-200d-1f3a8-fe0f", 290], ["1f469-200d-1f3a8", 291], ["1f469-200d-1f3a8-fe0f", 291], ["1f9d1-200d-2708-fe0f", 292], ["1f9d1-200d-2708", 292], ["1f468-200d-2708-fe0f", 293], ["1f468-200d-2708", 293], ["1f469-200d-2708-fe0f", 294], ["1f469-200d-2708", 294], ["1f9d1-200d-1f680", 295], ["1f9d1-200d-1f680-fe0f", 295], ["1f468-200d-1f680", 296], ["1f468-200d-1f680-fe0f", 296], ["1f469-200d-1f680", 297], ["1f469-200d-1f680-fe0f", 297], ["1f9d1-200d-1f692", 298], ["1f9d1-200d-1f692-fe0f", 298], ["1f468-200d-1f692", 299], ["1f468-200d-1f692-fe0f", 299], ["1f469-200d-1f692", 300], ["1f469-200d-1f692-fe0f", 300], ["1f46e", 301], ["1f46e-fe0f", 301], ["1f46e-200d-2642-fe0f", 302], ["1f46e-200d-2642", 302], ["1f46e-200d-2640-fe0f", 303], ["1f46e-200d-2640", 303], ["1f575-fe0f", 304], ["1f575", 304], ["1f575-fe0f-200d-2642-fe0f", 305], ["1f575-200d-2642-fe0f", 305], ["1f575-fe0f-200d-2642", 305], ["1f575-200d-2642", 305], ["1f575-fe0f-200d-2640-fe0f", 306], ["1f575-200d-2640-fe0f", 306], ["1f575-fe0f-200d-2640", 306], ["1f575-200d-2640", 306], ["1f482", 307], ["1f482-fe0f", 307], ["1f482-200d-2642-fe0f", 308], ["1f482-200d-2642", 308], ["1f482-200d-2640-fe0f", 309], ["1f482-200d-2640", 309], ["1f477", 310], ["1f477-fe0f", 310], ["1f477-200d-2642-fe0f", 311], ["1f477-200d-2642", 311], ["1f477-200d-2640-fe0f", 312], ["1f477-200d-2640", 312], ["1f934", 313], ["1f934-fe0f", 313], ["1f478", 314], ["1f478-fe0f", 314], ["1f473", 315], ["1f473-fe0f", 315], ["1f473-200d-2642-fe0f", 316], ["1f473-200d-2642", 316], ["1f473-200d-2640-fe0f", 317], ["1f473-200d-2640", 317], ["1f472", 318], ["1f472-fe0f", 318], ["1f9d5", 319], ["1f9d5-fe0f", 319], ["1f935", 320], ["1f935-fe0f", 320], ["1f470", 321], ["1f470-fe0f", 321], ["1f930", 322], ["1f930-fe0f", 322], ["1f931", 323], ["1f931-fe0f", 323], ["1f47c", 324], ["1f47c-fe0f", 324], ["1f385", 325], ["1f385-fe0f", 325], ["1f936", 326], ["1f936-fe0f", 326], ["1f9b8", 327], ["1f9b8-fe0f", 327], ["1f9b8-200d-2642-fe0f", 328], ["1f9b8-200d-2642", 328], ["1f9b8-200d-2640-fe0f", 329], ["1f9b8-200d-2640", 329], ["1f9b9", 330], ["1f9b9-fe0f", 330], ["1f9b9-200d-2642-fe0f", 331], ["1f9b9-200d-2642", 331], ["1f9b9-200d-2640-fe0f", 332], ["1f9b9-200d-2640", 332], ["1f9d9", 333], ["1f9d9-fe0f", 333], ["1f9d9-200d-2642-fe0f", 334], ["1f9d9-200d-2642", 334], ["1f9d9-200d-2640-fe0f", 335], ["1f9d9-200d-2640", 335], ["1f9da", 336], ["1f9da-fe0f", 336], ["1f9da-200d-2642-fe0f", 337], ["1f9da-200d-2642", 337], ["1f9da-200d-2640-fe0f", 338], ["1f9da-200d-2640", 338], ["1f9db", 339], ["1f9db-fe0f", 339], ["1f9db-200d-2642-fe0f", 340], ["1f9db-200d-2642", 340], ["1f9db-200d-2640-fe0f", 341], ["1f9db-200d-2640", 341], ["1f9dc", 342], ["1f9dc-fe0f", 342], ["1f9dc-200d-2642-fe0f", 343], ["1f9dc-200d-2642", 343], ["1f9dc-200d-2640-fe0f", 344], ["1f9dc-200d-2640", 344], ["1f9dd", 345], ["1f9dd-fe0f", 345], ["1f9dd-200d-2642-fe0f", 346], ["1f9dd-200d-2642", 346], ["1f9dd-200d-2640-fe0f", 347], ["1f9dd-200d-2640", 347], ["1f9de", 348], ["1f9de-fe0f", 348], ["1f9de-200d-2642-fe0f", 349], ["1f9de-200d-2642", 349], ["1f9de-200d-2640-fe0f", 350], ["1f9de-200d-2640", 350], ["1f9df", 351], ["1f9df-fe0f", 351], ["1f9df-200d-2642-fe0f", 352], ["1f9df-200d-2642", 352], ["1f9df-200d-2640-fe0f", 353], ["1f9df-200d-2640", 353], ["1f486", 354], ["1f486-fe0f", 354], ["1f486-200d-2642-fe0f", 355], ["1f486-200d-2642", 355], ["1f486-200d-2640-fe0f", 356], ["1f486-200d-2640", 356], ["1f487", 357], ["1f487-fe0f", 357], ["1f487-200d-2642-fe0f", 358], ["1f487-200d-2642", 358], ["1f487-200d-2640-fe0f", 359], ["1f487-200d-2640", 359], ["1f6b6", 360], ["1f6b6-fe0f", 360], ["1f6b6-200d-2642-fe0f", 361], ["1f6b6-200d-2642", 361], ["1f6b6-200d-2640-fe0f", 362], ["1f6b6-200d-2640", 362], ["1f9cd", 363], ["1f9cd-fe0f", 363], ["1f9cd-200d-2642-fe0f", 364], ["1f9cd-200d-2642", 364], ["1f9cd-200d-2640-fe0f", 365], ["1f9cd-200d-2640", 365], ["1f9ce", 366], ["1f9ce-fe0f", 366], ["1f9ce-200d-2642-fe0f", 367], ["1f9ce-200d-2642", 367], ["1f9ce-200d-2640-fe0f", 368], ["1f9ce-200d-2640", 368], ["1f9d1-200d-1f9af", 369], ["1f9d1-200d-1f9af-fe0f", 369], ["1f468-200d-1f9af", 370], ["1f468-200d-1f9af-fe0f", 370], ["1f469-200d-1f9af", 371], ["1f469-200d-1f9af-fe0f", 371], ["1f9d1-200d-1f9bc", 372], ["1f9d1-200d-1f9bc-fe0f", 372], ["1f468-200d-1f9bc", 373], ["1f468-200d-1f9bc-fe0f", 373], ["1f469-200d-1f9bc", 374], ["1f469-200d-1f9bc-fe0f", 374], ["1f9d1-200d-1f9bd", 375], ["1f9d1-200d-1f9bd-fe0f", 375], ["1f468-200d-1f9bd", 376], ["1f468-200d-1f9bd-fe0f", 376], ["1f469-200d-1f9bd", 377], ["1f469-200d-1f9bd-fe0f", 377], ["1f3c3", 378], ["1f3c3-fe0f", 378], ["1f3c3-200d-2642-fe0f", 379], ["1f3c3-200d-2642", 379], ["1f3c3-200d-2640-fe0f", 380], ["1f3c3-200d-2640", 380], ["1f483", 381], ["1f483-fe0f", 381], ["1f57a", 382], ["1f57a-fe0f", 382], ["1f574-fe0f", 383], ["1f574", 383], ["1f46f", 384], ["1f46f-fe0f", 384], ["1f46f-200d-2642-fe0f", 385], ["1f46f-200d-2642", 385], ["1f46f-200d-2640-fe0f", 386], ["1f46f-200d-2640", 386], ["1f9d6", 387], ["1f9d6-fe0f", 387], ["1f9d6-200d-2642-fe0f", 388], ["1f9d6-200d-2642", 388], ["1f9d6-200d-2640-fe0f", 389], ["1f9d6-200d-2640", 389], ["1f9d7", 390], ["1f9d7-fe0f", 390], ["1f9d7-200d-2642-fe0f", 391], ["1f9d7-200d-2642", 391], ["1f9d7-200d-2640-fe0f", 392], ["1f9d7-200d-2640", 392], ["1f93a", 393], ["1f93a-fe0f", 393], ["1f3c7", 394], ["1f3c7-fe0f", 394], ["26f7-fe0f", 395], ["26f7", 395], ["1f3c2", 396], ["1f3c2-fe0f", 396], ["1f3cc-fe0f", 397], ["1f3cc", 397], ["1f3cc-fe0f-200d-2642-fe0f", 398], ["1f3cc-200d-2642-fe0f", 398], ["1f3cc-fe0f-200d-2642", 398], ["1f3cc-200d-2642", 398], ["1f3cc-fe0f-200d-2640-fe0f", 399], ["1f3cc-200d-2640-fe0f", 399], ["1f3cc-fe0f-200d-2640", 399], ["1f3cc-200d-2640", 399], ["1f3c4", 400], ["1f3c4-fe0f", 400], ["1f3c4-200d-2642-fe0f", 401], ["1f3c4-200d-2642", 401], ["1f3c4-200d-2640-fe0f", 402], ["1f3c4-200d-2640", 402], ["1f6a3", 403], ["1f6a3-fe0f", 403], ["1f6a3-200d-2642-fe0f", 404], ["1f6a3-200d-2642", 404], ["1f6a3-200d-2640-fe0f", 405], ["1f6a3-200d-2640", 405], ["1f3ca", 406], ["1f3ca-fe0f", 406], ["1f3ca-200d-2642-fe0f", 407], ["1f3ca-200d-2642", 407], ["1f3ca-200d-2640-fe0f", 408], ["1f3ca-200d-2640", 408], ["26f9-fe0f", 409], ["26f9", 409], ["26f9-fe0f-200d-2642-fe0f", 410], ["26f9-200d-2642-fe0f", 410], ["26f9-fe0f-200d-2642", 410], ["26f9-200d-2642", 410], ["26f9-fe0f-200d-2640-fe0f", 411], ["26f9-200d-2640-fe0f", 411], ["26f9-fe0f-200d-2640", 411], ["26f9-200d-2640", 411], ["1f3cb-fe0f", 412], ["1f3cb", 412], ["1f3cb-fe0f-200d-2642-fe0f", 413], ["1f3cb-200d-2642-fe0f", 413], ["1f3cb-fe0f-200d-2642", 413], ["1f3cb-200d-2642", 413], ["1f3cb-fe0f-200d-2640-fe0f", 414], ["1f3cb-200d-2640-fe0f", 414], ["1f3cb-fe0f-200d-2640", 414], ["1f3cb-200d-2640", 414], ["1f6b4", 415], ["1f6b4-fe0f", 415], ["1f6b4-200d-2642-fe0f", 416], ["1f6b4-200d-2642", 416], ["1f6b4-200d-2640-fe0f", 417], ["1f6b4-200d-2640", 417], ["1f6b5", 418], ["1f6b5-fe0f", 418], ["1f6b5-200d-2642-fe0f", 419], ["1f6b5-200d-2642", 419], ["1f6b5-200d-2640-fe0f", 420], ["1f6b5-200d-2640", 420], ["1f938", 421], ["1f938-fe0f", 421], ["1f938-200d-2642-fe0f", 422], ["1f938-200d-2642", 422], ["1f938-200d-2640-fe0f", 423], ["1f938-200d-2640", 423], ["1f93c", 424], ["1f93c-fe0f", 424], ["1f93c-200d-2642-fe0f", 425], ["1f93c-200d-2642", 425], ["1f93c-200d-2640-fe0f", 426], ["1f93c-200d-2640", 426], ["1f93d", 427], ["1f93d-fe0f", 427], ["1f93d-200d-2642-fe0f", 428], ["1f93d-200d-2642", 428], ["1f93d-200d-2640-fe0f", 429], ["1f93d-200d-2640", 429], ["1f93e", 430], ["1f93e-fe0f", 430], ["1f93e-200d-2642-fe0f", 431], ["1f93e-200d-2642", 431], ["1f93e-200d-2640-fe0f", 432], ["1f93e-200d-2640", 432], ["1f939", 433], ["1f939-fe0f", 433], ["1f939-200d-2642-fe0f", 434], ["1f939-200d-2642", 434], ["1f939-200d-2640-fe0f", 435], ["1f939-200d-2640", 435], ["1f9d8", 436], ["1f9d8-fe0f", 436], ["1f9d8-200d-2642-fe0f", 437], ["1f9d8-200d-2642", 437], ["1f9d8-200d-2640-fe0f", 438], ["1f9d8-200d-2640", 438], ["1f6c0", 439], ["1f6c0-fe0f", 439], ["1f6cc", 440], ["1f6cc-fe0f", 440], ["1f9d1-200d-1f91d-200d-1f9d1", 441], ["1f9d1-200d-1f91d-200d-1f9d1-fe0f", 441], ["1f46d", 442], ["1f46d-fe0f", 442], ["1f46b", 443], ["1f46b-fe0f", 443], ["1f46c", 444], ["1f46c-fe0f", 444], ["1f48f", 445], ["1f48f-fe0f", 445], ["1f469-200d-2764-fe0f-200d-1f48b-200d-1f468", 446], ["1f469-200d-2764-200d-1f48b-200d-1f468", 446], ["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468", 447], ["1f468-200d-2764-200d-1f48b-200d-1f468", 447], ["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469", 448], ["1f469-200d-2764-200d-1f48b-200d-1f469", 448], ["1f491", 449], ["1f491-fe0f", 449], ["1f469-200d-2764-fe0f-200d-1f468", 450], ["1f469-200d-2764-200d-1f468", 450], ["1f468-200d-2764-fe0f-200d-1f468", 451], ["1f468-200d-2764-200d-1f468", 451], ["1f469-200d-2764-fe0f-200d-1f469", 452], ["1f469-200d-2764-200d-1f469", 452], ["1f46a", 453], ["1f46a-fe0f", 453], ["1f468-200d-1f469-200d-1f466", 454], ["1f468-200d-1f469-200d-1f466-fe0f", 454], ["1f468-200d-1f469-200d-1f467", 455], ["1f468-200d-1f469-200d-1f467-fe0f", 455], ["1f468-200d-1f469-200d-1f467-200d-1f466", 456], ["1f468-200d-1f469-200d-1f467-200d-1f466-fe0f", 456], ["1f468-200d-1f469-200d-1f466-200d-1f466", 457], ["1f468-200d-1f469-200d-1f466-200d-1f466-fe0f", 457], ["1f468-200d-1f469-200d-1f467-200d-1f467", 458], ["1f468-200d-1f469-200d-1f467-200d-1f467-fe0f", 458], ["1f468-200d-1f468-200d-1f466", 459], ["1f468-200d-1f468-200d-1f466-fe0f", 459], ["1f468-200d-1f468-200d-1f467", 460], ["1f468-200d-1f468-200d-1f467-fe0f", 460], ["1f468-200d-1f468-200d-1f467-200d-1f466", 461], ["1f468-200d-1f468-200d-1f467-200d-1f466-fe0f", 461], ["1f468-200d-1f468-200d-1f466-200d-1f466", 462], ["1f468-200d-1f468-200d-1f466-200d-1f466-fe0f", 462], ["1f468-200d-1f468-200d-1f467-200d-1f467", 463], ["1f468-200d-1f468-200d-1f467-200d-1f467-fe0f", 463], ["1f469-200d-1f469-200d-1f466", 464], ["1f469-200d-1f469-200d-1f466-fe0f", 464], ["1f469-200d-1f469-200d-1f467", 465], ["1f469-200d-1f469-200d-1f467-fe0f", 465], ["1f469-200d-1f469-200d-1f467-200d-1f466", 466], ["1f469-200d-1f469-200d-1f467-200d-1f466-fe0f", 466], ["1f469-200d-1f469-200d-1f466-200d-1f466", 467], ["1f469-200d-1f469-200d-1f466-200d-1f466-fe0f", 467], ["1f469-200d-1f469-200d-1f467-200d-1f467", 468], ["1f469-200d-1f469-200d-1f467-200d-1f467-fe0f", 468], ["1f468-200d-1f466", 469], ["1f468-200d-1f466-fe0f", 469], ["1f468-200d-1f466-200d-1f466", 470], ["1f468-200d-1f466-200d-1f466-fe0f", 470], ["1f468-200d-1f467", 471], ["1f468-200d-1f467-fe0f", 471], ["1f468-200d-1f467-200d-1f466", 472], ["1f468-200d-1f467-200d-1f466-fe0f", 472], ["1f468-200d-1f467-200d-1f467", 473], ["1f468-200d-1f467-200d-1f467-fe0f", 473], ["1f469-200d-1f466", 474], ["1f469-200d-1f466-fe0f", 474], ["1f469-200d-1f466-200d-1f466", 475], ["1f469-200d-1f466-200d-1f466-fe0f", 475], ["1f469-200d-1f467", 476], ["1f469-200d-1f467-fe0f", 476], ["1f469-200d-1f467-200d-1f466", 477], ["1f469-200d-1f467-200d-1f466-fe0f", 477], ["1f469-200d-1f467-200d-1f467", 478], ["1f469-200d-1f467-200d-1f467-fe0f", 478], ["1f5e3-fe0f", 479], ["1f5e3", 479], ["1f464", 480], ["1f464-fe0f", 480], ["1f465", 481], ["1f465-fe0f", 481], ["1f463", 482], ["1f463-fe0f", 482], ["1f435", 483], ["1f435-fe0f", 483], ["1f412", 484], ["1f412-fe0f", 484], ["1f98d", 485], ["1f98d-fe0f", 485], ["1f9a7", 486], ["1f9a7-fe0f", 486], ["1f436", 487], ["1f436-fe0f", 487], ["1f415", 488], ["1f415-fe0f", 488], ["1f9ae", 489], ["1f9ae-fe0f", 489], ["1f415-200d-1f9ba", 490], ["1f415-200d-1f9ba-fe0f", 490], ["1f429", 491], ["1f429-fe0f", 491], ["1f43a", 492], ["1f43a-fe0f", 492], ["1f98a", 493], ["1f98a-fe0f", 493], ["1f99d", 494], ["1f99d-fe0f", 494], ["1f431", 495], ["1f431-fe0f", 495], ["1f408", 496], ["1f408-fe0f", 496], ["1f981", 497], ["1f981-fe0f", 497], ["1f42f", 498], ["1f42f-fe0f", 498], ["1f405", 499], ["1f405-fe0f", 499], ["1f406", 500], ["1f406-fe0f", 500], ["1f434", 501], ["1f434-fe0f", 501], ["1f40e", 502], ["1f40e-fe0f", 502], ["1f984", 503], ["1f984-fe0f", 503], ["1f993", 504], ["1f993-fe0f", 504], ["1f98c", 505], ["1f98c-fe0f", 505], ["1f42e", 506], ["1f42e-fe0f", 506], ["1f402", 507], ["1f402-fe0f", 507], ["1f403", 508], ["1f403-fe0f", 508], ["1f404", 509], ["1f404-fe0f", 509], ["1f437", 510], ["1f437-fe0f", 510], ["1f416", 511], ["1f416-fe0f", 511], ["1f417", 512], ["1f417-fe0f", 512], ["1f43d", 513], ["1f43d-fe0f", 513], ["1f40f", 514], ["1f40f-fe0f", 514], ["1f411", 515], ["1f411-fe0f", 515], ["1f410", 516], ["1f410-fe0f", 516], ["1f42a", 517], ["1f42a-fe0f", 517], ["1f42b", 518], ["1f42b-fe0f", 518], ["1f999", 519], ["1f999-fe0f", 519], ["1f992", 520], ["1f992-fe0f", 520], ["1f418", 521], ["1f418-fe0f", 521], ["1f98f", 522], ["1f98f-fe0f", 522], ["1f99b", 523], ["1f99b-fe0f", 523], ["1f42d", 524], ["1f42d-fe0f", 524], ["1f401", 525], ["1f401-fe0f", 525], ["1f400", 526], ["1f400-fe0f", 526], ["1f439", 527], ["1f439-fe0f", 527], ["1f430", 528], ["1f430-fe0f", 528], ["1f407", 529], ["1f407-fe0f", 529], ["1f43f-fe0f", 530], ["1f43f", 530], ["1f994", 531], ["1f994-fe0f", 531], ["1f987", 532], ["1f987-fe0f", 532], ["1f43b", 533], ["1f43b-fe0f", 533], ["1f428", 534], ["1f428-fe0f", 534], ["1f43c", 535], ["1f43c-fe0f", 535], ["1f9a5", 536], ["1f9a5-fe0f", 536], ["1f9a6", 537], ["1f9a6-fe0f", 537], ["1f9a8", 538], ["1f9a8-fe0f", 538], ["1f998", 539], ["1f998-fe0f", 539], ["1f9a1", 540], ["1f9a1-fe0f", 540], ["1f43e", 541], ["1f43e-fe0f", 541], ["1f983", 542], ["1f983-fe0f", 542], ["1f414", 543], ["1f414-fe0f", 543], ["1f413", 544], ["1f413-fe0f", 544], ["1f423", 545], ["1f423-fe0f", 545], ["1f424", 546], ["1f424-fe0f", 546], ["1f425", 547], ["1f425-fe0f", 547], ["1f426", 548], ["1f426-fe0f", 548], ["1f427", 549], ["1f427-fe0f", 549], ["1f54a-fe0f", 550], ["1f54a", 550], ["1f985", 551], ["1f985-fe0f", 551], ["1f986", 552], ["1f986-fe0f", 552], ["1f9a2", 553], ["1f9a2-fe0f", 553], ["1f989", 554], ["1f989-fe0f", 554], ["1f9a9", 555], ["1f9a9-fe0f", 555], ["1f99a", 556], ["1f99a-fe0f", 556], ["1f99c", 557], ["1f99c-fe0f", 557], ["1f438", 558], ["1f438-fe0f", 558], ["1f40a", 559], ["1f40a-fe0f", 559], ["1f422", 560], ["1f422-fe0f", 560], ["1f98e", 561], ["1f98e-fe0f", 561], ["1f40d", 562], ["1f40d-fe0f", 562], ["1f432", 563], ["1f432-fe0f", 563], ["1f409", 564], ["1f409-fe0f", 564], ["1f995", 565], ["1f995-fe0f", 565], ["1f996", 566], ["1f996-fe0f", 566], ["1f433", 567], ["1f433-fe0f", 567], ["1f40b", 568], ["1f40b-fe0f", 568], ["1f42c", 569], ["1f42c-fe0f", 569], ["1f41f", 570], ["1f41f-fe0f", 570], ["1f420", 571], ["1f420-fe0f", 571], ["1f421", 572], ["1f421-fe0f", 572], ["1f988", 573], ["1f988-fe0f", 573], ["1f419", 574], ["1f419-fe0f", 574], ["1f41a", 575], ["1f41a-fe0f", 575], ["1f40c", 576], ["1f40c-fe0f", 576], ["1f98b", 577], ["1f98b-fe0f", 577], ["1f41b", 578], ["1f41b-fe0f", 578], ["1f41c", 579], ["1f41c-fe0f", 579], ["1f41d", 580], ["1f41d-fe0f", 580], ["1f41e", 581], ["1f41e-fe0f", 581], ["1f997", 582], ["1f997-fe0f", 582], ["1f577-fe0f", 583], ["1f577", 583], ["1f578-fe0f", 584], ["1f578", 584], ["1f982", 585], ["1f982-fe0f", 585], ["1f99f", 586], ["1f99f-fe0f", 586], ["1f9a0", 587], ["1f9a0-fe0f", 587], ["1f490", 588], ["1f490-fe0f", 588], ["1f338", 589], ["1f338-fe0f", 589], ["1f4ae", 590], ["1f4ae-fe0f", 590], ["1f3f5-fe0f", 591], ["1f3f5", 591], ["1f339", 592], ["1f339-fe0f", 592], ["1f940", 593], ["1f940-fe0f", 593], ["1f33a", 594], ["1f33a-fe0f", 594], ["1f33b", 595], ["1f33b-fe0f", 595], ["1f33c", 596], ["1f33c-fe0f", 596], ["1f337", 597], ["1f337-fe0f", 597], ["1f331", 598], ["1f331-fe0f", 598], ["1f332", 599], ["1f332-fe0f", 599], ["1f333", 600], ["1f333-fe0f", 600], ["1f334", 601], ["1f334-fe0f", 601], ["1f335", 602], ["1f335-fe0f", 602], ["1f33e", 603], ["1f33e-fe0f", 603], ["1f33f", 604], ["1f33f-fe0f", 604], ["2618-fe0f", 605], ["2618", 605], ["1f340", 606], ["1f340-fe0f", 606], ["1f341", 607], ["1f341-fe0f", 607], ["1f342", 608], ["1f342-fe0f", 608], ["1f343", 609], ["1f343-fe0f", 609], ["1f347", 610], ["1f347-fe0f", 610], ["1f348", 611], ["1f348-fe0f", 611], ["1f349", 612], ["1f349-fe0f", 612], ["1f34a", 613], ["1f34a-fe0f", 613], ["1f34b", 614], ["1f34b-fe0f", 614], ["1f34c", 615], ["1f34c-fe0f", 615], ["1f34d", 616], ["1f34d-fe0f", 616], ["1f96d", 617], ["1f96d-fe0f", 617], ["1f34e", 618], ["1f34e-fe0f", 618], ["1f34f", 619], ["1f34f-fe0f", 619], ["1f350", 620], ["1f350-fe0f", 620], ["1f351", 621], ["1f351-fe0f", 621], ["1f352", 622], ["1f352-fe0f", 622], ["1f353", 623], ["1f353-fe0f", 623], ["1f95d", 624], ["1f95d-fe0f", 624], ["1f345", 625], ["1f345-fe0f", 625], ["1f965", 626], ["1f965-fe0f", 626], ["1f951", 627], ["1f951-fe0f", 627], ["1f346", 628], ["1f346-fe0f", 628], ["1f954", 629], ["1f954-fe0f", 629], ["1f955", 630], ["1f955-fe0f", 630], ["1f33d", 631], ["1f33d-fe0f", 631], ["1f336-fe0f", 632], ["1f336", 632], ["1f952", 633], ["1f952-fe0f", 633], ["1f96c", 634], ["1f96c-fe0f", 634], ["1f966", 635], ["1f966-fe0f", 635], ["1f9c4", 636], ["1f9c4-fe0f", 636], ["1f9c5", 637], ["1f9c5-fe0f", 637], ["1f344", 638], ["1f344-fe0f", 638], ["1f95c", 639], ["1f95c-fe0f", 639], ["1f330", 640], ["1f330-fe0f", 640], ["1f35e", 641], ["1f35e-fe0f", 641], ["1f950", 642], ["1f950-fe0f", 642], ["1f956", 643], ["1f956-fe0f", 643], ["1f968", 644], ["1f968-fe0f", 644], ["1f96f", 645], ["1f96f-fe0f", 645], ["1f95e", 646], ["1f95e-fe0f", 646], ["1f9c7", 647], ["1f9c7-fe0f", 647], ["1f9c0", 648], ["1f9c0-fe0f", 648], ["1f356", 649], ["1f356-fe0f", 649], ["1f357", 650], ["1f357-fe0f", 650], ["1f969", 651], ["1f969-fe0f", 651], ["1f953", 652], ["1f953-fe0f", 652], ["1f354", 653], ["1f354-fe0f", 653], ["1f35f", 654], ["1f35f-fe0f", 654], ["1f355", 655], ["1f355-fe0f", 655], ["1f32d", 656], ["1f32d-fe0f", 656], ["1f96a", 657], ["1f96a-fe0f", 657], ["1f32e", 658], ["1f32e-fe0f", 658], ["1f32f", 659], ["1f32f-fe0f", 659], ["1f959", 660], ["1f959-fe0f", 660], ["1f9c6", 661], ["1f9c6-fe0f", 661], ["1f95a", 662], ["1f95a-fe0f", 662], ["1f373", 663], ["1f373-fe0f", 663], ["1f958", 664], ["1f958-fe0f", 664], ["1f372", 665], ["1f372-fe0f", 665], ["1f963", 666], ["1f963-fe0f", 666], ["1f957", 667], ["1f957-fe0f", 667], ["1f37f", 668], ["1f37f-fe0f", 668], ["1f9c8", 669], ["1f9c8-fe0f", 669], ["1f9c2", 670], ["1f9c2-fe0f", 670], ["1f96b", 671], ["1f96b-fe0f", 671], ["1f371", 672], ["1f371-fe0f", 672], ["1f358", 673], ["1f358-fe0f", 673], ["1f359", 674], ["1f359-fe0f", 674], ["1f35a", 675], ["1f35a-fe0f", 675], ["1f35b", 676], ["1f35b-fe0f", 676], ["1f35c", 677], ["1f35c-fe0f", 677], ["1f35d", 678], ["1f35d-fe0f", 678], ["1f360", 679], ["1f360-fe0f", 679], ["1f362", 680], ["1f362-fe0f", 680], ["1f363", 681], ["1f363-fe0f", 681], ["1f364", 682], ["1f364-fe0f", 682], ["1f365", 683], ["1f365-fe0f", 683], ["1f96e", 684], ["1f96e-fe0f", 684], ["1f361", 685], ["1f361-fe0f", 685], ["1f95f", 686], ["1f95f-fe0f", 686], ["1f960", 687], ["1f960-fe0f", 687], ["1f961", 688], ["1f961-fe0f", 688], ["1f980", 689], ["1f980-fe0f", 689], ["1f99e", 690], ["1f99e-fe0f", 690], ["1f990", 691], ["1f990-fe0f", 691], ["1f991", 692], ["1f991-fe0f", 692], ["1f9aa", 693], ["1f9aa-fe0f", 693], ["1f366", 694], ["1f366-fe0f", 694], ["1f367", 695], ["1f367-fe0f", 695], ["1f368", 696], ["1f368-fe0f", 696], ["1f369", 697], ["1f369-fe0f", 697], ["1f36a", 698], ["1f36a-fe0f", 698], ["1f382", 699], ["1f382-fe0f", 699], ["1f370", 700], ["1f370-fe0f", 700], ["1f9c1", 701], ["1f9c1-fe0f", 701], ["1f967", 702], ["1f967-fe0f", 702], ["1f36b", 703], ["1f36b-fe0f", 703], ["1f36c", 704], ["1f36c-fe0f", 704], ["1f36d", 705], ["1f36d-fe0f", 705], ["1f36e", 706], ["1f36e-fe0f", 706], ["1f36f", 707], ["1f36f-fe0f", 707], ["1f37c", 708], ["1f37c-fe0f", 708], ["1f95b", 709], ["1f95b-fe0f", 709], ["2615", 710], ["2615-fe0f", 710], ["1f375", 711], ["1f375-fe0f", 711], ["1f376", 712], ["1f376-fe0f", 712], ["1f37e", 713], ["1f37e-fe0f", 713], ["1f377", 714], ["1f377-fe0f", 714], ["1f378", 715], ["1f378-fe0f", 715], ["1f379", 716], ["1f379-fe0f", 716], ["1f37a", 717], ["1f37a-fe0f", 717], ["1f37b", 718], ["1f37b-fe0f", 718], ["1f942", 719], ["1f942-fe0f", 719], ["1f943", 720], ["1f943-fe0f", 720], ["1f964", 721], ["1f964-fe0f", 721], ["1f9c3", 722], ["1f9c3-fe0f", 722], ["1f9c9", 723], ["1f9c9-fe0f", 723], ["1f9ca", 724], ["1f9ca-fe0f", 724], ["1f962", 725], ["1f962-fe0f", 725], ["1f37d-fe0f", 726], ["1f37d", 726], ["1f374", 727], ["1f374-fe0f", 727], ["1f944", 728], ["1f944-fe0f", 728], ["1f52a", 729], ["1f52a-fe0f", 729], ["1f3fa", 730], ["1f3fa-fe0f", 730], ["1f30d", 731], ["1f30d-fe0f", 731], ["1f30e", 732], ["1f30e-fe0f", 732], ["1f30f", 733], ["1f30f-fe0f", 733], ["1f310", 734], ["1f310-fe0f", 734], ["1f5fa-fe0f", 735], ["1f5fa", 735], ["1f5fe", 736], ["1f5fe-fe0f", 736], ["1f9ed", 737], ["1f9ed-fe0f", 737], ["1f3d4-fe0f", 738], ["1f3d4", 738], ["26f0-fe0f", 739], ["26f0", 739], ["1f30b", 740], ["1f30b-fe0f", 740], ["1f5fb", 741], ["1f5fb-fe0f", 741], ["1f3d5-fe0f", 742], ["1f3d5", 742], ["1f3d6-fe0f", 743], ["1f3d6", 743], ["1f3dc-fe0f", 744], ["1f3dc", 744], ["1f3dd-fe0f", 745], ["1f3dd", 745], ["1f3de-fe0f", 746], ["1f3de", 746], ["1f3df-fe0f", 747], ["1f3df", 747], ["1f3db-fe0f", 748], ["1f3db", 748], ["1f3d7-fe0f", 749], ["1f3d7", 749], ["1f9f1", 750], ["1f9f1-fe0f", 750], ["1f3d8-fe0f", 751], ["1f3d8", 751], ["1f3da-fe0f", 752], ["1f3da", 752], ["1f3e0", 753], ["1f3e0-fe0f", 753], ["1f3e1", 754], ["1f3e1-fe0f", 754], ["1f3e2", 755], ["1f3e2-fe0f", 755], ["1f3e3", 756], ["1f3e3-fe0f", 756], ["1f3e4", 757], ["1f3e4-fe0f", 757], ["1f3e5", 758], ["1f3e5-fe0f", 758], ["1f3e6", 759], ["1f3e6-fe0f", 759], ["1f3e8", 760], ["1f3e8-fe0f", 760], ["1f3e9", 761], ["1f3e9-fe0f", 761], ["1f3ea", 762], ["1f3ea-fe0f", 762], ["1f3eb", 763], ["1f3eb-fe0f", 763], ["1f3ec", 764], ["1f3ec-fe0f", 764], ["1f3ed", 765], ["1f3ed-fe0f", 765], ["1f3ef", 766], ["1f3ef-fe0f", 766], ["1f3f0", 767], ["1f3f0-fe0f", 767], ["1f492", 768], ["1f492-fe0f", 768], ["1f5fc", 769], ["1f5fc-fe0f", 769], ["1f5fd", 770], ["1f5fd-fe0f", 770], ["26ea", 771], ["26ea-fe0f", 771], ["1f54c", 772], ["1f54c-fe0f", 772], ["1f6d5", 773], ["1f6d5-fe0f", 773], ["1f54d", 774], ["1f54d-fe0f", 774], ["26e9-fe0f", 775], ["26e9", 775], ["1f54b", 776], ["1f54b-fe0f", 776], ["26f2", 777], ["26f2-fe0f", 777], ["26fa", 778], ["26fa-fe0f", 778], ["1f301", 779], ["1f301-fe0f", 779], ["1f303", 780], ["1f303-fe0f", 780], ["1f3d9-fe0f", 781], ["1f3d9", 781], ["1f304", 782], ["1f304-fe0f", 782], ["1f305", 783], ["1f305-fe0f", 783], ["1f306", 784], ["1f306-fe0f", 784], ["1f307", 785], ["1f307-fe0f", 785], ["1f309", 786], ["1f309-fe0f", 786], ["2668-fe0f", 787], ["2668", 787], ["1f3a0", 788], ["1f3a0-fe0f", 788], ["1f3a1", 789], ["1f3a1-fe0f", 789], ["1f3a2", 790], ["1f3a2-fe0f", 790], ["1f488", 791], ["1f488-fe0f", 791], ["1f3aa", 792], ["1f3aa-fe0f", 792], ["1f682", 793], ["1f682-fe0f", 793], ["1f683", 794], ["1f683-fe0f", 794], ["1f684", 795], ["1f684-fe0f", 795], ["1f685", 796], ["1f685-fe0f", 796], ["1f686", 797], ["1f686-fe0f", 797], ["1f687", 798], ["1f687-fe0f", 798], ["1f688", 799], ["1f688-fe0f", 799], ["1f689", 800], ["1f689-fe0f", 800], ["1f68a", 801], ["1f68a-fe0f", 801], ["1f69d", 802], ["1f69d-fe0f", 802], ["1f69e", 803], ["1f69e-fe0f", 803], ["1f68b", 804], ["1f68b-fe0f", 804], ["1f68c", 805], ["1f68c-fe0f", 805], ["1f68d", 806], ["1f68d-fe0f", 806], ["1f68e", 807], ["1f68e-fe0f", 807], ["1f690", 808], ["1f690-fe0f", 808], ["1f691", 809], ["1f691-fe0f", 809], ["1f692", 810], ["1f692-fe0f", 810], ["1f693", 811], ["1f693-fe0f", 811], ["1f694", 812], ["1f694-fe0f", 812], ["1f695", 813], ["1f695-fe0f", 813], ["1f696", 814], ["1f696-fe0f", 814], ["1f697", 815], ["1f697-fe0f", 815], ["1f698", 816], ["1f698-fe0f", 816], ["1f699", 817], ["1f699-fe0f", 817], ["1f69a", 818], ["1f69a-fe0f", 818], ["1f69b", 819], ["1f69b-fe0f", 819], ["1f69c", 820], ["1f69c-fe0f", 820], ["1f3ce-fe0f", 821], ["1f3ce", 821], ["1f3cd-fe0f", 822], ["1f3cd", 822], ["1f6f5", 823], ["1f6f5-fe0f", 823], ["1f9bd", 824], ["1f9bd-fe0f", 824], ["1f9bc", 825], ["1f9bc-fe0f", 825], ["1f6fa", 826], ["1f6fa-fe0f", 826], ["1f6b2", 827], ["1f6b2-fe0f", 827], ["1f6f4", 828], ["1f6f4-fe0f", 828], ["1f6f9", 829], ["1f6f9-fe0f", 829], ["1f68f", 830], ["1f68f-fe0f", 830], ["1f6e3-fe0f", 831], ["1f6e3", 831], ["1f6e4-fe0f", 832], ["1f6e4", 832], ["1f6e2-fe0f", 833], ["1f6e2", 833], ["26fd", 834], ["26fd-fe0f", 834], ["1f6a8", 835], ["1f6a8-fe0f", 835], ["1f6a5", 836], ["1f6a5-fe0f", 836], ["1f6a6", 837], ["1f6a6-fe0f", 837], ["1f6d1", 838], ["1f6d1-fe0f", 838], ["1f6a7", 839], ["1f6a7-fe0f", 839], ["2693", 840], ["2693-fe0f", 840], ["26f5", 841], ["26f5-fe0f", 841], ["1f6f6", 842], ["1f6f6-fe0f", 842], ["1f6a4", 843], ["1f6a4-fe0f", 843], ["1f6f3-fe0f", 844], ["1f6f3", 844], ["26f4-fe0f", 845], ["26f4", 845], ["1f6e5-fe0f", 846], ["1f6e5", 846], ["1f6a2", 847], ["1f6a2-fe0f", 847], ["2708-fe0f", 848], ["2708", 848], ["1f6e9-fe0f", 849], ["1f6e9", 849], ["1f6eb", 850], ["1f6eb-fe0f", 850], ["1f6ec", 851], ["1f6ec-fe0f", 851], ["1fa82", 852], ["1fa82-fe0f", 852], ["1f4ba", 853], ["1f4ba-fe0f", 853], ["1f681", 854], ["1f681-fe0f", 854], ["1f69f", 855], ["1f69f-fe0f", 855], ["1f6a0", 856], ["1f6a0-fe0f", 856], ["1f6a1", 857], ["1f6a1-fe0f", 857], ["1f6f0-fe0f", 858], ["1f6f0", 858], ["1f680", 859], ["1f680-fe0f", 859], ["1f6f8", 860], ["1f6f8-fe0f", 860], ["1f6ce-fe0f", 861], ["1f6ce", 861], ["1f9f3", 862], ["1f9f3-fe0f", 862], ["231b", 863], ["231b-fe0f", 863], ["23f3", 864], ["23f3-fe0f", 864], ["231a", 865], ["231a-fe0f", 865], ["23f0", 866], ["23f0-fe0f", 866], ["23f1-fe0f", 867], ["23f1", 867], ["23f2-fe0f", 868], ["23f2", 868], ["1f570-fe0f", 869], ["1f570", 869], ["1f55b", 870], ["1f55b-fe0f", 870], ["1f567", 871], ["1f567-fe0f", 871], ["1f550", 872], ["1f550-fe0f", 872], ["1f55c", 873], ["1f55c-fe0f", 873], ["1f551", 874], ["1f551-fe0f", 874], ["1f55d", 875], ["1f55d-fe0f", 875], ["1f552", 876], ["1f552-fe0f", 876], ["1f55e", 877], ["1f55e-fe0f", 877], ["1f553", 878], ["1f553-fe0f", 878], ["1f55f", 879], ["1f55f-fe0f", 879], ["1f554", 880], ["1f554-fe0f", 880], ["1f560", 881], ["1f560-fe0f", 881], ["1f555", 882], ["1f555-fe0f", 882], ["1f561", 883], ["1f561-fe0f", 883], ["1f556", 884], ["1f556-fe0f", 884], ["1f562", 885], ["1f562-fe0f", 885], ["1f557", 886], ["1f557-fe0f", 886], ["1f563", 887], ["1f563-fe0f", 887], ["1f558", 888], ["1f558-fe0f", 888], ["1f564", 889], ["1f564-fe0f", 889], ["1f559", 890], ["1f559-fe0f", 890], ["1f565", 891], ["1f565-fe0f", 891], ["1f55a", 892], ["1f55a-fe0f", 892], ["1f566", 893], ["1f566-fe0f", 893], ["1f311", 894], ["1f311-fe0f", 894], ["1f312", 895], ["1f312-fe0f", 895], ["1f313", 896], ["1f313-fe0f", 896], ["1f314", 897], ["1f314-fe0f", 897], ["1f315", 898], ["1f315-fe0f", 898], ["1f316", 899], ["1f316-fe0f", 899], ["1f317", 900], ["1f317-fe0f", 900], ["1f318", 901], ["1f318-fe0f", 901], ["1f319", 902], ["1f319-fe0f", 902], ["1f31a", 903], ["1f31a-fe0f", 903], ["1f31b", 904], ["1f31b-fe0f", 904], ["1f31c", 905], ["1f31c-fe0f", 905], ["1f321-fe0f", 906], ["1f321", 906], ["2600-fe0f", 907], ["2600", 907], ["1f31d", 908], ["1f31d-fe0f", 908], ["1f31e", 909], ["1f31e-fe0f", 909], ["1fa90", 910], ["1fa90-fe0f", 910], ["2b50", 911], ["2b50-fe0f", 911], ["1f31f", 912], ["1f31f-fe0f", 912], ["1f320", 913], ["1f320-fe0f", 913], ["1f30c", 914], ["1f30c-fe0f", 914], ["2601-fe0f", 915], ["2601", 915], ["26c5", 916], ["26c5-fe0f", 916], ["26c8-fe0f", 917], ["26c8", 917], ["1f324-fe0f", 918], ["1f324", 918], ["1f325-fe0f", 919], ["1f325", 919], ["1f326-fe0f", 920], ["1f326", 920], ["1f327-fe0f", 921], ["1f327", 921], ["1f328-fe0f", 922], ["1f328", 922], ["1f329-fe0f", 923], ["1f329", 923], ["1f32a-fe0f", 924], ["1f32a", 924], ["1f32b-fe0f", 925], ["1f32b", 925], ["1f32c-fe0f", 926], ["1f32c", 926], ["1f300", 927], ["1f300-fe0f", 927], ["1f308", 928], ["1f308-fe0f", 928], ["1f302", 929], ["1f302-fe0f", 929], ["2602-fe0f", 930], ["2602", 930], ["2614", 931], ["2614-fe0f", 931], ["26f1-fe0f", 932], ["26f1", 932], ["26a1", 933], ["26a1-fe0f", 933], ["2744-fe0f", 934], ["2744", 934], ["2603-fe0f", 935], ["2603", 935], ["26c4", 936], ["26c4-fe0f", 936], ["2604-fe0f", 937], ["2604", 937], ["1f525", 938], ["1f525-fe0f", 938], ["1f4a7", 939], ["1f4a7-fe0f", 939], ["1f30a", 940], ["1f30a-fe0f", 940], ["1f383", 941], ["1f383-fe0f", 941], ["1f384", 942], ["1f384-fe0f", 942], ["1f386", 943], ["1f386-fe0f", 943], ["1f387", 944], ["1f387-fe0f", 944], ["1f9e8", 945], ["1f9e8-fe0f", 945], ["2728", 946], ["2728-fe0f", 946], ["1f388", 947], ["1f388-fe0f", 947], ["1f389", 948], ["1f389-fe0f", 948], ["1f38a", 949], ["1f38a-fe0f", 949], ["1f38b", 950], ["1f38b-fe0f", 950], ["1f38d", 951], ["1f38d-fe0f", 951], ["1f38e", 952], ["1f38e-fe0f", 952], ["1f38f", 953], ["1f38f-fe0f", 953], ["1f390", 954], ["1f390-fe0f", 954], ["1f391", 955], ["1f391-fe0f", 955], ["1f9e7", 956], ["1f9e7-fe0f", 956], ["1f380", 957], ["1f380-fe0f", 957], ["1f381", 958], ["1f381-fe0f", 958], ["1f397-fe0f", 959], ["1f397", 959], ["1f39f-fe0f", 960], ["1f39f", 960], ["1f3ab", 961], ["1f3ab-fe0f", 961], ["1f396-fe0f", 962], ["1f396", 962], ["1f3c6", 963], ["1f3c6-fe0f", 963], ["1f3c5", 964], ["1f3c5-fe0f", 964], ["1f947", 965], ["1f947-fe0f", 965], ["1f948", 966], ["1f948-fe0f", 966], ["1f949", 967], ["1f949-fe0f", 967], ["26bd", 968], ["26bd-fe0f", 968], ["26be", 969], ["26be-fe0f", 969], ["1f94e", 970], ["1f94e-fe0f", 970], ["1f3c0", 971], ["1f3c0-fe0f", 971], ["1f3d0", 972], ["1f3d0-fe0f", 972], ["1f3c8", 973], ["1f3c8-fe0f", 973], ["1f3c9", 974], ["1f3c9-fe0f", 974], ["1f3be", 975], ["1f3be-fe0f", 975], ["1f94f", 976], ["1f94f-fe0f", 976], ["1f3b3", 977], ["1f3b3-fe0f", 977], ["1f3cf", 978], ["1f3cf-fe0f", 978], ["1f3d1", 979], ["1f3d1-fe0f", 979], ["1f3d2", 980], ["1f3d2-fe0f", 980], ["1f94d", 981], ["1f94d-fe0f", 981], ["1f3d3", 982], ["1f3d3-fe0f", 982], ["1f3f8", 983], ["1f3f8-fe0f", 983], ["1f94a", 984], ["1f94a-fe0f", 984], ["1f94b", 985], ["1f94b-fe0f", 985], ["1f945", 986], ["1f945-fe0f", 986], ["26f3", 987], ["26f3-fe0f", 987], ["26f8-fe0f", 988], ["26f8", 988], ["1f3a3", 989], ["1f3a3-fe0f", 989], ["1f93f", 990], ["1f93f-fe0f", 990], ["1f3bd", 991], ["1f3bd-fe0f", 991], ["1f3bf", 992], ["1f3bf-fe0f", 992], ["1f6f7", 993], ["1f6f7-fe0f", 993], ["1f94c", 994], ["1f94c-fe0f", 994], ["1f3af", 995], ["1f3af-fe0f", 995], ["1fa80", 996], ["1fa80-fe0f", 996], ["1fa81", 997], ["1fa81-fe0f", 997], ["1f3b1", 998], ["1f3b1-fe0f", 998], ["1f52e", 999], ["1f52e-fe0f", 999], ["1f9ff", 1000], ["1f9ff-fe0f", 1000], ["1f3ae", 1001], ["1f3ae-fe0f", 1001], ["1f579-fe0f", 1002], ["1f579", 1002], ["1f3b0", 1003], ["1f3b0-fe0f", 1003], ["1f3b2", 1004], ["1f3b2-fe0f", 1004], ["1f9e9", 1005], ["1f9e9-fe0f", 1005], ["1f9f8", 1006], ["1f9f8-fe0f", 1006], ["2660-fe0f", 1007], ["2660", 1007], ["2665-fe0f", 1008], ["2665", 1008], ["2666-fe0f", 1009], ["2666", 1009], ["2663-fe0f", 1010], ["2663", 1010], ["265f-fe0f", 1011], ["265f", 1011], ["1f0cf", 1012], ["1f0cf-fe0f", 1012], ["1f004", 1013], ["1f004-fe0f", 1013], ["1f3b4", 1014], ["1f3b4-fe0f", 1014], ["1f3ad", 1015], ["1f3ad-fe0f", 1015], ["1f5bc-fe0f", 1016], ["1f5bc", 1016], ["1f3a8", 1017], ["1f3a8-fe0f", 1017], ["1f9f5", 1018], ["1f9f5-fe0f", 1018], ["1f9f6", 1019], ["1f9f6-fe0f", 1019], ["1f453", 1020], ["1f453-fe0f", 1020], ["1f576-fe0f", 1021], ["1f576", 1021], ["1f97d", 1022], ["1f97d-fe0f", 1022], ["1f97c", 1023], ["1f97c-fe0f", 1023], ["1f9ba", 1024], ["1f9ba-fe0f", 1024], ["1f454", 1025], ["1f454-fe0f", 1025], ["1f455", 1026], ["1f455-fe0f", 1026], ["1f456", 1027], ["1f456-fe0f", 1027], ["1f9e3", 1028], ["1f9e3-fe0f", 1028], ["1f9e4", 1029], ["1f9e4-fe0f", 1029], ["1f9e5", 1030], ["1f9e5-fe0f", 1030], ["1f9e6", 1031], ["1f9e6-fe0f", 1031], ["1f457", 1032], ["1f457-fe0f", 1032], ["1f458", 1033], ["1f458-fe0f", 1033], ["1f97b", 1034], ["1f97b-fe0f", 1034], ["1fa71", 1035], ["1fa71-fe0f", 1035], ["1fa72", 1036], ["1fa72-fe0f", 1036], ["1fa73", 1037], ["1fa73-fe0f", 1037], ["1f459", 1038], ["1f459-fe0f", 1038], ["1f45a", 1039], ["1f45a-fe0f", 1039], ["1f45b", 1040], ["1f45b-fe0f", 1040], ["1f45c", 1041], ["1f45c-fe0f", 1041], ["1f45d", 1042], ["1f45d-fe0f", 1042], ["1f6cd-fe0f", 1043], ["1f6cd", 1043], ["1f392", 1044], ["1f392-fe0f", 1044], ["1f45e", 1045], ["1f45e-fe0f", 1045], ["1f45f", 1046], ["1f45f-fe0f", 1046], ["1f97e", 1047], ["1f97e-fe0f", 1047], ["1f97f", 1048], ["1f97f-fe0f", 1048], ["1f460", 1049], ["1f460-fe0f", 1049], ["1f461", 1050], ["1f461-fe0f", 1050], ["1fa70", 1051], ["1fa70-fe0f", 1051], ["1f462", 1052], ["1f462-fe0f", 1052], ["1f451", 1053], ["1f451-fe0f", 1053], ["1f452", 1054], ["1f452-fe0f", 1054], ["1f3a9", 1055], ["1f3a9-fe0f", 1055], ["1f393", 1056], ["1f393-fe0f", 1056], ["1f9e2", 1057], ["1f9e2-fe0f", 1057], ["26d1-fe0f", 1058], ["26d1", 1058], ["1f4ff", 1059], ["1f4ff-fe0f", 1059], ["1f484", 1060], ["1f484-fe0f", 1060], ["1f48d", 1061], ["1f48d-fe0f", 1061], ["1f48e", 1062], ["1f48e-fe0f", 1062], ["1f507", 1063], ["1f507-fe0f", 1063], ["1f508", 1064], ["1f508-fe0f", 1064], ["1f509", 1065], ["1f509-fe0f", 1065], ["1f50a", 1066], ["1f50a-fe0f", 1066], ["1f4e2", 1067], ["1f4e2-fe0f", 1067], ["1f4e3", 1068], ["1f4e3-fe0f", 1068], ["1f4ef", 1069], ["1f4ef-fe0f", 1069], ["1f514", 1070], ["1f514-fe0f", 1070], ["1f515", 1071], ["1f515-fe0f", 1071], ["1f3bc", 1072], ["1f3bc-fe0f", 1072], ["1f3b5", 1073], ["1f3b5-fe0f", 1073], ["1f3b6", 1074], ["1f3b6-fe0f", 1074], ["1f399-fe0f", 1075], ["1f399", 1075], ["1f39a-fe0f", 1076], ["1f39a", 1076], ["1f39b-fe0f", 1077], ["1f39b", 1077], ["1f3a4", 1078], ["1f3a4-fe0f", 1078], ["1f3a7", 1079], ["1f3a7-fe0f", 1079], ["1f4fb", 1080], ["1f4fb-fe0f", 1080], ["1f3b7", 1081], ["1f3b7-fe0f", 1081], ["1f3b8", 1082], ["1f3b8-fe0f", 1082], ["1f3b9", 1083], ["1f3b9-fe0f", 1083], ["1f3ba", 1084], ["1f3ba-fe0f", 1084], ["1f3bb", 1085], ["1f3bb-fe0f", 1085], ["1fa95", 1086], ["1fa95-fe0f", 1086], ["1f941", 1087], ["1f941-fe0f", 1087], ["1f4f1", 1088], ["1f4f1-fe0f", 1088], ["1f4f2", 1089], ["1f4f2-fe0f", 1089], ["260e-fe0f", 1090], ["260e", 1090], ["1f4de", 1091], ["1f4de-fe0f", 1091], ["1f4df", 1092], ["1f4df-fe0f", 1092], ["1f4e0", 1093], ["1f4e0-fe0f", 1093], ["1f50b", 1094], ["1f50b-fe0f", 1094], ["1f50c", 1095], ["1f50c-fe0f", 1095], ["1f4bb", 1096], ["1f4bb-fe0f", 1096], ["1f5a5-fe0f", 1097], ["1f5a5", 1097], ["1f5a8-fe0f", 1098], ["1f5a8", 1098], ["2328-fe0f", 1099], ["2328", 1099], ["1f5b1-fe0f", 1100], ["1f5b1", 1100], ["1f5b2-fe0f", 1101], ["1f5b2", 1101], ["1f4bd", 1102], ["1f4bd-fe0f", 1102], ["1f4be", 1103], ["1f4be-fe0f", 1103], ["1f4bf", 1104], ["1f4bf-fe0f", 1104], ["1f4c0", 1105], ["1f4c0-fe0f", 1105], ["1f9ee", 1106], ["1f9ee-fe0f", 1106], ["1f3a5", 1107], ["1f3a5-fe0f", 1107], ["1f39e-fe0f", 1108], ["1f39e", 1108], ["1f4fd-fe0f", 1109], ["1f4fd", 1109], ["1f3ac", 1110], ["1f3ac-fe0f", 1110], ["1f4fa", 1111], ["1f4fa-fe0f", 1111], ["1f4f7", 1112], ["1f4f7-fe0f", 1112], ["1f4f8", 1113], ["1f4f8-fe0f", 1113], ["1f4f9", 1114], ["1f4f9-fe0f", 1114], ["1f4fc", 1115], ["1f4fc-fe0f", 1115], ["1f50d", 1116], ["1f50d-fe0f", 1116], ["1f50e", 1117], ["1f50e-fe0f", 1117], ["1f56f-fe0f", 1118], ["1f56f", 1118], ["1f4a1", 1119], ["1f4a1-fe0f", 1119], ["1f526", 1120], ["1f526-fe0f", 1120], ["1f3ee", 1121], ["1f3ee-fe0f", 1121], ["1fa94", 1122], ["1fa94-fe0f", 1122], ["1f4d4", 1123], ["1f4d4-fe0f", 1123], ["1f4d5", 1124], ["1f4d5-fe0f", 1124], ["1f4d6", 1125], ["1f4d6-fe0f", 1125], ["1f4d7", 1126], ["1f4d7-fe0f", 1126], ["1f4d8", 1127], ["1f4d8-fe0f", 1127], ["1f4d9", 1128], ["1f4d9-fe0f", 1128], ["1f4da", 1129], ["1f4da-fe0f", 1129], ["1f4d3", 1130], ["1f4d3-fe0f", 1130], ["1f4d2", 1131], ["1f4d2-fe0f", 1131], ["1f4c3", 1132], ["1f4c3-fe0f", 1132], ["1f4dc", 1133], ["1f4dc-fe0f", 1133], ["1f4c4", 1134], ["1f4c4-fe0f", 1134], ["1f4f0", 1135], ["1f4f0-fe0f", 1135], ["1f5de-fe0f", 1136], ["1f5de", 1136], ["1f4d1", 1137], ["1f4d1-fe0f", 1137], ["1f516", 1138], ["1f516-fe0f", 1138], ["1f3f7-fe0f", 1139], ["1f3f7", 1139], ["1f4b0", 1140], ["1f4b0-fe0f", 1140], ["1f4b4", 1141], ["1f4b4-fe0f", 1141], ["1f4b5", 1142], ["1f4b5-fe0f", 1142], ["1f4b6", 1143], ["1f4b6-fe0f", 1143], ["1f4b7", 1144], ["1f4b7-fe0f", 1144], ["1f4b8", 1145], ["1f4b8-fe0f", 1145], ["1f4b3", 1146], ["1f4b3-fe0f", 1146], ["1f9fe", 1147], ["1f9fe-fe0f", 1147], ["1f4b9", 1148], ["1f4b9-fe0f", 1148], ["1f4b1", 1149], ["1f4b1-fe0f", 1149], ["1f4b2", 1150], ["1f4b2-fe0f", 1150], ["2709-fe0f", 1151], ["2709", 1151], ["1f4e7", 1152], ["1f4e7-fe0f", 1152], ["1f4e8", 1153], ["1f4e8-fe0f", 1153], ["1f4e9", 1154], ["1f4e9-fe0f", 1154], ["1f4e4", 1155], ["1f4e4-fe0f", 1155], ["1f4e5", 1156], ["1f4e5-fe0f", 1156], ["1f4e6", 1157], ["1f4e6-fe0f", 1157], ["1f4eb", 1158], ["1f4eb-fe0f", 1158], ["1f4ea", 1159], ["1f4ea-fe0f", 1159], ["1f4ec", 1160], ["1f4ec-fe0f", 1160], ["1f4ed", 1161], ["1f4ed-fe0f", 1161], ["1f4ee", 1162], ["1f4ee-fe0f", 1162], ["1f5f3-fe0f", 1163], ["1f5f3", 1163], ["270f-fe0f", 1164], ["270f", 1164], ["2712-fe0f", 1165], ["2712", 1165], ["1f58b-fe0f", 1166], ["1f58b", 1166], ["1f58a-fe0f", 1167], ["1f58a", 1167], ["1f58c-fe0f", 1168], ["1f58c", 1168], ["1f58d-fe0f", 1169], ["1f58d", 1169], ["1f4dd", 1170], ["1f4dd-fe0f", 1170], ["1f4bc", 1171], ["1f4bc-fe0f", 1171], ["1f4c1", 1172], ["1f4c1-fe0f", 1172], ["1f4c2", 1173], ["1f4c2-fe0f", 1173], ["1f5c2-fe0f", 1174], ["1f5c2", 1174], ["1f4c5", 1175], ["1f4c5-fe0f", 1175], ["1f4c6", 1176], ["1f4c6-fe0f", 1176], ["1f5d2-fe0f", 1177], ["1f5d2", 1177], ["1f5d3-fe0f", 1178], ["1f5d3", 1178], ["1f4c7", 1179], ["1f4c7-fe0f", 1179], ["1f4c8", 1180], ["1f4c8-fe0f", 1180], ["1f4c9", 1181], ["1f4c9-fe0f", 1181], ["1f4ca", 1182], ["1f4ca-fe0f", 1182], ["1f4cb", 1183], ["1f4cb-fe0f", 1183], ["1f4cc", 1184], ["1f4cc-fe0f", 1184], ["1f4cd", 1185], ["1f4cd-fe0f", 1185], ["1f4ce", 1186], ["1f4ce-fe0f", 1186], ["1f587-fe0f", 1187], ["1f587", 1187], ["1f4cf", 1188], ["1f4cf-fe0f", 1188], ["1f4d0", 1189], ["1f4d0-fe0f", 1189], ["2702-fe0f", 1190], ["2702", 1190], ["1f5c3-fe0f", 1191], ["1f5c3", 1191], ["1f5c4-fe0f", 1192], ["1f5c4", 1192], ["1f5d1-fe0f", 1193], ["1f5d1", 1193], ["1f512", 1194], ["1f512-fe0f", 1194], ["1f513", 1195], ["1f513-fe0f", 1195], ["1f50f", 1196], ["1f50f-fe0f", 1196], ["1f510", 1197], ["1f510-fe0f", 1197], ["1f511", 1198], ["1f511-fe0f", 1198], ["1f5dd-fe0f", 1199], ["1f5dd", 1199], ["1f528", 1200], ["1f528-fe0f", 1200], ["1fa93", 1201], ["1fa93-fe0f", 1201], ["26cf-fe0f", 1202], ["26cf", 1202], ["2692-fe0f", 1203], ["2692", 1203], ["1f6e0-fe0f", 1204], ["1f6e0", 1204], ["1f5e1-fe0f", 1205], ["1f5e1", 1205], ["2694-fe0f", 1206], ["2694", 1206], ["1f52b", 1207], ["1f52b-fe0f", 1207], ["1f3f9", 1208], ["1f3f9-fe0f", 1208], ["1f6e1-fe0f", 1209], ["1f6e1", 1209], ["1f527", 1210], ["1f527-fe0f", 1210], ["1f529", 1211], ["1f529-fe0f", 1211], ["2699-fe0f", 1212], ["2699", 1212], ["1f5dc-fe0f", 1213], ["1f5dc", 1213], ["2696-fe0f", 1214], ["2696", 1214], ["1f9af", 1215], ["1f9af-fe0f", 1215], ["1f517", 1216], ["1f517-fe0f", 1216], ["26d3-fe0f", 1217], ["26d3", 1217], ["1f9f0", 1218], ["1f9f0-fe0f", 1218], ["1f9f2", 1219], ["1f9f2-fe0f", 1219], ["2697-fe0f", 1220], ["2697", 1220], ["1f9ea", 1221], ["1f9ea-fe0f", 1221], ["1f9eb", 1222], ["1f9eb-fe0f", 1222], ["1f9ec", 1223], ["1f9ec-fe0f", 1223], ["1f52c", 1224], ["1f52c-fe0f", 1224], ["1f52d", 1225], ["1f52d-fe0f", 1225], ["1f4e1", 1226], ["1f4e1-fe0f", 1226], ["1f489", 1227], ["1f489-fe0f", 1227], ["1fa78", 1228], ["1fa78-fe0f", 1228], ["1f48a", 1229], ["1f48a-fe0f", 1229], ["1fa79", 1230], ["1fa79-fe0f", 1230], ["1fa7a", 1231], ["1fa7a-fe0f", 1231], ["1f6aa", 1232], ["1f6aa-fe0f", 1232], ["1f6cf-fe0f", 1233], ["1f6cf", 1233], ["1f6cb-fe0f", 1234], ["1f6cb", 1234], ["1fa91", 1235], ["1fa91-fe0f", 1235], ["1f6bd", 1236], ["1f6bd-fe0f", 1236], ["1f6bf", 1237], ["1f6bf-fe0f", 1237], ["1f6c1", 1238], ["1f6c1-fe0f", 1238], ["1fa92", 1239], ["1fa92-fe0f", 1239], ["1f9f4", 1240], ["1f9f4-fe0f", 1240], ["1f9f7", 1241], ["1f9f7-fe0f", 1241], ["1f9f9", 1242], ["1f9f9-fe0f", 1242], ["1f9fa", 1243], ["1f9fa-fe0f", 1243], ["1f9fb", 1244], ["1f9fb-fe0f", 1244], ["1f9fc", 1245], ["1f9fc-fe0f", 1245], ["1f9fd", 1246], ["1f9fd-fe0f", 1246], ["1f9ef", 1247], ["1f9ef-fe0f", 1247], ["1f6d2", 1248], ["1f6d2-fe0f", 1248], ["1f6ac", 1249], ["1f6ac-fe0f", 1249], ["26b0-fe0f", 1250], ["26b0", 1250], ["26b1-fe0f", 1251], ["26b1", 1251], ["1f5ff", 1252], ["1f5ff-fe0f", 1252], ["1f3e7", 1253], ["1f3e7-fe0f", 1253], ["1f6ae", 1254], ["1f6ae-fe0f", 1254], ["1f6b0", 1255], ["1f6b0-fe0f", 1255], ["267f", 1256], ["267f-fe0f", 1256], ["1f6b9", 1257], ["1f6b9-fe0f", 1257], ["1f6ba", 1258], ["1f6ba-fe0f", 1258], ["1f6bb", 1259], ["1f6bb-fe0f", 1259], ["1f6bc", 1260], ["1f6bc-fe0f", 1260], ["1f6be", 1261], ["1f6be-fe0f", 1261], ["1f6c2", 1262], ["1f6c2-fe0f", 1262], ["1f6c3", 1263], ["1f6c3-fe0f", 1263], ["1f6c4", 1264], ["1f6c4-fe0f", 1264], ["1f6c5", 1265], ["1f6c5-fe0f", 1265], ["26a0-fe0f", 1266], ["26a0", 1266], ["1f6b8", 1267], ["1f6b8-fe0f", 1267], ["26d4", 1268], ["26d4-fe0f", 1268], ["1f6ab", 1269], ["1f6ab-fe0f", 1269], ["1f6b3", 1270], ["1f6b3-fe0f", 1270], ["1f6ad", 1271], ["1f6ad-fe0f", 1271], ["1f6af", 1272], ["1f6af-fe0f", 1272], ["1f6b1", 1273], ["1f6b1-fe0f", 1273], ["1f6b7", 1274], ["1f6b7-fe0f", 1274], ["1f4f5", 1275], ["1f4f5-fe0f", 1275], ["1f51e", 1276], ["1f51e-fe0f", 1276], ["2622-fe0f", 1277], ["2622", 1277], ["2623-fe0f", 1278], ["2623", 1278], ["2b06-fe0f", 1279], ["2b06", 1279], ["2197-fe0f", 1280], ["2197", 1280], ["27a1-fe0f", 1281], ["27a1", 1281], ["2198-fe0f", 1282], ["2198", 1282], ["2b07-fe0f", 1283], ["2b07", 1283], ["2199-fe0f", 1284], ["2199", 1284], ["2b05-fe0f", 1285], ["2b05", 1285], ["2196-fe0f", 1286], ["2196", 1286], ["2195-fe0f", 1287], ["2195", 1287], ["2194-fe0f", 1288], ["2194", 1288], ["21a9-fe0f", 1289], ["21a9", 1289], ["21aa-fe0f", 1290], ["21aa", 1290], ["2934-fe0f", 1291], ["2934", 1291], ["2935-fe0f", 1292], ["2935", 1292], ["1f503", 1293], ["1f503-fe0f", 1293], ["1f504", 1294], ["1f504-fe0f", 1294], ["1f519", 1295], ["1f519-fe0f", 1295], ["1f51a", 1296], ["1f51a-fe0f", 1296], ["1f51b", 1297], ["1f51b-fe0f", 1297], ["1f51c", 1298], ["1f51c-fe0f", 1298], ["1f51d", 1299], ["1f51d-fe0f", 1299], ["1f6d0", 1300], ["1f6d0-fe0f", 1300], ["269b-fe0f", 1301], ["269b", 1301], ["1f549-fe0f", 1302], ["1f549", 1302], ["2721-fe0f", 1303], ["2721", 1303], ["2638-fe0f", 1304], ["2638", 1304], ["262f-fe0f", 1305], ["262f", 1305], ["271d-fe0f", 1306], ["271d", 1306], ["2626-fe0f", 1307], ["2626", 1307], ["262a-fe0f", 1308], ["262a", 1308], ["262e-fe0f", 1309], ["262e", 1309], ["1f54e", 1310], ["1f54e-fe0f", 1310], ["1f52f", 1311], ["1f52f-fe0f", 1311], ["2648", 1312], ["2648-fe0f", 1312], ["2649", 1313], ["2649-fe0f", 1313], ["264a", 1314], ["264a-fe0f", 1314], ["264b", 1315], ["264b-fe0f", 1315], ["264c", 1316], ["264c-fe0f", 1316], ["264d", 1317], ["264d-fe0f", 1317], ["264e", 1318], ["264e-fe0f", 1318], ["264f", 1319], ["264f-fe0f", 1319], ["2650", 1320], ["2650-fe0f", 1320], ["2651", 1321], ["2651-fe0f", 1321], ["2652", 1322], ["2652-fe0f", 1322], ["2653", 1323], ["2653-fe0f", 1323], ["26ce", 1324], ["26ce-fe0f", 1324], ["1f500", 1325], ["1f500-fe0f", 1325], ["1f501", 1326], ["1f501-fe0f", 1326], ["1f502", 1327], ["1f502-fe0f", 1327], ["25b6-fe0f", 1328], ["25b6", 1328], ["23e9", 1329], ["23e9-fe0f", 1329], ["23ed-fe0f", 1330], ["23ed", 1330], ["23ef-fe0f", 1331], ["23ef", 1331], ["25c0-fe0f", 1332], ["25c0", 1332], ["23ea", 1333], ["23ea-fe0f", 1333], ["23ee-fe0f", 1334], ["23ee", 1334], ["1f53c", 1335], ["1f53c-fe0f", 1335], ["23eb", 1336], ["23eb-fe0f", 1336], ["1f53d", 1337], ["1f53d-fe0f", 1337], ["23ec", 1338], ["23ec-fe0f", 1338], ["23f8-fe0f", 1339], ["23f8", 1339], ["23f9-fe0f", 1340], ["23f9", 1340], ["23fa-fe0f", 1341], ["23fa", 1341], ["23cf-fe0f", 1342], ["23cf", 1342], ["1f3a6", 1343], ["1f3a6-fe0f", 1343], ["1f505", 1344], ["1f505-fe0f", 1344], ["1f506", 1345], ["1f506-fe0f", 1345], ["1f4f6", 1346], ["1f4f6-fe0f", 1346], ["1f4f3", 1347], ["1f4f3-fe0f", 1347], ["1f4f4", 1348], ["1f4f4-fe0f", 1348], ["2640-fe0f", 1349], ["2640", 1349], ["2642-fe0f", 1350], ["2642", 1350], ["2695-fe0f", 1351], ["2695", 1351], ["267e-fe0f", 1352], ["267e", 1352], ["267b-fe0f", 1353], ["267b", 1353], ["269c-fe0f", 1354], ["269c", 1354], ["1f531", 1355], ["1f531-fe0f", 1355], ["1f4db", 1356], ["1f4db-fe0f", 1356], ["1f530", 1357], ["1f530-fe0f", 1357], ["2b55", 1358], ["2b55-fe0f", 1358], ["2705", 1359], ["2705-fe0f", 1359], ["2611-fe0f", 1360], ["2611", 1360], ["2714-fe0f", 1361], ["2714", 1361], ["2716-fe0f", 1362], ["2716", 1362], ["274c", 1363], ["274c-fe0f", 1363], ["274e", 1364], ["274e-fe0f", 1364], ["2795", 1365], ["2795-fe0f", 1365], ["2796", 1366], ["2796-fe0f", 1366], ["2797", 1367], ["2797-fe0f", 1367], ["27b0", 1368], ["27b0-fe0f", 1368], ["27bf", 1369], ["27bf-fe0f", 1369], ["303d-fe0f", 1370], ["303d", 1370], ["2733-fe0f", 1371], ["2733", 1371], ["2734-fe0f", 1372], ["2734", 1372], ["2747-fe0f", 1373], ["2747", 1373], ["203c-fe0f", 1374], ["203c", 1374], ["2049-fe0f", 1375], ["2049", 1375], ["2753", 1376], ["2753-fe0f", 1376], ["2754", 1377], ["2754-fe0f", 1377], ["2755", 1378], ["2755-fe0f", 1378], ["2757", 1379], ["2757-fe0f", 1379], ["3030-fe0f", 1380], ["00a9-fe0f", 1381], ["00ae-fe0f", 1382], ["2122-fe0f", 1383], ["0023-fe0f-20e3", 1384], ["0023-20e3", 1384], ["002a-fe0f-20e3", 1385], ["002a-20e3", 1385], ["0030-fe0f-20e3", 1386], ["0030-20e3", 1386], ["0031-fe0f-20e3", 1387], ["0031-20e3", 1387], ["0032-fe0f-20e3", 1388], ["0032-20e3", 1388], ["0033-fe0f-20e3", 1389], ["0033-20e3", 1389], ["0034-fe0f-20e3", 1390], ["0034-20e3", 1390], ["0035-fe0f-20e3", 1391], ["0035-20e3", 1391], ["0036-fe0f-20e3", 1392], ["0036-20e3", 1392], ["0037-fe0f-20e3", 1393], ["0037-20e3", 1393], ["0038-fe0f-20e3", 1394], ["0038-20e3", 1394], ["0039-fe0f-20e3", 1395], ["0039-20e3", 1395], ["1f51f", 1396], ["1f51f-fe0f", 1396], ["1f520", 1397], ["1f520-fe0f", 1397], ["1f521", 1398], ["1f521-fe0f", 1398], ["1f522", 1399], ["1f522-fe0f", 1399], ["1f523", 1400], ["1f523-fe0f", 1400], ["1f524", 1401], ["1f524-fe0f", 1401], ["1f170-fe0f", 1402], ["1f18e", 1403], ["1f18e-fe0f", 1403], ["1f171-fe0f", 1404], ["1f191", 1405], ["1f191-fe0f", 1405], ["1f192", 1406], ["1f192-fe0f", 1406], ["1f193", 1407], ["1f193-fe0f", 1407], ["2139-fe0f", 1408], ["2139", 1408], ["1f194", 1409], ["1f194-fe0f", 1409], ["24c2-fe0f", 1410], ["24c2", 1410], ["1f195", 1411], ["1f195-fe0f", 1411], ["1f196", 1412], ["1f196-fe0f", 1412], ["1f17e-fe0f", 1413], ["1f197", 1414], ["1f197-fe0f", 1414], ["1f17f-fe0f", 1415], ["1f17f", 1415], ["1f198", 1416], ["1f198-fe0f", 1416], ["1f199", 1417], ["1f199-fe0f", 1417], ["1f19a", 1418], ["1f19a-fe0f", 1418], ["1f201", 1419], ["1f201-fe0f", 1419], ["1f202-fe0f", 1420], ["1f237-fe0f", 1421], ["1f236", 1422], ["1f236-fe0f", 1422], ["1f22f", 1423], ["1f22f-fe0f", 1423], ["1f250", 1424], ["1f250-fe0f", 1424], ["1f239", 1425], ["1f239-fe0f", 1425], ["1f21a", 1426], ["1f21a-fe0f", 1426], ["1f232", 1427], ["1f232-fe0f", 1427], ["1f251", 1428], ["1f251-fe0f", 1428], ["1f238", 1429], ["1f238-fe0f", 1429], ["1f234", 1430], ["1f234-fe0f", 1430], ["1f233", 1431], ["1f233-fe0f", 1431], ["3297-fe0f", 1432], ["3297", 1432], ["3299-fe0f", 1433], ["3299", 1433], ["1f23a", 1434], ["1f23a-fe0f", 1434], ["1f235", 1435], ["1f235-fe0f", 1435], ["1f534", 1436], ["1f534-fe0f", 1436], ["1f7e0", 1437], ["1f7e0-fe0f", 1437], ["1f7e1", 1438], ["1f7e1-fe0f", 1438], ["1f7e2", 1439], ["1f7e2-fe0f", 1439], ["1f535", 1440], ["1f535-fe0f", 1440], ["1f7e3", 1441], ["1f7e3-fe0f", 1441], ["1f7e4", 1442], ["1f7e4-fe0f", 1442], ["26ab", 1443], ["26ab-fe0f", 1443], ["26aa", 1444], ["26aa-fe0f", 1444], ["1f7e5", 1445], ["1f7e5-fe0f", 1445], ["1f7e7", 1446], ["1f7e7-fe0f", 1446], ["1f7e8", 1447], ["1f7e8-fe0f", 1447], ["1f7e9", 1448], ["1f7e9-fe0f", 1448], ["1f7e6", 1449], ["1f7e6-fe0f", 1449], ["1f7ea", 1450], ["1f7ea-fe0f", 1450], ["1f7eb", 1451], ["1f7eb-fe0f", 1451], ["2b1b", 1452], ["2b1b-fe0f", 1452], ["2b1c", 1453], ["2b1c-fe0f", 1453], ["25fc-fe0f", 1454], ["25fc", 1454], ["25fb-fe0f", 1455], ["25fb", 1455], ["25fe", 1456], ["25fe-fe0f", 1456], ["25fd", 1457], ["25fd-fe0f", 1457], ["25aa-fe0f", 1458], ["25aa", 1458], ["25ab-fe0f", 1459], ["25ab", 1459], ["1f536", 1460], ["1f536-fe0f", 1460], ["1f537", 1461], ["1f537-fe0f", 1461], ["1f538", 1462], ["1f538-fe0f", 1462], ["1f539", 1463], ["1f539-fe0f", 1463], ["1f53a", 1464], ["1f53a-fe0f", 1464], ["1f53b", 1465], ["1f53b-fe0f", 1465], ["1f4a0", 1466], ["1f4a0-fe0f", 1466], ["1f518", 1467], ["1f518-fe0f", 1467], ["1f533", 1468], ["1f533-fe0f", 1468], ["1f532", 1469], ["1f532-fe0f", 1469], ["1f3c1", 1470], ["1f3c1-fe0f", 1470], ["1f6a9", 1471], ["1f6a9-fe0f", 1471], ["1f38c", 1472], ["1f38c-fe0f", 1472], ["1f3f4", 1473], ["1f3f4-fe0f", 1473], ["1f3f3-fe0f", 1474], ["1f3f3", 1474], ["1f3f3-fe0f-200d-1f308", 1475], ["1f3f3-200d-1f308", 1475], ["1f3f4-200d-2620-fe0f", 1476], ["1f3f4-200d-2620", 1476], ["1f1e6-1f1e8", 1477], ["1f1e6-1f1e8-fe0f", 1477], ["1f1e6-1f1e9", 1478], ["1f1e6-1f1e9-fe0f", 1478], ["1f1e6-1f1ea", 1479], ["1f1e6-1f1ea-fe0f", 1479], ["1f1e6-1f1eb", 1480], ["1f1e6-1f1eb-fe0f", 1480], ["1f1e6-1f1ec", 1481], ["1f1e6-1f1ec-fe0f", 1481], ["1f1e6-1f1ee", 1482], ["1f1e6-1f1ee-fe0f", 1482], ["1f1e6-1f1f1", 1483], ["1f1e6-1f1f1-fe0f", 1483], ["1f1e6-1f1f2", 1484], ["1f1e6-1f1f2-fe0f", 1484], ["1f1e6-1f1f4", 1485], ["1f1e6-1f1f4-fe0f", 1485], ["1f1e6-1f1f6", 1486], ["1f1e6-1f1f6-fe0f", 1486], ["1f1e6-1f1f7", 1487], ["1f1e6-1f1f7-fe0f", 1487], ["1f1e6-1f1f8", 1488], ["1f1e6-1f1f8-fe0f", 1488], ["1f1e6-1f1f9", 1489], ["1f1e6-1f1f9-fe0f", 1489], ["1f1e6-1f1fa", 1490], ["1f1e6-1f1fa-fe0f", 1490], ["1f1e6-1f1fc", 1491], ["1f1e6-1f1fc-fe0f", 1491], ["1f1e6-1f1fd", 1492], ["1f1e6-1f1fd-fe0f", 1492], ["1f1e6-1f1ff", 1493], ["1f1e6-1f1ff-fe0f", 1493], ["1f1e7-1f1e6", 1494], ["1f1e7-1f1e6-fe0f", 1494], ["1f1e7-1f1e7", 1495], ["1f1e7-1f1e7-fe0f", 1495], ["1f1e7-1f1e9", 1496], ["1f1e7-1f1e9-fe0f", 1496], ["1f1e7-1f1ea", 1497], ["1f1e7-1f1ea-fe0f", 1497], ["1f1e7-1f1eb", 1498], ["1f1e7-1f1eb-fe0f", 1498], ["1f1e7-1f1ec", 1499], ["1f1e7-1f1ec-fe0f", 1499], ["1f1e7-1f1ed", 1500], ["1f1e7-1f1ed-fe0f", 1500], ["1f1e7-1f1ee", 1501], ["1f1e7-1f1ee-fe0f", 1501], ["1f1e7-1f1ef", 1502], ["1f1e7-1f1ef-fe0f", 1502], ["1f1e7-1f1f1", 1503], ["1f1e7-1f1f1-fe0f", 1503], ["1f1e7-1f1f2", 1504], ["1f1e7-1f1f2-fe0f", 1504], ["1f1e7-1f1f3", 1505], ["1f1e7-1f1f3-fe0f", 1505], ["1f1e7-1f1f4", 1506], ["1f1e7-1f1f4-fe0f", 1506], ["1f1e7-1f1f6", 1507], ["1f1e7-1f1f6-fe0f", 1507], ["1f1e7-1f1f7", 1508], ["1f1e7-1f1f7-fe0f", 1508], ["1f1e7-1f1f8", 1509], ["1f1e7-1f1f8-fe0f", 1509], ["1f1e7-1f1f9", 1510], ["1f1e7-1f1f9-fe0f", 1510], ["1f1e7-1f1fb", 1511], ["1f1e7-1f1fb-fe0f", 1511], ["1f1e7-1f1fc", 1512], ["1f1e7-1f1fc-fe0f", 1512], ["1f1e7-1f1fe", 1513], ["1f1e7-1f1fe-fe0f", 1513], ["1f1e7-1f1ff", 1514], ["1f1e7-1f1ff-fe0f", 1514], ["1f1e8-1f1e6", 1515], ["1f1e8-1f1e6-fe0f", 1515], ["1f1e8-1f1e8", 1516], ["1f1e8-1f1e8-fe0f", 1516], ["1f1e8-1f1e9", 1517], ["1f1e8-1f1e9-fe0f", 1517], ["1f1e8-1f1eb", 1518], ["1f1e8-1f1eb-fe0f", 1518], ["1f1e8-1f1ec", 1519], ["1f1e8-1f1ec-fe0f", 1519], ["1f1e8-1f1ed", 1520], ["1f1e8-1f1ed-fe0f", 1520], ["1f1e8-1f1ee", 1521], ["1f1e8-1f1ee-fe0f", 1521], ["1f1e8-1f1f0", 1522], ["1f1e8-1f1f0-fe0f", 1522], ["1f1e8-1f1f1", 1523], ["1f1e8-1f1f1-fe0f", 1523], ["1f1e8-1f1f2", 1524], ["1f1e8-1f1f2-fe0f", 1524], ["1f1e8-1f1f3", 1525], ["1f1e8-1f1f3-fe0f", 1525], ["1f1e8-1f1f4", 1526], ["1f1e8-1f1f4-fe0f", 1526], ["1f1e8-1f1f5", 1527], ["1f1e8-1f1f5-fe0f", 1527], ["1f1e8-1f1f7", 1528], ["1f1e8-1f1f7-fe0f", 1528], ["1f1e8-1f1fa", 1529], ["1f1e8-1f1fa-fe0f", 1529], ["1f1e8-1f1fb", 1530], ["1f1e8-1f1fb-fe0f", 1530], ["1f1e8-1f1fc", 1531], ["1f1e8-1f1fc-fe0f", 1531], ["1f1e8-1f1fd", 1532], ["1f1e8-1f1fd-fe0f", 1532], ["1f1e8-1f1fe", 1533], ["1f1e8-1f1fe-fe0f", 1533], ["1f1e8-1f1ff", 1534], ["1f1e8-1f1ff-fe0f", 1534], ["1f1e9-1f1ea", 1535], ["1f1e9-1f1ea-fe0f", 1535], ["1f1e9-1f1ec", 1536], ["1f1e9-1f1ec-fe0f", 1536], ["1f1e9-1f1ef", 1537], ["1f1e9-1f1ef-fe0f", 1537], ["1f1e9-1f1f0", 1538], ["1f1e9-1f1f0-fe0f", 1538], ["1f1e9-1f1f2", 1539], ["1f1e9-1f1f2-fe0f", 1539], ["1f1e9-1f1f4", 1540], ["1f1e9-1f1f4-fe0f", 1540], ["1f1e9-1f1ff", 1541], ["1f1e9-1f1ff-fe0f", 1541], ["1f1ea-1f1e6", 1542], ["1f1ea-1f1e6-fe0f", 1542], ["1f1ea-1f1e8", 1543], ["1f1ea-1f1e8-fe0f", 1543], ["1f1ea-1f1ea", 1544], ["1f1ea-1f1ea-fe0f", 1544], ["1f1ea-1f1ec", 1545], ["1f1ea-1f1ec-fe0f", 1545], ["1f1ea-1f1ed", 1546], ["1f1ea-1f1ed-fe0f", 1546], ["1f1ea-1f1f7", 1547], ["1f1ea-1f1f7-fe0f", 1547], ["1f1ea-1f1f8", 1548], ["1f1ea-1f1f8-fe0f", 1548], ["1f1ea-1f1f9", 1549], ["1f1ea-1f1f9-fe0f", 1549], ["1f1ea-1f1fa", 1550], ["1f1ea-1f1fa-fe0f", 1550], ["1f1eb-1f1ee", 1551], ["1f1eb-1f1ee-fe0f", 1551], ["1f1eb-1f1ef", 1552], ["1f1eb-1f1ef-fe0f", 1552], ["1f1eb-1f1f0", 1553], ["1f1eb-1f1f0-fe0f", 1553], ["1f1eb-1f1f2", 1554], ["1f1eb-1f1f2-fe0f", 1554], ["1f1eb-1f1f4", 1555], ["1f1eb-1f1f4-fe0f", 1555], ["1f1eb-1f1f7", 1556], ["1f1eb-1f1f7-fe0f", 1556], ["1f1ec-1f1e6", 1557], ["1f1ec-1f1e6-fe0f", 1557], ["1f1ec-1f1e7", 1558], ["1f1ec-1f1e7-fe0f", 1558], ["1f1ec-1f1e9", 1559], ["1f1ec-1f1e9-fe0f", 1559], ["1f1ec-1f1ea", 1560], ["1f1ec-1f1ea-fe0f", 1560], ["1f1ec-1f1eb", 1561], ["1f1ec-1f1eb-fe0f", 1561], ["1f1ec-1f1ec", 1562], ["1f1ec-1f1ec-fe0f", 1562], ["1f1ec-1f1ed", 1563], ["1f1ec-1f1ed-fe0f", 1563], ["1f1ec-1f1ee", 1564], ["1f1ec-1f1ee-fe0f", 1564], ["1f1ec-1f1f1", 1565], ["1f1ec-1f1f1-fe0f", 1565], ["1f1ec-1f1f2", 1566], ["1f1ec-1f1f2-fe0f", 1566], ["1f1ec-1f1f3", 1567], ["1f1ec-1f1f3-fe0f", 1567], ["1f1ec-1f1f5", 1568], ["1f1ec-1f1f5-fe0f", 1568], ["1f1ec-1f1f6", 1569], ["1f1ec-1f1f6-fe0f", 1569], ["1f1ec-1f1f7", 1570], ["1f1ec-1f1f7-fe0f", 1570], ["1f1ec-1f1f8", 1571], ["1f1ec-1f1f8-fe0f", 1571], ["1f1ec-1f1f9", 1572], ["1f1ec-1f1f9-fe0f", 1572], ["1f1ec-1f1fa", 1573], ["1f1ec-1f1fa-fe0f", 1573], ["1f1ec-1f1fc", 1574], ["1f1ec-1f1fc-fe0f", 1574], ["1f1ec-1f1fe", 1575], ["1f1ec-1f1fe-fe0f", 1575], ["1f1ed-1f1f0", 1576], ["1f1ed-1f1f0-fe0f", 1576], ["1f1ed-1f1f2", 1577], ["1f1ed-1f1f2-fe0f", 1577], ["1f1ed-1f1f3", 1578], ["1f1ed-1f1f3-fe0f", 1578], ["1f1ed-1f1f7", 1579], ["1f1ed-1f1f7-fe0f", 1579], ["1f1ed-1f1f9", 1580], ["1f1ed-1f1f9-fe0f", 1580], ["1f1ed-1f1fa", 1581], ["1f1ed-1f1fa-fe0f", 1581], ["1f1ee-1f1e8", 1582], ["1f1ee-1f1e8-fe0f", 1582], ["1f1ee-1f1e9", 1583], ["1f1ee-1f1e9-fe0f", 1583], ["1f1ee-1f1ea", 1584], ["1f1ee-1f1ea-fe0f", 1584], ["1f1ee-1f1f1", 1585], ["1f1ee-1f1f1-fe0f", 1585], ["1f1ee-1f1f2", 1586], ["1f1ee-1f1f2-fe0f", 1586], ["1f1ee-1f1f3", 1587], ["1f1ee-1f1f3-fe0f", 1587], ["1f1ee-1f1f4", 1588], ["1f1ee-1f1f4-fe0f", 1588], ["1f1ee-1f1f6", 1589], ["1f1ee-1f1f6-fe0f", 1589], ["1f1ee-1f1f7", 1590], ["1f1ee-1f1f7-fe0f", 1590], ["1f1ee-1f1f8", 1591], ["1f1ee-1f1f8-fe0f", 1591], ["1f1ee-1f1f9", 1592], ["1f1ee-1f1f9-fe0f", 1592], ["1f1ef-1f1ea", 1593], ["1f1ef-1f1ea-fe0f", 1593], ["1f1ef-1f1f2", 1594], ["1f1ef-1f1f2-fe0f", 1594], ["1f1ef-1f1f4", 1595], ["1f1ef-1f1f4-fe0f", 1595], ["1f1ef-1f1f5", 1596], ["1f1ef-1f1f5-fe0f", 1596], ["1f1f0-1f1ea", 1597], ["1f1f0-1f1ea-fe0f", 1597], ["1f1f0-1f1ec", 1598], ["1f1f0-1f1ec-fe0f", 1598], ["1f1f0-1f1ed", 1599], ["1f1f0-1f1ed-fe0f", 1599], ["1f1f0-1f1ee", 1600], ["1f1f0-1f1ee-fe0f", 1600], ["1f1f0-1f1f2", 1601], ["1f1f0-1f1f2-fe0f", 1601], ["1f1f0-1f1f3", 1602], ["1f1f0-1f1f3-fe0f", 1602], ["1f1f0-1f1f5", 1603], ["1f1f0-1f1f5-fe0f", 1603], ["1f1f0-1f1f7", 1604], ["1f1f0-1f1f7-fe0f", 1604], ["1f1f0-1f1fc", 1605], ["1f1f0-1f1fc-fe0f", 1605], ["1f1f0-1f1fe", 1606], ["1f1f0-1f1fe-fe0f", 1606], ["1f1f0-1f1ff", 1607], ["1f1f0-1f1ff-fe0f", 1607], ["1f1f1-1f1e6", 1608], ["1f1f1-1f1e6-fe0f", 1608], ["1f1f1-1f1e7", 1609], ["1f1f1-1f1e7-fe0f", 1609], ["1f1f1-1f1e8", 1610], ["1f1f1-1f1e8-fe0f", 1610], ["1f1f1-1f1ee", 1611], ["1f1f1-1f1ee-fe0f", 1611], ["1f1f1-1f1f0", 1612], ["1f1f1-1f1f0-fe0f", 1612], ["1f1f1-1f1f7", 1613], ["1f1f1-1f1f7-fe0f", 1613], ["1f1f1-1f1f8", 1614], ["1f1f1-1f1f8-fe0f", 1614], ["1f1f1-1f1f9", 1615], ["1f1f1-1f1f9-fe0f", 1615], ["1f1f1-1f1fa", 1616], ["1f1f1-1f1fa-fe0f", 1616], ["1f1f1-1f1fb", 1617], ["1f1f1-1f1fb-fe0f", 1617], ["1f1f1-1f1fe", 1618], ["1f1f1-1f1fe-fe0f", 1618], ["1f1f2-1f1e6", 1619], ["1f1f2-1f1e6-fe0f", 1619], ["1f1f2-1f1e8", 1620], ["1f1f2-1f1e8-fe0f", 1620], ["1f1f2-1f1e9", 1621], ["1f1f2-1f1e9-fe0f", 1621], ["1f1f2-1f1ea", 1622], ["1f1f2-1f1ea-fe0f", 1622], ["1f1f2-1f1eb", 1623], ["1f1f2-1f1eb-fe0f", 1623], ["1f1f2-1f1ec", 1624], ["1f1f2-1f1ec-fe0f", 1624], ["1f1f2-1f1ed", 1625], ["1f1f2-1f1ed-fe0f", 1625], ["1f1f2-1f1f0", 1626], ["1f1f2-1f1f0-fe0f", 1626], ["1f1f2-1f1f1", 1627], ["1f1f2-1f1f1-fe0f", 1627], ["1f1f2-1f1f2", 1628], ["1f1f2-1f1f2-fe0f", 1628], ["1f1f2-1f1f3", 1629], ["1f1f2-1f1f3-fe0f", 1629], ["1f1f2-1f1f4", 1630], ["1f1f2-1f1f4-fe0f", 1630], ["1f1f2-1f1f5", 1631], ["1f1f2-1f1f5-fe0f", 1631], ["1f1f2-1f1f6", 1632], ["1f1f2-1f1f6-fe0f", 1632], ["1f1f2-1f1f7", 1633], ["1f1f2-1f1f7-fe0f", 1633], ["1f1f2-1f1f8", 1634], ["1f1f2-1f1f8-fe0f", 1634], ["1f1f2-1f1f9", 1635], ["1f1f2-1f1f9-fe0f", 1635], ["1f1f2-1f1fa", 1636], ["1f1f2-1f1fa-fe0f", 1636], ["1f1f2-1f1fb", 1637], ["1f1f2-1f1fb-fe0f", 1637], ["1f1f2-1f1fc", 1638], ["1f1f2-1f1fc-fe0f", 1638], ["1f1f2-1f1fd", 1639], ["1f1f2-1f1fd-fe0f", 1639], ["1f1f2-1f1fe", 1640], ["1f1f2-1f1fe-fe0f", 1640], ["1f1f2-1f1ff", 1641], ["1f1f2-1f1ff-fe0f", 1641], ["1f1f3-1f1e6", 1642], ["1f1f3-1f1e6-fe0f", 1642], ["1f1f3-1f1e8", 1643], ["1f1f3-1f1e8-fe0f", 1643], ["1f1f3-1f1ea", 1644], ["1f1f3-1f1ea-fe0f", 1644], ["1f1f3-1f1eb", 1645], ["1f1f3-1f1eb-fe0f", 1645], ["1f1f3-1f1ec", 1646], ["1f1f3-1f1ec-fe0f", 1646], ["1f1f3-1f1ee", 1647], ["1f1f3-1f1ee-fe0f", 1647], ["1f1f3-1f1f1", 1648], ["1f1f3-1f1f1-fe0f", 1648], ["1f1f3-1f1f4", 1649], ["1f1f3-1f1f4-fe0f", 1649], ["1f1f3-1f1f5", 1650], ["1f1f3-1f1f5-fe0f", 1650], ["1f1f3-1f1f7", 1651], ["1f1f3-1f1f7-fe0f", 1651], ["1f1f3-1f1fa", 1652], ["1f1f3-1f1fa-fe0f", 1652], ["1f1f3-1f1ff", 1653], ["1f1f3-1f1ff-fe0f", 1653], ["1f1f4-1f1f2", 1654], ["1f1f4-1f1f2-fe0f", 1654], ["1f1f5-1f1e6", 1655], ["1f1f5-1f1e6-fe0f", 1655], ["1f1f5-1f1ea", 1656], ["1f1f5-1f1ea-fe0f", 1656], ["1f1f5-1f1eb", 1657], ["1f1f5-1f1eb-fe0f", 1657], ["1f1f5-1f1ec", 1658], ["1f1f5-1f1ec-fe0f", 1658], ["1f1f5-1f1ed", 1659], ["1f1f5-1f1ed-fe0f", 1659], ["1f1f5-1f1f0", 1660], ["1f1f5-1f1f0-fe0f", 1660], ["1f1f5-1f1f1", 1661], ["1f1f5-1f1f1-fe0f", 1661], ["1f1f5-1f1f2", 1662], ["1f1f5-1f1f2-fe0f", 1662], ["1f1f5-1f1f3", 1663], ["1f1f5-1f1f3-fe0f", 1663], ["1f1f5-1f1f7", 1664], ["1f1f5-1f1f7-fe0f", 1664], ["1f1f5-1f1f8", 1665], ["1f1f5-1f1f8-fe0f", 1665], ["1f1f5-1f1f9", 1666], ["1f1f5-1f1f9-fe0f", 1666], ["1f1f5-1f1fc", 1667], ["1f1f5-1f1fc-fe0f", 1667], ["1f1f5-1f1fe", 1668], ["1f1f5-1f1fe-fe0f", 1668], ["1f1f6-1f1e6", 1669], ["1f1f6-1f1e6-fe0f", 1669], ["1f1f7-1f1ea", 1670], ["1f1f7-1f1ea-fe0f", 1670], ["1f1f7-1f1f4", 1671], ["1f1f7-1f1f4-fe0f", 1671], ["1f1f7-1f1f8", 1672], ["1f1f7-1f1f8-fe0f", 1672], ["1f1f7-1f1fa", 1673], ["1f1f7-1f1fa-fe0f", 1673], ["1f1f7-1f1fc", 1674], ["1f1f7-1f1fc-fe0f", 1674], ["1f1f8-1f1e6", 1675], ["1f1f8-1f1e6-fe0f", 1675], ["1f1f8-1f1e7", 1676], ["1f1f8-1f1e7-fe0f", 1676], ["1f1f8-1f1e8", 1677], ["1f1f8-1f1e8-fe0f", 1677], ["1f1f8-1f1e9", 1678], ["1f1f8-1f1e9-fe0f", 1678], ["1f1f8-1f1ea", 1679], ["1f1f8-1f1ea-fe0f", 1679], ["1f1f8-1f1ec", 1680], ["1f1f8-1f1ec-fe0f", 1680], ["1f1f8-1f1ed", 1681], ["1f1f8-1f1ed-fe0f", 1681], ["1f1f8-1f1ee", 1682], ["1f1f8-1f1ee-fe0f", 1682], ["1f1f8-1f1ef", 1683], ["1f1f8-1f1ef-fe0f", 1683], ["1f1f8-1f1f0", 1684], ["1f1f8-1f1f0-fe0f", 1684], ["1f1f8-1f1f1", 1685], ["1f1f8-1f1f1-fe0f", 1685], ["1f1f8-1f1f2", 1686], ["1f1f8-1f1f2-fe0f", 1686], ["1f1f8-1f1f3", 1687], ["1f1f8-1f1f3-fe0f", 1687], ["1f1f8-1f1f4", 1688], ["1f1f8-1f1f4-fe0f", 1688], ["1f1f8-1f1f7", 1689], ["1f1f8-1f1f7-fe0f", 1689], ["1f1f8-1f1f8", 1690], ["1f1f8-1f1f8-fe0f", 1690], ["1f1f8-1f1f9", 1691], ["1f1f8-1f1f9-fe0f", 1691], ["1f1f8-1f1fb", 1692], ["1f1f8-1f1fb-fe0f", 1692], ["1f1f8-1f1fd", 1693], ["1f1f8-1f1fd-fe0f", 1693], ["1f1f8-1f1fe", 1694], ["1f1f8-1f1fe-fe0f", 1694], ["1f1f8-1f1ff", 1695], ["1f1f8-1f1ff-fe0f", 1695], ["1f1f9-1f1e6", 1696], ["1f1f9-1f1e6-fe0f", 1696], ["1f1f9-1f1e8", 1697], ["1f1f9-1f1e8-fe0f", 1697], ["1f1f9-1f1e9", 1698], ["1f1f9-1f1e9-fe0f", 1698], ["1f1f9-1f1eb", 1699], ["1f1f9-1f1eb-fe0f", 1699], ["1f1f9-1f1ec", 1700], ["1f1f9-1f1ec-fe0f", 1700], ["1f1f9-1f1ed", 1701], ["1f1f9-1f1ed-fe0f", 1701], ["1f1f9-1f1ef", 1702], ["1f1f9-1f1ef-fe0f", 1702], ["1f1f9-1f1f0", 1703], ["1f1f9-1f1f0-fe0f", 1703], ["1f1f9-1f1f1", 1704], ["1f1f9-1f1f1-fe0f", 1704], ["1f1f9-1f1f2", 1705], ["1f1f9-1f1f2-fe0f", 1705], ["1f1f9-1f1f3", 1706], ["1f1f9-1f1f3-fe0f", 1706], ["1f1f9-1f1f4", 1707], ["1f1f9-1f1f4-fe0f", 1707], ["1f1f9-1f1f7", 1708], ["1f1f9-1f1f7-fe0f", 1708], ["1f1f9-1f1f9", 1709], ["1f1f9-1f1f9-fe0f", 1709], ["1f1f9-1f1fb", 1710], ["1f1f9-1f1fb-fe0f", 1710], ["1f1f9-1f1fc", 1711], ["1f1f9-1f1fc-fe0f", 1711], ["1f1f9-1f1ff", 1712], ["1f1f9-1f1ff-fe0f", 1712], ["1f1fa-1f1e6", 1713], ["1f1fa-1f1e6-fe0f", 1713], ["1f1fa-1f1ec", 1714], ["1f1fa-1f1ec-fe0f", 1714], ["1f1fa-1f1f2", 1715], ["1f1fa-1f1f2-fe0f", 1715], ["1f1fa-1f1f3", 1716], ["1f1fa-1f1f3-fe0f", 1716], ["1f1fa-1f1f8", 1717], ["1f1fa-1f1f8-fe0f", 1717], ["1f1fa-1f1fe", 1718], ["1f1fa-1f1fe-fe0f", 1718], ["1f1fa-1f1ff", 1719], ["1f1fa-1f1ff-fe0f", 1719], ["1f1fb-1f1e6", 1720], ["1f1fb-1f1e6-fe0f", 1720], ["1f1fb-1f1e8", 1721], ["1f1fb-1f1e8-fe0f", 1721], ["1f1fb-1f1ea", 1722], ["1f1fb-1f1ea-fe0f", 1722], ["1f1fb-1f1ec", 1723], ["1f1fb-1f1ec-fe0f", 1723], ["1f1fb-1f1ee", 1724], ["1f1fb-1f1ee-fe0f", 1724], ["1f1fb-1f1f3", 1725], ["1f1fb-1f1f3-fe0f", 1725], ["1f1fb-1f1fa", 1726], ["1f1fb-1f1fa-fe0f", 1726], ["1f1fc-1f1eb", 1727], ["1f1fc-1f1eb-fe0f", 1727], ["1f1fc-1f1f8", 1728], ["1f1fc-1f1f8-fe0f", 1728], ["1f1fd-1f1f0", 1729], ["1f1fd-1f1f0-fe0f", 1729], ["1f1fe-1f1ea", 1730], ["1f1fe-1f1ea-fe0f", 1730], ["1f1fe-1f1f9", 1731], ["1f1fe-1f1f9-fe0f", 1731], ["1f1ff-1f1e6", 1732], ["1f1ff-1f1e6-fe0f", 1732], ["1f1ff-1f1f2", 1733], ["1f1ff-1f1f2-fe0f", 1733], ["1f1ff-1f1fc", 1734], ["1f1ff-1f1fc-fe0f", 1734], ["1f3f4-e0067-e0062-e0065-e006e-e0067-e007f", 1735], ["1f3f4-e0067-e0062-e0065-e006e-e0067-e007f-fe0f", 1735], ["1f3f4-e0067-e0062-e0073-e0063-e0074-e007f", 1736], ["1f3f4-e0067-e0062-e0073-e0063-e0074-e007f-fe0f", 1736], ["1f3f4-e0067-e0062-e0077-e006c-e0073-e007f", 1737], ["1f3f4-e0067-e0062-e0077-e006c-e0073-e007f-fe0f", 1737], ["1f44b-1f3fb", 1739], ["1f44b-1f3fc", 1740], ["1f44b-1f3fd", 1741], ["1f44b-1f3fe", 1742], ["1f44b-1f3ff", 1743], ["1f91a-1f3fb", 1744], ["1f91a-1f3fc", 1745], ["1f91a-1f3fd", 1746], ["1f91a-1f3fe", 1747], ["1f91a-1f3ff", 1748], ["1f590-1f3fb", 1749], ["1f590-1f3fc", 1750], ["1f590-1f3fd", 1751], ["1f590-1f3fe", 1752], ["1f590-1f3ff", 1753], ["270b-1f3fb", 1754], ["270b-1f3fc", 1755], ["270b-1f3fd", 1756], ["270b-1f3fe", 1757], ["270b-1f3ff", 1758], ["1f596-1f3fb", 1759], ["1f596-1f3fc", 1760], ["1f596-1f3fd", 1761], ["1f596-1f3fe", 1762], ["1f596-1f3ff", 1763], ["1f44c-1f3fb", 1764], ["1f44c-1f3fc", 1765], ["1f44c-1f3fd", 1766], ["1f44c-1f3fe", 1767], ["1f44c-1f3ff", 1768], ["1f90f-1f3fb", 1769], ["1f90f-1f3fc", 1770], ["1f90f-1f3fd", 1771], ["1f90f-1f3fe", 1772], ["1f90f-1f3ff", 1773], ["270c-1f3fb", 1774], ["270c-1f3fc", 1775], ["270c-1f3fd", 1776], ["270c-1f3fe", 1777], ["270c-1f3ff", 1778], ["1f91e-1f3fb", 1779], ["1f91e-1f3fc", 1780], ["1f91e-1f3fd", 1781], ["1f91e-1f3fe", 1782], ["1f91e-1f3ff", 1783], ["1f91f-1f3fb", 1784], ["1f91f-1f3fc", 1785], ["1f91f-1f3fd", 1786], ["1f91f-1f3fe", 1787], ["1f91f-1f3ff", 1788], ["1f918-1f3fb", 1789], ["1f918-1f3fc", 1790], ["1f918-1f3fd", 1791], ["1f918-1f3fe", 1792], ["1f918-1f3ff", 1793], ["1f919-1f3fb", 1794], ["1f919-1f3fc", 1795], ["1f919-1f3fd", 1796], ["1f919-1f3fe", 1797], ["1f919-1f3ff", 1798], ["1f448-1f3fb", 1799], ["1f448-1f3fc", 1800], ["1f448-1f3fd", 1801], ["1f448-1f3fe", 1802], ["1f448-1f3ff", 1803], ["1f449-1f3fb", 1804], ["1f449-1f3fc", 1805], ["1f449-1f3fd", 1806], ["1f449-1f3fe", 1807], ["1f449-1f3ff", 1808], ["1f446-1f3fb", 1809], ["1f446-1f3fc", 1810], ["1f446-1f3fd", 1811], ["1f446-1f3fe", 1812], ["1f446-1f3ff", 1813], ["1f595-1f3fb", 1814], ["1f595-1f3fc", 1815], ["1f595-1f3fd", 1816], ["1f595-1f3fe", 1817], ["1f595-1f3ff", 1818], ["1f447-1f3fb", 1819], ["1f447-1f3fc", 1820], ["1f447-1f3fd", 1821], ["1f447-1f3fe", 1822], ["1f447-1f3ff", 1823], ["261d-1f3fb", 1824], ["261d-1f3fc", 1825], ["261d-1f3fd", 1826], ["261d-1f3fe", 1827], ["261d-1f3ff", 1828], ["1f44d-1f3fb", 1829], ["1f44d-1f3fc", 1830], ["1f44d-1f3fd", 1831], ["1f44d-1f3fe", 1832], ["1f44d-1f3ff", 1833], ["1f44e-1f3fb", 1834], ["1f44e-1f3fc", 1835], ["1f44e-1f3fd", 1836], ["1f44e-1f3fe", 1837], ["1f44e-1f3ff", 1838], ["270a-1f3fb", 1839], ["270a-1f3fc", 1840], ["270a-1f3fd", 1841], ["270a-1f3fe", 1842], ["270a-1f3ff", 1843], ["1f44a-1f3fb", 1844], ["1f44a-1f3fc", 1845], ["1f44a-1f3fd", 1846], ["1f44a-1f3fe", 1847], ["1f44a-1f3ff", 1848], ["1f91b-1f3fb", 1849], ["1f91b-1f3fc", 1850], ["1f91b-1f3fd", 1851], ["1f91b-1f3fe", 1852], ["1f91b-1f3ff", 1853], ["1f91c-1f3fb", 1854], ["1f91c-1f3fc", 1855], ["1f91c-1f3fd", 1856], ["1f91c-1f3fe", 1857], ["1f91c-1f3ff", 1858], ["1f44f-1f3fb", 1859], ["1f44f-1f3fc", 1860], ["1f44f-1f3fd", 1861], ["1f44f-1f3fe", 1862], ["1f44f-1f3ff", 1863], ["1f64c-1f3fb", 1864], ["1f64c-1f3fc", 1865], ["1f64c-1f3fd", 1866], ["1f64c-1f3fe", 1867], ["1f64c-1f3ff", 1868], ["1f450-1f3fb", 1869], ["1f450-1f3fc", 1870], ["1f450-1f3fd", 1871], ["1f450-1f3fe", 1872], ["1f450-1f3ff", 1873], ["1f932-1f3fb", 1874], ["1f932-1f3fc", 1875], ["1f932-1f3fd", 1876], ["1f932-1f3fe", 1877], ["1f932-1f3ff", 1878], ["1f64f-1f3fb", 1879], ["1f64f-1f3fc", 1880], ["1f64f-1f3fd", 1881], ["1f64f-1f3fe", 1882], ["1f64f-1f3ff", 1883], ["270d-1f3fb", 1884], ["270d-1f3fc", 1885], ["270d-1f3fd", 1886], ["270d-1f3fe", 1887], ["270d-1f3ff", 1888], ["1f485-1f3fb", 1889], ["1f485-1f3fc", 1890], ["1f485-1f3fd", 1891], ["1f485-1f3fe", 1892], ["1f485-1f3ff", 1893], ["1f933-1f3fb", 1894], ["1f933-1f3fc", 1895], ["1f933-1f3fd", 1896], ["1f933-1f3fe", 1897], ["1f933-1f3ff", 1898], ["1f4aa-1f3fb", 1899], ["1f4aa-1f3fc", 1900], ["1f4aa-1f3fd", 1901], ["1f4aa-1f3fe", 1902], ["1f4aa-1f3ff", 1903], ["1f9b5-1f3fb", 1904], ["1f9b5-1f3fc", 1905], ["1f9b5-1f3fd", 1906], ["1f9b5-1f3fe", 1907], ["1f9b5-1f3ff", 1908], ["1f9b6-1f3fb", 1909], ["1f9b6-1f3fc", 1910], ["1f9b6-1f3fd", 1911], ["1f9b6-1f3fe", 1912], ["1f9b6-1f3ff", 1913], ["1f442-1f3fb", 1914], ["1f442-1f3fc", 1915], ["1f442-1f3fd", 1916], ["1f442-1f3fe", 1917], ["1f442-1f3ff", 1918], ["1f9bb-1f3fb", 1919], ["1f9bb-1f3fc", 1920], ["1f9bb-1f3fd", 1921], ["1f9bb-1f3fe", 1922], ["1f9bb-1f3ff", 1923], ["1f443-1f3fb", 1924], ["1f443-1f3fc", 1925], ["1f443-1f3fd", 1926], ["1f443-1f3fe", 1927], ["1f443-1f3ff", 1928], ["1f476-1f3fb", 1929], ["1f476-1f3fc", 1930], ["1f476-1f3fd", 1931], ["1f476-1f3fe", 1932], ["1f476-1f3ff", 1933], ["1f9d2-1f3fb", 1934], ["1f9d2-1f3fc", 1935], ["1f9d2-1f3fd", 1936], ["1f9d2-1f3fe", 1937], ["1f9d2-1f3ff", 1938], ["1f466-1f3fb", 1939], ["1f466-1f3fc", 1940], ["1f466-1f3fd", 1941], ["1f466-1f3fe", 1942], ["1f466-1f3ff", 1943], ["1f467-1f3fb", 1944], ["1f467-1f3fc", 1945], ["1f467-1f3fd", 1946], ["1f467-1f3fe", 1947], ["1f467-1f3ff", 1948], ["1f9d1-1f3fb", 1949], ["1f9d1-1f3fc", 1950], ["1f9d1-1f3fd", 1951], ["1f9d1-1f3fe", 1952], ["1f9d1-1f3ff", 1953], ["1f471-1f3fb", 1954], ["1f471-1f3fc", 1955], ["1f471-1f3fd", 1956], ["1f471-1f3fe", 1957], ["1f471-1f3ff", 1958], ["1f471-1f3fb-200d-2640-fe0f", 1959], ["1f471-1f3fc-200d-2640-fe0f", 1960], ["1f471-1f3fd-200d-2640-fe0f", 1961], ["1f471-1f3fe-200d-2640-fe0f", 1962], ["1f471-1f3ff-200d-2640-fe0f", 1963], ["1f468-1f3fb", 1964], ["1f468-1f3fc", 1965], ["1f468-1f3fd", 1966], ["1f468-1f3fe", 1967], ["1f468-1f3ff", 1968], ["1f9d4-1f3fb", 1969], ["1f9d4-1f3fc", 1970], ["1f9d4-1f3fd", 1971], ["1f9d4-1f3fe", 1972], ["1f9d4-1f3ff", 1973], ["1f468-1f3fb-200d-1f9b0", 1974], ["1f468-1f3fc-200d-1f9b0", 1975], ["1f468-1f3fd-200d-1f9b0", 1976], ["1f468-1f3fe-200d-1f9b0", 1977], ["1f468-1f3ff-200d-1f9b0", 1978], ["1f468-1f3fb-200d-1f9b1", 1979], ["1f468-1f3fc-200d-1f9b1", 1980], ["1f468-1f3fd-200d-1f9b1", 1981], ["1f468-1f3fe-200d-1f9b1", 1982], ["1f468-1f3ff-200d-1f9b1", 1983], ["1f468-1f3fb-200d-1f9b3", 1984], ["1f468-1f3fc-200d-1f9b3", 1985], ["1f468-1f3fd-200d-1f9b3", 1986], ["1f468-1f3fe-200d-1f9b3", 1987], ["1f468-1f3ff-200d-1f9b3", 1988], ["1f468-1f3fb-200d-1f9b2", 1989], ["1f468-1f3fc-200d-1f9b2", 1990], ["1f468-1f3fd-200d-1f9b2", 1991], ["1f468-1f3fe-200d-1f9b2", 1992], ["1f468-1f3ff-200d-1f9b2", 1993], ["1f469-1f3fb", 1994], ["1f469-1f3fc", 1995], ["1f469-1f3fd", 1996], ["1f469-1f3fe", 1997], ["1f469-1f3ff", 1998], ["1f469-1f3fb-200d-1f9b0", 1999], ["1f469-1f3fc-200d-1f9b0", 2000], ["1f469-1f3fd-200d-1f9b0", 2001], ["1f469-1f3fe-200d-1f9b0", 2002], ["1f469-1f3ff-200d-1f9b0", 2003], ["1f9d1-1f3fb-200d-1f9b0", 2004], ["1f9d1-1f3fc-200d-1f9b0", 2005], ["1f9d1-1f3fd-200d-1f9b0", 2006], ["1f9d1-1f3fe-200d-1f9b0", 2007], ["1f9d1-1f3ff-200d-1f9b0", 2008], ["1f469-1f3fb-200d-1f9b1", 2009], ["1f469-1f3fc-200d-1f9b1", 2010], ["1f469-1f3fd-200d-1f9b1", 2011], ["1f469-1f3fe-200d-1f9b1", 2012], ["1f469-1f3ff-200d-1f9b1", 2013], ["1f9d1-1f3fb-200d-1f9b1", 2014], ["1f9d1-1f3fc-200d-1f9b1", 2015], ["1f9d1-1f3fd-200d-1f9b1", 2016], ["1f9d1-1f3fe-200d-1f9b1", 2017], ["1f9d1-1f3ff-200d-1f9b1", 2018], ["1f469-1f3fb-200d-1f9b3", 2019], ["1f469-1f3fc-200d-1f9b3", 2020], ["1f469-1f3fd-200d-1f9b3", 2021], ["1f469-1f3fe-200d-1f9b3", 2022], ["1f469-1f3ff-200d-1f9b3", 2023], ["1f9d1-1f3fb-200d-1f9b3", 2024], ["1f9d1-1f3fc-200d-1f9b3", 2025], ["1f9d1-1f3fd-200d-1f9b3", 2026], ["1f9d1-1f3fe-200d-1f9b3", 2027], ["1f9d1-1f3ff-200d-1f9b3", 2028], ["1f469-1f3fb-200d-1f9b2", 2029], ["1f469-1f3fc-200d-1f9b2", 2030], ["1f469-1f3fd-200d-1f9b2", 2031], ["1f469-1f3fe-200d-1f9b2", 2032], ["1f469-1f3ff-200d-1f9b2", 2033], ["1f9d1-1f3fb-200d-1f9b2", 2034], ["1f9d1-1f3fc-200d-1f9b2", 2035], ["1f9d1-1f3fd-200d-1f9b2", 2036], ["1f9d1-1f3fe-200d-1f9b2", 2037], ["1f9d1-1f3ff-200d-1f9b2", 2038], ["1f471-1f3fb-200d-2640-fe0f", 2039], ["1f471-1f3fc-200d-2640-fe0f", 2040], ["1f471-1f3fd-200d-2640-fe0f", 2041], ["1f471-1f3fe-200d-2640-fe0f", 2042], ["1f471-1f3ff-200d-2640-fe0f", 2043], ["1f471-1f3fb-200d-2642-fe0f", 2044], ["1f471-1f3fc-200d-2642-fe0f", 2045], ["1f471-1f3fd-200d-2642-fe0f", 2046], ["1f471-1f3fe-200d-2642-fe0f", 2047], ["1f471-1f3ff-200d-2642-fe0f", 2048], ["1f9d3-1f3fb", 2049], ["1f9d3-1f3fc", 2050], ["1f9d3-1f3fd", 2051], ["1f9d3-1f3fe", 2052], ["1f9d3-1f3ff", 2053], ["1f474-1f3fb", 2054], ["1f474-1f3fc", 2055], ["1f474-1f3fd", 2056], ["1f474-1f3fe", 2057], ["1f474-1f3ff", 2058], ["1f475-1f3fb", 2059], ["1f475-1f3fc", 2060], ["1f475-1f3fd", 2061], ["1f475-1f3fe", 2062], ["1f475-1f3ff", 2063], ["1f64d-1f3fb", 2064], ["1f64d-1f3fc", 2065], ["1f64d-1f3fd", 2066], ["1f64d-1f3fe", 2067], ["1f64d-1f3ff", 2068], ["1f64d-1f3fb-200d-2642-fe0f", 2069], ["1f64d-1f3fc-200d-2642-fe0f", 2070], ["1f64d-1f3fd-200d-2642-fe0f", 2071], ["1f64d-1f3fe-200d-2642-fe0f", 2072], ["1f64d-1f3ff-200d-2642-fe0f", 2073], ["1f64d-1f3fb-200d-2640-fe0f", 2074], ["1f64d-1f3fc-200d-2640-fe0f", 2075], ["1f64d-1f3fd-200d-2640-fe0f", 2076], ["1f64d-1f3fe-200d-2640-fe0f", 2077], ["1f64d-1f3ff-200d-2640-fe0f", 2078], ["1f64e-1f3fb", 2079], ["1f64e-1f3fc", 2080], ["1f64e-1f3fd", 2081], ["1f64e-1f3fe", 2082], ["1f64e-1f3ff", 2083], ["1f64e-1f3fb-200d-2642-fe0f", 2084], ["1f64e-1f3fc-200d-2642-fe0f", 2085], ["1f64e-1f3fd-200d-2642-fe0f", 2086], ["1f64e-1f3fe-200d-2642-fe0f", 2087], ["1f64e-1f3ff-200d-2642-fe0f", 2088], ["1f64e-1f3fb-200d-2640-fe0f", 2089], ["1f64e-1f3fc-200d-2640-fe0f", 2090], ["1f64e-1f3fd-200d-2640-fe0f", 2091], ["1f64e-1f3fe-200d-2640-fe0f", 2092], ["1f64e-1f3ff-200d-2640-fe0f", 2093], ["1f645-1f3fb", 2094], ["1f645-1f3fc", 2095], ["1f645-1f3fd", 2096], ["1f645-1f3fe", 2097], ["1f645-1f3ff", 2098], ["1f645-1f3fb-200d-2642-fe0f", 2099], ["1f645-1f3fc-200d-2642-fe0f", 2100], ["1f645-1f3fd-200d-2642-fe0f", 2101], ["1f645-1f3fe-200d-2642-fe0f", 2102], ["1f645-1f3ff-200d-2642-fe0f", 2103], ["1f645-1f3fb-200d-2640-fe0f", 2104], ["1f645-1f3fc-200d-2640-fe0f", 2105], ["1f645-1f3fd-200d-2640-fe0f", 2106], ["1f645-1f3fe-200d-2640-fe0f", 2107], ["1f645-1f3ff-200d-2640-fe0f", 2108], ["1f646-1f3fb", 2109], ["1f646-1f3fc", 2110], ["1f646-1f3fd", 2111], ["1f646-1f3fe", 2112], ["1f646-1f3ff", 2113], ["1f646-1f3fb-200d-2642-fe0f", 2114], ["1f646-1f3fc-200d-2642-fe0f", 2115], ["1f646-1f3fd-200d-2642-fe0f", 2116], ["1f646-1f3fe-200d-2642-fe0f", 2117], ["1f646-1f3ff-200d-2642-fe0f", 2118], ["1f646-1f3fb-200d-2640-fe0f", 2119], ["1f646-1f3fc-200d-2640-fe0f", 2120], ["1f646-1f3fd-200d-2640-fe0f", 2121], ["1f646-1f3fe-200d-2640-fe0f", 2122], ["1f646-1f3ff-200d-2640-fe0f", 2123], ["1f481-1f3fb", 2124], ["1f481-1f3fc", 2125], ["1f481-1f3fd", 2126], ["1f481-1f3fe", 2127], ["1f481-1f3ff", 2128], ["1f481-1f3fb-200d-2642-fe0f", 2129], ["1f481-1f3fc-200d-2642-fe0f", 2130], ["1f481-1f3fd-200d-2642-fe0f", 2131], ["1f481-1f3fe-200d-2642-fe0f", 2132], ["1f481-1f3ff-200d-2642-fe0f", 2133], ["1f481-1f3fb-200d-2640-fe0f", 2134], ["1f481-1f3fc-200d-2640-fe0f", 2135], ["1f481-1f3fd-200d-2640-fe0f", 2136], ["1f481-1f3fe-200d-2640-fe0f", 2137], ["1f481-1f3ff-200d-2640-fe0f", 2138], ["1f64b-1f3fb", 2139], ["1f64b-1f3fc", 2140], ["1f64b-1f3fd", 2141], ["1f64b-1f3fe", 2142], ["1f64b-1f3ff", 2143], ["1f64b-1f3fb-200d-2642-fe0f", 2144], ["1f64b-1f3fc-200d-2642-fe0f", 2145], ["1f64b-1f3fd-200d-2642-fe0f", 2146], ["1f64b-1f3fe-200d-2642-fe0f", 2147], ["1f64b-1f3ff-200d-2642-fe0f", 2148], ["1f64b-1f3fb-200d-2640-fe0f", 2149], ["1f64b-1f3fc-200d-2640-fe0f", 2150], ["1f64b-1f3fd-200d-2640-fe0f", 2151], ["1f64b-1f3fe-200d-2640-fe0f", 2152], ["1f64b-1f3ff-200d-2640-fe0f", 2153], ["1f9cf-1f3fb", 2154], ["1f9cf-1f3fc", 2155], ["1f9cf-1f3fd", 2156], ["1f9cf-1f3fe", 2157], ["1f9cf-1f3ff", 2158], ["1f9cf-1f3fb-200d-2642-fe0f", 2159], ["1f9cf-1f3fc-200d-2642-fe0f", 2160], ["1f9cf-1f3fd-200d-2642-fe0f", 2161], ["1f9cf-1f3fe-200d-2642-fe0f", 2162], ["1f9cf-1f3ff-200d-2642-fe0f", 2163], ["1f9cf-1f3fb-200d-2640-fe0f", 2164], ["1f9cf-1f3fc-200d-2640-fe0f", 2165], ["1f9cf-1f3fd-200d-2640-fe0f", 2166], ["1f9cf-1f3fe-200d-2640-fe0f", 2167], ["1f9cf-1f3ff-200d-2640-fe0f", 2168], ["1f647-1f3fb", 2169], ["1f647-1f3fc", 2170], ["1f647-1f3fd", 2171], ["1f647-1f3fe", 2172], ["1f647-1f3ff", 2173], ["1f647-1f3fb-200d-2642-fe0f", 2174], ["1f647-1f3fc-200d-2642-fe0f", 2175], ["1f647-1f3fd-200d-2642-fe0f", 2176], ["1f647-1f3fe-200d-2642-fe0f", 2177], ["1f647-1f3ff-200d-2642-fe0f", 2178], ["1f647-1f3fb-200d-2640-fe0f", 2179], ["1f647-1f3fc-200d-2640-fe0f", 2180], ["1f647-1f3fd-200d-2640-fe0f", 2181], ["1f647-1f3fe-200d-2640-fe0f", 2182], ["1f647-1f3ff-200d-2640-fe0f", 2183], ["1f926-1f3fb", 2184], ["1f926-1f3fc", 2185], ["1f926-1f3fd", 2186], ["1f926-1f3fe", 2187], ["1f926-1f3ff", 2188], ["1f926-1f3fb-200d-2642-fe0f", 2189], ["1f926-1f3fc-200d-2642-fe0f", 2190], ["1f926-1f3fd-200d-2642-fe0f", 2191], ["1f926-1f3fe-200d-2642-fe0f", 2192], ["1f926-1f3ff-200d-2642-fe0f", 2193], ["1f926-1f3fb-200d-2640-fe0f", 2194], ["1f926-1f3fc-200d-2640-fe0f", 2195], ["1f926-1f3fd-200d-2640-fe0f", 2196], ["1f926-1f3fe-200d-2640-fe0f", 2197], ["1f926-1f3ff-200d-2640-fe0f", 2198], ["1f937-1f3fb", 2199], ["1f937-1f3fc", 2200], ["1f937-1f3fd", 2201], ["1f937-1f3fe", 2202], ["1f937-1f3ff", 2203], ["1f937-1f3fb-200d-2642-fe0f", 2204], ["1f937-1f3fc-200d-2642-fe0f", 2205], ["1f937-1f3fd-200d-2642-fe0f", 2206], ["1f937-1f3fe-200d-2642-fe0f", 2207], ["1f937-1f3ff-200d-2642-fe0f", 2208], ["1f937-1f3fb-200d-2640-fe0f", 2209], ["1f937-1f3fc-200d-2640-fe0f", 2210], ["1f937-1f3fd-200d-2640-fe0f", 2211], ["1f937-1f3fe-200d-2640-fe0f", 2212], ["1f937-1f3ff-200d-2640-fe0f", 2213], ["1f9d1-1f3fb-200d-2695-fe0f", 2214], ["1f9d1-1f3fc-200d-2695-fe0f", 2215], ["1f9d1-1f3fd-200d-2695-fe0f", 2216], ["1f9d1-1f3fe-200d-2695-fe0f", 2217], ["1f9d1-1f3ff-200d-2695-fe0f", 2218], ["1f468-1f3fb-200d-2695-fe0f", 2219], ["1f468-1f3fc-200d-2695-fe0f", 2220], ["1f468-1f3fd-200d-2695-fe0f", 2221], ["1f468-1f3fe-200d-2695-fe0f", 2222], ["1f468-1f3ff-200d-2695-fe0f", 2223], ["1f469-1f3fb-200d-2695-fe0f", 2224], ["1f469-1f3fc-200d-2695-fe0f", 2225], ["1f469-1f3fd-200d-2695-fe0f", 2226], ["1f469-1f3fe-200d-2695-fe0f", 2227], ["1f469-1f3ff-200d-2695-fe0f", 2228], ["1f9d1-1f3fb-200d-1f393", 2229], ["1f9d1-1f3fc-200d-1f393", 2230], ["1f9d1-1f3fd-200d-1f393", 2231], ["1f9d1-1f3fe-200d-1f393", 2232], ["1f9d1-1f3ff-200d-1f393", 2233], ["1f468-1f3fb-200d-1f393", 2234], ["1f468-1f3fc-200d-1f393", 2235], ["1f468-1f3fd-200d-1f393", 2236], ["1f468-1f3fe-200d-1f393", 2237], ["1f468-1f3ff-200d-1f393", 2238], ["1f469-1f3fb-200d-1f393", 2239], ["1f469-1f3fc-200d-1f393", 2240], ["1f469-1f3fd-200d-1f393", 2241], ["1f469-1f3fe-200d-1f393", 2242], ["1f469-1f3ff-200d-1f393", 2243], ["1f9d1-1f3fb-200d-1f3eb", 2244], ["1f9d1-1f3fc-200d-1f3eb", 2245], ["1f9d1-1f3fd-200d-1f3eb", 2246], ["1f9d1-1f3fe-200d-1f3eb", 2247], ["1f9d1-1f3ff-200d-1f3eb", 2248], ["1f468-1f3fb-200d-1f3eb", 2249], ["1f468-1f3fc-200d-1f3eb", 2250], ["1f468-1f3fd-200d-1f3eb", 2251], ["1f468-1f3fe-200d-1f3eb", 2252], ["1f468-1f3ff-200d-1f3eb", 2253], ["1f469-1f3fb-200d-1f3eb", 2254], ["1f469-1f3fc-200d-1f3eb", 2255], ["1f469-1f3fd-200d-1f3eb", 2256], ["1f469-1f3fe-200d-1f3eb", 2257], ["1f469-1f3ff-200d-1f3eb", 2258], ["1f9d1-1f3fb-200d-2696-fe0f", 2259], ["1f9d1-1f3fc-200d-2696-fe0f", 2260], ["1f9d1-1f3fd-200d-2696-fe0f", 2261], ["1f9d1-1f3fe-200d-2696-fe0f", 2262], ["1f9d1-1f3ff-200d-2696-fe0f", 2263], ["1f468-1f3fb-200d-2696-fe0f", 2264], ["1f468-1f3fc-200d-2696-fe0f", 2265], ["1f468-1f3fd-200d-2696-fe0f", 2266], ["1f468-1f3fe-200d-2696-fe0f", 2267], ["1f468-1f3ff-200d-2696-fe0f", 2268], ["1f469-1f3fb-200d-2696-fe0f", 2269], ["1f469-1f3fc-200d-2696-fe0f", 2270], ["1f469-1f3fd-200d-2696-fe0f", 2271], ["1f469-1f3fe-200d-2696-fe0f", 2272], ["1f469-1f3ff-200d-2696-fe0f", 2273], ["1f9d1-1f3fb-200d-1f33e", 2274], ["1f9d1-1f3fc-200d-1f33e", 2275], ["1f9d1-1f3fd-200d-1f33e", 2276], ["1f9d1-1f3fe-200d-1f33e", 2277], ["1f9d1-1f3ff-200d-1f33e", 2278], ["1f468-1f3fb-200d-1f33e", 2279], ["1f468-1f3fc-200d-1f33e", 2280], ["1f468-1f3fd-200d-1f33e", 2281], ["1f468-1f3fe-200d-1f33e", 2282], ["1f468-1f3ff-200d-1f33e", 2283], ["1f469-1f3fb-200d-1f33e", 2284], ["1f469-1f3fc-200d-1f33e", 2285], ["1f469-1f3fd-200d-1f33e", 2286], ["1f469-1f3fe-200d-1f33e", 2287], ["1f469-1f3ff-200d-1f33e", 2288], ["1f9d1-1f3fb-200d-1f373", 2289], ["1f9d1-1f3fc-200d-1f373", 2290], ["1f9d1-1f3fd-200d-1f373", 2291], ["1f9d1-1f3fe-200d-1f373", 2292], ["1f9d1-1f3ff-200d-1f373", 2293], ["1f468-1f3fb-200d-1f373", 2294], ["1f468-1f3fc-200d-1f373", 2295], ["1f468-1f3fd-200d-1f373", 2296], ["1f468-1f3fe-200d-1f373", 2297], ["1f468-1f3ff-200d-1f373", 2298], ["1f469-1f3fb-200d-1f373", 2299], ["1f469-1f3fc-200d-1f373", 2300], ["1f469-1f3fd-200d-1f373", 2301], ["1f469-1f3fe-200d-1f373", 2302], ["1f469-1f3ff-200d-1f373", 2303], ["1f9d1-1f3fb-200d-1f527", 2304], ["1f9d1-1f3fc-200d-1f527", 2305], ["1f9d1-1f3fd-200d-1f527", 2306], ["1f9d1-1f3fe-200d-1f527", 2307], ["1f9d1-1f3ff-200d-1f527", 2308], ["1f468-1f3fb-200d-1f527", 2309], ["1f468-1f3fc-200d-1f527", 2310], ["1f468-1f3fd-200d-1f527", 2311], ["1f468-1f3fe-200d-1f527", 2312], ["1f468-1f3ff-200d-1f527", 2313], ["1f469-1f3fb-200d-1f527", 2314], ["1f469-1f3fc-200d-1f527", 2315], ["1f469-1f3fd-200d-1f527", 2316], ["1f469-1f3fe-200d-1f527", 2317], ["1f469-1f3ff-200d-1f527", 2318], ["1f9d1-1f3fb-200d-1f3ed", 2319], ["1f9d1-1f3fc-200d-1f3ed", 2320], ["1f9d1-1f3fd-200d-1f3ed", 2321], ["1f9d1-1f3fe-200d-1f3ed", 2322], ["1f9d1-1f3ff-200d-1f3ed", 2323], ["1f468-1f3fb-200d-1f3ed", 2324], ["1f468-1f3fc-200d-1f3ed", 2325], ["1f468-1f3fd-200d-1f3ed", 2326], ["1f468-1f3fe-200d-1f3ed", 2327], ["1f468-1f3ff-200d-1f3ed", 2328], ["1f469-1f3fb-200d-1f3ed", 2329], ["1f469-1f3fc-200d-1f3ed", 2330], ["1f469-1f3fd-200d-1f3ed", 2331], ["1f469-1f3fe-200d-1f3ed", 2332], ["1f469-1f3ff-200d-1f3ed", 2333], ["1f9d1-1f3fb-200d-1f4bc", 2334], ["1f9d1-1f3fc-200d-1f4bc", 2335], ["1f9d1-1f3fd-200d-1f4bc", 2336], ["1f9d1-1f3fe-200d-1f4bc", 2337], ["1f9d1-1f3ff-200d-1f4bc", 2338], ["1f468-1f3fb-200d-1f4bc", 2339], ["1f468-1f3fc-200d-1f4bc", 2340], ["1f468-1f3fd-200d-1f4bc", 2341], ["1f468-1f3fe-200d-1f4bc", 2342], ["1f468-1f3ff-200d-1f4bc", 2343], ["1f469-1f3fb-200d-1f4bc", 2344], ["1f469-1f3fc-200d-1f4bc", 2345], ["1f469-1f3fd-200d-1f4bc", 2346], ["1f469-1f3fe-200d-1f4bc", 2347], ["1f469-1f3ff-200d-1f4bc", 2348], ["1f9d1-1f3fb-200d-1f52c", 2349], ["1f9d1-1f3fc-200d-1f52c", 2350], ["1f9d1-1f3fd-200d-1f52c", 2351], ["1f9d1-1f3fe-200d-1f52c", 2352], ["1f9d1-1f3ff-200d-1f52c", 2353], ["1f468-1f3fb-200d-1f52c", 2354], ["1f468-1f3fc-200d-1f52c", 2355], ["1f468-1f3fd-200d-1f52c", 2356], ["1f468-1f3fe-200d-1f52c", 2357], ["1f468-1f3ff-200d-1f52c", 2358], ["1f469-1f3fb-200d-1f52c", 2359], ["1f469-1f3fc-200d-1f52c", 2360], ["1f469-1f3fd-200d-1f52c", 2361], ["1f469-1f3fe-200d-1f52c", 2362], ["1f469-1f3ff-200d-1f52c", 2363], ["1f9d1-1f3fb-200d-1f4bb", 2364], ["1f9d1-1f3fc-200d-1f4bb", 2365], ["1f9d1-1f3fd-200d-1f4bb", 2366], ["1f9d1-1f3fe-200d-1f4bb", 2367], ["1f9d1-1f3ff-200d-1f4bb", 2368], ["1f468-1f3fb-200d-1f4bb", 2369], ["1f468-1f3fc-200d-1f4bb", 2370], ["1f468-1f3fd-200d-1f4bb", 2371], ["1f468-1f3fe-200d-1f4bb", 2372], ["1f468-1f3ff-200d-1f4bb", 2373], ["1f469-1f3fb-200d-1f4bb", 2374], ["1f469-1f3fc-200d-1f4bb", 2375], ["1f469-1f3fd-200d-1f4bb", 2376], ["1f469-1f3fe-200d-1f4bb", 2377], ["1f469-1f3ff-200d-1f4bb", 2378], ["1f9d1-1f3fb-200d-1f3a4", 2379], ["1f9d1-1f3fc-200d-1f3a4", 2380], ["1f9d1-1f3fd-200d-1f3a4", 2381], ["1f9d1-1f3fe-200d-1f3a4", 2382], ["1f9d1-1f3ff-200d-1f3a4", 2383], ["1f468-1f3fb-200d-1f3a4", 2384], ["1f468-1f3fc-200d-1f3a4", 2385], ["1f468-1f3fd-200d-1f3a4", 2386], ["1f468-1f3fe-200d-1f3a4", 2387], ["1f468-1f3ff-200d-1f3a4", 2388], ["1f469-1f3fb-200d-1f3a4", 2389], ["1f469-1f3fc-200d-1f3a4", 2390], ["1f469-1f3fd-200d-1f3a4", 2391], ["1f469-1f3fe-200d-1f3a4", 2392], ["1f469-1f3ff-200d-1f3a4", 2393], ["1f9d1-1f3fb-200d-1f3a8", 2394], ["1f9d1-1f3fc-200d-1f3a8", 2395], ["1f9d1-1f3fd-200d-1f3a8", 2396], ["1f9d1-1f3fe-200d-1f3a8", 2397], ["1f9d1-1f3ff-200d-1f3a8", 2398], ["1f468-1f3fb-200d-1f3a8", 2399], ["1f468-1f3fc-200d-1f3a8", 2400], ["1f468-1f3fd-200d-1f3a8", 2401], ["1f468-1f3fe-200d-1f3a8", 2402], ["1f468-1f3ff-200d-1f3a8", 2403], ["1f469-1f3fb-200d-1f3a8", 2404], ["1f469-1f3fc-200d-1f3a8", 2405], ["1f469-1f3fd-200d-1f3a8", 2406], ["1f469-1f3fe-200d-1f3a8", 2407], ["1f469-1f3ff-200d-1f3a8", 2408], ["1f9d1-1f3fb-200d-2708-fe0f", 2409], ["1f9d1-1f3fc-200d-2708-fe0f", 2410], ["1f9d1-1f3fd-200d-2708-fe0f", 2411], ["1f9d1-1f3fe-200d-2708-fe0f", 2412], ["1f9d1-1f3ff-200d-2708-fe0f", 2413], ["1f468-1f3fb-200d-2708-fe0f", 2414], ["1f468-1f3fc-200d-2708-fe0f", 2415], ["1f468-1f3fd-200d-2708-fe0f", 2416], ["1f468-1f3fe-200d-2708-fe0f", 2417], ["1f468-1f3ff-200d-2708-fe0f", 2418], ["1f469-1f3fb-200d-2708-fe0f", 2419], ["1f469-1f3fc-200d-2708-fe0f", 2420], ["1f469-1f3fd-200d-2708-fe0f", 2421], ["1f469-1f3fe-200d-2708-fe0f", 2422], ["1f469-1f3ff-200d-2708-fe0f", 2423], ["1f9d1-1f3fb-200d-1f680", 2424], ["1f9d1-1f3fc-200d-1f680", 2425], ["1f9d1-1f3fd-200d-1f680", 2426], ["1f9d1-1f3fe-200d-1f680", 2427], ["1f9d1-1f3ff-200d-1f680", 2428], ["1f468-1f3fb-200d-1f680", 2429], ["1f468-1f3fc-200d-1f680", 2430], ["1f468-1f3fd-200d-1f680", 2431], ["1f468-1f3fe-200d-1f680", 2432], ["1f468-1f3ff-200d-1f680", 2433], ["1f469-1f3fb-200d-1f680", 2434], ["1f469-1f3fc-200d-1f680", 2435], ["1f469-1f3fd-200d-1f680", 2436], ["1f469-1f3fe-200d-1f680", 2437], ["1f469-1f3ff-200d-1f680", 2438], ["1f9d1-1f3fb-200d-1f692", 2439], ["1f9d1-1f3fc-200d-1f692", 2440], ["1f9d1-1f3fd-200d-1f692", 2441], ["1f9d1-1f3fe-200d-1f692", 2442], ["1f9d1-1f3ff-200d-1f692", 2443], ["1f468-1f3fb-200d-1f692", 2444], ["1f468-1f3fc-200d-1f692", 2445], ["1f468-1f3fd-200d-1f692", 2446], ["1f468-1f3fe-200d-1f692", 2447], ["1f468-1f3ff-200d-1f692", 2448], ["1f469-1f3fb-200d-1f692", 2449], ["1f469-1f3fc-200d-1f692", 2450], ["1f469-1f3fd-200d-1f692", 2451], ["1f469-1f3fe-200d-1f692", 2452], ["1f469-1f3ff-200d-1f692", 2453], ["1f46e-1f3fb", 2454], ["1f46e-1f3fc", 2455], ["1f46e-1f3fd", 2456], ["1f46e-1f3fe", 2457], ["1f46e-1f3ff", 2458], ["1f46e-1f3fb-200d-2642-fe0f", 2459], ["1f46e-1f3fc-200d-2642-fe0f", 2460], ["1f46e-1f3fd-200d-2642-fe0f", 2461], ["1f46e-1f3fe-200d-2642-fe0f", 2462], ["1f46e-1f3ff-200d-2642-fe0f", 2463], ["1f46e-1f3fb-200d-2640-fe0f", 2464], ["1f46e-1f3fc-200d-2640-fe0f", 2465], ["1f46e-1f3fd-200d-2640-fe0f", 2466], ["1f46e-1f3fe-200d-2640-fe0f", 2467], ["1f46e-1f3ff-200d-2640-fe0f", 2468], ["1f575-1f3fb", 2469], ["1f575-1f3fc", 2470], ["1f575-1f3fd", 2471], ["1f575-1f3fe", 2472], ["1f575-1f3ff", 2473], ["1f575-1f3fb-200d-2642-fe0f", 2474], ["1f575-1f3fc-200d-2642-fe0f", 2475], ["1f575-1f3fd-200d-2642-fe0f", 2476], ["1f575-1f3fe-200d-2642-fe0f", 2477], ["1f575-1f3ff-200d-2642-fe0f", 2478], ["1f575-1f3fb-200d-2640-fe0f", 2479], ["1f575-1f3fc-200d-2640-fe0f", 2480], ["1f575-1f3fd-200d-2640-fe0f", 2481], ["1f575-1f3fe-200d-2640-fe0f", 2482], ["1f575-1f3ff-200d-2640-fe0f", 2483], ["1f482-1f3fb", 2484], ["1f482-1f3fc", 2485], ["1f482-1f3fd", 2486], ["1f482-1f3fe", 2487], ["1f482-1f3ff", 2488], ["1f482-1f3fb-200d-2642-fe0f", 2489], ["1f482-1f3fc-200d-2642-fe0f", 2490], ["1f482-1f3fd-200d-2642-fe0f", 2491], ["1f482-1f3fe-200d-2642-fe0f", 2492], ["1f482-1f3ff-200d-2642-fe0f", 2493], ["1f482-1f3fb-200d-2640-fe0f", 2494], ["1f482-1f3fc-200d-2640-fe0f", 2495], ["1f482-1f3fd-200d-2640-fe0f", 2496], ["1f482-1f3fe-200d-2640-fe0f", 2497], ["1f482-1f3ff-200d-2640-fe0f", 2498], ["1f477-1f3fb", 2499], ["1f477-1f3fc", 2500], ["1f477-1f3fd", 2501], ["1f477-1f3fe", 2502], ["1f477-1f3ff", 2503], ["1f477-1f3fb-200d-2642-fe0f", 2504], ["1f477-1f3fc-200d-2642-fe0f", 2505], ["1f477-1f3fd-200d-2642-fe0f", 2506], ["1f477-1f3fe-200d-2642-fe0f", 2507], ["1f477-1f3ff-200d-2642-fe0f", 2508], ["1f477-1f3fb-200d-2640-fe0f", 2509], ["1f477-1f3fc-200d-2640-fe0f", 2510], ["1f477-1f3fd-200d-2640-fe0f", 2511], ["1f477-1f3fe-200d-2640-fe0f", 2512], ["1f477-1f3ff-200d-2640-fe0f", 2513], ["1f934-1f3fb", 2514], ["1f934-1f3fc", 2515], ["1f934-1f3fd", 2516], ["1f934-1f3fe", 2517], ["1f934-1f3ff", 2518], ["1f478-1f3fb", 2519], ["1f478-1f3fc", 2520], ["1f478-1f3fd", 2521], ["1f478-1f3fe", 2522], ["1f478-1f3ff", 2523], ["1f473-1f3fb", 2524], ["1f473-1f3fc", 2525], ["1f473-1f3fd", 2526], ["1f473-1f3fe", 2527], ["1f473-1f3ff", 2528], ["1f473-1f3fb-200d-2642-fe0f", 2529], ["1f473-1f3fc-200d-2642-fe0f", 2530], ["1f473-1f3fd-200d-2642-fe0f", 2531], ["1f473-1f3fe-200d-2642-fe0f", 2532], ["1f473-1f3ff-200d-2642-fe0f", 2533], ["1f473-1f3fb-200d-2640-fe0f", 2534], ["1f473-1f3fc-200d-2640-fe0f", 2535], ["1f473-1f3fd-200d-2640-fe0f", 2536], ["1f473-1f3fe-200d-2640-fe0f", 2537], ["1f473-1f3ff-200d-2640-fe0f", 2538], ["1f472-1f3fb", 2539], ["1f472-1f3fc", 2540], ["1f472-1f3fd", 2541], ["1f472-1f3fe", 2542], ["1f472-1f3ff", 2543], ["1f9d5-1f3fb", 2544], ["1f9d5-1f3fc", 2545], ["1f9d5-1f3fd", 2546], ["1f9d5-1f3fe", 2547], ["1f9d5-1f3ff", 2548], ["1f935-1f3fb", 2549], ["1f935-1f3fc", 2550], ["1f935-1f3fd", 2551], ["1f935-1f3fe", 2552], ["1f935-1f3ff", 2553], ["1f470-1f3fb", 2554], ["1f470-1f3fc", 2555], ["1f470-1f3fd", 2556], ["1f470-1f3fe", 2557], ["1f470-1f3ff", 2558], ["1f930-1f3fb", 2559], ["1f930-1f3fc", 2560], ["1f930-1f3fd", 2561], ["1f930-1f3fe", 2562], ["1f930-1f3ff", 2563], ["1f931-1f3fb", 2564], ["1f931-1f3fc", 2565], ["1f931-1f3fd", 2566], ["1f931-1f3fe", 2567], ["1f931-1f3ff", 2568], ["1f47c-1f3fb", 2569], ["1f47c-1f3fc", 2570], ["1f47c-1f3fd", 2571], ["1f47c-1f3fe", 2572], ["1f47c-1f3ff", 2573], ["1f385-1f3fb", 2574], ["1f385-1f3fc", 2575], ["1f385-1f3fd", 2576], ["1f385-1f3fe", 2577], ["1f385-1f3ff", 2578], ["1f936-1f3fb", 2579], ["1f936-1f3fc", 2580], ["1f936-1f3fd", 2581], ["1f936-1f3fe", 2582], ["1f936-1f3ff", 2583], ["1f9b8-1f3fb", 2584], ["1f9b8-1f3fc", 2585], ["1f9b8-1f3fd", 2586], ["1f9b8-1f3fe", 2587], ["1f9b8-1f3ff", 2588], ["1f9b8-1f3fb-200d-2642-fe0f", 2589], ["1f9b8-1f3fc-200d-2642-fe0f", 2590], ["1f9b8-1f3fd-200d-2642-fe0f", 2591], ["1f9b8-1f3fe-200d-2642-fe0f", 2592], ["1f9b8-1f3ff-200d-2642-fe0f", 2593], ["1f9b8-1f3fb-200d-2640-fe0f", 2594], ["1f9b8-1f3fc-200d-2640-fe0f", 2595], ["1f9b8-1f3fd-200d-2640-fe0f", 2596], ["1f9b8-1f3fe-200d-2640-fe0f", 2597], ["1f9b8-1f3ff-200d-2640-fe0f", 2598], ["1f9b9-1f3fb", 2599], ["1f9b9-1f3fc", 2600], ["1f9b9-1f3fd", 2601], ["1f9b9-1f3fe", 2602], ["1f9b9-1f3ff", 2603], ["1f9b9-1f3fb-200d-2642-fe0f", 2604], ["1f9b9-1f3fc-200d-2642-fe0f", 2605], ["1f9b9-1f3fd-200d-2642-fe0f", 2606], ["1f9b9-1f3fe-200d-2642-fe0f", 2607], ["1f9b9-1f3ff-200d-2642-fe0f", 2608], ["1f9b9-1f3fb-200d-2640-fe0f", 2609], ["1f9b9-1f3fc-200d-2640-fe0f", 2610], ["1f9b9-1f3fd-200d-2640-fe0f", 2611], ["1f9b9-1f3fe-200d-2640-fe0f", 2612], ["1f9b9-1f3ff-200d-2640-fe0f", 2613], ["1f9d9-1f3fb", 2614], ["1f9d9-1f3fc", 2615], ["1f9d9-1f3fd", 2616], ["1f9d9-1f3fe", 2617], ["1f9d9-1f3ff", 2618], ["1f9d9-1f3fb-200d-2642-fe0f", 2619], ["1f9d9-1f3fc-200d-2642-fe0f", 2620], ["1f9d9-1f3fd-200d-2642-fe0f", 2621], ["1f9d9-1f3fe-200d-2642-fe0f", 2622], ["1f9d9-1f3ff-200d-2642-fe0f", 2623], ["1f9d9-1f3fb-200d-2640-fe0f", 2624], ["1f9d9-1f3fc-200d-2640-fe0f", 2625], ["1f9d9-1f3fd-200d-2640-fe0f", 2626], ["1f9d9-1f3fe-200d-2640-fe0f", 2627], ["1f9d9-1f3ff-200d-2640-fe0f", 2628], ["1f9da-1f3fb", 2629], ["1f9da-1f3fc", 2630], ["1f9da-1f3fd", 2631], ["1f9da-1f3fe", 2632], ["1f9da-1f3ff", 2633], ["1f9da-1f3fb-200d-2642-fe0f", 2634], ["1f9da-1f3fc-200d-2642-fe0f", 2635], ["1f9da-1f3fd-200d-2642-fe0f", 2636], ["1f9da-1f3fe-200d-2642-fe0f", 2637], ["1f9da-1f3ff-200d-2642-fe0f", 2638], ["1f9da-1f3fb-200d-2640-fe0f", 2639], ["1f9da-1f3fc-200d-2640-fe0f", 2640], ["1f9da-1f3fd-200d-2640-fe0f", 2641], ["1f9da-1f3fe-200d-2640-fe0f", 2642], ["1f9da-1f3ff-200d-2640-fe0f", 2643], ["1f9db-1f3fb", 2644], ["1f9db-1f3fc", 2645], ["1f9db-1f3fd", 2646], ["1f9db-1f3fe", 2647], ["1f9db-1f3ff", 2648], ["1f9db-1f3fb-200d-2642-fe0f", 2649], ["1f9db-1f3fc-200d-2642-fe0f", 2650], ["1f9db-1f3fd-200d-2642-fe0f", 2651], ["1f9db-1f3fe-200d-2642-fe0f", 2652], ["1f9db-1f3ff-200d-2642-fe0f", 2653], ["1f9db-1f3fb-200d-2640-fe0f", 2654], ["1f9db-1f3fc-200d-2640-fe0f", 2655], ["1f9db-1f3fd-200d-2640-fe0f", 2656], ["1f9db-1f3fe-200d-2640-fe0f", 2657], ["1f9db-1f3ff-200d-2640-fe0f", 2658], ["1f9dc-1f3fb", 2659], ["1f9dc-1f3fc", 2660], ["1f9dc-1f3fd", 2661], ["1f9dc-1f3fe", 2662], ["1f9dc-1f3ff", 2663], ["1f9dc-1f3fb-200d-2642-fe0f", 2664], ["1f9dc-1f3fc-200d-2642-fe0f", 2665], ["1f9dc-1f3fd-200d-2642-fe0f", 2666], ["1f9dc-1f3fe-200d-2642-fe0f", 2667], ["1f9dc-1f3ff-200d-2642-fe0f", 2668], ["1f9dc-1f3fb-200d-2640-fe0f", 2669], ["1f9dc-1f3fc-200d-2640-fe0f", 2670], ["1f9dc-1f3fd-200d-2640-fe0f", 2671], ["1f9dc-1f3fe-200d-2640-fe0f", 2672], ["1f9dc-1f3ff-200d-2640-fe0f", 2673], ["1f9dd-1f3fb", 2674], ["1f9dd-1f3fc", 2675], ["1f9dd-1f3fd", 2676], ["1f9dd-1f3fe", 2677], ["1f9dd-1f3ff", 2678], ["1f9dd-1f3fb-200d-2642-fe0f", 2679], ["1f9dd-1f3fc-200d-2642-fe0f", 2680], ["1f9dd-1f3fd-200d-2642-fe0f", 2681], ["1f9dd-1f3fe-200d-2642-fe0f", 2682], ["1f9dd-1f3ff-200d-2642-fe0f", 2683], ["1f9dd-1f3fb-200d-2640-fe0f", 2684], ["1f9dd-1f3fc-200d-2640-fe0f", 2685], ["1f9dd-1f3fd-200d-2640-fe0f", 2686], ["1f9dd-1f3fe-200d-2640-fe0f", 2687], ["1f9dd-1f3ff-200d-2640-fe0f", 2688], ["1f486-1f3fb", 2689], ["1f486-1f3fc", 2690], ["1f486-1f3fd", 2691], ["1f486-1f3fe", 2692], ["1f486-1f3ff", 2693], ["1f486-1f3fb-200d-2642-fe0f", 2694], ["1f486-1f3fc-200d-2642-fe0f", 2695], ["1f486-1f3fd-200d-2642-fe0f", 2696], ["1f486-1f3fe-200d-2642-fe0f", 2697], ["1f486-1f3ff-200d-2642-fe0f", 2698], ["1f486-1f3fb-200d-2640-fe0f", 2699], ["1f486-1f3fc-200d-2640-fe0f", 2700], ["1f486-1f3fd-200d-2640-fe0f", 2701], ["1f486-1f3fe-200d-2640-fe0f", 2702], ["1f486-1f3ff-200d-2640-fe0f", 2703], ["1f487-1f3fb", 2704], ["1f487-1f3fc", 2705], ["1f487-1f3fd", 2706], ["1f487-1f3fe", 2707], ["1f487-1f3ff", 2708], ["1f487-1f3fb-200d-2642-fe0f", 2709], ["1f487-1f3fc-200d-2642-fe0f", 2710], ["1f487-1f3fd-200d-2642-fe0f", 2711], ["1f487-1f3fe-200d-2642-fe0f", 2712], ["1f487-1f3ff-200d-2642-fe0f", 2713], ["1f487-1f3fb-200d-2640-fe0f", 2714], ["1f487-1f3fc-200d-2640-fe0f", 2715], ["1f487-1f3fd-200d-2640-fe0f", 2716], ["1f487-1f3fe-200d-2640-fe0f", 2717], ["1f487-1f3ff-200d-2640-fe0f", 2718], ["1f6b6-1f3fb", 2719], ["1f6b6-1f3fc", 2720], ["1f6b6-1f3fd", 2721], ["1f6b6-1f3fe", 2722], ["1f6b6-1f3ff", 2723], ["1f6b6-1f3fb-200d-2642-fe0f", 2724], ["1f6b6-1f3fc-200d-2642-fe0f", 2725], ["1f6b6-1f3fd-200d-2642-fe0f", 2726], ["1f6b6-1f3fe-200d-2642-fe0f", 2727], ["1f6b6-1f3ff-200d-2642-fe0f", 2728], ["1f6b6-1f3fb-200d-2640-fe0f", 2729], ["1f6b6-1f3fc-200d-2640-fe0f", 2730], ["1f6b6-1f3fd-200d-2640-fe0f", 2731], ["1f6b6-1f3fe-200d-2640-fe0f", 2732], ["1f9cd-1f3fb", 2733], ["1f9cd-1f3fc", 2734], ["1f9cd-1f3fd", 2735], ["1f9cd-1f3fe", 2736], ["1f9cd-1f3ff", 2737], ["1f9cd-1f3fb-200d-2642-fe0f", 2738], ["1f9cd-1f3fc-200d-2642-fe0f", 2739], ["1f9cd-1f3fd-200d-2642-fe0f", 2740], ["1f9cd-1f3fe-200d-2642-fe0f", 2741], ["1f9cd-1f3ff-200d-2642-fe0f", 2742], ["1f9cd-1f3fb-200d-2640-fe0f", 2743], ["1f9cd-1f3fc-200d-2640-fe0f", 2744], ["1f9cd-1f3fd-200d-2640-fe0f", 2745], ["1f9cd-1f3fe-200d-2640-fe0f", 2746], ["1f9cd-1f3ff-200d-2640-fe0f", 2747], ["1f9ce-1f3fb", 2748], ["1f9ce-1f3fc", 2749], ["1f9ce-1f3fd", 2750], ["1f9ce-1f3fe", 2751], ["1f9ce-1f3ff", 2752], ["1f9ce-1f3fb-200d-2642-fe0f", 2753], ["1f9ce-1f3fc-200d-2642-fe0f", 2754], ["1f9ce-1f3fd-200d-2642-fe0f", 2755], ["1f9ce-1f3fe-200d-2642-fe0f", 2756], ["1f9ce-1f3ff-200d-2642-fe0f", 2757], ["1f9ce-1f3fb-200d-2640-fe0f", 2758], ["1f9ce-1f3fc-200d-2640-fe0f", 2759], ["1f9ce-1f3fd-200d-2640-fe0f", 2760], ["1f9ce-1f3fe-200d-2640-fe0f", 2761], ["1f9ce-1f3ff-200d-2640-fe0f", 2762], ["1f9d1-1f3fb-200d-1f9af", 2763], ["1f9d1-1f3fc-200d-1f9af", 2764], ["1f9d1-1f3fd-200d-1f9af", 2765], ["1f9d1-1f3fe-200d-1f9af", 2766], ["1f9d1-1f3ff-200d-1f9af", 2767], ["1f468-1f3fb-200d-1f9af", 2768], ["1f468-1f3fc-200d-1f9af", 2769], ["1f468-1f3fd-200d-1f9af", 2770], ["1f468-1f3fe-200d-1f9af", 2771], ["1f468-1f3ff-200d-1f9af", 2772], ["1f469-1f3fb-200d-1f9af", 2773], ["1f469-1f3fc-200d-1f9af", 2774], ["1f469-1f3fd-200d-1f9af", 2775], ["1f469-1f3fe-200d-1f9af", 2776], ["1f469-1f3ff-200d-1f9af", 2777], ["1f9d1-1f3fb-200d-1f9bc", 2778], ["1f9d1-1f3fc-200d-1f9bc", 2779], ["1f9d1-1f3fd-200d-1f9bc", 2780], ["1f9d1-1f3fe-200d-1f9bc", 2781], ["1f9d1-1f3ff-200d-1f9bc", 2782], ["1f468-1f3fb-200d-1f9bc", 2783], ["1f468-1f3fc-200d-1f9bc", 2784], ["1f468-1f3fd-200d-1f9bc", 2785], ["1f468-1f3fe-200d-1f9bc", 2786], ["1f468-1f3ff-200d-1f9bc", 2787], ["1f469-1f3fb-200d-1f9bc", 2788], ["1f469-1f3fc-200d-1f9bc", 2789], ["1f469-1f3fd-200d-1f9bc", 2790], ["1f469-1f3fe-200d-1f9bc", 2791], ["1f469-1f3ff-200d-1f9bc", 2792], ["1f9d1-1f3fb-200d-1f9bd", 2793], ["1f9d1-1f3fc-200d-1f9bd", 2794], ["1f9d1-1f3fd-200d-1f9bd", 2795], ["1f9d1-1f3fe-200d-1f9bd", 2796], ["1f9d1-1f3ff-200d-1f9bd", 2797], ["1f468-1f3fb-200d-1f9bd", 2798], ["1f468-1f3fc-200d-1f9bd", 2799], ["1f468-1f3fd-200d-1f9bd", 2800], ["1f468-1f3fe-200d-1f9bd", 2801], ["1f468-1f3ff-200d-1f9bd", 2802], ["1f469-1f3fb-200d-1f9bd", 2803], ["1f469-1f3fc-200d-1f9bd", 2804], ["1f469-1f3fd-200d-1f9bd", 2805], ["1f469-1f3fe-200d-1f9bd", 2806], ["1f469-1f3ff-200d-1f9bd", 2807], ["1f3c3-1f3fb", 2808], ["1f3c3-1f3fc", 2809], ["1f3c3-1f3fd", 2810], ["1f3c3-1f3fe", 2811], ["1f3c3-1f3ff", 2812], ["1f3c3-1f3fb-200d-2642-fe0f", 2813], ["1f3c3-1f3fc-200d-2642-fe0f", 2814], ["1f3c3-1f3fd-200d-2642-fe0f", 2815], ["1f3c3-1f3fe-200d-2642-fe0f", 2816], ["1f3c3-1f3ff-200d-2642-fe0f", 2817], ["1f3c3-1f3fb-200d-2640-fe0f", 2818], ["1f3c3-1f3fc-200d-2640-fe0f", 2819], ["1f3c3-1f3fd-200d-2640-fe0f", 2820], ["1f3c3-1f3fe-200d-2640-fe0f", 2821], ["1f3c3-1f3ff-200d-2640-fe0f", 2822], ["1f483-1f3fb", 2823], ["1f483-1f3fc", 2824], ["1f483-1f3fd", 2825], ["1f483-1f3fe", 2826], ["1f483-1f3ff", 2827], ["1f57a-1f3fb", 2828], ["1f57a-1f3fc", 2829], ["1f57a-1f3fd", 2830], ["1f57a-1f3fe", 2831], ["1f57a-1f3ff", 2832], ["1f574-1f3fb", 2833], ["1f574-1f3fc", 2834], ["1f574-1f3fd", 2835], ["1f574-1f3fe", 2836], ["1f574-1f3ff", 2837], ["1f9d6-1f3fb", 2838], ["1f9d6-1f3fc", 2839], ["1f9d6-1f3fd", 2840], ["1f9d6-1f3fe", 2841], ["1f9d6-1f3ff", 2842], ["1f9d6-1f3fb-200d-2642-fe0f", 2843], ["1f9d6-1f3fc-200d-2642-fe0f", 2844], ["1f9d6-1f3fd-200d-2642-fe0f", 2845], ["1f9d6-1f3fe-200d-2642-fe0f", 2846], ["1f9d6-1f3ff-200d-2642-fe0f", 2847], ["1f9d6-1f3fb-200d-2640-fe0f", 2848], ["1f9d6-1f3fc-200d-2640-fe0f", 2849], ["1f9d6-1f3fd-200d-2640-fe0f", 2850], ["1f9d6-1f3fe-200d-2640-fe0f", 2851], ["1f9d6-1f3ff-200d-2640-fe0f", 2852], ["1f9d7-1f3fb", 2853], ["1f9d7-1f3fc", 2854], ["1f9d7-1f3fd", 2855], ["1f9d7-1f3fe", 2856], ["1f9d7-1f3ff", 2857], ["1f9d7-1f3fb-200d-2642-fe0f", 2858], ["1f9d7-1f3fc-200d-2642-fe0f", 2859], ["1f9d7-1f3fd-200d-2642-fe0f", 2860], ["1f9d7-1f3fe-200d-2642-fe0f", 2861], ["1f9d7-1f3ff-200d-2642-fe0f", 2862], ["1f9d7-1f3fb-200d-2640-fe0f", 2863], ["1f9d7-1f3fc-200d-2640-fe0f", 2864], ["1f9d7-1f3fd-200d-2640-fe0f", 2865], ["1f9d7-1f3fe-200d-2640-fe0f", 2866], ["1f9d7-1f3ff-200d-2640-fe0f", 2867], ["1f3c7-1f3fb", 2868], ["1f3c7-1f3fc", 2869], ["1f3c7-1f3fd", 2870], ["1f3c7-1f3fe", 2871], ["1f3c7-1f3ff", 2872], ["1f3cc-1f3fb", 2873], ["1f3cc-1f3fc", 2874], ["1f3cc-1f3fd", 2875], ["1f3cc-1f3fe", 2876], ["1f3cc-1f3ff", 2877], ["1f3cc-1f3fb-200d-2642-fe0f", 2878], ["1f3cc-1f3fc-200d-2642-fe0f", 2879], ["1f3cc-1f3fd-200d-2642-fe0f", 2880], ["1f3cc-1f3fe-200d-2642-fe0f", 2881], ["1f3cc-1f3ff-200d-2642-fe0f", 2882], ["1f3cc-1f3fb-200d-2640-fe0f", 2883], ["1f3cc-1f3fc-200d-2640-fe0f", 2884], ["1f3cc-1f3fd-200d-2640-fe0f", 2885], ["1f3cc-1f3fe-200d-2640-fe0f", 2886], ["1f3cc-1f3ff-200d-2640-fe0f", 2887], ["1f3c4-1f3fb", 2888], ["1f3c4-1f3fc", 2889], ["1f3c4-1f3fd", 2890], ["1f3c4-1f3fe", 2891], ["1f3c4-1f3ff", 2892], ["1f3c4-1f3fb-200d-2642-fe0f", 2893], ["1f3c4-1f3fc-200d-2642-fe0f", 2894], ["1f3c4-1f3fd-200d-2642-fe0f", 2895], ["1f3c4-1f3fe-200d-2642-fe0f", 2896], ["1f3c4-1f3ff-200d-2642-fe0f", 2897], ["1f3c4-1f3fb-200d-2640-fe0f", 2898], ["1f3c4-1f3fc-200d-2640-fe0f", 2899], ["1f3c4-1f3fd-200d-2640-fe0f", 2900], ["1f3c4-1f3fe-200d-2640-fe0f", 2901], ["1f3c4-1f3ff-200d-2640-fe0f", 2902], ["1f6a3-1f3fb", 2903], ["1f6a3-1f3fc", 2904], ["1f6a3-1f3fd", 2905], ["1f6a3-1f3fe", 2906], ["1f6a3-1f3ff", 2907], ["1f6a3-1f3fb-200d-2642-fe0f", 2908], ["1f6a3-1f3fc-200d-2642-fe0f", 2909], ["1f6a3-1f3fd-200d-2642-fe0f", 2910], ["1f6a3-1f3fe-200d-2642-fe0f", 2911], ["1f6a3-1f3ff-200d-2642-fe0f", 2912], ["1f6a3-1f3fb-200d-2640-fe0f", 2913], ["1f6a3-1f3fc-200d-2640-fe0f", 2914], ["1f6a3-1f3fd-200d-2640-fe0f", 2915], ["1f6a3-1f3fe-200d-2640-fe0f", 2916], ["1f6a3-1f3ff-200d-2640-fe0f", 2917], ["1f3ca-1f3fb", 2918], ["1f3ca-1f3fc", 2919], ["1f3ca-1f3fd", 2920], ["1f3ca-1f3fe", 2921], ["1f3ca-1f3ff", 2922], ["1f3ca-1f3fb-200d-2642-fe0f", 2923], ["1f3ca-1f3fc-200d-2642-fe0f", 2924], ["1f3ca-1f3fd-200d-2642-fe0f", 2925], ["1f3ca-1f3fe-200d-2642-fe0f", 2926], ["1f3ca-1f3ff-200d-2642-fe0f", 2927], ["1f3ca-1f3fb-200d-2640-fe0f", 2928], ["1f3ca-1f3fc-200d-2640-fe0f", 2929], ["1f3ca-1f3fd-200d-2640-fe0f", 2930], ["1f3ca-1f3fe-200d-2640-fe0f", 2931], ["1f3ca-1f3ff-200d-2640-fe0f", 2932], ["26f9-1f3fb", 2933], ["26f9-1f3fc", 2934], ["26f9-1f3fd", 2935], ["26f9-1f3fe", 2936], ["26f9-1f3ff", 2937], ["26f9-1f3fb-200d-2642-fe0f", 2938], ["26f9-1f3fc-200d-2642-fe0f", 2939], ["26f9-1f3fd-200d-2642-fe0f", 2940], ["26f9-1f3fe-200d-2642-fe0f", 2941], ["26f9-1f3ff-200d-2642-fe0f", 2942], ["26f9-1f3fb-200d-2640-fe0f", 2943], ["26f9-1f3fc-200d-2640-fe0f", 2944], ["26f9-1f3fd-200d-2640-fe0f", 2945], ["26f9-1f3fe-200d-2640-fe0f", 2946], ["26f9-1f3ff-200d-2640-fe0f", 2947], ["1f3cb-1f3fb", 2948], ["1f3cb-1f3fc", 2949], ["1f3cb-1f3fd", 2950], ["1f3cb-1f3fe", 2951], ["1f3cb-1f3ff", 2952], ["1f3cb-1f3fb-200d-2642-fe0f", 2953], ["1f3cb-1f3fc-200d-2642-fe0f", 2954], ["1f3cb-1f3fd-200d-2642-fe0f", 2955], ["1f3cb-1f3fe-200d-2642-fe0f", 2956], ["1f3cb-1f3ff-200d-2642-fe0f", 2957], ["1f3cb-1f3fb-200d-2640-fe0f", 2958], ["1f3cb-1f3fc-200d-2640-fe0f", 2959], ["1f3cb-1f3fd-200d-2640-fe0f", 2960], ["1f3cb-1f3fe-200d-2640-fe0f", 2961], ["1f3cb-1f3ff-200d-2640-fe0f", 2962], ["1f6b4-1f3fb", 2963], ["1f6b4-1f3fc", 2964], ["1f6b4-1f3fd", 2965], ["1f6b4-1f3fe", 2966], ["1f6b4-1f3ff", 2967], ["1f6b4-1f3fb-200d-2642-fe0f", 2968], ["1f6b4-1f3fc-200d-2642-fe0f", 2969], ["1f6b4-1f3fd-200d-2642-fe0f", 2970], ["1f6b4-1f3fe-200d-2642-fe0f", 2971], ["1f6b4-1f3ff-200d-2642-fe0f", 2972], ["1f6b4-1f3fb-200d-2640-fe0f", 2973], ["1f6b4-1f3fc-200d-2640-fe0f", 2974], ["1f6b4-1f3fd-200d-2640-fe0f", 2975], ["1f6b4-1f3fe-200d-2640-fe0f", 2976], ["1f6b4-1f3ff-200d-2640-fe0f", 2977], ["1f6b5-1f3fb", 2978], ["1f6b5-1f3fc", 2979], ["1f6b5-1f3fd", 2980], ["1f6b5-1f3fe", 2981], ["1f6b5-1f3ff", 2982], ["1f6b5-1f3fb-200d-2642-fe0f", 2983], ["1f6b5-1f3fc-200d-2642-fe0f", 2984], ["1f6b5-1f3fd-200d-2642-fe0f", 2985], ["1f6b5-1f3fe-200d-2642-fe0f", 2986], ["1f6b5-1f3ff-200d-2642-fe0f", 2987], ["1f6b5-1f3fb-200d-2640-fe0f", 2988], ["1f6b5-1f3fc-200d-2640-fe0f", 2989], ["1f6b5-1f3fd-200d-2640-fe0f", 2990], ["1f6b5-1f3fe-200d-2640-fe0f", 2991], ["1f6b5-1f3ff-200d-2640-fe0f", 2992], ["1f938-1f3fb", 2993], ["1f938-1f3fc", 2994], ["1f938-1f3fd", 2995], ["1f938-1f3fe", 2996], ["1f938-1f3ff", 2997], ["1f938-1f3fb-200d-2642-fe0f", 2998], ["1f938-1f3fc-200d-2642-fe0f", 2999], ["1f938-1f3fd-200d-2642-fe0f", 3000], ["1f938-1f3fe-200d-2642-fe0f", 3001], ["1f938-1f3ff-200d-2642-fe0f", 3002], ["1f938-1f3fb-200d-2640-fe0f", 3003], ["1f938-1f3fc-200d-2640-fe0f", 3004], ["1f938-1f3fd-200d-2640-fe0f", 3005], ["1f938-1f3fe-200d-2640-fe0f", 3006], ["1f938-1f3ff-200d-2640-fe0f", 3007], ["1f93d-1f3fb", 3008], ["1f93d-1f3fc", 3009], ["1f93d-1f3fd", 3010], ["1f93d-1f3fe", 3011], ["1f93d-1f3ff", 3012], ["1f93d-1f3fb-200d-2642-fe0f", 3013], ["1f93d-1f3fc-200d-2642-fe0f", 3014], ["1f93d-1f3fd-200d-2642-fe0f", 3015], ["1f93d-1f3fe-200d-2642-fe0f", 3016], ["1f93d-1f3ff-200d-2642-fe0f", 3017], ["1f93d-1f3fb-200d-2640-fe0f", 3018], ["1f93d-1f3fc-200d-2640-fe0f", 3019], ["1f93d-1f3fd-200d-2640-fe0f", 3020], ["1f93d-1f3fe-200d-2640-fe0f", 3021], ["1f93d-1f3ff-200d-2640-fe0f", 3022], ["1f93e-1f3fb", 3023], ["1f93e-1f3fc", 3024], ["1f93e-1f3fd", 3025], ["1f93e-1f3fe", 3026], ["1f93e-1f3ff", 3027], ["1f93e-1f3fb-200d-2642-fe0f", 3028], ["1f93e-1f3fc-200d-2642-fe0f", 3029], ["1f93e-1f3fd-200d-2642-fe0f", 3030], ["1f93e-1f3fe-200d-2642-fe0f", 3031], ["1f93e-1f3ff-200d-2642-fe0f", 3032], ["1f93e-1f3fb-200d-2640-fe0f", 3033], ["1f93e-1f3fc-200d-2640-fe0f", 3034], ["1f93e-1f3fd-200d-2640-fe0f", 3035], ["1f93e-1f3fe-200d-2640-fe0f", 3036], ["1f93e-1f3ff-200d-2640-fe0f", 3037], ["1f939-1f3fb", 3038], ["1f939-1f3fc", 3039], ["1f939-1f3fd", 3040], ["1f939-1f3fe", 3041], ["1f939-1f3ff", 3042], ["1f939-1f3fb-200d-2642-fe0f", 3043], ["1f939-1f3fc-200d-2642-fe0f", 3044], ["1f939-1f3fd-200d-2642-fe0f", 3045], ["1f939-1f3fe-200d-2642-fe0f", 3046], ["1f939-1f3ff-200d-2642-fe0f", 3047], ["1f939-1f3fb-200d-2640-fe0f", 3048], ["1f939-1f3fc-200d-2640-fe0f", 3049], ["1f939-1f3fd-200d-2640-fe0f", 3050], ["1f939-1f3fe-200d-2640-fe0f", 3051], ["1f939-1f3ff-200d-2640-fe0f", 3052], ["1f9d8-1f3fb", 3053], ["1f9d8-1f3fc", 3054], ["1f9d8-1f3fd", 3055], ["1f9d8-1f3fe", 3056], ["1f9d8-1f3ff", 3057], ["1f9d8-1f3fb-200d-2642-fe0f", 3058], ["1f9d8-1f3fc-200d-2642-fe0f", 3059], ["1f9d8-1f3fd-200d-2642-fe0f", 3060], ["1f9d8-1f3fe-200d-2642-fe0f", 3061], ["1f9d8-1f3ff-200d-2642-fe0f", 3062], ["1f9d8-1f3fb-200d-2640-fe0f", 3063], ["1f9d8-1f3fc-200d-2640-fe0f", 3064], ["1f9d8-1f3fd-200d-2640-fe0f", 3065], ["1f9d8-1f3fe-200d-2640-fe0f", 3066], ["1f9d8-1f3ff-200d-2640-fe0f", 3067], ["1f6c0-1f3fb", 3068], ["1f6c0-1f3fc", 3069], ["1f6c0-1f3fd", 3070], ["1f6c0-1f3fe", 3071], ["1f6c0-1f3ff", 3072], ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb", 3073], ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc", 3074], ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd", 3075], ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe", 3076], ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff", 3077], ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb", 3078], ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc", 3079], ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd", 3080], ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe", 3081], ["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff", 3082], ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb", 3083], ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc", 3084], ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd", 3085], ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe", 3086], ["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff", 3087], ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb", 3088], ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc", 3089], ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd", 3090], ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe", 3091], ["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff", 3092], ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb", 3093], ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc", 3094], ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd", 3095], ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe", 3096], ["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff", 3097], ["1f46d-1f3fb", 3098], ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc", 3099], ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd", 3100], ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe", 3101], ["1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff", 3102], ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb", 3103], ["1f46d-1f3fc", 3104], ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd", 3105], ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe", 3106], ["1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff", 3107], ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb", 3108], ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc", 3109], ["1f46d-1f3fd", 3110], ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe", 3111], ["1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff", 3112], ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb", 3113], ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc", 3114], ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd", 3115], ["1f46d-1f3fe", 3116], ["1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff", 3117], ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb", 3118], ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc", 3119], ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd", 3120], ["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe", 3121], ["1f46d-1f3ff", 3122], ["1f46b-1f3fb", 3123], ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc", 3124], ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd", 3125], ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe", 3126], ["1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff", 3127], ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb", 3128], ["1f46b-1f3fc", 3129], ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd", 3130], ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe", 3131], ["1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff", 3132], ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb", 3133], ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc", 3134], ["1f46b-1f3fd", 3135], ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe", 3136], ["1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff", 3137], ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb", 3138], ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc", 3139], ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd", 3140], ["1f46b-1f3fe", 3141], ["1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff", 3142], ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb", 3143], ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc", 3144], ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd", 3145], ["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe", 3146], ["1f46b-1f3ff", 3147], ["1f46c-1f3fb", 3148], ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc", 3149], ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd", 3150], ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe", 3151], ["1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff", 3152], ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb", 3153], ["1f46c-1f3fc", 3154], ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd", 3155], ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe", 3156], ["1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff", 3157], ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb", 3158], ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc", 3159], ["1f46c-1f3fd", 3160], ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe", 3161], ["1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff", 3162], ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb", 3163], ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc", 3164], ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd", 3165], ["1f46c-1f3fe", 3166], ["1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff", 3167], ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb", 3168], ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc", 3169], ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd", 3170], ["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe", 3171], ["1f46c-1f3ff", 3172]]);

// export const CategoryNames = ["smileys_emotion","people_body","animals_nature","food_drink","travel_places","activities","objects","symbols","flags","custom","skintone"];
var CategoryNames = exports.CategoryNames = ["smileys_emotion", "people_body", "animals_nature", "food_drink", "travel_places", "activities", "objects", "symbols", "flags"];

var EmojiIndicesByCategory = exports.EmojiIndicesByCategory = new _map2.default([["smileys_emotion", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148]], ["people_body", [149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482]], ["animals_nature", [483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604, 605, 606, 607, 608, 609]], ["food_drink", [610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620, 621, 622, 623, 624, 625, 626, 627, 628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639, 640, 641, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684, 685, 686, 687, 688, 689, 690, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709, 710, 711, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725, 726, 727, 728, 729, 730]], ["travel_places", [731, 732, 733, 734, 735, 736, 737, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753, 754, 755, 756, 757, 758, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 880, 881, 882, 883, 884, 885, 886, 887, 888, 889, 890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902, 903, 904, 905, 906, 907, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940]], ["activities", [941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 975, 976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019]], ["objects", [1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1151, 1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1191, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251, 1252]], ["symbols", [1253, 1254, 1255, 1256, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1315, 1316, 1317, 1318, 1319, 1320, 1321, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1330, 1331, 1332, 1333, 1334, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1345, 1346, 1347, 1348, 1349, 1350, 1351, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375, 1376, 1377, 1378, 1379, 1380, 1381, 1382, 1383, 1384, 1385, 1386, 1387, 1388, 1389, 1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412, 1413, 1414, 1415, 1416, 1417, 1418, 1419, 1420, 1421, 1422, 1423, 1424, 1425, 1426, 1427, 1428, 1429, 1430, 1431, 1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444, 1445, 1446, 1447, 1448, 1449, 1450, 1451, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469]], ["flags", [1470, 1471, 1472, 1473, 1474, 1475, 1476, 1477, 1478, 1479, 1480, 1481, 1482, 1483, 1484, 1485, 1486, 1487, 1488, 1489, 1490, 1491, 1492, 1493, 1494, 1495, 1496, 1497, 1498, 1499, 1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511, 1512, 1513, 1514, 1515, 1516, 1517, 1518, 1519, 1520, 1521, 1522, 1523, 1524, 1525, 1526, 1527, 1528, 1529, 1530, 1531, 1532, 1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543, 1544, 1545, 1546, 1547, 1548, 1549, 1550, 1551, 1552, 1553, 1554, 1555, 1556, 1557, 1558, 1559, 1560, 1561, 1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573, 1574, 1575, 1576, 1577, 1578, 1579, 1580, 1581, 1582, 1583, 1584, 1585, 1586, 1587, 1588, 1589, 1590, 1591, 1592, 1593, 1594, 1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605, 1606, 1607, 1608, 1609, 1610, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641, 1642, 1643, 1644, 1645, 1646, 1647, 1648, 1649, 1650, 1651, 1652, 1653, 1654, 1655, 1656, 1657, 1658, 1659, 1660, 1661, 1662, 1663, 1664, 1665, 1666, 1667, 1668, 1669, 1670, 1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683, 1684, 1685, 1686, 1687, 1688, 1689, 1690, 1691, 1692, 1693, 1694, 1695, 1696, 1697, 1698, 1699, 1700, 1701, 1702, 1703, 1704, 1705, 1706, 1707, 1708, 1709, 1710, 1711, 1712, 1713, 1714, 1715, 1716, 1717, 1718, 1719, 1720, 1721, 1722, 1723, 1724, 1725, 1726, 1727, 1728, 1729, 1730, 1731, 1732, 1733, 1734, 1735, 1736, 1737]], ["custom", [1738]], ["skintone", [1739, 1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748, 1749, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1757, 1758, 1759, 1760, 1761, 1762, 1763, 1764, 1765, 1766, 1767, 1768, 1769, 1770, 1771, 1772, 1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784, 1785, 1786, 1787, 1788, 1789, 1790, 1791, 1792, 1793, 1794, 1795, 1796, 1797, 1798, 1799, 1800, 1801, 1802, 1803, 1804, 1805, 1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813, 1814, 1815, 1816, 1817, 1818, 1819, 1820, 1821, 1822, 1823, 1824, 1825, 1826, 1827, 1828, 1829, 1830, 1831, 1832, 1833, 1834, 1835, 1836, 1837, 1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1867, 1868, 1869, 1870, 1871, 1872, 1873, 1874, 1875, 1876, 1877, 1878, 1879, 1880, 1881, 1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892, 1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921, 1922, 1923, 1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073, 2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100, 2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114, 2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2123, 2124, 2125, 2126, 2127, 2128, 2129, 2130, 2131, 2132, 2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144, 2145, 2146, 2147, 2148, 2149, 2150, 2151, 2152, 2153, 2154, 2155, 2156, 2157, 2158, 2159, 2160, 2161, 2162, 2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171, 2172, 2173, 2174, 2175, 2176, 2177, 2178, 2179, 2180, 2181, 2182, 2183, 2184, 2185, 2186, 2187, 2188, 2189, 2190, 2191, 2192, 2193, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207, 2208, 2209, 2210, 2211, 2212, 2213, 2214, 2215, 2216, 2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224, 2225, 2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236, 2237, 2238, 2239, 2240, 2241, 2242, 2243, 2244, 2245, 2246, 2247, 2248, 2249, 2250, 2251, 2252, 2253, 2254, 2255, 2256, 2257, 2258, 2259, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2274, 2275, 2276, 2277, 2278, 2279, 2280, 2281, 2282, 2283, 2284, 2285, 2286, 2287, 2288, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 2308, 2309, 2310, 2311, 2312, 2313, 2314, 2315, 2316, 2317, 2318, 2319, 2320, 2321, 2322, 2323, 2324, 2325, 2326, 2327, 2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338, 2339, 2340, 2341, 2342, 2343, 2344, 2345, 2346, 2347, 2348, 2349, 2350, 2351, 2352, 2353, 2354, 2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2384, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2392, 2393, 2394, 2395, 2396, 2397, 2398, 2399, 2400, 2401, 2402, 2403, 2404, 2405, 2406, 2407, 2408, 2409, 2410, 2411, 2412, 2413, 2414, 2415, 2416, 2417, 2418, 2419, 2420, 2421, 2422, 2423, 2424, 2425, 2426, 2427, 2428, 2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439, 2440, 2441, 2442, 2443, 2444, 2445, 2446, 2447, 2448, 2449, 2450, 2451, 2452, 2453, 2454, 2455, 2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466, 2467, 2468, 2469, 2470, 2471, 2472, 2473, 2474, 2475, 2476, 2477, 2478, 2479, 2480, 2481, 2482, 2483, 2484, 2485, 2486, 2487, 2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2501, 2502, 2503, 2504, 2505, 2506, 2507, 2508, 2509, 2510, 2511, 2512, 2513, 2514, 2515, 2516, 2517, 2518, 2519, 2520, 2521, 2522, 2523, 2524, 2525, 2526, 2527, 2528, 2529, 2530, 2531, 2532, 2533, 2534, 2535, 2536, 2537, 2538, 2539, 2540, 2541, 2542, 2543, 2544, 2545, 2546, 2547, 2548, 2549, 2550, 2551, 2552, 2553, 2554, 2555, 2556, 2557, 2558, 2559, 2560, 2561, 2562, 2563, 2564, 2565, 2566, 2567, 2568, 2569, 2570, 2571, 2572, 2573, 2574, 2575, 2576, 2577, 2578, 2579, 2580, 2581, 2582, 2583, 2584, 2585, 2586, 2587, 2588, 2589, 2590, 2591, 2592, 2593, 2594, 2595, 2596, 2597, 2598, 2599, 2600, 2601, 2602, 2603, 2604, 2605, 2606, 2607, 2608, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2617, 2618, 2619, 2620, 2621, 2622, 2623, 2624, 2625, 2626, 2627, 2628, 2629, 2630, 2631, 2632, 2633, 2634, 2635, 2636, 2637, 2638, 2639, 2640, 2641, 2642, 2643, 2644, 2645, 2646, 2647, 2648, 2649, 2650, 2651, 2652, 2653, 2654, 2655, 2656, 2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2674, 2675, 2676, 2677, 2678, 2679, 2680, 2681, 2682, 2683, 2684, 2685, 2686, 2687, 2688, 2689, 2690, 2691, 2692, 2693, 2694, 2695, 2696, 2697, 2698, 2699, 2700, 2701, 2702, 2703, 2704, 2705, 2706, 2707, 2708, 2709, 2710, 2711, 2712, 2713, 2714, 2715, 2716, 2717, 2718, 2719, 2720, 2721, 2722, 2723, 2724, 2725, 2726, 2727, 2728, 2729, 2730, 2731, 2732, 2733, 2734, 2735, 2736, 2737, 2738, 2739, 2740, 2741, 2742, 2743, 2744, 2745, 2746, 2747, 2748, 2749, 2750, 2751, 2752, 2753, 2754, 2755, 2756, 2757, 2758, 2759, 2760, 2761, 2762, 2763, 2764, 2765, 2766, 2767, 2768, 2769, 2770, 2771, 2772, 2773, 2774, 2775, 2776, 2777, 2778, 2779, 2780, 2781, 2782, 2783, 2784, 2785, 2786, 2787, 2788, 2789, 2790, 2791, 2792, 2793, 2794, 2795, 2796, 2797, 2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806, 2807, 2808, 2809, 2810, 2811, 2812, 2813, 2814, 2815, 2816, 2817, 2818, 2819, 2820, 2821, 2822, 2823, 2824, 2825, 2826, 2827, 2828, 2829, 2830, 2831, 2832, 2833, 2834, 2835, 2836, 2837, 2838, 2839, 2840, 2841, 2842, 2843, 2844, 2845, 2846, 2847, 2848, 2849, 2850, 2851, 2852, 2853, 2854, 2855, 2856, 2857, 2858, 2859, 2860, 2861, 2862, 2863, 2864, 2865, 2866, 2867, 2868, 2869, 2870, 2871, 2872, 2873, 2874, 2875, 2876, 2877, 2878, 2879, 2880, 2881, 2882, 2883, 2884, 2885, 2886, 2887, 2888, 2889, 2890, 2891, 2892, 2893, 2894, 2895, 2896, 2897, 2898, 2899, 2900, 2901, 2902, 2903, 2904, 2905, 2906, 2907, 2908, 2909, 2910, 2911, 2912, 2913, 2914, 2915, 2916, 2917, 2918, 2919, 2920, 2921, 2922, 2923, 2924, 2925, 2926, 2927, 2928, 2929, 2930, 2931, 2932, 2933, 2934, 2935, 2936, 2937, 2938, 2939, 2940, 2941, 2942, 2943, 2944, 2945, 2946, 2947, 2948, 2949, 2950, 2951, 2952, 2953, 2954, 2955, 2956, 2957, 2958, 2959, 2960, 2961, 2962, 2963, 2964, 2965, 2966, 2967, 2968, 2969, 2970, 2971, 2972, 2973, 2974, 2975, 2976, 2977, 2978, 2979, 2980, 2981, 2982, 2983, 2984, 2985, 2986, 2987, 2988, 2989, 2990, 2991, 2992, 2993, 2994, 2995, 2996, 2997, 2998, 2999, 3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057, 3058, 3059, 3060, 3061, 3062, 3063, 3064, 3065, 3066, 3067, 3068, 3069, 3070, 3071, 3072, 3073, 3074, 3075, 3076, 3077, 3078, 3079, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088, 3089, 3090, 3091, 3092, 3093, 3094, 3095, 3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104, 3105, 3106, 3107, 3108, 3109, 3110, 3111, 3112, 3113, 3114, 3115, 3116, 3117, 3118, 3119, 3120, 3121, 3122, 3123, 3124, 3125, 3126, 3127, 3128, 3129, 3130, 3131, 3132, 3133, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3141, 3142, 3143, 3144, 3145, 3146, 3147, 3148, 3149, 3150, 3151, 3152, 3153, 3154, 3155, 3156, 3157, 3158, 3159, 3160, 3161, 3162, 3163, 3164, 3165, 3166, 3167, 3168, 3169, 3170, 3171, 3172]]]);

/* eslint-enable */

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var emptyObject = __webpack_require__(189);
var _invariant = __webpack_require__(3);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;



/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};



/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/caf564678a3ff28efe329193e2cc6eed.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b34820a6c22107762018456963085c20.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2731dc107cf3d242676a752da8be993f.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyMirror = __webpack_require__(409);

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
    POST_LIST_SCROLL_CHANGE: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process, Buffer) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__w_pdfjs_require__(14);

var _streamsLib = __w_pdfjs_require__(9);

var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : undefined;
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VERBOSITY_LEVELS = {
  errors: 0,
  warnings: 1,
  infos: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var verbosity = VERBOSITY_LEVELS.warnings;
function setVerbosityLevel(level) {
  verbosity = level;
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VERBOSITY_LEVELS.infos) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VERBOSITY_LEVELS.warnings) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}
function isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var NotImplementedException = function NotImplementedExceptionClosure() {
  function NotImplementedException(msg) {
    this.message = msg;
  }
  NotImplementedException.prototype = new Error();
  NotImplementedException.prototype.name = 'NotImplementedException';
  NotImplementedException.constructor = NotImplementedException;
  return NotImplementedException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  var n = 1,
      i = 0;
  while (x > n) {
    n <<= 1;
    i++;
  }
  return i;
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  Util.sign = function Util_sign(num) {
    return num < 0 ? -1 : 1;
  };
  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  Util.toRoman = function Util_toRoman(number, lowerCase) {
    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
    var pos,
        romanBuf = [];
    while (number >= 1000) {
      number -= 1000;
      romanBuf.push('M');
    }
    pos = number / 100 | 0;
    number %= 100;
    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
    pos = number / 10 | 0;
    number %= 10;
    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
    var romanStr = romanBuf.join('');
    return lowerCase ? romanStr.toLowerCase() : romanStr;
  };
  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
    Array.prototype.push.apply(arr1, arr2);
  };
  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
    Array.prototype.unshift.apply(arr1, arr2);
  };
  Util.extendObj = function extendObj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key];
    }
  };
  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
    while (dict && !dict.has(name)) {
      dict = dict.get('Parent');
    }
    if (!dict) {
      return null;
    }
    return getArray ? dict.getArray(name) : dict.get(name);
  };
  Util.inherit = function Util_inherit(sub, base, prototype) {
    sub.prototype = Object.create(base.prototype);
    sub.prototype.constructor = sub;
    for (var prop in prototype) {
      sub.prototype[prop] = prototype[prop];
    }
  };
  Util.loadScript = function Util_loadScript(src, callback) {
    var script = document.createElement('script');
    var loaded = false;
    script.setAttribute('src', src);
    if (callback) {
      script.onload = function () {
        if (!loaded) {
          callback();
        }
        loaded = true;
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  return Util;
}();
var PageViewport = function PageViewportClosure() {
  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
    this.fontScale = scale;
  }
  PageViewport.prototype = {
    clone: function PageViewPort_clone(args) {
      args = args || {};
      var scale = 'scale' in args ? args.scale : this.scale;
      var rotation = 'rotation' in args ? args.rotation : this.rotation;
      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
    },
    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
      return Util.applyTransform([x, y], this.transform);
    },
    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    },
    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
      return Util.applyInverseTransform([x, y], this.transform);
    }
  };
  return PageViewport;
}();
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isInt(v) {
  return typeof v === 'number' && (v | 0) === v;
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArray(v) {
  return v instanceof Array;
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var StatTimer = function StatTimerClosure() {
  function rpad(str, pad, length) {
    while (str.length < length) {
      str += pad;
    }
    return str;
  }
  function StatTimer() {
    this.started = Object.create(null);
    this.times = [];
    this.enabled = true;
  }
  StatTimer.prototype = {
    time: function StatTimer_time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        warn('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    },
    timeEnd: function StatTimer_timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        warn('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    },
    toString: function StatTimer_toString() {
      var i, ii;
      var times = this.times;
      var out = '';
      var longest = 0;
      for (i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (i = 0, ii = times.length; i < ii; ++i) {
        var span = times[i];
        var duration = span.end - span.start;
        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  };
  return StatTimer;
}();
var createBlob = function createBlob(data, contentType) {
  if (typeof Blob !== 'undefined') {
    return new Blob([data], { type: contentType });
  }
  throw new Error('The "Blob" constructor is not supported.');
};
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = createBlob(data, contentType);
      return URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
function resolveCall(fn, args) {
  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!fn) {
    return Promise.resolve(undefined);
  }
  return new Promise(function (resolve, reject) {
    resolve(fn.apply(thisArg, args));
  });
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(data.error);
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          if (reason instanceof Error) {
            reason = reason + '';
          }
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: reason
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = createPromiseCapability();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _streamsLib.ReadableStream({
      start: function start(controller) {
        var startCapability = createPromiseCapability();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = createPromiseCapability();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = createPromiseCapability();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = createPromiseCapability();
    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          success = _ref.success,
          reason = _ref.reason;

      _this3.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      });
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = createPromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk
        });
      },
      close: function close() {
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, data.reason);
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, data.reason);
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        this.streamControllers[data.streamId].controller.error(data.reason);
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, data.reason);
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [data.reason]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
function loadJpegStream(id, imageUrl, objs) {
  var img = new Image();
  img.onload = function loadJpegStream_onloadClosure() {
    objs.resolve(id, img);
  };
  img.onerror = function loadJpegStream_onerrorClosure() {
    objs.resolve(id, null);
    warn('Error during JPEG image loading');
  };
  img.src = imageUrl;
}
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.InvalidPDFException = InvalidPDFException;
exports.MessageHandler = MessageHandler;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.NotImplementedException = NotImplementedException;
exports.PageViewport = PageViewport;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.StatTimer = StatTimer;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createBlob = createBlob;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.globalScope = globalScope;
exports.info = info;
exports.isArray = isArray;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isInt = isInt;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isNodeJS = isNodeJS;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.loadJpegStream = loadJpegStream;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streamsLib.ReadableStream;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';

var DOMCanvasFactory = function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: 'create',
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, 'invalid canvas size');
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: 'reset',
    value: function reset(canvasAndContext, width, height) {
      (0, _util.assert)(canvasAndContext.canvas, 'canvas is not specified');
      (0, _util.assert)(width > 0 && height > 0, 'invalid canvas size');
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: 'destroy',
    value: function destroy(canvasAndContext) {
      (0, _util.assert)(canvasAndContext.canvas, 'canvas is not specified');
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

var DOMCMapReaderFactory = function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: 'fetch',
    value: function fetch(_ref2) {
      var _this = this;

      var name = _ref2.name;

      if (!name) {
        return Promise.reject(new Error('CMap name must be specified.'));
      }
      return new Promise(function (resolve, reject) {
        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        if (_this.isCompressed) {
          request.responseType = 'arraybuffer';
        }
        request.onreadystatechange = function () {
          if (request.readyState !== XMLHttpRequest.DONE) {
            return;
          }
          if (request.status === 200 || request.status === 0) {
            var data = void 0;
            if (_this.isCompressed && request.response) {
              data = new Uint8Array(request.response);
            } else if (!_this.isCompressed && request.responseText) {
              data = (0, _util.stringToBytes)(request.responseText);
            }
            if (data) {
              resolve({
                cMapData: data,
                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
              });
              return;
            }
          }
          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
        };
        request.send(null);
      });
    }
  }]);

  return DOMCMapReaderFactory;
}();

var CustomStyle = function CustomStyleClosure() {
  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
  var _cache = Object.create(null);
  function CustomStyle() {}
  CustomStyle.getProp = function get(propName, element) {
    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
      return _cache[propName];
    }
    element = element || document.documentElement;
    var style = element.style,
        prefixed,
        uPropName;
    if (typeof style[propName] === 'string') {
      return _cache[propName] = propName;
    }
    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
    for (var i = 0, l = prefixes.length; i < l; i++) {
      prefixed = prefixes[i] + uPropName;
      if (typeof style[prefixed] === 'string') {
        return _cache[propName] = prefixed;
      }
    }
    return _cache[propName] = 'undefined';
  };
  CustomStyle.setProp = function set(propName, element, str) {
    var prop = this.getProp(propName);
    if (prop !== 'undefined') {
      element.style[prop] = str;
    }
  };
  return CustomStyle;
}();
var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }
  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
function addLinkAttributes(link, params) {
  var url = params && params.url;
  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
  if (url) {
    var target = params.target;
    if (typeof target === 'undefined') {
      target = getDefaultSetting('externalLinkTarget');
    }
    link.target = LinkTargetStringMap[target];
    var rel = params.rel;
    if (typeof rel === 'undefined') {
      rel = getDefaultSetting('externalLinkRel');
    }
    link.rel = rel;
  }
}
function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}
function getDefaultSetting(id) {
  var globalSettings = _util.globalScope.PDFJS;
  switch (id) {
    case 'pdfBug':
      return globalSettings ? globalSettings.pdfBug : false;
    case 'disableAutoFetch':
      return globalSettings ? globalSettings.disableAutoFetch : false;
    case 'disableStream':
      return globalSettings ? globalSettings.disableStream : false;
    case 'disableRange':
      return globalSettings ? globalSettings.disableRange : false;
    case 'disableFontFace':
      return globalSettings ? globalSettings.disableFontFace : false;
    case 'disableCreateObjectURL':
      return globalSettings ? globalSettings.disableCreateObjectURL : false;
    case 'disableWebGL':
      return globalSettings ? globalSettings.disableWebGL : true;
    case 'cMapUrl':
      return globalSettings ? globalSettings.cMapUrl : null;
    case 'cMapPacked':
      return globalSettings ? globalSettings.cMapPacked : false;
    case 'postMessageTransfers':
      return globalSettings ? globalSettings.postMessageTransfers : true;
    case 'workerPort':
      return globalSettings ? globalSettings.workerPort : null;
    case 'workerSrc':
      return globalSettings ? globalSettings.workerSrc : null;
    case 'disableWorker':
      return globalSettings ? globalSettings.disableWorker : false;
    case 'maxImageSize':
      return globalSettings ? globalSettings.maxImageSize : -1;
    case 'imageResourcesPath':
      return globalSettings ? globalSettings.imageResourcesPath : '';
    case 'isEvalSupported':
      return globalSettings ? globalSettings.isEvalSupported : true;
    case 'externalLinkTarget':
      if (!globalSettings) {
        return LinkTarget.NONE;
      }
      switch (globalSettings.externalLinkTarget) {
        case LinkTarget.NONE:
        case LinkTarget.SELF:
        case LinkTarget.BLANK:
        case LinkTarget.PARENT:
        case LinkTarget.TOP:
          return globalSettings.externalLinkTarget;
      }
      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
      globalSettings.externalLinkTarget = LinkTarget.NONE;
      return LinkTarget.NONE;
    case 'externalLinkRel':
      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
    case 'enableStats':
      return !!(globalSettings && globalSettings.enableStats);
    case 'pdfjsNext':
      return !!(globalSettings && globalSettings.pdfjsNext);
    default:
      throw new Error('Unknown default setting: ' + id);
  }
}
function isExternalLinkTargetSet() {
  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
  switch (externalLinkTarget) {
    case LinkTarget.NONE:
      return false;
    case LinkTarget.SELF:
    case LinkTarget.BLANK:
    case LinkTarget.PARENT:
    case LinkTarget.TOP:
      return true;
  }
}
function isValidUrl(url, allowRelative) {
  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
  var baseUrl = allowRelative ? 'http://example.com' : null;
  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
}
exports.CustomStyle = CustomStyle;
exports.RenderingCancelledException = RenderingCancelledException;
exports.addLinkAttributes = addLinkAttributes;
exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
exports.isValidUrl = isValidUrl;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.LinkTarget = LinkTarget;
exports.getDefaultSetting = getDefaultSetting;
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
exports.DOMCanvasFactory = DOMCanvasFactory;
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = undefined;

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

function AnnotationElementFactory() {}
AnnotationElementFactory.prototype = {
  create: function AnnotationElementFactory_create(parameters) {
    var subtype = parameters.data.annotationType;
    switch (subtype) {
      case _util.AnnotationType.LINK:
        return new LinkAnnotationElement(parameters);
      case _util.AnnotationType.TEXT:
        return new TextAnnotationElement(parameters);
      case _util.AnnotationType.WIDGET:
        var fieldType = parameters.data.fieldType;
        switch (fieldType) {
          case 'Tx':
            return new TextWidgetAnnotationElement(parameters);
          case 'Btn':
            if (parameters.data.radioButton) {
              return new RadioButtonWidgetAnnotationElement(parameters);
            } else if (parameters.data.checkBox) {
              return new CheckboxWidgetAnnotationElement(parameters);
            }
            (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
            break;
          case 'Ch':
            return new ChoiceWidgetAnnotationElement(parameters);
        }
        return new WidgetAnnotationElement(parameters);
      case _util.AnnotationType.POPUP:
        return new PopupAnnotationElement(parameters);
      case _util.AnnotationType.LINE:
        return new LineAnnotationElement(parameters);
      case _util.AnnotationType.HIGHLIGHT:
        return new HighlightAnnotationElement(parameters);
      case _util.AnnotationType.UNDERLINE:
        return new UnderlineAnnotationElement(parameters);
      case _util.AnnotationType.SQUIGGLY:
        return new SquigglyAnnotationElement(parameters);
      case _util.AnnotationType.STRIKEOUT:
        return new StrikeOutAnnotationElement(parameters);
      case _util.AnnotationType.FILEATTACHMENT:
        return new FileAttachmentAnnotationElement(parameters);
      default:
        return new AnnotationElement(parameters);
    }
  }
};
var AnnotationElement = function AnnotationElementClosure() {
  function AnnotationElement(parameters, isRenderable, ignoreBorder) {
    this.isRenderable = isRenderable || false;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }
  AnnotationElement.prototype = {
    _createContainer: function AnnotationElement_createContainer(ignoreBorder) {
      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);
      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';
        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
        }
        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;
          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;
          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;
          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;
          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;
          default:
            break;
        }
        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }
      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    },
    _createPopup: function AnnotationElement_createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }
      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    },
    render: function AnnotationElement_render() {
      throw new Error('Abstract method AnnotationElement.render called');
    }
  };
  return AnnotationElement;
}();
var LinkAnnotationElement = function LinkAnnotationElementClosure() {
  function LinkAnnotationElement(parameters) {
    AnnotationElement.call(this, parameters, true);
  }
  _util.Util.inherit(LinkAnnotationElement, AnnotationElement, {
    render: function LinkAnnotationElement_render() {
      this.container.className = 'linkAnnotation';
      var link = document.createElement('a');
      (0, _dom_utils.addLinkAttributes)(link, {
        url: this.data.url,
        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
      });
      if (!this.data.url) {
        if (this.data.action) {
          this._bindNamedAction(link, this.data.action);
        } else {
          this._bindLink(link, this.data.dest);
        }
      }
      this.container.appendChild(link);
      return this.container;
    },
    _bindLink: function _bindLink(link, destination) {
      var _this = this;

      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this.linkService.navigateTo(destination);
        }
        return false;
      };
      if (destination) {
        link.className = 'internalLink';
      }
    },
    _bindNamedAction: function _bindNamedAction(link, action) {
      var _this2 = this;

      link.href = this.linkService.getAnchorUrl('');
      link.onclick = function () {
        _this2.linkService.executeNamedAction(action);
        return false;
      };
      link.className = 'internalLink';
    }
  });
  return LinkAnnotationElement;
}();
var TextAnnotationElement = function TextAnnotationElementClosure() {
  function TextAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(TextAnnotationElement, AnnotationElement, {
    render: function TextAnnotationElement_render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }
      this.container.appendChild(image);
      return this.container;
    }
  });
  return TextAnnotationElement;
}();
var WidgetAnnotationElement = function WidgetAnnotationElementClosure() {
  function WidgetAnnotationElement(parameters, isRenderable) {
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(WidgetAnnotationElement, AnnotationElement, {
    render: function WidgetAnnotationElement_render() {
      return this.container;
    }
  });
  return WidgetAnnotationElement;
}();
var TextWidgetAnnotationElement = function TextWidgetAnnotationElementClosure() {
  var TEXT_ALIGNMENT = ['left', 'center', 'right'];
  function TextWidgetAnnotationElement(parameters) {
    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    WidgetAnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(TextWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function TextWidgetAnnotationElement_render() {
      this.container.className = 'textWidgetAnnotation';
      var element = null;
      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }
        element.disabled = this.data.readOnly;
        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;
        if (this.data.fontRefName) {
          font = this.page.commonObjs.getData(this.data.fontRefName);
        }
        this._setTextStyle(element, font);
      }
      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
      this.container.appendChild(element);
      return this.container;
    },
    _setTextStyle: function TextWidgetAnnotationElement_setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
      if (!font) {
        return;
      }
      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  });
  return TextWidgetAnnotationElement;
}();
var CheckboxWidgetAnnotationElement = function CheckboxWidgetAnnotationElementClosure() {
  function CheckboxWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(CheckboxWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function CheckboxWidgetAnnotationElement_render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';
      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  });
  return CheckboxWidgetAnnotationElement;
}();
var RadioButtonWidgetAnnotationElement = function RadioButtonWidgetAnnotationElementClosure() {
  function RadioButtonWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(RadioButtonWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function RadioButtonWidgetAnnotationElement_render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;
      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  });
  return RadioButtonWidgetAnnotationElement;
}();
var ChoiceWidgetAnnotationElement = function ChoiceWidgetAnnotationElementClosure() {
  function ChoiceWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(ChoiceWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function ChoiceWidgetAnnotationElement_render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;
        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
          optionElement.setAttribute('selected', true);
        }
        selectElement.appendChild(optionElement);
      }
      this.container.appendChild(selectElement);
      return this.container;
    }
  });
  return ChoiceWidgetAnnotationElement;
}();
var PopupAnnotationElement = function PopupAnnotationElementClosure() {
  var IGNORE_TYPES = ['Line'];
  function PopupAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(PopupAnnotationElement, AnnotationElement, {
    render: function PopupAnnotationElement_render() {
      this.container.className = 'popupAnnotation';
      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
        return this.container;
      }
      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);
      if (!parentElement) {
        return this.container;
      }
      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  });
  return PopupAnnotationElement;
}();
var PopupElement = function PopupElementClosure() {
  var BACKGROUND_ENLIGHT = 0.7;
  function PopupElement(parameters) {
    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }
  PopupElement.prototype = {
    render: function PopupElement_render() {
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;
      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }
      var contents = this._formatContents(this.contents);
      var title = document.createElement('h1');
      title.textContent = this.title;
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      popup.appendChild(title);
      popup.appendChild(contents);
      wrapper.appendChild(popup);
      return wrapper;
    },
    _formatContents: function PopupElement_formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));
        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }
      return p;
    },
    _toggle: function PopupElement_toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    },
    _show: function PopupElement_show(pin) {
      if (pin) {
        this.pinned = true;
      }
      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    },
    _hide: function PopupElement_hide(unpin) {
      if (unpin) {
        this.pinned = false;
      }
      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  };
  return PopupElement;
}();
var LineAnnotationElement = function LineAnnotationElementClosure() {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function LineAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(LineAnnotationElement, AnnotationElement, {
    render: function LineAnnotationElement_render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttributeNS(null, 'version', '1.1');
      svg.setAttributeNS(null, 'width', width + 'px');
      svg.setAttributeNS(null, 'height', height + 'px');
      svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
      svg.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
      var line = document.createElementNS(SVG_NS, 'svg:line');
      line.setAttributeNS(null, 'x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttributeNS(null, 'y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttributeNS(null, 'x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttributeNS(null, 'y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttributeNS(null, 'stroke-width', data.borderStyle.width);
      line.setAttributeNS(null, 'stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);
      this._createPopup(this.container, line, this.data);
      return this.container;
    }
  });
  return LineAnnotationElement;
}();
var HighlightAnnotationElement = function HighlightAnnotationElementClosure() {
  function HighlightAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(HighlightAnnotationElement, AnnotationElement, {
    render: function HighlightAnnotationElement_render() {
      this.container.className = 'highlightAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return HighlightAnnotationElement;
}();
var UnderlineAnnotationElement = function UnderlineAnnotationElementClosure() {
  function UnderlineAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(UnderlineAnnotationElement, AnnotationElement, {
    render: function UnderlineAnnotationElement_render() {
      this.container.className = 'underlineAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return UnderlineAnnotationElement;
}();
var SquigglyAnnotationElement = function SquigglyAnnotationElementClosure() {
  function SquigglyAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(SquigglyAnnotationElement, AnnotationElement, {
    render: function SquigglyAnnotationElement_render() {
      this.container.className = 'squigglyAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return SquigglyAnnotationElement;
}();
var StrikeOutAnnotationElement = function StrikeOutAnnotationElementClosure() {
  function StrikeOutAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(StrikeOutAnnotationElement, AnnotationElement, {
    render: function StrikeOutAnnotationElement_render() {
      this.container.className = 'strikeoutAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return StrikeOutAnnotationElement;
}();
var FileAttachmentAnnotationElement = function FileAttachmentAnnotationElementClosure() {
  function FileAttachmentAnnotationElement(parameters) {
    AnnotationElement.call(this, parameters, true);
    var file = this.data.file;
    this.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
    this.content = file.content;
    this.linkService.onFileAttachmentAnnotation({
      id: (0, _util.stringToPDFString)(file.filename),
      filename: file.filename,
      content: file.content
    });
  }
  _util.Util.inherit(FileAttachmentAnnotationElement, AnnotationElement, {
    render: function FileAttachmentAnnotationElement_render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));
      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }
      this.container.appendChild(trigger);
      return this.container;
    },
    _download: function FileAttachmentAnnotationElement_download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }
      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  });
  return FileAttachmentAnnotationElement;
}();
var AnnotationLayer = function AnnotationLayerClosure() {
  return {
    render: function AnnotationLayer_render(parameters) {
      var annotationElementFactory = new AnnotationElementFactory();
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        if (!data) {
          continue;
        }
        var element = annotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
          renderInteractiveForms: parameters.renderInteractiveForms || false
        });
        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    },
    update: function AnnotationLayer_update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
        if (element) {
          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
        }
      }
      parameters.div.removeAttribute('hidden');
    }
  };
}();
exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build = exports.version = exports._UnsupportedManager = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(1);

var _font_loader = __w_pdfjs_require__(11);

var _canvas = __w_pdfjs_require__(10);

var _metadata = __w_pdfjs_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var workerSrc;
var isPostMessageTransfersDisabled = false;
var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
var fakeWorkerFilesLoader = null;
var useRequireEnsure = false;
{
  if (typeof window === 'undefined') {
    isWorkerDisabled = true;
    if (false) {
      require.ensure = require('node-ensure');
    }
    useRequireEnsure = true;
  } else if (true) {
    useRequireEnsure = true;
  }
  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }
  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
    __webpack_require__.e/* require.ensure */(72).then((function () {
      var worker;
      worker = __webpack_require__(1253);
      callback(worker.WorkerMessageHandler);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } : dynamicLoaderSupported ? function (callback) {
    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
      callback(worker.WorkerMessageHandler);
    });
  } : null;
}
function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
  var task = new PDFDocumentLoadingTask();
  if (arguments.length > 1) {
    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
  }
  if (pdfDataRangeTransport) {
    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
      pdfDataRangeTransport.length = src.length;
      pdfDataRangeTransport.initialData = src.initialData;
      if (!pdfDataRangeTransport.abort) {
        pdfDataRangeTransport.abort = function () {};
      }
    }
    src = Object.create(src);
    src.range = pdfDataRangeTransport;
  }
  task.onPassword = passwordCallback || null;
  task.onProgress = progressCallback || null;
  var source;
  if (typeof src === 'string') {
    source = { url: src };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = { data: src };
  } else if (src instanceof PDFDataRangeTransport) {
    source = { range: src };
  } else {
    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }
    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }
    source = src;
  }
  var params = {};
  var rangeTransport = null;
  var worker = null;
  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];
      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }
      continue;
    } else if (key === 'CMapReaderFactory') {
      CMapReaderFactory = source[key];
      continue;
    }
    params[key] = source[key];
  }
  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.ignoreErrors = params.stopAtErrors !== true;
  if (params.disableNativeImageDecoder !== undefined) {
    (0, _util.deprecated)('parameter disableNativeImageDecoder, ' + 'use nativeImageDecoderSupport instead');
  }
  params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
  if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
    (0, _util.warn)('Invalid parameter nativeImageDecoderSupport: ' + 'need a state of enum {NativeImageDecoding}');
    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
  }
  if (!worker) {
    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
    task._worker = worker;
  }
  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }
    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }
      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
      var transport = new WorkerTransport(messageHandler, task, rangeTransport, CMapReaderFactory);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  }).catch(task._capability.reject);
  return task;
}
function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }
  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
  source.chunkedViewerLoading = !!pdfDataRangeTransport;
  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
  }
  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    source: source,
    disableRange: (0, _dom_utils.getDefaultSetting)('disableRange'),
    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }
    return workerId;
  });
}
var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;
  function PDFDocumentLoadingTask() {
    this._capability = (0, _util.createPromiseCapability)();
    this._transport = null;
    this._worker = null;
    this.docId = 'd' + nextDocumentId++;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
    this.onUnsupportedFeature = null;
  }
  PDFDocumentLoadingTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    destroy: function destroy() {
      var _this = this;

      this.destroyed = true;
      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
      return transportDestroyed.then(function () {
        _this._transport = null;
        if (_this._worker) {
          _this._worker.destroy();
          _this._worker = null;
        }
      });
    },

    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return PDFDocumentLoadingTask;
}();
var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
  function PDFDataRangeTransport(length, initialData) {
    this.length = length;
    this.initialData = initialData;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }
  PDFDataRangeTransport.prototype = {
    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
      this._rangeListeners.push(listener);
    },
    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
      this._progressListeners.push(listener);
    },
    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    },
    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
      var listeners = this._rangeListeners;
      for (var i = 0, n = listeners.length; i < n; ++i) {
        listeners[i](begin, chunk);
      }
    },
    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this2._progressListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](loaded);
        }
      });
    },
    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this3._progressiveReadListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](chunk);
        }
      });
    },
    transportReady: function PDFDataRangeTransport_transportReady() {
      this._readyCapability.resolve();
    },
    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
    },
    abort: function PDFDataRangeTransport_abort() {}
  };
  return PDFDataRangeTransport;
}();
var PDFDocumentProxy = function PDFDocumentProxyClosure() {
  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
    this.pdfInfo = pdfInfo;
    this.transport = transport;
    this.loadingTask = loadingTask;
  }
  PDFDocumentProxy.prototype = {
    get numPages() {
      return this.pdfInfo.numPages;
    },
    get fingerprint() {
      return this.pdfInfo.fingerprint;
    },
    getPage: function PDFDocumentProxy_getPage(pageNumber) {
      return this.transport.getPage(pageNumber);
    },
    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
      return this.transport.getPageIndex(ref);
    },
    getDestinations: function PDFDocumentProxy_getDestinations() {
      return this.transport.getDestinations();
    },
    getDestination: function PDFDocumentProxy_getDestination(id) {
      return this.transport.getDestination(id);
    },
    getPageLabels: function PDFDocumentProxy_getPageLabels() {
      return this.transport.getPageLabels();
    },
    getAttachments: function PDFDocumentProxy_getAttachments() {
      return this.transport.getAttachments();
    },
    getJavaScript: function PDFDocumentProxy_getJavaScript() {
      return this.transport.getJavaScript();
    },
    getOutline: function PDFDocumentProxy_getOutline() {
      return this.transport.getOutline();
    },
    getMetadata: function PDFDocumentProxy_getMetadata() {
      return this.transport.getMetadata();
    },
    getData: function PDFDocumentProxy_getData() {
      return this.transport.getData();
    },
    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
      return this.transport.downloadInfoCapability.promise;
    },
    getStats: function PDFDocumentProxy_getStats() {
      return this.transport.getStats();
    },
    cleanup: function PDFDocumentProxy_cleanup() {
      this.transport.startCleanup();
    },
    destroy: function PDFDocumentProxy_destroy() {
      return this.loadingTask.destroy();
    }
  };
  return PDFDocumentProxy;
}();
var PDFPageProxy = function PDFPageProxyClosure() {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    this.pageIndex = pageIndex;
    this.pageInfo = pageInfo;
    this.transport = transport;
    this.stats = new _util.StatTimer();
    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }
  PDFPageProxy.prototype = {
    get pageNumber() {
      return this.pageIndex + 1;
    },
    get rotate() {
      return this.pageInfo.rotate;
    },
    get ref() {
      return this.pageInfo.ref;
    },
    get userUnit() {
      return this.pageInfo.userUnit;
    },
    get view() {
      return this.pageInfo.view;
    },
    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
      if (arguments.length < 2) {
        rotate = this.rotate;
      }
      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
    },
    getAnnotations: function PDFPageProxy_getAnnotations(params) {
      var intent = params && params.intent || null;
      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }
      return this.annotationsPromise;
    },
    render: function PDFPageProxy_render(params) {
      var _this4 = this;

      var stats = this.stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: params.renderInteractiveForms === true
        });
      }
      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);
        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }
        if (_this4.cleanupAfterRender) {
          _this4.pendingCleanup = true;
        }
        _this4._tryCleanup();
        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }
        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };
      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }
      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      if (params.continueCallback) {
        (0, _util.deprecated)('render is used with continueCallback parameter');
        renderTask.onContinue = params.continueCallback;
      }
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this4.pendingCleanup) {
          complete();
          return;
        }
        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    },
    getOperatorList: function PDFPageProxy_getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);
          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }
      var renderingIntent = 'oplist';
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      var opListTask;
      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }
      return intentState.opListReadCapability.promise;
    },
    streamTextContent: function streamTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this.transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: params.normalizeWhitespace === true,
        combineTextItems: params.disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    },

    getTextContent: function PDFPageProxy_getTextContent(params) {
      params = params || {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref) {
            var value = _ref.value,
                done = _ref.done;

            if (done) {
              resolve(textContent);
              return;
            }
            _util.Util.extendObj(textContent.styles, value.styles);
            _util.Util.appendToArray(textContent.items, value.items);
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    },
    _destroy: function PDFPageProxy_destroy() {
      this.destroyed = true;
      this.transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }
        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise.catch(function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    },
    destroy: function destroy() {
      (0, _util.deprecated)('page destroy method, use cleanup() instead');
      this.cleanup();
    },

    cleanup: function PDFPageProxy_cleanup() {
      this.pendingCleanup = true;
      this._tryCleanup();
    },
    _tryCleanup: function PDFPageProxy_tryCleanup() {
      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }
      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
    },
    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];
      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    },
    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];
      var i, ii;
      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      for (i = 0; i < intentState.renderTasks.length; i++) {
        intentState.renderTasks[i].operatorListChanged();
      }
      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;
        this._tryCleanup();
      }
    }
  };
  return PDFPageProxy;
}();

var LoopbackPort = function () {
  function LoopbackPort(defer) {
    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: 'postMessage',
    value: function postMessage(obj, transfers) {
      var _this5 = this;

      function cloneValue(value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
          return value;
        }
        if (cloned.has(value)) {
          return cloned.get(value);
        }
        var result;
        var buffer;
        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.indexOf(buffer) >= 0;
          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }
          cloned.set(value, result);
          return result;
        }
        result = (0, _util.isArray)(value) ? [] : {};
        cloned.set(value, result);
        for (var i in value) {
          var desc,
              p = value;
          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }
          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }
          result[i] = cloneValue(desc.value);
        }
        return result;
      }
      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, { data: obj });
        }, this);
        return;
      }
      var cloned = new WeakMap();
      var e = { data: cloneValue(obj) };
      this._deferred.then(function () {
        _this5._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this5);
      });
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);
      this._listeners.splice(i, 1);
    }
  }, {
    key: 'terminate',
    value: function terminate() {
      this._listeners = [];
    }
  }]);

  return LoopbackPort;
}();

var PDFWorker = function PDFWorkerClosure() {
  var nextFakeWorkerId = 0;
  function getWorkerSrc() {
    if (typeof workerSrc !== 'undefined') {
      return workerSrc;
    }
    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
      return (0, _dom_utils.getDefaultSetting)('workerSrc');
    }
    if (pdfjsFilePath) {
      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
    throw new Error('No PDFJS.workerSrc specified');
  }
  var fakeWorkerFilesLoadedCapability = void 0;
  function setupFakeWorkerGlobal() {
    var WorkerMessageHandler;
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }
    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var loader = fakeWorkerFilesLoader || function (callback) {
      _util.Util.loadScript(getWorkerSrc(), function () {
        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
      });
    };
    loader(fakeWorkerFilesLoadedCapability.resolve);
    return fakeWorkerFilesLoadedCapability.promise;
  }
  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return URL.createObjectURL(new Blob([wrapper]));
  }
  var pdfWorkerPorts = new WeakMap();
  function PDFWorker(name, port) {
    if (port && pdfWorkerPorts.has(port)) {
      throw new Error('Cannot use more than one PDFWorker per port');
    }
    this.name = name;
    this.destroyed = false;
    this._readyCapability = (0, _util.createPromiseCapability)();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      pdfWorkerPorts.set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  PDFWorker.prototype = {
    get promise() {
      return this._readyCapability.promise;
    },
    get port() {
      return this._port;
    },
    get messageHandler() {
      return this._messageHandler;
    },
    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
      this._messageHandler.on('ready', function () {});
      this._readyCapability.resolve();
    },
    _initialize: function PDFWorker_initialize() {
      var _this6 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
        var workerSrc = getWorkerSrc();
        try {
          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
          }
          var worker = new Worker(workerSrc);
          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
          var terminateEarly = function terminateEarly() {
            worker.removeEventListener('error', onWorkerError);
            messageHandler.destroy();
            worker.terminate();
            if (_this6.destroyed) {
              _this6._readyCapability.reject(new Error('Worker was destroyed'));
            } else {
              _this6._setupFakeWorker();
            }
          };
          var onWorkerError = function onWorkerError() {
            if (!_this6._webWorker) {
              terminateEarly();
            }
          };
          worker.addEventListener('error', onWorkerError);
          messageHandler.on('test', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            var supportTypedArray = data && data.supportTypedArray;
            if (supportTypedArray) {
              _this6._messageHandler = messageHandler;
              _this6._port = worker;
              _this6._webWorker = worker;
              if (!data.supportTransfers) {
                isPostMessageTransfersDisabled = true;
              }
              _this6._readyCapability.resolve();
              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
            } else {
              _this6._setupFakeWorker();
              messageHandler.destroy();
              worker.terminate();
            }
          });
          messageHandler.on('console_log', function (data) {
            console.log.apply(console, data);
          });
          messageHandler.on('console_error', function (data) {
            console.error.apply(console, data);
          });
          messageHandler.on('ready', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            try {
              sendTest();
            } catch (e) {
              _this6._setupFakeWorker();
            }
          });
          var sendTest = function sendTest() {
            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
            try {
              messageHandler.send('test', testObj, [testObj.buffer]);
            } catch (ex) {
              (0, _util.info)('Cannot use postMessage transfers');
              testObj[0] = 0;
              messageHandler.send('test', testObj);
            }
          };
          sendTest();
          return;
        } catch (e) {
          (0, _util.info)('The worker has been disabled.');
        }
      }
      this._setupFakeWorker();
    },
    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
      var _this7 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
        (0, _util.warn)('Setting up fake worker.');
        isWorkerDisabled = true;
      }
      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
        if (_this7.destroyed) {
          _this7._readyCapability.reject(new Error('Worker was destroyed'));
          return;
        }
        var isTypedArraysPresent = Uint8Array !== Float32Array;
        var port = new LoopbackPort(isTypedArraysPresent);
        _this7._port = port;
        var id = 'fake' + nextFakeWorkerId++;
        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
        _this7._messageHandler = messageHandler;
        _this7._readyCapability.resolve();
      });
    },
    destroy: function PDFWorker_destroy() {
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  };
  PDFWorker.fromPort = function (port) {
    if (pdfWorkerPorts.has(port)) {
      return pdfWorkerPorts.get(port);
    }
    return new PDFWorker(null, port);
  };
  return PDFWorker;
}();
var WorkerTransport = function WorkerTransportClosure() {
  function WorkerTransport(messageHandler, loadingTask, pdfDataRangeTransport, CMapReaderFactory) {
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.pdfDataRangeTransport = pdfDataRangeTransport;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
    this.CMapReaderFactory = new CMapReaderFactory({
      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }
  WorkerTransport.prototype = {
    destroy: function WorkerTransport_destroy() {
      var _this8 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();
      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }
      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache = [];
      this.pagePromises = [];
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this8.fontLoader.clear();
        if (_this8.pdfDataRangeTransport) {
          _this8.pdfDataRangeTransport.abort();
          _this8.pdfDataRangeTransport = null;
        }
        if (_this8.messageHandler) {
          _this8.messageHandler.destroy();
          _this8.messageHandler = null;
        }
        _this8.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    },
    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
      var messageHandler = this.messageHandler;
      var loadingTask = this.loadingTask;
      var pdfDataRangeTransport = this.pdfDataRangeTransport;
      if (pdfDataRangeTransport) {
        pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
          messageHandler.send('OnDataRange', {
            begin: begin,
            chunk: chunk
          });
        });
        pdfDataRangeTransport.addProgressListener(function (loaded) {
          messageHandler.send('OnDataProgress', { loaded: loaded });
        });
        pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
          messageHandler.send('OnDataRange', { chunk: chunk });
        });
        messageHandler.on('RequestDataRange', function transportDataRange(data) {
          pdfDataRangeTransport.requestDataRange(data.begin, data.end);
        }, this);
      }
      messageHandler.on('GetDoc', function transportDoc(data) {
        var pdfInfo = data.pdfInfo;
        this.numPages = data.pdfInfo.numPages;
        var loadingTask = this.loadingTask;
        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
        this.pdfDocument = pdfDocument;
        loadingTask._capability.resolve(pdfDocument);
      }, this);
      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
        var _this9 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this9._passwordCapability.resolve({ password: password });
          };
          loadingTask.onPassword(updatePassword, exception.code);
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }
        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function transportPasswordException(exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function transportUnknownError(exception) {
        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function transportPage(data) {
        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('PDFManagerReady', function transportPage(data) {
        if (this.pdfDataRangeTransport) {
          this.pdfDataRangeTransport.transportReady();
        }
      }, this);
      messageHandler.on('StartRenderPage', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page.stats.timeEnd('Page Request');
        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function transportObj(data) {
        var _this10 = this;

        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var type = data[1];
        if (this.commonObjs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'Font':
            var exportedData = data[2];
            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)('Error during font loading: ' + exportedError);
              this.commonObjs.resolve(id, exportedError);
              break;
            }
            var fontRegistry = null;
            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.FontInspector && _util.globalScope['FontInspector'].enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _util.globalScope['FontInspector'].fontAdded(font, url);
                }
              };
            }
            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSuported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
              fontRegistry: fontRegistry
            });
            var fontReady = function fontReady(fontObjs) {
              _this10.commonObjs.resolve(id, font);
            };
            this.fontLoader.bind([font], fontReady);
            break;
          case 'FontPath':
            this.commonObjs.resolve(id, data[2]);
            break;
          default:
            throw new Error('Got unknown common object type ' + type);
        }
      }, this);
      messageHandler.on('obj', function transportObj(data) {
        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var pageIndex = data[1];
        var type = data[2];
        var pageProxy = this.pageCache[pageIndex];
        var imageData;
        if (pageProxy.objs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'JpegStream':
            imageData = data[3];
            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
            break;
          case 'Image':
            imageData = data[3];
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }
            break;
          default:
            throw new Error('Got unknown object type ' + type);
        }
      }, this);
      messageHandler.on('DocProgress', function transportDocProgress(data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function transportError(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageNum - 1];
        var intentState = page.intentStates[data.intent];
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(data.error);
        } else {
          throw new Error(data.error);
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
        if (this.destroyed) {
          return;
        }
        var featureId = data.featureId;
        var loadingTask = this.loadingTask;
        if (loadingTask.onUnsupportedFeature) {
          loadingTask.onUnsupportedFeature(featureId);
        }
        _UnsupportedManager.notify(featureId);
      }, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }
        var imageUrl = data[0];
        var components = data[1];
        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8Array(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;
            var i, j;
            if (components === 3) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
                buf[j] = data[i];
              }
            }
            resolve({
              data: buf,
              width: width,
              height: height
            });
          };
          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
          };
          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        return this.CMapReaderFactory.fetch({ name: data.name });
      }, this);
    },
    getData: function WorkerTransport_getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    },
    getPage: function WorkerTransport_getPage(pageNumber, capability) {
      var _this11 = this;

      if (!(0, _util.isInt)(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }
      var pageIndex = pageNumber - 1;
      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }
      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
        if (_this11.destroyed) {
          throw new Error('Transport destroyed');
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this11);
        _this11.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    },
    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
        return Promise.reject(new Error(reason));
      });
    },
    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    },
    getDestinations: function WorkerTransport_getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    },
    getDestination: function WorkerTransport_getDestination(id) {
      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
    },
    getPageLabels: function WorkerTransport_getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    },
    getAttachments: function WorkerTransport_getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    },
    getJavaScript: function WorkerTransport_getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    },
    getOutline: function WorkerTransport_getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    },
    getMetadata: function WorkerTransport_getMetadata() {
      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
        };
      });
    },
    getStats: function WorkerTransport_getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    },
    startCleanup: function WorkerTransport_startCleanup() {
      var _this12 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this12.pageCache.length; i < ii; i++) {
          var page = _this12.pageCache[i];
          if (page) {
            page.cleanup();
          }
        }
        _this12.commonObjs.clear();
        _this12.fontLoader.clear();
      });
    }
  };
  return WorkerTransport;
}();
var PDFObjects = function PDFObjectsClosure() {
  function PDFObjects() {
    this.objs = Object.create(null);
  }
  PDFObjects.prototype = {
    ensureObj: function PDFObjects_ensureObj(objId) {
      if (this.objs[objId]) {
        return this.objs[objId];
      }
      var obj = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
      this.objs[objId] = obj;
      return obj;
    },
    get: function PDFObjects_get(objId, callback) {
      if (callback) {
        this.ensureObj(objId).capability.promise.then(callback);
        return null;
      }
      var obj = this.objs[objId];
      if (!obj || !obj.resolved) {
        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
      }
      return obj.data;
    },
    resolve: function PDFObjects_resolve(objId, data) {
      var obj = this.ensureObj(objId);
      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    },
    isResolved: function PDFObjects_isResolved(objId) {
      var objs = this.objs;
      if (!objs[objId]) {
        return false;
      }
      return objs[objId].resolved;
    },
    hasData: function PDFObjects_hasData(objId) {
      return this.isResolved(objId);
    },
    getData: function PDFObjects_getData(objId) {
      var objs = this.objs;
      if (!objs[objId] || !objs[objId].resolved) {
        return null;
      }
      return objs[objId].data;
    },
    clear: function PDFObjects_clear() {
      this.objs = Object.create(null);
    }
  };
  return PDFObjects;
}();
var RenderTask = function RenderTaskClosure() {
  function RenderTask(internalRenderTask) {
    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  RenderTask.prototype = {
    get promise() {
      return this._internalRenderTask.capability.promise;
    },
    cancel: function RenderTask_cancel() {
      this._internalRenderTask.cancel();
    },
    then: function RenderTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return RenderTask;
}();
var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakMap();
  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this.pageNumber = pageNumber;
    this.canvasFactory = canvasFactory;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this.useRequestAnimationFrame = false;
    this.cancelled = false;
    this.capability = (0, _util.createPromiseCapability)();
    this.task = new RenderTask(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  InternalRenderTask.prototype = {
    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
      if (this._canvas) {
        if (canvasInRendering.has(this._canvas)) {
          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
        }
        canvasInRendering.set(this._canvas, this);
      }
      if (this.cancelled) {
        return;
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.StepperManager && _util.globalScope.StepperManager.enabled) {
        this.stepper = _util.globalScope.StepperManager.create(this.pageNumber - 1);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var params = this.params;
      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
      this.gfx.beginDrawing({
        transform: params.transform,
        viewport: params.viewport,
        transparency: transparency,
        background: params.background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      if (this.graphicsReadyCallback) {
        this.graphicsReadyCallback();
      }
    },
    cancel: function InternalRenderTask_cancel() {
      this.running = false;
      this.cancelled = true;
      if (this._canvas) {
        canvasInRendering.delete(this._canvas);
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
      } else {
        this.callback('cancelled');
      }
    },
    operatorListChanged: function InternalRenderTask_operatorListChanged() {
      if (!this.graphicsReady) {
        if (!this.graphicsReadyCallback) {
          this.graphicsReadyCallback = this._continueBound;
        }
        return;
      }
      if (this.stepper) {
        this.stepper.updateOperatorList(this.operatorList);
      }
      if (this.running) {
        return;
      }
      this._continue();
    },
    _continue: function InternalRenderTask__continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    },
    _scheduleNext: function InternalRenderTask__scheduleNext() {
      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
        window.requestAnimationFrame(this._nextBound);
      } else {
        Promise.resolve(undefined).then(this._nextBound);
      }
    },
    _next: function InternalRenderTask__next() {
      if (this.cancelled) {
        return;
      }
      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
      if (this.operatorListIdx === this.operatorList.argsArray.length) {
        this.running = false;
        if (this.operatorList.lastChunk) {
          this.gfx.endDrawing();
          if (this._canvas) {
            canvasInRendering.delete(this._canvas);
          }
          this.callback();
        }
      }
    }
  };
  return InternalRenderTask;
}();
var _UnsupportedManager = function UnsupportedManagerClosure() {
  var listeners = [];
  return {
    listen: function listen(cb) {
      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
      listeners.push(cb);
    },
    notify: function notify(featureId) {
      for (var i = 0, ii = listeners.length; i < ii; i++) {
        listeners[i](featureId);
      }
    }
  };
}();
var version, build;
{
  exports.version = version = '1.8.557';
  exports.build = build = '4a74cc41';
}
exports.getDocument = getDocument;
exports.LoopbackPort = LoopbackPort;
exports.PDFDataRangeTransport = PDFDataRangeTransport;
exports.PDFWorker = PDFWorker;
exports.PDFDocumentProxy = PDFDocumentProxy;
exports.PDFPageProxy = PDFPageProxy;
exports._UnsupportedManager = _UnsupportedManager;
exports.version = version;
exports.build = build;

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};
{
  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var convertImgDataToPng = function convertImgDataToPngClosure() {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);
    for (var i = 0; i < 256; i++) {
      var c = i;
      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }
      crcTable[i] = c;
    }
    function crc32(data, start, end) {
      var crc = -1;
      for (var i = start; i < end; i++) {
        var a = (crc ^ data[i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }
      return crc ^ -1;
    }
    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }
    function adler32(data, start, end) {
      var a = 1;
      var b = 0;
      for (var i = start; i < end; ++i) {
        a = (a + (data[i] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }
      return b << 16 | a;
    }
    function deflateSync(literals) {
      if (!(0, _util.isNodeJS)()) {
        return deflateSyncUncompressed(literals);
      }
      try {
        var input;
        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }
        var output = __webpack_require__(889).deflateSync(input, { level: 9 });
        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }
      return deflateSyncUncompressed(literals);
    }
    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;
      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }
      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }
    function encode(imgData, kind, forceDataSchema) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;
      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;
        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;
        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;
        default:
          throw new Error('invalid format');
      }
      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;
      var y, i;
      for (y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }
      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
        offsetLiterals = 0;
        for (y = 0; y < height; y++) {
          offsetLiterals++;
          for (i = 0; i < lineSize; i++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }
      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }
    return function convertImgDataToPng(imgData, forceDataSchema) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema);
    };
  }();
  var SVGExtraState = function SVGExtraStateClosure() {
    function SVGExtraState() {
      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }
    SVGExtraState.prototype = {
      clone: function SVGExtraState_clone() {
        return Object.create(this);
      },
      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    };
    return SVGExtraState;
  }();
  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
    function opListToTree(opList) {
      var opTree = [];
      var tmp = [];
      var opListLen = opList.length;
      for (var x = 0; x < opListLen; x++) {
        if (opList[x].fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }
        if (opList[x].fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opList[x]);
        }
      }
      return opTree;
    }
    function pf(value) {
      if (value === (value | 0)) {
        return value.toString();
      }
      var s = value.toFixed(10);
      var i = s.length - 1;
      if (s[i] !== '0') {
        return s;
      }
      do {
        i--;
      } while (s[i] === '0');
      return s.substr(0, s[i] === '.' ? i : i + 1);
    }
    function pm(m) {
      if (m[4] === 0 && m[5] === 0) {
        if (m[1] === 0 && m[2] === 0) {
          if (m[0] === 1 && m[3] === 1) {
            return '';
          }
          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
        }
        if (m[0] === m[3] && m[1] === -m[2]) {
          var a = Math.acos(m[0]) * 180 / Math.PI;
          return 'rotate(' + pf(a) + ')';
        }
      } else {
        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
        }
      }
      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
    }
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
    }
    var NS = 'http://www.w3.org/2000/svg';
    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
    var XLINK_NS = 'http://www.w3.org/1999/xlink';
    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
    var clipCount = 0;
    var maskCount = 0;
    SVGGraphics.prototype = {
      save: function SVGGraphics_save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      },
      restore: function SVGGraphics_restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      },
      group: function SVGGraphics_group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      },
      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var argsArray = operatorList.argsArray;
        for (var i = 0; i < fnArrayLen; i++) {
          if (_util.OPS.dependency === fnArray[i]) {
            var deps = argsArray[i];
            for (var n = 0, nn = deps.length; n < nn; n++) {
              var obj = deps[n];
              var common = obj.substring(0, 2) === 'g_';
              var promise;
              if (common) {
                promise = new Promise(function (resolve) {
                  _this.commonObjs.get(obj, resolve);
                });
              } else {
                promise = new Promise(function (resolve) {
                  _this.objs.get(obj, resolve);
                });
              }
              this.current.dependencies.push(promise);
            }
          }
        }
        return Promise.all(this.current.dependencies);
      },
      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      },
      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;
        var svgElement = this._initialize(viewport);
        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;
          var opTree = _this2.convertOpList(operatorList);
          _this2.executeOpTree(opTree);
          return svgElement;
        });
      },
      convertOpList: function SVGGraphics_convertOpList(operatorList) {
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var REVOPS = [];
        var opList = [];
        for (var op in _util.OPS) {
          REVOPS[_util.OPS[op]] = op;
        }
        for (var x = 0; x < fnArrayLen; x++) {
          var fnId = fnArray[x];
          opList.push({
            'fnId': fnId,
            'fn': REVOPS[fnId],
            'args': argsArray[x]
          });
        }
        return opListToTree(opList);
      },
      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
        var opTreeLen = opTree.length;
        for (var x = 0; x < opTreeLen; x++) {
          var fn = opTree[x].fn;
          var fnId = opTree[x].fnId;
          var args = opTree[x].args;
          switch (fnId | 0) {
            case _util.OPS.beginText:
              this.beginText();
              break;
            case _util.OPS.setLeading:
              this.setLeading(args);
              break;
            case _util.OPS.setLeadingMoveText:
              this.setLeadingMoveText(args[0], args[1]);
              break;
            case _util.OPS.setFont:
              this.setFont(args);
              break;
            case _util.OPS.showText:
              this.showText(args[0]);
              break;
            case _util.OPS.showSpacedText:
              this.showText(args[0]);
              break;
            case _util.OPS.endText:
              this.endText();
              break;
            case _util.OPS.moveText:
              this.moveText(args[0], args[1]);
              break;
            case _util.OPS.setCharSpacing:
              this.setCharSpacing(args[0]);
              break;
            case _util.OPS.setWordSpacing:
              this.setWordSpacing(args[0]);
              break;
            case _util.OPS.setHScale:
              this.setHScale(args[0]);
              break;
            case _util.OPS.setTextMatrix:
              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.setLineWidth:
              this.setLineWidth(args[0]);
              break;
            case _util.OPS.setLineJoin:
              this.setLineJoin(args[0]);
              break;
            case _util.OPS.setLineCap:
              this.setLineCap(args[0]);
              break;
            case _util.OPS.setMiterLimit:
              this.setMiterLimit(args[0]);
              break;
            case _util.OPS.setFillRGBColor:
              this.setFillRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setStrokeRGBColor:
              this.setStrokeRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setDash:
              this.setDash(args[0], args[1]);
              break;
            case _util.OPS.setGState:
              this.setGState(args[0]);
              break;
            case _util.OPS.fill:
              this.fill();
              break;
            case _util.OPS.eoFill:
              this.eoFill();
              break;
            case _util.OPS.stroke:
              this.stroke();
              break;
            case _util.OPS.fillStroke:
              this.fillStroke();
              break;
            case _util.OPS.eoFillStroke:
              this.eoFillStroke();
              break;
            case _util.OPS.clip:
              this.clip('nonzero');
              break;
            case _util.OPS.eoClip:
              this.clip('evenodd');
              break;
            case _util.OPS.paintSolidColorImageMask:
              this.paintSolidColorImageMask();
              break;
            case _util.OPS.paintJpegXObject:
              this.paintJpegXObject(args[0], args[1], args[2]);
              break;
            case _util.OPS.paintImageXObject:
              this.paintImageXObject(args[0]);
              break;
            case _util.OPS.paintInlineImageXObject:
              this.paintInlineImageXObject(args[0]);
              break;
            case _util.OPS.paintImageMaskXObject:
              this.paintImageMaskXObject(args[0]);
              break;
            case _util.OPS.paintFormXObjectBegin:
              this.paintFormXObjectBegin(args[0], args[1]);
              break;
            case _util.OPS.paintFormXObjectEnd:
              this.paintFormXObjectEnd();
              break;
            case _util.OPS.closePath:
              this.closePath();
              break;
            case _util.OPS.closeStroke:
              this.closeStroke();
              break;
            case _util.OPS.closeFillStroke:
              this.closeFillStroke();
              break;
            case _util.OPS.nextLine:
              this.nextLine();
              break;
            case _util.OPS.transform:
              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.constructPath:
              this.constructPath(args[0], args[1]);
              break;
            case _util.OPS.endPath:
              this.endPath();
              break;
            case 92:
              this.group(opTree[x].items);
              break;
            default:
              (0, _util.warn)('Unimplemented operator ' + fn);
              break;
          }
        }
      },
      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      },
      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      },
      nextLine: function SVGGraphics_nextLine() {
        this.moveText(0, this.current.leading);
      },
      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        current.xcoords = [];
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = document.createElementNS(NS, 'svg:text');
        current.txtElement.appendChild(current.tspan);
      },
      beginText: function SVGGraphics_beginText() {
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.current.textMatrix = _util.IDENTITY_MATRIX;
        this.current.lineMatrix = _util.IDENTITY_MATRIX;
        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
        this.current.txtElement = document.createElementNS(NS, 'svg:text');
        this.current.txtgrp = document.createElementNS(NS, 'svg:g');
        this.current.xcoords = [];
      },
      moveText: function SVGGraphics_moveText(x, y) {
        var current = this.current;
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
        current.xcoords = [];
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      },
      showText: function SVGGraphics_showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        if (fontSize === 0) {
          return;
        }
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0,
            i;
        for (i = 0; i < glyphsLength; ++i) {
          var glyph = glyphs[i];
          if (glyph === null) {
            x += fontDirection * wordSpacing;
            continue;
          } else if ((0, _util.isNum)(glyph)) {
            x += -glyph * fontSize * 0.001;
            continue;
          }
          current.xcoords.push(current.x + x * textHScale);
          var width = glyph.width;
          var character = glyph.fontChar;
          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
          x += charWidth;
          current.tspan.textContent += character;
        }
        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }
        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }
        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }
        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
        }
        current.txtElement.setAttributeNS(null, 'transform', pm(current.textMatrix) + ' scale(1, -1)');
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);
        this._ensureTransformGroup().appendChild(current.txtElement);
      },
      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      },
      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = document.createElementNS(NS, 'svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }
        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
      },
      setFont: function SVGGraphics_setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        this.current.font = fontObj;
        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }
        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';
        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }
        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      },
      endText: function SVGGraphics_endText() {},
      setLineWidth: function SVGGraphics_setLineWidth(width) {
        this.current.lineWidth = width;
      },
      setLineCap: function SVGGraphics_setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      },
      setLineJoin: function SVGGraphics_setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      },
      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
        this.current.miterLimit = limit;
      },
      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      },
      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.strokeColor = color;
      },
      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      },
      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.fillColor = color;
        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
        this.current.xcoords = [];
      },
      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      },
      constructPath: function SVGGraphics_constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        current.path = document.createElementNS(NS, 'svg:path');
        var d = [];
        var opLength = ops.length;
        for (var i = 0, j = 0; i < opLength; i++) {
          switch (ops[i] | 0) {
            case _util.OPS.rectangle:
              x = args[j++];
              y = args[j++];
              var width = args[j++];
              var height = args[j++];
              var xw = x + width;
              var yh = y + height;
              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
              break;
            case _util.OPS.moveTo:
              x = args[j++];
              y = args[j++];
              d.push('M', pf(x), pf(y));
              break;
            case _util.OPS.lineTo:
              x = args[j++];
              y = args[j++];
              d.push('L', pf(x), pf(y));
              break;
            case _util.OPS.curveTo:
              x = args[j + 4];
              y = args[j + 5];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
              j += 6;
              break;
            case _util.OPS.curveTo2:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
              j += 4;
              break;
            case _util.OPS.curveTo3:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
              j += 4;
              break;
            case _util.OPS.closePath:
              d.push('Z');
              break;
          }
        }
        current.path.setAttributeNS(null, 'd', d.join(' '));
        current.path.setAttributeNS(null, 'fill', 'none');
        this._ensureTransformGroup().appendChild(current.path);
        current.element = current.path;
        current.setCurrentPoint(x, y);
      },
      endPath: function SVGGraphics_endPath() {
        if (!this.pendingClip) {
          return;
        }
        var current = this.current;
        var clipId = 'clippath' + clipCount;
        clipCount++;
        var clipPath = document.createElementNS(NS, 'svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode();
        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }
        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);
        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
        }
        current.activeClipUrl = 'url(#' + clipId + ')';
        this.tgrp = null;
      },
      clip: function SVGGraphics_clip(type) {
        this.pendingClip = type;
      },
      closePath: function SVGGraphics_closePath() {
        var current = this.current;
        var d = current.path.getAttributeNS(null, 'd');
        d += 'Z';
        current.path.setAttributeNS(null, 'd', d);
      },
      setLeading: function SVGGraphics_setLeading(leading) {
        this.current.leading = -leading;
      },
      setTextRise: function SVGGraphics_setTextRise(textRise) {
        this.current.textRise = textRise;
      },
      setHScale: function SVGGraphics_setHScale(scale) {
        this.current.textHScale = scale / 100;
      },
      setGState: function SVGGraphics_setGState(states) {
        for (var i = 0, ii = states.length; i < ii; i++) {
          var state = states[i];
          var key = state[0];
          var value = state[1];
          switch (key) {
            case 'LW':
              this.setLineWidth(value);
              break;
            case 'LC':
              this.setLineCap(value);
              break;
            case 'LJ':
              this.setLineJoin(value);
              break;
            case 'ML':
              this.setMiterLimit(value);
              break;
            case 'D':
              this.setDash(value[0], value[1]);
              break;
            case 'Font':
              this.setFont(value);
              break;
            case 'CA':
              this.setStrokeAlpha(value);
              break;
            case 'ca':
              this.setFillAlpha(value);
              break;
            default:
              (0, _util.warn)('Unimplemented graphic state ' + key);
              break;
          }
        }
      },
      fill: function SVGGraphics_fill() {
        var current = this.current;
        current.element.setAttributeNS(null, 'fill', current.fillColor);
        current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
      },
      stroke: function SVGGraphics_stroke() {
        var current = this.current;
        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
        current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
        current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
        current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
        current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
        current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
        current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
        current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
        current.element.setAttributeNS(null, 'fill', 'none');
      },
      eoFill: function SVGGraphics_eoFill() {
        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        this.fill();
      },
      fillStroke: function SVGGraphics_fillStroke() {
        this.stroke();
        this.fill();
      },
      eoFillStroke: function SVGGraphics_eoFillStroke() {
        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        this.fillStroke();
      },
      closeStroke: function SVGGraphics_closeStroke() {
        this.closePath();
        this.stroke();
      },
      closeFillStroke: function SVGGraphics_closeFillStroke() {
        this.closePath();
        this.fillStroke();
      },
      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
        var current = this.current;
        var rect = document.createElementNS(NS, 'svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', current.fillColor);
        this._ensureTransformGroup().appendChild(rect);
      },
      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = document.createElementNS(NS, 'svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
        this._ensureTransformGroup().appendChild(imgEl);
      },
      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
        var imgData = this.objs.get(objId);
        if (!imgData) {
          (0, _util.warn)('Dependent image isn\'t ready yet');
          return;
        }
        this.paintInlineImageXObject(imgData);
      },
      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
        var cliprect = document.createElementNS(NS, 'svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = document.createElementNS(NS, 'svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      },
      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = 'mask' + maskCount++;
        var mask = document.createElementNS(NS, 'svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = document.createElementNS(NS, 'svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
        this.defs.appendChild(mask);
        this._ensureTransformGroup().appendChild(rect);
        this.paintInlineImageXObject(imgData, mask);
      },
      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
        if ((0, _util.isArray)(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }
        if ((0, _util.isArray)(bbox) && bbox.length === 4) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = document.createElementNS(NS, 'svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      },
      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
      _initialize: function SVGGraphics_initialize(viewport) {
        var svg = document.createElementNS(NS, 'svg:svg');
        svg.setAttributeNS(null, 'version', '1.1');
        svg.setAttributeNS(null, 'width', viewport.width + 'px');
        svg.setAttributeNS(null, 'height', viewport.height + 'px');
        svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
        svg.setAttributeNS(null, 'viewBox', '0 0 ' + viewport.width + ' ' + viewport.height);
        var definitions = document.createElementNS(NS, 'svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = document.createElementNS(NS, 'svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      },
      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = document.createElementNS(NS, 'svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }
        return this.current.clipGroup;
      },
      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = document.createElementNS(NS, 'svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }
        return this.tgrp;
      }
    };
    return SVGGraphics;
  }();
}
exports.SVGGraphics = SVGGraphics;

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = undefined;

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(1);

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;
  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }
  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
  function appendText(task, geom, styles) {
    var textDiv = document.createElement('div');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };
    task._textDivs.push(textDiv);
    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;
      task._textDivProperties.set(textDiv, textDivProperties);
      return;
    }
    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];
    if (style.vertical) {
      angle += Math.PI / 2;
    }
    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;
    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }
    var left;
    var top;
    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }
    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;
    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
      textDiv.dataset.fontName = geom.fontName;
    }
    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }
    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }
    task._textDivProperties.set(textDiv, textDivProperties);
    if (task._textContentStream) {
      task._layoutText(textDiv);
    }
    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;
      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }
      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;
      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }
      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }
  function render(task) {
    if (task._canceled) {
      return;
    }
    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;
    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }
    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }
    task._renderingDone = true;
    capability.resolve();
  }
  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);
    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;
      var divProperties = task._textDivProperties.get(div);
      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
        task._textDivProperties.set(div, divProperties);
        continue;
      }
      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);
        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });
      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;
        for (var i = 0; i < count; i++) {
          var t = ts[offset++];
          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }
        return result;
      };
      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
      task._textDivProperties.set(div, divProperties);
    }
  }
  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }
  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;
      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }
      var j = horizon.length - 1;
      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }
      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;
        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }
        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }
      boundary.x1New = maxXNew;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }
      var changedHorizon = [],
          lastBoundary = null;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }
      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }
      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New !== undefined) {
          continue;
        }
        var used = false;
        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }
        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }
      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;
      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }
  function TextLayerRenderTask(_ref) {
    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;

    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];
  }
  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    cancel: function TextLayer_cancel() {
      if (this._reader) {
        this._reader.cancel();
        this._reader = null;
      }
      this._canceled = true;
      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }
      this._capability.reject('canceled');
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);
        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;
      var textDivProperties = this._textDivProperties.get(textDiv);
      if (textDivProperties.isWhitespace) {
        return;
      }
      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;
      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._lastFontSize = fontSize;
        this._lastFontFamily = fontFamily;
      }
      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
      var transform = '';
      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = 'scaleX(' + textDivProperties.scale + ')';
      }
      if (textDivProperties.angle !== 0) {
        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
      }
      if (transform !== '') {
        textDivProperties.originalTransform = transform;
        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
      }
      this._textDivProperties.set(textDiv, textDivProperties);
      textLayerFrag.appendChild(textDiv);
    },

    _render: function TextLayer_render(timeout) {
      var _this = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;
        this._processItems(textItems, textStyles);
        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }
            _util.Util.extendObj(styleCache, value.styles);
            _this._processItems(value.items, styleCache);
            pump();
          }, capability.reject);
        };
        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }
      capability.promise.then(function () {
        styleCache = null;
        if (!timeout) {
          render(_this);
        } else {
          _this._renderTimer = setTimeout(function () {
            render(_this);
            _this._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }
      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }
      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];
        var divProperties = this._textDivProperties.get(div);
        if (divProperties.isWhitespace) {
          continue;
        }
        if (expandDivs) {
          var transform = '',
              padding = '';
          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }
          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }
          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }
          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }
          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }
          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }
          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }
          if (transform !== '') {
            _dom_utils.CustomStyle.setProp('transform', div, transform);
          }
        } else {
          div.style.padding = 0;
          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
        }
      }
    }
  };
  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });
    task._render(renderParameters.timeout);
    return task;
  }
  return renderTextLayer;
}();
exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function fixMetadata(meta) {
  return meta.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
    var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
      return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
    });
    var chars = '';
    for (var i = 0; i < bytes.length; i += 2) {
      var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
      chars += code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38 ? String.fromCharCode(code) : '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
    }
    return '>' + chars;
  });
}
function Metadata(meta) {
  if (typeof meta === 'string') {
    meta = fixMetadata(meta);
    var parser = new DOMParser();
    meta = parser.parseFromString(meta, 'application/xml');
  } else if (!(meta instanceof Document)) {
    throw new Error('Metadata: Invalid metadata object');
  }
  this.metaDocument = meta;
  this.metadata = Object.create(null);
  this.parse();
}
Metadata.prototype = {
  parse: function Metadata_parse() {
    var doc = this.metaDocument;
    var rdf = doc.documentElement;
    if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
      rdf = rdf.firstChild;
      while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.nextSibling;
      }
    }
    var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
    if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
      return;
    }
    var children = rdf.childNodes,
        desc,
        entry,
        name,
        i,
        ii,
        length,
        iLength;
    for (i = 0, length = children.length; i < length; i++) {
      desc = children[i];
      if (desc.nodeName.toLowerCase() !== 'rdf:description') {
        continue;
      }
      for (ii = 0, iLength = desc.childNodes.length; ii < iLength; ii++) {
        if (desc.childNodes[ii].nodeName.toLowerCase() !== '#text') {
          entry = desc.childNodes[ii];
          name = entry.nodeName.toLowerCase();
          this.metadata[name] = entry.textContent.trim();
        }
      }
    }
  },
  get: function Metadata_get(name) {
    return this.metadata[name] || null;
  },
  has: function Metadata_has(name) {
    return typeof this.metadata[name] !== 'undefined';
  }
};
exports.Metadata = Metadata;

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLUtils = undefined;

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }
    return shader;
  }
  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }
  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }
  function createProgram(gl, shaders) {
    var program = gl.createProgram();
    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }
    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }
    return program;
  }
  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }
  var currentGL, currentCanvas;
  function generateGL() {
    if (currentGL) {
      return;
    }
    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
  }
  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;
  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }
  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;
    if (!smaskCache) {
      initSmaskGL();
    }
    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }
    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }
  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;
  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }
  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }
    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;
    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;
        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }
    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;
          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;
            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }
          break;
        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }
          break;
      }
    }
    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }
  function cleanup() {
    if (smaskCache && smaskCache.canvas) {
      smaskCache.canvas.width = 0;
      smaskCache.canvas.height = 0;
    }
    if (figuresCache && figuresCache.canvas) {
      figuresCache.canvas.width = 0;
      figuresCache.canvas.height = 0;
    }
    smaskCache = null;
    figuresCache = null;
  }
  return {
    get isEnabled() {
      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
        return false;
      }
      var enabled = false;
      try {
        generateGL();
        enabled = !!currentGL;
      } catch (e) {}
      return (0, _util.shadow)(this, 'isEnabled', enabled);
    },
    composeSMask: composeSMask,
    drawFigures: drawFigures,
    clear: cleanup
  };
}();
exports.WebGLUtils = WebGLUtils;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFJS = exports.isWorker = exports.globalScope = undefined;

var _api = __w_pdfjs_require__(3);

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

var _annotation_layer = __w_pdfjs_require__(2);

var _metadata = __w_pdfjs_require__(6);

var _text_layer = __w_pdfjs_require__(5);

var _svg = __w_pdfjs_require__(4);

var isWorker = typeof window === 'undefined';
if (!_util.globalScope.PDFJS) {
  _util.globalScope.PDFJS = {};
}
var PDFJS = _util.globalScope.PDFJS;
{
  PDFJS.version = '1.8.557';
  PDFJS.build = '4a74cc41';
}
PDFJS.pdfBug = false;
if (PDFJS.verbosity !== undefined) {
  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
}
delete PDFJS.verbosity;
Object.defineProperty(PDFJS, 'verbosity', {
  get: function get() {
    return (0, _util.getVerbosityLevel)();
  },
  set: function set(level) {
    (0, _util.setVerbosityLevel)(level);
  },

  enumerable: true,
  configurable: true
});
PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
PDFJS.OPS = _util.OPS;
PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
PDFJS.isValidUrl = _dom_utils.isValidUrl;
PDFJS.shadow = _util.shadow;
PDFJS.createBlob = _util.createBlob;
PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
};
Object.defineProperty(PDFJS, 'isLittleEndian', {
  configurable: true,
  get: function PDFJS_isLittleEndian() {
    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
  }
});
PDFJS.removeNullCharacters = _util.removeNullCharacters;
PDFJS.PasswordResponses = _util.PasswordResponses;
PDFJS.PasswordException = _util.PasswordException;
PDFJS.UnknownErrorException = _util.UnknownErrorException;
PDFJS.InvalidPDFException = _util.InvalidPDFException;
PDFJS.MissingPDFException = _util.MissingPDFException;
PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
PDFJS.Util = _util.Util;
PDFJS.PageViewport = _util.PageViewport;
PDFJS.createPromiseCapability = _util.createPromiseCapability;
PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
{
  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
  delete PDFJS.openExternalLinksInNewWindow;
  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
    get: function get() {
      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
    },
    set: function set(value) {
      if (value) {
        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
      }
      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
        return;
      }
      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
    },

    enumerable: true,
    configurable: true
  });
  if (savedOpenExternalLinksInNewWindow) {
    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
  }
}
PDFJS.getDocument = _api.getDocument;
PDFJS.LoopbackPort = _api.LoopbackPort;
PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
PDFJS.PDFWorker = _api.PDFWorker;
PDFJS.hasCanvasTypedArrays = true;
PDFJS.CustomStyle = _dom_utils.CustomStyle;
PDFJS.LinkTarget = _dom_utils.LinkTarget;
PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
PDFJS.renderTextLayer = _text_layer.renderTextLayer;
PDFJS.Metadata = _metadata.Metadata;
PDFJS.SVGGraphics = _svg.SVGGraphics;
PDFJS.UnsupportedManager = _api._UnsupportedManager;
exports.globalScope = _util.globalScope;
exports.isWorker = isWorker;
exports.PDFJS = PDFJS;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};
  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }
  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;
  __w_pdfjs_require__.i = function (value) {
    return value;
  };
  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __w_pdfjs_require__.d(getter, 'a', getter);
    return getter;
  };
  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }
  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };
  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };
  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };
  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };
  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };
  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }
    if (v === Infinity) {
      return false;
    }
    if (v < 0) {
      return false;
    }
    return true;
  };
  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }
    return Function.prototype.apply.call(F, V, args);
  }
  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];
    if (method === undefined) {
      return undefined;
    }
    return Call(method, O, args);
  };
  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };
  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;
    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }
    if (method === undefined) {
      return F.apply(null, argsF);
    }
    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };
  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);
    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }
    return highWaterMark;
  };
  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }
    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }
  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }
  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;
  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }
  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;
  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
      _classCallCheck(this, WritableStream);
      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;
      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }
      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
      this._writableStreamController.__startSteps();
    }
    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }
        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }
        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }
        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsWritableStreamLocked(this);
      }
    }]);
    return WritableStream;
  }();
  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };
  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }
  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }
    return true;
  }
  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
    if (stream._writer === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamAbort(stream, reason) {
    var state = stream._state;
    if (state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    var error = new TypeError('Requested to abort');
    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }
    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;
    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }
    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });
    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }
    return promise;
  }
  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }
  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;
    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }
    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }
  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;
    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }
    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }
  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';
    stream._writableStreamController.__errorSteps();
    var storedError = stream._storedError;
    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];
      writeRequest._reject(storedError);
    }
    stream._writeRequests = [];
    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;
    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
    promise.then(function () {
      abortRequest._resolve();
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }
  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._resolve(undefined);
    stream._inFlightWriteRequest = undefined;
  }
  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._reject(error);
    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._resolve(undefined);
    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');
    if (state === 'erroring') {
      stream._storedError = undefined;
      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();
        stream._pendingAbortRequest = undefined;
      }
    }
    stream._state = 'closed';
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }
    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }
  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._reject(error);
    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);
      stream._pendingAbortRequest = undefined;
    }
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }
  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }
  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);
      stream._closeRequest._reject(stream._storedError);
      stream._closeRequest = undefined;
    }
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);
      writer._closedPromise.catch(function () {});
    }
  }
  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;
    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }
    stream._backpressure = backpressure;
  }
  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }
      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }
      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;
      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
        this._closedPromise.catch(function () {});
      }
    }
    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }
        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }
        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }
        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return;
        }
        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }
        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }
        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }
        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }
        return this._readyPromise;
      }
    }]);
    return WritableStreamDefaultWriter;
  }();
  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }
  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }
    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });
    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }
    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }
  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }
  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }
    writer._closedPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }
    writer._readyPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;
    if (state === 'errored' || state === 'erroring') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }
  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }
  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }
    var state = stream._state;
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }
    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }
  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }
      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }
      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }
        var state = this._controlledWritableStream._state;
        if (state !== 'writable') {
          return;
        }
        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;
        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        }).catch(rethrowAssertionErrorRejection);
      }
    }]);
    return WritableStreamDefaultController;
  }();
  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;
    if (strategySize === undefined) {
      return 1;
    }
    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }
  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = { chunk: chunk };
    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }
    var stream = controller._controlledWritableStream;
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;
    if (controller._started === false) {
      return;
    }
    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return;
    }
    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }
    if (controller._queue.length === 0) {
      return;
    }
    var writeRecord = PeekQueueValue(controller);
    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }
  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }
  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }
      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }
  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }
  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }
  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }
  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }
  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }
  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;
  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
    var pair = container._queue.shift();
    container._queueTotalSize -= pair.size;
    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }
    return pair.value;
  };
  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);
    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }
    container._queue.push({
      value: value,
      size: size
    });
    container._queueTotalSize += size;
  };
  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };
  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;
  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;
      _classCallCheck(this, ReadableStream);
      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);
      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }
        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }
        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }
    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }
        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }
        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }
        mode = String(mode);
        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }
        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }
        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }
        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }
        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }
        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();
            if (shuttingDown === true) {
              return Promise.resolve();
            }
            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;
                if (done === true) {
                  return;
                }
                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
              });
            }).then(pipeLoop);
          }
          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });
          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }
          pipeLoop().catch(function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });
          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }
          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise.catch(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }
            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              }).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              }).catch(rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }
          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);
            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }
        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsReadableStreamLocked(this);
      }
    }]);
    return ReadableStream;
  }();
  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };
  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }
  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }
  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }
  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
    if (stream._reader === undefined) {
      return false;
    }
    return true;
  }
  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;
    reader._closedPromise.catch(function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }
      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });
    return [branch1Stream, branch2Stream];
  }
  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');
        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }
          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }
          teeState.closedOrErrored = true;
        }
        if (teeState.closedOrErrored === true) {
          return;
        }
        var value1 = value;
        var value2 = value;
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }
    return f;
  }
  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;
      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;
      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }
  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }
  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    ReadableStreamClose(stream);
    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }
  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;
        _resolve(CreateIterResultObject(undefined, true));
      }
      reader._readRequests = [];
    }
    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }
  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];
        readRequest._reject(e);
      }
      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];
        readIntoRequest._reject(e);
      }
      reader._readIntoRequests = [];
    }
    defaultReaderClosedPromiseReject(reader, e);
    reader._closedPromise.catch(function () {});
  }
  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);
    var readIntoRequest = reader._readIntoRequests.shift();
    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);
    var readRequest = reader._readRequests.shift();
    readRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }
  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }
  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }
    return true;
  }
  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }
    return true;
  }
  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }
      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }
    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamDefaultReader;
  }();
  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);
      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }
      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }
      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }
    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }
        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }
        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamBYOBReader;
  }();
  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }
    return true;
  }
  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;
    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
      reader._closedPromise.catch(function () {});
    }
  }
  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }
  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);
    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }
    reader._closedPromise.catch(function () {});
    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }
  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }
  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }
  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }
      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);
          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }
          return Promise.resolve(CreateIterResultObject(chunk, false));
        }
        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);
    return ReadableStreamDefaultController;
  }();
  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }
    return true;
  }
  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }
      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    if (desiredSize > 0) {
      return true;
    }
    return false;
  }
  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;
    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }
  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;
      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;
        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }
      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }
  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }
  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);
      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }
    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }
        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);
    return ReadableStreamBYOBRequest;
  }();
  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }
      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }
      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }
        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);
        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);
          var entry = this._queue.shift();
          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;
          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }
          return Promise.resolve(CreateIterResultObject(view, false));
        }
        var autoAllocateChunkSize = this._autoAllocateChunkSize;
        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;
          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }
          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };
          this._pendingPullIntos.push(pullIntoDescriptor);
        }
        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }
        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }
        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }
        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);
    return ReadableByteStreamController;
  }();
  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }
    return true;
  }
  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }
  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;
    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }
  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }
  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });
    controller._queueTotalSize += byteLength;
  }
  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;
    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }
    var queue = controller._queue;
    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }
      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }
    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }
    return ready;
  }
  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }
  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');
    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }
  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }
    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }
  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);
    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }
      var pullIntoDescriptor = controller._pendingPullIntos[0];
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;
    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }
    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };
    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
      controller._pendingPullIntos.push(pullIntoDescriptor);
      return ReadableStreamAddReadIntoRequest(stream);
    }
    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }
    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }
      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);
    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }
  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;
    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }
    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }
  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }
      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }
  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }
  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state !== 'readable') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }
    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }
    return false;
  }
  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }
    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];
      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }
    ReadableStreamClose(stream);
  }
  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);
    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }
  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);
    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }
    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }
  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];
    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }
    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }
    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }
  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }
  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }
  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }
  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }
  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }
  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }
  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }
  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }
  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }
  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);
  var readableStream = __w_pdfjs_require__(4);
  var writableStream = __w_pdfjs_require__(2);
  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    TransformStreamCloseReadableInternal(transformStream);
  }
  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    var controller = transformStream._readableController;
    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;
    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }
  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    TransformStreamErrorInternal(transformStream, e);
  }
  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);
    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }
    transformStream._readableClosed = true;
  }
  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }
  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;
    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }
    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }
  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }
    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }
  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }
    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });
    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });
    transformStream._backpressure = backpressure;
  }
  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }
  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }
  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }
    return true;
  }
  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }
    return true;
  }
  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }
          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }
          return Promise.resolve();
        }).catch(function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);
    return TransformStreamSink;
  }();
  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);
    return TransformStreamSource;
  }();
  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);
      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }
      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }
      this._controlledTransformStream = transformStream;
    }
    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);
    return TransformStreamDefaultController;
  }();
  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, TransformStream);
      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise.catch(function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }
    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }
        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }
        return this._writable;
      }
    }]);
    return TransformStream;
  }();
  module.exports = { TransformStream: TransformStream };
  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }
  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var _pattern_helper = __w_pdfjs_require__(12);

var _webgl = __w_pdfjs_require__(7);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }
};
function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });
    ctx.save = function ctxSave() {
      var old = this._transformMatrix;
      this._transformStack.push(old);
      this._transformMatrix = old.slice(0, 6);
      this._originalSave();
    };
    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();
      if (prev) {
        this._transformMatrix = prev;
        this._originalRestore();
      }
    };
    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
      this._originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;
      this._originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
      ctx._originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];
      ctx._originalSetTransform(a, b, c, d, e, f);
    };
    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
      this._originalRotate(angle);
    };
  }
}
var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }
      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();
function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;
  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      coords.push(p % width1);
      coords.push(p / width1 | 0);
      --count;
    } while (p0 !== p);
    outlines.push(coords);
    --i;
  }
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();
    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);
      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }
    c.fill();
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }
  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();
var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }
    this.cachedGetSinglePixelWidth = null;
  }
  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;
        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;
          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }
          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }
            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }
        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }
      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;
      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }
        destPos = 0;
        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error('bad image kind: ' + imgData.kind);
    }
  }
  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;
      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;
        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }
          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }
  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];
      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }
    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }
  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }
  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;
    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];
      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }
  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;
    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }
  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;
    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }
  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;
    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }
    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }
      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }
  function composeSMask(ctx, smask, layerCtx) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;
    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
        subtype: smask.subtype,
        backdrop: backdrop
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }
    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          transparency = _ref.transparency,
          _ref$background = _ref.background,
          background = _ref$background === undefined ? null : _ref$background;

      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();
      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }
      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();
      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },

    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var deps = argsArray[i];
          for (var n = 0, nn = deps.length; n < nn; n++) {
            var depObjId = deps[n];
            var common = depObjId[0] === 'g' && depObjId[1] === '_';
            var objsPool = common ? commonObjs : objs;
            if (!objsPool.isResolved(depObjId)) {
              objsPool.get(depObjId, continueCallback);
              return i;
            }
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }
      this.ctx.restore();
      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }
      this.cachedCanvases.clear();
      _webgl.WebGLUtils.clear();
      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];
        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;
          case 'LC':
            this.setLineCap(value);
            break;
          case 'LJ':
            this.setLineJoin(value);
            break;
          case 'ML':
            this.setMiterLimit(value);
            break;
          case 'D':
            this.setDash(value[0], value[1]);
            break;
          case 'RI':
            this.setRenderingIntent(value);
            break;
          case 'FL':
            this.setFlatness(value);
            break;
          case 'Font':
            this.setFont(value[0], value[1]);
            break;
          case 'CA':
            this.current.strokeAlpha = state[1];
            break;
          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;
          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;
          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }
            this.current.activeSMask = value ? this.tempSMask : null;
            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }
            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }
      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this.cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this.cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            if (width === 0) {
              width = this.getSinglePixelWidth();
            }
            if (height === 0) {
              height = this.getSinglePixelWidth();
            }
            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;
          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;
          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;
          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;
          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;
          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;
      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
      if (consumePath) {
        this.consumePath();
      }
      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }
        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }
      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error('Can\'t find font for ' + fontRefName);
      }
      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = '"' + name + '", ' + fontObj.fallbackName;
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
      this.ctx.font = rule;
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function CanvasGraphics_paintChar(character, x, y) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var addToPath;
      if (font.disableFontFace || isAddToPathSet) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },
    get isFontSubpixelAAEnabled() {
      var ctx = this.canvasFactory.create(10, 10).context;
      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },
    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);
      if (current.patternFill) {
        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
      }
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this.cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      var x = 0,
          i;
      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;
        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY);
            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
            }
          }
        }
        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this.cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
          continue;
        }
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;
      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }
      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;
      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var bl = _util.Util.applyTransform([0, 0], inv);
        var br = _util.Util.applyTransform([0, height], inv);
        var ul = _util.Util.applyTransform([width, 0], inv);
        var ur = _util.Util.applyTransform([width, height], inv);
        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      throw new Error('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      throw new Error('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if ((0, _util.isArray)(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }
      this.baseTransform = this.ctx.mozCurrentTransform;
      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;
      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }
      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }
      var currentTransform = currentCtx.mozCurrentTransform;
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }
      (0, _util.assert)(group.bbox, 'Bounding box is required.');
      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;
      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }
      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }
      var cacheId = 'groupAt' + this.groupLevel;
      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();
      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }
      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();
      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();
      if ((0, _util.isArray)(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }
      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.objs.get(objId);
      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }
      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;
      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }
      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;
      if (imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }
      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }
      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }
      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }
        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }
        this.pendingClip = null;
      }
      ctx.beginPath();
    },
    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
      if (this.cachedGetSinglePixelWidth === null) {
        this.ctx.save();
        var inverse = this.ctx.mozCurrentTransformInverse;
        this.ctx.restore();
        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }
      return this.cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };
  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
  return CanvasGraphics;
}();
exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = undefined;

var _util = __w_pdfjs_require__(0);

function FontLoader(docId) {
  this.docId = docId;
  this.styleElement = null;
  this.nativeFontFaces = [];
  this.loadTestFontId = 0;
  this.loadingContext = {
    requests: [],
    nextRequestId: 0
  };
}
FontLoader.prototype = {
  insertRule: function fontLoaderInsertRule(rule) {
    var styleElement = this.styleElement;
    if (!styleElement) {
      styleElement = this.styleElement = document.createElement('style');
      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    var styleSheet = styleElement.sheet;
    styleSheet.insertRule(rule, styleSheet.cssRules.length);
  },
  clear: function fontLoaderClear() {
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
    this.nativeFontFaces.forEach(function (nativeFontFace) {
      document.fonts.delete(nativeFontFace);
    });
    this.nativeFontFaces.length = 0;
  }
};
{
  var getLoadTestFont = function getLoadTestFont() {
    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
  };
  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
    get: function get() {
      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
    },

    configurable: true
  });
  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.push(nativeFontFace);
    document.fonts.add(nativeFontFace);
  };
  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
    var rules = [];
    var fontsToLoad = [];
    var fontLoadPromises = [];
    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
      return nativeFontFace.loaded.catch(function (e) {
        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
      });
    };
    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
    for (var i = 0, ii = fonts.length; i < ii; i++) {
      var font = fonts[i];
      if (font.attached || font.loading === false) {
        continue;
      }
      font.attached = true;
      if (isFontLoadingAPISupported) {
        var nativeFontFace = font.createNativeFontFace();
        if (nativeFontFace) {
          this.addNativeFontFace(nativeFontFace);
          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
        }
      } else {
        var rule = font.createFontFaceRule();
        if (rule) {
          this.insertRule(rule);
          rules.push(rule);
          fontsToLoad.push(font);
        }
      }
    }
    var request = this.queueLoadingCallback(callback);
    if (isFontLoadingAPISupported) {
      Promise.all(fontLoadPromises).then(function () {
        request.complete();
      });
    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
      this.prepareFontLoadEvent(rules, fontsToLoad, request);
    } else {
      request.complete();
    }
  };
  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
    function LoadLoader_completeRequest() {
      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
      request.end = Date.now();
      while (context.requests.length > 0 && context.requests[0].end) {
        var otherRequest = context.requests.shift();
        setTimeout(otherRequest.callback, 0);
      }
    }
    var context = this.loadingContext;
    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
    var request = {
      id: requestId,
      complete: LoadLoader_completeRequest,
      callback: callback,
      started: Date.now()
    };
    context.requests.push(request);
    return request;
  };
  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
    function int32(data, offset) {
      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
    }
    function spliceString(s, offset, remove, insert) {
      var chunk1 = s.substr(0, offset);
      var chunk2 = s.substr(offset + remove);
      return chunk1 + insert + chunk2;
    }
    var i, ii;
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    var called = 0;
    function isFontReady(name, callback) {
      called++;
      if (called > 30) {
        (0, _util.warn)('Load test font never loaded.');
        callback();
        return;
      }
      ctx.font = '30px ' + name;
      ctx.fillText('.', 0, 20);
      var imageData = ctx.getImageData(0, 0, 1, 1);
      if (imageData.data[3] > 0) {
        callback();
        return;
      }
      setTimeout(isFontReady.bind(null, name, callback));
    }
    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
    var data = this.loadTestFont;
    var COMMENT_OFFSET = 976;
    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
    var CFF_CHECKSUM_OFFSET = 16;
    var XXXX_VALUE = 0x58585858;
    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
    }
    if (i < loadTestFontId.length) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
    }
    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
    this.insertRule(rule);
    var names = [];
    for (i = 0, ii = fonts.length; i < ii; i++) {
      names.push(fonts[i].loadedName);
    }
    names.push(loadTestFontId);
    var div = document.createElement('div');
    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
    for (i = 0, ii = names.length; i < ii; ++i) {
      var span = document.createElement('span');
      span.textContent = 'Hi';
      span.style.fontFamily = names[i];
      div.appendChild(span);
    }
    document.body.appendChild(div);
    isFontReady(loadTestFontId, function () {
      document.body.removeChild(div);
      request.complete();
    });
  };
}
{
  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
}
{
  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
    if (typeof navigator === 'undefined') {
      return true;
    }
    var supported = false;
    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
    if (m && m[1] >= 14) {
      supported = true;
    }
    return supported;
  };
  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
    get: function get() {
      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
    },

    enumerable: true,
    configurable: true
  });
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }
};
var FontFaceObject = function FontFaceObjectClosure() {
  function FontFaceObject(translatedData, options) {
    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.options = options;
  }
  FontFaceObject.prototype = {
    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this);
      }
      return nativeFontFace;
    },
    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var fontName = this.loadedName;
      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this, url);
      }
      return rule;
    },
    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
      if (!(character in this.compiledGlyphs)) {
        var cmds = objs.get(this.loadedName + '_path_' + character);
        var current, i, len;
        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
          var args,
              js = '';
          for (i = 0, len = cmds.length; i < len; i++) {
            current = cmds[i];
            if (current.args !== undefined) {
              args = current.args.join(',');
            } else {
              args = '';
            }
            js += 'c.' + current.cmd + '(' + args + ');\n';
          }
          this.compiledGlyphs[character] = new Function('c', 'size', js);
        } else {
          this.compiledGlyphs[character] = function (c, size) {
            for (i = 0, len = cmds.length; i < len; i++) {
              current = cmds[i];
              if (current.cmd === 'scale') {
                current.args = [size, -size];
              }
              c[current.cmd].apply(c, current.args);
            }
          };
        }
      }
      return this.compiledGlyphs[character];
    }
  };
  return FontFaceObject;
}();
exports.FontFaceObject = FontFaceObject;
exports.FontLoader = FontLoader;

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

var _util = __w_pdfjs_require__(0);

var _webgl = __w_pdfjs_require__(7);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;
        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }
        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }
        return grad;
      }
    };
  }
};
var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
      return;
    }
    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;
    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }
      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;
      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }
  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;
        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;
          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }
        break;
      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }
        break;
      default:
        throw new Error('illegal figure');
    }
  }
  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;
    if (_webgl.WebGLUtils.isEnabled) {
      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }
    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  return createMeshCanvas;
}();
ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;
        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }
        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);
          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};
function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];
  if (!shadingIR) {
    throw new Error('Unknown IR type: ' + raw[0]);
  }
  return shadingIR.fromIR(raw);
}
var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }
  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];
      var topLeft = [x0, y0];
      var botRight = [x0 + xstep, y0 + ystep];
      var width = botRight[0] - topLeft[0];
      var height = botRight[1] - topLeft[1];
      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(tmpCtx, paintType, color);
      this.setScale(width, height, xstep, ystep);
      this.transformToScale(graphics);
      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
      graphics.transform.apply(graphics, tmpTranslate);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      return tmpCanvas.canvas;
    },
    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
      this.scale = [width / xstep, height / ystep];
    },
    transformToScale: function TilingPattern_transformToScale(graphics) {
      var scale = this.scale;
      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
      graphics.transform.apply(graphics, tmpScale);
    },
    scaleToContext: function TilingPattern_scaleToContext() {
      var scale = this.scale;
      this.ctx.scale(1 / scale[0], 1 / scale[1]);
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(context, paintType, color) {
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          break;
        default:
          throw new _util.FormatError('Unsupported paint type: ' + paintType);
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      this.scaleToContext();
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = TilingPattern;

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '1.8.557';
var pdfjsBuild = '4a74cc41';
var pdfjsSharedUtil = __w_pdfjs_require__(0);
var pdfjsDisplayGlobal = __w_pdfjs_require__(8);
var pdfjsDisplayAPI = __w_pdfjs_require__(3);
var pdfjsDisplayTextLayer = __w_pdfjs_require__(5);
var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(2);
var pdfjsDisplayDOMUtils = __w_pdfjs_require__(1);
var pdfjsDisplaySVG = __w_pdfjs_require__(4);
exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.createBlob = pdfjsSharedUtil.createBlob;
exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
exports.StatTimer = pdfjsSharedUtil.StatTimer;

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : undefined;
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
  var isChrome = userAgent.indexOf('Chrom') >= 0;
  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isOpera = userAgent.indexOf('Opera') >= 0;
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkTypedArrayCompatibility() {
    if (typeof Uint8Array !== 'undefined') {
      if (typeof Uint8Array.prototype.subarray === 'undefined') {
        Uint8Array.prototype.subarray = function subarray(start, end) {
          return new Uint8Array(this.slice(start, end));
        };
        Float32Array.prototype.subarray = function subarray(start, end) {
          return new Float32Array(this.slice(start, end));
        };
      }
      if (typeof Float64Array === 'undefined') {
        globalScope.Float64Array = Float32Array;
      }
      return;
    }
    function subarray(start, end) {
      return new TypedArray(this.slice(start, end));
    }
    function setArrayOffset(array, offset) {
      if (arguments.length < 2) {
        offset = 0;
      }
      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
        this[offset] = array[i] & 0xFF;
      }
    }
    function Uint32ArrayView(buffer, length) {
      this.buffer = buffer;
      this.byteLength = buffer.length;
      this.length = length;
      ensureUint32ArrayViewProps(this.length);
    }
    Uint32ArrayView.prototype = Object.create(null);
    var uint32ArrayViewSetters = 0;
    function createUint32ArrayProp(index) {
      return {
        get: function get() {
          var buffer = this.buffer,
              offset = index << 2;
          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
        },
        set: function set(value) {
          var buffer = this.buffer,
              offset = index << 2;
          buffer[offset] = value & 255;
          buffer[offset + 1] = value >> 8 & 255;
          buffer[offset + 2] = value >> 16 & 255;
          buffer[offset + 3] = value >>> 24 & 255;
        }
      };
    }
    function ensureUint32ArrayViewProps(length) {
      while (uint32ArrayViewSetters < length) {
        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
        uint32ArrayViewSetters++;
      }
    }
    function TypedArray(arg1) {
      var result, i, n;
      if (typeof arg1 === 'number') {
        result = [];
        for (i = 0; i < arg1; ++i) {
          result[i] = 0;
        }
      } else if ('slice' in arg1) {
        result = arg1.slice(0);
      } else {
        result = [];
        for (i = 0, n = arg1.length; i < n; ++i) {
          result[i] = arg1[i];
        }
      }
      result.subarray = subarray;
      result.buffer = result;
      result.byteLength = result.length;
      result.set = setArrayOffset;
      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
        result.buffer = arg1.buffer;
      }
      return result;
    }
    globalScope.Uint8Array = TypedArray;
    globalScope.Int8Array = TypedArray;
    globalScope.Int32Array = TypedArray;
    globalScope.Uint16Array = TypedArray;
    globalScope.Float32Array = TypedArray;
    globalScope.Float64Array = TypedArray;
    globalScope.Uint32Array = function () {
      if (arguments.length === 3) {
        if (arguments[1] !== 0) {
          throw new Error('offset !== 0 is not supported');
        }
        return new Uint32ArrayView(arguments[0], arguments[2]);
      }
      return TypedArray.apply(this, arguments);
    };
  })();
  (function canvasPixelArrayBuffer() {
    if (!hasDOM || !window.CanvasPixelArray) {
      return;
    }
    var cpaProto = window.CanvasPixelArray.prototype;
    if ('buffer' in cpaProto) {
      return;
    }
    Object.defineProperty(cpaProto, 'buffer', {
      get: function get() {
        return this;
      },

      enumerable: false,
      configurable: true
    });
    Object.defineProperty(cpaProto, 'byteLength', {
      get: function get() {
        return this.length;
      },

      enumerable: false,
      configurable: true
    });
  })();
  (function normalizeURLObject() {
    if (!globalScope.URL) {
      globalScope.URL = globalScope.webkitURL;
    }
  })();
  (function checkObjectDefinePropertyCompatibility() {
    if (typeof Object.defineProperty !== 'undefined') {
      var definePropertyPossible = true;
      try {
        if (hasDOM) {
          Object.defineProperty(new Image(), 'id', { value: 'test' });
        }
        var Test = function Test() {};
        Test.prototype = {
          get id() {}
        };
        Object.defineProperty(new Test(), 'id', {
          value: '',
          configurable: true,
          enumerable: true,
          writable: false
        });
      } catch (e) {
        definePropertyPossible = false;
      }
      if (definePropertyPossible) {
        return;
      }
    }
    Object.defineProperty = function objectDefineProperty(obj, name, def) {
      delete obj[name];
      if ('get' in def) {
        obj.__defineGetter__(name, def['get']);
      }
      if ('set' in def) {
        obj.__defineSetter__(name, def['set']);
      }
      if ('value' in def) {
        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
          this.__defineGetter__(name, function objectDefinePropertyGetter() {
            return value;
          });
          return value;
        });
        obj[name] = def.value;
      }
    };
  })();
  (function checkXMLHttpRequestResponseCompatibility() {
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    var xhrPrototype = XMLHttpRequest.prototype;
    var xhr = new XMLHttpRequest();
    if (!('overrideMimeType' in xhr)) {
      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
      });
    }
    if ('responseType' in xhr) {
      return;
    }
    Object.defineProperty(xhrPrototype, 'responseType', {
      get: function xmlHttpRequestGetResponseType() {
        return this._responseType || 'text';
      },
      set: function xmlHttpRequestSetResponseType(value) {
        if (value === 'text' || value === 'arraybuffer') {
          this._responseType = value;
          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
            this.overrideMimeType('text/plain; charset=x-user-defined');
          }
        }
      }
    });
    if (typeof VBArray !== 'undefined') {
      Object.defineProperty(xhrPrototype, 'response', {
        get: function xmlHttpRequestResponseGet() {
          if (this.responseType === 'arraybuffer') {
            return new Uint8Array(new VBArray(this.responseBody).toArray());
          }
          return this.responseText;
        }
      });
      return;
    }
    Object.defineProperty(xhrPrototype, 'response', {
      get: function xmlHttpRequestResponseGet() {
        if (this.responseType !== 'arraybuffer') {
          return this.responseText;
        }
        var text = this.responseText;
        var i,
            n = text.length;
        var result = new Uint8Array(n);
        for (i = 0; i < n; ++i) {
          result[i] = text.charCodeAt(i) & 0xFF;
        }
        return result.buffer;
      }
    });
  })();
  (function checkWindowBtoaCompatibility() {
    if ('btoa' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.btoa = function (chars) {
      var buffer = '';
      var i, n;
      for (i = 0, n = chars.length; i < n; i += 3) {
        var b1 = chars.charCodeAt(i) & 0xFF;
        var b2 = chars.charCodeAt(i + 1) & 0xFF;
        var b3 = chars.charCodeAt(i + 2) & 0xFF;
        var d1 = b1 >> 2,
            d2 = (b1 & 3) << 4 | b2 >> 4;
        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
        var d4 = i + 2 < n ? b3 & 0x3F : 64;
        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
      }
      return buffer;
    };
  })();
  (function checkWindowAtobCompatibility() {
    if ('atob' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.atob = function (input) {
      input = input.replace(/=+$/, '');
      if (input.length % 4 === 1) {
        throw new Error('bad atob input');
      }
      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
        buffer = digits.indexOf(buffer);
      }
      return output;
    };
  })();
  (function checkFunctionPrototypeBindCompatibility() {
    if (typeof Function.prototype.bind !== 'undefined') {
      return;
    }
    Function.prototype.bind = function functionPrototypeBind(obj) {
      var fn = this,
          headArgs = Array.prototype.slice.call(arguments, 1);
      var bound = function functionPrototypeBindBound() {
        var args = headArgs.concat(Array.prototype.slice.call(arguments));
        return fn.apply(obj, args);
      };
      return bound;
    };
  })();
  (function checkDatasetProperty() {
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('dataset' in div) {
      return;
    }
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function get() {
        if (this._dataset) {
          return this._dataset;
        }
        var dataset = {};
        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
          var attribute = this.attributes[j];
          if (attribute.name.substring(0, 5) !== 'data-') {
            continue;
          }
          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
            return ch.toUpperCase();
          });
          dataset[key] = attribute.value;
        }
        Object.defineProperty(this, '_dataset', {
          value: dataset,
          writable: false,
          enumerable: false
        });
        return dataset;
      },

      enumerable: true
    });
  })();
  (function checkClassListProperty() {
    function changeList(element, itemName, add, remove) {
      var s = element.className || '';
      var list = s.split(/\s+/g);
      if (list[0] === '') {
        list.shift();
      }
      var index = list.indexOf(itemName);
      if (index < 0 && add) {
        list.push(itemName);
      }
      if (index >= 0 && remove) {
        list.splice(index, 1);
      }
      element.className = list.join(' ');
      return index >= 0;
    }
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('classList' in div) {
      return;
    }
    var classListPrototype = {
      add: function add(name) {
        changeList(this.element, name, true, false);
      },
      contains: function contains(name) {
        return changeList(this.element, name, false, false);
      },
      remove: function remove(name) {
        changeList(this.element, name, false, true);
      },
      toggle: function toggle(name) {
        changeList(this.element, name, true, true);
      }
    };
    Object.defineProperty(HTMLElement.prototype, 'classList', {
      get: function get() {
        if (this._classList) {
          return this._classList;
        }
        var classList = Object.create(classListPrototype, {
          element: {
            value: this,
            writable: false,
            enumerable: true
          }
        });
        Object.defineProperty(this, '_classList', {
          value: classList,
          writable: false,
          enumerable: false
        });
        return classList;
      },

      enumerable: true
    });
  })();
  (function checkWorkerConsoleCompatibility() {
    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
      return;
    }
    var consoleTimer = {};
    var workerConsole = {
      log: function log() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_log',
          data: args
        });
      },
      error: function error() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_error',
          data: args
        });
      },
      time: function time(name) {
        consoleTimer[name] = Date.now();
      },
      timeEnd: function timeEnd(name) {
        var time = consoleTimer[name];
        if (!time) {
          throw new Error('Unknown timer name ' + name);
        }
        this.log('Timer:', name, Date.now() - time);
      }
    };
    globalScope.console = workerConsole;
  })();
  (function checkConsoleCompatibility() {
    if (!hasDOM) {
      return;
    }
    if (!('console' in window)) {
      window.console = {
        log: function log() {},
        error: function error() {},
        warn: function warn() {}
      };
      return;
    }
    if (!('bind' in console.log)) {
      console.log = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.log);
      console.error = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.error);
      console.warn = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.warn);
      return;
    }
  })();
  (function checkOnClickCompatibility() {
    function ignoreIfTargetDisabled(event) {
      if (isDisabled(event.target)) {
        event.stopPropagation();
      }
    }
    function isDisabled(node) {
      return node.disabled || node.parentNode && isDisabled(node.parentNode);
    }
    if (isOpera) {
      document.addEventListener('click', ignoreIfTargetDisabled, true);
    }
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkHistoryManipulation() {
    if (!hasDOM) {
      return;
    }
    if (!history.pushState || isAndroidPre3) {
      PDFJS.disableHistory = true;
    }
  })();
  (function checkSetPresenceInImageData() {
    if (!hasDOM) {
      return;
    }
    if (window.CanvasPixelArray) {
      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
        window.CanvasPixelArray.prototype.set = function (arr) {
          for (var i = 0, ii = this.length; i < ii; i++) {
            this[i] = arr[i];
          }
        };
      }
    } else {
      var polyfill = false,
          versionMatch;
      if (isChrome) {
        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
      } else if (isAndroid) {
        polyfill = isAndroidPre5;
      } else if (isSafari) {
        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
      }
      if (polyfill) {
        var contextPrototype = window.CanvasRenderingContext2D.prototype;
        var createImageData = contextPrototype.createImageData;
        contextPrototype.createImageData = function (w, h) {
          var imageData = createImageData.call(this, w, h);
          imageData.data.set = function (arr) {
            for (var i = 0, ii = this.length; i < ii; i++) {
              this[i] = arr[i];
            }
          };
          return imageData;
        };
        contextPrototype = null;
      }
    }
  })();
  (function checkRequestAnimationFrame() {
    function installFakeAnimationFrameFunctions() {
      window.requestAnimationFrame = function (callback) {
        return window.setTimeout(callback, 20);
      };
      window.cancelAnimationFrame = function (timeoutID) {
        window.clearTimeout(timeoutID);
      };
    }
    if (!hasDOM) {
      return;
    }
    if (isIOS) {
      installFakeAnimationFrameFunctions();
      return;
    }
    if ('requestAnimationFrame' in window) {
      return;
    }
    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
    if (window.requestAnimationFrame) {
      return;
    }
    installFakeAnimationFrameFunctions();
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkInputTypeNumberAssign() {
    if (!hasDOM) {
      return;
    }
    var el = document.createElement('input');
    try {
      el.type = 'number';
    } catch (ex) {
      var inputProto = el.constructor.prototype;
      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
      Object.defineProperty(inputProto, 'type', {
        get: function get() {
          return typeProperty.get.call(this);
        },
        set: function set(value) {
          typeProperty.set.call(this, value === 'number' ? 'text' : value);
        },

        enumerable: true,
        configurable: true
      });
    }
  })();
  (function checkDocumentReadyState() {
    if (!hasDOM) {
      return;
    }
    if (!document.attachEvent) {
      return;
    }
    var documentProto = document.constructor.prototype;
    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
    Object.defineProperty(documentProto, 'readyState', {
      get: function get() {
        var value = readyStateProto.get.call(this);
        return value === 'interactive' ? 'loading' : value;
      },
      set: function set(value) {
        readyStateProto.set.call(this, value);
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = function (value) {
      return typeof value === 'number' && isNaN(value);
    };
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      if (typeof globalScope.Promise.all !== 'function') {
        globalScope.Promise.all = function (iterable) {
          var count = 0,
              results = [],
              resolve,
              reject;
          var promise = new globalScope.Promise(function (resolve_, reject_) {
            resolve = resolve_;
            reject = reject_;
          });
          iterable.forEach(function (p, i) {
            count++;
            p.then(function (result) {
              results[i] = result;
              count--;
              if (count === 0) {
                resolve(results);
              }
            }, reject);
          });
          if (count === 0) {
            resolve(results);
          }
          return promise;
        };
      }
      if (typeof globalScope.Promise.resolve !== 'function') {
        globalScope.Promise.resolve = function (value) {
          return new globalScope.Promise(function (resolve) {
            resolve(value);
          });
        };
      }
      if (typeof globalScope.Promise.reject !== 'function') {
        globalScope.Promise.reject = function (reason) {
          return new globalScope.Promise(function (resolve, reject) {
            reject(reason);
          });
        };
      }
      if (typeof globalScope.Promise.prototype.catch !== 'function') {
        globalScope.Promise.prototype.catch = function (onReject) {
          return globalScope.Promise.prototype.then(undefined, onReject);
        };
      }
      return;
    }
    var STATUS_PENDING = 0;
    var STATUS_RESOLVED = 1;
    var STATUS_REJECTED = 2;
    var REJECTION_TIMEOUT = 500;
    var HandlerManager = {
      handlers: [],
      running: false,
      unhandledRejections: [],
      pendingRejectionCheck: false,
      scheduleHandlers: function scheduleHandlers(promise) {
        if (promise._status === STATUS_PENDING) {
          return;
        }
        this.handlers = this.handlers.concat(promise._handlers);
        promise._handlers = [];
        if (this.running) {
          return;
        }
        this.running = true;
        setTimeout(this.runHandlers.bind(this), 0);
      },
      runHandlers: function runHandlers() {
        var RUN_TIMEOUT = 1;
        var timeoutAt = Date.now() + RUN_TIMEOUT;
        while (this.handlers.length > 0) {
          var handler = this.handlers.shift();
          var nextStatus = handler.thisPromise._status;
          var nextValue = handler.thisPromise._value;
          try {
            if (nextStatus === STATUS_RESOLVED) {
              if (typeof handler.onResolve === 'function') {
                nextValue = handler.onResolve(nextValue);
              }
            } else if (typeof handler.onReject === 'function') {
              nextValue = handler.onReject(nextValue);
              nextStatus = STATUS_RESOLVED;
              if (handler.thisPromise._unhandledRejection) {
                this.removeUnhandeledRejection(handler.thisPromise);
              }
            }
          } catch (ex) {
            nextStatus = STATUS_REJECTED;
            nextValue = ex;
          }
          handler.nextPromise._updateStatus(nextStatus, nextValue);
          if (Date.now() >= timeoutAt) {
            break;
          }
        }
        if (this.handlers.length > 0) {
          setTimeout(this.runHandlers.bind(this), 0);
          return;
        }
        this.running = false;
      },
      addUnhandledRejection: function addUnhandledRejection(promise) {
        this.unhandledRejections.push({
          promise: promise,
          time: Date.now()
        });
        this.scheduleRejectionCheck();
      },
      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
        promise._unhandledRejection = false;
        for (var i = 0; i < this.unhandledRejections.length; i++) {
          if (this.unhandledRejections[i].promise === promise) {
            this.unhandledRejections.splice(i);
            i--;
          }
        }
      },
      scheduleRejectionCheck: function scheduleRejectionCheck() {
        var _this = this;

        if (this.pendingRejectionCheck) {
          return;
        }
        this.pendingRejectionCheck = true;
        setTimeout(function () {
          _this.pendingRejectionCheck = false;
          var now = Date.now();
          for (var i = 0; i < _this.unhandledRejections.length; i++) {
            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
              var unhandled = _this.unhandledRejections[i].promise._value;
              var msg = 'Unhandled rejection: ' + unhandled;
              if (unhandled.stack) {
                msg += '\n' + unhandled.stack;
              }
              try {
                throw new Error(msg);
              } catch (_) {
                console.warn(msg);
              }
              _this.unhandledRejections.splice(i);
              i--;
            }
          }
          if (_this.unhandledRejections.length) {
            _this.scheduleRejectionCheck();
          }
        }, REJECTION_TIMEOUT);
      }
    };
    var Promise = function Promise(resolver) {
      this._status = STATUS_PENDING;
      this._handlers = [];
      try {
        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
      } catch (e) {
        this._reject(e);
      }
    };
    Promise.all = function Promise_all(promises) {
      var resolveAll, rejectAll;
      var deferred = new Promise(function (resolve, reject) {
        resolveAll = resolve;
        rejectAll = reject;
      });
      var unresolved = promises.length;
      var results = [];
      if (unresolved === 0) {
        resolveAll(results);
        return deferred;
      }
      function reject(reason) {
        if (deferred._status === STATUS_REJECTED) {
          return;
        }
        results = [];
        rejectAll(reason);
      }
      for (var i = 0, ii = promises.length; i < ii; ++i) {
        var promise = promises[i];
        var resolve = function (i) {
          return function (value) {
            if (deferred._status === STATUS_REJECTED) {
              return;
            }
            results[i] = value;
            unresolved--;
            if (unresolved === 0) {
              resolveAll(results);
            }
          };
        }(i);
        if (Promise.isPromise(promise)) {
          promise.then(resolve, reject);
        } else {
          resolve(promise);
        }
      }
      return deferred;
    };
    Promise.isPromise = function Promise_isPromise(value) {
      return value && typeof value.then === 'function';
    };
    Promise.resolve = function Promise_resolve(value) {
      return new Promise(function (resolve) {
        resolve(value);
      });
    };
    Promise.reject = function Promise_reject(reason) {
      return new Promise(function (resolve, reject) {
        reject(reason);
      });
    };
    Promise.prototype = {
      _status: null,
      _value: null,
      _handlers: null,
      _unhandledRejection: null,
      _updateStatus: function Promise__updateStatus(status, value) {
        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
          return;
        }
        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
          return;
        }
        this._status = status;
        this._value = value;
        if (status === STATUS_REJECTED && this._handlers.length === 0) {
          this._unhandledRejection = true;
          HandlerManager.addUnhandledRejection(this);
        }
        HandlerManager.scheduleHandlers(this);
      },
      _resolve: function Promise_resolve(value) {
        this._updateStatus(STATUS_RESOLVED, value);
      },
      _reject: function Promise_reject(reason) {
        this._updateStatus(STATUS_REJECTED, reason);
      },
      then: function Promise_then(onResolve, onReject) {
        var nextPromise = new Promise(function (resolve, reject) {
          this.resolve = resolve;
          this.reject = reject;
        });
        this._handlers.push({
          thisPromise: this,
          onResolve: onResolve,
          onReject: onReject,
          nextPromise: nextPromise
        });
        HandlerManager.scheduleHandlers(this);
        return nextPromise;
      },
      catch: function Promise_catch(onReject) {
        return this.then(undefined, onReject);
      }
    };
    globalScope.Promise = Promise;
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    var id = 0;
    function WeakMap() {
      this.id = '$weakmap' + id++;
    }
    WeakMap.prototype = {
      has: function has(obj) {
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
          return false;
        }
        return !!Object.getOwnPropertyDescriptor(obj, this.id);
      },
      get: function get(obj) {
        return this.has(obj) ? obj[this.id] : undefined;
      },
      set: function set(obj, value) {
        Object.defineProperty(obj, this.id, {
          value: value,
          enumerable: false,
          configurable: true
        });
      },
      delete: function _delete(obj) {
        delete obj[this.id];
      }
    };
    globalScope.WeakMap = WeakMap;
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdf.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(58), __webpack_require__(79).Buffer))

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports = module.exports = __webpack_require__(391);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(307);
exports.Duplex = __webpack_require__(127);
exports.Transform = __webpack_require__(393);
exports.PassThrough = __webpack_require__(895);



/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b8edeef2e8f1f5afa5e7c1e91f6a259b.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/734c28f9c7e5c1d5415c5b7ef3066962.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bb1e4b225d37ff7b7aef88c5784ab43f.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/27a33117c9e87996d618957adf3e9282.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f9afa3d10bfdeca899c8fc5206d746f5.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/0daa088e470a7dafd6f8eb61537a7b01.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/213df11b2b8d8471bfbbde98c88e5302.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a71d6c1c113e490b2aa90c85b17e16c3.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d1188f0485707dabdbf3b0f14ce7dce6.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/527066973b12f4750b521bfa84503b48.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1c82cbdfb332f1c52f6b15241cdc49ce.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/de3aca0c467716badc956d6846a093c5.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2a45a79de9cf894f84f3c76311ad55a5.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b850b9c8b7825e35bc515a39db3e1c6d.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ba0613ccc07e5e156e089bfb3f71771a.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/94144acf73af90c2f13a92deb3655099.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/273ae6c42624a6b9446ab455e8a0d307.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d9c74b68bca6831bd80ef36797567b4d.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/aa81974e5a3c8888619dc29a6f82a277.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/55e2c70080d94f45681b5681f58c9ffd.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/416b2668df62de7e2e3f2cd94fc676d5.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/96b02cb8a4ff1e4876220df6643d49e1.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ddc9d70e13918a7498c927651e3399cc.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a6d11658ca6e2641599bb40832de2b1e.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/918cad75540cface84d2380cc828091a.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a6672fca9536926ea09a9b574001a7d1.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d23661b17fb075351279a12afaaac310.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d888be64d490145f6007a6d967a3b5c7.png";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/0004e6dadd812054cb466c786274edcc.png";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a1ba784c55e14c18aaa16b1d6357ca06.png";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bc84c984f9b43c06c19690c11f255a7d.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9db326aad61ddabf72c5afcbd2e64735.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d3d8f0509086e5b3816e79100428aa6e.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2fb97a7525fb4919e7fd2567232e2138.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a626ad6ba9f52006710514fabebae4dc.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b6cbb6ac054e41139b0cd8090c298f3a.png";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ef9fdd9140fc3708aa920f4328132576.png";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a32982a7cdeff77995ef5773fde7c3e0.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/7ed67ec97760be5da993bfde6daa2554.png";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/93a865a30dbe3b93e32fd04349a57b3e.png";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b92f2a3353391d8de710db8ad932962d.png";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(497).Transform



/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/821b48093e33cb4088b1fc246a8311f6.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMyAllChannelsByCategory = exports.getMyAllChannels = exports.getChannelsInAllTeam = undefined;

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(168);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(122);

var _values2 = _interopRequireDefault(_values);

exports.buildNewDisplayableChannelList = buildNewDisplayableChannelList;

var _reselect = __webpack_require__(93);

var _channels = __webpack_require__(175);

var _preferences = __webpack_require__(105);

var _users = __webpack_require__(88);

var _constants = __webpack_require__(8);

var _channel_utils = __webpack_require__(209);

var _preference_utils = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// All channels the store knows about, in every team, sorted by display name.
var getChannelsInAllTeam = exports.getChannelsInAllTeam = (0, _reselect.createSelector)(_channels.getAllChannels, _users.getCurrentUser, function (allChannels, currentUser) {
    var locale = 'en';
    if (currentUser && currentUser.locale) {
        locale = currentUser.locale;
    }
    return (0, _values2.default)(allChannels).sort(_channel_utils.sortChannelsByDisplayName.bind(null, locale));
});

// Channels in every team that the current user is a member of.
// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux
// selectors/entities/channels + utils/channel_utils). These selectors work across ALL teams
// of the current user, unlike the upstream ones that are scoped to the current team.

var getMyAllChannels = exports.getMyAllChannels = (0, _reselect.createSelector)(getChannelsInAllTeam, _channels.getMyChannelMemberships, function (channels, myMembers) {
    return [].concat((0, _toConsumableArray3.default)(channels)).filter(function (c) {
        return myMembers.hasOwnProperty(c.id);
    });
});

// Same shape as the upstream getChannelsByCategory, but across all teams and with every
// direct/group channel listed regardless of the show/hide preferences.
var getMyAllChannelsByCategory = exports.getMyAllChannelsByCategory = (0, _reselect.createSelector)(_channels.getCurrentChannelId, getMyAllChannels, _preferences.getMyPreferences, _preferences.getTeammateNameDisplaySetting, function (state) {
    return state.entities.users;
}, function (currentChannelId, channels, myPreferences, teammateNameDisplay, usersState) {
    var allChannels = channels.map(function (c) {
        var channel = (0, _extends3.default)({}, c);
        channel.isCurrent = c.id === currentChannelId;
        return channel;
    });

    return buildNewDisplayableChannelList(usersState, allChannels, myPreferences, teammateNameDisplay);
});

// ---- helpers (mirrors of the non-exported upstream channel_utils helpers) ----

function getUserLocale(userId, profiles) {
    var locale = 'en';
    if (profiles && profiles[userId] && profiles[userId].locale) {
        locale = profiles[userId].locale;
    }
    return locale;
}

function isNotDeletedChannel(channel) {
    return channel.delete_at === 0;
}

function isOpenChannel(channel) {
    return channel.type === _constants.General.OPEN_CHANNEL;
}

function isPrivateChannel(channel) {
    return channel.type === _constants.General.PRIVATE_CHANNEL;
}

function isFavoriteChannel(myPreferences, channel) {
    var fav = myPreferences[_constants.Preferences.CATEGORY_FAVORITE_CHANNEL + '--' + channel.id];
    return fav && fav.value === 'true';
}

function isDirectChannelForUser(userId, otherUserId, channel) {
    return channel.type === _constants.General.DM_CHANNEL && (0, _channel_utils.getUserIdFromChannelName)(userId, channel.name) === otherUserId;
}

function createFakeChannel(userId, otherUserId) {
    return {
        name: (0, _channel_utils.getDirectChannelName)(userId, otherUserId),
        last_post_at: 0,
        total_msg_count: 0,
        type: _constants.General.DM_CHANNEL,
        fake: true
    };
}

// Direct channels the user asked to show in the sidebar but which do not exist in the store yet.
function createMissingDirectChannels(currentUserId, allChannels, myPreferences) {
    var directChannelsDisplayPreferences = (0, _preference_utils.getPreferencesByCategory)(myPreferences, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);

    return (0, _from2.default)(directChannelsDisplayPreferences).filter(function (entry) {
        return entry[1] === 'true';
    }).map(function (entry) {
        return entry[0];
    }).filter(function (teammateId) {
        return !allChannels.some(isDirectChannelForUser.bind(null, currentUserId, teammateId));
    }).map(function (teammateId) {
        return createFakeChannel(currentUserId, teammateId);
    });
}

function sortFavorites(locale, a, b) {
    var aDisplay = a.display_name.toLowerCase();
    var bDisplay = b.display_name.toLowerCase();
    return aDisplay.localeCompare(bDisplay, locale, { numeric: true });
}

function buildNewDisplayableChannelList(usersState, allChannels, myPreferences, teammateNameDisplay) {
    var currentUserId = usersState.currentUserId,
        profiles = usersState.profiles;

    var missingDirectChannels = createMissingDirectChannels(currentUserId, allChannels, myPreferences);
    var locale = getUserLocale(currentUserId, profiles);

    var channels = allChannels.concat(missingDirectChannels).map(_channel_utils.completeDirectChannelInfo.bind(null, usersState, teammateNameDisplay)).filter(isNotDeletedChannel).sort(_channel_utils.sortChannelsByDisplayName.bind(null, locale));

    var favoriteChannels = channels.filter(isFavoriteChannel.bind(null, myPreferences)).sort(sortFavorites.bind(null, locale));
    var notFavoriteChannels = channels.filter(function (c) {
        return !isFavoriteChannel(myPreferences, c);
    });
    var directAndGroupChannels = notFavoriteChannels.filter(function (c) {
        return (0, _channel_utils.isGroupChannel)(c) || (0, _channel_utils.isDirectChannel)(c);
    });

    return {
        favoriteChannels: favoriteChannels,
        publicChannels: notFavoriteChannels.filter(isOpenChannel),
        privateChannels: notFavoriteChannels.filter(isPrivateChannel),
        directAndGroupChannels: directAndGroupChannels
    };
}

// ---

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/00ccf29c13ef945a903f77f2284e94fc.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(554);
__webpack_require__(736);
__webpack_require__(737);
module.exports = __webpack_require__(1241);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

__webpack_require__(555);

__webpack_require__(338);

__webpack_require__(733);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(556);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(248);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(327);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(328);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(731);
__webpack_require__(732);
module.exports = __webpack_require__(80);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// ECMAScript 6 symbols shim
var global         = __webpack_require__(6)
  , has            = __webpack_require__(36)
  , DESCRIPTORS    = __webpack_require__(18)
  , $export        = __webpack_require__(1)
  , redefine       = __webpack_require__(42)
  , META           = __webpack_require__(95).KEY
  , $fails         = __webpack_require__(9)
  , shared         = __webpack_require__(178)
  , setToStringTag = __webpack_require__(128)
  , uid            = __webpack_require__(106)
  , wks            = __webpack_require__(14)
  , wksExt         = __webpack_require__(311)
  , wksDefine      = __webpack_require__(228)
  , keyOf          = __webpack_require__(557)
  , enumKeys       = __webpack_require__(558)
  , isArray        = __webpack_require__(231)
  , anObject       = __webpack_require__(4)
  , toIObject      = __webpack_require__(44)
  , toPrimitive    = __webpack_require__(72)
  , createDesc     = __webpack_require__(94)
  , _create        = __webpack_require__(110)
  , gOPNExt        = __webpack_require__(314)
  , $GOPD          = __webpack_require__(51)
  , $DP            = __webpack_require__(19)
  , $keys          = __webpack_require__(108)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(111).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(149).f  = $propertyIsEnumerable;
  __webpack_require__(180).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(107)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(41)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var getKeys   = __webpack_require__(108)
  , toIObject = __webpack_require__(44);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(108)
  , gOPS    = __webpack_require__(180)
  , pIE     = __webpack_require__(149);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(110)});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', {defineProperty: __webpack_require__(19).f});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', {defineProperties: __webpack_require__(313)});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(44)
  , $getOwnPropertyDescriptor = __webpack_require__(51).f;

__webpack_require__(73)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(29)
  , $getPrototypeOf = __webpack_require__(52);

__webpack_require__(73)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(29)
  , $keys    = __webpack_require__(108);

__webpack_require__(73)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(73)('getOwnPropertyNames', function(){
  return __webpack_require__(314).f;
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(13)
  , meta     = __webpack_require__(95).onFreeze;

__webpack_require__(73)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(13)
  , meta     = __webpack_require__(95).onFreeze;

__webpack_require__(73)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(13)
  , meta     = __webpack_require__(95).onFreeze;

__webpack_require__(73)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(13);

__webpack_require__(73)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(13);

__webpack_require__(73)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(13);

__webpack_require__(73)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(315)});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', {is: __webpack_require__(316)});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(233).set});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(150)
  , test    = {};
test[__webpack_require__(14)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(42)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', {bind: __webpack_require__(317)});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var dP         = __webpack_require__(19).f
  , createDesc = __webpack_require__(94)
  , has        = __webpack_require__(36)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(18) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var isObject       = __webpack_require__(13)
  , getPrototypeOf = __webpack_require__(52)
  , HAS_INSTANCE   = __webpack_require__(14)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(19).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export   = __webpack_require__(1)
  , $parseInt = __webpack_require__(318);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export     = __webpack_require__(1)
  , $parseFloat = __webpack_require__(319);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var global            = __webpack_require__(6)
  , has               = __webpack_require__(36)
  , cof               = __webpack_require__(60)
  , inheritIfRequired = __webpack_require__(235)
  , toPrimitive       = __webpack_require__(72)
  , fails             = __webpack_require__(9)
  , gOPN              = __webpack_require__(111).f
  , gOPD              = __webpack_require__(51).f
  , dP                = __webpack_require__(19).f
  , $trim             = __webpack_require__(129).trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(__webpack_require__(110)(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = __webpack_require__(18) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(42)(global, NUMBER, $Number);
}


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export      = __webpack_require__(1)
  , toInteger    = __webpack_require__(96)
  , aNumberValue = __webpack_require__(320)
  , repeat       = __webpack_require__(236)
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(9)(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export      = __webpack_require__(1)
  , $fails       = __webpack_require__(9)
  , aNumberValue = __webpack_require__(320)
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(1)
  , _isFinite = __webpack_require__(6).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {isInteger: __webpack_require__(321)});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(1)
  , isInteger = __webpack_require__(321)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export     = __webpack_require__(1)
  , $parseFloat = __webpack_require__(319);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export   = __webpack_require__(1)
  , $parseInt = __webpack_require__(318);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1)
  , log1p   = __webpack_require__(322)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1)
  , sign    = __webpack_require__(237);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1)
  , $expm1  = __webpack_require__(238);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(1)
  , sign      = __webpack_require__(237)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(9)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {log1p: __webpack_require__(322)});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {sign: __webpack_require__(237)});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1)
  , expm1   = __webpack_require__(238)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(9)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1)
  , expm1   = __webpack_require__(238)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export        = __webpack_require__(1)
  , toIndex        = __webpack_require__(109)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export   = __webpack_require__(1)
  , toIObject = __webpack_require__(44)
  , toLength  = __webpack_require__(26);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 21.1.3.25 String.prototype.trim()
__webpack_require__(129)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $at  = __webpack_require__(239)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(240)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $at     = __webpack_require__(239)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export   = __webpack_require__(1)
  , toLength  = __webpack_require__(26)
  , context   = __webpack_require__(242)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(243)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export  = __webpack_require__(1)
  , context  = __webpack_require__(242)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(243)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(236)
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export     = __webpack_require__(1)
  , toLength    = __webpack_require__(26)
  , context     = __webpack_require__(242)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(243)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(45)('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.3 String.prototype.big()
__webpack_require__(45)('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.4 String.prototype.blink()
__webpack_require__(45)('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.5 String.prototype.bold()
__webpack_require__(45)('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.6 String.prototype.fixed()
__webpack_require__(45)('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(45)('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(45)('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.9 String.prototype.italics()
__webpack_require__(45)('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.10 String.prototype.link(url)
__webpack_require__(45)('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.11 String.prototype.small()
__webpack_require__(45)('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.12 String.prototype.strike()
__webpack_require__(45)('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.13 String.prototype.sub()
__webpack_require__(45)('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// B.2.3.14 String.prototype.sup()
__webpack_require__(45)('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export     = __webpack_require__(1)
  , toObject    = __webpack_require__(29)
  , toPrimitive = __webpack_require__(72);

$export($export.P + $export.F * __webpack_require__(9)(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1)
  , fails   = __webpack_require__(9)
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  __webpack_require__(42)(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var TO_PRIMITIVE = __webpack_require__(14)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))__webpack_require__(41)(proto, TO_PRIMITIVE, __webpack_require__(637));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var anObject    = __webpack_require__(4)
  , toPrimitive = __webpack_require__(72)
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', {isArray: __webpack_require__(231)});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var ctx            = __webpack_require__(81)
  , $export        = __webpack_require__(1)
  , toObject       = __webpack_require__(29)
  , call           = __webpack_require__(323)
  , isArrayIter    = __webpack_require__(244)
  , toLength       = __webpack_require__(26)
  , createProperty = __webpack_require__(245)
  , getIterFn      = __webpack_require__(246);

$export($export.S + $export.F * !__webpack_require__(183)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});



/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export        = __webpack_require__(1)
  , createProperty = __webpack_require__(245);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(9)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export   = __webpack_require__(1)
  , toIObject = __webpack_require__(44)
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(148) != Object || !__webpack_require__(62)(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export    = __webpack_require__(1)
  , html       = __webpack_require__(232)
  , cof        = __webpack_require__(60)
  , toIndex    = __webpack_require__(109)
  , toLength   = __webpack_require__(26)
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(9)(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export   = __webpack_require__(1)
  , aFunction = __webpack_require__(43)
  , toObject  = __webpack_require__(29)
  , fails     = __webpack_require__(9)
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(62)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export  = __webpack_require__(1)
  , $forEach = __webpack_require__(74)(0)
  , STRICT   = __webpack_require__(62)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(646);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(13)
  , isArray  = __webpack_require__(231)
  , SPECIES  = __webpack_require__(14)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $map    = __webpack_require__(74)(1);

$export($export.P + $export.F * !__webpack_require__(62)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $filter = __webpack_require__(74)(2);

$export($export.P + $export.F * !__webpack_require__(62)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $some   = __webpack_require__(74)(3);

$export($export.P + $export.F * !__webpack_require__(62)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $every  = __webpack_require__(74)(4);

$export($export.P + $export.F * !__webpack_require__(62)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $reduce = __webpack_require__(324);

$export($export.P + $export.F * !__webpack_require__(62)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export = __webpack_require__(1)
  , $reduce = __webpack_require__(324);

$export($export.P + $export.F * !__webpack_require__(62)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export       = __webpack_require__(1)
  , $indexOf      = __webpack_require__(179)(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export       = __webpack_require__(1)
  , toIObject     = __webpack_require__(44)
  , toInteger     = __webpack_require__(96)
  , toLength      = __webpack_require__(26)
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', {copyWithin: __webpack_require__(325)});

__webpack_require__(131)('copyWithin');


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', {fill: __webpack_require__(247)});

__webpack_require__(131)('fill');


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1)
  , $find   = __webpack_require__(74)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(131)(KEY);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1)
  , $find   = __webpack_require__(74)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(131)(KEY);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(112)('Array');


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global            = __webpack_require__(6)
  , inheritIfRequired = __webpack_require__(235)
  , dP                = __webpack_require__(19).f
  , gOPN              = __webpack_require__(111).f
  , isRegExp          = __webpack_require__(182)
  , $flags            = __webpack_require__(184)
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(__webpack_require__(18) && (!CORRECT_NEW || __webpack_require__(9)(function(){
  re2[__webpack_require__(14)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(42)(global, 'RegExp', $RegExp);
}

__webpack_require__(112)('RegExp');


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
__webpack_require__(327);
var anObject    = __webpack_require__(4)
  , $flags      = __webpack_require__(184)
  , DESCRIPTORS = __webpack_require__(18)
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  __webpack_require__(42)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(__webpack_require__(9)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// @@match logic
__webpack_require__(185)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// @@replace logic
__webpack_require__(185)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// @@search logic
__webpack_require__(185)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// @@split logic
__webpack_require__(185)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(182)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var LIBRARY            = __webpack_require__(107)
  , global             = __webpack_require__(6)
  , ctx                = __webpack_require__(81)
  , classof            = __webpack_require__(150)
  , $export            = __webpack_require__(1)
  , isObject           = __webpack_require__(13)
  , aFunction          = __webpack_require__(43)
  , anInstance         = __webpack_require__(113)
  , forOf              = __webpack_require__(132)
  , speciesConstructor = __webpack_require__(249)
  , task               = __webpack_require__(250).set
  , microtask          = __webpack_require__(251)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(114)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(128)($Promise, PROMISE);
__webpack_require__(112)(PROMISE);
Wrapper = __webpack_require__(80)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(183)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var weak = __webpack_require__(332);

// 23.4 WeakSet Objects
__webpack_require__(186)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export      = __webpack_require__(1)
  , $typed       = __webpack_require__(187)
  , buffer       = __webpack_require__(252)
  , anObject     = __webpack_require__(4)
  , toIndex      = __webpack_require__(109)
  , toLength     = __webpack_require__(26)
  , isObject     = __webpack_require__(13)
  , ArrayBuffer  = __webpack_require__(6).ArrayBuffer
  , speciesConstructor = __webpack_require__(249)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(9)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(112)(ARRAY_BUFFER);


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(187).ABV, {
  DataView: __webpack_require__(252).DataView
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(82)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(1)
  , aFunction = __webpack_require__(43)
  , anObject  = __webpack_require__(4)
  , rApply    = (__webpack_require__(6).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(9)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(1)
  , create     = __webpack_require__(110)
  , aFunction  = __webpack_require__(43)
  , anObject   = __webpack_require__(4)
  , isObject   = __webpack_require__(13)
  , fails      = __webpack_require__(9)
  , bind       = __webpack_require__(317)
  , rConstruct = (__webpack_require__(6).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(19)
  , $export     = __webpack_require__(1)
  , anObject    = __webpack_require__(4)
  , toPrimitive = __webpack_require__(72);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(9)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(1)
  , gOPD     = __webpack_require__(51).f
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(1)
  , anObject = __webpack_require__(4);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(241)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(51)
  , getPrototypeOf = __webpack_require__(52)
  , has            = __webpack_require__(36)
  , $export        = __webpack_require__(1)
  , isObject       = __webpack_require__(13)
  , anObject       = __webpack_require__(4);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(51)
  , $export  = __webpack_require__(1)
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(1)
  , getProto = __webpack_require__(52)
  , anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(1)
  , anObject      = __webpack_require__(4)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(333)});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(1)
  , anObject           = __webpack_require__(4)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(19)
  , gOPD           = __webpack_require__(51)
  , getPrototypeOf = __webpack_require__(52)
  , has            = __webpack_require__(36)
  , $export        = __webpack_require__(1)
  , createDesc     = __webpack_require__(94)
  , anObject       = __webpack_require__(4)
  , isObject       = __webpack_require__(13);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(1)
  , setProto = __webpack_require__(233);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(1)
  , $includes = __webpack_require__(179)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(131)('includes');


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1)
  , $at     = __webpack_require__(239)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1)
  , $pad    = __webpack_require__(334);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1)
  , $pad    = __webpack_require__(334);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(129)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(129)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export     = __webpack_require__(1)
  , defined     = __webpack_require__(61)
  , toLength    = __webpack_require__(26)
  , isRegExp    = __webpack_require__(182)
  , getFlags    = __webpack_require__(184)
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

__webpack_require__(241)($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(228)('asyncIterator');


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(228)('observable');


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(1)
  , ownKeys        = __webpack_require__(333)
  , toIObject      = __webpack_require__(44)
  , gOPD           = __webpack_require__(51)
  , createProperty = __webpack_require__(245);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1)
  , $values = __webpack_require__(335)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(1)
  , $entries = __webpack_require__(335)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export         = __webpack_require__(1)
  , toObject        = __webpack_require__(29)
  , aFunction       = __webpack_require__(43)
  , $defineProperty = __webpack_require__(19);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(18) && $export($export.P + __webpack_require__(188), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export         = __webpack_require__(1)
  , toObject        = __webpack_require__(29)
  , aFunction       = __webpack_require__(43)
  , $defineProperty = __webpack_require__(19);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(18) && $export($export.P + __webpack_require__(188), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export                  = __webpack_require__(1)
  , toObject                 = __webpack_require__(29)
  , toPrimitive              = __webpack_require__(72)
  , getPrototypeOf           = __webpack_require__(52)
  , getOwnPropertyDescriptor = __webpack_require__(51).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(18) && $export($export.P + __webpack_require__(188), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $export                  = __webpack_require__(1)
  , toObject                 = __webpack_require__(29)
  , toPrimitive              = __webpack_require__(72)
  , getPrototypeOf           = __webpack_require__(52)
  , getOwnPropertyDescriptor = __webpack_require__(51).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(18) && $export($export.P + __webpack_require__(188), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(1);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(336)('Map')});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(1);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(336)('Set')});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', {global: __webpack_require__(6)});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1)
  , cof     = __webpack_require__(60);

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata                  = __webpack_require__(83)
  , anObject                  = __webpack_require__(4)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata               = __webpack_require__(83)
  , anObject               = __webpack_require__(4)
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata               = __webpack_require__(83)
  , anObject               = __webpack_require__(4)
  , getPrototypeOf         = __webpack_require__(52)
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var Set                     = __webpack_require__(330)
  , from                    = __webpack_require__(337)
  , metadata                = __webpack_require__(83)
  , anObject                = __webpack_require__(4)
  , getPrototypeOf          = __webpack_require__(52)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata               = __webpack_require__(83)
  , anObject               = __webpack_require__(4)
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata                = __webpack_require__(83)
  , anObject                = __webpack_require__(4)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata               = __webpack_require__(83)
  , anObject               = __webpack_require__(4)
  , getPrototypeOf         = __webpack_require__(52)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata               = __webpack_require__(83)
  , anObject               = __webpack_require__(4)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var metadata                  = __webpack_require__(83)
  , anObject                  = __webpack_require__(4)
  , aFunction                 = __webpack_require__(43)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = __webpack_require__(1)
  , microtask = __webpack_require__(251)()
  , process   = __webpack_require__(6).process
  , isNode    = __webpack_require__(60)(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// https://github.com/zenparsing/es-observable
var $export     = __webpack_require__(1)
  , global      = __webpack_require__(6)
  , core        = __webpack_require__(80)
  , microtask   = __webpack_require__(251)()
  , OBSERVABLE  = __webpack_require__(14)('observable')
  , aFunction   = __webpack_require__(43)
  , anObject    = __webpack_require__(4)
  , anInstance  = __webpack_require__(113)
  , redefineAll = __webpack_require__(114)
  , hide        = __webpack_require__(41)
  , forOf       = __webpack_require__(132)
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

__webpack_require__(112)('Observable');


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(6)
  , $export    = __webpack_require__(1)
  , invoke     = __webpack_require__(181)
  , partial    = __webpack_require__(729)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var path      = __webpack_require__(730)
  , invoke    = __webpack_require__(181)
  , aFunction = __webpack_require__(43);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(6);


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(1)
  , $task   = __webpack_require__(250);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $iterators    = __webpack_require__(248)
  , redefine      = __webpack_require__(42)
  , global        = __webpack_require__(6)
  , hide          = __webpack_require__(41)
  , Iterators     = __webpack_require__(130)
  , wks           = __webpack_require__(14)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(734);
module.exports = __webpack_require__(80).RegExp.escape;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1)
  , $re     = __webpack_require__(735)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});



/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);



/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(16);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(474);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(476);

var _es = __webpack_require__(49);

var _pdfjsDist = __webpack_require__(496);

var _pdfjsDist2 = _interopRequireDefault(_pdfjsDist);

var _websocket_actions = __webpack_require__(223);

var Websockets = _interopRequireWildcard(_websocket_actions);

var _user_actions = __webpack_require__(123);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _i18n = __webpack_require__(306);

var I18n = _interopRequireWildcard(_i18n);

__webpack_require__(1107);

__webpack_require__(1113);

__webpack_require__(1162);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _channels = __webpack_require__(89);

var _general = __webpack_require__(296);

var _route_root = __webpack_require__(1212);

var _route_root2 = _interopRequireDefault(_route_root);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1225)(_jquery2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// Import our styles


// Redux actions

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

// Import the root of our routing tree


// PDFJS.disableWorker = true;
_pdfjsDist2.default.PDFJS.disableWorker = true;
_pdfjsDist2.default.PDFJS.cMapUrl = "/static/cmaps/";
_pdfjsDist2.default.PDFJS.cMapPacked = true;

// This is for anything that needs to be done for ALL react components.
// This runs before we start to render anything.
function preRenderSetup(callwhendone) {
    window.onerror = function (msg, url, line, column, stack) {
        var l = {};
        l.level = 'ERROR';
        l.message = 'msg: ' + msg + ' row: ' + line + ' col: ' + column + ' stack: ' + stack + ' url: ' + url;
        console.error(l);

        // $.ajax({
        //     url: '/api/v3/general/log_client',
        //     dataType: 'json',
        //     contentType: 'application/json',
        //     type: 'POST',
        //     data: JSON.stringify(l)
        // });

        if (window.mm_config && window.mm_config.EnableDeveloper === 'true') {
            window.ErrorStore.storeLastError({ type: 'developer', message: 'DEVELOPER MODE: A JavaScript error has occurred.  Please use the JavaScript console to capture and report the error (row: ' + line + ' col: ' + column + ').' });
            window.ErrorStore.emitChange();
        }
    };

    var d1 = _jquery2.default.Deferred(); //eslint-disable-line new-cap

    (0, _general.setUrl)(window.location.origin);

    if (document.cookie.indexOf('MMUSERID=') > -1) {
        (0, _user_actions.loadMeAndConfig)(function () {
            return d1.resolve();
        });
    } else {
        (0, _general.getClientConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState).then(function (config) {
            global.window.mm_config = config;

            (0, _general.getLicenseConfig)()(_redux_store2.default.dispatch, _redux_store2.default.getState).then(function (license) {
                global.window.mm_license = license;
                d1.resolve();
            });
        });
    }

    // Make sure the websockets close and reset version
    (0, _jquery2.default)(window).on('beforeunload', function () {
        // Turn off to prevent getting stuck in a loop
        (0, _jquery2.default)(window).off('beforeunload');
        if (document.cookie.indexOf('MMUSERID=') > -1) {
            (0, _channels.viewChannel)('', _channel_store2.default.getCurrentId() || '')(dispatch, getState);
        }
        Websockets.close();
    });

    function afterIntl() {
        _jquery2.default.when(d1).done(function () {
            I18n.doAddLocaleData();
            callwhendone();
        });
    }

    if (global.Intl) {
        afterIntl();
    } else {
        I18n.safariFix(afterIntl);
    }

    // Prevent drag and drop files from navigating away from the app
    document.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    document.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
}

function renderRootComponent() {
    _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: _redux_store2.default },
        _react2.default.createElement(_es.Router, {
            history: _es.browserHistory,
            routes: _route_root2.default
        })
    ), document.getElementById('root'));
}

global.window.setup_root = function () {
    // Do the pre-render setup and call renderRootComponent when done
    preRenderSetup(renderRootComponent);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var PooledClass = __webpack_require__(740);
var ReactElement = __webpack_require__(134);

var emptyFunction = __webpack_require__(53);
var traverseAllChildren = __webpack_require__(741);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(151);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(151);

var ReactCurrentOwner = __webpack_require__(84);
var REACT_ELEMENT_TYPE = __webpack_require__(342);

var getIteratorFn = __webpack_require__(742);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(743);
var warning = __webpack_require__(10);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactElement = __webpack_require__(134);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _require = __webpack_require__(134),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(343);

module.exports = factory(isValidElement);


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

var emptyFunction = __webpack_require__(53);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var ReactPropTypesSecret = __webpack_require__(344);
var checkPropTypes = __webpack_require__(747);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};



/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;



/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

module.exports = '15.6.1';


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _require = __webpack_require__(339),
    Component = _require.Component;

var _require2 = __webpack_require__(134),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(340);
var factory = __webpack_require__(490);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
'use strict';

var _prodInvariant = __webpack_require__(151);

var ReactElement = __webpack_require__(134);

var invariant = __webpack_require__(3);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

'use strict';

var ReactDOMComponentTree = __webpack_require__(20);
var ReactDefaultInjection = __webpack_require__(752);
var ReactMount = __webpack_require__(368);
var ReactReconciler = __webpack_require__(136);
var ReactUpdates = __webpack_require__(75);
var ReactVersion = __webpack_require__(824);

var findDOMNode = __webpack_require__(825);
var getHostComponentFromComposite = __webpack_require__(369);
var renderSubtreeIntoContainer = __webpack_require__(826);
var warning = __webpack_require__(10);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ARIADOMPropertyConfig = __webpack_require__(753);
var BeforeInputEventPlugin = __webpack_require__(754);
var ChangeEventPlugin = __webpack_require__(758);
var DefaultEventPluginOrder = __webpack_require__(761);
var EnterLeaveEventPlugin = __webpack_require__(762);
var HTMLDOMPropertyConfig = __webpack_require__(763);
var ReactComponentBrowserEnvironment = __webpack_require__(764);
var ReactDOMComponent = __webpack_require__(770);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactDOMEmptyComponent = __webpack_require__(795);
var ReactDOMTreeTraversal = __webpack_require__(796);
var ReactDOMTextComponent = __webpack_require__(797);
var ReactDefaultBatchingStrategy = __webpack_require__(798);
var ReactEventListener = __webpack_require__(799);
var ReactInjection = __webpack_require__(801);
var ReactReconcileTransaction = __webpack_require__(802);
var SVGDOMPropertyConfig = __webpack_require__(808);
var SelectEventPlugin = __webpack_require__(809);
var SimpleEventPlugin = __webpack_require__(810);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(152);
var ExecutionEnvironment = __webpack_require__(37);
var FallbackCompositionState = __webpack_require__(755);
var SyntheticCompositionEvent = __webpack_require__(756);
var SyntheticInputEvent = __webpack_require__(757);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(115);

var getTextContentAccessor = __webpack_require__(348);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(153);
var EventPropagators = __webpack_require__(152);
var ExecutionEnvironment = __webpack_require__(37);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactUpdates = __webpack_require__(75);
var SyntheticEvent = __webpack_require__(85);

var inputValueTracking = __webpack_require__(351);
var getEventTarget = __webpack_require__(256);
var isEventSupported = __webpack_require__(257);
var isTextInputElement = __webpack_require__(352);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var ReactOwner = __webpack_require__(760);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(152);
var ReactDOMComponentTree = __webpack_require__(20);
var SyntheticMouseEvent = __webpack_require__(191);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(135);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(259);
var ReactDOMIDOperations = __webpack_require__(769);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(137);
var ExecutionEnvironment = __webpack_require__(37);

var createNodesFromMarkup = __webpack_require__(766);
var emptyFunction = __webpack_require__(53);
var invariant = __webpack_require__(3);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(37);

var createArrayFromMixed = __webpack_require__(767);
var getMarkupWrap = __webpack_require__(768);
var invariant = __webpack_require__(3);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(3);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(37);

var invariant = __webpack_require__(3);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(259);
var ReactDOMComponentTree = __webpack_require__(20);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var AutoFocusUtils = __webpack_require__(771);
var CSSPropertyOperations = __webpack_require__(772);
var DOMLazyTree = __webpack_require__(137);
var DOMNamespaces = __webpack_require__(260);
var DOMProperty = __webpack_require__(135);
var DOMPropertyOperations = __webpack_require__(357);
var EventPluginHub = __webpack_require__(153);
var EventPluginRegistry = __webpack_require__(253);
var ReactBrowserEventEmitter = __webpack_require__(194);
var ReactDOMComponentFlags = __webpack_require__(345);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactDOMInput = __webpack_require__(782);
var ReactDOMOption = __webpack_require__(784);
var ReactDOMSelect = __webpack_require__(358);
var ReactDOMTextarea = __webpack_require__(785);
var ReactInstrumentation = __webpack_require__(63);
var ReactMultiChild = __webpack_require__(786);
var ReactServerRenderingTransaction = __webpack_require__(793);

var emptyFunction = __webpack_require__(53);
var escapeTextContentForBrowser = __webpack_require__(193);
var invariant = __webpack_require__(3);
var isEventSupported = __webpack_require__(257);
var shallowEqual = __webpack_require__(222);
var inputValueTracking = __webpack_require__(351);
var validateDOMNesting = __webpack_require__(267);
var warning = __webpack_require__(10);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactDOMComponentTree = __webpack_require__(20);

var focusNode = __webpack_require__(355);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var CSSProperty = __webpack_require__(356);
var ExecutionEnvironment = __webpack_require__(37);
var ReactInstrumentation = __webpack_require__(63);

var camelizeStyleName = __webpack_require__(773);
var dangerousStyleValue = __webpack_require__(775);
var hyphenateStyleName = __webpack_require__(776);
var memoizeStringOnly = __webpack_require__(778);
var warning = __webpack_require__(10);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

var camelize = __webpack_require__(774);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var CSSProperty = __webpack_require__(356);
var warning = __webpack_require__(10);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

var hyphenate = __webpack_require__(777);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */

'use strict';

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var escapeTextContentForBrowser = __webpack_require__(193);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(153);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var DOMPropertyOperations = __webpack_require__(357);
var LinkedValueUtils = __webpack_require__(262);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactUpdates = __webpack_require__(75);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var React = __webpack_require__(133);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactDOMSelect = __webpack_require__(358);

var warning = __webpack_require__(10);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var LinkedValueUtils = __webpack_require__(262);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactUpdates = __webpack_require__(75);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactComponentEnvironment = __webpack_require__(263);
var ReactInstanceMap = __webpack_require__(155);
var ReactInstrumentation = __webpack_require__(63);

var ReactCurrentOwner = __webpack_require__(84);
var ReactReconciler = __webpack_require__(136);
var ReactChildReconciler = __webpack_require__(787);

var emptyFunction = __webpack_require__(53);
var flattenChildren = __webpack_require__(792);
var invariant = __webpack_require__(3);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactReconciler = __webpack_require__(136);

var instantiateReactComponent = __webpack_require__(359);
var KeyEscapeUtils = __webpack_require__(265);
var shouldUpdateReactComponent = __webpack_require__(264);
var traverseAllChildren = __webpack_require__(363);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(364);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var React = __webpack_require__(133);
var ReactComponentEnvironment = __webpack_require__(263);
var ReactCurrentOwner = __webpack_require__(84);
var ReactErrorUtils = __webpack_require__(255);
var ReactInstanceMap = __webpack_require__(155);
var ReactInstrumentation = __webpack_require__(63);
var ReactNodeTypes = __webpack_require__(360);
var ReactReconciler = __webpack_require__(136);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(189);
var invariant = __webpack_require__(3);
var shallowEqual = __webpack_require__(222);
var shouldUpdateReactComponent = __webpack_require__(264);
var warning = __webpack_require__(10);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var KeyEscapeUtils = __webpack_require__(265);
var traverseAllChildren = __webpack_require__(363);
var warning = __webpack_require__(10);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(364);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(115);
var Transaction = __webpack_require__(190);
var ReactInstrumentation = __webpack_require__(63);
var ReactServerUpdateQueue = __webpack_require__(794);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(266);

var warning = __webpack_require__(10);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var DOMLazyTree = __webpack_require__(137);
var ReactDOMComponentTree = __webpack_require__(20);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var invariant = __webpack_require__(3);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11),
    _assign = __webpack_require__(17);

var DOMChildrenOperations = __webpack_require__(259);
var DOMLazyTree = __webpack_require__(137);
var ReactDOMComponentTree = __webpack_require__(20);

var escapeTextContentForBrowser = __webpack_require__(193);
var invariant = __webpack_require__(3);
var validateDOMNesting = __webpack_require__(267);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var ReactUpdates = __webpack_require__(75);
var Transaction = __webpack_require__(190);

var emptyFunction = __webpack_require__(53);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var EventListener = __webpack_require__(365);
var ExecutionEnvironment = __webpack_require__(37);
var PooledClass = __webpack_require__(115);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactUpdates = __webpack_require__(75);

var getEventTarget = __webpack_require__(256);
var getUnboundedScrollPosition = __webpack_require__(800);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(135);
var EventPluginHub = __webpack_require__(153);
var EventPluginUtils = __webpack_require__(254);
var ReactComponentEnvironment = __webpack_require__(263);
var ReactEmptyComponent = __webpack_require__(361);
var ReactBrowserEventEmitter = __webpack_require__(194);
var ReactHostComponent = __webpack_require__(362);
var ReactUpdates = __webpack_require__(75);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _assign = __webpack_require__(17);

var CallbackQueue = __webpack_require__(349);
var PooledClass = __webpack_require__(115);
var ReactBrowserEventEmitter = __webpack_require__(194);
var ReactInputSelection = __webpack_require__(366);
var ReactInstrumentation = __webpack_require__(63);
var Transaction = __webpack_require__(190);
var ReactUpdateQueue = __webpack_require__(266);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(37);

var getNodeForCharacterOffset = __webpack_require__(804);
var getTextContentAccessor = __webpack_require__(348);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(806);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(807);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(152);
var ExecutionEnvironment = __webpack_require__(37);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactInputSelection = __webpack_require__(366);
var SyntheticEvent = __webpack_require__(85);

var getActiveElement = __webpack_require__(367);
var isTextInputElement = __webpack_require__(352);
var shallowEqual = __webpack_require__(222);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var EventListener = __webpack_require__(365);
var EventPropagators = __webpack_require__(152);
var ReactDOMComponentTree = __webpack_require__(20);
var SyntheticAnimationEvent = __webpack_require__(811);
var SyntheticClipboardEvent = __webpack_require__(812);
var SyntheticEvent = __webpack_require__(85);
var SyntheticFocusEvent = __webpack_require__(813);
var SyntheticKeyboardEvent = __webpack_require__(814);
var SyntheticMouseEvent = __webpack_require__(191);
var SyntheticDragEvent = __webpack_require__(816);
var SyntheticTouchEvent = __webpack_require__(817);
var SyntheticTransitionEvent = __webpack_require__(818);
var SyntheticUIEvent = __webpack_require__(154);
var SyntheticWheelEvent = __webpack_require__(819);

var emptyFunction = __webpack_require__(53);
var getEventCharCode = __webpack_require__(268);
var invariant = __webpack_require__(3);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(154);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(154);

var getEventCharCode = __webpack_require__(268);
var getEventKey = __webpack_require__(815);
var getEventModifierState = __webpack_require__(258);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var getEventCharCode = __webpack_require__(268);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(191);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(154);

var getEventModifierState = __webpack_require__(258);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(85);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(191);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var validateDOMNesting = __webpack_require__(267);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var adler32 = __webpack_require__(823);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

module.exports = '15.6.1';


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(20);
var ReactInstanceMap = __webpack_require__(155);

var getHostComponentFromComposite = __webpack_require__(369);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(10);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactMount = __webpack_require__(368);

module.exports = ReactMount.renderSubtreeIntoContainer;


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(269);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

var emptyFunction = __webpack_require__(53);
var invariant = __webpack_require__(3);
var ReactPropTypesSecret = __webpack_require__(344);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};



/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();




/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(857);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(377);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(837);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);



/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(835);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);



/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(374);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);



/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);



/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(839);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);



/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);



/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);



/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(842);



/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(843);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(491)(module)))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(375);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(376);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(851);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);



/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(849);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);



/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(379);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);



/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);



/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(853);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);



/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);



/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);



/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(377);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(378);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(858);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(269);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useQueries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["f" /* routes */],
    routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["f" /* routes */], // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // Deprecated:
    parseQueryString: func,
    stringifyQuery: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _props = this.props;
    var parseQueryString = _props.parseQueryString;
    var stringifyQuery = _props.stringifyQuery;

     false ? warning(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects();

    var history = _createRouterObjects.history;
    var transitionManager = _createRouterObjects.transitionManager;
    var router = _createRouterObjects.router;


    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        _this.setState(state, _this.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  },
  createRouterObjects: function createRouterObjects() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext;
    }

    var history = this.props.history;
    var _props2 = this.props;
    var routes = _props2.routes;
    var children = _props2.children;


    !!isUnsupportedHistory(history) ?  false ? invariant(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;

    if (isDeprecatedHistory(history)) {
      history = this.wrapDeprecatedHistory(history);
    }

    var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
    var router = Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, transitionManager);
    var routingHistory = Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRoutingHistory */])(history, transitionManager);

    return { history: routingHistory, transitionManager: transitionManager, router: router };
  },
  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
    var _props3 = this.props;
    var parseQueryString = _props3.parseQueryString;
    var stringifyQuery = _props3.stringifyQuery;


    var createHistory = void 0;
    if (history) {
       false ? warning(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
      createHistory = function createHistory() {
        return history;
      };
    } else {
       false ? warning(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
      createHistory = __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a;
    }

    return __WEBPACK_IMPORTED_MODULE_1_history_lib_useQueries___default()(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state;
    var location = _state.location;
    var routes = _state.routes;
    var params = _state.params;
    var components = _state.components;
    var _props4 = this.props;
    var createElement = _props4.createElement;
    var render = _props4.render;

    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(861);
var isArguments = __webpack_require__(862);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}



/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};



/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(76);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(125);

var _PathUtils = __webpack_require__(116);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var strictUriEncode = __webpack_require__(866);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};



/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = runEnterHooks;
/* harmony export (immutable) */ __webpack_exports__["a"] = runChangeHooks;
/* harmony export (immutable) */ __webpack_exports__["c"] = runLeaveHooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? warning(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname;
  var query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__makeStateWithLocation__ = __webpack_require__(383);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = Object(__WEBPACK_IMPORTED_MODULE_1__makeStateWithLocation__["a" /* default */])(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__makeStateWithLocation__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(97);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = Object(__WEBPACK_IMPORTED_MODULE_1__makeStateWithLocation__["a" /* default */])(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = Object(__WEBPACK_IMPORTED_MODULE_1__makeStateWithLocation__["a" /* default */])(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? warning(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(138);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(385);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PropTypes__ = __webpack_require__(198);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
    displayName: 'WithRouter',

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_3__PropTypes__["c" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_3__PropTypes__["c" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      var props = _extends({}, this.props, { router: router });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redirect__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(117);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);







var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_3__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(117);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);







var func = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__ = __webpack_require__(117);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);






var _React$PropTypes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_2__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: string,
    component: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_3__InternalPropTypes__["b" /* components */],
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InternalPropTypes__ = __webpack_require__(117);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: __WEBPACK_IMPORTED_MODULE_1__InternalPropTypes__["d" /* history */]
  },

  componentWillMount: function componentWillMount() {
     false ? warning(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (History);


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





var object = __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? warning(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? invariant(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? invariant(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Lifecycle);


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);




var object = __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  componentWillMount: function componentWillMount() {
     false ? warning(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (RouteContext);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTransitionManager__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? warning(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var routes = _ref.routes;

    var options = _objectWithoutProperties(_ref, ['routes']);

    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(createHistory)(options);
    var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_1__createTransitionManager__["a" /* default */])(history, routes);
    return _extends({}, history, transitionManager);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (useRoutes);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);





var RoutingContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
  displayName: 'RoutingContext',
  componentWillMount: function componentWillMount() {
     false ? warning(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], this.props);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RoutingContext);


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(384);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history;
  var routes = _ref.routes;
  var location = _ref.location;

  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager);
  history = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRoutingHistory */])(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation && router.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(27);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"] : arguments[0];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(389);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(389);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}



/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}



/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Transform = __webpack_require__(539);

var binding = __webpack_require__(896);
var util = __webpack_require__(397);
var assert = __webpack_require__(906).ok;

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = (16 * 1024);

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
Object.keys(binding).forEach(function(k) {
  if (k.match(/^Z/)) exports[k] = binding[k];
});

// translation table for return codes.
exports.codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

Object.keys(exports.codes).forEach(function(k) {
  exports.codes[exports.codes[k]] = k;
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function(o) {
  return new Deflate(o);
};

exports.createInflate = function(o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function(o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function(o) {
  return new InflateRaw(o);
};

exports.createGzip = function(o) {
  return new Gzip(o);
};

exports.createGunzip = function(o) {
  return new Gunzip(o);
};

exports.createUnzip = function(o) {
  return new Unzip(o);
};


// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function(buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function(buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function(buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function(buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function(buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function(buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function(buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf = Buffer.concat(buffers, nread);
    buffers = [];
    callback(null, buf);
    engine.close();
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string')
    buffer = new Buffer(buffer);
  if (!Buffer.isBuffer(buffer))
    throw new TypeError('Not a string or buffer');

  var flushFlag = binding.Z_FINISH;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}



// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}



// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}


// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}


// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush) {
    if (opts.flush !== binding.Z_NO_FLUSH &&
        opts.flush !== binding.Z_PARTIAL_FLUSH &&
        opts.flush !== binding.Z_SYNC_FLUSH &&
        opts.flush !== binding.Z_FULL_FLUSH &&
        opts.flush !== binding.Z_FINISH &&
        opts.flush !== binding.Z_BLOCK) {
      throw new Error('Invalid flush flag: ' + opts.flush);
    }
  }
  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
        opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL ||
        opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED &&
        opts.strategy != exports.Z_HUFFMAN_ONLY &&
        opts.strategy != exports.Z_RLE &&
        opts.strategy != exports.Z_FIXED &&
        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._binding = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._binding.onerror = function(message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    self._binding = null;
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
                     level,
                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
                     strategy,
                     opts.dictionary);

  this._buffer = new Buffer(this._chunkSize);
  this._offset = 0;
  this._closed = false;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function(level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL ||
      level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED &&
      strategy != exports.Z_HUFFMAN_ONLY &&
      strategy != exports.Z_RLE &&
      strategy != exports.Z_FIXED &&
      strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function() {
      self._binding.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function() {
  return this._binding.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function(callback) {
  this._transform(new Buffer(0), '', callback);
};

Zlib.prototype.flush = function(kind, callback) {
  var ws = this._writableState;

  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback)
      process.nextTick(callback);
  } else if (ws.ending) {
    if (callback)
      this.once('end', callback);
  } else if (ws.needDrain) {
    var self = this;
    this.once('drain', function() {
      self.flush(callback);
    });
  } else {
    this._flushFlag = kind;
    this.write(new Buffer(0), '', callback);
  }
};

Zlib.prototype.close = function(callback) {
  if (callback)
    process.nextTick(callback);

  if (this._closed)
    return;

  this._closed = true;

  this._binding.close();

  var self = this;
  process.nextTick(function() {
    self.emit('close');
  });
};

Zlib.prototype._transform = function(chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (!chunk === null && !Buffer.isBuffer(chunk))
    return cb(new Error('invalid input'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last)
    flushFlag = binding.Z_FINISH;
  else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  var self = this;
  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function(er) {
      error = er;
    });

    do {
      var res = this._binding.writeSync(flushFlag,
                                        chunk, // in
                                        inOff, // in_off
                                        availInBefore, // in_len
                                        this._buffer, // out
                                        this._offset, //out_off
                                        availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    var buf = Buffer.concat(buffers, nread);
    this.close();

    return buf;
  }

  var req = this._binding.write(flushFlag,
                                chunk, // in
                                inOff, // in_off
                                availInBefore, // in_len
                                this._buffer, // out
                                this._offset, //out_off
                                availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    if (self._hadError)
      return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = new Buffer(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += (availInBefore - availInAfter);
      availInBefore = availInAfter;

      if (!async)
        return true;

      var newReq = self._binding.write(flushFlag,
                                       chunk,
                                       inOff,
                                       availInBefore,
                                       self._buffer,
                                       self._offset,
                                       self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async)
      return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer, __webpack_require__(58)))

/***/ }),
/* 890 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var Buffer = __webpack_require__(79).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(277);
/*</replacement>*/

module.exports = BufferList;

function BufferList() {
  this.head = null;
  this.tail = null;
  this.length = 0;
}

BufferList.prototype.push = function (v) {
  var entry = { data: v, next: null };
  if (this.length > 0) this.tail.next = entry;else this.head = entry;
  this.tail = entry;
  ++this.length;
};

BufferList.prototype.unshift = function (v) {
  var entry = { data: v, next: this.head };
  if (this.length === 0) this.tail = entry;
  this.head = entry;
  ++this.length;
};

BufferList.prototype.shift = function () {
  if (this.length === 0) return;
  var ret = this.head.data;
  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
  --this.length;
  return ret;
};

BufferList.prototype.clear = function () {
  this.head = this.tail = null;
  this.length = 0;
};

BufferList.prototype.join = function (s) {
  if (this.length === 0) return '';
  var p = this.head;
  var ret = '' + p.data;
  while (p = p.next) {
    ret += s + p.data;
  }return ret;
};

BufferList.prototype.concat = function (n) {
  if (this.length === 0) return bufferShim.alloc(0);
  if (this.length === 1) return this.head.data;
  var ret = bufferShim.allocUnsafe(n >>> 0);
  var p = this.head;
  var i = 0;
  while (p) {
    p.data.copy(ret, i);
    i += p.data.length;
    p = p.next;
  }
  return ret;
};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(893);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;



/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(58)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = __webpack_require__(393);

/*<replacement>*/
var util = __webpack_require__(156);
util.inherits = __webpack_require__(147);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var msg = __webpack_require__(394);
var zstream = __webpack_require__(897);
var zlib_deflate = __webpack_require__(898);
var zlib_inflate = __webpack_require__(900);
var constants = __webpack_require__(903);

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (mode < exports.DEFLATE || mode > exports.UNZIP)
    throw new TypeError("Bad argument");
    
  this.mode = mode;
  this.init_done = false;
  this.write_in_progress = false;
  this.pending_close = false;
  this.windowBits = 0;
  this.level = 0;
  this.memLevel = 0;
  this.strategy = 0;
  this.dictionary = null;
}

Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
  this.windowBits = windowBits;
  this.level = level;
  this.memLevel = memLevel;
  this.strategy = strategy;
  // dictionary not supported.
  
  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
    this.windowBits += 16;
    
  if (this.mode === exports.UNZIP)
    this.windowBits += 32;
    
  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
    this.windowBits = -this.windowBits;
    
  this.strm = new zstream();
  
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflateInit2(
        this.strm,
        this.level,
        exports.Z_DEFLATED,
        this.windowBits,
        this.memLevel,
        this.strategy
      );
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      var status  = zlib_inflate.inflateInit2(
        this.strm,
        this.windowBits
      );
      break;
    default:
      throw new Error("Unknown mode " + this.mode);
  }
  
  if (status !== exports.Z_OK) {
    this._error(status);
    return;
  }
  
  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype.params = function() {
  throw new Error("deflateParams Not supported");
};

Zlib.prototype._writeCheck = function() {
  if (!this.init_done)
    throw new Error("write before init");
    
  if (this.mode === exports.NONE)
    throw new Error("already finalized");
    
  if (this.write_in_progress)
    throw new Error("write already in progress");
    
  if (this.pending_close)
    throw new Error("close is pending");
};

Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
  this._writeCheck();
  this.write_in_progress = true;
  
  var self = this;
  process.nextTick(function() {
    self.write_in_progress = false;
    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
    self.callback(res[0], res[1]);
    
    if (self.pending_close)
      self.close();
  });
  
  return this;
};

// set method for Node buffers, used by pako
function bufferSet(data, offset) {
  for (var i = 0; i < data.length; i++) {
    this[offset + i] = data[i];
  }
}

Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
  this._writeCheck();
  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
  this.write_in_progress = true;
  
  if (flush !== exports.Z_NO_FLUSH &&
      flush !== exports.Z_PARTIAL_FLUSH &&
      flush !== exports.Z_SYNC_FLUSH &&
      flush !== exports.Z_FULL_FLUSH &&
      flush !== exports.Z_FINISH &&
      flush !== exports.Z_BLOCK) {
    throw new Error("Invalid flush value");
  }
  
  if (input == null) {
    input = new Buffer(0);
    in_len = 0;
    in_off = 0;
  }
  
  if (out._set)
    out.set = out._set;
  else
    out.set = bufferSet;
  
  var strm = this.strm;
  strm.avail_in = in_len;
  strm.input = input;
  strm.next_in = in_off;
  strm.avail_out = out_len;
  strm.output = out;
  strm.next_out = out_off;
  
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflate(strm, flush);
      break;
    case exports.UNZIP:
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      var status = zlib_inflate.inflate(strm, flush);
      break;
    default:
      throw new Error("Unknown mode " + this.mode);
  }
  
  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
    this._error(status);
  }
  
  this.write_in_progress = false;
  return [strm.avail_in, strm.avail_out];
};

Zlib.prototype.close = function() {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }
  
  this.pending_close = false;
  
  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else {
    zlib_inflate.inflateEnd(this.strm);
  }
  
  this.mode = exports.NONE;
};

Zlib.prototype.reset = function() {
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
      var status = zlib_inflate.inflateReset(this.strm);
      break;
  }
  
  if (status !== exports.Z_OK) {
    this._error(status);
  }
};

Zlib.prototype._error = function(status) {
  this.onerror(msg[status] + ': ' + this.strm.msg, status);
  
  this.write_in_progress = false;
  if (this.pending_close)
    this.close();
};

exports.Zlib = Zlib;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(79).Buffer))

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;



/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var utils   = __webpack_require__(199);
var trees   = __webpack_require__(899);
var adler32 = __webpack_require__(395);
var crc32   = __webpack_require__(396);
var msg     = __webpack_require__(394);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/



/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


var utils = __webpack_require__(199);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;



/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


var utils         = __webpack_require__(199);
var adler32       = __webpack_require__(395);
var crc32         = __webpack_require__(396);
var inflate_fast  = __webpack_require__(901);
var inflate_table = __webpack_require__(902);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = zswap32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = { bits: state.lenbits };
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = { bits: state.lenbits };
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = { bits: state.distbits };
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/



/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};



/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


var utils = __webpack_require__(199);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i = 0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};



/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';


module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};



/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}



/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(397);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(338);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(200);
__webpack_require__(118);
__webpack_require__(141);
__webpack_require__(916);
module.exports = __webpack_require__(15).Promise;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toInteger = __webpack_require__(278)
  , defined   = __webpack_require__(201);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var create         = __webpack_require__(204)
  , descriptor     = __webpack_require__(157)
  , setToStringTag = __webpack_require__(159)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(99)(IteratorPrototype, __webpack_require__(32)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var dP       = __webpack_require__(64)
  , anObject = __webpack_require__(65)
  , getKeys  = __webpack_require__(120);

module.exports = __webpack_require__(77) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(90)
  , toLength  = __webpack_require__(205)
  , toIndex   = __webpack_require__(913);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var toInteger = __webpack_require__(278)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var addToUnscopables = __webpack_require__(915)
  , step             = __webpack_require__(403)
  , Iterators        = __webpack_require__(139)
  , toIObject        = __webpack_require__(90);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(279)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = function(){ /* empty */ };


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var LIBRARY            = __webpack_require__(202)
  , global             = __webpack_require__(38)
  , ctx                = __webpack_require__(98)
  , classof            = __webpack_require__(207)
  , $export            = __webpack_require__(31)
  , isObject           = __webpack_require__(100)
  , aFunction          = __webpack_require__(203)
  , anInstance         = __webpack_require__(286)
  , forOf              = __webpack_require__(208)
  , speciesConstructor = __webpack_require__(917)
  , task               = __webpack_require__(406).set
  , microtask          = __webpack_require__(919)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(32)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(288)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(159)($Promise, PROMISE);
__webpack_require__(407)(PROMISE);
Wrapper = __webpack_require__(15)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(408)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(65)
  , aFunction = __webpack_require__(203)
  , SPECIES   = __webpack_require__(32)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var global    = __webpack_require__(38)
  , macrotask = __webpack_require__(406).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(158)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(921);
module.exports = __webpack_require__(15).Object.assign;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(31);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(922)});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(120)
  , gOPS     = __webpack_require__(289)
  , pIE      = __webpack_require__(160)
  , toObject = __webpack_require__(140)
  , IObject  = __webpack_require__(282)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(101)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = __webpack_require__(924);



/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */

'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(3);

var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = (function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
        continue;
      }
      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
})();

module.exports = Dispatcher;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9061212809b4b782f82140a237b2690f.png";

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d6724700a31155baa90de2799b83529e.jpg";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/code_themes/82ff075b2124d9b007ac4caf40f8d3a9.css";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2e6c12717289353fe54c922871edd5d0.png";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/code_themes/5a0ca255fce9de83dde16a0f27d788fe.css";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/61b7e84911498a766585c4f0f30286b1.png";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/code_themes/bf6c14925e66edb1526b6c9489b3c042.css";

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/46278561af0c5b433188c1620955f3fa.png";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/code_themes/ad2b15c2189d3cdedbd68a1668bd1a52.css";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8aa43f3d86f2b882e53a69b42c08a8d6.png";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a14eebbff542b4dc4834b7fe8019d40f.png";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2cfff6bd2cd6761e997a436f696f5bdc.png";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/cb754192022d864259d2973c82f9e57f.png";

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ebbb68fa4d0bb68d4d027e57c98b0e22.png";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5fbbaa14682f92028bf00bf994d004a5.png";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d3d065ad0741756e7e1e81dcbbd12898.png";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(942);
module.exports = __webpack_require__(15).Object.keys;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(140)
  , $keys    = __webpack_require__(120);

__webpack_require__(300)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(118);
__webpack_require__(944);
module.exports = __webpack_require__(15).Array.from;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var ctx            = __webpack_require__(98)
  , $export        = __webpack_require__(31)
  , toObject       = __webpack_require__(140)
  , call           = __webpack_require__(404)
  , isArrayIter    = __webpack_require__(405)
  , toLength       = __webpack_require__(205)
  , createProperty = __webpack_require__(945)
  , getIterFn      = __webpack_require__(287);

$export($export.S + $export.F * !__webpack_require__(408)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});



/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var $defineProperty = __webpack_require__(64)
  , createDesc      = __webpack_require__(157);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(947);
module.exports = __webpack_require__(15).Object.getPrototypeOf;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(140)
  , $getPrototypeOf = __webpack_require__(402);

__webpack_require__(300)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(949);
var $Object = __webpack_require__(15).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(31);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(77), 'Object', {defineProperty: __webpack_require__(64).f});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(118);
__webpack_require__(141);
module.exports = __webpack_require__(290).f('iterator');


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(952), __esModule: true };


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(953);
__webpack_require__(200);
__webpack_require__(957);
__webpack_require__(958);
module.exports = __webpack_require__(15).Symbol;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
// ECMAScript 6 symbols shim
var global         = __webpack_require__(38)
  , has            = __webpack_require__(119)
  , DESCRIPTORS    = __webpack_require__(77)
  , $export        = __webpack_require__(31)
  , redefine       = __webpack_require__(399)
  , META           = __webpack_require__(291).KEY
  , $fails         = __webpack_require__(101)
  , shared         = __webpack_require__(284)
  , setToStringTag = __webpack_require__(159)
  , uid            = __webpack_require__(206)
  , wks            = __webpack_require__(32)
  , wksExt         = __webpack_require__(290)
  , wksDefine      = __webpack_require__(292)
  , keyOf          = __webpack_require__(954)
  , enumKeys       = __webpack_require__(955)
  , isArray        = __webpack_require__(421)
  , anObject       = __webpack_require__(65)
  , toIObject      = __webpack_require__(90)
  , toPrimitive    = __webpack_require__(281)
  , createDesc     = __webpack_require__(157)
  , _create        = __webpack_require__(204)
  , gOPNExt        = __webpack_require__(956)
  , $GOPD          = __webpack_require__(215)
  , $DP            = __webpack_require__(64)
  , $keys          = __webpack_require__(120)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(422).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(160).f  = $propertyIsEnumerable;
  __webpack_require__(289).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(202)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(99)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var getKeys   = __webpack_require__(120)
  , toIObject = __webpack_require__(90);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(120)
  , gOPS    = __webpack_require__(289)
  , pIE     = __webpack_require__(160);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(90)
  , gOPN      = __webpack_require__(422).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};



/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(292)('asyncIterator');


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(292)('observable');


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(960), __esModule: true };


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(961);
module.exports = __webpack_require__(15).Object.setPrototypeOf;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(31);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(962).set});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(100)
  , anObject = __webpack_require__(65);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(98)(Function.call, __webpack_require__(215).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(964), __esModule: true };


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(965);
var $Object = __webpack_require__(15).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var $export = __webpack_require__(31)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(204)});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = configureStore;

var _reduxBatchedActions = __webpack_require__(30);

var _store = __webpack_require__(967);

var _store2 = _interopRequireDefault(_store);

var _constants = __webpack_require__(8);

var _initial_state = __webpack_require__(435);

var _initial_state2 = _interopRequireDefault(_initial_state);

var _reduxPersist = __webpack_require__(1040);

var _localforage = __webpack_require__(1045);

var _localforage2 = _interopRequireDefault(_localforage);

var _reducers = __webpack_require__(441);

var _reducers2 = _interopRequireDefault(_reducers);

var _utils = __webpack_require__(1052);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAppReducer() {
    return __webpack_require__(441); // eslint-disable-line global-require
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var usersSetTransform = ['profilesInChannel', 'profilesNotInChannel', 'profilesInTeam', 'profilesNotInTeam'];

var teamSetTransform = ['membersInTeam'];

var setTransforms = [].concat(usersSetTransform, teamSetTransform);

function configureStore(initialState) {
    var setTransformer = (0, _reduxPersist.createTransform)(function (inboundState, key) {
        if (key === 'entities') {
            var state = (0, _extends3.default)({}, inboundState);
            for (var prop in state) {
                if (state.hasOwnProperty(prop)) {
                    state[prop] = (0, _utils.transformSet)(state[prop], setTransforms);
                }
            }

            return state;
        }

        return inboundState;
    }, function (outboundState, key) {
        if (key === 'entities') {
            var state = (0, _extends3.default)({}, outboundState);
            for (var prop in state) {
                if (state.hasOwnProperty(prop)) {
                    state[prop] = (0, _utils.transformSet)(state[prop], setTransforms, false);
                }
            }

            return state;
        }

        return outboundState;
    });

    var offlineOptions = {
        persist: function persist(store, options) {
            var persistor = (0, _reduxPersist.persistStore)(store, (0, _extends3.default)({ storage: _localforage2.default }, options), function () {
                store.dispatch({
                    type: _constants.General.STORE_REHYDRATION_COMPLETE,
                    complete: true
                });
            });

            var purging = false;

            // check to see if the logout request was successful
            store.subscribe(function () {
                var state = store.getState();
                if (state.requests.users.logout.status === _constants.RequestStatus.SUCCESS && !purging) {
                    purging = true;

                    persistor.purge();

                    document.cookie = 'MMUSERID=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    window.location.href = '/';

                    store.dispatch((0, _reduxBatchedActions.batchActions)([{
                        type: _constants.General.OFFLINE_STORE_RESET,
                        data: (0, _assign2.default)({}, _initial_state2.default, initialState)
                    }]));

                    setTimeout(function () {
                        purging = false;
                    }, 500);
                }
            });

            return persistor;
        },
        persistOptions: {
            autoRehydrate: {
                log: false
            },
            blacklist: ['errors', 'offline', 'requests', 'entities', 'views'],
            debounce: 500,
            transforms: [setTransformer]
        }
    };

    return (0, _store2.default)({}, _reducers2.default, offlineOptions, getAppReducer, { enableBuffer: false });
}

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/* eslint-disable global-require, no-process-env */

if (true) {
    module.exports = __webpack_require__(968);
} else {
    module.exports = require('./configureStore.dev.js');
}

/* eslint-enable global-require, no-process-env */


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureOfflineServiceStore;

var _redux = __webpack_require__(5);

var _reduxBatchedActions = __webpack_require__(30);

var _reduxThunk = __webpack_require__(969);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _constants = __webpack_require__(970);

var _reduxOffline = __webpack_require__(972);

var _defaults = __webpack_require__(431);

var _defaults2 = _interopRequireDefault(_defaults);

var _reduxActionBuffer = __webpack_require__(985);

var _reduxActionBuffer2 = _interopRequireDefault(_reduxActionBuffer);

var _constants2 = __webpack_require__(8);

var _reducers = __webpack_require__(995);

var _reducers2 = _interopRequireDefault(_reducers);

var _initial_state = __webpack_require__(435);

var _initial_state2 = _interopRequireDefault(_initial_state);

var _helpers = __webpack_require__(1039);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***
clientOptions object - This param allows users to configure the store from the client side.
It has two properties currently:
enableBuffer - bool - default = true - If true the store will buffer all actions until offline state rehydration occurs.
additionalMiddleware - func | array - Allows for single or multiple additional middleware functions to be passed in from the client side.
***/
function configureOfflineServiceStore(preloadedState, appReducer, userOfflineConfig, getAppReducer) {
    var clientOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var baseReducer = (0, _redux.combineReducers)(Object.assign({}, _reducers2.default, appReducer));
    var baseState = Object.assign({}, _initial_state2.default, preloadedState);

    var baseOfflineConfig = Object.assign({}, _defaults2.default, _helpers.offlineConfig, userOfflineConfig);
    var options = Object.assign({}, _helpers.defaultOptions, clientOptions);

    var additionalMiddleware = options.additionalMiddleware,
        enableBuffer = options.enableBuffer;


    var clientSideMiddleware = additionalMiddleware;

    if (typeof clientSideMiddleware === 'function') {
        clientSideMiddleware = [clientSideMiddleware];
    }

    var middleware = [_reduxThunk2.default].concat(_toConsumableArray(clientSideMiddleware));
    if (enableBuffer) {
        middleware.push((0, _reduxActionBuffer2.default)(_constants.REHYDRATE));
    }

    // Root reducer wrapper that listens for reset events.
    // Returns whatever is passed for the data property
    // as the new state.
    function offlineReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        if (action.type === _constants2.General.OFFLINE_STORE_RESET) {
            return baseReducer(baseState, action);
        }

        return baseReducer(state, action);
    }

    var store = (0, _redux.createStore)((0, _reduxOffline.createOfflineReducer)((0, _reduxBatchedActions.enableBatching)(offlineReducer)), baseState, (0, _reduxOffline.offlineCompose)(baseOfflineConfig)(middleware, []));

    // launch store persistor
    if (baseOfflineConfig.persist) {
        baseOfflineConfig.persist(store, baseOfflineConfig.persistOptions, baseOfflineConfig.persistCallback);
    }

    if (baseOfflineConfig.detectNetwork) {
        baseOfflineConfig.detectNetwork(function (online) {
            store.dispatch((0, _reduxOffline.networkStatusChangedAction)(online));
        });
    }

    return store;
}


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = __webpack_require__(971)



/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offlineCompose = exports.createOfflineReducer = exports.networkStatusChangedAction = undefined;

var _redux = __webpack_require__(5);

var _reduxPersist = __webpack_require__(423);

var _middleware = __webpack_require__(977);

var _updater = __webpack_require__(978);

var _config = __webpack_require__(979);

var _actions = __webpack_require__(430);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
/*global $Shape*/


/* // @TODO: Take createStore as config?

// eslint-disable-next-line no-unused-vars
let persistor;

export const offline = (userConfig: $Shape<Config> = {}) => (createStore: any) => (
  reducer: any,
  preloadedState: any
) => {
  console.log('user config', userConfig);
  const config = applyDefaults(userConfig);

  console.log('Creating offline store', config);

  // wraps userland reducer with a top-level
  // reducer that handles offline state updating
  const offlineReducer = enhanceReducer(reducer);

  const offlineMiddleware = applyMiddleware(createOfflineMiddleware(config));

  // create autoRehydrate enhancer if required
  const offlineEnhancer = compose(offlineMiddleware);

  // create store
  const store = createStore(offlineReducer, preloadedState, applyMiddleware(createOfflineMiddleware(config)));

  // launch store persistor
  if (config.persist) {
    persistor = config.persist(store, config.persistOptions, config.persistCallback);
  }

  // launch network detector
  if (config.detectNetwork) {
    config.detectNetwork(online => {
      store.dispatch(networkStatusChanged(online));
    });
  }

  return store;
};*/
var networkStatusChangedAction = exports.networkStatusChangedAction = _actions.networkStatusChanged;

var createOfflineReducer = exports.createOfflineReducer = function createOfflineReducer(reducers) {
  return (0, _updater.enhanceReducer)(reducers);
};

var offlineCompose = exports.offlineCompose = function offlineCompose() {
  var userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (middleware, funcs) {
    userConfig.log && console.log('user config', userConfig);
    var config = (0, _config.applyDefaults)(userConfig);

    userConfig.log && console.log('Creating offline store', config);

    var offlineMiddleware = (0, _middleware.createOfflineMiddleware)(config);

    return _redux.compose.apply(undefined, [(0, _reduxPersist.autoRehydrate)(config.persistOptions.autoRehydrate), _redux.applyMiddleware.apply(undefined, [offlineMiddleware].concat(_toConsumableArray(middleware)))].concat(_toConsumableArray(funcs)));
  };
};


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoRehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__ = __webpack_require__(974);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(inboundState[key]) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isStatePlainEnough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(270);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(a)) return false;
  return true;
}


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createTransform);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getStoredState__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistor__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__ = __webpack_require__(426);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistor__["a" /* default */])(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__getStoredState__["a" /* default */])(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return _extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: payload,
    error: error
  };
}


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfflineMiddleware = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(293);

var _actions = __webpack_require__(430);

var after = function after() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
};

var complete = function complete(action, success, payload) {
  if (typeof action === 'function') {
    return function (dispatch, getState) {
      // Must send an action with meta.completed = true to finish commit.
      dispatch({
        type: '@@OFFLINE_ACTION_COMPLETE',
        meta: {
          completed: true
        }
      });
      action(success, payload);
      return after();
    };
  }

  return _extends({}, action, { payload: payload, meta: _extends({}, action.meta || {}, { success: success, completed: true }) });
};

var take = function take(state, config) {
  // batching is optional, for now
  if (config.batch) {
    return config.batch(state.offline.outbox);
  }

  return [state.offline.outbox[0]];
};

var send = function send(action, dispatch, config) {
  var retries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var metadata = action.meta.offline;
  dispatch((0, _actions.busy)(true));
  return config.effect(metadata.effect, action).then(function (result) {
    return dispatch(complete(metadata.commit, true, result));
  }).catch(function (error) {
    // discard
    if (config.discard(error, action, retries)) {
      console.log('Discarding action', action.type);
      return dispatch(complete(metadata.rollback, false, error));
    }
    var delay = config.retry(action, retries);
    if (delay != null) {
      console.log('Retrying action', action.type, 'with delay', delay);
      if (typeof metadata.onRetryScheduled === 'function') {
        metadata.onRetryScheduled();
      }
      return dispatch((0, _actions.scheduleRetry)(delay));
    } else {
      console.log('Discarding action', action.type, 'because retry did not return a delay');
      return dispatch(complete(metadata.rollback, false, error));
    }
  });
};

var createOfflineMiddleware = exports.createOfflineMiddleware = function createOfflineMiddleware(config) {
  return function (store) {
    return function (next) {
      return function (action) {
        // allow other middleware to do their things
        var result = next(action);

        // find any actions to send, if any
        var state = store.getState();
        var actions = take(state, config);

        // if the are any actions in the queue that we are not
        // yet processing, send those actions
        if (actions.length > 0 && !state.offline.busy && !state.offline.retryScheduled && state.offline.online) {
          send(actions[0], store.dispatch, config, state.offline.retryCount);
        }

        if (action.type === _constants.OFFLINE_SCHEDULE_RETRY) {
          var retryToken = state.offline.retryToken;
          after(action.payload.delay).then(function () {
            return store.dispatch((0, _actions.completeRetry)(retryToken));
          });
        }

        // if (action.type === 'Offline/COMPLETE_RETRY') {
        //   if (action.meta.retryToken === state.offline.retryToken && actions.length > 0) {
        //     send(actions[0], store.dispatch, config);
        //   }
        // }

        if (action.type === _constants.OFFLINE_SEND && actions.length > 0 && !state.offline.busy) {
          send(actions[0], store.dispatch, config, state.offline.retryCount);
        }

        // sometimes actions need to be rolled back if we are offline. This can be accomplished
        // by setting offlineRollback to true in the meta.offline property of the action.
        if (actions.length > 0 && !state.offline.online && actions[0].meta.offline.offlineRollback) {
          var _action = actions[0];
          store.dispatch(complete(_action.meta.offline.rollback, false, {}));
        }

        return result;
      };
    };
  };
};


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhanceReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(293);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* global */

var enqueue = function enqueue(state, action) {
  var transaction = state.lastTransaction + 1;
  var stamped = _extends({}, action, { meta: _extends({}, action.meta, { transaction: transaction }) });
  var outbox = state.outbox;
  if (action.meta.offline.cancel) {
    outbox = outbox.filter(function (a) {
      return a.type !== action.type;
    });
  }
  return _extends({}, state, {
    lastTransaction: transaction,
    outbox: [].concat(_toConsumableArray(outbox), [stamped])
  });
};

var dequeue = function dequeue(state) {
  var _state$outbox = _toArray(state.outbox),
      rest = _state$outbox.slice(1);

  return _extends({}, state, { outbox: rest, retryCount: 0, busy: false });
};

var initialState = {
  busy: false,
  lastTransaction: 0,
  online: false,
  outbox: [],
  receipts: [],
  retryToken: 0,
  retryCount: 0,
  retryScheduled: false
};

// @TODO: the typing of this is all kinds of wack

var offlineUpdater = function offlineUpdater() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  // Update online/offline status
  if (action.type === _constants.OFFLINE_STATUS_CHANGED && action.payload && typeof action.payload.online === 'boolean') {
    return _extends({}, state, { online: action.payload.online });
  }

  if (action.type === _constants.PERSIST_REHYDRATE) {
    return _extends({}, state, { busy: false });
  }

  if (action.type === _constants.OFFLINE_SCHEDULE_RETRY) {
    return _extends({}, state, {
      busy: false,
      retryScheduled: true,
      retryCount: state.retryCount + 1,
      retryToken: state.retryToken + 1
    });
  }

  if (action.type === _constants.OFFLINE_COMPLETE_RETRY) {
    return _extends({}, state, { retryScheduled: false });
  }

  if (action.type === _constants.OFFLINE_BUSY && action.payload && typeof action.payload.busy === 'boolean') {
    return _extends({}, state, { busy: action.payload.busy });
  }

  // Add offline actions to queue
  if (action.meta && action.meta.offline) {
    return enqueue(state, action);
  }

  // Remove completed actions from queue (success or fail)
  if (action.meta != null && action.meta.completed === true) {
    return dequeue(state);
  }

  return state;
};

var enhanceReducer = function enhanceReducer(reducer) {
  return function (state, action) {
    var offlineState = void 0;
    var restState = void 0;
    if (typeof state !== 'undefined') {
      var offline = state.offline,
          rest = _objectWithoutProperties(state, ['offline']);

      offlineState = offline;
      restState = rest;
    }

    return _extends({}, reducer(restState, action), {
      offline: offlineUpdater(offlineState, action)
    });
  };
};
exports.enhanceReducer = enhanceReducer;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyDefaults = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaults = __webpack_require__(431);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*global $Shape*/
var applyDefaults = exports.applyDefaults = function applyDefaults() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, _defaults2.default, config);
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxPersist = __webpack_require__(423);

exports.default = _reduxPersist.persistStore; // flow


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*global window*/

var handle = function handle(callback, result) {
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(function () {
      return callback(result);
    });
  } else {
    setTimeout(function () {
      return callback(result);
    }, 0);
  }
};

exports.default = function (callback) {
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('online', function () {
      return handle(callback, true);
    });
    window.addEventListener('offline', function () {
      return handle(callback, false);
    });
    handle(callback, window.navigator.onLine);
  }
};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (outbox) {
  if (outbox.length > 0) {
    return [outbox[0]];
  }
  return [];
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var decaySchedule = [1000, //After 1 seconds
1000 * 5, //After 5 seconds
1000 * 15, //After 15 seconds
1000 * 30, //After 30 seconds
1000 * 60, //After 1 minute
1000 * 60 * 3, //After 3 minutes
1000 * 60 * 5, //After 5 minutes
1000 * 60 * 10, //After 10 minutes
1000 * 60 * 30, //After 30 minutes
1000 * 60 * 60 //After 1 hour
];

exports.default = function (action, retries) {
  return decaySchedule[retries] || null;
};


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effect = __webpack_require__(432);

exports.default = function (error, action) {
  var _retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // not a network error -> discard
  if (!('status' in error)) {
    return true;
  }

  //discard http 4xx errors
  //$FlowFixMe
  return error.status >= 400 && error.status < 500;
};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var BUFFERED_ACTION_RETURN = 'redux-action-buffer: buffered action'

module.exports = function bufferActions (breaker, cb) {
  var active = true
  var queue = []
  if (typeof breaker === 'string') {
    var actionType = breaker
    breaker = function (action) {
      if (action.type === actionType) return true
      else return false
    }
  }

  return function (store) {
    return function (next) {
      return function (action) {
        // console.log('next', next, action)
        if (!active) return next(action)
        if (breaker(action)) {
          active = false
          var result = next(action)
          var queueResults = []
          queue.forEach(function (queuedAction) {
            var queuedActionResult = next(queuedAction)
            queueResults.push(queuedActionResult)
          })
          cb && cb(null, {
            results: queueResults,
            queue: queue
          })
          return result
        } else {
          queue.push(action)
          // @TODO consider returning a dummy action, or maybe null for cleanliness
          return BUFFERED_ACTION_RETURN
        }
      }
    }
  }
}



/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    CONFIG_CHANGED: 'config_changed',

    PAGE_SIZE_DEFAULT: 60,
    PAGE_SIZE_MAXIMUM: 200,
    AUDITS_CHUNK_SIZE: 100,
    PROFILE_CHUNK_SIZE: 100,
    CHANNELS_CHUNK_SIZE: 50,
    TEAMS_CHUNK_SIZE: 50,
    JOBS_CHUNK_SIZE: 50,
    SEARCH_TIMEOUT_MILLISECONDS: 100,
    STATUS_INTERVAL: 60000,

    MENTION: 'mention',

    OFFLINE: 'offline',
    AWAY: 'away',
    ONLINE: 'online',

    PERMISSIONS_ALL: 'all',
    PERMISSIONS_CHANNEL_ADMIN: 'channel_admin',
    PERMISSIONS_TEAM_ADMIN: 'team_admin',
    PERMISSIONS_SYSTEM_ADMIN: 'system_admin',

    TEAM_USER_ROLE: 'team_user',
    TEAM_ADMIN_ROLE: 'team_admin',

    CHANNEL_USER_ROLE: 'channel_user',
    CHANNEL_ADMIN_ROLE: 'channel_admin',

    SYSTEM_USER_ROLE: 'system_user',
    SYSTEM_ADMIN_ROLE: 'system_admin',
    SYSTEM_USER_ACCESS_TOKEN_ROLE: 'system_user_access_token',
    SYSTEM_POST_ALL_ROLE: 'system_post_all',
    SYSTEM_POST_ALL_PUBLIC_ROLE: 'system_post_all_public',

    ALLOW_EDIT_POST_ALWAYS: 'always',
    ALLOW_EDIT_POST_NEVER: 'never',
    ALLOW_EDIT_POST_TIME_LIMIT: 'time_limit',
    DEFAULT_POST_EDIT_TIME_LIMIT: 300,

    RESTRICT_DIRECT_MESSAGE_ANY: 'any',
    RESTRICT_DIRECT_MESSAGE_TEAM: 'team',

    DEFAULT_CHANNEL: 'town-square',
    DM_CHANNEL: 'D',
    OPEN_CHANNEL: 'O',
    PRIVATE_CHANNEL: 'P',
    GM_CHANNEL: 'G',

    START_OF_NEW_MESSAGES: 'start-of-new-messages',

    PUSH_NOTIFY_APPLE_REACT_NATIVE: 'apple_rn',
    PUSH_NOTIFY_ANDROID_REACT_NATIVE: 'android_rn',

    STORE_REHYDRATION_COMPLETE: 'store_hydation_complete',
    OFFLINE_STORE_RESET: 'offline_store_reset',
    OFFLINE_STORE_PURGE: 'offline_store_purge',

    TEAMMATE_NAME_DISPLAY: {
        SHOW_USERNAME: 'username',
        SHOW_NICKNAME_FULLNAME: 'nickname_full_name',
        SHOW_FULLNAME: 'full_name'
    },

    SPECIAL_MENTIONS: ['all', 'channel', 'here'],

    MAX_USERS_IN_GM: 8,
    MIN_USERS_IN_GM: 3
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    NOT_STARTED: 'not_started',
    STARTED: 'started',
    SUCCESS: 'success',
    FAILURE: 'failure',
    CANCELLED: 'cancelled'
};


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var WebsocketEvents = {
    POSTED: 'posted',
    POST_EDITED: 'post_edited',
    POST_DELETED: 'post_deleted',
    CHANNEL_CREATED: 'channel_created',
    CHANNEL_DELETED: 'channel_deleted',
    DIRECT_ADDED: 'direct_added',
    ADDED_TO_TEAM: 'added_to_team',
    LEAVE_TEAM: 'leave_team',
    UPDATE_TEAM: 'update_team',
    USER_ADDED: 'user_added',
    USER_REMOVED: 'user_removed',
    USER_UPDATED: 'user_updated',
    TYPING: 'typing',
    STOP_TYPING: 'stop_typing',
    PREFERENCE_CHANGED: 'preference_changed',
    PREFERENCES_CHANGED: 'preferences_changed',
    PREFERENCES_DELETED: 'preferences_deleted',
    EPHEMERAL_MESSAGE: 'ephemeral_message',
    STATUS_CHANGED: 'status_change',
    HELLO: 'hello',
    WEBRTC: 'webrtc',
    REACTION_ADDED: 'reaction_added',
    REACTION_REMOVED: 'reaction_removed',
    EMOJI_ADDED: 'emoji_added'
};

exports.default = WebsocketEvents;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    CATEGORY_DIRECT_CHANNEL_SHOW: 'direct_channel_show',
    CATEGORY_GROUP_CHANNEL_SHOW: 'group_channel_show',
    CATEGORY_FLAGGED_POST: 'flagged_post',
    CATEGORY_NOTIFICATIONS: 'notifications',
    CATEGORY_DISPLAY_SETTINGS: 'display_settings',
    CATEGORY_FAVORITE_CHANNEL: 'favorite_channel',
    CATEGORY_ADVANCED_SETTINGS: 'advanced_settings',
    CATEGORY_AUTO_RESET_MANUAL_STATUS: 'auto_reset_manual_status',
    CATEGORY_THEME: 'theme',
    NAME_NAME_FORMAT: 'name_format',
    DISPLAY_PREFER_NICKNAME: 'nickname_full_name',
    DISPLAY_PREFER_FULL_NAME: 'full_name',
    EMAIL_INTERVAL: 'email_interval',
    INTERVAL_FIFTEEN_MINUTES: 15 * 60,
    INTERVAL_HOUR: 60 * 60,
    INTERVAL_IMMEDIATE: 30 // "immediate" is a 30 second interval
};


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PostTypes = {
    ADD_REMOVE: 'system_add_remove',
    ADD_TO_CHANNEL: 'system_add_to_channel',
    CHANNEL_DELETED: 'system_channel_deleted',
    DISPLAYNAME_CHANGE: 'system_displayname_change',
    EPHEMERAL: 'system_ephemeral',
    HEADER_CHANGE: 'system_header_change',
    JOIN_CHANNEL: 'system_join_channel',
    JOIN_LEAVE: 'system_join_leave',
    LEAVE_CHANNEL: 'system_leave_channel',
    PURPOSE_CHANGE: 'system_purpose_change',
    REMOVE_FROM_CHANNEL: 'system_remove_from_channel'
};

exports.default = {
    POST_CHUNK_SIZE: 60,
    POST_DELETED: 'DELETED',
    SYSTEM_MESSAGE_PREFIX: 'system_',
    POST_TYPES: PostTypes,
    POST_COLLAPSE_TIMEOUT: 1000 * 60 * 5, // five minutes
    IGNORE_POST_TYPES: [PostTypes.ADD_REMOVE, PostTypes.ADD_TO_CHANNEL, PostTypes.CHANNEL_DELETED, PostTypes.JOIN_LEAVE, PostTypes.JOIN_CHANNEL, PostTypes.LEAVE_CHANNEL, PostTypes.REMOVE_FROM_CHANNEL]
};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    AUDIO_TYPES: ['mp3', 'wav', 'wma', 'm4a', 'flac', 'aac', 'ogg'],
    CODE_TYPES: ['as', 'applescript', 'osascript', 'scpt', 'bash', 'sh', 'zsh', 'clj', 'boot', 'cl2', 'cljc', 'cljs', 'cljs.hl', 'cljscm', 'cljx', 'hic', 'coffee', '_coffee', 'cake', 'cjsx', 'cson', 'iced', 'cpp', 'c', 'cc', 'h', 'c++', 'h++', 'hpp', 'cs', 'csharp', 'css', 'd', 'di', 'dart', 'delphi', 'dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm', 'diff', 'django', 'jinja', 'dockerfile', 'docker', 'erl', 'f90', 'f95', 'fsharp', 'fs', 'gcode', 'nc', 'go', 'groovy', 'handlebars', 'hbs', 'html.hbs', 'html.handlebars', 'hs', 'hx', 'java', 'jsp', 'js', 'jsx', 'json', 'jl', 'kt', 'ktm', 'kts', 'less', 'lisp', 'lua', 'mk', 'mak', 'md', 'mkdown', 'mkd', 'matlab', 'm', 'mm', 'objc', 'obj-c', 'ml', 'perl', 'pl', 'php', 'php3', 'php4', 'php5', 'php6', 'ps', 'ps1', 'pp', 'py', 'gyp', 'r', 'ruby', 'rb', 'gemspec', 'podspec', 'thor', 'irb', 'rs', 'scala', 'scm', 'sld', 'scss', 'st', 'sql', 'swift', 'tex', 'txt', 'vbnet', 'vb', 'bas', 'vbs', 'v', 'veo', 'xml', 'html', 'xhtml', 'rss', 'atom', 'xsl', 'plist', 'yaml'],
    IMAGE_TYPES: ['jpg', 'gif', 'bmp', 'png', 'jpeg'],
    PATCH_TYPES: ['patch'],
    PDF_TYPES: ['pdf'],
    PRESENTATION_TYPES: ['ppt', 'pptx'],
    SPREADSHEET_TYPES: ['xlsx', 'csv'],
    VIDEO_TYPES: ['mp4', 'avi', 'webm', 'mkv', 'wmv', 'mpg', 'mov', 'flv'],
    WORD_TYPES: ['doc', 'docx']
};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    ALERT_NOTIFICATION: 'notification',
    ALERT_DEVELOPER: 'developer',
    ALERT_ERROR: 'error'
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    TEAM_TYPE_OPEN: 'O',
    TEAM_TYPE_INVITE: 'I'
};


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    TOTAL_USERS: null,
    TOTAL_PUBLIC_CHANNELS: null,
    TOTAL_PRIVATE_GROUPS: null,
    TOTAL_POSTS: null,
    TOTAL_TEAMS: null,
    TOTAL_FILE_POSTS: null,
    TOTAL_HASHTAG_POSTS: null,
    TOTAL_IHOOKS: null,
    TOTAL_OHOOKS: null,
    TOTAL_COMMANDS: null,
    TOTAL_SESSIONS: null,
    POST_PER_DAY: null,
    USERS_WITH_POSTS_PER_DAY: null,
    RECENTLY_ACTIVE_USERS: null,
    NEWLY_CREATED_USERS: null,
    TOTAL_WEBSOCKET_CONNECTIONS: null,
    TOTAL_MASTER_DB_CONNECTIONS: null,
    TOTAL_READ_DB_CONNECTIONS: null,
    DAILY_ACTIVE_USERS: null,
    MONTHLY_ACTIVE_USERS: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _entities = __webpack_require__(433);

var _entities2 = _interopRequireDefault(_entities);

var _errors = __webpack_require__(1025);

var _errors2 = _interopRequireDefault(_errors);

var _requests = __webpack_require__(1026);

var _requests2 = _interopRequireDefault(_requests);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    entities: _entities2.default,
    errors: _errors2.default,
    requests: _requests2.default
}; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function channelListToSet(state, action) {
    var nextState = _extends({}, state);
    action.data.forEach(function (channel) {
        var nextSet = new Set(nextState[channel.team_id]);
        nextSet.add(channel.id);
        nextState[channel.team_id] = nextSet;
    });

    return nextState;
}

function removeChannelFromSet(state, action) {
    var id = action.data.team_id;
    var nextSet = new Set(state[id]);
    nextSet.delete(action.data.id);
    return _extends({}, state, _defineProperty({}, id, nextSet));
}

function currentChannelId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ChannelTypes.SELECT_CHANNEL:
            return action.data;
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function channels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.ChannelTypes.RECEIVED_CHANNEL:
            return _extends({}, state, _defineProperty({}, action.data.id, action.data));

        case _action_types.ChannelTypes.RECEIVED_CHANNELS:
            {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var channel = _step.value;

                        nextState[channel.id] = channel;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED:
            Reflect.deleteProperty(nextState, action.data.id);
            return nextState;
        case _action_types.ChannelTypes.RECEIVED_LAST_VIEWED:
            {
                var channelId = action.data.channel_id;
                var lastUpdatedAt = action.data.last_viewed_at;
                var _channel = state[channelId];
                if (!_channel) {
                    return state;
                }
                return _extends({}, state, _defineProperty({}, channelId, _extends({}, _channel, {
                    extra_update_at: lastUpdatedAt
                })));
            }
        case _action_types.ChannelTypes.UPDATE_CHANNEL_HEADER:
            {
                var _action$data = action.data,
                    _channelId = _action$data.channelId,
                    header = _action$data.header;

                return _extends({}, state, _defineProperty({}, _channelId, _extends({}, state[_channelId], {
                    header: header
                })));
            }
        case _action_types.ChannelTypes.UPDATE_CHANNEL_PURPOSE:
            {
                var _action$data2 = action.data,
                    _channelId2 = _action$data2.channelId,
                    purpose = _action$data2.purpose;

                return _extends({}, state, _defineProperty({}, _channelId2, _extends({}, state[_channelId2], {
                    purpose: purpose
                })));
            }
        case _action_types.ChannelTypes.LEAVE_CHANNEL:
            {
                if (action.data && action.data.type === _constants.General.PRIVATE_CHANNEL) {
                    Reflect.deleteProperty(nextState, action.data.id);
                    return nextState;
                }
                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function channelsInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ChannelTypes.RECEIVED_CHANNEL:
            {
                var nextSet = new Set(state[action.data.team_id]);
                nextSet.add(action.data.id);
                return _extends({}, state, _defineProperty({}, action.data.team_id, nextSet));
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNELS:
            {
                return channelListToSet(state, action);
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED:
            return removeChannelFromSet(state, action);
        case _action_types.ChannelTypes.LEAVE_CHANNEL:
            {
                if (action.data && action.data.type === _constants.General.PRIVATE_CHANNEL) {
                    return removeChannelFromSet(state, action);
                }
                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function myMembers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER:
            {
                var channelMember = action.data;
                return _extends({}, state, _defineProperty({}, channelMember.channel_id, channelMember));
            }
        case _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS:
            {
                var remove = action.remove;
                if (remove) {
                    remove.forEach(function (id) {
                        Reflect.deleteProperty(nextState, id);
                    });
                }

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = action.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var cm = _step2.value;

                        nextState[cm.channel_id] = cm;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_PROPS:
            {
                var member = _extends({}, state[action.data.channel_id]);
                member.notify_props = action.data.notifyProps;

                return _extends({}, state, _defineProperty({}, action.data.channel_id, member));
            }
        case _action_types.ChannelTypes.RECEIVED_LAST_VIEWED:
            {
                var _member = state[action.data.channel_id];
                if (!_member) {
                    return state;
                }
                _member = _extends({}, _member, {
                    last_viewed_at: action.data.last_viewed_at,
                    msg_count: action.data.total_msg_count,
                    mention_count: 0
                });

                return _extends({}, state, _defineProperty({}, action.data.channel_id, _member));
            }
        case _action_types.ChannelTypes.LEAVE_CHANNEL:
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED:
            if (action.data) {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }

            return state;

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function membersInChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER:
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER:
            {
                var member = action.data;
                var members = _extends({}, state[member.channel_id] || {});
                members[member.user_id] = member;
                return _extends({}, state, _defineProperty({}, member.channel_id, members));
            }
        case _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS:
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS:
            {
                var nextState = _extends({}, state);
                var remove = action.remove;
                var currentUserId = action.currentUserId;
                if (remove && currentUserId) {
                    remove.forEach(function (id) {
                        if (nextState[id]) {
                            Reflect.deleteProperty(nextState[id], currentUserId);
                        }
                    });
                }

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = action.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var cm = _step3.value;

                        if (nextState[cm.channel_id]) {
                            nextState[cm.channel_id] = _extends({}, nextState[cm.channel_id]);
                        } else {
                            nextState[cm.channel_id] = {};
                        }
                        nextState[cm.channel_id][cm.user_id] = cm;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.ChannelTypes.LEAVE_CHANNEL:
        case _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL:
            {
                if (action.data) {
                    var data = action.data;
                    var _members = _extends({}, state[data.id] || {});
                    if (_members) {
                        Reflect.deleteProperty(_members, data.user_id);
                        return _extends({}, state, _defineProperty({}, data.id, _members));
                    }
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function stats() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);
    switch (action.type) {
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS:
            {
                var stat = action.data;
                nextState[stat.channel_id] = stat;

                return nextState;
            }
        case _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS:
            {
                var id = action.id;
                var nextStat = nextState[id];
                if (nextStat) {
                    var count = nextStat.member_count + 1;
                    return _extends({}, nextState, _defineProperty({}, id, _extends({}, nextStat, {
                        member_count: count
                    })));
                }

                return state;
            }
        case _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_SUCCESS:
            {
                var _id = action.id;
                var _nextStat = nextState[_id];
                if (_nextStat) {
                    var _count = _nextStat.member_count - 1;
                    return _extends({}, nextState, _defineProperty({}, _id, _extends({}, _nextStat, {
                        member_count: _count || 1
                    })));
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // the current selected channel
    currentChannelId: currentChannelId,

    // object where every key is the channel id and has and object with the channel detail
    channels: channels,

    // object where every key is a team id and has set of channel ids that are on the team
    channelsInTeam: channelsInTeam,

    // object where every key is the channel id and has an object with the channel members detail
    myMembers: myMembers,

    // object where every key is the channel id with an object where key is a user id and has an object with the channel members detail
    membersInChannel: membersInChannel,

    // object where every key is the channel id and has an object with the channel stats
    stats: stats
});


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    CHANNEL_REQUEST: null,
    CHANNEL_SUCCESS: null,
    CHANNEL_FAILURE: null,

    CHANNELS_REQUEST: null,
    CHANNELS_SUCCESS: null,
    CHANNELS_FAILURE: null,

    CHANNEL_MEMBERS_REQUEST: null,
    CHANNEL_MEMBERS_SUCCESS: null,
    CHANNEL_MEMBERS_FAILURE: null,

    CHANNEL_MY_MEMBERS_REQUEST: null,
    CHANNEL_MY_MEMBERS_SUCCESS: null,
    CHANNEL_MY_MEMBERS_FAILURE: null,

    CREATE_CHANNEL_REQUEST: null,
    CREATE_CHANNEL_SUCCESS: null,
    CREATE_CHANNEL_FAILURE: null,

    UPDATE_CHANNEL_REQUEST: null,
    UPDATE_CHANNEL_SUCCESS: null,
    UPDATE_CHANNEL_FAILURE: null,

    NOTIFY_PROPS_REQUEST: null,
    NOTIFY_PROPS_SUCCESS: null,
    NOTIFY_PROPS_FAILURE: null,

    JOIN_CHANNEL_REQUEST: null,
    JOIN_CHANNEL_SUCCESS: null,
    JOIN_CHANNEL_FAILURE: null,

    DELETE_CHANNEL_REQUEST: null,
    DELETE_CHANNEL_SUCCESS: null,
    DELETE_CHANNEL_FAILURE: null,

    UPDATE_LAST_VIEWED_REQUEST: null,
    UPDATE_LAST_VIEWED_SUCCESS: null,
    UPDATE_LAST_VIEWED_FAILURE: null,

    GET_CHANNELS_REQUEST: null,
    GET_CHANNELS_SUCCESS: null,
    GET_CHANNELS_FAILURE: null,

    CHANNEL_STATS_REQUEST: null,
    CHANNEL_STATS_SUCCESS: null,
    CHANNEL_STATS_FAILURE: null,

    ADD_CHANNEL_MEMBER_REQUEST: null,
    ADD_CHANNEL_MEMBER_SUCCESS: null,
    ADD_CHANNEL_MEMBER_FAILURE: null,

    REMOVE_CHANNEL_MEMBER_REQUEST: null,
    REMOVE_CHANNEL_MEMBER_SUCCESS: null,
    REMOVE_CHANNEL_MEMBER_FAILURE: null,

    UPDATE_CHANNEL_MEMBER_REQUEST: null,
    UPDATE_CHANNEL_MEMBER_SUCCESS: null,
    UPDATE_CHANNEL_MEMBER_FAILURE: null,

    SELECT_CHANNEL: null,
    LEAVE_CHANNEL: null,
    RECEIVED_CHANNEL: null,
    RECEIVED_CHANNELS: null,
    RECEIVED_CHANNELS_LIST: null,
    RECEIVED_MY_CHANNEL_MEMBERS: null,
    RECEIVED_MY_CHANNEL_MEMBER: null,
    RECEIVED_CHANNEL_MEMBERS: null,
    RECEIVED_CHANNEL_MEMBER: null,
    RECEIVED_CHANNEL_STATS: null,
    RECEIVED_CHANNEL_PROPS: null,
    RECEIVED_CHANNEL_DELETED: null,
    RECEIVED_LAST_VIEWED: null,
    UPDATE_CHANNEL_HEADER: null,
    UPDATE_CHANNEL_PURPOSE: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    DISMISS_ERROR: null,
    LOG_ERROR: null,
    CLEAR_ERRORS: null,
    RESTORE_ERRORS: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    RECEIVED_APP_STATE: null,
    RECEIVED_APP_CREDENTIALS: null,
    REMOVED_APP_CREDENTIALS: null,
    RECEIVED_APP_DEVICE_TOKEN: null,

    PING_REQUEST: null,
    PING_SUCCESS: null,
    PING_FAILURE: null,
    PING_RESET: null,

    RECEIVED_SERVER_VERSION: null,

    CLIENT_CONFIG_REQUEST: null,
    CLIENT_CONFIG_SUCCESS: null,
    CLIENT_CONFIG_FAILURE: null,
    CLIENT_CONFIG_RECEIVED: null,

    CLIENT_LICENSE_REQUEST: null,
    CLIENT_LICENSE_SUCCESS: null,
    CLIENT_LICENSE_FAILURE: null,
    CLIENT_LICENSE_RECEIVED: null,

    LOG_CLIENT_ERROR_REQUEST: null,
    LOG_CLIENT_ERROR_SUCCESS: null,
    LOG_CLIENT_ERROR_FAILURE: null,

    WEBSOCKET_REQUEST: null,
    WEBSOCKET_SUCCESS: null,
    WEBSOCKET_FAILURE: null,
    WEBSOCKET_CLOSED: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    CREATE_USER_REQUEST: null,
    CREATE_USER_SUCCESS: null,
    CREATE_USER_FAILURE: null,

    LOGIN_REQUEST: null,
    LOGIN_SUCCESS: null,
    LOGIN_FAILURE: null,

    LOGOUT_REQUEST: null,
    LOGOUT_SUCCESS: null,
    LOGOUT_FAILURE: null,

    PROFILES_REQUEST: null,
    PROFILES_SUCCESS: null,
    PROFILES_FAILURE: null,

    PROFILES_IN_TEAM_REQUEST: null,
    PROFILES_IN_TEAM_SUCCESS: null,
    PROFILES_IN_TEAM_FAILURE: null,

    PROFILES_NOT_IN_TEAM_REQUEST: null,
    PROFILES_NOT_IN_TEAM_SUCCESS: null,
    PROFILES_NOT_IN_TEAM_FAILURE: null,

    PROFILES_WITHOUT_TEAM_REQUEST: null,
    PROFILES_WITHOUT_TEAM_SUCCESS: null,
    PROFILES_WITHOUT_TEAM_FAILURE: null,

    PROFILES_IN_CHANNEL_REQUEST: null,
    PROFILES_IN_CHANNEL_SUCCESS: null,
    PROFILES_IN_CHANNEL_FAILURE: null,

    PROFILES_NOT_IN_CHANNEL_REQUEST: null,
    PROFILES_NOT_IN_CHANNEL_SUCCESS: null,
    PROFILES_NOT_IN_CHANNEL_FAILURE: null,

    USER_REQUEST: null,
    USER_SUCCESS: null,
    USER_FAILURE: null,

    USER_BY_USERNAME_REQUEST: null,
    USER_BY_USERNAME_SUCCESS: null,
    USER_BY_USERNAME_FAILURE: null,

    PROFILES_STATUSES_REQUEST: null,
    PROFILES_STATUSES_SUCCESS: null,
    PROFILES_STATUSES_FAILURE: null,

    PROFILE_STATUS_REQUEST: null,
    PROFILE_STATUS_SUCCESS: null,
    PROFILE_STATUS_FAILURE: null,

    SET_STATUS_REQUEST: null,
    SET_STATUS_SUCCESS: null,
    SET_STATUS_FAILURE: null,

    SESSIONS_REQUEST: null,
    SESSIONS_SUCCESS: null,
    SESSIONS_FAILURE: null,

    REVOKE_SESSION_REQUEST: null,
    REVOKE_SESSION_SUCCESS: null,
    REVOKE_SESSION_FAILURE: null,

    AUDITS_REQUEST: null,
    AUDITS_SUCCESS: null,
    AUDITS_FAILURE: null,

    CHECK_MFA_REQUEST: null,
    CHECK_MFA_SUCCESS: null,
    CHECK_MFA_FAILURE: null,

    AUTOCOMPLETE_USERS_REQUEST: null,
    AUTOCOMPLETE_USERS_SUCCESS: null,
    AUTOCOMPLETE_USERS_FAILURE: null,

    SEARCH_PROFILES_REQUEST: null,
    SEARCH_PROFILES_SUCCESS: null,
    SEARCH_PROFILES_FAILURE: null,

    UPDATE_ME_REQUEST: null,
    UPDATE_ME_SUCCESS: null,
    UPDATE_ME_FAILURE: null,

    UPDATE_USER_REQUEST: null,
    UPDATE_USER_SUCCESS: null,
    UPDATE_USER_FAILURE: null,

    MFA_SECRET_REQUEST: null,
    MFA_SECRET_SUCCESS: null,
    MFA_SECRET_FAILURE: null,

    VERIFY_EMAIL_REQUEST: null,
    VERIFY_EMAIL_SUCCESS: null,
    VERIFY_EMAIL_FAILURE: null,

    PASSWORD_RESET_REQUEST: null,
    PASSWORD_RESET_SUCCESS: null,
    PASSWORD_RESET_FAILURE: null,

    SWITCH_LOGIN_REQUEST: null,
    SWITCH_LOGIN_SUCCESS: null,
    SWITCH_LOGIN_FAILURE: null,

    CREATE_USER_ACCESS_TOKEN_REQUEST: null,
    CREATE_USER_ACCESS_TOKEN_SUCCESS: null,
    CREATE_USER_ACCESS_TOKEN_FAILURE: null,

    GET_USER_ACCESS_TOKEN_REQUEST: null,
    GET_USER_ACCESS_TOKEN_SUCCESS: null,
    GET_USER_ACCESS_TOKEN_FAILURE: null,

    REVOKE_USER_ACCESS_TOKEN_REQUEST: null,
    REVOKE_USER_ACCESS_TOKEN_SUCCESS: null,
    REVOKE_USER_ACCESS_TOKEN_FAILURE: null,

    RECEIVED_ME: null,
    RECEIVED_PROFILE: null,
    RECEIVED_PROFILES: null,
    RECEIVED_PROFILES_LIST: null,
    RECEIVED_PROFILES_IN_TEAM: null,
    RECEIVED_PROFILE_IN_TEAM: null,
    RECEIVED_PROFILES_LIST_IN_TEAM: null,
    RECEIVED_PROFILE_NOT_IN_TEAM: null,
    RECEIVED_PROFILES_LIST_NOT_IN_TEAM: null,
    RECEIVED_PROFILE_WITHOUT_TEAM: null,
    RECEIVED_PROFILES_LIST_WITHOUT_TEAM: null,
    RECEIVED_PROFILES_IN_CHANNEL: null,
    RECEIVED_PROFILES_LIST_IN_CHANNEL: null,
    RECEIVED_PROFILE_IN_CHANNEL: null,
    RECEIVED_PROFILES_NOT_IN_CHANNEL: null,
    RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL: null,
    RECEIVED_PROFILE_NOT_IN_CHANNEL: null,
    RECEIVED_SESSIONS: null,
    RECEIVED_REVOKED_SESSION: null,
    RECEIVED_AUDITS: null,
    RECEIVED_STATUS: null,
    RECEIVED_STATUSES: null,
    RECEIVED_AUTOCOMPLETE_IN_CHANNEL: null,
    RESET_LOGOUT_STATE: null,
    RECEIVED_MY_USER_ACCESS_TOKEN: null,
    RECEIVED_MY_USER_ACCESS_TOKENS: null,
    CLEAR_MY_USER_ACCESS_TOKENS: null,
    REVOKED_USER_ACCESS_TOKEN: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    GET_TEAMS_REQUEST: null,
    GET_TEAMS_SUCCESS: null,
    GET_TEAMS_FAILURE: null,

    GET_TEAM_REQUEST: null,
    GET_TEAM_SUCCESS: null,
    GET_TEAM_FAILURE: null,

    MY_TEAMS_REQUEST: null,
    MY_TEAMS_SUCCESS: null,
    MY_TEAMS_FAILURE: null,

    CREATE_TEAM_REQUEST: null,
    CREATE_TEAM_SUCCESS: null,
    CREATE_TEAM_FAILURE: null,

    UPDATE_TEAM_REQUEST: null,
    UPDATE_TEAM_SUCCESS: null,
    UPDATE_TEAM_FAILURE: null,

    MY_TEAM_MEMBERS_REQUEST: null,
    MY_TEAM_MEMBERS_SUCCESS: null,
    MY_TEAM_MEMBERS_FAILURE: null,

    GET_TEAM_MEMBERS_REQUEST: null,
    GET_TEAM_MEMBERS_SUCCESS: null,
    GET_TEAM_MEMBERS_FAILURE: null,

    MY_TEAM_UNREADS_REQUEST: null,
    MY_TEAM_UNREADS_SUCCESS: null,
    MY_TEAM_UNREADS_FAILURE: null,

    TEAM_MEMBERS_REQUEST: null,
    TEAM_MEMBERS_SUCCESS: null,
    TEAM_MEMBERS_FAILURE: null,

    TEAM_STATS_REQUEST: null,
    TEAM_STATS_SUCCESS: null,
    TEAM_STATS_FAILURE: null,

    ADD_TEAM_MEMBER_REQUEST: null,
    ADD_TEAM_MEMBER_SUCCESS: null,
    ADD_TEAM_MEMBER_FAILURE: null,

    REMOVE_TEAM_MEMBER_REQUEST: null,
    REMOVE_TEAM_MEMBER_SUCCESS: null,
    REMOVE_TEAM_MEMBER_FAILURE: null,

    UPDATE_TEAM_MEMBER_REQUEST: null,
    UPDATE_TEAM_MEMBER_SUCCESS: null,
    UPDATE_TEAM_MEMBER_FAILURE: null,

    TEAM_EMAIL_INVITE_REQUEST: null,
    TEAM_EMAIL_INVITE_SUCCESS: null,
    TEAM_EMAIL_INVITE_FAILURE: null,

    JOIN_TEAM_REQUEST: null,
    JOIN_TEAM_SUCCESS: null,
    JOIN_TEAM_FAILURE: null,

    CREATED_TEAM: null,
    SELECT_TEAM: null,
    UPDATED_TEAM: null,
    RECEIVED_TEAM: null,
    RECEIVED_TEAMS: null,
    RECEIVED_TEAMS_LIST: null,
    RECEIVED_MY_TEAM_MEMBERS: null,
    RECEIVED_MY_TEAM_MEMBER: null,
    RECEIVED_TEAM_MEMBERS: null,
    RECEIVED_MEMBERS_IN_TEAM: null,
    RECEIVED_MEMBER_IN_TEAM: null,
    REMOVE_MEMBER_FROM_TEAM: null,
    RECEIVED_TEAM_STATS: null,
    RECEIVED_MY_TEAM_UNREADS: null,
    LEAVE_TEAM: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    CREATE_POST_REQUEST: null,
    CREATE_POST_SUCCESS: null,
    CREATE_POST_FAILURE: null,

    EDIT_POST_REQUEST: null,
    EDIT_POST_SUCCESS: null,
    EDIT_POST_FAILURE: null,

    DELETE_POST_REQUEST: null,
    DELETE_POST_SUCCESS: null,
    DELETE_POST_FAILURE: null,

    GET_POST_THREAD_REQUEST: null,
    GET_POST_THREAD_SUCCESS: null,
    GET_POST_THREAD_FAILURE: null,

    GET_POSTS_REQUEST: null,
    GET_POSTS_SUCCESS: null,
    GET_POSTS_FAILURE: null,

    GET_POSTS_SINCE_REQUEST: null,
    GET_POSTS_SINCE_SUCCESS: null,
    GET_POSTS_SINCE_FAILURE: null,

    GET_POSTS_BEFORE_REQUEST: null,
    GET_POSTS_BEFORE_SUCCESS: null,
    GET_POSTS_BEFORE_FAILURE: null,

    GET_POSTS_AFTER_REQUEST: null,
    GET_POSTS_AFTER_SUCCESS: null,
    GET_POSTS_AFTER_FAILURE: null,

    REACTION_REQUEST: null,
    REACTION_SUCCESS: null,
    REACTION_FAILURE: null,

    OPEN_GRAPH_REQUEST: null,
    OPEN_GRAPH_SUCCESS: null,
    OPEN_GRAPH_FAILURE: null,

    GET_POST_THREAD_WITH_RETRY_ATTEMPT: null,
    GET_POSTS_WITH_RETRY_ATTEMPT: null,
    GET_POSTS_SINCE_WITH_RETRY_ATTEMPT: null,
    GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT: null,
    GET_POSTS_AFTER_WITH_RETRY_ATTEMPT: null,

    RECEIVED_POST: null,
    RECEIVED_POSTS: null,
    RECEIVED_FOCUSED_POST: null,
    RECEIVED_POST_SELECTED: null,
    RECEIVED_EDIT_POST: null,
    POST_DELETED: null,
    REMOVE_POST: null,
    RECEIVED_REACTION: null,
    RECEIVED_REACTIONS: null,
    REACTION_DELETED: null,
    RECEIVED_OPEN_GRAPH_METADATA: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    FETCH_FILES_FOR_POST_REQUEST: null,
    FETCH_FILES_FOR_POST_SUCCESS: null,
    FETCH_FILES_FOR_POST_FAILURE: null,

    RECEIVED_FILES_FOR_POST: null,

    UPLOAD_FILES_REQUEST: null,
    UPLOAD_FILES_SUCCESS: null,
    UPLOAD_FILES_FAILURE: null,
    UPLOAD_FILES_CANCEL: null,

    RECEIVED_UPLOAD_FILES: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    MY_PREFERENCES_REQUEST: null,
    MY_PREFERENCES_SUCCESS: null,
    MY_PREFERENCES_FAILURE: null,

    SAVE_PREFERENCES_REQUEST: null,
    SAVE_PREFERENCES_SUCCESS: null,
    SAVE_PREFERENCES_FAILURE: null,

    DELETE_PREFERENCES_REQUEST: null,
    DELETE_PREFERENCES_SUCCESS: null,
    DELETE_PREFERENCES_FAILURE: null,

    RECEIVED_PREFERENCES: null,
    RECEIVED_ALL_PREFERENCES: null,
    DELETED_PREFERENCES: null
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    GET_INCOMING_HOOKS_REQUEST: null,
    GET_INCOMING_HOOKS_SUCCESS: null,
    GET_INCOMING_HOOKS_FAILURE: null,

    CREATE_INCOMING_HOOK_REQUEST: null,
    CREATE_INCOMING_HOOK_SUCCESS: null,
    CREATE_INCOMING_HOOK_FAILURE: null,

    DELETE_INCOMING_HOOK_REQUEST: null,
    DELETE_INCOMING_HOOK_SUCCESS: null,
    DELETE_INCOMING_HOOK_FAILURE: null,

    UPDATE_INCOMING_HOOK_REQUEST: null,
    UPDATE_INCOMING_HOOK_SUCCESS: null,
    UPDATE_INCOMING_HOOK_FAILURE: null,

    GET_OUTGOING_HOOKS_REQUEST: null,
    GET_OUTGOING_HOOKS_SUCCESS: null,
    GET_OUTGOING_HOOKS_FAILURE: null,

    CREATE_OUTGOING_HOOK_REQUEST: null,
    CREATE_OUTGOING_HOOK_SUCCESS: null,
    CREATE_OUTGOING_HOOK_FAILURE: null,

    DELETE_OUTGOING_HOOK_REQUEST: null,
    DELETE_OUTGOING_HOOK_SUCCESS: null,
    DELETE_OUTGOING_HOOK_FAILURE: null,

    UPDATE_OUTGOING_HOOK_REQUEST: null,
    UPDATE_OUTGOING_HOOK_SUCCESS: null,
    UPDATE_OUTGOING_HOOK_FAILURE: null,

    GET_CUSTOM_TEAM_COMMANDS_REQUEST: null,
    GET_CUSTOM_TEAM_COMMANDS_SUCCESS: null,
    GET_CUSTOM_TEAM_COMMANDS_FAILURE: null,

    ADD_COMMAND_REQUEST: null,
    ADD_COMMAND_SUCCESS: null,
    ADD_COMMAND_FAILURE: null,

    EDIT_COMMAND_REQUEST: null,
    EDIT_COMMAND_SUCCESS: null,
    EDIT_COMMAND_FAILURE: null,

    DELETE_COMMAND_REQUEST: null,
    DELETE_COMMAND_SUCCESS: null,
    DELETE_COMMAND_FAILURE: null,

    REGEN_COMMAND_TOKEN_REQUEST: null,
    REGEN_COMMAND_TOKEN_SUCCESS: null,
    REGEN_COMMAND_TOKEN_FAILURE: null,

    ADD_OAUTH_APP_REQUEST: null,
    ADD_OAUTH_APP_SUCCESS: null,
    ADD_OAUTH_APP_FAILURE: null,

    GET_OAUTH_APPS_REQUEST: null,
    GET_OAUTH_APPS_SUCCESS: null,
    GET_OAUTH_APPS_FAILURE: null,

    GET_OAUTH_APP_REQUEST: null,
    GET_OAUTH_APP_SUCCESS: null,
    GET_OAUTH_APP_FAILURE: null,

    DELETE_OAUTH_APP_REQUEST: null,
    DELETE_OAUTH_APP_SUCCESS: null,
    DELETE_OAUTH_APP_FAILURE: null,

    UPDATE_OAUTH_APP_REQUEST: null,
    UPDATE_OAUTH_APP_SUCCESS: null,
    UPDATE_OAUTH_APP_FAILURE: null,

    RECEIVED_INCOMING_HOOK: null,
    RECEIVED_INCOMING_HOOKS: null,
    DELETED_INCOMING_HOOK: null,
    RECEIVED_OUTGOING_HOOK: null,
    RECEIVED_OUTGOING_HOOKS: null,
    DELETED_OUTGOING_HOOK: null,
    RECEIVED_CUSTOM_TEAM_COMMANDS: null,
    RECEIVED_COMMAND: null,
    RECEIVED_COMMAND_TOKEN: null,
    DELETED_COMMAND: null,
    RECEIVED_OAUTH_APP: null,
    RECEIVED_OAUTH_APPS: null,
    DELETED_OAUTH_APP: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    GET_CUSTOM_EMOJIS_REQUEST: null,
    GET_CUSTOM_EMOJIS_SUCCESS: null,
    GET_CUSTOM_EMOJIS_FAILURE: null,

    GET_ALL_CUSTOM_EMOJIS_REQUEST: null,
    GET_ALL_CUSTOM_EMOJIS_SUCCESS: null,
    GET_ALL_CUSTOM_EMOJIS_FAILURE: null,

    CREATE_CUSTOM_EMOJI_REQUEST: null,
    CREATE_CUSTOM_EMOJI_SUCCESS: null,
    CREATE_CUSTOM_EMOJI_FAILURE: null,

    DELETE_CUSTOM_EMOJI_REQUEST: null,
    DELETE_CUSTOM_EMOJI_SUCCESS: null,
    DELETE_CUSTOM_EMOJI_FAILURE: null,

    CLEAR_CUSTOM_EMOJIS: null,
    RECEIVED_CUSTOM_EMOJI: null,
    RECEIVED_CUSTOM_EMOJIS: null,
    DELETED_CUSTOM_EMOJI: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    GET_LOGS_REQUEST: null,
    GET_LOGS_SUCCESS: null,
    GET_LOGS_FAILURE: null,

    GET_AUDITS_REQUEST: null,
    GET_AUDITS_SUCCESS: null,
    GET_AUDITS_FAILURE: null,

    GET_CONFIG_REQUEST: null,
    GET_CONFIG_SUCCESS: null,
    GET_CONFIG_FAILURE: null,

    UPDATE_CONFIG_REQUEST: null,
    UPDATE_CONFIG_SUCCESS: null,
    UPDATE_CONFIG_FAILURE: null,

    RELOAD_CONFIG_REQUEST: null,
    RELOAD_CONFIG_SUCCESS: null,
    RELOAD_CONFIG_FAILURE: null,

    TEST_EMAIL_REQUEST: null,
    TEST_EMAIL_SUCCESS: null,
    TEST_EMAIL_FAILURE: null,

    INVALIDATE_CACHES_REQUEST: null,
    INVALIDATE_CACHES_SUCCESS: null,
    INVALIDATE_CACHES_FAILURE: null,

    RECYCLE_DATABASE_REQUEST: null,
    RECYCLE_DATABASE_SUCCESS: null,
    RECYCLE_DATABASE_FAILURE: null,

    CREATE_COMPLIANCE_REQUEST: null,
    CREATE_COMPLIANCE_SUCCESS: null,
    CREATE_COMPLIANCE_FAILURE: null,

    GET_COMPLIANCE_REQUEST: null,
    GET_COMPLIANCE_SUCCESS: null,
    GET_COMPLIANCE_FAILURE: null,

    UPLOAD_BRAND_IMAGE_REQUEST: null,
    UPLOAD_BRAND_IMAGE_SUCCESS: null,
    UPLOAD_BRAND_IMAGE_FAILURE: null,

    GET_CLUSTER_STATUS_REQUEST: null,
    GET_CLUSTER_STATUS_SUCCESS: null,
    GET_CLUSTER_STATUS_FAILURE: null,

    TEST_LDAP_REQUEST: null,
    TEST_LDAP_SUCCESS: null,
    TEST_LDAP_FAILURE: null,

    SYNC_LDAP_REQUEST: null,
    SYNC_LDAP_SUCCESS: null,
    SYNC_LDAP_FAILURE: null,

    SAML_CERT_STATUS_REQUEST: null,
    SAML_CERT_STATUS_SUCCESS: null,
    SAML_CERT_STATUS_FAILURE: null,

    UPLOAD_SAML_PUBLIC_REQUEST: null,
    UPLOAD_SAML_PUBLIC_SUCCESS: null,
    UPLOAD_SAML_PUBLIC_FAILURE: null,

    UPLOAD_SAML_PRIVATE_REQUEST: null,
    UPLOAD_SAML_PRIVATE_SUCCESS: null,
    UPLOAD_SAML_PRIVATE_FAILURE: null,

    UPLOAD_SAML_IDP_REQUEST: null,
    UPLOAD_SAML_IDP_SUCCESS: null,
    UPLOAD_SAML_IDP_FAILURE: null,

    DELETE_SAML_PUBLIC_REQUEST: null,
    DELETE_SAML_PUBLIC_SUCCESS: null,
    DELETE_SAML_PUBLIC_FAILURE: null,

    DELETE_SAML_PRIVATE_REQUEST: null,
    DELETE_SAML_PRIVATE_SUCCESS: null,
    DELETE_SAML_PRIVATE_FAILURE: null,

    DELETE_SAML_IDP_REQUEST: null,
    DELETE_SAML_IDP_SUCCESS: null,
    DELETE_SAML_IDP_FAILURE: null,

    UPLOAD_LICENSE_REQUEST: null,
    UPLOAD_LICENSE_SUCCESS: null,
    UPLOAD_LICENSE_FAILURE: null,

    REMOVE_LICENSE_REQUEST: null,
    REMOVE_LICENSE_SUCCESS: null,
    REMOVE_LICENSE_FAILURE: null,

    GET_ANALYTICS_REQUEST: null,
    GET_ANALYTICS_SUCCESS: null,
    GET_ANALYTICS_FAILURE: null,

    TEST_ELASTICSEARCH_REQUEST: null,
    TEST_ELASTICSEARCH_SUCCESS: null,
    TEST_ELASTICSEARCH_FAILURE: null,

    PURGE_ELASTICSEARCH_INDEXES_REQUEST: null,
    PURGE_ELASTICSEARCH_INDEXES_SUCCESS: null,
    PURGE_ELASTICSEARCH_INDEXES_FAILURE: null,

    RECEIVED_LOGS: null,
    RECEIVED_AUDITS: null,
    RECEIVED_CONFIG: null,
    RECEIVED_COMPLIANCE_REPORT: null,
    RECEIVED_COMPLIANCE_REPORTS: null,
    RECEIVED_CLUSTER_STATUS: null,
    RECEIVED_SAML_CERT_STATUS: null,
    RECEIVED_SYSTEM_ANALYTICS: null,
    RECEIVED_TEAM_ANALYTICS: null,
    RECEIVED_USER_ACCESS_TOKEN: null,
    RECEIVED_USER_ACCESS_TOKENS: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    PUSH_ALERT: null,
    CLEAR_ALERT: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    CREATE_JOB_REQUEST: null,
    CREATE_JOB_SUCCESS: null,
    CREATE_JOB_FAILURE: null,

    CANCEL_JOB_REQUEST: null,
    CANCEL_JOB_SUCCESS: null,
    CANCEL_JOB_FAILURE: null,

    GET_JOB_REQUEST: null,
    GET_JOB_SUCCESS: null,
    GET_JOB_FAILURE: null,

    GET_JOBS_REQUEST: null,
    GET_JOBS_SUCCESS: null,
    GET_JOBS_FAILURE: null,

    RECEIVED_JOB: null,
    RECEIVED_JOBS: null,
    RECEIVED_JOBS_BY_TYPE: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _key_mirror = __webpack_require__(33);

var _key_mirror2 = _interopRequireDefault(_key_mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _key_mirror2.default)({
    SEARCH_POSTS_REQUEST: null,
    SEARCH_POSTS_SUCCESS: null,
    SEARCH_POSTS_FAILURE: null,

    RECEIVED_SEARCH_POSTS: null,
    RECEIVED_SEARCH_TERM: null,
    REMOVE_SEARCH_POSTS: null,
    REMOVE_SEARCH_TERM: null
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function config() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.CLIENT_CONFIG_RECEIVED:
            return Object.assign({}, state, action.data);
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function appState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.RECEIVED_APP_STATE:
            return action.data;

        default:
            return state;
    }
}

function credentials() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.RECEIVED_APP_CREDENTIALS:
            return Object.assign({}, state, action.data);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function deviceToken() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.RECEIVED_APP_DEVICE_TOKEN:
            return action.data;
        default:
            return state;
    }
}

function license() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.CLIENT_LICENSE_RECEIVED:
            return Object.assign({}, state, action.data);
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function serverVersion() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.GeneralTypes.RECEIVED_SERVER_VERSION:
            return action.data;
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({
    appState: appState,
    credentials: credentials,
    config: config,
    deviceToken: deviceToken,
    license: license,
    serverVersion: serverVersion
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _user_utils = __webpack_require__(126);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function profilesToSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    Object.keys(action.data).forEach(function (key) {
        nextSet.add(key);
    });

    return _extends({}, state, _defineProperty({}, id, nextSet));
}

function profileListToSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    if (action.data) {
        action.data.forEach(function (profile) {
            nextSet.add(profile.id);
        });

        return _extends({}, state, _defineProperty({}, id, nextSet));
    }

    return state;
}

function removeProfileListFromSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    if (action.data) {
        action.data.forEach(function (profile) {
            nextSet.delete(profile.id);
        });

        return _extends({}, state, _defineProperty({}, id, nextSet));
    }

    return state;
}

function addProfileToSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    nextSet.add(action.data.user_id);
    return _extends({}, state, _defineProperty({}, id, nextSet));
}

function removeProfileFromSet(state, action) {
    var id = action.id;
    var nextSet = new Set(state[id]);
    nextSet.delete(action.data.user_id);
    return _extends({}, state, _defineProperty({}, id, nextSet));
}

function currentUserId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_ME:
            {
                var data = action.data || action.payload;

                return data.id;
            }

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';

    }

    return state;
}

function mySessions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_SESSIONS:
            return [].concat(_toConsumableArray(action.data));

        case _action_types.UserTypes.RECEIVED_REVOKED_SESSION:
            {
                var index = -1;
                var length = state.length;
                for (var i = 0; i < length; i++) {
                    if (state[i].id === action.sessionId) {
                        index = i;
                        break;
                    }
                }
                if (index > -1) {
                    return state.slice(0, index).concat(state.slice(index + 1));
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

function myAudits() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_AUDITS:
            return [].concat(_toConsumableArray(action.data));

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

function profiles() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_ME:
        case _action_types.UserTypes.RECEIVED_PROFILE:
            {
                var data = action.data || action.payload;
                return _extends({}, state, _defineProperty({}, data.id, _extends({}, data)));
            }
        case _action_types.UserTypes.RECEIVED_PROFILES_LIST:
            return Object.assign({}, state, (0, _user_utils.profileListToMap)(action.data));
        case _action_types.UserTypes.RECEIVED_PROFILES:
            return Object.assign({}, state, action.data);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function profilesInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM:
            return addProfileToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM:
            return profileListToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_IN_TEAM:
            return profilesToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM:
            return removeProfileFromSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM:
            return removeProfileListFromSet(state, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function profilesNotInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM:
            return addProfileToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM:
            return profileListToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM:
            return removeProfileFromSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM:
            return removeProfileListFromSet(state, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function profilesWithoutTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_PROFILE_WITHOUT_TEAM:
            {
                var nextSet = new Set(state);
                Object.values(action.data).forEach(function (id) {
                    return nextSet.add(id);
                });
                return nextSet;
            }
        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_WITHOUT_TEAM:
            {
                var _nextSet = new Set(state);
                action.data.forEach(function (user) {
                    return _nextSet.add(user.id);
                });
                return _nextSet;
            }
        case _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM:
            {
                var _nextSet2 = new Set(state);
                _nextSet2.delete(action.id);
                return _nextSet2;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return new Set();

        default:
            return state;
    }
}

function profilesInChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL:
            return addProfileToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL:
            return profileListToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_IN_CHANNEL:
            return profilesToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL:
            return removeProfileFromSet(state, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function profilesNotInChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL:
            return addProfileToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL:
            return profileListToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILES_NOT_IN_CHANNEL:
            return profilesToSet(state, action);

        case _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL:
            return removeProfileFromSet(state, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function statuses() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_STATUS:
            {
                var nextState = Object.assign({}, state);
                nextState[action.data.user_id] = action.data.status;

                return nextState;
            }
        case _action_types.UserTypes.RECEIVED_STATUSES:
            {
                var _nextState = Object.assign({}, state);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var s = _step.value;

                        _nextState[s.user_id] = s.status;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return _nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function myUserAccessTokens() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKEN:
            {
                var nextState = _extends({}, state);
                nextState[action.data.id] = action.data;

                return nextState;
            }
        case _action_types.UserTypes.RECEIVED_MY_USER_ACCESS_TOKENS:
            {
                var _nextState2 = _extends({}, state);

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = action.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var uat = _step2.value;

                        _nextState2[uat.id] = uat;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return _nextState2;
            }
        case _action_types.UserTypes.REVOKED_USER_ACCESS_TOKEN:
            {
                var _nextState3 = _extends({}, state);
                Reflect.deleteProperty(_nextState3, action.data);

                return _nextState3;
            }

        case _action_types.UserTypes.CLEAR_MY_USER_ACCESS_TOKENS:
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // the current selected user
    currentUserId: currentUserId,

    // array with the user's sessions
    mySessions: mySessions,

    // array with the user's audits
    myAudits: myAudits,

    // object where every key is the token id and has a user access token as a value
    myUserAccessTokens: myUserAccessTokens,

    // object where every key is a user id and has an object with the users details
    profiles: profiles,

    // object where every key is a team id and has a Set with the users id that are members of the team
    profilesInTeam: profilesInTeam,

    // object where every key is a team id and has a Set with the users id that are not members of the team
    profilesNotInTeam: profilesNotInTeam,

    // set with user ids for users that are not on any team
    profilesWithoutTeam: profilesWithoutTeam,

    // object where every key is a channel id and has a Set with the users id that are members of the channel
    profilesInChannel: profilesInChannel,

    // object where every key is a channel id and has a Set with the users id that are not members of the channel
    profilesNotInChannel: profilesNotInChannel,

    // object where every key is the user id and has a value with the current status of each user
    statuses: statuses
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _team_utils = __webpack_require__(1014);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function currentTeamId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.TeamTypes.SELECT_TEAM:
            return action.data;

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function teams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.TeamTypes.RECEIVED_TEAMS_LIST:
            return Object.assign({}, state, (0, _team_utils.teamListToMap)(action.data));
        case _action_types.TeamTypes.RECEIVED_TEAMS:
            return Object.assign({}, state, action.data);

        case _action_types.TeamTypes.CREATED_TEAM:
        case _action_types.TeamTypes.UPDATED_TEAM:
        case _action_types.TeamTypes.RECEIVED_TEAM:
            return _extends({}, state, _defineProperty({}, action.data.id, action.data));

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function myMembers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER:
            {
                var nextState = _extends({}, state);
                var member = action.data;
                if (member.delete_at === 0) {
                    nextState[member.team_id] = member;
                }
                return nextState;
            }
        case _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS:
            {
                var _nextState = {};
                var members = action.data;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var m = _step.value;

                        if (m.delete_at == null || m.delete_at === 0) {
                            _nextState[m.team_id] = m;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return _nextState;
            }

        case _action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS:
            {
                var _nextState2 = _extends({}, state);
                var unreads = action.data;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = unreads[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var u = _step2.value;

                        var _m = _extends({}, state[u.team_id], {
                            mention_count: u.mention_count,
                            msg_count: u.msg_count
                        });
                        _nextState2[u.team_id] = _m;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return _nextState2;
            }

        case _action_types.TeamTypes.LEAVE_TEAM:
            {
                var _nextState3 = _extends({}, state);
                var data = action.data;
                Reflect.deleteProperty(_nextState3, data.id);
                return _nextState3;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function membersInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM:
            {
                var data = action.data;
                var members = _extends({}, state[data.team_id] || {});
                members[data.user_id] = data;
                return _extends({}, state, _defineProperty({}, data.team_id, members));
            }
        case _action_types.TeamTypes.RECEIVED_TEAM_MEMBERS:
            {
                var _data = action.data;
                if (_data && _data.length) {
                    var nextState = _extends({}, state);
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = _data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var member = _step3.value;

                            if (nextState[member.team_id]) {
                                nextState[member.team_id] = _extends({}, nextState[member.team_id]);
                            } else {
                                nextState[member.team_id] = {};
                            }
                            nextState[member.team_id][member.user_id] = member;
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    return nextState;
                }

                return state;
            }
        case _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM:
            {
                var _data2 = action.data;
                if (_data2 && _data2.length) {
                    var teamId = _data2[0].team_id;
                    var _members = _extends({}, state[teamId] || {});
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = _data2[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var _member = _step4.value;

                            _members[_member.user_id] = _member;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    return _extends({}, state, _defineProperty({}, teamId, _members));
                }

                return state;
            }
        case _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM:
            {
                var _data3 = action.data;
                var _members2 = state[_data3.team_id];
                if (_members2) {
                    var _nextState4 = _extends({}, _members2);
                    Reflect.deleteProperty(_nextState4, _data3.user_id);
                    return _extends({}, state, _defineProperty({}, _data3.team_id, _nextState4));
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function stats() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.TeamTypes.RECEIVED_TEAM_STATS:
            {
                var stat = action.data;
                return _extends({}, state, _defineProperty({}, stat.team_id, stat));
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // the current selected team
    currentTeamId: currentTeamId,

    // object where every key is the team id and has and object with the team detail
    teams: teams,

    // object where every key is the team id and has and object with the team members detail
    myMembers: myMembers,

    // object where every key is the team id and has an of members in the team where the key is user id
    membersInTeam: membersInTeam,

    // object where every key is the team id and has an object with the team stats
    stats: stats
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.teamListToMap = teamListToMap;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function teamListToMap(teamList) {
    var teams = {};
    for (var i = 0; i < teamList.length; i++) {
        teams[teamList[i].id] = teamList[i];
    }
    return teams;
}


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var _handlePosts = handlePosts(state.posts, state.postsInChannel, action),
        posts = _handlePosts.posts,
        postsInChannel = _handlePosts.postsInChannel;

    var nextState = {

        // Object mapping post ids to post objects
        posts: posts,

        // Object mapping channel ids to an list of posts ids in that channel with the most recent post first
        postsInChannel: postsInChannel,

        // The current selected post
        selectedPostId: selectedPostId(state.selectedPostId, action),

        // The current selected focused post (permalink view)
        currentFocusedPostId: currentFocusedPostId(state.currentFocusedPostId, action),

        // Object mapping post ids to an object of emoji reactions using userId-emojiName as keys
        reactions: reactions(state.reactions, action),

        // Object mapping URLs to their relevant opengraph metadata for link previews
        openGraph: openGraph(state.openGraph, action)
    };

    if (state.posts === nextState.posts && state.postsInChannel === nextState.postsInChannel && state.selectedPostId === nextState.selectedPostId && state.currentFocusedPostId === nextState.currentFocusedPostId && state.reactions === nextState.reactions && state.openGraph === nextState.openGraph) {
        // None of the children have changed so don't even let the parent object change
        return state;
    }

    return nextState;
};

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _post_utils = __webpack_require__(434);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function handleReceivedPost() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = _extends({}, posts, _defineProperty({}, post.id, post));

    var nextPostsForChannel = postsInChannel;

    // Only change postsInChannel if the order of the posts needs to change
    if (!postsInChannel[channelId] || postsInChannel[channelId].indexOf(post.id) === -1) {
        // If we don't already have the post, assume it's the most recent one
        var postsForChannel = postsInChannel[channelId] || [];

        nextPostsForChannel = _extends({}, postsInChannel);
        nextPostsForChannel[channelId] = [post.id].concat(_toConsumableArray(postsForChannel));
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handleReceivedPosts() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var newPosts = action.data.posts;
    var channelId = action.channelId;
    var skipAddToChannel = action.skipAddToChannel;

    var nextPosts = _extends({}, posts);
    var nextPostsForChannel = _extends({}, postsInChannel);
    var postsForChannel = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.values(newPosts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var newPost = _step.value;

            if (newPost.delete_at > 0) {
                // Mark the post as deleted if we have it
                if (nextPosts[newPost.id]) {
                    nextPosts[newPost.id] = _extends({}, newPost, {
                        state: _constants.Posts.POST_DELETED,
                        file_ids: [],
                        has_reactions: false
                    });
                } else {
                    continue;
                }
            }

            // Only change the stored post if it's changed since we last received it
            if (!nextPosts[newPost.id] || nextPosts[newPost.id].update_at < newPost.update_at) {
                nextPosts[newPost.id] = newPost;
            }

            if (!skipAddToChannel && postsForChannel.indexOf(newPost.id) === -1) {
                // Just add the post id to the end of the order and we'll sort it out later
                postsForChannel.push(newPost.id);
            }

            // Remove any temporary posts
            if (nextPosts[newPost.pending_post_id]) {
                Reflect.deleteProperty(nextPosts, newPost.pending_post_id);

                var index = postsForChannel.indexOf(newPost.pending_post_id);
                if (index !== -1) {
                    postsForChannel.splice(index, 1);
                }
            }
        }

        // Sort to ensure that the most recent posts are first, with pending
        // and failed posts first
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    postsForChannel.sort(function (a, b) {
        var aIsPendingOrFailed = (0, _post_utils.isPostPendingOrFailed)(nextPosts[a]);
        var bIsPendingOrFailed = (0, _post_utils.isPostPendingOrFailed)(nextPosts[b]);
        if (aIsPendingOrFailed && !bIsPendingOrFailed) {
            return -1;
        } else if (!aIsPendingOrFailed && bIsPendingOrFailed) {
            return 1;
        }

        if (nextPosts[a].create_at > nextPosts[b].create_at) {
            return -1;
        } else if (nextPosts[a].create_at < nextPosts[b].create_at) {
            return 1;
        }

        return 0;
    });

    nextPostsForChannel[channelId] = postsForChannel;

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handlePostsFromSearch() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var newPosts = action.data.posts;
    var info = { posts: posts, postsInChannel: postsInChannel };
    var postsForChannel = new Map();

    var postIds = Object.keys(newPosts);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = postIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            var nextPost = newPosts[id];
            var channelId = nextPost.channel_id;
            if (postsForChannel.has(channelId)) {
                postsForChannel.get(channelId)[id] = nextPost;
            } else {
                postsForChannel.set(channelId, _defineProperty({}, id, nextPost));
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    postsForChannel.forEach(function (postList, channelId) {
        info = handleReceivedPosts(info.posts, postsInChannel, { channelId: channelId, data: { posts: postList } });
    });

    return info;
}

function handlePostDeleted() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = _extends({}, posts);
    var nextPostsForChannel = _extends({}, postsInChannel);

    // We only need to do something if already have the post
    if (posts[post.id]) {
        // Mark the post as deleted
        nextPosts[post.id] = _extends({}, posts[post.id], {
            state: _constants.Posts.POST_DELETED,
            file_ids: [],
            has_reactions: false
        });

        // Remove any of its comments
        var channelPosts = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];
        var postsForChannel = [].concat(_toConsumableArray(channelPosts)); // make sure we don't modify the array we loop over
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = channelPosts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var id = _step3.value;

                if (nextPosts[id].root_id === post.id) {
                    Reflect.deleteProperty(nextPosts, id);

                    var commentIndex = postsForChannel.indexOf(id);
                    if (commentIndex !== -1) {
                        postsForChannel.splice(commentIndex, 1);
                    }
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        nextPostsForChannel[channelId] = postsForChannel;
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handleRemovePost() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    var post = action.data;
    var channelId = post.channel_id;

    var nextPosts = posts;
    var nextPostsForChannel = postsInChannel;

    // We only need to do something if already have the post
    if (nextPosts[post.id]) {
        nextPosts = _extends({}, posts);
        nextPostsForChannel = _extends({}, postsInChannel);
        var channelPosts = postsInChannel[channelId] ? [].concat(_toConsumableArray(postsInChannel[channelId])) : [];

        // Remove the post itself
        Reflect.deleteProperty(nextPosts, post.id);

        var index = channelPosts.indexOf(post.id);
        if (index !== -1) {
            channelPosts.splice(index, 1);
        }

        // Create a copy of the channelPosts after we splice the
        // parent post so we can safely loop and have the latest changes
        var postsForChannel = [].concat(_toConsumableArray(channelPosts));

        // Remove any of its comments
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = channelPosts[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var id = _step4.value;

                if (nextPosts[id].root_id === post.id) {
                    Reflect.deleteProperty(nextPosts, id);

                    var commentIndex = postsForChannel.indexOf(id);
                    if (commentIndex !== -1) {
                        postsForChannel.splice(commentIndex, 1);
                    }
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        nextPostsForChannel[channelId] = postsForChannel;
    }

    return { posts: nextPosts, postsInChannel: nextPostsForChannel };
}

function handlePosts() {
    var posts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postsInChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var action = arguments[2];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_POST:
            return handleReceivedPost(posts, postsInChannel, action);
        case _action_types.PostTypes.RECEIVED_POSTS:
            return handleReceivedPosts(posts, postsInChannel, action);
        case _action_types.PostTypes.POST_DELETED:
            if (action.data) {
                return handlePostDeleted(posts, postsInChannel, action);
            }
            return { posts: posts, postsInChannel: postsInChannel };
        case _action_types.PostTypes.REMOVE_POST:
            return handleRemovePost(posts, postsInChannel, action);

        case _action_types.SearchTypes.RECEIVED_SEARCH_POSTS:
            return handlePostsFromSearch(posts, postsInChannel, action);

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {
                posts: {},
                postsInChannel: {}
            };
        default:
            return {
                posts: posts,
                postsInChannel: postsInChannel
            };
    }
}

function selectedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_POST_SELECTED:
            return action.data;
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function currentFocusedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return '';
        default:
            return state;
    }
}

function reactions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_REACTIONS:
            {
                var reactionsList = action.data;
                var nextReactions = {};
                reactionsList.forEach(function (reaction) {
                    nextReactions[reaction.user_id + '-' + reaction.emoji_name] = reaction;
                });

                return _extends({}, state, _defineProperty({}, action.postId, nextReactions));
            }
        case _action_types.PostTypes.RECEIVED_REACTION:
            {
                var reaction = action.data;
                var _nextReactions = _extends({}, state[reaction.post_id] || {});
                _nextReactions[reaction.user_id + '-' + reaction.emoji_name] = reaction;

                return _extends({}, state, _defineProperty({}, reaction.post_id, _nextReactions));
            }
        case _action_types.PostTypes.REACTION_DELETED:
            {
                var _reaction = action.data;
                var _nextReactions2 = _extends({}, state[_reaction.post_id] || {});
                if (!_nextReactions2[_reaction.user_id + '-' + _reaction.emoji_name]) {
                    return state;
                }

                Reflect.deleteProperty(_nextReactions2, _reaction.user_id + '-' + _reaction.emoji_name);

                return _extends({}, state, _defineProperty({}, _reaction.post_id, _nextReactions2));
            }
        case _action_types.PostTypes.POST_DELETED:
        case _action_types.PostTypes.REMOVE_POST:
            {
                var post = action.data;

                if (post && state[post.id]) {
                    var nextState = _extends({}, state);
                    Reflect.deleteProperty(nextState, post.id);

                    return nextState;
                }

                return state;
            }

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function openGraph() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.RECEIVED_OPEN_GRAPH_METADATA:
            {
                var nextState = _extends({}, state);
                nextState[action.url] = action.data;

                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function files() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.FileTypes.RECEIVED_UPLOAD_FILES:
        case _action_types.FileTypes.RECEIVED_FILES_FOR_POST:
            {
                var filesById = action.data.reduce(function (filesMap, file) {
                    return _extends({}, filesMap, _defineProperty({}, file.id, file));
                }, {});
                return _extends({}, state, filesById);
            }

        case _action_types.PostTypes.POST_DELETED:
            {
                if (action.data && action.data.file_ids && action.data.file_ids.length) {
                    var nextState = _extends({}, state);
                    var fileIds = action.data.file_ids;
                    fileIds.forEach(function (id) {
                        Reflect.deleteProperty(nextState, id);
                    });

                    return nextState;
                }

                return state;
            }

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function fileIdsByPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.FileTypes.RECEIVED_FILES_FOR_POST:
            {
                var data = action.data,
                    postId = action.postId;

                var filesIdsForPost = data.map(function (file) {
                    return file.id;
                });
                return _extends({}, state, _defineProperty({}, postId, filesIdsForPost));
            }

        case _action_types.PostTypes.POST_DELETED:
            {
                if (action.data) {
                    var nextState = _extends({}, state);
                    Reflect.deleteProperty(nextState, action.data.id);
                    return nextState;
                }

                return state;
            }

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({
    files: files,
    fileIdsByPostId: fileIdsByPostId
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function getKey(preference) {
    return preference.category + '--' + preference.name;
}

function myPreferences() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PreferenceTypes.RECEIVED_ALL_PREFERENCES:
            {
                var nextState = {};

                if (action.data) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var preference = _step.value;

                            nextState[getKey(preference)] = preference;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                return nextState;
            }

        case _action_types.PreferenceTypes.RECEIVED_PREFERENCES:
            {
                var _nextState = _extends({}, state);

                if (action.data) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = action.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _preference = _step2.value;

                            _nextState[getKey(_preference)] = _preference;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }

                return _nextState;
            }
        case _action_types.PreferenceTypes.DELETED_PREFERENCES:
            {
                var _nextState2 = _extends({}, state);

                if (action.data) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = action.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var _preference2 = _step3.value;

                            Reflect.deleteProperty(_nextState2, getKey(_preference2));
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }

                return _nextState2;
            }

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // object where the key is the category-name and has the corresponding value
    myPreferences: myPreferences
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = typing;

var _constants = __webpack_require__(8);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function typing() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var data = action.data,
        type = action.type;


    switch (type) {
        case _constants.WebsocketEvents.TYPING:
            {
                var id = data.id,
                    userId = data.userId,
                    now = data.now;


                if (id && userId) {
                    return _extends({}, state, _defineProperty({}, id, _extends({}, state[id] || {}, _defineProperty({}, userId, now))));
                }

                return state;
            }
        case _constants.WebsocketEvents.STOP_TYPING:
            {
                var _id = data.id,
                    _userId = data.userId,
                    _now = data.now;


                if (state[_id] && state[_id][_userId] <= _now) {
                    var nextState = _extends({}, state, _defineProperty({}, _id, _extends({}, state[_id])));

                    Reflect.deleteProperty(nextState[_id], _userId);

                    if (Object.keys(nextState[_id]).length === 0) {
                        Reflect.deleteProperty(nextState, _id);
                    }

                    return nextState;
                }

                return state;
            }

        default:
            return state;
    }
}


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function incomingHooks() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.IntegrationTypes.RECEIVED_INCOMING_HOOK:
            {
                nextState[action.data.id] = action.data;
                return nextState;
            }
        case _action_types.IntegrationTypes.RECEIVED_INCOMING_HOOKS:
            {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var hook = _step.value;

                        nextState[hook.id] = hook;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.IntegrationTypes.DELETED_INCOMING_HOOK:
            {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED:
            {
                var deleted = false;
                Object.keys(nextState).forEach(function (id) {
                    if (nextState[id].channel_id === action.data.id) {
                        deleted = true;
                        Reflect.deleteProperty(nextState, id);
                    }
                });

                if (deleted) {
                    return nextState;
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function outgoingHooks() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOK:
            {
                nextState[action.data.id] = action.data;
                return nextState;
            }
        case _action_types.IntegrationTypes.RECEIVED_OUTGOING_HOOKS:
            {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = action.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var hook = _step2.value;

                        nextState[hook.id] = hook;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.IntegrationTypes.DELETED_OUTGOING_HOOK:
            {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }
        case _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED:
            {
                var deleted = false;
                Object.keys(nextState).forEach(function (id) {
                    if (nextState[id].channel_id === action.data.id) {
                        deleted = true;
                        Reflect.deleteProperty(nextState, id);
                    }
                });

                if (deleted) {
                    return nextState;
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function commands() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);
    switch (action.type) {
        case _action_types.IntegrationTypes.RECEIVED_CUSTOM_TEAM_COMMANDS:
            {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = action.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var command = _step3.value;

                        nextState[command.id] = command;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.IntegrationTypes.RECEIVED_COMMAND:
            return _extends({}, state, _defineProperty({}, action.data.id, action.data));
        case _action_types.IntegrationTypes.RECEIVED_COMMAND_TOKEN:
            {
                var _action$data = action.data,
                    id = _action$data.id,
                    token = _action$data.token;

                return _extends({}, state, _defineProperty({}, id, _extends({}, state[id], {
                    token: token
                })));
            }
        case _action_types.IntegrationTypes.DELETED_COMMAND:
            {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function oauthApps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);
    switch (action.type) {
        case _action_types.IntegrationTypes.RECEIVED_OAUTH_APPS:
            {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = action.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var app = _step4.value;

                        nextState[app.id] = app;
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.IntegrationTypes.RECEIVED_OAUTH_APP:
            return _extends({}, state, _defineProperty({}, action.data.id, action.data));
        case _action_types.IntegrationTypes.DELETED_OAUTH_APP:
            {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // object where every key is the hook id and has an object with the incoming hook details
    incomingHooks: incomingHooks,

    // object where every key is the hook id and has an object with the outgoing hook details
    outgoingHooks: outgoingHooks,

    // object to represent installed slash commands for a current team
    commands: commands,

    // object to represent registered oauth apps with app id as the key
    oauthApps: oauthApps

});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function customEmoji() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJI:
            {
                nextState[action.data.id] = action.data;
                return nextState;
            }
        case _action_types.EmojiTypes.RECEIVED_CUSTOM_EMOJIS:
            {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var emoji = _step.value;

                        nextState[emoji.id] = emoji;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.EmojiTypes.DELETED_CUSTOM_EMOJI:
            {
                Reflect.deleteProperty(nextState, action.data.id);
                return nextState;
            }
        case _action_types.EmojiTypes.CLEAR_CUSTOM_EMOJIS:
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // object where every key is the custom emoji id and has an object with the custom emoji details
    customEmoji: customEmoji

});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function logs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_LOGS:
            {
                return action.data;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

function audits() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_AUDITS:
            {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var audit = _step.value;

                        nextState[audit.id] = audit;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function config() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_CONFIG:
            {
                return action.data;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function complianceReports() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_COMPLIANCE_REPORT:
            {
                nextState[action.data.id] = action.data;
                return nextState;
            }
        case _action_types.AdminTypes.RECEIVED_COMPLIANCE_REPORTS:
            {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = action.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var report = _step2.value;

                        nextState[report.id] = report;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function clusterInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_CLUSTER_STATUS:
            {
                return action.data;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

function samlCertStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_SAML_CERT_STATUS:
            {
                return action.data;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function convertAnalyticsRowsToStats(data, name) {
    var stats = {};

    if (name === 'post_counts_day') {
        data.reverse();
        stats[_constants.Stats.POST_PER_DAY] = data;
        return stats;
    }

    if (name === 'user_counts_with_posts_day') {
        data.reverse();
        stats[_constants.Stats.USERS_WITH_POSTS_PER_DAY] = data;
        return stats;
    }

    data.forEach(function (row) {
        var key = void 0;
        switch (row.name) {
            case 'channel_open_count':
                key = _constants.Stats.TOTAL_PUBLIC_CHANNELS;
                break;
            case 'channel_private_count':
                key = _constants.Stats.TOTAL_PRIVATE_GROUPS;
                break;
            case 'post_count':
                key = _constants.Stats.TOTAL_POSTS;
                break;
            case 'unique_user_count':
                key = _constants.Stats.TOTAL_USERS;
                break;
            case 'team_count':
                key = _constants.Stats.TOTAL_TEAMS;
                break;
            case 'total_websocket_connections':
                key = _constants.Stats.TOTAL_WEBSOCKET_CONNECTIONS;
                break;
            case 'total_master_db_connections':
                key = _constants.Stats.TOTAL_MASTER_DB_CONNECTIONS;
                break;
            case 'total_read_db_connections':
                key = _constants.Stats.TOTAL_READ_DB_CONNECTIONS;
                break;
            case 'daily_active_users':
                key = _constants.Stats.DAILY_ACTIVE_USERS;
                break;
            case 'monthly_active_users':
                key = _constants.Stats.MONTHLY_ACTIVE_USERS;
                break;
            case 'file_post_count':
                key = _constants.Stats.TOTAL_FILE_POSTS;
                break;
            case 'hashtag_post_count':
                key = _constants.Stats.TOTAL_HASHTAG_POSTS;
                break;
            case 'incoming_webhook_count':
                key = _constants.Stats.TOTAL_IHOOKS;
                break;
            case 'outgoing_webhook_count':
                key = _constants.Stats.TOTAL_OHOOKS;
                break;
            case 'command_count':
                key = _constants.Stats.TOTAL_COMMANDS;
                break;
            case 'session_count':
                key = _constants.Stats.TOTAL_SESSIONS;
                break;
        }

        if (key) {
            stats[key] = row.value;
        }
    });

    return stats;
}

function analytics() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_SYSTEM_ANALYTICS:
            {
                var stats = convertAnalyticsRowsToStats(action.data, action.name);
                return _extends({}, state, stats);
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function teamAnalytics() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_TEAM_ANALYTICS:
            {
                var nextState = _extends({}, state);
                var stats = convertAnalyticsRowsToStats(action.data, action.name);
                var analyticsForTeam = _extends({}, nextState[action.teamId] || {}, stats);
                nextState[action.teamId] = analyticsForTeam;
                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

function userAccessTokens() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKEN:
            {
                var nextUserState = _extends({}, state[action.data.user_id] || {});
                nextUserState[action.data.id] = action.data;

                return _extends({}, state, _defineProperty({}, action.data.user_id, nextUserState));
            }
        case _action_types.AdminTypes.RECEIVED_USER_ACCESS_TOKENS:
            {
                var _nextUserState = _extends({}, state[action.userId] || {});

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = action.data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var uat = _step3.value;

                        _nextUserState[uat.id] = uat;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return _extends({}, state, _defineProperty({}, action.userId, _nextUserState));
            }
        case _action_types.UserTypes.REVOKED_USER_ACCESS_TOKEN:
            {
                var userIds = Object.keys(state);
                for (var i = 0; i < userIds.length; i++) {
                    var userId = userIds[i];
                    if (state[userId] && state[userId][action.data]) {
                        var _nextUserState2 = _extends({}, state[userId]);
                        Reflect.deleteProperty(_nextUserState2, action.data);
                        return _extends({}, state, _defineProperty({}, userId, _nextUserState2));
                    }
                }

                return state;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // array of strings each representing a log entry
    logs: logs,

    // object where every key is an audit id and has an object with audit details
    audits: audits,

    // object representing the server configuration
    config: config,

    // object where every key is a report id and has an object with report details
    complianceReports: complianceReports,

    // array of cluster status data
    clusterInfo: clusterInfo,

    // object with certificate type as keys and boolean statuses as values
    samlCertStatus: samlCertStatus,

    // object with analytic categories as types and numbers as values
    analytics: analytics,

    // object with team ids as keys and analytics objects as values
    teamAnalytics: teamAnalytics,

    // object with user ids as keys and objects, with token ids as keys, as values
    userAccessTokens: userAccessTokens
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function alertStack() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    var nextState = [].concat(_toConsumableArray(state));

    switch (action.type) {
        case _action_types.AlertTypes.PUSH_ALERT:
            {
                nextState.unshift(action.data);
                return nextState;
            }
        case _action_types.AlertTypes.CLEAR_ALERT:
            {
                nextState.shift();
                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // array acting as a stack where every object is an alert
    alertStack: alertStack

});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function jobs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.JobTypes.RECEIVED_JOB:
            {
                nextState[action.data.id] = action.data;
                return nextState;
            }
        case _action_types.JobTypes.RECEIVED_JOBS:
            {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = action.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var job = _step.value;

                        nextState[job.id] = job;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextState;
            }
        default:
            return state;
    }
}

function jobsByTypeList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);

    switch (action.type) {
        case _action_types.JobTypes.RECEIVED_JOBS_BY_TYPE:
            {
                if (action.data && action.data.length && action.data.length > 0) {
                    nextState[action.data[0].type] = action.data;
                }
                return nextState;
            }
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // object where every key is the job id and has an object with the job details
    jobs: jobs,

    // object where every key is a job type and contains a list of jobs.
    jobsByTypeList: jobsByTypeList

});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function results() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.SearchTypes.RECEIVED_SEARCH_POSTS:
            {
                return action.data.order;
            }
        case _action_types.SearchTypes.REMOVE_SEARCH_POSTS:
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return [];

        default:
            return state;
    }
}

function recent() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = _extends({}, state);
    var data = action.data,
        type = action.type;


    switch (type) {
        case _action_types.SearchTypes.RECEIVED_SEARCH_TERM:
            {
                var teamId = data.teamId,
                    terms = data.terms,
                    isOrSearch = data.isOrSearch;

                var team = [].concat(_toConsumableArray(nextState[teamId] || []));
                var index = team.findIndex(function (r) {
                    return r.terms === terms;
                });
                if (index === -1) {
                    team.push({ terms: terms, isOrSearch: isOrSearch });
                } else {
                    team[index] = { terms: terms, isOrSearch: isOrSearch };
                }
                return _extends({}, nextState, _defineProperty({}, teamId, team));
            }
        case _action_types.SearchTypes.REMOVE_SEARCH_TERM:
            {
                var _teamId = data.teamId,
                    _terms = data.terms;

                var _team = [].concat(_toConsumableArray(nextState[_teamId] || []));
                var _index = _team.findIndex(function (r) {
                    return r.terms === _terms;
                });

                if (_index !== -1) {
                    _team.splice(_index, 1);

                    return _extends({}, nextState, _defineProperty({}, _teamId, _team));
                }

                return nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};

        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({

    // An ordered array with posts ids from the search results
    results: results,

    // Object where every key is a team composed with
    // an object where the key is the term and the value indicates is "or" search
    recent: recent
});


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _action_types = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ErrorTypes.DISMISS_ERROR:
            {
                var nextState = [].concat(_toConsumableArray(state));
                nextState.splice(action.index, 1);

                return nextState;
            }
        case _action_types.ErrorTypes.LOG_ERROR:
            {
                var _nextState = [].concat(_toConsumableArray(state));
                var displayable = action.displayable,
                    error = action.error;

                _nextState.push({
                    displayable: displayable,
                    error: error,
                    date: new Date(Date.now()).toUTCString()
                });

                return _nextState;
            }
        case _action_types.ErrorTypes.RESTORE_ERRORS:
            return action.data;
        case _action_types.ErrorTypes.CLEAR_ERRORS:
            {
                return [];
            }
        default:
            return state;
    }
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _channels = __webpack_require__(1027);

var _channels2 = _interopRequireDefault(_channels);

var _files = __webpack_require__(1028);

var _files2 = _interopRequireDefault(_files);

var _general = __webpack_require__(1029);

var _general2 = _interopRequireDefault(_general);

var _posts = __webpack_require__(1030);

var _posts2 = _interopRequireDefault(_posts);

var _teams = __webpack_require__(1031);

var _teams2 = _interopRequireDefault(_teams);

var _users = __webpack_require__(1032);

var _users2 = _interopRequireDefault(_users);

var _preferences = __webpack_require__(1033);

var _preferences2 = _interopRequireDefault(_preferences);

var _integrations = __webpack_require__(1034);

var _integrations2 = _interopRequireDefault(_integrations);

var _emojis = __webpack_require__(1035);

var _emojis2 = _interopRequireDefault(_emojis);

var _admin = __webpack_require__(1036);

var _admin2 = _interopRequireDefault(_admin);

var _jobs = __webpack_require__(1037);

var _jobs2 = _interopRequireDefault(_jobs);

var _search = __webpack_require__(1038);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    channels: _channels2.default,
    files: _files2.default,
    general: _general2.default,
    posts: _posts2.default,
    teams: _teams2.default,
    users: _users2.default,
    preferences: _preferences2.default,
    integrations: _integrations2.default,
    emojis: _emojis2.default,
    admin: _admin2.default,
    jobs: _jobs2.default,
    search: _search2.default
}); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function getChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CHANNEL_REQUEST, _action_types.ChannelTypes.CHANNEL_SUCCESS, _action_types.ChannelTypes.CHANNEL_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function myChannels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CHANNELS_REQUEST, _action_types.ChannelTypes.CHANNELS_SUCCESS, _action_types.ChannelTypes.CHANNELS_FAILURE, state, action);
}

function myMembers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CHANNEL_MY_MEMBERS_REQUEST, _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_SUCCESS, _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_FAILURE, state, action);
}

function members() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS, _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, state, action);
}

function createChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CREATE_CHANNEL_REQUEST, _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS, _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, state, action);
}

function updateChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST, _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS, _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, state, action);
}

function updateChannelNotifyProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.NOTIFY_PROPS_REQUEST, _action_types.ChannelTypes.NOTIFY_PROPS_SUCCESS, _action_types.ChannelTypes.NOTIFY_PROPS_FAILURE, state, action);
}

function joinChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.JOIN_CHANNEL_REQUEST, _action_types.ChannelTypes.JOIN_CHANNEL_SUCCESS, _action_types.ChannelTypes.JOIN_CHANNEL_FAILURE, state, action);
}

function deleteChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.DELETE_CHANNEL_REQUEST, _action_types.ChannelTypes.DELETE_CHANNEL_SUCCESS, _action_types.ChannelTypes.DELETE_CHANNEL_FAILURE, state, action);
}

function updateLastViewedAt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.UPDATE_LAST_VIEWED_REQUEST, _action_types.ChannelTypes.UPDATE_LAST_VIEWED_SUCCESS, _action_types.ChannelTypes.UPDATE_LAST_VIEWED_FAILURE, state, action);
}

function getChannels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.GET_CHANNELS_REQUEST, _action_types.ChannelTypes.GET_CHANNELS_SUCCESS, _action_types.ChannelTypes.GET_CHANNELS_FAILURE, state, action);
}

function getChannelStats() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.CHANNEL_STATS_REQUEST, _action_types.ChannelTypes.CHANNEL_STATS_SUCCESS, _action_types.ChannelTypes.CHANNEL_STATS_FAILURE, state, action);
}

function addChannelMember() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST, _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS, _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, state, action);
}

function removeChannelMember() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_REQUEST, _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_SUCCESS, _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_FAILURE, state, action);
}

function updateChannelMember() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_REQUEST, _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_SUCCESS, _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    getChannel: getChannel,
    getChannels: getChannels,
    myMembers: myMembers,
    members: members,
    myChannels: myChannels,
    createChannel: createChannel,
    updateChannel: updateChannel,
    updateChannelNotifyProps: updateChannelNotifyProps,
    joinChannel: joinChannel,
    deleteChannel: deleteChannel,
    updateLastViewedAt: updateLastViewedAt,
    getChannelStats: getChannelStats,
    addChannelMember: addChannelMember,
    removeChannelMember: removeChannelMember,
    updateChannelMember: updateChannelMember
});


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.handleUploadFilesRequest = handleUploadFilesRequest;

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _constants = __webpack_require__(8);

var _helpers = __webpack_require__(54);

function getFilesForPost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.FileTypes.FETCH_FILES_FOR_POST_REQUEST, _action_types.FileTypes.FETCH_FILES_FOR_POST_SUCCESS, _action_types.FileTypes.FETCH_FILES_FOR_POST_FAILURE, state, action);
}

function handleUploadFilesRequest(REQUEST, SUCCESS, FAILURE, CANCEL, state, action) {
    switch (action.type) {
        case REQUEST:
            return _extends({}, state, {
                status: _constants.RequestStatus.STARTED
            });
        case SUCCESS:
            return _extends({}, state, {
                status: _constants.RequestStatus.SUCCESS,
                error: null
            });
        case FAILURE:
            {
                var error = action.error;

                if (error instanceof Error) {
                    error = error.hasOwnProperty('intl') ? _extends({}, error) : error.toString();
                }

                return _extends({}, state, {
                    status: _constants.RequestStatus.FAILURE,
                    error: error
                });
            }
        case CANCEL:
            return _extends({}, state, {
                status: _constants.RequestStatus.CANCELLED,
                error: null
            });
        default:
            return state;
    }
}

function uploadFiles() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return handleUploadFilesRequest(_action_types.FileTypes.UPLOAD_FILES_REQUEST, _action_types.FileTypes.UPLOAD_FILES_SUCCESS, _action_types.FileTypes.UPLOAD_FILES_FAILURE, _action_types.FileTypes.UPLOAD_FILES_CANCEL, state, action);
}

exports.default = (0, _redux.combineReducers)({
    getFilesForPost: getFilesForPost,
    uploadFiles: uploadFiles
});


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function server() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    if (action.type === _action_types.GeneralTypes.PING_RESET) {
        return (0, _helpers.initialRequestState)();
    }

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.PING_REQUEST, _action_types.GeneralTypes.PING_SUCCESS, _action_types.GeneralTypes.PING_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function config() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.CLIENT_CONFIG_REQUEST, _action_types.GeneralTypes.CLIENT_CONFIG_SUCCESS, _action_types.GeneralTypes.CLIENT_CONFIG_FAILURE, state, action);
}

function license() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.CLIENT_LICENSE_REQUEST, _action_types.GeneralTypes.CLIENT_LICENSE_SUCCESS, _action_types.GeneralTypes.CLIENT_LICENSE_FAILURE, state, action);
}

function websocket() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    if (action.type === _action_types.GeneralTypes.WEBSOCKET_CLOSED) {
        return (0, _helpers.initialRequestState)();
    }

    return (0, _helpers.handleRequest)(_action_types.GeneralTypes.WEBSOCKET_REQUEST, _action_types.GeneralTypes.WEBSOCKET_SUCCESS, _action_types.GeneralTypes.WEBSOCKET_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    server: server,
    config: config,
    license: license,
    websocket: websocket
});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function createPost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.CREATE_POST_REQUEST, _action_types.PostTypes.CREATE_POST_SUCCESS, _action_types.PostTypes.CREATE_POST_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function editPost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.EDIT_POST_REQUEST, _action_types.PostTypes.EDIT_POST_SUCCESS, _action_types.PostTypes.EDIT_POST_FAILURE, state, action);
}

function deletePost() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.DELETE_POST_REQUEST, _action_types.PostTypes.DELETE_POST_SUCCESS, _action_types.PostTypes.DELETE_POST_FAILURE, state, action);
}

function getPostThread() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POST_THREAD_REQUEST, _action_types.PostTypes.GET_POST_THREAD_SUCCESS, _action_types.PostTypes.GET_POST_THREAD_FAILURE, state, action);
}

function getPostThreadWithRetryAttempt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.GET_POST_THREAD_WITH_RETRY_ATTEMPT:
            return state + 1;
        case _action_types.PostTypes.GET_POST_THREAD_REQUEST:
        case _action_types.PostTypes.GET_POST_THREAD_SUCCESS:
            return 0;
        default:
            return state;
    }
}

function getPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_REQUEST, _action_types.PostTypes.GET_POSTS_SUCCESS, _action_types.PostTypes.GET_POSTS_FAILURE, state, action);
}

function getPostsWithRetryAttempt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.GET_POSTS_WITH_RETRY_ATTEMPT:
            return state + 1;
        case _action_types.PostTypes.GET_POSTS_REQUEST:
        case _action_types.PostTypes.GET_POSTS_SUCCESS:
            return 0;
        default:
            return state;
    }
}

function getPostsSince() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_SINCE_REQUEST, _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS, _action_types.PostTypes.GET_POSTS_SINCE_FAILURE, state, action);
}

function getPostsSinceWithRetryAttempt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.GET_POSTS_SINCE_WITH_RETRY_ATTEMPT:
            return state + 1;
        case _action_types.PostTypes.GET_POSTS_REQUEST:
        case _action_types.PostTypes.GET_POSTS_SINCE_REQUEST:
        case _action_types.PostTypes.GET_POSTS_SINCE_SUCCESS:
            return 0;
        default:
            return state;
    }
}

function getPostsBefore() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_BEFORE_REQUEST, _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS, _action_types.PostTypes.GET_POSTS_BEFORE_FAILURE, state, action);
}

function getPostsBeforeWithRetryAttempt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.GET_POSTS_BEFORE_WITH_RETRY_ATTEMPT:
            return state + 1;
        case _action_types.PostTypes.GET_POSTS_REQUEST:
        case _action_types.PostTypes.GET_POSTS_BEFORE_REQUEST:
        case _action_types.PostTypes.GET_POSTS_BEFORE_SUCCESS:
            return 0;
        default:
            return state;
    }
}

function getPostsAfter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.GET_POSTS_AFTER_REQUEST, _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS, _action_types.PostTypes.GET_POSTS_AFTER_FAILURE, state, action);
}

function getPostsAfterWithRetryAttempt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    switch (action.type) {
        case _action_types.PostTypes.GET_POSTS_AFTER_WITH_RETRY_ATTEMPT:
            return state + 1;
        case _action_types.PostTypes.GET_POSTS_REQUEST:
        case _action_types.PostTypes.GET_POSTS_AFTER_REQUEST:
        case _action_types.PostTypes.GET_POSTS_AFTER_SUCCESS:
            return 0;
        default:
            return state;
    }
}

function reaction() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.REACTION_REQUEST, _action_types.PostTypes.REACTION_SUCCESS, _action_types.PostTypes.REACTION_FAILURE, state, action);
}

function openGraph() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PostTypes.OPEN_GRAPH_REQUEST, _action_types.PostTypes.OPEN_GRAPH_SUCCESS, _action_types.PostTypes.OPEN_GRAPH_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    createPost: createPost,
    editPost: editPost,
    deletePost: deletePost,
    getPostThread: getPostThread,
    getPostThreadRetryAttempts: getPostThreadWithRetryAttempt,
    getPosts: getPosts,
    getPostsRetryAttempts: getPostsWithRetryAttempt,
    getPostsSince: getPostsSince,
    getPostsSinceRetryAttempts: getPostsSinceWithRetryAttempt,
    getPostsBefore: getPostsBefore,
    getPostsBeforeRetryAttempts: getPostsBeforeWithRetryAttempt,
    getPostsAfter: getPostsAfter,
    getPostsAfterRetryAttempts: getPostsAfterWithRetryAttempt,
    reaction: reaction,
    openGraph: openGraph
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function getMyTeams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.MY_TEAMS_REQUEST, _action_types.TeamTypes.MY_TEAMS_SUCCESS, _action_types.TeamTypes.MY_TEAMS_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getTeams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.GET_TEAMS_REQUEST, _action_types.TeamTypes.GET_TEAMS_SUCCESS, _action_types.TeamTypes.GET_TEAMS_FAILURE, state, action);
}

function getTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.GET_TEAM_REQUEST, _action_types.TeamTypes.GET_TEAM_SUCCESS, _action_types.TeamTypes.GET_TEAM_FAILURE, state, action);
}

function createTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.CREATE_TEAM_REQUEST, _action_types.TeamTypes.CREATE_TEAM_SUCCESS, _action_types.TeamTypes.CREATE_TEAM_FAILURE, state, action);
}

function updateTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.UPDATE_TEAM_REQUEST, _action_types.TeamTypes.UPDATE_TEAM_SUCCESS, _action_types.TeamTypes.UPDATE_TEAM_FAILURE, state, action);
}

function getMyTeamMembers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.MY_TEAM_MEMBERS_REQUEST, _action_types.TeamTypes.MY_TEAM_MEMBERS_SUCCESS, _action_types.TeamTypes.MY_TEAM_MEMBERS_FAILURE, state, action);
}

function getMyTeamUnreads() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.MY_TEAM_UNREADS_REQUEST, _action_types.TeamTypes.MY_TEAM_UNREADS_SUCCESS, _action_types.TeamTypes.MY_TEAM_UNREADS_FAILURE, state, action);
}

function getTeamMembers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.TEAM_MEMBERS_REQUEST, _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS, _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, state, action);
}

function getTeamStats() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.TEAM_STATS_REQUEST, _action_types.TeamTypes.TEAM_STATS_SUCCESS, _action_types.TeamTypes.TEAM_STATS_FAILURE, state, action);
}

function addUserToTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST, _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS, _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, state, action);
}

function removeUserFromTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.REMOVE_TEAM_MEMBER_REQUEST, _action_types.TeamTypes.REMOVE_TEAM_MEMBER_SUCCESS, _action_types.TeamTypes.REMOVE_TEAM_MEMBER_FAILURE, state, action);
}

function updateTeamMember() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.UPDATE_TEAM_MEMBER_REQUEST, _action_types.TeamTypes.UPDATE_TEAM_MEMBER_SUCCESS, _action_types.TeamTypes.UPDATE_TEAM_MEMBER_FAILURE, state, action);
}

function emailInvite() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.TEAM_EMAIL_INVITE_REQUEST, _action_types.TeamTypes.TEAM_EMAIL_INVITE_SUCCESS, _action_types.TeamTypes.TEAM_EMAIL_INVITE_FAILURE, state, action);
}

function joinTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.TeamTypes.JOIN_TEAM_REQUEST, _action_types.TeamTypes.JOIN_TEAM_SUCCESS, _action_types.TeamTypes.JOIN_TEAM_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    getMyTeams: getMyTeams,
    getTeams: getTeams,
    getTeam: getTeam,
    createTeam: createTeam,
    updateTeam: updateTeam,
    getMyTeamMembers: getMyTeamMembers,
    getMyTeamUnreads: getMyTeamUnreads,
    getTeamMembers: getTeamMembers,
    getTeamStats: getTeamStats,
    addUserToTeam: addUserToTeam,
    removeUserFromTeam: removeUserFromTeam,
    updateTeamMember: updateTeamMember,
    emailInvite: emailInvite,
    joinTeam: joinTeam
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _redux = __webpack_require__(5);

var _constants = __webpack_require__(8);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function checkMfa() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.CHECK_MFA_REQUEST:
            return _extends({}, state, { status: _constants.RequestStatus.STARTED });

        case _action_types.UserTypes.CHECK_MFA_SUCCESS:
            return _extends({}, state, { status: _constants.RequestStatus.SUCCESS, error: null });

        case _action_types.UserTypes.CHECK_MFA_FAILURE:
            return _extends({}, state, { status: _constants.RequestStatus.FAILURE, error: action.error });

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return _extends({}, state, { status: _constants.RequestStatus.NOT_STARTED, error: null });

        default:
            return state;
    }
}

function login() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.LOGIN_REQUEST:
            return _extends({}, state, { status: _constants.RequestStatus.STARTED });

        case _action_types.UserTypes.LOGIN_SUCCESS:
            return _extends({}, state, { status: _constants.RequestStatus.SUCCESS, error: null });

        case _action_types.UserTypes.LOGIN_FAILURE:
            return _extends({}, state, { status: _constants.RequestStatus.FAILURE, error: action.error });

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return _extends({}, state, { status: _constants.RequestStatus.NOT_STARTED, error: null });

        default:
            return state;
    }
}

function generateMfaSecret() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.MFA_SECRET_REQUEST, _action_types.UserTypes.MFA_SECRET_SUCCESS, _action_types.UserTypes.MFA_SECRET_FAILURE, state, action);
}

function logout() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.LOGOUT_REQUEST:
            return _extends({}, state, { status: _constants.RequestStatus.STARTED });

        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return _extends({}, state, { status: _constants.RequestStatus.SUCCESS, error: null });

        case _action_types.UserTypes.LOGOUT_FAILURE:
            return _extends({}, state, { status: _constants.RequestStatus.FAILURE, error: action.error });

        case _action_types.UserTypes.RESET_LOGOUT_STATE:
            return (0, _helpers.initialRequestState)();

        default:
            return state;
    }
}

function getProfiles() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_REQUEST, _action_types.UserTypes.PROFILES_SUCCESS, _action_types.UserTypes.PROFILES_FAILURE, state, action);
}

function getProfilesInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_IN_TEAM_REQUEST, _action_types.UserTypes.PROFILES_IN_TEAM_SUCCESS, _action_types.UserTypes.PROFILES_IN_TEAM_FAILURE, state, action);
}

function getProfilesNotInTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_NOT_IN_TEAM_REQUEST, _action_types.UserTypes.PROFILES_NOT_IN_TEAM_SUCCESS, _action_types.UserTypes.PROFILES_NOT_IN_TEAM_FAILURE, state, action);
}

function getProfilesWithoutTeam() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_WITHOUT_TEAM_REQUEST, _action_types.UserTypes.PROFILES_WITHOUT_TEAM_SUCCESS, _action_types.UserTypes.PROFILES_WITHOUT_TEAM_FAILURE, state, action);
}

function getProfilesInChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_IN_CHANNEL_REQUEST, _action_types.UserTypes.PROFILES_IN_CHANNEL_SUCCESS, _action_types.UserTypes.PROFILES_IN_CHANNEL_FAILURE, state, action);
}

function getProfilesNotInChannel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_REQUEST, _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_SUCCESS, _action_types.UserTypes.PROFILES_NOT_IN_CHANNEL_FAILURE, state, action);
}

function getUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.USER_REQUEST, _action_types.UserTypes.USER_SUCCESS, _action_types.UserTypes.USER_FAILURE, state, action);
}

function getUserByUsername() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.USER_BY_USERNAME_REQUEST, _action_types.UserTypes.USER_BY_USERNAME_SUCCESS, _action_types.UserTypes.USER_BY_USERNAME_FAILURE, state, action);
}

function getStatusesByIds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILES_STATUSES_REQUEST, _action_types.UserTypes.PROFILES_STATUSES_SUCCESS, _action_types.UserTypes.PROFILES_STATUSES_FAILURE, state, action);
}

function getStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PROFILE_STATUS_REQUEST, _action_types.UserTypes.PROFILE_STATUS_SUCCESS, _action_types.UserTypes.PROFILE_STATUS_FAILURE, state, action);
}

function setStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.SET_STATUS_REQUEST, _action_types.UserTypes.SET_STATUS_SUCCESS, _action_types.UserTypes.SET_STATUS_FAILURE, state, action);
}

function getSessions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.SESSIONS_REQUEST, _action_types.UserTypes.SESSIONS_SUCCESS, _action_types.UserTypes.SESSIONS_FAILURE, state, action);
}

function revokeSession() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.REVOKE_SESSION_REQUEST, _action_types.UserTypes.REVOKE_SESSION_SUCCESS, _action_types.UserTypes.REVOKE_SESSION_FAILURE, state, action);
}

function getAudits() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.AUDITS_REQUEST, _action_types.UserTypes.AUDITS_SUCCESS, _action_types.UserTypes.AUDITS_FAILURE, state, action);
}

function autocompleteUsers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.AUTOCOMPLETE_USERS_REQUEST, _action_types.UserTypes.AUTOCOMPLETE_USERS_SUCCESS, _action_types.UserTypes.AUTOCOMPLETE_USERS_FAILURE, state, action);
}

function searchProfiles() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.SEARCH_PROFILES_REQUEST, _action_types.UserTypes.SEARCH_PROFILES_SUCCESS, _action_types.UserTypes.SEARCH_PROFILES_FAILURE, state, action);
}

function updateMe() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.UPDATE_ME_REQUEST, _action_types.UserTypes.UPDATE_ME_SUCCESS, _action_types.UserTypes.UPDATE_ME_FAILURE, state, action);
}

function updateUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.UPDATE_USER_REQUEST, _action_types.UserTypes.UPDATE_USER_SUCCESS, _action_types.UserTypes.UPDATE_USER_FAILURE, state, action);
}

function create() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.CREATE_USER_REQUEST, _action_types.UserTypes.CREATE_USER_SUCCESS, _action_types.UserTypes.CREATE_USER_FAILURE, state, action);
}

function verifyEmail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.VERIFY_EMAIL_REQUEST, _action_types.UserTypes.VERIFY_EMAIL_SUCCESS, _action_types.UserTypes.VERIFY_EMAIL_FAILURE, state, action);
}

function passwordReset() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.PASSWORD_RESET_REQUEST, _action_types.UserTypes.PASSWORD_RESET_SUCCESS, _action_types.UserTypes.PASSWORD_RESET_FAILURE, state, action);
}

function switchLogin() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.SWITCH_LOGIN_REQUEST, _action_types.UserTypes.SWITCH_LOGIN_SUCCESS, _action_types.UserTypes.SWITCH_LOGIN_FAILURE, state, action);
}

function createUserAccessToken() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_REQUEST, _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_SUCCESS, _action_types.UserTypes.CREATE_USER_ACCESS_TOKEN_FAILURE, state, action);
}

function getUserAccessToken() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.GET_USER_ACCESS_TOKEN_REQUEST, _action_types.UserTypes.GET_USER_ACCESS_TOKEN_SUCCESS, _action_types.UserTypes.GET_USER_ACCESS_TOKEN_FAILURE, state, action);
}

function revokeUserAccessToken() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_REQUEST, _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_SUCCESS, _action_types.UserTypes.REVOKE_USER_ACCESS_TOKEN_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    checkMfa: checkMfa,
    generateMfaSecret: generateMfaSecret,
    login: login,
    logout: logout,
    create: create,
    getProfiles: getProfiles,
    getProfilesInTeam: getProfilesInTeam,
    getProfilesNotInTeam: getProfilesNotInTeam,
    getProfilesWithoutTeam: getProfilesWithoutTeam,
    getProfilesInChannel: getProfilesInChannel,
    getProfilesNotInChannel: getProfilesNotInChannel,
    getUser: getUser,
    getUserByUsername: getUserByUsername,
    getStatusesByIds: getStatusesByIds,
    getStatus: getStatus,
    setStatus: setStatus,
    getSessions: getSessions,
    revokeSession: revokeSession,
    getAudits: getAudits,
    autocompleteUsers: autocompleteUsers,
    searchProfiles: searchProfiles,
    updateMe: updateMe,
    updateUser: updateUser,
    verifyEmail: verifyEmail,
    passwordReset: passwordReset,
    switchLogin: switchLogin,
    createUserAccessToken: createUserAccessToken,
    getUserAccessToken: getUserAccessToken,
    revokeUserAccessToken: revokeUserAccessToken
});


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function getMyPreferences() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PreferenceTypes.MY_PREFERENCES_REQUEST, _action_types.PreferenceTypes.MY_PREFERENCES_SUCCESS, _action_types.PreferenceTypes.MY_PREFERENCES_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function savePreferences() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PreferenceTypes.SAVE_PREFERENCES_REQUEST, _action_types.PreferenceTypes.SAVE_PREFERENCES_SUCCESS, _action_types.PreferenceTypes.SAVE_PREFERENCES_FAILURE, state, action);
}

function deletePreferences() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.PreferenceTypes.DELETE_PREFERENCES_REQUEST, _action_types.PreferenceTypes.DELETE_PREFERENCES_SUCCESS, _action_types.PreferenceTypes.DELETE_PREFERENCES_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    getMyPreferences: getMyPreferences,
    savePreferences: savePreferences,
    deletePreferences: deletePreferences
});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function createIncomingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.CREATE_INCOMING_HOOK_REQUEST, _action_types.IntegrationTypes.CREATE_INCOMING_HOOK_SUCCESS, _action_types.IntegrationTypes.CREATE_INCOMING_HOOK_FAILURE, state, action);
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getIncomingHooks() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.GET_INCOMING_HOOKS_REQUEST, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_SUCCESS, _action_types.IntegrationTypes.GET_INCOMING_HOOKS_FAILURE, state, action);
}

function deleteIncomingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.DELETE_INCOMING_HOOK_REQUEST, _action_types.IntegrationTypes.DELETE_INCOMING_HOOK_SUCCESS, _action_types.IntegrationTypes.DELETE_INCOMING_HOOK_FAILURE, state, action);
}

function updateIncomingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_REQUEST, _action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_SUCCESS, _action_types.IntegrationTypes.UPDATE_INCOMING_HOOK_FAILURE, state, action);
}

function createOutgoingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_REQUEST, _action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_SUCCESS, _action_types.IntegrationTypes.CREATE_OUTGOING_HOOK_FAILURE, state, action);
}

function getOutgoingHooks() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.GET_OUTGOING_HOOKS_REQUEST, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_SUCCESS, _action_types.IntegrationTypes.GET_OUTGOING_HOOKS_FAILURE, state, action);
}

function deleteOutgoingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_REQUEST, _action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_SUCCESS, _action_types.IntegrationTypes.DELETE_OUTGOING_HOOK_FAILURE, state, action);
}

function updateOutgoingHook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_REQUEST, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_SUCCESS, _action_types.IntegrationTypes.UPDATE_OUTGOING_HOOK_FAILURE, state, action);
}

function getCustomTeamCommands() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_REQUEST, _action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_SUCCESS, _action_types.IntegrationTypes.GET_CUSTOM_TEAM_COMMANDS_FAILURE, state, action);
}

function addCommand() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.ADD_COMMAND_REQUEST, _action_types.IntegrationTypes.ADD_COMMAND_SUCCESS, _action_types.IntegrationTypes.ADD_COMMAND_FAILURE, state, action);
}

function editCommand() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.EDIT_COMMAND_REQUEST, _action_types.IntegrationTypes.EDIT_COMMAND_SUCCESS, _action_types.IntegrationTypes.EDIT_COMMAND_FAILURE, state, action);
}

function regenCommandToken() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_REQUEST, _action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_SUCCESS, _action_types.IntegrationTypes.REGEN_COMMAND_TOKEN_FAILURE, state, action);
}

function deleteCommand() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.DELETE_COMMAND_REQUEST, _action_types.IntegrationTypes.DELETE_COMMAND_SUCCESS, _action_types.IntegrationTypes.DELETE_COMMAND_FAILURE, state, action);
}

function addOAuthApp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.ADD_OAUTH_APP_REQUEST, _action_types.IntegrationTypes.ADD_OAUTH_APP_SUCCESS, _action_types.IntegrationTypes.ADD_OAUTH_APP_FAILURE, state, action);
}

function getOAuthApps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.GET_OAUTH_APPS_REQUEST, _action_types.IntegrationTypes.GET_OAUTH_APPS_SUCCESS, _action_types.IntegrationTypes.GET_OAUTH_APPS_FAILURE, state, action);
}

function getOAuthApp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.GET_OAUTH_APP_REQUEST, _action_types.IntegrationTypes.GET_OAUTH_APP_SUCCESS, _action_types.IntegrationTypes.GET_OAUTH_APP_FAILURE, state, action);
}

function deleteOAuthApp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.DELETE_OAUTH_APP_REQUEST, _action_types.IntegrationTypes.DELETE_OAUTH_APP_SUCCESS, _action_types.IntegrationTypes.DELETE_OAUTH_APP_FAILURE, state, action);
}

function updateOAuthApp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.IntegrationTypes.UPDATE_OAUTH_APP_REQUEST, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_SUCCESS, _action_types.IntegrationTypes.UPDATE_OAUTH_APP_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    createIncomingHook: createIncomingHook,
    getIncomingHooks: getIncomingHooks,
    deleteIncomingHook: deleteIncomingHook,
    updateIncomingHook: updateIncomingHook,
    createOutgoingHook: createOutgoingHook,
    getOutgoingHooks: getOutgoingHooks,
    deleteOutgoingHook: deleteOutgoingHook,
    updateOutgoingHook: updateOutgoingHook,
    getCustomTeamCommands: getCustomTeamCommands,
    addCommand: addCommand,
    editCommand: editCommand,
    regenCommandToken: regenCommandToken,
    deleteCommand: deleteCommand,
    addOAuthApp: addOAuthApp,
    getOAuthApps: getOAuthApps,
    getOAuthApp: getOAuthApp,
    deleteOAuthApp: deleteOAuthApp,
    updateOAuthApp: updateOAuthApp
});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function createCustomEmoji() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_REQUEST, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_SUCCESS, _action_types.EmojiTypes.CREATE_CUSTOM_EMOJI_FAILURE, state, action);
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getCustomEmojis() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.EmojiTypes.GET_CUSTOM_EMOJIS_REQUEST, _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_SUCCESS, _action_types.EmojiTypes.GET_CUSTOM_EMOJIS_FAILURE, state, action);
}

function getAllCustomEmojis() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_REQUEST, _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_SUCCESS, _action_types.EmojiTypes.GET_ALL_CUSTOM_EMOJIS_FAILURE, state, action);
}

function deleteCustomEmoji() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_REQUEST, _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_SUCCESS, _action_types.EmojiTypes.DELETE_CUSTOM_EMOJI_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    createCustomEmoji: createCustomEmoji,
    getCustomEmojis: getCustomEmojis,
    getAllCustomEmojis: getAllCustomEmojis,
    deleteCustomEmoji: deleteCustomEmoji
});


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function getLogs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_LOGS_REQUEST, _action_types.AdminTypes.GET_LOGS_SUCCESS, _action_types.AdminTypes.GET_LOGS_FAILURE, state, action);
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getAudits() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_AUDITS_REQUEST, _action_types.AdminTypes.GET_AUDITS_SUCCESS, _action_types.AdminTypes.GET_AUDITS_FAILURE, state, action);
}

function getConfig() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_CONFIG_REQUEST, _action_types.AdminTypes.GET_CONFIG_SUCCESS, _action_types.AdminTypes.GET_CONFIG_FAILURE, state, action);
}

function updateConfig() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPDATE_CONFIG_REQUEST, _action_types.AdminTypes.UPDATE_CONFIG_SUCCESS, _action_types.AdminTypes.UPDATE_CONFIG_FAILURE, state, action);
}

function reloadConfig() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.RELOAD_CONFIG_REQUEST, _action_types.AdminTypes.RELOAD_CONFIG_SUCCESS, _action_types.AdminTypes.RELOAD_CONFIG_FAILURE, state, action);
}

function testEmail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.TEST_EMAIL_REQUEST, _action_types.AdminTypes.TEST_EMAIL_SUCCESS, _action_types.AdminTypes.TEST_EMAIL_FAILURE, state, action);
}

function invalidateCaches() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.INVALIDATE_CACHES_REQUEST, _action_types.AdminTypes.INVALIDATE_CACHES_SUCCESS, _action_types.AdminTypes.INVALIDATE_CACHES_FAILURE, state, action);
}

function recycleDatabase() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.RECYCLE_DATABASE_REQUEST, _action_types.AdminTypes.RECYCLE_DATABASE_SUCCESS, _action_types.AdminTypes.RECYCLE_DATABASE_FAILURE, state, action);
}

function createCompliance() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.CREATE_COMPLIANCE_REQUEST, _action_types.AdminTypes.CREATE_COMPLIANCE_SUCCESS, _action_types.AdminTypes.CREATE_COMPLIANCE_FAILURE, state, action);
}

function getCompliance() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_COMPLIANCE_REQUEST, _action_types.AdminTypes.GET_COMPLIANCE_SUCCESS, _action_types.AdminTypes.GET_COMPLIANCE_FAILURE, state, action);
}

function uploadBrandImage() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPLOAD_BRAND_IMAGE_REQUEST, _action_types.AdminTypes.UPLOAD_BRAND_IMAGE_SUCCESS, _action_types.AdminTypes.UPLOAD_BRAND_IMAGE_FAILURE, state, action);
}

function getClusterStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_CLUSTER_STATUS_REQUEST, _action_types.AdminTypes.GET_CLUSTER_STATUS_SUCCESS, _action_types.AdminTypes.GET_CLUSTER_STATUS_FAILURE, state, action);
}

function testLdap() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.TEST_LDAP_REQUEST, _action_types.AdminTypes.TEST_LDAP_SUCCESS, _action_types.AdminTypes.TEST_LDAP_FAILURE, state, action);
}

function syncLdap() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.SYNC_LDAP_REQUEST, _action_types.AdminTypes.SYNC_LDAP_SUCCESS, _action_types.AdminTypes.SYNC_LDAP_FAILURE, state, action);
}

function getSamlCertificateStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.SAML_CERT_STATUS_REQUEST, _action_types.AdminTypes.SAML_CERT_STATUS_SUCCESS, _action_types.AdminTypes.SAML_CERT_STATUS_FAILURE, state, action);
}

function uploadPublicSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPLOAD_SAML_PUBLIC_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_PUBLIC_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_PUBLIC_FAILURE, state, action);
}

function uploadPrivateSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPLOAD_SAML_PRIVATE_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_PRIVATE_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_PRIVATE_FAILURE, state, action);
}

function uploadIdpSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPLOAD_SAML_IDP_REQUEST, _action_types.AdminTypes.UPLOAD_SAML_IDP_SUCCESS, _action_types.AdminTypes.UPLOAD_SAML_IDP_FAILURE, state, action);
}

function removePublicSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.DELETE_SAML_PUBLIC_REQUEST, _action_types.AdminTypes.DELETE_SAML_PUBLIC_SUCCESS, _action_types.AdminTypes.DELETE_SAML_PUBLIC_FAILURE, state, action);
}

function removePrivateSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.DELETE_SAML_PRIVATE_REQUEST, _action_types.AdminTypes.DELETE_SAML_PRIVATE_SUCCESS, _action_types.AdminTypes.DELETE_SAML_PRIVATE_FAILURE, state, action);
}

function removeIdpSamlCertificate() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.DELETE_SAML_IDP_REQUEST, _action_types.AdminTypes.DELETE_SAML_IDP_SUCCESS, _action_types.AdminTypes.DELETE_SAML_IDP_FAILURE, state, action);
}

function testElasticsearch() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.TEST_ELASTICSEARCH_REQUEST, _action_types.AdminTypes.TEST_ELASTICSEARCH_SUCCESS, _action_types.AdminTypes.TEST_ELASTICSEARCH_FAILURE, state, action);
}

function purgeElasticsearchIndexes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_REQUEST, _action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_SUCCESS, _action_types.AdminTypes.PURGE_ELASTICSEARCH_INDEXES_FAILURE, state, action);
}

function uploadLicense() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.UPLOAD_LICENSE_REQUEST, _action_types.AdminTypes.UPLOAD_LICENSE_SUCCESS, _action_types.AdminTypes.UPLOAD_LICENSE_FAILURE, state, action);
}

function removeLicense() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.REMOVE_LICENSE_REQUEST, _action_types.AdminTypes.REMOVE_LICENSE_SUCCESS, _action_types.AdminTypes.REMOVE_LICENSE_FAILURE, state, action);
}

function getAnalytics() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.AdminTypes.GET_ANALYTICS_REQUEST, _action_types.AdminTypes.GET_ANALYTICS_SUCCESS, _action_types.AdminTypes.GET_ANALYTICS_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    getLogs: getLogs,
    getAudits: getAudits,
    getConfig: getConfig,
    updateConfig: updateConfig,
    reloadConfig: reloadConfig,
    testEmail: testEmail,
    invalidateCaches: invalidateCaches,
    recycleDatabase: recycleDatabase,
    createCompliance: createCompliance,
    getCompliance: getCompliance,
    uploadBrandImage: uploadBrandImage,
    getClusterStatus: getClusterStatus,
    testLdap: testLdap,
    syncLdap: syncLdap,
    getSamlCertificateStatus: getSamlCertificateStatus,
    uploadPublicSamlCertificate: uploadPublicSamlCertificate,
    uploadPrivateSamlCertificate: uploadPrivateSamlCertificate,
    uploadIdpSamlCertificate: uploadIdpSamlCertificate,
    removePublicSamlCertificate: removePublicSamlCertificate,
    removePrivateSamlCertificate: removePrivateSamlCertificate,
    removeIdpSamlCertificate: removeIdpSamlCertificate,
    testElasticsearch: testElasticsearch,
    purgeElasticsearchIndexes: purgeElasticsearchIndexes,
    uploadLicense: uploadLicense,
    removeLicense: removeLicense,
    getAnalytics: getAnalytics
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function createJob() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.JobTypes.CREATE_JOB_REQUEST, _action_types.JobTypes.CREATE_JOB_SUCCESS, _action_types.JobTypes.CREATE_JOB_FAILURE, state, action);
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getJob() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.JobTypes.GET_JOB_REQUEST, _action_types.JobTypes.GET_JOB_SUCCESS, _action_types.JobTypes.GET_JOB_FAILURE, state, action);
}

function getJobs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.JobTypes.GET_JOBS_REQUEST, _action_types.JobTypes.GET_JOBS_SUCCESS, _action_types.JobTypes.GET_JOBS_FAILURE, state, action);
}

function cancelJob() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    return (0, _helpers.handleRequest)(_action_types.JobTypes.CANCEL_JOB_REQUEST, _action_types.JobTypes.CANCEL_JOB_SUCCESS, _action_types.JobTypes.CANCEL_JOB_FAILURE, state, action);
}

exports.default = (0, _redux.combineReducers)({
    createJob: createJob,
    getJob: getJob,
    getJobs: getJobs,
    cancelJob: cancelJob
});


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _action_types = __webpack_require__(2);

var _helpers = __webpack_require__(54);

function searchPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _helpers.initialRequestState)();
    var action = arguments[1];

    if (action.type === _action_types.SearchTypes.REMOVE_SEARCH_POSTS) {
        return (0, _helpers.initialRequestState)();
    }

    return (0, _helpers.handleRequest)(_action_types.SearchTypes.SEARCH_POSTS_REQUEST, _action_types.SearchTypes.SEARCH_POSTS_SUCCESS, _action_types.SearchTypes.SEARCH_POSTS_FAILURE, state, action);
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _redux.combineReducers)({
    searchPosts: searchPosts
});


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var defaultOptions = exports.defaultOptions = {
    additionalMiddleware: [],
    enableBuffer: true
};

var offlineConfig = {
    effect: function effect(_effect, action) {
        if (typeof _effect !== 'function') {
            throw new Error('Offline Action: effect must be a function.');
        } else if (!action.meta.offline.commit) {
            throw new Error('Offline Action: commit action must be present.');
        }

        return _effect();
    },
    discard: function discard(error, action, retries) {
        if (action.meta && action.meta.offline.hasOwnProperty('maxRetry')) {
            return retries >= action.meta.offline.maxRetry;
        }

        return retries > 10;
    }
};
exports.offlineConfig = offlineConfig;


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createPersistor__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTransform__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__persistStore__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createPersistor", function() { return __WEBPACK_IMPORTED_MODULE_1__createPersistor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return __WEBPACK_IMPORTED_MODULE_2__createTransform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredState", function() { return __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistStore", function() { return __WEBPACK_IMPORTED_MODULE_4__persistStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__["a"]; });
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);








// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};




/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoRehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__ = __webpack_require__(1042);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(inboundState[key]) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isStatePlainEnough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(270);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(a)) return false;
  return true;
}


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createTransform);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getStoredState__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistor__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__ = __webpack_require__(438);
/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistor__["a" /* default */])(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__getStoredState__["a" /* default */])(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }

        store.dispatch(rehydrateAction(restoredState, err));
        complete(err, restoredState);
      });
    });
  } else Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return _extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: payload,
    error: error
  };
}


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*!
    localForage -- Offline Storage, Improved
    Version 1.5.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && typeof obj === 'object' && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

exports.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

exports.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

exports.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

exports.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {}
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && localStorage.setItem;
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs;
var dbContexts;
var toString = Object.prototype.toString;

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, 'readwrite');
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve) {
        deferredOperation.resolve = resolve;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + ' can\'t be downgraded from version ' + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Initialize a singleton container for all running localForages.
    if (!dbContexts) {
        dbContexts = {};
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = {
            // Running localForages sharing a database.
            forages: [],
            // Shared database.
            db: null,
            // Database readiness (promise).
            dbReady: null,
            // Deferred operations on the database.
            deferredOperations: []
        };
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);
            var req = store.get(key);

            req.onsuccess = function () {
                var value = req.result;
                if (value === undefined) {
                    value = null;
                }
                if (_isEncodedBlob(value)) {
                    value = _decodeBlob(value);
                }
                resolve(value);
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var req = store.openCursor();
            var iterationNumber = 1;

            req.onsuccess = function () {
                var cursor = req.result;

                if (cursor) {
                    var value = cursor.value;
                    if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                    }
                    var result = iterator(value, cursor.key, iterationNumber++);

                    if (result !== void 0) {
                        resolve(result);
                    } else {
                        cursor["continue"]();
                    }
                } else {
                    resolve();
                }
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);
            var req = store.put(value, key);

            // The reason we don't _save_ null is because IE 10 does
            // not support saving the `null` type in IndexedDB. How
            // ironic, given the bug below!
            // See: https://github.com/mozilla/localForage/issues/161
            if (value === null) {
                value = undefined;
            }

            transaction.oncomplete = function () {
                // Cast to undefined so the value passed to
                // callback/promise is the same as what one would get out
                // of `getItem()` later. This leads to some weirdness
                // (setItem('foo', undefined) will return `null`), but
                // it's not my fault localStorage is our baseline and that
                // it's weird.
                if (value === undefined) {
                    value = null;
                }

                resolve(value);
            };
            transaction.onabort = transaction.onerror = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);

            // We use a Grunt task to make this safe for IE and some
            // versions of Android (including those used by Cordova).
            // Normally IE won't like `.delete()` and will insist on
            // using `['delete']()`, but we have a build step that
            // fixes this for us now.
            var req = store["delete"](key);
            transaction.oncomplete = function () {
                resolve();
            };

            transaction.onerror = function () {
                reject(req.error);
            };

            // The request will be also be aborted if we've exceeded our storage
            // space.
            transaction.onabort = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);
            var req = store.clear();

            transaction.oncomplete = function () {
                resolve();
            };

            transaction.onabort = transaction.onerror = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);
            var req = store.count();

            req.onsuccess = function () {
                resolve(req.result);
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var advanced = false;
            var req = store.openCursor();
            req.onsuccess = function () {
                var cursor = req.result;
                if (!cursor) {
                    // this means there weren't enough keys
                    resolve(null);

                    return;
                }

                if (n === 0) {
                    // We have the first key, return it if that's what they
                    // wanted.
                    resolve(cursor.key);
                } else {
                    if (!advanced) {
                        // Otherwise, ask the cursor to skip ahead n
                        // records.
                        advanced = true;
                        cursor.advance(n);
                    } else {
                        // When we get here, we've got the nth key.
                        resolve(cursor.key);
                    }
                }
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var req = store.openCursor();
            var keys = [];

            req.onsuccess = function () {
                var cursor = req.result;

                if (!cursor) {
                    resolve(keys);
                    return;
                }

                keys.push(cursor.key);
                cursor["continue"]();
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys
};

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' (id INTEGER PRIMARY KEY, key unique, value)', [], function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        });
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function getItem$1(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        t.executeSql('INSERT OR REPLACE INTO ' + dbInfo.storeName + ' (key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                t.executeSql('SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;

                    resolve(result);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1
};

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = dbInfo.name + '/';

    if (dbInfo.storeName !== self._defaultConfig.storeName) {
        dbInfo.keyPrefix += dbInfo.storeName + '/';
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            if (localStorage.key(i).indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(localStorage.key(i).substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    // Default API, from Gaia/localStorage.
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2
};

// Custom drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var CustomDrivers = {};

var DriverType = {
    INDEXEDDB: 'asyncStorage',
    LOCALSTORAGE: 'localStorageWrapper',
    WEBSQL: 'webSQLStorage'
};

var DefaultDriverOrder = [DriverType.INDEXEDDB, DriverType.WEBSQL, DriverType.LOCALSTORAGE];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'];

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

var driverSupport = {};
// Check to see if IndexedDB is available and if it is the latest
// implementation; it's our preferred backend library. We use "_spec_test"
// as the name of the database because it's not the one we'll operate on,
// but it's useful to make sure its using the right spec.
// See: https://github.com/mozilla/localForage/issues/128
driverSupport[DriverType.INDEXEDDB] = isIndexedDBValid();

driverSupport[DriverType.WEBSQL] = isWebSQLValid();

driverSupport[DriverType.LOCALSTORAGE] = isLocalStorageValid();

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var key in arg) {
                if (arg.hasOwnProperty(key)) {
                    if (isArray(arg[key])) {
                        arguments[0][key] = arg[key].slice();
                    } else {
                        arguments[0][key] = arg[key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

function isLibraryDriver(driverName) {
    for (var driver in DriverType) {
        if (DriverType.hasOwnProperty(driver) && DriverType[driver] === driverName) {
            return true;
        }
    }

    return false;
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        this.INDEXEDDB = DriverType.INDEXEDDB;
        this.LOCALSTORAGE = DriverType.LOCALSTORAGE;
        this.WEBSQL = DriverType.WEBSQL;

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');
                var namingError = new Error('Custom driver name already in use: ' + driverObject._driver);

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }
                if (isLibraryDriver(driverObject._driver)) {
                    reject(namingError);
                    return;
                }

                var customDriverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0; i < customDriverMethods.length; i++) {
                    var customDriverMethod = customDriverMethods[i];
                    if (!customDriverMethod || !driverObject[customDriverMethod] || typeof driverObject[customDriverMethod] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var supportPromise = Promise$1.resolve(true);
                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        supportPromise = driverObject._support();
                    } else {
                        supportPromise = Promise$1.resolve(!!driverObject._support);
                    }
                }

                supportPromise.then(function (supportResult) {
                    driverSupport[driverName] = supportResult;
                    CustomDrivers[driverName] = driverObject;
                    resolve();
                }, reject);
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var self = this;
        var getDriverPromise = Promise$1.resolve().then(function () {
            if (isLibraryDriver(driverName)) {
                switch (driverName) {
                    case self.INDEXEDDB:
                        return asyncStorage;
                    case self.LOCALSTORAGE:
                        return localStorageWrapper;
                    case self.WEBSQL:
                        return webSQLStorage;
                }
            } else if (CustomDrivers[driverName]) {
                return CustomDrivers[driverName];
            } else {
                throw new Error('Driver not found.');
            }
        });
        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!driverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0; i < LibraryMethods.length; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _rhs = __webpack_require__(1047);

var _rhs2 = _interopRequireDefault(_rhs);

var _channel = __webpack_require__(1048);

var _channel2 = _interopRequireDefault(_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    rhs: _rhs2.default,
    channel: _channel2.default
}); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(5);

var _constants = __webpack_require__(12);

var _action_types = __webpack_require__(2);

function selectedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.SELECT_POST:
            return action.postId;
        case _action_types.PostTypes.REMOVE_POST:
            if (action.data && action.data.id === state) {
                return '';
            }
            return state;
        default:
            return state;
    }
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function fromSearch() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.SELECT_POST:
            if (action.from_search) {
                return action.from_search;
            }
            return '';
        default:
            return state;
    }
}

function fromFlaggedPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.SELECT_POST:
            if (action.from_flagged_posts) {
                return action.from_flagged_posts;
            }
            return false;
        default:
            return state;
    }
}

function fromPinnedPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.SELECT_POST:
            if (action.from_pinned_posts) {
                return action.from_pinned_posts;
            }
            return false;
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({
    selectedPostId: selectedPostId,
    fromSearch: fromSearch,
    fromFlaggedPosts: fromFlaggedPosts,
    fromPinnedPosts: fromPinnedPosts
});

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _redux = __webpack_require__(5);

var _constants = __webpack_require__(12);

var _action_types = __webpack_require__(2);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function postVisibility() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ChannelTypes.SELECT_CHANNEL:
            {
                var nextState = (0, _extends3.default)({}, state);
                nextState[action.data] = _constants.Constants.POST_CHUNK_SIZE / 2;
                return nextState;
            }
        case _constants.ActionTypes.INCREASE_POST_VISIBILITY:
            {
                var _nextState = (0, _extends3.default)({}, state);
                _nextState[action.data] += action.amount;
                return _nextState;
            }
        case _constants.ActionTypes.RECEIVED_FOCUSED_POST:
            {
                var _nextState2 = (0, _extends3.default)({}, state);
                _nextState2[action.channelId] = _constants.Constants.POST_CHUNK_SIZE / 2;
                return _nextState2;
            }
        case _action_types.PostTypes.RECEIVED_POST:
            {
                if (action.data && state[action.data.channel_id]) {
                    var _nextState3 = (0, _extends3.default)({}, state);
                    _nextState3[action.data.channel_id] += 1;
                    return _nextState3;
                }
                return state;
            }
        case _action_types.PostTypes.CREATE_POST_FAILURE:
            {
                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.RECEIVED_ERROR,
                    err: action.error
                });
                return state;
            }
        default:
            return state;
    }
}

function lastChannelViewTime() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.ChannelTypes.SELECT_CHANNEL:
            {
                if (action.member) {
                    var nextState = (0, _extends3.default)({}, state);
                    nextState[action.data] = action.member.last_viewed_at;
                    return nextState;
                }
                return state;
            }
        default:
            return state;
    }
}

function loadingPosts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.LOADING_POSTS:
            {
                var nextState = (0, _extends3.default)({}, state);
                nextState[action.channelId] = action.data;
                return nextState;
            }
        default:
            return state;
    }
}

function focusedPostId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _constants.ActionTypes.RECEIVED_FOCUSED_POST:
            return action.data;
        case _action_types.ChannelTypes.SELECT_CHANNEL:
            return '';
        default:
            return state;
    }
}

exports.default = (0, _redux.combineReducers)({
    postVisibility: postVisibility,
    lastChannelViewTime: lastChannelViewTime,
    loadingPosts: loadingPosts,
    focusedPostId: focusedPostId
});

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(66);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = entities;

var _action_types = __webpack_require__(2);

var _entities = __webpack_require__(433);

var _entities2 = _interopRequireDefault(_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2026 Cordchat. All Rights Reserved.
//
// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux reducers/entities/users).
// The patched package kept a second map `entities.users.statusesDetail` holding the *whole* status
// object of each user (status, manual, last_activity_at, ...). The upstream package only keeps the
// status string in `entities.users.statuses`. This wrapper adds the field back on top of the upstream
// entities reducer, so the stock mattermost-redux package can be used unmodified.

function statusesDetail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action_types.UserTypes.RECEIVED_STATUS:
            {
                var nextState = (0, _extends3.default)({}, state);
                nextState[action.data.user_id] = action.data;
                return nextState;
            }
        case _action_types.UserTypes.RECEIVED_STATUSES:
            {
                var _nextState = (0, _extends3.default)({}, state);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(action.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var status = _step.value;

                        _nextState[status.user_id] = status;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return _nextState;
            }
        case _action_types.UserTypes.LOGOUT_SUCCESS:
            return {};
        default:
            return state;
    }
}

function entities(state, action) {
    var next = (0, _entities2.default)(state, action);

    var prevDetail = state && state.users ? state.users.statusesDetail : {};
    var nextDetail = statusesDetail(prevDetail, action);

    if (next === state && nextDetail === prevDetail) {
        return state;
    }

    if (next.users !== (state && state.users) || nextDetail !== prevDetail || !next.users.statusesDetail) {
        return (0, _extends3.default)({}, next, {
            users: (0, _extends3.default)({}, next.users, {
                statusesDetail: nextDetail
            })
        });
    }

    return next;
}

// ---

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(141);
__webpack_require__(118);
module.exports = __webpack_require__(1051);


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var anObject = __webpack_require__(65)
  , get      = __webpack_require__(287);
module.exports = __webpack_require__(15).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(168);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(294);

var _set2 = _interopRequireDefault(_set);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

exports.transformSet = transformSet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function transformFromSet(incoming) {
    var state = (0, _extends3.default)({}, incoming);

    for (var key in state) {
        if (state.hasOwnProperty(key)) {
            if (state[key] instanceof _set2.default) {
                state[key] = (0, _from2.default)([].concat((0, _toConsumableArray3.default)(state[key])));
            }
        }
    }

    return state;
}

function transformToSet(incoming) {
    var state = (0, _extends3.default)({}, incoming);

    for (var key in state) {
        if (state.hasOwnProperty(key)) {
            state[key] = new _set2.default(state[key]);
        }
    }

    return state;
}

function transformSet(incoming, setTransforms) {
    var toStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var state = (0, _extends3.default)({}, incoming);

    var transformer = toStorage ? transformFromSet : transformToSet;

    for (var key in state) {
        if (state.hasOwnProperty(key) && setTransforms.includes(key)) {
            state[key] = transformer(state[key]);
        }
    }

    return state;
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(200);
__webpack_require__(118);
__webpack_require__(141);
__webpack_require__(1054);
__webpack_require__(1058);
module.exports = __webpack_require__(15).Set;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var strong = __webpack_require__(442);

// 23.2 Set Objects
module.exports = __webpack_require__(443)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(98)
  , IObject  = __webpack_require__(282)
  , toObject = __webpack_require__(140)
  , toLength = __webpack_require__(205)
  , asc      = __webpack_require__(1056);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1057);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var isObject = __webpack_require__(100)
  , isArray  = __webpack_require__(421)
  , SPECIES  = __webpack_require__(32)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(31);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(444)('Set')});


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var forOf = __webpack_require__(208);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};



/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(1061);
module.exports = __webpack_require__(15).Object.values;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(31)
  , $values = __webpack_require__(483)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.map = map;
exports.latinise = latinise;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
// Credit to http://semplicewebsites.com/removing-accents-javascript

var latinMap = {
    Á: 'A', // LATIN CAPITAL LETTER A WITH ACUTE
    Ă: 'A', // LATIN CAPITAL LETTER A WITH BREVE
    Ắ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND ACUTE
    Ặ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND DOT BELOW
    Ằ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND GRAVE
    Ẳ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND HOOK ABOVE
    Ẵ: 'A', // LATIN CAPITAL LETTER A WITH BREVE AND TILDE
    Ǎ: 'A', // LATIN CAPITAL LETTER A WITH CARON
    Â: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX
    Ấ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND ACUTE
    Ậ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    Ầ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND GRAVE
    Ẩ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    Ẫ: 'A', // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND TILDE
    Ä: 'A', // LATIN CAPITAL LETTER A WITH DIAERESIS
    Ǟ: 'A', // LATIN CAPITAL LETTER A WITH DIAERESIS AND MACRON
    Ȧ: 'A', // LATIN CAPITAL LETTER A WITH DOT ABOVE
    Ǡ: 'A', // LATIN CAPITAL LETTER A WITH DOT ABOVE AND MACRON
    Ạ: 'A', // LATIN CAPITAL LETTER A WITH DOT BELOW
    Ȁ: 'A', // LATIN CAPITAL LETTER A WITH DOUBLE GRAVE
    À: 'A', // LATIN CAPITAL LETTER A WITH GRAVE
    Ả: 'A', // LATIN CAPITAL LETTER A WITH HOOK ABOVE
    Ȃ: 'A', // LATIN CAPITAL LETTER A WITH INVERTED BREVE
    Ā: 'A', // LATIN CAPITAL LETTER A WITH MACRON
    Ą: 'A', // LATIN CAPITAL LETTER A WITH OGONEK
    Å: 'A', // LATIN CAPITAL LETTER A WITH RING ABOVE
    Ǻ: 'A', // LATIN CAPITAL LETTER A WITH RING ABOVE AND ACUTE
    Ḁ: 'A', // LATIN CAPITAL LETTER A WITH RING BELOW
    Ⱥ: 'A', // LATIN CAPITAL LETTER A WITH STROKE
    Ã: 'A', // LATIN CAPITAL LETTER A WITH TILDE
    Ꜳ: 'AA', // LATIN CAPITAL LETTER AA
    Æ: 'AE', // LATIN CAPITAL LETTER AE
    Ǽ: 'AE', // LATIN CAPITAL LETTER AE WITH ACUTE
    Ǣ: 'AE', // LATIN CAPITAL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER AFRICAN D' (Ɖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ALPHA' (Ɑ)
    Ꜵ: 'AO', // LATIN CAPITAL LETTER AO
    Ꜷ: 'AU', // LATIN CAPITAL LETTER AU
    Ꜹ: 'AV', // LATIN CAPITAL LETTER AV
    Ꜻ: 'AV', // LATIN CAPITAL LETTER AV WITH HORIZONTAL BAR
    Ꜽ: 'AY', // LATIN CAPITAL LETTER AY
    Ḃ: 'B', // LATIN CAPITAL LETTER B WITH DOT ABOVE
    Ḅ: 'B', // LATIN CAPITAL LETTER B WITH DOT BELOW
    Ɓ: 'B', // LATIN CAPITAL LETTER B WITH HOOK
    Ḇ: 'B', // LATIN CAPITAL LETTER B WITH LINE BELOW
    Ƀ: 'B', // LATIN CAPITAL LETTER B WITH STROKE
    Ƃ: 'B', // LATIN CAPITAL LETTER B WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER BROKEN L' (Ꝇ)
    Ć: 'C', // LATIN CAPITAL LETTER C WITH ACUTE
    Č: 'C', // LATIN CAPITAL LETTER C WITH CARON
    Ç: 'C', // LATIN CAPITAL LETTER C WITH CEDILLA
    Ḉ: 'C', // LATIN CAPITAL LETTER C WITH CEDILLA AND ACUTE
    Ĉ: 'C', // LATIN CAPITAL LETTER C WITH CIRCUMFLEX
    Ċ: 'C', // LATIN CAPITAL LETTER C WITH DOT ABOVE
    Ƈ: 'C', // LATIN CAPITAL LETTER C WITH HOOK
    Ȼ: 'C', // LATIN CAPITAL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CON' (Ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO' (Ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO WITH COMMA' (Ꜯ)
    Ď: 'D', // LATIN CAPITAL LETTER D WITH CARON
    Ḑ: 'D', // LATIN CAPITAL LETTER D WITH CEDILLA
    Ḓ: 'D', // LATIN CAPITAL LETTER D WITH CIRCUMFLEX BELOW
    Ḋ: 'D', // LATIN CAPITAL LETTER D WITH DOT ABOVE
    Ḍ: 'D', // LATIN CAPITAL LETTER D WITH DOT BELOW
    Ɗ: 'D', // LATIN CAPITAL LETTER D WITH HOOK
    Ḏ: 'D', // LATIN CAPITAL LETTER D WITH LINE BELOW
    ǲ: 'D', // LATIN CAPITAL LETTER D WITH SMALL LETTER Z
    ǅ: 'D', // LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON
    Đ: 'D', // LATIN CAPITAL LETTER D WITH STROKE
    Ƌ: 'D', // LATIN CAPITAL LETTER D WITH TOPBAR
    Ǳ: 'DZ', // LATIN CAPITAL LETTER DZ
    Ǆ: 'DZ', // LATIN CAPITAL LETTER DZ WITH CARON
    É: 'E', // LATIN CAPITAL LETTER E WITH ACUTE
    Ĕ: 'E', // LATIN CAPITAL LETTER E WITH BREVE
    Ě: 'E', // LATIN CAPITAL LETTER E WITH CARON
    Ȩ: 'E', // LATIN CAPITAL LETTER E WITH CEDILLA
    Ḝ: 'E', // LATIN CAPITAL LETTER E WITH CEDILLA AND BREVE
    Ê: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX
    Ế: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND ACUTE
    Ệ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    Ề: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND GRAVE
    Ể: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    Ễ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND TILDE
    Ḙ: 'E', // LATIN CAPITAL LETTER E WITH CIRCUMFLEX BELOW
    Ë: 'E', // LATIN CAPITAL LETTER E WITH DIAERESIS
    Ė: 'E', // LATIN CAPITAL LETTER E WITH DOT ABOVE
    Ẹ: 'E', // LATIN CAPITAL LETTER E WITH DOT BELOW
    Ȅ: 'E', // LATIN CAPITAL LETTER E WITH DOUBLE GRAVE
    È: 'E', // LATIN CAPITAL LETTER E WITH GRAVE
    Ẻ: 'E', // LATIN CAPITAL LETTER E WITH HOOK ABOVE
    Ȇ: 'E', // LATIN CAPITAL LETTER E WITH INVERTED BREVE
    Ē: 'E', // LATIN CAPITAL LETTER E WITH MACRON
    Ḗ: 'E', // LATIN CAPITAL LETTER E WITH MACRON AND ACUTE
    Ḕ: 'E', // LATIN CAPITAL LETTER E WITH MACRON AND GRAVE
    Ę: 'E', // LATIN CAPITAL LETTER E WITH OGONEK
    Ɇ: 'E', // LATIN CAPITAL LETTER E WITH STROKE
    Ẽ: 'E', // LATIN CAPITAL LETTER E WITH TILDE
    Ḛ: 'E', // LATIN CAPITAL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL AIN' (Ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL ALEF' (Ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ENG' (Ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ESH' (Ʃ)
    Ꝫ: 'ET', // LATIN CAPITAL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ETH' (Ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH' (Ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH REVERSED' (Ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH WITH CARON' (Ǯ)
    Ḟ: 'F', // LATIN CAPITAL LETTER F WITH DOT ABOVE
    Ƒ: 'F', // LATIN CAPITAL LETTER F WITH HOOK
    Ǵ: 'G', // LATIN CAPITAL LETTER G WITH ACUTE
    Ğ: 'G', // LATIN CAPITAL LETTER G WITH BREVE
    Ǧ: 'G', // LATIN CAPITAL LETTER G WITH CARON
    Ģ: 'G', // LATIN CAPITAL LETTER G WITH CEDILLA
    Ĝ: 'G', // LATIN CAPITAL LETTER G WITH CIRCUMFLEX
    Ġ: 'G', // LATIN CAPITAL LETTER G WITH DOT ABOVE
    Ɠ: 'G', // LATIN CAPITAL LETTER G WITH HOOK
    Ḡ: 'G', // LATIN CAPITAL LETTER G WITH MACRON
    Ǥ: 'G', // LATIN CAPITAL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GAMMA' (Ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GLOTTAL STOP' (Ɂ)
    Ḫ: 'H', // LATIN CAPITAL LETTER H WITH BREVE BELOW
    Ȟ: 'H', // LATIN CAPITAL LETTER H WITH CARON
    Ḩ: 'H', // LATIN CAPITAL LETTER H WITH CEDILLA
    Ĥ: 'H', // LATIN CAPITAL LETTER H WITH CIRCUMFLEX
    Ⱨ: 'H', // LATIN CAPITAL LETTER H WITH DESCENDER
    Ḧ: 'H', // LATIN CAPITAL LETTER H WITH DIAERESIS
    Ḣ: 'H', // LATIN CAPITAL LETTER H WITH DOT ABOVE
    Ḥ: 'H', // LATIN CAPITAL LETTER H WITH DOT BELOW
    Ħ: 'H', // LATIN CAPITAL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HALF H' (Ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HENG' (Ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HWAIR' (Ƕ)
    Í: 'I', // LATIN CAPITAL LETTER I WITH ACUTE
    Ĭ: 'I', // LATIN CAPITAL LETTER I WITH BREVE
    Ǐ: 'I', // LATIN CAPITAL LETTER I WITH CARON
    Î: 'I', // LATIN CAPITAL LETTER I WITH CIRCUMFLEX
    Ï: 'I', // LATIN CAPITAL LETTER I WITH DIAERESIS
    Ḯ: 'I', // LATIN CAPITAL LETTER I WITH DIAERESIS AND ACUTE
    İ: 'I', // LATIN CAPITAL LETTER I WITH DOT ABOVE
    Ị: 'I', // LATIN CAPITAL LETTER I WITH DOT BELOW
    Ȉ: 'I', // LATIN CAPITAL LETTER I WITH DOUBLE GRAVE
    Ì: 'I', // LATIN CAPITAL LETTER I WITH GRAVE
    Ỉ: 'I', // LATIN CAPITAL LETTER I WITH HOOK ABOVE
    Ȋ: 'I', // LATIN CAPITAL LETTER I WITH INVERTED BREVE
    Ī: 'I', // LATIN CAPITAL LETTER I WITH MACRON
    Į: 'I', // LATIN CAPITAL LETTER I WITH OGONEK
    Ɨ: 'I', // LATIN CAPITAL LETTER I WITH STROKE
    Ĩ: 'I', // LATIN CAPITAL LETTER I WITH TILDE
    Ḭ: 'I', // LATIN CAPITAL LETTER I WITH TILDE BELOW
    Ꝺ: 'D', // LATIN CAPITAL LETTER INSULAR D
    Ꝼ: 'F', // LATIN CAPITAL LETTER INSULAR F
    Ᵹ: 'G', // LATIN CAPITAL LETTER INSULAR G
    Ꞃ: 'R', // LATIN CAPITAL LETTER INSULAR R
    Ꞅ: 'S', // LATIN CAPITAL LETTER INSULAR S
    Ꞇ: 'T', // LATIN CAPITAL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER IOTA' (Ɩ)
    Ꝭ: 'IS', // LATIN CAPITAL LETTER IS
    Ĵ: 'J', // LATIN CAPITAL LETTER J WITH CIRCUMFLEX
    Ɉ: 'J', // LATIN CAPITAL LETTER J WITH STROKE
    Ḱ: 'K', // LATIN CAPITAL LETTER K WITH ACUTE
    Ǩ: 'K', // LATIN CAPITAL LETTER K WITH CARON
    Ķ: 'K', // LATIN CAPITAL LETTER K WITH CEDILLA
    Ⱪ: 'K', // LATIN CAPITAL LETTER K WITH DESCENDER
    Ꝃ: 'K', // LATIN CAPITAL LETTER K WITH DIAGONAL STROKE
    Ḳ: 'K', // LATIN CAPITAL LETTER K WITH DOT BELOW
    Ƙ: 'K', // LATIN CAPITAL LETTER K WITH HOOK
    Ḵ: 'K', // LATIN CAPITAL LETTER K WITH LINE BELOW
    Ꝁ: 'K', // LATIN CAPITAL LETTER K WITH STROKE
    Ꝅ: 'K', // LATIN CAPITAL LETTER K WITH STROKE AND DIAGONAL STROKE
    Ĺ: 'L', // LATIN CAPITAL LETTER L WITH ACUTE
    Ƚ: 'L', // LATIN CAPITAL LETTER L WITH BAR
    Ľ: 'L', // LATIN CAPITAL LETTER L WITH CARON
    Ļ: 'L', // LATIN CAPITAL LETTER L WITH CEDILLA
    Ḽ: 'L', // LATIN CAPITAL LETTER L WITH CIRCUMFLEX BELOW
    Ḷ: 'L', // LATIN CAPITAL LETTER L WITH DOT BELOW
    Ḹ: 'L', // LATIN CAPITAL LETTER L WITH DOT BELOW AND MACRON
    Ⱡ: 'L', // LATIN CAPITAL LETTER L WITH DOUBLE BAR
    Ꝉ: 'L', // LATIN CAPITAL LETTER L WITH HIGH STROKE
    Ḻ: 'L', // LATIN CAPITAL LETTER L WITH LINE BELOW
    Ŀ: 'L', // LATIN CAPITAL LETTER L WITH MIDDLE DOT
    Ɫ: 'L', // LATIN CAPITAL LETTER L WITH MIDDLE TILDE
    ǈ: 'L', // LATIN CAPITAL LETTER L WITH SMALL LETTER J
    Ł: 'L', // LATIN CAPITAL LETTER L WITH STROKE
    Ǉ: 'LJ', // LATIN CAPITAL LETTER LJ
    Ḿ: 'M', // LATIN CAPITAL LETTER M WITH ACUTE
    Ṁ: 'M', // LATIN CAPITAL LETTER M WITH DOT ABOVE
    Ṃ: 'M', // LATIN CAPITAL LETTER M WITH DOT BELOW
    Ɱ: 'M', // LATIN CAPITAL LETTER M WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH LL' (Ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH V' (Ỽ)
    Ń: 'N', // LATIN CAPITAL LETTER N WITH ACUTE
    Ň: 'N', // LATIN CAPITAL LETTER N WITH CARON
    Ņ: 'N', // LATIN CAPITAL LETTER N WITH CEDILLA
    Ṋ: 'N', // LATIN CAPITAL LETTER N WITH CIRCUMFLEX BELOW
    Ṅ: 'N', // LATIN CAPITAL LETTER N WITH DOT ABOVE
    Ṇ: 'N', // LATIN CAPITAL LETTER N WITH DOT BELOW
    Ǹ: 'N', // LATIN CAPITAL LETTER N WITH GRAVE
    Ɲ: 'N', // LATIN CAPITAL LETTER N WITH LEFT HOOK
    Ṉ: 'N', // LATIN CAPITAL LETTER N WITH LINE BELOW
    Ƞ: 'N', // LATIN CAPITAL LETTER N WITH LONG RIGHT LEG
    ǋ: 'N', // LATIN CAPITAL LETTER N WITH SMALL LETTER J
    Ñ: 'N', // LATIN CAPITAL LETTER N WITH TILDE
    Ǌ: 'NJ', // LATIN CAPITAL LETTER NJ
    Ó: 'O', // LATIN CAPITAL LETTER O WITH ACUTE
    Ŏ: 'O', // LATIN CAPITAL LETTER O WITH BREVE
    Ǒ: 'O', // LATIN CAPITAL LETTER O WITH CARON
    Ô: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX
    Ố: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND ACUTE
    Ộ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    Ồ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND GRAVE
    Ổ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    Ỗ: 'O', // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND TILDE
    Ö: 'O', // LATIN CAPITAL LETTER O WITH DIAERESIS
    Ȫ: 'O', // LATIN CAPITAL LETTER O WITH DIAERESIS AND MACRON
    Ȯ: 'O', // LATIN CAPITAL LETTER O WITH DOT ABOVE
    Ȱ: 'O', // LATIN CAPITAL LETTER O WITH DOT ABOVE AND MACRON
    Ọ: 'O', // LATIN CAPITAL LETTER O WITH DOT BELOW
    Ő: 'O', // LATIN CAPITAL LETTER O WITH DOUBLE ACUTE
    Ȍ: 'O', // LATIN CAPITAL LETTER O WITH DOUBLE GRAVE
    Ò: 'O', // LATIN CAPITAL LETTER O WITH GRAVE
    Ỏ: 'O', // LATIN CAPITAL LETTER O WITH HOOK ABOVE
    Ơ: 'O', // LATIN CAPITAL LETTER O WITH HORN
    Ớ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND ACUTE
    Ợ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND DOT BELOW
    Ờ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND GRAVE
    Ở: 'O', // LATIN CAPITAL LETTER O WITH HORN AND HOOK ABOVE
    Ỡ: 'O', // LATIN CAPITAL LETTER O WITH HORN AND TILDE
    Ȏ: 'O', // LATIN CAPITAL LETTER O WITH INVERTED BREVE
    Ꝋ: 'O', // LATIN CAPITAL LETTER O WITH LONG STROKE OVERLAY
    Ꝍ: 'O', // LATIN CAPITAL LETTER O WITH LOOP
    Ō: 'O', // LATIN CAPITAL LETTER O WITH MACRON
    Ṓ: 'O', // LATIN CAPITAL LETTER O WITH MACRON AND ACUTE
    Ṑ: 'O', // LATIN CAPITAL LETTER O WITH MACRON AND GRAVE
    Ɵ: 'O', // LATIN CAPITAL LETTER O WITH MIDDLE TILDE
    Ǫ: 'O', // LATIN CAPITAL LETTER O WITH OGONEK
    Ǭ: 'O', // LATIN CAPITAL LETTER O WITH OGONEK AND MACRON
    Ø: 'O', // LATIN CAPITAL LETTER O WITH STROKE
    Ǿ: 'O', // LATIN CAPITAL LETTER O WITH STROKE AND ACUTE
    Õ: 'O', // LATIN CAPITAL LETTER O WITH TILDE
    Ṍ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND ACUTE
    Ṏ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND DIAERESIS
    Ȭ: 'O', // LATIN CAPITAL LETTER O WITH TILDE AND MACRON
    Ƣ: 'OI', // LATIN CAPITAL LETTER OI
    Ꝏ: 'OO', // LATIN CAPITAL LETTER OO
    Ɛ: 'E', // LATIN CAPITAL LETTER OPEN E
    Ɔ: 'O', // LATIN CAPITAL LETTER OPEN O
    Ȣ: 'OU', // LATIN CAPITAL LETTER OU
    Ṕ: 'P', // LATIN CAPITAL LETTER P WITH ACUTE
    Ṗ: 'P', // LATIN CAPITAL LETTER P WITH DOT ABOVE
    Ꝓ: 'P', // LATIN CAPITAL LETTER P WITH FLOURISH
    Ƥ: 'P', // LATIN CAPITAL LETTER P WITH HOOK
    Ꝕ: 'P', // LATIN CAPITAL LETTER P WITH SQUIRREL TAIL
    Ᵽ: 'P', // LATIN CAPITAL LETTER P WITH STROKE
    Ꝑ: 'P', // LATIN CAPITAL LETTER P WITH STROKE THROUGH DESCENDER
    Ꝙ: 'Q', // LATIN CAPITAL LETTER Q WITH DIAGONAL STROKE
    Ꝗ: 'Q', // LATIN CAPITAL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER R ROTUNDA' (Ꝛ)
    Ŕ: 'R', // LATIN CAPITAL LETTER R WITH ACUTE
    Ř: 'R', // LATIN CAPITAL LETTER R WITH CARON
    Ŗ: 'R', // LATIN CAPITAL LETTER R WITH CEDILLA
    Ṙ: 'R', // LATIN CAPITAL LETTER R WITH DOT ABOVE
    Ṛ: 'R', // LATIN CAPITAL LETTER R WITH DOT BELOW
    Ṝ: 'R', // LATIN CAPITAL LETTER R WITH DOT BELOW AND MACRON
    Ȑ: 'R', // LATIN CAPITAL LETTER R WITH DOUBLE GRAVE
    Ȓ: 'R', // LATIN CAPITAL LETTER R WITH INVERTED BREVE
    Ṟ: 'R', // LATIN CAPITAL LETTER R WITH LINE BELOW
    Ɍ: 'R', // LATIN CAPITAL LETTER R WITH STROKE
    Ɽ: 'R', // LATIN CAPITAL LETTER R WITH TAIL
    Ꜿ: 'C', // LATIN CAPITAL LETTER REVERSED C WITH DOT
    Ǝ: 'E', // LATIN CAPITAL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER RUM ROTUNDA' (Ꝝ)
    Ś: 'S', // LATIN CAPITAL LETTER S WITH ACUTE
    Ṥ: 'S', // LATIN CAPITAL LETTER S WITH ACUTE AND DOT ABOVE
    Š: 'S', // LATIN CAPITAL LETTER S WITH CARON
    Ṧ: 'S', // LATIN CAPITAL LETTER S WITH CARON AND DOT ABOVE
    Ş: 'S', // LATIN CAPITAL LETTER S WITH CEDILLA
    Ŝ: 'S', // LATIN CAPITAL LETTER S WITH CIRCUMFLEX
    Ș: 'S', // LATIN CAPITAL LETTER S WITH COMMA BELOW
    Ṡ: 'S', // LATIN CAPITAL LETTER S WITH DOT ABOVE
    Ṣ: 'S', // LATIN CAPITAL LETTER S WITH DOT BELOW
    Ṩ: 'S', // LATIN CAPITAL LETTER S WITH DOT BELOW AND DOT ABOVE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SALTILLO' (Ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SCHWA' (Ə)
    ẞ: 'SS', // LATIN CAPITAL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL' (Ɋ)
    Ť: 'T', // LATIN CAPITAL LETTER T WITH CARON
    Ţ: 'T', // LATIN CAPITAL LETTER T WITH CEDILLA
    Ṱ: 'T', // LATIN CAPITAL LETTER T WITH CIRCUMFLEX BELOW
    Ț: 'T', // LATIN CAPITAL LETTER T WITH COMMA BELOW
    Ⱦ: 'T', // LATIN CAPITAL LETTER T WITH DIAGONAL STROKE
    Ṫ: 'T', // LATIN CAPITAL LETTER T WITH DOT ABOVE
    Ṭ: 'T', // LATIN CAPITAL LETTER T WITH DOT BELOW
    Ƭ: 'T', // LATIN CAPITAL LETTER T WITH HOOK
    Ṯ: 'T', // LATIN CAPITAL LETTER T WITH LINE BELOW
    Ʈ: 'T', // LATIN CAPITAL LETTER T WITH RETROFLEX HOOK
    Ŧ: 'T', // LATIN CAPITAL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN' (Þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE' (Ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE THROUGH DESCENDER' (Ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE FIVE' (Ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE SIX' (Ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE TWO' (Ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TRESILLO' (Ꜫ)
    Ɐ: 'A', // LATIN CAPITAL LETTER TURNED A
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TURNED INSULAR G' (Ꝿ)
    Ꞁ: 'L', // LATIN CAPITAL LETTER TURNED L
    Ɯ: 'M', // LATIN CAPITAL LETTER TURNED M
    Ʌ: 'V', // LATIN CAPITAL LETTER TURNED V
    Ꜩ: 'TZ', // LATIN CAPITAL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER U BAR' (Ʉ)
    Ú: 'U', // LATIN CAPITAL LETTER U WITH ACUTE
    Ŭ: 'U', // LATIN CAPITAL LETTER U WITH BREVE
    Ǔ: 'U', // LATIN CAPITAL LETTER U WITH CARON
    Û: 'U', // LATIN CAPITAL LETTER U WITH CIRCUMFLEX
    Ṷ: 'U', // LATIN CAPITAL LETTER U WITH CIRCUMFLEX BELOW
    Ü: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS
    Ǘ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND ACUTE
    Ǚ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND CARON
    Ǜ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND GRAVE
    Ǖ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS AND MACRON
    Ṳ: 'U', // LATIN CAPITAL LETTER U WITH DIAERESIS BELOW
    Ụ: 'U', // LATIN CAPITAL LETTER U WITH DOT BELOW
    Ű: 'U', // LATIN CAPITAL LETTER U WITH DOUBLE ACUTE
    Ȕ: 'U', // LATIN CAPITAL LETTER U WITH DOUBLE GRAVE
    Ù: 'U', // LATIN CAPITAL LETTER U WITH GRAVE
    Ủ: 'U', // LATIN CAPITAL LETTER U WITH HOOK ABOVE
    Ư: 'U', // LATIN CAPITAL LETTER U WITH HORN
    Ứ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND ACUTE
    Ự: 'U', // LATIN CAPITAL LETTER U WITH HORN AND DOT BELOW
    Ừ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND GRAVE
    Ử: 'U', // LATIN CAPITAL LETTER U WITH HORN AND HOOK ABOVE
    Ữ: 'U', // LATIN CAPITAL LETTER U WITH HORN AND TILDE
    Ȗ: 'U', // LATIN CAPITAL LETTER U WITH INVERTED BREVE
    Ū: 'U', // LATIN CAPITAL LETTER U WITH MACRON
    Ṻ: 'U', // LATIN CAPITAL LETTER U WITH MACRON AND DIAERESIS
    Ų: 'U', // LATIN CAPITAL LETTER U WITH OGONEK
    Ů: 'U', // LATIN CAPITAL LETTER U WITH RING ABOVE
    Ũ: 'U', // LATIN CAPITAL LETTER U WITH TILDE
    Ṹ: 'U', // LATIN CAPITAL LETTER U WITH TILDE AND ACUTE
    Ṵ: 'U', // LATIN CAPITAL LETTER U WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER UPSILON' (Ʊ)
    Ꝟ: 'V', // LATIN CAPITAL LETTER V WITH DIAGONAL STROKE
    Ṿ: 'V', // LATIN CAPITAL LETTER V WITH DOT BELOW
    Ʋ: 'V', // LATIN CAPITAL LETTER V WITH HOOK
    Ṽ: 'V', // LATIN CAPITAL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VEND' (Ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VISIGOTHIC Z' (Ꝣ)
    Ꝡ: 'VY', // LATIN CAPITAL LETTER VY
    Ẃ: 'W', // LATIN CAPITAL LETTER W WITH ACUTE
    Ŵ: 'W', // LATIN CAPITAL LETTER W WITH CIRCUMFLEX
    Ẅ: 'W', // LATIN CAPITAL LETTER W WITH DIAERESIS
    Ẇ: 'W', // LATIN CAPITAL LETTER W WITH DOT ABOVE
    Ẉ: 'W', // LATIN CAPITAL LETTER W WITH DOT BELOW
    Ẁ: 'W', // LATIN CAPITAL LETTER W WITH GRAVE
    Ⱳ: 'W', // LATIN CAPITAL LETTER W WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER WYNN' (Ƿ)
    Ẍ: 'X', // LATIN CAPITAL LETTER X WITH DIAERESIS
    Ẋ: 'X', // LATIN CAPITAL LETTER X WITH DOT ABOVE
    Ý: 'Y', // LATIN CAPITAL LETTER Y WITH ACUTE
    Ŷ: 'Y', // LATIN CAPITAL LETTER Y WITH CIRCUMFLEX
    Ÿ: 'Y', // LATIN CAPITAL LETTER Y WITH DIAERESIS
    Ẏ: 'Y', // LATIN CAPITAL LETTER Y WITH DOT ABOVE
    Ỵ: 'Y', // LATIN CAPITAL LETTER Y WITH DOT BELOW
    Ỳ: 'Y', // LATIN CAPITAL LETTER Y WITH GRAVE
    Ƴ: 'Y', // LATIN CAPITAL LETTER Y WITH HOOK
    Ỷ: 'Y', // LATIN CAPITAL LETTER Y WITH HOOK ABOVE
    Ỿ: 'Y', // LATIN CAPITAL LETTER Y WITH LOOP
    Ȳ: 'Y', // LATIN CAPITAL LETTER Y WITH MACRON
    Ɏ: 'Y', // LATIN CAPITAL LETTER Y WITH STROKE
    Ỹ: 'Y', // LATIN CAPITAL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER YOGH' (Ȝ)
    Ź: 'Z', // LATIN CAPITAL LETTER Z WITH ACUTE
    Ž: 'Z', // LATIN CAPITAL LETTER Z WITH CARON
    Ẑ: 'Z', // LATIN CAPITAL LETTER Z WITH CIRCUMFLEX
    Ⱬ: 'Z', // LATIN CAPITAL LETTER Z WITH DESCENDER
    Ż: 'Z', // LATIN CAPITAL LETTER Z WITH DOT ABOVE
    Ẓ: 'Z', // LATIN CAPITAL LETTER Z WITH DOT BELOW
    Ȥ: 'Z', // LATIN CAPITAL LETTER Z WITH HOOK
    Ẕ: 'Z', // LATIN CAPITAL LETTER Z WITH LINE BELOW
    Ƶ: 'Z', // LATIN CAPITAL LETTER Z WITH STROKE
    Ĳ: 'IJ', // LATIN CAPITAL LIGATURE IJ
    Œ: 'OE', // LATIN CAPITAL LIGATURE OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CROSS' (✝)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER ARCHAIC M' (ꟿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER I LONGA' (ꟾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER INVERTED M' (ꟽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED F' (ꟻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED P' (ꟼ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER AIN' (ᴥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER ALVEOLAR CLICK' (ǂ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BIDENTAL PERCUSSIVE' (ʭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL CLICK' (ʘ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL PERCUSSIVE' (ʬ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER DENTAL CLICK' (ǀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP' (ʔ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP WITH STROKE' (ʡ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP' (ʖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP WITH STROKE' (ƾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER LATERAL CLICK' (ǁ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER PHARYNGEAL VOICED FRICATIVE' (ʕ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER RETROFLEX CLICK' (ǃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED ESH LOOP' (ƪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED GLOTTAL STOP WITH STROKE' (ʢ)
    ᴀ: 'A', // LATIN LETTER SMALL CAPITAL A
    ᴁ: 'AE', // LATIN LETTER SMALL CAPITAL AE
    ʙ: 'B', // LATIN LETTER SMALL CAPITAL B
    ᴃ: 'B', // LATIN LETTER SMALL CAPITAL BARRED B
    ᴄ: 'C', // LATIN LETTER SMALL CAPITAL C
    ᴅ: 'D', // LATIN LETTER SMALL CAPITAL D
    ᴇ: 'E', // LATIN LETTER SMALL CAPITAL E
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL ETH' (ᴆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL EZH' (ᴣ)
    ꜰ: 'F', // LATIN LETTER SMALL CAPITAL F
    ɢ: 'G', // LATIN LETTER SMALL CAPITAL G
    ʛ: 'G', // LATIN LETTER SMALL CAPITAL G WITH HOOK
    ʜ: 'H', // LATIN LETTER SMALL CAPITAL H
    ɪ: 'I', // LATIN LETTER SMALL CAPITAL I
    ʁ: 'R', // LATIN LETTER SMALL CAPITAL INVERTED R
    ᴊ: 'J', // LATIN LETTER SMALL CAPITAL J
    ᴋ: 'K', // LATIN LETTER SMALL CAPITAL K
    ʟ: 'L', // LATIN LETTER SMALL CAPITAL L
    ᴌ: 'L', // LATIN LETTER SMALL CAPITAL L WITH STROKE
    ᴍ: 'M', // LATIN LETTER SMALL CAPITAL M
    ɴ: 'N', // LATIN LETTER SMALL CAPITAL N
    ᴏ: 'O', // LATIN LETTER SMALL CAPITAL O
    ɶ: 'OE', // LATIN LETTER SMALL CAPITAL OE
    ᴐ: 'O', // LATIN LETTER SMALL CAPITAL OPEN O
    ᴕ: 'OU', // LATIN LETTER SMALL CAPITAL OU
    ᴘ: 'P', // LATIN LETTER SMALL CAPITAL P
    ʀ: 'R', // LATIN LETTER SMALL CAPITAL R
    ᴎ: 'N', // LATIN LETTER SMALL CAPITAL REVERSED N
    ᴙ: 'R', // LATIN LETTER SMALL CAPITAL REVERSED R
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL RUM' (ꝶ)
    ꜱ: 'S', // LATIN LETTER SMALL CAPITAL S
    ᴛ: 'T', // LATIN LETTER SMALL CAPITAL T
    ⱻ: 'E', // LATIN LETTER SMALL CAPITAL TURNED E
    ᴚ: 'R', // LATIN LETTER SMALL CAPITAL TURNED R
    ᴜ: 'U', // LATIN LETTER SMALL CAPITAL U
    ᴠ: 'V', // LATIN LETTER SMALL CAPITAL V
    ᴡ: 'W', // LATIN LETTER SMALL CAPITAL W
    ʏ: 'Y', // LATIN LETTER SMALL CAPITAL Y
    ᴢ: 'Z', // LATIN LETTER SMALL CAPITAL Z
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER STRETCHED C' (ʗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER TWO WITH STROKE' (ƻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER VOICED LARYNGEAL SPIRANT' (ᴤ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER WYNN' (ƿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER YR' (Ʀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER I WITH STROKE' (ᵻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER U WITH STROKE' (ᵾ)
    á: 'a', // LATIN SMALL LETTER A WITH ACUTE
    ă: 'a', // LATIN SMALL LETTER A WITH BREVE
    ắ: 'a', // LATIN SMALL LETTER A WITH BREVE AND ACUTE
    ặ: 'a', // LATIN SMALL LETTER A WITH BREVE AND DOT BELOW
    ằ: 'a', // LATIN SMALL LETTER A WITH BREVE AND GRAVE
    ẳ: 'a', // LATIN SMALL LETTER A WITH BREVE AND HOOK ABOVE
    ẵ: 'a', // LATIN SMALL LETTER A WITH BREVE AND TILDE
    ǎ: 'a', // LATIN SMALL LETTER A WITH CARON
    â: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX
    ấ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND ACUTE
    ậ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    ầ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND GRAVE
    ẩ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    ẫ: 'a', // LATIN SMALL LETTER A WITH CIRCUMFLEX AND TILDE
    ä: 'a', // LATIN SMALL LETTER A WITH DIAERESIS
    ǟ: 'a', // LATIN SMALL LETTER A WITH DIAERESIS AND MACRON
    ȧ: 'a', // LATIN SMALL LETTER A WITH DOT ABOVE
    ǡ: 'a', // LATIN SMALL LETTER A WITH DOT ABOVE AND MACRON
    ạ: 'a', // LATIN SMALL LETTER A WITH DOT BELOW
    ȁ: 'a', // LATIN SMALL LETTER A WITH DOUBLE GRAVE
    à: 'a', // LATIN SMALL LETTER A WITH GRAVE
    ả: 'a', // LATIN SMALL LETTER A WITH HOOK ABOVE
    ȃ: 'a', // LATIN SMALL LETTER A WITH INVERTED BREVE
    ā: 'a', // LATIN SMALL LETTER A WITH MACRON
    ą: 'a', // LATIN SMALL LETTER A WITH OGONEK
    ᶏ: 'a', // LATIN SMALL LETTER A WITH RETROFLEX HOOK
    ẚ: 'a', // LATIN SMALL LETTER A WITH RIGHT HALF RING
    å: 'a', // LATIN SMALL LETTER A WITH RING ABOVE
    ǻ: 'a', // LATIN SMALL LETTER A WITH RING ABOVE AND ACUTE
    ḁ: 'a', // LATIN SMALL LETTER A WITH RING BELOW
    ⱥ: 'a', // LATIN SMALL LETTER A WITH STROKE
    ã: 'a', // LATIN SMALL LETTER A WITH TILDE
    ꜳ: 'aa', // LATIN SMALL LETTER AA
    æ: 'ae', // LATIN SMALL LETTER AE
    ǽ: 'ae', // LATIN SMALL LETTER AE WITH ACUTE
    ǣ: 'ae', // LATIN SMALL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA' (ɑ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA WITH RETROFLEX HOOK' (ᶐ)
    ꜵ: 'ao', // LATIN SMALL LETTER AO
    ꜷ: 'au', // LATIN SMALL LETTER AU
    ꜹ: 'av', // LATIN SMALL LETTER AV
    ꜻ: 'av', // LATIN SMALL LETTER AV WITH HORIZONTAL BAR
    ꜽ: 'ay', // LATIN SMALL LETTER AY
    ḃ: 'b', // LATIN SMALL LETTER B WITH DOT ABOVE
    ḅ: 'b', // LATIN SMALL LETTER B WITH DOT BELOW
    ɓ: 'b', // LATIN SMALL LETTER B WITH HOOK
    ḇ: 'b', // LATIN SMALL LETTER B WITH LINE BELOW
    ᵬ: 'b', // LATIN SMALL LETTER B WITH MIDDLE TILDE
    ᶀ: 'b', // LATIN SMALL LETTER B WITH PALATAL HOOK
    ƀ: 'b', // LATIN SMALL LETTER B WITH STROKE
    ƃ: 'b', // LATIN SMALL LETTER B WITH TOPBAR
    ɵ: 'o', // LATIN SMALL LETTER BARRED O
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BOTTOM HALF O' (ᴗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BROKEN L' (ꝇ)
    ć: 'c', // LATIN SMALL LETTER C WITH ACUTE
    č: 'c', // LATIN SMALL LETTER C WITH CARON
    ç: 'c', // LATIN SMALL LETTER C WITH CEDILLA
    ḉ: 'c', // LATIN SMALL LETTER C WITH CEDILLA AND ACUTE
    ĉ: 'c', // LATIN SMALL LETTER C WITH CIRCUMFLEX
    ɕ: 'c', // LATIN SMALL LETTER C WITH CURL
    ċ: 'c', // LATIN SMALL LETTER C WITH DOT ABOVE
    ƈ: 'c', // LATIN SMALL LETTER C WITH HOOK
    ȼ: 'c', // LATIN SMALL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OMEGA' (ɷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OPEN E' (ʚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED REVERSED OPEN E' (ɞ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CON' (ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO' (ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO WITH COMMA' (ꜯ)
    ď: 'd', // LATIN SMALL LETTER D WITH CARON
    ḑ: 'd', // LATIN SMALL LETTER D WITH CEDILLA
    ḓ: 'd', // LATIN SMALL LETTER D WITH CIRCUMFLEX BELOW
    ȡ: 'd', // LATIN SMALL LETTER D WITH CURL
    ḋ: 'd', // LATIN SMALL LETTER D WITH DOT ABOVE
    ḍ: 'd', // LATIN SMALL LETTER D WITH DOT BELOW
    ɗ: 'd', // LATIN SMALL LETTER D WITH HOOK
    ᶑ: 'd', // LATIN SMALL LETTER D WITH HOOK AND TAIL
    ḏ: 'd', // LATIN SMALL LETTER D WITH LINE BELOW
    ᵭ: 'd', // LATIN SMALL LETTER D WITH MIDDLE TILDE
    ᶁ: 'd', // LATIN SMALL LETTER D WITH PALATAL HOOK
    đ: 'd', // LATIN SMALL LETTER D WITH STROKE
    ɖ: 'd', // LATIN SMALL LETTER D WITH TAIL
    ƌ: 'd', // LATIN SMALL LETTER D WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DB DIGRAPH' (ȸ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DELTA' (ẟ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DEZH DIGRAPH' (ʤ)
    ı: 'i', // LATIN SMALL LETTER DOTLESS I
    ȷ: 'j', // LATIN SMALL LETTER DOTLESS J
    ɟ: 'j', // LATIN SMALL LETTER DOTLESS J WITH STROKE
    ʄ: 'j', // LATIN SMALL LETTER DOTLESS J WITH STROKE AND HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DUM' (ꝱ)
    ǳ: 'dz', // LATIN SMALL LETTER DZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH' (ʣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH WITH CURL' (ʥ)
    ǆ: 'dz', // LATIN SMALL LETTER DZ WITH CARON
    é: 'e', // LATIN SMALL LETTER E WITH ACUTE
    ĕ: 'e', // LATIN SMALL LETTER E WITH BREVE
    ě: 'e', // LATIN SMALL LETTER E WITH CARON
    ȩ: 'e', // LATIN SMALL LETTER E WITH CEDILLA
    ḝ: 'e', // LATIN SMALL LETTER E WITH CEDILLA AND BREVE
    ê: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX
    ế: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND ACUTE
    ệ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    ề: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND GRAVE
    ể: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    ễ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX AND TILDE
    ḙ: 'e', // LATIN SMALL LETTER E WITH CIRCUMFLEX BELOW
    ë: 'e', // LATIN SMALL LETTER E WITH DIAERESIS
    ė: 'e', // LATIN SMALL LETTER E WITH DOT ABOVE
    ẹ: 'e', // LATIN SMALL LETTER E WITH DOT BELOW
    ȅ: 'e', // LATIN SMALL LETTER E WITH DOUBLE GRAVE
    è: 'e', // LATIN SMALL LETTER E WITH GRAVE
    ẻ: 'e', // LATIN SMALL LETTER E WITH HOOK ABOVE
    ȇ: 'e', // LATIN SMALL LETTER E WITH INVERTED BREVE
    ē: 'e', // LATIN SMALL LETTER E WITH MACRON
    ḗ: 'e', // LATIN SMALL LETTER E WITH MACRON AND ACUTE
    ḕ: 'e', // LATIN SMALL LETTER E WITH MACRON AND GRAVE
    ⱸ: 'e', // LATIN SMALL LETTER E WITH NOTCH
    ę: 'e', // LATIN SMALL LETTER E WITH OGONEK
    ᶒ: 'e', // LATIN SMALL LETTER E WITH RETROFLEX HOOK
    ɇ: 'e', // LATIN SMALL LETTER E WITH STROKE
    ẽ: 'e', // LATIN SMALL LETTER E WITH TILDE
    ḛ: 'e', // LATIN SMALL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL AIN' (ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL ALEF' (ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ENG' (ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH' (ʃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH CURL' (ʆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH PALATAL HOOK' (ᶋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH RETROFLEX HOOK' (ᶘ)
    ꝫ: 'et', // LATIN SMALL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ETH' (ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH' (ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH REVERSED' (ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CARON' (ǯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CURL' (ʓ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH RETROFLEX HOOK' (ᶚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH TAIL' (ƺ)
    ḟ: 'f', // LATIN SMALL LETTER F WITH DOT ABOVE
    ƒ: 'f', // LATIN SMALL LETTER F WITH HOOK
    ᵮ: 'f', // LATIN SMALL LETTER F WITH MIDDLE TILDE
    ᶂ: 'f', // LATIN SMALL LETTER F WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER FENG DIGRAPH' (ʩ)
    ǵ: 'g', // LATIN SMALL LETTER G WITH ACUTE
    ğ: 'g', // LATIN SMALL LETTER G WITH BREVE
    ǧ: 'g', // LATIN SMALL LETTER G WITH CARON
    ģ: 'g', // LATIN SMALL LETTER G WITH CEDILLA
    ĝ: 'g', // LATIN SMALL LETTER G WITH CIRCUMFLEX
    ġ: 'g', // LATIN SMALL LETTER G WITH DOT ABOVE
    ɠ: 'g', // LATIN SMALL LETTER G WITH HOOK
    ḡ: 'g', // LATIN SMALL LETTER G WITH MACRON
    ᶃ: 'g', // LATIN SMALL LETTER G WITH PALATAL HOOK
    ǥ: 'g', // LATIN SMALL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GAMMA' (ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GLOTTAL STOP' (ɂ)
    ḫ: 'h', // LATIN SMALL LETTER H WITH BREVE BELOW
    ȟ: 'h', // LATIN SMALL LETTER H WITH CARON
    ḩ: 'h', // LATIN SMALL LETTER H WITH CEDILLA
    ĥ: 'h', // LATIN SMALL LETTER H WITH CIRCUMFLEX
    ⱨ: 'h', // LATIN SMALL LETTER H WITH DESCENDER
    ḧ: 'h', // LATIN SMALL LETTER H WITH DIAERESIS
    ḣ: 'h', // LATIN SMALL LETTER H WITH DOT ABOVE
    ḥ: 'h', // LATIN SMALL LETTER H WITH DOT BELOW
    ɦ: 'h', // LATIN SMALL LETTER H WITH HOOK
    ẖ: 'h', // LATIN SMALL LETTER H WITH LINE BELOW
    ħ: 'h', // LATIN SMALL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HALF H' (ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG' (ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG WITH HOOK' (ɧ)
    ƕ: 'hv', // LATIN SMALL LETTER HV
    í: 'i', // LATIN SMALL LETTER I WITH ACUTE
    ĭ: 'i', // LATIN SMALL LETTER I WITH BREVE
    ǐ: 'i', // LATIN SMALL LETTER I WITH CARON
    î: 'i', // LATIN SMALL LETTER I WITH CIRCUMFLEX
    ï: 'i', // LATIN SMALL LETTER I WITH DIAERESIS
    ḯ: 'i', // LATIN SMALL LETTER I WITH DIAERESIS AND ACUTE
    ị: 'i', // LATIN SMALL LETTER I WITH DOT BELOW
    ȉ: 'i', // LATIN SMALL LETTER I WITH DOUBLE GRAVE
    ì: 'i', // LATIN SMALL LETTER I WITH GRAVE
    ỉ: 'i', // LATIN SMALL LETTER I WITH HOOK ABOVE
    ȋ: 'i', // LATIN SMALL LETTER I WITH INVERTED BREVE
    ī: 'i', // LATIN SMALL LETTER I WITH MACRON
    į: 'i', // LATIN SMALL LETTER I WITH OGONEK
    ᶖ: 'i', // LATIN SMALL LETTER I WITH RETROFLEX HOOK
    ɨ: 'i', // LATIN SMALL LETTER I WITH STROKE
    ĩ: 'i', // LATIN SMALL LETTER I WITH TILDE
    ḭ: 'i', // LATIN SMALL LETTER I WITH TILDE BELOW
    ꝺ: 'd', // LATIN SMALL LETTER INSULAR D
    ꝼ: 'f', // LATIN SMALL LETTER INSULAR F
    ᵹ: 'g', // LATIN SMALL LETTER INSULAR G
    ꞃ: 'r', // LATIN SMALL LETTER INSULAR R
    ꞅ: 's', // LATIN SMALL LETTER INSULAR S
    ꞇ: 't', // LATIN SMALL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA' (ɩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA WITH STROKE' (ᵼ)
    ꝭ: 'is', // LATIN SMALL LETTER IS
    ǰ: 'j', // LATIN SMALL LETTER J WITH CARON
    ĵ: 'j', // LATIN SMALL LETTER J WITH CIRCUMFLEX
    ʝ: 'j', // LATIN SMALL LETTER J WITH CROSSED-TAIL
    ɉ: 'j', // LATIN SMALL LETTER J WITH STROKE
    ḱ: 'k', // LATIN SMALL LETTER K WITH ACUTE
    ǩ: 'k', // LATIN SMALL LETTER K WITH CARON
    ķ: 'k', // LATIN SMALL LETTER K WITH CEDILLA
    ⱪ: 'k', // LATIN SMALL LETTER K WITH DESCENDER
    ꝃ: 'k', // LATIN SMALL LETTER K WITH DIAGONAL STROKE
    ḳ: 'k', // LATIN SMALL LETTER K WITH DOT BELOW
    ƙ: 'k', // LATIN SMALL LETTER K WITH HOOK
    ḵ: 'k', // LATIN SMALL LETTER K WITH LINE BELOW
    ᶄ: 'k', // LATIN SMALL LETTER K WITH PALATAL HOOK
    ꝁ: 'k', // LATIN SMALL LETTER K WITH STROKE
    ꝅ: 'k', // LATIN SMALL LETTER K WITH STROKE AND DIAGONAL STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER KRA' (ĸ)
    ĺ: 'l', // LATIN SMALL LETTER L WITH ACUTE
    ƚ: 'l', // LATIN SMALL LETTER L WITH BAR
    ɬ: 'l', // LATIN SMALL LETTER L WITH BELT
    ľ: 'l', // LATIN SMALL LETTER L WITH CARON
    ļ: 'l', // LATIN SMALL LETTER L WITH CEDILLA
    ḽ: 'l', // LATIN SMALL LETTER L WITH CIRCUMFLEX BELOW
    ȴ: 'l', // LATIN SMALL LETTER L WITH CURL
    ḷ: 'l', // LATIN SMALL LETTER L WITH DOT BELOW
    ḹ: 'l', // LATIN SMALL LETTER L WITH DOT BELOW AND MACRON
    ⱡ: 'l', // LATIN SMALL LETTER L WITH DOUBLE BAR
    ꝉ: 'l', // LATIN SMALL LETTER L WITH HIGH STROKE
    ḻ: 'l', // LATIN SMALL LETTER L WITH LINE BELOW
    ŀ: 'l', // LATIN SMALL LETTER L WITH MIDDLE DOT
    ɫ: 'l', // LATIN SMALL LETTER L WITH MIDDLE TILDE
    ᶅ: 'l', // LATIN SMALL LETTER L WITH PALATAL HOOK
    ɭ: 'l', // LATIN SMALL LETTER L WITH RETROFLEX HOOK
    ł: 'l', // LATIN SMALL LETTER L WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LAMBDA WITH STROKE' (ƛ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LEZH' (ɮ)
    ǉ: 'lj', // LATIN SMALL LETTER LJ
    ſ: 's', // LATIN SMALL LETTER LONG S
    ẜ: 's', // LATIN SMALL LETTER LONG S WITH DIAGONAL STROKE
    ẛ: 's', // LATIN SMALL LETTER LONG S WITH DOT ABOVE
    ẝ: 's', // LATIN SMALL LETTER LONG S WITH HIGH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LS DIGRAPH' (ʪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LUM' (ꝲ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LZ DIGRAPH' (ʫ)
    ḿ: 'm', // LATIN SMALL LETTER M WITH ACUTE
    ṁ: 'm', // LATIN SMALL LETTER M WITH DOT ABOVE
    ṃ: 'm', // LATIN SMALL LETTER M WITH DOT BELOW
    ɱ: 'm', // LATIN SMALL LETTER M WITH HOOK
    ᵯ: 'm', // LATIN SMALL LETTER M WITH MIDDLE TILDE
    ᶆ: 'm', // LATIN SMALL LETTER M WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH LL' (ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH V' (ỽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MUM' (ꝳ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER N PRECEDED BY APOSTROPHE' (ŉ)
    ń: 'n', // LATIN SMALL LETTER N WITH ACUTE
    ň: 'n', // LATIN SMALL LETTER N WITH CARON
    ņ: 'n', // LATIN SMALL LETTER N WITH CEDILLA
    ṋ: 'n', // LATIN SMALL LETTER N WITH CIRCUMFLEX BELOW
    ȵ: 'n', // LATIN SMALL LETTER N WITH CURL
    ṅ: 'n', // LATIN SMALL LETTER N WITH DOT ABOVE
    ṇ: 'n', // LATIN SMALL LETTER N WITH DOT BELOW
    ǹ: 'n', // LATIN SMALL LETTER N WITH GRAVE
    ɲ: 'n', // LATIN SMALL LETTER N WITH LEFT HOOK
    ṉ: 'n', // LATIN SMALL LETTER N WITH LINE BELOW
    ƞ: 'n', // LATIN SMALL LETTER N WITH LONG RIGHT LEG
    ᵰ: 'n', // LATIN SMALL LETTER N WITH MIDDLE TILDE
    ᶇ: 'n', // LATIN SMALL LETTER N WITH PALATAL HOOK
    ɳ: 'n', // LATIN SMALL LETTER N WITH RETROFLEX HOOK
    ñ: 'n', // LATIN SMALL LETTER N WITH TILDE
    ǌ: 'nj', // LATIN SMALL LETTER NJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER NUM' (ꝴ)
    ó: 'o', // LATIN SMALL LETTER O WITH ACUTE
    ŏ: 'o', // LATIN SMALL LETTER O WITH BREVE
    ǒ: 'o', // LATIN SMALL LETTER O WITH CARON
    ô: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX
    ố: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND ACUTE
    ộ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    ồ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND GRAVE
    ổ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    ỗ: 'o', // LATIN SMALL LETTER O WITH CIRCUMFLEX AND TILDE
    ö: 'o', // LATIN SMALL LETTER O WITH DIAERESIS
    ȫ: 'o', // LATIN SMALL LETTER O WITH DIAERESIS AND MACRON
    ȯ: 'o', // LATIN SMALL LETTER O WITH DOT ABOVE
    ȱ: 'o', // LATIN SMALL LETTER O WITH DOT ABOVE AND MACRON
    ọ: 'o', // LATIN SMALL LETTER O WITH DOT BELOW
    ő: 'o', // LATIN SMALL LETTER O WITH DOUBLE ACUTE
    ȍ: 'o', // LATIN SMALL LETTER O WITH DOUBLE GRAVE
    ò: 'o', // LATIN SMALL LETTER O WITH GRAVE
    ỏ: 'o', // LATIN SMALL LETTER O WITH HOOK ABOVE
    ơ: 'o', // LATIN SMALL LETTER O WITH HORN
    ớ: 'o', // LATIN SMALL LETTER O WITH HORN AND ACUTE
    ợ: 'o', // LATIN SMALL LETTER O WITH HORN AND DOT BELOW
    ờ: 'o', // LATIN SMALL LETTER O WITH HORN AND GRAVE
    ở: 'o', // LATIN SMALL LETTER O WITH HORN AND HOOK ABOVE
    ỡ: 'o', // LATIN SMALL LETTER O WITH HORN AND TILDE
    ȏ: 'o', // LATIN SMALL LETTER O WITH INVERTED BREVE
    ꝋ: 'o', // LATIN SMALL LETTER O WITH LONG STROKE OVERLAY
    ꝍ: 'o', // LATIN SMALL LETTER O WITH LOOP
    ⱺ: 'o', // LATIN SMALL LETTER O WITH LOW RING INSIDE
    ō: 'o', // LATIN SMALL LETTER O WITH MACRON
    ṓ: 'o', // LATIN SMALL LETTER O WITH MACRON AND ACUTE
    ṑ: 'o', // LATIN SMALL LETTER O WITH MACRON AND GRAVE
    ǫ: 'o', // LATIN SMALL LETTER O WITH OGONEK
    ǭ: 'o', // LATIN SMALL LETTER O WITH OGONEK AND MACRON
    ø: 'o', // LATIN SMALL LETTER O WITH STROKE
    ǿ: 'o', // LATIN SMALL LETTER O WITH STROKE AND ACUTE
    õ: 'o', // LATIN SMALL LETTER O WITH TILDE
    ṍ: 'o', // LATIN SMALL LETTER O WITH TILDE AND ACUTE
    ṏ: 'o', // LATIN SMALL LETTER O WITH TILDE AND DIAERESIS
    ȭ: 'o', // LATIN SMALL LETTER O WITH TILDE AND MACRON
    ƣ: 'oi', // LATIN SMALL LETTER OI
    ꝏ: 'oo', // LATIN SMALL LETTER OO
    ɛ: 'e', // LATIN SMALL LETTER OPEN E
    ᶓ: 'e', // LATIN SMALL LETTER OPEN E WITH RETROFLEX HOOK
    ɔ: 'o', // LATIN SMALL LETTER OPEN O
    ᶗ: 'o', // LATIN SMALL LETTER OPEN O WITH RETROFLEX HOOK
    ȣ: 'ou', // LATIN SMALL LETTER OU
    ṕ: 'p', // LATIN SMALL LETTER P WITH ACUTE
    ṗ: 'p', // LATIN SMALL LETTER P WITH DOT ABOVE
    ꝓ: 'p', // LATIN SMALL LETTER P WITH FLOURISH
    ƥ: 'p', // LATIN SMALL LETTER P WITH HOOK
    ᵱ: 'p', // LATIN SMALL LETTER P WITH MIDDLE TILDE
    ᶈ: 'p', // LATIN SMALL LETTER P WITH PALATAL HOOK
    ꝕ: 'p', // LATIN SMALL LETTER P WITH SQUIRREL TAIL
    ᵽ: 'p', // LATIN SMALL LETTER P WITH STROKE
    ꝑ: 'p', // LATIN SMALL LETTER P WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER PHI' (ɸ)
    ꝙ: 'q', // LATIN SMALL LETTER Q WITH DIAGONAL STROKE
    ʠ: 'q', // LATIN SMALL LETTER Q WITH HOOK
    ɋ: 'q', // LATIN SMALL LETTER Q WITH HOOK TAIL
    ꝗ: 'q', // LATIN SMALL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER QP DIGRAPH' (ȹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER R ROTUNDA' (ꝛ)
    ŕ: 'r', // LATIN SMALL LETTER R WITH ACUTE
    ř: 'r', // LATIN SMALL LETTER R WITH CARON
    ŗ: 'r', // LATIN SMALL LETTER R WITH CEDILLA
    ṙ: 'r', // LATIN SMALL LETTER R WITH DOT ABOVE
    ṛ: 'r', // LATIN SMALL LETTER R WITH DOT BELOW
    ṝ: 'r', // LATIN SMALL LETTER R WITH DOT BELOW AND MACRON
    ȑ: 'r', // LATIN SMALL LETTER R WITH DOUBLE GRAVE
    ɾ: 'r', // LATIN SMALL LETTER R WITH FISHHOOK
    ᵳ: 'r', // LATIN SMALL LETTER R WITH FISHHOOK AND MIDDLE TILDE
    ȓ: 'r', // LATIN SMALL LETTER R WITH INVERTED BREVE
    ṟ: 'r', // LATIN SMALL LETTER R WITH LINE BELOW
    ɼ: 'r', // LATIN SMALL LETTER R WITH LONG LEG
    ᵲ: 'r', // LATIN SMALL LETTER R WITH MIDDLE TILDE
    ᶉ: 'r', // LATIN SMALL LETTER R WITH PALATAL HOOK
    ɍ: 'r', // LATIN SMALL LETTER R WITH STROKE
    ɽ: 'r', // LATIN SMALL LETTER R WITH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RAMS HORN' (ɤ)
    ↄ: 'c', // LATIN SMALL LETTER REVERSED C
    ꜿ: 'c', // LATIN SMALL LETTER REVERSED C WITH DOT
    ɘ: 'e', // LATIN SMALL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E' (ɜ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH HOOK' (ɝ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH RETROFLEX HOOK' (ᶔ)
    ɿ: 'r', // LATIN SMALL LETTER REVERSED R WITH FISHHOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM' (ꝵ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM ROTUNDA' (ꝝ)
    ś: 's', // LATIN SMALL LETTER S WITH ACUTE
    ṥ: 's', // LATIN SMALL LETTER S WITH ACUTE AND DOT ABOVE
    š: 's', // LATIN SMALL LETTER S WITH CARON
    ṧ: 's', // LATIN SMALL LETTER S WITH CARON AND DOT ABOVE
    ş: 's', // LATIN SMALL LETTER S WITH CEDILLA
    ŝ: 's', // LATIN SMALL LETTER S WITH CIRCUMFLEX
    ș: 's', // LATIN SMALL LETTER S WITH COMMA BELOW
    ṡ: 's', // LATIN SMALL LETTER S WITH DOT ABOVE
    ṣ: 's', // LATIN SMALL LETTER S WITH DOT BELOW
    ṩ: 's', // LATIN SMALL LETTER S WITH DOT BELOW AND DOT ABOVE
    ʂ: 's', // LATIN SMALL LETTER S WITH HOOK
    ᵴ: 's', // LATIN SMALL LETTER S WITH MIDDLE TILDE
    ᶊ: 's', // LATIN SMALL LETTER S WITH PALATAL HOOK
    ȿ: 's', // LATIN SMALL LETTER S WITH SWASH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SALTILLO' (ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA' (ə)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH HOOK' (ɚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH RETROFLEX HOOK' (ᶕ)
    ɡ: 'g', // LATIN SMALL LETTER SCRIPT G
    ß: 'ss', // LATIN SMALL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS DIAERESIZED U' (ᴞ)
    ᴑ: 'o', // LATIN SMALL LETTER SIDEWAYS O
    ᴓ: 'o', // LATIN SMALL LETTER SIDEWAYS O WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS OPEN O' (ᴒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS TURNED M' (ᴟ)
    ᴝ: 'u', // LATIN SMALL LETTER SIDEWAYS U
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SQUAT REVERSED ESH' (ʅ)
    ť: 't', // LATIN SMALL LETTER T WITH CARON
    ţ: 't', // LATIN SMALL LETTER T WITH CEDILLA
    ṱ: 't', // LATIN SMALL LETTER T WITH CIRCUMFLEX BELOW
    ț: 't', // LATIN SMALL LETTER T WITH COMMA BELOW
    ȶ: 't', // LATIN SMALL LETTER T WITH CURL
    ẗ: 't', // LATIN SMALL LETTER T WITH DIAERESIS
    ⱦ: 't', // LATIN SMALL LETTER T WITH DIAGONAL STROKE
    ṫ: 't', // LATIN SMALL LETTER T WITH DOT ABOVE
    ṭ: 't', // LATIN SMALL LETTER T WITH DOT BELOW
    ƭ: 't', // LATIN SMALL LETTER T WITH HOOK
    ṯ: 't', // LATIN SMALL LETTER T WITH LINE BELOW
    ᵵ: 't', // LATIN SMALL LETTER T WITH MIDDLE TILDE
    ƫ: 't', // LATIN SMALL LETTER T WITH PALATAL HOOK
    ʈ: 't', // LATIN SMALL LETTER T WITH RETROFLEX HOOK
    ŧ: 't', // LATIN SMALL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TAILLESS PHI' (ⱷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TC DIGRAPH WITH CURL' (ʨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TESH DIGRAPH' (ʧ)
    ᵺ: 'th', // LATIN SMALL LETTER TH WITH STRIKETHROUGH
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN' (þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE' (ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE THROUGH DESCENDER' (ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE FIVE' (ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE SIX' (ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE TWO' (ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TOP HALF O' (ᴖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TRESILLO' (ꜫ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TS DIGRAPH' (ʦ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TUM' (ꝷ)
    ɐ: 'a', // LATIN SMALL LETTER TURNED A
    ᴂ: 'ae', // LATIN SMALL LETTER TURNED AE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED ALPHA' (ɒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED DELTA' (ƍ)
    ǝ: 'e', // LATIN SMALL LETTER TURNED E
    ᵷ: 'g', // LATIN SMALL LETTER TURNED G
    ɥ: 'h', // LATIN SMALL LETTER TURNED H
    ʮ: 'h', // LATIN SMALL LETTER TURNED H WITH FISHHOOK
    ʯ: 'h', // LATIN SMALL LETTER TURNED H WITH FISHHOOK AND TAIL
    ᴉ: 'i', // LATIN SMALL LETTER TURNED I
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED INSULAR G' (ꝿ)
    ʞ: 'k', // LATIN SMALL LETTER TURNED K
    ꞁ: 'l', // LATIN SMALL LETTER TURNED L
    ɯ: 'm', // LATIN SMALL LETTER TURNED M
    ɰ: 'm', // LATIN SMALL LETTER TURNED M WITH LONG LEG
    ᴔ: 'oe', // LATIN SMALL LETTER TURNED OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED OPEN E' (ᴈ)
    ɹ: 'r', // LATIN SMALL LETTER TURNED R
    ɻ: 'r', // LATIN SMALL LETTER TURNED R WITH HOOK
    ɺ: 'r', // LATIN SMALL LETTER TURNED R WITH LONG LEG
    ⱹ: 'r', // LATIN SMALL LETTER TURNED R WITH TAIL
    ʇ: 't', // LATIN SMALL LETTER TURNED T
    ʌ: 'v', // LATIN SMALL LETTER TURNED V
    ʍ: 'w', // LATIN SMALL LETTER TURNED W
    ʎ: 'y', // LATIN SMALL LETTER TURNED Y
    ꜩ: 'tz', // LATIN SMALL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER U BAR' (ʉ)
    ú: 'u', // LATIN SMALL LETTER U WITH ACUTE
    ŭ: 'u', // LATIN SMALL LETTER U WITH BREVE
    ǔ: 'u', // LATIN SMALL LETTER U WITH CARON
    û: 'u', // LATIN SMALL LETTER U WITH CIRCUMFLEX
    ṷ: 'u', // LATIN SMALL LETTER U WITH CIRCUMFLEX BELOW
    ü: 'u', // LATIN SMALL LETTER U WITH DIAERESIS
    ǘ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND ACUTE
    ǚ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND CARON
    ǜ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND GRAVE
    ǖ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS AND MACRON
    ṳ: 'u', // LATIN SMALL LETTER U WITH DIAERESIS BELOW
    ụ: 'u', // LATIN SMALL LETTER U WITH DOT BELOW
    ű: 'u', // LATIN SMALL LETTER U WITH DOUBLE ACUTE
    ȕ: 'u', // LATIN SMALL LETTER U WITH DOUBLE GRAVE
    ù: 'u', // LATIN SMALL LETTER U WITH GRAVE
    ủ: 'u', // LATIN SMALL LETTER U WITH HOOK ABOVE
    ư: 'u', // LATIN SMALL LETTER U WITH HORN
    ứ: 'u', // LATIN SMALL LETTER U WITH HORN AND ACUTE
    ự: 'u', // LATIN SMALL LETTER U WITH HORN AND DOT BELOW
    ừ: 'u', // LATIN SMALL LETTER U WITH HORN AND GRAVE
    ử: 'u', // LATIN SMALL LETTER U WITH HORN AND HOOK ABOVE
    ữ: 'u', // LATIN SMALL LETTER U WITH HORN AND TILDE
    ȗ: 'u', // LATIN SMALL LETTER U WITH INVERTED BREVE
    ū: 'u', // LATIN SMALL LETTER U WITH MACRON
    ṻ: 'u', // LATIN SMALL LETTER U WITH MACRON AND DIAERESIS
    ų: 'u', // LATIN SMALL LETTER U WITH OGONEK
    ᶙ: 'u', // LATIN SMALL LETTER U WITH RETROFLEX HOOK
    ů: 'u', // LATIN SMALL LETTER U WITH RING ABOVE
    ũ: 'u', // LATIN SMALL LETTER U WITH TILDE
    ṹ: 'u', // LATIN SMALL LETTER U WITH TILDE AND ACUTE
    ṵ: 'u', // LATIN SMALL LETTER U WITH TILDE BELOW
    ᵫ: 'ue', // LATIN SMALL LETTER UE
    ꝸ: 'um', // LATIN SMALL LETTER UM
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON' (ʊ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON WITH STROKE' (ᵿ)
    ⱴ: 'v', // LATIN SMALL LETTER V WITH CURL
    ꝟ: 'v', // LATIN SMALL LETTER V WITH DIAGONAL STROKE
    ṿ: 'v', // LATIN SMALL LETTER V WITH DOT BELOW
    ʋ: 'v', // LATIN SMALL LETTER V WITH HOOK
    ᶌ: 'v', // LATIN SMALL LETTER V WITH PALATAL HOOK
    ⱱ: 'v', // LATIN SMALL LETTER V WITH RIGHT HOOK
    ṽ: 'v', // LATIN SMALL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VEND' (ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VISIGOTHIC Z' (ꝣ)
    ꝡ: 'vy', // LATIN SMALL LETTER VY
    ẃ: 'w', // LATIN SMALL LETTER W WITH ACUTE
    ŵ: 'w', // LATIN SMALL LETTER W WITH CIRCUMFLEX
    ẅ: 'w', // LATIN SMALL LETTER W WITH DIAERESIS
    ẇ: 'w', // LATIN SMALL LETTER W WITH DOT ABOVE
    ẉ: 'w', // LATIN SMALL LETTER W WITH DOT BELOW
    ẁ: 'w', // LATIN SMALL LETTER W WITH GRAVE
    ⱳ: 'w', // LATIN SMALL LETTER W WITH HOOK
    ẘ: 'w', // LATIN SMALL LETTER W WITH RING ABOVE
    ẍ: 'x', // LATIN SMALL LETTER X WITH DIAERESIS
    ẋ: 'x', // LATIN SMALL LETTER X WITH DOT ABOVE
    ᶍ: 'x', // LATIN SMALL LETTER X WITH PALATAL HOOK
    ý: 'y', // LATIN SMALL LETTER Y WITH ACUTE
    ŷ: 'y', // LATIN SMALL LETTER Y WITH CIRCUMFLEX
    ÿ: 'y', // LATIN SMALL LETTER Y WITH DIAERESIS
    ẏ: 'y', // LATIN SMALL LETTER Y WITH DOT ABOVE
    ỵ: 'y', // LATIN SMALL LETTER Y WITH DOT BELOW
    ỳ: 'y', // LATIN SMALL LETTER Y WITH GRAVE
    ƴ: 'y', // LATIN SMALL LETTER Y WITH HOOK
    ỷ: 'y', // LATIN SMALL LETTER Y WITH HOOK ABOVE
    ỿ: 'y', // LATIN SMALL LETTER Y WITH LOOP
    ȳ: 'y', // LATIN SMALL LETTER Y WITH MACRON
    ẙ: 'y', // LATIN SMALL LETTER Y WITH RING ABOVE
    ɏ: 'y', // LATIN SMALL LETTER Y WITH STROKE
    ỹ: 'y', // LATIN SMALL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER YOGH' (ȝ)
    ź: 'z', // LATIN SMALL LETTER Z WITH ACUTE
    ž: 'z', // LATIN SMALL LETTER Z WITH CARON
    ẑ: 'z', // LATIN SMALL LETTER Z WITH CIRCUMFLEX
    ʑ: 'z', // LATIN SMALL LETTER Z WITH CURL
    ⱬ: 'z', // LATIN SMALL LETTER Z WITH DESCENDER
    ż: 'z', // LATIN SMALL LETTER Z WITH DOT ABOVE
    ẓ: 'z', // LATIN SMALL LETTER Z WITH DOT BELOW
    ȥ: 'z', // LATIN SMALL LETTER Z WITH HOOK
    ẕ: 'z', // LATIN SMALL LETTER Z WITH LINE BELOW
    ᵶ: 'z', // LATIN SMALL LETTER Z WITH MIDDLE TILDE
    ᶎ: 'z', // LATIN SMALL LETTER Z WITH PALATAL HOOK
    ʐ: 'z', // LATIN SMALL LETTER Z WITH RETROFLEX HOOK
    ƶ: 'z', // LATIN SMALL LETTER Z WITH STROKE
    ɀ: 'z', // LATIN SMALL LETTER Z WITH SWASH TAIL
    ﬀ: 'ff', // LATIN SMALL LIGATURE FF
    ﬃ: 'ffi', // LATIN SMALL LIGATURE FFI
    ﬄ: 'ffl', // LATIN SMALL LIGATURE FFL
    ﬁ: 'fi', // LATIN SMALL LIGATURE FI
    ﬂ: 'fl', // LATIN SMALL LIGATURE FL
    ĳ: 'ij', // LATIN SMALL LIGATURE IJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LIGATURE LONG S T' (ﬅ)
    œ: 'oe', // LATIN SMALL LIGATURE OE
    ﬆ: 'st', // LATIN SMALL LIGATURE ST
    ₐ: 'a', // LATIN SUBSCRIPT SMALL LETTER A
    ₑ: 'e', // LATIN SUBSCRIPT SMALL LETTER E
    ᵢ: 'i', // LATIN SUBSCRIPT SMALL LETTER I
    ⱼ: 'j', // LATIN SUBSCRIPT SMALL LETTER J
    ₒ: 'o', // LATIN SUBSCRIPT SMALL LETTER O
    ᵣ: 'r', // LATIN SUBSCRIPT SMALL LETTER R
    // CANNOT FIND APPROXIMATION FOR 'LATIN SUBSCRIPT SMALL LETTER SCHWA' (ₔ)
    ᵤ: 'u', // LATIN SUBSCRIPT SMALL LETTER U
    ᵥ: 'v', // LATIN SUBSCRIPT SMALL LETTER V
    ₓ: 'x' // LATIN SUBSCRIPT SMALL LETTER X
};

function map(x) {
    return latinMap[x] || x;
}

function latinise(input) {
    return input.replace(/[^A-Za-z0-9]/g, map);
}

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1064), __esModule: true };


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(1065);
module.exports = __webpack_require__(15).Reflect.apply;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(31)
  , aFunction = __webpack_require__(203)
  , anObject  = __webpack_require__(65)
  , rApply    = (__webpack_require__(38).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(101)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

module.exports = { "default": __webpack_require__(1067), __esModule: true };


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(141);
__webpack_require__(118);
module.exports = __webpack_require__(1068);


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var classof   = __webpack_require__(207)
  , ITERATOR  = __webpack_require__(32)('iterator')
  , Iterators = __webpack_require__(139);
module.exports = __webpack_require__(15).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(200);
__webpack_require__(118);
__webpack_require__(141);
__webpack_require__(1070);
__webpack_require__(1071);
module.exports = __webpack_require__(15).Map;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';
var strong = __webpack_require__(442);

// 23.1 Map Objects
module.exports = __webpack_require__(443)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(31);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(444)('Map')});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _event_emitter = __webpack_require__(210);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

var _constants = __webpack_require__(8);

var _fetch_etag = __webpack_require__(445);

var _fetch_etag2 = _interopRequireDefault(_fetch_etag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormData = __webpack_require__(295);

var HEADER_AUTH = 'Authorization';
var HEADER_BEARER = 'BEARER';
var HEADER_REQUESTED_WITH = 'X-Requested-With';
var HEADER_TOKEN = 'Token';
var HEADER_X_VERSION_ID = 'X-Version-Id';
var HEADER_USER_AGENT = 'User-Agent';
var HEADER_ACCEPT_LANGUAGE = 'Accept-Language';

var Client = function () {
    function Client() {
        var _this = this;

        _classCallCheck(this, Client);

        this.getClientConfig = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', _this.doFetch(_this.getGeneralRoute() + '/client_props', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));
        this.getLicenseConfig = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', _this.doFetch(_this.getLicenseRoute() + '/client_config', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));
        this.getPing = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', _this.doFetch(_this.getGeneralRoute() + '/ping?time=' + Date.now(), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        this.logClientError = function () {
            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(message) {
                var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ERROR';
                var body;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                body = {
                                    message: message,
                                    level: level
                                };
                                return _context4.abrupt('return', _this.doFetch(_this.getGeneralRoute() + '/log_client', { method: 'post', body: JSON.stringify(body) }));

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));

            return function (_x) {
                return _ref4.apply(this, arguments);
            };
        }();

        this.createUser = function () {
            var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(user) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                return _context5.abrupt('return', _this.createUserWithInvite(user));

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this);
            }));

            return function (_x3) {
                return _ref5.apply(this, arguments);
            };
        }();

        this.createUserWithInvite = function () {
            var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(user, data, emailHash, inviteId) {
                var url;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                url = _this.getUsersRoute() + '/create';


                                url += '?d=' + encodeURIComponent(data);

                                if (emailHash) {
                                    url += '&h=' + encodeURIComponent(emailHash);
                                }

                                if (inviteId) {
                                    url += '&iid=' + encodeURIComponent(inviteId);
                                }

                                return _context6.abrupt('return', _this.doFetch(url, { method: 'post', body: JSON.stringify(user) }));

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this);
            }));

            return function (_x4, _x5, _x6, _x7) {
                return _ref6.apply(this, arguments);
            };
        }();

        this.checkMfa = function () {
            var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(loginId) {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                return _context7.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/mfa', { method: 'post', body: JSON.stringify({ login_id: loginId }) }));

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this);
            }));

            return function (_x8) {
                return _ref7.apply(this, arguments);
            };
        }();

        this.login = function () {
            var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(loginId, password) {
                var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var deviceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                var body, _ref9, headers, data;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                body = {
                                    device_id: deviceId,
                                    login_id: loginId,
                                    password: password,
                                    token: token
                                };
                                _context8.next = 3;
                                return _this.doFetchWithResponse(_this.getUsersRoute() + '/login', { method: 'post', body: JSON.stringify(body) });

                            case 3:
                                _ref9 = _context8.sent;
                                headers = _ref9.headers;
                                data = _ref9.data;


                                if (headers.has(HEADER_TOKEN)) {
                                    _this.token = headers.get(HEADER_TOKEN);
                                }

                                return _context8.abrupt('return', data);

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this);
            }));

            return function (_x9, _x10) {
                return _ref8.apply(this, arguments);
            };
        }();

        this.logout = _asyncToGenerator(regeneratorRuntime.mark(function _callee9() {
            var _ref11, response;

            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return _this.doFetchWithResponse(_this.getUsersRoute() + '/logout', { method: 'post' });

                        case 2:
                            _ref11 = _context9.sent;
                            response = _ref11.response;

                            if (response.ok) {
                                _this.token = '';
                            }
                            _this.serverVersion = '';
                            return _context9.abrupt('return', response);

                        case 7:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this);
        }));

        this.attachDevice = function () {
            var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(deviceId) {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                return _context10.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/attach_device', { method: 'post', body: JSON.stringify({ device_id: deviceId }) }));

                            case 1:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this);
            }));

            return function (_x13) {
                return _ref12.apply(this, arguments);
            };
        }();

        this.updateUser = function () {
            var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(user) {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                return _context11.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/update', { method: 'post', body: JSON.stringify(user) }));

                            case 1:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this);
            }));

            return function (_x14) {
                return _ref13.apply(this, arguments);
            };
        }();

        this.updatePassword = function () {
            var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(userId, currentPassword, newPassword) {
                var data;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                data = {
                                    user_id: userId,
                                    current_password: currentPassword,
                                    new_password: newPassword
                                };
                                return _context12.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/newpassword', { method: 'post', body: JSON.stringify(data) }));

                            case 2:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this);
            }));

            return function (_x15, _x16, _x17) {
                return _ref14.apply(this, arguments);
            };
        }();

        this.updateUserNotifyProps = function () {
            var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(notifyProps) {
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                return _context13.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/update_notify', { method: 'post', body: JSON.stringify(notifyProps) }));

                            case 1:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this);
            }));

            return function (_x18) {
                return _ref15.apply(this, arguments);
            };
        }();

        this.updateUserRoles = function () {
            var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(userId, newRoles) {
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                return _context14.abrupt('return', _this.doFetch(_this.getUserNeededRoute(userId) + '/update_roles', { method: 'post', body: JSON.stringify({ new_roles: newRoles }) }));

                            case 1:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this);
            }));

            return function (_x19, _x20) {
                return _ref16.apply(this, arguments);
            };
        }();

        this.getMe = _asyncToGenerator(regeneratorRuntime.mark(function _callee15() {
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            return _context15.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/me', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this);
        }));

        this.getProfiles = function () {
            var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(offset, limit) {
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                return _context16.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this);
            }));

            return function (_x21, _x22) {
                return _ref18.apply(this, arguments);
            };
        }();

        this.getProfilesByIds = function () {
            var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(userIds) {
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                return _context17.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this);
            }));

            return function (_x23) {
                return _ref19.apply(this, arguments);
            };
        }();

        this.getProfilesInTeam = function () {
            var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(teamId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                return _context18.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/users/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, _this);
            }));

            return function (_x24, _x25, _x26) {
                return _ref20.apply(this, arguments);
            };
        }();

        this.getProfilesInChannel = function () {
            var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(teamId, channelId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                return _context19.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/users/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, _this);
            }));

            return function (_x27, _x28, _x29, _x30) {
                return _ref21.apply(this, arguments);
            };
        }();

        this.getProfilesNotInChannel = function () {
            var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(teamId, channelId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                return _context20.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/users/not_in_channel/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, _this);
            }));

            return function (_x31, _x32, _x33, _x34) {
                return _ref22.apply(this, arguments);
            };
        }();

        this.getUser = function () {
            var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21(userId) {
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                return _context21.abrupt('return', _this.doFetch(_this.getUserNeededRoute(userId) + '/get', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context21.stop();
                        }
                    }
                }, _callee21, _this);
            }));

            return function (_x35) {
                return _ref23.apply(this, arguments);
            };
        }();

        this.getUserByUsername = function () {
            var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(username) {
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                return _context22.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/name/' + username, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, _this);
            }));

            return function (_x36) {
                return _ref24.apply(this, arguments);
            };
        }();

        this.getStatusesByIds = function () {
            var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23(userIds) {
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                        switch (_context23.prev = _context23.next) {
                            case 0:
                                return _context23.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/status/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context23.stop();
                        }
                    }
                }, _callee23, _this);
            }));

            return function (_x37) {
                return _ref25.apply(this, arguments);
            };
        }();

        this.getSessions = function () {
            var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee24(userId) {
                return regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                        switch (_context24.prev = _context24.next) {
                            case 0:
                                return _context24.abrupt('return', _this.doFetch(_this.getUserNeededRoute(userId) + '/sessions', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context24.stop();
                        }
                    }
                }, _callee24, _this);
            }));

            return function (_x38) {
                return _ref26.apply(this, arguments);
            };
        }();

        this.revokeSession = function () {
            var _ref27 = _asyncToGenerator(regeneratorRuntime.mark(function _callee25(id) {
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                return _context25.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/revoke_session', { method: 'post', body: JSON.stringify({ id: id }) }));

                            case 1:
                            case 'end':
                                return _context25.stop();
                        }
                    }
                }, _callee25, _this);
            }));

            return function (_x39) {
                return _ref27.apply(this, arguments);
            };
        }();

        this.getAudits = function () {
            var _ref28 = _asyncToGenerator(regeneratorRuntime.mark(function _callee26(userId) {
                return regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                return _context26.abrupt('return', _this.doFetch(_this.getUserNeededRoute(userId) + '/audits', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context26.stop();
                        }
                    }
                }, _callee26, _this);
            }));

            return function (_x40) {
                return _ref28.apply(this, arguments);
            };
        }();

        this.getProfilePictureUrl = function (userId, lastPictureUpdate) {
            var params = '';
            if (lastPictureUpdate) {
                params = '?time=' + lastPictureUpdate;
            }

            return _this.getUsersRoute() + '/' + userId + '/image' + params;
        };

        this.autocompleteUsersInChannel = function (teamId, channelId, term) {
            return _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/users/autocomplete?term=' + encodeURIComponent(term), { method: 'get' });
        };

        this.searchProfiles = function (term, options) {
            return _this.doFetch(_this.getUsersRoute() + '/search', { method: 'post', body: JSON.stringify(_extends({ term: term }, options)) });
        };

        this.createTeam = function () {
            var _ref29 = _asyncToGenerator(regeneratorRuntime.mark(function _callee27(team) {
                return regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                return _context27.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/create', { method: 'post', body: JSON.stringify(team) }));

                            case 1:
                            case 'end':
                                return _context27.stop();
                        }
                    }
                }, _callee27, _this);
            }));

            return function (_x41) {
                return _ref29.apply(this, arguments);
            };
        }();

        this.updateTeam = function () {
            var _ref30 = _asyncToGenerator(regeneratorRuntime.mark(function _callee28(team) {
                return regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                        switch (_context28.prev = _context28.next) {
                            case 0:
                                return _context28.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(team.id) + '/update', { method: 'post', body: JSON.stringify(team) }));

                            case 1:
                            case 'end':
                                return _context28.stop();
                        }
                    }
                }, _callee28, _this);
            }));

            return function (_x42) {
                return _ref30.apply(this, arguments);
            };
        }();

        this.getAllTeams = _asyncToGenerator(regeneratorRuntime.mark(function _callee29() {
            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            return _context29.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/all', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this);
        }));
        this.getMyTeamMembers = _asyncToGenerator(regeneratorRuntime.mark(function _callee30() {
            return regeneratorRuntime.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            return _context30.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/members', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, _this);
        }));
        this.getAllTeamListings = _asyncToGenerator(regeneratorRuntime.mark(function _callee31() {
            return regeneratorRuntime.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            return _context31.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/all_team_listings', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, _this);
        }));

        this.getTeamMember = function () {
            var _ref34 = _asyncToGenerator(regeneratorRuntime.mark(function _callee32(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee32$(_context32) {
                    while (1) {
                        switch (_context32.prev = _context32.next) {
                            case 0:
                                return _context32.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/members/' + userId, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context32.stop();
                        }
                    }
                }, _callee32, _this);
            }));

            return function (_x43, _x44) {
                return _ref34.apply(this, arguments);
            };
        }();

        this.getTeamMemberByIds = function () {
            var _ref35 = _asyncToGenerator(regeneratorRuntime.mark(function _callee33(teamId, userIds) {
                return regeneratorRuntime.wrap(function _callee33$(_context33) {
                    while (1) {
                        switch (_context33.prev = _context33.next) {
                            case 0:
                                return _context33.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/members/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context33.stop();
                        }
                    }
                }, _callee33, _this);
            }));

            return function (_x45, _x46) {
                return _ref35.apply(this, arguments);
            };
        }();

        this.getTeamStats = function () {
            var _ref36 = _asyncToGenerator(regeneratorRuntime.mark(function _callee34(teamId) {
                return regeneratorRuntime.wrap(function _callee34$(_context34) {
                    while (1) {
                        switch (_context34.prev = _context34.next) {
                            case 0:
                                return _context34.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/stats', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context34.stop();
                        }
                    }
                }, _callee34, _this);
            }));

            return function (_x47) {
                return _ref36.apply(this, arguments);
            };
        }();

        this.addUserToTeam = function () {
            var _ref37 = _asyncToGenerator(regeneratorRuntime.mark(function _callee35(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee35$(_context35) {
                    while (1) {
                        switch (_context35.prev = _context35.next) {
                            case 0:
                                return _context35.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/add_user_to_team', { method: 'post', body: JSON.stringify({ user_id: userId }) }));

                            case 1:
                            case 'end':
                                return _context35.stop();
                        }
                    }
                }, _callee35, _this);
            }));

            return function (_x48, _x49) {
                return _ref37.apply(this, arguments);
            };
        }();

        this.joinTeamFromInvite = function () {
            var _ref38 = _asyncToGenerator(regeneratorRuntime.mark(function _callee36(inviteId) {
                return regeneratorRuntime.wrap(function _callee36$(_context36) {
                    while (1) {
                        switch (_context36.prev = _context36.next) {
                            case 0:
                                return _context36.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/add_user_to_team_from_invite', { method: 'post', body: JSON.stringify({ invite_id: inviteId }) }));

                            case 1:
                            case 'end':
                                return _context36.stop();
                        }
                    }
                }, _callee36, _this);
            }));

            return function (_x50) {
                return _ref38.apply(this, arguments);
            };
        }();

        this.removeUserFromTeam = function () {
            var _ref39 = _asyncToGenerator(regeneratorRuntime.mark(function _callee37(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee37$(_context37) {
                    while (1) {
                        switch (_context37.prev = _context37.next) {
                            case 0:
                                return _context37.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/remove_user_from_team', { method: 'post', body: JSON.stringify({ user_id: userId }) }));

                            case 1:
                            case 'end':
                                return _context37.stop();
                        }
                    }
                }, _callee37, _this);
            }));

            return function (_x51, _x52) {
                return _ref39.apply(this, arguments);
            };
        }();

        this.createChannel = function () {
            var _ref40 = _asyncToGenerator(regeneratorRuntime.mark(function _callee38(channel) {
                return regeneratorRuntime.wrap(function _callee38$(_context38) {
                    while (1) {
                        switch (_context38.prev = _context38.next) {
                            case 0:
                                return _context38.abrupt('return', _this.doFetch(_this.getChannelsRoute(channel.team_id) + '/create', { method: 'post', body: JSON.stringify(channel) }));

                            case 1:
                            case 'end':
                                return _context38.stop();
                        }
                    }
                }, _callee38, _this);
            }));

            return function (_x53) {
                return _ref40.apply(this, arguments);
            };
        }();

        this.createDirectChannel = function () {
            var _ref41 = _asyncToGenerator(regeneratorRuntime.mark(function _callee39(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee39$(_context39) {
                    while (1) {
                        switch (_context39.prev = _context39.next) {
                            case 0:
                                return _context39.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/create_direct', { method: 'post', body: JSON.stringify({ user_id: userId }) }));

                            case 1:
                            case 'end':
                                return _context39.stop();
                        }
                    }
                }, _callee39, _this);
            }));

            return function (_x54, _x55) {
                return _ref41.apply(this, arguments);
            };
        }();

        this.getChannel = function () {
            var _ref42 = _asyncToGenerator(regeneratorRuntime.mark(function _callee40(teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee40$(_context40) {
                    while (1) {
                        switch (_context40.prev = _context40.next) {
                            case 0:
                                return _context40.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context40.stop();
                        }
                    }
                }, _callee40, _this);
            }));

            return function (_x56, _x57) {
                return _ref42.apply(this, arguments);
            };
        }();

        this.getChannels = function () {
            var _ref43 = _asyncToGenerator(regeneratorRuntime.mark(function _callee41(teamId) {
                return regeneratorRuntime.wrap(function _callee41$(_context41) {
                    while (1) {
                        switch (_context41.prev = _context41.next) {
                            case 0:
                                return _context41.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context41.stop();
                        }
                    }
                }, _callee41, _this);
            }));

            return function (_x58) {
                return _ref43.apply(this, arguments);
            };
        }();

        this.getMyChannelMembers = function () {
            var _ref44 = _asyncToGenerator(regeneratorRuntime.mark(function _callee42(teamId) {
                return regeneratorRuntime.wrap(function _callee42$(_context42) {
                    while (1) {
                        switch (_context42.prev = _context42.next) {
                            case 0:
                                return _context42.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/members', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context42.stop();
                        }
                    }
                }, _callee42, _this);
            }));

            return function (_x59) {
                return _ref44.apply(this, arguments);
            };
        }();

        this.updateChannel = function () {
            var _ref45 = _asyncToGenerator(regeneratorRuntime.mark(function _callee43(channel) {
                return regeneratorRuntime.wrap(function _callee43$(_context43) {
                    while (1) {
                        switch (_context43.prev = _context43.next) {
                            case 0:
                                return _context43.abrupt('return', _this.doFetch(_this.getChannelsRoute(channel.team_id) + '/update', { method: 'post', body: JSON.stringify(channel) }));

                            case 1:
                            case 'end':
                                return _context43.stop();
                        }
                    }
                }, _callee43, _this);
            }));

            return function (_x60) {
                return _ref45.apply(this, arguments);
            };
        }();

        this.updateChannelNotifyProps = function () {
            var _ref46 = _asyncToGenerator(regeneratorRuntime.mark(function _callee44(teamId, data) {
                return regeneratorRuntime.wrap(function _callee44$(_context44) {
                    while (1) {
                        switch (_context44.prev = _context44.next) {
                            case 0:
                                return _context44.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/update_notify_props', { method: 'post', body: JSON.stringify(data) }));

                            case 1:
                            case 'end':
                                return _context44.stop();
                        }
                    }
                }, _callee44, _this);
            }));

            return function (_x61, _x62) {
                return _ref46.apply(this, arguments);
            };
        }();

        this.leaveChannel = function () {
            var _ref47 = _asyncToGenerator(regeneratorRuntime.mark(function _callee45(teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee45$(_context45) {
                    while (1) {
                        switch (_context45.prev = _context45.next) {
                            case 0:
                                return _context45.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/leave', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context45.stop();
                        }
                    }
                }, _callee45, _this);
            }));

            return function (_x63, _x64) {
                return _ref47.apply(this, arguments);
            };
        }();

        this.joinChannel = function () {
            var _ref48 = _asyncToGenerator(regeneratorRuntime.mark(function _callee46(teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee46$(_context46) {
                    while (1) {
                        switch (_context46.prev = _context46.next) {
                            case 0:
                                return _context46.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/join', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context46.stop();
                        }
                    }
                }, _callee46, _this);
            }));

            return function (_x65, _x66) {
                return _ref48.apply(this, arguments);
            };
        }();

        this.joinChannelByName = function () {
            var _ref49 = _asyncToGenerator(regeneratorRuntime.mark(function _callee47(teamId, channelName) {
                return regeneratorRuntime.wrap(function _callee47$(_context47) {
                    while (1) {
                        switch (_context47.prev = _context47.next) {
                            case 0:
                                return _context47.abrupt('return', _this.doFetch(_this.getChannelNameRoute(teamId, channelName) + '/join', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context47.stop();
                        }
                    }
                }, _callee47, _this);
            }));

            return function (_x67, _x68) {
                return _ref49.apply(this, arguments);
            };
        }();

        this.deleteChannel = function () {
            var _ref50 = _asyncToGenerator(regeneratorRuntime.mark(function _callee48(teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee48$(_context48) {
                    while (1) {
                        switch (_context48.prev = _context48.next) {
                            case 0:
                                return _context48.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/delete', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context48.stop();
                        }
                    }
                }, _callee48, _this);
            }));

            return function (_x69, _x70) {
                return _ref50.apply(this, arguments);
            };
        }();

        this.viewChannel = function () {
            var _ref51 = _asyncToGenerator(regeneratorRuntime.mark(function _callee49(teamId, channelId) {
                var prevChannelId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var data;
                return regeneratorRuntime.wrap(function _callee49$(_context49) {
                    while (1) {
                        switch (_context49.prev = _context49.next) {
                            case 0:
                                data = {
                                    channel_id: channelId,
                                    prev_channel_id: prevChannelId
                                };
                                return _context49.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/view', { method: 'post', body: JSON.stringify(data) }));

                            case 2:
                            case 'end':
                                return _context49.stop();
                        }
                    }
                }, _callee49, _this);
            }));

            return function (_x71, _x72) {
                return _ref51.apply(this, arguments);
            };
        }();

        this.getMoreChannels = function () {
            var _ref52 = _asyncToGenerator(regeneratorRuntime.mark(function _callee50(teamId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee50$(_context50) {
                    while (1) {
                        switch (_context50.prev = _context50.next) {
                            case 0:
                                return _context50.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/more/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context50.stop();
                        }
                    }
                }, _callee50, _this);
            }));

            return function (_x74, _x75, _x76) {
                return _ref52.apply(this, arguments);
            };
        }();

        this.searchMoreChannels = function () {
            var _ref53 = _asyncToGenerator(regeneratorRuntime.mark(function _callee51(teamId, term) {
                return regeneratorRuntime.wrap(function _callee51$(_context51) {
                    while (1) {
                        switch (_context51.prev = _context51.next) {
                            case 0:
                                return _context51.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/more/search', { method: 'post', body: JSON.stringify({ term: term }) }));

                            case 1:
                            case 'end':
                                return _context51.stop();
                        }
                    }
                }, _callee51, _this);
            }));

            return function (_x77, _x78) {
                return _ref53.apply(this, arguments);
            };
        }();

        this.getChannelStats = function () {
            var _ref54 = _asyncToGenerator(regeneratorRuntime.mark(function _callee52(teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee52$(_context52) {
                    while (1) {
                        switch (_context52.prev = _context52.next) {
                            case 0:
                                return _context52.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/stats', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context52.stop();
                        }
                    }
                }, _callee52, _this);
            }));

            return function (_x79, _x80) {
                return _ref54.apply(this, arguments);
            };
        }();

        this.addChannelMember = function () {
            var _ref55 = _asyncToGenerator(regeneratorRuntime.mark(function _callee53(teamId, channelId, userId) {
                return regeneratorRuntime.wrap(function _callee53$(_context53) {
                    while (1) {
                        switch (_context53.prev = _context53.next) {
                            case 0:
                                return _context53.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/add', { method: 'post', body: JSON.stringify({ user_id: userId }) }));

                            case 1:
                            case 'end':
                                return _context53.stop();
                        }
                    }
                }, _callee53, _this);
            }));

            return function (_x81, _x82, _x83) {
                return _ref55.apply(this, arguments);
            };
        }();

        this.removeChannelMember = function () {
            var _ref56 = _asyncToGenerator(regeneratorRuntime.mark(function _callee54(teamId, channelId, userId) {
                return regeneratorRuntime.wrap(function _callee54$(_context54) {
                    while (1) {
                        switch (_context54.prev = _context54.next) {
                            case 0:
                                return _context54.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/remove', { method: 'post', body: JSON.stringify({ user_id: userId }) }));

                            case 1:
                            case 'end':
                                return _context54.stop();
                        }
                    }
                }, _callee54, _this);
            }));

            return function (_x84, _x85, _x86) {
                return _ref56.apply(this, arguments);
            };
        }();

        this.autocompleteChannels = function () {
            var _ref57 = _asyncToGenerator(regeneratorRuntime.mark(function _callee55(teamId, term) {
                return regeneratorRuntime.wrap(function _callee55$(_context55) {
                    while (1) {
                        switch (_context55.prev = _context55.next) {
                            case 0:
                                return _context55.abrupt('return', _this.doFetch(_this.getChannelsRoute(teamId) + '/autocomplete?term=' + encodeURIComponent(term), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context55.stop();
                        }
                    }
                }, _callee55, _this);
            }));

            return function (_x87, _x88) {
                return _ref57.apply(this, arguments);
            };
        }();

        this.createPost = function () {
            var _ref58 = _asyncToGenerator(regeneratorRuntime.mark(function _callee56(teamId, post) {
                return regeneratorRuntime.wrap(function _callee56$(_context56) {
                    while (1) {
                        switch (_context56.prev = _context56.next) {
                            case 0:
                                return _context56.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, post.channel_id) + '/create', { method: 'post', body: JSON.stringify(post) }));

                            case 1:
                            case 'end':
                                return _context56.stop();
                        }
                    }
                }, _callee56, _this);
            }));

            return function (_x89, _x90) {
                return _ref58.apply(this, arguments);
            };
        }();

        this.editPost = function () {
            var _ref59 = _asyncToGenerator(regeneratorRuntime.mark(function _callee57(teamId, post) {
                return regeneratorRuntime.wrap(function _callee57$(_context57) {
                    while (1) {
                        switch (_context57.prev = _context57.next) {
                            case 0:
                                return _context57.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, post.channel_id) + '/update', { method: 'post', body: JSON.stringify(post) }));

                            case 1:
                            case 'end':
                                return _context57.stop();
                        }
                    }
                }, _callee57, _this);
            }));

            return function (_x91, _x92) {
                return _ref59.apply(this, arguments);
            };
        }();

        this.deletePost = function () {
            var _ref60 = _asyncToGenerator(regeneratorRuntime.mark(function _callee58(teamId, channelId, postId) {
                return regeneratorRuntime.wrap(function _callee58$(_context58) {
                    while (1) {
                        switch (_context58.prev = _context58.next) {
                            case 0:
                                return _context58.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/' + postId + '/delete', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context58.stop();
                        }
                    }
                }, _callee58, _this);
            }));

            return function (_x93, _x94, _x95) {
                return _ref60.apply(this, arguments);
            };
        }();

        this.getPost = function () {
            var _ref61 = _asyncToGenerator(regeneratorRuntime.mark(function _callee59(teamId, channelId, postId) {
                return regeneratorRuntime.wrap(function _callee59$(_context59) {
                    while (1) {
                        switch (_context59.prev = _context59.next) {
                            case 0:
                                return _context59.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/' + postId + '/get', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context59.stop();
                        }
                    }
                }, _callee59, _this);
            }));

            return function (_x96, _x97, _x98) {
                return _ref61.apply(this, arguments);
            };
        }();

        this.getPosts = function () {
            var _ref62 = _asyncToGenerator(regeneratorRuntime.mark(function _callee60(teamId, channelId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee60$(_context60) {
                    while (1) {
                        switch (_context60.prev = _context60.next) {
                            case 0:
                                return _context60.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/page/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context60.stop();
                        }
                    }
                }, _callee60, _this);
            }));

            return function (_x99, _x100, _x101, _x102) {
                return _ref62.apply(this, arguments);
            };
        }();

        this.getPostsSince = function () {
            var _ref63 = _asyncToGenerator(regeneratorRuntime.mark(function _callee61(teamId, channelId, since) {
                return regeneratorRuntime.wrap(function _callee61$(_context61) {
                    while (1) {
                        switch (_context61.prev = _context61.next) {
                            case 0:
                                return _context61.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/since/' + since, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context61.stop();
                        }
                    }
                }, _callee61, _this);
            }));

            return function (_x103, _x104, _x105) {
                return _ref63.apply(this, arguments);
            };
        }();

        this.getPostsBefore = function () {
            var _ref64 = _asyncToGenerator(regeneratorRuntime.mark(function _callee62(teamId, channelId, postId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee62$(_context62) {
                    while (1) {
                        switch (_context62.prev = _context62.next) {
                            case 0:
                                return _context62.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/' + postId + '/before/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context62.stop();
                        }
                    }
                }, _callee62, _this);
            }));

            return function (_x106, _x107, _x108, _x109, _x110) {
                return _ref64.apply(this, arguments);
            };
        }();

        this.getPostsAfter = function () {
            var _ref65 = _asyncToGenerator(regeneratorRuntime.mark(function _callee63(teamId, channelId, postId, offset, limit) {
                return regeneratorRuntime.wrap(function _callee63$(_context63) {
                    while (1) {
                        switch (_context63.prev = _context63.next) {
                            case 0:
                                return _context63.abrupt('return', _this.doFetch(_this.getPostsRoute(teamId, channelId) + '/' + postId + '/after/' + offset + '/' + limit, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context63.stop();
                        }
                    }
                }, _callee63, _this);
            }));

            return function (_x111, _x112, _x113, _x114, _x115) {
                return _ref65.apply(this, arguments);
            };
        }();

        this.getFileInfosForPost = function () {
            var _ref66 = _asyncToGenerator(regeneratorRuntime.mark(function _callee64(teamId, channelId, postId) {
                return regeneratorRuntime.wrap(function _callee64$(_context64) {
                    while (1) {
                        switch (_context64.prev = _context64.next) {
                            case 0:
                                return _context64.abrupt('return', _this.doFetch(_this.getChannelNeededRoute(teamId, channelId) + '/posts/' + postId + '/get_file_infos', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context64.stop();
                        }
                    }
                }, _callee64, _this);
            }));

            return function (_x116, _x117, _x118) {
                return _ref66.apply(this, arguments);
            };
        }();

        this.uploadFile = function () {
            var _ref67 = _asyncToGenerator(regeneratorRuntime.mark(function _callee65(teamId, channelId, fileFormData, formBoundary) {
                var contentType;
                return regeneratorRuntime.wrap(function _callee65$(_context65) {
                    while (1) {
                        switch (_context65.prev = _context65.next) {
                            case 0:
                                contentType = 'multipart/form-data';

                                if (formBoundary) {
                                    contentType += '; boundary=' + formBoundary;
                                }

                                return _context65.abrupt('return', _this.doFetch(_this.getTeamNeededRoute(teamId) + '/files/upload', {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': contentType
                                    },
                                    body: fileFormData
                                }));

                            case 3:
                            case 'end':
                                return _context65.stop();
                        }
                    }
                }, _callee65, _this);
            }));

            return function (_x119, _x120, _x121, _x122) {
                return _ref67.apply(this, arguments);
            };
        }();

        this.getOpenGraphMetadata = function () {
            var _ref68 = _asyncToGenerator(regeneratorRuntime.mark(function _callee66(url) {
                return regeneratorRuntime.wrap(function _callee66$(_context66) {
                    while (1) {
                        switch (_context66.prev = _context66.next) {
                            case 0:
                                return _context66.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/get_opengraph_metadata', { method: 'post', body: JSON.stringify({ url: url }) }));

                            case 1:
                            case 'end':
                                return _context66.stop();
                        }
                    }
                }, _callee66, _this);
            }));

            return function (_x123) {
                return _ref68.apply(this, arguments);
            };
        }();

        this.getMyPreferences = _asyncToGenerator(regeneratorRuntime.mark(function _callee67() {
            return regeneratorRuntime.wrap(function _callee67$(_context67) {
                while (1) {
                    switch (_context67.prev = _context67.next) {
                        case 0:
                            return _context67.abrupt('return', _this.doFetch(_this.getPreferencesRoute() + '/', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context67.stop();
                    }
                }
            }, _callee67, _this);
        }));

        this.savePreferences = function () {
            var _ref70 = _asyncToGenerator(regeneratorRuntime.mark(function _callee68(preferences) {
                return regeneratorRuntime.wrap(function _callee68$(_context68) {
                    while (1) {
                        switch (_context68.prev = _context68.next) {
                            case 0:
                                return _context68.abrupt('return', _this.doFetch(_this.getPreferencesRoute() + '/save', { method: 'post', body: JSON.stringify(preferences) }));

                            case 1:
                            case 'end':
                                return _context68.stop();
                        }
                    }
                }, _callee68, _this);
            }));

            return function (_x124) {
                return _ref70.apply(this, arguments);
            };
        }();

        this.deletePreferences = function () {
            var _ref71 = _asyncToGenerator(regeneratorRuntime.mark(function _callee69(preferences) {
                return regeneratorRuntime.wrap(function _callee69$(_context69) {
                    while (1) {
                        switch (_context69.prev = _context69.next) {
                            case 0:
                                return _context69.abrupt('return', _this.doFetch(_this.getPreferencesRoute() + '/delete', { method: 'post', body: JSON.stringify(preferences) }));

                            case 1:
                            case 'end':
                                return _context69.stop();
                        }
                    }
                }, _callee69, _this);
            }));

            return function (_x125) {
                return _ref71.apply(this, arguments);
            };
        }();

        this.getPreferenceCategory = function () {
            var _ref72 = _asyncToGenerator(regeneratorRuntime.mark(function _callee70(category) {
                return regeneratorRuntime.wrap(function _callee70$(_context70) {
                    while (1) {
                        switch (_context70.prev = _context70.next) {
                            case 0:
                                return _context70.abrupt('return', _this.doFetch(_this.getPreferencesRoute() + '/' + category, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context70.stop();
                        }
                    }
                }, _callee70, _this);
            }));

            return function (_x126) {
                return _ref72.apply(this, arguments);
            };
        }();

        this.getPreference = function () {
            var _ref73 = _asyncToGenerator(regeneratorRuntime.mark(function _callee71(category, name) {
                return regeneratorRuntime.wrap(function _callee71$(_context71) {
                    while (1) {
                        switch (_context71.prev = _context71.next) {
                            case 0:
                                return _context71.abrupt('return', _this.doFetch(_this.getPreferencesRoute() + '/' + category + '/' + name, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context71.stop();
                        }
                    }
                }, _callee71, _this);
            }));

            return function (_x127, _x128) {
                return _ref73.apply(this, arguments);
            };
        }();

        this.addCommand = function () {
            var _ref74 = _asyncToGenerator(regeneratorRuntime.mark(function _callee72(teamId, command) {
                return regeneratorRuntime.wrap(function _callee72$(_context72) {
                    while (1) {
                        switch (_context72.prev = _context72.next) {
                            case 0:
                                return _context72.abrupt('return', _this.doFetch(_this.getCommandsRoute(teamId) + '/create', { method: 'post', body: JSON.stringify(command) }));

                            case 1:
                            case 'end':
                                return _context72.stop();
                        }
                    }
                }, _callee72, _this);
            }));

            return function (_x129, _x130) {
                return _ref74.apply(this, arguments);
            };
        }();

        this.regenCommandToken = function () {
            var _ref75 = _asyncToGenerator(regeneratorRuntime.mark(function _callee73(teamId, id) {
                return regeneratorRuntime.wrap(function _callee73$(_context73) {
                    while (1) {
                        switch (_context73.prev = _context73.next) {
                            case 0:
                                return _context73.abrupt('return', _this.doFetch(_this.getCommandsRoute(teamId) + '/regen_token', { method: 'post', body: JSON.stringify({ id: id }) }));

                            case 1:
                            case 'end':
                                return _context73.stop();
                        }
                    }
                }, _callee73, _this);
            }));

            return function (_x131, _x132) {
                return _ref75.apply(this, arguments);
            };
        }();

        this.deleteCommand = function () {
            var _ref76 = _asyncToGenerator(regeneratorRuntime.mark(function _callee74(teamId, id) {
                return regeneratorRuntime.wrap(function _callee74$(_context74) {
                    while (1) {
                        switch (_context74.prev = _context74.next) {
                            case 0:
                                return _context74.abrupt('return', _this.doFetch(_this.getCommandsRoute(teamId) + '/delete', { method: 'post', body: JSON.stringify({ id: id }) }));

                            case 1:
                            case 'end':
                                return _context74.stop();
                        }
                    }
                }, _callee74, _this);
            }));

            return function (_x133, _x134) {
                return _ref76.apply(this, arguments);
            };
        }();

        this.createCustomEmoji = function () {
            var _ref77 = _asyncToGenerator(regeneratorRuntime.mark(function _callee75(emoji, image) {
                var imageFormData, formBoundary, contentType;
                return regeneratorRuntime.wrap(function _callee75$(_context75) {
                    while (1) {
                        switch (_context75.prev = _context75.next) {
                            case 0:
                                imageFormData = new FormData();

                                imageFormData.append('image', image);
                                imageFormData.append('emoji', JSON.stringify(emoji));
                                formBoundary = imageFormData.getBoundary();
                                contentType = 'multipart/form-data';

                                if (formBoundary) {
                                    contentType += '; boundary=' + formBoundary;
                                }

                                return _context75.abrupt('return', _this.doFetch(_this.getEmojiRoute() + '/create', {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': contentType
                                    },
                                    body: imageFormData
                                }));

                            case 7:
                            case 'end':
                                return _context75.stop();
                        }
                    }
                }, _callee75, _this);
            }));

            return function (_x135, _x136) {
                return _ref77.apply(this, arguments);
            };
        }();

        this.getCustomEmojis = _asyncToGenerator(regeneratorRuntime.mark(function _callee76() {
            return regeneratorRuntime.wrap(function _callee76$(_context76) {
                while (1) {
                    switch (_context76.prev = _context76.next) {
                        case 0:
                            return _context76.abrupt('return', _this.doFetch(_this.getEmojiRoute() + '/list', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context76.stop();
                    }
                }
            }, _callee76, _this);
        }));

        this.deleteCustomEmoji = function () {
            var _ref79 = _asyncToGenerator(regeneratorRuntime.mark(function _callee77(emojiId) {
                return regeneratorRuntime.wrap(function _callee77$(_context77) {
                    while (1) {
                        switch (_context77.prev = _context77.next) {
                            case 0:
                                return _context77.abrupt('return', _this.doFetch(_this.getEmojiRoute() + '/delete', { method: 'post', body: JSON.stringify({ id: emojiId }) }));

                            case 1:
                            case 'end':
                                return _context77.stop();
                        }
                    }
                }, _callee77, _this);
            }));

            return function (_x137) {
                return _ref79.apply(this, arguments);
            };
        }();

        this.getSystemEmojiImageUrl = function (filename) {
            return _this.url + '/static/emoji/' + filename + '.png';
        };

        this.getCustomEmojiImageUrl = function (id) {
            return _this.getEmojiRoute() + '/' + id;
        };

        this.doFetch = function () {
            var _ref80 = _asyncToGenerator(regeneratorRuntime.mark(function _callee78(url, options) {
                var _ref81, data;

                return regeneratorRuntime.wrap(function _callee78$(_context78) {
                    while (1) {
                        switch (_context78.prev = _context78.next) {
                            case 0:
                                _context78.next = 2;
                                return _this.doFetchWithResponse(url, options);

                            case 2:
                                _ref81 = _context78.sent;
                                data = _ref81.data;
                                return _context78.abrupt('return', data);

                            case 5:
                            case 'end':
                                return _context78.stop();
                        }
                    }
                }, _callee78, _this);
            }));

            return function (_x138, _x139) {
                return _ref80.apply(this, arguments);
            };
        }();

        this.doFetchWithResponse = function () {
            var _ref82 = _asyncToGenerator(regeneratorRuntime.mark(function _callee79(url, options) {
                var response, headers, data, serverVersion, msg;
                return regeneratorRuntime.wrap(function _callee79$(_context79) {
                    while (1) {
                        switch (_context79.prev = _context79.next) {
                            case 0:
                                _context79.next = 2;
                                return (0, _fetch_etag2.default)(url, _this.getOptions(options));

                            case 2:
                                response = _context79.sent;
                                headers = parseAndMergeNestedHeaders(response.headers);
                                data = void 0;
                                _context79.prev = 5;
                                _context79.next = 8;
                                return response.json();

                            case 8:
                                data = _context79.sent;
                                _context79.next = 14;
                                break;

                            case 11:
                                _context79.prev = 11;
                                _context79.t0 = _context79['catch'](5);
                                throw {
                                    intl: {
                                        id: 'mobile.request.invalid_response',
                                        defaultMessage: 'Received invalid response from the server.'
                                    }
                                };

                            case 14:

                                if (headers.has(HEADER_X_VERSION_ID)) {
                                    serverVersion = headers.get(HEADER_X_VERSION_ID);

                                    if (serverVersion && _this.serverVersion !== serverVersion) {
                                        _this.serverVersion = serverVersion;
                                        _event_emitter2.default.emit(_constants.General.CONFIG_CHANGED, serverVersion);
                                    }
                                }

                                if (!response.ok) {
                                    _context79.next = 17;
                                    break;
                                }

                                return _context79.abrupt('return', {
                                    response: response,
                                    headers: headers,
                                    data: data
                                });

                            case 17:
                                msg = data.message || '';


                                if (_this.logToConsole) {
                                    console.error(msg); // eslint-disable-line no-console
                                }

                                throw {
                                    message: msg,
                                    server_error_id: data.id,
                                    status_code: data.status_code,
                                    url: url
                                };

                            case 20:
                            case 'end':
                                return _context79.stop();
                        }
                    }
                }, _callee79, _this, [[5, 11]]);
            }));

            return function (_x140, _x141) {
                return _ref82.apply(this, arguments);
            };
        }();

        this.logToConsole = false;
        this.serverVersion = '';
        this.token = '';
        this.url = '';
        this.urlVersion = '/api/v3';
        this.userAgent = null;
        this.acceptLanguage = null;

        this.translations = {
            connectionError: 'There appears to be a problem with your internet connection.',
            unknownError: 'We received an unexpected status code from the server.'
        };
    }

    _createClass(Client, [{
        key: 'getUrl',
        value: function getUrl() {
            return this.url;
        }
    }, {
        key: 'setUrl',
        value: function setUrl(url) {
            this.url = url;
        }
    }, {
        key: 'setUserAgent',
        value: function setUserAgent(userAgent) {
            this.userAgent = userAgent;
        }
    }, {
        key: 'setLocale',
        value: function setLocale(locale) {
            this.acceptLanguage = locale;
        }
    }, {
        key: 'getToken',
        value: function getToken() {
            return this.token;
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            this.token = token;
        }
    }, {
        key: 'getServerVersion',
        value: function getServerVersion() {
            return this.serverVersion;
        }
    }, {
        key: 'getUrlVersion',
        value: function getUrlVersion() {
            return this.urlVersion;
        }
    }, {
        key: 'getBaseRoute',
        value: function getBaseRoute() {
            return '' + this.url + this.urlVersion;
        }
    }, {
        key: 'getAdminRoute',
        value: function getAdminRoute() {
            return '' + this.url + this.urlVersion + '/admin';
        }
    }, {
        key: 'getGeneralRoute',
        value: function getGeneralRoute() {
            return '' + this.url + this.urlVersion + '/general';
        }
    }, {
        key: 'getLicenseRoute',
        value: function getLicenseRoute() {
            return '' + this.url + this.urlVersion + '/license';
        }
    }, {
        key: 'getTeamsRoute',
        value: function getTeamsRoute() {
            return '' + this.url + this.urlVersion + '/teams';
        }
    }, {
        key: 'getPreferencesRoute',
        value: function getPreferencesRoute() {
            return '' + this.url + this.urlVersion + '/preferences';
        }
    }, {
        key: 'getTeamNeededRoute',
        value: function getTeamNeededRoute(teamId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId;
        }
    }, {
        key: 'getChannelsRoute',
        value: function getChannelsRoute(teamId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/channels';
        }
    }, {
        key: 'getChannelNameRoute',
        value: function getChannelNameRoute(teamId, channelName) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/channels/name/' + channelName;
        }
    }, {
        key: 'getChannelNeededRoute',
        value: function getChannelNeededRoute(teamId, channelId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/channels/' + channelId;
        }
    }, {
        key: 'getCommandsRoute',
        value: function getCommandsRoute(teamId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/commands';
        }
    }, {
        key: 'getEmojiRoute',
        value: function getEmojiRoute() {
            return '' + this.url + this.urlVersion + '/emoji';
        }
    }, {
        key: 'getHooksRoute',
        value: function getHooksRoute(teamId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/hooks';
        }
    }, {
        key: 'getPostsRoute',
        value: function getPostsRoute(teamId, channelId) {
            return '' + this.url + this.urlVersion + '/teams/' + teamId + '/channels/' + channelId + '/posts';
        }
    }, {
        key: 'getUsersRoute',
        value: function getUsersRoute() {
            return '' + this.url + this.urlVersion + '/users';
        }
    }, {
        key: 'getFilesRoute',
        value: function getFilesRoute() {
            return '' + this.url + this.urlVersion + '/files';
        }
    }, {
        key: 'getOAuthRoute',
        value: function getOAuthRoute() {
            return '' + this.url + this.urlVersion + '/oauth';
        }
    }, {
        key: 'getUserNeededRoute',
        value: function getUserNeededRoute(userId) {
            return '' + this.url + this.urlVersion + '/users/' + userId;
        }
    }, {
        key: 'enableLogErrorsToConsole',
        value: function enableLogErrorsToConsole(enabled) {
            this.logToConsole = enabled;
        }
    }, {
        key: 'getOptions',
        value: function getOptions(options) {
            var newOptions = Object.assign({}, options);

            var headers = _defineProperty({}, HEADER_REQUESTED_WITH, 'XMLHttpRequest');

            if (this.token) {
                headers[HEADER_AUTH] = HEADER_BEARER + ' ' + this.token;
            } else {
                newOptions.credentials = 'include';
            }

            if (this.userAgent) {
                headers[HEADER_USER_AGENT] = this.userAgent;
            }

            if (this.acceptLanguage) {
                headers[HEADER_ACCEPT_LANGUAGE] = this.acceptLanguage;
            }

            if (options.headers) {
                Object.assign(headers, newOptions.headers);
            }

            return _extends({}, newOptions, {
                headers: headers
            });
        }

        // General routes

        // User routes


        // TODO: add deep linking to emails so we can create accounts from within
        // the mobile app


        // Team routes

        // Channel routes

        // Post routes


        // Preferences routes


        // Integration Routes

    }, {
        key: 'getFileUrl',


        // File routes
        value: function getFileUrl(fileId, timestamp) {
            var url = this.getFilesRoute() + '/' + fileId + '/get';
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }
    }, {
        key: 'getFileThumbnailUrl',
        value: function getFileThumbnailUrl(fileId, timestamp) {
            var url = this.getFilesRoute() + '/' + fileId + '/get_thumbnail';
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }
    }, {
        key: 'getFilePreviewUrl',
        value: function getFilePreviewUrl(fileId, timestamp) {
            var url = this.getFilesRoute() + '/' + fileId + '/get_preview';
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }

        // Emoji routes


        // Client helpers

    }]);

    return Client;
}();

exports.default = Client;


function parseAndMergeNestedHeaders(originalHeaders) {
    // TODO: This is a workaround for https://github.com/matthew-andrews/isomorphic-fetch/issues/97
    // The real solution is to set Access-Control-Expose-Headers on the server
    var headers = new Map();
    var nestedHeaders = new Map();
    originalHeaders.forEach(function (val, key) {
        var capitalizedKey = key.replace(/\b[a-z]/g, function (l) {
            return l.toUpperCase();
        });
        var realVal = val;
        if (val && val.match(/\n\S+:\s\S+/)) {
            var nestedHeaderStrings = val.split('\n');
            realVal = nestedHeaderStrings.shift();
            var moreNestedHeaders = new Map(nestedHeaderStrings.map(function (h) {
                return h.split(/:\s/);
            }));
            nestedHeaders = new Map([].concat(_toConsumableArray(nestedHeaders), _toConsumableArray(moreNestedHeaders)));
        }
        headers.set(capitalizedKey, realVal);
    });
    return new Map([].concat(_toConsumableArray(headers), _toConsumableArray(nestedHeaders)));
}


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _event_emitter = __webpack_require__(210);

var _event_emitter2 = _interopRequireDefault(_event_emitter);

var _constants = __webpack_require__(8);

var _fetch_etag = __webpack_require__(445);

var _fetch_etag2 = _interopRequireDefault(_fetch_etag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormData = __webpack_require__(295);

var HEADER_TOKEN = 'Token';
var HEADER_AUTH = 'Authorization';
var HEADER_BEARER = 'BEARER';
var HEADER_REQUESTED_WITH = 'X-Requested-With';
var HEADER_USER_AGENT = 'User-Agent';
var HEADER_X_VERSION_ID = 'X-Version-Id';
var HEADER_X_CLUSTER_ID = 'X-Cluster-Id';

var PER_PAGE_DEFAULT = 60;

var Client4 = function () {
    function Client4() {
        var _this = this;

        _classCallCheck(this, Client4);

        this.createUser = function () {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(user, data, emailHash, inviteId) {
                var queryParams;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_create');

                                queryParams = {};


                                if (data) {
                                    queryParams.d = data;
                                }

                                if (emailHash) {
                                    queryParams.h = emailHash;
                                }

                                if (inviteId) {
                                    queryParams.iid = inviteId;
                                }

                                return _context.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString(queryParams), { method: 'post', body: JSON.stringify(user) }));

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x, _x2, _x3, _x4) {
                return _ref.apply(this, arguments);
            };
        }();

        this.patchMe = function () {
            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(user) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/patch', { method: 'put', body: JSON.stringify(user) }));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function (_x5) {
                return _ref2.apply(this, arguments);
            };
        }();

        this.updateUser = function () {
            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(user) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_update');

                                return _context3.abrupt('return', _this.doFetch('' + _this.getUserRoute(user.id), { method: 'put', body: JSON.stringify(user) }));

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function (_x6) {
                return _ref3.apply(this, arguments);
            };
        }();

        this.updateUserRoles = function () {
            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(userId, roles) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_update_roles');

                                return _context4.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/roles', { method: 'put', body: JSON.stringify({ roles: roles }) }));

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));

            return function (_x7, _x8) {
                return _ref4.apply(this, arguments);
            };
        }();

        this.updateUserMfa = function () {
            var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(userId, activate, code) {
                var body;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                body = { activate: activate };

                                if (activate) {
                                    body.code = code;
                                }

                                return _context5.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/mfa', { method: 'put', body: JSON.stringify(body) }));

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this);
            }));

            return function (_x9, _x10, _x11) {
                return _ref5.apply(this, arguments);
            };
        }();

        this.updateUserPassword = function () {
            var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(userId, currentPassword, newPassword) {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_newpassword');

                                return _context6.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/password', { method: 'put', body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }) }));

                            case 2:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this);
            }));

            return function (_x12, _x13, _x14) {
                return _ref6.apply(this, arguments);
            };
        }();

        this.resetUserPassword = function () {
            var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(token, newPassword) {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_reset_password');

                                return _context7.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/password/reset', { method: 'post', body: JSON.stringify({ token: token, new_password: newPassword }) }));

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this);
            }));

            return function (_x15, _x16) {
                return _ref7.apply(this, arguments);
            };
        }();

        this.sendPasswordResetEmail = function () {
            var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(email) {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_send_password_reset');

                                return _context8.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/password/reset/send', { method: 'post', body: JSON.stringify({ email: email }) }));

                            case 2:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this);
            }));

            return function (_x17) {
                return _ref8.apply(this, arguments);
            };
        }();

        this.updateUserActive = function () {
            var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(userId, active) {
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_update_active');

                                return _context9.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/active', { method: 'put', body: JSON.stringify({ active: active }) }));

                            case 2:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this);
            }));

            return function (_x18, _x19) {
                return _ref9.apply(this, arguments);
            };
        }();

        this.uploadProfileImage = function () {
            var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(userId, imageData) {
                var formData, request;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_update_profile_picture');

                                formData = new FormData();

                                formData.append('image', imageData);

                                request = {
                                    method: 'post',
                                    body: formData
                                };


                                if (formData.getBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                    };
                                }

                                return _context10.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/image', request));

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this);
            }));

            return function (_x20, _x21) {
                return _ref10.apply(this, arguments);
            };
        }();

        this.verifyUserEmail = function () {
            var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(token) {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                return _context11.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/email/verify', { method: 'post', body: JSON.stringify({ token: token }) }));

                            case 1:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this);
            }));

            return function (_x22) {
                return _ref11.apply(this, arguments);
            };
        }();

        this.sendVerificationEmail = function () {
            var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(email) {
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                return _context12.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/email/verify/send', { method: 'post', body: JSON.stringify({ email: email }) }));

                            case 1:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this);
            }));

            return function (_x23) {
                return _ref12.apply(this, arguments);
            };
        }();

        this.login = function () {
            var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(loginId, password) {
                var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var deviceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                var ldapOnly = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                var body, _ref14, headers, data;

                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_login');

                                if (ldapOnly) {
                                    _this.trackEvent('api', 'api_users_login_ldap');
                                }

                                body = {
                                    device_id: deviceId,
                                    login_id: loginId,
                                    password: password,
                                    token: token
                                };


                                if (ldapOnly) {
                                    body.ldap_only = 'true';
                                }

                                _context13.next = 6;
                                return _this.doFetchWithResponse(_this.getUsersRoute() + '/login', { method: 'post', body: JSON.stringify(body) });

                            case 6:
                                _ref14 = _context13.sent;
                                headers = _ref14.headers;
                                data = _ref14.data;


                                if (headers.has(HEADER_TOKEN)) {
                                    _this.token = headers.get(HEADER_TOKEN);
                                }

                                return _context13.abrupt('return', data);

                            case 11:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this);
            }));

            return function (_x24, _x25) {
                return _ref13.apply(this, arguments);
            };
        }();

        this.loginById = function () {
            var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(id, password) {
                var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var deviceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                var body, _ref16, headers, data;

                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_login');

                                body = {
                                    device_id: deviceId,
                                    id: id,
                                    password: password,
                                    token: token
                                };
                                _context14.next = 4;
                                return _this.doFetchWithResponse(_this.getUsersRoute() + '/login', { method: 'post', body: JSON.stringify(body) });

                            case 4:
                                _ref16 = _context14.sent;
                                headers = _ref16.headers;
                                data = _ref16.data;


                                if (headers.has(HEADER_TOKEN)) {
                                    _this.token = headers.get(HEADER_TOKEN);
                                }

                                return _context14.abrupt('return', data);

                            case 9:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this);
            }));

            return function (_x29, _x30) {
                return _ref15.apply(this, arguments);
            };
        }();

        this.logout = _asyncToGenerator(regeneratorRuntime.mark(function _callee15() {
            var _ref18, response;

            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _this.trackEvent('api', 'api_users_logout');

                            _context15.next = 3;
                            return _this.doFetchWithResponse(_this.getUsersRoute() + '/logout', { method: 'post' });

                        case 3:
                            _ref18 = _context15.sent;
                            response = _ref18.response;


                            if (response.ok) {
                                _this.token = '';
                            }

                            _this.serverVersion = '';

                            return _context15.abrupt('return', response);

                        case 8:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this);
        }));

        this.getProfiles = function () {
            var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get');

                                return _context16.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this);
            }));

            return function () {
                return _ref19.apply(this, arguments);
            };
        }();

        this.getProfilesByIds = function () {
            var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(userIds) {
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_by_ids');

                                return _context17.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 2:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this);
            }));

            return function (_x35) {
                return _ref20.apply(this, arguments);
            };
        }();

        this.getProfilesByUsernames = function () {
            var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(usernames) {
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_by_usernames');

                                return _context18.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/usernames', { method: 'post', body: JSON.stringify(usernames) }));

                            case 2:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, _this);
            }));

            return function (_x36) {
                return _ref21.apply(this, arguments);
            };
        }();

        this.getProfilesInTeam = function () {
            var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(teamId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_in_team', { team_id: teamId, sort: sort });

                                return _context19.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ in_team: teamId, page: page, per_page: perPage, sort: sort }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, _this);
            }));

            return function (_x37) {
                return _ref22.apply(this, arguments);
            };
        }();

        this.getProfilesNotInTeam = function () {
            var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(teamId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_not_in_team', { team_id: teamId });

                                return _context20.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ not_in_team: teamId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, _this);
            }));

            return function (_x41) {
                return _ref23.apply(this, arguments);
            };
        }();

        this.getProfilesWithoutTeam = function () {
            var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_without_team');

                                return _context21.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ without_team: 1, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context21.stop();
                        }
                    }
                }, _callee21, _this);
            }));

            return function () {
                return _ref24.apply(this, arguments);
            };
        }();

        this.getProfilesInChannel = function () {
            var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(channelId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_in_channel', { channel_id: channelId });

                                return _context22.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ in_channel: channelId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, _this);
            }));

            return function (_x46) {
                return _ref25.apply(this, arguments);
            };
        }();

        this.getProfilesNotInChannel = function () {
            var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23(teamId, channelId) {
                var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                        switch (_context23.prev = _context23.next) {
                            case 0:
                                _this.trackEvent('api', 'api_profiles_get_not_in_channel', { team_id: teamId, channel_id: channelId });

                                return _context23.abrupt('return', _this.doFetch('' + _this.getUsersRoute() + buildQueryString({ in_team: teamId, not_in_channel: channelId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context23.stop();
                        }
                    }
                }, _callee23, _this);
            }));

            return function (_x49, _x50) {
                return _ref26.apply(this, arguments);
            };
        }();

        this.getMe = _asyncToGenerator(regeneratorRuntime.mark(function _callee24() {
            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            return _context24.abrupt('return', _this.doFetch('' + _this.getUserRoute('me'), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this);
        }));

        this.getUser = function () {
            var _ref28 = _asyncToGenerator(regeneratorRuntime.mark(function _callee25(userId) {
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                return _context25.abrupt('return', _this.doFetch('' + _this.getUserRoute(userId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context25.stop();
                        }
                    }
                }, _callee25, _this);
            }));

            return function (_x53) {
                return _ref28.apply(this, arguments);
            };
        }();

        this.getUserByUsername = function () {
            var _ref29 = _asyncToGenerator(regeneratorRuntime.mark(function _callee26(username) {
                return regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                return _context26.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/username/' + username, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context26.stop();
                        }
                    }
                }, _callee26, _this);
            }));

            return function (_x54) {
                return _ref29.apply(this, arguments);
            };
        }();

        this.getUserByEmail = function () {
            var _ref30 = _asyncToGenerator(regeneratorRuntime.mark(function _callee27(email) {
                return regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                return _context27.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/email/' + email, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context27.stop();
                        }
                    }
                }, _callee27, _this);
            }));

            return function (_x55) {
                return _ref30.apply(this, arguments);
            };
        }();

        this.getProfilePictureUrl = function (userId, lastPictureUpdate) {
            var params = {};
            if (lastPictureUpdate) {
                params.time = lastPictureUpdate;
            }

            return _this.getUserRoute(userId) + '/image' + buildQueryString(params);
        };

        this.autocompleteUsers = function () {
            var _ref31 = _asyncToGenerator(regeneratorRuntime.mark(function _callee28(name, teamId, channelId) {
                return regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                        switch (_context28.prev = _context28.next) {
                            case 0:
                                return _context28.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/autocomplete' + buildQueryString({ in_team: teamId, in_channel: channelId, name: name }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context28.stop();
                        }
                    }
                }, _callee28, _this);
            }));

            return function (_x56, _x57, _x58) {
                return _ref31.apply(this, arguments);
            };
        }();

        this.getSessions = function () {
            var _ref32 = _asyncToGenerator(regeneratorRuntime.mark(function _callee29(userId) {
                return regeneratorRuntime.wrap(function _callee29$(_context29) {
                    while (1) {
                        switch (_context29.prev = _context29.next) {
                            case 0:
                                return _context29.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/sessions', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context29.stop();
                        }
                    }
                }, _callee29, _this);
            }));

            return function (_x59) {
                return _ref32.apply(this, arguments);
            };
        }();

        this.getCurrentSession = function () {
            var _ref33 = _asyncToGenerator(regeneratorRuntime.mark(function _callee30(userId, token) {
                var sessions;
                return regeneratorRuntime.wrap(function _callee30$(_context30) {
                    while (1) {
                        switch (_context30.prev = _context30.next) {
                            case 0:
                                _context30.next = 2;
                                return _this.getSessions(userId);

                            case 2:
                                sessions = _context30.sent;
                                return _context30.abrupt('return', sessions.find(function (s) {
                                    return s.token === token;
                                }));

                            case 4:
                            case 'end':
                                return _context30.stop();
                        }
                    }
                }, _callee30, _this);
            }));

            return function (_x60, _x61) {
                return _ref33.apply(this, arguments);
            };
        }();

        this.revokeSession = function () {
            var _ref34 = _asyncToGenerator(regeneratorRuntime.mark(function _callee31(userId, sessionId) {
                return regeneratorRuntime.wrap(function _callee31$(_context31) {
                    while (1) {
                        switch (_context31.prev = _context31.next) {
                            case 0:
                                return _context31.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/sessions/revoke', { method: 'post', body: JSON.stringify({ session_id: sessionId }) }));

                            case 1:
                            case 'end':
                                return _context31.stop();
                        }
                    }
                }, _callee31, _this);
            }));

            return function (_x62, _x63) {
                return _ref34.apply(this, arguments);
            };
        }();

        this.getUserAudits = function () {
            var _ref35 = _asyncToGenerator(regeneratorRuntime.mark(function _callee32(userId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee32$(_context32) {
                    while (1) {
                        switch (_context32.prev = _context32.next) {
                            case 0:
                                return _context32.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/audits' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context32.stop();
                        }
                    }
                }, _callee32, _this);
            }));

            return function (_x64) {
                return _ref35.apply(this, arguments);
            };
        }();

        this.checkUserMfa = function () {
            var _ref36 = _asyncToGenerator(regeneratorRuntime.mark(function _callee33(loginId) {
                return regeneratorRuntime.wrap(function _callee33$(_context33) {
                    while (1) {
                        switch (_context33.prev = _context33.next) {
                            case 0:
                                return _context33.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/mfa', { method: 'post', body: JSON.stringify({ login_id: loginId }) }));

                            case 1:
                            case 'end':
                                return _context33.stop();
                        }
                    }
                }, _callee33, _this);
            }));

            return function (_x67) {
                return _ref36.apply(this, arguments);
            };
        }();

        this.generateMfaSecret = function () {
            var _ref37 = _asyncToGenerator(regeneratorRuntime.mark(function _callee34(userId) {
                return regeneratorRuntime.wrap(function _callee34$(_context34) {
                    while (1) {
                        switch (_context34.prev = _context34.next) {
                            case 0:
                                return _context34.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/mfa/generate', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context34.stop();
                        }
                    }
                }, _callee34, _this);
            }));

            return function (_x68) {
                return _ref37.apply(this, arguments);
            };
        }();

        this.attachDevice = function () {
            var _ref38 = _asyncToGenerator(regeneratorRuntime.mark(function _callee35(deviceId) {
                return regeneratorRuntime.wrap(function _callee35$(_context35) {
                    while (1) {
                        switch (_context35.prev = _context35.next) {
                            case 0:
                                return _context35.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/sessions/device', { method: 'put', body: JSON.stringify({ device_id: deviceId }) }));

                            case 1:
                            case 'end':
                                return _context35.stop();
                        }
                    }
                }, _callee35, _this);
            }));

            return function (_x69) {
                return _ref38.apply(this, arguments);
            };
        }();

        this.searchUsers = function (term, options) {
            _this.trackEvent('api', 'api_search_users');

            return _this.doFetch(_this.getUsersRoute() + '/search', { method: 'post', body: JSON.stringify(_extends({ term: term }, options)) });
        };

        this.getStatusesByIds = function () {
            var _ref39 = _asyncToGenerator(regeneratorRuntime.mark(function _callee36(userIds) {
                return regeneratorRuntime.wrap(function _callee36$(_context36) {
                    while (1) {
                        switch (_context36.prev = _context36.next) {
                            case 0:
                                return _context36.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/status/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context36.stop();
                        }
                    }
                }, _callee36, _this);
            }));

            return function (_x70) {
                return _ref39.apply(this, arguments);
            };
        }();

        this.getStatus = function () {
            var _ref40 = _asyncToGenerator(regeneratorRuntime.mark(function _callee37(userId) {
                return regeneratorRuntime.wrap(function _callee37$(_context37) {
                    while (1) {
                        switch (_context37.prev = _context37.next) {
                            case 0:
                                return _context37.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/status', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context37.stop();
                        }
                    }
                }, _callee37, _this);
            }));

            return function (_x71) {
                return _ref40.apply(this, arguments);
            };
        }();

        this.updateStatus = function () {
            var _ref41 = _asyncToGenerator(regeneratorRuntime.mark(function _callee38(status) {
                return regeneratorRuntime.wrap(function _callee38$(_context38) {
                    while (1) {
                        switch (_context38.prev = _context38.next) {
                            case 0:
                                return _context38.abrupt('return', _this.doFetch(_this.getUserRoute(status.user_id) + '/status', { method: 'put', body: JSON.stringify(status) }));

                            case 1:
                            case 'end':
                                return _context38.stop();
                        }
                    }
                }, _callee38, _this);
            }));

            return function (_x72) {
                return _ref41.apply(this, arguments);
            };
        }();

        this.switchEmailToOAuth = function () {
            var _ref42 = _asyncToGenerator(regeneratorRuntime.mark(function _callee39(service, email, password) {
                var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                return regeneratorRuntime.wrap(function _callee39$(_context39) {
                    while (1) {
                        switch (_context39.prev = _context39.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_email_to_oauth');

                                return _context39.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/login/switch', { method: 'post', body: JSON.stringify({ current_service: 'email', new_service: service, email: email, password: password, mfa_code: mfaCode }) }));

                            case 2:
                            case 'end':
                                return _context39.stop();
                        }
                    }
                }, _callee39, _this);
            }));

            return function (_x73, _x74, _x75) {
                return _ref42.apply(this, arguments);
            };
        }();

        this.switchOAuthToEmail = function () {
            var _ref43 = _asyncToGenerator(regeneratorRuntime.mark(function _callee40(currentService, email, password) {
                return regeneratorRuntime.wrap(function _callee40$(_context40) {
                    while (1) {
                        switch (_context40.prev = _context40.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_oauth_to_email');

                                return _context40.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/login/switch', { method: 'post', body: JSON.stringify({ current_service: currentService, new_service: 'email', email: email, new_password: password }) }));

                            case 2:
                            case 'end':
                                return _context40.stop();
                        }
                    }
                }, _callee40, _this);
            }));

            return function (_x77, _x78, _x79) {
                return _ref43.apply(this, arguments);
            };
        }();

        this.switchEmailToLdap = function () {
            var _ref44 = _asyncToGenerator(regeneratorRuntime.mark(function _callee41(email, emailPassword, ldapId, ldapPassword) {
                var mfaCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
                return regeneratorRuntime.wrap(function _callee41$(_context41) {
                    while (1) {
                        switch (_context41.prev = _context41.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_email_to_ldap');

                                return _context41.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/login/switch', { method: 'post', body: JSON.stringify({ current_service: 'email', new_service: 'ldap', email: email, password: emailPassword, ldap_id: ldapId, new_password: ldapPassword, mfa_code: mfaCode }) }));

                            case 2:
                            case 'end':
                                return _context41.stop();
                        }
                    }
                }, _callee41, _this);
            }));

            return function (_x80, _x81, _x82, _x83) {
                return _ref44.apply(this, arguments);
            };
        }();

        this.switchLdapToEmail = function () {
            var _ref45 = _asyncToGenerator(regeneratorRuntime.mark(function _callee42(ldapPassword, email, emailPassword) {
                var mfaCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                return regeneratorRuntime.wrap(function _callee42$(_context42) {
                    while (1) {
                        switch (_context42.prev = _context42.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_ldap_to_email');

                                return _context42.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/login/switch', { method: 'post', body: JSON.stringify({ current_service: 'ldap', new_service: 'email', email: email, password: ldapPassword, new_password: emailPassword, mfa_code: mfaCode }) }));

                            case 2:
                            case 'end':
                                return _context42.stop();
                        }
                    }
                }, _callee42, _this);
            }));

            return function (_x85, _x86, _x87) {
                return _ref45.apply(this, arguments);
            };
        }();

        this.getAuthorizedOAuthApps = function () {
            var _ref46 = _asyncToGenerator(regeneratorRuntime.mark(function _callee43(userId) {
                return regeneratorRuntime.wrap(function _callee43$(_context43) {
                    while (1) {
                        switch (_context43.prev = _context43.next) {
                            case 0:
                                return _context43.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/oauth/apps/authorized', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context43.stop();
                        }
                    }
                }, _callee43, _this);
            }));

            return function (_x89) {
                return _ref46.apply(this, arguments);
            };
        }();

        this.authorizeOAuthApp = function () {
            var _ref47 = _asyncToGenerator(regeneratorRuntime.mark(function _callee44(responseType, clientId, redirectUri, state, scope) {
                return regeneratorRuntime.wrap(function _callee44$(_context44) {
                    while (1) {
                        switch (_context44.prev = _context44.next) {
                            case 0:
                                return _context44.abrupt('return', _this.doFetch(_this.url + '/oauth/authorize', { method: 'post', body: JSON.stringify({ client_id: clientId, response_type: responseType, redirect_uri: redirectUri, state: state, scope: scope }) }));

                            case 1:
                            case 'end':
                                return _context44.stop();
                        }
                    }
                }, _callee44, _this);
            }));

            return function (_x90, _x91, _x92, _x93, _x94) {
                return _ref47.apply(this, arguments);
            };
        }();

        this.deauthorizeOAuthApp = function () {
            var _ref48 = _asyncToGenerator(regeneratorRuntime.mark(function _callee45(clientId) {
                return regeneratorRuntime.wrap(function _callee45$(_context45) {
                    while (1) {
                        switch (_context45.prev = _context45.next) {
                            case 0:
                                return _context45.abrupt('return', _this.doFetch(_this.url + '/oauth/deauthorize', { method: 'post', body: JSON.stringify({ client_id: clientId }) }));

                            case 1:
                            case 'end':
                                return _context45.stop();
                        }
                    }
                }, _callee45, _this);
            }));

            return function (_x95) {
                return _ref48.apply(this, arguments);
            };
        }();

        this.createUserAccessToken = function () {
            var _ref49 = _asyncToGenerator(regeneratorRuntime.mark(function _callee46(userId, description) {
                return regeneratorRuntime.wrap(function _callee46$(_context46) {
                    while (1) {
                        switch (_context46.prev = _context46.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_create_access_token');

                                return _context46.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/tokens', { method: 'post', body: JSON.stringify({ description: description }) }));

                            case 2:
                            case 'end':
                                return _context46.stop();
                        }
                    }
                }, _callee46, _this);
            }));

            return function (_x96, _x97) {
                return _ref49.apply(this, arguments);
            };
        }();

        this.getUserAccessToken = function () {
            var _ref50 = _asyncToGenerator(regeneratorRuntime.mark(function _callee47(tokenId) {
                return regeneratorRuntime.wrap(function _callee47$(_context47) {
                    while (1) {
                        switch (_context47.prev = _context47.next) {
                            case 0:
                                return _context47.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/tokens/' + tokenId, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context47.stop();
                        }
                    }
                }, _callee47, _this);
            }));

            return function (_x98) {
                return _ref50.apply(this, arguments);
            };
        }();

        this.getUserAccessTokensForUser = function () {
            var _ref51 = _asyncToGenerator(regeneratorRuntime.mark(function _callee48(userId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee48$(_context48) {
                    while (1) {
                        switch (_context48.prev = _context48.next) {
                            case 0:
                                return _context48.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/tokens' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context48.stop();
                        }
                    }
                }, _callee48, _this);
            }));

            return function (_x99) {
                return _ref51.apply(this, arguments);
            };
        }();

        this.revokeUserAccessToken = function () {
            var _ref52 = _asyncToGenerator(regeneratorRuntime.mark(function _callee49(tokenId) {
                return regeneratorRuntime.wrap(function _callee49$(_context49) {
                    while (1) {
                        switch (_context49.prev = _context49.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_revoke_access_token');

                                return _context49.abrupt('return', _this.doFetch(_this.getUsersRoute() + '/tokens/revoke', { method: 'post', body: JSON.stringify({ token_id: tokenId }) }));

                            case 2:
                            case 'end':
                                return _context49.stop();
                        }
                    }
                }, _callee49, _this);
            }));

            return function (_x102) {
                return _ref52.apply(this, arguments);
            };
        }();

        this.createTeam = function () {
            var _ref53 = _asyncToGenerator(regeneratorRuntime.mark(function _callee50(team) {
                return regeneratorRuntime.wrap(function _callee50$(_context50) {
                    while (1) {
                        switch (_context50.prev = _context50.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_create');

                                return _context50.abrupt('return', _this.doFetch('' + _this.getTeamsRoute(), { method: 'post', body: JSON.stringify(team) }));

                            case 2:
                            case 'end':
                                return _context50.stop();
                        }
                    }
                }, _callee50, _this);
            }));

            return function (_x103) {
                return _ref53.apply(this, arguments);
            };
        }();

        this.updateTeam = function () {
            var _ref54 = _asyncToGenerator(regeneratorRuntime.mark(function _callee51(team) {
                return regeneratorRuntime.wrap(function _callee51$(_context51) {
                    while (1) {
                        switch (_context51.prev = _context51.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_update_name', { team_id: team.id });

                                return _context51.abrupt('return', _this.doFetch('' + _this.getTeamRoute(team.id), { method: 'put', body: JSON.stringify(team) }));

                            case 2:
                            case 'end':
                                return _context51.stop();
                        }
                    }
                }, _callee51, _this);
            }));

            return function (_x104) {
                return _ref54.apply(this, arguments);
            };
        }();

        this.checkIfTeamExists = function () {
            var _ref55 = _asyncToGenerator(regeneratorRuntime.mark(function _callee52(teamName) {
                return regeneratorRuntime.wrap(function _callee52$(_context52) {
                    while (1) {
                        switch (_context52.prev = _context52.next) {
                            case 0:
                                return _context52.abrupt('return', _this.doFetch(_this.getTeamNameRoute(teamName) + '/exists', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context52.stop();
                        }
                    }
                }, _callee52, _this);
            }));

            return function (_x105) {
                return _ref55.apply(this, arguments);
            };
        }();

        this.getTeams = function () {
            var _ref56 = _asyncToGenerator(regeneratorRuntime.mark(function _callee53() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee53$(_context53) {
                    while (1) {
                        switch (_context53.prev = _context53.next) {
                            case 0:
                                return _context53.abrupt('return', _this.doFetch('' + _this.getTeamsRoute() + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context53.stop();
                        }
                    }
                }, _callee53, _this);
            }));

            return function () {
                return _ref56.apply(this, arguments);
            };
        }();

        this.getTeam = function () {
            var _ref57 = _asyncToGenerator(regeneratorRuntime.mark(function _callee54(teamId) {
                return regeneratorRuntime.wrap(function _callee54$(_context54) {
                    while (1) {
                        switch (_context54.prev = _context54.next) {
                            case 0:
                                return _context54.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context54.stop();
                        }
                    }
                }, _callee54, _this);
            }));

            return function (_x108) {
                return _ref57.apply(this, arguments);
            };
        }();

        this.getMyTeams = _asyncToGenerator(regeneratorRuntime.mark(function _callee55() {
            return regeneratorRuntime.wrap(function _callee55$(_context55) {
                while (1) {
                    switch (_context55.prev = _context55.next) {
                        case 0:
                            return _context55.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/teams', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context55.stop();
                    }
                }
            }, _callee55, _this);
        }));

        this.getTeamsForUser = function () {
            var _ref59 = _asyncToGenerator(regeneratorRuntime.mark(function _callee56(userId) {
                return regeneratorRuntime.wrap(function _callee56$(_context56) {
                    while (1) {
                        switch (_context56.prev = _context56.next) {
                            case 0:
                                return _context56.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/teams', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context56.stop();
                        }
                    }
                }, _callee56, _this);
            }));

            return function (_x109) {
                return _ref59.apply(this, arguments);
            };
        }();

        this.getMyTeamMembers = _asyncToGenerator(regeneratorRuntime.mark(function _callee57() {
            return regeneratorRuntime.wrap(function _callee57$(_context57) {
                while (1) {
                    switch (_context57.prev = _context57.next) {
                        case 0:
                            return _context57.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/teams/members', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context57.stop();
                    }
                }
            }, _callee57, _this);
        }));
        this.getMyTeamUnreads = _asyncToGenerator(regeneratorRuntime.mark(function _callee58() {
            return regeneratorRuntime.wrap(function _callee58$(_context58) {
                while (1) {
                    switch (_context58.prev = _context58.next) {
                        case 0:
                            return _context58.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/teams/unread', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context58.stop();
                    }
                }
            }, _callee58, _this);
        }));

        this.getTeamMembersForUser = function () {
            var _ref62 = _asyncToGenerator(regeneratorRuntime.mark(function _callee59(userId) {
                return regeneratorRuntime.wrap(function _callee59$(_context59) {
                    while (1) {
                        switch (_context59.prev = _context59.next) {
                            case 0:
                                return _context59.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/teams/members', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context59.stop();
                        }
                    }
                }, _callee59, _this);
            }));

            return function (_x110) {
                return _ref62.apply(this, arguments);
            };
        }();

        this.getTeamMember = function () {
            var _ref63 = _asyncToGenerator(regeneratorRuntime.mark(function _callee60(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee60$(_context60) {
                    while (1) {
                        switch (_context60.prev = _context60.next) {
                            case 0:
                                return _context60.abrupt('return', _this.doFetch('' + _this.getTeamMemberRoute(teamId, userId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context60.stop();
                        }
                    }
                }, _callee60, _this);
            }));

            return function (_x111, _x112) {
                return _ref63.apply(this, arguments);
            };
        }();

        this.getTeamMembersByIds = function () {
            var _ref64 = _asyncToGenerator(regeneratorRuntime.mark(function _callee61(teamId, userIds) {
                return regeneratorRuntime.wrap(function _callee61$(_context61) {
                    while (1) {
                        switch (_context61.prev = _context61.next) {
                            case 0:
                                return _context61.abrupt('return', _this.doFetch(_this.getTeamMembersRoute(teamId) + '/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context61.stop();
                        }
                    }
                }, _callee61, _this);
            }));

            return function (_x113, _x114) {
                return _ref64.apply(this, arguments);
            };
        }();

        this.addToTeam = function () {
            var _ref65 = _asyncToGenerator(regeneratorRuntime.mark(function _callee62(teamId, userId) {
                var member;
                return regeneratorRuntime.wrap(function _callee62$(_context62) {
                    while (1) {
                        switch (_context62.prev = _context62.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_invite_members', { team_id: teamId });

                                member = { user_id: userId, team_id: teamId };
                                return _context62.abrupt('return', _this.doFetch('' + _this.getTeamMembersRoute(teamId), { method: 'post', body: JSON.stringify(member) }));

                            case 3:
                            case 'end':
                                return _context62.stop();
                        }
                    }
                }, _callee62, _this);
            }));

            return function (_x115, _x116) {
                return _ref65.apply(this, arguments);
            };
        }();

        this.addToTeamFromInvite = function () {
            var _ref66 = _asyncToGenerator(regeneratorRuntime.mark(function _callee63() {
                var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var inviteId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var query;
                return regeneratorRuntime.wrap(function _callee63$(_context63) {
                    while (1) {
                        switch (_context63.prev = _context63.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_invite_members');

                                query = buildQueryString({ hash: hash, data: data, invite_id: inviteId });
                                return _context63.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/members/invite' + query, { method: 'post' }));

                            case 3:
                            case 'end':
                                return _context63.stop();
                        }
                    }
                }, _callee63, _this);
            }));

            return function () {
                return _ref66.apply(this, arguments);
            };
        }();

        this.addUsersToTeam = function () {
            var _ref67 = _asyncToGenerator(regeneratorRuntime.mark(function _callee64(teamId, userIds) {
                var members;
                return regeneratorRuntime.wrap(function _callee64$(_context64) {
                    while (1) {
                        switch (_context64.prev = _context64.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_batch_add_members', { team_id: teamId, count: userIds.length });

                                members = [];

                                userIds.forEach(function (id) {
                                    return members.push({ team_id: teamId, user_id: id });
                                });
                                return _context64.abrupt('return', _this.doFetch(_this.getTeamMembersRoute(teamId) + '/batch', { method: 'post', body: JSON.stringify(members) }));

                            case 4:
                            case 'end':
                                return _context64.stop();
                        }
                    }
                }, _callee64, _this);
            }));

            return function (_x120, _x121) {
                return _ref67.apply(this, arguments);
            };
        }();

        this.joinTeam = function () {
            var _ref68 = _asyncToGenerator(regeneratorRuntime.mark(function _callee65(inviteId) {
                var query;
                return regeneratorRuntime.wrap(function _callee65$(_context65) {
                    while (1) {
                        switch (_context65.prev = _context65.next) {
                            case 0:
                                query = buildQueryString({ invite_id: inviteId });
                                return _context65.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/members/invite' + query, { method: 'post' }));

                            case 2:
                            case 'end':
                                return _context65.stop();
                        }
                    }
                }, _callee65, _this);
            }));

            return function (_x122) {
                return _ref68.apply(this, arguments);
            };
        }();

        this.removeFromTeam = function () {
            var _ref69 = _asyncToGenerator(regeneratorRuntime.mark(function _callee66(teamId, userId) {
                return regeneratorRuntime.wrap(function _callee66$(_context66) {
                    while (1) {
                        switch (_context66.prev = _context66.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_remove_members', { team_id: teamId });

                                return _context66.abrupt('return', _this.doFetch('' + _this.getTeamMemberRoute(teamId, userId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context66.stop();
                        }
                    }
                }, _callee66, _this);
            }));

            return function (_x123, _x124) {
                return _ref69.apply(this, arguments);
            };
        }();

        this.getTeamStats = function () {
            var _ref70 = _asyncToGenerator(regeneratorRuntime.mark(function _callee67(teamId) {
                return regeneratorRuntime.wrap(function _callee67$(_context67) {
                    while (1) {
                        switch (_context67.prev = _context67.next) {
                            case 0:
                                return _context67.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/stats', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context67.stop();
                        }
                    }
                }, _callee67, _this);
            }));

            return function (_x125) {
                return _ref70.apply(this, arguments);
            };
        }();

        this.getTeamInviteInfo = function () {
            var _ref71 = _asyncToGenerator(regeneratorRuntime.mark(function _callee68(inviteId) {
                return regeneratorRuntime.wrap(function _callee68$(_context68) {
                    while (1) {
                        switch (_context68.prev = _context68.next) {
                            case 0:
                                return _context68.abrupt('return', _this.doFetch(_this.getTeamsRoute() + '/invite/' + inviteId, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context68.stop();
                        }
                    }
                }, _callee68, _this);
            }));

            return function (_x126) {
                return _ref71.apply(this, arguments);
            };
        }();

        this.updateTeamMemberRoles = function () {
            var _ref72 = _asyncToGenerator(regeneratorRuntime.mark(function _callee69(teamId, userId, roles) {
                return regeneratorRuntime.wrap(function _callee69$(_context69) {
                    while (1) {
                        switch (_context69.prev = _context69.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_update_member_roles', { team_id: teamId });

                                return _context69.abrupt('return', _this.doFetch(_this.getTeamMemberRoute(teamId, userId) + '/roles', { method: 'put', body: JSON.stringify({ roles: roles }) }));

                            case 2:
                            case 'end':
                                return _context69.stop();
                        }
                    }
                }, _callee69, _this);
            }));

            return function (_x127, _x128, _x129) {
                return _ref72.apply(this, arguments);
            };
        }();

        this.sendEmailInvitesToTeam = function () {
            var _ref73 = _asyncToGenerator(regeneratorRuntime.mark(function _callee70(teamId, emails) {
                return regeneratorRuntime.wrap(function _callee70$(_context70) {
                    while (1) {
                        switch (_context70.prev = _context70.next) {
                            case 0:
                                _this.trackEvent('api', 'api_teams_invite_members', { team_id: teamId });

                                return _context70.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/invite/email', { method: 'post', body: JSON.stringify(emails) }));

                            case 2:
                            case 'end':
                                return _context70.stop();
                        }
                    }
                }, _callee70, _this);
            }));

            return function (_x130, _x131) {
                return _ref73.apply(this, arguments);
            };
        }();

        this.importTeam = function () {
            var _ref74 = _asyncToGenerator(regeneratorRuntime.mark(function _callee71(teamId, file, importFrom) {
                var formData, request;
                return regeneratorRuntime.wrap(function _callee71$(_context71) {
                    while (1) {
                        switch (_context71.prev = _context71.next) {
                            case 0:
                                formData = new FormData();

                                formData.append('file', file, file.name);
                                formData.append('filesize', file.size);
                                formData.append('importFrom', importFrom);

                                request = {
                                    method: 'post',
                                    body: formData
                                };


                                if (formData.getBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                    };
                                }

                                return _context71.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/import', request));

                            case 7:
                            case 'end':
                                return _context71.stop();
                        }
                    }
                }, _callee71, _this);
            }));

            return function (_x132, _x133, _x134) {
                return _ref74.apply(this, arguments);
            };
        }();

        this.createChannel = function () {
            var _ref75 = _asyncToGenerator(regeneratorRuntime.mark(function _callee72(channel) {
                return regeneratorRuntime.wrap(function _callee72$(_context72) {
                    while (1) {
                        switch (_context72.prev = _context72.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_create', { team_id: channel.team_id });

                                return _context72.abrupt('return', _this.doFetch('' + _this.getChannelsRoute(), { method: 'post', body: JSON.stringify(channel) }));

                            case 2:
                            case 'end':
                                return _context72.stop();
                        }
                    }
                }, _callee72, _this);
            }));

            return function (_x135) {
                return _ref75.apply(this, arguments);
            };
        }();

        this.createDirectChannel = function () {
            var _ref76 = _asyncToGenerator(regeneratorRuntime.mark(function _callee73(userIds) {
                return regeneratorRuntime.wrap(function _callee73$(_context73) {
                    while (1) {
                        switch (_context73.prev = _context73.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_create_direct');

                                return _context73.abrupt('return', _this.doFetch(_this.getChannelsRoute() + '/direct', { method: 'post', body: JSON.stringify(userIds) }));

                            case 2:
                            case 'end':
                                return _context73.stop();
                        }
                    }
                }, _callee73, _this);
            }));

            return function (_x136) {
                return _ref76.apply(this, arguments);
            };
        }();

        this.createGroupChannel = function () {
            var _ref77 = _asyncToGenerator(regeneratorRuntime.mark(function _callee74(userIds) {
                return regeneratorRuntime.wrap(function _callee74$(_context74) {
                    while (1) {
                        switch (_context74.prev = _context74.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_create_group');

                                return _context74.abrupt('return', _this.doFetch(_this.getChannelsRoute() + '/group', { method: 'post', body: JSON.stringify(userIds) }));

                            case 2:
                            case 'end':
                                return _context74.stop();
                        }
                    }
                }, _callee74, _this);
            }));

            return function (_x137) {
                return _ref77.apply(this, arguments);
            };
        }();

        this.deleteChannel = function () {
            var _ref78 = _asyncToGenerator(regeneratorRuntime.mark(function _callee75(channelId) {
                return regeneratorRuntime.wrap(function _callee75$(_context75) {
                    while (1) {
                        switch (_context75.prev = _context75.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_delete', { channel_id: channelId });

                                return _context75.abrupt('return', _this.doFetch('' + _this.getChannelRoute(channelId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context75.stop();
                        }
                    }
                }, _callee75, _this);
            }));

            return function (_x138) {
                return _ref78.apply(this, arguments);
            };
        }();

        this.updateChannel = function () {
            var _ref79 = _asyncToGenerator(regeneratorRuntime.mark(function _callee76(channel) {
                return regeneratorRuntime.wrap(function _callee76$(_context76) {
                    while (1) {
                        switch (_context76.prev = _context76.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_update', { channel_id: channel.id });

                                return _context76.abrupt('return', _this.doFetch('' + _this.getChannelRoute(channel.id), { method: 'put', body: JSON.stringify(channel) }));

                            case 2:
                            case 'end':
                                return _context76.stop();
                        }
                    }
                }, _callee76, _this);
            }));

            return function (_x139) {
                return _ref79.apply(this, arguments);
            };
        }();

        this.patchChannel = function () {
            var _ref80 = _asyncToGenerator(regeneratorRuntime.mark(function _callee77(channelId, patch) {
                return regeneratorRuntime.wrap(function _callee77$(_context77) {
                    while (1) {
                        switch (_context77.prev = _context77.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_patch', { channel_id: channelId });

                                return _context77.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/patch', { method: 'put', body: JSON.stringify(patch) }));

                            case 2:
                            case 'end':
                                return _context77.stop();
                        }
                    }
                }, _callee77, _this);
            }));

            return function (_x140, _x141) {
                return _ref80.apply(this, arguments);
            };
        }();

        this.updateChannelNotifyProps = function () {
            var _ref81 = _asyncToGenerator(regeneratorRuntime.mark(function _callee78(props) {
                return regeneratorRuntime.wrap(function _callee78$(_context78) {
                    while (1) {
                        switch (_context78.prev = _context78.next) {
                            case 0:
                                _this.trackEvent('api', 'api_users_update_channel_notifcations', { channel_id: props.channel_id });

                                return _context78.abrupt('return', _this.doFetch(_this.getChannelMemberRoute(props.channel_id, props.user_id) + '/notify_props', { method: 'put', body: JSON.stringify(props) }));

                            case 2:
                            case 'end':
                                return _context78.stop();
                        }
                    }
                }, _callee78, _this);
            }));

            return function (_x142) {
                return _ref81.apply(this, arguments);
            };
        }();

        this.getChannel = function () {
            var _ref82 = _asyncToGenerator(regeneratorRuntime.mark(function _callee79(channelId) {
                return regeneratorRuntime.wrap(function _callee79$(_context79) {
                    while (1) {
                        switch (_context79.prev = _context79.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channel_get', { channel_id: channelId });

                                return _context79.abrupt('return', _this.doFetch('' + _this.getChannelRoute(channelId), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context79.stop();
                        }
                    }
                }, _callee79, _this);
            }));

            return function (_x143) {
                return _ref82.apply(this, arguments);
            };
        }();

        this.getChannelByName = function () {
            var _ref83 = _asyncToGenerator(regeneratorRuntime.mark(function _callee80(teamId, channelName) {
                return regeneratorRuntime.wrap(function _callee80$(_context80) {
                    while (1) {
                        switch (_context80.prev = _context80.next) {
                            case 0:
                                return _context80.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/channels/name/' + channelName, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context80.stop();
                        }
                    }
                }, _callee80, _this);
            }));

            return function (_x144, _x145) {
                return _ref83.apply(this, arguments);
            };
        }();

        this.getChannels = function () {
            var _ref84 = _asyncToGenerator(regeneratorRuntime.mark(function _callee81(teamId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee81$(_context81) {
                    while (1) {
                        switch (_context81.prev = _context81.next) {
                            case 0:
                                return _context81.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/channels' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context81.stop();
                        }
                    }
                }, _callee81, _this);
            }));

            return function (_x146) {
                return _ref84.apply(this, arguments);
            };
        }();

        this.getMyChannels = function () {
            var _ref85 = _asyncToGenerator(regeneratorRuntime.mark(function _callee82(teamId) {
                return regeneratorRuntime.wrap(function _callee82$(_context82) {
                    while (1) {
                        switch (_context82.prev = _context82.next) {
                            case 0:
                                return _context82.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/teams/' + teamId + '/channels', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context82.stop();
                        }
                    }
                }, _callee82, _this);
            }));

            return function (_x149) {
                return _ref85.apply(this, arguments);
            };
        }();

        this.getMyChannelMember = function () {
            var _ref86 = _asyncToGenerator(regeneratorRuntime.mark(function _callee83(channelId) {
                return regeneratorRuntime.wrap(function _callee83$(_context83) {
                    while (1) {
                        switch (_context83.prev = _context83.next) {
                            case 0:
                                return _context83.abrupt('return', _this.doFetch('' + _this.getChannelMemberRoute(channelId, 'me'), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context83.stop();
                        }
                    }
                }, _callee83, _this);
            }));

            return function (_x150) {
                return _ref86.apply(this, arguments);
            };
        }();

        this.getMyChannelMembers = function () {
            var _ref87 = _asyncToGenerator(regeneratorRuntime.mark(function _callee84(teamId) {
                return regeneratorRuntime.wrap(function _callee84$(_context84) {
                    while (1) {
                        switch (_context84.prev = _context84.next) {
                            case 0:
                                return _context84.abrupt('return', _this.doFetch(_this.getUserRoute('me') + '/teams/' + teamId + '/channels/members', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context84.stop();
                        }
                    }
                }, _callee84, _this);
            }));

            return function (_x151) {
                return _ref87.apply(this, arguments);
            };
        }();

        this.getChannelMembers = function () {
            var _ref88 = _asyncToGenerator(regeneratorRuntime.mark(function _callee85(channelId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee85$(_context85) {
                    while (1) {
                        switch (_context85.prev = _context85.next) {
                            case 0:
                                return _context85.abrupt('return', _this.doFetch('' + _this.getChannelMembersRoute(channelId) + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context85.stop();
                        }
                    }
                }, _callee85, _this);
            }));

            return function (_x152) {
                return _ref88.apply(this, arguments);
            };
        }();

        this.getChannelMember = function () {
            var _ref89 = _asyncToGenerator(regeneratorRuntime.mark(function _callee86(channelId, userId) {
                return regeneratorRuntime.wrap(function _callee86$(_context86) {
                    while (1) {
                        switch (_context86.prev = _context86.next) {
                            case 0:
                                return _context86.abrupt('return', _this.doFetch('' + _this.getChannelMemberRoute(channelId, userId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context86.stop();
                        }
                    }
                }, _callee86, _this);
            }));

            return function (_x155, _x156) {
                return _ref89.apply(this, arguments);
            };
        }();

        this.getChannelMembersByIds = function () {
            var _ref90 = _asyncToGenerator(regeneratorRuntime.mark(function _callee87(channelId, userIds) {
                return regeneratorRuntime.wrap(function _callee87$(_context87) {
                    while (1) {
                        switch (_context87.prev = _context87.next) {
                            case 0:
                                return _context87.abrupt('return', _this.doFetch(_this.getChannelMembersRoute(channelId) + '/ids', { method: 'post', body: JSON.stringify(userIds) }));

                            case 1:
                            case 'end':
                                return _context87.stop();
                        }
                    }
                }, _callee87, _this);
            }));

            return function (_x157, _x158) {
                return _ref90.apply(this, arguments);
            };
        }();

        this.addToChannel = function () {
            var _ref91 = _asyncToGenerator(regeneratorRuntime.mark(function _callee88(userId, channelId) {
                var member;
                return regeneratorRuntime.wrap(function _callee88$(_context88) {
                    while (1) {
                        switch (_context88.prev = _context88.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_add_member', { channel_id: channelId });

                                member = { user_id: userId, channel_id: channelId };
                                return _context88.abrupt('return', _this.doFetch('' + _this.getChannelMembersRoute(channelId), { method: 'post', body: JSON.stringify(member) }));

                            case 3:
                            case 'end':
                                return _context88.stop();
                        }
                    }
                }, _callee88, _this);
            }));

            return function (_x159, _x160) {
                return _ref91.apply(this, arguments);
            };
        }();

        this.removeFromChannel = function () {
            var _ref92 = _asyncToGenerator(regeneratorRuntime.mark(function _callee89(userId, channelId) {
                return regeneratorRuntime.wrap(function _callee89$(_context89) {
                    while (1) {
                        switch (_context89.prev = _context89.next) {
                            case 0:
                                _this.trackEvent('api', 'api_channels_remove_member', { channel_id: channelId });

                                return _context89.abrupt('return', _this.doFetch('' + _this.getChannelMemberRoute(channelId, userId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context89.stop();
                        }
                    }
                }, _callee89, _this);
            }));

            return function (_x161, _x162) {
                return _ref92.apply(this, arguments);
            };
        }();

        this.updateChannelMemberRoles = function () {
            var _ref93 = _asyncToGenerator(regeneratorRuntime.mark(function _callee90(channelId, userId, roles) {
                return regeneratorRuntime.wrap(function _callee90$(_context90) {
                    while (1) {
                        switch (_context90.prev = _context90.next) {
                            case 0:
                                return _context90.abrupt('return', _this.doFetch(_this.getChannelMemberRoute(channelId, userId) + '/roles', { method: 'put', body: JSON.stringify({ roles: roles }) }));

                            case 1:
                            case 'end':
                                return _context90.stop();
                        }
                    }
                }, _callee90, _this);
            }));

            return function (_x163, _x164, _x165) {
                return _ref93.apply(this, arguments);
            };
        }();

        this.getChannelStats = function () {
            var _ref94 = _asyncToGenerator(regeneratorRuntime.mark(function _callee91(channelId) {
                return regeneratorRuntime.wrap(function _callee91$(_context91) {
                    while (1) {
                        switch (_context91.prev = _context91.next) {
                            case 0:
                                return _context91.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/stats', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context91.stop();
                        }
                    }
                }, _callee91, _this);
            }));

            return function (_x166) {
                return _ref94.apply(this, arguments);
            };
        }();

        this.viewMyChannel = function () {
            var _ref95 = _asyncToGenerator(regeneratorRuntime.mark(function _callee92(channelId, prevChannelId) {
                var data;
                return regeneratorRuntime.wrap(function _callee92$(_context92) {
                    while (1) {
                        switch (_context92.prev = _context92.next) {
                            case 0:
                                data = { channel_id: channelId, prev_channel_id: prevChannelId };
                                return _context92.abrupt('return', _this.doFetch(_this.getChannelsRoute() + '/members/me/view', { method: 'post', body: JSON.stringify(data) }));

                            case 2:
                            case 'end':
                                return _context92.stop();
                        }
                    }
                }, _callee92, _this);
            }));

            return function (_x167, _x168) {
                return _ref95.apply(this, arguments);
            };
        }();

        this.searchChannels = function () {
            var _ref96 = _asyncToGenerator(regeneratorRuntime.mark(function _callee93(teamId, term) {
                return regeneratorRuntime.wrap(function _callee93$(_context93) {
                    while (1) {
                        switch (_context93.prev = _context93.next) {
                            case 0:
                                return _context93.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/channels/search', { method: 'post', body: JSON.stringify({ term: term }) }));

                            case 1:
                            case 'end':
                                return _context93.stop();
                        }
                    }
                }, _callee93, _this);
            }));

            return function (_x169, _x170) {
                return _ref96.apply(this, arguments);
            };
        }();

        this.createPost = function () {
            var _ref97 = _asyncToGenerator(regeneratorRuntime.mark(function _callee94(post) {
                return regeneratorRuntime.wrap(function _callee94$(_context94) {
                    while (1) {
                        switch (_context94.prev = _context94.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_create', { channel_id: post.channel_id });

                                if (post.root_id != null && post.root_id !== '') {
                                    _this.trackEvent('api', 'api_posts_replied', { channel_id: post.channel_id });
                                }

                                return _context94.abrupt('return', _this.doFetch('' + _this.getPostsRoute(), { method: 'post', body: JSON.stringify(post) }));

                            case 3:
                            case 'end':
                                return _context94.stop();
                        }
                    }
                }, _callee94, _this);
            }));

            return function (_x171) {
                return _ref97.apply(this, arguments);
            };
        }();

        this.updatePost = function () {
            var _ref98 = _asyncToGenerator(regeneratorRuntime.mark(function _callee95(post) {
                return regeneratorRuntime.wrap(function _callee95$(_context95) {
                    while (1) {
                        switch (_context95.prev = _context95.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_update', { channel_id: post.channel_id });

                                return _context95.abrupt('return', _this.doFetch('' + _this.getPostRoute(post.id), { method: 'put', body: JSON.stringify(post) }));

                            case 2:
                            case 'end':
                                return _context95.stop();
                        }
                    }
                }, _callee95, _this);
            }));

            return function (_x172) {
                return _ref98.apply(this, arguments);
            };
        }();

        this.patchPost = function () {
            var _ref99 = _asyncToGenerator(regeneratorRuntime.mark(function _callee96(post) {
                return regeneratorRuntime.wrap(function _callee96$(_context96) {
                    while (1) {
                        switch (_context96.prev = _context96.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_patch', { channel_id: post.channel_id });

                                return _context96.abrupt('return', _this.doFetch(_this.getPostRoute(post.id) + '/patch', { method: 'put', body: JSON.stringify(post) }));

                            case 2:
                            case 'end':
                                return _context96.stop();
                        }
                    }
                }, _callee96, _this);
            }));

            return function (_x173) {
                return _ref99.apply(this, arguments);
            };
        }();

        this.deletePost = function () {
            var _ref100 = _asyncToGenerator(regeneratorRuntime.mark(function _callee97(postId) {
                return regeneratorRuntime.wrap(function _callee97$(_context97) {
                    while (1) {
                        switch (_context97.prev = _context97.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_delete');

                                return _context97.abrupt('return', _this.doFetch('' + _this.getPostRoute(postId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context97.stop();
                        }
                    }
                }, _callee97, _this);
            }));

            return function (_x174) {
                return _ref100.apply(this, arguments);
            };
        }();

        this.getPostThread = function () {
            var _ref101 = _asyncToGenerator(regeneratorRuntime.mark(function _callee98(postId) {
                return regeneratorRuntime.wrap(function _callee98$(_context98) {
                    while (1) {
                        switch (_context98.prev = _context98.next) {
                            case 0:
                                return _context98.abrupt('return', _this.doFetch(_this.getPostRoute(postId) + '/thread', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context98.stop();
                        }
                    }
                }, _callee98, _this);
            }));

            return function (_x175) {
                return _ref101.apply(this, arguments);
            };
        }();

        this.getPosts = function () {
            var _ref102 = _asyncToGenerator(regeneratorRuntime.mark(function _callee99(channelId) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee99$(_context99) {
                    while (1) {
                        switch (_context99.prev = _context99.next) {
                            case 0:
                                return _context99.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/posts' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context99.stop();
                        }
                    }
                }, _callee99, _this);
            }));

            return function (_x176) {
                return _ref102.apply(this, arguments);
            };
        }();

        this.getPostsSince = function () {
            var _ref103 = _asyncToGenerator(regeneratorRuntime.mark(function _callee100(channelId, since) {
                return regeneratorRuntime.wrap(function _callee100$(_context100) {
                    while (1) {
                        switch (_context100.prev = _context100.next) {
                            case 0:
                                return _context100.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/posts' + buildQueryString({ since: since }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context100.stop();
                        }
                    }
                }, _callee100, _this);
            }));

            return function (_x179, _x180) {
                return _ref103.apply(this, arguments);
            };
        }();

        this.getPostsBefore = function () {
            var _ref104 = _asyncToGenerator(regeneratorRuntime.mark(function _callee101(channelId, postId) {
                var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee101$(_context101) {
                    while (1) {
                        switch (_context101.prev = _context101.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_get_before', { channel_id: channelId });

                                return _context101.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/posts' + buildQueryString({ before: postId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context101.stop();
                        }
                    }
                }, _callee101, _this);
            }));

            return function (_x181, _x182) {
                return _ref104.apply(this, arguments);
            };
        }();

        this.getPostsAfter = function () {
            var _ref105 = _asyncToGenerator(regeneratorRuntime.mark(function _callee102(channelId, postId) {
                var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee102$(_context102) {
                    while (1) {
                        switch (_context102.prev = _context102.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_get_after', { channel_id: channelId });

                                return _context102.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/posts' + buildQueryString({ after: postId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context102.stop();
                        }
                    }
                }, _callee102, _this);
            }));

            return function (_x185, _x186) {
                return _ref105.apply(this, arguments);
            };
        }();

        this.getFileInfosForPost = function () {
            var _ref106 = _asyncToGenerator(regeneratorRuntime.mark(function _callee103(postId) {
                return regeneratorRuntime.wrap(function _callee103$(_context103) {
                    while (1) {
                        switch (_context103.prev = _context103.next) {
                            case 0:
                                return _context103.abrupt('return', _this.doFetch(_this.getPostRoute(postId) + '/files/info', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context103.stop();
                        }
                    }
                }, _callee103, _this);
            }));

            return function (_x189) {
                return _ref106.apply(this, arguments);
            };
        }();

        this.getFlaggedPosts = function () {
            var _ref107 = _asyncToGenerator(regeneratorRuntime.mark(function _callee104(userId) {
                var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var teamId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var perPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee104$(_context104) {
                    while (1) {
                        switch (_context104.prev = _context104.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_get_flagged', { team_id: teamId });

                                return _context104.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/posts/flagged' + buildQueryString({ channel_id: channelId, team_id: teamId, page: page, per_page: perPage }), { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context104.stop();
                        }
                    }
                }, _callee104, _this);
            }));

            return function (_x190) {
                return _ref107.apply(this, arguments);
            };
        }();

        this.getPinnedPosts = function () {
            var _ref108 = _asyncToGenerator(regeneratorRuntime.mark(function _callee105(channelId) {
                return regeneratorRuntime.wrap(function _callee105$(_context105) {
                    while (1) {
                        switch (_context105.prev = _context105.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_get_pinned', { channel_id: channelId });
                                return _context105.abrupt('return', _this.doFetch(_this.getChannelRoute(channelId) + '/pinned', { method: 'get' }));

                            case 2:
                            case 'end':
                                return _context105.stop();
                        }
                    }
                }, _callee105, _this);
            }));

            return function (_x195) {
                return _ref108.apply(this, arguments);
            };
        }();

        this.pinPost = function () {
            var _ref109 = _asyncToGenerator(regeneratorRuntime.mark(function _callee106(postId) {
                return regeneratorRuntime.wrap(function _callee106$(_context106) {
                    while (1) {
                        switch (_context106.prev = _context106.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_pin');

                                return _context106.abrupt('return', _this.doFetch(_this.getPostRoute(postId) + '/pin', { method: 'post' }));

                            case 2:
                            case 'end':
                                return _context106.stop();
                        }
                    }
                }, _callee106, _this);
            }));

            return function (_x196) {
                return _ref109.apply(this, arguments);
            };
        }();

        this.unpinPost = function () {
            var _ref110 = _asyncToGenerator(regeneratorRuntime.mark(function _callee107(postId) {
                return regeneratorRuntime.wrap(function _callee107$(_context107) {
                    while (1) {
                        switch (_context107.prev = _context107.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_unpin');

                                return _context107.abrupt('return', _this.doFetch(_this.getPostRoute(postId) + '/unpin', { method: 'post' }));

                            case 2:
                            case 'end':
                                return _context107.stop();
                        }
                    }
                }, _callee107, _this);
            }));

            return function (_x197) {
                return _ref110.apply(this, arguments);
            };
        }();

        this.addReaction = function () {
            var _ref111 = _asyncToGenerator(regeneratorRuntime.mark(function _callee108(userId, postId, emojiName) {
                return regeneratorRuntime.wrap(function _callee108$(_context108) {
                    while (1) {
                        switch (_context108.prev = _context108.next) {
                            case 0:
                                _this.trackEvent('api', 'api_reactions_save', { post_id: postId });

                                return _context108.abrupt('return', _this.doFetch('' + _this.getReactionsRoute(), { method: 'post', body: JSON.stringify({ user_id: userId, post_id: postId, emoji_name: emojiName }) }));

                            case 2:
                            case 'end':
                                return _context108.stop();
                        }
                    }
                }, _callee108, _this);
            }));

            return function (_x198, _x199, _x200) {
                return _ref111.apply(this, arguments);
            };
        }();

        this.removeReaction = function () {
            var _ref112 = _asyncToGenerator(regeneratorRuntime.mark(function _callee109(userId, postId, emojiName) {
                return regeneratorRuntime.wrap(function _callee109$(_context109) {
                    while (1) {
                        switch (_context109.prev = _context109.next) {
                            case 0:
                                _this.trackEvent('api', 'api_reactions_delete', { post_id: postId });

                                return _context109.abrupt('return', _this.doFetch(_this.getUserRoute(userId) + '/posts/' + postId + '/reactions/' + emojiName, { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context109.stop();
                        }
                    }
                }, _callee109, _this);
            }));

            return function (_x201, _x202, _x203) {
                return _ref112.apply(this, arguments);
            };
        }();

        this.getReactionsForPost = function () {
            var _ref113 = _asyncToGenerator(regeneratorRuntime.mark(function _callee110(postId) {
                return regeneratorRuntime.wrap(function _callee110$(_context110) {
                    while (1) {
                        switch (_context110.prev = _context110.next) {
                            case 0:
                                return _context110.abrupt('return', _this.doFetch(_this.getPostRoute(postId) + '/reactions', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context110.stop();
                        }
                    }
                }, _callee110, _this);
            }));

            return function (_x204) {
                return _ref113.apply(this, arguments);
            };
        }();

        this.searchPosts = function () {
            var _ref114 = _asyncToGenerator(regeneratorRuntime.mark(function _callee111(teamId, terms, isOrSearch) {
                return regeneratorRuntime.wrap(function _callee111$(_context111) {
                    while (1) {
                        switch (_context111.prev = _context111.next) {
                            case 0:
                                _this.trackEvent('api', 'api_posts_search', { team_id: teamId });

                                return _context111.abrupt('return', _this.doFetch(_this.getTeamRoute(teamId) + '/posts/search', { method: 'post', body: JSON.stringify({ terms: terms, is_or_search: isOrSearch }) }));

                            case 2:
                            case 'end':
                                return _context111.stop();
                        }
                    }
                }, _callee111, _this);
            }));

            return function (_x205, _x206, _x207) {
                return _ref114.apply(this, arguments);
            };
        }();

        this.getOpenGraphMetadata = function () {
            var _ref115 = _asyncToGenerator(regeneratorRuntime.mark(function _callee112(url) {
                return regeneratorRuntime.wrap(function _callee112$(_context112) {
                    while (1) {
                        switch (_context112.prev = _context112.next) {
                            case 0:
                                return _context112.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/opengraph', { method: 'post', body: JSON.stringify({ url: url }) }));

                            case 1:
                            case 'end':
                                return _context112.stop();
                        }
                    }
                }, _callee112, _this);
            }));

            return function (_x208) {
                return _ref115.apply(this, arguments);
            };
        }();

        this.uploadFile = function () {
            var _ref116 = _asyncToGenerator(regeneratorRuntime.mark(function _callee113(fileFormData, formBoundary) {
                var request;
                return regeneratorRuntime.wrap(function _callee113$(_context113) {
                    while (1) {
                        switch (_context113.prev = _context113.next) {
                            case 0:
                                _this.trackEvent('api', 'api_files_upload');

                                request = {
                                    method: 'post',
                                    body: fileFormData
                                };


                                if (formBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formBoundary
                                    };
                                }

                                return _context113.abrupt('return', _this.doFetch('' + _this.getFilesRoute(), request));

                            case 4:
                            case 'end':
                                return _context113.stop();
                        }
                    }
                }, _callee113, _this);
            }));

            return function (_x209, _x210) {
                return _ref116.apply(this, arguments);
            };
        }();

        this.getFilePublicLink = function () {
            var _ref117 = _asyncToGenerator(regeneratorRuntime.mark(function _callee114(fileId) {
                return regeneratorRuntime.wrap(function _callee114$(_context114) {
                    while (1) {
                        switch (_context114.prev = _context114.next) {
                            case 0:
                                return _context114.abrupt('return', _this.doFetch(_this.getFileRoute(fileId) + '/link', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context114.stop();
                        }
                    }
                }, _callee114, _this);
            }));

            return function (_x211) {
                return _ref117.apply(this, arguments);
            };
        }();

        this.savePreferences = function () {
            var _ref118 = _asyncToGenerator(regeneratorRuntime.mark(function _callee115(userId, preferences) {
                return regeneratorRuntime.wrap(function _callee115$(_context115) {
                    while (1) {
                        switch (_context115.prev = _context115.next) {
                            case 0:
                                return _context115.abrupt('return', _this.doFetch('' + _this.getPreferencesRoute(userId), { method: 'put', body: JSON.stringify(preferences) }));

                            case 1:
                            case 'end':
                                return _context115.stop();
                        }
                    }
                }, _callee115, _this);
            }));

            return function (_x212, _x213) {
                return _ref118.apply(this, arguments);
            };
        }();

        this.getMyPreferences = _asyncToGenerator(regeneratorRuntime.mark(function _callee116() {
            return regeneratorRuntime.wrap(function _callee116$(_context116) {
                while (1) {
                    switch (_context116.prev = _context116.next) {
                        case 0:
                            return _context116.abrupt('return', _this.doFetch('' + _this.getPreferencesRoute('me'), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context116.stop();
                    }
                }
            }, _callee116, _this);
        }));

        this.deletePreferences = function () {
            var _ref120 = _asyncToGenerator(regeneratorRuntime.mark(function _callee117(userId, preferences) {
                return regeneratorRuntime.wrap(function _callee117$(_context117) {
                    while (1) {
                        switch (_context117.prev = _context117.next) {
                            case 0:
                                return _context117.abrupt('return', _this.doFetch(_this.getPreferencesRoute(userId) + '/delete', { method: 'post', body: JSON.stringify(preferences) }));

                            case 1:
                            case 'end':
                                return _context117.stop();
                        }
                    }
                }, _callee117, _this);
            }));

            return function (_x214, _x215) {
                return _ref120.apply(this, arguments);
            };
        }();

        this.ping = _asyncToGenerator(regeneratorRuntime.mark(function _callee118() {
            return regeneratorRuntime.wrap(function _callee118$(_context118) {
                while (1) {
                    switch (_context118.prev = _context118.next) {
                        case 0:
                            return _context118.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/system/ping?time=' + Date.now(), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context118.stop();
                    }
                }
            }, _callee118, _this);
        }));

        this.logClientError = function () {
            var _ref122 = _asyncToGenerator(regeneratorRuntime.mark(function _callee119(message) {
                var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ERROR';
                return regeneratorRuntime.wrap(function _callee119$(_context119) {
                    while (1) {
                        switch (_context119.prev = _context119.next) {
                            case 0:
                                if (_this.enableLogging) {
                                    _context119.next = 2;
                                    break;
                                }

                                throw {
                                    message: 'Logging disabled.'
                                };

                            case 2:
                                return _context119.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/logs', { method: 'post', body: JSON.stringify({ message: message, level: level }) }));

                            case 3:
                            case 'end':
                                return _context119.stop();
                        }
                    }
                }, _callee119, _this);
            }));

            return function (_x216) {
                return _ref122.apply(this, arguments);
            };
        }();

        this.getClientConfigOld = _asyncToGenerator(regeneratorRuntime.mark(function _callee120() {
            return regeneratorRuntime.wrap(function _callee120$(_context120) {
                while (1) {
                    switch (_context120.prev = _context120.next) {
                        case 0:
                            return _context120.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/config/client?format=old', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context120.stop();
                    }
                }
            }, _callee120, _this);
        }));
        this.getClientLicenseOld = _asyncToGenerator(regeneratorRuntime.mark(function _callee121() {
            return regeneratorRuntime.wrap(function _callee121$(_context121) {
                while (1) {
                    switch (_context121.prev = _context121.next) {
                        case 0:
                            return _context121.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/license/client?format=old', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context121.stop();
                    }
                }
            }, _callee121, _this);
        }));

        this.getTranslations = function () {
            var _ref125 = _asyncToGenerator(regeneratorRuntime.mark(function _callee122(url) {
                return regeneratorRuntime.wrap(function _callee122$(_context122) {
                    while (1) {
                        switch (_context122.prev = _context122.next) {
                            case 0:
                                return _context122.abrupt('return', _this.doFetch(url, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context122.stop();
                        }
                    }
                }, _callee122, _this);
            }));

            return function (_x218) {
                return _ref125.apply(this, arguments);
            };
        }();

        this.getWebSocketUrl = function () {
            return _this.getBaseRoute() + '/websocket';
        };

        this.webrtcToken = _asyncToGenerator(regeneratorRuntime.mark(function _callee123() {
            return regeneratorRuntime.wrap(function _callee123$(_context123) {
                while (1) {
                    switch (_context123.prev = _context123.next) {
                        case 0:
                            return _context123.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/webrtc/token', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context123.stop();
                    }
                }
            }, _callee123, _this);
        }));

        this.createIncomingWebhook = function () {
            var _ref127 = _asyncToGenerator(regeneratorRuntime.mark(function _callee124(hook) {
                return regeneratorRuntime.wrap(function _callee124$(_context124) {
                    while (1) {
                        switch (_context124.prev = _context124.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_created', { team_id: hook.team_id });

                                return _context124.abrupt('return', _this.doFetch('' + _this.getIncomingHooksRoute(), { method: 'post', body: JSON.stringify(hook) }));

                            case 2:
                            case 'end':
                                return _context124.stop();
                        }
                    }
                }, _callee124, _this);
            }));

            return function (_x219) {
                return _ref127.apply(this, arguments);
            };
        }();

        this.getIncomingWebhook = function () {
            var _ref128 = _asyncToGenerator(regeneratorRuntime.mark(function _callee125(hookId) {
                return regeneratorRuntime.wrap(function _callee125$(_context125) {
                    while (1) {
                        switch (_context125.prev = _context125.next) {
                            case 0:
                                return _context125.abrupt('return', _this.doFetch('' + _this.getIncomingHookRoute(hookId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context125.stop();
                        }
                    }
                }, _callee125, _this);
            }));

            return function (_x220) {
                return _ref128.apply(this, arguments);
            };
        }();

        this.getIncomingWebhooks = function () {
            var _ref129 = _asyncToGenerator(regeneratorRuntime.mark(function _callee126() {
                var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                var queryParams;
                return regeneratorRuntime.wrap(function _callee126$(_context126) {
                    while (1) {
                        switch (_context126.prev = _context126.next) {
                            case 0:
                                queryParams = { page: page, per_page: perPage };


                                if (teamId) {
                                    queryParams.team_id = teamId;
                                }

                                return _context126.abrupt('return', _this.doFetch('' + _this.getIncomingHooksRoute() + buildQueryString(queryParams), { method: 'get' }));

                            case 3:
                            case 'end':
                                return _context126.stop();
                        }
                    }
                }, _callee126, _this);
            }));

            return function () {
                return _ref129.apply(this, arguments);
            };
        }();

        this.removeIncomingWebhook = function () {
            var _ref130 = _asyncToGenerator(regeneratorRuntime.mark(function _callee127(hookId) {
                return regeneratorRuntime.wrap(function _callee127$(_context127) {
                    while (1) {
                        switch (_context127.prev = _context127.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_deleted');

                                return _context127.abrupt('return', _this.doFetch('' + _this.getIncomingHookRoute(hookId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context127.stop();
                        }
                    }
                }, _callee127, _this);
            }));

            return function (_x224) {
                return _ref130.apply(this, arguments);
            };
        }();

        this.updateIncomingWebhook = function () {
            var _ref131 = _asyncToGenerator(regeneratorRuntime.mark(function _callee128(hook) {
                return regeneratorRuntime.wrap(function _callee128$(_context128) {
                    while (1) {
                        switch (_context128.prev = _context128.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_updated', { team_id: hook.team_id });

                                return _context128.abrupt('return', _this.doFetch('' + _this.getIncomingHookRoute(hook.id), { method: 'put', body: JSON.stringify(hook) }));

                            case 2:
                            case 'end':
                                return _context128.stop();
                        }
                    }
                }, _callee128, _this);
            }));

            return function (_x225) {
                return _ref131.apply(this, arguments);
            };
        }();

        this.createOutgoingWebhook = function () {
            var _ref132 = _asyncToGenerator(regeneratorRuntime.mark(function _callee129(hook) {
                return regeneratorRuntime.wrap(function _callee129$(_context129) {
                    while (1) {
                        switch (_context129.prev = _context129.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_created', { team_id: hook.team_id });

                                return _context129.abrupt('return', _this.doFetch('' + _this.getOutgoingHooksRoute(), { method: 'post', body: JSON.stringify(hook) }));

                            case 2:
                            case 'end':
                                return _context129.stop();
                        }
                    }
                }, _callee129, _this);
            }));

            return function (_x226) {
                return _ref132.apply(this, arguments);
            };
        }();

        this.getOutgoingWebhook = function () {
            var _ref133 = _asyncToGenerator(regeneratorRuntime.mark(function _callee130(hookId) {
                return regeneratorRuntime.wrap(function _callee130$(_context130) {
                    while (1) {
                        switch (_context130.prev = _context130.next) {
                            case 0:
                                return _context130.abrupt('return', _this.doFetch('' + _this.getOutgoingHookRoute(hookId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context130.stop();
                        }
                    }
                }, _callee130, _this);
            }));

            return function (_x227) {
                return _ref133.apply(this, arguments);
            };
        }();

        this.getOutgoingWebhooks = function () {
            var _ref134 = _asyncToGenerator(regeneratorRuntime.mark(function _callee131() {
                var channelId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
                var queryParams;
                return regeneratorRuntime.wrap(function _callee131$(_context131) {
                    while (1) {
                        switch (_context131.prev = _context131.next) {
                            case 0:
                                queryParams = { page: page, per_page: perPage };


                                if (channelId) {
                                    queryParams.channel_id = channelId;
                                }

                                if (teamId) {
                                    queryParams.team_id = teamId;
                                }

                                return _context131.abrupt('return', _this.doFetch('' + _this.getOutgoingHooksRoute() + buildQueryString(queryParams), { method: 'get' }));

                            case 4:
                            case 'end':
                                return _context131.stop();
                        }
                    }
                }, _callee131, _this);
            }));

            return function () {
                return _ref134.apply(this, arguments);
            };
        }();

        this.removeOutgoingWebhook = function () {
            var _ref135 = _asyncToGenerator(regeneratorRuntime.mark(function _callee132(hookId) {
                return regeneratorRuntime.wrap(function _callee132$(_context132) {
                    while (1) {
                        switch (_context132.prev = _context132.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_deleted');

                                return _context132.abrupt('return', _this.doFetch('' + _this.getOutgoingHookRoute(hookId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context132.stop();
                        }
                    }
                }, _callee132, _this);
            }));

            return function (_x232) {
                return _ref135.apply(this, arguments);
            };
        }();

        this.updateOutgoingWebhook = function () {
            var _ref136 = _asyncToGenerator(regeneratorRuntime.mark(function _callee133(hook) {
                return regeneratorRuntime.wrap(function _callee133$(_context133) {
                    while (1) {
                        switch (_context133.prev = _context133.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_updated', { team_id: hook.team_id });

                                return _context133.abrupt('return', _this.doFetch('' + _this.getOutgoingHookRoute(hook.id), { method: 'put', body: JSON.stringify(hook) }));

                            case 2:
                            case 'end':
                                return _context133.stop();
                        }
                    }
                }, _callee133, _this);
            }));

            return function (_x233) {
                return _ref136.apply(this, arguments);
            };
        }();

        this.regenOutgoingHookToken = function () {
            var _ref137 = _asyncToGenerator(regeneratorRuntime.mark(function _callee134(id) {
                return regeneratorRuntime.wrap(function _callee134$(_context134) {
                    while (1) {
                        switch (_context134.prev = _context134.next) {
                            case 0:
                                return _context134.abrupt('return', _this.doFetch(_this.getOutgoingHookRoute(id) + '/regen_token', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context134.stop();
                        }
                    }
                }, _callee134, _this);
            }));

            return function (_x234) {
                return _ref137.apply(this, arguments);
            };
        }();

        this.getCommandsList = function () {
            var _ref138 = _asyncToGenerator(regeneratorRuntime.mark(function _callee135(teamId) {
                return regeneratorRuntime.wrap(function _callee135$(_context135) {
                    while (1) {
                        switch (_context135.prev = _context135.next) {
                            case 0:
                                return _context135.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '?team_id=' + teamId, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context135.stop();
                        }
                    }
                }, _callee135, _this);
            }));

            return function (_x235) {
                return _ref138.apply(this, arguments);
            };
        }();

        this.getCustomTeamCommands = function () {
            var _ref139 = _asyncToGenerator(regeneratorRuntime.mark(function _callee136(teamId) {
                return regeneratorRuntime.wrap(function _callee136$(_context136) {
                    while (1) {
                        switch (_context136.prev = _context136.next) {
                            case 0:
                                return _context136.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '?team_id=' + teamId + '&custom_only=true', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context136.stop();
                        }
                    }
                }, _callee136, _this);
            }));

            return function (_x236) {
                return _ref139.apply(this, arguments);
            };
        }();

        this.executeCommand = function () {
            var _ref140 = _asyncToGenerator(regeneratorRuntime.mark(function _callee137(command) {
                var commandArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return regeneratorRuntime.wrap(function _callee137$(_context137) {
                    while (1) {
                        switch (_context137.prev = _context137.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_used');

                                return _context137.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '/execute', { method: 'post', body: JSON.stringify(_extends({ command: command }, commandArgs)) }));

                            case 2:
                            case 'end':
                                return _context137.stop();
                        }
                    }
                }, _callee137, _this);
            }));

            return function (_x237) {
                return _ref140.apply(this, arguments);
            };
        }();

        this.addCommand = function () {
            var _ref141 = _asyncToGenerator(regeneratorRuntime.mark(function _callee138(command) {
                return regeneratorRuntime.wrap(function _callee138$(_context138) {
                    while (1) {
                        switch (_context138.prev = _context138.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_created');

                                return _context138.abrupt('return', _this.doFetch('' + _this.getCommandsRoute(), { method: 'post', body: JSON.stringify(command) }));

                            case 2:
                            case 'end':
                                return _context138.stop();
                        }
                    }
                }, _callee138, _this);
            }));

            return function (_x239) {
                return _ref141.apply(this, arguments);
            };
        }();

        this.editCommand = function () {
            var _ref142 = _asyncToGenerator(regeneratorRuntime.mark(function _callee139(command) {
                return regeneratorRuntime.wrap(function _callee139$(_context139) {
                    while (1) {
                        switch (_context139.prev = _context139.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_created');

                                return _context139.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '/' + command.id, { method: 'put', body: JSON.stringify(command) }));

                            case 2:
                            case 'end':
                                return _context139.stop();
                        }
                    }
                }, _callee139, _this);
            }));

            return function (_x240) {
                return _ref142.apply(this, arguments);
            };
        }();

        this.regenCommandToken = function () {
            var _ref143 = _asyncToGenerator(regeneratorRuntime.mark(function _callee140(id) {
                return regeneratorRuntime.wrap(function _callee140$(_context140) {
                    while (1) {
                        switch (_context140.prev = _context140.next) {
                            case 0:
                                return _context140.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '/' + id + '/regen_token', { method: 'put' }));

                            case 1:
                            case 'end':
                                return _context140.stop();
                        }
                    }
                }, _callee140, _this);
            }));

            return function (_x241) {
                return _ref143.apply(this, arguments);
            };
        }();

        this.deleteCommand = function () {
            var _ref144 = _asyncToGenerator(regeneratorRuntime.mark(function _callee141(id) {
                return regeneratorRuntime.wrap(function _callee141$(_context141) {
                    while (1) {
                        switch (_context141.prev = _context141.next) {
                            case 0:
                                _this.trackEvent('api', 'api_integrations_deleted');

                                return _context141.abrupt('return', _this.doFetch(_this.getCommandsRoute() + '/' + id, { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context141.stop();
                        }
                    }
                }, _callee141, _this);
            }));

            return function (_x242) {
                return _ref144.apply(this, arguments);
            };
        }();

        this.createOAuthApp = function () {
            var _ref145 = _asyncToGenerator(regeneratorRuntime.mark(function _callee142(app) {
                return regeneratorRuntime.wrap(function _callee142$(_context142) {
                    while (1) {
                        switch (_context142.prev = _context142.next) {
                            case 0:
                                _this.trackEvent('api', 'api_apps_register');

                                return _context142.abrupt('return', _this.doFetch('' + _this.getOAuthAppsRoute(), { method: 'post', body: JSON.stringify(app) }));

                            case 2:
                            case 'end':
                                return _context142.stop();
                        }
                    }
                }, _callee142, _this);
            }));

            return function (_x243) {
                return _ref145.apply(this, arguments);
            };
        }();

        this.getOAuthApps = function () {
            var _ref146 = _asyncToGenerator(regeneratorRuntime.mark(function _callee143() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee143$(_context143) {
                    while (1) {
                        switch (_context143.prev = _context143.next) {
                            case 0:
                                return _context143.abrupt('return', _this.doFetch('' + _this.getOAuthAppsRoute() + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context143.stop();
                        }
                    }
                }, _callee143, _this);
            }));

            return function () {
                return _ref146.apply(this, arguments);
            };
        }();

        this.getOAuthApp = function () {
            var _ref147 = _asyncToGenerator(regeneratorRuntime.mark(function _callee144(appId) {
                return regeneratorRuntime.wrap(function _callee144$(_context144) {
                    while (1) {
                        switch (_context144.prev = _context144.next) {
                            case 0:
                                return _context144.abrupt('return', _this.doFetch('' + _this.getOAuthAppRoute(appId), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context144.stop();
                        }
                    }
                }, _callee144, _this);
            }));

            return function (_x246) {
                return _ref147.apply(this, arguments);
            };
        }();

        this.getOAuthAppInfo = function () {
            var _ref148 = _asyncToGenerator(regeneratorRuntime.mark(function _callee145(appId) {
                return regeneratorRuntime.wrap(function _callee145$(_context145) {
                    while (1) {
                        switch (_context145.prev = _context145.next) {
                            case 0:
                                return _context145.abrupt('return', _this.doFetch(_this.getOAuthAppRoute(appId) + '/info', { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context145.stop();
                        }
                    }
                }, _callee145, _this);
            }));

            return function (_x247) {
                return _ref148.apply(this, arguments);
            };
        }();

        this.deleteOAuthApp = function () {
            var _ref149 = _asyncToGenerator(regeneratorRuntime.mark(function _callee146(appId) {
                return regeneratorRuntime.wrap(function _callee146$(_context146) {
                    while (1) {
                        switch (_context146.prev = _context146.next) {
                            case 0:
                                _this.trackEvent('api', 'api_apps_delete');

                                return _context146.abrupt('return', _this.doFetch('' + _this.getOAuthAppRoute(appId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context146.stop();
                        }
                    }
                }, _callee146, _this);
            }));

            return function (_x248) {
                return _ref149.apply(this, arguments);
            };
        }();

        this.regenOAuthAppSecret = function () {
            var _ref150 = _asyncToGenerator(regeneratorRuntime.mark(function _callee147(appId) {
                return regeneratorRuntime.wrap(function _callee147$(_context147) {
                    while (1) {
                        switch (_context147.prev = _context147.next) {
                            case 0:
                                return _context147.abrupt('return', _this.doFetch(_this.getOAuthAppRoute(appId) + '/regen_secret', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context147.stop();
                        }
                    }
                }, _callee147, _this);
            }));

            return function (_x249) {
                return _ref150.apply(this, arguments);
            };
        }();

        this.createCustomEmoji = function () {
            var _ref151 = _asyncToGenerator(regeneratorRuntime.mark(function _callee148(emoji, imageData) {
                var formData, request;
                return regeneratorRuntime.wrap(function _callee148$(_context148) {
                    while (1) {
                        switch (_context148.prev = _context148.next) {
                            case 0:
                                _this.trackEvent('api', 'api_emoji_custom_add');

                                formData = new FormData();

                                formData.append('image', imageData);
                                formData.append('emoji', JSON.stringify(emoji));

                                request = {
                                    method: 'post',
                                    body: formData
                                };


                                if (formData.getBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                    };
                                }

                                return _context148.abrupt('return', _this.doFetch('' + _this.getEmojisRoute(), request));

                            case 7:
                            case 'end':
                                return _context148.stop();
                        }
                    }
                }, _callee148, _this);
            }));

            return function (_x250, _x251) {
                return _ref151.apply(this, arguments);
            };
        }();

        this.getCustomEmojis = function () {
            var _ref152 = _asyncToGenerator(regeneratorRuntime.mark(function _callee149() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee149$(_context149) {
                    while (1) {
                        switch (_context149.prev = _context149.next) {
                            case 0:
                                return _context149.abrupt('return', _this.doFetch('' + _this.getEmojisRoute() + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context149.stop();
                        }
                    }
                }, _callee149, _this);
            }));

            return function () {
                return _ref152.apply(this, arguments);
            };
        }();

        this.deleteCustomEmoji = function () {
            var _ref153 = _asyncToGenerator(regeneratorRuntime.mark(function _callee150(emojiId) {
                return regeneratorRuntime.wrap(function _callee150$(_context150) {
                    while (1) {
                        switch (_context150.prev = _context150.next) {
                            case 0:
                                _this.trackEvent('api', 'api_emoji_custom_delete');

                                return _context150.abrupt('return', _this.doFetch('' + _this.getEmojiRoute(emojiId), { method: 'delete' }));

                            case 2:
                            case 'end':
                                return _context150.stop();
                        }
                    }
                }, _callee150, _this);
            }));

            return function (_x254) {
                return _ref153.apply(this, arguments);
            };
        }();

        this.getSystemEmojiImageUrl = function (filename) {
            return _this.url + '/static/emoji/' + filename + '.png';
        };

        this.getCustomEmojiImageUrl = function (id) {
            return _this.getEmojiRoute(id) + '/image';
        };

        this.getJob = function () {
            var _ref154 = _asyncToGenerator(regeneratorRuntime.mark(function _callee151(id) {
                return regeneratorRuntime.wrap(function _callee151$(_context151) {
                    while (1) {
                        switch (_context151.prev = _context151.next) {
                            case 0:
                                return _context151.abrupt('return', _this.doFetch(_this.getJobsRoute() + '/' + id, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context151.stop();
                        }
                    }
                }, _callee151, _this);
            }));

            return function (_x255) {
                return _ref154.apply(this, arguments);
            };
        }();

        this.getJobs = function () {
            var _ref155 = _asyncToGenerator(regeneratorRuntime.mark(function _callee152() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee152$(_context152) {
                    while (1) {
                        switch (_context152.prev = _context152.next) {
                            case 0:
                                return _context152.abrupt('return', _this.doFetch('' + _this.getJobsRoute() + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context152.stop();
                        }
                    }
                }, _callee152, _this);
            }));

            return function () {
                return _ref155.apply(this, arguments);
            };
        }();

        this.getJobsByType = function () {
            var _ref156 = _asyncToGenerator(regeneratorRuntime.mark(function _callee153(type) {
                var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee153$(_context153) {
                    while (1) {
                        switch (_context153.prev = _context153.next) {
                            case 0:
                                return _context153.abrupt('return', _this.doFetch(_this.getJobsRoute() + '/type/' + type + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context153.stop();
                        }
                    }
                }, _callee153, _this);
            }));

            return function (_x258) {
                return _ref156.apply(this, arguments);
            };
        }();

        this.createJob = function () {
            var _ref157 = _asyncToGenerator(regeneratorRuntime.mark(function _callee154(job) {
                return regeneratorRuntime.wrap(function _callee154$(_context154) {
                    while (1) {
                        switch (_context154.prev = _context154.next) {
                            case 0:
                                return _context154.abrupt('return', _this.doFetch('' + _this.getJobsRoute(), { method: 'post', body: JSON.stringify(job) }));

                            case 1:
                            case 'end':
                                return _context154.stop();
                        }
                    }
                }, _callee154, _this);
            }));

            return function (_x261) {
                return _ref157.apply(this, arguments);
            };
        }();

        this.cancelJob = function () {
            var _ref158 = _asyncToGenerator(regeneratorRuntime.mark(function _callee155(id) {
                return regeneratorRuntime.wrap(function _callee155$(_context155) {
                    while (1) {
                        switch (_context155.prev = _context155.next) {
                            case 0:
                                return _context155.abrupt('return', _this.doFetch(_this.getJobsRoute() + '/' + id + '/cancel', { method: 'post' }));

                            case 1:
                            case 'end':
                                return _context155.stop();
                        }
                    }
                }, _callee155, _this);
            }));

            return function (_x262) {
                return _ref158.apply(this, arguments);
            };
        }();

        this.getLogs = function () {
            var _ref159 = _asyncToGenerator(regeneratorRuntime.mark(function _callee156() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee156$(_context156) {
                    while (1) {
                        switch (_context156.prev = _context156.next) {
                            case 0:
                                return _context156.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/logs' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context156.stop();
                        }
                    }
                }, _callee156, _this);
            }));

            return function () {
                return _ref159.apply(this, arguments);
            };
        }();

        this.getAudits = function () {
            var _ref160 = _asyncToGenerator(regeneratorRuntime.mark(function _callee157() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee157$(_context157) {
                    while (1) {
                        switch (_context157.prev = _context157.next) {
                            case 0:
                                return _context157.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/audits' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context157.stop();
                        }
                    }
                }, _callee157, _this);
            }));

            return function () {
                return _ref160.apply(this, arguments);
            };
        }();

        this.getConfig = _asyncToGenerator(regeneratorRuntime.mark(function _callee158() {
            return regeneratorRuntime.wrap(function _callee158$(_context158) {
                while (1) {
                    switch (_context158.prev = _context158.next) {
                        case 0:
                            return _context158.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/config', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context158.stop();
                    }
                }
            }, _callee158, _this);
        }));

        this.updateConfig = function () {
            var _ref162 = _asyncToGenerator(regeneratorRuntime.mark(function _callee159(config) {
                return regeneratorRuntime.wrap(function _callee159$(_context159) {
                    while (1) {
                        switch (_context159.prev = _context159.next) {
                            case 0:
                                return _context159.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/config', { method: 'put', body: JSON.stringify(config) }));

                            case 1:
                            case 'end':
                                return _context159.stop();
                        }
                    }
                }, _callee159, _this);
            }));

            return function (_x267) {
                return _ref162.apply(this, arguments);
            };
        }();

        this.reloadConfig = _asyncToGenerator(regeneratorRuntime.mark(function _callee160() {
            return regeneratorRuntime.wrap(function _callee160$(_context160) {
                while (1) {
                    switch (_context160.prev = _context160.next) {
                        case 0:
                            return _context160.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/config/reload', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context160.stop();
                    }
                }
            }, _callee160, _this);
        }));

        this.testEmail = function () {
            var _ref164 = _asyncToGenerator(regeneratorRuntime.mark(function _callee161(config) {
                return regeneratorRuntime.wrap(function _callee161$(_context161) {
                    while (1) {
                        switch (_context161.prev = _context161.next) {
                            case 0:
                                return _context161.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/email/test', { method: 'post', body: JSON.stringify(config) }));

                            case 1:
                            case 'end':
                                return _context161.stop();
                        }
                    }
                }, _callee161, _this);
            }));

            return function (_x268) {
                return _ref164.apply(this, arguments);
            };
        }();

        this.invalidateCaches = _asyncToGenerator(regeneratorRuntime.mark(function _callee162() {
            return regeneratorRuntime.wrap(function _callee162$(_context162) {
                while (1) {
                    switch (_context162.prev = _context162.next) {
                        case 0:
                            return _context162.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/caches/invalidate', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context162.stop();
                    }
                }
            }, _callee162, _this);
        }));
        this.recycleDatabase = _asyncToGenerator(regeneratorRuntime.mark(function _callee163() {
            return regeneratorRuntime.wrap(function _callee163$(_context163) {
                while (1) {
                    switch (_context163.prev = _context163.next) {
                        case 0:
                            return _context163.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/database/recycle', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context163.stop();
                    }
                }
            }, _callee163, _this);
        }));

        this.createComplianceReport = function () {
            var _ref167 = _asyncToGenerator(regeneratorRuntime.mark(function _callee164(job) {
                return regeneratorRuntime.wrap(function _callee164$(_context164) {
                    while (1) {
                        switch (_context164.prev = _context164.next) {
                            case 0:
                                return _context164.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/compliance/reports', { method: 'post', body: JSON.stringify(job) }));

                            case 1:
                            case 'end':
                                return _context164.stop();
                        }
                    }
                }, _callee164, _this);
            }));

            return function (_x269) {
                return _ref167.apply(this, arguments);
            };
        }();

        this.getComplianceReport = function () {
            var _ref168 = _asyncToGenerator(regeneratorRuntime.mark(function _callee165(reportId) {
                return regeneratorRuntime.wrap(function _callee165$(_context165) {
                    while (1) {
                        switch (_context165.prev = _context165.next) {
                            case 0:
                                return _context165.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/compliance/reports/' + reportId, { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context165.stop();
                        }
                    }
                }, _callee165, _this);
            }));

            return function (_x270) {
                return _ref168.apply(this, arguments);
            };
        }();

        this.getComplianceReports = function () {
            var _ref169 = _asyncToGenerator(regeneratorRuntime.mark(function _callee166() {
                var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
                return regeneratorRuntime.wrap(function _callee166$(_context166) {
                    while (1) {
                        switch (_context166.prev = _context166.next) {
                            case 0:
                                return _context166.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/compliance/reports' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context166.stop();
                        }
                    }
                }, _callee166, _this);
            }));

            return function () {
                return _ref169.apply(this, arguments);
            };
        }();

        this.uploadBrandImage = function () {
            var _ref170 = _asyncToGenerator(regeneratorRuntime.mark(function _callee167(imageData) {
                var formData, request;
                return regeneratorRuntime.wrap(function _callee167$(_context167) {
                    while (1) {
                        switch (_context167.prev = _context167.next) {
                            case 0:
                                formData = new FormData();

                                formData.append('image', imageData);

                                request = {
                                    method: 'post',
                                    body: formData
                                };


                                if (formData.getBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                    };
                                }

                                return _context167.abrupt('return', _this.doFetch(_this.getBrandRoute() + '/image', request));

                            case 5:
                            case 'end':
                                return _context167.stop();
                        }
                    }
                }, _callee167, _this);
            }));

            return function (_x273) {
                return _ref170.apply(this, arguments);
            };
        }();

        this.getClusterStatus = _asyncToGenerator(regeneratorRuntime.mark(function _callee168() {
            return regeneratorRuntime.wrap(function _callee168$(_context168) {
                while (1) {
                    switch (_context168.prev = _context168.next) {
                        case 0:
                            return _context168.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/cluster/status', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context168.stop();
                    }
                }
            }, _callee168, _this);
        }));
        this.testLdap = _asyncToGenerator(regeneratorRuntime.mark(function _callee169() {
            return regeneratorRuntime.wrap(function _callee169$(_context169) {
                while (1) {
                    switch (_context169.prev = _context169.next) {
                        case 0:
                            return _context169.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/ldap/test', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context169.stop();
                    }
                }
            }, _callee169, _this);
        }));
        this.syncLdap = _asyncToGenerator(regeneratorRuntime.mark(function _callee170() {
            return regeneratorRuntime.wrap(function _callee170$(_context170) {
                while (1) {
                    switch (_context170.prev = _context170.next) {
                        case 0:
                            return _context170.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/ldap/sync', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context170.stop();
                    }
                }
            }, _callee170, _this);
        }));
        this.getSamlCertificateStatus = _asyncToGenerator(regeneratorRuntime.mark(function _callee171() {
            return regeneratorRuntime.wrap(function _callee171$(_context171) {
                while (1) {
                    switch (_context171.prev = _context171.next) {
                        case 0:
                            return _context171.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/status', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context171.stop();
                    }
                }
            }, _callee171, _this);
        }));

        this.uploadPublicSamlCertificate = function () {
            var _ref175 = _asyncToGenerator(regeneratorRuntime.mark(function _callee172(fileData) {
                var formData;
                return regeneratorRuntime.wrap(function _callee172$(_context172) {
                    while (1) {
                        switch (_context172.prev = _context172.next) {
                            case 0:
                                formData = new FormData();

                                formData.append('certificate', fileData);

                                return _context172.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/public', {
                                    method: 'post',
                                    body: formData
                                }));

                            case 3:
                            case 'end':
                                return _context172.stop();
                        }
                    }
                }, _callee172, _this);
            }));

            return function (_x274) {
                return _ref175.apply(this, arguments);
            };
        }();

        this.uploadPrivateSamlCertificate = function () {
            var _ref176 = _asyncToGenerator(regeneratorRuntime.mark(function _callee173(fileData) {
                var formData;
                return regeneratorRuntime.wrap(function _callee173$(_context173) {
                    while (1) {
                        switch (_context173.prev = _context173.next) {
                            case 0:
                                formData = new FormData();

                                formData.append('certificate', fileData);

                                return _context173.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/private', {
                                    method: 'post',
                                    body: formData
                                }));

                            case 3:
                            case 'end':
                                return _context173.stop();
                        }
                    }
                }, _callee173, _this);
            }));

            return function (_x275) {
                return _ref176.apply(this, arguments);
            };
        }();

        this.uploadIdpSamlCertificate = function () {
            var _ref177 = _asyncToGenerator(regeneratorRuntime.mark(function _callee174(fileData) {
                var formData;
                return regeneratorRuntime.wrap(function _callee174$(_context174) {
                    while (1) {
                        switch (_context174.prev = _context174.next) {
                            case 0:
                                formData = new FormData();

                                formData.append('certificate', fileData);

                                return _context174.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/idp', {
                                    method: 'post',
                                    body: formData
                                }));

                            case 3:
                            case 'end':
                                return _context174.stop();
                        }
                    }
                }, _callee174, _this);
            }));

            return function (_x276) {
                return _ref177.apply(this, arguments);
            };
        }();

        this.deletePublicSamlCertificate = _asyncToGenerator(regeneratorRuntime.mark(function _callee175() {
            return regeneratorRuntime.wrap(function _callee175$(_context175) {
                while (1) {
                    switch (_context175.prev = _context175.next) {
                        case 0:
                            return _context175.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/public', { method: 'delete' }));

                        case 1:
                        case 'end':
                            return _context175.stop();
                    }
                }
            }, _callee175, _this);
        }));
        this.deletePrivateSamlCertificate = _asyncToGenerator(regeneratorRuntime.mark(function _callee176() {
            return regeneratorRuntime.wrap(function _callee176$(_context176) {
                while (1) {
                    switch (_context176.prev = _context176.next) {
                        case 0:
                            return _context176.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/private', { method: 'delete' }));

                        case 1:
                        case 'end':
                            return _context176.stop();
                    }
                }
            }, _callee176, _this);
        }));
        this.deleteIdpSamlCertificate = _asyncToGenerator(regeneratorRuntime.mark(function _callee177() {
            return regeneratorRuntime.wrap(function _callee177$(_context177) {
                while (1) {
                    switch (_context177.prev = _context177.next) {
                        case 0:
                            return _context177.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/saml/certificate/idp', { method: 'delete' }));

                        case 1:
                        case 'end':
                            return _context177.stop();
                    }
                }
            }, _callee177, _this);
        }));

        this.testElasticsearch = function () {
            var _ref181 = _asyncToGenerator(regeneratorRuntime.mark(function _callee178(config) {
                return regeneratorRuntime.wrap(function _callee178$(_context178) {
                    while (1) {
                        switch (_context178.prev = _context178.next) {
                            case 0:
                                return _context178.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/elasticsearch/test', { method: 'post', body: JSON.stringify(config) }));

                            case 1:
                            case 'end':
                                return _context178.stop();
                        }
                    }
                }, _callee178, _this);
            }));

            return function (_x277) {
                return _ref181.apply(this, arguments);
            };
        }();

        this.purgeElasticsearchIndexes = _asyncToGenerator(regeneratorRuntime.mark(function _callee179() {
            return regeneratorRuntime.wrap(function _callee179$(_context179) {
                while (1) {
                    switch (_context179.prev = _context179.next) {
                        case 0:
                            return _context179.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/elasticsearch/purge_indexes', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context179.stop();
                    }
                }
            }, _callee179, _this);
        }));

        this.uploadLicense = function () {
            var _ref183 = _asyncToGenerator(regeneratorRuntime.mark(function _callee180(fileData) {
                var formData, request;
                return regeneratorRuntime.wrap(function _callee180$(_context180) {
                    while (1) {
                        switch (_context180.prev = _context180.next) {
                            case 0:
                                _this.trackEvent('api', 'api_license_upload');

                                formData = new FormData();

                                formData.append('license', fileData);

                                request = {
                                    method: 'post',
                                    body: formData
                                };


                                if (formData.getBoundary) {
                                    request.headers = {
                                        'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                    };
                                }

                                return _context180.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/license', request));

                            case 6:
                            case 'end':
                                return _context180.stop();
                        }
                    }
                }, _callee180, _this);
            }));

            return function (_x278) {
                return _ref183.apply(this, arguments);
            };
        }();

        this.removeLicense = _asyncToGenerator(regeneratorRuntime.mark(function _callee181() {
            return regeneratorRuntime.wrap(function _callee181$(_context181) {
                while (1) {
                    switch (_context181.prev = _context181.next) {
                        case 0:
                            return _context181.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/license', { method: 'delete' }));

                        case 1:
                        case 'end':
                            return _context181.stop();
                    }
                }
            }, _callee181, _this);
        }));

        this.getAnalytics = function () {
            var _ref185 = _asyncToGenerator(regeneratorRuntime.mark(function _callee182() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'standard';
                var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                return regeneratorRuntime.wrap(function _callee182$(_context182) {
                    while (1) {
                        switch (_context182.prev = _context182.next) {
                            case 0:
                                return _context182.abrupt('return', _this.doFetch(_this.getBaseRoute() + '/analytics/old' + buildQueryString({ name: name, team_id: teamId }), { method: 'get' }));

                            case 1:
                            case 'end':
                                return _context182.stop();
                        }
                    }
                }, _callee182, _this);
            }));

            return function () {
                return _ref185.apply(this, arguments);
            };
        }();

        this.doFetch = function () {
            var _ref186 = _asyncToGenerator(regeneratorRuntime.mark(function _callee183(url, options) {
                var _ref187, data;

                return regeneratorRuntime.wrap(function _callee183$(_context183) {
                    while (1) {
                        switch (_context183.prev = _context183.next) {
                            case 0:
                                _context183.next = 2;
                                return _this.doFetchWithResponse(url, options);

                            case 2:
                                _ref187 = _context183.sent;
                                data = _ref187.data;
                                return _context183.abrupt('return', data);

                            case 5:
                            case 'end':
                                return _context183.stop();
                        }
                    }
                }, _callee183, _this);
            }));

            return function (_x281, _x282) {
                return _ref186.apply(this, arguments);
            };
        }();

        this.doFetchWithResponse = function () {
            var _ref188 = _asyncToGenerator(regeneratorRuntime.mark(function _callee184(url, options) {
                var response, headers, data, serverVersion, clusterId, msg;
                return regeneratorRuntime.wrap(function _callee184$(_context184) {
                    while (1) {
                        switch (_context184.prev = _context184.next) {
                            case 0:
                                _context184.next = 2;
                                return (0, _fetch_etag2.default)(url, _this.getOptions(options));

                            case 2:
                                response = _context184.sent;
                                headers = parseAndMergeNestedHeaders(response.headers);
                                data = void 0;
                                _context184.prev = 5;
                                _context184.next = 8;
                                return response.json();

                            case 8:
                                data = _context184.sent;
                                _context184.next = 14;
                                break;

                            case 11:
                                _context184.prev = 11;
                                _context184.t0 = _context184['catch'](5);
                                throw {
                                    intl: {
                                        id: 'mobile.request.invalid_response',
                                        defaultMessage: 'Received invalid response from the server.'
                                    }
                                };

                            case 14:

                                // Need to only accept version in the header from requests that are not cached
                                // to avoid getting an old version from a cached response
                                if (headers.has(HEADER_X_VERSION_ID) && !headers.get('Cache-Control')) {
                                    serverVersion = headers.get(HEADER_X_VERSION_ID);

                                    if (serverVersion && _this.serverVersion !== serverVersion) {
                                        _this.serverVersion = serverVersion;
                                        _event_emitter2.default.emit(_constants.General.CONFIG_CHANGED, serverVersion);
                                    }
                                }

                                if (headers.has(HEADER_X_CLUSTER_ID)) {
                                    clusterId = headers.get(HEADER_X_CLUSTER_ID);

                                    if (clusterId && _this.clusterId !== clusterId) {
                                        _this.clusterId = clusterId;
                                    }
                                }

                                if (!response.ok) {
                                    _context184.next = 18;
                                    break;
                                }

                                return _context184.abrupt('return', {
                                    response: response,
                                    headers: headers,
                                    data: data
                                });

                            case 18:
                                msg = data.message || '';


                                if (_this.logToConsole) {
                                    console.error(msg); // eslint-disable-line no-console
                                }

                                throw {
                                    message: msg,
                                    server_error_id: data.id,
                                    status_code: data.status_code,
                                    url: url
                                };

                            case 21:
                            case 'end':
                                return _context184.stop();
                        }
                    }
                }, _callee184, _this, [[5, 11]]);
            }));

            return function (_x283, _x284) {
                return _ref188.apply(this, arguments);
            };
        }();

        this.logToConsole = false;
        this.serverVersion = '';
        this.clusterId = '';
        this.token = '';
        this.url = '';
        this.urlVersion = '/api/v4';
        this.userAgent = null;
        this.enableLogging = false;
        this.defaultHeaders = {};
        this.userId = '';

        this.translations = {
            connectionError: 'There appears to be a problem with your internet connection.',
            unknownError: 'We received an unexpected status code from the server.'
        };
    }

    _createClass(Client4, [{
        key: 'getUrl',
        value: function getUrl() {
            return this.url;
        }
    }, {
        key: 'setUrl',
        value: function setUrl(url) {
            this.url = url;
        }
    }, {
        key: 'setUserAgent',
        value: function setUserAgent(userAgent) {
            this.userAgent = userAgent;
        }
    }, {
        key: 'getToken',
        value: function getToken() {
            return this.token;
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            this.token = token;
        }
    }, {
        key: 'setAcceptLanguage',
        value: function setAcceptLanguage(locale) {
            this.defaultHeaders['Accept-Language'] = locale;
        }
    }, {
        key: 'setEnableLogging',
        value: function setEnableLogging(enable) {
            this.enableLogging = enable;
        }
    }, {
        key: 'setUserId',
        value: function setUserId(userId) {
            this.userId = userId;
        }
    }, {
        key: 'getServerVersion',
        value: function getServerVersion() {
            return this.serverVersion;
        }
    }, {
        key: 'getUrlVersion',
        value: function getUrlVersion() {
            return this.urlVersion;
        }
    }, {
        key: 'getBaseRoute',
        value: function getBaseRoute() {
            return '' + this.url + this.urlVersion;
        }
    }, {
        key: 'getUsersRoute',
        value: function getUsersRoute() {
            return this.getBaseRoute() + '/users';
        }
    }, {
        key: 'getUserRoute',
        value: function getUserRoute(userId) {
            return this.getUsersRoute() + '/' + userId;
        }
    }, {
        key: 'getTeamsRoute',
        value: function getTeamsRoute() {
            return this.getBaseRoute() + '/teams';
        }
    }, {
        key: 'getTeamRoute',
        value: function getTeamRoute(teamId) {
            return this.getTeamsRoute() + '/' + teamId;
        }
    }, {
        key: 'getTeamNameRoute',
        value: function getTeamNameRoute(teamName) {
            return this.getTeamsRoute() + '/name/' + teamName;
        }
    }, {
        key: 'getTeamMembersRoute',
        value: function getTeamMembersRoute(teamId) {
            return this.getTeamRoute(teamId) + '/members';
        }
    }, {
        key: 'getTeamMemberRoute',
        value: function getTeamMemberRoute(teamId, userId) {
            return this.getTeamMembersRoute(teamId) + '/' + userId;
        }
    }, {
        key: 'getChannelsRoute',
        value: function getChannelsRoute() {
            return this.getBaseRoute() + '/channels';
        }
    }, {
        key: 'getChannelRoute',
        value: function getChannelRoute(channelId) {
            return this.getChannelsRoute() + '/' + channelId;
        }
    }, {
        key: 'getChannelMembersRoute',
        value: function getChannelMembersRoute(channelId) {
            return this.getChannelRoute(channelId) + '/members';
        }
    }, {
        key: 'getChannelMemberRoute',
        value: function getChannelMemberRoute(channelId, userId) {
            return this.getChannelMembersRoute(channelId) + '/' + userId;
        }
    }, {
        key: 'getPostsRoute',
        value: function getPostsRoute() {
            return this.getBaseRoute() + '/posts';
        }
    }, {
        key: 'getPostRoute',
        value: function getPostRoute(postId) {
            return this.getPostsRoute() + '/' + postId;
        }
    }, {
        key: 'getReactionsRoute',
        value: function getReactionsRoute() {
            return this.getBaseRoute() + '/reactions';
        }
    }, {
        key: 'getCommandsRoute',
        value: function getCommandsRoute() {
            return this.getBaseRoute() + '/commands';
        }
    }, {
        key: 'getFilesRoute',
        value: function getFilesRoute() {
            return this.getBaseRoute() + '/files';
        }
    }, {
        key: 'getFileRoute',
        value: function getFileRoute(fileId) {
            return this.getFilesRoute() + '/' + fileId;
        }
    }, {
        key: 'getPreferencesRoute',
        value: function getPreferencesRoute(userId) {
            return this.getUserRoute(userId) + '/preferences';
        }
    }, {
        key: 'getIncomingHooksRoute',
        value: function getIncomingHooksRoute() {
            return this.getBaseRoute() + '/hooks/incoming';
        }
    }, {
        key: 'getIncomingHookRoute',
        value: function getIncomingHookRoute(hookId) {
            return this.getBaseRoute() + '/hooks/incoming/' + hookId;
        }
    }, {
        key: 'getOutgoingHooksRoute',
        value: function getOutgoingHooksRoute() {
            return this.getBaseRoute() + '/hooks/outgoing';
        }
    }, {
        key: 'getOutgoingHookRoute',
        value: function getOutgoingHookRoute(hookId) {
            return this.getBaseRoute() + '/hooks/outgoing/' + hookId;
        }
    }, {
        key: 'getOAuthRoute',
        value: function getOAuthRoute() {
            return this.url + '/oauth';
        }
    }, {
        key: 'getOAuthAppsRoute',
        value: function getOAuthAppsRoute() {
            return this.getBaseRoute() + '/oauth/apps';
        }
    }, {
        key: 'getOAuthAppRoute',
        value: function getOAuthAppRoute(appId) {
            return this.getOAuthAppsRoute() + '/' + appId;
        }
    }, {
        key: 'getEmojisRoute',
        value: function getEmojisRoute() {
            return this.getBaseRoute() + '/emoji';
        }
    }, {
        key: 'getEmojiRoute',
        value: function getEmojiRoute(emojiId) {
            return this.getEmojisRoute() + '/' + emojiId;
        }
    }, {
        key: 'getBrandRoute',
        value: function getBrandRoute() {
            return this.getBaseRoute() + '/brand';
        }
    }, {
        key: 'getBrandImageUrl',
        value: function getBrandImageUrl(timestamp) {
            return this.getBrandRoute() + '/image?t=' + timestamp;
        }
    }, {
        key: 'getJobsRoute',
        value: function getJobsRoute() {
            return this.getBaseRoute() + '/jobs';
        }
    }, {
        key: 'getOptions',
        value: function getOptions(options) {
            var newOptions = Object.assign({}, options);

            var headers = _extends(_defineProperty({}, HEADER_REQUESTED_WITH, 'XMLHttpRequest'), this.defaultHeaders);

            if (this.token) {
                headers[HEADER_AUTH] = HEADER_BEARER + ' ' + this.token;
            }

            newOptions.credentials = 'include';

            if (this.userAgent) {
                headers[HEADER_USER_AGENT] = this.userAgent;
            }

            if (newOptions.headers) {
                Object.assign(headers, newOptions.headers);
            }

            return _extends({}, newOptions, {
                headers: headers
            });
        }

        // User Routes

        // Team Routes

        // Channel Routes

        // Post Routes

    }, {
        key: 'getFileUrl',


        // Files Routes

        value: function getFileUrl(fileId, timestamp) {
            var url = '' + this.getFileRoute(fileId);
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }
    }, {
        key: 'getFileThumbnailUrl',
        value: function getFileThumbnailUrl(fileId, timestamp) {
            var url = this.getFileRoute(fileId) + '/thumbnail';
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }
    }, {
        key: 'getFilePreviewUrl',
        value: function getFilePreviewUrl(fileId, timestamp) {
            var url = this.getFileRoute(fileId) + '/preview';
            if (timestamp) {
                url += '?' + timestamp;
            }

            return url;
        }

        // Preference Routes

        // General Routes

        // Integration Routes

        // Emoji Routes

        // Jobs Routes

        // Admin Routes

        // Client Helpers

    }, {
        key: 'trackEvent',
        value: function trackEvent(category, event, props) {
            var properties = Object.assign({ category: category, type: event, user_actual_id: this.userId }, props);
            var options = {
                context: {
                    ip: '0.0.0.0'
                },
                page: {
                    path: '',
                    referrer: '',
                    search: '',
                    title: '',
                    url: ''
                },
                anonymousId: '00000000000000000000000000'
            };

            if (global && global.window && global.window.analytics && global.window.analytics.initialized) {
                global.window.analytics.track('event', properties, options);
            } else if (global && global.analytics) {
                global.analytics.track(Object.assign({
                    event: 'event'
                }, { properties: properties }, options));
            }
        }
    }]);

    return Client4;
}();

exports.default = Client4;


function buildQueryString(parameters) {
    var keys = Object.keys(parameters);
    if (keys.length === 0) {
        return '';
    }

    var query = '?';
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        query += key + '=' + encodeURIComponent(parameters[key]);

        if (i < keys.length - 1) {
            query += '&';
        }
    }

    return query;
}

function parseAndMergeNestedHeaders(originalHeaders) {
    var headers = new Map();
    var nestedHeaders = new Map();
    originalHeaders.forEach(function (val, key) {
        var capitalizedKey = key.replace(/\b[a-z]/g, function (l) {
            return l.toUpperCase();
        });
        var realVal = val;
        if (val && val.match(/\n\S+:\s\S+/)) {
            var nestedHeaderStrings = val.split('\n');
            realVal = nestedHeaderStrings.shift();
            var moreNestedHeaders = new Map(nestedHeaderStrings.map(function (h) {
                return h.split(/:\s/);
            }));
            nestedHeaders = new Map([].concat(_toConsumableArray(nestedHeaders), _toConsumableArray(moreNestedHeaders)));
        }
        headers.set(capitalizedKey, realVal);
    });
    return new Map([].concat(_toConsumableArray(headers), _toConsumableArray(nestedHeaders)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* jslint esnext: true */

"use strict";
var src$core$$ = __webpack_require__(1076), src$en$$ = __webpack_require__(1081);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";
var src$utils$$ = __webpack_require__(447), src$es5$$ = __webpack_require__(1077), src$compiler$$ = __webpack_require__(1078), intl$messageformat$parser$$ = __webpack_require__(1079);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        return messageFormat._format(pattern, values);
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            throw new Error('A value must be provided for: ' + id);
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";
var src$utils$$ = __webpack_require__(447);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";
exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports = module.exports = __webpack_require__(1080)['default'];
exports['default'] = exports;



/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";

exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// GENERATED FILE
"use strict";
exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* jshint node:true */

'use strict';

var IntlRelativeFormat = __webpack_require__(1084)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1089);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;



/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/* jslint esnext: true */

"use strict";
var src$core$$ = __webpack_require__(1085), src$en$$ = __webpack_require__(1088);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";
var intl$messageformat$$ = __webpack_require__(446), src$diff$$ = __webpack_require__(1086), src$es5$$ = __webpack_require__(1087);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";

var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

"use strict";

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// GENERATED FILE
"use strict";
exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

exports = module.exports = __webpack_require__(1091)['default'];
exports['default'] = exports;



/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";
var src$es5$$ = __webpack_require__(1092);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3812df668bb0144f7ae51853b202315b.mp3";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

var core  = __webpack_require__(15)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _deleteProperty = __webpack_require__(485);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MAX_WEBSOCKET_FAILS = 7;
var MIN_WEBSOCKET_RETRY_TIME = 3000; // 3 sec
var MAX_WEBSOCKET_RETRY_TIME = 300000; // 5 mins

var WebSocketClient = function () {
    function WebSocketClient() {
        (0, _classCallCheck3.default)(this, WebSocketClient);

        this.conn = null;
        this.connectionUrl = null;
        this.sequence = 1;
        this.eventSequence = 0;
        this.connectFailCount = 0;
        this.eventCallback = null;
        this.responseCallbacks = {};
        this.firstConnectCallback = null;
        this.reconnectCallback = null;
        this.missedEventCallback = null;
        this.errorCallback = null;
        this.closeCallback = null;
    }

    (0, _createClass3.default)(WebSocketClient, [{
        key: 'initialize',
        value: function initialize() {
            var _this = this;

            var connectionUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.connectionUrl;
            var token = arguments[1];

            if (this.conn) {
                return;
            }

            if (connectionUrl == null) {
                console.log('websocket must have connection url'); //eslint-disable-line no-console
                return;
            }

            if (this.connectFailCount === 0) {
                console.log('websocket connecting to ' + connectionUrl); //eslint-disable-line no-console
            }

            this.conn = new WebSocket(connectionUrl);
            this.connectionUrl = connectionUrl;

            this.conn.onopen = function () {
                _this.eventSequence = 0;

                if (token) {
                    _this.sendMessage('authentication_challenge', { token: token });
                }

                if (_this.connectFailCount > 0) {
                    console.log('websocket re-established connection'); //eslint-disable-line no-console
                    if (_this.reconnectCallback) {
                        _this.reconnectCallback();
                    }
                } else if (_this.firstConnectCallback) {
                    _this.firstConnectCallback();
                }

                _this.connectFailCount = 0;
            };

            this.conn.onclose = function () {
                _this.conn = null;
                _this.sequence = 1;

                if (_this.connectFailCount === 0) {
                    console.log('websocket closed'); //eslint-disable-line no-console
                }

                _this.connectFailCount++;

                if (_this.closeCallback) {
                    _this.closeCallback(_this.connectFailCount);
                }

                var retryTime = MIN_WEBSOCKET_RETRY_TIME;

                // If we've failed a bunch of connections then start backing off
                if (_this.connectFailCount > MAX_WEBSOCKET_FAILS) {
                    retryTime = MIN_WEBSOCKET_RETRY_TIME * _this.connectFailCount * _this.connectFailCount;
                    if (retryTime > MAX_WEBSOCKET_RETRY_TIME) {
                        retryTime = MAX_WEBSOCKET_RETRY_TIME;
                    }
                }

                setTimeout(function () {
                    _this.initialize(connectionUrl, token);
                }, retryTime);
            };

            this.conn.onerror = function (evt) {
                if (_this.connectFailCount <= 1) {
                    console.log('websocket error'); //eslint-disable-line no-console
                    console.log(evt); //eslint-disable-line no-console
                }

                if (_this.errorCallback) {
                    _this.errorCallback(evt);
                }
            };

            this.conn.onmessage = function (evt) {
                var msg = JSON.parse(evt.data);
                if (msg.seq_reply) {
                    if (msg.error) {
                        console.log(msg); //eslint-disable-line no-console
                    }

                    if (_this.responseCallbacks[msg.seq_reply]) {
                        _this.responseCallbacks[msg.seq_reply](msg);
                        (0, _deleteProperty2.default)(_this.responseCallbacks, msg.seq_reply);
                    }
                } else if (_this.eventCallback) {
                    if (msg.seq !== _this.eventSequence && _this.missedEventCallback) {
                        console.log('missed websocket event, act_seq=' + msg.seq + ' exp_seq=' + _this.eventSequence); //eslint-disable-line no-console
                        _this.missedEventCallback();
                    }
                    _this.eventSequence = msg.seq + 1;
                    _this.eventCallback(msg);
                }
            };
        }
    }, {
        key: 'setEventCallback',
        value: function setEventCallback(callback) {
            this.eventCallback = callback;
        }
    }, {
        key: 'setFirstConnectCallback',
        value: function setFirstConnectCallback(callback) {
            this.firstConnectCallback = callback;
        }
    }, {
        key: 'setReconnectCallback',
        value: function setReconnectCallback(callback) {
            this.reconnectCallback = callback;
        }
    }, {
        key: 'setMissedEventCallback',
        value: function setMissedEventCallback(callback) {
            this.missedEventCallback = callback;
        }
    }, {
        key: 'setErrorCallback',
        value: function setErrorCallback(callback) {
            this.errorCallback = callback;
        }
    }, {
        key: 'setCloseCallback',
        value: function setCloseCallback(callback) {
            this.closeCallback = callback;
        }
    }, {
        key: 'close',
        value: function close() {
            this.connectFailCount = 0;
            this.sequence = 1;
            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
                this.conn.onclose = function () {}; //eslint-disable-line no-empty-function
                this.conn.close();
                this.conn = null;
                console.log('websocket closed'); //eslint-disable-line no-console
            }
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(action, data, responseCallback) {
            var msg = {
                action: action,
                seq: this.sequence++,
                data: data
            };

            if (responseCallback) {
                this.responseCallbacks[msg.seq] = responseCallback;
            }

            if (this.conn && this.conn.readyState === WebSocket.OPEN) {
                this.conn.send((0, _stringify2.default)(msg));
            } else if (!this.conn || this.conn.readyState === WebSocket.CLOSED) {
                this.conn = null;
                this.initialize();
            }
        }
    }, {
        key: 'userTyping',
        value: function userTyping(channelId, parentId, callback) {
            var data = {};
            data.channel_id = channelId;
            data.parent_id = parentId;

            this.sendMessage('user_typing', data, callback);
        }
    }, {
        key: 'getStatuses',
        value: function getStatuses(callback) {
            this.sendMessage('get_statuses', null, callback);
        }
    }, {
        key: 'getStatusesByIds',
        value: function getStatusesByIds(userIds, callback) {
            var data = {};
            data.user_ids = userIds;
            this.sendMessage('get_statuses_by_ids', data, callback);
        }
    }]);
    return WebSocketClient;
}();

exports.default = WebSocketClient;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

__webpack_require__(1097);
module.exports = __webpack_require__(15).Reflect.deleteProperty;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(31)
  , gOPD     = __webpack_require__(215).f
  , anObject = __webpack_require__(65);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(69);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(70);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(124);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(71);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _client = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PER_PAGE_DEFAULT = 60;
var FormData = __webpack_require__(295);

var CustomClientClass4 = function CustomClientClass4() {
    var _this = this;

    (0, _classCallCheck3.default)(this, CustomClientClass4);

    this.createUserWithOauth = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(user, data, accessToken, inviteId, service, action) {
            var queryParams;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_users_create');

                            queryParams = {};


                            if (data) {
                                queryParams.d = data;
                            }

                            if (accessToken) {
                                queryParams.at = accessToken;
                            }

                            if (inviteId) {
                                queryParams.iid = inviteId;
                            }

                            if (action) {
                                queryParams.a = action;
                            }

                            return _context.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/create/' + service + buildQueryString(queryParams), { method: 'post', body: (0, _stringify2.default)(user) }));

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref.apply(this, arguments);
        };
    }();

    this.customOauthLogin = function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(userId, accessToken, service, action) {
            var deviceId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
            var ldapOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            var body, _ref3, headers, data;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_users_login');

                            if (ldapOnly) {
                                _client.Client4.trackEvent('api', 'api_users_login_ldap');
                            }

                            body = {
                                device_id: deviceId,
                                user_id: userId,
                                access_token: accessToken,
                                action: action
                            };


                            if (ldapOnly) {
                                body.ldap_only = 'true';
                            }

                            _context2.next = 6;
                            return _client.Client4.doFetchWithResponse(_client.Client4.getUsersRoute() + '/login/' + service, { method: 'post', body: (0, _stringify2.default)(body) });

                        case 6:
                            _ref3 = _context2.sent;
                            headers = _ref3.headers;
                            data = _ref3.data;


                            if (headers.has(_client.Client4.HEADER_TOKEN)) {
                                _client.Client4.token = headers.get(_client.Client4.HEADER_TOKEN);
                            }

                            return _context2.abrupt('return', data);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x7, _x8, _x9, _x10) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.updateSelfDestructTimer = function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(channelId, patch) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_channels_patch', { channel_id: channelId });

                            return _context3.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelRoute(channelId) + '/self_destruct_timer', { method: 'put', body: (0, _stringify2.default)(patch) }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function (_x13, _x14) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.batchUpdateSelfDestructTimer = function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(selfDestructProps) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:

                            _client.Client4.trackEvent('api', 'api_channels_batch_update_selfDestructTimer', selfDestructProps);

                            return _context4.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/self_destruct_timer', { method: 'put', body: (0, _stringify2.default)(selfDestructProps) }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this);
        }));

        return function (_x15) {
            return _ref5.apply(this, arguments);
        };
    }();

    this.initTalk2Site = function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(channelId) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelRoute(channelId) + '/inittalk2site', { method: 'put' }));

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this);
        }));

        return function (_x16) {
            return _ref6.apply(this, arguments);
        };
    }();

    this.getUnreadPosts = function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(userId) {
            var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_posts_get_unread', { team_id: teamId });

                            return _context6.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/posts/unread' + buildQueryString({ team_id: teamId, page: page, per_page: perPage }), { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this);
        }));

        return function (_x17) {
            return _ref7.apply(this, arguments);
        };
    }();

    this.getVcLives = function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(userId) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            return _context7.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/vclog/livestream/' + userId, { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this);
        }));

        return function (_x21) {
            return _ref8.apply(this, arguments);
        };
    }();

    this.getVcLivesPost = function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(userId) {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            return _context8.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/vclog/livestreampost/' + userId, { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this);
        }));

        return function (_x22) {
            return _ref9.apply(this, arguments);
        };
    }();

    this.searchXTeamPosts = function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(teamId, terms, isOrSearch) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_posts_search', { team_id: teamId });

                            return _context9.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/posts/searchxteam', { method: 'post', body: (0, _stringify2.default)({ terms: terms, is_or_search: isOrSearch }) }));

                        case 2:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this);
        }));

        return function (_x23, _x24, _x25) {
            return _ref10.apply(this, arguments);
        };
    }();

    this.exportTeam = function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(teamId) {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_teams_export', { team_id: teamId });

                            return _context10.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/export', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this);
        }));

        return function (_x26) {
            return _ref11.apply(this, arguments);
        };
    }();

    this.getTeamStorage = function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(teamId) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_teams_getStorage', { team_id: teamId });

                            return _context11.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/storage', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this);
        }));

        return function (_x27) {
            return _ref12.apply(this, arguments);
        };
    }();

    this.getTeamVcHour = function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(teamId) {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_teams_getVcHour', { team_id: teamId });

                            return _context12.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/vchour', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this);
        }));

        return function (_x28) {
            return _ref13.apply(this, arguments);
        };
    }();

    this.exportTeamDownload = function () {
        var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(teamId, fileId) {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_teams_export_download', { team_id: teamId, field_id: fileId });

                            return _context13.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/export/download/' + fileId, { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this);
        }));

        return function (_x29, _x30) {
            return _ref14.apply(this, arguments);
        };
    }();

    this.getChannelsByIds = function () {
        var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(channelIds) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_channels_get_by_ids');

                            return _context14.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelsRoute() + '/ids', { method: 'post', body: (0, _stringify2.default)(channelIds) }));

                        case 2:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this);
        }));

        return function (_x31) {
            return _ref15.apply(this, arguments);
        };
    }();

    this.uploadTeamImage = function () {
        var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(teamId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_team_update_profile_picture');

                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context15.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/image', request));

                        case 6:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this);
        }));

        return function (_x32, _x33) {
            return _ref16.apply(this, arguments);
        };
    }();

    this.uploadTeamBackgroundImage = function () {
        var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(teamId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context16.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/background', request));

                        case 5:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this);
        }));

        return function (_x34, _x35) {
            return _ref17.apply(this, arguments);
        };
    }();

    this.getMyAllChannels = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        return _context17.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/channels', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, _this);
    }));
    this.getMyAllMembers = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
        return _regenerator2.default.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        return _context18.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/members', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, _this);
    }));
    this.getMyAllChannelMembers = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
        return _regenerator2.default.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        return _context19.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/members', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, _this);
    }));
    this.getLastPosts = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
        return _regenerator2.default.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        return _context20.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/posts/last', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, _this);
    }));

    this.getAccessibleChannels = function () {
        var _ref22 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            return _context21.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelsRoute() + '/all/accessible' + buildQueryString({ page: page, per_page: perPage }), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this);
        }));

        return function () {
            return _ref22.apply(this, arguments);
        };
    }();

    this.getTeamAdminUsers = function () {
        var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(teamId) {
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            return _context22.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/admin', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this);
        }));

        return function (_x38) {
            return _ref23.apply(this, arguments);
        };
    }();

    this.getProfilesInChannels = function () {
        var _ref24 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23(channelIds) {
            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            return _context23.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/channels' + buildQueryString({ page: page, per_page: perPage }), { method: 'post', body: (0, _stringify2.default)(channelIds) }));

                        case 1:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this);
        }));

        return function (_x39) {
            return _ref24.apply(this, arguments);
        };
    }();

    this.searchAccessibleChannels = function () {
        var _ref25 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24(term) {
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            return _context24.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelsRoute() + '/search/accessible', { method: 'post', body: (0, _stringify2.default)({ term: term }) }));

                        case 1:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this);
        }));

        return function (_x42) {
            return _ref25.apply(this, arguments);
        };
    }();

    this.deleteTeam = function () {
        var _ref26 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25(teamId) {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_teams_delete_name', { team_id: teamId });

                            return _context25.abrupt('return', _client.Client4.doFetch('' + _client.Client4.getTeamRoute(teamId), { method: 'delete' }));

                        case 2:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this);
        }));

        return function (_x43) {
            return _ref26.apply(this, arguments);
        };
    }();

    this.getMyAllTeamUsers = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26() {
        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        return _context26.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/teams/member_users', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, _this);
    }));

    this.getQuotation = function () {
        var _ref28 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27(teamId, enquiry) {
            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_get_quotation', { team_id: teamId });

                            return _context27.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/quotation', { method: 'post', body: (0, _stringify2.default)(enquiry) }));

                        case 2:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, _this);
        }));

        return function (_x44, _x45) {
            return _ref28.apply(this, arguments);
        };
    }();

    this.payByJetco = function () {
        var _ref29 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee28(teamId, enquiry) {
            return _regenerator2.default.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_pay_by_jetco', { team_id: teamId });

                            return _context28.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/payByJetco', { method: 'post', body: (0, _stringify2.default)(enquiry) }));

                        case 2:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, _this);
        }));

        return function (_x46, _x47) {
            return _ref29.apply(this, arguments);
        };
    }();

    this.payByAlipay = function () {
        var _ref30 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee29(teamId, enquiry) {
            return _regenerator2.default.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_pay_by_alipay', { team_id: teamId });

                            return _context29.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/payByAlipay', { method: 'post', body: (0, _stringify2.default)(enquiry) }));

                        case 2:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, _this);
        }));

        return function (_x48, _x49) {
            return _ref30.apply(this, arguments);
        };
    }();

    this.payByStripe = function () {
        var _ref31 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee30(teamId, enquiry, token) {
            return _regenerator2.default.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_pay_by_stripe', { team_id: teamId });

                            return _context30.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/payment/stripe', { method: 'post', body: (0, _stringify2.default)({ enquiry: enquiry, token: token }) }));

                        case 2:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, _this);
        }));

        return function (_x50, _x51, _x52) {
            return _ref31.apply(this, arguments);
        };
    }();

    this.payZeroPayment = function () {
        var _ref32 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee31(teamId, enquiry) {
            return _regenerator2.default.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            return _context31.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/payment/zeroAmount', { method: 'post', body: (0, _stringify2.default)(enquiry) }));

                        case 1:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, _this);
        }));

        return function (_x53, _x54) {
            return _ref32.apply(this, arguments);
        };
    }();

    this.getContracts = function () {
        var _ref33 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee32(teamId) {
            return _regenerator2.default.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_get_contracts', { team_id: teamId });

                            return _context32.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/contract', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, _this);
        }));

        return function (_x55) {
            return _ref33.apply(this, arguments);
        };
    }();

    this.getInvitesByEmail = function () {
        var _ref34 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee33(email) {
            return _regenerator2.default.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_get_invites_by_email', { email: email });

                            return _context33.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/invitations/email/' + email, { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, _this);
        }));

        return function (_x56) {
            return _ref34.apply(this, arguments);
        };
    }();

    this.getInvitesByUserId = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee34() {
        return _regenerator2.default.wrap(function _callee34$(_context34) {
            while (1) {
                switch (_context34.prev = _context34.next) {
                    case 0:
                        return _context34.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/invitations/users/me', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context34.stop();
                }
            }
        }, _callee34, _this);
    }));

    this.blockUser = function () {
        var _ref36 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee35(sender) {
            return _regenerator2.default.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_block_user', { sender: sender });

                            return _context35.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/block/' + sender, { method: 'put' }));

                        case 2:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, _this);
        }));

        return function (_x57) {
            return _ref36.apply(this, arguments);
        };
    }();

    this.checkBlockUser = function () {
        var _ref37 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee36(sender) {
            return _regenerator2.default.wrap(function _callee36$(_context36) {
                while (1) {
                    switch (_context36.prev = _context36.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_check_block_user', { sender: sender });

                            return _context36.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/block/' + sender, { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context36.stop();
                    }
                }
            }, _callee36, _this);
        }));

        return function (_x58) {
            return _ref37.apply(this, arguments);
        };
    }();

    this.unBlockUser = function () {
        var _ref38 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee37(sender) {
            return _regenerator2.default.wrap(function _callee37$(_context37) {
                while (1) {
                    switch (_context37.prev = _context37.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_unblock_user', { sender: sender });

                            return _context37.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/unblock/' + sender, { method: 'put' }));

                        case 2:
                        case 'end':
                            return _context37.stop();
                    }
                }
            }, _callee37, _this);
        }));

        return function (_x59) {
            return _ref38.apply(this, arguments);
        };
    }();

    this.getBlockList = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee38() {
        return _regenerator2.default.wrap(function _callee38$(_context38) {
            while (1) {
                switch (_context38.prev = _context38.next) {
                    case 0:
                        _client.Client4.trackEvent('api', 'api_get_block_list');

                        return _context38.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/blocklist', { method: 'get' }));

                    case 2:
                    case 'end':
                        return _context38.stop();
                }
            }
        }, _callee38, _this);
    }));

    this.getOrderHist = function () {
        var _ref40 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee39(teamId) {
            return _regenerator2.default.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_getOrderHist', { team_id: teamId });

                            return _context39.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/orders', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, _this);
        }));

        return function (_x60) {
            return _ref40.apply(this, arguments);
        };
    }();

    this.getInvoice = function () {
        var _ref41 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee40(orderId) {
            return _regenerator2.default.wrap(function _callee40$(_context40) {
                while (1) {
                    switch (_context40.prev = _context40.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_getOrder', { order_id: orderId });

                            return _context40.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/invoice' + buildQueryString({ order_id: orderId }), { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context40.stop();
                    }
                }
            }, _callee40, _this);
        }));

        return function (_x61) {
            return _ref41.apply(this, arguments);
        };
    }();

    this.getBillingAddress = function () {
        var _ref42 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee41(teamId) {
            return _regenerator2.default.wrap(function _callee41$(_context41) {
                while (1) {
                    switch (_context41.prev = _context41.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_getBillingAddress', { team_id: teamId });

                            return _context41.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/billingAddress', { method: 'get' }));

                        case 2:
                        case 'end':
                            return _context41.stop();
                    }
                }
            }, _callee41, _this);
        }));

        return function (_x62) {
            return _ref42.apply(this, arguments);
        };
    }();

    this.setBillingAddress = function () {
        var _ref43 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee42(teamId, address) {
            return _regenerator2.default.wrap(function _callee42$(_context42) {
                while (1) {
                    switch (_context42.prev = _context42.next) {
                        case 0:
                            _client.Client4.trackEvent('api', 'api_setBillingAddress', { team_id: teamId });

                            return _context42.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/billingAddress', { method: 'post', body: (0, _stringify2.default)(address) }));

                        case 2:
                        case 'end':
                            return _context42.stop();
                    }
                }
            }, _callee42, _this);
        }));

        return function (_x63, _x64) {
            return _ref43.apply(this, arguments);
        };
    }();

    this.addMembersToChannel = function () {
        var _ref44 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee43(channelId, userIds) {
            return _regenerator2.default.wrap(function _callee43$(_context43) {
                while (1) {
                    switch (_context43.prev = _context43.next) {
                        case 0:
                            return _context43.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelMembersRoute(channelId) + '/batch', { method: 'post', body: (0, _stringify2.default)(userIds) }));

                        case 1:
                        case 'end':
                            return _context43.stop();
                    }
                }
            }, _callee43, _this);
        }));

        return function (_x65, _x66) {
            return _ref44.apply(this, arguments);
        };
    }();

    this.addAllMembersToChannel = function () {
        var _ref45 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee44(channelId) {
            return _regenerator2.default.wrap(function _callee44$(_context44) {
                while (1) {
                    switch (_context44.prev = _context44.next) {
                        case 0:
                            return _context44.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelMembersRoute(channelId) + '/addall', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context44.stop();
                    }
                }
            }, _callee44, _this);
        }));

        return function (_x67) {
            return _ref45.apply(this, arguments);
        };
    }();

    this.addGuestsToChannel = function () {
        var _ref46 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee45(channelId, userIds) {
            return _regenerator2.default.wrap(function _callee45$(_context45) {
                while (1) {
                    switch (_context45.prev = _context45.next) {
                        case 0:
                            return _context45.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelMembersRoute(channelId) + '/guest/batch', { method: 'post', body: (0, _stringify2.default)(userIds) }));

                        case 1:
                        case 'end':
                            return _context45.stop();
                    }
                }
            }, _callee45, _this);
        }));

        return function (_x68, _x69) {
            return _ref46.apply(this, arguments);
        };
    }();

    this.addAllGuestsToChannel = function () {
        var _ref47 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee46(channelId) {
            return _regenerator2.default.wrap(function _callee46$(_context46) {
                while (1) {
                    switch (_context46.prev = _context46.next) {
                        case 0:
                            return _context46.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelMembersRoute(channelId) + '/guest/addall', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context46.stop();
                    }
                }
            }, _callee46, _this);
        }));

        return function (_x70) {
            return _ref47.apply(this, arguments);
        };
    }();

    this.addAllUsersToTeam = function () {
        var _ref48 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee47(teamId) {
            return _regenerator2.default.wrap(function _callee47$(_context47) {
                while (1) {
                    switch (_context47.prev = _context47.next) {
                        case 0:
                            return _context47.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamMembersRoute(teamId) + '/addall', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context47.stop();
                    }
                }
            }, _callee47, _this);
        }));

        return function (_x71) {
            return _ref48.apply(this, arguments);
        };
    }();

    this.addGuestToTeam = function () {
        var _ref49 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee48(teamId, userId) {
            var member;
            return _regenerator2.default.wrap(function _callee48$(_context48) {
                while (1) {
                    switch (_context48.prev = _context48.next) {
                        case 0:
                            member = { user_id: userId, team_id: teamId };
                            return _context48.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamMembersRoute(teamId) + '/guest', { method: 'post', body: (0, _stringify2.default)(member) }));

                        case 2:
                        case 'end':
                            return _context48.stop();
                    }
                }
            }, _callee48, _this);
        }));

        return function (_x72, _x73) {
            return _ref49.apply(this, arguments);
        };
    }();

    this.addGuestsToTeam = function () {
        var _ref50 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee49(teamId, userIds) {
            var members;
            return _regenerator2.default.wrap(function _callee49$(_context49) {
                while (1) {
                    switch (_context49.prev = _context49.next) {
                        case 0:
                            members = [];

                            userIds.forEach(function (id) {
                                return members.push({ team_id: teamId, user_id: id });
                            });
                            return _context49.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamMembersRoute(teamId) + '/guest/batch', { method: 'post', body: (0, _stringify2.default)(members) }));

                        case 3:
                        case 'end':
                            return _context49.stop();
                    }
                }
            }, _callee49, _this);
        }));

        return function (_x74, _x75) {
            return _ref50.apply(this, arguments);
        };
    }();

    this.addAllGuestsToTeam = function () {
        var _ref51 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee50(teamId) {
            return _regenerator2.default.wrap(function _callee50$(_context50) {
                while (1) {
                    switch (_context50.prev = _context50.next) {
                        case 0:
                            return _context50.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamMembersRoute(teamId) + '/guest/addall', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context50.stop();
                    }
                }
            }, _callee50, _this);
        }));

        return function (_x76) {
            return _ref51.apply(this, arguments);
        };
    }();

    this.getUserWithSensitiveInfo = function () {
        var _ref52 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee51(userId) {
            return _regenerator2.default.wrap(function _callee51$(_context51) {
                while (1) {
                    switch (_context51.prev = _context51.next) {
                        case 0:
                            return _context51.abrupt('return', _client.Client4.doFetch('' + _client.Client4.getUserRoute(userId) + buildQueryString({ sensitive: true }), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context51.stop();
                    }
                }
            }, _callee51, _this);
        }));

        return function (_x77) {
            return _ref52.apply(this, arguments);
        };
    }();

    this.getUserDefinedStatus = function () {
        var _ref53 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee52(userId, udfStatusId) {
            return _regenerator2.default.wrap(function _callee52$(_context52) {
                while (1) {
                    switch (_context52.prev = _context52.next) {
                        case 0:
                            return _context52.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/udf_status/' + udfStatusId, { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context52.stop();
                    }
                }
            }, _callee52, _this);
        }));

        return function (_x78, _x79) {
            return _ref53.apply(this, arguments);
        };
    }();

    this.getUserDefinedStatuses = function () {
        var _ref54 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee53(userId) {
            return _regenerator2.default.wrap(function _callee53$(_context53) {
                while (1) {
                    switch (_context53.prev = _context53.next) {
                        case 0:
                            return _context53.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/udf_statuses', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context53.stop();
                    }
                }
            }, _callee53, _this);
        }));

        return function (_x80) {
            return _ref54.apply(this, arguments);
        };
    }();

    this.saveOrUpdateUserDefinedStatus = function () {
        var _ref55 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee54(userId, udfStatus) {
            return _regenerator2.default.wrap(function _callee54$(_context54) {
                while (1) {
                    switch (_context54.prev = _context54.next) {
                        case 0:
                            return _context54.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/udf_status', { method: 'put', body: (0, _stringify2.default)(udfStatus) }));

                        case 1:
                        case 'end':
                            return _context54.stop();
                    }
                }
            }, _callee54, _this);
        }));

        return function (_x81, _x82) {
            return _ref55.apply(this, arguments);
        };
    }();

    this.deleteUserDefinedStatus = function () {
        var _ref56 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee55(userId, udfStatusId) {
            return _regenerator2.default.wrap(function _callee55$(_context55) {
                while (1) {
                    switch (_context55.prev = _context55.next) {
                        case 0:
                            return _context55.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/udf_status/' + udfStatusId, { method: 'delete' }));

                        case 1:
                        case 'end':
                            return _context55.stop();
                    }
                }
            }, _callee55, _this);
        }));

        return function (_x83, _x84) {
            return _ref56.apply(this, arguments);
        };
    }();

    this.updateCustomStatus = function () {
        var _ref57 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee56(userId, udfStatusId) {
            return _regenerator2.default.wrap(function _callee56$(_context56) {
                while (1) {
                    switch (_context56.prev = _context56.next) {
                        case 0:
                            return _context56.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/custom_status/' + udfStatusId, { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context56.stop();
                    }
                }
            }, _callee56, _this);
        }));

        return function (_x85, _x86) {
            return _ref57.apply(this, arguments);
        };
    }();

    this.getPaidStats = function () {
        var _ref58 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee57(teamId) {
            return _regenerator2.default.wrap(function _callee57$(_context57) {
                while (1) {
                    switch (_context57.prev = _context57.next) {
                        case 0:
                            return _context57.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/paid_stat', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context57.stop();
                    }
                }
            }, _callee57, _this);
        }));

        return function (_x87) {
            return _ref58.apply(this, arguments);
        };
    }();

    this.uploadWatermarkImage = function () {
        var _ref59 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee58(userId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee58$(_context58) {
                while (1) {
                    switch (_context58.prev = _context58.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context58.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/watermark', request));

                        case 5:
                        case 'end':
                            return _context58.stop();
                    }
                }
            }, _callee58, _this);
        }));

        return function (_x88, _x89) {
            return _ref59.apply(this, arguments);
        };
    }();

    this.uploadBackgroundImage = function () {
        var _ref60 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee59(userId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee59$(_context59) {
                while (1) {
                    switch (_context59.prev = _context59.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context59.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/background', request));

                        case 5:
                        case 'end':
                            return _context59.stop();
                    }
                }
            }, _callee59, _this);
        }));

        return function (_x90, _x91) {
            return _ref60.apply(this, arguments);
        };
    }();

    this.getProfilesCanJoinTeam = function () {
        var _ref61 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee60(teamId) {
            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PER_PAGE_DEFAULT;
            return _regenerator2.default.wrap(function _callee60$(_context60) {
                while (1) {
                    switch (_context60.prev = _context60.next) {
                        case 0:
                            return _context60.abrupt('return', _client.Client4.doFetch('' + _client.Client4.getUsersRoute() + buildQueryString({ allow_added_to_team: teamId, page: page, per_page: perPage, exclude_web_visitor: true, exclude_inactive: true }), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context60.stop();
                    }
                }
            }, _callee60, _this);
        }));

        return function (_x92) {
            return _ref61.apply(this, arguments);
        };
    }();

    this.getProfilesCanJoinChannel = function () {
        var _ref62 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee61(teamId, channelId) {
            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PER_PAGE_DEFAULT;
            return _regenerator2.default.wrap(function _callee61$(_context61) {
                while (1) {
                    switch (_context61.prev = _context61.next) {
                        case 0:
                            return _context61.abrupt('return', _client.Client4.doFetch('' + _client.Client4.getUsersRoute() + buildQueryString({ in_team: teamId, not_in_channel: channelId, page: page, per_page: perPage, exclude_web_visitor: true, exclude_inactive: true }), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context61.stop();
                    }
                }
            }, _callee61, _this);
        }));

        return function (_x95, _x96) {
            return _ref62.apply(this, arguments);
        };
    }();

    this.incrementMapUsage = function () {
        var _ref63 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee62(userId) {
            return _regenerator2.default.wrap(function _callee62$(_context62) {
                while (1) {
                    switch (_context62.prev = _context62.next) {
                        case 0:
                            return _context62.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute(userId) + '/map/usage', { method: 'post' }));

                        case 1:
                        case 'end':
                            return _context62.stop();
                    }
                }
            }, _callee62, _this);
        }));

        return function (_x99) {
            return _ref63.apply(this, arguments);
        };
    }();

    this.getMaxCallInfo = function () {
        var _ref64 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee63(teamId) {
            return _regenerator2.default.wrap(function _callee63$(_context63) {
                while (1) {
                    switch (_context63.prev = _context63.next) {
                        case 0:
                            return _context63.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/max_calls_info', { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context63.stop();
                    }
                }
            }, _callee63, _this);
        }));

        return function (_x100) {
            return _ref64.apply(this, arguments);
        };
    }();

    this.allowPMR = function () {
        var _ref65 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee64(teamId) {
            return _regenerator2.default.wrap(function _callee64$(_context64) {
                while (1) {
                    switch (_context64.prev = _context64.next) {
                        case 0:
                            return _context64.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/allow_pmr', { method: 'put' }));

                        case 1:
                        case 'end':
                            return _context64.stop();
                    }
                }
            }, _callee64, _this);
        }));

        return function (_x101) {
            return _ref65.apply(this, arguments);
        };
    }();

    this.denyPMR = function () {
        var _ref66 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee65(teamId) {
            return _regenerator2.default.wrap(function _callee65$(_context65) {
                while (1) {
                    switch (_context65.prev = _context65.next) {
                        case 0:
                            return _context65.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/deny_pmr', { method: 'put' }));

                        case 1:
                        case 'end':
                            return _context65.stop();
                    }
                }
            }, _callee65, _this);
        }));

        return function (_x102) {
            return _ref66.apply(this, arguments);
        };
    }();

    this.configPMR = function () {
        var _ref67 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee66(team) {
            return _regenerator2.default.wrap(function _callee66$(_context66) {
                while (1) {
                    switch (_context66.prev = _context66.next) {
                        case 0:
                            return _context66.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(team.id) + '/config_pmr', { method: 'put', body: (0, _stringify2.default)(team) }));

                        case 1:
                        case 'end':
                            return _context66.stop();
                    }
                }
            }, _callee66, _this);
        }));

        return function (_x103) {
            return _ref67.apply(this, arguments);
        };
    }();

    this.sendVerificationSMS = function () {
        var _ref68 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee67(login_id) {
            return _regenerator2.default.wrap(function _callee67$(_context67) {
                while (1) {
                    switch (_context67.prev = _context67.next) {
                        case 0:
                            return _context67.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/sms/verify/send', { method: 'post', body: (0, _stringify2.default)({ login_id: login_id }) }));

                        case 1:
                        case 'end':
                            return _context67.stop();
                    }
                }
            }, _callee67, _this);
        }));

        return function (_x104) {
            return _ref68.apply(this, arguments);
        };
    }();

    this.verifyUserMobile = function () {
        var _ref69 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee68(token, login_id) {
            return _regenerator2.default.wrap(function _callee68$(_context68) {
                while (1) {
                    switch (_context68.prev = _context68.next) {
                        case 0:
                            return _context68.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/mobile/verify', { method: 'post', body: (0, _stringify2.default)({ token: token, login_id: login_id }) }));

                        case 1:
                        case 'end':
                            return _context68.stop();
                    }
                }
            }, _callee68, _this);
        }));

        return function (_x105, _x106) {
            return _ref69.apply(this, arguments);
        };
    }();

    this.createVclog = function () {
        var _ref70 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee69(vclog) {
            return _regenerator2.default.wrap(function _callee69$(_context69) {
                while (1) {
                    switch (_context69.prev = _context69.next) {
                        case 0:
                            return _context69.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/vclog', { method: 'post', body: (0, _stringify2.default)(vclog) }));

                        case 1:
                        case 'end':
                            return _context69.stop();
                    }
                }
            }, _callee69, _this);
        }));

        return function (_x107) {
            return _ref70.apply(this, arguments);
        };
    }();

    this.getVclog = function () {
        var _ref71 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee70(userId) {
            return _regenerator2.default.wrap(function _callee70$(_context70) {
                while (1) {
                    switch (_context70.prev = _context70.next) {
                        case 0:
                            return _context70.abrupt('return', _client.Client4.doFetch(_client.Client4.getUrlVersion() + '/vclog/' + userId, { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context70.stop();
                    }
                }
            }, _callee70, _this);
        }));

        return function (_x108) {
            return _ref71.apply(this, arguments);
        };
    }();

    this.sendPasswordResetSMS = function () {
        var _ref72 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee71(login_id) {
            return _regenerator2.default.wrap(function _callee71$(_context71) {
                while (1) {
                    switch (_context71.prev = _context71.next) {
                        case 0:
                            return _context71.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/password/sms/reset/send', { method: 'post', body: (0, _stringify2.default)({ login_id: login_id }) }));

                        case 1:
                        case 'end':
                            return _context71.stop();
                    }
                }
            }, _callee71, _this);
        }));

        return function (_x109) {
            return _ref72.apply(this, arguments);
        };
    }();

    this.sendOnRequestVerificationEmail = function () {
        var _ref73 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee72(email, type) {
            return _regenerator2.default.wrap(function _callee72$(_context72) {
                while (1) {
                    switch (_context72.prev = _context72.next) {
                        case 0:
                            return _context72.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/email/verify/send', { method: 'post', body: (0, _stringify2.default)({ email: email, type: type }) }));

                        case 1:
                        case 'end':
                            return _context72.stop();
                    }
                }
            }, _callee72, _this);
        }));

        return function (_x110, _x111) {
            return _ref73.apply(this, arguments);
        };
    }();

    this.getCountryCode = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee73() {
        return _regenerator2.default.wrap(function _callee73$(_context73) {
            while (1) {
                switch (_context73.prev = _context73.next) {
                    case 0:
                        return _context73.abrupt('return', _client.Client4.doFetch(_client.Client4.getBaseRoute() + '/country', { method: 'get' }));

                    case 1:
                    case 'end':
                        return _context73.stop();
                }
            }
        }, _callee73, _this);
    }));

    this.resetUserPasswordBySMS = function () {
        var _ref75 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee74(token, loginId, newPassword) {
            return _regenerator2.default.wrap(function _callee74$(_context74) {
                while (1) {
                    switch (_context74.prev = _context74.next) {
                        case 0:
                            return _context74.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/password/reset', { method: 'post', body: (0, _stringify2.default)({ token: token, login_id: loginId, new_password: newPassword }) }));

                        case 1:
                        case 'end':
                            return _context74.stop();
                    }
                }
            }, _callee74, _this);
        }));

        return function (_x112, _x113, _x114) {
            return _ref75.apply(this, arguments);
        };
    }();

    this.getUserByCallee = function () {
        var _ref76 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee75(callee) {
            return _regenerator2.default.wrap(function _callee75$(_context75) {
                while (1) {
                    switch (_context75.prev = _context75.next) {
                        case 0:
                            return _context75.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/callee', { method: 'post', body: (0, _stringify2.default)(callee) }));

                        case 1:
                        case 'end':
                            return _context75.stop();
                    }
                }
            }, _callee75, _this);
        }));

        return function (_x115) {
            return _ref76.apply(this, arguments);
        };
    }();

    this.lookupPossibleUsers = function () {
        var _ref77 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee76(user) {
            return _regenerator2.default.wrap(function _callee76$(_context76) {
                while (1) {
                    switch (_context76.prev = _context76.next) {
                        case 0:
                            return _context76.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/lookup/unverified', { method: 'post', body: (0, _stringify2.default)(user) }));

                        case 1:
                        case 'end':
                            return _context76.stop();
                    }
                }
            }, _callee76, _this);
        }));

        return function (_x116) {
            return _ref77.apply(this, arguments);
        };
    }();

    this.getUserCleanUpTime = function () {
        var _ref78 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee77(loginId) {
            return _regenerator2.default.wrap(function _callee77$(_context77) {
                while (1) {
                    switch (_context77.prev = _context77.next) {
                        case 0:
                            return _context77.abrupt('return', _client.Client4.doFetch(_client.Client4.getUsersRoute() + '/lookup/cleanup' + buildQueryString({ login_id: loginId }), { method: 'get' }));

                        case 1:
                        case 'end':
                            return _context77.stop();
                    }
                }
            }, _callee77, _this);
        }));

        return function (_x117) {
            return _ref78.apply(this, arguments);
        };
    }();

    this.sendEmailInvitesGuestsToTeam = function () {
        var _ref79 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee78(teamId, emails) {
            return _regenerator2.default.wrap(function _callee78$(_context78) {
                while (1) {
                    switch (_context78.prev = _context78.next) {
                        case 0:
                            return _context78.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamRoute(teamId) + '/guests/invite/email', { method: 'post', body: (0, _stringify2.default)(emails) }));

                        case 1:
                        case 'end':
                            return _context78.stop();
                    }
                }
            }, _callee78, _this);
        }));

        return function (_x118, _x119) {
            return _ref79.apply(this, arguments);
        };
    }();

    this.sendMeetingInviteToExternal = function () {
        var _ref80 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee79(category, invites) {
            return _regenerator2.default.wrap(function _callee79$(_context79) {
                while (1) {
                    switch (_context79.prev = _context79.next) {
                        case 0:
                            return _context79.abrupt('return', _client.Client4.doFetch(_client.Client4.getUserRoute('me') + '/meeting/invite/' + category, { method: 'post', body: (0, _stringify2.default)(invites) }));

                        case 1:
                        case 'end':
                            return _context79.stop();
                    }
                }
            }, _callee79, _this);
        }));

        return function (_x120, _x121) {
            return _ref80.apply(this, arguments);
        };
    }();

    this.uploadChannelImage = function () {
        var _ref81 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee80(channelId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee80$(_context80) {
                while (1) {
                    switch (_context80.prev = _context80.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context80.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelRoute(channelId) + '/image', request));

                        case 5:
                        case 'end':
                            return _context80.stop();
                    }
                }
            }, _callee80, _this);
        }));

        return function (_x122, _x123) {
            return _ref81.apply(this, arguments);
        };
    }();

    this.uploadChannelBackgroundImage = function () {
        var _ref82 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee81(channelId, imageData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee81$(_context81) {
                while (1) {
                    switch (_context81.prev = _context81.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('image', imageData);

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context81.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelRoute(channelId) + '/background', request));

                        case 5:
                        case 'end':
                            return _context81.stop();
                    }
                }
            }, _callee81, _this);
        }));

        return function (_x124, _x125) {
            return _ref82.apply(this, arguments);
        };
    }();

    this.getTeamsWithMemberCount = function () {
        var _ref83 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee82() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PER_PAGE_DEFAULT;
            var needCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var query;
            return _regenerator2.default.wrap(function _callee82$(_context82) {
                while (1) {
                    switch (_context82.prev = _context82.next) {
                        case 0:
                            query = { page: page, per_page: perPage };

                            if (needCount) {
                                query.need_member_count = 'true';
                            }

                            return _context82.abrupt('return', _client.Client4.doFetch('' + _client.Client4.getTeamsRoute() + buildQueryString(query), { method: 'get' }));

                        case 3:
                        case 'end':
                            return _context82.stop();
                    }
                }
            }, _callee82, _this);
        }));

        return function () {
            return _ref83.apply(this, arguments);
        };
    }();

    this.getTeamsStats = function () {
        var _ref84 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee83(teamIds) {
            return _regenerator2.default.wrap(function _callee83$(_context83) {
                while (1) {
                    switch (_context83.prev = _context83.next) {
                        case 0:
                            return _context83.abrupt('return', _client.Client4.doFetch(_client.Client4.getTeamsRoute() + '/stats', { method: 'post', body: (0, _stringify2.default)(teamIds) }));

                        case 1:
                        case 'end':
                            return _context83.stop();
                    }
                }
            }, _callee83, _this);
        }));

        return function (_x129) {
            return _ref84.apply(this, arguments);
        };
    }();

    this.createChannelWithImages = function () {
        var _ref85 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee84(channel, imageData, backgroundData) {
            var formData, request;
            return _regenerator2.default.wrap(function _callee84$(_context84) {
                while (1) {
                    switch (_context84.prev = _context84.next) {
                        case 0:
                            formData = new FormData();

                            formData.append('channel', (0, _stringify2.default)(channel));

                            if (imageData) {
                                formData.append('image', imageData);
                            }
                            if (backgroundData) {
                                formData.append('backgroundImage', backgroundData);
                            }

                            request = {
                                method: 'post',
                                body: formData
                            };


                            if (formData.getBoundary) {
                                request.headers = {
                                    'Content-Type': 'multipart/form-data; boundary=' + formData.getBoundary()
                                };
                            }

                            return _context84.abrupt('return', _client.Client4.doFetch(_client.Client4.getChannelsRoute() + '/form', request));

                        case 7:
                        case 'end':
                            return _context84.stop();
                    }
                }
            }, _callee84, _this);
        }));

        return function (_x130, _x131, _x132) {
            return _ref85.apply(this, arguments);
        };
    }();
}

// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux Client4)


// ---

;

exports.default = CustomClientClass4;


function buildQueryString(parameters) {
    var keys = (0, _keys2.default)(parameters);
    if (keys.length === 0) {
        return '';
    }

    var query = '?';
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        query += key + '=' + encodeURIComponent(parameters[key]);

        if (i < keys.length - 1) {
            query += '&';
        }
    }

    return query;
}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

// Make a value ready for JSON.stringify() / process.send()
module.exports = function (value) {
	if (typeof value === 'object') {
		return destroyCircular(value, []);
	}

	// People sometimes throw things besides Error objects, so...

	if (typeof value === 'function') {
		// JSON.stringify discards functions. We do to, unless a function is thrown directly.
		return '[Function: ' + (value.name || 'anonymous') + ']';
	}

	return value;
};

// https://www.npmjs.com/package/destroy-circular
function destroyCircular(from, seen) {
	var to;
	if (Array.isArray(from)) {
		to = [];
	} else {
		to = {};
	}

	seen.push(from);

	Object.keys(from).forEach(function (key) {
		var value = from[key];

		if (typeof value === 'function') {
			return;
		}

		if (!value || typeof value !== 'object') {
			to[key] = value;
			return;
		}

		if (seen.indexOf(from[key]) === -1) {
			to[key] = destroyCircular(from[key], seen.slice(0));
			return;
		}

		to[key] = '[Circular]';
	});

	if (typeof from.name === 'string') {
		to.name = from.name;
	}

	if (typeof from.message === 'string') {
		to.message = from.message;
	}

	if (typeof from.stack === 'string') {
		to.stack = from.stack;
	}

	return to;
}



/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendDesktopNotification = sendDesktopNotification;

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _notification_store = __webpack_require__(448);

var _notification_store2 = _interopRequireDefault(_notification_store);

var _post_utils = __webpack_require__(173);

var _channel_utils = __webpack_require__(214);

var _user_agent = __webpack_require__(167);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function sendDesktopNotification(post, msgProps) {
    if (_user_store2.default.getCurrentId() === post.user_id && post.props.from_webhook !== 'true') {
        return;
    }

    if (!(0, _post_utils.isShowNotification)(post)) {
        return;
    }

    var mentions = [];
    if (msgProps.mentions) {
        mentions = JSON.parse(msgProps.mentions);
    }
    var teamId = msgProps.team_id;

    var channel = _channel_store2.default.get(post.channel_id);
    var user = _user_store2.default.getCurrentUser();
    var member = _channel_store2.default.getMyMember(post.channel_id);

    var notifyLevel = member && member.notify_props ? member.notify_props.desktop : 'default';
    if (notifyLevel === 'default') {
        notifyLevel = user.notify_props.desktop;
    }

    if (notifyLevel === 'none') {
        return;
    } else if (notifyLevel === 'mention' && mentions.indexOf(user.id) === -1 && msgProps.channel_type !== _constants2.default.DM_CHANNEL) {
        return;
    }

    var username = Utils.localizeMessage('channel_loader.someone', 'Someone');
    if (post.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
        username = post.props.override_username;
    } else if (msgProps.sender_name) {
        username = msgProps.sender_name;
    } else if (_user_store2.default.hasProfile(post.user_id)) {
        username = _user_store2.default.getProfile(post.user_id).username;
    }

    var title = Utils.localizeMessage('channel_loader.posted', 'Posted');
    if (!channel) {
        title = msgProps.channel_display_name;
        channel = {
            name: msgProps.channel_name,
            type: msgProps.channel_type
        };
    } else if (channel.type === _constants2.default.DM_CHANNEL) {
        title = Utils.localizeMessage('notification.dm', 'Direct Message');
    } else if (channel.type === _constants2.default.GM_CHANNEL) {
        title = (0, _channel_utils.buildGroupChannelName)(channel.id);
    } else {
        title = channel.display_name;
    }

    if (title === '') {
        if (msgProps.channel_type === _constants2.default.DM_CHANNEL) {
            title = Utils.localizeMessage('notification.dm', 'Direct Message');
        } else {
            title = msgProps.channel_display_name;
        }
    }

    var notifyText = post.message;

    var msgPropsPost = JSON.parse(msgProps.post);
    var attachments = msgPropsPost && msgPropsPost.props && msgPropsPost.props.attachments ? msgPropsPost.props.attachments : [];
    var image = false;
    attachments.forEach(function (attachment) {
        if (notifyText.length === 0) {
            notifyText = attachment.fallback || attachment.pretext || attachment.text;
        }
        image |= attachment.image_url.length > 0;
    });

    notifyText = notifyText.replace(/\n+/g, ' ');
    if (notifyText.length > 50) {
        notifyText = notifyText.substring(0, 49) + '...';
    }

    var body = '';
    if (notifyText.length === 0) {
        if (msgProps.image) {
            body = username + Utils.localizeMessage('channel_loader.uploadedImage', ' uploaded an image');
        } else if (msgProps.otherFile) {
            body = username + Utils.localizeMessage('channel_loader.uploadedFile', ' uploaded a file');
        } else if (image) {
            body = username + Utils.localizeMessage('channel_loader.postedImage', ' posted an image');
        } else if (post.type === _constants2.default.PostTypes.FORMAT_LOCATION) {
            body = username + Utils.localizeMessage('channel_loader.postedLocation', ' shared an location');
        } else if (post.type === _constants2.default.PostTypes.FORMAT_NAMECARD) {
            body = username + Utils.localizeMessage('channel_loader.postedNamecard', ' shared an contact');
        } else {
            body = username + Utils.localizeMessage('channel_loader.something', ' did something new');
        }
    } else {
        body = username + Utils.localizeMessage('channel_loader.wrote', ' wrote: ') + notifyText;
    }

    var duration = _constants2.default.DEFAULT_NOTIFICATION_DURATION;
    if (user.notify_props && user.notify_props.desktop_duration) {
        duration = parseInt(user.notify_props.desktop_duration, 10) * 1000;
    }

    //Play a sound if explicitly set in settings
    var sound = !user.notify_props || user.notify_props.desktop_sound === 'true';

    // Notify if you're not looking in the right channel or when
    // the window itself is not active
    var activeChannel = _channel_store2.default.getCurrent();
    var channelId = channel ? channel.id : null;
    var notify = activeChannel && activeChannel.id !== channelId || !_notification_store2.default.getFocus();

    if (notify) {
        Utils.notifyMe(title, body, channel, teamId, duration, !sound);

        //Don't add extra sounds on native desktop clients
        if (sound && !(0, _user_agent.isWindowsApp)() && !(0, _user_agent.isMacApp)() && !(0, _user_agent.isMobileApp)()) {
            Utils.ding();
        }
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = [
	{
		"aliases": [
			"grinning"
		],
		"filename": "1f600",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smiley"
		],
		"filename": "1f603",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smile"
		],
		"filename": "1f604",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"grin"
		],
		"filename": "1f601",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"laughing",
			"satisfied"
		],
		"filename": "1f606",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sweat_smile"
		],
		"filename": "1f605",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"rofl"
		],
		"filename": "1f923",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"joy"
		],
		"filename": "1f602",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"slightly_smiling_face"
		],
		"filename": "1f642",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"upside_down_face"
		],
		"filename": "1f643",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"wink"
		],
		"filename": "1f609",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"blush"
		],
		"filename": "1f60a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"innocent"
		],
		"filename": "1f607",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smiling_face_with_three_hearts"
		],
		"filename": "1f970",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"heart_eyes"
		],
		"filename": "1f60d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"star_struck"
		],
		"filename": "1f929",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_heart"
		],
		"filename": "1f618",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing"
		],
		"filename": "1f617",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"relaxed"
		],
		"filename": "263a-fe0f",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_closed_eyes"
		],
		"filename": "1f61a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_smiling_eyes"
		],
		"filename": "1f619",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"yum"
		],
		"filename": "1f60b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue"
		],
		"filename": "1f61b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue_winking_eye"
		],
		"filename": "1f61c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"zany_face"
		],
		"filename": "1f92a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue_closed_eyes"
		],
		"filename": "1f61d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"money_mouth_face"
		],
		"filename": "1f911",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"hugs"
		],
		"filename": "1f917",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_over_mouth"
		],
		"filename": "1f92d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"shushing_face"
		],
		"filename": "1f92b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"thinking"
		],
		"filename": "1f914",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"zipper_mouth_face"
		],
		"filename": "1f910",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_eyebrow"
		],
		"filename": "1f928",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"neutral_face"
		],
		"filename": "1f610",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"expressionless"
		],
		"filename": "1f611",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"no_mouth"
		],
		"filename": "1f636",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smirk"
		],
		"filename": "1f60f",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"unamused"
		],
		"filename": "1f612",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"roll_eyes"
		],
		"filename": "1f644",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"grimacing"
		],
		"filename": "1f62c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"lying_face"
		],
		"filename": "1f925",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"relieved"
		],
		"filename": "1f60c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"pensive"
		],
		"filename": "1f614",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sleepy"
		],
		"filename": "1f62a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"drooling_face"
		],
		"filename": "1f924",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sleeping"
		],
		"filename": "1f634",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"mask"
		],
		"filename": "1f637",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"face_with_thermometer"
		],
		"filename": "1f912",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"face_with_head_bandage"
		],
		"filename": "1f915",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"nauseated_face"
		],
		"filename": "1f922",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"vomiting_face"
		],
		"filename": "1f92e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sneezing_face"
		],
		"filename": "1f927",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"hot_face"
		],
		"filename": "1f975",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cold_face"
		],
		"filename": "1f976",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"woozy_face"
		],
		"filename": "1f974",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"dizzy_face"
		],
		"filename": "1f635",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"exploding_head"
		],
		"filename": "1f92f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cowboy_hat_face"
		],
		"filename": "1f920",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"partying_face"
		],
		"filename": "1f973",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sunglasses"
		],
		"filename": "1f60e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"nerd_face"
		],
		"filename": "1f913",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"monocle_face"
		],
		"filename": "1f9d0",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"confused"
		],
		"filename": "1f615",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"worried"
		],
		"filename": "1f61f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"slightly_frowning_face"
		],
		"filename": "1f641",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_face"
		],
		"filename": "2639-fe0f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"open_mouth"
		],
		"filename": "1f62e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"hushed"
		],
		"filename": "1f62f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"astonished"
		],
		"filename": "1f632",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"flushed"
		],
		"filename": "1f633",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"pleading_face"
		],
		"filename": "1f97a",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning"
		],
		"filename": "1f626",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"anguished"
		],
		"filename": "1f627",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"fearful"
		],
		"filename": "1f628",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cold_sweat"
		],
		"filename": "1f630",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"disappointed_relieved"
		],
		"filename": "1f625",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cry"
		],
		"filename": "1f622",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sob"
		],
		"filename": "1f62d",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"scream"
		],
		"filename": "1f631",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"confounded"
		],
		"filename": "1f616",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"persevere"
		],
		"filename": "1f623",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"disappointed"
		],
		"filename": "1f61e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sweat"
		],
		"filename": "1f613",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"weary"
		],
		"filename": "1f629",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"tired_face"
		],
		"filename": "1f62b",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"yawning_face"
		],
		"filename": "1f971",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"triumph"
		],
		"filename": "1f624",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"rage",
			"pout"
		],
		"filename": "1f621",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"angry"
		],
		"filename": "1f620",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cursing_face"
		],
		"filename": "1f92c",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"smiling_imp"
		],
		"filename": "1f608",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"imp"
		],
		"filename": "1f47f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"skull"
		],
		"filename": "1f480",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"skull_and_crossbones"
		],
		"filename": "2620-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"hankey",
			"poop",
			"shit"
		],
		"filename": "1f4a9",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"clown_face"
		],
		"filename": "1f921",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"japanese_ogre"
		],
		"filename": "1f479",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"japanese_goblin"
		],
		"filename": "1f47a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"ghost"
		],
		"filename": "1f47b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"alien"
		],
		"filename": "1f47d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"space_invader"
		],
		"filename": "1f47e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"robot"
		],
		"filename": "1f916",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smiley_cat"
		],
		"filename": "1f63a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smile_cat"
		],
		"filename": "1f638",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"joy_cat"
		],
		"filename": "1f639",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart_eyes_cat"
		],
		"filename": "1f63b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smirk_cat"
		],
		"filename": "1f63c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"kissing_cat"
		],
		"filename": "1f63d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"scream_cat"
		],
		"filename": "1f640",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"crying_cat_face"
		],
		"filename": "1f63f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"pouting_cat"
		],
		"filename": "1f63e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"see_no_evil"
		],
		"filename": "1f648",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"hear_no_evil"
		],
		"filename": "1f649",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"speak_no_evil"
		],
		"filename": "1f64a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"kiss"
		],
		"filename": "1f48b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"love_letter"
		],
		"filename": "1f48c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"cupid"
		],
		"filename": "1f498",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"gift_heart"
		],
		"filename": "1f49d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"sparkling_heart"
		],
		"filename": "1f496",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heartpulse"
		],
		"filename": "1f497",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heartbeat"
		],
		"filename": "1f493",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"revolving_hearts"
		],
		"filename": "1f49e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"two_hearts"
		],
		"filename": "1f495",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart_decoration"
		],
		"filename": "1f49f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_heart_exclamation"
		],
		"filename": "2763-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"broken_heart"
		],
		"filename": "1f494",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart"
		],
		"filename": "2764-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"orange_heart"
		],
		"filename": "1f9e1",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"yellow_heart"
		],
		"filename": "1f49b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"green_heart"
		],
		"filename": "1f49a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"blue_heart"
		],
		"filename": "1f499",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"purple_heart"
		],
		"filename": "1f49c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"brown_heart"
		],
		"filename": "1f90e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"black_heart"
		],
		"filename": "1f5a4",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"white_heart"
		],
		"filename": "1f90d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"100"
		],
		"filename": "1f4af",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"anger"
		],
		"filename": "1f4a2",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"boom",
			"collision"
		],
		"filename": "1f4a5",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"dizzy"
		],
		"filename": "1f4ab",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"sweat_drops"
		],
		"filename": "1f4a6",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"dash"
		],
		"filename": "1f4a8",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"hole"
		],
		"filename": "1f573-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"bomb"
		],
		"filename": "1f4a3",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"speech_balloon"
		],
		"filename": "1f4ac",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"eye_speech_bubble"
		],
		"filename": "1f441-fe0f-200d-1f5e8-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"left_speech_bubble"
		],
		"filename": "1f5e8-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"right_anger_bubble"
		],
		"filename": "1f5ef-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"thought_balloon"
		],
		"filename": "1f4ad",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"zzz"
		],
		"filename": "1f4a4",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"wave"
		],
		"filename": "1f44b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand"
		],
		"filename": "1f91a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed"
		],
		"filename": "1f590",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"hand",
			"raised_hand"
		],
		"filename": "270b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute"
		],
		"filename": "1f596",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand"
		],
		"filename": "1f44c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_hand"
		],
		"filename": "1f90f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"v"
		],
		"filename": "270c-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers"
		],
		"filename": "1f91e",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture"
		],
		"filename": "1f91f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"metal"
		],
		"filename": "1f918",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"call_me_hand"
		],
		"filename": "1f919",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_left"
		],
		"filename": "1f448",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_right"
		],
		"filename": "1f449",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_up_2"
		],
		"filename": "1f446",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"middle_finger",
			"fu"
		],
		"filename": "1f595",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_down"
		],
		"filename": "1f447",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_up"
		],
		"filename": "261d-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"+1",
			"thumbsup"
		],
		"filename": "1f44d",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"-1",
			"thumbsdown"
		],
		"filename": "1f44e",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_raised",
			"fist"
		],
		"filename": "270a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_oncoming",
			"facepunch",
			"punch"
		],
		"filename": "1f44a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_left"
		],
		"filename": "1f91b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_right"
		],
		"filename": "1f91c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"clap"
		],
		"filename": "1f44f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hands"
		],
		"filename": "1f64c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"open_hands"
		],
		"filename": "1f450",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"palms_up_together"
		],
		"filename": "1f932",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"handshake"
		],
		"filename": "1f91d",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"pray"
		],
		"filename": "1f64f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"writing_hand"
		],
		"filename": "270d-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"nail_care"
		],
		"filename": "1f485",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"selfie"
		],
		"filename": "1f933",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"muscle"
		],
		"filename": "1f4aa",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"mechanical_arm"
		],
		"filename": "1f9be",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"mechanical_leg"
		],
		"filename": "1f9bf",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"leg"
		],
		"filename": "1f9b5",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"foot"
		],
		"filename": "1f9b6",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ear"
		],
		"filename": "1f442",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid"
		],
		"filename": "1f9bb",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"nose"
		],
		"filename": "1f443",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"brain"
		],
		"filename": "1f9e0",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"tooth"
		],
		"filename": "1f9b7",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"bone"
		],
		"filename": "1f9b4",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"eyes"
		],
		"filename": "1f440",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"eye"
		],
		"filename": "1f441",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tongue"
		],
		"filename": "1f445",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"lips"
		],
		"filename": "1f444",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"baby"
		],
		"filename": "1f476",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"child"
		],
		"filename": "1f9d2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"boy"
		],
		"filename": "1f466",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"girl"
		],
		"filename": "1f467",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"adult"
		],
		"filename": "1f9d1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_person",
			"person_with_blond_hair"
		],
		"filename": "1f471",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"man"
		],
		"filename": "1f468",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bearded_person"
		],
		"filename": "1f9d4",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"red_haired_man"
		],
		"filename": "1f468-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"curly_haired_man"
		],
		"filename": "1f468-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"white_haired_man"
		],
		"filename": "1f468-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bald_man"
		],
		"filename": "1f468-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"woman"
		],
		"filename": "1f469",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"red_haired_woman"
		],
		"filename": "1f469-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_red_hair"
		],
		"filename": "1f9d1-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"curly_haired_woman"
		],
		"filename": "1f469-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_curly_hair"
		],
		"filename": "1f9d1-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"white_haired_woman"
		],
		"filename": "1f469-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_white_hair"
		],
		"filename": "1f9d1-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bald_woman"
		],
		"filename": "1f469-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_bald"
		],
		"filename": "1f9d1-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_woman",
			"blonde_woman"
		],
		"filename": "1f471-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_man",
			"blonde_man"
		],
		"filename": "1f471-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_adult"
		],
		"filename": "1f9d3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_man"
		],
		"filename": "1f474",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_woman"
		],
		"filename": "1f475",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_person",
			"person_frowning"
		],
		"filename": "1f64d",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_man"
		],
		"filename": "1f64d-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_woman"
		],
		"filename": "1f64d-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_face",
			"person_with_pouting_face"
		],
		"filename": "1f64e",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_man"
		],
		"filename": "1f64e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_woman"
		],
		"filename": "1f64e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good"
		],
		"filename": "1f645",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good_man",
			"ng_man"
		],
		"filename": "1f645-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good_woman",
			"ng_woman"
		],
		"filename": "1f645-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_person"
		],
		"filename": "1f646",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_man"
		],
		"filename": "1f646-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_woman"
		],
		"filename": "1f646-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_person",
			"information_desk_person"
		],
		"filename": "1f481",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_man",
			"sassy_man"
		],
		"filename": "1f481-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_woman",
			"sassy_woman"
		],
		"filename": "1f481-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"raising_hand"
		],
		"filename": "1f64b",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"raising_hand_man"
		],
		"filename": "1f64b-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"raising_hand_woman"
		],
		"filename": "1f64b-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_person"
		],
		"filename": "1f9cf",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_man"
		],
		"filename": "1f9cf-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_woman"
		],
		"filename": "1f9cf-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bow"
		],
		"filename": "1f647",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bowing_man"
		],
		"filename": "1f647-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bowing_woman"
		],
		"filename": "1f647-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"facepalm"
		],
		"filename": "1f926",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_facepalming"
		],
		"filename": "1f926-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_facepalming"
		],
		"filename": "1f926-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"shrug"
		],
		"filename": "1f937",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_shrugging"
		],
		"filename": "1f937-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_shrugging"
		],
		"filename": "1f937-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"health_worker"
		],
		"filename": "1f9d1-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_health_worker"
		],
		"filename": "1f468-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_health_worker"
		],
		"filename": "1f469-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"student"
		],
		"filename": "1f9d1-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_student"
		],
		"filename": "1f468-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_student"
		],
		"filename": "1f469-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"teacher"
		],
		"filename": "1f9d1-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_teacher"
		],
		"filename": "1f468-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_teacher"
		],
		"filename": "1f469-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"judge"
		],
		"filename": "1f9d1-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_judge"
		],
		"filename": "1f468-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_judge"
		],
		"filename": "1f469-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"farmer"
		],
		"filename": "1f9d1-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_farmer"
		],
		"filename": "1f468-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_farmer"
		],
		"filename": "1f469-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"cook"
		],
		"filename": "1f9d1-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_cook"
		],
		"filename": "1f468-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_cook"
		],
		"filename": "1f469-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"mechanic"
		],
		"filename": "1f9d1-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_mechanic"
		],
		"filename": "1f468-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_mechanic"
		],
		"filename": "1f469-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"factory_worker"
		],
		"filename": "1f9d1-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_factory_worker"
		],
		"filename": "1f468-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_factory_worker"
		],
		"filename": "1f469-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"office_worker"
		],
		"filename": "1f9d1-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_office_worker"
		],
		"filename": "1f468-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_office_worker"
		],
		"filename": "1f469-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"scientist"
		],
		"filename": "1f9d1-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_scientist"
		],
		"filename": "1f468-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_scientist"
		],
		"filename": "1f469-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"technologist"
		],
		"filename": "1f9d1-200d-1f4bb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_technologist"
		],
		"filename": "1f468-200d-1f4bb",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_technologist"
		],
		"filename": "1f469-200d-1f4bb",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"singer"
		],
		"filename": "1f9d1-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_singer"
		],
		"filename": "1f468-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_singer"
		],
		"filename": "1f469-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"artist"
		],
		"filename": "1f9d1-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_artist"
		],
		"filename": "1f468-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_artist"
		],
		"filename": "1f469-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"pilot"
		],
		"filename": "1f9d1-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_pilot"
		],
		"filename": "1f468-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_pilot"
		],
		"filename": "1f469-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"astronaut"
		],
		"filename": "1f9d1-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_astronaut"
		],
		"filename": "1f468-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_astronaut"
		],
		"filename": "1f469-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"firefighter"
		],
		"filename": "1f9d1-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_firefighter"
		],
		"filename": "1f468-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_firefighter"
		],
		"filename": "1f469-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"police_officer",
			"cop"
		],
		"filename": "1f46e",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"policeman"
		],
		"filename": "1f46e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"policewoman"
		],
		"filename": "1f46e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"detective"
		],
		"filename": "1f575-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"male_detective"
		],
		"filename": "1f575-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"female_detective"
		],
		"filename": "1f575-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guard"
		],
		"filename": "1f482",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guardsman"
		],
		"filename": "1f482-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guardswoman"
		],
		"filename": "1f482-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker"
		],
		"filename": "1f477",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker_man"
		],
		"filename": "1f477-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker_woman"
		],
		"filename": "1f477-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"prince"
		],
		"filename": "1f934",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"princess"
		],
		"filename": "1f478",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"person_with_turban"
		],
		"filename": "1f473",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_with_turban"
		],
		"filename": "1f473-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_with_turban"
		],
		"filename": "1f473-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao"
		],
		"filename": "1f472",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_with_headscarf"
		],
		"filename": "1f9d5",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_in_tuxedo"
		],
		"filename": "1f935",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"bride_with_veil"
		],
		"filename": "1f470",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"pregnant_woman"
		],
		"filename": "1f930",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"breast_feeding"
		],
		"filename": "1f931",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"angel"
		],
		"filename": "1f47c",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"santa"
		],
		"filename": "1f385",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"mrs_claus"
		],
		"filename": "1f936",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero"
		],
		"filename": "1f9b8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero_man"
		],
		"filename": "1f9b8-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero_woman"
		],
		"filename": "1f9b8-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain"
		],
		"filename": "1f9b9",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain_man"
		],
		"filename": "1f9b9-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain_woman"
		],
		"filename": "1f9b9-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage"
		],
		"filename": "1f9d9",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage_man"
		],
		"filename": "1f9d9-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage_woman"
		],
		"filename": "1f9d9-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy"
		],
		"filename": "1f9da",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy_man"
		],
		"filename": "1f9da-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy_woman"
		],
		"filename": "1f9da-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire"
		],
		"filename": "1f9db",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire_man"
		],
		"filename": "1f9db-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire_woman"
		],
		"filename": "1f9db-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"merperson"
		],
		"filename": "1f9dc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"merman"
		],
		"filename": "1f9dc-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mermaid"
		],
		"filename": "1f9dc-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf"
		],
		"filename": "1f9dd",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf_man"
		],
		"filename": "1f9dd-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf_woman"
		],
		"filename": "1f9dd-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie"
		],
		"filename": "1f9de",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie_man"
		],
		"filename": "1f9de-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie_woman"
		],
		"filename": "1f9de-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie"
		],
		"filename": "1f9df",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie_man"
		],
		"filename": "1f9df-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie_woman"
		],
		"filename": "1f9df-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage"
		],
		"filename": "1f486",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage_man"
		],
		"filename": "1f486-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage_woman"
		],
		"filename": "1f486-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut"
		],
		"filename": "1f487",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut_man"
		],
		"filename": "1f487-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut_woman"
		],
		"filename": "1f487-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking"
		],
		"filename": "1f6b6",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking_man"
		],
		"filename": "1f6b6-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking_woman"
		],
		"filename": "1f6b6-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_person"
		],
		"filename": "1f9cd",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_man"
		],
		"filename": "1f9cd-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_woman"
		],
		"filename": "1f9cd-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_person"
		],
		"filename": "1f9ce",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_man"
		],
		"filename": "1f9ce-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_woman"
		],
		"filename": "1f9ce-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"person_with_probing_cane"
		],
		"filename": "1f9d1-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"man_with_probing_cane"
		],
		"filename": "1f468-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"woman_with_probing_cane"
		],
		"filename": "1f469-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair"
		],
		"filename": "1f9d1-200d-1f9bc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair"
		],
		"filename": "1f468-200d-1f9bc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair"
		],
		"filename": "1f469-200d-1f9bc",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair"
		],
		"filename": "1f9d1-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair"
		],
		"filename": "1f468-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair"
		],
		"filename": "1f469-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"runner",
			"running"
		],
		"filename": "1f3c3",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"running_man"
		],
		"filename": "1f3c3-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"running_woman"
		],
		"filename": "1f3c3-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_dancing",
			"dancer"
		],
		"filename": "1f483",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"man_dancing"
		],
		"filename": "1f57a",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"business_suit_levitating"
		],
		"filename": "1f574",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancers"
		],
		"filename": "1f46f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancing_men"
		],
		"filename": "1f46f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancing_women"
		],
		"filename": "1f46f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_person"
		],
		"filename": "1f9d6",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_man"
		],
		"filename": "1f9d6-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_woman"
		],
		"filename": "1f9d6-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing"
		],
		"filename": "1f9d7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing_man"
		],
		"filename": "1f9d7-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing_woman"
		],
		"filename": "1f9d7-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"person_fencing"
		],
		"filename": "1f93a",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"horse_racing"
		],
		"filename": "1f3c7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"skier"
		],
		"filename": "26f7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"snowboarder"
		],
		"filename": "1f3c2",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing"
		],
		"filename": "1f3cc-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing_man"
		],
		"filename": "1f3cc-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing_woman"
		],
		"filename": "1f3cc-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfer"
		],
		"filename": "1f3c4",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfing_man"
		],
		"filename": "1f3c4-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfing_woman"
		],
		"filename": "1f3c4-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowboat"
		],
		"filename": "1f6a3",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowing_man"
		],
		"filename": "1f6a3-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowing_woman"
		],
		"filename": "1f6a3-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimmer"
		],
		"filename": "1f3ca",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimming_man"
		],
		"filename": "1f3ca-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimming_woman"
		],
		"filename": "1f3ca-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_person"
		],
		"filename": "26f9-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_man",
			"basketball_man"
		],
		"filename": "26f9-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_woman",
			"basketball_woman"
		],
		"filename": "26f9-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting"
		],
		"filename": "1f3cb-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting_man"
		],
		"filename": "1f3cb-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting_woman"
		],
		"filename": "1f3cb-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bicyclist"
		],
		"filename": "1f6b4",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"biking_man"
		],
		"filename": "1f6b4-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"biking_woman"
		],
		"filename": "1f6b4-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"mountain_bicyclist"
		],
		"filename": "1f6b5",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"mountain_biking_man"
		],
		"filename": "1f6b5-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"mountain_biking_woman"
		],
		"filename": "1f6b5-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"cartwheeling"
		],
		"filename": "1f938",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_cartwheeling"
		],
		"filename": "1f938-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_cartwheeling"
		],
		"filename": "1f938-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"wrestling"
		],
		"filename": "1f93c",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"men_wrestling"
		],
		"filename": "1f93c-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"women_wrestling"
		],
		"filename": "1f93c-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"water_polo"
		],
		"filename": "1f93d",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_playing_water_polo"
		],
		"filename": "1f93d-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_playing_water_polo"
		],
		"filename": "1f93d-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"handball_person"
		],
		"filename": "1f93e",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_playing_handball"
		],
		"filename": "1f93e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_playing_handball"
		],
		"filename": "1f93e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"juggling_person"
		],
		"filename": "1f939",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_juggling"
		],
		"filename": "1f939-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_juggling"
		],
		"filename": "1f939-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position"
		],
		"filename": "1f9d8",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position_man"
		],
		"filename": "1f9d8-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position_woman"
		],
		"filename": "1f9d8-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"bath"
		],
		"filename": "1f6c0",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"sleeping_bed"
		],
		"filename": "1f6cc",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"people_holding_hands"
		],
		"filename": "1f9d1-200d-1f91d-200d-1f9d1",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"two_women_holding_hands"
		],
		"filename": "1f46d",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple"
		],
		"filename": "1f46b",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"two_men_holding_hands"
		],
		"filename": "1f46c",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss"
		],
		"filename": "1f48f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_man_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_man_man"
		],
		"filename": "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_woman_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart"
		],
		"filename": "1f491",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_woman_man"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_man_man"
		],
		"filename": "1f468-200d-2764-fe0f-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_woman_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f469",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family"
		],
		"filename": "1f46a",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl"
		],
		"filename": "1f468-200d-1f469-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_boy_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl_girl"
		],
		"filename": "1f468-200d-1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl"
		],
		"filename": "1f468-200d-1f468-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_boy_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl_girl"
		],
		"filename": "1f468-200d-1f468-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_woman_woman_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl"
		],
		"filename": "1f469-200d-1f469-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_boy_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl_girl"
		],
		"filename": "1f469-200d-1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_boy"
		],
		"filename": "1f468-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_boy_boy"
		],
		"filename": "1f468-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl"
		],
		"filename": "1f468-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl_boy"
		],
		"filename": "1f468-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl_girl"
		],
		"filename": "1f468-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_boy"
		],
		"filename": "1f469-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_boy_boy"
		],
		"filename": "1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl"
		],
		"filename": "1f469-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl_boy"
		],
		"filename": "1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl_girl"
		],
		"filename": "1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"speaking_head"
		],
		"filename": "1f5e3",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"bust_in_silhouette"
		],
		"filename": "1f464",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"busts_in_silhouette"
		],
		"filename": "1f465",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"footprints"
		],
		"filename": "1f463",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"monkey_face"
		],
		"filename": "1f435",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"monkey"
		],
		"filename": "1f412",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"gorilla"
		],
		"filename": "1f98d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"orangutan"
		],
		"filename": "1f9a7",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dog"
		],
		"filename": "1f436",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dog2"
		],
		"filename": "1f415",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"guide_dog"
		],
		"filename": "1f9ae",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"service_dog"
		],
		"filename": "1f415-200d-1f9ba",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"poodle"
		],
		"filename": "1f429",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"wolf"
		],
		"filename": "1f43a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"fox_face"
		],
		"filename": "1f98a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"raccoon"
		],
		"filename": "1f99d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cat"
		],
		"filename": "1f431",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cat2"
		],
		"filename": "1f408",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"lion"
		],
		"filename": "1f981",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"tiger"
		],
		"filename": "1f42f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"tiger2"
		],
		"filename": "1f405",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"leopard"
		],
		"filename": "1f406",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"horse"
		],
		"filename": "1f434",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"racehorse"
		],
		"filename": "1f40e",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"unicorn"
		],
		"filename": "1f984",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"zebra"
		],
		"filename": "1f993",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"deer"
		],
		"filename": "1f98c",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cow"
		],
		"filename": "1f42e",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"ox"
		],
		"filename": "1f402",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"water_buffalo"
		],
		"filename": "1f403",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cow2"
		],
		"filename": "1f404",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig"
		],
		"filename": "1f437",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig2"
		],
		"filename": "1f416",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"boar"
		],
		"filename": "1f417",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig_nose"
		],
		"filename": "1f43d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"ram"
		],
		"filename": "1f40f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"sheep"
		],
		"filename": "1f411",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"goat"
		],
		"filename": "1f410",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dromedary_camel"
		],
		"filename": "1f42a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"camel"
		],
		"filename": "1f42b",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"llama"
		],
		"filename": "1f999",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"giraffe"
		],
		"filename": "1f992",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"elephant"
		],
		"filename": "1f418",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rhinoceros"
		],
		"filename": "1f98f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"hippopotamus"
		],
		"filename": "1f99b",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"mouse"
		],
		"filename": "1f42d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"mouse2"
		],
		"filename": "1f401",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rat"
		],
		"filename": "1f400",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"hamster"
		],
		"filename": "1f439",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rabbit"
		],
		"filename": "1f430",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"rabbit2"
		],
		"filename": "1f407",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"chipmunk"
		],
		"filename": "1f43f",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hedgehog"
		],
		"filename": "1f994",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bat"
		],
		"filename": "1f987",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bear"
		],
		"filename": "1f43b",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"koala"
		],
		"filename": "1f428",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"panda_face"
		],
		"filename": "1f43c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"sloth"
		],
		"filename": "1f9a5",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"otter"
		],
		"filename": "1f9a6",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"skunk"
		],
		"filename": "1f9a8",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"kangaroo"
		],
		"filename": "1f998",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"badger"
		],
		"filename": "1f9a1",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"feet",
			"paw_prints"
		],
		"filename": "1f43e",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"turkey"
		],
		"filename": "1f983",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"chicken"
		],
		"filename": "1f414",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"rooster"
		],
		"filename": "1f413",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hatching_chick"
		],
		"filename": "1f423",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"baby_chick"
		],
		"filename": "1f424",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hatched_chick"
		],
		"filename": "1f425",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bird"
		],
		"filename": "1f426",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"penguin"
		],
		"filename": "1f427",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dove"
		],
		"filename": "1f54a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"eagle"
		],
		"filename": "1f985",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"duck"
		],
		"filename": "1f986",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"swan"
		],
		"filename": "1f9a2",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"owl"
		],
		"filename": "1f989",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"flamingo"
		],
		"filename": "1f9a9",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"peacock"
		],
		"filename": "1f99a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"parrot"
		],
		"filename": "1f99c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"frog"
		],
		"filename": "1f438",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"crocodile"
		],
		"filename": "1f40a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"turtle"
		],
		"filename": "1f422",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"lizard"
		],
		"filename": "1f98e",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"snake"
		],
		"filename": "1f40d",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dragon_face"
		],
		"filename": "1f432",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dragon"
		],
		"filename": "1f409",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"sauropod"
		],
		"filename": "1f995",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"t-rex"
		],
		"filename": "1f996",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"whale"
		],
		"filename": "1f433",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"whale2"
		],
		"filename": "1f40b",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dolphin",
			"flipper"
		],
		"filename": "1f42c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"fish"
		],
		"filename": "1f41f",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"tropical_fish"
		],
		"filename": "1f420",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"blowfish"
		],
		"filename": "1f421",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"shark"
		],
		"filename": "1f988",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"octopus"
		],
		"filename": "1f419",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"shell"
		],
		"filename": "1f41a",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"snail"
		],
		"filename": "1f40c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"butterfly"
		],
		"filename": "1f98b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bug"
		],
		"filename": "1f41b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"ant"
		],
		"filename": "1f41c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bee",
			"honeybee"
		],
		"filename": "1f41d",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"beetle"
		],
		"filename": "1f41e",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cricket"
		],
		"filename": "1f997",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"spider"
		],
		"filename": "1f577",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"spider_web"
		],
		"filename": "1f578",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"scorpion"
		],
		"filename": "1f982",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"mosquito"
		],
		"filename": "1f99f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"microbe"
		],
		"filename": "1f9a0",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bouquet"
		],
		"filename": "1f490",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cherry_blossom"
		],
		"filename": "1f338",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"white_flower"
		],
		"filename": "1f4ae",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"rosette"
		],
		"filename": "1f3f5",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"rose"
		],
		"filename": "1f339",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"wilted_flower"
		],
		"filename": "1f940",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"hibiscus"
		],
		"filename": "1f33a",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"sunflower"
		],
		"filename": "1f33b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"blossom"
		],
		"filename": "1f33c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"tulip"
		],
		"filename": "1f337",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"seedling"
		],
		"filename": "1f331",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"evergreen_tree"
		],
		"filename": "1f332",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"deciduous_tree"
		],
		"filename": "1f333",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"palm_tree"
		],
		"filename": "1f334",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cactus"
		],
		"filename": "1f335",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"ear_of_rice"
		],
		"filename": "1f33e",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"herb"
		],
		"filename": "1f33f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"shamrock"
		],
		"filename": "2618-fe0f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"four_leaf_clover"
		],
		"filename": "1f340",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"maple_leaf"
		],
		"filename": "1f341",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"fallen_leaf"
		],
		"filename": "1f342",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"leaves"
		],
		"filename": "1f343",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"grapes"
		],
		"filename": "1f347",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"melon"
		],
		"filename": "1f348",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"watermelon"
		],
		"filename": "1f349",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"tangerine",
			"orange",
			"mandarin"
		],
		"filename": "1f34a",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"lemon"
		],
		"filename": "1f34b",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"banana"
		],
		"filename": "1f34c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pineapple"
		],
		"filename": "1f34d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"mango"
		],
		"filename": "1f96d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"apple"
		],
		"filename": "1f34e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"green_apple"
		],
		"filename": "1f34f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pear"
		],
		"filename": "1f350",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"peach"
		],
		"filename": "1f351",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cherries"
		],
		"filename": "1f352",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"strawberry"
		],
		"filename": "1f353",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"kiwi_fruit"
		],
		"filename": "1f95d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"tomato"
		],
		"filename": "1f345",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"coconut"
		],
		"filename": "1f965",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"avocado"
		],
		"filename": "1f951",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"eggplant"
		],
		"filename": "1f346",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"potato"
		],
		"filename": "1f954",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"carrot"
		],
		"filename": "1f955",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"corn"
		],
		"filename": "1f33d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"hot_pepper"
		],
		"filename": "1f336",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cucumber"
		],
		"filename": "1f952",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"leafy_green"
		],
		"filename": "1f96c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"broccoli"
		],
		"filename": "1f966",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"garlic"
		],
		"filename": "1f9c4",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"onion"
		],
		"filename": "1f9c5",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"mushroom"
		],
		"filename": "1f344",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"peanuts"
		],
		"filename": "1f95c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"chestnut"
		],
		"filename": "1f330",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bread"
		],
		"filename": "1f35e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"croissant"
		],
		"filename": "1f950",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"baguette_bread"
		],
		"filename": "1f956",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pretzel"
		],
		"filename": "1f968",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bagel"
		],
		"filename": "1f96f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pancakes"
		],
		"filename": "1f95e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"waffle"
		],
		"filename": "1f9c7",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cheese"
		],
		"filename": "1f9c0",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"meat_on_bone"
		],
		"filename": "1f356",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"poultry_leg"
		],
		"filename": "1f357",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cut_of_meat"
		],
		"filename": "1f969",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bacon"
		],
		"filename": "1f953",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"hamburger"
		],
		"filename": "1f354",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"fries"
		],
		"filename": "1f35f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pizza"
		],
		"filename": "1f355",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"hotdog"
		],
		"filename": "1f32d",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sandwich"
		],
		"filename": "1f96a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"taco"
		],
		"filename": "1f32e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"burrito"
		],
		"filename": "1f32f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"stuffed_flatbread"
		],
		"filename": "1f959",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"falafel"
		],
		"filename": "1f9c6",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"egg"
		],
		"filename": "1f95a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fried_egg"
		],
		"filename": "1f373",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shallow_pan_of_food"
		],
		"filename": "1f958",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"stew"
		],
		"filename": "1f372",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"bowl_with_spoon"
		],
		"filename": "1f963",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"green_salad"
		],
		"filename": "1f957",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"popcorn"
		],
		"filename": "1f37f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"butter"
		],
		"filename": "1f9c8",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"salt"
		],
		"filename": "1f9c2",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"canned_food"
		],
		"filename": "1f96b",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"bento"
		],
		"filename": "1f371",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice_cracker"
		],
		"filename": "1f358",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice_ball"
		],
		"filename": "1f359",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice"
		],
		"filename": "1f35a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"curry"
		],
		"filename": "1f35b",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"ramen"
		],
		"filename": "1f35c",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"spaghetti"
		],
		"filename": "1f35d",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sweet_potato"
		],
		"filename": "1f360",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"oden"
		],
		"filename": "1f362",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sushi"
		],
		"filename": "1f363",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fried_shrimp"
		],
		"filename": "1f364",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fish_cake"
		],
		"filename": "1f365",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"moon_cake"
		],
		"filename": "1f96e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"dango"
		],
		"filename": "1f361",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"dumpling"
		],
		"filename": "1f95f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fortune_cookie"
		],
		"filename": "1f960",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"takeout_box"
		],
		"filename": "1f961",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"crab"
		],
		"filename": "1f980",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"lobster"
		],
		"filename": "1f99e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shrimp"
		],
		"filename": "1f990",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"squid"
		],
		"filename": "1f991",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"oyster"
		],
		"filename": "1f9aa",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"icecream"
		],
		"filename": "1f366",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shaved_ice"
		],
		"filename": "1f367",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"ice_cream"
		],
		"filename": "1f368",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"doughnut"
		],
		"filename": "1f369",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"cookie"
		],
		"filename": "1f36a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"birthday"
		],
		"filename": "1f382",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"cake"
		],
		"filename": "1f370",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cupcake"
		],
		"filename": "1f9c1",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"pie"
		],
		"filename": "1f967",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"chocolate_bar"
		],
		"filename": "1f36b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"candy"
		],
		"filename": "1f36c",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"lollipop"
		],
		"filename": "1f36d",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"custard"
		],
		"filename": "1f36e",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"honey_pot"
		],
		"filename": "1f36f",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"baby_bottle"
		],
		"filename": "1f37c",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"milk_glass"
		],
		"filename": "1f95b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"coffee"
		],
		"filename": "2615",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tea"
		],
		"filename": "1f375",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"sake"
		],
		"filename": "1f376",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"champagne"
		],
		"filename": "1f37e",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"wine_glass"
		],
		"filename": "1f377",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cocktail"
		],
		"filename": "1f378",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tropical_drink"
		],
		"filename": "1f379",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beer"
		],
		"filename": "1f37a",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beers"
		],
		"filename": "1f37b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"clinking_glasses"
		],
		"filename": "1f942",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tumbler_glass"
		],
		"filename": "1f943",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cup_with_straw"
		],
		"filename": "1f964",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beverage_box"
		],
		"filename": "1f9c3",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"mate"
		],
		"filename": "1f9c9",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"ice_cube"
		],
		"filename": "1f9ca",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"chopsticks"
		],
		"filename": "1f962",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"plate_with_cutlery"
		],
		"filename": "1f37d",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"fork_and_knife"
		],
		"filename": "1f374",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"spoon"
		],
		"filename": "1f944",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"hocho",
			"knife"
		],
		"filename": "1f52a",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"amphora"
		],
		"filename": "1f3fa",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"earth_africa"
		],
		"filename": "1f30d",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"earth_americas"
		],
		"filename": "1f30e",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"earth_asia"
		],
		"filename": "1f30f",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"globe_with_meridians"
		],
		"filename": "1f310",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"world_map"
		],
		"filename": "1f5fa",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"japan"
		],
		"filename": "1f5fe",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"compass"
		],
		"filename": "1f9ed",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mountain_snow"
		],
		"filename": "1f3d4",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mountain"
		],
		"filename": "26f0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"volcano"
		],
		"filename": "1f30b",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mount_fuji"
		],
		"filename": "1f5fb",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"camping"
		],
		"filename": "1f3d5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"beach_umbrella"
		],
		"filename": "1f3d6",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"desert"
		],
		"filename": "1f3dc",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"desert_island"
		],
		"filename": "1f3dd",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"national_park"
		],
		"filename": "1f3de",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"stadium"
		],
		"filename": "1f3df",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"classical_building"
		],
		"filename": "1f3db",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"building_construction"
		],
		"filename": "1f3d7",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"bricks"
		],
		"filename": "1f9f1",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"houses"
		],
		"filename": "1f3d8",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"derelict_house"
		],
		"filename": "1f3da",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"house"
		],
		"filename": "1f3e0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"house_with_garden"
		],
		"filename": "1f3e1",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"office"
		],
		"filename": "1f3e2",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"post_office"
		],
		"filename": "1f3e3",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"european_post_office"
		],
		"filename": "1f3e4",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hospital"
		],
		"filename": "1f3e5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"bank"
		],
		"filename": "1f3e6",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hotel"
		],
		"filename": "1f3e8",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"love_hotel"
		],
		"filename": "1f3e9",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"convenience_store"
		],
		"filename": "1f3ea",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"school"
		],
		"filename": "1f3eb",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"department_store"
		],
		"filename": "1f3ec",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"factory"
		],
		"filename": "1f3ed",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"japanese_castle"
		],
		"filename": "1f3ef",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"european_castle"
		],
		"filename": "1f3f0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"wedding"
		],
		"filename": "1f492",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"tokyo_tower"
		],
		"filename": "1f5fc",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"statue_of_liberty"
		],
		"filename": "1f5fd",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"church"
		],
		"filename": "26ea",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mosque"
		],
		"filename": "1f54c",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hindu_temple"
		],
		"filename": "1f6d5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"synagogue"
		],
		"filename": "1f54d",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"shinto_shrine"
		],
		"filename": "26e9",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"kaaba"
		],
		"filename": "1f54b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"fountain"
		],
		"filename": "26f2",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tent"
		],
		"filename": "26fa",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"foggy"
		],
		"filename": "1f301",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"night_with_stars"
		],
		"filename": "1f303",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"cityscape"
		],
		"filename": "1f3d9",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"sunrise_over_mountains"
		],
		"filename": "1f304",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"sunrise"
		],
		"filename": "1f305",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"city_sunset"
		],
		"filename": "1f306",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"city_sunrise"
		],
		"filename": "1f307",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bridge_at_night"
		],
		"filename": "1f309",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"hotsprings"
		],
		"filename": "2668-fe0f",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"carousel_horse"
		],
		"filename": "1f3a0",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"ferris_wheel"
		],
		"filename": "1f3a1",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"roller_coaster"
		],
		"filename": "1f3a2",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"barber"
		],
		"filename": "1f488",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"circus_tent"
		],
		"filename": "1f3aa",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"steam_locomotive"
		],
		"filename": "1f682",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"railway_car"
		],
		"filename": "1f683",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bullettrain_side"
		],
		"filename": "1f684",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bullettrain_front"
		],
		"filename": "1f685",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"train2"
		],
		"filename": "1f686",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"metro"
		],
		"filename": "1f687",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"light_rail"
		],
		"filename": "1f688",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"station"
		],
		"filename": "1f689",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tram"
		],
		"filename": "1f68a",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"monorail"
		],
		"filename": "1f69d",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"mountain_railway"
		],
		"filename": "1f69e",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"train"
		],
		"filename": "1f68b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bus"
		],
		"filename": "1f68c",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_bus"
		],
		"filename": "1f68d",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"trolleybus"
		],
		"filename": "1f68e",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"minibus"
		],
		"filename": "1f690",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"ambulance"
		],
		"filename": "1f691",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"fire_engine"
		],
		"filename": "1f692",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"police_car"
		],
		"filename": "1f693",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_police_car"
		],
		"filename": "1f694",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"taxi"
		],
		"filename": "1f695",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_taxi"
		],
		"filename": "1f696",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"car",
			"red_car"
		],
		"filename": "1f697",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_automobile"
		],
		"filename": "1f698",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"blue_car"
		],
		"filename": "1f699",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"truck"
		],
		"filename": "1f69a",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"articulated_lorry"
		],
		"filename": "1f69b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tractor"
		],
		"filename": "1f69c",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"racing_car"
		],
		"filename": "1f3ce",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorcycle"
		],
		"filename": "1f3cd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motor_scooter"
		],
		"filename": "1f6f5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"manual_wheelchair"
		],
		"filename": "1f9bd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorized_wheelchair"
		],
		"filename": "1f9bc",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"auto_rickshaw"
		],
		"filename": "1f6fa",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"bike"
		],
		"filename": "1f6b2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"kick_scooter"
		],
		"filename": "1f6f4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"skateboard"
		],
		"filename": "1f6f9",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"busstop"
		],
		"filename": "1f68f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorway"
		],
		"filename": "1f6e3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"railway_track"
		],
		"filename": "1f6e4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"oil_drum"
		],
		"filename": "1f6e2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"fuelpump"
		],
		"filename": "26fd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"rotating_light"
		],
		"filename": "1f6a8",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"traffic_light"
		],
		"filename": "1f6a5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"vertical_traffic_light"
		],
		"filename": "1f6a6",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"stop_sign"
		],
		"filename": "1f6d1",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"construction"
		],
		"filename": "1f6a7",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"anchor"
		],
		"filename": "2693",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"boat",
			"sailboat"
		],
		"filename": "26f5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"canoe"
		],
		"filename": "1f6f6",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"speedboat"
		],
		"filename": "1f6a4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"passenger_ship"
		],
		"filename": "1f6f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"ferry"
		],
		"filename": "26f4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motor_boat"
		],
		"filename": "1f6e5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"ship"
		],
		"filename": "1f6a2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"airplane"
		],
		"filename": "2708-fe0f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"small_airplane"
		],
		"filename": "1f6e9",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flight_departure"
		],
		"filename": "1f6eb",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flight_arrival"
		],
		"filename": "1f6ec",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"parachute"
		],
		"filename": "1fa82",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"seat"
		],
		"filename": "1f4ba",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"helicopter"
		],
		"filename": "1f681",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"suspension_railway"
		],
		"filename": "1f69f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"mountain_cableway"
		],
		"filename": "1f6a0",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"aerial_tramway"
		],
		"filename": "1f6a1",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"artificial_satellite"
		],
		"filename": "1f6f0",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"rocket"
		],
		"filename": "1f680",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flying_saucer"
		],
		"filename": "1f6f8",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"bellhop_bell"
		],
		"filename": "1f6ce",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"luggage"
		],
		"filename": "1f9f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"hourglass"
		],
		"filename": "231b",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"hourglass_flowing_sand"
		],
		"filename": "23f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"watch"
		],
		"filename": "231a",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"alarm_clock"
		],
		"filename": "23f0",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"stopwatch"
		],
		"filename": "23f1",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"timer_clock"
		],
		"filename": "23f2",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"mantelpiece_clock"
		],
		"filename": "1f570",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock12"
		],
		"filename": "1f55b",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1230"
		],
		"filename": "1f567",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1"
		],
		"filename": "1f550",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock130"
		],
		"filename": "1f55c",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock2"
		],
		"filename": "1f551",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock230"
		],
		"filename": "1f55d",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock3"
		],
		"filename": "1f552",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock330"
		],
		"filename": "1f55e",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock4"
		],
		"filename": "1f553",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock430"
		],
		"filename": "1f55f",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock5"
		],
		"filename": "1f554",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock530"
		],
		"filename": "1f560",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock6"
		],
		"filename": "1f555",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock630"
		],
		"filename": "1f561",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock7"
		],
		"filename": "1f556",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock730"
		],
		"filename": "1f562",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock8"
		],
		"filename": "1f557",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock830"
		],
		"filename": "1f563",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock9"
		],
		"filename": "1f558",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock930"
		],
		"filename": "1f564",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock10"
		],
		"filename": "1f559",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1030"
		],
		"filename": "1f565",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock11"
		],
		"filename": "1f55a",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1130"
		],
		"filename": "1f566",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"new_moon"
		],
		"filename": "1f311",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waxing_crescent_moon"
		],
		"filename": "1f312",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"first_quarter_moon"
		],
		"filename": "1f313",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"moon",
			"waxing_gibbous_moon"
		],
		"filename": "1f314",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"full_moon"
		],
		"filename": "1f315",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waning_gibbous_moon"
		],
		"filename": "1f316",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"last_quarter_moon"
		],
		"filename": "1f317",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waning_crescent_moon"
		],
		"filename": "1f318",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"crescent_moon"
		],
		"filename": "1f319",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"new_moon_with_face"
		],
		"filename": "1f31a",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"first_quarter_moon_with_face"
		],
		"filename": "1f31b",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"last_quarter_moon_with_face"
		],
		"filename": "1f31c",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"thermometer"
		],
		"filename": "1f321",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"sunny"
		],
		"filename": "2600-fe0f",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"full_moon_with_face"
		],
		"filename": "1f31d",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"sun_with_face"
		],
		"filename": "1f31e",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"ringed_planet"
		],
		"filename": "1fa90",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"star"
		],
		"filename": "2b50",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"star2"
		],
		"filename": "1f31f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"stars"
		],
		"filename": "1f320",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"milky_way"
		],
		"filename": "1f30c",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud"
		],
		"filename": "2601-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"partly_sunny"
		],
		"filename": "26c5",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_lightning_and_rain"
		],
		"filename": "26c8",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_small_cloud"
		],
		"filename": "1f324",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_large_cloud"
		],
		"filename": "1f325",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_rain_cloud"
		],
		"filename": "1f326",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_rain"
		],
		"filename": "1f327",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_snow"
		],
		"filename": "1f328",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_lightning"
		],
		"filename": "1f329",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"tornado"
		],
		"filename": "1f32a",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"fog"
		],
		"filename": "1f32b",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"wind_face"
		],
		"filename": "1f32c",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cyclone"
		],
		"filename": "1f300",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"rainbow"
		],
		"filename": "1f308",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"closed_umbrella"
		],
		"filename": "1f302",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"open_umbrella"
		],
		"filename": "2602-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"umbrella"
		],
		"filename": "2614",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"parasol_on_ground"
		],
		"filename": "26f1",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"zap"
		],
		"filename": "26a1",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowflake"
		],
		"filename": "2744-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowman_with_snow"
		],
		"filename": "2603-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowman"
		],
		"filename": "26c4",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"comet"
		],
		"filename": "2604-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"fire"
		],
		"filename": "1f525",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"droplet"
		],
		"filename": "1f4a7",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"ocean"
		],
		"filename": "1f30a",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"jack_o_lantern"
		],
		"filename": "1f383",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"christmas_tree"
		],
		"filename": "1f384",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"fireworks"
		],
		"filename": "1f386",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"sparkler"
		],
		"filename": "1f387",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"firecracker"
		],
		"filename": "1f9e8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"sparkles"
		],
		"filename": "2728",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"balloon"
		],
		"filename": "1f388",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tada"
		],
		"filename": "1f389",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"confetti_ball"
		],
		"filename": "1f38a",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tanabata_tree"
		],
		"filename": "1f38b",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"bamboo"
		],
		"filename": "1f38d",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"dolls"
		],
		"filename": "1f38e",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"flags"
		],
		"filename": "1f38f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"wind_chime"
		],
		"filename": "1f390",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"rice_scene"
		],
		"filename": "1f391",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"red_envelope"
		],
		"filename": "1f9e7",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ribbon"
		],
		"filename": "1f380",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"gift"
		],
		"filename": "1f381",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"reminder_ribbon"
		],
		"filename": "1f397",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tickets"
		],
		"filename": "1f39f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ticket"
		],
		"filename": "1f3ab",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"medal_military"
		],
		"filename": "1f396",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"trophy"
		],
		"filename": "1f3c6",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"medal_sports"
		],
		"filename": "1f3c5",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"1st_place_medal"
		],
		"filename": "1f947",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"2nd_place_medal"
		],
		"filename": "1f948",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"3rd_place_medal"
		],
		"filename": "1f949",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"soccer"
		],
		"filename": "26bd",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"baseball"
		],
		"filename": "26be",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"softball"
		],
		"filename": "1f94e",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"basketball"
		],
		"filename": "1f3c0",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"volleyball"
		],
		"filename": "1f3d0",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"football"
		],
		"filename": "1f3c8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"rugby_football"
		],
		"filename": "1f3c9",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tennis"
		],
		"filename": "1f3be",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"flying_disc"
		],
		"filename": "1f94f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"bowling"
		],
		"filename": "1f3b3",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"cricket_game"
		],
		"filename": "1f3cf",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"field_hockey"
		],
		"filename": "1f3d1",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ice_hockey"
		],
		"filename": "1f3d2",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"lacrosse"
		],
		"filename": "1f94d",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ping_pong"
		],
		"filename": "1f3d3",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"badminton"
		],
		"filename": "1f3f8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"boxing_glove"
		],
		"filename": "1f94a",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"martial_arts_uniform"
		],
		"filename": "1f94b",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"goal_net"
		],
		"filename": "1f945",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"golf"
		],
		"filename": "26f3",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"ice_skate"
		],
		"filename": "26f8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"fishing_pole_and_fish"
		],
		"filename": "1f3a3",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"diving_mask"
		],
		"filename": "1f93f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"running_shirt_with_sash"
		],
		"filename": "1f3bd",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"ski"
		],
		"filename": "1f3bf",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"sled"
		],
		"filename": "1f6f7",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"curling_stone"
		],
		"filename": "1f94c",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"dart"
		],
		"filename": "1f3af",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"yo_yo"
		],
		"filename": "1fa80",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"kite"
		],
		"filename": "1fa81",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"8ball"
		],
		"filename": "1f3b1",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"crystal_ball"
		],
		"filename": "1f52e",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"nazar_amulet"
		],
		"filename": "1f9ff",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"video_game"
		],
		"filename": "1f3ae",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"joystick"
		],
		"filename": "1f579",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"slot_machine"
		],
		"filename": "1f3b0",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"game_die"
		],
		"filename": "1f3b2",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"jigsaw"
		],
		"filename": "1f9e9",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"teddy_bear"
		],
		"filename": "1f9f8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"spades"
		],
		"filename": "2660-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"hearts"
		],
		"filename": "2665-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"diamonds"
		],
		"filename": "2666-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"clubs"
		],
		"filename": "2663-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"chess_pawn"
		],
		"filename": "265f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"black_joker"
		],
		"filename": "1f0cf",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"mahjong"
		],
		"filename": "1f004",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"flower_playing_cards"
		],
		"filename": "1f3b4",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"performing_arts"
		],
		"filename": "1f3ad",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"framed_picture"
		],
		"filename": "1f5bc",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"art"
		],
		"filename": "1f3a8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"thread"
		],
		"filename": "1f9f5",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"yarn"
		],
		"filename": "1f9f6",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"eyeglasses"
		],
		"filename": "1f453",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"dark_sunglasses"
		],
		"filename": "1f576",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"goggles"
		],
		"filename": "1f97d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"lab_coat"
		],
		"filename": "1f97c",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"safety_vest"
		],
		"filename": "1f9ba",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"necktie"
		],
		"filename": "1f454",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shirt",
			"tshirt"
		],
		"filename": "1f455",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"jeans"
		],
		"filename": "1f456",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"scarf"
		],
		"filename": "1f9e3",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"gloves"
		],
		"filename": "1f9e4",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"coat"
		],
		"filename": "1f9e5",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"socks"
		],
		"filename": "1f9e6",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"dress"
		],
		"filename": "1f457",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"kimono"
		],
		"filename": "1f458",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sari"
		],
		"filename": "1f97b",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"one_piece_swimsuit"
		],
		"filename": "1fa71",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"swim_brief"
		],
		"filename": "1fa72",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shorts"
		],
		"filename": "1fa73",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"bikini"
		],
		"filename": "1f459",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"womans_clothes"
		],
		"filename": "1f45a",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"purse"
		],
		"filename": "1f45b",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"handbag"
		],
		"filename": "1f45c",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"pouch"
		],
		"filename": "1f45d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shopping"
		],
		"filename": "1f6cd",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"school_satchel"
		],
		"filename": "1f392",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mans_shoe",
			"shoe"
		],
		"filename": "1f45e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"athletic_shoe"
		],
		"filename": "1f45f",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"hiking_boot"
		],
		"filename": "1f97e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"flat_shoe"
		],
		"filename": "1f97f",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"high_heel"
		],
		"filename": "1f460",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sandal"
		],
		"filename": "1f461",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"ballet_shoes"
		],
		"filename": "1fa70",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"boot"
		],
		"filename": "1f462",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"crown"
		],
		"filename": "1f451",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"womans_hat"
		],
		"filename": "1f452",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"tophat"
		],
		"filename": "1f3a9",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mortar_board"
		],
		"filename": "1f393",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"billed_cap"
		],
		"filename": "1f9e2",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"rescue_worker_helmet"
		],
		"filename": "26d1",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"prayer_beads"
		],
		"filename": "1f4ff",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"lipstick"
		],
		"filename": "1f484",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"ring"
		],
		"filename": "1f48d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"gem"
		],
		"filename": "1f48e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mute"
		],
		"filename": "1f507",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"speaker"
		],
		"filename": "1f508",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sound"
		],
		"filename": "1f509",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"loud_sound"
		],
		"filename": "1f50a",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"loudspeaker"
		],
		"filename": "1f4e2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"mega"
		],
		"filename": "1f4e3",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"postal_horn"
		],
		"filename": "1f4ef",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"bell"
		],
		"filename": "1f514",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"no_bell"
		],
		"filename": "1f515",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_score"
		],
		"filename": "1f3bc",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_note"
		],
		"filename": "1f3b5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"notes"
		],
		"filename": "1f3b6",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"studio_microphone"
		],
		"filename": "1f399",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"level_slider"
		],
		"filename": "1f39a",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"control_knobs"
		],
		"filename": "1f39b",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"microphone"
		],
		"filename": "1f3a4",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"headphones"
		],
		"filename": "1f3a7",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"radio"
		],
		"filename": "1f4fb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"saxophone"
		],
		"filename": "1f3b7",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"guitar"
		],
		"filename": "1f3b8",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_keyboard"
		],
		"filename": "1f3b9",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"trumpet"
		],
		"filename": "1f3ba",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"violin"
		],
		"filename": "1f3bb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"banjo"
		],
		"filename": "1fa95",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"drum"
		],
		"filename": "1f941",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"iphone"
		],
		"filename": "1f4f1",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"calling"
		],
		"filename": "1f4f2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"phone",
			"telephone"
		],
		"filename": "260e-fe0f",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"telephone_receiver"
		],
		"filename": "1f4de",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"pager"
		],
		"filename": "1f4df",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"fax"
		],
		"filename": "1f4e0",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"battery"
		],
		"filename": "1f50b",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"electric_plug"
		],
		"filename": "1f50c",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"computer"
		],
		"filename": "1f4bb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"desktop_computer"
		],
		"filename": "1f5a5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"printer"
		],
		"filename": "1f5a8",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"keyboard"
		],
		"filename": "2328-fe0f",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"computer_mouse"
		],
		"filename": "1f5b1",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"trackball"
		],
		"filename": "1f5b2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"minidisc"
		],
		"filename": "1f4bd",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"floppy_disk"
		],
		"filename": "1f4be",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"cd"
		],
		"filename": "1f4bf",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"dvd"
		],
		"filename": "1f4c0",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"abacus"
		],
		"filename": "1f9ee",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"movie_camera"
		],
		"filename": "1f3a5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"film_strip"
		],
		"filename": "1f39e",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"film_projector"
		],
		"filename": "1f4fd",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"clapper"
		],
		"filename": "1f3ac",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"tv"
		],
		"filename": "1f4fa",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"camera"
		],
		"filename": "1f4f7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"camera_flash"
		],
		"filename": "1f4f8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"video_camera"
		],
		"filename": "1f4f9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"vhs"
		],
		"filename": "1f4fc",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"mag"
		],
		"filename": "1f50d",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"mag_right"
		],
		"filename": "1f50e",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"candle"
		],
		"filename": "1f56f",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bulb"
		],
		"filename": "1f4a1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"flashlight"
		],
		"filename": "1f526",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"izakaya_lantern",
			"lantern"
		],
		"filename": "1f3ee",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"diya_lamp"
		],
		"filename": "1fa94",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"notebook_with_decorative_cover"
		],
		"filename": "1f4d4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"closed_book"
		],
		"filename": "1f4d5",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"book",
			"open_book"
		],
		"filename": "1f4d6",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"green_book"
		],
		"filename": "1f4d7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"blue_book"
		],
		"filename": "1f4d8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"orange_book"
		],
		"filename": "1f4d9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"books"
		],
		"filename": "1f4da",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"notebook"
		],
		"filename": "1f4d3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"ledger"
		],
		"filename": "1f4d2",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"page_with_curl"
		],
		"filename": "1f4c3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"scroll"
		],
		"filename": "1f4dc",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"page_facing_up"
		],
		"filename": "1f4c4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"newspaper"
		],
		"filename": "1f4f0",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"newspaper_roll"
		],
		"filename": "1f5de",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bookmark_tabs"
		],
		"filename": "1f4d1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bookmark"
		],
		"filename": "1f516",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"label"
		],
		"filename": "1f3f7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"moneybag"
		],
		"filename": "1f4b0",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"yen"
		],
		"filename": "1f4b4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"dollar"
		],
		"filename": "1f4b5",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"euro"
		],
		"filename": "1f4b6",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"pound"
		],
		"filename": "1f4b7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"money_with_wings"
		],
		"filename": "1f4b8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"credit_card"
		],
		"filename": "1f4b3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"receipt"
		],
		"filename": "1f9fe",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"chart"
		],
		"filename": "1f4b9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"currency_exchange"
		],
		"filename": "1f4b1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_dollar_sign"
		],
		"filename": "1f4b2",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"email",
			"envelope"
		],
		"filename": "2709-fe0f",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"e-mail"
		],
		"filename": "1f4e7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"incoming_envelope"
		],
		"filename": "1f4e8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"envelope_with_arrow"
		],
		"filename": "1f4e9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"outbox_tray"
		],
		"filename": "1f4e4",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"inbox_tray"
		],
		"filename": "1f4e5",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"package"
		],
		"filename": "1f4e6",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox"
		],
		"filename": "1f4eb",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_closed"
		],
		"filename": "1f4ea",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_with_mail"
		],
		"filename": "1f4ec",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_with_no_mail"
		],
		"filename": "1f4ed",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"postbox"
		],
		"filename": "1f4ee",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"ballot_box"
		],
		"filename": "1f5f3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pencil2"
		],
		"filename": "270f-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"black_nib"
		],
		"filename": "2712-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"fountain_pen"
		],
		"filename": "1f58b",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pen"
		],
		"filename": "1f58a",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paintbrush"
		],
		"filename": "1f58c",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"crayon"
		],
		"filename": "1f58d",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"memo",
			"pencil"
		],
		"filename": "1f4dd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"briefcase"
		],
		"filename": "1f4bc",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"file_folder"
		],
		"filename": "1f4c1",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"open_file_folder"
		],
		"filename": "1f4c2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_index_dividers"
		],
		"filename": "1f5c2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"date"
		],
		"filename": "1f4c5",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"calendar"
		],
		"filename": "1f4c6",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"spiral_notepad"
		],
		"filename": "1f5d2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"spiral_calendar"
		],
		"filename": "1f5d3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_index"
		],
		"filename": "1f4c7",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"chart_with_upwards_trend"
		],
		"filename": "1f4c8",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"chart_with_downwards_trend"
		],
		"filename": "1f4c9",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"bar_chart"
		],
		"filename": "1f4ca",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"clipboard"
		],
		"filename": "1f4cb",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pushpin"
		],
		"filename": "1f4cc",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"round_pushpin"
		],
		"filename": "1f4cd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paperclip"
		],
		"filename": "1f4ce",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paperclips"
		],
		"filename": "1f587",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"straight_ruler"
		],
		"filename": "1f4cf",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"triangular_ruler"
		],
		"filename": "1f4d0",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"scissors"
		],
		"filename": "2702-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_file_box"
		],
		"filename": "1f5c3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"file_cabinet"
		],
		"filename": "1f5c4",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"wastebasket"
		],
		"filename": "1f5d1",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"lock"
		],
		"filename": "1f512",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"unlock"
		],
		"filename": "1f513",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"lock_with_ink_pen"
		],
		"filename": "1f50f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"closed_lock_with_key"
		],
		"filename": "1f510",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"key"
		],
		"filename": "1f511",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"old_key"
		],
		"filename": "1f5dd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"hammer"
		],
		"filename": "1f528",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"axe"
		],
		"filename": "1fa93",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"pick"
		],
		"filename": "26cf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"hammer_and_pick"
		],
		"filename": "2692",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"hammer_and_wrench"
		],
		"filename": "1f6e0",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"dagger"
		],
		"filename": "1f5e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"crossed_swords"
		],
		"filename": "2694-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"gun"
		],
		"filename": "1f52b",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bow_and_arrow"
		],
		"filename": "1f3f9",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"shield"
		],
		"filename": "1f6e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"wrench"
		],
		"filename": "1f527",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"nut_and_bolt"
		],
		"filename": "1f529",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"gear"
		],
		"filename": "2699-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"clamp"
		],
		"filename": "1f5dc",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"balance_scale"
		],
		"filename": "2696-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"probing_cane"
		],
		"filename": "1f9af",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"link"
		],
		"filename": "1f517",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"chains"
		],
		"filename": "26d3",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"toolbox"
		],
		"filename": "1f9f0",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"magnet"
		],
		"filename": "1f9f2",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"alembic"
		],
		"filename": "2697-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"test_tube"
		],
		"filename": "1f9ea",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"petri_dish"
		],
		"filename": "1f9eb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"dna"
		],
		"filename": "1f9ec",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"microscope"
		],
		"filename": "1f52c",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"telescope"
		],
		"filename": "1f52d",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"satellite"
		],
		"filename": "1f4e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"syringe"
		],
		"filename": "1f489",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"drop_of_blood"
		],
		"filename": "1fa78",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"pill"
		],
		"filename": "1f48a",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"adhesive_bandage"
		],
		"filename": "1fa79",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"stethoscope"
		],
		"filename": "1fa7a",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"door"
		],
		"filename": "1f6aa",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bed"
		],
		"filename": "1f6cf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"couch_and_lamp"
		],
		"filename": "1f6cb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"chair"
		],
		"filename": "1fa91",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"toilet"
		],
		"filename": "1f6bd",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"shower"
		],
		"filename": "1f6bf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bathtub"
		],
		"filename": "1f6c1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"razor"
		],
		"filename": "1fa92",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"lotion_bottle"
		],
		"filename": "1f9f4",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"safety_pin"
		],
		"filename": "1f9f7",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"broom"
		],
		"filename": "1f9f9",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"basket"
		],
		"filename": "1f9fa",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"roll_of_paper"
		],
		"filename": "1f9fb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"soap"
		],
		"filename": "1f9fc",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"sponge"
		],
		"filename": "1f9fd",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"fire_extinguisher"
		],
		"filename": "1f9ef",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"shopping_cart"
		],
		"filename": "1f6d2",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"smoking"
		],
		"filename": "1f6ac",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"coffin"
		],
		"filename": "26b0-fe0f",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"funeral_urn"
		],
		"filename": "26b1-fe0f",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"moyai"
		],
		"filename": "1f5ff",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"atm"
		],
		"filename": "1f3e7",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"put_litter_in_its_place"
		],
		"filename": "1f6ae",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"potable_water"
		],
		"filename": "1f6b0",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"wheelchair"
		],
		"filename": "267f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"mens"
		],
		"filename": "1f6b9",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"womens"
		],
		"filename": "1f6ba",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"restroom"
		],
		"filename": "1f6bb",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"baby_symbol"
		],
		"filename": "1f6bc",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"wc"
		],
		"filename": "1f6be",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"passport_control"
		],
		"filename": "1f6c2",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"customs"
		],
		"filename": "1f6c3",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"baggage_claim"
		],
		"filename": "1f6c4",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"left_luggage"
		],
		"filename": "1f6c5",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"warning"
		],
		"filename": "26a0-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"children_crossing"
		],
		"filename": "1f6b8",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_entry"
		],
		"filename": "26d4",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_entry_sign"
		],
		"filename": "1f6ab",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_bicycles"
		],
		"filename": "1f6b3",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_smoking"
		],
		"filename": "1f6ad",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"do_not_litter"
		],
		"filename": "1f6af",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"non-potable_water"
		],
		"filename": "1f6b1",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_pedestrians"
		],
		"filename": "1f6b7",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_mobile_phones"
		],
		"filename": "1f4f5",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"underage"
		],
		"filename": "1f51e",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"radioactive"
		],
		"filename": "2622-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"biohazard"
		],
		"filename": "2623-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_up"
		],
		"filename": "2b06-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_upper_right"
		],
		"filename": "2197-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_right"
		],
		"filename": "27a1-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_lower_right"
		],
		"filename": "2198-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_down"
		],
		"filename": "2b07-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_lower_left"
		],
		"filename": "2199-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_left"
		],
		"filename": "2b05-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_upper_left"
		],
		"filename": "2196-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_up_down"
		],
		"filename": "2195-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"left_right_arrow"
		],
		"filename": "2194-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"leftwards_arrow_with_hook"
		],
		"filename": "21a9-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_right_hook"
		],
		"filename": "21aa-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_heading_up"
		],
		"filename": "2934-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_heading_down"
		],
		"filename": "2935-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrows_clockwise"
		],
		"filename": "1f503",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrows_counterclockwise"
		],
		"filename": "1f504",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"back"
		],
		"filename": "1f519",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"end"
		],
		"filename": "1f51a",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"on"
		],
		"filename": "1f51b",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"soon"
		],
		"filename": "1f51c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"top"
		],
		"filename": "1f51d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"place_of_worship"
		],
		"filename": "1f6d0",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"atom_symbol"
		],
		"filename": "269b-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"om"
		],
		"filename": "1f549",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"star_of_david"
		],
		"filename": "2721-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"wheel_of_dharma"
		],
		"filename": "2638-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"yin_yang"
		],
		"filename": "262f-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"latin_cross"
		],
		"filename": "271d-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"orthodox_cross"
		],
		"filename": "2626-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"star_and_crescent"
		],
		"filename": "262a-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"peace_symbol"
		],
		"filename": "262e-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"menorah"
		],
		"filename": "1f54e",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"six_pointed_star"
		],
		"filename": "1f52f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"aries"
		],
		"filename": "2648",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"taurus"
		],
		"filename": "2649",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"gemini"
		],
		"filename": "264a",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"cancer"
		],
		"filename": "264b",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"leo"
		],
		"filename": "264c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"virgo"
		],
		"filename": "264d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"libra"
		],
		"filename": "264e",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"scorpius"
		],
		"filename": "264f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"sagittarius"
		],
		"filename": "2650",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"capricorn"
		],
		"filename": "2651",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"aquarius"
		],
		"filename": "2652",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"pisces"
		],
		"filename": "2653",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"ophiuchus"
		],
		"filename": "26ce",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"twisted_rightwards_arrows"
		],
		"filename": "1f500",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"repeat"
		],
		"filename": "1f501",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"repeat_one"
		],
		"filename": "1f502",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_forward"
		],
		"filename": "25b6-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"fast_forward"
		],
		"filename": "23e9",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"next_track_button"
		],
		"filename": "23ed",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"play_or_pause_button"
		],
		"filename": "23ef",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_backward"
		],
		"filename": "25c0-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"rewind"
		],
		"filename": "23ea",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"previous_track_button"
		],
		"filename": "23ee",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_up_small"
		],
		"filename": "1f53c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_double_up"
		],
		"filename": "23eb",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_down_small"
		],
		"filename": "1f53d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_double_down"
		],
		"filename": "23ec",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"pause_button"
		],
		"filename": "23f8",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"stop_button"
		],
		"filename": "23f9",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"record_button"
		],
		"filename": "23fa",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"eject_button"
		],
		"filename": "23cf",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"cinema"
		],
		"filename": "1f3a6",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"low_brightness"
		],
		"filename": "1f505",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"high_brightness"
		],
		"filename": "1f506",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"signal_strength"
		],
		"filename": "1f4f6",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"vibration_mode"
		],
		"filename": "1f4f3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"mobile_phone_off"
		],
		"filename": "1f4f4",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"female_sign"
		],
		"filename": "2640",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"male_sign"
		],
		"filename": "2642",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"medical_symbol"
		],
		"filename": "2695",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"infinity"
		],
		"filename": "267e",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"recycle"
		],
		"filename": "267b-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"fleur_de_lis"
		],
		"filename": "269c-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"trident"
		],
		"filename": "1f531",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"name_badge"
		],
		"filename": "1f4db",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"beginner"
		],
		"filename": "1f530",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"o"
		],
		"filename": "2b55",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"white_check_mark"
		],
		"filename": "2705",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"ballot_box_with_check"
		],
		"filename": "2611-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_check_mark"
		],
		"filename": "2714-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_multiplication_x"
		],
		"filename": "2716-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"x"
		],
		"filename": "274c",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"negative_squared_cross_mark"
		],
		"filename": "274e",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_plus_sign"
		],
		"filename": "2795",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_minus_sign"
		],
		"filename": "2796",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_division_sign"
		],
		"filename": "2797",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"curly_loop"
		],
		"filename": "27b0",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"loop"
		],
		"filename": "27bf",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"part_alternation_mark"
		],
		"filename": "303d-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"eight_spoked_asterisk"
		],
		"filename": "2733-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"eight_pointed_black_star"
		],
		"filename": "2734-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"sparkle"
		],
		"filename": "2747-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"bangbang"
		],
		"filename": "203c-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"interrobang"
		],
		"filename": "2049-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"question"
		],
		"filename": "2753",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"grey_question"
		],
		"filename": "2754",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"grey_exclamation"
		],
		"filename": "2755",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"exclamation",
			"heavy_exclamation_mark"
		],
		"filename": "2757",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"wavy_dash"
		],
		"filename": "3030-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"copyright"
		],
		"filename": "00a9-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"registered"
		],
		"filename": "00ae-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"tm"
		],
		"filename": "2122-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"hash"
		],
		"filename": "0023-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"asterisk"
		],
		"filename": "002a-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"zero"
		],
		"filename": "0030-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"one"
		],
		"filename": "0031-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"two"
		],
		"filename": "0032-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"three"
		],
		"filename": "0033-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"four"
		],
		"filename": "0034-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"five"
		],
		"filename": "0035-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"six"
		],
		"filename": "0036-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"seven"
		],
		"filename": "0037-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"eight"
		],
		"filename": "0038-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"nine"
		],
		"filename": "0039-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"keycap_ten"
		],
		"filename": "1f51f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"capital_abcd"
		],
		"filename": "1f520",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"abcd"
		],
		"filename": "1f521",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"1234"
		],
		"filename": "1f522",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"symbols"
		],
		"filename": "1f523",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"abc"
		],
		"filename": "1f524",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"a"
		],
		"filename": "1f170-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ab"
		],
		"filename": "1f18e",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"b"
		],
		"filename": "1f171-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"cl"
		],
		"filename": "1f191",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"cool"
		],
		"filename": "1f192",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"free"
		],
		"filename": "1f193",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"information_source"
		],
		"filename": "2139-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"id"
		],
		"filename": "1f194",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"m"
		],
		"filename": "24c2-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"new"
		],
		"filename": "1f195",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ng"
		],
		"filename": "1f196",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"o2"
		],
		"filename": "1f17e-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ok"
		],
		"filename": "1f197",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"parking"
		],
		"filename": "1f17f-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"sos"
		],
		"filename": "1f198",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"up"
		],
		"filename": "1f199",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"vs"
		],
		"filename": "1f19a",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"koko"
		],
		"filename": "1f201",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"sa"
		],
		"filename": "1f202-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6708"
		],
		"filename": "1f237-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6709"
		],
		"filename": "1f236",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6307"
		],
		"filename": "1f22f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ideograph_advantage"
		],
		"filename": "1f250",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u5272"
		],
		"filename": "1f239",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7121"
		],
		"filename": "1f21a",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7981"
		],
		"filename": "1f232",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"accept"
		],
		"filename": "1f251",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7533"
		],
		"filename": "1f238",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u5408"
		],
		"filename": "1f234",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7a7a"
		],
		"filename": "1f233",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"congratulations"
		],
		"filename": "3297-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"secret"
		],
		"filename": "3299-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"u55b6"
		],
		"filename": "1f23a",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"u6e80"
		],
		"filename": "1f235",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"red_circle"
		],
		"filename": "1f534",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"orange_circle"
		],
		"filename": "1f7e0",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"yellow_circle"
		],
		"filename": "1f7e1",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"green_circle"
		],
		"filename": "1f7e2",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_blue_circle"
		],
		"filename": "1f535",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"purple_circle"
		],
		"filename": "1f7e3",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"brown_circle"
		],
		"filename": "1f7e4",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_circle"
		],
		"filename": "26ab",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_circle"
		],
		"filename": "26aa",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"red_square"
		],
		"filename": "1f7e5",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"orange_square"
		],
		"filename": "1f7e7",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"yellow_square"
		],
		"filename": "1f7e8",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"green_square"
		],
		"filename": "1f7e9",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"blue_square"
		],
		"filename": "1f7e6",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"purple_square"
		],
		"filename": "1f7ea",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"brown_square"
		],
		"filename": "1f7eb",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_large_square"
		],
		"filename": "2b1b",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_large_square"
		],
		"filename": "2b1c",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_medium_square"
		],
		"filename": "25fc-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_medium_square"
		],
		"filename": "25fb-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_medium_small_square"
		],
		"filename": "25fe",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_medium_small_square"
		],
		"filename": "25fd",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_small_square"
		],
		"filename": "25aa-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_small_square"
		],
		"filename": "25ab-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_orange_diamond"
		],
		"filename": "1f536",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_blue_diamond"
		],
		"filename": "1f537",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_orange_diamond"
		],
		"filename": "1f538",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_blue_diamond"
		],
		"filename": "1f539",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_red_triangle"
		],
		"filename": "1f53a",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_red_triangle_down"
		],
		"filename": "1f53b",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"diamond_shape_with_a_dot_inside"
		],
		"filename": "1f4a0",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"radio_button"
		],
		"filename": "1f518",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_square_button"
		],
		"filename": "1f533",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_square_button"
		],
		"filename": "1f532",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"checkered_flag"
		],
		"filename": "1f3c1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"triangular_flag_on_post"
		],
		"filename": "1f6a9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_flags"
		],
		"filename": "1f38c",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"black_flag"
		],
		"filename": "1f3f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"white_flag"
		],
		"filename": "1f3f3-fe0f",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"rainbow_flag"
		],
		"filename": "1f3f3-fe0f-200d-1f308",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"pirate_flag"
		],
		"filename": "1f3f4-200d-2620-fe0f",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"ascension_island"
		],
		"filename": "1f1e6-1f1e8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"andorra"
		],
		"filename": "1f1e6-1f1e9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"united_arab_emirates"
		],
		"filename": "1f1e6-1f1ea",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"afghanistan"
		],
		"filename": "1f1e6-1f1eb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"antigua_barbuda"
		],
		"filename": "1f1e6-1f1ec",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"anguilla"
		],
		"filename": "1f1e6-1f1ee",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"albania"
		],
		"filename": "1f1e6-1f1f1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"armenia"
		],
		"filename": "1f1e6-1f1f2",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"angola"
		],
		"filename": "1f1e6-1f1f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"antarctica"
		],
		"filename": "1f1e6-1f1f6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"argentina"
		],
		"filename": "1f1e6-1f1f7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"american_samoa"
		],
		"filename": "1f1e6-1f1f8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"austria"
		],
		"filename": "1f1e6-1f1f9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"australia"
		],
		"filename": "1f1e6-1f1fa",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"aruba"
		],
		"filename": "1f1e6-1f1fc",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"aland_islands"
		],
		"filename": "1f1e6-1f1fd",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"azerbaijan"
		],
		"filename": "1f1e6-1f1ff",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bosnia_herzegovina"
		],
		"filename": "1f1e7-1f1e6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"barbados"
		],
		"filename": "1f1e7-1f1e7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bangladesh"
		],
		"filename": "1f1e7-1f1e9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belgium"
		],
		"filename": "1f1e7-1f1ea",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"burkina_faso"
		],
		"filename": "1f1e7-1f1eb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bulgaria"
		],
		"filename": "1f1e7-1f1ec",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bahrain"
		],
		"filename": "1f1e7-1f1ed",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"burundi"
		],
		"filename": "1f1e7-1f1ee",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"benin"
		],
		"filename": "1f1e7-1f1ef",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"st_barthelemy"
		],
		"filename": "1f1e7-1f1f1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bermuda"
		],
		"filename": "1f1e7-1f1f2",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"brunei"
		],
		"filename": "1f1e7-1f1f3",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bolivia"
		],
		"filename": "1f1e7-1f1f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"caribbean_netherlands"
		],
		"filename": "1f1e7-1f1f6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"brazil"
		],
		"filename": "1f1e7-1f1f7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bahamas"
		],
		"filename": "1f1e7-1f1f8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bhutan"
		],
		"filename": "1f1e7-1f1f9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bouvet_island"
		],
		"filename": "1f1e7-1f1fb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"botswana"
		],
		"filename": "1f1e7-1f1fc",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belarus"
		],
		"filename": "1f1e7-1f1fe",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belize"
		],
		"filename": "1f1e7-1f1ff",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"canada",
			"ca"
		],
		"filename": "1f1e8-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cocos_islands"
		],
		"filename": "1f1e8-1f1e8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"congo_kinshasa"
		],
		"filename": "1f1e8-1f1e9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"central_african_republic"
		],
		"filename": "1f1e8-1f1eb",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"congo_brazzaville"
		],
		"filename": "1f1e8-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"switzerland"
		],
		"filename": "1f1e8-1f1ed",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cote_divoire"
		],
		"filename": "1f1e8-1f1ee",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cook_islands"
		],
		"filename": "1f1e8-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"chile"
		],
		"filename": "1f1e8-1f1f1",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cameroon"
		],
		"filename": "1f1e8-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cn"
		],
		"filename": "1f1e8-1f1f3",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"colombia"
		],
		"filename": "1f1e8-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"clipperton_island"
		],
		"filename": "1f1e8-1f1f5",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"costa_rica"
		],
		"filename": "1f1e8-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cuba"
		],
		"filename": "1f1e8-1f1fa",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cape_verde"
		],
		"filename": "1f1e8-1f1fb",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"curacao"
		],
		"filename": "1f1e8-1f1fc",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"christmas_island"
		],
		"filename": "1f1e8-1f1fd",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cyprus"
		],
		"filename": "1f1e8-1f1fe",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"czech_republic"
		],
		"filename": "1f1e8-1f1ff",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"de"
		],
		"filename": "1f1e9-1f1ea",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"diego_garcia"
		],
		"filename": "1f1e9-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"djibouti"
		],
		"filename": "1f1e9-1f1ef",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"denmark"
		],
		"filename": "1f1e9-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"dominica"
		],
		"filename": "1f1e9-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"dominican_republic"
		],
		"filename": "1f1e9-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"algeria"
		],
		"filename": "1f1e9-1f1ff",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ceuta_melilla"
		],
		"filename": "1f1ea-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ecuador"
		],
		"filename": "1f1ea-1f1e8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"estonia"
		],
		"filename": "1f1ea-1f1ea",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"egypt"
		],
		"filename": "1f1ea-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"western_sahara"
		],
		"filename": "1f1ea-1f1ed",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"eritrea"
		],
		"filename": "1f1ea-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"es"
		],
		"filename": "1f1ea-1f1f8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ethiopia"
		],
		"filename": "1f1ea-1f1f9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"eu",
			"european_union"
		],
		"filename": "1f1ea-1f1fa",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"finland"
		],
		"filename": "1f1eb-1f1ee",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"fiji"
		],
		"filename": "1f1eb-1f1ef",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"falkland_islands"
		],
		"filename": "1f1eb-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"micronesia"
		],
		"filename": "1f1eb-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"faroe_islands"
		],
		"filename": "1f1eb-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"fr"
		],
		"filename": "1f1eb-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"gabon"
		],
		"filename": "1f1ec-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"gb",
			"uk"
		],
		"filename": "1f1ec-1f1e7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"grenada"
		],
		"filename": "1f1ec-1f1e9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"georgia"
		],
		"filename": "1f1ec-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"french_guiana"
		],
		"filename": "1f1ec-1f1eb",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guernsey"
		],
		"filename": "1f1ec-1f1ec",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"ghana"
		],
		"filename": "1f1ec-1f1ed",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"gibraltar"
		],
		"filename": "1f1ec-1f1ee",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"greenland"
		],
		"filename": "1f1ec-1f1f1",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"gambia"
		],
		"filename": "1f1ec-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guinea"
		],
		"filename": "1f1ec-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guadeloupe"
		],
		"filename": "1f1ec-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"equatorial_guinea"
		],
		"filename": "1f1ec-1f1f6",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"greece"
		],
		"filename": "1f1ec-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"south_georgia_south_sandwich_islands"
		],
		"filename": "1f1ec-1f1f8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guatemala"
		],
		"filename": "1f1ec-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guam"
		],
		"filename": "1f1ec-1f1fa",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guinea_bissau"
		],
		"filename": "1f1ec-1f1fc",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guyana"
		],
		"filename": "1f1ec-1f1fe",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"hong_kong"
		],
		"filename": "1f1ed-1f1f0",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"heard_mcdonald_islands"
		],
		"filename": "1f1ed-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"honduras"
		],
		"filename": "1f1ed-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"croatia"
		],
		"filename": "1f1ed-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"haiti"
		],
		"filename": "1f1ed-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"hungary"
		],
		"filename": "1f1ed-1f1fa",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"canary_islands"
		],
		"filename": "1f1ee-1f1e8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"indonesia"
		],
		"filename": "1f1ee-1f1e9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"ireland"
		],
		"filename": "1f1ee-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"israel"
		],
		"filename": "1f1ee-1f1f1",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"isle_of_man"
		],
		"filename": "1f1ee-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"india"
		],
		"filename": "1f1ee-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"british_indian_ocean_territory"
		],
		"filename": "1f1ee-1f1f4",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iraq"
		],
		"filename": "1f1ee-1f1f6",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iran"
		],
		"filename": "1f1ee-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iceland"
		],
		"filename": "1f1ee-1f1f8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"it"
		],
		"filename": "1f1ee-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jersey"
		],
		"filename": "1f1ef-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jamaica"
		],
		"filename": "1f1ef-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jordan"
		],
		"filename": "1f1ef-1f1f4",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jp"
		],
		"filename": "1f1ef-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kenya"
		],
		"filename": "1f1f0-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kyrgyzstan"
		],
		"filename": "1f1f0-1f1ec",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"cambodia"
		],
		"filename": "1f1f0-1f1ed",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kiribati"
		],
		"filename": "1f1f0-1f1ee",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"comoros"
		],
		"filename": "1f1f0-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"st_kitts_nevis"
		],
		"filename": "1f1f0-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"north_korea"
		],
		"filename": "1f1f0-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kr"
		],
		"filename": "1f1f0-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kuwait"
		],
		"filename": "1f1f0-1f1fc",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"cayman_islands"
		],
		"filename": "1f1f0-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"kazakhstan"
		],
		"filename": "1f1f0-1f1ff",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"laos"
		],
		"filename": "1f1f1-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lebanon"
		],
		"filename": "1f1f1-1f1e7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"st_lucia"
		],
		"filename": "1f1f1-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"liechtenstein"
		],
		"filename": "1f1f1-1f1ee",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"sri_lanka"
		],
		"filename": "1f1f1-1f1f0",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"liberia"
		],
		"filename": "1f1f1-1f1f7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lesotho"
		],
		"filename": "1f1f1-1f1f8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lithuania"
		],
		"filename": "1f1f1-1f1f9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"luxembourg"
		],
		"filename": "1f1f1-1f1fa",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"latvia"
		],
		"filename": "1f1f1-1f1fb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"libya"
		],
		"filename": "1f1f1-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"morocco"
		],
		"filename": "1f1f2-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"monaco"
		],
		"filename": "1f1f2-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"moldova"
		],
		"filename": "1f1f2-1f1e9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"montenegro"
		],
		"filename": "1f1f2-1f1ea",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"st_martin"
		],
		"filename": "1f1f2-1f1eb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"madagascar"
		],
		"filename": "1f1f2-1f1ec",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"marshall_islands"
		],
		"filename": "1f1f2-1f1ed",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"macedonia"
		],
		"filename": "1f1f2-1f1f0",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mali"
		],
		"filename": "1f1f2-1f1f1",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"myanmar"
		],
		"filename": "1f1f2-1f1f2",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mongolia"
		],
		"filename": "1f1f2-1f1f3",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"macau"
		],
		"filename": "1f1f2-1f1f4",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"northern_mariana_islands"
		],
		"filename": "1f1f2-1f1f5",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"martinique"
		],
		"filename": "1f1f2-1f1f6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mauritania"
		],
		"filename": "1f1f2-1f1f7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"montserrat"
		],
		"filename": "1f1f2-1f1f8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malta"
		],
		"filename": "1f1f2-1f1f9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mauritius"
		],
		"filename": "1f1f2-1f1fa",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"maldives"
		],
		"filename": "1f1f2-1f1fb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malawi"
		],
		"filename": "1f1f2-1f1fc",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mexico"
		],
		"filename": "1f1f2-1f1fd",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malaysia"
		],
		"filename": "1f1f2-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mozambique"
		],
		"filename": "1f1f2-1f1ff",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"namibia"
		],
		"filename": "1f1f3-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"new_caledonia"
		],
		"filename": "1f1f3-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"niger"
		],
		"filename": "1f1f3-1f1ea",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"norfolk_island"
		],
		"filename": "1f1f3-1f1eb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nigeria"
		],
		"filename": "1f1f3-1f1ec",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nicaragua"
		],
		"filename": "1f1f3-1f1ee",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"netherlands"
		],
		"filename": "1f1f3-1f1f1",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"norway"
		],
		"filename": "1f1f3-1f1f4",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nepal"
		],
		"filename": "1f1f3-1f1f5",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"nauru"
		],
		"filename": "1f1f3-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"niue"
		],
		"filename": "1f1f3-1f1fa",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"new_zealand"
		],
		"filename": "1f1f3-1f1ff",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"oman"
		],
		"filename": "1f1f4-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"panama"
		],
		"filename": "1f1f5-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"peru"
		],
		"filename": "1f1f5-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"french_polynesia"
		],
		"filename": "1f1f5-1f1eb",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"papua_new_guinea"
		],
		"filename": "1f1f5-1f1ec",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"philippines"
		],
		"filename": "1f1f5-1f1ed",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"pakistan",
			"pk"
		],
		"filename": "1f1f5-1f1f0",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"poland"
		],
		"filename": "1f1f5-1f1f1",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"st_pierre_miquelon"
		],
		"filename": "1f1f5-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"pitcairn_islands"
		],
		"filename": "1f1f5-1f1f3",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"puerto_rico"
		],
		"filename": "1f1f5-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"palestinian_territories"
		],
		"filename": "1f1f5-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"portugal"
		],
		"filename": "1f1f5-1f1f9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"palau"
		],
		"filename": "1f1f5-1f1fc",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"paraguay"
		],
		"filename": "1f1f5-1f1fe",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"qatar"
		],
		"filename": "1f1f6-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"reunion"
		],
		"filename": "1f1f7-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"romania"
		],
		"filename": "1f1f7-1f1f4",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"serbia"
		],
		"filename": "1f1f7-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"ru"
		],
		"filename": "1f1f7-1f1fa",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"rwanda"
		],
		"filename": "1f1f7-1f1fc",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"saudi_arabia"
		],
		"filename": "1f1f8-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"solomon_islands"
		],
		"filename": "1f1f8-1f1e7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"seychelles"
		],
		"filename": "1f1f8-1f1e8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sudan"
		],
		"filename": "1f1f8-1f1e9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sweden"
		],
		"filename": "1f1f8-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"singapore"
		],
		"filename": "1f1f8-1f1ec",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"st_helena"
		],
		"filename": "1f1f8-1f1ed",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"slovenia"
		],
		"filename": "1f1f8-1f1ee",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"svalbard_jan_mayen"
		],
		"filename": "1f1f8-1f1ef",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"slovakia"
		],
		"filename": "1f1f8-1f1f0",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sierra_leone"
		],
		"filename": "1f1f8-1f1f1",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"san_marino"
		],
		"filename": "1f1f8-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"senegal"
		],
		"filename": "1f1f8-1f1f3",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"somalia"
		],
		"filename": "1f1f8-1f1f4",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"suriname"
		],
		"filename": "1f1f8-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"south_sudan"
		],
		"filename": "1f1f8-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sao_tome_principe"
		],
		"filename": "1f1f8-1f1f9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"el_salvador"
		],
		"filename": "1f1f8-1f1fb",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sint_maarten"
		],
		"filename": "1f1f8-1f1fd",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"syria"
		],
		"filename": "1f1f8-1f1fe",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"swaziland"
		],
		"filename": "1f1f8-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tristan_da_cunha"
		],
		"filename": "1f1f9-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"turks_caicos_islands"
		],
		"filename": "1f1f9-1f1e8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"chad"
		],
		"filename": "1f1f9-1f1e9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"french_southern_territories"
		],
		"filename": "1f1f9-1f1eb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"togo"
		],
		"filename": "1f1f9-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"thailand"
		],
		"filename": "1f1f9-1f1ed",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tajikistan"
		],
		"filename": "1f1f9-1f1ef",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tokelau"
		],
		"filename": "1f1f9-1f1f0",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"timor_leste"
		],
		"filename": "1f1f9-1f1f1",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"turkmenistan"
		],
		"filename": "1f1f9-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tunisia"
		],
		"filename": "1f1f9-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tonga"
		],
		"filename": "1f1f9-1f1f4",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tr"
		],
		"filename": "1f1f9-1f1f7",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"trinidad_tobago"
		],
		"filename": "1f1f9-1f1f9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tuvalu"
		],
		"filename": "1f1f9-1f1fb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"taiwan"
		],
		"filename": "1f1f9-1f1fc",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tanzania"
		],
		"filename": "1f1f9-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"ukraine"
		],
		"filename": "1f1fa-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uganda"
		],
		"filename": "1f1fa-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us_outlying_islands"
		],
		"filename": "1f1fa-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"united_nations"
		],
		"filename": "1f1fa-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us"
		],
		"filename": "1f1fa-1f1f8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uruguay"
		],
		"filename": "1f1fa-1f1fe",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uzbekistan"
		],
		"filename": "1f1fa-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vatican_city"
		],
		"filename": "1f1fb-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"st_vincent_grenadines"
		],
		"filename": "1f1fb-1f1e8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"venezuela"
		],
		"filename": "1f1fb-1f1ea",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"british_virgin_islands"
		],
		"filename": "1f1fb-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us_virgin_islands"
		],
		"filename": "1f1fb-1f1ee",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vietnam"
		],
		"filename": "1f1fb-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vanuatu"
		],
		"filename": "1f1fb-1f1fa",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"wallis_futuna"
		],
		"filename": "1f1fc-1f1eb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"samoa"
		],
		"filename": "1f1fc-1f1f8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"kosovo"
		],
		"filename": "1f1fd-1f1f0",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"yemen"
		],
		"filename": "1f1fe-1f1ea",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"mayotte"
		],
		"filename": "1f1fe-1f1f9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"south_africa",
			"za"
		],
		"filename": "1f1ff-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"zambia"
		],
		"filename": "1f1ff-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"zimbabwe"
		],
		"filename": "1f1ff-1f1fc",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"england"
		],
		"filename": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"scotland"
		],
		"filename": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"wales"
		],
		"filename": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"cordchat"
		],
		"filename": "cordchat",
		"category": "custom",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_light_skin_tone"
		],
		"filename": "1f44b-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_light_skin_tone"
		],
		"filename": "1f44b-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_skin_tone"
		],
		"filename": "1f44b-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_dark_skin_tone"
		],
		"filename": "1f44b-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_dark_skin_tone"
		],
		"filename": "1f44b-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_light_skin_tone"
		],
		"filename": "1f91a-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_light_skin_tone"
		],
		"filename": "1f91a-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_skin_tone"
		],
		"filename": "1f91a-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_dark_skin_tone"
		],
		"filename": "1f91a-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_dark_skin_tone"
		],
		"filename": "1f91a-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_light_skin_tone"
		],
		"filename": "1f590-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_light_skin_tone"
		],
		"filename": "1f590-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_skin_tone"
		],
		"filename": "1f590-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_dark_skin_tone"
		],
		"filename": "1f590-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_dark_skin_tone"
		],
		"filename": "1f590-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_light_skin_tone"
		],
		"filename": "270b-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_light_skin_tone"
		],
		"filename": "270b-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_skin_tone"
		],
		"filename": "270b-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_dark_skin_tone"
		],
		"filename": "270b-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_dark_skin_tone"
		],
		"filename": "270b-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_light_skin_tone"
		],
		"filename": "1f596-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_light_skin_tone"
		],
		"filename": "1f596-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_skin_tone"
		],
		"filename": "1f596-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_dark_skin_tone"
		],
		"filename": "1f596-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_dark_skin_tone"
		],
		"filename": "1f596-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_light_skin_tone"
		],
		"filename": "1f44c-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_light_skin_tone"
		],
		"filename": "1f44c-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_skin_tone"
		],
		"filename": "1f44c-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_dark_skin_tone"
		],
		"filename": "1f44c-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_dark_skin_tone"
		],
		"filename": "1f44c-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_light_skin_tone"
		],
		"filename": "1f90f-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_light_skin_tone"
		],
		"filename": "1f90f-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_skin_tone"
		],
		"filename": "1f90f-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_dark_skin_tone"
		],
		"filename": "1f90f-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_dark_skin_tone"
		],
		"filename": "1f90f-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_light_skin_tone"
		],
		"filename": "270c-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_light_skin_tone"
		],
		"filename": "270c-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_skin_tone"
		],
		"filename": "270c-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_dark_skin_tone"
		],
		"filename": "270c-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_dark_skin_tone"
		],
		"filename": "270c-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_light_skin_tone"
		],
		"filename": "1f91e-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_light_skin_tone"
		],
		"filename": "1f91e-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_skin_tone"
		],
		"filename": "1f91e-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_dark_skin_tone"
		],
		"filename": "1f91e-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_dark_skin_tone"
		],
		"filename": "1f91e-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_light_skin_tone"
		],
		"filename": "1f91f-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_light_skin_tone"
		],
		"filename": "1f91f-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_skin_tone"
		],
		"filename": "1f91f-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_dark_skin_tone"
		],
		"filename": "1f91f-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_dark_skin_tone"
		],
		"filename": "1f91f-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"metal_light_skin_tone"
		],
		"filename": "1f918-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_light_skin_tone"
		],
		"filename": "1f918-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_skin_tone"
		],
		"filename": "1f918-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_dark_skin_tone"
		],
		"filename": "1f918-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_dark_skin_tone"
		],
		"filename": "1f918-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_light_skin_tone"
		],
		"filename": "1f919-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_light_skin_tone"
		],
		"filename": "1f919-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_skin_tone"
		],
		"filename": "1f919-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_dark_skin_tone"
		],
		"filename": "1f919-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_dark_skin_tone"
		],
		"filename": "1f919-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_light_skin_tone"
		],
		"filename": "1f448-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_light_skin_tone"
		],
		"filename": "1f448-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_skin_tone"
		],
		"filename": "1f448-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_dark_skin_tone"
		],
		"filename": "1f448-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_dark_skin_tone"
		],
		"filename": "1f448-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_light_skin_tone"
		],
		"filename": "1f449-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_light_skin_tone"
		],
		"filename": "1f449-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_skin_tone"
		],
		"filename": "1f449-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_dark_skin_tone"
		],
		"filename": "1f449-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_dark_skin_tone"
		],
		"filename": "1f449-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_light_skin_tone"
		],
		"filename": "1f446-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_light_skin_tone"
		],
		"filename": "1f446-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_skin_tone"
		],
		"filename": "1f446-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_dark_skin_tone"
		],
		"filename": "1f446-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_dark_skin_tone"
		],
		"filename": "1f446-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_light_skin_tone"
		],
		"filename": "1f595-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_light_skin_tone"
		],
		"filename": "1f595-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_skin_tone"
		],
		"filename": "1f595-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_dark_skin_tone"
		],
		"filename": "1f595-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_dark_skin_tone"
		],
		"filename": "1f595-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_light_skin_tone"
		],
		"filename": "1f447-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_light_skin_tone"
		],
		"filename": "1f447-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_skin_tone"
		],
		"filename": "1f447-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_dark_skin_tone"
		],
		"filename": "1f447-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_dark_skin_tone"
		],
		"filename": "1f447-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_light_skin_tone"
		],
		"filename": "261d-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_light_skin_tone"
		],
		"filename": "261d-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_skin_tone"
		],
		"filename": "261d-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_dark_skin_tone"
		],
		"filename": "261d-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_dark_skin_tone"
		],
		"filename": "261d-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_light_skin_tone"
		],
		"filename": "1f44d-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_light_skin_tone"
		],
		"filename": "1f44d-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_skin_tone"
		],
		"filename": "1f44d-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_dark_skin_tone"
		],
		"filename": "1f44d-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_dark_skin_tone"
		],
		"filename": "1f44d-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"-1_light_skin_tone"
		],
		"filename": "1f44e-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_light_skin_tone"
		],
		"filename": "1f44e-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_skin_tone"
		],
		"filename": "1f44e-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_dark_skin_tone"
		],
		"filename": "1f44e-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_dark_skin_tone"
		],
		"filename": "1f44e-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_light_skin_tone"
		],
		"filename": "270a-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_light_skin_tone"
		],
		"filename": "270a-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_skin_tone"
		],
		"filename": "270a-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_dark_skin_tone"
		],
		"filename": "270a-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_dark_skin_tone"
		],
		"filename": "270a-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_light_skin_tone"
		],
		"filename": "1f44a-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_light_skin_tone"
		],
		"filename": "1f44a-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_skin_tone"
		],
		"filename": "1f44a-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_dark_skin_tone"
		],
		"filename": "1f44a-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_dark_skin_tone"
		],
		"filename": "1f44a-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_light_skin_tone"
		],
		"filename": "1f91b-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_light_skin_tone"
		],
		"filename": "1f91b-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_skin_tone"
		],
		"filename": "1f91b-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_dark_skin_tone"
		],
		"filename": "1f91b-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_dark_skin_tone"
		],
		"filename": "1f91b-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_light_skin_tone"
		],
		"filename": "1f91c-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_light_skin_tone"
		],
		"filename": "1f91c-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_skin_tone"
		],
		"filename": "1f91c-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_dark_skin_tone"
		],
		"filename": "1f91c-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_dark_skin_tone"
		],
		"filename": "1f91c-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_light_skin_tone"
		],
		"filename": "1f44f-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_light_skin_tone"
		],
		"filename": "1f44f-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_skin_tone"
		],
		"filename": "1f44f-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_dark_skin_tone"
		],
		"filename": "1f44f-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_dark_skin_tone"
		],
		"filename": "1f44f-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_light_skin_tone"
		],
		"filename": "1f64c-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_light_skin_tone"
		],
		"filename": "1f64c-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_skin_tone"
		],
		"filename": "1f64c-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_dark_skin_tone"
		],
		"filename": "1f64c-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_dark_skin_tone"
		],
		"filename": "1f64c-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_light_skin_tone"
		],
		"filename": "1f450-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_light_skin_tone"
		],
		"filename": "1f450-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_skin_tone"
		],
		"filename": "1f450-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_dark_skin_tone"
		],
		"filename": "1f450-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_dark_skin_tone"
		],
		"filename": "1f450-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_light_skin_tone"
		],
		"filename": "1f932-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_light_skin_tone"
		],
		"filename": "1f932-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_skin_tone"
		],
		"filename": "1f932-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_dark_skin_tone"
		],
		"filename": "1f932-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_dark_skin_tone"
		],
		"filename": "1f932-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"pray_light_skin_tone"
		],
		"filename": "1f64f-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_light_skin_tone"
		],
		"filename": "1f64f-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_skin_tone"
		],
		"filename": "1f64f-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_dark_skin_tone"
		],
		"filename": "1f64f-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_dark_skin_tone"
		],
		"filename": "1f64f-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_light_skin_tone"
		],
		"filename": "270d-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_light_skin_tone"
		],
		"filename": "270d-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_skin_tone"
		],
		"filename": "270d-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_dark_skin_tone"
		],
		"filename": "270d-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_dark_skin_tone"
		],
		"filename": "270d-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_light_skin_tone"
		],
		"filename": "1f485-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_light_skin_tone"
		],
		"filename": "1f485-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_skin_tone"
		],
		"filename": "1f485-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_dark_skin_tone"
		],
		"filename": "1f485-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_dark_skin_tone"
		],
		"filename": "1f485-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_light_skin_tone"
		],
		"filename": "1f933-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_light_skin_tone"
		],
		"filename": "1f933-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_skin_tone"
		],
		"filename": "1f933-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_dark_skin_tone"
		],
		"filename": "1f933-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_dark_skin_tone"
		],
		"filename": "1f933-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_light_skin_tone"
		],
		"filename": "1f4aa-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_light_skin_tone"
		],
		"filename": "1f4aa-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_skin_tone"
		],
		"filename": "1f4aa-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_dark_skin_tone"
		],
		"filename": "1f4aa-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_dark_skin_tone"
		],
		"filename": "1f4aa-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_light_skin_tone"
		],
		"filename": "1f9b5-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_light_skin_tone"
		],
		"filename": "1f9b5-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_skin_tone"
		],
		"filename": "1f9b5-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_dark_skin_tone"
		],
		"filename": "1f9b5-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_dark_skin_tone"
		],
		"filename": "1f9b5-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_light_skin_tone"
		],
		"filename": "1f9b6-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_light_skin_tone"
		],
		"filename": "1f9b6-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_skin_tone"
		],
		"filename": "1f9b6-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_dark_skin_tone"
		],
		"filename": "1f9b6-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_dark_skin_tone"
		],
		"filename": "1f9b6-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_light_skin_tone"
		],
		"filename": "1f442-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_light_skin_tone"
		],
		"filename": "1f442-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_skin_tone"
		],
		"filename": "1f442-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_dark_skin_tone"
		],
		"filename": "1f442-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_dark_skin_tone"
		],
		"filename": "1f442-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_light_skin_tone"
		],
		"filename": "1f9bb-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_light_skin_tone"
		],
		"filename": "1f9bb-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_skin_tone"
		],
		"filename": "1f9bb-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_dark_skin_tone"
		],
		"filename": "1f9bb-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_dark_skin_tone"
		],
		"filename": "1f9bb-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"nose_light_skin_tone"
		],
		"filename": "1f443-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_light_skin_tone"
		],
		"filename": "1f443-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_skin_tone"
		],
		"filename": "1f443-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_dark_skin_tone"
		],
		"filename": "1f443-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_dark_skin_tone"
		],
		"filename": "1f443-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"baby_light_skin_tone"
		],
		"filename": "1f476-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_light_skin_tone"
		],
		"filename": "1f476-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_skin_tone"
		],
		"filename": "1f476-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_dark_skin_tone"
		],
		"filename": "1f476-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_dark_skin_tone"
		],
		"filename": "1f476-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_light_skin_tone"
		],
		"filename": "1f9d2-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_light_skin_tone"
		],
		"filename": "1f9d2-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_skin_tone"
		],
		"filename": "1f9d2-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_dark_skin_tone"
		],
		"filename": "1f9d2-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_dark_skin_tone"
		],
		"filename": "1f9d2-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_light_skin_tone"
		],
		"filename": "1f466-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_light_skin_tone"
		],
		"filename": "1f466-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_skin_tone"
		],
		"filename": "1f466-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_dark_skin_tone"
		],
		"filename": "1f466-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_dark_skin_tone"
		],
		"filename": "1f466-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_light_skin_tone"
		],
		"filename": "1f467-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_light_skin_tone"
		],
		"filename": "1f467-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_skin_tone"
		],
		"filename": "1f467-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_dark_skin_tone"
		],
		"filename": "1f467-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_dark_skin_tone"
		],
		"filename": "1f467-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_light_skin_tone"
		],
		"filename": "1f471-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_skin_tone"
		],
		"filename": "1f471-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_dark_skin_tone"
		],
		"filename": "1f471-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_light_skin_tone"
		],
		"filename": "1f468-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_light_skin_tone"
		],
		"filename": "1f9d4-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_light_skin_tone"
		],
		"filename": "1f9d4-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_skin_tone"
		],
		"filename": "1f9d4-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_dark_skin_tone"
		],
		"filename": "1f9d4-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_dark_skin_tone"
		],
		"filename": "1f9d4-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"red_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_light_skin_tone"
		],
		"filename": "1f9d3-1f3fb",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_light_skin_tone"
		],
		"filename": "1f9d3-1f3fc",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_skin_tone"
		],
		"filename": "1f9d3-1f3fd",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_dark_skin_tone"
		],
		"filename": "1f9d3-1f3fe",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_dark_skin_tone"
		],
		"filename": "1f9d3-1f3ff",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_light_skin_tone"
		],
		"filename": "1f474-1f3fb",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_light_skin_tone"
		],
		"filename": "1f474-1f3fc",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_skin_tone"
		],
		"filename": "1f474-1f3fd",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_dark_skin_tone"
		],
		"filename": "1f474-1f3fe",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_dark_skin_tone"
		],
		"filename": "1f474-1f3ff",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_woman_light_skin_tone"
		],
		"filename": "1f475-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_light_skin_tone"
		],
		"filename": "1f475-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_skin_tone"
		],
		"filename": "1f475-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_dark_skin_tone"
		],
		"filename": "1f475-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_dark_skin_tone"
		],
		"filename": "1f475-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_light_skin_tone"
		],
		"filename": "1f64d-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_light_skin_tone"
		],
		"filename": "1f64d-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_light_skin_tone"
		],
		"filename": "1f64d-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_light_skin_tone"
		],
		"filename": "1f64e-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_light_skin_tone"
		],
		"filename": "1f64e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_woman_light_skin_tone"
		],
		"filename": "1f64e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_light_skin_tone"
		],
		"filename": "1f645-1f3fb",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_skin_tone"
		],
		"filename": "1f645-1f3fd",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_dark_skin_tone"
		],
		"filename": "1f645-1f3ff",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_light_skin_tone"
		],
		"filename": "1f645-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_skin_tone"
		],
		"filename": "1f645-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_dark_skin_tone"
		],
		"filename": "1f645-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_light_skin_tone"
		],
		"filename": "1f645-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_skin_tone"
		],
		"filename": "1f645-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_dark_skin_tone"
		],
		"filename": "1f645-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_light_skin_tone"
		],
		"filename": "1f646-1f3fb",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_skin_tone"
		],
		"filename": "1f646-1f3fd",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_dark_skin_tone"
		],
		"filename": "1f646-1f3ff",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_man_light_skin_tone"
		],
		"filename": "1f646-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_skin_tone"
		],
		"filename": "1f646-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_dark_skin_tone"
		],
		"filename": "1f646-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_light_skin_tone"
		],
		"filename": "1f646-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_skin_tone"
		],
		"filename": "1f646-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_dark_skin_tone"
		],
		"filename": "1f646-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_light_skin_tone"
		],
		"filename": "1f481-1f3fb",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_skin_tone"
		],
		"filename": "1f481-1f3fd",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_dark_skin_tone"
		],
		"filename": "1f481-1f3ff",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_light_skin_tone"
		],
		"filename": "1f481-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_skin_tone"
		],
		"filename": "1f481-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_dark_skin_tone"
		],
		"filename": "1f481-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_light_skin_tone"
		],
		"filename": "1f481-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_skin_tone"
		],
		"filename": "1f481-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_dark_skin_tone"
		],
		"filename": "1f481-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_light_skin_tone"
		],
		"filename": "1f64b-1f3fb",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_man_light_skin_tone"
		],
		"filename": "1f64b-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_light_skin_tone"
		],
		"filename": "1f64b-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"deaf_person_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"bow_light_skin_tone"
		],
		"filename": "1f647-1f3fb",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_skin_tone"
		],
		"filename": "1f647-1f3fd",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_dark_skin_tone"
		],
		"filename": "1f647-1f3ff",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_light_skin_tone"
		],
		"filename": "1f647-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_skin_tone"
		],
		"filename": "1f647-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_dark_skin_tone"
		],
		"filename": "1f647-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_light_skin_tone"
		],
		"filename": "1f647-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_skin_tone"
		],
		"filename": "1f647-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_dark_skin_tone"
		],
		"filename": "1f647-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"facepalm_light_skin_tone"
		],
		"filename": "1f926-1f3fb",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_skin_tone"
		],
		"filename": "1f926-1f3fd",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_dark_skin_tone"
		],
		"filename": "1f926-1f3ff",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_light_skin_tone"
		],
		"filename": "1f926-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_skin_tone"
		],
		"filename": "1f926-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_dark_skin_tone"
		],
		"filename": "1f926-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_light_skin_tone"
		],
		"filename": "1f926-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_skin_tone"
		],
		"filename": "1f926-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_dark_skin_tone"
		],
		"filename": "1f926-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_light_skin_tone"
		],
		"filename": "1f937-1f3fb",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_skin_tone"
		],
		"filename": "1f937-1f3fd",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_dark_skin_tone"
		],
		"filename": "1f937-1f3ff",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_light_skin_tone"
		],
		"filename": "1f937-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_skin_tone"
		],
		"filename": "1f937-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_dark_skin_tone"
		],
		"filename": "1f937-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_shrugging_light_skin_tone"
		],
		"filename": "1f937-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_skin_tone"
		],
		"filename": "1f937-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_dark_skin_tone"
		],
		"filename": "1f937-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_teacher_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_cook_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_office_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_singer_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_astronaut_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_light_skin_tone"
		],
		"filename": "1f46e-1f3fb",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_light_skin_tone"
		],
		"filename": "1f46e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_light_skin_tone"
		],
		"filename": "1f46e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_light_skin_tone"
		],
		"filename": "1f482-1f3fb",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_skin_tone"
		],
		"filename": "1f482-1f3fd",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_dark_skin_tone"
		],
		"filename": "1f482-1f3ff",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_light_skin_tone"
		],
		"filename": "1f482-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_skin_tone"
		],
		"filename": "1f482-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_dark_skin_tone"
		],
		"filename": "1f482-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardswoman_light_skin_tone"
		],
		"filename": "1f482-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_skin_tone"
		],
		"filename": "1f482-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_dark_skin_tone"
		],
		"filename": "1f482-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_light_skin_tone"
		],
		"filename": "1f477-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_skin_tone"
		],
		"filename": "1f477-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_dark_skin_tone"
		],
		"filename": "1f477-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_light_skin_tone"
		],
		"filename": "1f477-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_skin_tone"
		],
		"filename": "1f477-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_dark_skin_tone"
		],
		"filename": "1f477-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_light_skin_tone"
		],
		"filename": "1f477-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_skin_tone"
		],
		"filename": "1f477-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_dark_skin_tone"
		],
		"filename": "1f477-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_light_skin_tone"
		],
		"filename": "1f934-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_light_skin_tone"
		],
		"filename": "1f934-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_skin_tone"
		],
		"filename": "1f934-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_dark_skin_tone"
		],
		"filename": "1f934-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_dark_skin_tone"
		],
		"filename": "1f934-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_light_skin_tone"
		],
		"filename": "1f478-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_light_skin_tone"
		],
		"filename": "1f478-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_skin_tone"
		],
		"filename": "1f478-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_dark_skin_tone"
		],
		"filename": "1f478-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_dark_skin_tone"
		],
		"filename": "1f478-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"man_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_light_skin_tone"
		],
		"filename": "1f472-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_light_skin_tone"
		],
		"filename": "1f472-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_skin_tone"
		],
		"filename": "1f472-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_dark_skin_tone"
		],
		"filename": "1f472-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_dark_skin_tone"
		],
		"filename": "1f472-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_light_skin_tone"
		],
		"filename": "1f9d5-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_light_skin_tone"
		],
		"filename": "1f9d5-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_skin_tone"
		],
		"filename": "1f9d5-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_dark_skin_tone"
		],
		"filename": "1f9d5-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_dark_skin_tone"
		],
		"filename": "1f9d5-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_light_skin_tone"
		],
		"filename": "1f935-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_light_skin_tone"
		],
		"filename": "1f935-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_skin_tone"
		],
		"filename": "1f935-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_dark_skin_tone"
		],
		"filename": "1f935-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_dark_skin_tone"
		],
		"filename": "1f935-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_light_skin_tone"
		],
		"filename": "1f470-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_light_skin_tone"
		],
		"filename": "1f470-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_skin_tone"
		],
		"filename": "1f470-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_dark_skin_tone"
		],
		"filename": "1f470-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_dark_skin_tone"
		],
		"filename": "1f470-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_light_skin_tone"
		],
		"filename": "1f930-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_light_skin_tone"
		],
		"filename": "1f930-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_skin_tone"
		],
		"filename": "1f930-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_dark_skin_tone"
		],
		"filename": "1f930-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_dark_skin_tone"
		],
		"filename": "1f930-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"breast_feeding_light_skin_tone"
		],
		"filename": "1f931-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_light_skin_tone"
		],
		"filename": "1f931-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_skin_tone"
		],
		"filename": "1f931-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_dark_skin_tone"
		],
		"filename": "1f931-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_dark_skin_tone"
		],
		"filename": "1f931-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_light_skin_tone"
		],
		"filename": "1f47c-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_light_skin_tone"
		],
		"filename": "1f47c-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_skin_tone"
		],
		"filename": "1f47c-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_dark_skin_tone"
		],
		"filename": "1f47c-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_dark_skin_tone"
		],
		"filename": "1f47c-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_light_skin_tone"
		],
		"filename": "1f385-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_light_skin_tone"
		],
		"filename": "1f385-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_skin_tone"
		],
		"filename": "1f385-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_dark_skin_tone"
		],
		"filename": "1f385-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_dark_skin_tone"
		],
		"filename": "1f385-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_light_skin_tone"
		],
		"filename": "1f936-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_light_skin_tone"
		],
		"filename": "1f936-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_skin_tone"
		],
		"filename": "1f936-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_dark_skin_tone"
		],
		"filename": "1f936-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_dark_skin_tone"
		],
		"filename": "1f936-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"supervillain_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_woman_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_light_skin_tone"
		],
		"filename": "1f9da-1f3fb",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_light_skin_tone"
		],
		"filename": "1f9da-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_light_skin_tone"
		],
		"filename": "1f9da-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_light_skin_tone"
		],
		"filename": "1f9db-1f3fb",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_light_skin_tone"
		],
		"filename": "1f9db-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_woman_light_skin_tone"
		],
		"filename": "1f9db-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_man_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_light_skin_tone"
		],
		"filename": "1f486-1f3fb",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_skin_tone"
		],
		"filename": "1f486-1f3fd",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_dark_skin_tone"
		],
		"filename": "1f486-1f3ff",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_light_skin_tone"
		],
		"filename": "1f486-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_skin_tone"
		],
		"filename": "1f486-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_dark_skin_tone"
		],
		"filename": "1f486-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_light_skin_tone"
		],
		"filename": "1f486-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_skin_tone"
		],
		"filename": "1f486-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_dark_skin_tone"
		],
		"filename": "1f486-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_light_skin_tone"
		],
		"filename": "1f487-1f3fb",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_skin_tone"
		],
		"filename": "1f487-1f3fd",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_dark_skin_tone"
		],
		"filename": "1f487-1f3ff",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_man_light_skin_tone"
		],
		"filename": "1f487-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_skin_tone"
		],
		"filename": "1f487-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_dark_skin_tone"
		],
		"filename": "1f487-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_light_skin_tone"
		],
		"filename": "1f487-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_skin_tone"
		],
		"filename": "1f487-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_dark_skin_tone"
		],
		"filename": "1f487-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_dark_skin_tone"
		],
		"filename": "1f6b6-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_dark_skin_tone"
		],
		"filename": "1f6b6-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"person_with_probing_cane_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"runner_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_light_skin_tone"
		],
		"filename": "1f483-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_light_skin_tone"
		],
		"filename": "1f483-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_skin_tone"
		],
		"filename": "1f483-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_dark_skin_tone"
		],
		"filename": "1f483-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_dark_skin_tone"
		],
		"filename": "1f483-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_light_skin_tone"
		],
		"filename": "1f57a-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_light_skin_tone"
		],
		"filename": "1f57a-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_skin_tone"
		],
		"filename": "1f57a-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_dark_skin_tone"
		],
		"filename": "1f57a-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_dark_skin_tone"
		],
		"filename": "1f57a-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_light_skin_tone"
		],
		"filename": "1f574-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_light_skin_tone"
		],
		"filename": "1f574-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_skin_tone"
		],
		"filename": "1f574-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_dark_skin_tone"
		],
		"filename": "1f574-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_dark_skin_tone"
		],
		"filename": "1f574-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_man_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"horse_racing_light_skin_tone"
		],
		"filename": "1f3c7-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_light_skin_tone"
		],
		"filename": "1f3c7-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_skin_tone"
		],
		"filename": "1f3c7-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_dark_skin_tone"
		],
		"filename": "1f3c7-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_dark_skin_tone"
		],
		"filename": "1f3c7-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_woman_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimming_man_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_light_skin_tone"
		],
		"filename": "26f9-1f3fb",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_skin_tone"
		],
		"filename": "26f9-1f3fd",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_dark_skin_tone"
		],
		"filename": "26f9-1f3ff",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_light_skin_tone"
		],
		"filename": "26f9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_skin_tone"
		],
		"filename": "26f9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_dark_skin_tone"
		],
		"filename": "26f9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_light_skin_tone"
		],
		"filename": "26f9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_skin_tone"
		],
		"filename": "26f9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_dark_skin_tone"
		],
		"filename": "26f9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_man_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"mountain_bicyclist_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"woman_cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_light_skin_tone"
		],
		"filename": "1f93e-1f3fb",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_light_skin_tone"
		],
		"filename": "1f93e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_handball_light_skin_tone"
		],
		"filename": "1f93e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_light_skin_tone"
		],
		"filename": "1f939-1f3fb",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_skin_tone"
		],
		"filename": "1f939-1f3fd",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_dark_skin_tone"
		],
		"filename": "1f939-1f3ff",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_light_skin_tone"
		],
		"filename": "1f939-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_skin_tone"
		],
		"filename": "1f939-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_dark_skin_tone"
		],
		"filename": "1f939-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_light_skin_tone"
		],
		"filename": "1f939-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_skin_tone"
		],
		"filename": "1f939-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_dark_skin_tone"
		],
		"filename": "1f939-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_man_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_light_skin_tone"
		],
		"filename": "1f6c0-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_light_skin_tone"
		],
		"filename": "1f6c0-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_skin_tone"
		],
		"filename": "1f6c0-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_dark_skin_tone"
		],
		"filename": "1f6c0-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_dark_skin_tone"
		],
		"filename": "1f6c0-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone"
		],
		"filename": "1f46d-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46d-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone"
		],
		"filename": "1f46d-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46d-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone"
		],
		"filename": "1f46d-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone"
		],
		"filename": "1f46b-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46b-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone"
		],
		"filename": "1f46b-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46b-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone"
		],
		"filename": "1f46b-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone"
		],
		"filename": "1f46c-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46c-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone"
		],
		"filename": "1f46c-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46c-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone"
		],
		"filename": "1f46c-1f3ff",
		"category": "skintone",
		"batch": "38"
	}
];

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = {
	"about.close": "Close",
	"about.copyright": "Copyright 2015 - {currentYear} Multiable Company. All rights reserved",
	"about.database": "Database:",
	"about.date": "Build Date:",
	"about.enterpriseEditionLearn": "Learn more about Enterprise Edition at ",
	"about.enterpriseEditionSt": "Secured communication tools for serious discussion with no mix up!!!",
	"about.enterpriseEditione1": "Enterprise Edition",
	"about.hash": "Build Hash:",
	"about.hashee": "EE Build Hash:",
	"about.licensed": "Licensed to:",
	"about.number": "Build Number:",
	"about.teamEditionLearn": "Join the Cordchat community at ",
	"about.teamEditionSt": "All your team communication in one place, instantly searchable and accessible anywhere.",
	"about.teamEditiont0": "Team Edition",
	"about.teamEditiont1": "Enterprise Edition",
	"about.title": "About Cordchat",
	"about.version": "Version:",
	"access_history.title": "Access History",
	"activity_log.activeSessions": "Active Sessions",
	"activity_log.browser": "Browser: {browser}",
	"activity_log.firstTime": "First time active: {date}, {time}",
	"activity_log.lastActivity": "Last activity: {date}, {time}",
	"activity_log.logout": "Logout",
	"activity_log.moreInfo": "More info",
	"activity_log.os": "OS: {os}",
	"activity_log.sessionId": "Session ID: {id}",
	"activity_log.sessionsDescription": "Sessions are created when you log in to a new browser on a device. Sessions let you use Cordchat without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the 'Logout' button below to end a session.",
	"activity_log_modal.android": "Android",
	"activity_log_modal.androidNativeApp": "Android Native App",
	"activity_log_modal.desktop": "Native Desktop App",
	"activity_log_modal.iphoneNativeApp": "iPhone Native App",
	"add_command.autocomplete": "Autocomplete",
	"add_command.autocomplete.help": "(Optional) Show slash command in autocomplete list.",
	"add_command.autocompleteDescription": "Autocomplete Description",
	"add_command.autocompleteDescription.help": "(Optional) Short description of slash command for the autocomplete list.",
	"add_command.autocompleteDescription.placeholder": "Example: \"Returns search results for patient records\"",
	"add_command.autocompleteHint": "Autocomplete Hint",
	"add_command.autocompleteHint.help": "(Optional) Arguments associated with your slash command, displayed as help in the autocomplete list.",
	"add_command.autocompleteHint.placeholder": "Example: [Patient Name]",
	"add_command.cancel": "Cancel",
	"add_command.description": "Description",
	"add_command.description.help": "Description for your incoming webhook.",
	"add_command.displayName": "Display Name",
	"add_command.displayName.help": "Display name for your slash command made of up to 64 characters.",
	"add_command.doneHelp": "Your slash command has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Cordchat team .",
	"add_command.iconUrl": "Response Icon",
	"add_command.iconUrl.help": "(Optional) Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.",
	"add_command.iconUrl.placeholder": "https://www.example.com/myicon.png",
	"add_command.method": "Request Method",
	"add_command.method.get": "GET",
	"add_command.method.help": "The type of command request issued to the Request URL.",
	"add_command.method.post": "POST",
	"add_command.save": "Save",
	"add_command.token": "<b>Token</b>: {token}",
	"add_command.trigger": "Command Trigger Word",
	"add_command.trigger.help": "Trigger word must be unique, and cannot begin with a slash or contain any spaces.",
	"add_command.trigger.helpExamples": "Examples: client, employee, patient, weather",
	"add_command.trigger.helpReserved": "Reserved: {link}",
	"add_command.trigger.helpReservedLinkText": "see list of built-in slash commands",
	"add_command.trigger.placeholder": "Command trigger e.g. \"hello\"",
	"add_command.triggerInvalidLength": "A trigger word must contain between {min} and {max} characters",
	"add_command.triggerInvalidSlash": "A trigger word cannot begin with a /",
	"add_command.triggerInvalidSpace": "A trigger word must not contain spaces",
	"add_command.triggerRequired": "A trigger word is required",
	"add_command.url": "Request URL",
	"add_command.url.help": "The callback URL to receive the HTTP POST or GET event request when the slash command is run.",
	"add_command.url.placeholder": "Must start with http:// or https://",
	"add_command.urlRequired": "A request URL is required",
	"add_command.username": "Response Username",
	"add_command.username.help": "(Optional) Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and they symbols \"-\", \"_\", and \".\" .",
	"add_command.username.placeholder": "Username",
	"add_emoji.cancel": "Cancel",
	"add_emoji.header": "Add",
	"add_emoji.image": "Image",
	"add_emoji.image.button": "Select",
	"add_emoji.image.help": "Choose the image for your emoji. The image can be a gif, png, or jpeg file with a max size of 1 MB. Dimensions will automatically resize to fit 128 by 128 pixels but keeping aspect ratio.",
	"add_emoji.imageRequired": "An image is required for the emoji",
	"add_emoji.name": "Name",
	"add_emoji.name.help": "Choose a name for your emoji made of up to 64 characters consisting of lowercase letters, numbers, and the symbols '-' and '_'.",
	"add_emoji.nameInvalid": "An emoji's name can only contain numbers, letters, and the symbols '-' and '_'.",
	"add_emoji.nameRequired": "A name is required for the emoji",
	"add_emoji.nameTaken": "This name is already in use by a system emoji. Please choose another name.",
	"add_emoji.preview": "Preview",
	"add_emoji.preview.sentence": "This is a sentence with {image} in it.",
	"add_emoji.save": "Save",
	"add_incoming_webhook.cancel": "Cancel",
	"add_incoming_webhook.channel": "Channel",
	"add_incoming_webhook.channel.help": "Public or private channel that receives the webhook payloads. You must belong to the private channel when setting up the webhook.",
	"add_incoming_webhook.channelRequired": "A valid channel is required",
	"add_incoming_webhook.description": "Description",
	"add_incoming_webhook.description.help": "Description for your incoming webhook.",
	"add_incoming_webhook.displayName": "Display Name",
	"add_incoming_webhook.displayName.help": "Display name for your incoming webhook made of up to 64 characters.",
	"add_incoming_webhook.doneHelp": "Your incoming webhook has been set up. Please send data to the following URL.",
	"add_incoming_webhook.name": "Name",
	"add_incoming_webhook.save": "Save",
	"add_incoming_webhook.url": "<b>URL</b>: {url}",
	"add_oauth_app.callbackUrls.help": "The redirect URIs to which the service will redirect users after accepting or denying authorization of your application, and which will handle authorization codes or access tokens. Must be a valid URL and start with http:// or https://.",
	"add_oauth_app.callbackUrlsRequired": "One or more callback URLs are required",
	"add_oauth_app.clientId": "<b>Client ID</b>: {id}",
	"add_oauth_app.clientSecret": "<b>Client Secret</b>: {secret}",
	"add_oauth_app.description.help": "Description for your OAuth 2.0 application.",
	"add_oauth_app.descriptionRequired": "Description for the OAuth 2.0 application is required.",
	"add_oauth_app.doneHelp": "Your OAuth 2.0 application has been set up. Please use the following Client ID and Client Secret when requesting authorization for your application.",
	"add_oauth_app.doneUrlHelp": "The following are your authorized redirect URL(s).",
	"add_oauth_app.header": "Add",
	"add_oauth_app.homepage.help": "The URL for the homepage of the OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"add_oauth_app.homepageRequired": "Homepage for the OAuth 2.0 application is required.",
	"add_oauth_app.icon.help": "(Optional) The URL of the image used for your OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL.",
	"add_oauth_app.name.help": "Display name for your OAuth 2.0 application made of up to 64 characters.",
	"add_oauth_app.nameRequired": "Name for the OAuth 2.0 application is required.",
	"add_oauth_app.trusted.help": "When true, the OAuth 2.0 application is considered trusted by the Cordchat server and doesn't require the user to accept authorization. When false, an additional window will appear, asking the user to accept or deny the authorization.",
	"add_oauth_app.url": "<b>URL(s)</b>: {url}",
	"add_outgoing_webhook.callbackUrls": "Callback URLs (One Per Line)",
	"add_outgoing_webhook.callbackUrls.help": "The URL that messages will be sent to.",
	"add_outgoing_webhook.callbackUrlsRequired": "One or more callback URLs are required",
	"add_outgoing_webhook.cancel": "Cancel",
	"add_outgoing_webhook.channel": "Channel",
	"add_outgoing_webhook.channel.help": "Public channel to receive webhook payloads. Optional if at least one Trigger Word is specified.",
	"add_outgoing_webhook.contentType.help1": "Choose the content type by which the response will be sent.",
	"add_outgoing_webhook.contentType.help2": "If application/x-www-form-urlencoded is chosen, the server assumes you will be encoding the parameters in a URL format.",
	"add_outgoing_webhook.contentType.help3": "If application/json is chosen, the server assumes you will posting JSON data.",
	"add_outgoing_webhook.content_Type": "Content Type",
	"add_outgoing_webhook.description": "Description",
	"add_outgoing_webhook.description.help": "Description for your outgoing webhook.",
	"add_outgoing_webhook.displayName": "Display Name",
	"add_outgoing_webhook.displayName.help": "Display name for your outgoing webhook made of up to 64 characters.",
	"add_outgoing_webhook.doneHelp": "Your outgoing webhook has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Cordchat team.",
	"add_outgoing_webhook.name": "Name",
	"add_outgoing_webhook.save": "Save",
	"add_outgoing_webhook.token": "<b>Token</b>: {token}",
	"add_outgoing_webhook.triggerWords": "Trigger Words (One Per Line)",
	"add_outgoing_webhook.triggerWords.help": "Messages that start with one of the specified words will trigger the outgoing webhook. Optional if Channel is selected.",
	"add_outgoing_webhook.triggerWordsOrChannelRequired": "A valid channel or a list of trigger words is required",
	"add_outgoing_webhook.triggerWordsTriggerWhen": "Trigger When",
	"add_outgoing_webhook.triggerWordsTriggerWhen.help": "Choose when to trigger the outgoing webhook; if the first word of a message matches a Trigger Word exactly, or if it starts with a Trigger Word.",
	"add_outgoing_webhook.triggerWordsTriggerWhenFullWord": "First word matches a trigger word exactly",
	"add_outgoing_webhook.triggerWordsTriggerWhenStartsWith": "First word starts with a trigger word",
	"add_users_to_team.title": "Add New Members To {teamName} Team",
	"admin.advance.cluster": "High Availability",
	"admin.advance.metrics": "Performance Monitoring",
	"admin.audits.reload": "Reload User Activity Logs",
	"admin.audits.title": "User Activity Logs",
	"admin.authentication.email": "Email Authentication",
	"admin.authentication.gitlab": "GitLab",
	"admin.authentication.ldap": "AD/LDAP",
	"admin.authentication.oauth": "OAuth 2.0",
	"admin.authentication.saml": "SAML",
	"admin.banner.heading": "Note:",
	"admin.cluster.enableDescription": "When true, Cordchat will run in High Availability mode. Please see <a href=\"http://docs.cordchat.com/deployment/cluster.html\" target='_blank'>documentation</a> to learn more about configuring High Availability for Cordchat.",
	"admin.cluster.enableTitle": "Enable High Availability Mode:",
	"admin.cluster.interNodeListenAddressDesc": "The address the server will listen on for communicating with other servers.",
	"admin.cluster.interNodeListenAddressEx": "E.g.: \":8075\"",
	"admin.cluster.interNodeListenAddressTitle": "Inter-Node Listen Address:",
	"admin.cluster.interNodeUrlsDesc": "The internal/private URLs of all the Cordchat servers separated by commas.",
	"admin.cluster.interNodeUrlsEx": "E.g.: \"http://10.10.10.30, http://10.10.10.31\"",
	"admin.cluster.interNodeUrlsTitle": "Inter-Node URLs:",
	"admin.cluster.loadedFrom": "This configuration file was loaded from Node ID {clusterId}. Please see the Troubleshooting Guide in our <a href=\"http://docs.cordchat.com/deployment/cluster.html\" target='_blank'>documentation</a> if you are accessing the System Console through a load balancer and experiencing issues.",
	"admin.cluster.noteDescription": "Changing properties in this section will require a server restart before taking effect. When High Availability mode is enabled, the System Console is set to read-only and can only be changed from the configuration file unless ReadOnlyConfig is disabled in the configuration file.",
	"admin.cluster.should_not_change": "WARNING: These settings may not sync with the other servers in the cluster. High Availability inter-node communication will not start until you modify the config.json to be identical on all servers and restart Cordchat. Please see the <a href=\"http://docs.cordchat.com/deployment/cluster.html\" target='_blank'>documentation</a> on how to add or remove a server from the cluster. If you are accessing the System Console through a load balancer and experiencing issues, please see the Troubleshooting Guide in our <a href=\"http://docs.cordchat.com/deployment/cluster.html\" target='_blank'>documentation</a>.",
	"admin.cluster.status_table.config_hash": "Config File MD5",
	"admin.cluster.status_table.hostname": "Hostname",
	"admin.cluster.status_table.id": "Node ID",
	"admin.cluster.status_table.reload": " Reload Cluster Status",
	"admin.cluster.status_table.status": "Status",
	"admin.cluster.status_table.url": "Gossip Address",
	"admin.cluster.status_table.version": "Version",
	"admin.cluster.unknown": "unknown",
	"admin.compliance.directoryDescription": "Directory to which compliance reports are written. If blank, will be set to ./data/.",
	"admin.compliance.directoryExample": "E.g.: \"./data/\"",
	"admin.compliance.directoryTitle": "Compliance Report Directory:",
	"admin.compliance.enableDailyDesc": "When true, Cordchat will generate a daily compliance report.",
	"admin.compliance.enableDailyTitle": "Enable Daily Report:",
	"admin.compliance.enableDesc": "When true, Cordchat allows compliance reporting from the <strong>Compliance and Auditing</strong> tab. See <a href=\"https://docs.cordchat.com/administration/compliance.html\" target='_blank'>documentation</a> to learn more.",
	"admin.compliance.enableTitle": "Enable Compliance Reporting:",
	"admin.compliance.false": "false",
	"admin.compliance.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href=\"http://cordchat.com\" target='_blank'>here</a> for information and pricing on enterprise licenses.</p>",
	"admin.compliance.save": "Save",
	"admin.compliance.saving": "Saving Config...",
	"admin.compliance.title": "Compliance Settings",
	"admin.compliance.true": "true",
	"admin.compliance_reports.desc": "Job Name:",
	"admin.compliance_reports.desc_placeholder": "E.g. \"Audit 445 for HR\"",
	"admin.compliance_reports.emails": "Emails:",
	"admin.compliance_reports.emails_placeholder": "E.g. \"bill@example.com, bob@example.com\"",
	"admin.compliance_reports.from": "From:",
	"admin.compliance_reports.from_placeholder": "E.g. \"2016-03-11\"",
	"admin.compliance_reports.keywords": "Keywords:",
	"admin.compliance_reports.keywords_placeholder": "E.g. \"shorting stock\"",
	"admin.compliance_reports.reload": "Reload Completed Compliance Reports",
	"admin.compliance_reports.run": "Run Compliance Report",
	"admin.compliance_reports.title": "Compliance Reports",
	"admin.compliance_reports.to": "To:",
	"admin.compliance_reports.to_placeholder": "E.g. \"2016-03-15\"",
	"admin.compliance_table.desc": "Description",
	"admin.compliance_table.download": "Download",
	"admin.compliance_table.params": "Params",
	"admin.compliance_table.records": "Records",
	"admin.compliance_table.status": "Status",
	"admin.compliance_table.timestamp": "Timestamp",
	"admin.compliance_table.type": "Type",
	"admin.compliance_table.userId": "Requested By",
	"admin.connectionSecurityNone": "None",
	"admin.connectionSecurityNoneDescription": "Cordchat will connect over an insecure connection.",
	"admin.connectionSecurityStart": "STARTTLS",
	"admin.connectionSecurityStartDescription": "Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.",
	"admin.connectionSecurityTest": "Test Connection",
	"admin.connectionSecurityTitle": "Connection Security:",
	"admin.connectionSecurityTls": "TLS",
	"admin.connectionSecurityTlsDescription": "Encrypts the communication between Cordchat and your server.",
	"admin.customization.androidAppDownloadLinkDesc": "Add a link to download the Android app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.",
	"admin.customization.androidAppDownloadLinkTitle": "Android App Download Link:",
	"admin.customization.appDownloadLinkDesc": "Add a link to a download page for the Cordchat apps. When a link is present, an option to \"Download Cordchat Apps\" will be added in the Main Menu so users can find the download page. Leave this field blank to hide the option from the Main Menu.",
	"admin.customization.appDownloadLinkTitle": "Cordchat Apps Download Page Link:",
	"admin.customization.customBrand": "Custom Branding",
	"admin.customization.emoji": "Emoji",
	"admin.customization.enableCustomEmojiDesc": "Enable users to create custom emoji for use in messages. When enabled, Custom Emoji settings can be accessed by switching to a team and clicking the three dots above the channel sidebar, and selecting \"Custom Emoji\".",
	"admin.customization.enableCustomEmojiTitle": "Enable Custom Emoji:",
	"admin.customization.enableEmojiPickerDesc": "The emoji picker allows users to select emoji to add as reactions or use in messages. Enabling the emoji picker with a large number of custom emoji may slow down performance.",
	"admin.customization.enableEmojiPickerTitle": "Enable Emoji Picker:",
	"admin.customization.enableLinkPreviewsDesc": "Enable users to display a preview of website content below the message, if available. When true, website previews can be enabled from Account Settings > Advanced > Preview pre-release features.",
	"admin.customization.enableLinkPreviewsTitle": "Enable Link Previews:",
	"admin.customization.iosAppDownloadLinkDesc": "Add a link to download the iOS app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.",
	"admin.customization.iosAppDownloadLinkTitle": "iOS App Download Link:",
	"admin.customization.linkPreviews": "Link Previews",
	"admin.customization.nativeAppLinks": "Cordchat App Links",
	"admin.customization.restrictCustomEmojiCreationAdmin": "Allow System and Team Admins to create custom emoji",
	"admin.customization.restrictCustomEmojiCreationAll": "Allow everyone to create custom emoji",
	"admin.customization.restrictCustomEmojiCreationDesc": "Restrict the creation of custom emoji to certain users.",
	"admin.customization.restrictCustomEmojiCreationSystemAdmin": "Only allow System Admins to create custom emoji",
	"admin.customization.restrictCustomEmojiCreationTitle": "Restrict Custom Emoji Creation:",
	"admin.customization.support": "Legal and Support",
	"admin.database.title": "Database Settings",
	"admin.developer.title": "Developer Settings",
	"admin.elasticsearch.bulkIndexButton.error": "Failed to schedule Bulk Index Job: {error}",
	"admin.elasticsearch.connectionUrlDescription": "The address of the Elasticsearch server. {documentationLink}",
	"admin.elasticsearch.connectionUrlExample": "E.g.: \"https://elasticsearch.example.org:9200\"",
	"admin.elasticsearch.connectionUrlExample.documentationLinkText": "Please see documentation with server setup instructions.",
	"admin.elasticsearch.connectionUrlTitle": "Server Connection Address:",
	"admin.elasticsearch.elasticsearch_test_button": "Test Connection",
	"admin.elasticsearch.enableIndexingDescription": "When true, indexing of new posts occurs automatically. Search queries will use database search until \"Enable Elasticsearch for search queries\" is enabled. {documentationLink}",
	"admin.elasticsearch.enableIndexingDescription.documentationLinkText": "Learn more about Elasticsearch in our documentation.",
	"admin.elasticsearch.enableIndexingTitle": "Enable Elasticsearch Indexing:",
	"admin.elasticsearch.enableSearchingDescription": "Requires a successful connection to the Elasticsearch server. When true, Elasticsearch will be used for all search queries using the latest index. Search results may be incomplete until a bulk index of the existing post database is finished. When false, database search is used.",
	"admin.elasticsearch.enableSearchingTitle": "Enable Elasticsearch for search queries:",
	"admin.elasticsearch.indexButton.inProgress": "Indexing in progress",
	"admin.elasticsearch.indexButton.ready": "Build Index",
	"admin.elasticsearch.indexHelpText.buildIndex": "All posts in the database will be indexed from oldest to newest. Elasticsearch is available during indexing but search results may be incomplete until the indexing job is complete.",
	"admin.elasticsearch.indexHelpText.cancelIndexing": "Cancelling stops the indexing job and removes it from the queue. Posts that have already been indexed will not be deleted.",
	"admin.elasticsearch.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
	"admin.elasticsearch.password": "E.g.: \"yourpassword\"",
	"admin.elasticsearch.passwordDescription": "(Optional) The password to authenticate to the Elasticsearch server.",
	"admin.elasticsearch.passwordTitle": "Server Password:",
	"admin.elasticsearch.purgeIndexesButton": "Purge Indexes",
	"admin.elasticsearch.purgeIndexesButton.error": "Failed to purge indexes: {error}",
	"admin.elasticsearch.purgeIndexesButton.label": "Purge Indexes:",
	"admin.elasticsearch.purgeIndexesButton.success": "Indexes purged successfully.",
	"admin.elasticsearch.purgeIndexesHelpText": "Purging will entirely remove the index on the Elasticsearch server. Search results may be incomplete until a bulk index of the existing post database is rebuilt.",
	"admin.elasticsearch.sniffDescription": "When true, sniffing finds and connects to all data nodes in your cluster automatically.",
	"admin.elasticsearch.sniffTitle": "Enable Cluster Sniffing:",
	"admin.elasticsearch.testConfigSuccess": "Test successful. Configuration saved.",
	"admin.elasticsearch.testHelpText": "Tests if the Cordchat server can connect to the Elasticsearch server specified. Testing the connection only saves the configuration if the test is successful. See log file for more detailed error messages.",
	"admin.elasticsearch.title": "Elasticsearch (Beta)",
	"admin.elasticsearch.usernameDescription": "(Optional) The username to authenticate to the Elasticsearch server.",
	"admin.elasticsearch.usernameExample": "E.g.: \"elastic\"",
	"admin.elasticsearch.usernameTitle": "Server Username:",
	"admin.elasticsearchStatus.bulkIndexLabel": "Bulk Indexing:",
	"admin.elasticsearchStatus.cancelButton": "Cancel",
	"admin.elasticsearchStatus.status": "Status: ",
	"admin.elasticsearchStatus.statusCancelled": "Indexing job cancelled.",
	"admin.elasticsearchStatus.statusError": "Indexing error.",
	"admin.elasticsearchStatus.statusError.help": "Cordchat encountered an error building the Elasticsearch index: {error}",
	"admin.elasticsearchStatus.statusInProgress": "Job in progress. {percent}% complete.",
	"admin.elasticsearchStatus.statusInProgress.help": "Indexing is in progress on the job server. If Elasticsearch is enabled, search results may be incomplete until the job is finished.",
	"admin.elasticsearchStatus.statusIndexingDisabled": "Indexing disabled.",
	"admin.elasticsearchStatus.statusLoading": "Loading...",
	"admin.elasticsearchStatus.statusNoJobs": "No indexing jobs queued.",
	"admin.elasticsearchStatus.statusPending": "Job pending.",
	"admin.elasticsearchStatus.statusPending.help": "Elasticsearch index job is queued on the job server. If Elasticsearch is enabled, search results may be incomplete until the job is finished.",
	"admin.elasticsearchStatus.statusRequestCancel": "Canceling Job...",
	"admin.elasticsearchStatus.statusSuccess": "Indexing complete.",
	"admin.elasticsearchStatus.statusSuccess.help": "Indexing is complete and new posts are being automatically indexed.",
	"admin.email.agreeHPNS": " I understand and accept the Cordchat Hosted Push Notification Service <a href=\"https://about.cordchat.com/hpns-terms/\" target='_blank'>Terms of Service</a> and <a href=\"https://about.cordchat.com/hpns-privacy/\" target='_blank'>Privacy Policy</a>.",
	"admin.email.allowEmailSignInDescription": "When true, Cordchat allows users to sign in using their email and password.",
	"admin.email.allowEmailSignInTitle": "Enable sign-in with email: ",
	"admin.email.allowSignupDescription": "When true, Cordchat allows account creation using email and password. This value should be false only when you want to limit sign up to a single sign-on service like AD/LDAP, SAML or GitLab.",
	"admin.email.allowSignupTitle": "Enable account creation with email: ",
	"admin.email.allowUsernameSignInDescription": "When true, users with email login can sign in using their username and password. This setting does not affect AD/LDAP login.",
	"admin.email.allowUsernameSignInTitle": "Enable sign-in with username: ",
	"admin.email.connectionSecurityTest": "Test Connection",
	"admin.email.easHelp": "Learn more about compiling and deploying your own mobile apps from an <a href=\"https://about.cordchat.com/default-enterprise-app-store\" target='_blank'>Enterprise App Store</a>.",
	"admin.email.emailFail": "Connection unsuccessful: {error}",
	"admin.email.emailSuccess": "No errors were reported while sending an email.  Please check your inbox to make sure.",
	"admin.email.enableEmailBatching.clusterEnabled": "Email batching cannot be enabled when High Availability mode is enabled.",
	"admin.email.enableEmailBatching.siteURL": "Email batching cannot be enabled unless the SiteURL is configured in <b>Configuration > SiteURL</b>.",
	"admin.email.enableEmailBatchingDesc": "When true, users will have email notifications for multiple direct messages and mentions combined into a single email. Batching will occur at a default interval of 15 minutes, configurable in Account Settings > Notifications.",
	"admin.email.enableEmailBatchingTitle": "Enable Email Batching:",
	"admin.email.enableSMTPAuthDesc": "When enabled, username and password are used for authenticating to the SMTP server.",
	"admin.email.enableSMTPAuthTitle": "Enable SMTP Authentication:",
	"admin.email.fullPushNotification": "Send full message snippet",
	"admin.email.genericNoChannelPushNotification": "Send generic description with only sender name",
	"admin.email.genericPushNotification": "Send generic description with sender and channel names",
	"admin.email.inviteSaltDescription": "32-character salt added to signing of email invites. Randomly generated on install. Click \"Regenerate\" to create new salt.",
	"admin.email.inviteSaltExample": "E.g.: \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
	"admin.email.inviteSaltTitle": "Email Invite Salt:",
	"admin.email.mhpns": "Use encrypted, production-quality HPNS connection to iOS and Android apps",
	"admin.email.mhpnsHelp": "Download <a href=\"https://about.cordchat.com/cordchat-ios-app\" target='_blank'>Cordchat iOS app</a> from iTunes. Download <a href=\"https://about.cordchat.com/cordchat-android-app\" target='_blank'>Cordchat Android app</a> from Google Play. Learn more about <a href=\"https://about.cordchat.com/default-hpns\" target='_blank'>HPNS</a>.",
	"admin.email.mtpns": "Use iOS and Android apps on iTunes and Google Play with TPNS",
	"admin.email.mtpnsHelp": "Download <a href=\"https://about.cordchat.com/cordchat-ios-app\" target='_blank'>Cordchat iOS app</a> from iTunes. Download <a href=\"https://about.cordchat.com/cordchat-android-app\" target='_blank'>Cordchat Android app</a> from Google Play. Learn more about <a href=\"https://about.cordchat.com/default-tpns/\" target='_blank'>TPNS</a>.",
	"admin.email.nofificationOrganizationExample": "E.g.: \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\"",
	"admin.email.notification.contents.full": "Send full message contents",
	"admin.email.notification.contents.full.description": "Sender name and channel are included in email notifications.</br>Typically used for compliance reasons if Cordchat contains confidential information and policy dictates it cannot be stored in email.",
	"admin.email.notification.contents.generic": "Send generic description with only sender name",
	"admin.email.notification.contents.generic.description": "Only the name of the person who sent the message, with no information about channel name or message contents are included in email notifications.</br>Typically used for compliance reasons if Cordchat contains confidential information and policy dictates it cannot be stored in email.",
	"admin.email.notification.contents.title": "Email Notification Contents: ",
	"admin.email.notificationDisplayDescription": "Display name on email account used when sending notification emails from Cordchat.",
	"admin.email.notificationDisplayExample": "E.g.: \"Cordchat Notification\", \"System\", \"No-Reply\"",
	"admin.email.notificationDisplayTitle": "Notification Display Name:",
	"admin.email.notificationEmailDescription": "Email address displayed on email account used when sending notification emails from Cordchat.",
	"admin.email.notificationEmailExample": "E.g.: \"cordchat@yourcompany.com\", \"admin@yourcompany.com\"",
	"admin.email.notificationEmailTitle": "Notification From Address:",
	"admin.email.notificationOrganization": "Notification Footer Mailing Address:",
	"admin.email.notificationOrganizationDescription": "Organization name and address displayed on email notifications from Cordchat, such as \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\". If the field is left empty, the organization name and address will not be displayed.",
	"admin.email.notificationOrganizationExample": "E.g.: \"© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA\"",
	"admin.email.notificationsDescription": "Typically set to true in production. When true, Cordchat attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).",
	"admin.email.notificationsTitle": "Enable Email Notifications: ",
	"admin.email.passwordSaltDescription": "32-character salt added to signing of password reset emails. Randomly generated on install. Click \"Regenerate\" to create new salt.",
	"admin.email.passwordSaltExample": "E.g.: \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
	"admin.email.passwordSaltTitle": "Password Reset Salt:",
	"admin.email.pushContentDesc": "\"Send generic description with only sender name\" includes only the name of the person who sent the message in push notifications, with no information about channel name or message contents.<br /><br />\"Send generic description with sender and channel names\" includes the name of the person who sent the message and the channel it was sent in, but not the message text.<br /><br />\"Send full message snippet\" includes a message excerpt in push notifications, which may contain confidential information sent in messages. If your Push Notification Service is outside your firewall, it is *highly recommended* this option only be used with an \"https\" protocol to encrypt the connection.",
	"admin.email.pushContentTitle": "Push Notification Contents:",
	"admin.email.pushDesc": "Typically set to true in production. When true, Cordchat attempts to send iOS and Android push notifications through the push notification server.",
	"admin.email.pushOff": "Do not send push notifications",
	"admin.email.pushOffHelp": "Please see <a href=\"https://about.cordchat.com/default-mobile-push-notifications\" target='_blank'>documentation on push notifications</a> to learn more about setup options.",
	"admin.email.pushServerDesc": "Location of Cordchat push notification service you can set up behind your firewall using https://github.com/cordchat/push-proxy. For testing you can use http://push-test.cordchat.com, which connects to the sample Cordchat iOS app in the public Apple AppStore. Please do not use test service for production deployments.",
	"admin.email.pushServerEx": "E.g.: \"http://push-test.cordchat.com\"",
	"admin.email.pushServerTitle": "Push Notification Server:",
	"admin.email.pushTitle": "Enable Push Notifications: ",
	"admin.email.requireVerificationDescription": "Typically set to true in production. When true, Cordchat requires verification after account creation prior to allowing login. Developers may set this field to false so skip sending verification for faster development.",
	"admin.email.requireVerificationTitle": "Require Email Verification: ",
	"admin.email.selfPush": "Manually enter Push Notification Service location",
	"admin.email.skipServerCertificateVerification.description": "When true, Cordchat will not verify the email server certificate.",
	"admin.email.skipServerCertificateVerification.title": "Skip Server Certificate Verification: ",
	"admin.email.smtpPasswordDescription": "The password associated with the SMTP username.",
	"admin.email.smtpPasswordExample": "E.g.: \"yourpassword\", \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.email.smtpPasswordTitle": "SMTP Server Password:",
	"admin.email.smtpPortDescription": "Port of SMTP email server.",
	"admin.email.smtpPortExample": "E.g.: \"25\", \"465\", \"587\"",
	"admin.email.smtpPortTitle": "SMTP Server Port:",
	"admin.email.smtpServerDescription": "Location of SMTP email server.",
	"admin.email.smtpServerExample": "E.g.: \"smtp.yourcompany.com\", \"email-smtp.us-east-1.amazonaws.com\"",
	"admin.email.smtpServerTitle": "SMTP Server:",
	"admin.email.smtpUsernameDescription": "The username for authenticating to the SMTP server.",
	"admin.email.smtpUsernameExample": "E.g.: \"admin@yourcompany.com\", \"AKIADTOVBGERKLCBV\"",
	"admin.email.smtpUsernameTitle": "SMTP Server Username:",
	"admin.email.testing": "Testing...",
	"admin.false": "false",
	"admin.file.enableFileAttachments": "Allow File Sharing:",
	"admin.file.enableFileAttachmentsDesc": "When false, disables file sharing on the server. All file and image uploads on messages are forbidden across clients and devices, including mobile.",
	"admin.file.enableVirusScanTitle": "Enable File Security Scan:",
	"admin.file.enableVirusScanDesc": "When true, every uploaded file is scanned by the local anti-virus scanner on the server. Files other than images and text cannot be downloaded until the scan has finished and found no threat. Files never leave the server.",
	"admin.file.virusScanCommandTitle": "Scanner Command:",
	"admin.file.virusScanCommandExample": "Ex \"/opt/sophos-av/bin/savscan\"",
	"admin.file.virusScanCommandDesc": "Full path of the scanner executable on the server, e.g. Sophos Anti-Virus for Linux \"/opt/sophos-av/bin/savscan\" or Sophos Protection for Linux \"/opt/sophos-spl/plugins/av/bin/avscanner\".",
	"admin.file.virusScanArgsTitle": "Scanner Arguments:",
	"admin.file.virusScanArgsExample": "Ex \"-f -archive -all -ss -nc\"",
	"admin.file.virusScanArgsDesc": "Arguments passed to the scanner before the file path. Default for savscan: \"-f -archive -all -ss -nc\". For avscanner use \"--scan-archives\".",
	"admin.file.virusScanCleanExitCodesTitle": "Exit Codes Meaning \"Clean\":",
	"admin.file.virusScanCleanExitCodesExample": "Ex \"0\"",
	"admin.file.virusScanCleanExitCodesDesc": "Comma separated scanner exit codes that mean no threat was found. savscan: \"0\".",
	"admin.file.virusScanInfectedExitCodesTitle": "Exit Codes Meaning \"Threat Found\":",
	"admin.file.virusScanInfectedExitCodesExample": "Ex \"3\"",
	"admin.file.virusScanInfectedExitCodesDesc": "Comma separated scanner exit codes that mean a threat was found. savscan: \"3\". Any other exit code is treated as a scan failure and the file stays blocked.",
	"admin.file.virusScanTimeoutTitle": "Scan Timeout (seconds):",
	"admin.file.virusScanTimeoutExample": "Ex \"120\"",
	"admin.file.virusScanTimeoutDesc": "Maximum time a single scan may take. A scan that takes longer is aborted and counted as failed.",
	"admin.file.virusScanWorkersTitle": "Concurrent Scans:",
	"admin.file.virusScanWorkersExample": "Ex \"2\"",
	"admin.file.virusScanWorkersDesc": "Number of files scanned at the same time. Takes effect after a server restart.",
	"admin.file.virusScanDeleteInfectedTitle": "Delete Infected Files:",
	"admin.file.virusScanDeleteInfectedDesc": "When true, the content of a file in which a threat was found is removed from storage. The file entry is kept so users can see why it is blocked.",
	"admin.file.virusScanMethodTitle": "Scan Method:",
	"admin.file.virusScanMethodHttp": "Scan API endpoint (HTTP)",
	"admin.file.virusScanMethodCommand": "Local scanner command",
	"admin.file.virusScanMethodDesc": "\"Scan API endpoint\": the file is sent to an internal HTTP scan service. \"Local scanner command\": a scanner executable (e.g. Sophos savscan) is run on this server.",
	"admin.file.virusScanEndpointTitle": "Scan API Endpoint:",
	"admin.file.virusScanEndpointExample": "Ex \"http://127.0.0.1:8080/scan\"",
	"admin.file.virusScanEndpointDesc": "URL of the internal scan API. The file is POSTed as multipart/form-data (field \"file\") and a JSON verdict is expected, e.g. {\"status\":\"clean\"} or {\"status\":\"infected\",\"threat\":\"...\"}.",
	"admin.file.virusScanEndpointTokenTitle": "Scan API Token:",
	"admin.file.virusScanEndpointTokenExample": "Optional",
	"admin.file.virusScanEndpointTokenDesc": "Optional token sent to the scan API as \"Authorization: Bearer <token>\" and \"X-Api-Key\".",
	"admin.file.enableMobileDownloadDesc": "When false, disables file downloads on mobile apps. Users can still download files from a mobile web browser.",
	"admin.file.enableMobileDownloadTitle": "Allow File Downloads on Mobile:",
	"admin.file.enableMobileUploadDesc": "When false, disables file uploads on mobile apps. If Allow File Sharing is set to true, users can still upload files from a mobile web browser.",
	"admin.file.enableMobileUploadTitle": "Allow File Uploads on Mobile:",
	"admin.file_upload.chooseFile": "Choose File",
	"admin.file_upload.noFile": "No file uploaded",
	"admin.file_upload.uploadFile": "Upload",
	"admin.files.images": "Images",
	"admin.files.storage": "Storage",
	"admin.general.configuration": "Configuration",
	"admin.general.localization": "Localization",
	"admin.general.localization.availableLocalesDescription": "Set which languages are available for users in Account Settings (leave this field blank to have all supported languages available). If you’re manually adding new languages, the <strong>Default Client Language</strong> must be added before saving this setting.",
	"admin.general.localization.availableLocalesNoResults": "No results found",
	"admin.general.localization.availableLocalesNotPresent": "The default client language must be included in the available list",
	"admin.general.localization.availableLocalesTitle": "Available Languages:",
	"admin.general.localization.clientLocaleDescription": "Default language for newly created users and pages where the user hasn't logged in.",
	"admin.general.localization.clientLocaleTitle": "Default Client Language:",
	"admin.general.localization.serverLocaleDescription": "Default language for system messages and logs. Changing this will require a server restart before taking effect.",
	"admin.general.localization.serverLocaleTitle": "Default Server Language:",
	"admin.general.log": "Logging",
	"admin.general.policy": "Policy",
	"admin.general.policy.allowBannerDismissalDesc": "When true, users can dismiss the banner until its next update. When false, the banner is permanently visible until it is turned off by the System Admin.",
	"admin.general.policy.allowBannerDismissalTitle": "Allow Banner Dismissal:",
	"admin.general.policy.allowEditPostAlways": "Any time",
	"admin.general.policy.allowEditPostDescription": "Set policy on the length of time authors have to edit their messages after posting.",
	"admin.general.policy.allowEditPostNever": "Never",
	"admin.general.policy.allowEditPostTimeLimit": "seconds after posting",
	"admin.general.policy.allowEditPostTitle": "Allow users to edit their messages:",
	"admin.general.policy.bannerColorTitle": "Banner Color:",
	"admin.general.policy.bannerTextColorTitle": "Banner Text Color:",
	"admin.general.policy.bannerTextDesc": "Text that will appear in the announcement banner.",
	"admin.general.policy.bannerTextTitle": "Banner Text:",
	"admin.general.policy.enableBannerDesc": "Enable an announcement banner across all teams.",
	"admin.general.policy.enableBannerTitle": "Enable Announcement Banner:",
	"admin.general.policy.permissionsAdmin": "Team and System Admins",
	"admin.general.policy.permissionsAll": "All team members",
	"admin.general.policy.permissionsAllChannel": "All channel members",
	"admin.general.policy.permissionsChannelAdmin": "Channel, Team and System Admins",
	"admin.general.policy.permissionsDeletePostAdmin": "Team Admins and System Admins",
	"admin.general.policy.permissionsDeletePostAll": "Message authors can delete their own messages, and Administrators can delete any message",
	"admin.general.policy.permissionsDeletePostSystemAdmin": "System Admins",
	"admin.general.policy.permissionsSystemAdmin": "System Admins",
	"admin.general.policy.restrictPostDeleteDescription": "Set policy on who has permission to delete messages.",
	"admin.general.policy.restrictPostDeleteTitle": "Allow which users to delete messages:",
	"admin.general.policy.restrictPrivateChannelCreationDescription": "Set policy on who can create private channels.",
	"admin.general.policy.restrictPrivateChannelCreationTitle": "Enable private channel creation for:",
	"admin.general.policy.restrictPrivateChannelDeletionCommandLineToolLink": "command line tool",
	"admin.general.policy.restrictPrivateChannelDeletionDescription": "Set policy on who can delete private channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.",
	"admin.general.policy.restrictPrivateChannelDeletionTitle": "Enable private channel deletion for:",
	"admin.general.policy.restrictPrivateChannelManageMembersDescription": "Set policy on who can add and remove members from private channels.",
	"admin.general.policy.restrictPrivateChannelManageMembersTitle": "Enable managing of private channel members for:",
	"admin.general.policy.restrictPrivateChannelManagementDescription": "Set policy on who can rename and set the header or purpose for private channels.",
	"admin.general.policy.restrictPrivateChannelManagementTitle": "Enable private channel renaming for:",
	"admin.general.policy.restrictPublicChannelCreationDescription": "Set policy on who can create public channels.",
	"admin.general.policy.restrictPublicChannelCreationTitle": "Enable public channel creation for:",
	"admin.general.policy.restrictPublicChannelDeletionCommandLineToolLink": "command line tool",
	"admin.general.policy.restrictPublicChannelDeletionDescription": "Set policy on who can delete public channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.",
	"admin.general.policy.restrictPublicChannelDeletionTitle": "Enable public channel deletion for:",
	"admin.general.policy.restrictPublicChannelManagementDescription": "Set policy on who can rename and set the header or purpose for public channels.",
	"admin.general.policy.restrictPublicChannelManagementTitle": "Enable public channel renaming for:",
	"admin.general.policy.teamInviteDescription": "Set policy on who can invite others to a team using <b>Send Private Invitation</b> to invite new users by email, or the <b>Get Public Invitation Link</b> options from the Main Menu. If <b>Get Public Invitation Link</b> is used to share a link, you can expire the invite code from <b>Team Settings</b> > <b>Invite Code</b> after the desired users join the team.",
	"admin.general.policy.teamInviteTitle": "Enable sending team invites from:",
	"admin.general.privacy": "Privacy",
	"admin.general.usersAndTeams": "Users and Teams",
	"admin.gitab.clientSecretDescription": "Obtain this value via the instructions above for logging into GitLab.",
	"admin.gitlab.EnableHtmlDesc": "<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs \"<your-cordchat-url>/login/gitlab/complete\" (example: http://localhost:8065/login/gitlab/complete) and \"<your-cordchat-url>/signup/gitlab/complete\". </li><li>Then use \"Application Secret Key\" and \"Application ID\" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>",
	"admin.gitlab.authDescription": "Enter https://<your-gitlab-url>/oauth/authorize (example https://example.com:3000/oauth/authorize).   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.authExample": "E.g.: \"https://<your-gitlab-url>/oauth/authorize\"",
	"admin.gitlab.authTitle": "Auth Endpoint:",
	"admin.gitlab.clientIdDescription": "Obtain this value via the instructions above for logging into GitLab",
	"admin.gitlab.clientIdExample": "E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.gitlab.clientIdTitle": "Application ID:",
	"admin.gitlab.clientSecretExample": "E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.gitlab.clientSecretTitle": "Application Secret Key:",
	"admin.gitlab.enableDescription": "When true, Cordchat allows team creation and account signup using GitLab OAuth.",
	"admin.gitlab.enableTitle": "Enable authentication with GitLab: ",
	"admin.gitlab.settingsTitle": "GitLab Settings",
	"admin.gitlab.tokenDescription": "Enter https://<your-gitlab-url>/oauth/token.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.tokenExample": "E.g.: \"https://<your-gitlab-url>/oauth/token\"",
	"admin.gitlab.tokenTitle": "Token Endpoint:",
	"admin.gitlab.userDescription": "Enter https://<your-gitlab-url>/api/v3/user.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.userExample": "E.g.: \"https://<your-gitlab-url>/api/v3/user\"",
	"admin.gitlab.userTitle": "User API Endpoint:",
	"admin.google.EnableHtmlDesc": "<ol><li><a target='_blank' href='https://accounts.google.com/login'>Log in</a> to your Google account.</li><li>Go to <a target='_blank' href='https://console.developers.google.com'>https://console.developers.google.com</a>, click <strong>Credentials</strong> in the left hand sidebar and enter \"Cordchat - your-company-name\" as the <strong>Project Name</strong>, then click <strong>Create</strong>.</li><li>Click the <strong>OAuth consent screen</strong> header and enter \"cordchat\" as the <strong>Product name shown to users</strong>, then click <strong>Save</strong>.</li><li>Under the <strong>Credentials</strong> header, click <strong>Create credentials</strong>, choose <strong>OAuth client ID</strong> and select <strong>Web Application</strong>.</li><li>Under <strong>Restrictions</strong> and <strong>Authorized redirect URIs</strong> enter <strong>your-cordchat-url/signup/google/complete</strong> (example: http://localhost:8065/signup/google/complete). Click <strong>Create</strong>.</li><li>Paste the <strong>Client ID</strong> and <strong>Client Secret</strong> to the fields below, then click <strong>Save</strong>.</li><li>Finally, go to <a target='_blank' href='https://console.developers.google.com/apis/api/plus/overview'>Google+ API</a> and click <strong>Enable</strong>. This might take a few minutes to propagate through Google's systems.</li></ol>",
	"admin.google.authTitle": "Auth Endpoint:",
	"admin.google.clientIdDescription": "The Client ID you received when registering your application with Google.",
	"admin.google.clientIdExample": "E.g.: \"7602141235235-url0fhs1mayfasbmop5qlfns8dh4.apps.googleusercontent.com\"",
	"admin.google.clientIdTitle": "Client ID:",
	"admin.google.clientSecretDescription": "The Client Secret you received when registering your application with Google.",
	"admin.google.clientSecretExample": "E.g.: \"H8sz0Az-dDs2p15-7QzD231\"",
	"admin.google.clientSecretTitle": "Client Secret:",
	"admin.google.tokenTitle": "Token Endpoint:",
	"admin.google.userTitle": "User API Endpoint:",
	"admin.image.amazonS3BucketDescription": "Name you selected for your S3 bucket in AWS.",
	"admin.image.amazonS3BucketExample": "E.g.: \"cordchat-media\"",
	"admin.image.amazonS3BucketTitle": "Amazon S3 Bucket:",
	"admin.image.amazonS3EndpointDescription": "Hostname of your S3 Compatible Storage provider. Defaults to `s3.amazonaws.com`.",
	"admin.image.amazonS3EndpointExample": "E.g.: \"s3.amazonaws.com\"",
	"admin.image.amazonS3EndpointTitle": "Amazon S3 Endpoint:",
	"admin.image.amazonS3IdDescription": "Obtain this credential from your Amazon EC2 administrator.",
	"admin.image.amazonS3IdExample": "E.g.: \"AKIADTOVBGERKLCBV\"",
	"admin.image.amazonS3IdTitle": "Amazon S3 Access Key ID:",
	"admin.image.amazonS3RegionDescription": "AWS region you selected for creating your S3 bucket.",
	"admin.image.amazonS3RegionExample": "E.g.: \"us-east-1\"",
	"admin.image.amazonS3RegionTitle": "Amazon S3 Region:",
	"admin.image.amazonS3SSEDescription": "When true, encrypt files in Amazon S3 using server-side encryption with Amazon S3-managed keys. See <a href=\"https://about.cordchat.com/default-server-side-encryption\">documentation</a> to learn more.",
	"admin.image.amazonS3SSEExample": "E.g.: \"false\"",
	"admin.image.amazonS3SSETitle": "Enable Server-Side Encryption for Amazon S3:",
	"admin.image.amazonS3SSLDescription": "When false, allow insecure connections to Amazon S3. Defaults to secure connections only.",
	"admin.image.amazonS3SSLExample": "E.g.: \"true\"",
	"admin.image.amazonS3SSLTitle": "Enable Secure Amazon S3 Connections:",
	"admin.image.amazonS3SecretDescription": "Obtain this credential from your Amazon EC2 administrator.",
	"admin.image.amazonS3SecretExample": "E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.image.amazonS3SecretTitle": "Amazon S3 Secret Access Key:",
	"admin.image.localDescription": "Directory to which files and images are written. If blank, defaults to ./data/.",
	"admin.image.localExample": "E.g.: \"./data/\"",
	"admin.image.localTitle": "Local Storage Directory:",
	"admin.image.maxFileSizeDescription": "Maximum file size for message attachments in megabytes. Caution: Verify server memory can support your setting choice. Large file sizes increase the risk of server crashes and failed uploads due to network interruptions.",
	"admin.image.maxFileSizeExample": "50",
	"admin.image.maxFileSizeTitle": "Maximum File Size:",
	"admin.image.publicLinkDescription": "32-character salt added to signing of public image links. Randomly generated on install. Click \"Regenerate\" to create new salt.",
	"admin.image.publicLinkExample": "E.g.: \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
	"admin.image.publicLinkTitle": "Public Link Salt:",
	"admin.image.shareDescription": "Allow users to share public links to files and images.",
	"admin.image.shareTitle": "Enable Public File Links: ",
	"admin.image.storeAmazonS3": "Amazon S3",
	"admin.image.storeDescription": "Storage system where files and image attachments are saved.<br /><br />Selecting \"Amazon S3\" enables fields to enter your Amazon credentials and bucket details.<br /><br />Selecting \"Local File System\" enables the field to specify a local file directory.",
	"admin.image.storeLocal": "Local File System",
	"admin.image.storeTitle": "File Storage System:",
	"admin.integrations.custom": "Custom Integrations",
	"admin.integrations.external": "External Services",
	"admin.integrations.webrtc": "Cordchat WebRTC",
	"admin.ldap.baseDesc": "The Base DN is the Distinguished Name of the location where Cordchat should start its search for users in the AD/LDAP tree.",
	"admin.ldap.baseEx": "E.g.: \"ou=Unit Name,dc=corp,dc=example,dc=com\"",
	"admin.ldap.baseTitle": "BaseDN:",
	"admin.ldap.bindPwdDesc": "Password of the user given in \"Bind Username\".",
	"admin.ldap.bindPwdTitle": "Bind Password:",
	"admin.ldap.bindUserDesc": "The username used to perform the AD/LDAP search. This should typically be an account created specifically for use with Cordchat. It should have access limited to read the portion of the AD/LDAP tree specified in the BaseDN field.",
	"admin.ldap.bindUserTitle": "Bind Username:",
	"admin.ldap.emailAttrDesc": "The attribute in the AD/LDAP server that will be used to populate the email addresses of users in Cordchat.",
	"admin.ldap.emailAttrEx": "E.g.: \"mail\" or \"userPrincipalName\"",
	"admin.ldap.emailAttrTitle": "Email Attribute:",
	"admin.ldap.enableDesc": "When true, Cordchat allows login using AD/LDAP",
	"admin.ldap.enableTitle": "Enable sign-in with AD/LDAP:",
	"admin.ldap.firstnameAttrDesc": "(Optional) The attribute in the AD/LDAP server that will be used to populate the first name of users in Cordchat. When set, users will not be able to edit their first name, since it is synchronized with the LDAP server. When left blank, users can set their own first name in Account Settings.",
	"admin.ldap.firstnameAttrEx": "E.g.: \"givenName\"",
	"admin.ldap.firstnameAttrTitle": "First Name Attribute",
	"admin.ldap.idAttrDesc": "The attribute in the AD/LDAP server that will be used as a unique identifier in Cordchat. It should be an AD/LDAP attribute with a value that does not change, such as username or uid. If a user's ID Attribute changes, it will create a new Cordchat account unassociated with their old one. This is the value used to log in to Cordchat in the \"AD/LDAP Username\" field on the sign in page. Normally this attribute is the same as the \"Username Attribute\" field above. If your team typically uses domain\\\\username to sign in to other services with AD/LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.",
	"admin.ldap.idAttrEx": "E.g.: \"sAMAccountName\"",
	"admin.ldap.idAttrTitle": "ID Attribute: ",
	"admin.ldap.lastnameAttrDesc": "(Optional) The attribute in the AD/LDAP server that will be used to populate the last name of users in Cordchat. When set, users will not be able to edit their last name, since it is synchronized with the LDAP server. When left blank, users can set their own last name in Account Settings.",
	"admin.ldap.lastnameAttrEx": "E.g.: \"sn\"",
	"admin.ldap.lastnameAttrTitle": "Last Name Attribute:",
	"admin.ldap.ldap_test_button": "AD/LDAP Test",
	"admin.ldap.loginNameDesc": "The placeholder text that appears in the login field on the login page. Defaults to \"AD/LDAP Username\".",
	"admin.ldap.loginNameEx": "E.g.: \"AD/LDAP Username\"",
	"admin.ldap.loginNameTitle": "Login Field Name:",
	"admin.ldap.maxPageSizeEx": "E.g.: \"2000\"",
	"admin.ldap.maxPageSizeHelpText": "The maximum number of users the Cordchat server will request from the AD/LDAP server at one time. 0 is unlimited.",
	"admin.ldap.maxPageSizeTitle": "Maximum Page Size:",
	"admin.ldap.nicknameAttrDesc": "(Optional) The attribute in the AD/LDAP server that will be used to populate the nickname of users in Cordchat. When set, users will not be able to edit their nickname, since it is synchronized with the LDAP server. When left blank, users can set their own nickname in Account Settings.",
	"admin.ldap.nicknameAttrEx": "E.g.: \"nickname\"",
	"admin.ldap.nicknameAttrTitle": "Nickname Attribute:",
	"admin.ldap.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>AD/LDAP is an enterprise feature. Your current license does not support AD/LDAP. Click <a href=\"http://cordchat.com\" target='_blank'>here</a> for information and pricing on enterprise licenses.</p>",
	"admin.ldap.portDesc": "The port Cordchat will use to connect to the AD/LDAP server. Default is 389.",
	"admin.ldap.portEx": "E.g.: \"389\"",
	"admin.ldap.portTitle": "AD/LDAP Port:",
	"admin.ldap.positionAttrDesc": "(Optional) The attribute in the AD/LDAP server that will be used to populate the position field in Cordchat.",
	"admin.ldap.positionAttrEx": "E.g.: \"title\"",
	"admin.ldap.positionAttrTitle": "Position Attribute:",
	"admin.ldap.queryDesc": "The timeout value for queries to the AD/LDAP server. Increase if you are getting timeout errors caused by a slow AD/LDAP server.",
	"admin.ldap.queryEx": "E.g.: \"60\"",
	"admin.ldap.queryTitle": "Query Timeout (seconds):",
	"admin.ldap.serverDesc": "The domain or IP address of AD/LDAP server.",
	"admin.ldap.serverEx": "E.g.: \"10.0.0.23\"",
	"admin.ldap.serverTitle": "AD/LDAP Server:",
	"admin.ldap.skipCertificateVerification": "Skip Certificate Verification:",
	"admin.ldap.skipCertificateVerificationDesc": "Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.",
	"admin.ldap.syncFailure": "Sync Failure: {error}",
	"admin.ldap.syncIntervalHelpText": "AD/LDAP Synchronization updates Cordchat user information to reflect updates on the AD/LDAP server. For example, when a user’s name changes on the AD/LDAP server, the change updates in Cordchat when synchronization is performed. Accounts removed from or disabled in the AD/LDAP server have their Cordchat accounts set to \"Inactive\" and have their account sessions revoked. Cordchat performs synchronization on the interval entered. For example, if 60 is entered, Cordchat synchronizes every 60 minutes.",
	"admin.ldap.syncIntervalTitle": "Synchronization Interval (minutes):",
	"admin.ldap.syncNowHelpText": "Initiates an AD/LDAP synchronization immediately.",
	"admin.ldap.sync_button": "AD/LDAP Synchronize Now",
	"admin.ldap.testFailure": "AD/LDAP Test Failure: {error}",
	"admin.ldap.testHelpText": "Tests if the Cordchat server can connect to the AD/LDAP server specified. See log file for more detailed error messages.",
	"admin.ldap.testSuccess": "AD/LDAP Test Successful",
	"admin.ldap.uernameAttrDesc": "The attribute in the AD/LDAP server that will be used to populate the username field in Cordchat. This may be the same as the ID Attribute.",
	"admin.ldap.userFilterDisc": "(Optional) Enter an AD/LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Cordchat. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).",
	"admin.ldap.userFilterEx": "E.g.: \"(objectClass=user)\"",
	"admin.ldap.userFilterTitle": "User Filter:",
	"admin.ldap.usernameAttrEx": "E.g.: \"sAMAccountName\"",
	"admin.ldap.usernameAttrTitle": "Username Attribute:",
	"admin.license.choose": "Choose File",
	"admin.license.chooseFile": "Choose File",
	"admin.license.edition": "Edition: ",
	"admin.license.key": "License Key: ",
	"admin.license.keyRemove": "Remove Enterprise License and Downgrade Server",
	"admin.license.noFile": "No file uploaded",
	"admin.license.removing": "Removing License...",
	"admin.license.title": "Edition and License",
	"admin.license.type": "License: ",
	"admin.license.upload": "Upload",
	"admin.license.uploadDesc": "Upload a license key for Cordchat Enterprise Edition to upgrade this server. <a href=\"http://cordchat.com\" target='_blank'>Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.",
	"admin.license.uploading": "Uploading License...",
	"admin.log.consoleDescription": "Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).",
	"admin.log.consoleTitle": "Output logs to console: ",
	"admin.log.enableDiagnostics": "Enable Diagnostics and Error Reporting:",
	"admin.log.enableDiagnosticsDescription": "Enable this feature to improve the quality and performance of Cordchat by sending error reporting and diagnostic information to Cordchat, Inc. Read our <a href=\"https://about.cordchat.com/default-privacy-policy/\" target='_blank'>privacy policy</a> to learn more.",
	"admin.log.enableWebhookDebugging": "Enable Webhook Debugging:",
	"admin.log.enableWebhookDebuggingDescription": "You can set this to false to disable the debug logging of all incoming webhook request bodies.",
	"admin.log.fileDescription": "Typically set to true in production. When true, logged events are written to the cordchat.log file in the directory specified in the File Log Directory field. The logs are rotated at 10,000 lines and archived to a file in the same directory, and given a name with a datestamp and serial number. For example, cordchat.2017-03-31.001.",
	"admin.log.fileLevelDescription": "This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
	"admin.log.fileLevelTitle": "File Log Level:",
	"admin.log.fileTitle": "Output logs to file: ",
	"admin.log.formatDateLong": "Date (2006/01/02)",
	"admin.log.formatDateShort": "Date (01/02/06)",
	"admin.log.formatDescription": "Format of log message output. If blank will be set to \"[%D %T] [%L] %M\", where:",
	"admin.log.formatLevel": "Level (DEBG, INFO, EROR)",
	"admin.log.formatMessage": "Message",
	"admin.log.formatPlaceholder": "Enter your file format",
	"admin.log.formatSource": "Source",
	"admin.log.formatTime": "Time (15:04:05 MST)",
	"admin.log.formatTitle": "File Log Format:",
	"admin.log.levelDescription": "This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
	"admin.log.levelTitle": "Console Log Level:",
	"admin.log.locationDescription": "The location of the log files. If blank, they are stored in the ./logs directory. The path that you set must exist and Cordchat must have write permissions in it.",
	"admin.log.locationPlaceholder": "Enter your file location",
	"admin.log.locationTitle": "File Log Directory:",
	"admin.log.logSettings": "Log Settings",
	"admin.logs.bannerDesc": "To look up users by User ID, go to Reporting > Users and paste the ID into the search filter.",
	"admin.logs.reload": "Reload",
	"admin.logs.title": "Server Logs",
	"admin.manage_roles.additionalRoles": "Select additional permissions for the account. <a href=\"https://about.cordchat.com/default-permissions\" target=\"_blank\">Read more about roles and permissions</a>.",
	"admin.manage_roles.allowUserAccessTokens": "Allow this account to generate <a href=\"https://about.cordchat.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a>.",
	"admin.manage_roles.cancel": "Cancel",
	"admin.manage_roles.manageRolesTitle": "Manage Roles",
	"admin.manage_roles.postAllPublicRole": "Access to post to all Cordchat public channels.",
	"admin.manage_roles.postAllPublicRoleTitle": "post:channels",
	"admin.manage_roles.postAllRole": "Access to post to all Cordchat channels including direct messages.",
	"admin.manage_roles.postAllRoleTitle": "post:all",
	"admin.manage_roles.save": "Save",
	"admin.manage_roles.saveError": "Unable to save roles.",
	"admin.manage_roles.systemAdmin": "System Admin",
	"admin.manage_roles.systemMember": "Member",
	"admin.manage_tokens.manageTokensTitle": "Manage Personal Access Tokens",
	"admin.manage_tokens.userAccessTokensDescription": "Personal access tokens function similar to session tokens and can be used by integrations to <a href=\"https://about.cordchat.com/default-api-authentication\" target=\"_blank\">interact with this Cordchat server</a>. Learn more about <a href=\"https://about.cordchat.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a>.",
	"admin.manage_tokens.userAccessTokensNone": "No personal access tokens.",
	"admin.metrics.enableDescription": "When true, Cordchat will enable performance monitoring collection and profiling. Please see <a href=\"http://docs.cordchat.com/deployment/metrics.html\" target='_blank'>documentation</a> to learn more about configuring performance monitoring for Cordchat.",
	"admin.metrics.enableTitle": "Enable Performance Monitoring:",
	"admin.metrics.listenAddressDesc": "The address the server will listen on to expose performance metrics.",
	"admin.metrics.listenAddressEx": "E.g.: \":8067\"",
	"admin.metrics.listenAddressTitle": "Listen Address:",
	"admin.mfa.bannerDesc": "<a href='https://docs.cordchat.com/deployment/auth.html' target='_blank'>Multi-factor authentication</a> is available for accounts with AD/LDAP or email login. If other login methods are used, MFA should be configured with the authentication provider.",
	"admin.mfa.cluster": "High",
	"admin.mfa.title": "Multi-factor Authentication",
	"admin.nav.administratorsGuide": "Administrator's Guide",
	"admin.nav.commercialSupport": "Commercial Support",
	"admin.nav.help": "Help",
	"admin.nav.logout": "Logout",
	"admin.nav.report": "Report a Problem",
	"admin.nav.switch": "Team Selection",
	"admin.nav.troubleshootingForum": "Troubleshooting Forum",
	"admin.notifications.email": "Email",
	"admin.notifications.push": "Mobile Push",
	"admin.notifications.title": "Notification Settings",
	"admin.oauth.gitlab": "GitLab",
	"admin.oauth.google": "Google Apps",
	"admin.oauth.off": "Do not allow sign-in via an OAuth 2.0 provider",
	"admin.oauth.office365": "Office 365 (Beta)",
	"admin.oauth.providerDescription": "When true, Cordchat can act as an OAuth 2.0 service provider allowing Cordchat to authorize API requests from external applications. See <a target='_blank' href=\"https://docs.cordchat.com/developer/oauth-2-0-applications.html\">documentation</a> to learn more.",
	"admin.oauth.providerTitle": "Enable OAuth 2.0 Service Provider: ",
	"admin.oauth.select": "Select OAuth 2.0 service provider:",
	"admin.office365.EnableHtmlDesc": "<ol><li><a target='_blank' href='https://login.microsoftonline.com/'>Log in</a> to your Microsoft or Office 365 account. Make sure it's the account on the same <a target='_blank' href='https://msdn.microsoft.com/en-us/library/azure/jj573650.aspx#Anchor_0'>tenant</a> that you would like users to log in with.</li><li>Go to <a target='_blank' href='https://apps.dev.microsoft.com'>https://apps.dev.microsoft.com</a>, click <strong>Go to app list</strong> > <strong>Add an app</strong> and use \"Cordchat - your-company-name\" as the <strong>Application Name</strong>.</li><li>Under <strong>Application Secrets</strong>, click <strong>Generate New Password</strong> and paste it to the <strong>Application Secret Password</strong> field below.</li><li>Under <strong>Platforms</strong>, click <strong>Add Platform</strong>, choose <strong>Web</strong> and enter <strong>your-cordchat-url/signup/office365/complete</strong> (example: http://localhost:8065/signup/office365/complete) under <strong>Redirect URIs</strong>. Also uncheck <strong>Allow Implicit Flow</strong>.</li><li>Finally, click <strong>Save</strong> and then paste the <strong>Application ID</strong> below.</li></ol>",
	"admin.office365.authTitle": "Auth Endpoint:",
	"admin.office365.clientIdDescription": "The Application/Client ID you received when registering your application with Microsoft.",
	"admin.office365.clientIdExample": "E.g.: \"adf3sfa2-ag3f-sn4n-ids0-sh1hdax192qq\"",
	"admin.office365.clientIdTitle": "Application ID:",
	"admin.office365.clientSecretDescription": "The Application Secret Password you generated when registering your application with Microsoft.",
	"admin.office365.clientSecretExample": "E.g.: \"shAieM47sNBfgl20f8ci294\"",
	"admin.office365.clientSecretTitle": "Application Secret Password:",
	"admin.office365.tokenTitle": "Token Endpoint:",
	"admin.office365.userTitle": "User API Endpoint:",
	"admin.password.lowercase": "At least one lowercase letter",
	"admin.password.minimumLength": "Minimum Password Length:",
	"admin.password.minimumLengthDescription": "Minimum number of characters required for a valid password. Must be a whole number greater than or equal to {min} and less than or equal to {max}.",
	"admin.password.minimumLengthExample": "E.g.: \"5\"",
	"admin.password.number": "At least one number",
	"admin.password.preview": "Error message preview",
	"admin.password.requirements": "Password Requirements:",
	"admin.password.requirementsDescription": "Character types required in a valid password.",
	"admin.password.symbol": "At least one symbol (e.g. \"~!@#$%^&*()\")",
	"admin.password.uppercase": "At least one uppercase letter",
	"admin.plugins.jira": "JIRA (Beta)",
	"admin.plugins.jira.channelParamNamePlaceholder": "channelname",
	"admin.plugins.jira.enabledDescription": "When true, you can configure JIRA webhooks to post message in Cordchat. To help combat phishing attacks, all posts are labelled by a BOT tag.",
	"admin.plugins.jira.enabledLabel": "Enabled:",
	"admin.plugins.jira.secretDescription": "This secret is used to authenticate to Cordchat.",
	"admin.plugins.jira.secretLabel": "Secret:",
	"admin.plugins.jira.secretParamPlaceholder": "secret",
	"admin.plugins.jira.secretRegenerateDescription": "Regenerates the secret for the webhook URL endpoint. Regenerating the secret invalidates your existing JIRA integrations.",
	"admin.plugins.jira.setupDescription": "Use this webhook URL to set up the JIRA integration. See {webhookDocsLink} to learn more.",
	"admin.plugins.jira.teamParamPlaceholder": "teamname",
	"admin.plugins.jira.userDescription": "Select the username that this integration is attached to.",
	"admin.plugins.jira.userLabel": "User:",
	"admin.plugins.jira.webhookDocsLink": "documentation",
	"admin.privacy.showEmailDescription": "When false, hides the email address of members from everyone except System Administrators.",
	"admin.privacy.showEmailTitle": "Show Email Address: ",
	"admin.privacy.showFullNameDescription": "When false, hides the full name of members from everyone except System Administrators. Username is shown in place of full name.",
	"admin.privacy.showFullNameTitle": "Show Full Name: ",
	"admin.purge.button": "Purge All Caches",
	"admin.purge.loading": " Loading...",
	"admin.purge.purgeDescription": "This will purge all the in-memory caches for things like sessions, accounts, channels, etc. Deployments using High Availability will attempt to purge all the servers in the cluster.  Purging the caches may adversly impact performance.",
	"admin.purge.purgeFail": "Purging unsuccessful: {error}",
	"admin.rate.enableLimiterDescription": "When true, APIs are throttled at rates specified below.",
	"admin.rate.enableLimiterTitle": "Enable Rate Limiting: ",
	"admin.rate.httpHeaderDescription": "When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to \"X-Real-IP\", when configuring AmazonELB set to \"X-Forwarded-For\").",
	"admin.rate.httpHeaderExample": "E.g.: \"X-Real-IP\", \"X-Forwarded-For\"",
	"admin.rate.httpHeaderTitle": "Vary rate limit by HTTP header:",
	"admin.rate.maxBurst": "Maximum Burst Size:",
	"admin.rate.maxBurstDescription": "Maximum number of requests allowed beyond the per second query limit.",
	"admin.rate.maxBurstExample": "E.g.: \"100\"",
	"admin.rate.memoryDescription": "Maximum number of users sessions connected to the system as determined by \"Vary rate limit by remote address\" and \"Vary rate limit by HTTP header\" settings below.",
	"admin.rate.memoryExample": "E.g.: \"10000\"",
	"admin.rate.memoryTitle": "Memory Store Size:",
	"admin.rate.noteDescription": "Changing properties other than Site URL in this section will require a server restart before taking effect.",
	"admin.rate.noteTitle": "Note:",
	"admin.rate.queriesDescription": "Throttles API at this number of requests per second.",
	"admin.rate.queriesExample": "E.g.: \"10\"",
	"admin.rate.queriesTitle": "Maximum Queries per Second:",
	"admin.rate.remoteDescription": "When true, rate limit API access by IP address.",
	"admin.rate.remoteTitle": "Vary rate limit by remote address: ",
	"admin.rate.title": "Rate Limit Settings",
	"admin.recycle.button": "Recycle Database Connections",
	"admin.recycle.loading": " Recycling...",
	"admin.recycle.recycleDescription": "Deployments using multiple databases can switch from one master database to another without restarting the Cordchat server by updating \"config.json\" to the new desired configuration and using the {reloadConfiguration} feature to load the new settings while the server is running. The administrator should then use {featureName} feature to recycle the database connections based on the new settings.",
	"admin.recycle.recycleDescription.featureName": "Recycle Database Connections",
	"admin.recycle.recycleDescription.reloadConfiguration": "Configuration > Reload Configuration from Disk",
	"admin.recycle.reloadFail": "Recycling unsuccessful: {error}",
	"admin.regenerate": "Regenerate",
	"admin.reload.button": "Reload Configuration From Disk",
	"admin.reload.loading": " Loading...",
	"admin.reload.reloadDescription": "Deployments using multiple databases can switch from one master database to another without restarting the Cordchat server by updating \"config.json\" to the new desired configuration and using the {featureName} feature to load the new settings while the server is running. The administrator should then use the {recycleDatabaseConnections} feature to recycle the database connections based on the new settings.",
	"admin.reload.reloadDescription.featureName": "Reload Configuration from Disk",
	"admin.reload.reloadDescription.recycleDatabaseConnections": "Database > Recycle Database Connections",
	"admin.reload.reloadFail": "Reloading unsuccessful: {error}",
	"admin.requestButton.loading": " Loading...",
	"admin.requestButton.requestFailure": "Test Failure: {error}",
	"admin.requestButton.requestSuccess": "Test Successful",
	"admin.reset_password.close": "Close",
	"admin.reset_password.newPassword": "New Password",
	"admin.reset_password.select": "Select",
	"admin.reset_password.submit": "Please enter at least {chars} characters.",
	"admin.reset_password.titleReset": "Reset Password",
	"admin.reset_password.titleSwitch": "Switch Account to Email/Password",
	"admin.saml.assertionConsumerServiceURLDesc": "Enter https://<your-cordchat-url>/login/sso/saml. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. This field is also known as the Assertion Consumer Service URL.",
	"admin.saml.assertionConsumerServiceURLEx": "E.g.: \"https://<your-cordchat-url>/login/sso/saml\"",
	"admin.saml.assertionConsumerServiceURLTitle": "Service Provider Login URL:",
	"admin.saml.bannerDesc": "User attributes in SAML server, including user deactivation or removal, are updated in Cordchat during user login. Learn more at: <a href=\"https://docs.cordchat.com/deployment/sso-saml.html\">https://docs.cordchat.com/deployment/sso-saml.html</a>",
	"admin.saml.emailAttrDesc": "The attribute in the SAML Assertion that will be used to populate the email addresses of users in Cordchat.",
	"admin.saml.emailAttrEx": "E.g.: \"Email\" or \"PrimaryEmail\"",
	"admin.saml.emailAttrTitle": "Email Attribute:",
	"admin.saml.enableDescription": "When true, Cordchat allows login using SAML. Please see <a href='http://docs.cordchat.com/deployment/sso-saml.html' target='_blank'>documentation</a> to learn more about configuring SAML for Cordchat.",
	"admin.saml.enableTitle": "Enable Login With SAML:",
	"admin.saml.encryptDescription": "When false, Cordchat will not decrypt SAML Assertions encrypted with your Service Provider Public Certificate. Not recommended for production environments. For testing only.",
	"admin.saml.encryptTitle": "Enable Encryption:",
	"admin.saml.firstnameAttrDesc": "(Optional) The attribute in the SAML Assertion that will be used to populate the first name of users in Cordchat.",
	"admin.saml.firstnameAttrEx": "E.g.: \"FirstName\"",
	"admin.saml.firstnameAttrTitle": "First Name Attribute:",
	"admin.saml.idpCertificateFileDesc": "The public authentication certificate issued by your Identity Provider.",
	"admin.saml.idpCertificateFileRemoveDesc": "Remove the public authentication certificate issued by your Identity Provider.",
	"admin.saml.idpCertificateFileTitle": "Identity Provider Public Certificate:",
	"admin.saml.idpDescriptorUrlDesc": "The issuer URL for the Identity Provider you use for SAML requests.",
	"admin.saml.idpDescriptorUrlEx": "E.g.: \"https://idp.example.org/SAML2/issuer\"",
	"admin.saml.idpDescriptorUrlTitle": "Identity Provider Issuer URL:",
	"admin.saml.idpUrlDesc": "The URL where Cordchat sends a SAML request to start login sequence.",
	"admin.saml.idpUrlEx": "E.g.: \"https://idp.example.org/SAML2/SSO/Login\"",
	"admin.saml.idpUrlTitle": "SAML SSO URL:",
	"admin.saml.lastnameAttrDesc": "(Optional) The attribute in the SAML Assertion that will be used to populate the last name of users in Cordchat.",
	"admin.saml.lastnameAttrEx": "E.g.: \"LastName\"",
	"admin.saml.lastnameAttrTitle": "Last Name Attribute:",
	"admin.saml.localeAttrDesc": "(Optional) The attribute in the SAML Assertion that will be used to populate the language of users in Cordchat.",
	"admin.saml.localeAttrEx": "E.g.: \"Locale\" or \"PrimaryLanguage\"",
	"admin.saml.localeAttrTitle": "Preferred Language Attribute:",
	"admin.saml.loginButtonTextDesc": "(Optional) The text that appears in the login button on the login page. Defaults to \"With SAML\".",
	"admin.saml.loginButtonTextEx": "E.g.: \"With OKTA\"",
	"admin.saml.loginButtonTextTitle": "Login Button Text:",
	"admin.saml.nicknameAttrDesc": "(Optional) The attribute in the SAML Assertion that will be used to populate the nickname of users in Cordchat.",
	"admin.saml.nicknameAttrEx": "E.g.: \"Nickname\"",
	"admin.saml.nicknameAttrTitle": "Nickname Attribute:",
	"admin.saml.positionAttrDesc": "(Optional) The attribute in the SAML Assertion that will be used to populate the position of users in Cordchat.",
	"admin.saml.positionAttrEx": "E.g.: \"Role\"",
	"admin.saml.positionAttrTitle": "Position Attribute:",
	"admin.saml.privateKeyFileFileDesc": "The private key used to decrypt SAML Assertions from the Identity Provider.",
	"admin.saml.privateKeyFileFileRemoveDesc": "Remove the private key used to decrypt SAML Assertions from the Identity Provider.",
	"admin.saml.privateKeyFileTitle": "Service Provider Private Key:",
	"admin.saml.publicCertificateFileDesc": "The certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Cordchat is the Service Provider.",
	"admin.saml.publicCertificateFileRemoveDesc": "Remove the certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Cordchat is the Service Provider.",
	"admin.saml.publicCertificateFileTitle": "Service Provider Public Certificate:",
	"admin.saml.remove.idp_certificate": "Remove Identity Provider Certificate",
	"admin.saml.remove.privKey": "Remove Service Provider Private Key",
	"admin.saml.remove.sp_certificate": "Remove Service Provider Certificate",
	"admin.saml.removing.certificate": "Removing Certificate...",
	"admin.saml.removing.privKey": "Removing Private Key...",
	"admin.saml.uploading.certificate": "Uploading Certificate...",
	"admin.saml.uploading.privateKey": "Uploading Private Key...",
	"admin.saml.usernameAttrDesc": "The attribute in the SAML Assertion that will be used to populate the username field in Cordchat.",
	"admin.saml.usernameAttrEx": "E.g.: \"Username\"",
	"admin.saml.usernameAttrTitle": "Username Attribute:",
	"admin.saml.verifyDescription": "When false, Cordchat will not verify that the signature sent from a SAML Response matches the Service Provider Login URL. Not recommended for production environments. For testing only.",
	"admin.saml.verifyTitle": "Verify Signature:",
	"admin.save": "Save",
	"admin.saving": "Saving Config...",
	"admin.security.connection": "Connections",
	"admin.security.inviteSalt.disabled": "Invite salt cannot be changed while sending emails is disabled.",
	"admin.security.login": "Login",
	"admin.security.password": "Password",
	"admin.security.passwordResetSalt.disabled": "Password reset salt cannot be changed while sending emails is disabled.",
	"admin.security.public_links": "Public Links",
	"admin.security.requireEmailVerification.disabled": "Email verification cannot be changed while sending emails is disabled.",
	"admin.security.session": "Sessions",
	"admin.security.signup": "Signup",
	"admin.select_team.close": "Close",
	"admin.select_team.select": "Select",
	"admin.select_team.selectTeam": "Select Team",
	"admin.service.attemptDescription": "Number of login attempts allowed before a user is locked out and required to reset their password via email.",
	"admin.service.attemptExample": "E.g.: \"10\"",
	"admin.service.attemptTitle": "Maximum Login Attempts:",
	"admin.service.cmdsDesc": "When true, custom slash commands will be allowed. See <a href='http://docs.cordchat.com/developer/slash-commands.html' target='_blank'>documentation</a> to learn more.",
	"admin.service.cmdsTitle": "Enable Custom Slash Commands: ",
	"admin.service.corsDescription": "Enable HTTP Cross origin request from a specific domain. Use \"*\" if you want to allow CORS from any domain or leave it blank to disable it.",
	"admin.service.corsEx": "http://example.com",
	"admin.service.corsTitle": "Enable cross-origin requests from:",
	"admin.service.developerDesc": "When true, JavaScript errors are shown in a purple bar at the top of the user interface. Not recommended for use in production. ",
	"admin.service.developerTitle": "Enable Developer Mode: ",
	"admin.service.enableAPIv3": "Allow use of API v3 endpoints:",
	"admin.service.enableAPIv3Description": "Set to false to disable all version 3 endpoints of the REST API. Integrations that rely on API v3 will fail and can then be identified for migration to API v4. API v3 is deprecated and will be removed in the near future. See <a href='https://api.cordchat.com' target='_blank'>https://api.cordchat.com</a> for details.",
	"admin.service.enforceMfaDesc": "When true, <a href='https://docs.cordchat.com/deployment/auth.html' target='_blank'>multi-factor authentication</a> is required for login. New users will be required to configure MFA on signup. Logged in users without MFA configured are redirected to the MFA setup page until configuration is complete.<br/><br/>If your system has users with login methods other than AD/LDAP and email, MFA must be enforced with the authentication provider outside of Cordchat.",
	"admin.service.enforceMfaTitle": "Enforce Multi-factor Authentication:",
	"admin.service.forward80To443": "Forward port 80 to 443:",
	"admin.service.forward80To443Description": "Forwards all insecure traffic from port 80 to secure port 443",
	"admin.service.googleDescription": "Set this key to enable the display of titles for embedded YouTube video previews. Without the key, YouTube previews will still be created based on hyperlinks appearing in messages or comments but they will not show the video title. View a <a href=\"https://www.youtube.com/watch?v=Im69kzhpR3I\" target='_blank'>Google Developers Tutorial</a> for instructions on how to obtain a key.",
	"admin.service.googleExample": "E.g.: \"7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV\"",
	"admin.service.googleTitle": "Google API Key:",
	"admin.service.iconDescription": "When true, webhooks, slash commands and other integrations, such as <a href=\"https://docs.cordchat.com/integrations/zapier.html\" target='_blank'>Zapier</a>, will be allowed to change the profile picture they post with. Note: Combined with allowing integrations to override usernames, users may be able to perform phishing attacks by attempting to impersonate other users.",
	"admin.service.iconTitle": "Enable integrations to override profile picture icons:",
	"admin.service.insecureTlsDesc": "When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.",
	"admin.service.insecureTlsTitle": "Enable Insecure Outgoing Connections: ",
	"admin.service.integrationAdmin": "Restrict managing integrations to Admins:",
	"admin.service.integrationAdminDesc": "When true, webhooks and slash commands can only be created, edited and viewed by Team and System Admins, and OAuth 2.0 applications by System Admins. Integrations are available to all users after they have been created by the Admin.",
	"admin.service.letsEncryptCertificateCacheFile": "Let's Encrypt Certificate Cache File:",
	"admin.service.letsEncryptCertificateCacheFileDescription": "Certificates retrieved and other data about the Let's Encrypt service will be stored in this file.",
	"admin.service.listenAddress": "Listen Address:",
	"admin.service.listenDescription": "The address and port to which to bind and listen. Specifying \":8065\" will bind to all network interfaces. Specifying \"127.0.0.1:8065\" will only bind to the network interface having that IP address. If you choose a port of a lower level (called \"system ports\" or \"well-known ports\", in the range of 0-1023), you must have permissions to bind to that port. On Linux you can use: \"sudo setcap cap_net_bind_service=+ep ./bin/platform\" to allow Cordchat to bind to well-known ports.",
	"admin.service.listenExample": "E.g.: \":8065\"",
	"admin.service.mfaDesc": "When true, users with AD/LDAP or email login can add multi-factor authentication to their account using Google Authenticator.",
	"admin.service.mfaTitle": "Enable Multi-factor Authentication:",
	"admin.service.mobileSessionDays": "Session length mobile (days):",
	"admin.service.mobileSessionDaysDesc": "The number of days from the last time a user entered their credentials to the expiry of the user's session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.",
	"admin.service.outWebhooksDesc": "When true, outgoing webhooks will be allowed. See <a href='http://docs.cordchat.com/developer/webhooks-outgoing.html' target='_blank'>documentation</a> to learn more.",
	"admin.service.outWebhooksTitle": "Enable Outgoing Webhooks: ",
	"admin.service.overrideDescription": "When true, webhooks, slash commands and other integrations, such as <a href=\"https://docs.cordchat.com/integrations/zapier.html\" target='_blank'>Zapier</a>, will be allowed to change the username they are posting as. Note: Combined with allowing integrations to override profile picture icons, users may be able to perform phishing attacks by attempting to impersonate other users.",
	"admin.service.overrideTitle": "Enable integrations to override usernames:",
	"admin.service.readTimeout": "Read Timeout:",
	"admin.service.readTimeoutDescription": "Maximum time allowed from when the connection is accepted to when the request body is fully read.",
	"admin.service.securityDesc": "When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.",
	"admin.service.securityTitle": "Enable Security Alerts: ",
	"admin.service.sessionCache": "Session Cache (minutes):",
	"admin.service.sessionCacheDesc": "The number of minutes to cache a session in memory.",
	"admin.service.sessionDaysEx": "E.g.: \"30\"",
	"admin.service.siteURL": "Site URL:",
	"admin.service.siteURLDescription": "The URL that users will use to access Cordchat. Standard ports, such as 80 and 443, can be omitted, but non-standard ports are required. For example: http://cordchat.example.com:8065. This setting is required.",
	"admin.service.siteURLExample": "E.g.: \"https://cordchat.example.com:1234\"",
	"admin.service.ssoSessionDays": "Session length SSO (days):",
	"admin.service.ssoSessionDaysDesc": "The number of days from the last time a user entered their credentials to the expiry of the user's session. If the authentication method is SAML or GitLab, the user may automatically be logged back in to Cordchat if they are already logged in to SAML or GitLab. After changing this setting, the setting will take effect after the next time the user enters their credentials.",
	"admin.service.testingDescription": "When true, /test slash command is enabled to load test accounts, data and text formatting. Changing this requires a server restart before taking effect.",
	"admin.service.testingTitle": "Enable Testing Commands: ",
	"admin.service.tlsCertFile": "TLS Certificate File:",
	"admin.service.tlsCertFileDescription": "The certificate file to use.",
	"admin.service.tlsKeyFile": "TLS Key File:",
	"admin.service.tlsKeyFileDescription": "The private key file to use.",
	"admin.service.useLetsEncrypt": "Use Let's Encrypt:",
	"admin.service.useLetsEncryptDescription": "Enable the automatic retreval of certificates from the Let's Encrypt. The certificate will be retrieved when a client attempts to connect from a new domain. This will work with multiple domains.",
	"admin.service.userAccessTokensDescLabel": "Name: ",
	"admin.service.userAccessTokensDescription": "When true, users can create <a href=\"https://about.cordchat.com/default-user-access-tokens\" target=\"_blank\">personal access tokens</a> for integrations in <strong>Account Settings > Security</strong>. They can be used to authenticate against the API and give full access to the account.<br/><br/>To manage who can create personal access tokens, go to the <strong>System Console > Users</strong> page.",
	"admin.service.userAccessTokensIdLabel": "Token ID: ",
	"admin.service.userAccessTokensTitle": "Enable Personal Access Tokens: ",
	"admin.service.webSessionDays": "Session length AD/LDAP and email (days):",
	"admin.service.webSessionDaysDesc": "The number of days from the last time a user entered their credentials to the expiry of the user's session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.",
	"admin.service.webhooksDescription": "When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag. See <a href='http://docs.cordchat.com/developer/webhooks-incoming.html' target='_blank'>documentation</a> to learn more.",
	"admin.service.webhooksTitle": "Enable Incoming Webhooks: ",
	"admin.service.writeTimeout": "Write Timeout:",
	"admin.service.writeTimeoutDescription": "If using HTTP (insecure), this is the maximum time allowed from the end of reading the request headers until the response is written. If using HTTPS, it is the total time from when the connection is accepted until the response is written.",
	"admin.sidebar.advanced": "Advanced",
	"admin.sidebar.audits": "Compliance and Auditing",
	"admin.sidebar.authentication": "Authentication",
	"admin.sidebar.cluster": "High Availability",
	"admin.sidebar.compliance": "Compliance",
	"admin.sidebar.configuration": "Configuration",
	"admin.sidebar.connections": "Connections",
	"admin.sidebar.customBrand": "Custom Branding",
	"admin.sidebar.customIntegrations": "Custom Integrations",
	"admin.sidebar.customization": "Customization",
	"admin.sidebar.database": "Database",
	"admin.sidebar.developer": "Developer",
	"admin.sidebar.elasticsearch": "Elasticsearch (Beta)",
	"admin.sidebar.email": "Email",
	"admin.sidebar.emoji": "Emoji",
	"admin.sidebar.external": "External Services",
	"admin.sidebar.files": "Files",
	"admin.sidebar.general": "General",
	"admin.sidebar.gitlab": "GitLab",
	"admin.sidebar.integrations": "Integrations",
	"admin.sidebar.jira": "JIRA (Beta)",
	"admin.sidebar.ldap": "AD/LDAP",
	"admin.sidebar.legalAndSupport": "Legal and Support",
	"admin.sidebar.license": "Edition and License",
	"admin.sidebar.linkPreviews": "Link Previews",
	"admin.sidebar.localization": "Localization",
	"admin.sidebar.logging": "Logging",
	"admin.sidebar.login": "Login",
	"admin.sidebar.logs": "Logs",
	"admin.sidebar.metrics": "Performance Monitoring",
	"admin.sidebar.mfa": "MFA",
	"admin.sidebar.nativeAppLinks": "Cordchat App Links",
	"admin.sidebar.notifications": "Notifications",
	"admin.sidebar.oauth": "OAuth 2.0",
	"admin.sidebar.other": "OTHER",
	"admin.sidebar.password": "Password",
	"admin.sidebar.policy": "Policy",
	"admin.sidebar.privacy": "Privacy",
	"admin.sidebar.publicLinks": "Public Links",
	"admin.sidebar.push": "Mobile Push",
	"admin.sidebar.rateLimiting": "Rate Limiting",
	"admin.sidebar.reports": "REPORTING",
	"admin.sidebar.saml": "SAML",
	"admin.sidebar.security": "Security",
	"admin.sidebar.sessions": "Sessions",
	"admin.sidebar.settings": "SETTINGS",
	"admin.sidebar.signUp": "Sign Up",
	"admin.sidebar.sign_up": "Sign Up",
	"admin.sidebar.statistics": "Team Dashboard",
	"admin.sidebar.storage": "Storage",
	"admin.sidebar.support": "Legal and Support",
	"admin.sidebar.users": "Users",
	"admin.sidebar.usersAndTeams": "Users and Teams",
	"admin.sidebar.view_statistics": "Site Statistics",
	"admin.sidebar.webrtc": "Video Conference",
	"admin.sidebarHeader.systemConsole": "System Console",
	"admin.sql.dataSource": "Data Source:",
	"admin.sql.driverName": "Driver Name:",
	"admin.sql.keyDescription": "32-character salt available to encrypt and decrypt sensitive fields in database.",
	"admin.sql.keyExample": "E.g.: \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
	"admin.sql.keyTitle": "At Rest Encrypt Key:",
	"admin.sql.maxConnectionsDescription": "Maximum number of idle connections held open to the database.",
	"admin.sql.maxConnectionsExample": "E.g.: \"10\"",
	"admin.sql.maxConnectionsTitle": "Maximum Idle Connections:",
	"admin.sql.maxOpenDescription": "Maximum number of open connections held open to the database.",
	"admin.sql.maxOpenExample": "E.g.: \"10\"",
	"admin.sql.maxOpenTitle": "Maximum Open Connections:",
	"admin.sql.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
	"admin.sql.noteTitle": "Note:",
	"admin.sql.queryTimeoutDescription": "The number of seconds to wait for a response from the database after opening a connection and sending the query. Errors that you see in the UI or in the logs as a result of a query timeout can vary depending on the type of query.",
	"admin.sql.queryTimeoutExample": "E.g.: \"30\"",
	"admin.sql.queryTimeoutTitle": "Query Timeout:",
	"admin.sql.replicas": "Data Source Replicas:",
	"admin.sql.traceDescription": "(Development Mode) When true, executing SQL statements are written to the log.",
	"admin.sql.traceTitle": "Trace: ",
	"admin.sql.warning": "Warning: regenerating this salt may cause some columns in the database to return empty results.",
	"admin.support.aboutDesc": "The URL for the About link on the Cordchat login and sign-up pages. If this field is empty, the About link is hidden from users.",
	"admin.support.aboutTitle": "About link:",
	"admin.support.emailHelp": "Email address displayed on email notifications and during tutorial for end users to ask support questions.",
	"admin.support.emailTitle": "Support Email:",
	"admin.support.helpDesc": "The URL for the Help link on the Cordchat login page, sign-up pages, and Main Menu. If this field is empty, the Help link is hidden from users.",
	"admin.support.helpTitle": "Help link:",
	"admin.support.noteDescription": "If linking to an external site, URLs should begin with http:// or https://.",
	"admin.support.noteTitle": "Note:",
	"admin.support.privacyDesc": "The URL for the Privacy link on the login and sign-up pages. If this field is empty, the Privacy link is hidden from users.",
	"admin.support.privacyTitle": "Privacy Policy link:",
	"admin.support.problemDesc": "The URL for the Report a Problem link in the Main Menu. If this field is empty, the link is removed from the Main Menu.",
	"admin.support.problemTitle": "Report a Problem link:",
	"admin.support.termsDesc": "Link to the terms under which users may use your online service. By default, this includes the \"Cordchat Conditions of Use (End Users)\" explaining the terms under which Cordchat software is provided to end users. If you change the default link to add your own terms for using the service you provide, your new terms must include a link to the default terms so end users are aware of the Cordchat Conditions of Use (End User) for Cordchat software.",
	"admin.support.termsTitle": "Terms of Service link:",
	"admin.system_analytics.activeUsers": "Active Users With Posts",
	"admin.system_analytics.title": "the System",
	"admin.system_analytics.totalPosts": "Total Posts",
	"admin.system_users.allUsers": "All Users",
	"admin.system_users.noTeams": "No Teams",
	"admin.system_users.title": "{siteName} Users",
	"admin.team.brandDesc": "Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.",
	"admin.team.brandDescriptionExample": "All team communication in one place, searchable and accessible anywhere",
	"admin.team.brandDescriptionHelp": "Description of service shown in login screens and UI. When not specified, \"All team communication in one place, searchable and accessible anywhere\" is displayed.",
	"admin.team.brandDescriptionTitle": "Site Description: ",
	"admin.team.brandImageTitle": "Custom Brand Image:",
	"admin.team.brandTextDescription": "Text that will appear below your custom brand image on your login screen. Supports Markdown-formatted text. Maximum 500 characters allowed.",
	"admin.team.brandTextTitle": "Custom Brand Text:",
	"admin.team.brandTitle": "Enable Custom Branding: ",
	"admin.team.chooseImage": "Choose New Image",
	"admin.team.dirDesc": "When true, teams that are configured to show in team directory will show on main page inplace of creating a new team.",
	"admin.team.dirTitle": "Enable Team Directory: ",
	"admin.team.maxChannelsDescription": "Maximum total number of channels per team, including both active and deleted channels.",
	"admin.team.maxChannelsExample": "E.g.: \"100\"",
	"admin.team.maxChannelsTitle": "Max Channels Per Team:",
	"admin.team.maxNotificationsPerChannelDescription": "Maximum total number of users in a channel before users typing messages, @all, @here, and @channel no longer send notifications because of performance.",
	"admin.team.maxNotificationsPerChannelExample": "E.g.: \"1000\"",
	"admin.team.maxNotificationsPerChannelTitle": "Max Notifications Per Channel:",
	"admin.team.maxUsersDescription": "Maximum total number of users per team, including both active and inactive users.",
	"admin.team.maxUsersExample": "E.g.: \"25\"",
	"admin.team.maxUsersTitle": "Max Users Per Team:",
	"admin.team.noBrandImage": "No brand image uploaded",
	"admin.team.openServerDescription": "When true, anyone can signup for a user account on this server without the need to be invited.",
	"admin.team.openServerTitle": "Enable Open Server: ",
	"admin.team.restrictDescription": "Teams and user accounts can only be created from a specific domain (e.g. \"cordchat.org\") or list of comma-separated domains (e.g. \"corp.cordchat.com, cordchat.org\").",
	"admin.team.restrictDirectMessage": "Enable users to open Direct Message channels with:",
	"admin.team.restrictDirectMessageDesc": "'Any user on the Cordchat server' enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. 'Any member of the team' limits the ability to open Direct Message channels to only users who are in the same team.",
	"admin.team.restrictExample": "E.g.: \"corp.cordchat.com, cordchat.org\"",
	"admin.team.restrictNameDesc": "When true, You cannot create a team name with reserved words like www, admin, support, test, channel, etc",
	"admin.team.restrictNameTitle": "Restrict Team Names: ",
	"admin.team.restrictTitle": "Restrict account creation to specified email domains:",
	"admin.team.restrict_direct_message_any": "Any user on the Cordchat server",
	"admin.team.restrict_direct_message_team": "Any member of the team",
	"admin.team.showFullname": "Show first and last name",
	"admin.team.showNickname": "Show nickname if one exists, otherwise show first and last name",
	"admin.team.showUsername": "Show username (default)",
	"admin.team.siteNameDescription": "Name of service shown in login screens and UI.",
	"admin.team.siteNameExample": "E.g.: \"cordchat\"",
	"admin.team.siteNameTitle": "Site Name:",
	"admin.team.teamCreationDescription": "When false, only System Administrators can create teams.",
	"admin.team.teamCreationTitle": "Enable Team Creation: ",
	"admin.team.teammateNameDisplay": "Teammate Name Display:",
	"admin.team.teammateNameDisplayDesc": "Set how to display users' names in posts and the Direct Messages list.",
	"admin.team.upload": "Upload",
	"admin.team.uploadDesc": "Customize your user experience by adding a custom image to your login screen. Recommended maximum image size is less than 2 MB.",
	"admin.team.uploaded": "Uploaded!",
	"admin.team.uploading": "Uploading..",
	"admin.team.userCreationDescription": "When false, the ability to create accounts is disabled. The create account button displays error when pressed.",
	"admin.team.userCreationTitle": "Enable Account Creation: ",
	"admin.team_analytics.activeUsers": "Active Users With Posts",
	"admin.team_analytics.totalPosts": "Total Posts",
	"admin.true": "true",
	"admin.user_item.authServiceEmail": "<strong>Sign-in Method:</strong> Email / Mobile Number",
	"admin.user_item.authServiceNotEmail": "<strong>Sign-in Method:</strong> {service}",
	"admin.user_item.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Cordchat server through a terminal and running the following command.",
	"admin.user_item.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
	"admin.user_item.confirmDemotion": "Confirm Demotion",
	"admin.user_item.confirmDemotionCmd": "platform roles system_admin {username}",
	"admin.user_item.emailTitle": "<strong>Email:</strong> {email}",
	"admin.user_item.inactive": "Inactive",
	"admin.user_item.makeActive": "Activate",
	"admin.user_item.makeInactive": "Deactivate",
	"admin.user_item.makeMember": "Make Member",
	"admin.user_item.makeSysAdmin": "Make System Admin",
	"admin.user_item.makeTeamAdmin": "Make Team Admin",
	"admin.user_item.manageRoles": "Manage Roles",
	"admin.user_item.manageTeams": "Manage Teams",
	"admin.user_item.manageTokens": "Manage Tokens",
	"admin.user_item.member": "Member",
	"admin.user_item.mfaNo": "<strong>MFA</strong>: No",
	"admin.user_item.mfaYes": "<strong>MFA</strong>: Yes",
	"admin.user_item.resetMfa": "Remove MFA",
	"admin.user_item.resetPwd": "Reset Password",
	"admin.user_item.switchToEmail": "Switch to Email/Password",
	"admin.user_item.sysAdmin": "System Admin",
	"admin.user_item.teamAdmin": "Team Admin",
	"admin.user_item.userAccessTokenPostAll": "(with post:all personal access tokens)",
	"admin.user_item.userAccessTokenPostAllPublic": "(with post:channels personal access tokens)",
	"admin.user_item.userAccessTokenYes": "(with personal access tokens)",
	"admin.webrtc.enableDescription": "When true, Cordchat allows making video calls. Video calls are available on Chrome, Firefox and Cordchat Apps.",
	"admin.webrtc.enableTitle": "Enable Video Conference: ",
	"admin.webrtc.gatewayAdminSecretDescription": "Enter your admin secret password to access the Gateway Admin URL.",
	"admin.webrtc.gatewayAdminSecretExample": "E.g.: \"PVRzWNN1Tg6szn7IQWvhpAvLByScWxdy\"",
	"admin.webrtc.gatewayAdminSecretTitle": "Gateway Admin Secret:",
	"admin.webrtc.gatewayAdminUrlDescription": "Enter https://<cordchat-webrtc-gateway-url>:<port>/admin. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. Cordchat WebRTC uses this URL to obtain valid tokens for each peer to establish the connection.",
	"admin.webrtc.gatewayAdminUrlExample": "E.g.: \"https://webrtc.cordchat.com:7089/admin\"",
	"admin.webrtc.gatewayAdminUrlTitle": "Gateway Admin URL:",
	"admin.webrtc.gatewayWebsocketUrlDescription": "Enter wss://<cordchat-webrtc-gateway-url>:<port>. Make sure you use WS or WSS in your URL depending on your server configuration. This is the WebSocket used to signal and establish communication between the peers.",
	"admin.webrtc.gatewayWebsocketUrlExample": "E.g.: \"wss://webrtc.cordchat.com:8189\"",
	"admin.webrtc.gatewayWebsocketUrlTitle": "Gateway WebSocket URL:",
	"admin.webrtc.stunUriDescription": "Enter your STUN URI as stun:<your-stun-url>:<port>. STUN is a standardized network protocol to allow an end host to assist devices to access its public IP address if it is located behind a NAT.",
	"admin.webrtc.stunUriExample": "E.g.: \"stun:webrtc.cordchat.com:5349\"",
	"admin.webrtc.stunUriTitle": "STUN URI:",
	"admin.webrtc.turnSharedKeyDescription": "Enter your TURN Server Shared Key. This is used to created dynamic passwords to establish the connection. Each password is valid for a short period of time.",
	"admin.webrtc.turnSharedKeyExample": "E.g.: \"bXdkOWQxc3d0Ynk3emY5ZmsxZ3NtazRjaWg=\"",
	"admin.webrtc.turnSharedKeyTitle": "TURN Shared Key:",
	"admin.webrtc.turnUriDescription": "Enter your TURN URI as turn:<your-turn-url>:<port>. TURN is a standardized network protocol to allow an end host to assist devices to establish a connection by using a relay public IP address if it is located behind a symmetric NAT.",
	"admin.webrtc.turnUriExample": "E.g.: \"turn:webrtc.cordchat.com:5349\"",
	"admin.webrtc.turnUriTitle": "TURN URI:",
	"admin.webrtc.turnUsernameDescription": "Enter your TURN Server Username.",
	"admin.webrtc.turnUsernameExample": "E.g.: \"myusername\"",
	"admin.webrtc.turnUsernameTitle": "TURN Username:",
	"admin.webserverModeDisabled": "Disabled",
	"admin.webserverModeDisabledDescription": "The Cordchat server will not serve static files.",
	"admin.webserverModeGzip": "gzip",
	"admin.webserverModeGzipDescription": "The Cordchat server will serve static files compressed with gzip.",
	"admin.webserverModeHelpText": "gzip compression applies to static content files. It is recommended to enable gzip to improve performance unless your environment has specific restrictions, such as a web proxy that distributes gzip files poorly.",
	"admin.webserverModeTitle": "Webserver Mode:",
	"admin.webserverModeUncompressed": "Uncompressed",
	"admin.webserverModeUncompressedDescription": "The Cordchat server will serve static files uncompressed.",
	"analytics.chart.loading": "Loading...",
	"analytics.chart.meaningful": "Not enough data for a meaningful representation.",
	"analytics.system.activeUsers": "Active Users With Posts",
	"analytics.system.channelTypes": "Channel Types",
	"analytics.system.dailyActiveUsers": "Daily Active Users",
	"analytics.system.monthlyActiveUsers": "Monthly Active Users",
	"analytics.system.postTypes": "Posts, Files and Hashtags",
	"analytics.system.privateGroups": "Private Channels",
	"analytics.system.publicChannels": "Public Channels",
	"analytics.system.skippedIntensiveQueries": "To maximize performance, some statistics are disabled. You can re-enable them in config.json. See: <a href='https://docs.cordchat.com/administration/statistics.html' target='_blank'>https://docs.cordchat.com/administration/statistics.html</a>",
	"analytics.system.textPosts": "Posts with Text-only",
	"analytics.system.title": "System Statistics",
	"analytics.system.totalChannels": "Total Channels",
	"analytics.system.totalCommands": "Total Commands",
	"analytics.system.totalFilePosts": "Posts with Files",
	"analytics.system.totalHashtagPosts": "Posts with Hashtags",
	"analytics.system.totalIncomingWebhooks": "Incoming Webhooks",
	"analytics.system.totalMasterDbConnections": "Master DB Conns",
	"analytics.system.totalOutgoingWebhooks": "Outgoing Webhooks",
	"analytics.system.totalPosts": "Total Posts",
	"analytics.system.totalReadDbConnections": "Replica DB Conns",
	"analytics.system.totalSessions": "Total Sessions",
	"analytics.system.totalTeams": "Total Teams",
	"analytics.system.totalUsers": "Total Users",
	"analytics.system.totalWebsockets": "WebSocket Conns",
	"analytics.team.activeUsers": "Active Users With Posts",
	"analytics.team.newlyCreated": "Newly Created Users",
	"analytics.team.noTeams": "There are no teams on this server for which to view statistics.",
	"analytics.team.privateGroups": "Private Channels",
	"analytics.team.publicChannels": "Public Channels",
	"analytics.team.recentActive": "Recent Active Users",
	"analytics.team.recentUsers": "Recent Active Users",
	"analytics.team.title": "Team Dashboard for {team}",
	"analytics.team.totalPosts": "Total Posts",
	"analytics.team.totalUsers": "Total Users",
	"api.channel.add_member.added": "{addedUsername} added to the channel by {username}",
	"api.channel.delete_channel.archived": "{username} has archived the channel.",
	"api.channel.join_channel.post_and_forget": "{username} has joined the channel.",
	"api.channel.leave.left": "{username} has left the channel.",
	"api.channel.post_update_channel_displayname_message_and_forget.updated_from": "{username} updated the channel display name from: {old} to: {new}",
	"api.channel.post_update_channel_header_message_and_forget.removed": "{username} removed the channel header (was: {old})",
	"api.channel.post_update_channel_header_message_and_forget.updated_from": "{username} updated the channel header from: {old} to: {new}",
	"api.channel.post_update_channel_header_message_and_forget.updated_to": "{username} updated the channel header to: {new}",
	"api.channel.remove_member.removed": "{removedUsername} was removed from the channel",
	"api.payment.paid_message": "{payerName} completes payment of {currency} {amount} to {payeeName} of {teamName} on {paidAt}.",
	"api.payment.rejected_message": "{payerName} rejects payment request of {currency} {amount} sent from {payeeName} of {teamName} on {rejectAt} since \"{reason}\".",
	"app.channel.post_update_channel_purpose_message.removed": "{username} removed the channel purpose (was: {old})",
	"app.channel.post_update_channel_purpose_message.updated_from": "{username} updated the channel purpose from: {old} to: {new}",
	"app.channel.post_update_channel_purpose_message.updated_to": "{username} updated the channel purpose to: {new}",
	"audit_table.accountActive": "Account activated",
	"audit_table.accountInactive": "Account deactivated",
	"audit_table.action": "Action",
	"audit_table.attemptedAllowOAuthAccess": "Attempted to allow a new OAuth service access",
	"audit_table.attemptedLicenseAdd": "Attempted to add new license",
	"audit_table.attemptedLogin": "Attempted to login",
	"audit_table.attemptedOAuthToken": "Attempted to get an OAuth access token",
	"audit_table.attemptedPassword": "Attempted to change password",
	"audit_table.attemptedRegisterApp": "Attempted to register a new OAuth Application with ID {id}",
	"audit_table.attemptedReset": "Attempted to reset password",
	"audit_table.attemptedWebhookCreate": "Attempted to create a webhook",
	"audit_table.attemptedWebhookDelete": "Attempted to delete a webhook",
	"audit_table.authenticated": "Authenticated",
	"audit_table.by": " by {username}",
	"audit_table.byAdmin": " by an admin",
	"audit_table.channelCreated": "Created the {channelName} channel",
	"audit_table.channelDeleted": "Deleted the channel with the URL {url}",
	"audit_table.establishedDM": "Established a direct message channel with {username}",
	"audit_table.failedExpiredLicenseAdd": "Failed to add a new license as it has either expired or not yet been started",
	"audit_table.failedInvalidLicenseAdd": "Failed to add an invalid license",
	"audit_table.failedLogin": "FAILED login attempt",
	"audit_table.failedOAuthAccess": "Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback",
	"audit_table.failedPassword": "Failed to change password - tried to update user password who was logged in through OAuth",
	"audit_table.failedWebhookCreate": "Failed to create a webhook - bad channel permissions",
	"audit_table.failedWebhookDelete": "Failed to delete a webhook - inappropriate conditions",
	"audit_table.headerUpdated": "Updated the {channelName} channel header",
	"audit_table.ip": "IP Address",
	"audit_table.licenseRemoved": "Successfully removed a license",
	"audit_table.loginAttempt": " (Login attempt)",
	"audit_table.loginFailure": " (Login failure)",
	"audit_table.logout": "Logged out of your account",
	"audit_table.member": "member",
	"audit_table.nameUpdated": "Updated the {channelName} channel name",
	"audit_table.oauthTokenFailed": "Failed to get an OAuth access token - {token}",
	"audit_table.revokedAll": "Revoked all current sessions for the team",
	"audit_table.sentEmail": "Sent an email to {email} to reset your password",
	"audit_table.session": "Session ID",
	"audit_table.sessionRevoked": "The session with id {sessionId} was revoked",
	"audit_table.successfullLicenseAdd": "Successfully added new license",
	"audit_table.successfullLogin": "Successfully logged in",
	"audit_table.successfullOAuthAccess": "Successfully gave a new OAuth service access",
	"audit_table.successfullOAuthToken": "Successfully added a new OAuth service",
	"audit_table.successfullPassword": "Successfully changed password",
	"audit_table.successfullReset": "Successfully reset password",
	"audit_table.successfullWebhookCreate": "Successfully created a webhook",
	"audit_table.successfullWebhookDelete": "Successfully deleted a webhook",
	"audit_table.timestamp": "Timestamp",
	"audit_table.updateGeneral": "Updated the general settings of your account",
	"audit_table.updateGlobalNotifications": "Updated your global notification settings",
	"audit_table.updatePicture": "Updated your profile picture",
	"audit_table.updatedRol": "Updated user role(s) to ",
	"audit_table.userAdded": "Added {username} to the {channelName} channel",
	"audit_table.userId": "User ID",
	"audit_table.userRemoved": "Removed {username} to the {channelName} channel",
	"audit_table.verified": "Sucessfully verified your email address",
	"authorize.access": "Allow <strong>{appName}</strong> access?",
	"authorize.allow": "Allow",
	"authorize.app": "The app <strong>{appName}</strong> would like the ability to access and modify your basic information.",
	"authorize.deny": "Deny",
	"authorize.title": "<strong>{appName}</strong> would like to connect to your <strong>Cordchat</strong> user account",
	"backstage_list.search": "Search",
	"backstage_navbar.backToMattermost": "Back to {siteName}",
	"backstage_sidebar.emoji": "Custom Emoji",
	"backstage_sidebar.integrations": "Integrations",
	"backstage_sidebar.integrations.commands": "Slash Commands",
	"backstage_sidebar.integrations.incoming_webhooks": "Incoming Webhooks",
	"backstage_sidebar.integrations.oauthApps": "OAuth 2.0 Applications",
	"backstage_sidebar.integrations.outgoing_webhooks": "Outgoing Webhooks",
	"calling_screen": "Calling",
	"center_panel.recent": "Click here to jump to recent messages. ",
	"change_url.close": "Close",
	"change_url.endWithLetter": "URL must end with a letter or number.",
	"change_url.invalidUrl": "Invalid URL",
	"change_url.longer": "URL must be two or more characters.",
	"change_url.noUnderscore": "URL can not contain two underscores in a row.",
	"change_url.startWithLetter": "URL must start with a letter or number.",
	"change_url.urlLabel": "Channel URL",
	"channelHeader.addToFavorites": "Add to Favorites",
	"channelHeader.removeFromFavorites": "Remove from Favorites",
	"channel_flow.alreadyExist": "A channel with that URL already exists",
	"channel_flow.changeUrlDescription": "Some characters are not allowed in URLs and may be removed.",
	"channel_flow.changeUrlTitle": "Change Channel URL",
	"channel_flow.create": "Create Channel",
	"channel_flow.handleTooShort": "Channel URL must be 2 or more lowercase alphanumeric characters",
	"channel_flow.invalidName": "Invalid Channel Name",
	"channel_flow.set_url_title": "Set Channel URL",
	"channel_header.addChannelHeader": "Add a channel description",
	"channel_header.addMembers": "Add Members",
	"channel_header.addToFavorites": "Add to Favorites",
	"channel_header.channelHeader": "Edit Channel Header",
	"channel_header.channelMembers": "Members",
	"channel_header.delete": "Delete Channel",
	"channel_header.flagged": "Flagged Posts",
	"channel_header.leave": "Leave Channel",
	"channel_header.manageMembers": "Manage Members",
	"channel_header.notificationPreferences": "Notification Preferences",
	"channel_header.pinnedPosts": "Pinned Posts",
	"channel_header.recentMentions": "Recent Mentions",
	"channel_header.removeFromFavorites": "Remove from Favorites",
	"channel_header.rename": "Rename Channel",
	"channel_header.setHeader": "Edit Channel Header",
	"channel_header.setPurpose": "Edit Channel Purpose",
	"channel_header.viewInfo": "View Info",
	"channel_header.viewMembers": "View Members",
	"channel_header.webrtc.call3": "Live",
	"channel_header.webrtc.call2": "Voice Call",
	"channel_header.webrtc.call": "Video Call",
	"channel_header.webrtc.offline": "The user is offline",
	"channel_header.webrtc.unavailable": "New call unavailable until your existing call ends",
	"channel_info.about": "About",
	"channel_info.close": "Close",
	"channel_info.header": "Header:",
	"channel_info.id": "ID: ",
	"channel_info.name": "Name:",
	"channel_info.notFound": "No Channel Found",
	"channel_info.purpose": "Purpose:",
	"channel_info.url": "URL:",
	"channel_invite.add": " Add",
	"channel_invite.addNewMembers": "Add New Members to ",
	"channel_invite.close": "Close",
	"channel_loader.connection_error": "There appears to be a problem with your internet connection.",
	"channel_loader.posted": "Posted",
	"channel_loader.postedImage": " posted an image",
	"channel_loader.socketError": "Please check connection, Cordchat unreachable. If issue persists, ask administrator to check WebSocket port.",
	"channel_loader.someone": "Someone",
	"channel_loader.something": " did something new",
	"channel_loader.unknown_error": "We received an unexpected status code from the server.",
	"channel_loader.uploadedFile": " uploaded a file",
	"channel_loader.uploadedImage": " uploaded an image",
	"channel_loader.wrote": " wrote: ",
	"channel_members_dropdown.channel_admin": "Channel Admin",
	"channel_members_dropdown.channel_member": "Channel Member",
	"channel_members_dropdown.channel_guest": "Channel Guest",
	"channel_members_dropdown.make_channel_admin": "Make Channel Admin",
	"channel_members_dropdown.make_channel_member": "Make Channel Member",
	"channel_members_dropdown.make_channel_guest": "Make Channel Guest",
	"channel_members_dropdown.remove_from_channel": "Remove From Channel",
	"channel_members_dropdown.remove_member": "Remove Member",
	"channel_members_modal.addNew": " Add New Members",
	"channel_members_modal.members": " Members",
	"channel_modal.cancel": "Cancel",
	"channel_modal.createNew": "Create New Channel",
	"channel_modal.descriptionHelp": "Describe how this channel should be used.",
	"channel_modal.displayNameError": "Channel name must be 2 or more characters",
	"channel_modal.edit": "Edit",
	"channel_modal.header": "Header",
	"channel_modal.headerEx": "E.g.: \"[Link Title](http://example.com)\"",
	"channel_modal.headerHelp": "Set text that will appear in the header of the channel beside the channel name. For example, include frequently used links by typing [Link Title](http://example.com).",
	"channel_modal.modalTitle": "New Channel",
	"channel_modal.name": "Channel Name",
	"channel_modal.nameEx": "E.g.: \"Bugs\", \"Marketing\", \"客户支持\"",
	"channel_modal.optional": "(optional)",
	"channel_modal.privateGroup1": "Create a new private channel with restricted membership. ",
	"channel_modal.privateGroup2": "Create a private channel",
	"channel_modal.publicChannel1": "Create a public channel",
	"channel_modal.publicChannel2": "Create a new public channel anyone can join. ",
	"channel_modal.purpose": "Purpose",
	"channel_modal.purposeEx": "E.g.: \"A channel to file bugs and improvements\"",
	"channel_notifications.allActivity": "For all activity",
	"channel_notifications.allUnread": "For all unread messages",
	"channel_notifications.globalDefault": "Global default ({notifyLevel})",
	"channel_notifications.markUnread": "Mark Channel Unread",
	"channel_notifications.never": "Never",
	"channel_notifications.onlyMentions": "Only for mentions",
	"channel_notifications.override": "Selecting an option other than \"Default\" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.",
	"channel_notifications.overridePush": "Selecting an option other than \"Global default\" will override the global notification settings for mobile push notifications in account settings. Push notifications must be enabled by the System Admin.",
	"channel_notifications.preferences": "Notification Preferences for ",
	"channel_notifications.push": "Send mobile push notifications",
	"channel_notifications.sendDesktop": "Send desktop notifications",
	"channel_notifications.unreadInfo": "The channel name is bolded in the sidebar when there are unread messages. Selecting \"Only for mentions\" will bold the channel only when you are mentioned.",
	"channel_select.placeholder": "--- Select a channel ---",
	"channel_switch_modal.dm": "(Direct Message)",
	"channel_switch_modal.failed_to_open": "Failed to open channel.",
	"channel_switch_modal.not_found": "No matches found.",
	"channel_switch_modal.submit": "Switch",
	"channel_switch_modal.title": "Switch Channels",
	"claim.account.noEmail": "No email specified",
	"claim.email_to_ldap.enterLdapPwd": "Enter the ID and password for your AD/LDAP account",
	"claim.email_to_ldap.enterPwd": "Enter the password for your {site} email account",
	"claim.email_to_ldap.ldapId": "AD/LDAP ID",
	"claim.email_to_ldap.ldapIdError": "Please enter your AD/LDAP ID.",
	"claim.email_to_ldap.ldapPasswordError": "Please enter your AD/LDAP password.",
	"claim.email_to_ldap.ldapPwd": "AD/LDAP Password",
	"claim.email_to_ldap.pwd": "Password",
	"claim.email_to_ldap.pwdError": "Please enter your password.",
	"claim.email_to_ldap.ssoNote": "You must already have a valid AD/LDAP account",
	"claim.email_to_ldap.ssoType": "Upon claiming your account, you will only be able to login with AD/LDAP",
	"claim.email_to_ldap.switchTo": "Switch account to AD/LDAP",
	"claim.email_to_ldap.title": "Switch Email/Password Account to AD/LDAP",
	"claim.email_to_oauth.enterPwd": "Enter the password for your {site} account",
	"claim.email_to_oauth.pwd": "Password",
	"claim.email_to_oauth.pwdError": "Please enter your password.",
	"claim.email_to_oauth.ssoNote": "You must already have a valid {type} account",
	"claim.email_to_oauth.ssoType": "Upon claiming your account, you will only be able to login with {type}",
	"claim.email_to_oauth.switchTo": "Switch account to {uiType}",
	"claim.email_to_oauth.title": "Switch Email/Password Account to {uiType}",
	"claim.ldap_to_email.confirm": "Confirm Password",
	"claim.ldap_to_email.email": "You will use the email {email} to login",
	"claim.ldap_to_email.enterLdapPwd": "Enter your {ldapPassword} for your {site} email account",
	"claim.ldap_to_email.enterPwd": "Enter a new password for your email account",
	"claim.ldap_to_email.ldapPasswordError": "Please enter your AD/LDAP password.",
	"claim.ldap_to_email.ldapPwd": "AD/LDAP Password",
	"claim.ldap_to_email.pwd": "Password",
	"claim.ldap_to_email.pwdError": "Please enter your password.",
	"claim.ldap_to_email.pwdNotMatch": "Passwords do not match.",
	"claim.ldap_to_email.ssoType": "Upon claiming your account, you will only be able to login with your email and password",
	"claim.ldap_to_email.switchTo": "Switch account to email/password",
	"claim.ldap_to_email.title": "Switch AD/LDAP Account to Email/Password",
	"claim.oauth_to_email.confirm": "Confirm Password",
	"claim.oauth_to_email.description": "Upon changing your account type, you will only be able to login with your email and password.",
	"claim.oauth_to_email.enterNewPwd": "Enter a new password for your {site} email account",
	"claim.oauth_to_email.enterPwd": "Please enter a password.",
	"claim.oauth_to_email.newPwd": "New Password",
	"claim.oauth_to_email.pwdNotMatch": "Password do not match.",
	"claim.oauth_to_email.switchTo": "Switch {type} to email and password",
	"claim.oauth_to_email.title": "Switch {type} Account to Email",
	"confirm_modal.cancel": "Cancel",
	"connecting_screen": "Connecting",
	"create_comment.addComment": "Add a comment...",
	"create_comment.comment": "Add Comment",
	"create_comment.commentLength": "Comment length must be less than {max} characters.",
	"create_comment.commentTitle": "Comment",
	"create_comment.file": "File uploading",
	"create_comment.files": "Files uploading",
	"create_post.comment": "Comment",
	"create_post.error_message": "Your message is too long. Character count: {length}/{limit}",
	"create_post.post": "Post",
	"create_post.shortcutsNotSupported": "Keyboard shortcuts are not supported on your device.",
	"create_post.tutorialTip": "<h4>Sending Messages</h4><p>Type here to write a message and press <strong>ENTER</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>",
	"create_post.write": "Write a message...",
	"create_team.agreement": "By proceeding to create your account and use {siteName}, you agree to our <a href={TermsOfServiceLink}>Terms of Service</a> and <a href={PrivacyPolicyLink}>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.",
	"create_team.display_name.charLength": "Name must be {min} or more characters up to a maximum of {max}. You can add a longer team description later.",
	"create_team.display_name.nameHelp": "Name your team in any language. Your team name shows in menus and headings.",
	"create_team.display_name.next": "Next",
	"create_team.display_name.required": "This field is required",
	"create_team.display_name.teamName": "Team Name",
	"create_team.team_url.back": "Back to previous step",
	"create_team.team_url.charLength": "Name must be {min} or more characters up to a maximum of {max}",
	"create_team.team_url.creatingTeam": "Creating team...",
	"create_team.team_url.finish": "Finish",
	"create_team.team_url.hint": "<li>Short and memorable is best</li><li>Use lowercase letters, numbers and dashes</li><li>Must start with a letter and can't end in a dash</li>",
	"create_team.team_url.regex": "Use only lowercase letters, numbers and dashes. Must start with a letter(lowercase) and can't end in a dash.",
	"create_team.team_url.regex1": "URL must start with a letter(lowercase).",
	"create_team.team_url.regex2": "URL cannot contain space.",
	"create_team.team_url.regex3": "URL cannot contain uppercase letter.",
	"create_team.team_url.required": "This field is required",
	"create_team.team_url.taken": "This URL starts with a reserved word or is unavailable. Please try another.",
	"create_team.team_url.teamUrl": "Team URL",
	"create_team.team_url.unavailable": "This URL is taken or unavailable. Please try another.",
	"create_team.team_url.webAddress": "Choose the web address of your new team:",
	"custom_emoji.empty": "No custom emoji found",
	"custom_emoji.header": "Custom Emoji",
	"custom_emoji.search": "Search Custom Emoji",
	"deactivate_member_modal.cancel": "Cancel",
	"deactivate_member_modal.deactivate": "Deactivate",
	"deactivate_member_modal.desc": "This action deactivates {username}. They will be logged out and not have access to any teams or channels on this system. Are you sure you want to deactivate {username}?",
	"deactivate_member_modal.title": "Deactivate {username}",
	"default_channel.purpose": "Post messages here that you want everyone to see. Everyone automatically becomes a permanent member of this channel when they join the team.",
	"delete_channel.cancel": "Cancel",
	"delete_channel.confirm": "Confirm DELETE Channel",
	"delete_channel.del": "Delete",
	"delete_channel.question": "This will delete the channel from the team and make its contents inaccessible for all users. <br /><br />Are you sure you wish to delete the <strong>{display_name}</strong> channel?",
	"delete_post.cancel": "Cancel",
	"delete_post.comment": "Comment",
	"delete_post.confirm": "Confirm {term} Delete",
	"delete_post.del": "Delete",
	"delete_post.post": "Post",
	"delete_post.question": "Are you sure you want to delete this {term}?",
	"delete_post.warning": "This post has {count, number} {count, plural, one {comment} other {comments}} on it.",
	"edit_channel_header.editHeader": "Edit the Channel Header...",
	"edit_channel_header.previewHeader": "Edit header",
	"edit_channel_header_modal.cancel": "Cancel",
	"edit_channel_header_modal.description": "Edit the text appearing next to the channel name in the channel header.",
	"edit_channel_header_modal.error": "This channel header is too long, please enter a shorter one",
	"edit_channel_header_modal.save": "Save",
	"edit_channel_header_modal.title": "Edit Header for {channel}",
	"edit_channel_header_modal.title_dm": "Edit Header",
	"edit_channel_private_purpose_modal.body": "This text appears in the \"View Info\" modal of the private channel.",
	"edit_channel_purpose_modal.body": "Describe how this channel should be used. This text appears in the channel list in the \"More...\" menu and helps others decide whether to join.",
	"edit_channel_purpose_modal.cancel": "Cancel",
	"edit_channel_purpose_modal.error": "This channel purpose is too long, please enter a shorter one",
	"edit_channel_purpose_modal.save": "Save",
	"edit_channel_purpose_modal.title1": "Edit Purpose",
	"edit_channel_purpose_modal.title2": "Edit Purpose for ",
	"edit_channel_wvc_purpose_modal.body": "This text appears in the \"View Info\" modal of the web visitor center.",
	"edit_command.save": "Update",
	"edit_post.cancel": "Cancel",
	"edit_post.edit": "Edit {title}",
	"edit_post.editPost": "Edit the post...",
	"edit_post.save": "Save",
	"email_signup.address": "Email Address",
	"email_signup.createTeam": "Create Team",
	"email_signup.emailError": "Please enter a valid email address.",
	"email_signup.find": "Find my teams",
	"email_verify.almost": "{siteName}: You are almost done",
	"email_verify.failed": " Failed to send verification email.",
	"email_verify.notVerifiedBody": "Please verify your email address. Check your inbox for an email.",
	"email_verify.resend": "Resend Email",
	"email_verify.sent": " Verification email sent.",
	"email_verify.verified": "{siteName} Email Verified",
	"email_verify.verifiedBody": "<p>Your email has been verified! Click <a href={url}>here</a> to log in.</p>",
	"email_verify.verifyFailed": "Failed to verify your email.",
	"emoji_list.actions": "Actions",
	"emoji_list.add": "Add Custom Emoji",
	"emoji_list.creator": "Creator",
	"emoji_list.delete": "Delete",
	"emoji_list.delete.confirm.button": "Delete",
	"emoji_list.delete.confirm.msg": "This action permanently deletes the custom emoji. Are you sure you want to delete it?",
	"emoji_list.delete.confirm.title": "Delete Custom Emoji",
	"emoji_list.empty": "No Custom Emoji Found",
	"emoji_list.header": "Custom Emoji",
	"emoji_list.help": "Custom emoji are available to everyone on your server. Type ':' in a message box to bring up the emoji selection menu. Other users may need to refresh the page before new emojis appear.",
	"emoji_list.help2": "Tip: If you add #, ##, or ### as the first character on a new line containing emoji, you can use larger sized emoji. To try it out, send a message such as: '# :smile:'.",
	"emoji_list.image": "Image",
	"emoji_list.name": "Name",
	"emoji_list.search": "Search Custom Emoji",
	"emoji_list.somebody": "Somebody on another team",
	"emoji_picker.activity": "Activity",
	"emoji_picker.activities": "Activities",
	"emoji_picker.custom": "Custom",
	"emoji_picker.emojiPicker": "Emoji Picker",
	"emoji_picker.smileys_emotion": "Emoji",
	"emoji_picker.flags": "Flags",
	"emoji_picker.foods": "Foods",
	"emoji_picker.food_drink": "Foods",
	"emoji_picker.nature": "Nature",
	"emoji_picker.animals_nature": "Nature",
	"emoji_picker.objects": "Objects",
	"emoji_picker.people": "People",
	"emoji_picker.people_body": "People",
	"emoji_picker.places": "Places",
	"emoji_picker.travel_places": "Places",
	"emoji_picker.recent": "Recently Used",
	"emoji_picker.search": "Search",
	"emoji_picker.symbols": "Symbols",
	"error.local_storage.title": "Cannot Load Cordchat",
	"error.local_storage.help1": "Enable cookies",
	"error.local_storage.help2": "Turn off private browsing",
	"error.local_storage.help3": "Use a supported browser (IE 11, Chrome 43+, Firefox 38+, Safari 9, Edge)",
	"error.local_storage.message": "Cordchat was unable to load because a setting in your browser prevents the use of its local storage features. To allow Cordchat to load, try the following actions:",
	"error.not_found.link_message": "Back to Cordchat",
	"error.generic.link_message": "Back to Cordchat",
	"error.not_found.message": "The page you were trying to reach does not exist",
	"error.not_found.title": "Page not found",
	"error_bar.expired": "Enterprise license is expired and some features may be disabled. <a href='{link}' target='_blank'>Please renew</a>.",
	"error_bar.expiring": "Enterprise license expires on {date}. <a href='{link}' target='_blank'>Please renew</a>.",
	"error_bar.past_grace": "Enterprise license is expired and some features may be disabled. Please contact your System Administrator for details.",
	"error_bar.preview_mode": "Preview Mode: Email notifications have not been configured",
	"error_bar.site_url": "Please configure your {docsLink} in the {link}.",
	"error_bar.site_url.docsLink": "Site URL",
	"error_bar.site_url.link": "System Console",
	"error_bar.site_url_gitlab": "Please configure your {docsLink} in the System Console or in gitlab.rb if you're using GitLab Cordchat.",
	"file_attachment.scan_pending": "Security scan in progress",
	"file_attachment.scan_infected": "Blocked: threat detected",
	"file_attachment.scan_error": "Security scan failed",
	"file_attachment.download": "Download",
	"file_info_preview.size": "Size ",
	"file_info_preview.scan_pending": "This file is being scanned for security threats. It can be downloaded once the scan has finished.",
	"file_info_preview.scan_infected": "The security scan detected a threat in this file. It has been blocked.",
	"file_info_preview.scan_error": "The security scan of this file could not be completed. Please contact your system administrator.",
	"file_info_preview.type": "File type ",
	"file_upload.disabled": "File attachments are disabled.",
	"file_upload.fileAbove": "File above {max}MB cannot be uploaded: {filename}",
	"file_upload.filesAbove": "Files above {max}MB cannot be uploaded: {filenames}",
	"file_upload.limited": "Uploads limited to {count, number} files maximum. Please use additional posts for more files.",
	"file_upload.pasted": "Image Pasted at ",
	"filtered_channels_list.search": "Search channels",
	"filtered_channels_list.count": "{count, number} {count, plural, one {channel} other {channels}}",
	"filtered_channels_list.countTotal": "{count, number} {count, plural, one {channel} other {channels}} of {total, number} total",
	"filtered_user_list.any_team": "All Users",
	"filtered_user_list.count": "{count, number} {count, plural, one {member} other {members}}",
	"filtered_user_list.countTotal": "{count, number} {count, plural, one {member} other {members}} of {total, number} total",
	"filtered_user_list.countTotalPage": "{startCount, number} - {endCount, number} {count, plural, one {member} other {members}} of {total, number} total",
	"filtered_user_list.member": "Member",
	"filtered_user_list.next": "Next",
	"filtered_user_list.prev": "Previous",
	"filtered_user_list.search": "Search users",
	"filtered_user_list.searchButton": "Search",
	"filtered_user_list.show": "Filter:",
	"filtered_user_list.team_only": "Members of this Team",
	"find_team.email": "Email",
	"find_team.findDescription": "An email was sent with links to any teams to which you are a member.",
	"find_team.findTitle": "Find Your Team",
	"find_team.getLinks": "Get an email with links to any teams to which you are a member.",
	"find_team.placeholder": "you@domain.com",
	"find_team.send": "Send",
	"find_team.submitError": "Please enter a valid email address",
	"flag_post.flag": "Flag for follow up",
	"flag_post.unflag": "Unflag",
	"general_tab.chooseDescription": "Please choose a new description for your team",
	"general_tab.codeDesc": "Click 'Edit' to regenerate Invite Code.",
	"general_tab.codeLongDesc": "The Invite Code is used as part of the URL in the team invitation link created by {getTeamInviteLink} in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.",
	"general_tab.codeTitle": "Invite Code",
	"general_tab.emptyDescription": "Click 'Edit' to add a team description.",
	"general_tab.getTeamInviteLink": "Get Public Invitation Link",
	"general_tab.includeDirDesc": "Including this team will display the team name from the Team Directory section of the Home Page, and provide a link to the sign-in page.",
	"general_tab.no": "No",
	"general_tab.openInviteDesc": "When allowed, a link to this team will be included on the landing page allowing anyone with an account to join this team.",
	"general_tab.openInviteTitle": "Allow any user with an account on this server to join this team",
	"general_tab.regenerate": "Regenerate",
	"general_tab.required": "This field is required",
	"general_tab.teamDescription": "Team Description",
	"general_tab.teamDescriptionInfo": "Team description provides additional information to help users select the right team. Maximum of 200 characters.",
	"general_tab.teamName": "Team Name",
	"general_tab.teamNameInfo": "Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.",
	"general_tab.title": "General Settings",
	"general_tab.yes": "Yes",
	"get_app.alreadyHaveIt": "Already have it?",
	"get_app.androidAppName": "Cordchat for Android",
	"get_app.androidHeader": "Cordchat works best if you switch to our Android app",
	"get_app.continue": "continue",
	"get_app.continueWithBrowser": "Or {link}",
	"get_app.continueWithBrowserLink": "continue with browser",
	"get_app.iosHeader": "Cordchat works best if you switch to our iPhone app",
	"get_app.mattermostInc": "Cordchat, Inc",
	"get_app.openMattermost": "Open Cordchat",
	"get_link.clipboard": " Link copied",
	"get_link.close": "Close",
	"get_link.copy": "Copy Link",
	"get_post_link_modal.help": "The link below allows authorized users to see your post.",
	"get_post_link_modal.title": "Copy Permalink",
	"get_public_link_modal.help": "The link below allows anyone to see this file without being registered on this server.",
	"get_public_link_modal.title": "Copy Public Link",
	"get_team_invite_link_modal.help": "Send teammates the link below for them to sign-up to this team site. The Public Invitation Link can be shared with multiple teammates as it does not change unless it's regenerated in Team Settings by a Team Admin.",
	"get_team_invite_link_modal.helpDisabled": "User creation has been disabled for your team. Please ask your Team Administrator for details.",
	"get_team_invite_link_modal.title": "Public Invitation Link",
	"help.attaching.downloading": "#### Downloading Files\nDownload an attached file by clicking the download icon next to the file thumbnail or by opening the file previewer and clicking **Download**.",
	"help.attaching.dragdrop": "#### Drag and Drop\nUpload a file or selection of files by dragging the files from your computer into the right-hand sidebar or center pane. Dragging and dropping attaches the files to the message input box, then you can optionally type a message and press **ENTER** to post.",
	"help.attaching.icon": "#### Attachment Icon\nAlternatively, upload files by clicking the grey paperclip icon inside the message input box. This opens up your system file viewer where you can navigate to the desired files and then click **Open** to upload the files to the message input box. Optionally type a message and then press **ENTER** to post.",
	"help.attaching.limitations": "## File Size Limitations\nCordchat supports a maximum of five attached files per post, each with a maximum file size of 50Mb.",
	"help.attaching.methods": "## Attachment Methods\nAttach a file by drag and drop or by clicking the attachment icon in the message input box.",
	"help.attaching.notSupported": "Document preview (Word, Excel, PPT) is not yet supported.",
	"help.attaching.pasting": "#### Pasting Images\nOn Chrome and Edge browsers, it is also possible to upload files by pasting them from the clipboard. This is not yet supported on other browsers.",
	"help.attaching.previewer": "## File Previewer\nCordchat has a built in file previewer that is used to view media, download files and share public links. Click the thumbnail of an attached file to open it in the file previewer.",
	"help.attaching.publicLinks": "#### Sharing Public Links\nPublic links allow you to share file attachments with people outside your Cordchat team. Open the file previewer by clicking on the thumbnail of an attachment, then click **Get Public Link**. This opens a dialog box with a link to copy. When the link is shared and opened by another user, the file will automatically download.",
	"help.attaching.publicLinks2": "If **Get Public Link** is not visible in the file previewer and you prefer the feature enabled, you can request that your System Admin enable the feature from the System Console under **Security** > **Public Links**.",
	"help.attaching.supported": "#### Supported Media Types\nIf you are trying to preview a media type that is not supported, the file previewer will open a standard media attachment icon. Supported media formats depend heavily on your browser and operating system, but the following formats are supported by Cordchat on most browsers:",
	"help.attaching.supportedList": "- Images: BMP, GIF, JPG, JPEG, PNG\n- Video: MP4\n- Audio: MP3, M4A\n- Documents: PDF",
	"help.attaching.title": "# Attaching Files\n_____",
	"help.commands.builtin": "## Built-in Commands\nThe following slash commands are available on all Cordchat installations:",
	"help.commands.builtin2": "Begin by typing `/` and a list of slash command options appears above the text input box. The autocomplete suggestions help by providing a format example in black text and a short description of the slash command in grey text.",
	"help.commands.custom": "## Custom Commands\nCustom slash commands integrate with external applications. For example, a team might configure a custom slash command to check internal health records with `/patient joe smith` or check the weekly weather forecast in a city with `/weather toronto week`. Check with your System Admin or open the autocomplete list by typing `/` to determine if your team configured any custom slash commands.",
	"help.commands.custom2": "Custom slash commands are disabled by default and can be enabled by the System Admin in the **System Console** > **Integrations** > **Webhooks and Commands**. Learn about configuring custom slash commands on the [developer slash command documentation page](http://docs.cordchat.com/developer/slash-commands.html).",
	"help.commands.intro": "Slash commands perform operations in Cordchat by typing into the text input box. Enter a `/` followed by a command and some arguments to perform actions.\n\nBuilt-in slash commands come with all Cordchat installations and custom slash commands are configurable to interact with external applications.",
	"help.commands.title": "# Executing Commands\n___",
	"help.composing.deleting": "## Deleting a message\nDelete a message by clicking the **[...]** icon next to any message text that you’ve composed, then click **Delete**. System and Team Admins can delete any message on their system or team.",
	"help.composing.editing": "## Editing a Message\nEdit a message by clicking the **[...]** icon next to any message text that you’ve composed, then click **Edit**. After making modifications to the message text, press **ENTER** to save the modifications. Message edits do not trigger new @mention notifications, desktop notifications or notification sounds.",
	"help.composing.linking": "## Linking to a message\nThe **Permalink** feature creates a link to any message. Sharing this link with other users in the channel lets them view the linked message in the Message Archives. Users who are not a member of the channel where the message was posted cannot view the permalink. Get the permalink to any message by clicking the **[...]** icon next to the message text > **Permalink** > **Copy Link**.",
	"help.composing.posting": "## Posting a Message\nWrite a message by typing into the text input box, then press ENTER to send it. Use SHIFT+ENTER to create a new line without sending a message. To send messages by pressing CTRL+ENTER go to **Main Menu > Account Settings > Send messages on CTRL+ENTER**.",
	"help.composing.posts": "#### Posts\nPosts can be considered parent messages. They are the messages that often start a thread of replies. Posts are composed and sent from the text input box at the bottom of the center pane.",
	"help.composing.replies": "#### Replies\nReply to a message by clicking the reply icon next to any message text. This action opens the right-hand sidebar where you can see the message thread, then compose and send your reply. Replies are indented slightly in the center pane to indicate that they are child messages of a parent post.\n\nWhen composing a reply in the right-hand side, click the expand/collapse icon with two arrows at the top of the sidebar to make things easier to read.",
	"help.composing.title": "# Sending Messages\n_____",
	"help.composing.types": "## Message Types\nReply to posts to keep conversations organized in threads.",
	"help.formatting.checklist": "Make a task list by including square brackets:",
	"help.formatting.checklistExample": "- [ ] Item one\n- [ ] Item two\n- [x] Completed item",
	"help.formatting.code": "## Code Block\n\nCreate a code block by indenting each line by four spaces, or by placing ``` on the line above and below your code.",
	"help.formatting.codeBlock": "Code block",
	"help.formatting.emojiExample": ":smile: :+1: :sheep:",
	"help.formatting.emojis": "## Emojis\n\nOpen the emoji autocomplete by typing `:`. A full list of emojis can be found [here](http://www.emoji-cheat-sheet.com/). It is also possible to create your own Custom Emoji if the emoji you want to use doesn't exist.",
	"help.formatting.example": "Example:",
	"help.formatting.defaultTheme": "**Default Theme**",
	"help.formatting.headings": "## Headings\n\nMake a heading by typing # and a space before your title. For smaller headings, use more #’s.",
	"help.formatting.headings2": "Alternatively, you can underline the text using `===` or `---` to create headings.",
	"help.formatting.headings2Example": "Large Heading\n-------------",
	"help.formatting.headingsExample": "## Large Heading\n### Smaller Heading\n#### Even Smaller Heading",
	"help.formatting.images": "## In-line Images\n\nCreate in-line images using an `!` followed by the alt text in square brackets and the link in normal brackets. Add hover text by placing it in quotes after the link.",
	"help.formatting.imagesExample": "![alt text](link \"hover text\")\n\nand\n\n[![Build Status](https://travis-ci.org/cordchat/platform.svg?branch=master)](https://travis-ci.org/cordchat/platform) [![Github](https://assets-cdn.github.com/favicon.ico)](https://github.com/cordchat/platform)",
	"help.formatting.inline": "## In-line Code\n\nCreate in-line monospaced font by surrounding it with backticks.",
	"help.formatting.intro": "Markdown makes it easy to format messages. Type a message as you normally would, and use these rules to render it with special formatting.",
	"help.formatting.lines": "## Lines\n\nCreate a line by using three `*`, `_`, or `-`.",
	"help.formatting.linkEx": "[Check out Cordchat!]",
	"help.formatting.links": "## Links\n\nCreate labeled links by putting the desired text in square brackets and the associated link in normal brackets.",
	"help.formatting.listExample": "* list item one\n* list item two\n    * item two sub-point",
	"help.formatting.lists": "## Lists\n\nCreate a list by using `*` or `-` as bullets. Indent a bullet point by adding two spaces in front of it.",
	"help.formatting.funTheme": "**Fun Theme**",
	"help.formatting.ordered": "Make it an ordered list by using numbers instead:",
	"help.formatting.orderedExample": "1. Item one\n2. Item two",
	"help.formatting.quotes": "## Block quotes\n\nCreate block quotes using `>`.",
	"help.formatting.quotesExample": "`> block quotes` renders as:",
	"help.formatting.quotesRender": "> block quotes",
	"help.formatting.renders": "Renders as:",
	"help.formatting.familyThemeTheme": "**Family Theme**",
	"help.formatting.solirizedLightTheme": "**Solarized Light Theme**",
	"help.formatting.style": "## Text Style\n\nYou can use either `_` or `*` around a word to make it italic. Use two to make it bold.\n\n* `_italics_` renders as _italics_\n* `**bold**` renders as **bold**\n* `**_bold-italic_**` renders as **_bold-italics_**\n* `~~strikethrough~~` renders as ~~strikethrough~~",
	"help.formatting.supportedSyntax": "Supported languages are:\n`as`, `applescript`, `osascript`, `scpt`, `bash`, `sh`, `zsh`, `clj`, `boot`, `cl2`, `cljc`, `cljs`, `cljs.hl`, `cljscm`, `cljx`, `hic`, `coffee`, `_coffee`, `cake`, `cjsx`, `cson`, `iced`, `cpp`, `c`, `cc`, `h`, `c++`, `h++`, `hpp`, `cs`, `csharp`, `css`, `d`, `di`, `dart`, `delphi`, `dpr`, `dfm`, `pas`, `pascal`, `freepascal`, `lazarus`, `lpr`, `lfm`, `diff`, `django`, `jinja`, `dockerfile`, `docker`, `erl`, `f90`, `f95`, `fsharp`, `fs`, `gcode`, `nc`, `go`, `groovy`, `handlebars`, `hbs`, `html.hbs`, `html.handlebars`, `hs`, `hx`, `java`, `jsp`, `js`, `jsx`, `json`, `jl`, `kt`, `ktm`, `kts`, `less`, `lisp`, `lua`, `mk`, `mak`, `md`, `mkdown`, `mkd`, `matlab`, `m`, `mm`, `objc`, `obj-c`, `ml`, `perl`, `pl`, `php`, `php3`, `php4`, `php5`, `php6`, `ps`, `ps1`, `pp`, `py`, `gyp`, `r`, `ruby`, `rb`, `gemspec`, `podspec`, `thor`, `irb`, `rs`, `scala`, `scm`, `sld`, `scss`, `st`, `sql`, `swift`, `tex`, `vbnet`, `vb`, `bas`, `vbs`, `v`, `veo`, `xml`, `html`, `xhtml`, `rss`, `atom`, `xsl`, `plist`, `yaml`",
	"help.formatting.syntax": "### Syntax Highlighting\n\nTo add syntax highlighting, type the language to be highlighted after the ``` at the beginning of the code block. Cordchat also offers four different code themes (GitHub, Solarized Dark, Solarized Light, Monokai) that can be changed in **Account Settings** > **Display** > **Theme** > **Custom Theme** > **Center Channel Styles**",
	"help.formatting.syntaxEx": "    package main\n    import \"fmt\"\n    func main() {\n        fmt.Println(\"Hello, 世界\")\n    }",
	"help.formatting.tableExample": "| Left-Aligned  | Center Aligned  | Right Aligned |\n| :------------ |:---------------:| -----:|\n| Left column 1 | this text       |  $100 |\n| Left column 2 | is              |   $10 |\n| Left column 3 | centered        |    $1 |",
	"help.formatting.tables": "## Tables\n\nCreate a table by placing a dashed line under the header row and separating the columns with a pipe `|`. (The columns don’t need to line up exactly for it to work). Choose how to align table columns by including colons `:` within the header row.",
	"help.formatting.title": "# Formatting Text\n_____",
	"help.learnMore": "Learn more about:",
	"help.link.attaching": "Attaching Files",
	"help.link.commands": "Executing Commands",
	"help.link.composing": "Composing Messages and Replies",
	"help.link.formatting": "Formatting Messages using Markdown",
	"help.link.mentioning": "Mentioning Teammates",
	"help.link.messaging": "Basic Messaging",
	"help.link.photoCompression": "Photo Compression",
	"help.link.wvc": "Web Visitor Center (WVC)",
	"help.mentioning.channel": "#### @Channel\nYou can mention an entire channel by typing `@channel`. All members of the channel will receive a mention notification that behaves the same way as if the members had been mentioned personally.",
	"help.mentioning.channelExample": "@channel great work on interviews this week. I think we found some excellent potential candidates!",
	"help.mentioning.mentions": "## @Mentions\nUse @mentions to get the attention of specific team members.",
	"help.mentioning.recent": "## Recent Mentions\nClick `@` next to the search box to query for your most recent @mentions and words that trigger mentions. Click **Jump** next to a search result in the right-hand sidebar to jump the center pane to the channel and location of the message with the mention.",
	"help.mentioning.title": "# Mentioning Teammates\n_____",
	"help.mentioning.triggers": "## Words That Trigger Mentions\nIn addition to being notified by @username and @channel, you can customize words that trigger mention notifications in **Account Settings** > **Notifications** > **Words that trigger mentions**. By default, you will receive mention notifications on your first name, and you can add more words by typing them into the input box separated by commas. This is useful if you want to be notified of all posts on certain topics, for example, \"interviewing\" or \"marketing\".",
	"help.mentioning.username": "#### @Username\nYou can mention a teammate by using the `@` symbol plus their username to send them a mention notification.\n\nType `@` to bring up a list of team members who can be mentioned. To filter the list, type the first few letters of any username, first name, last name, or nickname. The **Up** and **Down** arrow keys can then be used to scroll through entries in the list, and pressing **ENTER** will select which user to mention. Once selected, the username will automatically replace the full name or nickname.\nThe following example sends a special mention notification to **alice** that alerts her of the channel and message where she has been mentioned. If **alice** is away from Cordchat and has email notifications turned on, then she will receive an email alert of her mention along with the message text.",
	"help.mentioning.usernameCont": "If the user you mentioned does not belong to the channel, a System Message will be posted to let you know. This is a temporary message only seen by the person who triggered it. To add the mentioned user to the channel, go to the dropdown menu beside the channel name and select **Add Members**.",
	"help.mentioning.usernameExample": "@alice how did your interview go with the new candidate?",
	"help.messaging.attach": "**Attach files** by dragging and dropping into Cordchat or clicking the attachment icon in the text input box.",
	"help.messaging.emoji": "**Quickly add emoji** by typing \":\", which will open an emoji autocomplete. If the existing emoji don't cover what you want to express, you can also create your own Custom Emoji.",
	"help.messaging.format": "**Format your messages** using Markdown that supports text styling, headings, links, emoticons, code blocks, block quotes, tables, lists and in-line images.",
	"help.messaging.notify": "**Notify teammates** when they are needed by typing `@username`.",
	"help.messaging.reply": "**Reply to messages** by clicking the reply arrow next to the message text.",
	"help.messaging.title": "# Messaging Basics\n_____",
	"help.messaging.write": "**Write messages** using the text input box at the bottom of Cordchat. Press ENTER to send a message. Use SHIFT+ENTER to create a new line without sending a message.",
	"installed_command.header": "Slash Commands",
	"installed_commands.add": "Add Slash Command",
	"installed_commands.delete.confirm": "This action permanently deletes the slash command and breaks any integrations using it. Are you sure you want to delete it?",
	"installed_commands.empty": "No commands found",
	"installed_commands.header": "Slash Commands",
	"installed_commands.help": "Use slash commands to connect external tools to Cordchat.",
	"installed_commands.help.appDirectory": "App Directory",
	"installed_commands.help.buildYourOwn": "Build your own",
	"installed_commands.search": "Search Slash Commands",
	"installed_commands.unnamed_command": "Unnamed Slash Command",
	"installed_incoming_webhooks.add": "Add Incoming Webhook",
	"installed_incoming_webhooks.delete.confirm": "This action permanently deletes the incoming webhook and breaks any integrations using it. Are you sure you want to delete it?",
	"installed_incoming_webhooks.empty": "No incoming webhooks found",
	"installed_incoming_webhooks.header": "Incoming Webhooks",
	"installed_incoming_webhooks.help": "Use incoming webhooks to connect external tools to Cordchat.",
	"installed_incoming_webhooks.help.appDirectory": "App Directory",
	"installed_incoming_webhooks.help.buildYourOwn": "Build your own",
	"installed_incoming_webhooks.search": "Search Incoming Webhooks",
	"installed_incoming_webhooks.unknown_channel": "A Private Webhook",
	"installed_integrations.callback_urls": "Callback URLs: {urls}",
	"installed_integrations.client_id": "Client ID: <strong>{clientId}</strong>",
	"installed_integrations.client_secret": "Client Secret: <strong>{clientSecret}</strong>",
	"installed_integrations.content_type": "Content-Type: {contentType}",
	"installed_integrations.creation": "Created by {creator} on {createAt, date, full}",
	"installed_integrations.delete": "Delete",
	"installed_integrations.edit": "Edit",
	"installed_integrations.hideSecret": "Hide Secret",
	"installed_integrations.regenSecret": "Regenerate Secret",
	"installed_integrations.regenToken": "Regenerate Token",
	"installed_integrations.showSecret": "Show Secret",
	"installed_integrations.token": "Token: {token}",
	"installed_integrations.triggerWhen": "Trigger When: {triggerWhen}",
	"installed_integrations.triggerWords": "Trigger Words: {triggerWords}",
	"installed_integrations.unnamed_oauth_app": "Unnamed OAuth 2.0 Application",
	"installed_integrations.url": "URL: {url}",
	"installed_oauth_apps.add": "Add OAuth 2.0 Application",
	"installed_oauth_apps.callbackUrls": "Callback URLs (One Per Line)",
	"installed_oauth_apps.cancel": "Cancel",
	"installed_oauth_apps.delete.confirm": "This action permanently deletes the OAuth 2.0 application and breaks any integrations using it. Are you sure you want to delete it?",
	"installed_oauth_apps.description": "Description",
	"installed_oauth_apps.empty": "No OAuth 2.0 Applications found",
	"installed_oauth_apps.header": "OAuth 2.0 Applications",
	"installed_oauth_apps.help": "Create {oauthApplications} to securely integrate bots and third-party apps with Cordchat.",
	"installed_oauth_apps.help.appDirectory": "App Directory",
	"installed_oauth_apps.help.oauthApplications": "OAuth 2.0 applications",
	"installed_oauth_apps.homepage": "Homepage",
	"installed_oauth_apps.iconUrl": "Icon URL",
	"installed_oauth_apps.is_trusted": "Is Trusted: <strong>{isTrusted}</strong>",
	"installed_oauth_apps.name": "Display Name",
	"installed_oauth_apps.save": "Save",
	"installed_oauth_apps.search": "Search OAuth 2.0 Applications",
	"installed_oauth_apps.trusted": "Is Trusted",
	"installed_oauth_apps.trusted.no": "No",
	"installed_oauth_apps.trusted.yes": "Yes",
	"installed_outgoing_webhooks.add": "Add Outgoing Webhook",
	"installed_outgoing_webhooks.delete.confirm": "This action permanently deletes the outgoing webhook and breaks any integrations using it. Are you sure you want to delete it?",
	"installed_outgoing_webhooks.empty": "No outgoing webhooks found",
	"installed_outgoing_webhooks.header": "Outgoing Webhooks",
	"installed_outgoing_webhooks.help": "Use outgoing webhooks to connect external tools to Cordchat.",
	"installed_outgoing_webhooks.help.appDirectory": "App Directory",
	"installed_outgoing_webhooks.help.buildYourOwn": "Build your own",
	"installed_outgoing_webhooks.search": "Search Outgoing Webhooks",
	"installed_outgoing_webhooks.unknown_channel": "A Private Webhook",
	"integrations.add": "Add",
	"integrations.command.description": "Slash commands send events to external integrations",
	"integrations.command.title": "Slash Command",
	"integrations.delete.confirm.button": "Delete",
	"integrations.delete.confirm.title": "Delete Integration",
	"integrations.done": "Done",
	"integrations.edit": "Edit",
	"integrations.header": "Integrations",
	"integrations.help": "Visit the {appDirectory} to find self-hosted, third-party apps and integrations for Cordchat.",
	"integrations.help.appDirectory": "App Directory",
	"integrations.incomingWebhook.description": "Incoming webhooks allow external integrations to send messages",
	"integrations.incomingWebhook.title": "Incoming Webhook",
	"integrations.oauthApps.description": "OAuth 2.0 allows external applications to make authorized requests to the Cordchat API.",
	"integrations.oauthApps.title": "OAuth 2.0 Applications",
	"integrations.outgoingWebhook.description": "Outgoing webhooks allow external integrations to receive and respond to messages",
	"integrations.outgoingWebhook.title": "Outgoing Webhook",
	"integrations.successful": "Setup Successful",
	"intro_messages.DM": "This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.",
	"intro_messages.GM": "This is the start of your group message history with {names}.<br />Messages and files shared here are not shown to people outside this area.",
	"intro_messages.anyMember": " Any member can join and read this channel.",
	"intro_messages.beginning": "Beginning of {name}",
	"intro_messages.channel": "channel",
	"intro_messages.creator": "This is the start of the {name} {type}, created by {creator} on {date}.",
	"intro_messages.default": "<h4 class='channel-intro__title'>Beginning of {display_name}</h4><p class='channel-intro__content'><strong>Welcome to {display_name}!</strong><br/><br/>Post messages here that you want everyone to see. Everyone automatically becomes a permanent member of this channel when they join the team.</p>",
	"intro_messages.group": "private channel",
	"intro_messages.group_message": "This is the start of your group message history with these teammates. Messages and files shared here are not shown to people outside this area.",
	"intro_messages.invite": "Invite others to this {type}",
	"intro_messages.inviteOthers": "Invite others to this team",
	"intro_messages.noCreator": "This is the start of the {name} {type}, created on {date}.",
	"intro_messages.offTopic": "<h4 class=\"channel-intro__title\">Beginning of {display_name}</h4><p class=\"channel-intro__content\">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>",
	"intro_messages.onlyInvited": " Only invited members can see this private channel.",
	"intro_messages.purpose": " This {type}'s purpose is: {purpose}.",
	"intro_messages.setHeader": "Set a Header",
	"intro_messages.teammate": "This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.",
	"invite_member.addAnother": "Add another",
	"invite_member.autoJoin": "Invitation will be sent by email (and Cordchat for existing Cordchat user). Recipient can join this team automatically by clicking the button in the email (or accept the invitation in Cordchat).",
	"invite_member.cancel": "Cancel",
	"invite_member.content": "Email is currently disabled for your team, and email invitations cannot be sent. Contact your System Administrator to enable email and email invitations.",
	"invite_member.disabled": "User creation has been disabled for your team. Please ask your Team Administrator for details.",
	"invite_member.emailError": "Please enter a valid email address",
	"invite_member.firstname": "First name",
	"invite_member.inviteLink": "Public Invitation Link",
	"invite_member.lastname": "Last name",
	"invite_member.modalButton": "Yes, Discard",
	"invite_member.modalMessage": "You have unsent invitations, are you sure you want to discard them?",
	"invite_member.modalTitle": "Discard Invitations?",
	"invite_member.newMember": "Send Private Invitation",
	"invite_member.send": "Send Member {count, plural, one {Invitation} other {Invitations}}",
	"invite_member.send2": "Send Invitations",
	"invite_guest.send": "Send Guest {count, plural, one {Invitation} other {Invitations}}",
	"invite_member.sending": " Sending",
	"invite_member.teamInviteLink": "You can also invite people using the {link}.",
	"ldap_signup.find": "Find my teams",
	"ldap_signup.ldap": "Create team with AD/LDAP Account",
	"ldap_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
	"ldap_signup.teamName": "Enter name of new team",
	"ldap_signup.team_error": "Please enter a team name",
	"leave_private_channel_modal.leave": "Yes, leave channel",
	"leave_private_channel_modal.message": "Are you sure you wish to leave the private channel {channel}? You must be re-invited in order to re-join this channel in the future.",
	"leave_private_channel_modal.title": "Leave Private Channel {channel}",
	"leave_team_modal.desc": "You will be removed from all public and private channels.  If the team is private you will not be able to rejoin the team.  Continue ? ",
	"leave_team_modal.lastAdmindesc": "You are the only team administrator in this team. If you leave this team, this team will be deleted. Continue? ",
	"leave_team_modal.no": "No",
	"leave_team_modal.title": "Leave Team {team} ? ",
	"leave_team_modal.yes": "Yes",
	"leave_wvc_channel_modal.message": "Are you sure you wish to leave Web Visitor Center {channel}? You must be re-invited in order to re-join this channel in the future.",
	"leave_wvc_channel_modal.title": "Leave Web Visitor Center {channel}",
	"loading_screen.loading": "Loading",
	"login.changed": " Sign-in method changed successfully",
	"login.create": "Create one now",
	"login.createTeam": "Create a new team",
	"login.createTeamAdminOnly": "This option is only available for System Administrators, and does not show up for other users.",
	"login.email": "Email",
	"login.find": "Find your other teams",
	"login.forgot": "I forgot my password",
	"login.gitlab": "GitLab",
	"login.google": "Sign in with Google",
	"login.invalidPassword": "Your password is incorrect.",
	"login.ldapUsername": "AD/LDAP Username",
	"login.ldapUsernameLower": "AD/LDAP username",
	"login.noAccount": "Don't have an account? ",
	"login.noEmail": "Please enter your email",
	"login.noEmailLdapUsername": "Please enter your email or {ldapUsername}",
	"login.noEmailUsername": "Please enter your email or username",
	"login.noEmailUsernameLdapUsername": "Please enter your email, username or {ldapUsername}",
	"login.noLdapUsername": "Please enter your {ldapUsername}",
	"login.noMethods": "No sign-in methods are enabled. Please contact your System Administrator.",
	"login.noPassword": "Please enter your password",
	"login.noUsername": "Please enter your username",
	"login.noUsernameLdapUsername": "Please enter your username or {ldapUsername}",
	"login.office365": "Office 365",
	"login.on": "on {siteName}",
	"login.or": "or",
	"login.password": "Password",
	"login.passwordChanged": " Password updated successfully",
	"login.placeholderOr": " or ",
	"login.session_expired": " Your session has expired. Please login again.",
	"login.signIn": "Sign in",
	"login.signInLoading": "Signing in...",
	"login.signInWith": "Sign in with:",
	"login.userNotFound": "We couldn't find an account matching your login credentials.",
	"login.username": "Username",
	"login.verified": " Email Verified",
	"login_mfa.enterToken": "To complete the sign in process, please enter a token from your smartphone's authenticator",
	"login_mfa.submit": "Submit",
	"login_mfa.token": "MFA Token",
	"login_mfa.tokenReq": "Please enter an MFA token",
	"member_item.makeAdmin": "Make Admin",
	"member_item.member": "Member",
	"member_list.noUsersAdd": "No users to add.",
	"members_popover.manageMembers": "Manage Members",
	"members_popover.msg": "Message",
	"members_popover.title": "Members",
	"members_popover.viewMembers": "View Members",
	"mfa.confirm.complete": "<strong>Set up complete!</strong>",
	"mfa.confirm.okay": "Okay",
	"mfa.confirm.secure": "Your account is now secure. Next time you sign in, you will be asked to enter a code from the Google Authenticator app on your phone.",
	"mfa.setup.badCode": "Invalid code. If this issue persists, contact your System Administrator.",
	"mfa.setup.code": "MFA Code",
	"mfa.setup.codeError": "Please enter the code from Google Authenticator.",
	"mfa.setup.required": "<strong>Multi-factor authentication is required on {siteName}.</strong>",
	"mfa.setup.save": "Save",
	"mfa.setup.secret": "Secret: {secret}",
	"mfa.setup.step1": "<strong>Step 1: </strong>On your phone, download Google Authenticator from <a target='_blank' href='https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8'>iTunes</a> or <a target='_blank' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en'>Google Play</a>",
	"mfa.setup.step2": "<strong>Step 2: </strong>Use Google Authenticator to scan this QR code, or manually type in the secret key",
	"mfa.setup.step3": "<strong>Step 3: </strong>Enter the code generated by Google Authenticator",
	"mfa.setupTitle": "Multi-factor Authentication Setup",
	"mobile.about.appVersion": "App Version: {version} (Build {number})",
	"mobile.about.copyright": "Copyright 2015-{currentYear} Multiable Company. All rights reserved",
	"mobile.about.database": "Database: {type}",
	"mobile.about.serverVersion": "Server Version: {version} (Build {number})",
	"mobile.about.serverVersionNoBuild": "Server Version: {version}",
	"mobile.account.notifications.email.footer": "When offline or away for more than five minutes",
	"mobile.account_notifications.mentions_footer": "Your username (\"@{username}\") will always trigger mentions.",
	"mobile.account_notifications.non-case_sensitive_words": "Other non-case sensitive words...",
	"mobile.account_notifications.reply.header": "Send reply notifications for",
	"mobile.account_notifications.threads_mentions": "Mentions in threads",
	"mobile.account_notifications.threads_start": "Threads that I start",
	"mobile.account_notifications.threads_start_participate": "Threads that I start or participate in",
	"mobile.advanced_settings.reset_button": "Reset",
	"mobile.advanced_settings.reset_message": "\nThis will reset all offline data and restart the app. You will be automatically logged back in once the app restarts.\n",
	"mobile.advanced_settings.reset_title": "Reset Cache",
	"mobile.advanced_settings.title": "Advanced Settings",
	"mobile.channel_drawer.search": "Jump to a conversation",
	"mobile.channel_info.alertMessageDeleteChannel": "Are you sure you want to delete the {term} {name}?",
	"mobile.channel_info.alertMessageLeaveChannel": "Are you sure you want to leave the {term} {name}?",
	"mobile.channel_info.alertNo": "No",
	"mobile.channel_info.alertTitleDeleteChannel": "Delete {term}",
	"mobile.channel_info.alertTitleLeaveChannel": "Leave {term}",
	"mobile.channel_info.alertYes": "Yes",
	"mobile.channel_info.delete_failed": "We couldn't delete the channel {displayName}. Please check your connection and try again.",
	"mobile.channel_info.privateChannel": "Private Channel",
	"mobile.channel_info.publicChannel": "Public Channel",
	"mobile.channel_list.alertMessageLeaveChannel": "Are you sure you want to leave the {term} {name}?",
	"mobile.channel_list.alertNo": "No",
	"mobile.channel_list.alertTitleLeaveChannel": "Leave {term}",
	"mobile.channel_list.alertYes": "Yes",
	"mobile.channel_list.closeDM": "Close Direct Message",
	"mobile.channel_list.closeGM": "Close Group Message",
	"mobile.channel_list.dm": "Direct Message",
	"mobile.channel_list.gm": "Group Message",
	"mobile.channel_list.not_member": "NOT A MEMBER",
	"mobile.channel_list.open": "Open {term}",
	"mobile.channel_list.openDM": "Open Direct Message",
	"mobile.channel_list.openGM": "Open Group Message",
	"mobile.channel_list.privateChannel": "Private Channel",
	"mobile.channel_list.publicChannel": "Public Channel",
	"mobile.channel_list.unreads": "UNREADS",
	"mobile.components.channels_list_view.yourChannels": "Your channels:",
	"mobile.components.error_list.dismiss_all": "Dismiss All",
	"mobile.components.select_server_view.continue": "Continue",
	"mobile.components.select_server_view.enterServerUrl": "Enter Server URL",
	"mobile.components.select_server_view.proceed": "Proceed",
	"mobile.components.select_server_view.siteUrlPlaceholder": "https://cordchat.example.com",
	"mobile.create_channel": "Create",
	"mobile.create_channel.private": "New Private Channel",
	"mobile.create_channel.public": "New Public Channel",
	"mobile.custom_list.no_results": "No Results",
	"mobile.drawer.teamsTitle": "Teams",
	"mobile.edit_post.title": "Editing Message",
	"mobile.error_handler.button": "Relaunch",
	"mobile.error_handler.description": "\nClick relaunch to open the app again. After restart, you can report the problem from the settings menu.\n",
	"mobile.error_handler.title": "Unexpected error occurred",
	"mobile.file_upload.camera": "Take Photo or Video",
	"mobile.file_upload.library": "Photo Library",
	"mobile.file_upload.more": "More",
	"mobile.file_upload.video": "Video Library",
	"mobile.help.title": "Help",
	"mobile.intro_messages.DM": "This is the start of your direct message history with {teammate}. Direct messages and files shared here are not shown to people outside this area.",
	"mobile.intro_messages.default_message": "This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.",
	"mobile.intro_messages.default_welcome": "Welcome to {name}!",
	"mobile.join_channel.error": "We couldn't join the channel {displayName}. Please check your connection and try again.",
	"mobile.loading_channels": "Loading Channels...",
	"mobile.loading_members": "Loading Members...",
	"mobile.loading_posts": "Loading Messages...",
	"mobile.login_options.choose_title": "Choose your login method",
	"mobile.more_dms.start": "Start",
	"mobile.more_dms.title": "New Conversation",
	"mobile.notice_mobile_link": "mobile apps",
	"mobile.notice_platform_link": "platform",
	"mobile.notice_text": "Cordchat is made possible by the open source software used in our {platform} and {mobile}.",
	"mobile.notification.in": " in ",
	"mobile.offlineIndicator.connected": "Connected",
	"mobile.offlineIndicator.connecting": "Connecting...",
	"mobile.offlineIndicator.offline": "No internet connection",
	"mobile.open_dm.error": "We couldn't open a direct message with {displayName}. Please check your connection and try again.",
	"mobile.open_gm.error": "We couldn't open a group message with those users. Please check your connection and try again.",
	"mobile.post.cancel": "Cancel",
	"mobile.post.delete_question": "Are you sure you want to delete this post?",
	"mobile.post.delete_title": "Delete Post",
	"mobile.post.failed_delete": "Delete Message",
	"mobile.post.failed_retry": "Try Again",
	"mobile.post.failed_title": "Unable to send your message",
	"mobile.post.retry": "Refresh",
	"mobile.request.invalid_response": "Received invalid response from the server.",
	"mobile.routes.channelInfo": "Info",
	"mobile.routes.channelInfo.createdBy": "Created by {creator} on ",
	"mobile.routes.channelInfo.delete_channel": "Delete Channel",
	"mobile.routes.channelInfo.favorite": "Favorite",
	"mobile.routes.channel_members.action": "Remove Members",
	"mobile.routes.channel_members.action_message": "You must select at least one member to remove from the channel.",
	"mobile.routes.channel_members.action_message_confirm": "Are you sure you want to remove the selected members from the channel?",
	"mobile.routes.channels": "Channels",
	"mobile.routes.enterServerUrl": "Enter Server URL",
	"mobile.routes.login": "Login",
	"mobile.routes.loginOptions": "Login Chooser",
	"mobile.routes.mfa": "Multi-factor Authentication",
	"mobile.routes.postsList": "Posts List",
	"mobile.routes.saml": "Single SignOn",
	"mobile.routes.selectTeam": "Select Team",
	"mobile.routes.settings": "Settings",
	"mobile.routes.sso": "Single Sign-On",
	"mobile.routes.thread": "{channelName} Thread",
	"mobile.routes.thread_dm": "Direct Message Thread",
	"mobile.routes.user_profile": "Profile",
	"mobile.routes.user_profile.send_message": "Send Message",
	"mobile.search.jump": "JUMP",
	"mobile.search.no_results": "No Results Found",
	"mobile.select_team.choose": "Your teams:",
	"mobile.select_team.join_open": "Open teams you can join",
	"mobile.select_team.no_teams": "There are no available teams for you to join.",
	"mobile.server_ping_failed": "Cannot connect to the server. Please check your server URL and internet connection.",
	"mobile.server_upgrade.button": "OK",
	"mobile.server_upgrade.description": "\nA server upgrade is required to use the Cordchat app. Please ask your System Administrator for details.\n",
	"mobile.server_upgrade.title": "Server upgrade required",
	"mobile.server_url.invalid_format": "URL must start with http:// or https://",
	"mobile.session_expired": "Session Expired: Please log in to continue receiving notifications.",
	"mobile.settings.clear": "Clear Offline Store",
	"mobile.settings.clear_button": "Clear",
	"mobile.settings.clear_message": "\nThis will clear all offline data and restart the app. You will be automatically logged back in once the app restarts.\n",
	"mobile.settings.team_selection": "Team Selection",
	"mobile.suggestion.members": "Members",
	"modal.manaul_status.ask": "Do not ask me again",
	"modal.manaul_status.button": "Yes, set my status to \"Online\"",
	"modal.manaul_status.cancel": "No, keep it as \"{status}\"",
	"modal.manaul_status.message": "Would you like to switch your status to \"Online\"?",
	"modal.manaul_status.title": "Your status is set to \"{status}\"",
	"more_channels.close": "Close",
	"more_channels.create": "Create New Channel",
	"more_channels.createClick": "Click 'Create New Channel' to make a new one",
	"more_channels.join": "Join",
	"more_channels.next": "Next",
	"more_channels.noMore": "No more channels to join",
	"more_channels.prev": "Previous",
	"more_channels.title": "More Channels",
	"more_direct_channels.close": "Close",
	"more_direct_channels.message": "Message",
	"more_direct_channels.new_convo_note": "This will start a new conversation. If you’re adding a lot of people, consider creating a private channel instead.",
	"more_direct_channels.new_convo_note.full": "You’ve reached the maximum number of people for this conversation. Consider creating a private channel instead.",
	"more_direct_channels.title": "Direct Messages",
	"msg_typing.areTyping": "{users} and {last} are typing...",
	"msg_typing.isTyping": "{user} is typing...",
	"msg_typing.someone": "Someone",
	"multiselect.add": "Add",
	"multiselect.go": "Go",
	"multiselect.start": "Start",
	"multiselect.list.notFound": "No items found",
	"multiselect.numPeopleRemaining": "Use ↑↓ to browse, ↵ to select. You can add {num, number} more {num, plural, one {person} other {people}}. ",
	"multiselect.numRemaining": "You can add {num, number} more",
	"multiselect.placeholder": "Search and add members",
	"navbar.addMembers": "Add Members",
	"navbar.click": "Click here",
	"navbar.delete": "Delete Channel...",
	"navbar.leave": "Leave Channel",
	"navbar.manageMembers": "Manage Members",
	"navbar.noHeader": "No channel header yet.{newline}{link} to add one.",
	"navbar.noHeader_noLink": "No channel header yet.",
	"navbar.preferences": "Notification Preferences",
	"navbar.rename": "Rename Channel...",
	"navbar.setHeader": "Set Channel Header...",
	"navbar.setPurpose": "Set Channel Purpose...",
	"navbar.toggle1": "Toggle sidebar",
	"navbar.toggle2": "Toggle sidebar",
	"navbar.viewInfo": "View Info",
	"navbar.viewPinnedPosts": "View Pinned Posts",
	"navbar_dropdown.about": "About Cordchat",
	"navbar_dropdown.accountSettings": "Account Settings",
	"navbar_dropdown.addMemberToTeam": "Add Members to Team",
	"navbar_dropdown.console": "System Console",
	"navbar_dropdown.create": "Create Team",
	"navbar_dropdown.emoji": "Custom Emoji",
	"navbar_dropdown.help": "Help",
	"navbar_dropdown.integrations": "Integrations",
	"navbar_dropdown.inviteMember": "Send Private Invitation",
	"navbar_dropdown.join": "Join Another Team",
	"navbar_dropdown.keyboardShortcuts": "Keyboard Shortcuts",
	"navbar_dropdown.leave": "Leave Team",
	"navbar_dropdown.delete": "Delete Team",
	"delete_team_modal.title": "Delete Team {team} ? ",
	"delete_team_modal.desc": "Deleting a Team cannot be undone. All messages and files will be irretrievable. Please use caution and consider exporting your data before deletion. Are you sure to delete?",
	"navbar_dropdown.logout": "Logout",
	"navbar_dropdown.manageMembers": "Manage Members",
	"navbar_dropdown.nativeApps": "Download Apps",
	"navbar_dropdown.report": "Report a Problem",
	"navbar_dropdown.switchTeam": "Switch to {team}",
	"navbar_dropdown.switchTo": "Switch to ",
	"navbar_dropdown.teamLink": "Get Public Invitation Link",
	"navbar_dropdown.teamSettings": "Team Settings",
	"navbar_dropdown.viewMembers": "View Members",
	"notification.dm": "Direct Message",
	"notify_all.confirm": "Confirm",
	"notify_all.question": "By using @all or @channel you are about to send notifications to {totalMembers} people. Are you sure you want to do this?",
	"notify_all.title.confirm": "Confirm sending notifications to entire channel",
	"passwordRequirements": "Password Requirements:",
	"password_form.change": "Change my password",
	"password_form.click": "Click <a href={url}>here</a> to log in.",
	"password_form.enter": "Enter a new password for your {siteName} account.",
	"password_form.error": "Please enter at least {chars} characters.",
	"password_form.pwd": "Password",
	"password_form.title": "Reset Password",
	"password_form.update": "Your password has been updated successfully.",
	"password_send.checkInbox": "Please check your inbox.",
	"password_send.description": "To reset your password, enter the email address you used to sign up",
	"password_send.email": "Email",
	"password_send.error": "Please enter a valid email address.",
	"password_send.link": "If the account exists, a password reset email will be sent to: <br/><b>{email}</b><br/><br/>",
	"password_send.reset": "Reset my password",
	"password_send.title": "Forgot Password",
	"pdf_preview.max_pages": "Download to read more pages",
	"pending_post_actions.cancel": "Cancel",
	"pending_post_actions.retry": "Retry",
	"permalink.error.access": "Permalink belongs to a deleted message or to a channel to which you do not have access.",
	"permalink.error.title": "Message Not Found",
	"post_attachment.collapse": "Show less...",
	"post_attachment.more": "Show more...",
	"post_body.commentedOn": "Commented on {name}{apostrophe} message: ",
	"post_body.deleted": "(message deleted)",
	"post_body.plusMore": " plus {count, number} other {count, plural, one {file} other {files}}",
	"post_delete.notPosted": "Comment could not be posted",
	"post_delete.okay": "Okay",
	"post_delete.someone": "Someone deleted the message on which you tried to post a comment.",
	"post_focus_view.beginning": "Beginning of Channel Archives",
	"post_info.del": "Delete",
	"post_info.edit": "Edit",
	"post_info.message.visible": "(Only visible to you)",
	"post_info.message.visible.compact": " (Only visible to you)",
	"post_info.mobile.flag": "Flag",
	"post_info.mobile.unflag": "Unflag",
	"post_info.permalink": "Permalink",
	"post_info.pin": "Pin to channel",
	"post_info.pinned": "Pinned",
	"post_info.reply": "Reply",
	"post_info.system": "System",
	"post_info.unpin": "Un-pin from channel",
	"post_message_view.edited": "(edited)",
	"posts_view.loadMore": "Load more messages",
	"posts_view.loadingMore": "Loading more messages...",
	"posts_view.newMsg": "New Messages",
	"posts_view.newMsgBelow": "New {count, plural, one {message} other {messages}}",
	"quick_switch_modal.channels": "Channels",
	"quick_switch_modal.channelsShortcut.mac": "- CMD+K",
	"quick_switch_modal.channelsShortcut.windows": "- CTRL+K",
	"quick_switch_modal.help": "Start typing then use TAB to toggle channels/teams, ↑↓ to browse,, Enter to select, and ESC to dismiss.",
	"quick_switch_modal.help_mobile": "Type to find a channel.",
	"quick_switch_modal.help_mobile_team": "Type to find a team.",
	"quick_switch_modal.help_no_team": "Type to find a channel. Use ↑↓ to browse, Enter to select, ESC to dismiss.",
	"quick_switch_modal.help_with_team": "Type to find a team. Use ↑↓ to browse, Enter to select, ESC to dismiss.",
	"quick_switch_modal.teams": "Teams",
	"quick_switch_modal.teamsShortcut.mac": "- ALT+K",
	"quick_switch_modal.teamsShortcut.windows": "- ALT+K",
	"reaction.clickToAdd": "(click to add)",
	"reaction.clickToRemove": "(click to remove)",
	"reaction.othersReacted": "{otherUsers, number} {otherUsers, plural, one {user} other {users}}",
	"reaction.reacted": "{users} {reactionVerb} with {emoji}",
	"reaction.reactionVerb.user": "reacted",
	"reaction.reactionVerb.users": "reacted",
	"reaction.reactionVerb.you": "reacted",
	"reaction.reactionVerb.youAndUsers": "reacted",
	"reaction.usersAndOthersReacted": "{users} and {otherUsers, number} other {otherUsers, plural, one {user} other {users}}",
	"reaction.usersReacted": "{users} and {lastUser}",
	"reaction.you": "You",
	"removed_channel.channelName": "the channel",
	"removed_channel.from": "Removed from ",
	"removed_channel.okay": "Okay",
	"removed_channel.remover": "{remover} removed you from {channel}",
	"removed_channel.someone": "Someone",
	"rename_channel.cancel": "Cancel",
	"rename_channel.defaultError": " - Cannot be changed for the default channel",
	"rename_channel.displayName": "Display Name",
	"rename_channel.displayNameHolder": "Enter display name",
	"rename_channel.handleHolder": "lowercase alphanumeric characters",
	"rename_channel.lowercase": "Must be lowercase alphanumeric characters",
	"rename_channel.maxLength": "This field must be less than {maxLength, number} characters",
	"rename_channel.required": "This field is required",
	"rename_channel.save": "Save",
	"rename_channel.title": "Rename Channel",
	"rename_channel.url": "URL",
	"rhs_comment.comment": "Comment",
	"rhs_comment.del": "Delete",
	"rhs_comment.edit": "Edit",
	"rhs_comment.mobile.flag": "Flag",
	"rhs_comment.mobile.unflag": "Unflag",
	"rhs_comment.permalink": "Permalink",
	"rhs_header.backToCallTooltip": "Back to Call",
	"rhs_header.backToFlaggedTooltip": "Back to Flagged Posts",
	"rhs_header.backToPinnedTooltip": "Back to Pinned Posts",
	"rhs_header.backToResultsTooltip": "Back to Search Results",
	"rhs_header.closeSidebarTooltip": "Close Sidebar",
	"rhs_header.closeTooltip": "Close Sidebar",
	"rhs_header.details": "Message Details",
	"rhs_header.expandSidebarTooltip": "Expand Sidebar",
	"rhs_header.expandTooltip": "Shrink Sidebar",
	"rhs_header.shrinkSidebarTooltip": "Shrink Sidebar",
	"rhs_root.del": "Delete",
	"rhs_root.direct": "Direct Message",
	"rhs_root.edit": "Edit",
	"rhs_root.mobile.flag": "Flag",
	"rhs_root.mobile.unflag": "Unflag",
	"rhs_root.permalink": "Permalink",
	"rhs_root.pin": "Pin to channel",
	"rhs_root.unpin": "Un-pin from channel",
	"search_bar.search": "Search",
	"search_bar.searchIn": "Search in",
	"search_bar.filters": "Search filters",
	"search_bar.filtersActive": "{count} filters",
	"search_bar.filtersActiveOne": "1 filter",
	"search_filters.clear": "Clear",
	"search_filters.from": "From",
	"search_filters.fromPlaceholder": "Type a name…",
	"search_filters.hint": "Type keywords above, then press Enter or Search",
	"search_filters.in": "In",
	"search_filters.inLockedToCurrent": "Limited to the current conversation",
	"search_filters.inPlaceholder": "Channel, direct message or group…",
	"search_filters.loading": "Loading…",
	"search_filters.noMatch": "No matches",
	"search_filters.scope": "Scope",
	"search_filters.scopeAll": "Everywhere",
	"search_filters.scopeCurrent": "This conversation: {name}",
	"search_filters.search": "Search",
	"search_filters.since": "Date",
	"search_filters.since30": "Last 30 days",
	"search_filters.since7": "Last 7 days",
	"search_filters.since90": "Last 90 days",
	"search_filters.sinceAny": "Any time",
	"search_filters.team": "Team",
	"search_filters.teamAll": "All teams",
	"search_bar.usage": "<h4>Search Options</h4><ul><li><span>Use </span><b>\"quotation marks\"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users.</span></li><li><span> Use</span> <b>in:</b> or <b>channel:</b><span> to find posts in specific channels</span></li><li><span> Use</span> <b>team:</b><span> to find posts in specific team</span></li><li><span> Use</span> <b>@</b><span> to find posts mention specific user</span></li><li><span> Use</span> <b>since:</b><span> to find posts on/after specific date</span></li><li><span>Click the </span><b>sliders icon</b><span> in the search box to filter by sender, channel, team or date without typing these prefixes</span></li></ul>",
	"search_header.results": "Search Results",
	"search_header.title2": "Recent Mentions",
	"search_header.title3": "Flagged Posts",
	"search_header.title4": "Pinned posts in {channelDisplayName}",
	"search_item.direct": "Direct Message (with {username})",
	"search_item.jump": "Jump",
	"search_results.because": "<ul><li>If you're searching a partial phrase (ex. searching \"rea\", looking for \"reach\" or \"reaction\"), append a * to your search term.</li><li>Two letter searches and common words like \"this\", \"a\" and \"is\" won't appear in search results due to excessive results returned.</li></ul>",
	"search_results.noResults": "No results found. Try again?",
	"search_results.searching": "Searching...",
	"search_results.usage": "<ul><li>Use <b>\"quotation marks\"</b> to search for phrases</li><li>Use <b>from:</b> to find posts from specific users and <b>in:</b> to find posts in specific channels</li></ul>",
	"search_results.usageFlag1": "You haven't flagged any messages yet.",
	"search_results.usageFlag2": "You can add a flag to messages and comments by clicking the ",
	"search_results.usageFlag3": " icon next to the timestamp.",
	"search_results.usageFlag4": "Flags are a way to mark messages for follow up. Your flags are personal, and cannot be seen by other users.",
	"search_results.usagePin1": "There are no pinned messages yet.",
	"search_results.usagePin2": "All members of this channel can pin important or useful messages.",
	"search_results.usagePin3": "Pinned messages are visible to all channel members.",
	"search_results.usagePin4": "To pin a message: Go to the message that you want to pin and click [...] > \"Pin to channel\".",
	"setting_item_max.cancel": "Cancel",
	"setting_item_max.save": "Save",
	"setting_item_min.edit": "Edit",
	"setting_picture.cancel": "Cancel",
	"setting_picture.help": "Upload a profile picture in BMP, JPG, JPEG or PNG format, at least {width}px in width and {height}px height.",
	"setting_picture.team.help": "Upload a team picture in BMP, JPG, JPEG or PNG format, at least {width}px in width and {height}px height.",
	"setting_picture.save": "Save",
	"setting_picture.select": "Select",
	"setting_upload.import": "Import",
	"setting_upload.noFile": "No file selected.",
	"setting_upload.select": "Select file",
	"sidebar.channels": "PUBLIC CHANNELS",
	"sidebar.createChannel": "Create New Public Channel",
	"sidebar.createGroup": "Create New Private Channel",
	"sidebar.direct": "DIRECT MESSAGES",
	"sidebar.favorite": "FAVORITE CHANNELS",
	"sidebar.more": "More",
	"sidebar.moreElips": "More...",
	"sidebar.otherMembers": "Outside this team",
	"sidebar.pg": "PRIVATE CHANNELS",
	"sidebar.removeList": "Remove from list",
	"sidebar.tutorialScreen1": "<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They’re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Channel</strong> for multiple people.</p>",
	"sidebar.tutorialScreen2": "<h4>\"{townsquare}\" and \"{offtopic}\" channels</h4><p>Here are two public channels to start:</p><p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p><p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>",
	"sidebar.tutorialScreen3": "<h4>Creating and Joining Channels</h4><p>Click <strong>\"More...\"</strong> to create a new channel or join an existing one.</p><p>You can also create a new channel by clicking the <strong>\"+\" symbol</strong> next to the public or private channel header.</p>",
	"sidebar.unreads": "More unreads",
	"sidebar_header.tutorial": "<h4>Main Menu</h4><p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p><p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>",
	"sidebar_right_menu.accountSettings": "Account Settings",
	"sidebar_right_menu.addMemberToTeam": "Add Members to Team",
	"sidebar_right_menu.console": "System Console",
	"sidebar_right_menu.flagged": "Flagged Posts",
	"sidebar_right_menu.help": "Help",
	"sidebar_right_menu.inviteNew": "Send Private Invitation",
	"sidebar_right_menu.logout": "Logout",
	"sidebar_right_menu.manageMembers": "Manage Members",
	"sidebar_right_menu.nativeApps": "Download Apps",
	"sidebar_right_menu.recentMentions": "Recent Mentions",
	"sidebar_right_menu.report": "Report a Problem",
	"sidebar_right_menu.teamLink": "Get Public Invitation Link",
	"sidebar_right_menu.teamSettings": "Team Settings",
	"sidebar_right_menu.viewMembers": "View Members",
	"signup.email": "Email and Password",
	"signup.gitlab": "GitLab Single Sign-On",
	"signup.google": "Google Account",
	"signup.ldap": "AD/LDAP Credentials",
	"signup.office365": "Office 365",
	"signup.title": "Create an account with:",
	"signup_team.createTeam": "Or Create a Team",
	"signup_team.disabled": "Team creation has been disabled.  Please contact an administrator for access.",
	"signup_team.join_open": "Teams you can join: ",
	"signup_team.noTeams": "There are no teams included in the Team Directory and team creation has been disabled.",
	"signup_team.no_open_teams": "No teams are available to join. Please ask your administrator for an invite.",
	"signup_team.no_open_teams_canCreate": "No teams are available to join. Please create a new team or ask your administrator for an invite.",
	"signup_team.no_teams": "No teams have been created. Please contact your administrator.",
	"signup_team.no_teams_canCreate": "No teams have been created. You may create one by clicking \"Create a new team\".",
	"signup_team.none": "No team creation method has been enabled.  Please contact an administrator for access.",
	"signup_team_complete.completed": "You've already completed the signup process for this invitation or this invitation has expired.",
	"signup_team_confirm.checkEmail": "Please check your email: <strong>{email}</strong><br />Your email contains a link to set up your team",
	"signup_team_confirm.title": "Sign up Complete",
	"signup_team_system_console": "Go to System Console",
	"signup_user_completed.choosePwd": "Choose your password(Required)",
	"signup_user_completed.chooseUser": "Choose your username(Required)",
	"signup_user_completed.create": "Create Account",
	"signup_user_completed.emailHelp": "Valid email required for sign-up",
	"signup_user_completed.emailIs": "Your email address is <strong>{email}</strong>. You'll use this address to sign in to {siteName}.",
	"signup_user_completed.expired": "You've already completed the signup process for this invitation or this invitation has expired.",
	"signup_user_completed.gitlab": "with GitLab",
	"signup_user_completed.google": "with Google",
	"signup_user_completed.haveAccount": "Already have an account?",
	"signup_user_completed.invalid_invite": "The invite link was invalid.  Please speak with your Administrator to receive an invitation.",
	"signup_user_completed.lets": "Let's create your account",
	"signup_user_completed.no_open_server": "This server does not allow open signups.  Please speak with your Administrator to receive an invitation.",
	"signup_user_completed.none": "No user creation method has been enabled.  Please contact an administrator for access.",
	"signup_user_completed.office365": "with Office 365",
	"signup_user_completed.onSite": "on {siteName}",
	"signup_user_completed.or": "or",
	"signup_user_completed.passwordLength": "Please enter between {min} and {max} characters",
	"signup_user_completed.required": "This field is required",
	"signup_user_completed.reserved": "This username is reserved, please choose a new one.",
	"signup_user_completed.signIn": "Click here to sign in.",
	"signup_user_completed.userHelp": "<li>Username must begin with a letter(lowercase),and contain between {min} to {max} characters</li><li>Characters used can only be numbers, letters(lowercase), '.', '-' and '_'</li>",
	"signup_user_completed.usernameErr1": "Username must begin with a letter(lowercase).",
	"signup_user_completed.usernameErr2": "Username must contain between {min} to {max} characters.",
	"signup_user_completed.usernameErr3": "Username characters used can only be numbers, letters(lowercase), '.', '-' and '_'.",
	"signup_user_completed.validEmail": "Please enter a valid email address",
	"signup_user_completed.welcome": "Welcome to:",
	"signup_user_completed.whatis": "What's your email address?",
	"signup_user_completed.withLdap": "With your AD/LDAP credentials",
	"sso_signup.find": "Find my teams",
	"sso_signup.gitlab": "Create team with GitLab Account",
	"sso_signup.google": "Create team with Google Apps Account",
	"sso_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
	"sso_signup.teamName": "Enter name of new team",
	"sso_signup.team_error": "Please enter a team name",
	"status_dropdown.set_away": "Away",
	"status_dropdown.set_offline": "Offline",
	"status_dropdown.set_online": "Online",
	"status_display.show_away": "Away",
	"status_display.show_offline": "Offline",
	"status_display.show_online": "Online",
	"suggestion.loading": "Loading...",
	"suggestion.mention.all": "CAUTION: This mentions everyone in channel",
	"suggestion.mention.channel": "Notifies everyone in the channel",
	"suggestion.mention.channels": "My Channels",
	"suggestion.mention.here": "Notifies everyone in the channel and online",
	"suggestion.mention.in_channel": "Channels",
	"suggestion.mention.members": "Channel Members",
	"suggestion.mention.morechannels": "Other Channels",
	"suggestion.mention.nonmembers": "Not in Channel",
	"suggestion.mention.not_in_channel": "Other Channels",
	"suggestion.mention.special": "Special Mentions",
	"suggestion.search.private": "Private Channels",
	"suggestion.search.public": "Public Channels",
	"system_users_list.count": "{count, number} {count, plural, one {user} other {users}}",
	"system_users_list.countPage": "{startCount, number} - {endCount, number} {count, plural, one {user} other {users}} of {total, number} total",
	"system_users_list.countSearch": "{count, number} {count, plural, one {user} other {users}} of {total, number} total",
	"team_export_tab.download": "download",
	"team_export_tab.export": "Export",
	"team_export_tab.exportTeam": "Export your team",
	"team_export_tab.ready": " Ready for ",
	"team_export_tab.unable": " Unable to export: {error}",
	"team_import_tab.failure": " Import failure: ",
	"team_import_tab.import": "Import",
	"team_import_tab.importHelpDocsLink": "documentation",
	"team_import_tab.importHelpExportInstructions": "Slack > Team Settings > Import/Export Data > Export > Start Export",
	"team_import_tab.importHelpExporterLink": "Slack Advanced Exporter",
	"team_import_tab.importHelpLine1": "Slack import to Cordchat supports importing of messages in your Slack team's public channels.",
	"team_import_tab.importHelpLine2": "To import a team from Slack, go to {exportInstructions}. See {uploadDocsLink} to learn more.",
	"team_import_tab.importHelpLine3": "To import posts with attached files, see {slackAdvancedExporterLink} for details.",
	"team_import_tab.importSlack": "Import from Slack (Beta)",
	"team_import_tab.importing": " Importing...",
	"team_import_tab.successful": " Import successful: ",
	"team_import_tab.summary": "View Summary",
	"team_member_modal.close": "Close",
	"team_member_modal.members": "{team} Members",
	"team_members_dropdown.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Cordchat server through a terminal and running the following command.",
	"team_members_dropdown.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
	"team_members_dropdown.confirmDemotion": "Confirm Demotion",
	"team_members_dropdown.confirmDemotionCmd": "platform roles system_admin {username}",
	"team_members_dropdown.inactive": "Inactive",
	"team_members_dropdown.leave_team": "Remove From Team",
	"team_members_dropdown.makeActive": "Activate",
	"team_members_dropdown.makeAdmin": "Make Team Admin",
	"team_members_dropdown.makeInactive": "Deactivate",
	"team_members_dropdown.makeMember": "Make Member",
	"team_members_dropdown.makeGuest": "Make Guest",
	"team_members_dropdown.member": "Member",
	"team_members_dropdown.systemAdmin": "System Admin",
	"team_members_dropdown.teamAdmin": "Team Admin",
	"team_settings_modal.exportTab": "Export",
	"team_settings_modal.generalTab": "General",
	"team_settings_modal.importTab": "Import",
	"team_settings_modal.title": "Team Settings",
	"team_sidebar.join": "Other teams you can join.",
	"textbox.bold": "**bold**",
	"textbox.edit": "Edit message",
	"textbox.help": "Help",
	"textbox.inlinecode": "`inline code`",
	"textbox.italic": "_italic_",
	"textbox.preformatted": "```preformatted```",
	"textbox.preview": "Preview",
	"textbox.quote": ">quote",
	"textbox.strike": "strike",
	"tutorial_intro.chooseTheme": "<h1>Cordchat Tips (2):</h1>",
	"tutorial_intro.allSet": "<h1>Enjoy powerful features now.</h1>",
	"tutorial_intro.end": "Click \"Next\" to enter {channel}. This is the first channel teammates see when they sign up. Speak here and post updates everyone needs to know.",
	"tutorial_intro.invite": "Invite teammates",
	"tutorial_intro.mobileApps": "From desktop PC, notebook to smartphones, install the apps for {link} for mobile access and discussion without boundary.",
	"tutorial_intro.mobileAppsLinkText": "iOS and Android",
	"tutorial_intro.next": "Next",
	"tutorial_intro.screenOne": "<h1>Welcome!</h1><p>Now you can communicate through secure encryption anytime and anywhere.</p>",
	"tutorial_intro.screenTwo": "<h1>Cordchat Tips (1):</h1><p>There are three chat modes: public channel, private channel and private message, for you to choose.</p>",
	"tutorial_intro.skip": "Skip tutorial",
	"tutorial_intro.support": "For enquiry, please send an email to: ",
	"tutorial_intro.teamInvite": "Invite teammates",
	"tutorial_intro.whenReady": " so your teammates can join this team.",
	"tutorial_tip.next": "Next",
	"tutorial_tip.ok": "Okay",
	"tutorial_tip.out": "Opt out of these tips.",
	"tutorial_tip.seen": "Seen this before? ",
	"update_command.cancel": "Cancel",
	"update_command.confirm": "Edit Slash Command",
	"update_command.question": "Your changes may break the existing slash command. Are you sure you would like to update it?",
	"update_command.update": "Update",
	"update_incoming_webhook.update": "Update",
	"update_outgoing_webhook.confirm": "Edit Outgoing Webhook",
	"update_outgoing_webhook.question": "Your changes may break the existing outgoing webhook. Are you sure you would like to update it?",
	"update_outgoing_webhook.update": "Update",
	"upload_overlay.info": "Drop a file to upload it.",
	"user.settings.advance.embed_preview": "For the first web link in a message, display a preview of website content below the message, if available",
	"user.settings.advance.embed_toggle": "Show toggle for all embed previews",
	"user.settings.advance.enabledFeatures": "{count, number} {count, plural, one {Feature} other {Features}} Enabled",
	"user.settings.advance.formattingDesc": "If enabled, posts will be formatted to create links, show emoji, style the text, and add line breaks. By default, this setting is enabled. Changing this setting requires the page to be refreshed.",
	"user.settings.advance.formattingTitle": "Enable Post Formatting",
	"user.settings.advance.joinLeaveDesc": "When \"On\", System Messages saying a user has joined or left a channel will be visible. When \"Off\", the System Messages about joining or leaving a channel will be hidden. A message will still show up when you are added to a channel, so you can receive a notification.",
	"user.settings.advance.joinLeaveTitle": "Enable Join/Leave Messages",
	"user.settings.advance.markdown_preview": "Show markdown preview option in message input box",
	"user.settings.advance.off": "Off",
	"user.settings.advance.on": "On",
	"user.settings.advance.preReleaseDesc": "Check any pre-released features you'd like to preview.  You may also need to refresh the page before the setting will take effect.",
	"user.settings.advance.preReleaseTitle": "Preview pre-release features",
	"user.settings.advance.sendDesc": "If enabled ENTER inserts a new line and CTRL+ENTER submits the message.",
	"user.settings.advance.sendTitle": "Send messages on CTRL+ENTER",
	"user.settings.advance.slashCmd_autocmp": "Enable external application to offer slash command autocomplete",
	"user.settings.advance.title": "Advanced Settings",
	"user.settings.advance.webrtc_preview": "Enable the ability to make and receive one-on-one WebRTC calls",
	"user.settings.custom_theme.awayIndicator": "Away Indicator",
	"user.settings.custom_theme.buttonBg": "Button BG",
	"user.settings.custom_theme.buttonColor": "Button Text",
	"user.settings.custom_theme.centerChannelBg": "Center Channel BG",
	"user.settings.custom_theme.centerChannelColor": "Center Channel Text",
	"user.settings.custom_theme.centerChannelTitle": "Center Channel Styles",
	"user.settings.custom_theme.codeTheme": "Code Theme",
	"user.settings.custom_theme.copyPaste": "Copy and paste to share theme colors:",
	"user.settings.custom_theme.linkButtonTitle": "Link and Button Styles",
	"user.settings.custom_theme.linkColor": "Link Color",
	"user.settings.custom_theme.mentionBj": "Mention Jewel BG",
	"user.settings.custom_theme.mentionColor": "Mention Jewel Text",
	"user.settings.custom_theme.mentionHighlightBg": "Mention Highlight BG",
	"user.settings.custom_theme.mentionHighlightLink": "Mention Highlight Link",
	"user.settings.custom_theme.newMessageSeparator": "New Message Separator",
	"user.settings.custom_theme.onlineIndicator": "Online Indicator",
	"user.settings.custom_theme.sidebarBg": "Sidebar BG",
	"user.settings.custom_theme.sidebarHeaderBg": "Sidebar Header BG",
	"user.settings.custom_theme.sidebarHeaderTextColor": "Sidebar Header Text",
	"user.settings.custom_theme.sidebarText": "Sidebar Text",
	"user.settings.custom_theme.sidebarTextActiveBorder": "Sidebar Text Active Border",
	"user.settings.custom_theme.sidebarTextActiveColor": "Sidebar Text Active Color",
	"user.settings.custom_theme.sidebarTextHoverBg": "Sidebar Text Hover BG",
	"user.settings.custom_theme.sidebarTitle": "Sidebar Styles",
	"user.settings.custom_theme.sidebarUnreadText": "Sidebar Unread Text",
	"user.settings.display.channelDisplayTitle": "Channel Display Mode",
	"user.settings.display.channeldisplaymode": "Select the width of the center channel.",
	"user.settings.display.clockDisplay": "Clock Display",
	"user.settings.display.collapseDesc": "Set whether previews of image links show as expanded or collapsed by default. This setting can also be controlled using the slash commands /expand and /collapse.",
	"user.settings.display.collapseDisplay": "Default appearance of image link previews",
	"user.settings.display.collapseOff": "Collapsed",
	"user.settings.display.collapseOn": "Expanded",
	"user.settings.display.fixedWidthCentered": "Fixed width, centered",
	"user.settings.display.fullScreen": "Full width",
	"user.settings.display.language": "Language",
	"user.settings.display.messageDisplayClean": "Standard",
	"user.settings.display.messageDisplayCleanDes": "Easy to scan and read.",
	"user.settings.display.messageDisplayCompact": "Compact",
	"user.settings.display.messageDisplayCompactDes": "Fit as many messages on the screen as we can.",
	"user.settings.display.messageDisplayDescription": "Select how messages in a channel should be displayed.",
	"user.settings.display.messageDisplayTitle": "Message Display",
	"user.settings.display.militaryClock": "24-hour clock (example: 16:00)",
	"user.settings.display.nameOptsDesc": "Set how to display other user's names in posts and the Direct Messages list.",
	"user.settings.display.normalClock": "12-hour clock (example: 4:00 PM)",
	"user.settings.display.preferTime": "Select how you prefer time displayed.",
	"user.settings.display.theme.applyToAllTeams": "Apply new theme to all my teams",
	"user.settings.display.theme.customTheme": "Custom Theme",
	"user.settings.display.theme.describe": "Open to manage your theme",
	"user.settings.display.theme.import": "Import theme colors from Slack",
	"user.settings.display.theme.otherThemes": "See other themes",
	"user.settings.display.theme.themeColors": "Theme Colors",
	"user.settings.display.theme.title": "Theme",
	"user.settings.display.title": "Display Settings",
	"user.settings.general.checkEmail": "Check your email at {email} to verify the address.",
	"user.settings.general.close": "Close",
	"user.settings.general.confirmEmail": "Confirm Email",
	"user.settings.general.currentEmail": "Current Email",
	"user.settings.general.email": "Email",
	"user.settings.general.emailGitlabCantUpdate": "Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailGoogleCantUpdate": "Login occurs through Google. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailAppleCantUpdate": "Login occurs through Apple. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailHelp1": "Email is used for sign-in, notifications, and password reset. Email requires verification if changed.",
	"user.settings.general.emailHelp2": "Email has been disabled by your System Administrator. No notification emails will be sent until it is enabled.",
	"user.settings.general.emailHelp3": "Email is used for sign-in, notifications, and password reset.",
	"user.settings.general.emailLdapCantUpdate": "Login occurs through AD/LDAP. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailMatch": "The new emails you entered do not match.",
	"user.settings.general.emailOffice365CantUpdate": "Login occurs through Office 365. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailSamlCantUpdate": "Login occurs through SAML. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailUnchanged": "Your new email address is the same as your old email address.",
	"user.settings.general.emptyName": "Click 'Edit' to add your full name",
	"user.settings.general.emptyNickname": "Click 'Edit' to add a nickname",
	"user.settings.general.emptyPosition": "Click 'Edit' to add your job title / position",
	"user.settings.general.field_handled_externally": "This field is handled through your login provider. If you want to change it, you need to do so through your login provider.",
	"user.settings.general.firstName": "First Name",
	"user.settings.general.fullName": "Full Name",
	"user.settings.general.imageTooLarge": "Unable to upload profile image. File is too large.",
	"user.settings.general.imageUpdated": "Image last updated {date}",
	"user.settings.general.lastName": "Last Name",
	"user.settings.general.loginGitlab": "Login done through GitLab ({email})",
	"user.settings.general.loginGoogle": "Login done through Google ({email})",
	"user.settings.general.loginApple": "Login done through Apple ({email})",
	"user.settings.general.loginLdap": "Login done through AD/LDAP ({email})",
	"user.settings.general.loginOffice365": "Login done through Office 365 ({email})",
	"user.settings.general.loginSaml": "Login done through SAML ({email})",
	"user.settings.general.mobile.emptyName": "Click to add your full name",
	"user.settings.general.mobile.emptyNickname": "Click to add a nickname",
	"user.settings.general.mobile.emptyPosition": "Click to add your job title / position",
	"user.settings.general.mobile.uploadImage": "Click to upload an image.",
	"user.settings.general.newEmail": "New Email",
	"user.settings.general.nickname": "Nickname",
	"user.settings.general.nicknameExtra": "Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.",
	"user.settings.general.notificationsExtra": "By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.",
	"user.settings.general.notificationsLink": "Notifications",
	"user.settings.general.position": "Position",
	"user.settings.general.positionExtra": "Use Position for your role or job title. This will be shown in your profile popover.",
	"user.settings.general.profilePicture": "Profile Picture",
	"user.settings.general.title": "General Settings",
	"user.settings.general.uploadImage": "Click 'Edit' to upload an image.",
	"user.settings.general.username": "Username",
	"user.settings.general.usernameInfo": "Pick something easy for teammates to recognize and recall.",
	"user.settings.general.usernameReserved": "This username is reserved, please choose a new one.",
	"user.settings.general.usernameRestrictions": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'.",
	"user.settings.general.validEmail": "Please enter a valid email address",
	"user.settings.general.validImage": "Only JPG or PNG images may be used for profile pictures",
	"user.settings.import_theme.cancel": "Cancel",
	"user.settings.import_theme.importBody": "To import a theme, go to a Slack team and look for \"Preferences -> Sidebar Theme\". Open the custom theme option, copy the theme color values and paste them here:",
	"user.settings.import_theme.importHeader": "Import Slack Theme",
	"user.settings.import_theme.submit": "Submit",
	"user.settings.import_theme.submitError": "Invalid format, please try copying and pasting in again.",
	"user.settings.languages.change": "Change interface language",
	"user.settings.languages.promote": "Select which language Cordchat displays in the user interface.",
	"user.settings.mfa.add": "Add MFA to your account",
	"user.settings.mfa.addHelp": "Adding multi-factor authentication will make your account more secure by requiring a code from your mobile phone each time you sign in.",
	"user.settings.mfa.addHelpQr": "Please scan the QR code with the Google Authenticator app on your smartphone and fill in the token with one provided by the app. If you are unable to scan the code, you can manually enter the secret provided.",
	"user.settings.mfa.enterToken": "Token (numbers only)",
	"user.settings.mfa.qrCode": "Bar Code",
	"user.settings.mfa.remove": "Remove MFA from your account",
	"user.settings.mfa.removeHelp": "Removing multi-factor authentication means you will no longer require a phone-based passcode to sign-in to your account.",
	"user.settings.mfa.requiredHelp": "Multi-factor authentication is required on this server. Resetting is only recommended when you need to switch code generation to a new mobile device. You will be required to set it up again immediately.",
	"user.settings.mfa.reset": "Reset MFA on your account",
	"user.settings.mfa.secret": "Secret",
	"user.settings.mfa.title": "Multi-factor Authentication",
	"user.settings.modal.advanced": "Advanced",
	"user.settings.modal.confirmBtns": "Yes, Discard",
	"user.settings.modal.confirmMsg": "You have unsaved changes, are you sure you want to discard them?",
	"user.settings.modal.confirmTitle": "Discard Changes?",
	"user.settings.modal.display": "Display & Language",
	"user.settings.modal.general": "General",
	"user.settings.modal.notifications": "Notifications",
	"user.settings.modal.security": "Security",
	"user.settings.modal.title": "Account Settings",
	"user.settings.notifications.allActivity": "For all activity",
	"user.settings.notifications.channelWide": "Channel-wide mentions \"@channel\", \"@all\", \"@here\"",
	"user.settings.notifications.close": "Close",
	"user.settings.notifications.comments": "Reply notifications",
	"user.settings.notifications.commentsAny": "Trigger notifications on messages in reply threads that I start or participate in",
	"user.settings.notifications.commentsInfo": "In addition to notifications for when you're mentioned, select if you would like to receive notifications on reply threads.",
	"user.settings.notifications.commentsNever": "Do not trigger notifications on messages in reply threads unless I'm mentioned",
	"user.settings.notifications.commentsRoot": "Trigger notifications on messages in threads that I start",
	"user.settings.notifications.desktop": "Send desktop notifications",
	"user.settings.notifications.desktop.allNoSoundForever": "For all activity, without sound, shown indefinitely",
	"user.settings.notifications.desktop.allNoSoundTimed": "For all activity, without sound, shown for {seconds} seconds",
	"user.settings.notifications.desktop.allSoundForever": "For all activity, with sound, shown indefinitely",
	"user.settings.notifications.desktop.allSoundHiddenForever": "For all activity, shown indefinitely",
	"user.settings.notifications.desktop.allSoundHiddenTimed": "For all activity, shown for {seconds} seconds",
	"user.settings.notifications.desktop.allSoundTimed": "For all activity, with sound, shown for {seconds} seconds",
	"user.settings.notifications.desktop.duration": "Notification duration",
	"user.settings.notifications.desktop.durationInfo": "Sets how long desktop notifications will remain on screen when using Firefox or Chrome. Desktop notifications in Edge and Safari can only stay on screen for a maximum of 5 seconds.",
	"user.settings.notifications.desktop.mentionsNoSoundForever": "For mentions and direct messages, without sound, shown indefinitely",
	"user.settings.notifications.desktop.mentionsNoSoundTimed": "For mentions and direct messages, without sound, shown for {seconds} seconds",
	"user.settings.notifications.desktop.mentionsSoundForever": "For mentions and direct messages, with sound, shown indefinitely",
	"user.settings.notifications.desktop.mentionsSoundHiddenForever": "For mentions and direct messages, shown indefinitely",
	"user.settings.notifications.desktop.mentionsSoundHiddenTimed": "For mentions and direct messages, shown for {seconds} seconds",
	"user.settings.notifications.desktop.mentionsSoundTimed": "For mentions and direct messages, with sound, shown for {seconds} seconds",
	"user.settings.notifications.desktop.seconds": "{seconds} seconds",
	"user.settings.notifications.desktop.sound": "Notification sound",
	"user.settings.notifications.desktop.title": "Desktop notifications",
	"user.settings.notifications.desktop.unlimited": "Unlimited",
	"user.settings.notifications.desktopSounds": "Desktop notification sounds",
	"user.settings.notifications.email.disabled": "Disabled by System Administrator",
	"user.settings.notifications.email.disabled_long": "Email notifications have been disabled by your System Administrator.",
	"user.settings.notifications.email.everyHour": "Every hour",
	"user.settings.notifications.email.everyXMinutes": "Every {count, plural, one {minute} other {{count, number} minutes}}",
	"user.settings.notifications.email.immediately": "Immediately",
	"user.settings.notifications.email.never": "Never",
	"user.settings.notifications.email.send": "Send email notifications",
	"user.settings.notifications.emailBatchingInfo": "Notifications received over the time period selected are combined and sent in a single email.",
	"user.settings.notifications.emailInfo": "Email notifications are sent for mentions and direct messages when you are offline or away from {siteName} for more than 5 minutes.",
	"user.settings.notifications.emailNotifications": "Email notifications",
	"user.settings.notifications.header": "Notifications",
	"user.settings.notifications.info": "Desktop notifications are available on Edge, Firefox, Safari, Chrome and Cordchat Desktop Apps.",
	"user.settings.notifications.mentionsInfo": "Mentions trigger when someone sends a message that includes your username (\"@{username}\") or any of the options selected above.",
	"user.settings.notifications.never": "Never",
	"user.settings.notifications.noWords": "No words configured",
	"user.settings.notifications.off": "Off",
	"user.settings.notifications.on": "On",
	"user.settings.notifications.onlyMentions": "Only for mentions and direct messages",
	"user.settings.notifications.push": "Mobile push notifications",
	"user.settings.notifications.push_notification.status": "Trigger push notifications when",
	"user.settings.notifications.sensitiveName": "Your case sensitive first name \"{first_name}\"",
	"user.settings.notifications.sensitiveUsername": "Your non-case sensitive username \"{username}\"",
	"user.settings.notifications.sensitiveWords": "Other non-case sensitive words, separated by commas:",
	"user.settings.notifications.soundConfig": "Please configure notification sounds in your browser settings",
	"user.settings.notifications.sounds_info": "Notification sounds are available on IE11, Safari, Chrome and Cordchat Desktop Apps.",
	"user.settings.notifications.teamWide": "Team-wide mentions \"@all\"",
	"user.settings.notifications.title": "Notification Settings",
	"user.settings.notifications.wordsTrigger": "Words that trigger mentions",
	"user.settings.push_notification.allActivity": "For all activity",
	"user.settings.push_notification.allActivityAway": "For all activity when away or offline",
	"user.settings.push_notification.allActivityOffline": "For all activity when offline",
	"user.settings.push_notification.allActivityOnline": "For all activity when online, away or offline",
	"user.settings.push_notification.away": "Away or offline",
	"user.settings.push_notification.disabled": "Disabled by System Administrator",
	"user.settings.push_notification.disabled_long": "Push notifications for mobile devices have been disabled by your System Administrator.",
	"user.settings.push_notification.info": "Notification alerts are pushed to your mobile device when there is activity in Cordchat.",
	"user.settings.push_notification.label.nonwvc": "(Exclude Web Visitor Center)",
	"user.settings.push_notification.label.wvc": "(For Web Visitor Center Only)",
	"user.settings.push_notification.off": "Off",
	"user.settings.push_notification.offline": "Offline",
	"user.settings.push_notification.online": "Online, away or offline",
	"user.settings.push_notification.onlyMentions": "For mentions and direct messages",
	"user.settings.push_notification.onlyMentionsAway": "For mentions and direct messages when away or offline",
	"user.settings.push_notification.onlyMentionsOffline": "For mentions and direct messages when offline",
	"user.settings.push_notification.onlyMentionsOnline": "For mentions and direct messages when online, away or offline",
	"user.settings.push_notification.onlyMentions.wvc": "For mentions",
	"user.settings.push_notification.onlyMentionsAway.wvc": "For mentions when away or offline",
	"user.settings.push_notification.onlyMentionsOffline.wvc": "For mentions when offline",
	"user.settings.push_notification.onlyMentionsOnline.wvc": "For mentions when online, away or offline",
	"user.settings.push_notification.send": "Send mobile push notifications",
	"user.settings.push_notification.status": "Trigger push notifications when",
	"user.settings.push_notification.status_info": "Notification alerts are only pushed to your mobile device when your online status matches the selection above.",
	"user.settings.security.active": "Active",
	"user.settings.security.close": "Close",
	"user.settings.security.currentPassword": "Current Password",
	"user.settings.security.currentPasswordError": "Please enter your current password.",
	"user.settings.security.deauthorize": "Deauthorize",
	"user.settings.security.emailPwd": "Email / Mobile and Password",
	"user.settings.security.gitlab": "GitLab",
	"user.settings.security.google": "Google",
	"user.settings.security.inactive": "Inactive",
	"user.settings.security.lastUpdated": "Last updated {date} at {time}",
	"user.settings.security.ldap": "AD/LDAP",
	"user.settings.security.loginGitlab": "Login done through GitLab",
	"user.settings.security.loginGoogle": "Login done through Google Apps",
	"user.settings.security.loginLdap": "Login done through AD/LDAP",
	"user.settings.security.loginOffice365": "Login done through Office 365",
	"user.settings.security.loginSaml": "Login done through SAML",
	"user.settings.security.logoutActiveSessions": "View and Logout of Active Sessions",
	"user.settings.security.method": "Sign-in Method",
	"user.settings.security.newPassword": "New Password",
	"user.settings.security.noApps": "No OAuth 2.0 Applications are authorized.",
	"user.settings.security.oauthApps": "OAuth 2.0 Applications",
	"user.settings.security.oauthAppsDescription": "Click 'Edit' to manage your OAuth 2.0 Applications",
	"user.settings.security.oauthAppsHelp": "Applications act on your behalf to access your data based on the permissions you grant them.",
	"user.settings.security.office365": "Office 365",
	"user.settings.security.oneSignin": "You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.",
	"user.settings.security.password": "Password",
	"user.settings.security.passwordError": "Your password must contain between {min} and {max} characters.",
	"user.settings.security.passwordErrorLowercase": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter.",
	"user.settings.security.passwordErrorLowercaseNumber": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one number.",
	"user.settings.security.passwordErrorLowercaseNumberSymbol": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorLowercaseSymbol": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorLowercaseUppercase": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter and at least one uppercase letter.",
	"user.settings.security.passwordErrorLowercaseUppercaseNumber": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, and at least one number.",
	"user.settings.security.passwordErrorLowercaseUppercaseNumberSymbol": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorLowercaseUppercaseSymbol": "Your password must contain between {min} and {max} characters made up of at least one lowercase letter, at least one uppercase letter, and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorNumber": "Your password must contain between {min} and {max} characters made up of at least one number.",
	"user.settings.security.passwordErrorNumberSymbol": "Your password must contain between {min} and {max} characters made up of at least one number and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorSymbol": "Your password must contain between {min} and {max} characters made up of at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorUppercase": "Your password must contain between {min} and {max} characters made up of at least one uppercase letter.",
	"user.settings.security.passwordErrorUppercaseNumber": "Your password must contain between {min} and {max} characters made up of at least one uppercase letter and at least one number.",
	"user.settings.security.passwordErrorUppercaseNumberSymbol": "Your password must contain between {min} and {max} characters made up of at least one uppercase letter, at least one number, and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordErrorUppercaseSymbol": "Your password must contain between {min} and {max} characters made up of at least one uppercase letter and at least one symbol (e.g. \"~!@#$%^&*()\").",
	"user.settings.security.passwordGitlabCantUpdate": "Login occurs through GitLab. Password cannot be updated.",
	"user.settings.security.passwordGoogleCantUpdate": "Login occurs through Google Apps. Password cannot be updated.",
	"user.settings.security.passwordLdapCantUpdate": "Login occurs through AD/LDAP. Password cannot be updated.",
	"user.settings.security.passwordMatchError": "The new passwords you entered do not match.",
	"user.settings.security.passwordMinLength": "Invalid minimum length, cannot show preview.",
	"user.settings.security.passwordOffice365CantUpdate": "Login occurs through Office 365. Password cannot be updated.",
	"user.settings.security.passwordSamlCantUpdate": "This field is handled through your login provider. If you want to change it, you need to do so through your login provider.",
	"user.settings.security.retypePassword": "Retype New Password",
	"user.settings.security.saml": "SAML",
	"user.settings.security.switchEmail": "Switch to using email and password",
	"user.settings.security.switchGitlab": "Switch to using GitLab SSO",
	"user.settings.security.switchGoogle": "Switch to using Google SSO",
	"user.settings.security.switchApple": "Switch to using Sign in With Apple",
	"user.settings.security.switchLdap": "Switch to using AD/LDAP",
	"user.settings.security.switchOffice365": "Switch to using Office 365 SSO",
	"user.settings.security.switchSaml": "Switch to using SAML SSO",
	"user.settings.security.title": "Security Settings",
	"user.settings.security.viewHistory": "View Access History",
	"user.settings.tokens.cancel": "Cancel",
	"user.settings.tokens.clickToEdit": "Click 'Edit' to manage your personal access tokens",
	"user.settings.tokens.confirmCreateButton": "Yes, Create",
	"user.settings.tokens.confirmCreateMessage": "You are generating a personal access token with System Admin permissions. Are you sure want to create this token?",
	"user.settings.tokens.confirmCreateTitle": "Create System Admin Personal Access Token",
	"user.settings.tokens.confirmDeleteButton": "Yes, Delete",
	"user.settings.tokens.confirmDeleteMessage": "Any integrations using this token will no longer be able to access the Cordchat API. You cannot undo this action. <br /><br />Are you sure want to delete the <strong>{description}</strong> token?",
	"user.settings.tokens.confirmDeleteTitle": "Delete Token?",
	"user.settings.tokens.copy": "Please copy the access token below. You won't be able to see it again!",
	"user.settings.tokens.create": "Create New Token",
	"user.settings.tokens.delete": "Delete",
	"user.settings.tokens.description": "Personal access tokens function similar to session tokens and can be used by integrations to authenticate against the REST API.",
	"user.settings.tokens.description_mobile": "Personal access tokens function similar to session tokens and can be used by integrations to authenticate against the REST API. Create new tokens on your desktop.",
	"user.settings.tokens.id": "Token ID: ",
	"user.settings.tokens.name": "Token Description: ",
	"user.settings.tokens.nameHelp": "Enter a description for your token to remember what it does.",
	"user.settings.tokens.nameRequired": "Please enter a description.",
	"user.settings.tokens.save": "Save",
	"user.settings.tokens.title": "Personal Access Tokens",
	"user.settings.tokens.token": "Access Token: ",
	"user.settings.tokens.tokenId": "Token ID: ",
	"user.settings.tokens.userAccessTokensNone": "No personal access tokens.",
	"user_list.notFound": "No users found",
	"user_profile.send.dm": "Send Message",
	"user_profile.webrtc.call": "Video Call",
	"user_profile.webrtc.offline": "The user is offline",
	"user_profile.webrtc.unavailable": "New call unavailable until your existing call ends",
	"view_image.loading": "Loading ",
	"view_image_popover.download": "Download",
	"view_image_popover.download_all": "Download All",
	"view_image_popover.file": "File {count, number} of {total, number}",
	"view_image_popover.publicLink": "Get Public Link",
	"web.footer.about": "About",
	"web.footer.help": "Help",
	"web.footer.privacy": "Privacy",
	"web.footer.terms": "Terms",
	"web.header.back": "Back",
	"web.header.logout": "Logout",
	"web.root.signup_info": "New Landscape. New Experience!",
	"webrtc.invite": "Add Participants",
	"webrtc.statusReject": "The status of {username} does not accept your call",
	"webrtc.busy": "{username} is busy.",
	"webrtc.call": "Call",
	"webrtc.callEnded": "Call with {username} ended.",
	"webrtc.cancel": "Cancel call",
	"webrtc.cancelled": "{username} cancelled the call.",
	"webrtc.declined": "Your call has been declined by {username}.",
	"webrtc.disabled": "{username} has WebRTC disabled, and cannot receive calls. To enable the feature, they must go to Account Settings > Advanced > Preview pre-release features and turn on WebRTC.",
	"webrtc.failed": "There was a problem connecting the video call.",
	"webrtc.hangup": "Hang up",
	"webrtc.header": "Call with {username}",
	"webrtc.inProgress": "You have a call in progress. Please hang up first.",
	"webrtc.mediaError": "Unable to access camera or microphone.",
	"webrtc.mute_audio": "Mute microphone",
	"webrtc.noAnswer": "{username} is not answering the call.",
	"webrtc.notification.answer": "Answer",
	"webrtc.notification.decline": "Decline",
	"webrtc.notification.incoming_call": "{username} is inviting you to make a video call",
	"webrtc.notification.incoming_call2": "{username} is inviting you to make a voice call",
	"webrtc.notification.returnToCall": "Return to ongoing call with {username}",
	"webrtc.offline": "{username} is offline.",
	"webrtc.pause_video": "Turn off camera",
	"webrtc.unmute_audio": "Unmute microphone",
	"webrtc.unpause_video": "Turn on camera",
	"webrtc.unsupported": "{username} client does not support video calls.",
	"youtube_video.notFound": "Video not found",
	"admin.sidebar.facebook": "Facebook",
	"admin.authentication.facebook": "Facebook",
	"admin.facebook.enableSignInTitle": "Enable authentication with with Facebook: ",
	"admin.facebook.enableSignInDescription": "When true, Cordchat allows team creation and account signup using Facebook OAuth.",
	"admin.facebook.clientIdTitle": "Application ID:",
	"admin.facebook.clientSecretExample": "E.g.: \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.facebook.clientIdDescription": "Obtain this value via the instructions above for logging into Facebook",
	"admin.facebook.sdkVersionTitle": "SDK Version:",
	"user.settings.general.emailFacebookCantUpdate": "Login occurs through Facebook. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.loginFacebook": "Login done through Facebook ({email})",
	"user.settings.security.facebook": "Facebook",
	"signup.facebook": "Facebook Account",
	"channel_header.setSelfDestructTimer": "Set Self-Destruct Timer",
	"self_destruct_timer.max": "This field must be equal or smaller than {max, number}",
	"self_destruct_timer.min": "This field must be equal or greater than {min, number}",
	"self_destruct_timer.patternError": "This field must be in range of {min, number} - {max, number}",
	"self_destruct_timer.timerPlaceHolder": "Self-Destruct Time",
	"self_destruct_timer.displayName": "Message will self destruct after message created",
	"self_destruct_timer.example": "never delete when 0; Please note that the timer does not affect messages sent or received before it was set, nor after it is disabled.",
	"self_destruct_timer.deleteAllMessages": "Delete all previous messages",
	"self_destruct_timer.cancel": "Cancel",
	"self_destruct_timer.save": "Save",
	"user_profile.find.msg": "Find Messages",
	"channel_header.initSitechatScript": "Customize Chatbox",
	"sitechat_script.css_description": "Please copy this to your website page <head> tag",
	"sitechat_script.js_description": "Please copy these scripts to your website <body> tag",
	"sitechat_script.genScript": "Generate Scripts",
	"get_code.clipboard": "Scripts copied",
	"get_code.copy": "Copy Scripts",
	"sidebar.createWVC": "Create New Web Visitor Center",
	"admin.general.policy.restrictWVCCreationTitle": "Enable Web Visitor Center creation for:",
	"admin.general.policy.restrictWVCCreationDescription": "Set policy on who can create web visitor center.",
	"sidebar.WVC": "WEB VISITOR CENTER",
	"channel_modal.modalTitle2": "New Channel(Web Visitor Center)",
	"channel_modal.WVCHelp": "You can create a Web Visitor Center (WVC) channel here. All your customer service staff will be notified by desktop / push notifications when there is any message from new guests of your WVC. Your customer service staff can then directly communicate with your guest through Cordchat.",
	"channel_modal.wvc.titleBar": "Title Bar",
	"channel.wvc_theme.titleBarColor": "Title Bar Color",
	"channel.wvc_theme.titleFontColor": "Title Font Color",
	"channel_modal.wvc.titleLabel": "Title Label",
	"channel_modal.wvc.greeting_message": "Greeting Message",
	"channel_modal.wvc.message_placeholder": "Message entry placeholder text",
	"channel_modal.wvc.slogan": "<h4>Prompt response to your customers is always a key to success.</h4>",
	"channel_modal.wvc.tipsTitle": "<b>Important Notes:</b>",
	"channel_modal.wvc.tips": "<ul><li>Add all your customer service staff into this channel. </li><li>Set appropriate notification setting for this channel so that no guest of your WVC will be ignored.</li><li>After you create this channel, Cordchat will generate two lines of code for you to plant a Web Visitor Centre into your website.</li></ul>",
	"sitechat_script.close": "Close",
	"about.customVersion": "1.0.2",
	"help.keyboard_shortcut.title": "# Keyboard Shortcuts\n_____",
	"help.keyboard_shortcut.desc1": "Keyboard shortcuts perform operations in Cordchat to help you navigate through channels and make a more efficient use of your keyboard.",
	"help.keyboard_shortcut.desc2": "To display a list of available keyboard shortcuts, type CTRL+/ (CMD+/ on Mac), or `/shortcuts`.",
	"help.keyboard_shortcut.sub_title.navigation": "## Navigation",
	"help.keyboard_shortcut.table.navigation": "| On Windows                             | On Mac                                 | Description                                                                  |\n| -------------------------------------- | -------------------------------------- | ---------------------------------------------------------------------------- |\n| ALT+UP                                 | ALT+UP                                 | Previous channel or direct message in left hand sidebar                      |\n| ALT+DOWN                               | ALT+DOWN                               | Next channel or direct message in left hand sidebar                          |\n| ALT+SHIFT+UP                           | ALT+SHIFT+UP                           | Previous channel or direct message in left hand sidebar with unread messages |\n| ALT+SHIFT+DOWN                         | ALT+SHIFT+DOWN                         | Next channel or direct message in left hand sidebar with unread messages     |\n| CTRL+K                                 | CMD+K                                  | Open a quick channel switcher dialog                                         |\n| CTRL+SHIFT+K                           | CMD+SHIFT+K                            | Open the Direct Messages dialog                                              |\n| CTRL+SHIFT+A                           | CMD+SHIFT+A                            | Open the Account Settings dialog                                             |\n| CTRL+SHIFT+M                           | CMD+SHIFT+M                            | Open recent mentions                                                         |",
	"help.keyboard_shortcut.sub_title.files": "## Files",
	"help.keyboard_shortcut.table.files": "| On Windows                             | On Mac                                 | Description                                                    |\n| -------------------------------------- | -------------------------------------- | -------------------------------------------------------------- |\n| CTRL+U                                 | CMD+U                                  | Upload a file                                                  |",
	"help.keyboard_shortcut.sub_title.messages": "## Messages",
	"help.keyboard_shortcut.table.messages": "| On Windows                             | On Mac                                 | Description                                                                |\n| -------------------------------------- | -------------------------------------- | -------------------------------------------------------------------------- |\n| CTRL+UP (in empty input field)         | CMD+UP (in empty input field)          | Reprint previous message or slash command you entered                      |\n| CTRL+DOWN (in empty input field)       | CMD+DOWN (in empty input field)        | Reprint next message or slash command you entered                          |\n| SHIFT+UP (in empty input field)        | SHIFT+UP (in empty input field)        | Reply to the most recent message in the current channel                    |\n| UP (in empty input field)              | UP (in empty input field)              | Edit your last message in the current channel                              |\n| @[character]+TAB                       | @[character]+TAB                       | Autocomplete @username beginning with [character]                          |\n| ~[character]+TAB                       | ~[character]+TAB                       | Autocomplete channel beginning with [character]                            |\n| :[character]+TAB                       | :[character]+TAB                       | Autocomplete emoji beginning with [character]                              |",
	"help.keyboard_shortcut.sub_title.browser": "## Browser Built-In",
	"help.keyboard_shortcut.table.browser": "| On Windows                             | On Mac                                 | Description                                                    |\n| -------------------------------------- | -------------------------------------- | -------------------------------------------------------------- |\n| ALT+LEFT                               | CMD+[                                  | Previous channel in your history                               |\n| ALT+RIGHT                              | CMD+]                                  | Next channel in your history                                   |\n| CTRL+PLUS                              | CMD+PLUS                               | Increase font size (zoom in)                                   |\n| CTRL+MINUS                             | CMD+MINUS                              | Decrease font size (zoom out)                                  |\n| SHIFT+UP (in input field)              | SHIFT+UP (in input field)              | Highlight text to the previous line                            |\n| SHIFT+DOWN (in input field)            | SHIFT+DOWN (in input field)            | Highlight text to the next line                                |\n| SHIFT+ENTER (in input field)           | SHIFT+ENTER (in input field)           | Create a new line                                              |",
	"self_destruct_timer.unitOption.month": "Month",
	"self_destruct_timer.unitOption.day": "Day",
	"self_destruct_timer.unitOption.hour": "Hour",
	"self_destruct_timer.unitOption.minute": "Minute",
	"self_destruct_timer.unitOption.second": "Second",
	"admin.general.policy.permissionsNobody": "Nobody",
	"admin.general.policy.addMemberTitle": "Enable adding members to team:",
	"admin.general.policy.addMemberDescription": "Set policy on who can invite others to a team using <b>Add Members to Team</b> option from the Main Menu.",
	"help.messaging.table": "| Text Entered | How It Appears |\n| ---- | ---- |\n| `_italics_` | _italics_ |\n| `**bold**` | **bold** |\n| `~~strikethrough~~` | ~~strikethrough~~ |\n| ``monospace`` | `monospace` |\n| `[hyperlink](https://sitename.com/)` | [hyperlink](https://sitename.com/) |\n| `![embedded image](https://travis-ci.org/temp/temp.svg)` | ![embedded image](https://travis-ci.org/temp/temp.svg) |\n| `:smile:` `:sheep:` `:alien:` | :smile: :sheep: :alien: |",
	"help.commands.table": "| Command | Description | Example |\n| ---- | ---- | ---- |\n| /away | Set your status away | /away |\n| /offline | Set your status offline | /offline |\n| /online | Set your status online | /online |\n| /code {text} | Display text as a code block | /code File bugs |\n| /collapse | Turn on auto-collapsing of image previews | /collapse |\n| /expand | Turn off auto-collapsing of image previews | /expand |\n| /echo {message} {delay in seconds} | Echo back text from your account | /echo Hello World 5 |\n| /header {text} | Edit the channel header | /header File bugs here |\n| /purpose {text} | Edit the channel purpose | /purpose A channel to discuss bugs |\n| /rename {text} | Rename the channel | /rename Developers |\n| /help | Open the help page | /help |\n| /invite_people {name@domain.com ?�} | Send an email invite to your Cordchat team | /invite_people john@example.com |\n| /join {channel-name} | Join the open channel | /join off-topic |\n| /open {channel-name} | Join the open channel | /open off-topic |\n| /leave | Leave the current channel | /leave |\n| /logout | Log out of Cordchat | /logout |\n| /me {message} | Do an action | /me Hello World |\n| /msg {@username} {message} | Send a Direct Message to a user | /msg @alice hello |\n| /search {text} | Search text in messages | /search meeting |\n| /settings | Open the Account Settings dialog | /settings |\n| /shortcuts | Display a list of keyboard shortcuts | /shortcuts |\n| /shrug {message} | Add `¯\\_(ツ)_/¯` to your message | /shrug oh well |",
	"channel_header.unreadPost": "Unread Posts",
	"sidebar_right_menu.unread": "Unread Posts",
	"search_results.noUnreadPost": "You don't have any unread messages yet.",
	"team.settings.general.imageUpdated": "Image last updated {date}",
	"team.settings.general.validImage": "Only JPG or PNG images may be used for team pictures",
	"team.settings.general.uploadImage": "Click 'Edit' to upload an image.",
	"team.settings.general.imageTooLarge": "Unable to upload profile image. File is too large.",
	"team.settings.general.mobile.uploadImage": "Click to upload an image.",
	"team.settings.general.profilePicture": "Team Picture",
	"channel.settings.general.validImage": "Only JPG or PNG images may be used for channel pictures.",
	"create_team.ppTeamTip": "<b>Public team</b> will allow any user to join without invitation. <b>Private team</b> will only allow user to join through invitation.",
	"create_team.publicTeamTip": "This is a <b>public</b> team (unclick to turn this team to <b>private</b>)",
	"create_team.privateTeamTip": "This is a <b>private</b> team (click to turn this team to <b>public</b>)",
	"user.settings.security.openuserTitle": "Allow other teams to add me",
	"user.settings.security.openuserDesc": "If enabled, Others can add you to their team . By default, this setting is enabled.",
	"navbar_dropdown.selfDestructSettings": "Self Destruct Setting",
	"self_destruct.setting.disabled": "Disabled",
	"self_destruct.setting.selectAll": "Select All",
	"self_destruct.setting.deselectAll": "Deselect All",
	"self_destruct.settings.directMessageTitle": "Direct Messages",
	"sidebar.wvc.notYetReplied": "NOT YET REPLIED",
	"sidebar.wvc.repliedByMe": "REPLIED BY ME",
	"sidebar.wvc.repliedByOthers": "REPLIED BY OTHERS",
	"sidebar.expand": "Expand",
	"sidebar.collapse": "Collapse",
	"tutorial_intro.customTheme": "Custom Theme",
	"tutorial_intro.setDifferentThemeInfo": " You can now choose different themes for different teams and say goodbye to sending wrong message.",
	"post_info.wvc_client": "Guest",
	"user.settings.display.theme.slogan": "<h4>You can now choose different themes for different teams and say goodbye to sending wrong message.</h4>",
	"search_results.allteam": "Multiple Team ",
	"search_results.currentteam": "Only Current Team",
	"search_results.markAsRead": "Mark All as Read",
	"sidebar.createDMG": "New Direct Messages",
	"team_export_tab.exportInstructions": "Message in all public and private channels will be exported as .csv file.",
	"team_export_tab.exportInstructions2": "Click the link below to download the .csv file generated:",
	"team_export_tab.exportInstructions3": "The entire export process may take a long time, you can leave first, we will send the download link of the file to your Cordchat email account later.",
	"team_export_tab.doexport": "Begin Export",
	"team_export_tab.exporting": "Exporting...",
	"team_export_tab.successful": ".csv file generation success.",
	"team_export_tab.failure": "Export failed",
	"search_date_provide.thisweek": "This Week",
	"search_date_provide.thismonth": "This Month",
	"search_date_provide.thisyear": "This Year",
	"search_date_provide.today": "Today",
	"search_date_provide.withinNdays": "Within N day",
	"team_storage_tab.teamStorage": "Team Storage",
	"team_settings_modal.storageTab": "Storage",
	"team_storage_tab.storageDetail1": "Limit",
	"team_storage_tab.storageDetail2": "Used",
	"team_storage_tab.storageDetail3": "Available",
	"team_storage_tab.storageDetail4": "Storage data up to: {calcat}",
	"team_export_tab.encodeCase": "Cordchat fully supports unicode. When you use MS Excel to open the .csv file downloaded and your message contains non-English character, please take proper steps to open the .csv file. Otherwise, MS Excel may not be able to display the non-English character properly. ",
	"checkout_sidebar.order": "Order",
	"checkout_sidebar.billing": "Billing",
	"checkout_sidebar.address": "Address",
	"billing.order.header": "Checkout",
	"billing.overview.orderNo": "Order No.",
	"billing.overview.availableUser": "Available Users",
	"billing.available_user.unlimited": "Unlimited",
	"billing.purchasedUnit.title": "Purchased Unit",
	"billing.purchasedUser.title": "Purchased Users",
	"billing.purchasedStorage.title": "Purchased Storage (GB)",
	"billing.storageLimit.title": "Storage Limit",
	"billing.startsAt.title": "Starts At",
	"billing.startedAt.title": "Started At",
	"billing.expiresAt.title": "Expires At",
	"billing.overview.header": "Overview",
	"billing.address.header": "Billing Address",
	"billing.paymentMethod.alipay": "Alipay",
	"billing.paymentMethod.jetco": "Credit Card",
	"billing.paymentMethod.stripe": "Credit Card",
	"billing.paymentMethod.stripe_prepaid": "Prepaid Card",
	"billing.paymentMethod.stripe_credit": "Credit Card",
	"billing.paymentMethod.stripe_debit": "Debit Card",
	"billing.paymentMethod.stripe_unknown": "Unknown",
	"billing.paymentMethod.card_visa": "Visa",
	"billing.paymentMethod.card_mastercard": "MasterCard",
	"billing.paymentMethod.card_american_express": "American Express",
	"billing.paymentMethod.zero_payment": "Zero Payment",
	"billing.paymentMethod.title": "Payment Method",
	"billing.amount.title": "Amount",
	"billing.currency.title": "Currency",
	"billing.orderType.title": "Order Type",
	"billing.newContractValue.title": "New Order Total Amount",
	"billing.netContractValue.title": "Current Contract Residual Value",
	"checkout.form.current_used_storage": "Current Used Storage",
	"checkout.form.expiry_date": "Prefer Service End Month",
	"checkout.form.label.number_of_storage": "Storage (GB)",
	"checkout.form.label.order_type": "Order Type",
	"billing.orderType.new.label": "New Contract",
	"billing.orderType.add.label": "Add Users",
	"billing.orderType.startup.label": "Business",
	"billing.orderType.business.label": "Business",
	"checkout.order_type.new": "New Contract to Keep Continues",
	"checkout.order_type.add": "Add Users to Existing Contracts",
	"checkout.order_type.business": "Business",
	"checkout.order_type.startup": "Business",
	"billing.paymentDate.title": "Payment Date",
	"billing.contract.current": "Current",
	"billing.contract.next": "Next",
	"billing.overview.orderHist": "Order History",
	"checkout.order.button": "Order",
	"billing.learn_more": "Learn More",
	"billing.order_now": "Order Now",
	"checkout.form.help.number_of_storage": "{price} {currency} per GB per month (billed annually)",
	"checkout.form.help.number_of_user": "{currency} {price} per user per month (billed annually)",
	"checkout.form.label.number_of_user": "Number of Users",
	"checkout.form.label.team_name": "Team Name",
	"billing.free.desc": "Upgrade to Business plan to enjoy ultimate features.",
	"billing.free.header": "Your Team is under Free License.",
	"navbar_dropdown.billing": "Billing Overview",
	"billing.checkout.amountDetail": "Amount Detail",
	"checkout.amountDetail.current.subAmount": "{currency} {price} x 12 Months x {user} Users x {paid_days}/{total_contract_days}",
	"checkout.amountDetail.next.subAmount": "{currency} {price} x 12 Months x {contract} Contracts x {user} Users",
	"checkout.form.notApplicable": "N/A",
	"checkout.amountDetail.totalAmount": "Total Amount",
	"checkout.form.totalMemberCounts": "Current Team Members",
	"checkout.form.error.user_cannot_less_than_current": "The number of users cannot be less than current team members.",
	"checkout.form.error.user_cannot_less_than_one": "The number of users must be greater than 0.",
	"checkout.form.error.storage_cannot_less_than_min": "The storage size must be greater than or equal to 10 GB.",
	"checkout.form.error.storage_cannot_less_than_current": "The storage size cannot be less than current storage usage.",
	"billing.address.button": "Save",
	"billing.address.next": "Next",
	"billing.address.form.label.company_name": "Company Name",
	"billing.address.form.label.city": "City",
	"billing.address.form.label.province": "Province",
	"billing.address.form.label.address": "Address",
	"billing.address.form.label.country": "Country",
	"billing.address.form.label.contact_name": "Contact Name",
	"billing.address.form.label.contact_phone": "Contact Phone",
	"billing.address.form.label.contact_email": "Contact Email",
	"backstage_navbar.backToBilling": "Back to billing overview",
	"billing.invoice.header": "Invoice",
	"billing.invoice.billing_to.header": "Bill To",
	"billing.invoice.order_detail": "Order Detail",
	"billing.invoice.print.button": "Print",
	"country.AFG": "Afghanistan",
	"country.ALA": "?land Islands",
	"country.ALB": "Albania",
	"country.DZA": "Algeria",
	"country.ASM": "American Samoa",
	"country.AND": "Andorra",
	"country.AGO": "Angola",
	"country.AIA": "Anguilla",
	"country.ATA": "Antarctica",
	"country.ATG": "Antigua and Barbuda",
	"country.ARG": "Argentina",
	"country.ARM": "Armenia",
	"country.ABW": "Aruba",
	"country.AUS": "Australia",
	"country.AUT": "Austria",
	"country.AZE": "Azerbaijan",
	"country.BHS": "Bahamas",
	"country.BHR": "Bahrain",
	"country.BGD": "Bangladesh",
	"country.BRB": "Barbados",
	"country.BLR": "Belarus",
	"country.BEL": "Belgium",
	"country.BLZ": "Belize",
	"country.BEN": "Benin",
	"country.BMU": "Bermuda",
	"country.BTN": "Bhutan",
	"country.BOL": "Bolivia (Plurinational State of)",
	"country.BES": "Bonaire, Sint Eustatius and Saba",
	"country.BIH": "Bosnia and Herzegovina",
	"country.BWA": "Botswana",
	"country.BVT": "Bouvet Island",
	"country.BRA": "Brazil",
	"country.IOT": "British Indian Ocean Territory",
	"country.BRN": "Brunei Darussalam",
	"country.BGR": "Bulgaria",
	"country.BFA": "Burkina Faso",
	"country.BDI": "Burundi",
	"country.KHM": "Cambodia",
	"country.CMR": "Cameroon",
	"country.CAN": "Canada",
	"country.CPV": "Cabo Verde",
	"country.CYM": "Cayman Islands",
	"country.CAF": "Central African Republic",
	"country.TCD": "Chad",
	"country.CHL": "Chile",
	"country.CHN": "China",
	"country.CXR": "Christmas Island",
	"country.CCK": "Cocos (Keeling) Islands",
	"country.COL": "Colombia",
	"country.COM": "Comoros",
	"country.COG": "Congo",
	"country.COD": "Congo (Democratic Republic of the)",
	"country.COK": "Cook Islands",
	"country.CRI": "Costa Rica",
	"country.CIV": "Côte d'Ivoire",
	"country.HRV": "Croatia",
	"country.CUB": "Cuba",
	"country.CUW": "Curaçao",
	"country.CYP": "Cyprus",
	"country.CZE": "Czech Republic",
	"country.DNK": "Denmark",
	"country.DJI": "Djibouti",
	"country.DMA": "Dominica",
	"country.DOM": "Dominican Republic",
	"country.ECU": "Ecuador",
	"country.EGY": "Egypt",
	"country.SLV": "El Salvador",
	"country.GNQ": "Equatorial Guinea",
	"country.ERI": "Eritrea",
	"country.EST": "Estonia",
	"country.ETH": "Ethiopia",
	"country.FLK": "Falkland Islands (Malvinas)",
	"country.FRO": "Faroe Islands",
	"country.FJI": "Fiji",
	"country.FIN": "Finland",
	"country.FRA": "France",
	"country.GUF": "French Guiana",
	"country.PYF": "French Polynesia",
	"country.ATF": "French Southern Territories",
	"country.GAB": "Gabon",
	"country.GMB": "Gambia",
	"country.GEO": "Georgia",
	"country.DEU": "Germany",
	"country.GHA": "Ghana",
	"country.GIB": "Gibraltar",
	"country.GRC": "Greece",
	"country.GRL": "Greenland",
	"country.GRD": "Grenada",
	"country.GLP": "Guadeloupe",
	"country.GUM": "Guam",
	"country.GTM": "Guatemala",
	"country.GGY": "Guernsey",
	"country.GIN": "Guinea",
	"country.GNB": "Guinea-Bissau",
	"country.GUY": "Guyana",
	"country.HTI": "Haiti",
	"country.HMD": "Heard Island and McDonald Islands",
	"country.VAT": "Holy See",
	"country.HND": "Honduras",
	"country.HKG": "Hong Kong",
	"country.HUN": "Hungary",
	"country.ISL": "Iceland",
	"country.IND": "India",
	"country.IDN": "Indonesia",
	"country.IRN": "Iran (Islamic Republic of)",
	"country.IRQ": "Iraq",
	"country.IRL": "Ireland",
	"country.IMN": "Isle of Man",
	"country.ISR": "Israel",
	"country.ITA": "Italy",
	"country.JAM": "Jamaica",
	"country.JPN": "Japan",
	"country.JEY": "Jersey",
	"country.JOR": "Jordan",
	"country.KAZ": "Kazakhstan",
	"country.KEN": "Kenya",
	"country.KIR": "Kiribati",
	"country.PRK": "Korea (Democratic People's Republic of)",
	"country.KOR": "Korea (Republic of)",
	"country.KWT": "Kuwait",
	"country.KGZ": "Kyrgyzstan",
	"country.LAO": "Lao People's Democratic Republic",
	"country.LVA": "Latvia",
	"country.LBN": "Lebanon",
	"country.LSO": "Lesotho",
	"country.LBR": "Liberia",
	"country.LBY": "Libya",
	"country.LIE": "Liechtenstein",
	"country.LTU": "Lithuania",
	"country.LUX": "Luxembourg",
	"country.MAC": "Macao",
	"country.MKD": "Macedonia (the former Yugoslav Republic of)",
	"country.MDG": "Madagascar",
	"country.MWI": "Malawi",
	"country.MYS": "Malaysia",
	"country.MDV": "Maldives",
	"country.MLI": "Mali",
	"country.MLT": "Malta",
	"country.MHL": "Marshall Islands",
	"country.MTQ": "Martinique",
	"country.MRT": "Mauritania",
	"country.MUS": "Mauritius",
	"country.MYT": "Mayotte",
	"country.MEX": "Mexico",
	"country.FSM": "Micronesia (Federated States of)",
	"country.MDA": "Moldova (Republic of)",
	"country.MCO": "Monaco",
	"country.MNG": "Mongolia",
	"country.MNE": "Montenegro",
	"country.MSR": "Montserrat",
	"country.MAR": "Morocco",
	"country.MOZ": "Mozambique",
	"country.MMR": "Myanmar",
	"country.NAM": "Namibia",
	"country.NRU": "Nauru",
	"country.NPL": "Nepal",
	"country.NLD": "Netherlands",
	"country.NCL": "New Caledonia",
	"country.NZL": "New Zealand",
	"country.NIC": "Nicaragua",
	"country.NER": "Niger",
	"country.NGA": "Nigeria",
	"country.NIU": "Niue",
	"country.NFK": "Norfolk Island",
	"country.MNP": "Northern Mariana Islands",
	"country.NOR": "Norway",
	"country.OMN": "Oman",
	"country.PAK": "Pakistan",
	"country.PLW": "Palau",
	"country.PSE": "Palestine, State of",
	"country.PAN": "Panama",
	"country.PNG": "Papua New Guinea",
	"country.PRY": "Paraguay",
	"country.PER": "Peru",
	"country.PHL": "Philippines",
	"country.PCN": "Pitcairn",
	"country.POL": "Poland",
	"country.PRT": "Portugal",
	"country.PRI": "Puerto Rico",
	"country.QAT": "Qatar",
	"country.REU": "Réunion",
	"country.ROU": "Romania",
	"country.RUS": "Russian Federation",
	"country.RWA": "Rwanda",
	"country.BLM": "Saint Barthélemy",
	"country.SHN": "Saint Helena, Ascension and Tristan da Cunha",
	"country.KNA": "Saint Kitts and Nevis",
	"country.LCA": "Saint Lucia",
	"country.MAF": "Saint Martin (French part)",
	"country.SPM": "Saint Pierre and Miquelon",
	"country.VCT": "Saint Vincent and the Grenadines",
	"country.WSM": "Samoa",
	"country.SMR": "San Marino",
	"country.STP": "Sao Tome and Principe",
	"country.SAU": "Saudi Arabia",
	"country.SEN": "Senegal",
	"country.SRB": "Serbia",
	"country.SYC": "Seychelles",
	"country.SLE": "Sierra Leone",
	"country.SGP": "Singapore",
	"country.SXM": "Sint Maarten (Dutch part)",
	"country.SVK": "Slovakia",
	"country.SVN": "Slovenia",
	"country.SLB": "Solomon Islands",
	"country.SOM": "Somalia",
	"country.ZAF": "South Africa",
	"country.SGS": "South Georgia and the South Sandwich Islands",
	"country.SSD": "South Sudan",
	"country.ESP": "Spain",
	"country.LKA": "Sri Lanka",
	"country.SDN": "Sudan",
	"country.SUR": "Suriname",
	"country.SJM": "Svalbard and Jan Mayen",
	"country.SWZ": "Swaziland",
	"country.SWE": "Sweden",
	"country.CHE": "Switzerland",
	"country.SYR": "Syrian Arab Republic",
	"country.TWN": "Taiwan",
	"country.TJK": "Tajikistan",
	"country.TZA": "Tanzania, United Republic of",
	"country.THA": "Thailand",
	"country.TLS": "Timor-Leste",
	"country.TGO": "Togo",
	"country.TKL": "Tokelau",
	"country.TON": "Tonga",
	"country.TTO": "Trinidad and Tobago",
	"country.TUN": "Tunisia",
	"country.TUR": "Turkey",
	"country.TKM": "Turkmenistan",
	"country.TCA": "Turks and Caicos Islands",
	"country.TUV": "Tuvalu",
	"country.UGA": "Uganda",
	"country.UKR": "Ukraine",
	"country.ARE": "United Arab Emirates",
	"country.GBR": "United Kingdom of Great Britain and Northern Ireland",
	"country.USA": "United States of America",
	"country.UMI": "United States Minor Outlying Islands",
	"country.URY": "Uruguay",
	"country.UZB": "Uzbekistan",
	"country.VUT": "Vanuatu",
	"country.VEN": "Venezuela (Bolivarian Republic of)",
	"country.VNM": "Viet Nam",
	"country.VGB": "Virgin Islands (British)",
	"country.VIR": "Virgin Islands (U.S.)",
	"country.WLF": "Wallis and Futuna",
	"country.ESH": "Western Sahara",
	"country.YEM": "Yemen",
	"country.ZMB": "Zambia",
	"country.ZWE": "Zimbabwe",
	"billing.address.incomplete_form": "Please fill out all the fields",
	"address.reminder.before_order": "Please fill out the billing address before place order.",
	"billing.address.success": "Saved",
	"billing.order_table.unit.user": "{count, number} {count, plural, one {User} other {Users}}",
	"billing.order_table.unit.storage": "{count, number} {count, plural, one {(GB)} other {(GB)}}",
	"billing.order_table.next": "Next",
	"billing.order_table.previous": "Previous",
	"order.error.title": "Permission Denied",
	"order.error.access": "You do not have permission to access the order page. Please ask your Team Administrator for details.",
	"billing.invoice.serviceProvider.title": "Service Provider",
	"billing.invoice.serviceProvider.value": "Cordchat",
	"billing.users_detail.title": "Effective Users",
	"billing.users_detail.effective_user": "Users",
	"billing.users_detail.from": "From",
	"billing.users_detail.to": "To",
	"billing.users_detail.btn": "Click to view effective users by period",
	"help.wvc.title": "# Web Visitor Center (WVC)\n_____",
	"help.wvc.create.header": "## How to Create WVC",
	"help.wvc.create.content": "Click the \"+\" button at the right hand side of **WEB VISITOR CENTER**.",
	"help.wvc.create.content2": "Then fill-out the channel name, title label, greeting message and placeholder that you want to display in your website.",
	"help.wvc.install.header": "## Installation to your website",
	"help.wvc.install.general.header": "#### Installation on General Website",
	"help.wvc.install.general.desc": "Copy the code displayed and paste the code into the source code of your website.",
	"help.wvc.install.general.example.header": "**Example:**",
	"help.wvc.install.magento.header": "#### Installation on Magento 2",
	"help.wvc.install.magento.method1.header": "**Method 1**",
	"help.wvc.install.magento.method1.desc": "Paste the code to your theme directory ``` /app/design/frontend/<Vendor>/<theme>/Magento_theme/templates/root.phtml```.",
	"help.wvc.install.magento.method1.css": "Put the following code before ```</head>```.",
	"help.wvc.install.magento.method1.js": "Put the following code before ```</body>```.",
	"help.wvc.install.magento.method2.header": "**Method 2**",
	"help.wvc.install.example.method2": "Download the extension in [here]({{SiteUrl}}/static/sitechat/magento/Cordchat.zip). Put the extension in your app directory ``` /app/code/```.",
	"help.wvc.install.example.method2.desc": "Go to your magento root directory and enter the following command lines.",
	"help.wvc.install.example.method2.command1": "```php bin/magento module:enable -c Cordchat_Chatbox ```",
	"help.wvc.install.example.method2.command2": "```php bin/magento setup:upgrade ```",
	"help.wvc.install.example.method2.command3": "```php bin/magento setup:static-content:deploy ```",
	"help.wvc.install.example.method2.admin": "Then login to admin panel: and tab **STORES** in sidebar. Click **Configuration** and expand **customer** tab to find **Cordchat**.",
	"help.wvc.install.example.method2.admin2": "Input the site ID, hostname, and click  **Save Config**.",
	"help.wvc.install.magento.result.header": "**Result**",
	"post_info.forward": "Forward to Other Channels",
	"post_info.forward_to_direct": "Forward to Direct Messages",
	"forward_message.from.me": "Me",
	"forward.filter.include_wvc": "Include Web Visitor Center",
	"forward_message.button.forward": "Forward",
	"post_body.ForwardedFrom": "Forwarded message from: {username}",
	"get_forward_modal.title": "Forward To",
	"get_forward_direct_modal.title": "Forward to Direct Messages",
	"get_forward_modal.help": "Please select a channel",
	"forward_message.modal.confirmTitle": "Confirm to Forward Message?",
	"forward_message.modal.confirmMsg": "Are you sure to forward to {teamName} - {channelName}?",
	"forward_message.direct.modal.confirmMsg": "Are you sure to forward to {displayName}?",
	"forward_message.modal.confirmBtns": "Confirm",
	"search_header.results.limit": "Only the first <b>{maxResult}</b> results are shown",
	"get_team_invite_link_modal.warn": "Anyone clicks the link generated can join this team and become a team member automatically.",
	"get_team_invite_link_modal.warn2": "Anyone clicks the link generated can join this team and become a team guest automatically.",
	"signup_user_completed.invalid_dismatch": "Current login user does not match with the invited email address or mobile number. Please logout first and then, click the invitation button again.",
	"invitation.new_arrived": "New Invitation Arrived",
	"invitation.ignore": "Ignore",
	"invitation.accept": "Accept",
	"invitation.question": "<strong>{sender}</strong> invited you to join <strong>{teamName}</strong> team. Do you accept?",
	"admin.storage.google_drive": "Google Drive",
	"admin.storage.google_drive.enableTitle": "Enable Google Drive:",
	"admin.storage.google_drive.enableDesc": "Enable user to select attachment from  Google Drive.",
	"admin.service.googleDriveDescription": "View a <a href=\"https://www.youtube.com/watch?v=Im69kzhpR3I\" target=\"_blank\">Google Developers Tutorial</a> for instructions on how to obtain a key.",
	"admin.google.appIdTitle": "Google App ID:",
	"admin.google.appIdExample": "Ex \"cordchat-162042\"",
	"admin.google.appIdDescription": "The App ID you received when registering your developer account with Google.",
	"admin.sidebar.google_drive": "Google Drive",
	"admin.sidebar.dropbox": "Dropbox",
	"admin.storage.dropbox": "Dropbox",
	"admin.storage.dropbox.enableTitle": "Enable Dropbox:",
	"admin.storage.dropbox.enableDesc": "Enable user to select attachment from Dropbox.",
	"admin.dropbox.appKeyTitle": "Dropbox App Key:",
	"admin.dropbox.appKeyExample": "Ex \"uk9wx12ecibgafg\"",
	"admin.dropbox.appKeyDescription": "<a href=\"https://www.dropbox.com/developers/apps/create\" target=\"_blank\">Create an Dropbox app</a> to obtain a app key.",
	"admin.dropbox.appSecret": "Dropbox App Secret:",
	"admin.dropbox.appSecretExample": "Ex \"katp3ybf0kp1boh\"",
	"admin.dropbox.appSecretDescription": "The App Secret you received when registering your developer account with Dropbox.",
	"attachment.file.upload_file": "Choose File to Upload",
	"attachment.file.google.drive": "Select from Google Drive",
	"attachment.file.dropbox": "Select from Dropbox",
	"google_drive.popups_blocked.error": "Please enable pop-ups in your browser.",
	"google_drive.filesCannotDownload": "Files could not be attached: {filenames}",
	"google_drive.fileCannotDownload": "File could not be attached: {filename}",
	"create_post.dropbox.error": "Dropbox file link expired, please select again.",
	"create_post.sending": " Sending...",
	"signup_team.join_invite": "Teams inviting you:",
	"google_drive.config.error": "Google Drive configuration problem. Please ask your System Administrator for details.",
	"add_users_to_team.addAllUsers": "Add All Available Users (Total: {total} {total, plural, one {User} other {Users}})",
	"add_users_to_team.addAllUsers.reach_page_max": "Add All Available Users (Total: 99+ Users)",
	"channel_invite.addAllMembers": "Add All Members (Total: {total} {total, plural, one {User} other {Users}})",
	"user_profile.unBlock": "Remove from Blacklist",
	"user_profile.block": "Add to Blacklist",
	"user_profile.blacklist": "Blacklist",
	"user_profile.blockInfo": "All direct messages sent to you by this user will be ignored.",
	"user_profile.unblockInfo": "Resume normal communication with this user.",
	"user.settings.modal.status": "Status",
	"status_dropdown.edit_status": "Edit Status",
	"user.settings.general.contact": "Sensitive Information",
	"user.settings.general.disclose": "Allow particular teams to see sensitive information",
	"user.settings.general.contact.companyName": "Company",
	"user.settings.general.contact.mobile": "Mobile",
	"user.settings.general.contact.tel": "Tel. and Extension",
	"user.settings.general.contact.isSensitive": "Is this field sensitive?",
	"user.settings.general.contact.helpText": "Sensitive info will only be shown to members of trusted team(s).",
	"user.settings.status.title": "Status Setting",
	"user.settings.status.btn.add": "Add New Status",
	"user.settings.statuses.addTitle": "Add New Status",
	"user.settings.status.name": "Name",
	"user.settings.status.type": "Type",
	"user.settings.status.description": "Description",
	"user.settings.status.promptInDM": "Prompt description to Direct Messages",
	"user.settings.status.promptWhenMention": "Prompt description to @",
	"status_desc.title": "Status Description",
	"status_desc.confirm": "Confirm",
	"user.settings.statuses.editTitle": "{name} ({type})",
	"status_dropdown.header.pre-defined": "Pre-defined Status",
	"status_dropdown.header.user-defined": "User Defined Status",
	"user.settings.status.delete": "Delete",
	"status_desc.helptext": "Status of selected members will not be promoted again in 15 minutes unless status changes.",
	"status_desc.btn.selectAll": "Select All",
	"status_desc.btn.deselectAll": "Deselect All",
	"user.setting.error.name.empty": "Name cannot be empty.",
	"user.setting.error.description.empty": "Description cannot be empty.",
	"stripe.invalid_number": "The card number is not a valid credit card number.",
	"stripe.invalid_expiry_month": "The card's expiration month is invalid.",
	"stripe.invalid_expiry_year": "The card's expiration year is invalid.",
	"stripe.invalid_cvc": "The card's security code is invalid.",
	"stripe.invalid_swipe_data": "The card's swipe data is invalid.",
	"stripe.incorrect_number": "The card number is incorrect.",
	"stripe.expired_card": "The card has expired.",
	"stripe.incorrect_cvc": "The card's security code is incorrect.",
	"stripe.incorrect_zip": "The card's zip code failed validation.",
	"stripe.card_declined": "The card was declined.",
	"stripe.missing": "There is no card on a customer that is being charged.",
	"stripe.processing_error": "An error occurred while processing your card. Try again in a little bit.",
	"stripe.incomplete_expiry": "Your card's expiration date is incomplete.",
	"stripe.incomplete_number": "Your card number is incomplete.",
	"stripe.invalid_expiry_year_past": "Your card's expiration year is in the past.",
	"stripe.incomplete_cvc": "Your card's security code is incomplete.",
	"stripe.incomplete_zip": "Your postal code is incomplete.",
	"stripe.card_not_supported": "Your card is not supported.",
	"reach_user_limit.title": "Out of Available Team Member Limits",
	"reach_user_limit.helptext": "Your team is out of available member limits to add {addMembersCount, plural, one {member} other {members}} to team. Please click the following link to purchase extra {newUsersCount, plural, one {user} other {users}}.",
	"reach_user_limit.helptext_ask_admin": "Your team is out of available member limits to add {addMembersCount, plural, one {member} other {members}} to team. Please contact your team administrator.",
	"admin.reach_user_limit.link": "Purchase {newUsersCount} {newUsersCount, plural, one {User} other {Users}}",
	"reach_user_limit.error_title": "Cannot Join the Team",
	"reach_user_limit.link_message": "Go to Login",
	"user.settings.general.watermarkPicture": "Watermark Picture",
	"user.settings.general.validWatermark": "Only PNG images may be used for watermark",
	"user.settings.general.watermarkTooLarge": "Unable to upload watermark image. File is too large.",
	"user.settings.general.use_watermark": "Add watermark when upload image:",
	"user.settings.general.use_watermark.yes": "Yes",
	"user.settings.general.use_watermark.no": "No",
	"user.settings.general.use_watermark.ask": "Ask",
	"user.settings.general.watermark.preview": "Watermark Preview",
	"setting_watermark_picture.help": "Upload a watermark image in PNG format, at most 1 MB.",
	"add_watermark.title.confirm": "Adding watermark",
	"FormattedMessage.question": "Do you want to add watermark to the image of this post?",
	"add_watermark.yes": "Yes",
	"add_watermark.no": "No",
	"admin.sidebar.social_networks": "Social Networks",
	"admin.sidebar.social_networks.facebook": "Facebook",
	"admin.social_networks.facebook": "Share to Facebook",
	"admin.social_networks.weibo": "Share to Weibo",
	"admin.social_networks.facebook.enableTitle": "Enable feature to share content to Facebook: ",
	"admin.social_networks.facebook.help_text": "When true, users can share Cordchat message to Facebook.",
	"admin.sidebar.social_networks.weibo": "Weibo",
	"admin.social_networks.weibo.enableTitle": "Enable feature to share content to Weibo: ",
	"admin.social_networks.weibo.help_text": "When true, users can share Cordchat message to Weibo.",
	"admin.weibo.weiboAppKey": "App Key",
	"post_info.share.confirm.button": "Share",
	"post_info.share.title": "Share Message to",
	"post_info.share.message": "Confirm to share to facebook?",
	"post_body.share_location": "{username} shared location of {location}:",
	"post_body.share_contact": "{username} shared contact of {contact}:",
	"admin.sidebar.location": "Location / Map",
	"admin.sidebar.location.google_map": "Google Map",
	"admin.location.google_map": "Google Map",
	"admin.location.google_map.enableTitle": "Enable Google Map",
	"admin.location.google_map.enableDesc": "Enable user to view location via Google Map.",
	"admin.sidebar.location.baidu_map": "Baidu Map",
	"admin.location.baidu_map": "Baidu Map",
	"admin.location.baidu_map.enableTitle": "Enable Baidu Map",
	"admin.location.baidu_map.enableDesc": "Enable user to view location via Baidu Map.",
	"admin.service.baiduTitle": "Baidu App Key",
	"channel_loader.postedLocation": "shared a location",
	"channel_loader.postedNamecard": "shared a contact",
	"help.image_compression.title": "# Photo Compression\n___",
	"help.image_compression.desc": "**Photo Compression** can help to reduce the cost of storage and data transmission. It also speed up the time of sending messages which provide better experience to users.",
	"help.image_compression.support": "**Photo Compression options** will be showed when selecting photo in mobile app. Click \"Compress\" to perform compression before upload. Or click \"Original\" keep original size when upload.",
	"help.image_compression.supported_format": "**Supported formats** includes JPG, JPEG, PNG.",
	"help.image_compression.android_example": "**Example in Android:**",
	"help.image_compression.ios_example": "**Example in iOS:**",
	"create_team.public.header": "Create Public Team",
	"create_team.private.header": "Create Private Team",
	"select_team.button.join_team": "Join Another Team",
	"join_team.header": "Join Another Team",
	"select_team.or": "Or",
	"select_team.public_team.helper": "<span class=\"team-public\">Public team</span> will allow <b>any</b> user to join without invitation.",
	"select_team.private_team.helper": "<span class=\"team-private\">Private team</span> will <b>only</b> allow user to join through invitation.",
	"join_team.sort.option.team_name": "Team Name",
	"join_team.sort.option.last_update": "Last Update",
	"join_team.sort.option.last_create": "Last Create",
	"join_team.sort.search.placeholder": "Search Teams",
	"join_team.join_invite": "Total {count, number} {count, plural, one {team} other {teams}} invite you:",
	"join_team.select.sort_by": "Sort By:",
	"join_team.select.no_result": "No results matched your search",
	"sms_verify.sent": " Verification SMS sent.",
	"sms_verify.failed": " Failed to send verification SMS.",
	"all_verify.notVerifiedBody.or": "Please verify your email address or mobile number. Check your inbox for an email or your SMS app.",
	"mobile_verify.notVerifiedBody": "Please verify your mobile number. Check your SMS app.",
	"mobile_verify.verifyFailed": "Failed to verify your mobile.",
	"login.mobile_verified": "Mobile Verified",
	"password_send_sms.link": "Verification code sent to {mobile} by SMS",
	"password_send.checkSMS": " Please check your SMS app.",
	"webrtc.header_live": "Live streaming",
	"webrtc.liveEnded": "Live streaming ended",
	"webrtc.header_conference": "Group call",
	"webrtc.header_conferenceended": "Group call ended",
	"post_body.webrtc_post": "{username} launched a live stream, click this link to enter the room to watch.",
	"webrtc.header_view": "{username} is streaming",
	"webrtc.status_calling": "Waiting",
	"webrtc.status_decline": "Decline",
	"webrtc.status_hangup": "Hang Up",
	"webrtc.status_reject": "Do not accept",
	"webrtc.status_busy": "Busy",
	"webrtc.status_noanswer": "No Answer",
	"webrtc.status_answer": "Meeting",
	"webrtc.status_nosupport": "Do not Support",
	"signup.mobile": "Mobile and Password",
	"signup_user_completed.header": "Create your {siteName} Account",
	"admin.user.requireVerificationTitle": "Require Email / Mobile Verification: ",
	"signup_user_completed.placeholder.username": "Username",
	"signup_user_completed.placeholder.email": "Email",
	"signup_user_completed.placeholder.phone": "Phone",
	"signup_user_completed.placeholder.password": "Password",
	"login.invalid_mobile": "Invalid mobile number",
	"signup_user_completed.mobileError": "Invalid mobile number",
	"signup_user_completed.emailHelp2": "Enter email or / and mobile number (At least enter one)",
	"receive.verify.link": "Verify by:",
	"receive.reset_password.email": "Email",
	"receive.reset_password.sms": "SMS",
	"signup_user_completed.mobileHelp": "Mobile: {number} can be used to receive SMS for account verification / reset password",
	"email_verify.email_sent": "Verification email sent:",
	"verify_email.link_sent": "If the account exists, a verification email will be sent to: <br/><b>{email}</b><br/><br/>",
	"sms_verify.get_code": "Get your verification code",
	"sms_verify.sent_and_wait": "Get your verification code after {second, number} {second, plural, one {second} other {seconds}}",
	"mobile_verify.mobile_helper": "Verification code sent to {mobile} by SMS",
	"mobile_verify.verify_button.label": "Verify",
	"sms_verify.mobile_header": "Enter a verification code",
	"mobile_verify.code_placeholder": "Verification code",
	"forgot_password.description": "To reset password via:",
	"forgot_password.btn.email": "Email",
	"forgot_password.button_collector": "Or",
	"forgot_password.btn.sms": "SMS",
	"forgot_password.email.desc_label": "Email:",
	"forgot_password.email.desc1": "You should receive a password reset mail via email to the email address associated with your account",
	"forgot_password.email.desc2": "Click \"Reset Password\" at email",
	"forgot_password.sms.desc_label": "SMS:",
	"forgot_password.sms.desc1": "A verification code should be sent to the phone number",
	"forgot_password.sms.desc2": "Enter the verification code and select \"Reset password\"",
	"forgot_password.general.enter_desire_password": "Enter your new desired password",
	"password_send.email_description": "Enter the email address you used to sign up.",
	"password_send.sms_description": "Enter mobile number you used to sign up.",
	"password_send.send_verification_code": "Send Verification Code",
	"mobile_verify.next_button.label": "Reset Password",
	"password_form.enter_new_pwd": "Enter new password",
	"password_form.confirm_pwd_label": "Confirm new password",
	"password_form.new_pwd": "New password",
	"password_form.confirm_pwd": "Confirm password",
	"sms_verify.resend": "Resend SMS",
	"user.settings.general.sms": "Phone Number",
	"user.settings.general.smsHelp1": "This phone number is used for sign-in, and password reset. Phone number requires verification if changed.",
	"user.settings.general.smsHelp2": "This phone number is used for sign-in, and password reset.",
	"user.settings.general.smsHelp3": "A verification token SMS was sent to {phoneNumber}. New phone number will be updated after verified.",
	"user.settings.general.SMSPhone": "Phone Number",
	"user.settings.general.validSMSPhoneNumber": "Please enter a valid phone number.",
	"user.settings.general.checkSMS": "Check your message at {phoneNumber} to verify the phone number.",
	"sms_verify.invalid_token": "Invalid verification code",
	"sms_reset_password.invalid_token": "Invalid verification code",
	"user.settings.notifications.email.not_verified": "Disabled. Email address not yet verified",
	"user.settings.notifications.email.not_verified.disabled_long": "You need to verify you email address before able to receive email notification.",
	"user.settings.notifications.email.send_verify.label": "Send Verification Email",
	"admin.sidebar.mobile": "Mobile",
	"admin.authentication.mobile": "Mobile Authentication",
	"admin.mobile.allowMobileSignInTitle": "Enable sign-in with mobile: ",
	"admin.mobile.allowMobileSignInDescription": "When true, Cordchat allows users to sign in using their mobile and password.",
	"admin.mobile.enableIhuyi": "Enable Ihuyi SMS Service:",
	"admin.mobile.enableIhuyiDescription": "Only available for mobile numbers in China. When more than one SMS services enabled, Ihuyi will be used to delivery SMS to the mobile numbers in China.",
	"admin.mobile.IhuyiAccountTitle": "Ihuyi Account:",
	"admin.mobile.ihuyiPasswordTitle": "Ihuyi Password:",
	"admin.mobile.IhuyiMarketingAccountTitle": "Ihuyi Account(Marketing SMS):",
	"admin.mobile.IhuyiMarketingPasswordTitle": "Ihuyi Password(Marketing SMS):",
	"admin.mobile.enableAccessYou": "Enable Access You SMS Service: ",
	"admin.mobile.enableAccessYouDescription": "When more than one SMS services enabled, Access You will be used to delivery SMS to the mobile numbers in Hong Kong.",
	"admin.mobile.accessYouAccountTitle": "Access You Account:",
	"admin.mobile.accessYouPasswordTitle": "Access You Password:",
	"admin.mobile.enableNexmo": "Enable Nexmo SMS Service:",
	"admin.mobile.nexmoApiKeyTitle": "Nexmo API Key:",
	"admin.mobile.nexmoApiSecretTitle": "Nexmo API Secret:",
	"channel_invite.addNewGuests": "Add New Guest to ",
	"navbar.addGuests": "Add Guests",
	"channel_header.addGuests": "Add Guests",
	"create_team.landing.title": "Invite Friends",
	"create_team.landing.private_invitation": "Send Private Invitation",
	"create_team.landing.get_public_invitation_link": "Get Public Invitation Link",
	"create_team.landing.skip": "Skip",
	"select_theme.theme.title": "Theme Colors",
	"user.settings.notifications.email.no_email": "Disabled. Email address not yet provided",
	"vclog_table.type": "Type",
	"vclog_table.time": "Time",
	"vclog_table.duration": "Duration",
	"vclog_table.members": "Members",
	"user.settings.modal.vclog": "Call History",
	"user.settings.vclog.title": "Call History",
	"user.settings.vclog.video": "Video Call",
	"user.settings.vclog.voice": "Voice Call",
	"user.settings.vclog.durationDesc1": "{hour} hour {min} mins",
	"user.settings.vclog.durationDesc2": "{min} mins",
	"theme_name.Default": "Default",
	"theme_name.Work": "Work",
	"theme_name.Family": "Family",
	"theme_name.Fun": "Fun",
	"select_channel_member.new_convo_note.full": "You’ve reached the maximum number of people for this call. Consider upgrade your price plan.",
	"admin.webrtc.meetingServer.voiceCallTitle": "Max Members Per Each Voice Call:",
	"admin.webrtc.meetingServer.videoCallTitle": "Max Members Per Each Video Call:",
	"admin.webrtc.meetingServer.guestVideoCallTitle": "Max Guests Per Each Video Call:",
	"admin.webrtc.meetingServer.guestVoiceCallTitle": "Max Guests Per Each Voice Call:",
	"signup_user_completed.select_user.header": "You might have an unverified account. Do you want to verify again?",
	"signup_user.last_password_update": "Password created / updated at",
	"signup_user_completed.helper": "Please select your account to verify. After verified, remember to use the password of selected account to login.",
	"signup_user_completed.verify": "Verify",
	"signup_user_completed.clear_possible_list": "Register new account",
	"team_vchour_tab.vcHourDetail4": "Call Statistics data up to: {calcat}",
	"team_vchour_tab.teamVcHour": "Team Call Statistics",
	"team_settings_modal.vcHourTab": "Call Statistics",
	"team_vchour_tab.hour": "Hour",
	"team_vchour_tab.storageDetail1": "Limit",
	"team_vchour_tab.storageDetail2": "Used",
	"team_vchour_tab.storageDetail3": "Available",
	"should_verify.cleanup_time": "If you cannot verify the account on or before {time}, please re-start account creation process again.",
	"user.settings.modal.confirmToSaveTitle": "Confirm Changes?",
	"user.settings.modal.confirmToSaveBtns": "Save",
	"user.settings.modal.confirmToSaveEmailMsg": "Please note that you will have to use the new email address saved to login afterwards. Old email address cannot be used to login anymore. Are you sure to change your email address?",
	"user.settings.modal.confirmToSaveMobileMsg": "Please note that you will have to use the new mobile no. saved to login afterwards. Old mobile no. cannot be used to login anymore. Are you sure to change your mobile no.?",
	"channel_modal.add_member_or_guest": "Default members or guests",
	"channel_modal.options.guests": "Add all team members and guests to channel guests",
	"channel_modal.options.members": "Add all team members and guests to channel members",
	"channel_modal.options.by_team_members_role": "Add all members and guests by default role",
	"channel_modal.options.not_now": "Not now",
	"channel_members_modal.addNewGuests": "Add New Guests",
	"general_tab.label.invite_id": "For Member",
	"general_tab.label.guest_invite_id": "For Guest",
	"team_members_dropdown.guest": "Guest",
	"sidebar_right_menu.addGuestToTeam": "Add Guests to Team",
	"navbar_dropdown.addGuestToTeam": "Add Guests to Team",
	"add_users_to_team._guest_title": "Add New Guests To {teamName} Team",
	"get_team_invite_link_modal.guest_header": "Team Guest Link",
	"get_team_invite_link_modal.member_header": "Team Member Link",
	"user.settings.status.acceptVideoCall": "Accept Video Call:",
	"user.settings.status.acceptVoiceCall": "Accept Voice Call:",
	"admin.general.policy.restrictPublicChannelSelfDestructTitle": "Enable public channel self destruction setting for:",
	"admin.general.policy.restrictPrivateChannelSelfDestructTitle": "Enable private channel self destruction setting for:",
	"admin.general.policy.restrictPublicChannelSelfDestructDescription": "Set policy on who can change the self-destruct timer of public channel.",
	"admin.general.policy.restrictPrivateChannelSelfDestructDescription": "Set policy on who can change the self-destruct timer of private channel.",
	"user.notification.newvc": "You have a new call",
	"shortcuts.info": "Begin a message with / for a list of all the commands at your disposal.",
	"shortcuts.header": "Keyboard Shortcuts",
	"shortcuts.nav.header": "Navigation",
	"shortcuts.nav.prev": "Previous channel:\tAlt|Up",
	"shortcuts.nav.prev.mac": "Previous channel:\t⌥|Up",
	"shortcuts.nav.next": "Next channel:\tAlt|Down",
	"shortcuts.nav.next.mac": "Next channel:\t⌥|Down",
	"shortcuts.nav.unread_prev": "Previous unread channel:\tAlt|Shift|Up",
	"shortcuts.nav.unread_prev.mac": "Previous unread channel:\t⌥|Shift|Up",
	"shortcuts.nav.unread_next": "Next unread channel:\tAlt|Shift|Down",
	"shortcuts.nav.unread_next.mac": "Next unread channel:\t⌥|Shift|Down",
	"shortcuts.nav.switcher": "Quick channel switcher:\tCtrl|K",
	"shortcuts.nav.switcher.mac": "Quick channel switcher:\t⌘|K",
	"shortcuts.nav.team_switcher": "Quick team switcher:\tAlt|K",
	"shortcuts.nav.team_switcher.mac": "Quick team switcher:\t⌥|K",
	"shortcuts.nav.direct_messages_menu": "Direct messages menu:\tCtrl|Shift|K",
	"shortcuts.nav.direct_messages_menu.mac": "Direct messages menu:\t⌘|Shift|K",
	"shortcuts.nav.settings": "Account settings:\tCtrl|Shift|A",
	"shortcuts.nav.settings.mac": "Account settings:\t⌘|Shift|A",
	"shortcuts.nav.recent_mentions": "Recent mentions:\tCtrl|Shift|M",
	"shortcuts.nav.recent_mentions.mac": "Recent mentions:\t⌘|Shift|M",
	"shortcuts.msgs.header": "Messages",
	"shortcuts.msgs.mark_as_read": "Mark current channel as read:\tEsc",
	"shortcuts.msgs.input.header": "Works inside an empty input field",
	"shortcuts.msgs.edit": "Edit last message in channel:\tUp",
	"shortcuts.msgs.reply": "Reply to last message in channel:\tShift|Up",
	"shortcuts.msgs.reprint_prev": "Reprint previous message:\tCtrl|Up",
	"shortcuts.msgs.reprint_prev.mac": "Reprint previous message:\t⌘|Up",
	"shortcuts.msgs.reprint_next": "Reprint next message:\tCtrl|Down",
	"shortcuts.msgs.reprint_next.mac": "Reprint next message:\t⌘|Down",
	"shortcuts.msgs.comp.header": "Autocomplete",
	"shortcuts.msgs.comp.username": "Username:\t@|[a-z]|Tab",
	"shortcuts.msgs.comp.channel": "Channel:\t~|[a-z]|Tab",
	"shortcuts.msgs.comp.emoji": "Emoji:\t:|[a-z]|Tab",
	"shortcuts.files.header": "Files",
	"shortcuts.files.upload": "Upload files:\tCtrl|U",
	"shortcuts.files.upload.mac": "Upload files:\t⌘|U",
	"shortcuts.browser.header": "Built-in Browser Commands",
	"shortcuts.browser.channel_prev": "Back in history:\tAlt|Left",
	"shortcuts.browser.channel_prev.mac": "Back in history:\t⌘|[",
	"shortcuts.browser.channel_next": "Forward in history:\tAlt|Right",
	"shortcuts.browser.channel_next.mac": "Forward in history:\t⌘|]",
	"shortcuts.browser.font_increase": "Zoom in:\tCtrl|+",
	"shortcuts.browser.font_increase.mac": "Zoom in:\t⌘|+",
	"shortcuts.browser.font_decrease": "Zoom out:\tCtrl|-",
	"shortcuts.browser.font_decrease.mac": "Zoom out:\t⌘|-",
	"shortcuts.browser.input.header": "Works inside an input field",
	"shortcuts.browser.highlight_prev": "Highlight text to the previous line:\tShift|Up",
	"shortcuts.browser.highlight_next": "Highlight text to the next line:\tShift|Down",
	"shortcuts.browser.newline": "Create a new line:\tShift|Enter",
	"sidebar_left.header.emptyNickname": "Add a nickname",
	"channel_header.switchTeam": "Switch Team",
	"channel_header.edit_image_background": "Edit Channel Picture",
	"edit_channel_image.title": "Edit Channel Picture",
	"setting_picture.channel.help": "Upload a channel picture in BMP, JPG, JPEG or PNG format, at least {width}px in width and {height}px height.",
	"sidebar_left.header.edit_cover_image": "Edit Cover Image",
	"external.talkto.found": "<span>The target user has been found and a call connection is being established.</span>",
	"invite_meeting.send1": "Send Voice Call",
	"invite_meeting.send2": "Send Video Call",
	"invite_meeting.title": "Send Meeting Invitation",
	"invite_meeting.desc": "Cordchat unable to find the identity of the callee,you can send a meeting link to the callee via email.When the callee click the link (not-yet-expired) in the email, they will go straight to the voice / video call UI.",
	"external.talkto.roomNew": "Meeting room has been created,waiting for the callee to accept the meeting invitation",
	"external.talkto.roomIn": "Enter meeting",
	"join_team.sort.option.members_in_three_day": "Most New Members in 3 Days",
	"join_team.sort.option.posts_in_three_day": "Most Posts in 3 Days",
	"checkout.form.edit_date": "Edit",
	"edit.post": "Post",
	"webrtc.user.offline": "{username} is offline",
	"webrtc.status_offline": "Offline",
	"audit_table.updateConfig": "Updated system configuration",
	"audit_table.updateBackground": "Updated your profile cover picture",
	"audit_table.channelSelfDestructTimer": "Updated the {channelName} channel self-destruct timer",
	"audit_table.channelImageUpdated": "Updated the {channelName} channel image",
	"audit_table.channelBackgroundUpdated": "Updated the {channelName} channel cover image",
	"audit_table.mobile_verified": "Successfully verified your mobile number",
	"channel_header.livestreamPost": "Live Streaming List",
	"search_results.noLiveStreamPost": "You don't have any live streaming to join yet.",
	"search_item.join": "Watch live",
	"api.channel.missing_call": "{callee} has missed calls from {caller}.",
	"webrtc.numOfParticipants": "<p>There are currently <strong>{num} viewers</strong> in total.</p>",
	"webrtc.numOfParticipants2": "<p>There are currently no viewers entering the live room.</p>",
	"api.channel.live_end": "{caller} completed a live broadcast.",
	"webrtc.liveViewEnded": "Has exited from the room",
	"webrtc.notification.returnToLive": "Return to the video screen",
	"web.root.site.name": "Cordchat",
	"tutorial_intro.unlimited_user": "<h1>Cordchat Tips (3):</h1><p>There is no limit on the number of team members. You can name the team and customize notifications. </p>",
	"tutorial_intro.self_destruct": "<h1>Cordchat Tips (4):</h1><p>You can decide when your message posted will be deleted for any purpose of your own.</p>",
	"tutorial_intro.conference": "<h1>Cordchat Tips (5):</h1><p>Functions like voice call, video call, video conferencing, screen sharing and live streaming are ready for you. </p>",
	"tutorial_intro.storage": "<h1>Cordchat Tips (6):</h1><p>You don't need the hassle of email or file sharing apps to transfer all kinds of files.</p><p>You can upload documents up to 50GB for free.</p>",
	"tutorial_intro.cross_platform": "<h1>Cordchat Tips (7):</h1><p>You can seamlessly sync all of your chats on the web and mobile so that you can chat on whatever you want.</p>",
	"team_settings_modal.vcServerTab": "Meeting Server",
	"team_vcs_tab.meetingserver": "Private Meeting Room",
	"team_vcs_tab.meetingserverTip": "Please make sure people joining voice/video call can access this server, especially for users who will visit the Private Meeting Room through their own firewall.  Corresponding network access has to be granted prior to the voice/video call meeting.",
	"team_vcs_tab.meetingserver1": "Server Address",
	"team_vcs_tab.meetingServerDescription": "Team-wide meetings prefer this server",
	"team_vcs_tab.meetingServerUpdated": "Successfully modified. ",
	"team_vcs_tab.meetingServerHeader": "(Server:{servername})",
	"team_vcs_tab.reclive": "Enabled recording for live streaming",
	"team_vcs_tab.recvideo": "Enabled recording for video call",
	"team_vcs_tab.recvoice": "Enabled recording for voice call",
	"analytics.allowPMR": "Allow Private Meeting Room",
	"analytics.denyPMR": "Deny Private Meeting Room",
	"analytics.denyPMRInfo": "The current team has allowed the private meeting room to be activated. If you want to prohibit it, please press",
	"analytics.allowPMRInfo": "The current team is not allowed to enable private meeting rooms. If you want to authorize, please press",
	"team_vcs_tab.pmrdeny": "This team has not purchased Private Meeting Room (PMR). PMR allows enjoy video / voice conference / live streaming recording and autonomy in computing resource allocation for voice/video communication. Feel free to find us if you want to have your own PMR.",
	"team_vcs_tab.contactus": "Contact Us",
	"api.channel.create_channel.created": "{username} created a new channel - {channelDisplayName}.",
	"api.channel.create_channel.join": " Click this link to join.",
	"admin.support.contactDesc": "The URL for the Contact Us link in the Private Meeting Room",
	"admin.support.contactTitle": "Contact link:",
	"create_team.team_url.reset": "Reset",
	"create_team.team_url.save": "Save",
	"create_team.set_image_and_cover": "Add icon and cover picture",
	"post_message.team_setting1": "You have not added any profile picture, icon nor description for your teams:",
	"post_message.team_setting2": "To make your team more appealing, you are strongly recommended to refurnish such information. Click the team name to edit and act now!!!",
	"join_team.load_more": "Load More",
	"admin.service.enableDynamicLinks": "Enable Dynamic Links: ",
	"admin.service.enableDynamicLinksDescription": "Use Dynamic Links when send SMS.",
	"admin.service.dynamicLinksSubdomain": "Dynamic Links Subdomain: ",
	"admin.service.dynamicLinksSubdomainExample": "Ex: \"https://example.page.link\"",
	"admin.service.DynamicLinksAPIKey": "Dynamic Links API Key:",
	"admin.service.enableSinaUrlShorten": "Enable Sina URL Shorten Service: ",
	"admin.service.enableSinaUrlShortenDescription": "Use Shorten URL when send SMS.",
	"admin.service.sinaApiKey": "Sina API Key:",
	"general.current_team": "Current Team:",
	"relative_time.yesterday": "Yesterday",
	"sidebar.recent_channels": "Recent Chats",
	"change_team.button": "Change Team",
	"user.settings.display.layoutDisplay": "Layout Display",
	"user.settings.display.newLayout": "Modern",
	"user.settings.display.classicLayout": "Classic",
	"user.settings.display.preferLayout": "Select how you prefer the layout displayed.",
	"more_channels.go": "Switch",
	"find_channels.title": "Find Channels",
	"more_channels.team": "Team: ",
	"sidebar.top": "Top",
	"navbar_dropdown.find_team": "Find Team",
	"navbar_dropdown.find_channel": "Find Channel",
	"navbar_dropdown.find_people": "Find People",
	"navbar_dropdown.create_join_team": "Create / Join Team",
	"navbar_dropdown.create_channel": "Create Channel",
	"navbar_dropdown.direct_message": "Direct Messages",
	"channel_modal.publicChannel.helper": "<span class=\"channel-public\">Public channel</span> will allow <b>any</b> member to join.",
	"channel_modal.privateGroup.helper": "<span class=\"channel-private\">Private channel</span> is limited with <b>restricted membership</b>.",
	"sidebar_left.header.switch_modern": "Swap to Modern Mode",
	"sidebar_left.header.switch_classic": "Swap to Classic Mode",
	"channel_modal.create_public_channel": "Create Public Channel",
	"channel_modal.create_private_channel": "Create Private Channel"
};

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";var e=[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}];return e});



/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";var e=[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}];return e});



/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/zh-TW.d7bdbf8bb15804fb9550ac6c31e92644.json";

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/zh-CN.3a167cded6e3d6bfd7b72e3bc776cb82.json";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(449);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(220)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./bootstrap-colorpicker.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./bootstrap-colorpicker.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/668d0a0e7a0189f62898bcc57ab8370c.png";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/e75b2a9cae62d4c2951a9fea86e8fac4.png";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/34a3768e23e11bc227fa6dd3091ff26e.png";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1b3c0ada204c72f99386a99545a5ccfc.png";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};



/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1114);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(220)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js??ref--4-2!./styles.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js??ref--4-2!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports
exports.i(__webpack_require__(1115), "");
exports.i(__webpack_require__(1120), "");
exports.i(__webpack_require__(1121), "");
exports.i(__webpack_require__(1122), "");
exports.i(__webpack_require__(449), "");
exports.i(__webpack_require__(1129), "");

// module
exports.push([module.i, ".suggestion-list{-webkit-box-shadow:rgba(0,0,0,.175) 1px -3px 12px;-moz-box-shadow:rgba(0,0,0,.175) 1px -3px 12px;box-shadow:1px -3px 12px rgba(0,0,0,.175)}.signup-team__container .has-error .control-label:before{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0)}@keyframes spin{0%{transform:scale(1) rotate(0deg)}to{transform:scale(1) rotate(1turn)}}@keyframes highlight{0%{background:rgba(255,255,0,.5)}to{background:none}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes blinker{0%{opacity:1}to{opacity:.1}}.padding-top{padding-top:7px}.padding-top.x2{padding-top:14px}.padding-top.x3{padding-top:21px}.padding-bottom{padding-bottom:7px}.padding-bottom.x2{padding-bottom:14px}.padding-bottom.x3{padding-bottom:21px}.padding-bottom .control-label{font-weight:600}.padding-bottom .control-label.text-left{text-align:left}.padding-left{padding-left:7px}.padding-left.x2{padding-left:14px}.padding-left.x3{padding-left:21px}.padding-right{padding-right:7px}.padding-right.x2{padding-right:14px}.padding-right.x3{padding-right:21px}.margin-right{margin-right:7px}.margin-right.x2{margin-right:14px}.margin-right.x3{margin-right:21px}.margin-left{margin-left:7px}.margin-left.x2{margin-left:14px}.margin-left.x3{margin-left:21px}.margin-top{margin-top:7px}.margin-top.half{margin-top:4px}.margin-top.x2{margin-top:14px}.margin-top.x3{margin-top:21px}.margin-bottom{margin-bottom:7px}.margin-bottom.x2{margin-bottom:14px}.margin-bottom.x3{margin-bottom:21px}b,strong{font-weight:600}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Open Sans,sans-serif}.light{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.word-break--all{word-break:break-all}.whitespace--nowrap{white-space:nowrap}.overflow--ellipsis{overflow:hidden;text-overflow:ellipsis}.fa.fa-margin--left{margin-left:3px}.fa.fa-margin--right{margin-right:3px}.font-weight--normal{font-weight:400}@font-face{font-family:Open Sans;font-style:normal;font-weight:300;src:url(" + __webpack_require__(452) + ");src:local(\"Open Sans Light\"),local(\"OpenSans-Light\"),url(" + __webpack_require__(452) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1130) + ") format(\"woff2\"),url(" + __webpack_require__(1131) + ") format(\"woff\"),url(" + __webpack_require__(1132) + ") format(\"truetype\"),url(" + __webpack_require__(1133) + "#OpenSans) format(\"svg\")}@font-face{font-family:Open Sans;font-style:italic;font-weight:300;src:url(" + __webpack_require__(453) + ");src:local(\"Open Sans Light Italic\"),local(\"OpenSansLight-Italic\"),url(" + __webpack_require__(453) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1134) + ") format(\"woff2\"),url(" + __webpack_require__(1135) + ") format(\"woff\"),url(" + __webpack_require__(1136) + ") format(\"truetype\"),url(" + __webpack_require__(1137) + "#OpenSans) format(\"svg\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:400;src:url(" + __webpack_require__(454) + ");src:local(\"Open Sans\"),local(\"OpenSans\"),url(" + __webpack_require__(454) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1138) + ") format(\"woff2\"),url(" + __webpack_require__(1139) + ") format(\"woff\"),url(" + __webpack_require__(1140) + ") format(\"truetype\"),url(" + __webpack_require__(1141) + "#OpenSans) format(\"svg\")}@font-face{font-family:Open Sans;font-style:italic;font-weight:400;src:url(" + __webpack_require__(455) + ");src:local(\"Open Sans Italic\"),local(\"OpenSans-Italic\"),url(" + __webpack_require__(455) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1142) + ") format(\"woff2\"),url(" + __webpack_require__(1143) + ") format(\"woff\"),url(" + __webpack_require__(1144) + ") format(\"truetype\"),url(" + __webpack_require__(1145) + "#OpenSans) format(\"svg\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:600;src:url(" + __webpack_require__(456) + ");src:local(\"Open Sans Semibold\"),local(\"OpenSans-Semibold\"),url(" + __webpack_require__(456) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1146) + ") format(\"woff2\"),url(" + __webpack_require__(1147) + ") format(\"woff\"),url(" + __webpack_require__(1148) + ") format(\"truetype\"),url(" + __webpack_require__(1149) + "#OpenSans) format(\"svg\")}@font-face{font-family:Open Sans;font-style:italic;font-weight:600;src:url(" + __webpack_require__(457) + ");src:local(\"Open Sans Semibold Italic\"),local(\"OpenSans-SemiboldItalic\"),url(" + __webpack_require__(457) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1150) + ") format(\"woff2\"),url(" + __webpack_require__(1151) + ") format(\"woff\"),url(" + __webpack_require__(1152) + ") format(\"truetype\"),url(" + __webpack_require__(1153) + "#OpenSans) format(\"svg\")}.app__body.font--open_sans{font-family:Open Sans,\"sans-serif\"}body,html{height:100%}body{background:#f5f5f5;position:relative;width:100%}body.error-bar--fixed{padding-top:22px}.sticky{background:#fff}.sticky>.container-fluid{overflow:auto}.sticky .inner-wrap>.row.content{margin-bottom:-89px;min-height:100%}.inner-wrap{height:100%}.inner-wrap.sticky{overflow:auto}.container-fluid,.inner-wrap>.row.main{height:100%;position:relative}.container-fluid{*zoom:1;-webkit-overflow-scrolling:touch}.container-fluid:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.channel-view{overflow:hidden;*zoom:1;height:100%;position:relative}img{max-width:100%}img.rounded{-webkit-border-radius:100%;-moz-border-radius:100%;-ms-border-radius:100%;-o-border-radius:100%;border-radius:100%}img.round-corners{-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.modal .modal-content{-webkit-box-shadow:0 0 10px rgba(0,0,0,.5);-moz-box-shadow:0 0 10px rgba(0,0,0,.5);box-shadow:0 0 10px rgba(0,0,0,.5);border-radius:1px}.modal .about-modal .modal-content .modal-header{background:transparent;border:none;color:inherit;padding:20px 25px 0}.modal .about-modal .modal-content .modal-header .close{color:inherit;font-weight:400;right:15px}.modal .about-modal .modal-content .modal-header .modal-title{color:inherit;font-size:16px}.modal .about-modal .modal-content .modal-header .icon{margin:0 5px 0 8px;position:relative;top:1px}.modal .about-modal .modal-content .modal-header .icon svg{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;height:14px;width:14px}.modal .about-modal .modal-body{padding:20px 25px 10px}.modal .about-modal.large .modal-body{padding-bottom:20px}.modal .about-modal .about-modal__content{overflow:hidden;*zoom:1;display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;padding:1em 0 3em}.modal .about-modal .about-modal__copyright{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;margin-top:.5em}.modal .about-modal .about-modal__footer{font-size:13.5px}.modal .about-modal .about-modal__title{line-height:1.5;margin:0 0 10px}.modal .about-modal .about-modal__subtitle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.modal .about-modal .about-modal__hash{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4;font-size:.75em;text-align:right}.modal .about-modal .about-modal__hash p:first-child{float:left;text-align:left}.modal .about-modal .about-modal__logo{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;padding:0 40px 0 20px}.modal .about-modal .about-modal__logo svg{height:125px;width:125px}.modal .about-modal .about-modal__logo path{fill:inherit}.access-history__table{display:table;line-height:1.6;padding-top:15px;width:100%}.access-history__table:first-child{padding:0}.access-history__table>div{display:table-cell;vertical-align:top}.access-history__table .access__date{font-size:15px;font-weight:600;width:190px}.access-history__table .access__report{border-bottom:1px solid #ddd;padding-bottom:15px}.access-history__table .report__info{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.animation--highlight:before{animation:highlight 1.5s ease;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%;display:inline-block}.activity-log__table{border-top:1px solid rgba(0,0,0,.15);display:table;line-height:1.8;padding:15px 0;width:100%}.activity-log__table:first-child{border:none;padding-top:0}.activity-log__table>div{display:table-cell;vertical-align:top}.activity-log__table .activity-log__report{width:80%}.activity-log__table .activity-log__action{text-align:right}.activity-log__table .report__platform{font-size:15px;font-weight:600}.activity-log__table .report__platform .fa{margin-right:6px}.activity-log__table .report__info{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.session-help-text{padding:0 0 20px}.admin-console,.admin-console__wrapper{height:100%;overflow:auto}.admin-console{color:#333;margin-left:220px;padding:0 20px}.admin-console .color-picker__popover{position:absolute;right:0;top:40px;z-index:5}.admin-console .dropdown-menu .divider{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.admin-console .filtered-user-list{height:calc(100vh - 120px)}.admin-console .Select-value-label{white-space:nowrap}.admin-console .inner-wrap{position:absolute;width:100%}.admin-console h3{font-weight:600;margin:1em 0;padding-bottom:.5em}.admin-console h4{font-weight:600;margin-bottom:2em}.admin-console .form-control{background-color:#fff;border:1px solid rgba(0,0,0,.15)}.admin-console .form-control:focus{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);border-color:#66afe9;outline:0}.admin-console .table.table-margin--none{margin-bottom:0}.admin-console .btn.btn-spacing--right{margin-right:10px}.admin-console .btn .fa{margin-right:5px}.admin-console .log__panel{background-color:#fff;border:1px solid #ddd;height:calc(100vh - 200px);margin-top:10px;overflow:scroll;padding:5px;width:100%}.admin-console.admin{background-color:#f1f1f1;min-height:600px;overflow:auto;padding:0 40px 20px}.admin-console .wrapper--fixed{max-width:800px}.admin-console .form-horizontal{margin-top:40px}.admin-console .form-horizontal .control-label{font-weight:600;padding-right:0;text-align:left}.admin-console .form-horizontal .has-error .control-label{font-weight:400}.admin-console .form-horizontal .form-group{margin-bottom:25px}.admin-console .form-horizontal .file__upload{display:inline-block;margin:0 10px 10px 0;position:relative}.admin-console .form-horizontal .file__upload input{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;height:100%;left:0;position:absolute;top:0;width:100%;z-index:5}.admin-console .form-horizontal .help-text{color:rgba(0,0,0,.5);display:block;margin:10px 0 0}.admin-console .form-horizontal .help-text.no-margin{margin:0}.admin-console .form-horizontal .help-text.no-margin--top{margin-top:0}.admin-console .form-horizontal .help-text ol,.admin-console .form-horizontal .help-text ul{padding-left:23px}.admin-console .form-horizontal .help-text .help-link{margin-right:5px}.admin-console .form-horizontal .help-text .btn{font-size:13px}.admin-console .form-horizontal .help-text.remove-filename{margin-bottom:5px;top:-2px;position:relative}.admin-console .form-horizontal .alert{display:inline-block;margin:1em 0 0;padding:5px 7px;position:relative;top:1px}.admin-console .form-horizontal .alert .fa{margin-right:5px}.admin-console .banner{background:#fff;border:1px solid #ddd;font-size:.95em;margin:2em 0;padding:.8em 1.5rem}.admin-console .banner.banner--url{padding:1.2em}.admin-console .banner .banner__url{background:rgba(0,0,0,.07);border-radius:2px;padding:.7em 1em;word-break:break-all}.admin-console .banner .banner__heading{font-size:1.5em;margin-bottom:.5em}.admin-console .banner.warning{background:#e60000}.admin-console .popover{border-radius:3px;font-size:.95em;width:100%}.admin-console .panel{background-color:transparent;border:none}.admin-console .panel-default>.panel-heading{background-color:transparent;padding:10px 0}.admin-console .panel-default .panel-body{padding:30px 0 10px}.admin-console .panel-group{margin-bottom:50px}.admin-console .panel-title{font-size:24px;line-height:1.5}.admin-console .panel-title a{overflow:hidden;*zoom:1;display:block;text-decoration:none}.admin-console .panel-title a.collapsed .fa-minus{display:none}.admin-console .panel-title a.collapsed .fa-plus{display:inline-block}.admin-console .panel-title a .fa{color:#aaa;float:right;font-size:18px;margin-top:8px}.admin-console .panel-title a .fa-plus{display:none}.admin-console .more-modal__list .filtered-user-list .filter-controls{padding-bottom:1em}.admin-console .more-modal__list .filter-row{margin:10px 0}.admin-console .member-list-holder{background:#fff;overflow:visible;padding:5px 0}.admin-console .member-list-holder .more-modal__list{overflow:visible}.admin-console .member-list-holder .more-modal__row:last-child{border:none}.admin-console .member-count{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;margin-top:8px}.admin-console .admin-console-header{border-bottom:1px solid rgba(0,0,0,.1)}.admin-console .status-icon-unknown{color:gray}.admin-console .status-icon-success{color:#69c169}.admin-console .status-icon-warning{color:#eac262}.admin-console .status-icon-error{color:#ea6262}.admin-console .suggestion--selected{background-color:#e2e2e2}.brand-img{margin-bottom:1.5em;max-width:150px}.admin-console__disabled-text{color:#777;margin:10px 0 0 15px}.admin-sidebar{background:#333;height:100%;left:0;position:absolute;top:0;width:220px;z-index:5}.admin-sidebar .dropdown-menu{max-height:80vh;max-width:200px;min-width:200px;overflow:auto}.admin-sidebar .team__header{background:transparent}.admin-sidebar .nav-pills__container{-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:auto;background:#111;height:calc(100% - 50px);margin-top:1px;padding-bottom:20px;position:relative}.admin-sidebar .sidebar-category .category-title{background:hsla(0,0%,100%,.15);color:#fff;line-height:15.4px;padding:10px}.admin-sidebar .sidebar-category .category-title .category-icon{font-size:15px;margin-right:7px;overflow:hidden;right:12px;text-align:center;top:6px;vertical-align:bottom;width:16px}.admin-sidebar .sidebar-category .category-title .category-icon.fa-user{font-size:14px}.admin-sidebar .sidebar-category .category-title .category-icon.fa-bar-chart{font-size:16px}.admin-sidebar .sidebar-category .sections{padding:5px 0}.admin-sidebar .sidebar-section>.sidebar-section-title{position:relative}.admin-sidebar .sidebar-section .nav__sub-menu{margin-bottom:7px}.admin-sidebar .sidebar-section .nav__sub-menu:empty{display:none}.admin-sidebar .sections.sections--settings .sidebar-section-title{text-transform:uppercase}.admin-sidebar .sections.sections--settings .sidebar-section-title:focus,.admin-sidebar .sections.sections--settings .sidebar-section-title:hover{color:hsla(0,0%,100%,.5)}.admin-sidebar .sidebar-section-title{padding:7px 35px 7px 15px}.admin-sidebar .sidebar-subsection-title{padding:7px 35px 7px 30px}.admin-sidebar .sidebar-section-title,.admin-sidebar .sidebar-subsection-title{color:hsla(0,0%,100%,.5);display:block;font-size:13px;position:relative}.admin-sidebar .sidebar-section-title:focus,.admin-sidebar .sidebar-subsection-title:focus{text-decoration:none}.admin-sidebar .sidebar-section-title:hover,.admin-sidebar .sidebar-subsection-title:hover{color:#4ba1e2;text-decoration:none}.admin-sidebar .sidebar-section-title--active,.admin-sidebar .sidebar-section-title--active:focus,.admin-sidebar .sidebar-section-title--active:hover,.admin-sidebar .sidebar-subsection-title--active,.admin-sidebar .sidebar-subsection-title--active:focus,.admin-sidebar .sidebar-subsection-title--active:hover{background:hsla(0,0%,100%,.1);color:#fff}.admin-sidebar .sidebar-section-title--active:after,.admin-sidebar .sidebar-subsection-title--active:after{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:#f5f5f5;content:\"\\F0D9\";display:inline-block;font:normal normal normal 26px/1 FontAwesome;position:absolute;right:-1px;text-rendering:auto;top:3px}.admin-sidebar .sidebar-subsection-title--active:after{top:4px}.admin-sidebar .menu-icon--right{font-size:18px;font-weight:600;height:20px;line-height:20px;position:absolute;right:12px;text-align:center;top:8px;width:20px}.admin-sidebar .menu-icon--right .fa{color:#fff;font-size:13px;position:relative;right:-2px}.admin-sidebar .menu-icon--right.menu__close{cursor:pointer;right:10px;top:3px}.email-connection-test{margin-top:-15px}.recycle-db{margin-top:50px!important}.cluster-status{height:24px;width:24px}.config-hash{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.system-users__filter-row{display:flex;margin-left:15px;margin-right:15px}.system-users__filter-row .system-users__filter{flex:1;margin-right:15px}.system-users__filter-row .system-users__team-filter-label{margin-right:15px}.system-users__filter-row .system-users__team-filter{display:inline-block;width:200px}.system-users__filter-row label{font-weight:400}.manage-teams .manage-teams__user{align-items:center;display:flex}.manage-teams .manage-teams__teams{border-top:1px solid #ddd;margin:1em 0 .3em}.manage-teams .manage-teams__teams .btn-link.danger{color:#c55151}.manage-teams .member-row--padded{padding-left:20px}.manage-teams .member-row--padded strong{margin-right:10px}.manage-teams .manage-row--inner{padding:15px 0 4px}.manage-teams .manage-row--inner+div{border-top:1px solid #ddd}.manage-teams .manage-teams__profile-picture{border-radius:20px;height:40px;width:40px}.manage-teams .manage-teams__info{flex:1;margin-left:10px;overflow:hidden;white-space:nowrap}.manage-teams .manage-teams__info .manage-teams__name{font-weight:700;overflow:hidden;text-overflow:ellipsis}.manage-teams .manage-teams__info .manage-teams__email{opacity:.5;overflow:hidden;text-overflow:ellipsis}.manage-teams .manage-teams__system-admin{margin-left:10px;opacity:.5;padding-right:10px}.manage-teams .manage-teams__teams{margin-top:1em}.manage-teams .manage-teams__teams .manage-row__empty{padding:9px 0}.manage-teams .manage-teams__team{align-items:center;border-bottom:1px solid #ddd;display:flex;padding:7px 10px}.manage-teams .manage-teams__team .btn{font-size:.9em}.manage-teams .manage-teams__team .dropdown{padding:6px 0}.manage-teams .manage-teams__team-name{flex:1;overflow:hidden;text-overflow:ellipsis}.manage-teams .manage-teams__team-actions{margin-left:10px}.manage-teams .manage-teams__team-actions .dropdown-toggle{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.backstage{height:100vh;width:100vw}.backstage-navbar{background:#fff;height:41px;border-bottom:1px solid rgba(0,0,0,.15);padding:10px 20px;z-index:10}.backstage-navbar__back{color:inherit;text-decoration:none}.backstage-navbar__back .fa{font-size:1.1em;font-weight:700;margin-right:7px}.backstage-navbar__back:active,.backstage-navbar__back:hover{color:inherit}.backstage-body{background-color:#f5f5f5;bottom:0;display:inline-block;height:calc(100vh - 41px);overflow:auto;top:0;width:100%}.backstage-content{background-color:#f5f5f5;margin:46px auto;max-width:1200px;padding-left:135px;vertical-align:top}.backstage-sidebar{padding:46px 20px;position:absolute;vertical-align:top;width:260px}.backstage-sidebar ul{list-style:none;padding:0}.backstage-sidebar>ul{overflow:hidden;*zoom:1;-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;border-left:1px solid rgba(0,0,0,.15);border-right:1px solid rgba(0,0,0,.15)}.backstage-sidebar__category+.backstage-sidebar__category .category-title{border-top:none}.backstage-sidebar__category .category-title{border-bottom:1px solid rgba(0,0,0,.15);border-top:1px solid rgba(0,0,0,.15);color:#000;display:block;line-height:35px;padding:0 10px;position:relative}.backstage-sidebar__category .category-title .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;position:relative;text-align:center;top:1px;width:20px}.backstage-sidebar__category .category-title .fa-smile-o{font-size:17px}.backstage-sidebar__category .category-title--active{background-color:#2389d7;color:#fff}.backstage-sidebar__category .category-title--active .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.backstage-sidebar__category .category-title__text{left:2.5em;position:absolute}.backstage-sidebar__category .sections{background:#fff;border-bottom:1px solid rgba(0,0,0,.15)}.backstage-sidebar__category .section-title,.backstage-sidebar__category .subsection-title{display:block;font-size:.95em;line-height:29px;padding-left:2em;text-decoration:none}.backstage-sidebar__category .subsection-title{padding-left:3em}.backstage-sidebar__category .section-title--active,.backstage-sidebar__category .subsection-title--active{background-color:#2389d7;color:#fff;font-weight:600}.backstage-header__divider{color:rgba(0,0,0,.3);margin:0 10px}.backstage-header{overflow:hidden;*zoom:1;margin-bottom:20px;width:100%}.backstage-header h1{float:left;font-size:20px;margin:5px 0}.backstage-header .add-link{float:right}.backstage-filters{display:flex;flex-direction:row;width:100%}.backstage-filters__sort{flex-grow:1;flex-shrink:0;line-height:30px}.backstage-filters__sort .filter-sort{text-decoration:none}.backstage-filters__sort .filter-sort.filter-sort--active{color:inherit;cursor:default}.backstage-filters__sort .divider{margin-left:8px;margin-right:8px}.backstage-filter__search{flex-grow:0;flex-shrink:0;position:relative;width:270px}.backstage-filter__search .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4;left:11px;position:absolute;top:11px}.backstage-filter__search input{background:#fff;padding-left:30px}.backstage-list{background-color:#fff;border:1px solid rgba(0,0,0,.15);padding:5px 15px;min-height:50px}.backstage-list__help{display:block;margin:1em 0}.backstage-list__item{border-bottom:1px solid rgba(0,0,0,.15);display:flex;padding:20px 15px;position:relative}.backstage-list__item:last-child{border:none}.backstage-list__item .item-details{color:rgba(0,0,0,.5);flex-grow:1;flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.backstage-list__item .item-details__row+.item-details__row{overflow:hidden;*zoom:1;text-overflow:ellipsis}.backstage-list__item .item-details__name{color:#000;font-weight:600}.backstage-list__item .item-details__trigger{margin-left:6px}.backstage-list__item .item-details__content_type,.backstage-list__item .item-details__creation,.backstage-list__item .item-details__description,.backstage-list__item .item-details__token,.backstage-list__item .item-details__trigger-when,.backstage-list__item .item-details__trigger-words,.backstage-list__item .item-details__url{display:inline-block;margin-top:10px;vertical-align:top}.backstage-list__item .item-details__content_type:empty,.backstage-list__item .item-details__creation:empty,.backstage-list__item .item-details__description:empty,.backstage-list__item .item-details__token:empty,.backstage-list__item .item-details__trigger-when:empty,.backstage-list__item .item-details__trigger-words:empty,.backstage-list__item .item-details__url:empty{display:none}.backstage-list__item .item-details__trigger-words{white-space:nowrap}.backstage-list__item .item-actions{flex-grow:0;flex-shrink:0;padding-left:20px}.backstage-form{background-color:#fff;border:1px solid rgba(0,0,0,.15);padding:40px 30px 30px;position:relative}.backstage-form.backstage-form__confirmation{padding:30px 30px 20px}.backstage-form label{font-weight:400}.backstage-form .backstage-form__title{margin:5px 0 1.5em}.backstage-form .checkbox input,.backstage-form .radio input{height:16px;margin:0 5px 0 0;position:relative;top:2px;width:16px}.backstage-form .form-control{background:#fff}.backstage-form .form-control:focus{border-color:#2389d7}.backstage-form .form__help{color:rgba(0,0,0,.5);font-size:.95em;margin-top:1em}.backstage-form .form__help+.form__help{margin-top:.4em}.backstage-form__footer{border-top:1px solid rgba(0,0,0,.15);margin-top:2.5em;padding-top:1.8em;text-align:right}.backstage-form__footer .has-error{float:left;margin:0}.integration__icon{position:absolute;height:100px;width:100px;right:20px}.integration__icon.integration-list__icon{top:50px}.integration-option{background-color:#fff;border:1px solid rgba(0,0,0,.15);display:inline-block;margin:0 30px 30px 0;min-height:230px;padding:20px;text-align:center;vertical-align:top;width:290px}.integration-option:last-child{margin-right:0}.integration-option:hover{color:default;text-decoration:none}.integration-option__image{height:80px;margin:.5em 0 .7em}.integration-option__title{color:#000;margin-bottom:10px}.integration-option__description{color:rgba(0,0,0,.5)}.emoji-list__table{width:100%}.emoji-list__table .backstage-list__item{display:table-row}.emoji-list__table .backstage-list__empty td{padding:15px 20px}.emoji-list__table-header{font-weight:700}.emoji-list__name{padding:20px 0 20px 15px;width:30%}.emoji-list__image{padding:15px 0;width:15%}.emoji-list__creator{padding:15px 0;width:40%}.emoji-list__actions{padding:20px 15px 20px 0;width:15%}.add-emoji__upload{display:inline-block;margin:0 10px 10px 0;position:relative}.add-emoji__upload input{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;height:100%;left:0;position:absolute;top:0;width:100%;z-index:5}.add-emoji__filename,.add-emoji__preview{padding-top:7px}.backstage.checkout .invoice-content{padding-left:0}.checkout__container{background:#fff;padding:20px 30px}.contract-detail{padding:0 20px 20px;margin:20px 0;border:1px solid #eee;border-left-width:5px;border-radius:3px}.contract-detail.current{border-left-color:#2389d7}.checkout-form .team-icon{margin-right:5px}.checkout-form .checkout-form-value{padding-top:7px}.popover.amount-detail-popover,.popover.users-detail-popover{max-width:500px}.popover.users-detail-popover th{min-width:50px}.popover.users-detail-popover .current-period td{background:#f0f8ff}.audit-panel__table,.cluster-panel__table,.compliance-panel__table{background-color:#fff;border:1px solid #ddd;margin-top:10px;max-height:70vh;min-height:100px;overflow:auto;padding:5px;width:100%}.audit-panel .row>.form-group,.compliance-panel .row>.form-group{padding-left:0}.audit-panel .row>.form-group:first-child,.compliance-panel .row>.form-group:first-child{padding-left:15px}.audit-panel .row label,.compliance-panel .row label{font-weight:600}.audit-panel .fa-refresh,.compliance-panel .fa-refresh{margin-right:5px}.compliance-panel{margin-bottom:3em}.docs__page{line-height:1.7;padding-bottom:20px}.docs__page>div{margin:0 auto;max-width:100%;padding:0 15px;width:1170px}.docs__page h1.markdown__heading{border-bottom:1px solid #ddd;margin:1em 0;padding-bottom:1rem}body.error .container-fluid{display:table;height:90%}body.error .error__container{color:#555;display:table-cell;margin:0 auto;max-width:800px;padding:5em 0;text-align:left;vertical-align:top}body.error .error__icon{color:#ccc;font-size:4em}body.error h2{font-size:1.5em;font-weight:600;margin:.8em 0 .5em}body.error p{font-size:1.2em}.get-app hr{border-top:1px solid #ddd}.get-app .get-app__header{color:#666;font-size:20px;font-weight:700;text-align:center}.get-app .get-app__screenshot{border-bottom:1px solid #ddd;display:block;margin:auto}.get-app .get-app__continue-with-browser{display:block;margin-top:40px;padding-bottom:30px;text-align:center}.get-android-app{margin:20px}.get-android-app .get-app__header{text-align:left}.get-android-app .get-android-app__icon{width:60px}.get-android-app .get-android-app__app-info{display:inline-block;margin-left:8px;vertical-align:middle}.get-android-app .get-android-app__app-info .get-android-app__app-name{color:#666;display:block;font-size:13px;font-weight:700}.get-android-app .get-android-app__app-info .get-android-app__app-creator{color:#aaa;display:block;font-size:10px}.get-android-app .get-app__screenshot{width:240px}.get-android-app .get-android-app__continue{display:block;font-size:16px;margin-bottom:40px;margin-top:15px;padding:12px}.get-ios-app{margin:30px}.get-ios-app .get-app__screenshot{width:180px}.get-ios-app .get-ios-app__app-store-link{display:block;margin:auto;margin-bottom:30px;width:180px}.get-ios-app .get-ios-app__already-have-it{font-size:18px;margin-bottom:20px;text-align:center}.get-ios-app .get-ios-app__open-mattermost{display:block;font-size:20px;margin:auto;padding:12px;width:220px}.loading-screen{display:table;height:100%;padding:60px;text-align:center;width:100%}.loading-screen .loading__content{display:table-cell;font-size:0;vertical-align:middle}.loading-screen .loading__content h3{display:inline-block;font-size:16px;font-weight:400;margin:0 .2em}.loading-screen .loading__content .round{-webkit-animation:move .75s infinite linear;-moz-animation:move .75s infinite linear;-ms-animation:move .75s infinite linear;-o-animation:move .75s infinite linear;animation:move .75s infinite linear;-webkit-border-radius:10px;-moz-border-radius:10px;-ms-border-radius:10px;-o-border-radius:10px;border-radius:10px;background-color:#444;display:inline-block;height:4px;margin:0 2px;opacity:.1;width:4px}.loading-screen .loading__content .round-1{-webkit-animation-delay:.2s;-moz-animation-delay:.2s;-ms-animation-delay:.2s;-o-animation-delay:.2s;animation-delay:.2s}.loading-screen .loading__content .round-2{-webkit-animation-delay:.4s;-moz-animation-delay:.4s;-ms-animation-delay:.4s;-o-animation-delay:.4s;animation-delay:.4s}.loading-screen .loading__content .round-3{-webkit-animation-delay:.6s;-moz-animation-delay:.6s;-ms-animation-delay:.6s;-o-animation-delay:.6s;animation-delay:.6s}@-moz-keyframes move{0%{opacity:1}to{opacity:.1}}@-webkit-keyframes move{0%{opacity:1}to{opacity:.1}}@-o-keyframes move{0%{opacity:1}to{opacity:.1}}@-ms-keyframes move{.loading-screen .loading__content 0%{opacity:1}.loading-screen .loading__content to{opacity:.1}}@keyframes move{0%{opacity:1}to{opacity:.1}}@media print{*{background:transparent!important;color:#000!important;text-shadow:none!important}.app__content,.post-list__content,.post-list__table{display:block}a:not(.mention-link),a:not(.mention-link):visited{text-decoration:underline}a[href^=http]:after{content:\" <\" attr(href) \"> \"}.date-separator,.post,blockquote,code,img,pre,tr{page-break-inside:avoid}.post__header{page-break-after:avoid}thead{display:table-header-group}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}#archive-link-home,#channel-header,#post-create,#post-list .more-messages-text,#sidebar-left,#sidebar-right,.attachment__content,.channel-intro,.post-image__thumbnail,.post.post--system,.post .post__content>div.post__img,.post .post__header .col__reply,.post__body .img-div{display:none}#channel_view,#post-list,#post-list .post-list-holder-by-time{overflow:visible;overflow-y:visible}#app-content{margin-left:0}#channel_view .inner-wrap.move--left,#channel_view .inner-wrap.webrtc--show{margin-right:0}.post-image__columns>div:first-child:before{content:\"Attachments:\";display:block;font-weight:700}.post-image__column{width:inherit;display:inline;height:inherit;background:transparent;border-color:transparent;border:0 none}.post-image__details{width:100%;border:0 none}.post-image__details .post-image__name:before{content:\"[\"}.post-image__details .post-image__name:after{content:\": \" attr(href) \"]\"}.post-image__details .post-image__name+div{display:none}.date-separator .separator__hr,.new-separator .separator__hr{top:1.7em}.error-bar{display:none}.backstage.checkout{display:inherit}.backstage.checkout .backstage-content{padding:0}.backstage.checkout .backstage-navbar,.backstage.checkout .no-print{display:none}.backstage.checkout .col-sm-6{width:50%;display:inline-block;vertical-align:top}}.user-settings{min-height:300px}.user-settings .vclog-participants{text-align:left;max-width:300px;overflow:auto}.user-settings .vclog-participants .item{margin-left:.3em;display:inline-block}.user-settings .vclog-participants p{font-size:.8em}.user-settings .table-responsive{max-height:300px;max-width:560px}.user-settings .authorized-apps__help{font-size:13px;font-weight:400;margin-top:7px}.user-settings .authorized-apps__wrapper{padding:10px 0}.user-settings .authorized-app{display:inline-block;width:100%}.user-settings .authorized-app:not(:last-child){border-bottom:1px solid #ccc;margin-bottom:10px}.user-settings .authorized-app .authorized-app__name{font-weight:600}.user-settings .authorized-app .authorized-app__url{font-size:13px;font-weight:400}.user-settings .authorized-app .authorized-app__deauthorize,.user-settings .authorized-app .authorized-app__description{font-size:13px;margin:5px 0}.modal .settings-modal:not(.channel-image-modal){width:800px}.modal .settings-modal .modal-back{font-size:27px;font-weight:400;height:40px;left:0;line-height:32px;position:absolute;text-align:center;top:12px;width:50px}.modal .settings-modal .modal-back .fa{height:100%;left:0;line-height:inherit;position:absolute;width:100%}.modal .settings-modal .modal-body{margin:0 auto;min-height:calc(100% - 62px);padding:0}.modal .settings-modal li{list-style:none}.modal .settings-modal label{font-weight:600}.modal .settings-modal label.has-error{font-weight:400}.modal .settings-modal .no-padding--left{padding-left:0}.modal .settings-modal .settings-table{display:table;margin:0 auto;max-width:1000px;table-layout:fixed;width:100%}.modal .settings-modal .settings-table>div{display:table-cell;vertical-align:top}.modal .settings-modal .settings-table .nav{position:fixed;width:179px}.modal .settings-modal .settings-table .nav.position--top{top:57px}.modal .settings-modal .settings-table .security-links{margin-right:20px}.modal .settings-modal .settings-table .security-links .fa{margin-right:6px}.modal .settings-modal .settings-table .settings-links{width:180px}.modal .settings-modal .settings-table .settings-content{padding:0 20px 30px}.modal .settings-modal .settings-table .settings-content .modal-header{display:none}.modal .settings-modal .settings-table .settings-content .section-min{padding:1em 0;margin-bottom:0;cursor:pointer;position:relative;overflow:hidden;*zoom:1}.modal .settings-modal .settings-table .settings-content .section-min:hover{background:#f9f9f9}.modal .settings-modal .settings-table .settings-content .section-min:hover .fa{display:inline-block}.modal .settings-modal .settings-table .settings-content .section-min:hover .section-edit{text-decoration:underline}.modal .settings-modal .settings-table .settings-content .section-max{overflow:hidden;*zoom:1;background:rgba(0,0,0,.05);margin-bottom:0;padding:1em 0 1.3em}.modal .settings-modal .settings-table .settings-content .section-max .section-title{margin-bottom:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-group .input-group-addon{padding:4px 5px;width:40px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-group img{border:1px solid rgba(0,0,0,.15);width:29px}.modal .settings-modal .settings-table .settings-content .appearance-section .group--code select{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding-right:25px}.modal .settings-modal .settings-table .settings-content .appearance-section .group--code:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\F0D7\";display:inline-block;font:normal normal normal 14px/1 FontAwesome;pointer-events:none;position:absolute;right:50px;text-rendering:auto;top:11px;z-index:5}.browser--ie .modal .settings-modal .settings-table .settings-content .appearance-section .group--code:before{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes{margin-bottom:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes .theme-label{font-weight:400;margin-top:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes img{border:3px solid transparent}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes .active img{border-color:#2389d7}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements{padding-left:15px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements .element{margin-right:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements .element:nth-child(2n){margin-right:0}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header{border-bottom:1px solid;cursor:pointer;font-size:.96429em;font-weight:600;margin:10px 20px 0 0;padding:1px 0 10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header .fa-minus{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header.open .fa-minus{display:inline-block}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header.open .fa-plus{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header .header__icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;float:right}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body{-webkit-border-radius:0 0 3px 3px;-moz-border-radius:0 0 3px 3px;-ms-border-radius:0 0 3px 3px;-o-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;*zoom:1;background-color:hsla(0,0%,100%,.05);display:none;margin:0 20px 0 0;padding:20px 0 0 20px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body.open{display:block}.modal .settings-modal .settings-table .settings-content .appearance-section .custom-label{font-size:12px;font-weight:400;margin-bottom:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.modal .settings-modal .settings-table .settings-content .appearance-section .input-group-addon{background:transparent}.modal .settings-modal .settings-table .settings-content .appearance-section .radio label{font-weight:600}.modal .settings-modal .settings-table .settings-content .section-title{font-weight:600;margin-bottom:5px;padding-right:50px}.modal .settings-modal .settings-table .settings-content .section-edit{margin-bottom:5px;text-align:right}.modal .settings-modal .settings-table .settings-content .section-edit .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:none;font-size:12px;margin-right:5px}.modal .settings-modal .settings-table .settings-content .section-edit .fa.fa-chevron-down{margin-right:0;position:relative;top:-1px}.modal .settings-modal .settings-table .settings-content .section-describe{overflow:hidden;*zoom:1;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;text-overflow:ellipsis;white-space:pre}.modal .settings-modal .settings-table .settings-content .divider-dark{border-bottom:1px solid #aaa}.modal .settings-modal .settings-table .settings-content .divider-light{border-bottom:1px solid #d3d3d3}.modal .settings-modal .settings-table .settings-content .divider-light+.divider-dark,.modal .settings-modal .settings-table .settings-content .divider-light+.divider-light{display:none}.modal .settings-modal .settings-table .settings-content .setting-list{list-style-type:none;padding:0}.modal .settings-modal .settings-table .settings-content .setting-box__item:first-child{padding-top:3px}.modal .settings-modal .settings-table .settings-content .setting-box__item:last-child hr{display:none}.modal .settings-modal .settings-table .settings-content .setting-box__token-id{margin:4px 0}.modal .settings-modal .settings-table .settings-content .setting-list__hint{margin-top:20px}.modal .settings-modal .settings-table .settings-content .mentions-input{margin-top:10px}.modal .settings-modal .settings-table .settings-content .setting-list-item{margin-top:7px}.modal .settings-modal .settings-table .settings-content .setting-list-item .image-setting-item{max-height:200px}.modal .settings-modal .settings-table .settings-content .has-error{color:#a94442}.modal .settings-modal .settings-table .settings-content .file-status{color:#555;font-size:13px;margin-top:8px}.modal .settings-modal .settings-table .settings-content .confirm-import{margin:10px 0;padding:4px 10px}.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group{margin-bottom:5px}.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group .team-icon{-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px;margin-right:10px}.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group .checkbox-inline input[type=checkbox],.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group .checkbox input[type=checkbox],.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group .radio-inline input[type=radio],.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group .radio input[type=radio]{margin-top:8px}.modal .settings-modal .settings-table .settings-content .disclose-teams-groups .disclose-teams-group label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.modal .settings-modal .country-list{max-height:150px;width:100%}.modal .settings-modal .country-list .ps__scrollbar-y-rail{display:none}.modal .settings-modal.channel-image-modal .setting-list{padding-left:0}.modal .settings-modal.channel-image-modal .setting-list .setting-list-item:last-child{display:none}.modal .nav-pills>li{margin:0}.modal .nav-pills>li a{border-radius:0;color:rgba(0,0,0,.3);overflow:hidden;padding:8px 15px;text-overflow:ellipsis;white-space:nowrap}.modal .nav-pills>li .icon{font-size:15px;margin-right:10px;text-align:center;top:2px;width:14px}.modal .nav-pills>li:hover a{background-color:rgba(0,0,0,.1)}.modal .nav-pills>li.active a{background-color:#e1e1e1;color:#111}.modal .nav-pills>li.active a:before{background:#000;content:\"\";height:100%;left:0;position:absolute;top:0;width:5px}.modal .nav-pills>li.active a,.modal .nav-pills>li.active a:focus,.modal .nav-pills>li.active a:hover{background-color:rgba(0,0,0,.1);border-radius:0;font-weight:400;position:relative}.modal h3{font-size:1.42857em}.modal .verification-modal .has-error{color:#a94442}.modal .new-channel__modal .setting-list{padding-left:0}.modal .new-channel__modal .setting-list .setting-list-item:last-child{display:none}.modal .new-channel__modal ul.setting-picture{padding-left:0;display:inline-block;list-style-type:none}.modal .new-channel__modal ul.setting-picture ul{list-style-type:none}.modal .new-channel__modal ul.setting-picture .col-xs-12{padding-left:0}.channel-settings{padding:0 10px}.tab-header{margin-bottom:1em}.setting-name{color:grey;font-weight:500}.sel-btn{margin-right:5px}.member-div{border-bottom:1px solid #d3d3d3;margin:0;padding:2px;position:relative;width:100%}.member-div:first-child{border-top:1px solid #d3d3d3}.member-div .post-profile-img{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;margin-right:8px}.member-drop .fa,.member-role .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;font-size:12px;margin-right:5px}.member-drop .member-menu,.member-role .member-menu{right:110%;top:-50%}.member-invite{position:absolute;right:10px;top:7px}.member-menu{left:auto;right:0}.member-list{overflow-x:visible;width:100%}.member-page{padding-top:50px}.active-border{border:1px solid red}.color-btn{margin:4px}.no-resize{resize:none}.user-settings__submit-checkbox{padding-top:0;padding-bottom:20px}.setting-picture .profile-img{height:128px;width:128px}.setting-picture .profile-img.profile-setting-img{height:64px;width:64px}.setting-picture .profile-img-preview{background-position:50% 50%;background-size:cover;border-radius:100%;height:128px;width:128px}.setting-picture .profile-img-preview.profile-setting-img-preview{overflow:hidden;height:68px;width:68px;vertical-align:middle;display:inline-block;border:2px solid #fff}.setting-picture .profile-img-preview.round-corners{-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.setting-picture .profile-setting-bg-img-preview{background-position:50% 50%;background-size:cover;width:328.5px;height:150px}.setting-picture .image-picker-overlay input{opacity:0;border-radius:100%;width:64px;height:64px;cursor:pointer;position:relative;top:-96px;left:27px}.setting-picture .image-picker-overlay .fa-stack{position:relative;color:rgba(60,60,60,.5);left:-5px;top:-15px}.setting-picture .image-picker-overlay .fa-stack .fa.fa-pencil{color:#fff}.setting-picture .background-picker-overlay input{opacity:0;width:328.5px;height:150px;cursor:pointer;position:relative;top:-187px}.setting-picture .background-picker-overlay .fa-stack{position:relative;color:rgba(60,60,60,.5);left:290px;top:-39px}.setting-picture .background-picker-overlay .fa-stack .fa.fa-pencil{color:#fff}.setting-picture .profile-background-wrapper,.setting-picture .profile-bg-img{width:328.5px;height:150px}.setting-picture .profile-background-wrapper .preview-wrapper,.setting-picture .profile-bg-img .preview-wrapper{width:inherit;height:inherit;overflow:hidden}.setting-picture .profile-background-wrapper .background,.setting-picture .profile-bg-img .background{text-align:center;width:100%;height:100%;border:1px solid #aaa}.setting-picture .profile-background-wrapper .background svg,.setting-picture .profile-bg-img .background svg{margin-top:27px}.setting-picture .profile-wrapper{height:64px}.setting-picture .profile-wrapper .image-wrapper{position:relative;top:-30px;left:25px;display:inline-block;background:transparent}.setting-picture .profile-wrapper .image-wrapper img{width:68px;height:68px;border:2px solid #fff;-webkit-border-radius:100%;-moz-border-radius:100%;-ms-border-radius:100%;-o-border-radius:100%;border-radius:100%}.setting-picture .profile-wrapper .image-wrapper.round-corners img{-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.setting-picture .profile-wrapper .image-wrapper .profile-placeholder{text-align:center}.setting-picture .profile-wrapper .image-wrapper .profile-placeholder svg{margin-top:14px;width:36px;height:36px}.app__body .modal .shortcuts-modal{margin-top:50px;width:1100px}.app__body .modal .shortcuts-modal .shortcuts-content .modal-header{background:transparent;border:none;color:inherit;padding:40px 40px 20px}.app__body .modal .shortcuts-modal .shortcuts-content .modal-header .close{color:inherit;font-size:28px;font-weight:400;right:35px}.app__body .modal .shortcuts-modal .shortcuts-content .modal-header .modal-title{color:inherit;font-size:20px}.app__body .modal .shortcuts-modal .modal-body{max-height:calc(100vh - 67px);padding:0 40px 20px}.app__body .modal .shortcuts-modal .section>div:first-child{margin-bottom:2.5em}.app__body .modal .shortcuts-modal .section .shortcut-line{margin:17px 0}.app__body .modal .shortcuts-modal .section .shortcut-line span:first-child{margin-right:5px}.app__body .modal .shortcuts-modal .section .shortcut-line .shortcut-key{border-radius:3px;font-size:12px;font-weight:500;margin:5px 0 5px 5px;padding:1px 5px}.app__body .modal .shortcuts-modal .section-title{font-size:18px;margin:1.5em 0}.app__body .modal .shortcuts-modal .subsection{border-left:2px solid;padding-left:15px}.app__body .modal .shortcuts-modal .info__label{margin:35px 0 10px;text-align:center}.signup-header{background:#efeff4;line-height:33px;padding:0 1em .2em;width:100%}.signup-header .fa{margin-right:5px}.signup-header a{color:#007aff}.signup-header.public-team{background:#2ab27b}.signup-header.public-team a{color:#fff}.signup-header.private-team{background:#5856d6}.signup-header.private-team a{color:#fff}.signup-header.reset-via-sms,.signup-header.signup{background:#007aff}.signup-header.reset-via-sms a,.signup-header.signup a{color:#fff}.signup-header.reset-via-email{background:#2ab27b}.signup-header.reset-via-email a{color:#fff}.signup-header div.empty-height{min-height:33px}.signup-team__container{margin:0 auto;max-width:400px;padding:100px 0 50px;position:relative}.signup-team__container.branded{display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;max-width:900px}.signup-team__container.branded .signup__markdown{-webkit-flex:1.3 0 0;flex:1.3 0 0;padding-right:80px}.signup-team__container.branded .signup__markdown img{max-width:450px}.signup-team__container.branded .signup__markdown p{color:gray}.signup-team__container.branded .signup__content{-webkit-flex:1 0 0;flex:1 0 0}.signup-team__container.padding--less{padding-top:50px}.signup-team__container .form-control:focus{-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.signup-team__container h1,.signup-team__container h2,.signup-team__container h3,.signup-team__container h4,.signup-team__container h5,.signup-team__container h6,.signup-team__container p{line-height:1.3}.signup-team__container h1{font-weight:600}.signup-team__container h2{font-size:2.14286em;font-weight:600;letter-spacing:-.5px;margin-bottom:.8em}.signup-team__container h3{font-size:1.5em;font-weight:600;margin:0 0 1.3em}.signup-team__container h4{font-size:1.42857em;font-weight:600;margin-bottom:1em}.signup-team__container h5{font-size:1.14286em}.signup-team__container hr{margin:2em 0}.signup-team__container p{color:#555;line-height:1.5;margin-bottom:1em}.signup-team__container .text-custom-dark{color:#8e8e93}.signup-team__container .text-custom-white{color:#fff}.signup-team__container .text-custom-blue,.signup-team__container .text-custom-blue-to-bold b,.signup-team__container .text-custom-blue-to-bold b h1,.signup-team__container .text-custom-blue-to-bold b h2,.signup-team__container .text-custom-blue-to-bold b h3,.signup-team__container .text-custom-blue-to-bold b h4,.signup-team__container .text-custom-blue-to-bold b h5,.signup-team__container .text-custom-blue-to-bold b h6,.signup-team__container .text-custom-blue-to-bold b p,.signup-team__container .text-custom-blue h1,.signup-team__container .text-custom-blue h2,.signup-team__container .text-custom-blue h3,.signup-team__container .text-custom-blue h4,.signup-team__container .text-custom-blue h5,.signup-team__container .text-custom-blue h6,.signup-team__container .text-custom-blue p,.signup-team__container .text-reset-password-sms{color:#007aff}.signup-team__container .text-reset-password-email{color:#2ab27b}.signup-team__container .input-group.input-group--limit{table-layout:fixed;width:100%}.signup-team__container .input-group.input-group--limit .tooltip-inner{word-wrap:break-word}.signup-team__container .input-group.input-group--limit .form-control{display:table-cell;text-align:left;width:100%}.signup-team__container .input-group.input-group--limit .input-group-addon{display:table-cell;overflow:hidden;text-align:left;text-overflow:ellipsis;width:50%}.signup-team__container .inner__content{margin:30px 0 20px}.signup-team__container .block--gray{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#f2f2f2;display:inline-block;font-weight:600;padding:.85em 1.2em}.signup-team__container form{margin-bottom:.8em}.signup-team__container .signup-team-confirm__container{padding:100px 0}.signup-team__container .signup-team-logo{display:none;margin:0 0 2em;width:210px}.signup-team__container .talkto-team-logo{margin:0 0 2em;width:300px}.signup-team__container .signup-team-login{font-weight:600;padding-bottom:10px}.signup-team__container .signup-team-login.create-team{font-weight:400;font-size:18px;text-align:center;width:130px;height:130px;padding:0 10px;color:#fff;display:table;text-decoration:none;margin-bottom:10px}.signup-team__container .signup-team-login.create-team.team-public{background:#2ab27b;float:left}.signup-team__container .signup-team-login.create-team.team-private{background:#5856d6;float:right}.signup-team__container .signup-team-login.create-team .link-text{vertical-align:middle;display:table-cell}.signup-team__container .create-team-helper{clear:both}.signup-team__container .create-team-helper .team-public{color:#2ab27b;font-weight:600}.signup-team__container .create-team-helper .team-private{color:#5856d6;font-weight:600}.signup-team__container .margin-separator{margin:15px 0;font-size:25px;color:#8e8e93}.signup-team__container a.join-team{display:block;height:3.5em;line-height:3.6em;padding:0 15px;background:#5ac8fa;color:#fff;font-size:18px;text-align:center;text-decoration:none}.signup-team__container .button-collector{padding:20px;font-size:16px}.signup-team__container .signup-team__name{font-size:2.2em;font-weight:600;margin:.5em 0 0}.signup-team__container .signup-team__subdomain{font-size:1.5em;font-weight:300;margin:.2em 0 1.2em;text-transform:uppercase}.signup-team__container .form-control{height:2.71429em}.signup-team__container .or__container{background:#ddd;height:1px;margin:2em 0;margin:2.5em 0 2.5em -1rem;text-align:left}.signup-team__container .or__container span{background:#fff;display:inline-block;font-size:1.14286em;font-weight:600;line-height:20px;position:relative;text-align:center;top:-10px;width:40px}.signup-team__container ul{margin-bottom:0;padding-left:18px}.signup-team__container ul.forgot-password-lists li{color:#8e8e93}.signup-team__container .btn{font-size:1em;font-weight:600;margin-right:5px;padding:.5em 1.07143em}.signup-team__container .btn.btn--large{padding:1.5em 1.07143em}.signup-team__container .btn.btn--full_width{width:100%}.signup-team__container .btn .fa{font-size:17px;margin-right:8px}.signup-team__container .btn .fa.fa--margin-top{position:relative;top:2px}.signup-team__container .btn .fa.fa-2x{font-size:2em}.signup-team__container .btn .fa.fa-2x.fa-user{top:-5px;margin-right:26px}.signup-team__container .btn .icon{-webkit-background-size:100% 100%;-moz-background-size:100% 100%;-o-background-size:100% 100%;background-size:100% 100%;display:inline-block;height:18px;margin-right:8px;position:relative;text-align:center;top:-1px;width:18px}.signup-team__container .btn.btn-create-team{width:100%;padding:15px 10px}.signup-team__container .btn.btn-create-team.public-team{background:#2ab27b;color:#fff}.signup-team__container .btn.btn-create-team.private-team{background:#5856d6;color:#fff}.signup-team__container .btn.public-invitation{color:#fff;background:#2ab27b}.signup-team__container .btn.private-invitation{color:#fff;background:#5856d6}.signup-team__container .btn.btn-custom-login{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;color:#fff;display:block;height:40px;line-height:36px;margin:1em 0;min-width:200px;padding:0 1em 0 2em;text-align:left;width:200px}.signup-team__container .btn.btn-custom-login>span{position:relative;top:11px;vertical-align:top}.signup-team__container .btn.btn-custom-login>span>span{display:inline-block;line-height:normal;vertical-align:top}.signup-team__container .btn.btn-custom-login.gitlab{background:#548}.signup-team__container .btn.btn-custom-login.gitlab:hover{background:#403366}.signup-team__container .btn.btn-custom-login.gitlab .icon{background-image:url(" + __webpack_require__(1154) + ")}.signup-team__container .btn.btn-custom-login.google{background:#dd4b39;padding:0 1em 0 0}.signup-team__container .btn.btn-custom-login.google:hover{background:#c23321}.signup-team__container .btn.btn-custom-login.google .icon{margin-right:16px;top:-11px;background-size:20px 20px;background-color:#fff;background-position:50%;background-repeat:no-repeat;height:38px;width:38px;background-image:url(" + __webpack_require__(1155) + ")}.signup-team__container .btn.btn-custom-login.google.btn--full{padding-left:0}.signup-team__container .btn.btn-custom-login.facebook{background:#4267b2}.signup-team__container .btn.btn-custom-login.facebook:hover{background:#34518d}.signup-team__container .btn.btn-custom-login.facebook>span{position:unset}.signup-team__container .btn.btn-custom-login.office365{background:#0079d6}.signup-team__container .btn.btn-custom-login.office365:hover{background:#005ca3}.signup-team__container .btn.btn-custom-login.office365 .icon{background-image:url(" + __webpack_require__(1156) + ")}.signup-team__container .btn.btn-custom-login.ldap{background:#3aa1cf}.signup-team__container .btn.btn-custom-login.ldap:hover{background:#2a84ac}.signup-team__container .btn.btn-custom-login.email{background:#2389d7}.signup-team__container .btn.btn-custom-login.email:hover{background:#1c6dab}.signup-team__container .btn.btn-custom-login.email .btn>.fa.fa-2x{top:-5px;margin-right:26px}.signup-team__container .btn.btn-custom-login.email.btn--full{padding-left:10px}.signup-team__container .btn.btn-custom-login.saml{background:#34a28b}.signup-team__container .btn.btn-custom-login.saml:hover{background:#287b6a}.signup-team__container .btn.btn-custom-login.btn--full{max-width:350px;padding-left:35px;text-align:left;width:100%}.signup-team__container .btn.btn-custom-login.btn--large{width:300px}.signup-team__container .btn.btn-default{color:#444}.signup-team__container .btn.btn-create-account,.signup-team__container .btn.btn-verify{background:#007aff;color:#fff}.signup-team__container .btn.resend-sms-link{padding-left:0}.signup-team__container .btn.resend-sms-link:disabled{color:#777}.signup-team__container .btn.btn-square{width:8em;height:8em}.signup-team__container .btn.reset-via-sms{background:#007aff;color:#fff}.signup-team__container .btn.reset-via-email{background:#2ab27b;color:#fff}.signup-team__container .btn .fa{position:relative}.signup-team__container .btn .fa.fa-check,.signup-team__container .btn .fa.fa-refresh{font-size:.9em;left:-2px;margin-right:.5em}.signup-team__container .btn .fa.fa-chevron-right{font-size:.8em;right:-5px;top:0}.signup-team__container .btn .fa.fa-chevron-left{font-size:.8em;left:-2px;top:0}.signup-team__container .btn-apple{padding:0;max-width:350px;height:40px;outline:none;margin-bottom:1em}.signup-team__container .btn-apple.hidden{display:none}.signup-team__container .btn-apple div{outline:none}.signup-team__container .has-error .control-label{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#f2f2f2;color:#999;font-size:14px;font-weight:400;margin:1em 0 0;padding:.7em 1em;width:100%}.signup-team__container .has-error .control-label:before{color:#aaa;content:\"\\F071\";margin-right:4px}.signup-team__container .reset-form{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;font-size:.95em;position:relative}.signup-team__container .reset-form p{color:inherit}.signup-team__container h1.margin--top-none,.signup-team__container h2.margin--top-none,.signup-team__container h3.margin--top-none,.signup-team__container h4.margin--top-none,.signup-team__container h5.margin--top-none,.signup-team__container h6.margin--top-none{margin-top:0}.signup-team__container h1.margin--bottom-none,.signup-team__container h2.margin--bottom-none,.signup-team__container h3.margin--bottom-none,.signup-team__container h4.margin--bottom-none,.signup-team__container h5.margin--bottom-none,.signup-team__container h6.margin--bottom-none{margin-bottom:0}.signup-team__container h1.margin--less,.signup-team__container h2.margin--less,.signup-team__container h3.margin--less,.signup-team__container h4.margin--less,.signup-team__container h5.margin--less,.signup-team__container h6.margin--less{margin-bottom:.3em}.signup-team__container h1.sub-heading,.signup-team__container h2.sub-heading,.signup-team__container h3.sub-heading,.signup-team__container h4.sub-heading,.signup-team__container h5.sub-heading,.signup-team__container h6.sub-heading{font-weight:400;margin-bottom:0}.signup-team__container h1.color--light,.signup-team__container h2.color--light,.signup-team__container h3.color--light,.signup-team__container h4.color--light,.signup-team__container h5.color--light,.signup-team__container h6.color--light{font-weight:300}.signup-team__container p.margin--extra{margin-bottom:1.5em}.signup-team__container p.margin--less{margin-bottom:.3em}.signup-team__container p.black,.signup-team__container p .black{color:#000}.signup-team__container .color--light{color:#777}.signup-team__container .margin-bottom--less{margin-bottom:.7em}.signup-team__container .margin--extra{margin-top:2.5em}.signup-team__container .margin--extra-2x{margin-top:5em}.signup-team-all{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;border:1px solid #ddd;margin:0 0 20px}.signup-team-all .signup-team-dir{position:relative;background:#fafafa;border-top:1px solid #d5d5d5;overflow:hidden}.signup-team-all .signup-team-dir.image-cell{display:inline-block;width:96px;height:96px;background-size:cover;margin-bottom:8px;border-radius:5px;border:none;box-shadow:2px 2px 3px rgba(0,0,0,.33)}.signup-team-all .signup-team-dir.image-cell .signup-team-dir__name{padding:5px;line-height:1.3;background:#efeff4;width:100%;font-size:12px;color:#333}.signup-team-all .signup-team-dir.image-cell .signup-team-dir__name .icon{margin:0 3px}.signup-team-all .signup-team-dir.image-cell .signup-team-dir__name .icon svg{width:12px;height:12px}.signup-team-all .signup-team-dir:first-child{border:none}.signup-team-all .signup-team-dir .icon{cursor:pointer;float:left;margin:16px 7px 0 15px;opacity:.45}.signup-team-all .signup-team-dir .icon svg{height:20px;width:20px}.signup-team-all .signup-team-dir a{color:inherit;display:block;font-size:1.1em;height:3.5em;line-height:3.6em;padding:0 15px}.signup-team-all .signup-team-dir-err{background:#fafafa;border-top:1px solid #d5d5d5;color:inherit;padding:5px 15px}.signup-team-all .signup-team-dir-err:first-child{border:none}.signup-team-all .signup-team-dir__name{float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:calc(100% - 50px)}.signup-team-all .signup-team__icon{color:rgba(0,0,0,.5);float:right;font-size:1.5em;line-height:25px;position:relative;top:.66em}.signup-team-all .signup-team__icon.fa-spin{font-size:.9em;right:-2px;top:16px}.signup-team-all .signup-team__icon.fa-spin.in-item{position:static;line-height:12px}.signup-team-all .signup-team__icon.fa-info-circle{float:left;line-height:1.5em;margin-right:.3em;padding-left:.5em;font-size:1.5em;top:11px}.authorize-box{border:1px solid #000;height:280px;margin:100px auto;width:500px}.authorize-inner{padding:20px}.authorize-btn{margin-right:6px}.verify_panel{margin:60px auto auto;max-width:380px}.join-team-container .filter-box{display:flex;margin:15px 0 30px;justify-content:space-around}@media (max-width:768px){.join-team-container .filter-box{display:block}.join-team-container .filter-box .join-team-header{text-align:center;line-height:36px}}.join-team-container .filter-box .input-filter,.join-team-container .filter-box .join-team-header,.join-team-container .filter-box .select-filter{flex:1;margin:0 15px;align-self:flex-end}.join-team-container .filter-box .join-team-header{line-height:38px;font-size:18px;font-weight:600}.join-team-container .filter-box .input-filter .search__icon{position:relative;top:34px}.join-team-container .filter-box .select-filter select{border-radius:5px;border:1px solid rgba(0,0,0,.15);background:transparent}.join-team-container .filter-box .select-filter label{position:relative;top:34px}.join-team-container .form-control{height:2.71429em}.join-team-container #joinTeamSortBy{padding-left:70px}@media (min-width:768px){.join-team-container .input-filter{padding-left:0}.join-team-container .select-filter{padding:0}}@media (max-width:768px){.join-team-container .input-filter,.join-team-container .select-filter{padding:0;margin-bottom:5px}}.join-team-container .input-filter .search__icon{left:10px;top:11px}.join-team-container .input-filter .search__icon svg{stroke:rgba(0,0,0,.15)}.join-team-container .input-filter .search-bar{border-radius:5px;border:1px solid rgba(0,0,0,.15);background:transparent;box-shadow:none;font-size:14px;height:38px;outline:none;padding:0 30px 0 40px;width:100%}.join-team-container .select-filter label{color:#8e8e93;position:absolute;left:10px;top:10px}.image-cell-link{position:relative;display:inline-flex;margin:16px 8px 0}.image-cell-link,.image-cell-link:hover{text-decoration:none;color:#333}.image-cell-link.disabled{cursor:not-allowed;pointer-events:none}.team-card-box-container{display:block;margin-left:auto;margin-right:auto}@media (max-width:768px){.team-card-box-container{width:256px}}@media (min-width:768px){.team-card-box-container{width:512px}}@media (min-width:992px){.team-card-box-container{width:768px}}@media (min-width:1200px){.team-card-box-container{width:1024px}}.team-card-box-container .team-card-box{margin-bottom:50px;display:flex;flex-flow:wrap}.team-card-box-container .team-card-box .joining-block{position:absolute;text-align:center;height:60px;top:98px;padding:20px;background:#fff;z-index:1;width:100%;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.team-card-box-container .team-card-box .joining-block i{margin-right:5px}.team-card-box-container .team-card-box .team-card{-webkit-animation:fade-in .6s ease-in;-moz-animation:fade-in .6s ease-in;-ms-animation:fade-in .6s ease-in;-o-animation:fade-in .6s ease-in;animation:fade-in .6s ease-in;width:240px;height:240px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);border-radius:5px;background:#fff}.team-card-box-container .team-card-box .team-card.disabled{opacity:.5}.team-card-box-container .team-card-box .team-card .cover-image{border-bottom:1px solid #eee;background-position:50%;background-size:cover;width:100%;height:160px;border-top-left-radius:inherit;border-top-right-radius:inherit}.team-card-box-container .team-card-box .team-card .cover-image.cover-placeholder{background:#9da9b6}.team-card-box-container .team-card-box .team-card .team-icon{width:68px;height:68px;padding:2px;background:#fff;position:relative;top:126px;left:24px;display:inline-block;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.team-card-box-container .team-card-box .team-card .team-icon.rounded,.team-card-box-container .team-card-box .team-card .team-icon img{-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%;border-radius:50%}.team-card-box-container .team-card-box .team-card .team-icon img{width:64px;height:64px}.team-card-box-container .team-card-box .team-card .team__display_name{margin-top:24px}.team-card-box-container .team-card-box .team-card .team__display_name .display_name{margin-left:24px;font-size:16px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bg-black{background:#000}.bg-white{background:#fff}.inner-wrap .row.content.bg-black{background:#000}.inner-wrap .row.content.bg-black .text-reverse{color:#fff}.team_statistics .total-count{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#fff;border:1px solid rgba(0,0,0,.15);margin:1em 0;text-align:center;width:100%}.team_statistics .total-count .title{border-bottom:1px solid rgba(0,0,0,.15);font-size:13px;font-weight:400;padding:7px 10px;text-align:left}.team_statistics .total-count .title span{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:calc(100% - 20px)}.team_statistics .total-count .title .fa{color:#555;float:right;font-size:16px;margin:0}.team_statistics .total-count .content{color:#555;font-size:30px;font-weight:600;overflow:auto;padding:.3em 0 .35em}.team_statistics .total-count--day{background:#fff;border:1px solid rgba(0,0,0,.15);clear:both;height:275px;margin:10px;padding:5px 10px 10px;width:760px}.team_statistics .total-count--day>div{font-size:18px;font-weight:300}.team_statistics .recent-active-users table{table-layout:fixed;width:100%}.team_statistics .recent-active-users .content{max-height:400px;overflow:auto;padding:0}.team_statistics .recent-active-users tr:first-child td{border-top:none}.team_statistics .recent-active-users tr td{overflow:hidden;*zoom:1;border-left:1px solid rgba(0,0,0,.15);border-top:1px solid rgba(0,0,0,.15);font-size:13px;font-weight:400;padding:5px 5px 6px;text-overflow:ellipsis;white-space:nowrap}.team_statistics .recent-active-users tr td:first-child{border-left:none}.team_statistics .team-statistics__header-row{display:flex;margin-bottom:1.5em;margin-top:1.5em}.team_statistics .team-statistics__header{display:inline-block;flex:1;margin-right:15px;overflow:hidden;padding-bottom:.5em}.team_statistics .team-statistics__header>h3{margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.team_statistics .team-statistics__team-filter{display:inline-block;width:200px}.team-picture ul{list-style-type:none;padding-left:0}.team-picture .btn.btn-create-team{width:45%;margin-left:5px;margin-right:5px}.team-picture .btn.btn-create-team.btn-reset{background:#888}.team-picture .setting-picture .background{background:#333}.team-picture .setting-picture .background svg{fill:#fff}.alert{-webkit-border-radius:1px;-moz-border-radius:1px;-ms-border-radius:1px;-o-border-radius:1px;border-radius:1px;padding:8px 12px}.alert--confirm{display:inline-block;float:left;margin:1px 0 0 10px;padding:4px 10px}.attachment-picker{position:absolute;flex-direction:column;display:flex;min-width:250px}.attachment-picker li{min-width:250px}.attachment-picker .no-padding{padding:0}.attachment-picker .icon--attachment{padding:3px 20px;width:100%;display:inline-block;position:relative;vertical-align:top}.attachment-picker .icon--attachment input{cursor:pointer;direction:ltr;filter:alpha(opacity=0);height:100%;margin:0;opacity:0;position:absolute;right:0;top:0;width:100%}.icon.attachment_icon{opacity:.5}.icon.attachment_icon:hover{opacity:.9}img.picker-icons{width:20px;margin-right:5px}.dropdown-menu .fa.local-drive,.fa.local-drive{color:#1b3db6;opacity:.9}.btn{-webkit-transition:all .15s ease-in;-webkit-transition-delay:0s;-moz-transition:all .15s ease-in;-o-transition:all .15s ease-in;transition:all false .15s ease-in;-webkit-border-radius:1px;-moz-border-radius:1px;-ms-border-radius:1px;-o-border-radius:1px;border-radius:1px}.btn.btn-primary{background:#2389d7;border-color:transparent}.btn.btn-primary:active,.btn.btn-primary:focus,.btn.btn-primary:hover{background:#1c6dab}.btn.btn-default{background:rgba(0,0,0,.7);color:#fff}.btn.btn-default:active,.btn.btn-default:focus,.btn.btn-default:hover{background:rgba(0,0,0,.8);color:#fff}.app__body .btn.btn-danger,.app__body .btn.btn-danger:active,.app__body .btn.btn-danger:focus,.app__body .btn.btn-danger:hover,.btn.btn-danger,.btn.btn-danger:active,.btn.btn-danger:focus,.btn.btn-danger:hover{color:#fff}.btn.btn-inactive{background:rgba(0,0,0,.15);border-color:transparent;color:#fff}.StripeElement{background-color:#fff;height:40px;padding:10px 12px;border-radius:4px;border:1px solid #b2b7be;box-shadow:0 1px 3px 0 #b2b7be;-webkit-transition:box-shadow .15s ease;transition:box-shadow .15s ease;width:100%}.StripeElement--focus{box-shadow:0 1px 3px 0 #cfd7df}.StripeElement--invalid{border-color:#fa755a;box-shadow:0 1px 3px 0 #9e2146}.StripeElement--webkit-autofill{background-color:#fefde5!important}.Checkout label{width:100%}.dropdown-menu{border-radius:1px}.dropdown-menu.colorpicker{min-width:125px;z-index:2500}.dropdown-menu .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;margin-right:5px}.dropdown-menu .divider{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=15);opacity:.15}.dropdown-menu .divider+.divider,.dropdown-menu .divider:last-child{display:none}.dropdown-menu div>a,.dropdown-menu li>a{color:inherit;text-decoration:none}.dropdown-menu div>a:focus,.dropdown-menu div>a:hover,.dropdown-menu li>a:focus,.dropdown-menu li>a:hover{color:inherit}.open>.dropdown-menu__content,.open>.dropdown-menu__content>.dropdown-menu{display:block}.dropdown-menu__content{display:none}.reacticon{fill:inherit;opacity:.7;position:relative;top:2px;visibility:hidden}.emoticon,.reacticon{display:inline-block;vertical-align:middle}.emoticon{background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:21px;min-height:1em;min-width:1em;width:21px}.emoticon-suggestion{overflow:hidden;*zoom:1;cursor:pointer;font-size:13px;height:30px;line-height:30px;width:100%}.emoticon-suggestion>div:first-child{text-align:center;width:30px}.emoticon-suggestion__image{margin-top:-2px;max-height:20px;max-width:20px;padding:0;text-align:center;vertical-align:middle}.emoji-picker{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:3px;border:1px solid;display:flex;flex-direction:column;position:absolute;height:362px;width:278px;z-index:8}.emoji-picker.reaction-picker{height:36px;width:190px}.emoji-picker.reaction-picker .emoji-picker__items{overflow-y:hidden}.emoji-picker__categories{flex-grow:0;flex-shrink:0}.emoji-picker__categories .emoji-picker__category{color:#333;display:inline-block;font-size:16px;margin:3px 6px;text-align:center;width:15px}.emoji-picker__categories .emoji-picker__category--selected,.emoji-picker__categories .emoji-picker__category:hover{color:#666}.emoji-picker__search-container{position:relative;border-top-style:solid;border-top-width:1px}.emoji-picker__search-container .emoji-picker__search-icon{padding-left:6px;padding-top:6px;position:absolute;font-size:13px}.emoji-picker__search-container .emoji-picker__search{border-width:0;padding:2px 0 2px 25px;width:100%;height:25px;font-size:12px}.emoji-picker__search-container .emoji-picker__search:focus{outline:none}.emoji-picker__items{max-height:278px;overflow-x:hidden;overflow-y:auto;padding:0 8px 8px;position:relative;border-top-style:solid;border-top-width:1px}.emoji-picker__items .emoji-picker__category-header{font-size:12px;font-weight:700;margin-bottom:6px;margin-top:3px;padding-top:3px}.emoji-picker__items .emoji-picker__preview_sprite{isplay:inline-block;height:45px;margin:3px;vertical-align:top;padding:3px}.emoji-picker__items .emoji-picker-items__container>div{display:inline-block;height:21px;margin:3px;vertical-align:top;width:21px;padding:3px}.emoji-picker__items .emoji-picker-items__container>span{display:inline-block;height:21px;margin:3px;vertical-align:top;width:21px;padding:0;border:0;text-align:center;border-radius:6px;overflow:hidden;cursor:pointer}.emoji-picker__items .emoji-picker__item-wrapper .emoji-picker__item{font-size:18px;margin:3px;max-height:21px;max-width:21px;min-height:0;min-width:0;width:auto;height:auto;margin:0 auto}.emoji-picker__preview{border-top:1px solid;display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;flex-grow:0;flex-shrink:0;height:45px;padding:3px 10px;vertical-align:middle;width:278px}.emoji-picker__preview.emoji-picker__preview-placeholder{padding:12px}.emoji-picker__preview>div{display:table-cell;vertical-align:middle}.emoji-picker__preview .emoji-picker__preview-image-label-box{margin-left:3px}.emoji-picker__preview .emoji-picker__preview-image-label-box .emoji-picker__preview-name{font-size:13px;font-weight:700}.emoji-picker__preview .emoji-picker__preview-image-label-box .emoji-picker__preview-aliases{display:block;font-size:12px;font-weight:700}.emoji-picker__preview .emoji-picker__preview-image-box{display:flex;align-items:center;justify-content:center;height:36px;max-height:36px;width:42px;max-width:42px;text-align:center}.emoji-picker__preview .emoji-picker__preview-image-box .sprite-preview{border:none;display:inline-block;height:36px;padding:0;vertical-align:middle;width:36px}.emoji-picker__preview .emoji-picker__preview-image{max-height:36px;max-width:42px}.emojisprite-preview{-webkit-transform:scale(.55);-moz-transform:scale(.55);-ms-transform:scale(.55);-o-transform:scale(.55);transform:scale(.55);background-repeat:no-repeat;cursor:pointer;height:64px;max-width:none;transform-origin:0 0;width:64px;padding:0 10px 0 0}.emojisprite,.emojisprite-loading{-webkit-transform:scale(.35);-moz-transform:scale(.35);-ms-transform:scale(.35);-o-transform:scale(.35);transform:scale(.35);background-repeat:no-repeat;border-radius:18px;cursor:pointer;height:64px;max-width:none;transform-origin:0 0;width:64px}.emojisprite-loading{background-image:none!important}.emoji-category-smileys_emotion-1{background-image:url(" + __webpack_require__(492) + ")}.emoji-263a-fe0f{background-position:0 0}.emoji-1f601{background-position:-64px 0}.emoji-1f602{background-position:0 -64px}.emoji-1f603{background-position:-64px -64px}.emoji-1f604{background-position:-128px 0}.emoji-1f605{background-position:-128px -64px}.emoji-1f606{background-position:0 -128px}.emoji-1f607{background-position:-64px -128px}.emoji-1f609{background-position:-128px -128px}.emoji-1f60a{background-position:-192px 0}.emoji-1f60b{background-position:-192px -64px}.emoji-1f60c{background-position:-192px -128px}.emoji-1f60d{background-position:0 -192px}.emoji-1f60f{background-position:-64px -192px}.emoji-1f610{background-position:-128px -192px}.emoji-1f611{background-position:-192px -192px}.emoji-1f612{background-position:-256px 0}.emoji-1f614{background-position:-256px -64px}.emoji-1f617{background-position:-256px -128px}.emoji-1f618{background-position:-256px -192px}.emoji-1f619{background-position:0 -256px}.emoji-1f61a{background-position:-64px -256px}.emoji-1f61b{background-position:-128px -256px}.emoji-1f61c{background-position:-192px -256px}.emoji-1f61d{background-position:-256px -256px}.emoji-1f62a{background-position:-320px 0}.emoji-1f62c{background-position:-320px -64px}.emoji-1f636{background-position:-320px -128px}.emoji-1f642{background-position:-320px -192px}.emoji-1f643{background-position:-320px -256px}.emoji-1f644{background-position:0 -320px}.emoji-1f910{background-position:-64px -320px}.emoji-1f911{background-position:-128px -320px}.emoji-1f914{background-position:-192px -320px}.emoji-1f917{background-position:-256px -320px}.emoji-1f923{background-position:-320px -320px}.emoji-1f924{background-position:-384px 0}.emoji-1f925{background-position:-384px -64px}.emoji-1f928{background-position:-384px -128px}.emoji-1f929{background-position:-384px -192px}.emoji-1f92a{background-position:-384px -256px}.emoji-1f92b{background-position:-384px -320px}.emoji-1f92d{background-position:0 -384px}.emoji-1f970{background-position:-64px -384px}.emoji-1f600{background-position:-128px -384px}.emoji-category-smileys_emotion-2{background-image:url(" + __webpack_require__(493) + ")}.emoji-2639-fe0f{background-position:0 0}.emoji-1f613{background-position:-64px 0}.emoji-1f615{background-position:0 -64px}.emoji-1f616{background-position:-64px -64px}.emoji-1f61e{background-position:-128px 0}.emoji-1f61f{background-position:-128px -64px}.emoji-1f620{background-position:0 -128px}.emoji-1f621{background-position:-64px -128px}.emoji-1f622{background-position:-128px -128px}.emoji-1f623{background-position:-192px 0}.emoji-1f624{background-position:-192px -64px}.emoji-1f625{background-position:-192px -128px}.emoji-1f626{background-position:0 -192px}.emoji-1f627{background-position:-64px -192px}.emoji-1f628{background-position:-128px -192px}.emoji-1f629{background-position:-192px -192px}.emoji-1f62b{background-position:-256px 0}.emoji-1f62d{background-position:-256px -64px}.emoji-1f62e{background-position:-256px -128px}.emoji-1f62f{background-position:-256px -192px}.emoji-1f630{background-position:0 -256px}.emoji-1f631{background-position:-64px -256px}.emoji-1f632{background-position:-128px -256px}.emoji-1f633{background-position:-192px -256px}.emoji-1f634{background-position:-256px -256px}.emoji-1f635{background-position:-320px 0}.emoji-1f637{background-position:-320px -64px}.emoji-1f641{background-position:-320px -128px}.emoji-1f912{background-position:-320px -192px}.emoji-1f913{background-position:-320px -256px}.emoji-1f915{background-position:0 -320px}.emoji-1f920{background-position:-64px -320px}.emoji-1f922{background-position:-128px -320px}.emoji-1f927{background-position:-192px -320px}.emoji-1f92c{background-position:-256px -320px}.emoji-1f92e{background-position:-320px -320px}.emoji-1f92f{background-position:-384px 0}.emoji-1f971{background-position:-384px -64px}.emoji-1f973{background-position:-384px -128px}.emoji-1f974{background-position:-384px -192px}.emoji-1f975{background-position:-384px -256px}.emoji-1f976{background-position:-384px -320px}.emoji-1f97a{background-position:0 -384px}.emoji-1f9d0{background-position:-64px -384px}.emoji-1f60e{background-position:-128px -384px}.emoji-category-smileys_emotion-3{background-image:url(" + __webpack_require__(499) + ")}.emoji-2764-fe0f{background-position:0 0}.emoji-1f47a{background-position:-64px 0}.emoji-1f47b{background-position:0 -64px}.emoji-1f47d{background-position:-64px -64px}.emoji-1f47e{background-position:-128px 0}.emoji-1f47f{background-position:-128px -64px}.emoji-1f480{background-position:0 -128px}.emoji-1f48b{background-position:-64px -128px}.emoji-1f48c{background-position:-128px -128px}.emoji-1f493{background-position:-192px 0}.emoji-1f494{background-position:-192px -64px}.emoji-1f495{background-position:-192px -128px}.emoji-1f496{background-position:0 -192px}.emoji-1f497{background-position:-64px -192px}.emoji-1f498{background-position:-128px -192px}.emoji-1f499{background-position:-192px -192px}.emoji-1f49a{background-position:-256px 0}.emoji-1f49b{background-position:-256px -64px}.emoji-1f49c{background-position:-256px -128px}.emoji-1f49d{background-position:-256px -192px}.emoji-1f49e{background-position:0 -256px}.emoji-1f49f{background-position:-64px -256px}.emoji-1f4a9{background-position:-128px -256px}.emoji-1f5a4{background-position:-192px -256px}.emoji-1f608{background-position:-256px -256px}.emoji-1f638{background-position:-320px 0}.emoji-1f639{background-position:-320px -64px}.emoji-1f63a{background-position:-320px -128px}.emoji-1f63b{background-position:-320px -192px}.emoji-1f63c{background-position:-320px -256px}.emoji-1f63d{background-position:0 -320px}.emoji-1f63e{background-position:-64px -320px}.emoji-1f63f{background-position:-128px -320px}.emoji-1f640{background-position:-192px -320px}.emoji-1f648{background-position:-256px -320px}.emoji-1f649{background-position:-320px -320px}.emoji-1f64a{background-position:-384px 0}.emoji-1f90d{background-position:-384px -64px}.emoji-1f90e{background-position:-384px -128px}.emoji-1f916{background-position:-384px -192px}.emoji-1f921{background-position:-384px -256px}.emoji-1f9e1{background-position:-384px -320px}.emoji-2620-fe0f{background-position:0 -384px}.emoji-2763-fe0f{background-position:-64px -384px}.emoji-1f479{background-position:-128px -384px}.emoji-category-smileys_emotion-4{background-image:url(" + __webpack_require__(500) + ")}.emoji-1f5ef-fe0f{background-position:0 0}.emoji-1f4a2{background-position:-64px 0}.emoji-1f4a3{background-position:0 -64px}.emoji-1f4a4{background-position:-64px -64px}.emoji-1f4a5{background-position:-128px 0}.emoji-1f4a6{background-position:-128px -64px}.emoji-1f4a8{background-position:0 -128px}.emoji-1f4ab{background-position:-64px -128px}.emoji-1f4ac{background-position:-128px -128px}.emoji-1f4ad{background-position:-192px 0}.emoji-1f4af{background-position:-192px -64px}.emoji-1f573-fe0f{background-position:-192px -128px}.emoji-1f5e8-fe0f{background-position:0 -192px}.emoji-1f441-fe0f-200d-1f5e8-fe0f{background-position:-64px -192px}.emoji-category-people_body-1{background-image:url(" + __webpack_require__(494) + ")}.emoji-270d-fe0f{background-position:0 0}.emoji-1f442{background-position:-64px 0}.emoji-1f443{background-position:0 -64px}.emoji-1f446{background-position:-64px -64px}.emoji-1f447{background-position:-128px 0}.emoji-1f448{background-position:-128px -64px}.emoji-1f449{background-position:0 -128px}.emoji-1f44a{background-position:-64px -128px}.emoji-1f44b{background-position:-128px -128px}.emoji-1f44c{background-position:-192px 0}.emoji-1f44d{background-position:-192px -64px}.emoji-1f44e{background-position:-192px -128px}.emoji-1f44f{background-position:0 -192px}.emoji-1f450{background-position:-64px -192px}.emoji-1f485{background-position:-128px -192px}.emoji-1f4aa{background-position:-192px -192px}.emoji-1f590{background-position:-256px 0}.emoji-1f595{background-position:-256px -64px}.emoji-1f596{background-position:-256px -128px}.emoji-1f64c{background-position:-256px -192px}.emoji-1f64f{background-position:0 -256px}.emoji-1f90f{background-position:-64px -256px}.emoji-1f918{background-position:-128px -256px}.emoji-1f919{background-position:-192px -256px}.emoji-1f91a{background-position:-256px -256px}.emoji-1f91b{background-position:-320px 0}.emoji-1f91c{background-position:-320px -64px}.emoji-1f91d{background-position:-320px -128px}.emoji-1f91e{background-position:-320px -192px}.emoji-1f91f{background-position:-320px -256px}.emoji-1f932{background-position:0 -320px}.emoji-1f933{background-position:-64px -320px}.emoji-1f9b4{background-position:-128px -320px}.emoji-1f9b5{background-position:-192px -320px}.emoji-1f9b6{background-position:-256px -320px}.emoji-1f9b7{background-position:-320px -320px}.emoji-1f9bb{background-position:-384px 0}.emoji-1f9be{background-position:-384px -64px}.emoji-1f9bf{background-position:-384px -128px}.emoji-1f9e0{background-position:-384px -192px}.emoji-261d-fe0f{background-position:-384px -256px}.emoji-270a{background-position:-384px -320px}.emoji-270b{background-position:0 -384px}.emoji-270c-fe0f{background-position:-64px -384px}.emoji-1f440{background-position:-128px -384px}.emoji-category-people_body-2{background-image:url(" + __webpack_require__(501) + ")}.emoji-1f9d4{background-position:0 0}.emoji-1f444{background-position:-64px 0}.emoji-1f445{background-position:0 -64px}.emoji-1f466{background-position:-64px -64px}.emoji-1f467{background-position:-128px 0}.emoji-1f468{background-position:-128px -64px}.emoji-1f468-200d-1f9b0{background-position:0 -128px}.emoji-1f468-200d-1f9b1{background-position:-64px -128px}.emoji-1f468-200d-1f9b2{background-position:-128px -128px}.emoji-1f468-200d-1f9b3{background-position:-192px 0}.emoji-1f469{background-position:-192px -64px}.emoji-1f469-200d-1f9b0{background-position:-192px -128px}.emoji-1f469-200d-1f9b1{background-position:0 -192px}.emoji-1f469-200d-1f9b2{background-position:-64px -192px}.emoji-1f469-200d-1f9b3{background-position:-128px -192px}.emoji-1f471{background-position:-192px -192px}.emoji-1f471-200d-2640-fe0f{background-position:-256px 0}.emoji-1f471-200d-2642-fe0f{background-position:-256px -64px}.emoji-1f474{background-position:-256px -128px}.emoji-1f475{background-position:-256px -192px}.emoji-1f476{background-position:0 -256px}.emoji-1f481{background-position:-64px -256px}.emoji-1f481-200d-2640-fe0f{background-position:-128px -256px}.emoji-1f481-200d-2642-fe0f{background-position:-192px -256px}.emoji-1f645{background-position:-256px -256px}.emoji-1f645-200d-2640-fe0f{background-position:-320px 0}.emoji-1f645-200d-2642-fe0f{background-position:-320px -64px}.emoji-1f646{background-position:-320px -128px}.emoji-1f646-200d-2640-fe0f{background-position:-320px -192px}.emoji-1f646-200d-2642-fe0f{background-position:-320px -256px}.emoji-1f64b{background-position:0 -320px}.emoji-1f64d{background-position:-64px -320px}.emoji-1f64d-200d-2640-fe0f{background-position:-128px -320px}.emoji-1f64d-200d-2642-fe0f{background-position:-192px -320px}.emoji-1f64e{background-position:-256px -320px}.emoji-1f64e-200d-2640-fe0f{background-position:-320px -320px}.emoji-1f64e-200d-2642-fe0f{background-position:-384px 0}.emoji-1f9d1{background-position:-384px -64px}.emoji-1f9d1-200d-1f9b0{background-position:-384px -128px}.emoji-1f9d1-200d-1f9b1{background-position:-384px -192px}.emoji-1f9d1-200d-1f9b2{background-position:-384px -256px}.emoji-1f9d1-200d-1f9b3{background-position:-384px -320px}.emoji-1f9d2{background-position:0 -384px}.emoji-1f9d3{background-position:-64px -384px}.emoji-1f441{background-position:-128px -384px}.emoji-category-people_body-3{background-image:url(" + __webpack_require__(502) + ")}.emoji-1f9d1-200d-2696-fe0f{background-position:0 0}.emoji-1f468-200d-1f373{background-position:-64px 0}.emoji-1f468-200d-1f393{background-position:0 -64px}.emoji-1f468-200d-1f3eb{background-position:-64px -64px}.emoji-1f468-200d-1f3ed{background-position:-128px 0}.emoji-1f468-200d-1f4bc{background-position:-128px -64px}.emoji-1f468-200d-1f527{background-position:0 -128px}.emoji-1f468-200d-1f52c{background-position:-64px -128px}.emoji-1f468-200d-2695-fe0f{background-position:-128px -128px}.emoji-1f468-200d-2696-fe0f{background-position:-192px 0}.emoji-1f469-200d-1f33e{background-position:-192px -64px}.emoji-1f469-200d-1f373{background-position:-192px -128px}.emoji-1f469-200d-1f393{background-position:0 -192px}.emoji-1f469-200d-1f3eb{background-position:-64px -192px}.emoji-1f469-200d-1f3ed{background-position:-128px -192px}.emoji-1f469-200d-1f4bc{background-position:-192px -192px}.emoji-1f469-200d-1f527{background-position:-256px 0}.emoji-1f469-200d-1f52c{background-position:-256px -64px}.emoji-1f469-200d-2695-fe0f{background-position:-256px -128px}.emoji-1f469-200d-2696-fe0f{background-position:-256px -192px}.emoji-1f647{background-position:0 -256px}.emoji-1f647-200d-2640-fe0f{background-position:-64px -256px}.emoji-1f647-200d-2642-fe0f{background-position:-128px -256px}.emoji-1f64b-200d-2640-fe0f{background-position:-192px -256px}.emoji-1f64b-200d-2642-fe0f{background-position:-256px -256px}.emoji-1f926{background-position:-320px 0}.emoji-1f926-200d-2640-fe0f{background-position:-320px -64px}.emoji-1f926-200d-2642-fe0f{background-position:-320px -128px}.emoji-1f937{background-position:-320px -192px}.emoji-1f937-200d-2640-fe0f{background-position:-320px -256px}.emoji-1f937-200d-2642-fe0f{background-position:0 -320px}.emoji-1f9cf{background-position:-64px -320px}.emoji-1f9cf-200d-2640-fe0f{background-position:-128px -320px}.emoji-1f9cf-200d-2642-fe0f{background-position:-192px -320px}.emoji-1f9d1-200d-1f33e{background-position:-256px -320px}.emoji-1f9d1-200d-1f373{background-position:-320px -320px}.emoji-1f9d1-200d-1f393{background-position:-384px 0}.emoji-1f9d1-200d-1f3eb{background-position:-384px -64px}.emoji-1f9d1-200d-1f3ed{background-position:-384px -128px}.emoji-1f9d1-200d-1f4bb{background-position:-384px -192px}.emoji-1f9d1-200d-1f4bc{background-position:-384px -256px}.emoji-1f9d1-200d-1f527{background-position:-384px -320px}.emoji-1f9d1-200d-1f52c{background-position:0 -384px}.emoji-1f9d1-200d-2695-fe0f{background-position:-64px -384px}.emoji-1f468-200d-1f33e{background-position:-128px -384px}.emoji-category-people_body-4{background-image:url(" + __webpack_require__(503) + ")}.emoji-1f9d5{background-position:0 0}.emoji-1f468-200d-1f3a4{background-position:-64px 0}.emoji-1f468-200d-1f3a8{background-position:0 -64px}.emoji-1f468-200d-1f4bb{background-position:-64px -64px}.emoji-1f468-200d-1f680{background-position:-128px 0}.emoji-1f468-200d-1f692{background-position:-128px -64px}.emoji-1f468-200d-2708-fe0f{background-position:0 -128px}.emoji-1f469-200d-1f3a4{background-position:-64px -128px}.emoji-1f469-200d-1f3a8{background-position:-128px -128px}.emoji-1f469-200d-1f4bb{background-position:-192px 0}.emoji-1f469-200d-1f680{background-position:-192px -64px}.emoji-1f469-200d-1f692{background-position:-192px -128px}.emoji-1f469-200d-2708-fe0f{background-position:0 -192px}.emoji-1f46e{background-position:-64px -192px}.emoji-1f46e-200d-2640-fe0f{background-position:-128px -192px}.emoji-1f46e-200d-2642-fe0f{background-position:-192px -192px}.emoji-1f470{background-position:-256px 0}.emoji-1f472{background-position:-256px -64px}.emoji-1f473{background-position:-256px -128px}.emoji-1f473-200d-2640-fe0f{background-position:-256px -192px}.emoji-1f473-200d-2642-fe0f{background-position:0 -256px}.emoji-1f477{background-position:-64px -256px}.emoji-1f477-200d-2640-fe0f{background-position:-128px -256px}.emoji-1f477-200d-2642-fe0f{background-position:-192px -256px}.emoji-1f478{background-position:-256px -256px}.emoji-1f47c{background-position:-320px 0}.emoji-1f482{background-position:-320px -64px}.emoji-1f482-200d-2640-fe0f{background-position:-320px -128px}.emoji-1f482-200d-2642-fe0f{background-position:-320px -192px}.emoji-1f575-fe0f{background-position:-320px -256px}.emoji-1f575-fe0f-200d-2640-fe0f{background-position:0 -320px}.emoji-1f575-fe0f-200d-2642-fe0f{background-position:-64px -320px}.emoji-1f930{background-position:-128px -320px}.emoji-1f931{background-position:-192px -320px}.emoji-1f934{background-position:-256px -320px}.emoji-1f935{background-position:-320px -320px}.emoji-1f936{background-position:-384px 0}.emoji-1f9b8{background-position:-384px -64px}.emoji-1f9b8-200d-2642-fe0f{background-position:-384px -128px}.emoji-1f9d1-200d-1f3a4{background-position:-384px -192px}.emoji-1f9d1-200d-1f3a8{background-position:-384px -256px}.emoji-1f9d1-200d-1f680{background-position:-384px -320px}.emoji-1f9d1-200d-1f692{background-position:0 -384px}.emoji-1f9d1-200d-2708-fe0f{background-position:-64px -384px}.emoji-1f385{background-position:-128px -384px}.emoji-category-people_body-5{background-image:url(" + __webpack_require__(504) + ")}.emoji-1f9df-200d-2642-fe0f{background-position:0 0}.emoji-1f468-200d-1f9bc{background-position:-64px 0}.emoji-1f469-200d-1f9af{background-position:0 -64px}.emoji-1f486{background-position:-64px -64px}.emoji-1f486-200d-2640-fe0f{background-position:-128px 0}.emoji-1f486-200d-2642-fe0f{background-position:-128px -64px}.emoji-1f487{background-position:0 -128px}.emoji-1f487-200d-2640-fe0f{background-position:-64px -128px}.emoji-1f487-200d-2642-fe0f{background-position:-128px -128px}.emoji-1f6b6{background-position:-192px 0}.emoji-1f6b6-200d-2640-fe0f{background-position:-192px -64px}.emoji-1f6b6-200d-2642-fe0f{background-position:-192px -128px}.emoji-1f9b8-200d-2640-fe0f{background-position:0 -192px}.emoji-1f9b9{background-position:-64px -192px}.emoji-1f9b9-200d-2640-fe0f{background-position:-128px -192px}.emoji-1f9b9-200d-2642-fe0f{background-position:-192px -192px}.emoji-1f9cd{background-position:-256px 0}.emoji-1f9cd-200d-2640-fe0f{background-position:-256px -64px}.emoji-1f9cd-200d-2642-fe0f{background-position:-256px -128px}.emoji-1f9ce{background-position:-256px -192px}.emoji-1f9ce-200d-2640-fe0f{background-position:0 -256px}.emoji-1f9ce-200d-2642-fe0f{background-position:-64px -256px}.emoji-1f9d1-200d-1f9af{background-position:-128px -256px}.emoji-1f9d1-200d-1f9bc{background-position:-192px -256px}.emoji-1f9d9{background-position:-256px -256px}.emoji-1f9d9-200d-2640-fe0f{background-position:-320px 0}.emoji-1f9d9-200d-2642-fe0f{background-position:-320px -64px}.emoji-1f9da{background-position:-320px -128px}.emoji-1f9da-200d-2640-fe0f{background-position:-320px -192px}.emoji-1f9da-200d-2642-fe0f{background-position:-320px -256px}.emoji-1f9db{background-position:0 -320px}.emoji-1f9db-200d-2640-fe0f{background-position:-64px -320px}.emoji-1f9db-200d-2642-fe0f{background-position:-128px -320px}.emoji-1f9dc{background-position:-192px -320px}.emoji-1f9dc-200d-2640-fe0f{background-position:-256px -320px}.emoji-1f9dc-200d-2642-fe0f{background-position:-320px -320px}.emoji-1f9dd{background-position:-384px 0}.emoji-1f9dd-200d-2640-fe0f{background-position:-384px -64px}.emoji-1f9dd-200d-2642-fe0f{background-position:-384px -128px}.emoji-1f9de{background-position:-384px -192px}.emoji-1f9de-200d-2640-fe0f{background-position:-384px -256px}.emoji-1f9de-200d-2642-fe0f{background-position:-384px -320px}.emoji-1f9df{background-position:0 -384px}.emoji-1f9df-200d-2640-fe0f{background-position:-64px -384px}.emoji-1f468-200d-1f9af{background-position:-128px -384px}.emoji-category-people_body-6{background-image:url(" + __webpack_require__(505) + ")}.emoji-26f9-fe0f-200d-2642-fe0f{background-position:0 0}.emoji-1f3c3{background-position:-64px 0}.emoji-1f3c3-200d-2640-fe0f{background-position:0 -64px}.emoji-1f3c3-200d-2642-fe0f{background-position:-64px -64px}.emoji-1f3c4{background-position:-128px 0}.emoji-1f3c4-200d-2640-fe0f{background-position:-128px -64px}.emoji-1f3c4-200d-2642-fe0f{background-position:0 -128px}.emoji-1f3c7{background-position:-64px -128px}.emoji-1f3ca{background-position:-128px -128px}.emoji-1f3ca-200d-2640-fe0f{background-position:-192px 0}.emoji-1f3ca-200d-2642-fe0f{background-position:-192px -64px}.emoji-1f3cb-fe0f{background-position:-192px -128px}.emoji-1f3cb-fe0f-200d-2640-fe0f{background-position:0 -192px}.emoji-1f3cb-fe0f-200d-2642-fe0f{background-position:-64px -192px}.emoji-1f3cc-fe0f{background-position:-128px -192px}.emoji-1f3cc-fe0f-200d-2640-fe0f{background-position:-192px -192px}.emoji-1f3cc-fe0f-200d-2642-fe0f{background-position:-256px 0}.emoji-1f468-200d-1f9bd{background-position:-256px -64px}.emoji-1f469-200d-1f9bc{background-position:-256px -128px}.emoji-1f469-200d-1f9bd{background-position:-256px -192px}.emoji-1f46f{background-position:0 -256px}.emoji-1f46f-200d-2640-fe0f{background-position:-64px -256px}.emoji-1f46f-200d-2642-fe0f{background-position:-128px -256px}.emoji-1f483{background-position:-192px -256px}.emoji-1f574,.emoji-1f574-fe0f{background-position:-256px -256px}.emoji-1f57a{background-position:-320px 0}.emoji-1f6a3{background-position:-320px -64px}.emoji-1f6a3-200d-2640-fe0f{background-position:-320px -128px}.emoji-1f6a3-200d-2642-fe0f{background-position:-320px -192px}.emoji-1f6b4{background-position:-320px -256px}.emoji-1f6b4-200d-2640-fe0f{background-position:0 -320px}.emoji-1f6b4-200d-2642-fe0f{background-position:-64px -320px}.emoji-1f6b5{background-position:-128px -320px}.emoji-1f93a{background-position:-192px -320px}.emoji-1f9d1-200d-1f9bd{background-position:-256px -320px}.emoji-1f9d6{background-position:-320px -320px}.emoji-1f9d6-200d-2640-fe0f{background-position:-384px 0}.emoji-1f9d6-200d-2642-fe0f{background-position:-384px -64px}.emoji-1f9d7{background-position:-384px -128px}.emoji-1f9d7-200d-2640-fe0f{background-position:-384px -192px}.emoji-1f9d7-200d-2642-fe0f{background-position:-384px -256px}.emoji-26f7{background-position:-384px -320px}.emoji-26f9-fe0f{background-position:0 -384px}.emoji-26f9-fe0f-200d-2640-fe0f{background-position:-64px -384px}.emoji-1f3c2{background-position:-128px -384px}.emoji-category-people_body-7{background-image:url(" + __webpack_require__(506) + ")}.emoji-1f9d8-200d-2642-fe0f{background-position:0 0}.emoji-1f468-200d-1f468-200d-1f466-200d-1f466{background-position:-64px 0}.emoji-1f468-200d-1f468-200d-1f467{background-position:0 -64px}.emoji-1f468-200d-1f468-200d-1f467-200d-1f466{background-position:-64px -64px}.emoji-1f468-200d-1f468-200d-1f467-200d-1f467{background-position:-128px 0}.emoji-1f468-200d-1f469-200d-1f466{background-position:-128px -64px}.emoji-1f468-200d-1f469-200d-1f466-200d-1f466{background-position:0 -128px}.emoji-1f468-200d-1f469-200d-1f467{background-position:-64px -128px}.emoji-1f468-200d-1f469-200d-1f467-200d-1f466{background-position:-128px -128px}.emoji-1f468-200d-1f469-200d-1f467-200d-1f467{background-position:-192px 0}.emoji-1f468-200d-2764-fe0f-200d-1f468{background-position:-192px -64px}.emoji-1f468-200d-2764-fe0f-200d-1f48b-200d-1f468{background-position:-192px -128px}.emoji-1f469-200d-2764-fe0f-200d-1f468{background-position:0 -192px}.emoji-1f469-200d-2764-fe0f-200d-1f469{background-position:-64px -192px}.emoji-1f469-200d-2764-fe0f-200d-1f48b-200d-1f468{background-position:-128px -192px}.emoji-1f469-200d-2764-fe0f-200d-1f48b-200d-1f469{background-position:-192px -192px}.emoji-1f46a{background-position:-256px 0}.emoji-1f46b{background-position:-256px -64px}.emoji-1f46c{background-position:-256px -128px}.emoji-1f46d{background-position:-256px -192px}.emoji-1f48f{background-position:0 -256px}.emoji-1f491{background-position:-64px -256px}.emoji-1f6b5-200d-2640-fe0f{background-position:-128px -256px}.emoji-1f6b5-200d-2642-fe0f{background-position:-192px -256px}.emoji-1f6c0{background-position:-256px -256px}.emoji-1f6cc{background-position:-320px 0}.emoji-1f938{background-position:-320px -64px}.emoji-1f938-200d-2640-fe0f{background-position:-320px -128px}.emoji-1f938-200d-2642-fe0f{background-position:-320px -192px}.emoji-1f939{background-position:-320px -256px}.emoji-1f939-200d-2640-fe0f{background-position:0 -320px}.emoji-1f939-200d-2642-fe0f{background-position:-64px -320px}.emoji-1f93c{background-position:-128px -320px}.emoji-1f93c-200d-2640-fe0f{background-position:-192px -320px}.emoji-1f93c-200d-2642-fe0f{background-position:-256px -320px}.emoji-1f93d{background-position:-320px -320px}.emoji-1f93d-200d-2640-fe0f{background-position:-384px 0}.emoji-1f93d-200d-2642-fe0f{background-position:-384px -64px}.emoji-1f93e{background-position:-384px -128px}.emoji-1f93e-200d-2640-fe0f{background-position:-384px -192px}.emoji-1f93e-200d-2642-fe0f{background-position:-384px -256px}.emoji-1f9d1-200d-1f91d-200d-1f9d1{background-position:-384px -320px}.emoji-1f9d8{background-position:0 -384px}.emoji-1f9d8-200d-2640-fe0f{background-position:-64px -384px}.emoji-1f468-200d-1f468-200d-1f466{background-position:-128px -384px}.emoji-category-people_body-8{background-image:url(" + __webpack_require__(507) + ")}.emoji-1f5e3{background-position:0 0}.emoji-1f464{background-position:-64px 0}.emoji-1f465{background-position:0 -64px}.emoji-1f468-200d-1f466{background-position:-64px -64px}.emoji-1f468-200d-1f466-200d-1f466{background-position:-128px 0}.emoji-1f468-200d-1f467{background-position:-128px -64px}.emoji-1f468-200d-1f467-200d-1f466{background-position:0 -128px}.emoji-1f468-200d-1f467-200d-1f467{background-position:-64px -128px}.emoji-1f469-200d-1f466{background-position:-128px -128px}.emoji-1f469-200d-1f466-200d-1f466{background-position:-192px 0}.emoji-1f469-200d-1f467{background-position:-192px -64px}.emoji-1f469-200d-1f467-200d-1f466{background-position:-192px -128px}.emoji-1f469-200d-1f467-200d-1f467{background-position:0 -192px}.emoji-1f469-200d-1f469-200d-1f466{background-position:-64px -192px}.emoji-1f469-200d-1f469-200d-1f466-200d-1f466{background-position:-128px -192px}.emoji-1f469-200d-1f469-200d-1f467{background-position:-192px -192px}.emoji-1f469-200d-1f469-200d-1f467-200d-1f466{background-position:-256px 0}.emoji-1f469-200d-1f469-200d-1f467-200d-1f467{background-position:-256px -64px}.emoji-1f463{background-position:-256px -128px}.emoji-category-animals_nature-1{background-image:url(" + __webpack_require__(508) + ")}.emoji-1f9ae{background-position:0 0}.emoji-1f401{background-position:-64px 0}.emoji-1f402{background-position:0 -64px}.emoji-1f403{background-position:-64px -64px}.emoji-1f404{background-position:-128px 0}.emoji-1f405{background-position:-128px -64px}.emoji-1f406{background-position:0 -128px}.emoji-1f408{background-position:-64px -128px}.emoji-1f40e{background-position:-128px -128px}.emoji-1f40f{background-position:-192px 0}.emoji-1f410{background-position:-192px -64px}.emoji-1f411{background-position:-192px -128px}.emoji-1f412{background-position:0 -192px}.emoji-1f415{background-position:-64px -192px}.emoji-1f415-200d-1f9ba{background-position:-128px -192px}.emoji-1f416{background-position:-192px -192px}.emoji-1f417{background-position:-256px 0}.emoji-1f418{background-position:-256px -64px}.emoji-1f429{background-position:-256px -128px}.emoji-1f42a{background-position:-256px -192px}.emoji-1f42b{background-position:0 -256px}.emoji-1f42d{background-position:-64px -256px}.emoji-1f42e{background-position:-128px -256px}.emoji-1f42f{background-position:-192px -256px}.emoji-1f431{background-position:-256px -256px}.emoji-1f434{background-position:-320px 0}.emoji-1f435{background-position:-320px -64px}.emoji-1f436{background-position:-320px -128px}.emoji-1f437{background-position:-320px -192px}.emoji-1f439{background-position:-320px -256px}.emoji-1f43a{background-position:0 -320px}.emoji-1f43d{background-position:-64px -320px}.emoji-1f981{background-position:-128px -320px}.emoji-1f984{background-position:-192px -320px}.emoji-1f98a{background-position:-256px -320px}.emoji-1f98c{background-position:-320px -320px}.emoji-1f98d{background-position:-384px 0}.emoji-1f98f{background-position:-384px -64px}.emoji-1f992{background-position:-384px -128px}.emoji-1f993{background-position:-384px -192px}.emoji-1f999{background-position:-384px -256px}.emoji-1f99b{background-position:-384px -320px}.emoji-1f99d{background-position:0 -384px}.emoji-1f9a7{background-position:-64px -384px}.emoji-1f400{background-position:-128px -384px}.emoji-category-animals_nature-2{background-image:url(" + __webpack_require__(509) + ")}.emoji-1f9a9{background-position:0 0}.emoji-1f409{background-position:-64px 0}.emoji-1f40a{background-position:0 -64px}.emoji-1f40b{background-position:-64px -64px}.emoji-1f40d{background-position:-128px 0}.emoji-1f413{background-position:-128px -64px}.emoji-1f414{background-position:0 -128px}.emoji-1f41f{background-position:-64px -128px}.emoji-1f420{background-position:-128px -128px}.emoji-1f421{background-position:-192px 0}.emoji-1f422{background-position:-192px -64px}.emoji-1f423{background-position:-192px -128px}.emoji-1f424{background-position:0 -192px}.emoji-1f425{background-position:-64px -192px}.emoji-1f426{background-position:-128px -192px}.emoji-1f427{background-position:-192px -192px}.emoji-1f428{background-position:-256px 0}.emoji-1f42c{background-position:-256px -64px}.emoji-1f430{background-position:-256px -128px}.emoji-1f432{background-position:-256px -192px}.emoji-1f433{background-position:0 -256px}.emoji-1f438{background-position:-64px -256px}.emoji-1f43b{background-position:-128px -256px}.emoji-1f43c{background-position:-192px -256px}.emoji-1f43e{background-position:-256px -256px}.emoji-1f43f{background-position:-320px 0}.emoji-1f54a{background-position:-320px -64px}.emoji-1f983{background-position:-320px -128px}.emoji-1f985{background-position:-320px -192px}.emoji-1f986{background-position:-320px -256px}.emoji-1f987{background-position:0 -320px}.emoji-1f989{background-position:-64px -320px}.emoji-1f98e{background-position:-128px -320px}.emoji-1f994{background-position:-192px -320px}.emoji-1f995{background-position:-256px -320px}.emoji-1f996{background-position:-320px -320px}.emoji-1f998{background-position:-384px 0}.emoji-1f99a{background-position:-384px -64px}.emoji-1f99c{background-position:-384px -128px}.emoji-1f9a1{background-position:-384px -192px}.emoji-1f9a2{background-position:-384px -256px}.emoji-1f9a5{background-position:-384px -320px}.emoji-1f9a6{background-position:0 -384px}.emoji-1f9a8{background-position:-64px -384px}.emoji-1f407{background-position:-128px -384px}.emoji-category-animals_nature-3{background-image:url(" + __webpack_require__(510) + ")}.emoji-2618-fe0f{background-position:0 0}.emoji-1f332{background-position:-64px 0}.emoji-1f333{background-position:0 -64px}.emoji-1f334{background-position:-64px -64px}.emoji-1f335{background-position:-128px 0}.emoji-1f337{background-position:-128px -64px}.emoji-1f338{background-position:0 -128px}.emoji-1f339{background-position:-64px -128px}.emoji-1f33a{background-position:-128px -128px}.emoji-1f33b{background-position:-192px 0}.emoji-1f33c{background-position:-192px -64px}.emoji-1f33e{background-position:-192px -128px}.emoji-1f33f{background-position:0 -192px}.emoji-1f340{background-position:-64px -192px}.emoji-1f341{background-position:-128px -192px}.emoji-1f342{background-position:-192px -192px}.emoji-1f343{background-position:-256px 0}.emoji-1f3f5{background-position:-256px -64px}.emoji-1f40c{background-position:-256px -128px}.emoji-1f419{background-position:-256px -192px}.emoji-1f41a{background-position:0 -256px}.emoji-1f41b{background-position:-64px -256px}.emoji-1f41c{background-position:-128px -256px}.emoji-1f41d{background-position:-192px -256px}.emoji-1f41e{background-position:-256px -256px}.emoji-1f490{background-position:-320px 0}.emoji-1f4ae{background-position:-320px -64px}.emoji-1f577{background-position:-320px -128px}.emoji-1f578{background-position:-320px -192px}.emoji-1f940{background-position:-320px -256px}.emoji-1f982{background-position:0 -320px}.emoji-1f988{background-position:-64px -320px}.emoji-1f98b{background-position:-128px -320px}.emoji-1f997{background-position:-192px -320px}.emoji-1f99f{background-position:-256px -320px}.emoji-1f9a0{background-position:-320px -320px}.emoji-1f331{background-position:-384px 0}.emoji-category-food_drink-1{background-image:url(" + __webpack_require__(511) + ")}.emoji-1f9c7{background-position:0 0}.emoji-1f336{background-position:-64px 0}.emoji-1f33d{background-position:0 -64px}.emoji-1f344{background-position:-64px -64px}.emoji-1f345{background-position:-128px 0}.emoji-1f346{background-position:-128px -64px}.emoji-1f347{background-position:0 -128px}.emoji-1f348{background-position:-64px -128px}.emoji-1f349{background-position:-128px -128px}.emoji-1f34a{background-position:-192px 0}.emoji-1f34b{background-position:-192px -64px}.emoji-1f34c{background-position:-192px -128px}.emoji-1f34d{background-position:0 -192px}.emoji-1f34e{background-position:-64px -192px}.emoji-1f34f{background-position:-128px -192px}.emoji-1f350{background-position:-192px -192px}.emoji-1f351{background-position:-256px 0}.emoji-1f352{background-position:-256px -64px}.emoji-1f353{background-position:-256px -128px}.emoji-1f354{background-position:-256px -192px}.emoji-1f356{background-position:0 -256px}.emoji-1f357{background-position:-64px -256px}.emoji-1f35e{background-position:-128px -256px}.emoji-1f35f{background-position:-192px -256px}.emoji-1f950{background-position:-256px -256px}.emoji-1f951{background-position:-320px 0}.emoji-1f952{background-position:-320px -64px}.emoji-1f953{background-position:-320px -128px}.emoji-1f954{background-position:-320px -192px}.emoji-1f955{background-position:-320px -256px}.emoji-1f956{background-position:0 -320px}.emoji-1f95c{background-position:-64px -320px}.emoji-1f95d{background-position:-128px -320px}.emoji-1f95e{background-position:-192px -320px}.emoji-1f965{background-position:-256px -320px}.emoji-1f966{background-position:-320px -320px}.emoji-1f968{background-position:-384px 0}.emoji-1f969{background-position:-384px -64px}.emoji-1f96c{background-position:-384px -128px}.emoji-1f96d{background-position:-384px -192px}.emoji-1f96f{background-position:-384px -256px}.emoji-1f9c0{background-position:-384px -320px}.emoji-1f9c4{background-position:0 -384px}.emoji-1f9c5{background-position:-64px -384px}.emoji-1f330{background-position:-128px -384px}.emoji-category-food_drink-2{background-image:url(" + __webpack_require__(512) + ")}.emoji-1f9c8{background-position:0 0}.emoji-1f32e{background-position:-64px 0}.emoji-1f32f{background-position:0 -64px}.emoji-1f355{background-position:-64px -64px}.emoji-1f358{background-position:-128px 0}.emoji-1f359{background-position:-128px -64px}.emoji-1f35a{background-position:0 -128px}.emoji-1f35b{background-position:-64px -128px}.emoji-1f35c{background-position:-128px -128px}.emoji-1f35d{background-position:-192px 0}.emoji-1f360{background-position:-192px -64px}.emoji-1f361{background-position:-192px -128px}.emoji-1f362{background-position:0 -192px}.emoji-1f363{background-position:-64px -192px}.emoji-1f364{background-position:-128px -192px}.emoji-1f365{background-position:-192px -192px}.emoji-1f366{background-position:-256px 0}.emoji-1f367{background-position:-256px -64px}.emoji-1f368{background-position:-256px -128px}.emoji-1f369{background-position:-256px -192px}.emoji-1f36a{background-position:0 -256px}.emoji-1f371{background-position:-64px -256px}.emoji-1f372{background-position:-128px -256px}.emoji-1f373{background-position:-192px -256px}.emoji-1f37f{background-position:-256px -256px}.emoji-1f382{background-position:-320px 0}.emoji-1f957{background-position:-320px -64px}.emoji-1f958{background-position:-320px -128px}.emoji-1f959{background-position:-320px -192px}.emoji-1f95a{background-position:-320px -256px}.emoji-1f95f{background-position:0 -320px}.emoji-1f960{background-position:-64px -320px}.emoji-1f961{background-position:-128px -320px}.emoji-1f963{background-position:-192px -320px}.emoji-1f96a{background-position:-256px -320px}.emoji-1f96b{background-position:-320px -320px}.emoji-1f96e{background-position:-384px 0}.emoji-1f980{background-position:-384px -64px}.emoji-1f990{background-position:-384px -128px}.emoji-1f991{background-position:-384px -192px}.emoji-1f99e{background-position:-384px -256px}.emoji-1f9aa{background-position:-384px -320px}.emoji-1f9c2{background-position:0 -384px}.emoji-1f9c6{background-position:-64px -384px}.emoji-1f32d{background-position:-128px -384px}.emoji-category-food_drink-3{background-image:url(" + __webpack_require__(513) + ")}.emoji-2615{background-position:0 0}.emoji-1f36c{background-position:-64px 0}.emoji-1f36d{background-position:0 -64px}.emoji-1f36e{background-position:-64px -64px}.emoji-1f36f{background-position:-128px 0}.emoji-1f370{background-position:-128px -64px}.emoji-1f374{background-position:0 -128px}.emoji-1f375{background-position:-64px -128px}.emoji-1f376{background-position:-128px -128px}.emoji-1f377{background-position:-192px 0}.emoji-1f378{background-position:-192px -64px}.emoji-1f379{background-position:-192px -128px}.emoji-1f37a{background-position:0 -192px}.emoji-1f37b{background-position:-64px -192px}.emoji-1f37c{background-position:-128px -192px}.emoji-1f37d-fe0f{background-position:-192px -192px}.emoji-1f37e{background-position:-256px 0}.emoji-1f3fa{background-position:-256px -64px}.emoji-1f52a{background-position:-256px -128px}.emoji-1f942{background-position:-256px -192px}.emoji-1f943{background-position:0 -256px}.emoji-1f944{background-position:-64px -256px}.emoji-1f95b{background-position:-128px -256px}.emoji-1f962{background-position:-192px -256px}.emoji-1f964{background-position:-256px -256px}.emoji-1f967{background-position:-320px 0}.emoji-1f9c1{background-position:-320px -64px}.emoji-1f9c3{background-position:-320px -128px}.emoji-1f9c9{background-position:-320px -192px}.emoji-1f9ca{background-position:-320px -256px}.emoji-1f36b{background-position:0 -320px}.emoji-category-travel_places-1{background-image:url(" + __webpack_require__(514) + ")}.emoji-26f0{background-position:0 0}.emoji-1f30d{background-position:-64px 0}.emoji-1f30e{background-position:0 -64px}.emoji-1f30f{background-position:-64px -64px}.emoji-1f310{background-position:-128px 0}.emoji-1f3d4{background-position:-128px -64px}.emoji-1f3d5{background-position:0 -128px}.emoji-1f3d6{background-position:-64px -128px}.emoji-1f3d7,.emoji-1f3d7-fe0f{background-position:-128px -128px}.emoji-1f3d8{background-position:-192px 0}.emoji-1f3da{background-position:-192px -64px}.emoji-1f3db{background-position:-192px -128px}.emoji-1f3dc{background-position:0 -192px}.emoji-1f3dd{background-position:-64px -192px}.emoji-1f3de{background-position:-128px -192px}.emoji-1f3df{background-position:-192px -192px}.emoji-1f3e0{background-position:-256px 0}.emoji-1f3e1{background-position:-256px -64px}.emoji-1f3e2{background-position:-256px -128px}.emoji-1f3e3{background-position:-256px -192px}.emoji-1f3e4{background-position:0 -256px}.emoji-1f3e5{background-position:-64px -256px}.emoji-1f3e6{background-position:-128px -256px}.emoji-1f3e8{background-position:-192px -256px}.emoji-1f3e9{background-position:-256px -256px}.emoji-1f3ea{background-position:-320px 0}.emoji-1f3eb{background-position:-320px -64px}.emoji-1f3ec{background-position:-320px -128px}.emoji-1f3ed{background-position:-320px -192px}.emoji-1f3ef{background-position:-320px -256px}.emoji-1f3f0{background-position:0 -320px}.emoji-1f492{background-position:-64px -320px}.emoji-1f54c{background-position:-128px -320px}.emoji-1f54d{background-position:-192px -320px}.emoji-1f5fa{background-position:-256px -320px}.emoji-1f5fb{background-position:-320px -320px}.emoji-1f5fc{background-position:-384px 0}.emoji-1f5fd{background-position:-384px -64px}.emoji-1f5fe{background-position:-384px -128px}.emoji-1f6d5{background-position:-384px -192px}.emoji-1f9ed{background-position:-384px -256px}.emoji-1f9f1{background-position:-384px -320px}.emoji-26e9{background-position:0 -384px}.emoji-26ea{background-position:-64px -384px}.emoji-1f30b{background-position:-128px -384px}.emoji-category-travel_places-2{background-image:url(" + __webpack_require__(515) + ")}.emoji-26fa{background-position:0 0}.emoji-1f303{background-position:-64px 0}.emoji-1f304{background-position:0 -64px}.emoji-1f305{background-position:-64px -64px}.emoji-1f306{background-position:-128px 0}.emoji-1f307{background-position:-128px -64px}.emoji-1f309{background-position:0 -128px}.emoji-1f3a0{background-position:-64px -128px}.emoji-1f3a1{background-position:-128px -128px}.emoji-1f3a2{background-position:-192px 0}.emoji-1f3aa{background-position:-192px -64px}.emoji-1f3d9-fe0f{background-position:-192px -128px}.emoji-1f488{background-position:0 -192px}.emoji-1f54b{background-position:-64px -192px}.emoji-1f682{background-position:-128px -192px}.emoji-1f683{background-position:-192px -192px}.emoji-1f684{background-position:-256px 0}.emoji-1f685{background-position:-256px -64px}.emoji-1f686{background-position:-256px -128px}.emoji-1f687{background-position:-256px -192px}.emoji-1f688{background-position:0 -256px}.emoji-1f689{background-position:-64px -256px}.emoji-1f68a{background-position:-128px -256px}.emoji-1f68b{background-position:-192px -256px}.emoji-1f68c{background-position:-256px -256px}.emoji-1f68d{background-position:-320px 0}.emoji-1f68e{background-position:-320px -64px}.emoji-1f690{background-position:-320px -128px}.emoji-1f691{background-position:-320px -192px}.emoji-1f692{background-position:-320px -256px}.emoji-1f693{background-position:0 -320px}.emoji-1f694{background-position:-64px -320px}.emoji-1f695{background-position:-128px -320px}.emoji-1f696{background-position:-192px -320px}.emoji-1f697{background-position:-256px -320px}.emoji-1f698{background-position:-320px -320px}.emoji-1f699{background-position:-384px 0}.emoji-1f69a{background-position:-384px -64px}.emoji-1f69b{background-position:-384px -128px}.emoji-1f69c{background-position:-384px -192px}.emoji-1f69d{background-position:-384px -256px}.emoji-1f69e{background-position:-384px -320px}.emoji-2668-fe0f{background-position:0 -384px}.emoji-26f2{background-position:-64px -384px}.emoji-1f301{background-position:-128px -384px}.emoji-category-travel_places-3{background-image:url(" + __webpack_require__(516) + ")}.emoji-2708-fe0f{background-position:0 0}.emoji-1f3ce-fe0f{background-position:-64px 0}.emoji-1f4ba{background-position:0 -64px}.emoji-1f680{background-position:-64px -64px}.emoji-1f681{background-position:-128px 0}.emoji-1f68f{background-position:-128px -64px}.emoji-1f69f{background-position:0 -128px}.emoji-1f6a0{background-position:-64px -128px}.emoji-1f6a1{background-position:-128px -128px}.emoji-1f6a2{background-position:-192px 0}.emoji-1f6a4{background-position:-192px -64px}.emoji-1f6a5{background-position:-192px -128px}.emoji-1f6a6{background-position:0 -192px}.emoji-1f6a7{background-position:-64px -192px}.emoji-1f6a8{background-position:-128px -192px}.emoji-1f6b2{background-position:-192px -192px}.emoji-1f6ce{background-position:-256px 0}.emoji-1f6d1{background-position:-256px -64px}.emoji-1f6e2{background-position:-256px -128px}.emoji-1f6e3{background-position:-256px -192px}.emoji-1f6e4{background-position:0 -256px}.emoji-1f6e5{background-position:-64px -256px}.emoji-1f6e9{background-position:-128px -256px}.emoji-1f6eb{background-position:-192px -256px}.emoji-1f6ec{background-position:-256px -256px}.emoji-1f6f0{background-position:-320px 0}.emoji-1f6f3{background-position:-320px -64px}.emoji-1f6f4{background-position:-320px -128px}.emoji-1f6f5{background-position:-320px -192px}.emoji-1f6f6{background-position:-320px -256px}.emoji-1f6f8{background-position:0 -320px}.emoji-1f6f9{background-position:-64px -320px}.emoji-1f6fa{background-position:-128px -320px}.emoji-1f9bc{background-position:-192px -320px}.emoji-1f9bd{background-position:-256px -320px}.emoji-1f9f3{background-position:-320px -320px}.emoji-1fa82{background-position:-384px 0}.emoji-231a{background-position:-384px -64px}.emoji-231b{background-position:-384px -128px}.emoji-23f3{background-position:-384px -192px}.emoji-2693{background-position:-384px -256px}.emoji-26f4{background-position:-384px -320px}.emoji-26f5{background-position:0 -384px}.emoji-26fd{background-position:-64px -384px}.emoji-1f3cd{background-position:-128px -384px}.emoji-category-travel_places-4{background-image:url(" + __webpack_require__(517) + ")}.emoji-2600-fe0f{background-position:0 0}.emoji-1f312{background-position:-64px 0}.emoji-1f313{background-position:0 -64px}.emoji-1f314{background-position:-64px -64px}.emoji-1f315{background-position:-128px 0}.emoji-1f316{background-position:-128px -64px}.emoji-1f317{background-position:0 -128px}.emoji-1f318{background-position:-64px -128px}.emoji-1f319{background-position:-128px -128px}.emoji-1f31a{background-position:-192px 0}.emoji-1f31b{background-position:-192px -64px}.emoji-1f31c{background-position:-192px -128px}.emoji-1f31d{background-position:0 -192px}.emoji-1f31e{background-position:-64px -192px}.emoji-1f321{background-position:-128px -192px}.emoji-1f550{background-position:-192px -192px}.emoji-1f551{background-position:-256px 0}.emoji-1f552{background-position:-256px -64px}.emoji-1f553{background-position:-256px -128px}.emoji-1f554{background-position:-256px -192px}.emoji-1f555{background-position:0 -256px}.emoji-1f556{background-position:-64px -256px}.emoji-1f557{background-position:-128px -256px}.emoji-1f558{background-position:-192px -256px}.emoji-1f559{background-position:-256px -256px}.emoji-1f55a{background-position:-320px 0}.emoji-1f55b{background-position:-320px -64px}.emoji-1f55c{background-position:-320px -128px}.emoji-1f55d{background-position:-320px -192px}.emoji-1f55e{background-position:-320px -256px}.emoji-1f55f{background-position:0 -320px}.emoji-1f560{background-position:-64px -320px}.emoji-1f561{background-position:-128px -320px}.emoji-1f562{background-position:-192px -320px}.emoji-1f563{background-position:-256px -320px}.emoji-1f564{background-position:-320px -320px}.emoji-1f565{background-position:-384px 0}.emoji-1f566{background-position:-384px -64px}.emoji-1f567{background-position:-384px -128px}.emoji-1f570{background-position:-384px -192px}.emoji-1fa90{background-position:-384px -256px}.emoji-23f0{background-position:-384px -320px}.emoji-23f1{background-position:0 -384px}.emoji-23f2{background-position:-64px -384px}.emoji-1f311{background-position:-128px -384px}.emoji-category-travel_places-5{background-image:url(" + __webpack_require__(518) + ")}.emoji-2b50{background-position:0 0}.emoji-1f302{background-position:-64px 0}.emoji-1f308{background-position:0 -64px}.emoji-1f30a{background-position:-64px -64px}.emoji-1f30c{background-position:-128px 0}.emoji-1f31f{background-position:-128px -64px}.emoji-1f320{background-position:0 -128px}.emoji-1f324{background-position:-64px -128px}.emoji-1f325{background-position:-128px -128px}.emoji-1f326{background-position:-192px 0}.emoji-1f327{background-position:-192px -64px}.emoji-1f328{background-position:-192px -128px}.emoji-1f329{background-position:0 -192px}.emoji-1f32a{background-position:-64px -192px}.emoji-1f32b{background-position:-128px -192px}.emoji-1f32c{background-position:-192px -192px}.emoji-1f4a7{background-position:-256px 0}.emoji-1f525{background-position:-256px -64px}.emoji-2601-fe0f{background-position:-256px -128px}.emoji-2602-fe0f{background-position:-256px -192px}.emoji-2603-fe0f{background-position:0 -256px}.emoji-2604-fe0f{background-position:-64px -256px}.emoji-2614{background-position:-128px -256px}.emoji-26a1{background-position:-192px -256px}.emoji-26c4{background-position:-256px -256px}.emoji-26c5{background-position:-320px 0}.emoji-26c8{background-position:-320px -64px}.emoji-26f1{background-position:-320px -128px}.emoji-2744-fe0f{background-position:-320px -192px}.emoji-1f300{background-position:-320px -256px}.emoji-category-activities-1{background-image:url(" + __webpack_require__(519) + ")}.emoji-2728{background-position:0 0}.emoji-1f381{background-position:-64px 0}.emoji-1f383{background-position:0 -64px}.emoji-1f384{background-position:-64px -64px}.emoji-1f386{background-position:-128px 0}.emoji-1f387{background-position:-128px -64px}.emoji-1f388{background-position:0 -128px}.emoji-1f389{background-position:-64px -128px}.emoji-1f38a{background-position:-128px -128px}.emoji-1f38b{background-position:-192px 0}.emoji-1f38d{background-position:-192px -64px}.emoji-1f38e{background-position:-192px -128px}.emoji-1f38f{background-position:0 -192px}.emoji-1f390{background-position:-64px -192px}.emoji-1f391{background-position:-128px -192px}.emoji-1f396{background-position:-192px -192px}.emoji-1f397{background-position:-256px 0}.emoji-1f39f{background-position:-256px -64px}.emoji-1f3ab{background-position:-256px -128px}.emoji-1f3b3{background-position:-256px -192px}.emoji-1f3be{background-position:0 -256px}.emoji-1f3c0{background-position:-64px -256px}.emoji-1f3c5{background-position:-128px -256px}.emoji-1f3c6{background-position:-192px -256px}.emoji-1f3c8{background-position:-256px -256px}.emoji-1f3c9{background-position:-320px 0}.emoji-1f3cf{background-position:-320px -64px}.emoji-1f3d0{background-position:-320px -128px}.emoji-1f3d1{background-position:-320px -192px}.emoji-1f3d2{background-position:-320px -256px}.emoji-1f3d3{background-position:0 -320px}.emoji-1f3f8{background-position:-64px -320px}.emoji-1f947{background-position:-128px -320px}.emoji-1f948{background-position:-192px -320px}.emoji-1f949{background-position:-256px -320px}.emoji-1f94a{background-position:-320px -320px}.emoji-1f94b{background-position:-384px 0}.emoji-1f94d{background-position:-384px -64px}.emoji-1f94e{background-position:-384px -128px}.emoji-1f94f{background-position:-384px -192px}.emoji-1f9e7{background-position:-384px -256px}.emoji-1f9e8{background-position:-384px -320px}.emoji-26bd{background-position:0 -384px}.emoji-26be{background-position:-64px -384px}.emoji-1f380{background-position:-128px -384px}.emoji-category-activities-2{background-image:url(" + __webpack_require__(520) + ")}.emoji-26f8{background-position:0 0}.emoji-1f0cf{background-position:-64px 0}.emoji-1f3a3{background-position:0 -64px}.emoji-1f3a8{background-position:-64px -64px}.emoji-1f3ad{background-position:-128px 0}.emoji-1f3ae{background-position:-128px -64px}.emoji-1f3af{background-position:0 -128px}.emoji-1f3b0{background-position:-64px -128px}.emoji-1f3b1{background-position:-128px -128px}.emoji-1f3b2{background-position:-192px 0}.emoji-1f3b4{background-position:-192px -64px}.emoji-1f3bd{background-position:-192px -128px}.emoji-1f3bf{background-position:0 -192px}.emoji-1f52e{background-position:-64px -192px}.emoji-1f579{background-position:-128px -192px}.emoji-1f5bc{background-position:-192px -192px}.emoji-1f6f7{background-position:-256px 0}.emoji-1f93f{background-position:-256px -64px}.emoji-1f945{background-position:-256px -128px}.emoji-1f94c{background-position:-256px -192px}.emoji-1f9e9{background-position:0 -256px}.emoji-1f9f5{background-position:-64px -256px}.emoji-1f9f6{background-position:-128px -256px}.emoji-1f9f8{background-position:-192px -256px}.emoji-1f9ff{background-position:-256px -256px}.emoji-1fa80{background-position:-320px 0}.emoji-1fa81{background-position:-320px -64px}.emoji-265f{background-position:-320px -128px}.emoji-2660-fe0f{background-position:-320px -192px}.emoji-2663-fe0f{background-position:-320px -256px}.emoji-2665-fe0f{background-position:0 -320px}.emoji-2666-fe0f{background-position:-64px -320px}.emoji-26f3{background-position:-128px -320px}.emoji-1f004{background-position:-192px -320px}.emoji-category-objects-1{background-image:url(" + __webpack_require__(521) + ")}.emoji-26d1{background-position:0 0}.emoji-1f393{background-position:-64px 0}.emoji-1f3a9{background-position:0 -64px}.emoji-1f451{background-position:-64px -64px}.emoji-1f452{background-position:-128px 0}.emoji-1f453{background-position:-128px -64px}.emoji-1f454{background-position:0 -128px}.emoji-1f455{background-position:-64px -128px}.emoji-1f456{background-position:-128px -128px}.emoji-1f457{background-position:-192px 0}.emoji-1f458{background-position:-192px -64px}.emoji-1f459{background-position:-192px -128px}.emoji-1f45a{background-position:0 -192px}.emoji-1f45b{background-position:-64px -192px}.emoji-1f45c{background-position:-128px -192px}.emoji-1f45d{background-position:-192px -192px}.emoji-1f45e{background-position:-256px 0}.emoji-1f45f{background-position:-256px -64px}.emoji-1f460{background-position:-256px -128px}.emoji-1f461{background-position:-256px -192px}.emoji-1f462{background-position:0 -256px}.emoji-1f484{background-position:-64px -256px}.emoji-1f48d{background-position:-128px -256px}.emoji-1f48e{background-position:-192px -256px}.emoji-1f4ff{background-position:-256px -256px}.emoji-1f507{background-position:-320px 0}.emoji-1f508{background-position:-320px -64px}.emoji-1f576{background-position:-320px -128px}.emoji-1f6cd{background-position:-320px -192px}.emoji-1f97b{background-position:-320px -256px}.emoji-1f97c{background-position:0 -320px}.emoji-1f97d{background-position:-64px -320px}.emoji-1f97e{background-position:-128px -320px}.emoji-1f97f{background-position:-192px -320px}.emoji-1f9ba{background-position:-256px -320px}.emoji-1f9e2{background-position:-320px -320px}.emoji-1f9e3{background-position:-384px 0}.emoji-1f9e4{background-position:-384px -64px}.emoji-1f9e5{background-position:-384px -128px}.emoji-1f9e6{background-position:-384px -192px}.emoji-1fa70{background-position:-384px -256px}.emoji-1fa71{background-position:-384px -320px}.emoji-1fa72{background-position:0 -384px}.emoji-1fa73{background-position:-64px -384px}.emoji-1f392{background-position:-128px -384px}.emoji-category-objects-2{background-image:url(" + __webpack_require__(522) + ")}.emoji-260e-fe0f{background-position:0 0}.emoji-1f39a{background-position:-64px 0}.emoji-1f39b{background-position:0 -64px}.emoji-1f39e{background-position:-64px -64px}.emoji-1f3a4{background-position:-128px 0}.emoji-1f3a5{background-position:-128px -64px}.emoji-1f3a7{background-position:0 -128px}.emoji-1f3b5{background-position:-64px -128px}.emoji-1f3b6{background-position:-128px -128px}.emoji-1f3b7{background-position:-192px 0}.emoji-1f3b8{background-position:-192px -64px}.emoji-1f3b9{background-position:-192px -128px}.emoji-1f3ba{background-position:0 -192px}.emoji-1f3bb{background-position:-64px -192px}.emoji-1f3bc{background-position:-128px -192px}.emoji-1f4bb{background-position:-192px -192px}.emoji-1f4bd{background-position:-256px 0}.emoji-1f4be{background-position:-256px -64px}.emoji-1f4bf{background-position:-256px -128px}.emoji-1f4c0{background-position:-256px -192px}.emoji-1f4de{background-position:0 -256px}.emoji-1f4df{background-position:-64px -256px}.emoji-1f4e0{background-position:-128px -256px}.emoji-1f4e2{background-position:-192px -256px}.emoji-1f4e3{background-position:-256px -256px}.emoji-1f4ef{background-position:-320px 0}.emoji-1f4f1{background-position:-320px -64px}.emoji-1f4f2{background-position:-320px -128px}.emoji-1f4fb{background-position:-320px -192px}.emoji-1f4fd{background-position:-320px -256px}.emoji-1f509{background-position:0 -320px}.emoji-1f50a{background-position:-64px -320px}.emoji-1f50b{background-position:-128px -320px}.emoji-1f50c{background-position:-192px -320px}.emoji-1f514{background-position:-256px -320px}.emoji-1f515{background-position:-320px -320px}.emoji-1f5a5{background-position:-384px 0}.emoji-1f5a8{background-position:-384px -64px}.emoji-1f5b1{background-position:-384px -128px}.emoji-1f5b2{background-position:-384px -192px}.emoji-1f941{background-position:-384px -256px}.emoji-1f9ee{background-position:-384px -320px}.emoji-1fa95{background-position:0 -384px}.emoji-2328-fe0f{background-position:-64px -384px}.emoji-1f399{background-position:-128px -384px}.emoji-category-objects-3{background-image:url(" + __webpack_require__(523) + ")}.emoji-2709-fe0f{background-position:0 0}.emoji-1f3ee{background-position:-64px 0}.emoji-1f3f7{background-position:0 -64px}.emoji-1f4a1{background-position:-64px -64px}.emoji-1f4b0{background-position:-128px 0}.emoji-1f4b1{background-position:-128px -64px}.emoji-1f4b2{background-position:0 -128px}.emoji-1f4b3{background-position:-64px -128px}.emoji-1f4b4{background-position:-128px -128px}.emoji-1f4b5{background-position:-192px 0}.emoji-1f4b6{background-position:-192px -64px}.emoji-1f4b7{background-position:-192px -128px}.emoji-1f4b8{background-position:0 -192px}.emoji-1f4b9{background-position:-64px -192px}.emoji-1f4c3{background-position:-128px -192px}.emoji-1f4c4{background-position:-192px -192px}.emoji-1f4d1{background-position:-256px 0}.emoji-1f4d2{background-position:-256px -64px}.emoji-1f4d3{background-position:-256px -128px}.emoji-1f4d4{background-position:-256px -192px}.emoji-1f4d5{background-position:0 -256px}.emoji-1f4d6{background-position:-64px -256px}.emoji-1f4d7{background-position:-128px -256px}.emoji-1f4d8{background-position:-192px -256px}.emoji-1f4d9{background-position:-256px -256px}.emoji-1f4da{background-position:-320px 0}.emoji-1f4dc{background-position:-320px -64px}.emoji-1f4e7{background-position:-320px -128px}.emoji-1f4e8{background-position:-320px -192px}.emoji-1f4e9{background-position:-320px -256px}.emoji-1f4f0{background-position:0 -320px}.emoji-1f4f7{background-position:-64px -320px}.emoji-1f4f8{background-position:-128px -320px}.emoji-1f4f9{background-position:-192px -320px}.emoji-1f4fa{background-position:-256px -320px}.emoji-1f4fc{background-position:-320px -320px}.emoji-1f50d{background-position:-384px 0}.emoji-1f50e{background-position:-384px -64px}.emoji-1f516{background-position:-384px -128px}.emoji-1f526{background-position:-384px -192px}.emoji-1f56f{background-position:-384px -256px}.emoji-1f5de{background-position:-384px -320px}.emoji-1f9fe{background-position:0 -384px}.emoji-1fa94{background-position:-64px -384px}.emoji-1f3ac{background-position:-128px -384px}.emoji-category-objects-4{background-image:url(" + __webpack_require__(524) + ")}.emoji-2712-fe0f{background-position:0 0}.emoji-1f4c1{background-position:-64px 0}.emoji-1f4c2{background-position:0 -64px}.emoji-1f4c5{background-position:-64px -64px}.emoji-1f4c6{background-position:-128px 0}.emoji-1f4c7{background-position:-128px -64px}.emoji-1f4c8{background-position:0 -128px}.emoji-1f4c9{background-position:-64px -128px}.emoji-1f4ca{background-position:-128px -128px}.emoji-1f4cb{background-position:-192px 0}.emoji-1f4cc{background-position:-192px -64px}.emoji-1f4cd{background-position:-192px -128px}.emoji-1f4ce{background-position:0 -192px}.emoji-1f4cf{background-position:-64px -192px}.emoji-1f4d0{background-position:-128px -192px}.emoji-1f4dd{background-position:-192px -192px}.emoji-1f4e4{background-position:-256px 0}.emoji-1f4e5{background-position:-256px -64px}.emoji-1f4e6{background-position:-256px -128px}.emoji-1f4ea{background-position:-256px -192px}.emoji-1f4eb{background-position:0 -256px}.emoji-1f4ec{background-position:-64px -256px}.emoji-1f4ed{background-position:-128px -256px}.emoji-1f4ee{background-position:-192px -256px}.emoji-1f50f{background-position:-256px -256px}.emoji-1f510{background-position:-320px 0}.emoji-1f511{background-position:-320px -64px}.emoji-1f512{background-position:-320px -128px}.emoji-1f513{background-position:-320px -192px}.emoji-1f587{background-position:-320px -256px}.emoji-1f58a{background-position:0 -320px}.emoji-1f58b{background-position:-64px -320px}.emoji-1f58c{background-position:-128px -320px}.emoji-1f58d{background-position:-192px -320px}.emoji-1f5c2{background-position:-256px -320px}.emoji-1f5c3{background-position:-320px -320px}.emoji-1f5c4{background-position:-384px 0}.emoji-1f5d1{background-position:-384px -64px}.emoji-1f5d2{background-position:-384px -128px}.emoji-1f5d3{background-position:-384px -192px}.emoji-1f5dd{background-position:-384px -256px}.emoji-1f5f3{background-position:-384px -320px}.emoji-2702-fe0f{background-position:0 -384px}.emoji-270f-fe0f{background-position:-64px -384px}.emoji-1f4bc{background-position:-128px -384px}.emoji-category-objects-5{background-image:url(" + __webpack_require__(525) + ")}.emoji-26d3{background-position:0 0}.emoji-1f489{background-position:-64px 0}.emoji-1f48a{background-position:0 -64px}.emoji-1f4e1{background-position:-64px -64px}.emoji-1f517{background-position:-128px 0}.emoji-1f527{background-position:-128px -64px}.emoji-1f528{background-position:0 -128px}.emoji-1f529{background-position:-64px -128px}.emoji-1f52b{background-position:-128px -128px}.emoji-1f52c{background-position:-192px 0}.emoji-1f52d{background-position:-192px -64px}.emoji-1f5dc{background-position:-192px -128px}.emoji-1f5e1{background-position:0 -192px}.emoji-1f6aa{background-position:-64px -192px}.emoji-1f6bd{background-position:-128px -192px}.emoji-1f6bf{background-position:-192px -192px}.emoji-1f6c1{background-position:-256px 0}.emoji-1f6cb{background-position:-256px -64px}.emoji-1f6cf{background-position:-256px -128px}.emoji-1f6e0{background-position:-256px -192px}.emoji-1f6e1{background-position:0 -256px}.emoji-1f9af{background-position:-64px -256px}.emoji-1f9ea{background-position:-128px -256px}.emoji-1f9eb{background-position:-192px -256px}.emoji-1f9ec{background-position:-256px -256px}.emoji-1f9f0{background-position:-320px 0}.emoji-1f9f2{background-position:-320px -64px}.emoji-1f9f4{background-position:-320px -128px}.emoji-1f9f7{background-position:-320px -192px}.emoji-1f9f9{background-position:-320px -256px}.emoji-1f9fa{background-position:0 -320px}.emoji-1f9fb{background-position:-64px -320px}.emoji-1fa78{background-position:-128px -320px}.emoji-1fa79{background-position:-192px -320px}.emoji-1fa7a{background-position:-256px -320px}.emoji-1fa91{background-position:-320px -320px}.emoji-1fa92{background-position:-384px 0}.emoji-1fa93{background-position:-384px -64px}.emoji-2692{background-position:-384px -128px}.emoji-2694-fe0f{background-position:-384px -192px}.emoji-2696-fe0f{background-position:-384px -256px}.emoji-2697-fe0f{background-position:-384px -320px}.emoji-2699-fe0f{background-position:0 -384px}.emoji-26cf{background-position:-64px -384px}.emoji-1f3f9{background-position:-128px -384px}.emoji-category-objects-6{background-image:url(" + __webpack_require__(526) + ")}.emoji-26b1-fe0f{background-position:0 0}.emoji-1f6ac{background-position:-64px 0}.emoji-1f6d2{background-position:0 -64px}.emoji-1f9ef{background-position:-64px -64px}.emoji-1f9fc{background-position:-128px 0}.emoji-1f9fd{background-position:-128px -64px}.emoji-26b0-fe0f{background-position:0 -128px}.emoji-1f5ff{background-position:-64px -128px}.emoji-category-symbols-1{background-image:url(" + __webpack_require__(527) + ")}.emoji-2b07-fe0f{background-position:0 0}.emoji-1f4f5{background-position:-64px 0}.emoji-1f503{background-position:0 -64px}.emoji-1f504{background-position:-64px -64px}.emoji-1f519{background-position:-128px 0}.emoji-1f51a{background-position:-128px -64px}.emoji-1f51b{background-position:0 -128px}.emoji-1f51e{background-position:-64px -128px}.emoji-1f6ab{background-position:-128px -128px}.emoji-1f6ad{background-position:-192px 0}.emoji-1f6ae{background-position:-192px -64px}.emoji-1f6af{background-position:-192px -128px}.emoji-1f6b0{background-position:0 -192px}.emoji-1f6b1{background-position:-64px -192px}.emoji-1f6b3{background-position:-128px -192px}.emoji-1f6b7{background-position:-192px -192px}.emoji-1f6b8{background-position:-256px 0}.emoji-1f6b9{background-position:-256px -64px}.emoji-1f6ba{background-position:-256px -128px}.emoji-1f6bb{background-position:-256px -192px}.emoji-1f6bc{background-position:0 -256px}.emoji-1f6be{background-position:-64px -256px}.emoji-1f6c2{background-position:-128px -256px}.emoji-1f6c3{background-position:-192px -256px}.emoji-1f6c4{background-position:-256px -256px}.emoji-1f6c5{background-position:-320px 0}.emoji-2194-fe0f{background-position:-320px -64px}.emoji-2195-fe0f{background-position:-320px -128px}.emoji-2196-fe0f{background-position:-320px -192px}.emoji-2197-fe0f{background-position:-320px -256px}.emoji-2198-fe0f{background-position:0 -320px}.emoji-2199-fe0f{background-position:-64px -320px}.emoji-21a9-fe0f{background-position:-128px -320px}.emoji-21aa-fe0f{background-position:-192px -320px}.emoji-2622-fe0f{background-position:-256px -320px}.emoji-2623-fe0f{background-position:-320px -320px}.emoji-267f{background-position:-384px 0}.emoji-26a0-fe0f{background-position:-384px -64px}.emoji-26d4{background-position:-384px -128px}.emoji-27a1-fe0f{background-position:-384px -192px}.emoji-2934-fe0f{background-position:-384px -256px}.emoji-2935-fe0f{background-position:-384px -320px}.emoji-2b05-fe0f{background-position:0 -384px}.emoji-2b06-fe0f{background-position:-64px -384px}.emoji-1f3e7{background-position:-128px -384px}.emoji-category-symbols-2{background-image:url(" + __webpack_require__(528) + ")}.emoji-2721-fe0f{background-position:0 0}.emoji-1f501{background-position:-64px 0}.emoji-1f502{background-position:0 -64px}.emoji-1f51c{background-position:-64px -64px}.emoji-1f51d{background-position:-128px 0}.emoji-1f52f{background-position:-128px -64px}.emoji-1f53c{background-position:0 -128px}.emoji-1f53d{background-position:-64px -128px}.emoji-1f549{background-position:-128px -128px}.emoji-1f54e{background-position:-192px 0}.emoji-1f6d0{background-position:-192px -64px}.emoji-23cf{background-position:-192px -128px}.emoji-23e9{background-position:0 -192px}.emoji-23ea{background-position:-64px -192px}.emoji-23eb{background-position:-128px -192px}.emoji-23ec{background-position:-192px -192px}.emoji-23ed{background-position:-256px 0}.emoji-23ee{background-position:-256px -64px}.emoji-23ef-fe0f{background-position:-256px -128px}.emoji-23f8{background-position:-256px -192px}.emoji-23f9{background-position:0 -256px}.emoji-23fa{background-position:-64px -256px}.emoji-25b6-fe0f{background-position:-128px -256px}.emoji-25c0-fe0f{background-position:-192px -256px}.emoji-2626-fe0f{background-position:-256px -256px}.emoji-262a-fe0f{background-position:-320px 0}.emoji-262e-fe0f{background-position:-320px -64px}.emoji-262f-fe0f{background-position:-320px -128px}.emoji-2638-fe0f{background-position:-320px -192px}.emoji-2648{background-position:-320px -256px}.emoji-2649{background-position:0 -320px}.emoji-264a{background-position:-64px -320px}.emoji-264b{background-position:-128px -320px}.emoji-264c{background-position:-192px -320px}.emoji-264d{background-position:-256px -320px}.emoji-264e{background-position:-320px -320px}.emoji-264f{background-position:-384px 0}.emoji-2650{background-position:-384px -64px}.emoji-2651{background-position:-384px -128px}.emoji-2652{background-position:-384px -192px}.emoji-2653{background-position:-384px -256px}.emoji-269b-fe0f{background-position:-384px -320px}.emoji-26ce{background-position:0 -384px}.emoji-271d-fe0f{background-position:-64px -384px}.emoji-1f500{background-position:-128px -384px}.emoji-category-symbols-3{background-image:url(" + __webpack_require__(529) + ")}.emoji-303d-fe0f{background-position:0 0}.emoji-002a-fe0f-20e3{background-position:-64px 0}.emoji-0030-fe0f-20e3{background-position:0 -64px}.emoji-0031-fe0f-20e3{background-position:-64px -64px}.emoji-00a9-fe0f{background-position:-128px 0}.emoji-00ae-fe0f{background-position:-128px -64px}.emoji-1f3a6{background-position:0 -128px}.emoji-1f4db{background-position:-64px -128px}.emoji-1f4f3{background-position:-128px -128px}.emoji-1f4f4{background-position:-192px 0}.emoji-1f4f6{background-position:-192px -64px}.emoji-1f505{background-position:-192px -128px}.emoji-1f506{background-position:0 -192px}.emoji-1f530{background-position:-64px -192px}.emoji-1f531{background-position:-128px -192px}.emoji-203c-fe0f{background-position:-192px -192px}.emoji-2049-fe0f{background-position:-256px 0}.emoji-2122-fe0f{background-position:-256px -64px}.emoji-2611-fe0f{background-position:-256px -128px}.emoji-2640{background-position:-256px -192px}.emoji-2642{background-position:0 -256px}.emoji-267b-fe0f{background-position:-64px -256px}.emoji-267e{background-position:-128px -256px}.emoji-2695{background-position:-192px -256px}.emoji-269c-fe0f{background-position:-256px -256px}.emoji-2705{background-position:-320px 0}.emoji-2714-fe0f{background-position:-320px -64px}.emoji-2716-fe0f{background-position:-320px -128px}.emoji-2733-fe0f{background-position:-320px -192px}.emoji-2734-fe0f{background-position:-320px -256px}.emoji-2747-fe0f{background-position:0 -320px}.emoji-274c{background-position:-64px -320px}.emoji-274e{background-position:-128px -320px}.emoji-2753{background-position:-192px -320px}.emoji-2754{background-position:-256px -320px}.emoji-2755{background-position:-320px -320px}.emoji-2757{background-position:-384px 0}.emoji-2795{background-position:-384px -64px}.emoji-2796{background-position:-384px -128px}.emoji-2797{background-position:-384px -192px}.emoji-27b0{background-position:-384px -256px}.emoji-27bf{background-position:-384px -320px}.emoji-2b55{background-position:0 -384px}.emoji-3030-fe0f{background-position:-64px -384px}.emoji-0023-fe0f-20e3{background-position:-128px -384px}.emoji-category-symbols-4{background-image:url(" + __webpack_require__(530) + ")}.emoji-3297-fe0f{background-position:0 0}.emoji-0033-fe0f-20e3{background-position:-64px 0}.emoji-0034-fe0f-20e3{background-position:0 -64px}.emoji-0035-fe0f-20e3{background-position:-64px -64px}.emoji-0036-fe0f-20e3{background-position:-128px 0}.emoji-0037-fe0f-20e3{background-position:-128px -64px}.emoji-0038-fe0f-20e3{background-position:0 -128px}.emoji-0039-fe0f-20e3{background-position:-64px -128px}.emoji-1f170-fe0f{background-position:-128px -128px}.emoji-1f171-fe0f{background-position:-192px 0}.emoji-1f17e-fe0f{background-position:-192px -64px}.emoji-1f17f-fe0f{background-position:-192px -128px}.emoji-1f18e{background-position:0 -192px}.emoji-1f191{background-position:-64px -192px}.emoji-1f192{background-position:-128px -192px}.emoji-1f193{background-position:-192px -192px}.emoji-1f194{background-position:-256px 0}.emoji-1f195{background-position:-256px -64px}.emoji-1f196{background-position:-256px -128px}.emoji-1f197{background-position:-256px -192px}.emoji-1f198{background-position:0 -256px}.emoji-1f199{background-position:-64px -256px}.emoji-1f19a{background-position:-128px -256px}.emoji-1f201{background-position:-192px -256px}.emoji-1f202-fe0f{background-position:-256px -256px}.emoji-1f21a{background-position:-320px 0}.emoji-1f22f{background-position:-320px -64px}.emoji-1f232{background-position:-320px -128px}.emoji-1f233{background-position:-320px -192px}.emoji-1f234{background-position:-320px -256px}.emoji-1f236{background-position:0 -320px}.emoji-1f237-fe0f{background-position:-64px -320px}.emoji-1f238{background-position:-128px -320px}.emoji-1f239{background-position:-192px -320px}.emoji-1f250{background-position:-256px -320px}.emoji-1f251{background-position:-320px -320px}.emoji-1f51f{background-position:-384px 0}.emoji-1f520{background-position:-384px -64px}.emoji-1f521{background-position:-384px -128px}.emoji-1f522{background-position:-384px -192px}.emoji-1f523{background-position:-384px -256px}.emoji-1f524{background-position:-384px -320px}.emoji-2139-fe0f{background-position:0 -384px}.emoji-24c2-fe0f{background-position:-64px -384px}.emoji-0032-fe0f-20e3{background-position:-128px -384px}.emoji-category-symbols-5{background-image:url(" + __webpack_require__(531) + ")}.emoji-3299-fe0f{background-position:0 0}.emoji-1f23a{background-position:-64px 0}.emoji-1f4a0{background-position:0 -64px}.emoji-1f518{background-position:-64px -64px}.emoji-1f532{background-position:-128px 0}.emoji-1f533{background-position:-128px -64px}.emoji-1f534{background-position:0 -128px}.emoji-1f535{background-position:-64px -128px}.emoji-1f536{background-position:-128px -128px}.emoji-1f537{background-position:-192px 0}.emoji-1f538{background-position:-192px -64px}.emoji-1f539{background-position:-192px -128px}.emoji-1f53a{background-position:0 -192px}.emoji-1f53b{background-position:-64px -192px}.emoji-1f7e0{background-position:-128px -192px}.emoji-1f7e1{background-position:-192px -192px}.emoji-1f7e2{background-position:-256px 0}.emoji-1f7e3{background-position:-256px -64px}.emoji-1f7e4{background-position:-256px -128px}.emoji-1f7e5{background-position:-256px -192px}.emoji-1f7e6{background-position:0 -256px}.emoji-1f7e7{background-position:-64px -256px}.emoji-1f7e8{background-position:-128px -256px}.emoji-1f7e9{background-position:-192px -256px}.emoji-1f7ea{background-position:-256px -256px}.emoji-1f7eb{background-position:-320px 0}.emoji-25aa-fe0f{background-position:-320px -64px}.emoji-25ab-fe0f{background-position:-320px -128px}.emoji-25fb-fe0f{background-position:-320px -192px}.emoji-25fc-fe0f{background-position:-320px -256px}.emoji-25fd{background-position:0 -320px}.emoji-25fe{background-position:-64px -320px}.emoji-26aa{background-position:-128px -320px}.emoji-26ab{background-position:-192px -320px}.emoji-2b1b{background-position:-256px -320px}.emoji-2b1c{background-position:-320px -320px}.emoji-1f235{background-position:-384px 0}.emoji-category-flags-1{background-image:url(" + __webpack_require__(532) + ")}.emoji-1f6a9{background-position:0 0}.emoji-1f1e6-1f1e9{background-position:-64px 0}.emoji-1f1e6-1f1ea{background-position:0 -64px}.emoji-1f1e6-1f1eb{background-position:-64px -64px}.emoji-1f1e6-1f1ec{background-position:-128px 0}.emoji-1f1e6-1f1ee{background-position:-128px -64px}.emoji-1f1e6-1f1f1{background-position:0 -128px}.emoji-1f1e6-1f1f2{background-position:-64px -128px}.emoji-1f1e6-1f1f4{background-position:-128px -128px}.emoji-1f1e6-1f1f6{background-position:-192px 0}.emoji-1f1e6-1f1f7{background-position:-192px -64px}.emoji-1f1e6-1f1f8{background-position:-192px -128px}.emoji-1f1e6-1f1f9{background-position:0 -192px}.emoji-1f1e6-1f1fa{background-position:-64px -192px}.emoji-1f1e6-1f1fc{background-position:-128px -192px}.emoji-1f1e6-1f1fd{background-position:-192px -192px}.emoji-1f1e6-1f1ff{background-position:-256px 0}.emoji-1f1e7-1f1e6{background-position:-256px -64px}.emoji-1f1e7-1f1e7{background-position:-256px -128px}.emoji-1f1e7-1f1e9{background-position:-256px -192px}.emoji-1f1e7-1f1ea{background-position:0 -256px}.emoji-1f1e7-1f1eb{background-position:-64px -256px}.emoji-1f1e7-1f1ec{background-position:-128px -256px}.emoji-1f1e7-1f1ed{background-position:-192px -256px}.emoji-1f1e7-1f1ee{background-position:-256px -256px}.emoji-1f1e7-1f1ef{background-position:-320px 0}.emoji-1f1e7-1f1f1{background-position:-320px -64px}.emoji-1f1e7-1f1f2{background-position:-320px -128px}.emoji-1f1e7-1f1f3{background-position:-320px -192px}.emoji-1f1e7-1f1f4{background-position:-320px -256px}.emoji-1f1e7-1f1f6{background-position:0 -320px}.emoji-1f1e7-1f1f7{background-position:-64px -320px}.emoji-1f1e7-1f1f8{background-position:-128px -320px}.emoji-1f1e7-1f1f9{background-position:-192px -320px}.emoji-1f1e7-1f1fb{background-position:-256px -320px}.emoji-1f1e7-1f1fc{background-position:-320px -320px}.emoji-1f1e7-1f1fe{background-position:-384px 0}.emoji-1f1e7-1f1ff{background-position:-384px -64px}.emoji-1f38c{background-position:-384px -128px}.emoji-1f3c1{background-position:-384px -192px}.emoji-1f3f3-fe0f{background-position:-384px -256px}.emoji-1f3f3-fe0f-200d-1f308{background-position:-384px -320px}.emoji-1f3f4{background-position:0 -384px}.emoji-1f3f4-200d-2620-fe0f{background-position:-64px -384px}.emoji-1f1e6-1f1e8{background-position:-128px -384px}.emoji-category-flags-2{background-image:url(" + __webpack_require__(533) + ")}.emoji-1f1ec-1f1e9{background-position:0 0}.emoji-1f1e8-1f1e8{background-position:-64px 0}.emoji-1f1e8-1f1e9{background-position:0 -64px}.emoji-1f1e8-1f1eb{background-position:-64px -64px}.emoji-1f1e8-1f1ec{background-position:-128px 0}.emoji-1f1e8-1f1ed{background-position:-128px -64px}.emoji-1f1e8-1f1ee{background-position:0 -128px}.emoji-1f1e8-1f1f0{background-position:-64px -128px}.emoji-1f1e8-1f1f1{background-position:-128px -128px}.emoji-1f1e8-1f1f2{background-position:-192px 0}.emoji-1f1e8-1f1f3{background-position:-192px -64px}.emoji-1f1e8-1f1f4{background-position:-192px -128px}.emoji-1f1e8-1f1f5{background-position:0 -192px}.emoji-1f1e8-1f1f7{background-position:-64px -192px}.emoji-1f1e8-1f1fa{background-position:-128px -192px}.emoji-1f1e8-1f1fb{background-position:-192px -192px}.emoji-1f1e8-1f1fc{background-position:-256px 0}.emoji-1f1e8-1f1fd{background-position:-256px -64px}.emoji-1f1e8-1f1fe{background-position:-256px -128px}.emoji-1f1e8-1f1ff{background-position:-256px -192px}.emoji-1f1e9-1f1ea{background-position:0 -256px}.emoji-1f1e9-1f1ec{background-position:-64px -256px}.emoji-1f1e9-1f1ef{background-position:-128px -256px}.emoji-1f1e9-1f1f0{background-position:-192px -256px}.emoji-1f1e9-1f1f2{background-position:-256px -256px}.emoji-1f1e9-1f1f4{background-position:-320px 0}.emoji-1f1e9-1f1ff{background-position:-320px -64px}.emoji-1f1ea-1f1e6{background-position:-320px -128px}.emoji-1f1ea-1f1e8{background-position:-320px -192px}.emoji-1f1ea-1f1ea{background-position:-320px -256px}.emoji-1f1ea-1f1ec{background-position:0 -320px}.emoji-1f1ea-1f1ed{background-position:-64px -320px}.emoji-1f1ea-1f1f7{background-position:-128px -320px}.emoji-1f1ea-1f1f8{background-position:-192px -320px}.emoji-1f1ea-1f1f9{background-position:-256px -320px}.emoji-1f1ea-1f1fa{background-position:-320px -320px}.emoji-1f1eb-1f1ee{background-position:-384px 0}.emoji-1f1eb-1f1ef{background-position:-384px -64px}.emoji-1f1eb-1f1f0{background-position:-384px -128px}.emoji-1f1eb-1f1f2{background-position:-384px -192px}.emoji-1f1eb-1f1f4{background-position:-384px -256px}.emoji-1f1eb-1f1f7{background-position:-384px -320px}.emoji-1f1ec-1f1e6{background-position:0 -384px}.emoji-1f1ec-1f1e7{background-position:-64px -384px}.emoji-1f1e8-1f1e6{background-position:-128px -384px}.emoji-category-flags-3{background-image:url(" + __webpack_require__(534) + ")}.emoji-1f1f0-1f1f7{background-position:0 0}.emoji-1f1ec-1f1eb{background-position:-64px 0}.emoji-1f1ec-1f1ec{background-position:0 -64px}.emoji-1f1ec-1f1ed{background-position:-64px -64px}.emoji-1f1ec-1f1ee{background-position:-128px 0}.emoji-1f1ec-1f1f1{background-position:-128px -64px}.emoji-1f1ec-1f1f2{background-position:0 -128px}.emoji-1f1ec-1f1f3{background-position:-64px -128px}.emoji-1f1ec-1f1f5{background-position:-128px -128px}.emoji-1f1ec-1f1f6{background-position:-192px 0}.emoji-1f1ec-1f1f7{background-position:-192px -64px}.emoji-1f1ec-1f1f8{background-position:-192px -128px}.emoji-1f1ec-1f1f9{background-position:0 -192px}.emoji-1f1ec-1f1fa{background-position:-64px -192px}.emoji-1f1ec-1f1fc{background-position:-128px -192px}.emoji-1f1ec-1f1fe{background-position:-192px -192px}.emoji-1f1ed-1f1f0{background-position:-256px 0}.emoji-1f1ed-1f1f2{background-position:-256px -64px}.emoji-1f1ed-1f1f3{background-position:-256px -128px}.emoji-1f1ed-1f1f7{background-position:-256px -192px}.emoji-1f1ed-1f1f9{background-position:0 -256px}.emoji-1f1ed-1f1fa{background-position:-64px -256px}.emoji-1f1ee-1f1e8{background-position:-128px -256px}.emoji-1f1ee-1f1e9{background-position:-192px -256px}.emoji-1f1ee-1f1ea{background-position:-256px -256px}.emoji-1f1ee-1f1f1{background-position:-320px 0}.emoji-1f1ee-1f1f2{background-position:-320px -64px}.emoji-1f1ee-1f1f3{background-position:-320px -128px}.emoji-1f1ee-1f1f4{background-position:-320px -192px}.emoji-1f1ee-1f1f6{background-position:-320px -256px}.emoji-1f1ee-1f1f7{background-position:0 -320px}.emoji-1f1ee-1f1f8{background-position:-64px -320px}.emoji-1f1ee-1f1f9{background-position:-128px -320px}.emoji-1f1ef-1f1ea{background-position:-192px -320px}.emoji-1f1ef-1f1f2{background-position:-256px -320px}.emoji-1f1ef-1f1f4{background-position:-320px -320px}.emoji-1f1ef-1f1f5{background-position:-384px 0}.emoji-1f1f0-1f1ea{background-position:-384px -64px}.emoji-1f1f0-1f1ec{background-position:-384px -128px}.emoji-1f1f0-1f1ed{background-position:-384px -192px}.emoji-1f1f0-1f1ee{background-position:-384px -256px}.emoji-1f1f0-1f1f2{background-position:-384px -320px}.emoji-1f1f0-1f1f3{background-position:0 -384px}.emoji-1f1f0-1f1f5{background-position:-64px -384px}.emoji-1f1ec-1f1ea{background-position:-128px -384px}.emoji-category-flags-4{background-image:url(" + __webpack_require__(535) + ")}.emoji-1f1f3-1f1f4{background-position:0 0}.emoji-1f1f0-1f1fe{background-position:-64px 0}.emoji-1f1f0-1f1ff{background-position:0 -64px}.emoji-1f1f1-1f1e6{background-position:-64px -64px}.emoji-1f1f1-1f1e7{background-position:-128px 0}.emoji-1f1f1-1f1e8{background-position:-128px -64px}.emoji-1f1f1-1f1ee{background-position:0 -128px}.emoji-1f1f1-1f1f0{background-position:-64px -128px}.emoji-1f1f1-1f1f7{background-position:-128px -128px}.emoji-1f1f1-1f1f8{background-position:-192px 0}.emoji-1f1f1-1f1f9{background-position:-192px -64px}.emoji-1f1f1-1f1fa{background-position:-192px -128px}.emoji-1f1f1-1f1fb{background-position:0 -192px}.emoji-1f1f1-1f1fe{background-position:-64px -192px}.emoji-1f1f2-1f1e6{background-position:-128px -192px}.emoji-1f1f2-1f1e8{background-position:-192px -192px}.emoji-1f1f2-1f1e9{background-position:-256px 0}.emoji-1f1f2-1f1ea{background-position:-256px -64px}.emoji-1f1f2-1f1eb{background-position:-256px -128px}.emoji-1f1f2-1f1ec{background-position:-256px -192px}.emoji-1f1f2-1f1ed{background-position:0 -256px}.emoji-1f1f2-1f1f0{background-position:-64px -256px}.emoji-1f1f2-1f1f1{background-position:-128px -256px}.emoji-1f1f2-1f1f2{background-position:-192px -256px}.emoji-1f1f2-1f1f3{background-position:-256px -256px}.emoji-1f1f2-1f1f4{background-position:-320px 0}.emoji-1f1f2-1f1f5{background-position:-320px -64px}.emoji-1f1f2-1f1f6{background-position:-320px -128px}.emoji-1f1f2-1f1f7{background-position:-320px -192px}.emoji-1f1f2-1f1f8{background-position:-320px -256px}.emoji-1f1f2-1f1f9{background-position:0 -320px}.emoji-1f1f2-1f1fa{background-position:-64px -320px}.emoji-1f1f2-1f1fb{background-position:-128px -320px}.emoji-1f1f2-1f1fc{background-position:-192px -320px}.emoji-1f1f2-1f1fd{background-position:-256px -320px}.emoji-1f1f2-1f1fe{background-position:-320px -320px}.emoji-1f1f2-1f1ff{background-position:-384px 0}.emoji-1f1f3-1f1e6{background-position:-384px -64px}.emoji-1f1f3-1f1e8{background-position:-384px -128px}.emoji-1f1f3-1f1ea{background-position:-384px -192px}.emoji-1f1f3-1f1eb{background-position:-384px -256px}.emoji-1f1f3-1f1ec{background-position:-384px -320px}.emoji-1f1f3-1f1ee{background-position:0 -384px}.emoji-1f1f3-1f1f1{background-position:-64px -384px}.emoji-1f1f0-1f1fc{background-position:-128px -384px}.emoji-category-flags-5{background-image:url(" + __webpack_require__(536) + ")}.emoji-1f1f8-1f1fe{background-position:0 0}.emoji-1f1f3-1f1f7{background-position:-64px 0}.emoji-1f1f3-1f1fa{background-position:0 -64px}.emoji-1f1f3-1f1ff{background-position:-64px -64px}.emoji-1f1f4-1f1f2{background-position:-128px 0}.emoji-1f1f5-1f1e6{background-position:-128px -64px}.emoji-1f1f5-1f1ea{background-position:0 -128px}.emoji-1f1f5-1f1eb{background-position:-64px -128px}.emoji-1f1f5-1f1ec{background-position:-128px -128px}.emoji-1f1f5-1f1ed{background-position:-192px 0}.emoji-1f1f5-1f1f0{background-position:-192px -64px}.emoji-1f1f5-1f1f1{background-position:-192px -128px}.emoji-1f1f5-1f1f2{background-position:0 -192px}.emoji-1f1f5-1f1f3{background-position:-64px -192px}.emoji-1f1f5-1f1f7{background-position:-128px -192px}.emoji-1f1f5-1f1f8{background-position:-192px -192px}.emoji-1f1f5-1f1f9{background-position:-256px 0}.emoji-1f1f5-1f1fc{background-position:-256px -64px}.emoji-1f1f5-1f1fe{background-position:-256px -128px}.emoji-1f1f6-1f1e6{background-position:-256px -192px}.emoji-1f1f7-1f1ea{background-position:0 -256px}.emoji-1f1f7-1f1f4{background-position:-64px -256px}.emoji-1f1f7-1f1f8{background-position:-128px -256px}.emoji-1f1f7-1f1fa{background-position:-192px -256px}.emoji-1f1f7-1f1fc{background-position:-256px -256px}.emoji-1f1f8-1f1e6{background-position:-320px 0}.emoji-1f1f8-1f1e7{background-position:-320px -64px}.emoji-1f1f8-1f1e8{background-position:-320px -128px}.emoji-1f1f8-1f1e9{background-position:-320px -192px}.emoji-1f1f8-1f1ea{background-position:-320px -256px}.emoji-1f1f8-1f1ec{background-position:0 -320px}.emoji-1f1f8-1f1ed{background-position:-64px -320px}.emoji-1f1f8-1f1ee{background-position:-128px -320px}.emoji-1f1f8-1f1ef{background-position:-192px -320px}.emoji-1f1f8-1f1f0{background-position:-256px -320px}.emoji-1f1f8-1f1f1{background-position:-320px -320px}.emoji-1f1f8-1f1f2{background-position:-384px 0}.emoji-1f1f8-1f1f3{background-position:-384px -64px}.emoji-1f1f8-1f1f4{background-position:-384px -128px}.emoji-1f1f8-1f1f7{background-position:-384px -192px}.emoji-1f1f8-1f1f8{background-position:-384px -256px}.emoji-1f1f8-1f1f9{background-position:-384px -320px}.emoji-1f1f8-1f1fb{background-position:0 -384px}.emoji-1f1f8-1f1fd{background-position:-64px -384px}.emoji-1f1f3-1f1f5{background-position:-128px -384px}.emoji-category-flags-6{background-image:url(" + __webpack_require__(537) + ")}.emoji-1f3f4-e0067-e0062-e0077-e006c-e0073-e007f{background-position:0 0}.emoji-1f1f9-1f1e6{background-position:-64px 0}.emoji-1f1f9-1f1e8{background-position:0 -64px}.emoji-1f1f9-1f1e9{background-position:-64px -64px}.emoji-1f1f9-1f1eb{background-position:-128px 0}.emoji-1f1f9-1f1ec{background-position:-128px -64px}.emoji-1f1f9-1f1ed{background-position:0 -128px}.emoji-1f1f9-1f1ef{background-position:-64px -128px}.emoji-1f1f9-1f1f0{background-position:-128px -128px}.emoji-1f1f9-1f1f1{background-position:-192px 0}.emoji-1f1f9-1f1f2{background-position:-192px -64px}.emoji-1f1f9-1f1f3{background-position:-192px -128px}.emoji-1f1f9-1f1f4{background-position:0 -192px}.emoji-1f1f9-1f1f7{background-position:-64px -192px}.emoji-1f1f9-1f1f9{background-position:-128px -192px}.emoji-1f1f9-1f1fb{background-position:-192px -192px}.emoji-1f1f9-1f1fc{background-position:-256px 0}.emoji-1f1f9-1f1ff{background-position:-256px -64px}.emoji-1f1fa-1f1e6{background-position:-256px -128px}.emoji-1f1fa-1f1ec{background-position:-256px -192px}.emoji-1f1fa-1f1f2{background-position:0 -256px}.emoji-1f1fa-1f1f3{background-position:-64px -256px}.emoji-1f1fa-1f1f8{background-position:-128px -256px}.emoji-1f1fa-1f1fe{background-position:-192px -256px}.emoji-1f1fa-1f1ff{background-position:-256px -256px}.emoji-1f1fb-1f1e6{background-position:-320px 0}.emoji-1f1fb-1f1e8{background-position:-320px -64px}.emoji-1f1fb-1f1ea{background-position:-320px -128px}.emoji-1f1fb-1f1ec{background-position:-320px -192px}.emoji-1f1fb-1f1ee{background-position:-320px -256px}.emoji-1f1fb-1f1f3{background-position:0 -320px}.emoji-1f1fb-1f1fa{background-position:-64px -320px}.emoji-1f1fc-1f1eb{background-position:-128px -320px}.emoji-1f1fc-1f1f8{background-position:-192px -320px}.emoji-1f1fd-1f1f0{background-position:-256px -320px}.emoji-1f1fe-1f1ea{background-position:-320px -320px}.emoji-1f1fe-1f1f9{background-position:-384px 0}.emoji-1f1ff-1f1e6{background-position:-384px -64px}.emoji-1f1ff-1f1f2{background-position:-384px -128px}.emoji-1f1ff-1f1fc{background-position:-384px -192px}.emoji-1f3f4-e0067-e0062-e0065-e006e-e0067-e007f{background-position:-384px -256px}.emoji-1f3f4-e0067-e0062-e0073-e0063-e0074-e007f{background-position:-384px -320px}.emoji-1f1f8-1f1ff{background-position:0 -384px}.emoji-category-custom-1{background-image:url(" + __webpack_require__(1157) + ")}.emoji-cordchat{background-position:0 0}.error-bar{background-color:#1f7bc1;color:#fff;padding:5px 30px;position:fixed;text-align:center;top:0;width:100%;z-index:9999}.error-bar.error-bar--fixed{overflow:hidden;padding:1px 30px;text-overflow:ellipsis;white-space:nowrap}.error-bar a{text-decoration:underline}.error-bar a,.error-bar a:active,.error-bar a:focus,.error-bar a:hover{color:inherit!important}.error-bar a.error-bar__close{font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;padding:0 10px;position:absolute;right:0;top:0}.error-bar a.error-bar__close,.error-bar a.error-bar__close:hover{color:#fff;text-decoration:none}.error-bar-critical{background-color:#b0171f}.error-bar-developer{background-color:purple}.file-preview__container{max-height:100px;overflow-x:auto;overflow-y:hidden;white-space:nowrap;margin:1px 10px 10px 0}.file-preview,.file-preview__container{height:100px;position:relative;display:inline-block}.file-preview{overflow:hidden;*zoom:1;border:1px solid rgba(0,0,0,.15);margin:0 0 0 10px;width:120px}.file-preview:first-child{margin-left:0}.file-preview .spinner{height:32px;left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%;width:32px}.file-preview__remove{background:rgba(0,0,0,.5);border-radius:0 0 0 2px;height:28px;position:absolute;right:0;text-align:center;top:0;width:28px}.file-preview__remove i{color:#fff;cursor:pointer;font-size:16px;line-height:29px;position:relative;right:auto;text-shadow:0 0 3px rgba(0,0,0,.7);top:auto;z-index:5}.file-picker-service{position:absolute;height:20px;width:20px;text-align:center;z-index:3;background:#fff}.file-picker-service i.fa{z-index:5;font-size:16px;position:relative;line-height:20px;top:auto}.file-picker-service img.picker-icons{width:16px}.image-comment{background-position:0 0;background-repeat:no-repeat;height:300px;width:300px}.file-icon{height:100%;width:100%}.file-icon.audio{background-image:url(" + __webpack_require__(410) + ")}.file-icon.audio,.file-icon.video{-webkit-background-size:60px auto;-moz-background-size:60px auto;-o-background-size:60px auto;background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.video{background-image:url(" + __webpack_require__(411) + ")}.file-icon.ppt{background-image:url(" + __webpack_require__(413) + ")}.file-icon.generic,.file-icon.ppt{-webkit-background-size:60px auto;-moz-background-size:60px auto;-o-background-size:60px auto;background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.generic{background-image:url(" + __webpack_require__(418) + ")}.file-icon.code{background-image:url(" + __webpack_require__(415) + ")}.file-icon.code,.file-icon.excel{-webkit-background-size:60px auto;-moz-background-size:60px auto;-o-background-size:60px auto;background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.excel{background-image:url(" + __webpack_require__(412) + ")}.file-icon.word{background-image:url(" + __webpack_require__(416) + ")}.file-icon.pdf,.file-icon.word{-webkit-background-size:60px auto;-moz-background-size:60px auto;-o-background-size:60px auto;background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.pdf{background-image:url(" + __webpack_require__(414) + ")}.file-icon.patch{background-image:url(" + __webpack_require__(417) + ")}.file-icon.image,.file-icon.patch{-webkit-background-size:60px auto;-moz-background-size:60px auto;-o-background-size:60px auto;background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.image{background-image:url(" + __webpack_require__(1158) + ")}.pdf-preview-spacer{height:5px}.pdf-max-pages{background:#fff;bottom:0;display:block;left:0;position:relative;width:100%}.pdf-max-pages span{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:rgba(0,0,0,.8);bottom:15px;color:#fff;display:inline-block;height:3em;line-height:3em;padding:0 1.5em;position:relative}.post-image__column{border:1px solid rgba(0,0,0,.2);float:left;height:100px;margin:5px 10px 5px 0;position:relative;width:240px}.post-image__column--placeholder{visibility:hidden}.post-image__load{background-position:50%;background-size:20px 20px}.post-image,.post-image__load{background-repeat:no-repeat;height:100%;width:100%}.post-image{background-color:#fff;overflow:hidden;position:relative;text-align:center}.post-image.small{background-position:50%}.post-image.normal{background-position:0 0}.post-image .spinner .file__loading{left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%}.post-image .file__loaded{max-width:none}.post-image .file__loaded.landscape,.post-image .file__loaded.quadrat{height:100px}.post-image .file__loaded.portrait{width:120px}.post-image__thumbnail{cursor:-webkit- zoom-in;cursor:zoom- zoom-in;float:left;height:100%;width:50%}.post-image__details{overflow:hidden;*zoom:1;background:#fff;border-left:1px solid rgba(0,0,0,.15);color:rgba(0,0,0,.8);float:left;font-size:13px;height:100%;padding:7px;width:50%;word-break:break-word}.post-image__details .post-image__name{display:block;margin-bottom:3px}.post-image__details .post-image__download{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;cursor:pointer;display:inline-block;padding-right:7px}.post-image__details .post-image__type{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.post-image__details .post-image__scan{display:block;font-size:.85em;margin-top:2px}.post-image__details .post-image__scan .fa{margin-right:4px}.post-image__details .post-image__scan.post-image__scan--pending{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.post-image__details .post-image__scan.post-image__scan--infected{color:#d24b4e;font-weight:600}.post-image__details .post-image__scan.post-image__scan--error{color:#d24b4e}.post-image__details .post-image__size{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;margin-left:4px}.file-details__container{display:-webkit-flex;display:flex;background:#fff}.file-details__container .file-details{height:270px;padding:14px;text-align:left;vertical-align:top;width:320px}.file-details__container .file-details .file-details__name{color:rgba(0,0,0,.9);font-size:16px;margin:5px 0;word-break:break-word}.file-details__container .file-details .file-details__info{color:rgba(0,0,0,.5)}.file-details__container .file-details__preview{border-right:1px solid rgba(0,0,0,.15);height:270px;vertical-align:center;width:320px}.file-details__container .file-details__preview .file-details__preview-helper{display:inline-block;height:100%;vertical-align:middle}.file-playback__controls{-webkit-transition:opacity .6s;-webkit-transition-delay:0s;-moz-transition:opacity .6s;-o-transition:opacity .6s;transition:opacity false false .6s;bottom:0;cursor:pointer;font-size:22px;position:absolute;right:5px;transition:opacity .6s;z-index:2}.file-playback__controls.stop{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0}.view-image__loading{background:#000;min-height:100px}.file-details__scan{margin-top:10px;font-size:13px}.file-details__scan .fa{margin-right:5px}.file-details__scan.file-details__scan--pending{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.file-details__scan.file-details__scan--error,.file-details__scan.file-details__scan--infected{color:#d24b4e}.form-control{-webkit-border-radius:1px;-moz-border-radius:1px;-ms-border-radius:1px;-o-border-radius:1px;border-radius:1px}.form-control:focus{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.form-control.no-padding{line-height:32px;padding:0}.form-control.no-resize{resize:none}.form-control[disabled],.form-control [readonly],fieldset[disabled] .form-control{background:hsla(0,0%,100%,.1);color:inherit;cursor:auto}.admin-textarea{resize:none}input[type=checkbox],input[type=radio]{font-size:14px;margin-top:3px}::-webkit-input-placeholder{color:inherit;opacity:.5}::-moz-placeholder{color:inherit;opacity:.5}:-ms-input-placeholder{color:inherit;opacity:.5}:-moz-placeholder{color:inherit;opacity:.5}a{color:#2389d7;cursor:pointer;text-decoration:none;word-break:break-word}a:focus,a:hover{color:#1c6dab}.text-danger,.text-danger:focus,.text-danger:hover{color:#bf5f5d}.mention{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#2389d7;color:#fff;padding-bottom:2px;position:relative;z-index:10}.badge{background-color:#777;border-radius:10px;color:#fff;display:inline-block;font-size:12px;font-weight:700;line-height:1;min-width:10px;padding:3px 7px;text-align:center;vertical-align:middle;white-space:nowrap}.mentions__name{overflow:hidden;*zoom:1;cursor:pointer;font-size:13px;line-height:20px;margin:0;padding:6px 10px;position:relative;white-space:nowrap;width:100%;z-index:101}.mentions__name .icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:inline-block;margin:0 7px 0 0;position:relative;text-align:center;top:2px;vertical-align:top;width:16px}.mentions__name .icon.icon__globe svg{height:14px;width:14px}.mentions__name .status{font-size:15px;text-align:center;vertical-align:bottom;width:20px}.mentions__name .fa-user{position:relative;top:-1px}.mentions__name .mention--align{overflow:hidden;*zoom:1;text-overflow:ellipsis;width:calc(100% - 50px)}.mentions__name.mentions__channel{overflow:hidden;*zoom:1;cursor:pointer;font-size:14px;line-height:36px;margin:0;padding:3px 10px;position:relative;white-space:nowrap;width:100%;z-index:101}.mentions__name.mentions__channel .icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:inline-block;margin:0 7px 0 0;position:relative;padding:0;text-align:center;vertical-align:middle}.mentions__name.mentions__channel .icon.icon__globe svg,.mentions__name.mentions__channel .icon.icon__lock svg{height:16px;width:16px}.mentions__name.mentions__channel .status{vertical-align:middle}.mentions__name.mentions__channel .mention__image{width:32px;height:32px}.mentions__name.mentions__channel .mention__image.mention__channel-image{-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.mention__image{-webkit-border-radius:20px;-moz-border-radius:20px;-ms-border-radius:20px;-o-border-radius:20px;border-radius:20px;display:block;font-size:15px;height:16px;line-height:16px;margin-right:7px;margin-top:3px;text-align:center;width:16px}.mention__image .mention--align{display:inline-block;max-width:80%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mention__fullname{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.mention--highlight{background-color:#ff0}.mention__purpose{line-height:normal;margin-left:5px}.mention__channelname,.mention__purpose{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.app__body.browser--ie .modal .modal-dialog{-webkit-transform:translateY(0);-moz-transform:translateY(0);-ms-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0)}.app__body .modal-body{max-height:calc(90vh - 62px);overflow:auto;padding:20px 15px}.app__body .edit-modal-body{overflow:visible}.app__body .edit-modal-body .custom-textarea{max-height:60vh;min-height:8em}.app__body .edit-modal-body .suggestion-list__content{max-height:150px}.app__body .edit-modal-body .edit-post-footer{display:inline-block;font-size:13px;position:relative}.app__body .edit-modal-body .edit-post-footer .post-error{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=55);opacity:.55;font-size:.85em;font-weight:400;margin-bottom:0;position:relative;top:3px}.app__body .row--invite .col-sm-6:first-child{padding-right:0}.app__body .modal__hint{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;display:block;font-size:.9em;margin:0 0 10px}.app__body .modal__error{color:#d64946;float:left;font-size:.95em;font-weight:400;margin-top:6px}.app__body .more-table{margin:0;table-layout:fixed}.app__body .modal{color:rgba(0,0,0,.9);width:100%}.app__body .modal .channel-switch-modal .modal-header{background:transparent;border:none;min-height:0;padding:0}.app__body .modal .channel-switch-modal .modal-header .close{top:10px}.app__body .modal .modal--overflow .modal-body{overflow:visible}.app__body .modal.modal-image .modal-backdrop.in{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.app__body .modal .custom-textarea{border-color:rgba(0,0,0,.15);color:inherit}.app__body .modal .custom-textarea:focus{border-color:rgba(0,0,0,.15);box-shadow:none}.app__body .modal .btn{font-size:13px}.app__body .modal .btn.btn-default{background:transparent;border:none}.app__body .modal .info__label{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;font-size:.9em;font-weight:600;margin-bottom:3px}.app__body .modal .info__value{padding-left:10px;word-break:break-word}.app__body .modal .team-member-list{width:100%}.app__body .modal .remove__member{color:inherit;float:right;font-size:20px;line-height:0;padding:6px}.app__body .modal .remove__member:hover{color:#d64946}.app__body .modal .modal-dialog{margin-bottom:0;margin-left:auto;margin-right:auto;max-width:95%}.app__body .modal .modal-dialog.modal-xl{width:800px}.app__body .modal .modal-push-down{margin-top:60px}.app__body .modal .modal-next-bar{height:100%;position:absolute;right:0;top:0}.app__body .modal .modal-header{-webkit-border-radius:0;-moz-border-radius:0;-ms-border-radius:0;-o-border-radius:0;border-radius:0;overflow:hidden;*zoom:1;background:#2389d7;border:1px solid rgba(0,0,0,.15);color:#fff;min-height:56px;padding:14px 15px 11px}.app__body .modal .modal-header .modal-title{color:#f5f5f5;float:left;font-size:17px;line-height:27px;max-width:calc(100% - 80px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.app__body .modal .modal-header .modal-title .name{color:#fff;font-weight:600}.app__body .modal .modal-header .modal-action{margin:0;padding:0}.app__body .modal .modal-header .close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;-webkit-transition:all .25s ease-in;-webkit-transition-delay:0s;-moz-transition:all .25s ease-in;-o-transition:all .25s ease-in;transition:all false .25s ease-in;color:#fff;height:30px;line-height:30px;position:absolute;right:10px;text-shadow:none;width:30px;z-index:5}.app__body .modal .modal-header .close:hover{background:rgba(0,0,0,.1)}.app__body .modal .modal-header .close .sr-only{display:none}.app__body .modal .modal-header .close span{font-family:Open Sans,sans-serif;line-height:10px}.app__body .modal .modal-header .btn.btn-primary{float:right;margin:-4px 33px 0 0;position:relative}.app__body .modal .modal-header .btn.btn-primary i{margin-right:5px}.app__body .modal .no-channel-message{padding:2em 1em;text-align:center}.app__body .modal .no-channel-message .primary-message{font-size:1.25em}.app__body .modal .no-channel-message .secondary-message{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;margin:1em 0 0}.app__body .modal .modal-content{-webkit-box-shadow:0 0 10px rgba(0,0,0,.5);-moz-box-shadow:0 0 10px rgba(0,0,0,.5);box-shadow:0 0 10px rgba(0,0,0,.5);border-radius:1px}.app__body .modal .modal-chevron-icon{font-size:120%;top:50%}.app__body .modal .modal-prev-bar{height:100%;left:0;position:absolute;top:0}.app__body .modal .modal-image{height:100%;margin:0 auto;max-width:100%;position:relative;width:100%}.app__body .modal .modal-image .modal-body{overflow:hidden;*zoom:1;display:table;height:100%;max-height:100%;table-layout:fixed;width:100%}.app__body .modal .modal-image .modal-image__content{max-height:85vh;max-width:90vw;overflow-x:hidden;overflow-y:visible}.app__body .modal .modal-image .post-code__container{overflow:auto}.app__body .modal .modal-image .modal-image__wrapper{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;display:table-cell;max-width:90%;position:relative;text-align:center;vertical-align:middle;width:100%}.app__body .modal .modal-image .modal-image__wrapper:hover{-webkit-border-radius:3px 3px 0 0;-moz-border-radius:3px 3px 0 0;-ms-border-radius:3px 3px 0 0;-o-border-radius:3px 3px 0 0;border-radius:3px 3px 0 0}.app__body .modal .modal-image .modal-image__wrapper.default{height:80%;width:100%}.app__body .modal .modal-image .modal-image__wrapper audio,.app__body .modal .modal-image .modal-image__wrapper canvas,.app__body .modal .modal-image .modal-image__wrapper progress,.app__body .modal .modal-image .modal-image__wrapper video{display:block;height:auto;max-height:85vh;width:auto;margin:0 auto}.app__body .modal .modal-image .modal-image__wrapper .modal-close{-webkit-transition:opacity .6s;-webkit-transition-delay:0s;-moz-transition:opacity .6s;-o-transition:opacity .6s;transition:opacity false false .6s;-webkit-background-size:100% 100%;-moz-background-size:100% 100%;-o-background-size:100% 100%;background-size:100% 100%;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;background-image:url(" + __webpack_require__(1159) + ");cursor:pointer;height:37px;position:absolute;right:-13px;top:-13px;transition:opacity .6s;width:37px;z-index:9999}.app__body .modal .modal-image .modal-image__wrapper .modal-close.modal-close--show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-image .modal-image__wrapper>div{display:inline-block;min-height:100px;min-width:320px;position:relative}.app__body .modal .modal-image .modal-image__wrapper code{min-height:130px;min-width:330px}.app__body .modal .modal-image .modal-image__wrapper code,.app__body .modal .modal-image .modal-image__wrapper pre{display:inline-block}.app__body .modal .modal-image .modal-image__wrapper .post-body--code{max-height:calc(100vh - 80px);max-width:calc(100vw - 80px);overflow:auto}.app__body .modal .modal-image .modal-image__wrapper img{max-height:calc(100vh - 200px);max-width:100%}.app__body .modal .modal-image .modal-image__wrapper .spinner .file__loading{left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%;z-index:2}.app__body .modal .modal-image .modal-content{background:transparent;border:none;box-shadow:none;height:100%;padding:0;width:100%}.app__body .modal .modal-image .modal-image__body{display:table-cell;height:100%;overflow:visible;padding:0;position:relative;text-align:center;vertical-align:middle}.app__body .modal .modal-image .image-control{background:url(" + __webpack_require__(1160) + ") 0 no-repeat;float:left;height:45px;margin-top:-23px;position:relative;top:50%;width:50px}.app__body .modal .modal-image .image-control.image-next{background:url(" + __webpack_require__(1161) + ") 0 no-repeat;float:right}.app__body .modal .modal-image .loader-image{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.app__body .modal .modal-image .loader-percent{bottom:0;color:hsla(0,0%,100%,.8);height:20px;left:0;margin:auto;position:absolute;right:0;top:55px}.app__body .modal .modal-image .modal-button-bar{-webkit-transition:opacity .6s;-webkit-transition-delay:0s;-moz-transition:opacity .6s;-o-transition:opacity .6s;transition:opacity false false .6s;-webkit-border-radius:0 0 3px 3px;-moz-border-radius:0 0 3px 3px;-ms-border-radius:0 0 3px 3px;-o-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;background-color:#000;bottom:-40px;left:0;line-height:40px;max-width:90vw;padding:0 10px;position:absolute;right:0}.app__body .modal .modal-image .modal-button-bar.footer--show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-image .modal-button-bar .image-links a,.app__body .modal .modal-image .modal-button-bar .image-links span{float:right}.app__body .modal .modal-image .modal-button-bar .text{bottom:0;color:#fff;margin-left:5px;vertical-align:middle}.app__body .modal .modal-image .modal-button-bar .public-link{margin-right:5px}.app__body .modal.more-channel__modal .modal-body{overflow-x:hidden;padding:10px 0 15px}.app__body .modal.more-channel__modal .channel-count{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;float:right;margin-top:5px}.app__body .modal .channel-members__modal .modal-header .modal-title{width:100%;margin-bottom:10px}.app__body .modal .collapse-elements__header{border-bottom:1px solid rgba(68,68,68,.2);cursor:pointer;font-size:.96429em;font-weight:600;margin:10px 20px 0 0;padding:1px 0 10px}.app__body .modal .collapse-elements__header .fa-minus{display:none}.app__body .modal .collapse-elements__header.open .fa-minus{display:inline-block}.app__body .modal .collapse-elements__header.open .fa-plus{display:none}.app__body .modal .collapse-elements__header .header__icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;float:right}.app__body .modal .collapse-elements__header .team-icon{border-radius:5px;margin-right:10px}.app__body .modal .collapse-elements__body{-webkit-border-radius:0 0 3px 3px;-moz-border-radius:0 0 3px 3px;-ms-border-radius:0 0 3px 3px;-o-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;*zoom:1;background-color:hsla(0,0%,100%,.05);display:none;margin:0 20px 0 0;padding:5px 0 0 20px}.app__body .modal .collapse-elements__body:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.app__body .modal .collapse-elements__body.open{display:block}.app__body .modal .collapse-elements__body .label{margin-left:2em}.app__body .modal .collapse-elements__body .label-active{background-color:#3092e8}.app__body .modal .collapse-elements__body label{width:100%}.app__body .modal .collapse-elements__body input[type=checkbox]{position:relative}.app__body .modal .collapse-elements__body .self-destruct-channel .icon{fill:#999;margin-right:5px}.app__body .modal .collapse-elements__body .self-destruct-channel .status.status--group{background:rgba(0,0,0,.3);color:#fff}.app__body .modal .collapse-elements__body .forward-channel{height:30px;margin:5px 0}.app__body .modal .collapse-elements__body .forward-channel .icon{margin-right:5px;fill:#999;vertical-align:middle}.app__body .modal .collapse-elements__body .forward-channel .channel-name{vertical-align:middle;width:375px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app__body .modal .reach_user-limit-modal-content .helptext,.app__body .modal .status-modal-content .helptext{margin-bottom:15px}.app__body .modal .status-modal-content .status-desc-item{padding:10px 0;border-bottom:1px solid #d3d3d3}.app__body .modal .status-modal-content .status-desc-item:first-child{padding-top:0}.app__body .modal .status-modal-content .status-desc-item:last-child{padding-bottom:0;border-bottom:0}.app__body .modal .status-modal-content .status-wrapper{margin-right:15px}.app__body .modal .status-modal-content .status_desc_image{vertical-align:top;border-radius:50%}.app__body .more-modal .user-list{margin-top:10px;overflow-x:hidden;overflow-y:auto;position:relative}.app__body .more-modal.can-switch-team .modal-body{padding-top:0}.app__body .more-modal.can-switch-team .modal-body .filtered-user-list{height:calc(90vh - 187px)}.app__body .more-modal .modal-body{overflow-x:hidden;padding:10px 0 15px}.app__body .more-modal .modal-body .team-panel{margin-bottom:10px}.app__body .more-modal .modal-body .team-panel .team-panel-wrapper{flex-direction:row;display:flex;align-items:center;padding:15px;background-color:rgba(0,0,0,.2)}.app__body .more-modal .modal-body .team-panel .team-icon-wrapper{margin-right:10px;border:1px solid hsla(0,0%,100%,.2);background-color:transparent;border-color:#fff;-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px}.app__body .more-modal .modal-body .team-panel .team-icon-wrapper img{width:48px;-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px}.app__body .more-modal .modal-body .team-panel .list-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.app__body .more-modal .modal-body .team-panel .list-text .team-name-label{padding-right:5px}.app__body .more-modal .modal-body .team-panel .list-text .team-name{font-weight:700}.app__body .more-modal .filter-row{margin:5px 0 10px;width:300px}.app__body .more-modal .filter-row.filter-row--full{width:100%}.app__body .more-modal .member-count{margin-top:5px}.app__body .more-modal .member-count,.app__body .more-modal .member-show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;float:right}.app__body .more-modal .member-show{margin-right:3px;margin-top:8px}.app__body .more-modal .member-select__container .member-count{margin:12px 0 0 3px}.app__body .more-modal .member-select__container select{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;float:right;margin:1px 5px 0 2px;width:auto}.app__body .more-modal .more-purpose{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.app__body .select-channel-type-modal .channel-type-wrapper{display:flex;justify-content:space-around;margin:30px 0}.app__body .select-channel-type-modal .channel-type-wrapper .channel-type{font-weight:400;font-size:18px;text-align:center;width:130px;height:130px;padding:0 10px;color:#fff;display:table;text-decoration:none;cursor:pointer}.app__body .select-channel-type-modal .channel-type-wrapper .channel-type .text-content{vertical-align:middle;display:table-cell}.app__body .select-channel-type-modal .channel-type-wrapper .channel-type.channel-public{background:#2ab27b}.app__body .select-channel-type-modal .channel-type-wrapper .channel-type.channel-private{background:#5856d6}.app__body .select-channel-type-modal .create-channel-helper{margin-left:30px}.app__body .select-channel-type-modal .create-channel-helper .channel-public{color:#2ab27b}.app__body .select-channel-type-modal .create-channel-helper .channel-private{color:#5856d6}.more-modal__list{display:flex;flex-direction:column}.browser--ie .more-modal__list{flex:20}.more-modal__list>div{min-height:100%;overflow:auto}.popover .more-modal__list{font-size:.95em}.popover .more-modal__list .more-modal__row{padding:5px 10px}.popover .more-modal__list .more-modal__name{font-weight:400}.more-modal__list .more-modal__image{-webkit-border-radius:60px;-moz-border-radius:60px;-ms-border-radius:60px;-o-border-radius:60px;border-radius:60px;flex-grow:0;flex-shrink:0;margin-top:2px;max-width:none}.more-modal__list .more-modal__details{flex-grow:1;flex-shrink:1;overflow:hidden;padding-left:10px;text-overflow:ellipsis}.more-modal__list .more-modal__actions{flex-grow:0;flex-shrink:0;margin:5px 0;padding-left:20px}.more-modal__list .more-modal__actions.align-self-center,.more-modal__list .more-modal__channel-list{align-self:center}.more-modal__list .more-modal__channel-list img{-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.more-modal__list .more-modal__name{font-size:.95em;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.more-modal__list .more-modal__name.channel-name{font-size:1em}.more-modal__list .more-modal__name .icon{margin-right:5px;vertical-align:middle}.more-modal__list .more-modal__description{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.more-modal__list .more-modal__row{border-bottom:1px solid rgba(0,0,0,.15);display:flex;padding:10px 15px}.more-modal__list .more-modal__row.clickable{cursor:pointer}.more-modal__list .more-modal__row:hover .more-modal__actions--round{opacity:.5}.more-modal__list .more-modal__placeholder-row{padding:10px 15px}.more-modal__list .more-modal__actions--round{height:32px;line-height:32px;opacity:0;text-align:center;width:32px}.more-modal__list p{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;font-size:.9em;margin:5px 0;overflow:hidden;text-overflow:ellipsis}.member-select__container{position:absolute;right:15px;top:15px}.filtered-user-list{display:flex;flex-direction:column;height:calc(90vh - 120px);width:100%}.filtered-user-list>div{flex:1 1 auto}.filtered-user-list .more-modal__list{flex-grow:500;height:1px}.filtered-user-list .filter-button .btn{height:34px}.filtered-user-list .filter-controls{padding:1em 1.5em 0}.filtered-user-list .filter-controls .filter-control__next{float:right}.filtered-user-list .filter-button{margin-left:0;padding-left:0}.multi-select__container{display:table;padding:0 15px;width:100%}.multi-select__container .Select{display:table-cell;padding-right:15px;vertical-align:top;width:100%}.multi-select__container .btn{display:table-cell;height:36px;min-width:60px;vertical-align:top}.multi-select__container .Select-control{border-radius:1px}.multi-select__container .Select-value{white-space:nowrap}.multi-select__container .Select-value-label{overflow:hidden}.multi-select__help{padding:10px 15px 0}.multi-select__help>div:not(.multi-select__note),.multi-select__help>span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.multi-select__note{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;display:table;margin-top:5px;padding:8px 13px;width:100%}.multi-select__note>div{display:table-cell}.multi-select__note>div.note__icon{width:15px}.prompt{background:#fff;border:1px solid rgba(0,0,0,.15);margin:50px auto;max-width:90%;padding:1em 2em 0;width:600px}.prompt .prompt__heading{display:table;font-size:1.28571em;line-height:normal;margin:1em 0;table-layout:fixed;width:100%}.prompt .prompt__heading>div{display:table-cell;vertical-align:top}.prompt .prompt__heading>div:first-child{width:70px}.prompt .prompt__heading img{margin-right:15px}.prompt .prompt__allow{font-size:1.42857em;margin:1em 0}.prompt .prompt__buttons{border-top:1px solid rgba(0,0,0,.15);padding:1.5em 0;text-align:right}.prompt .prompt__error{display:inline-block}.popover{-webkit-border-radius:1px;-moz-border-radius:1px;-ms-border-radius:1px;-o-border-radius:1px;border-radius:1px;color:#404040;padding:0}.popover.bottom>.arrow:after,.popover.left>.arrow:after,.popover.right>.arrow:after,.popover.top>.arrow:after{border-color:transparent}.popover .popover-title{-webkit-border-radius:0;-moz-border-radius:0;-ms-border-radius:0;-o-border-radius:0;border-radius:0;background:rgba(0,0,0,.05);max-width:100%;overflow:hidden;padding:8px 10px;text-overflow:ellipsis}.popover .popover-content{word-break:break-word}.popover .popover-content p:last-child{margin-bottom:5px}.popover .popover__row{margin:0 -15px;padding:9px 15px 0}.popover .popover__row.first{border-top:1px solid transparent;margin-top:9px}.popover .popover__row>a>i{margin-right:5px}.popover .popover__row>a>span{text-transform:capitalize}.channel-header__info .popover-content{max-height:250px;overflow:auto}.user-popover{cursor:pointer;display:inline-block}.code-popover .popover-content{padding:5px}.profile-popover .profile-popover__header{height:55px;display:flex;flex-direction:row-reverse;padding:6px 50px 3px 12px;position:relative}.profile-popover .profile-popover__header .header__info{flex-grow:1;padding-left:8px;position:relative;overflow:hidden}.profile-popover .profile-popover__header .header__info .user__fullname,.profile-popover .profile-popover__header .header__info .user__nickname{display:block;font-size:14px;max-width:100%;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.profile-popover .profile-popover__header .image-wrapper{position:relative;top:-24px}.profile-popover .profile-popover__header .image-wrapper img{width:68px;height:68px;border:2px solid #fff;-webkit-border-radius:100%;-moz-border-radius:100%;-ms-border-radius:100%;-o-border-radius:100%;border-radius:100%}.profile-popover .popover-content{padding:0}.profile-popover .popover-content .user-popover__bg-placeholder{width:100%;min-width:219px;padding-top:45.6621%}.profile-popover .popover-content .user-profile-data-items{padding:9px 14px}.channel-info-popover,.team-info-popover{max-width:335px}.channel-info-popover .popover-content,.team-info-popover .popover-content{padding:2px}.channel-info-popover .popover-content .fake-placeholder,.team-info-popover .popover-content .fake-placeholder{background:#007aff;min-width:328.5px;padding-bottom:45.6621%}.channel-info-popover .popover-content .channel-profile,.channel-info-popover .popover-content .team-profile,.team-info-popover .popover-content .channel-profile,.team-info-popover .popover-content .team-profile{display:flex;flex-direction:row-reverse;padding:6px 0 6px 30px;height:60px}.channel-info-popover .popover-content .channel-profile .channel-profile__header,.channel-info-popover .popover-content .channel-profile .team-profile__header,.channel-info-popover .popover-content .team-profile .channel-profile__header,.channel-info-popover .popover-content .team-profile .team-profile__header,.team-info-popover .popover-content .channel-profile .channel-profile__header,.team-info-popover .popover-content .channel-profile .team-profile__header,.team-info-popover .popover-content .team-profile .channel-profile__header,.team-info-popover .popover-content .team-profile .team-profile__header{flex-grow:1;padding:0 10px}.channel-info-popover .popover-content .channel-profile .channel-profile__header .channel__display_name,.channel-info-popover .popover-content .channel-profile .channel-profile__header .team__display_name,.channel-info-popover .popover-content .channel-profile .team-profile__header .channel__display_name,.channel-info-popover .popover-content .channel-profile .team-profile__header .team__display_name,.channel-info-popover .popover-content .team-profile .channel-profile__header .channel__display_name,.channel-info-popover .popover-content .team-profile .channel-profile__header .team__display_name,.channel-info-popover .popover-content .team-profile .team-profile__header .channel__display_name,.channel-info-popover .popover-content .team-profile .team-profile__header .team__display_name,.team-info-popover .popover-content .channel-profile .channel-profile__header .channel__display_name,.team-info-popover .popover-content .channel-profile .channel-profile__header .team__display_name,.team-info-popover .popover-content .channel-profile .team-profile__header .channel__display_name,.team-info-popover .popover-content .channel-profile .team-profile__header .team__display_name,.team-info-popover .popover-content .team-profile .channel-profile__header .channel__display_name,.team-info-popover .popover-content .team-profile .channel-profile__header .team__display_name,.team-info-popover .popover-content .team-profile .team-profile__header .channel__display_name,.team-info-popover .popover-content .team-profile .team-profile__header .team__display_name{font-size:16px;display:block;width:211px}.channel-info-popover .popover-content .channel-profile .channel-profile__header .channel__display_name div,.channel-info-popover .popover-content .channel-profile .channel-profile__header .team__display_name div,.channel-info-popover .popover-content .channel-profile .team-profile__header .channel__display_name div,.channel-info-popover .popover-content .channel-profile .team-profile__header .team__display_name div,.channel-info-popover .popover-content .team-profile .channel-profile__header .channel__display_name div,.channel-info-popover .popover-content .team-profile .channel-profile__header .team__display_name div,.channel-info-popover .popover-content .team-profile .team-profile__header .channel__display_name div,.channel-info-popover .popover-content .team-profile .team-profile__header .team__display_name div,.team-info-popover .popover-content .channel-profile .channel-profile__header .channel__display_name div,.team-info-popover .popover-content .channel-profile .channel-profile__header .team__display_name div,.team-info-popover .popover-content .channel-profile .team-profile__header .channel__display_name div,.team-info-popover .popover-content .channel-profile .team-profile__header .team__display_name div,.team-info-popover .popover-content .team-profile .channel-profile__header .channel__display_name div,.team-info-popover .popover-content .team-profile .channel-profile__header .team__display_name div,.team-info-popover .popover-content .team-profile .team-profile__header .channel__display_name div,.team-info-popover .popover-content .team-profile .team-profile__header .team__display_name div{overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.channel-info-popover .popover-content .channel-profile .channel-icon,.channel-info-popover .popover-content .channel-profile .team-icon,.channel-info-popover .popover-content .team-profile .channel-icon,.channel-info-popover .popover-content .team-profile .team-icon,.team-info-popover .popover-content .channel-profile .channel-icon,.team-info-popover .popover-content .channel-profile .team-icon,.team-info-popover .popover-content .team-profile .channel-icon,.team-info-popover .popover-content .team-profile .team-icon{background:transparent;position:relative;top:-30px}.channel-info-popover .popover-content .channel-profile .channel-icon img,.channel-info-popover .popover-content .channel-profile .team-icon img,.channel-info-popover .popover-content .team-profile .channel-icon img,.channel-info-popover .popover-content .team-profile .team-icon img,.team-info-popover .popover-content .channel-profile .channel-icon img,.team-info-popover .popover-content .channel-profile .team-icon img,.team-info-popover .popover-content .team-profile .channel-icon img,.team-info-popover .popover-content .team-profile .team-icon img{width:68px;height:68px;border:2px solid #fff;-webkit-border-radius:10%;-moz-border-radius:10%;-ms-border-radius:10%;-o-border-radius:10%;border-radius:10%}.channel-info-popover .popover-content .info-content,.team-info-popover .popover-content .info-content{padding:5px}.channel-info-popover .popover-content .info-content .content-item,.team-info-popover .popover-content .info-content .content-item{margin-top:10px}.channel-info-popover .popover-content .info-content .content-item:first-child,.team-info-popover .popover-content .info-content .content-item:first-child{margin-top:0}.channel-info-popover .popover-content .info-content .content-item.channel__id,.team-info-popover .popover-content .info-content .content-item.channel__id{opacity:.4;font-size:.75em}.channel-info-popover .popover-content .info-content .content-item .info__label,.team-info-popover .popover-content .info-content .content-item .info__label{opacity:.5;font-size:.9em;font-weight:600;margin-bottom:3px}.channel-info-popover .popover-content .info-content .content-item .info__value,.team-info-popover .popover-content .info-content .content-item .info__value{padding-left:10px;word-break:break-word}.channel-info-popover .popover-content .info-content .content-item .info__value.team__description,.team-info-popover .popover-content .info-content .content-item .info__value.team__description{font-size:12px}.user-popover__image{-webkit-border-radius:128px;-moz-border-radius:128px;-ms-border-radius:128px;-o-border-radius:128px;border-radius:128px;margin:0 0 10px}.tocenter{text-align:center}.user-popover__email{display:block;max-width:200px;overflow:hidden;text-overflow:ellipsis}.user-popover__email[disabled]{color:#aaa}.user-popover__email[disabled]:focus,.user-popover__email[disabled]:hover{color:#aaa;text-decoration:none}.fa-lg.extra-margin-right{margin-right:5px}.user-popover__info{height:20px;vertical-align:middle;width:calc(100% - 29px);display:inline-block}.search-help-popover{-webkit-transition:opacity .3s ease-in;-webkit-transition-delay:0s;-moz-transition:opacity .3s ease-in;-o-transition:opacity .3s ease-in;transition:opacity false .3s ease-in;font-size:.92857em;min-width:300px;max-width:350px;top:36px;visibility:hidden;width:100%}.search-help-popover.autocomplete{display:block}.search-help-popover.autocomplete .popover-content{padding:10px;position:relative;-webkit-overflow-scrolling:touch}.search-help-popover .search-autocomplete__divider{line-height:21px;margin:10px 0 5px;position:relative}.search-help-popover .search-autocomplete__divider:first-child{margin-top:5px}.search-help-popover .search-autocomplete__divider>span{background:#fff;display:inline-block;padding-right:10px;position:relative;z-index:5}.search-help-popover .search-autocomplete__divider:before{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background:rgba(0,0,0,.5);content:\"\";height:1px;left:0;position:absolute;top:10px;width:100%}.search-help-popover .search-autocomplete__item{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;cursor:pointer;margin:3px 0 0 5px;overflow:hidden;padding:6px 8px;text-overflow:ellipsis;white-space:nowrap}.search-help-popover .search-autocomplete__item:hover{background:rgba(0,0,0,.1)}.search-help-popover .search-autocomplete__item.selected{background:rgba(0,0,0,.2)}.search-help-popover .search-autocomplete__item .mention--align{display:inline-block}.search-help-popover .search-autocomplete__item .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;margin-right:5px}.search-help-popover .search-autocomplete__item .profile-img{height:16px;margin-right:6px;margin-top:-1px;width:16px}.search-help-popover.bottom>.arrow{border-width:9px;left:30px;top:-18px}.search-help-popover .popover-content{max-height:500px;overflow:auto;padding:3px 13px}.search-help-popover h4{font-size:1em}.search-help-popover ul{padding-left:17px}.search-help-popover ul span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.search-help-popover ul b,.search-help-popover ul strong{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.search-help-popover .tooltip-inner{max-width:100%}.search-help-popover.visible{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;visibility:visible}.member-list__popover{max-width:none}.member-list__popover .more-modal__header{padding:14px 0}.member-list__popover .more-modal__header .icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;margin:0 38px 0 24px;position:relative;top:2px}.member-list__popover .more-modal__header span{font-weight:500}.member-list__popover .more-modal__list .more-modal__row{border-bottom:none;border-top:1px solid;cursor:pointer;height:45px;overflow:hidden;padding:5px 19px 5px 17px}.member-list__popover .more-modal__list .more-modal__row:hover{border-left:3px solid transparent;padding-left:14px}.member-list__popover .more-modal__list .more-modal__row:hover .more-modal__actions{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.member-list__popover .more-modal__list .more-modal__row.more-modal__row--button{border-left:none;height:40px;position:relative}.member-list__popover .more-modal__list .more-modal__row.more-modal__row--button button{font-weight:500;height:100%;left:0;position:absolute;top:0;width:100%}.member-list__popover .more-modal__list .more-modal__name{line-height:33px}.member-list__popover .more-modal__list .more-modal__image{margin:0}.member-list__popover .more-modal__list .more-modal__details{line-height:32px;padding-left:30px}.member-list__popover .more-modal__list .more-modal__actions{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;line-height:42px;margin:0}.member-list__popover .popover-content{max-height:350px;padding:0;position:relative;width:260px}.member-list__popover .popover-content .text-nowrap{font-size:13px;line-height:26px;overflow:hidden;padding:6px 10px;width:100%}.member-list__popover .popover-content .more__name{margin-left:6px;max-width:140px;overflow:hidden;text-overflow:ellipsis}.signup__popover{border-radius:10px;background:#007aff;border-color:#007aff;color:#fff}.signup__popover .help-block{margin-top:0;color:#fff}.signup__popover.top>.arrow{border-top-color:#007aff}.signup__popover.right>.arrow{border-right-color:#007aff}.save-button .icon{margin-right:10px}::-webkit-scrollbar{height:8px;width:8px}::-webkit-scrollbar-track{background:rgba(0,0,0,.1)}::-webkit-scrollbar-thumb{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;background:rgba(0,0,0,.2)}body.app__body{scrollbar-3dlight-color:#7d7e94;scrollbar-arrow-color:#c1c1d1;scrollbar-darkshadow-color:#2d2c4d;scrollbar-face-color:rgba(0,0,0,.1);scrollbar-highlight-color:#7d7e94;scrollbar-shadow-color:#2d2c4d;scrollbar-track-color:rgba(0,0,0,.1)}body .ps>.ps__scrollbar-y-rail>.ps__scrollbar-y{width:8px!important;border-radius:2px!important}body .ps:hover>.ps__scrollbar-y-rail:hover{background:transparent}.scrollbar--horizontal,.scrollbar--vertical{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;background-color:rgba(0,0,0,.5)}.scrollbar--view{-ms-overflow-style:none}.browser--ie .scrollbar--view{margin:0!important}.ps-container:hover .ps-scrollbar-x-rail,.ps-container:hover .ps-scrollbar-y-rail{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=30);opacity:.3}.ps-container>.ps-scrollbar-y-rail{width:10px}.ps-container>.ps-scrollbar-y-rail:hover .ps-scrollbar-y{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;width:6px}.sidebar--right .search-bar__container .channel-header__links{line-height:25px}.icon--rotate{-webkit-animation:spin .7s infinite linear;-moz-animation:spin .7s infinite linear;-ms-animation:spin .7s infinite linear;-o-animation:spin .7s infinite linear;animation:spin .7s infinite linear}.search-item-snippet{overflow:hidden;*zoom:1;text-overflow:ellipsis}.search-item-snippet ol,.search-item-snippet ul{padding-left:20px}.search__icon{left:10px;position:absolute;top:8px}.sidebar__search-clear{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;margin-right:30px;right:0;top:12px;visibility:hidden;width:40px}.search__filter-toggle,.sidebar__search-clear{color:rgba(0,0,0,.5);cursor:pointer;position:absolute}.search__filter-toggle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=55);opacity:.55;font-size:15px;line-height:20px;right:12px;text-decoration:none;top:8px}.search__filter-toggle.open,.search__filter-toggle:focus,.search__filter-toggle:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;color:rgba(0,0,0,.5);text-decoration:none}.search__filter-toggle.active,.search__filter-toggle.active:focus,.search__filter-toggle.active:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;color:#2389d7}.search__filter-toggle .search__filter-count{background:#2389d7;border-radius:8px;color:#fff;display:inline-block;font-size:10px;line-height:14px;margin-left:2px;min-width:14px;padding:0 4px;position:relative;text-align:center;top:-6px}.search-filters-panel{background:#fff;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 18px rgba(0,0,0,.18);color:#404040;font-size:13px;line-height:normal;max-width:calc(100vw - 20px);padding:12px 14px 10px;position:absolute;right:0;text-align:left;top:42px;width:440px;z-index:90}.search-filters-panel .search-filters__row{display:-webkit-flex;display:flex;align-items:flex-start;margin-bottom:10px}.search-filters-panel .search-filters__label{-webkit-flex:none;flex:none;color:rgba(0,0,0,.5);line-height:30px;padding-right:8px;width:64px}.search-filters-panel .search-filters__field{-webkit-flex:1 1 auto;flex:1 1 auto;min-width:0;position:relative}.search-filters-panel .form-control{box-shadow:none;font-size:13px;height:30px;padding:4px 8px}.search-filters-panel .search-filters__muted{color:rgba(0,0,0,.5);line-height:30px}.search-filters-panel .search-filters__scope{line-height:30px}.search-filters-panel .search-filters__scope-btn{border:1px solid rgba(0,0,0,.15);border-radius:15px;color:#404040;cursor:pointer;display:inline-block;line-height:20px;margin:4px 6px 0 0;max-width:100%;overflow:hidden;padding:3px 12px;text-decoration:none;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.search-filters-panel .search-filters__scope-btn:focus,.search-filters-panel .search-filters__scope-btn:hover{border-color:#2389d7;color:#2389d7;text-decoration:none}.search-filters-panel .search-filters__scope-btn.active,.search-filters-panel .search-filters__scope-btn.active:focus,.search-filters-panel .search-filters__scope-btn.active:hover{background:#2389d7;border-color:#2389d7;color:#fff}.search-filters-panel .search-filters__typeahead{position:relative}.search-filters-panel .search-filters__suggest{background:#fff;border:1px solid rgba(0,0,0,.15);border-radius:3px;box-shadow:0 4px 12px rgba(0,0,0,.15);left:0;list-style:none;margin:2px 0 0;max-height:230px;overflow-y:auto;padding:4px 0;position:absolute;right:0;top:100%;z-index:95}.search-filters-panel .search-filters__suggest li{display:-webkit-flex;display:flex;align-items:center;cursor:pointer;overflow:hidden;padding:5px 10px;white-space:nowrap}.search-filters-panel .search-filters__suggest li.selected,.search-filters-panel .search-filters__suggest li:hover{background:rgba(35,137,215,.08)}.search-filters-panel .search-filters__suggest li img{border-radius:50%;height:20px;margin-right:8px;width:20px}.search-filters-panel .search-filters__suggest li .fa{color:rgba(0,0,0,.5);margin-right:8px;text-align:center;width:20px}.search-filters-panel .search-filters__suggest li .search-filters__suggest-label{overflow:hidden;text-overflow:ellipsis}.search-filters-panel .search-filters__suggest li .search-filters__suggest-sub{color:#999;font-size:12px;margin-left:6px;overflow:hidden;text-overflow:ellipsis}.search-filters-panel .search-filters__suggest .search-filters__suggest-empty{color:#999;cursor:default}.search-filters-panel .search-filters__suggest .search-filters__suggest-empty:hover{background:none}.search-filters-panel .search-filters__chips{display:-webkit-flex;display:flex;flex-wrap:wrap;margin-top:6px}.search-filters-panel .search-filters__chip{background:rgba(35,137,215,.1);border-radius:12px;color:#2389d7;font-size:12px;line-height:18px;margin:0 6px 4px 0;max-width:100%;overflow:hidden;padding:2px 8px;text-overflow:ellipsis;white-space:nowrap}.search-filters-panel .search-filters__chip .fa{margin-right:4px}.search-filters-panel .search-filters__chip a{color:inherit;font-weight:700;margin-left:5px;text-decoration:none}.search-filters-panel .search-filters__chip a:hover{color:#185f95}.search-filters-panel .search-filters__actions{display:-webkit-flex;display:flex;align-items:center;border-top:1px solid rgba(0,0,0,.15);justify-content:flex-end;margin-top:4px;padding-top:8px}.search-filters-panel .search-filters__actions .search-filters__hint{-webkit-flex:1 1 auto;flex:1 1 auto;color:#999;font-size:12px}.search-filters-panel .search-filters__actions .btn{margin-left:6px}.search__form{position:relative}.search-bar__container .search__form{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;border:1px solid rgba(0,0,0,.15);margin:16px 10px 0 0;width:480px}@media (max-width:1440px){.search-bar__container .search__form{width:380px}}.sidebar--right .search__form{width:100%}.search__form .search-bar{background:transparent;border:none;box-shadow:none;font-size:14px;height:35px;outline:none;padding:0 64px 0 40px;width:100%}.search__form .fa-spin{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;font-size:1.2em;position:absolute;right:27px;top:27px}.search-bar__container .search__form .fa-spin{right:12px;top:10px}.search-items-container{-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-overflow-scrolling:touch;height:calc(100% - 56px);overflow:auto;padding-top:10px;position:relative}.search-items-container .filterTeam,.search-items-container .markAsRead{margin-left:15px}.search-items-container div.loading{text-align:center}.search-items-container img{display:inline-block}.search-results-header{border-bottom:1px solid #ddd;color:#999;font-size:1em;font-weight:400;height:44px;line-height:44px;padding:0 10px;text-transform:uppercase}.search-item__container .post{margin:0;padding:0 1em 1em}.search-item__container .post:first-child{border:none}.search-item__container .post .post__header{padding-right:70px}.search-item__container .post .search-channel__name{font-weight:600;margin:0 0 10px}.col__controls{font-size:13px;position:absolute;right:0;top:0}.col__controls a{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;vertical-align:top}.col__controls a:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.col__controls .search-item__jump{font-size:13px;position:relative;top:1px}.col__controls .search-item__comment{margin-right:5px}.search-item-time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;font-size:.9em}.search-results-none{padding:10px}.search-highlight{background-color:#ff0}.status-wrapper{display:inline-block;height:32px;position:relative}.status-wrapper .status{border-radius:100px;bottom:-4px;height:15px;line-height:0;margin:0;position:absolute;right:-3px;top:auto;width:15px}.modal .status-wrapper .status{bottom:-6px}.status-wrapper .status.status-edit{text-align:center}.status-wrapper .status.status-edit i{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;font-size:10px;position:relative;top:4px}.status-wrapper .status svg{max-height:11px;position:relative;top:2px}.status{display:inline-block;margin:0 7px 0 1px;position:relative;top:2px;width:15px}.status.status--group{border-radius:2px;font-size:10px;font-weight:600;height:15px;left:1px;line-height:14px;margin:0 9px 0 -1px;text-align:center;top:-2px;width:15px}.mentions__name .status.status--group{height:18px;left:0;line-height:18px;margin-left:0;margin-right:6px;text-align:center;width:17px}.status svg{max-height:14px}.status ellipse,.status i,.status path{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.status ellipse.away--icon,.status ellipse.online--icon,.status i.away--icon,.status i.online--icon,.status path.away--icon,.status path.online--icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.status .fa-lock{margin-left:1px}.status .fa-globe{position:relative;top:-1px}#status-dropdown{cursor:pointer}.suggestion-list{width:100%;z-index:100}.suggestion-list .suggestion-list__item:hover{background:rgba(0,0,0,.1)}.suggestion-list .suggestion-list__item .team-icon{-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px;margin-right:10px}.suggestion-list .suggestion-list__item.active:before{background:#000;content:\"\";height:100%;left:0;position:absolute;top:0;width:5px}.suggestion-list .suggestion-list__item.unread:before{background:#000;border-radius:50%;content:\"\";height:5px;left:1px;position:absolute;top:22px;width:5px}.suggestion-list .suggestion-list__item .badge{font-size:10px;position:absolute;left:36px;top:1px}.suggestion-list--top{bottom:100%;position:absolute}.suggestion-list--bottom{height:0}.suggestion-list__content{-webkit-overflow-scrolling:touch;background-color:#fff;border:1px solid #ddd;max-height:292px;overflow-x:hidden;overflow-y:scroll;padding-bottom:5px;width:100%}.suggestion-list__content .command{border-bottom:1px solid rgba(0,0,0,.15);font-size:.95em;line-height:24px;padding:5px 10px 8px;position:relative;width:100%;z-index:101}.suggestion-list__content .command .command__desc{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;line-height:normal;margin-left:5px}.suggestion-list__content--top{bottom:0;position:absolute}.suggestion-list--bottom{position:relative}.suggestion-loader{margin:6px 11px}.suggestion-list__divider{line-height:21px;margin:5px 0 5px 5px;position:relative}.suggestion-list__divider:first-child{margin-top:5px}.suggestion-list__divider>span{display:inline-block;font-size:.9em;padding:0 10px 0 5px;position:relative;z-index:5}.suggestion-list__divider:before{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background:rgba(0,0,0,.5);content:\"\";height:1px;left:0;position:absolute;top:11px;width:100%}.tooltip .tooltip-inner{font-size:13px;font-weight:500;padding:3px 10px 4px;-ms-word-break:break-all;word-break:break-all;word-break:break-word}.tooltip.text-nowrap .tooltip-inner{white-space:nowrap}#webrtcTooltip .tooltip-inner{word-break:normal}.tip-backdrop{background:rgba(0,0,0,.5);height:100%;left:0;position:absolute;top:0;width:100%;z-index:999}.tip-overlay{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background-color:#fff;max-width:90%;padding:20px;position:absolute;width:350px;z-index:1000}.tip-overlay .arrow{border:10px solid transparent;display:block;height:0;position:absolute;width:0}.tip-overlay.tip-overlay--sidebar{margin:50px 0 0 10px;max-width:75%;min-height:330px}.tip-overlay.tip-overlay--sidebar .tutorial__footer{bottom:20px;left:0;padding:0 20px;position:absolute;width:100%}.tip-overlay.tip-overlay--sidebar .arrow{border-left-width:0;border-right-color:#fff;left:-10px;margin-top:-10px;top:80px}.tip-overlay.tip-overlay--header--left{margin:10px 0 0 10px}.tip-overlay.tip-overlay--header--left .arrow{border-left-width:0;border-right-color:#fff;left:-10px;top:15px}.tip-overlay.tip-overlay--header--bottom{margin-top:-10px}.tip-overlay.tip-overlay--header--bottom .arrow{border-bottom-color:#fff;border-top-width:0;left:50%;margin-left:-10px;top:-10px}.tip-overlay.tip-overlay--chat{margin-top:-10px}.tip-overlay.tip-overlay--chat .arrow{border-bottom-width:0;border-top-color:#fff;bottom:-10px;left:50%;margin-left:-10px}.tip-overlay h4{font-size:1.14286em;font-weight:600;margin:5px 0 15px}.tip-overlay p{font-size:13px;line-height:1.6}.tip-overlay p strong{font-weight:600}.tip-overlay .btn{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:rgba(0,0,0,.3);border:none;color:#fff;margin:10px 0}.tip-overlay .btn:active,.tip-overlay .btn:focus,.tip-overlay .btn:hover{background:rgba(0,0,0,.4);border:none;color:#fff}.tip-overlay .tip-opt{font-size:12px}.tip-overlay .tip-opt span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.tip-overlay .tutorial__circles{margin:1.5em 0 -1.7em -4px}.tip-overlay .tutorial__circles .circle{height:7px;margin:0 4px;width:7px}.tip-button{cursor:pointer;position:relative;right:-10px;top:-10px;z-index:998}.tip-div{position:absolute;right:0;top:0}.tip-div.tip-overlay--header{right:2px;top:21px}.tip-div.tip-overlay--header .tip-button,.tip-div.tip-overlay--sidebar{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.tip-div.tip-overlay--sidebar{left:0;top:-9px}.tutorial-steps__container{display:table;height:100%;left:0;position:absolute;text-align:center;top:0;width:100%}.tutorial-steps__container .tutorial__content{display:table-cell;vertical-align:middle}.tutorial-steps__container .tutorial__content .tutorial__steps{display:inline-block;margin-bottom:50px;max-width:450px;min-height:480px;position:relative;text-align:left}.tutorial-steps__container .tutorial__footer{bottom:0;position:absolute}.tutorial-steps__container h1{font-size:2.85714em;font-weight:600;margin:-20px 0 30px}.tutorial-steps__container h3{font-size:1.71429em;font-weight:600;margin-bottom:30px}.tutorial-steps__container .tutorial__circles{bottom:25px;position:absolute}.tutorial-steps__container .tutorial-skip{margin-left:13px}.tutorial__circles{margin:2em 0}.tutorial__circles .circle{-webkit-border-radius:9px;-moz-border-radius:9px;-ms-border-radius:9px;-o-border-radius:9px;border-radius:9px;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background:#000;display:inline-block;height:9px;margin:0 5px;width:9px}.tutorial__circles .circle.active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;background:#2389d7}.tutorial__app-icons{margin:2em 0}.post .video-div{margin-bottom:8px;max-width:480px;position:relative}.post .video-div .video-thumbnail{height:auto;max-width:100%}.post .video-div .video-thumbnail__error{height:100%;line-height:2;padding:110px 0;text-align:center;width:100%}.post .video-div .video-thumbnail__error .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.post .video-div .video-thumbnail__error div{font-size:1.2em}.post .video-div .block{background-color:rgba(0,0,0,.5);border-radius:10px;height:150px;left:50%;margin:-75px 0 0 -100px;position:absolute;top:50%;width:200px}.post .video-type{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;font-size:15px;margin:0;padding:0}.post .video-title{font-size:15px;margin-top:3px}.post .play-button{-webkit-border-radius:14px;-moz-border-radius:14px;-ms-border-radius:14px;-o-border-radius:14px;border-radius:14px;border:4px solid hsla(0,0%,100%,.4);height:100px;position:absolute;right:51px;top:26px;width:100px}.post .play-button span{border-bottom:36px solid transparent;border-left:60px solid hsla(0,0%,100%,.4);border-top:36px solid transparent;height:0;left:20px;position:absolute;top:10px;width:0}.post .img-div{-moz-force-broken-image-icon:1;border-radius:5px;margin-bottom:8px;max-height:500px;max-width:450px;position:relative}.post .img-div.placeholder{height:500px}.sidebar--right .post .img-div{max-width:100%}.post .video-loading{height:360px}.webrtc__header .webrtc__button.offline{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.webrtc__header svg{position:relative}.webrtc__notification--rhs{background:#00a6ee;border-radius:3px 0 0 3px;color:#fff;cursor:pointer;left:50%;margin-left:-150px;overflow:hidden;padding:10px 15px;position:absolute;text-align:center;text-overflow:ellipsis;top:0;white-space:nowrap;width:300px;z-index:9999}.webrtc__notification--rhs:empty{display:none}.webrtc__notification--rhs .fa{margin-right:6px}.webrtc__error{padding:0 20px;text-align:center}.sidebar--right--expanded .webrtc__error{padding:0 20px;position:absolute;text-align:center;width:100%}.webrtc__error .form-group{padding:0 20px;position:relative;text-align:center;z-index:9999}.webrtc__error .control-label{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#f2f2f2;color:rgba(0,0,0,.7);font-size:14px;font-weight:400;margin:1em 0 -1em;padding:.7em 1em}.webrtc__error .has-error .control-label{color:#a94442;font-size:.95em}.webrtc__error .has-error .control-label.warning{color:#444}.webrtc__error .has-error .control-label.warning:before{display:none}.webrtc__error .has-error .control-label:before{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:#a94442;content:\"\\F071\";display:inline-block;font:normal normal normal 14px/1 FontAwesome;margin-right:4px;text-rendering:auto;transform:translate(0)}#videos{background:#000;font-size:0;height:300px;left:0;position:relative;text-align:center;width:100%}#videos #main-video video{height:100%;left:0;position:absolute;top:0;width:100%}#videos #local-video{border:1px solid gray;max-width:30%;opacity:1;position:absolute;right:10px;top:10px;transition:opacity 1s;z-index:2}#videos #local-video.full{background:#000;border:none;height:100%;max-width:100%!important;right:0;top:0;width:100%}#videos #local-video video{-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);-o-transform:scaleX(-1);-webkit-transform:scaleX(-1);height:100%;max-height:100%;max-width:100%;object-fit:cover;transform:scaleX(-1);transition:opacity 1s;width:100%}#videos .webrtc__local-image{position:absolute;right:10px;top:10px;z-index:2}#videos .webrtc__local-image img{border-radius:50%;height:64px;max-width:100%;width:64px}#videos .webrtc__remote-image{background-color:#000;border:1px solid rgba(0,0,0,.2);padding:40px 0}#videos .webrtc__remote-image img{border-radius:50%;max-height:128px;max-width:128px;width:100%}#videos .webrtc__remote-mute{bottom:0;position:absolute;right:10px;z-index:9999}.webrtc-buttons{margin-top:1.2em;text-align:center}.webrtc-buttons .webrtc-icons__call{border-radius:48px}.webrtc-buttons .webrtc-icons__call circle{fill:#00a6ee}.webrtc-buttons .webrtc-icons__call:hover{cursor:pointer}.webrtc-buttons .webrtc-icons__call:hover circle{fill:#0094d5}.webrtc-buttons .webrtc-icons__call[disabled] circle{fill:#aaa}.webrtc-buttons .webrtc-icons__cancel{border-radius:48px}.webrtc-buttons .webrtc-icons__cancel circle{fill:#e41020}.webrtc-buttons .webrtc-icons__cancel:hover{cursor:pointer}.webrtc-buttons .webrtc-icons__cancel:hover circle{fill:#cc0e1d}.webrtc-icons.active svg{transform:translateY(0)}.webrtc-icons svg{border-radius:48px;margin:5px}.webrtc-icons svg path.on{display:block}.webrtc-icons svg path.off{display:none}.connecting{position:absolute;top:0;width:100%}.connecting .loading-screen{background-color:rgba(0,0,0,.3);color:#fff;margin-left:5px;padding:20px;position:relative;top:75px;width:97%}.connecting .loading-screen .loading__content .round{background:#fff!important}.webrtc-notification{background-color:rgba(112,128,144,.8);color:#fff;left:calc(50% - 200px);padding:20px 30px 10px;position:absolute;text-align:center;top:calc(50% - 115px);width:400px;z-index:99999}.webrtc-notification .webrtc-buttons{margin-top:1.2em;text-align:center}.webrtc-notification .webrtc-buttons .webrtc-icons__pickup circle{fill:#73b001}.webrtc-notification .webrtc-buttons .webrtc-icons__pickup:hover{cursor:pointer}.webrtc-notification .webrtc-buttons .webrtc-icons__pickup:hover circle{fill:#69a101}.webrtc-participants{bottom:-5px;position:absolute;width:100%;margin-top:1.2em;text-align:left}.webrtc-participants .item{margin-left:1em;display:inline-block}.webrtc-participants .webrtc-icons__invite:hover{cursor:pointer}.sidebar--right--expanded #videos{height:calc(100% - 90px);position:absolute}.sidebar--right--expanded #videos #main-video{height:100%}.sidebar--right--expanded #videos #main-video video{height:100%;width:100%}.sidebar--right--expanded .webrtc-buttons{bottom:15px;position:absolute;width:100%}.sidebar--right--expanded #videos #local-video{max-width:200px}.sidebar--right--expanded #videos.small{position:relative}.intl-tel-input .country-list .flag-box{display:none!important}.intl-tel-input .iti-flag{display:none}.intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code{padding-left:18px!important}.fa-stack.verified-icon{margin-left:3px;width:1.5em;height:1.5em;line-height:1.5em}.fa-stack.verified-icon .fa-stack-2x{font-size:1.5em}.fa-stack.verified-icon .fa-stack-1x{font-size:.7em}.fa-stack.verified-icon .fa-certificate{color:#007aff}.inner-wrap.move--left .search-bar__container,.inner-wrap.move--left .search-btns,.inner-wrap.webrtc--show .search-bar__container,.inner-wrap.webrtc--show .search-btns{display:none}.inner-wrap.move--left .header-list__right,.inner-wrap.webrtc--show .header-list__right{float:right;padding-right:0!important;position:relative;z-index:6}.inner-wrap.move--right .search-bar__container,.inner-wrap.move--right .search-btns{display:none}.inner-wrap.move--right .header-list__right{float:right;margin-right:-18px;padding-right:0!important;position:relative;z-index:6}.app__content{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;background:#fff;height:100%;margin-left:220px;padding-top:50px;position:relative}.channel__wrap .app__content{padding-top:0}#archive-link-home{-webkit-flex:0 0 auto;flex:0 0 auto;cursor:pointer;font-size:13px}#archive-link-home .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;font-size:11px}#archive-link-home a{color:inherit;display:block;padding:10px 20px;width:100%}.delete-message-text{margin-top:10px}.col-sm-auto{padding-left:15px;padding-right:15px}.footer-pane{background:#efeff4;padding-bottom:1em}.footer-pane .footer-link{padding:0 1.5em;color:#007aff;font-weight:600}.footer-pane .footer-link.copyright{color:#8e8e93;padding-right:0}.footer-pane .footer-site-name{font-size:14px;font-weight:700;padding:1.5em 0 1em;text-transform:uppercase}.footer,.footer-pane,.footer-push{height:89px}.checkbox.margin-bottom--none,.radio.margin-bottom--none{margin-bottom:0}.form-horizontal .modal-intro{margin:-10px 0 30px}.form-horizontal .form__label{font-size:1.1em;font-weight:600;padding-right:3px;text-align:left}.form-horizontal .form__label.light{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;font-size:1.05em;font-style:italic;font-weight:400;padding-top:2px}.form-horizontal .input__help{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;color:inherit;margin:10px 0 0;word-break:break-word}.form-horizontal .input__help.dark{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.form-horizontal .input__help.error{color:#952321}.form-horizontal .form-control{font-weight:400}.form-horizontal .wvc-theme .form-group{margin-left:0!important;margin-right:0!important}.form-horizontal .form-group{margin-bottom:25px}.form-horizontal .form-group.less{margin-bottom:10px}.help-block{color:rgba(0,0,0,.5);font-size:.95em;margin:10px 0 0}.form-group.form-group--small{margin-bottom:10px}.has-error .checkbox,.has-error .checkbox-inline,.has-error .help-block,.has-error .radio,.has-error .radio-inline{color:#d64946}.has-error .form__label.control-label{color:inherit!important}.has-error.checkbox-inline label,.has-error.checkbox label,.has-error.radio-inline label,.has-error.radio label{color:#d64946}.channel-header{-webkit-flex:0 0 70px;flex:0 0 70px;border-bottom:1px solid;font-size:14px;position:relative;width:100%;z-index:9}.channel-header .flex-parent{display:flex}.channel-header .info-icon{position:relative;top:15px;line-height:1;cursor:pointer}.channel-header .flex-child:first-child{min-width:50px;text-align:center}.channel-header .flex-child:nth-child(0n+2){flex:1;min-width:0}.channel-header .flex-child .markdown__paragraph-inline{overflow:hidden;text-overflow:ellipsis;width:calc(100% - 50px)}.channel-header .channel-header__icon{-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%;border-radius:50%;border:1px solid;cursor:pointer;height:37px;line-height:36px;margin:16px 10px 0 0;min-width:30px;text-align:center;width:37px}.channel-header .channel-header__icon.wide{-webkit-border-radius:37px;-moz-border-radius:37px;-ms-border-radius:37px;-o-border-radius:37px;border-radius:37px;padding:0;white-space:nowrap;width:auto}.channel-header .channel-header__icon.wide>div{padding:0 13px 0 15px}.channel-header .channel-header__icon .icon__text{font-weight:600;margin-right:9px}.channel-header .channel-header__icon a{display:block}.channel-header .channel-header__icon .fa{font-size:19px}.channel-header .channel-header__icon+div{display:none}.channel-header .channel-header__icon .icon{position:relative}.channel-header .channel-header__icon .icon__members,.channel-header .channel-header__icon .icon__pin{top:2px}.channel-header .channel-header__icon .icon__dm{top:3px;left:-2px}.channel-header .channel-header__icon .icon__find-channel{top:3px}.channel-header .channel-header__icon .icon__live,.channel-header .channel-header__icon .icon__video,.channel-header .channel-header__icon .icon__voice{top:4px}.channel-header .channel-header__icon .icon__mentions{top:5px}.channel-header .channel-header__icon .icon__flag,.channel-header .channel-header__icon .icon__unread{top:3px}.channel-header .channel-header__icon .badge-unread{background:#d64946;position:absolute;top:6px;right:10px;z-index:100}.move--left .channel-header .icon--hidden{display:none}.channel-header.alt{margin:0}.channel-header.alt th{font-weight:400;vertical-align:top}.channel-header.alt th.header-list__right{padding-right:4px;white-space:nowrap}.channel-header.alt td{border:none}.channel-header .heading{display:inline-block;font-size:17px;font-weight:400;margin:0 4px 0 0;max-width:100%;overflow:hidden;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.channel-header .caret{margin-top:3px}.channel-header .more{color:#81848b;display:inline-block;font-size:13px;text-transform:capitalize;vertical-align:top}.channel-header .disabled{color:#999}.channel-header .tab-like{padding-right:20px;padding-left:20px;display:inline-block;text-align:center;height:0;border-width:0 20px 20px;border-style:solid}.channel-header .tab-like.clickable{cursor:pointer}.channel-header .tab-like.width-fix{padding-right:45px}.row.header{position:relative}.channel__wrap .row.header{display:none}.sidebar--left .team-header,.team__header-container{padding-bottom:0!important}.header-dropdown__icon{color:inherit;font-size:21px;margin-left:1px;position:relative;top:2px}.channel-header__info{margin-top:12px;white-space:nowrap}.channel-header__info .channel-header__title.dropdown.btn-group{display:block}.channel-header__info .channel-header__title.dropdown.btn-group.open .dropdown-toggle{box-shadow:none}.channel-header__info .channel-header__title .header-dropdown__icon{color:rgba(0,0,0,.5)}.channel-header__info .channel-header__title>a{display:inline-block;text-decoration:none;width:calc(100% - 105px)}.channel-header__info .channel-header__title .modal{white-space:normal}.channel-header__info .channel-header__title .icon{margin-left:10px;position:relative}.channel-header__info .channel-header__title .icon.icon__switch{top:4px}.channel-header__info .channel-header__title .icon.icon__add{top:2px}.channel-header__info .channel-header__description{height:19px;margin-top:3px;margin-bottom:13px;overflow:hidden;position:relative;text-overflow:ellipsis;width:calc(100% - 18px)}.channel-header__info .channel-header__description .markdown__heading{font-size:1em;margin:0}.channel-header__info .channel-header__description.light{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;color:inherit}.channel-header__info .channel-header__description.light:focus,.channel-header__info .channel-header__description.light:hover{color:inherit}.channel-header__info .channel-header__description .markdown-inline-img{max-height:45px}.channel-header__info .status{width:18px}.channel-header__info .status svg{max-height:20px;width:16px}.channel-intro{margin:0 auto 10px;padding:0 15px}.channel-intro.channel-intro--centered{max-width:1020px}.channel-intro .intro-links{display:inline-block;margin:0 1.5em 10px 0}.channel-intro .intro-links .fa{margin-right:5px}.channel-intro .channel-intro-profile{margin-top:5px}.channel-intro .channel-intro-profile .user-popover{max-width:calc(100% - 100px);overflow:hidden;text-overflow:ellipsis}.channel-intro .channel-intro-img .status-wrapper{height:50px;margin:0 10px 10px 0}.channel-intro .channel-intro-img img{-webkit-border-radius:100px;-moz-border-radius:100px;-ms-border-radius:100px;-o-border-radius:100px;border-radius:100px}.channel-intro .channel-intro__title{font-size:20px;font-weight:600;margin-bottom:15px}.channel-intro .channel-intro__content{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#f5f5f5;padding:10px 15px}.admin-sidebar .divider,.sidebar--left .divider,.sidebar--menu .divider{border-top:1px solid transparent;margin:.5em 0}.admin-sidebar .divider+.divider,.sidebar--left .divider+.divider,.sidebar--menu .divider+.divider{display:none}.admin-sidebar .team__header,.sidebar--left .team__header,.sidebar--menu .team__header{height:50px;*zoom:1;display:-webkit-flex;display:flex;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;padding:6px 40px 3px 12px;position:relative}.admin-sidebar .team__header:after,.sidebar--left .team__header:after,.sidebar--menu .team__header:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.admin-sidebar .team__header:before,.sidebar--left .team__header:before,.sidebar--menu .team__header:before{-webkit-transition:all .05s linear;-webkit-transition-delay:0s;-moz-transition:all .05s linear;-o-transition:all .05s linear;transition:all false .05s linear;background:none;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}.admin-sidebar .team__header:hover:before,.sidebar--left .team__header:hover:before,.sidebar--menu .team__header:hover:before{background:rgba(0,0,0,.1)}.admin-sidebar .team__header:hover .user__name,.sidebar--left .team__header:hover .user__name,.sidebar--menu .team__header:hover .user__name{color:#fff}.admin-sidebar .team__header:hover .navbar-right .dropdown-toggle,.admin-sidebar .team__header:hover .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--left .team__header:hover .navbar-right .dropdown-toggle,.sidebar--left .team__header:hover .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--menu .team__header:hover .navbar-right .dropdown-toggle,.sidebar--menu .team__header:hover .sidebar-header-dropdown .sidebar-header-dropdown__toggle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.admin-sidebar .team__header a,.sidebar--left .team__header a,.sidebar--menu .team__header a{text-decoration:none;-webkit-flex-grow:1;flex-grow:1}.admin-sidebar .team__header .admin-navbar-dropdown,.admin-sidebar .team__header .sidebar-header-dropdown,.sidebar--left .team__header .admin-navbar-dropdown,.sidebar--left .team__header .sidebar-header-dropdown,.sidebar--menu .team__header .admin-navbar-dropdown,.sidebar--menu .team__header .sidebar-header-dropdown{font-size:.85em;height:100%;left:0;margin-right:-22px;position:absolute;right:22px;top:0}.admin-sidebar .team__header .admin-navbar-dropdown li,.admin-sidebar .team__header .sidebar-header-dropdown li,.sidebar--left .team__header .admin-navbar-dropdown li,.sidebar--left .team__header .sidebar-header-dropdown li,.sidebar--menu .team__header .admin-navbar-dropdown li,.sidebar--menu .team__header .sidebar-header-dropdown li{width:100%}.admin-sidebar .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.admin-sidebar .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--left .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.sidebar--left .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--menu .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.sidebar--menu .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle{padding:0 10px}.admin-sidebar .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.admin-sidebar .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle,.sidebar--left .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.sidebar--left .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle,.sidebar--menu .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.sidebar--menu .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle{padding:10px}.admin-sidebar .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.admin-sidebar .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.admin-sidebar .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle,.admin-sidebar .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--left .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.sidebar--left .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.sidebar--left .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle,.sidebar--left .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle,.sidebar--menu .team__header .admin-navbar-dropdown .admin-navbar-dropdown__toggle,.sidebar--menu .team__header .admin-navbar-dropdown .sidebar-header-dropdown__toggle,.sidebar--menu .team__header .sidebar-header-dropdown .admin-navbar-dropdown__toggle,.sidebar--menu .team__header .sidebar-header-dropdown .sidebar-header-dropdown__toggle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;-webkit-transition:all .1s linear;-webkit-transition-delay:0s;-moz-transition:all .1s linear;-o-transition:all .1s linear;transition:all false .1s linear;background:none;color:#fff;display:block;font-size:1em;height:100%;left:0;line-height:1.8;width:100%}.admin-sidebar .team__header .admin-navbar-dropdown .dropdown-menu,.admin-sidebar .team__header .sidebar-header-dropdown .dropdown-menu,.sidebar--left .team__header .admin-navbar-dropdown .dropdown-menu,.sidebar--left .team__header .sidebar-header-dropdown .dropdown-menu,.sidebar--menu .team__header .admin-navbar-dropdown .dropdown-menu,.sidebar--menu .team__header .sidebar-header-dropdown .dropdown-menu{margin-right:10px;margin-top:4px;width:199px}.admin-sidebar .team__header .admin-navbar-dropdown .dropdown-menu a,.admin-sidebar .team__header .sidebar-header-dropdown .dropdown-menu a,.sidebar--left .team__header .admin-navbar-dropdown .dropdown-menu a,.sidebar--left .team__header .sidebar-header-dropdown .dropdown-menu a,.sidebar--menu .team__header .admin-navbar-dropdown .dropdown-menu a,.sidebar--menu .team__header .sidebar-header-dropdown .dropdown-menu a{overflow:hidden;padding:3px 20px;text-overflow:ellipsis}.admin-sidebar .team__header .admin-navbar-dropdown .admin-navbar-dropdown__icon,.admin-sidebar .team__header .admin-navbar-dropdown .sidebar-header-dropdown__icon,.admin-sidebar .team__header .sidebar-header-dropdown .admin-navbar-dropdown__icon,.admin-sidebar .team__header .sidebar-header-dropdown .sidebar-header-dropdown__icon,.sidebar--left .team__header .admin-navbar-dropdown .admin-navbar-dropdown__icon,.sidebar--left .team__header .admin-navbar-dropdown .sidebar-header-dropdown__icon,.sidebar--left .team__header .sidebar-header-dropdown .admin-navbar-dropdown__icon,.sidebar--left .team__header .sidebar-header-dropdown .sidebar-header-dropdown__icon,.sidebar--menu .team__header .admin-navbar-dropdown .admin-navbar-dropdown__icon,.sidebar--menu .team__header .admin-navbar-dropdown .sidebar-header-dropdown__icon,.sidebar--menu .team__header .sidebar-header-dropdown .admin-navbar-dropdown__icon,.sidebar--menu .team__header .sidebar-header-dropdown .sidebar-header-dropdown__icon{border-radius:36px;fill:#fff;float:right;height:36px;line-height:36px;position:relative;right:-3px;text-align:center;top:7px;width:36px}.admin-sidebar .team__header .user__picture,.sidebar--left .team__header .user__picture,.sidebar--menu .team__header .user__picture{-webkit-border-radius:36px;-moz-border-radius:36px;-ms-border-radius:36px;-o-border-radius:36px;border-radius:36px;float:left;height:36px;width:36px}.admin-sidebar .team__header .header__info,.sidebar--left .team__header .header__info,.sidebar--menu .team__header .header__info{overflow:hidden;*zoom:1;-webkit-flex-grow:1;flex-grow:1;color:#fff;padding-left:8px;position:relative}.admin-sidebar .team__header .team__name,.admin-sidebar .team__header .user__name,.admin-sidebar .team__header .user__nickname,.sidebar--left .team__header .team__name,.sidebar--left .team__header .user__name,.sidebar--left .team__header .user__nickname,.sidebar--menu .team__header .team__name,.sidebar--menu .team__header .user__name,.sidebar--menu .team__header .user__nickname{display:block;font-size:14px;font-weight:600;max-width:100%;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.admin-sidebar .team__header a.user__nickname:hover,.sidebar--left .team__header a.user__nickname:hover,.sidebar--menu .team__header a.user__nickname:hover{text-decoration:underline}.admin-sidebar .team__header .user__nickname,.sidebar--left .team__header .user__nickname,.sidebar--menu .team__header .user__nickname{position:relative;z-index:2;font-style:italic;color:inherit}.admin-sidebar .team__header .team__name,.sidebar--left .team__header .team__name,.sidebar--menu .team__header .team__name{display:none;line-height:22px}.admin-sidebar .team__header .user__name,.sidebar--left .team__header .user__name,.sidebar--menu .team__header .user__name{-webkit-transition:all .1s linear;-webkit-transition-delay:0s;-moz-transition:all .1s linear;-o-transition:all .1s linear;transition:all false .1s linear;color:hsla(0,0%,100%,.8);font-size:14px;font-weight:400;line-height:18px}.admin-sidebar .team__header .user__nickname,.sidebar--left .team__header .user__nickname,.sidebar--menu .team__header .user__nickname{font-weight:400}.admin-sidebar .team__header .status-over-background,.sidebar--left .team__header .status-over-background,.sidebar--menu .team__header .status-over-background{position:relative;top:-24px}.admin-sidebar .team__header .status-over-background .status-wrapper,.sidebar--left .team__header .status-over-background .status-wrapper,.sidebar--menu .team__header .status-over-background .status-wrapper{padding:1px;width:50px;border-radius:100%;height:50px;background-color:#fff}.admin-sidebar .team__header .status-over-background .status-wrapper img.user__picture,.sidebar--left .team__header .status-over-background .status-wrapper img.user__picture,.sidebar--menu .team__header .status-over-background .status-wrapper img.user__picture{width:48px;height:48px}.admin-sidebar .layout-switcher,.sidebar--left .layout-switcher,.sidebar--menu .layout-switcher{cursor:pointer;line-height:20px;padding:5px 10px;text-align:center;position:relative}.admin-sidebar .layout-switcher:before,.sidebar--left .layout-switcher:before,.sidebar--menu .layout-switcher:before{-webkit-transition:all .05s linear;-webkit-transition-delay:0s;-moz-transition:all .05s linear;-o-transition:all .05s linear;transition:all false .05s linear;background:none;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}.admin-sidebar .layout-switcher:hover:before,.sidebar--left .layout-switcher:hover:before,.sidebar--menu .layout-switcher:hover:before{background:rgba(0,0,0,.1)}.admin-sidebar .layout-switcher:hover .icon,.sidebar--left .layout-switcher:hover .icon,.sidebar--menu .layout-switcher:hover .icon{-webkit-transform:rotateY(180deg);-moz-transform:rotateY(180deg);-ms-transform:rotateY(180deg);-o-transform:rotateY(180deg);transform:rotateY(180deg)}.admin-sidebar .layout-switcher span.icon,.sidebar--left .layout-switcher span.icon,.sidebar--menu .layout-switcher span.icon{display:inline-block;-webkit-transition:-webkit-transform,.35s ease-in-out;-moz-transition:-moz-transform,.35s ease-in-out;-o-transition:-o-transform,.35s ease-in-out;transition:transform,.35s ease-in-out;position:relative;top:-2px;margin-right:8px}.admin-sidebar .layout-switcher span.icon svg,.sidebar--left .layout-switcher span.icon svg,.sidebar--menu .layout-switcher span.icon svg{vertical-align:bottom}.admin-sidebar.new-sidebar .profile-background,.sidebar--left.new-sidebar .profile-background,.sidebar--menu.new-sidebar .profile-background{height:130px}.admin-sidebar.new-sidebar .profile-background .background-placeholder,.sidebar--left.new-sidebar .profile-background .background-placeholder,.sidebar--menu.new-sidebar .profile-background .background-placeholder{padding-top:33px}.admin-sidebar.new-sidebar .team__header .status-over-background,.sidebar--left.new-sidebar .team__header .status-over-background,.sidebar--menu.new-sidebar .team__header .status-over-background{position:relative;top:-32px}.admin-sidebar.new-sidebar .team__header .status-over-background .status-wrapper,.sidebar--left.new-sidebar .team__header .status-over-background .status-wrapper,.sidebar--menu.new-sidebar .team__header .status-over-background .status-wrapper{padding:1px;width:66px;border-radius:100%;height:66px;background-color:#fff}.admin-sidebar.new-sidebar .team__header .status-over-background .status-wrapper img.user__picture,.sidebar--left.new-sidebar .team__header .status-over-background .status-wrapper img.user__picture,.sidebar--menu.new-sidebar .team__header .status-over-background .status-wrapper img.user__picture{width:64px;height:64px}.admin-sidebar .profile-background,.sidebar--left .profile-background,.sidebar--menu .profile-background{height:100px;cursor:pointer;text-align:center}.admin-sidebar .profile-background .background-placeholder,.sidebar--left .profile-background .background-placeholder,.sidebar--menu .profile-background .background-placeholder{padding-top:17px}.admin-sidebar .profile-background .background-placeholder svg,.sidebar--left .profile-background .background-placeholder svg,.sidebar--menu .profile-background .background-placeholder svg{width:64px;height:64px}.admin-sidebar .search__clear,.sidebar--left .search__clear,.sidebar--menu .search__clear{display:none}.admin-sidebar .team__header{height:unset;padding:16px 40px 12px 12px}.sidebar--left .team__name,.sidebar--menu .team__name{display:none}#navbar .navbar-default .navbar-toggle.menu-toggle{padding:0 1em}.channel-header__navbar{font-size:16px}.channel-header__navbar .heading{margin-right:3px}.channel-header__navbar .header-dropdown__icon{top:1px}.channel-header__favorites{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;float:left;height:20px;margin:0 8px 0 0;padding-top:3px;position:relative;z-index:1}.channel-header__favorites.inactive,.channel-header__favorites.inactive:active,.channel-header__favorites.inactive:hover{color:inherit}.channel-header__favorites.active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.channel-header__favorites i{font-size:17px}.app__body .channel-header__links{display:inline-block;font-family:Open Sans,sans-serif;font-size:22px;height:30px;line-height:26px;margin-right:1px;text-align:center;width:30px}.app__body .channel-header__links th:last-child div{margin-right:10px}.channel__wrap.move--left .app__body .channel-header__links,.channel__wrap.webrtc--show .app__body .channel-header__links{position:absolute;right:-400px;top:14px}.app__body .channel-header__links .icon__flag svg{height:19px;position:relative;top:2px;width:19px}.app__body .channel-header__links>a{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;-webkit-transition:all .1s ease-in;-webkit-transition-delay:0s;-moz-transition:all .1s ease-in;-o-transition:all .1s ease-in;transition:all false .1s ease-in;color:inherit;text-decoration:none}.app__body .channel-header__links>a:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.app__body .channel-header__links>a:focus{color:inherit}.app__body .channel-header__links>a.active{color:#2389d7;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .channel-header__links>a.active .icon{fill:#2389d7}h1{font-size:28px}h2{font-size:25px}h3{font-size:22px}h4{font-size:19px}h5{font-size:15px}h6{font-size:1em}.markdown__heading{font-weight:700;line-height:1.5;margin:10px 0}.markdown__heading:first-child{margin:5px 0 10px}.markdown__heading .emoticon{min-height:1.5em;min-width:1.5em;vertical-align:top}.markdown__paragraph-inline{display:inline}.markdown__paragraph-inline+.markdown__paragraph-inline{margin-left:4px}#post-list .markdown-inline-img{-moz-force-broken-image-icon:1;margin:5px 0;max-height:500px}.post-code{overflow-x:auto;overflow-y:hidden;position:relative}.post-code code{border:1px solid #ddd;border-radius:.25em;font-size:13px;margin:5px 0;padding:6.5px;text-align:left;white-space:pre}.post-code td{padding:0 .5em;vertical-align:top}.post-code:hover .post-code__language{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.post-code--wrap code{white-space:pre-wrap}.post-code .hljs{position:relative;visibility:visible}.post-code__language{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:opacity,.6s;-moz-transition:opacity,.6s;-o-transition:opacity,.6s;transition:opacity,.6s;background:#21586d;border-radius:0 0 0 2px;color:#fff;padding:4px 10px 5px;position:absolute;right:0;top:5px;z-index:5}.post-code__language,.post-code__lineno{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.post-code__lineno{border-right:1px solid #aaa;color:#aaa;margin-right:.5em;text-align:right}.post-code__search-highlighting{color:transparent;right:6.5px;left:6.5px;pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.post__body hr{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background-color:#e7e7e7;border:0 none;height:4px;margin:15px 0 16px;padding:0}.post__body .codespan__pre-wrap code{white-space:pre-wrap}.markdown__table{background:#fff;margin:5px 0 10px}.markdown__table td,.markdown__table th{border:1px solid #ddd;padding:6px 13px}.markdown__table tbody tr{background:#fff}.markdown__table tbody tr:nth-child(2n){background-color:#f8f8f8}blockquote{border:none;font-size:16px;margin-bottom:0;padding:10px 10px 10px 38px;position:relative}blockquote:before{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;content:\"\\F10D\";display:inline-block;font-family:FontAwesome;font-size:20px;font-style:normal;font-weight:400;left:8px;position:absolute;text-decoration:inherit;top:5px}pre{margin:5px 0;padding:0}code,pre{color:inherit}code{background:#fff}.help code{background:rgba(51,51,51,.1)}.help .hljs{background:#f8f8f8;color:#333;display:block;overflow-x:auto;padding:.5em}.help .container{margin-bottom:40px}.help .links{font-size:1.2em;margin-top:30px}.nav>li>a:focus,.nav>li>a:hover{background:transparent}.nav-tabs{margin-bottom:10px}.nav-tabs>li{margin-right:5px}.nav-tabs>li>a{border-bottom-color:transparent!important;padding:7px 15px}.nav-tabs>li>a .small{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;margin-left:4px}#navbar input{margin:0 5px 0 2px}#navbar .navbar-default{background:#2389d7;border:none;min-height:50px;position:absolute}#navbar .navbar-default .navbar-nav>li>a{height:50px;padding:0 1.3em}#navbar .navbar-default .navbar-nav>li>a i{line-height:50px}#navbar .navbar-default .navbar-toggle{border-color:transparent;border-radius:0;fill:#fff;float:left;height:50px;line-height:48px;margin:0;padding:0 10px;width:50px;z-index:5}#navbar .navbar-default .navbar-toggle.navbar-right__icon{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;height:32px;line-height:0;margin:9px 10px 0 0;padding:0;width:32px}#navbar .navbar-default .navbar-toggle.menu-toggle{margin-right:16px}#navbar .navbar-default .navbar-toggle .icon-bar{background:#fff;width:21px}#navbar .navbar-default .navbar-toggle .icon__search svg{left:-1px;position:relative;width:17px}#navbar .navbar-default .navbar-toggle .icon--white{color:#fff}#navbar .navbar-default .navbar-toggle:active,#navbar .navbar-default .navbar-toggle:focus,#navbar .navbar-default .navbar-toggle:hover{background:inherit}#navbar .navbar-default .navbar-brand{float:none;font-size:16px;height:50px;line-height:50px;padding:0 .5em}#navbar .navbar-default .navbar-brand .heading{display:inline-block;font-weight:600;line-height:50px;margin-right:5px;max-width:calc(100% - 200px);overflow:hidden;text-overflow:ellipsis;vertical-align:top}#navbar .navbar-default .navbar-brand .header-dropdown__icon{margin-left:0;top:-1px}#navbar .navbar-default .navbar-brand .dropdown-toggle{color:#fff}#navbar .navbar-default .navbar-brand .description{color:#fff;display:inline-block;margin-right:1em}#navbar .navbar-default .navbar-brand .description.info-popover{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;cursor:pointer;height:32px;line-height:32px;margin:9px 10px 0 0;position:relative;text-align:center;vertical-align:top;width:32px}#navbar .navbar-default .navbar-brand .description.info-popover svg{position:relative;top:5px}#navbar .sidebar-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#navbar .sidebar-name span{margin-left:2px;white-space:nowrap}#navbar .channel-create-btn{margin-right:15px}#navbar .more-channel-table{border:1px solid #dbdbdc;width:100%}#navbar .more-channel-table td{padding:7px}#navbar .more-channel-table button{width:110px}.badge-notify{background:#d64946;left:4px;position:absolute;top:3px;z-index:100}.custom-textarea{background:transparent;border:1px solid #ccc;height:100%;line-height:20px;min-height:36px;overflow-x:hidden;resize:none;white-space:pre-wrap;word-wrap:break-word}.custom-textarea:focus{border-color:#ccc;box-shadow:none}.custom-textarea.bad-connection{background:#ffffac!important;color:#d04444!important}.textarea-wrapper{min-height:37px;position:relative}.textarea-wrapper .textbox-preview-area{box-shadow:none;left:0;position:absolute;top:0;white-space:normal;z-index:2}.textarea-wrapper .help__text{bottom:-23px;cursor:pointer;font-size:13px;position:absolute;right:0;text-align:right;z-index:3}.textarea-wrapper .textbox-preview-link{margin-right:8px}.help__format-text{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .5s ease;-webkit-transition-delay:.5s;-moz-transition:all .5s ease .5s;-o-transition:all .5s ease .5s;transition:all .5s ease .5s;display:inline-block;font-size:.85em;margin-right:10px;vertical-align:bottom;white-space:nowrap}.help__format-text b,.help__format-text i,.help__format-text span{margin:0 2px;position:relative;top:-1px}.help__format-text b{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.help__format-text code{background:transparent;padding:0}.help__format-text .textbox-preview-link{cursor:pointer;font-size:13px;margin-left:15px}.date-separator,.new-separator{height:2em;margin:0;position:relative;text-align:center;z-index:0}.date-separator:after,.date-separator:before,.new-separator:after,.new-separator:before{content:\"\";display:none;height:1em;left:0;position:absolute;width:100%}.date-separator:before,.new-separator:before{bottom:0}.date-separator:after,.new-separator:after{top:0}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after{background:#f5f5f5;display:block}.date-separator .separator__hr,.new-separator .separator__hr{border-color:#ccc;margin:0;position:relative;top:1em;z-index:5}.date-separator .separator__text,.new-separator .separator__text{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;background:#fff;color:#555;display:inline-block;font-size:13px;font-weight:700;line-height:2em;padding:0 1em;position:relative;z-index:5}.new-separator .separator__hr{border-color:#ffaf53}.new-separator .separator__text{color:#f80;font-weight:400}.file-overlay{color:#fff;font-size:1.42857em;font-weight:600;height:100%;left:0;pointer-events:none;position:absolute;text-align:center;top:0;width:100%;z-index:11}.file-overlay .overlay__indent{overflow:hidden;*zoom:1;background-color:rgba(0,0,0,.6);height:100%;position:relative}.file-overlay.right-file-overlay{font-size:1.28571em}.file-overlay.right-file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.file-overlay.right-file-overlay .overlay__files{margin:60px auto 15px;width:150px}.file-overlay .overlay__circle{-webkit-border-radius:500px;-moz-border-radius:500px;-ms-border-radius:500px;-o-border-radius:500px;border-radius:500px;background:rgba(0,0,0,.7);height:370px;left:50%;margin:-185px 0 0 -185px;pointer-events:none;position:absolute;top:50%;width:370px}.file-overlay .overlay__files{display:block;margin:75px auto 20px}.file-overlay .overlay__logo{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=30);opacity:.3;bottom:30px;left:50%;margin-left:-50px;position:absolute}.file-overlay .fa{display:inline-block;font-size:1.1em;margin-right:8px}#post-list{-webkit-flex:1 1 auto;flex:1 1 auto;height:100%;overflow-y:hidden;position:relative}#post-list .inactive{display:none}#post-list .post-list__loading{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;font-size:.9em;font-style:italic;padding:1em 0;text-align:center}#post-list .post-list__loading i{margin-right:2px}#post-list .post-list__loading.post-list__loading-search{cursor:pointer}#post-list .post-list__loading.post-list__loading-search:hover{text-decoration:underline}#post-list .post-list-holder-by-time{-webkit-overflow-scrolling:touch;background:#fff;height:100%;overflow-y:scroll;padding:1em 0 0;position:absolute;width:100%}#post-list .post-list-holder-by-time.active{display:inline}#post-list .more-messages-text{border:none;display:block;font-size:13px;margin:5px 0 10px;outline:none;text-align:center}#post-list .new-messages__button{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;bottom:0;font-size:13.5px;left:0;margin:5px auto;position:absolute;right:0;text-align:center;visibility:hidden;z-index:1}#post-list .new-messages__button .fa{font-size:1.2em;font-weight:700;margin-right:.5rem;position:relative;top:1px}#post-list .new-messages__button .icon{margin-left:5px}#post-list .new-messages__button div{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;cursor:pointer;display:inline-block;padding:4px 20px 3px}#post-list .new-messages__button.visible{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;visibility:visible}#post-list .new-messages__button.disabled{display:none}.post-list__timestamp{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .6s ease;-webkit-transition-delay:0s;-moz-transition:all .6s ease;-o-transition:all .6s ease;transition:all false .6s ease;-webkit-transform:translateY(-45px);-moz-transform:translateY(-45px);-ms-transform:translateY(-45px);-o-transform:translateY(-45px);transform:translateY(-45px);display:none;left:0;position:absolute;text-align:center;top:8px;width:100%;z-index:50}.post-list__timestamp.scrolling{-webkit-transform:translateY(0);-moz-transform:translateY(0);-ms-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0);filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.post-list__timestamp.rhs{top:98px}.post-list__timestamp>div{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:auto;background:#2389d7;border:1px solid;color:#fff;display:inline-block;font-size:12px;line-height:25px;padding:0 8px;text-align:center}.post-list__arrows{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .6s;-webkit-transition-delay:0s;-moz-transition:all .6s;-o-transition:all .6s;transition:all false false .6s;background-repeat:no-repeat;bottom:0;display:none;fill:#444;height:40px;left:9px;position:absolute;text-align:center;width:40px;z-index:50}.post-list__arrows svg{color:inherit;height:28px;width:28px}.post-list__arrows.scrolling{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;display:block}.post-create__container{-webkit-flex:0 0 auto;flex:0 0 auto;width:100%;z-index:9}.post-create__container label{font-weight:400}.post-create__container form{margin:0 auto;padding:.5em 15px 0;width:100%}.post-create__container .center{max-width:1028px}.post-create__container .custom-textarea{bottom:0;max-height:162px;padding-top:8px;overflow:hidden;resize:none}.post-create__container .custom-textarea:not(.custom-textarea--emoji-picker){padding-right:35px}.post-create__container .custom-textarea.custom-textarea--emoji-picker{padding-right:60px}.post-create__container .emoji-picker{position:absolute;top:-361px;right:0}.post-create__container .post-create.scroll .btn-file{right:10px}.post-create__container .post-create.scroll .custom-textarea{-ms-overflow-style:auto;overflow:auto;-webkit-overflow-scrolling:touch}.post-create__container .post-create.scroll .custom-textarea:not(.custom-textarea--emoji-picker){padding-right:43px}.post-create__container .post-create.scroll .custom-textarea.custom-textarea--emoji-picker{padding-right:60px}.post-create__container .post-create-body{padding:0 0 2px;position:relative}.post-create__container .post-create-body .post-body__cell{position:relative;vertical-align:top}.post-create__container .post-create-body .send-button{-webkit-transition:all .15s;-webkit-transition-delay:0s;-moz-transition:all .15s;-o-transition:all .15s;transition:all false false .15s;cursor:pointer;display:none;font-size:18px;height:37px;line-height:37px;padding-right:4px;text-align:center;vertical-align:bottom;width:45px}.post-create__container .post-create-body .send-button:active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=75);opacity:.75}.post-create__container .post-create-body .send-button.disabled{color:grey}.post-create__container .post-create-body .btn-send-msg{-webkit-transition:all .15s;-webkit-transition-delay:0s;-moz-transition:all .15s;-o-transition:all .15s;transition:all false false .15s;cursor:pointer;display:inline-block;text-align:center;vertical-align:top}.post-create__container .post-create-body .btn-send-msg i{margin-left:7px;vertical-align:top}.post-create__container .post-create-body .btn-send-msg.disabled,.post-create__container .post-create-body .btn-send-msg:active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=75);opacity:.75}.post-create__container .post-create-body .btn-send-msg.disabled{color:grey}.post-create__container .post-create-body .btn-file{-webkit-transition:all .15s;-webkit-transition-delay:0s;-moz-transition:all .15s;-o-transition:all .15s;transition:all false false .15s;font-size:16px;padding:8px 9px 4px;position:absolute;right:0;top:0;z-index:5}.post-create__container .post-create-body .btn-file svg{height:18px;width:18px}.post-create__container .post-create-body .btn-file:active,.post-create__container .post-create-body .btn-file:hover{box-shadow:none}.post-create__container .post-create-body .btn-file.btn-file__disabled,.post-create__container .post-create-body .btn-file.btn-file__disabled:active,.post-create__container .post-create-body .btn-file.btn-file__disabled:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=10);opacity:.1}.post-create__container .post-create-body .btn-file .icon--attachment{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:inline-block;position:relative;vertical-align:top}.post-create__container .post-create-body .btn-file .icon--attachment input{cursor:pointer;direction:ltr;filter:alpha(opacity=0);font-size:23px;height:100%;margin:0;opacity:0;position:absolute;right:0;top:0;width:100%}.post-create__container .post-create-body .btn-file .icon--attachment:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.post-create__container .post-create-body .icon--emoji-picker .icon--attachment{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:inline-block;position:relative;vertical-align:top}.post-create__container .post-create-body .icon--emoji-picker .icon--attachment input{cursor:pointer;direction:ltr;filter:alpha(opacity=0);font-size:23px;height:100%;margin:0;opacity:0;position:absolute;right:0;top:0;width:100%}.post-create__container .post-create-body .icon--emoji-picker .icon--attachment:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.post-create__container .post-create-body .icon--emoji-picker{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;-webkit-transition:all .15s;-webkit-transition-delay:0s;-moz-transition:all .15s;-o-transition:all .15s;transition:all false false .15s;cursor:pointer;font-size:19px;margin-left:7px;position:relative;vertical-align:top}.post-create__container .post-create-body .icon--emoji-picker:active,.post-create__container .post-create-body .icon--emoji-picker:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;box-shadow:none}.post-create__container .post-create-body textarea{box-shadow:none}.post-create__container .post-create-footer{overflow:hidden;*zoom:1;font-size:13px;padding:3px 0 0;position:relative}.post-create__container .post-create-footer .post-error{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=55);opacity:.55;display:inline-block;font-size:.85em;font-weight:400;margin-bottom:0;position:absolute;top:4px}.post-create__container .msg-typing{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;font-size:.95em;height:20px;margin-bottom:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post-list__table{display:table;height:100%;min-height:350px;table-layout:fixed;width:100%}.post-list__table .post-list__content{display:table-cell;vertical-align:bottom}.post-list__table .post-list__content .dropdown-menu.bottom{bottom:19px;top:auto}.post{*zoom:1;max-width:100%;padding:8px .5em 0 1em;position:relative;word-wrap:break-word}.post:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.post.post--system .post__header .col__reply{min-width:0}.post.post--hovered .comment-icon__container,.post.post--hovered .dropdown,.post.post--hovered .permalink-icon,.post.post--hovered .post__remove,.post.post--hovered .post__reply,.post.post--hovered .reacticon__container,.post.post--hovered .social_network-icon__container,.post:hover .comment-icon__container,.post:hover .dropdown,.post:hover .flag-icon__container,.post:hover .permalink-icon,.post:hover .post__remove,.post:hover .post__reply,.post:hover .reacticon,.post:hover .reacticon__container,.post:hover .social_network-icon__container{visibility:visible}.post.post--hovered .post__header .col__reply{z-index:7}.post.post--hovered .post__body{background:transparent!important}.post.post--highlight{background-color:beige}.post.post--hide-controls .post__header .col__reply{display:none}.post.post--compact.post--thread .post__header{padding-top:3px}.post.post--compact.post--system .status{visibility:hidden}.post.post--compact.post--system>div{margin-bottom:0}.post.post--compact.same--root.same--user .post__header{height:0}.post.post--compact .post__img{padding-top:0}.post.post--compact .status-wrapper{cursor:auto;height:14px;pointer-events:none}.post.post--compact .status-wrapper .status{bottom:auto;height:13px;left:-2px;position:relative;right:auto;top:auto;width:13px}.post.post--compact .status-wrapper svg{top:1px}.post.post--compact .status-wrapper:after{bottom:0}.post.post--compact blockquote{font-size:1em;margin-left:0;margin-top:1.3em;padding:3px 0 0 25px;vertical-align:top}.post.post--compact blockquote:before{font-size:15px;left:4px;top:2px}.post.post--compact .search-item-snippet blockquote{margin-top:0}.post.post--compact .markdown__heading{clear:both;font-size:1em;margin:0}.post.post--compact .post__header{height:22px;margin-bottom:0}.post.post--compact .post__body{background:transparent!important;line-height:1.5;margin-top:-1px;padding:3px 0 0}.post.post--compact .post__body .img-div{max-height:150px;max-width:150px}.post.post--compact .post__body p{line-height:inherit}.post.post--compact .post__body p+p{margin-bottom:1em;margin-top:1em}.post.post--compact .post__body ol,.post.post--compact .post__body ul{clear:both;padding-left:20px}.post.post--compact .post__body div{margin-bottom:0}.post.post--compact .post__body .post-image__column{margin:3px 0}.post.post--compact .post-image__column{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;font-size:.9em;height:26px;line-height:25px;padding:0 7px;width:auto}.post.post--compact .post-image__column .post-image__thumbnail{display:none}.post.post--compact .post-image__column .post-image__details{background:transparent;border:none;padding:0;width:100%}.post.post--compact .post-image__column .post-image__details svg{display:inline-block;height:13px;margin:5px 4px 0 0;opacity:.5;position:relative;vertical-align:top;width:13px}.post.post--compact .post-image__column .post-image__details>div{display:none}.post.post--compact .post-image__column .post-image__name{overflow:hidden;*zoom:1;display:block;margin:0;padding-right:10px;text-overflow:ellipsis;white-space:nowrap}.post.post--compact .post-image__column .post-image__name i{font-size:.9em;margin-right:5px;opacity:.5}.post.post--compact .post-image__column a:hover{text-decoration:none}.post.post--compact .post__img{padding-top:1px;width:16px}.post.post--compact .post__img img{display:none}.post .post__img:hover{cursor:pointer}.post .post--fail{position:relative}.post .post--edited .post-message__text>p:last-child{display:inline-block;width:auto}.post .post--edited .post-edited-indicator{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;font-size:.87em}.post .emoticon{vertical-align:top}.post p{font-size:13.5px;line-height:1.6em;margin:0;white-space:pre-wrap;width:100%;word-break:break-word}.post .post__header--info{padding:0}.post.post--root .comment-icon__container{visibility:visible}.post.post--comment .post__body{border-left:4px solid rgba(0,0,0,.3);padding-left:7px}.post.post--comment .post__body.mention-comment{border-left:4px solid #ff0;border-color:#ff0}.post.same--root.post--pinned h1:first-child,.post.same--root.post--pinned h2:first-child{margin-top:15px}.post.same--root.post--pinned h3:first-child,.post.same--root.post--pinned h4:first-child,.post.same--root.post--pinned h5:first-child,.post.same--root.post--pinned h6:first-child{margin-top:20px}.post.same--root.same--user{padding:0 .5em 0 1em}.post.same--root.same--user.post--hovered .post__time,.post.same--root.same--user:hover .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.post.same--root.same--user .flag-icon__container{left:36px;margin-left:7px;position:absolute;top:6px}.post.same--root.same--user .post__img .status-wrapper,.post.same--root.same--user .post__img img{display:none}.post.same--root.same--user .post__header{height:0;margin:0}.post.same--root.same--user .post__header .col__name{display:none}.post.same--root.same--user .post__header .col__reply{top:-1px}.post.same--root.post--comment .post__link,.post.same--root.post--comment.same--user .post__img img,.post.same--root.same--user .post__header .bot-indicator{display:none}.post.other--root .comment-icon__container.icon--show{visibility:visible}.post.other--root.post--comment .popover{margin-top:84px}.post.other--root.post--comment .popover>.arrow{top:21px!important}.post.other--root.post--comment .post__header .col__reply{top:-4px}.post .post__content{display:table;margin:0 auto;padding:0 5px;position:relative;table-layout:fixed;width:100%}.post .post__content>div{display:table-cell;vertical-align:top}.post .center{max-width:1000px}.post .post__header{margin-bottom:2px;padding:0}.post .post__header>div{display:inline-block;vertical-align:top}.post .post__header .col__name{font-weight:600;margin-right:7px}.post .post__header .col__name .user-popover{overflow:hidden;*zoom:1;max-width:200px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.post .post__header .col__name .colon{display:none;font-weight:900;margin-left:2px}.post .post__header .col__name .fa-stack.verified-icon{top:-2px;margin-left:3px}.post .post__header .col__reply{border:1px solid transparent;border-radius:2px;min-width:70px;padding:2px 5px;position:absolute;right:0;top:-4px;white-space:nowrap;z-index:6}.post .post__header .col__remove{position:absolute;right:10px}.post .post__header .permalink-popover{min-width:0}.post .post__header .permalink-popover .popover-content{padding:5px}.post .post__header .permalink-popover .btn,.post .post__header .permalink-popover .form-control{font-size:13px;height:30px;line-height:30px;padding:0 8px}.post .post__img{padding-right:10px;text-align:right;width:53px}.post .post__img .icon svg{height:32px;width:32px}.post .post__img path{fill:inherit}.post .post__img img{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;height:32px;vertical-align:inherit;width:32px;max-width:none}.post .post__embed-container{-webkit-transition:max-height .5 ease;-webkit-transition-delay:0s;-moz-transition:max-height .5 ease;-o-transition:max-height .5 ease;transition:max-height false .5 ease;display:block;max-height:1000px;overflow:hidden}.post .post__embed-container[hidden]{max-height:0}.post .dropdown{display:inline-block;top:-1px;vertical-align:middle;visibility:hidden}.post .dropdown .dropdown-menu{left:auto;min-width:130px;padding:2px 0;right:0;top:20px}.post .dropdown .dropdown-menu li{display:block}.post .dropdown .dropdown-menu a{padding:5px 15px}.post .post__dropdown{vertical-align:middle}.post .post__dropdown:after{content:\"[...]\";top:-1px}.post .post__dropdown:after,.post .post__remove{font-family:Open Sans,sans-serif;position:relative}.post .post__remove{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;color:inherit;display:inline-block;float:right;font-size:20px;font-weight:600;height:20px;line-height:20px;right:-10px;text-decoration:none;vertical-align:top;visibility:hidden;width:20px}.post .post__remove:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.post .post__body{*zoom:1;padding:.2em .5em;width:100%;word-wrap:break-word}.post .post__body:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.post .post__body p+p{margin:.5em 0 0}.post .post__body .google-map img{max-height:unset!important}.post .post__body .google-map div.gm-style-iw{color:#333!important}.post .post__body img{max-height:400px}.post .post__body ol,.post .post__body ul{font-size:13.5px;margin-bottom:.11em;margin-top:3px;padding-left:20px}.post .post__body ol p,.post .post__body ul p{margin-bottom:0}.post .post__body ol li ol,.post .post__body ol li ul,.post .post__body ul li ol,.post .post__body ul li ul{font-size:1em;margin:0;padding:0 0 0 20px}.post .post__body ol li.list-item--task-list ol,.post .post__body ol li.list-item--task-list ul,.post .post__body ul li.list-item--task-list ol,.post .post__body ul li.list-item--task-list ul{margin-left:20px}.post .post__body ol li.list-item--task-list ul,.post .post__body ul li.list-item--task-list ul{padding-left:0}.post .post__body ol li:not(.list-item--task-list) li.list-item--task-list,.post .post__body ol li:not(.list-item--task-list) li.list-item--task-list~li,.post .post__body ul li:not(.list-item--task-list) li.list-item--task-list,.post .post__body ul li:not(.list-item--task-list) li.list-item--task-list~li{margin-left:-20px}.post .post__body ol li input[type=checkbox]:disabled,.post .post__body ul li input[type=checkbox]:disabled{cursor:default;vertical-align:top}.post .post__body ul li.list-item--task-list,.post .post__body ul li.list-item--task-list~li{list-style-type:none}.post .post__body ul li.list-item--task-list~li:not(.list-item--task-list){text-indent:3px}.post .post__body ul li.list-item--task-list~li:not(.list-item--task-list):before{content:\"\\2022\";margin-right:8px}.post .post__body ol+p,.post .post__body p+ol,.post .post__body p+ul,.post .post__body ul+p{margin-top:.6em}.post .post__body .pending-post-actions{background:rgba(0,0,0,.7);color:#fff;font-size:.9em;padding:5px 7px;position:absolute;right:0;top:0;z-index:100}.post .post__body .pending-post-actions a{color:#fff}.post .post__body .post-reaction-list{min-height:30px}.post .post__body .post-reaction{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;border:1px solid #2389d7;cursor:pointer;display:inline-block;font-size:11px;height:23px;margin-bottom:5px;margin-right:5px;padding:0 4px 0 3px}.post .post__body .post-reaction .post-reaction__emoji{margin:2px 3px 0 0;max-height:16px;max-width:16px;vertical-align:middle}.post .post__body .post-reaction .post-reaction__count{line-height:10px;position:relative;top:3px}.post .post__body .post-reaction--current-user .post-reaction__count{font-weight:600}.post .post__link{font-size:13px;margin:2px 0 5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .post__link a{font-weight:700}.post .post__embed-visibility{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;cursor:pointer;display:inline-block;font:normal normal normal 14px/1 FontAwesome;margin:0;text-rendering:auto}.post .post__embed-visibility.pull-left{margin:5px 5px 0 0}.post .post__embed-visibility:hover{text-decoration:none}.post .post__embed-visibility:before{content:\"\\F065\";font-size:14px}.post .post__embed-visibility[data-expanded=true]:before{content:\"\\F066\"}.post .post__visibility{padding:8px}.post .post__time,.post .post__visibility{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;font-size:.9em}.post .post__permalink,.post .post__permalink:focus,.post .post__permalink:hover{color:inherit}.post .post__permalink:focus{text-decoration:none}.post .post__permalink:hover{text-decoration:underline}.post .post-loading-gif{height:10px;margin-top:6px;width:10px}.post .post-fail{color:#d58a8a}.post .post-waiting{color:#999}.post .permalink-icon{color:#2389d7;display:inline-block;visibility:hidden}.post .post__reply{display:inline-block;margin-right:6px;visibility:hidden}.post .post__reply svg{fill:inherit;position:relative;top:3px;width:18px}.post .comment-icon__container{display:inline-block;fill:#2389d7;position:relative;top:1px;visibility:hidden}.post .comment-icon__container:focus{outline:none}.post .comment-icon__container.icon--visible{visibility:visible}.post .comment-icon__container svg{height:17px;width:17px}.post .comment-icon__container .comment-count{margin-left:2px}.post .comment-icon__container .comment-icon{display:inline-block;fill:inherit;margin:0 1px 0 5px;position:relative;top:1px;vertical-align:top}.post .comment-icon__container path{fill:inherit}.post .reacticon__container,.post .social_network-icon__container{display:inline-block;fill:#2389d7;font-size:16px;margin-left:5px;vertical-align:top;visibility:hidden}.post .flag-icon__container{display:inline-block;height:15px;margin-left:7px;position:relative;top:2px;vertical-align:top;visibility:hidden}.post .flag-icon__container.visible{visibility:visible}.post .flag-icon__container svg{width:12px}.post .flag-icon__container path{fill:inherit}.post .flag-icon__container .fa-star-o{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.post .flag-icon__container:focus{outline:none}.post .flag-icon__container.icon--visible{visibility:visible}.post .web-embed-data{-webkit-border-radius:2px;-moz-border-radius:2px;-ms-border-radius:2px;-o-border-radius:2px;border-radius:2px;background:rgba(0,0,0,.05);height:50px;overflow:hidden;padding:2px 0 0 10px;text-overflow:ellipsis}.post .web-embed-data .embed-title{color:#555;font-weight:600;margin:3px 0 1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .web-embed-data .embed-description{color:#888;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .web-embed-data .embed-link{display:none}.bot-indicator,.post__pinned-badge{border-radius:2px;font-family:inherit;font-size:10px;font-weight:600;padding:1px 4px}.bot-indicator{margin:2px 10px 0 -4px}.post__pinned-badge{margin-left:7px;position:relative;top:-1px}.permalink-text{overflow:hidden}.permalink-popover{margin-left:50px!important;min-width:320px}label.BMapLabel{max-width:none;border:1px solid #fff!important;box-shadow:0 1px 1px 1px hsla(0,0%,67%,.5)!important;padding:3px 5px!important;border-radius:5px!important;color:#000!important;float:left!important;width:max-content!important;background-color:#fff!important}.post-namecard__column{float:left;height:150px;margin:5px 10px 5px 0;position:relative;width:350px;border-radius:2px;box-shadow:0 1px 3px 0 #b2b7be}.post-namecard__column img{cursor:pointer}.post-namecard__column.is-rhs{width:300px}.post-namecard__column.is-rhs .post-namecard__thumbnail{width:93px}.post-namecard__column.is-rhs .post-namecard__details{width:205px}.post-namecard__column.is-rhs .post-namecard{width:70px;height:70px;margin:40px 8px 40px 15px}.post-namecard__column.is-rhs .post-namecard img{width:70px;height:70px}.post-namecard__column.is-rhs .no-user-found{font-size:5em;margin:40px 8px 40px 15px}.post-namecard{background-position:50%;background-color:#fff;background-repeat:no-repeat;border-radius:64px;overflow:hidden;position:relative;text-align:center;width:90px;height:90px;margin-top:30px;margin-left:15px;margin-right:8px}.post-namecard-name{text-transform:uppercase;text-align:center;font-size:16px;font-weight:600;margin-bottom:5px;border-bottom:1px solid hsla(0,0%,49%,.35)}.post-namecard__thumbnail{cursor:-webkit- zoom-in;cursor:zoom- zoom-in;float:left;height:100%;width:113px;background-color:#fff}.post-namecard__thumbnail .no-user-found{font-size:6.5em;margin-top:29px;margin-left:14px;margin-right:8px}.post-namecard__details{overflow:hidden;*zoom:1;background:#fff;color:rgba(0,0,0,.8);float:left;font-size:13px;height:100%;padding:7px;width:237px;word-break:break-word}.post-namecard__details .post-namecard__item{font-family:Open Sans,sans-serif;padding:5px}.post-namecard__details .post-namecard__item i.fa{margin-right:3px}.post-right__container{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;height:100%}.post-right__container .post-right-root-message{padding:1em 1em 0}.post-right__container .post-right-comments-container{position:relative}.post-right__container .help_format_text{bottom:-63px;right:auto}.post-right__container .post.post--root{border-bottom:1px solid #ddd;padding-bottom:1em}.post-right__container .post.post--root .post__body{background:transparent!important}.post-right__container .post .post__header .col__reply{background:transparent!important;border:none!important;right:5px;text-align:right;top:-3px}.post-right__container .post .post__body{width:100%}.post-right__container hr{border:none}.post-right__container .date-separator hr{border-top:1px solid #eee}.post-right__container .post-create__container{width:100%}.post-right__container .post-create__container .btn{margin-bottom:10px}.post-right__container .post-create__container .btn.disabled{background:grey!important;border-color:transparent!important}.post-right__container .post-create__container .custom-textarea{min-height:100px}.post-right__container .post-create__container .msg-typing{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;float:left;font-size:13px;height:20px;line-height:20px;margin-top:3px;max-width:230px;min-width:1px}.post-right__container .post-create__container .post-create-footer{padding:5px 0 30px;width:100%}.post-right__container .post-create__container .post-right-comments-upload-in-progress{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;margin-right:10px;padding:6px 0}.post-right__container .post-create__container .emoji-picker{position:absolute;top:-361px;right:0}.post-right-header{border-bottom:1px solid #ddd;color:#999;font-size:1em;font-weight:400;height:39px;padding:10px 10px 0 15px;text-transform:uppercase}.post-right-root-container{border-bottom:1px solid #ddd;padding:5px 10px}.post-right-root-container ul{margin-bottom:2px;padding-left:0}.post-right-channel__name{font-weight:600;margin:0 0 15px}.post-right-root-container li{display:inline;list-style-type:none;padding-right:3px}.post-right-root-time{color:#a8adb7}.post-right-create-comment-container{bottom:0;left:0;margin-bottom:18px;padding:5px;position:absolute;width:100%}.post-right__scroll{-webkit-overflow-scrolling:touch;-webkit-flex:1 1 auto;flex:1 1 auto;padding-top:10px;position:relative}.post-right__scroll .file-preview__container{margin-top:5px}.post-right-comment-time{color:#a8adb7}.sidebar--left{border-right:1px solid #ddd;height:100%;left:0;position:fixed;width:220px;z-index:5}.sidebar--left.new-sidebar{width:285px}.sidebar--left.new-sidebar .nav-pills__container{height:calc(100% - 290px)}.sidebar--left.new-sidebar .nav-pills__unread-indicator{left:47px}.sidebar--left.new-sidebar.headerCollapsed .nav-pills__container{height:calc(100% - 190px)}.sidebar--left.new-sidebar.headerCollapsed .nav-pills__unread-indicator-top{top:200px}.sidebar--left.new-sidebar .nav-pills__unread-indicator-top{top:300px}.sidebar--left.new-sidebar .new-list{height:60px;border-top:1px solid}.sidebar--left.new-sidebar .new-list:last-child{border-bottom:1px solid}.sidebar--left.new-sidebar .team__header-container.collapsed .profile-background{height:30px}.sidebar--left.new-sidebar .team__header-container .chevron:before{background:rgba(60,60,60,.5);color:#fff}.sidebar--left.new-sidebar .team__header-container .profile-background{transition:height .5s;overflow:hidden}.sidebar--left.new-sidebar .team__header-container .status-wrapper .status{bottom:-2px;height:22px;right:-2px;width:22px}.sidebar--left.new-sidebar .team__header-container .status-wrapper .status.status-edit .fa{top:6px}.sidebar--left.new-sidebar .team__header-container .status-wrapper .status .icon__container:after{height:15px;left:4px;top:4px;width:15px}.sidebar--left.new-sidebar .team__header-container .status-wrapper .status svg{height:18px;left:2px;top:2px;width:18px}.sidebar--left.new-sidebar .status-wrapper .status svg{height:14px;left:2px;top:2px;width:14px}.error-bar--fixed .sidebar--left{height:calc(100% - 22px)}.sidebar--left.sidebar--padded{padding-top:44px}.sidebar--left .sidebar-item .icon{display:inline-block;margin:0 7px 0 1px;position:relative;text-align:left;vertical-align:top;width:15px}.sidebar--left .sidebar-item .icon__lock{top:2px}.sidebar--left .sidebar-item .icon__globe{top:1px}.sidebar--left .sidebar-item__name{display:inline-block;max-width:160px;overflow:hidden;text-overflow:ellipsis;vertical-align:top}.sidebar--left .sidebar__divider{color:#fff;font-size:.9em;height:20px;line-height:20px;margin:5px 0 6px;position:relative;z-index:0}.sidebar--left .sidebar__divider:before{background:rgba(0,0,0,.15);content:\"\";height:1px;position:absolute;top:10px;width:100%}.sidebar--left .sidebar__divider .sidebar__divider__text{background:#2389d7;float:right;padding:0 10px;position:relative;z-index:1}.sidebar--left .sidebar__switcher{bottom:0;display:none;padding-bottom:0;position:absolute;width:100%;z-index:2}.sidebar--left .sidebar__switcher button{-webkit-transition:all .15s ease-in;-webkit-transition-delay:0s;-moz-transition:all .15s ease-in;-o-transition:all .15s ease-in;transition:all false .15s ease-in;display:block;font-weight:600;height:45px;line-height:40px;padding:0;text-decoration:none;width:100%}.sidebar--left .sidebar__switcher button>span{display:inline-block;position:relative;vertical-align:middle;z-index:5}.sidebar--left .sidebar__switcher button .icon{display:none;margin-right:15px}.sidebar--left .sidebar__switcher button .icon svg{position:relative;top:7px}.sidebar--left .sidebar__switcher button:hover span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.sidebar--left .sidebar__switcher .switch__shortcut{margin-left:4px}.sidebar--left .dropdown-menu{max-height:80vh;max-width:200px;overflow-x:hidden;overflow-y:auto;width:200px}.sidebar--left .search__form{display:none;margin:0;padding:1em 1em 0}.sidebar--left .badge{-webkit-border-radius:100px;-moz-border-radius:100px;-ms-border-radius:100px;-o-border-radius:100px;border-radius:100px;font-size:11px;height:16px;line-height:16px;min-width:18px;padding:0 5px;position:absolute;right:15px;top:8px}.sidebar--left .nav-pills__container{-webkit-overflow-scrolling:touch;height:calc(100% - 180px);overflow:auto;position:relative}.sidebar--left .nav-pills__unread-indicator{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;font-size:13.5px;left:15px;margin:0 auto;padding:4px 0 3px;position:fixed;text-align:center;width:190px;z-index:1}.sidebar--left .nav-pills__unread-indicator .icon{margin-left:5px}.sidebar--left .nav-pills__unread-indicator-top{top:190px}.sidebar--left .nav-pills__unread-indicator-top .icon svg{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}.sidebar--left .nav-pills__unread-indicator-bottom{bottom:15px}.sidebar--left .nav.nav-stacked{transition:height .3s}.sidebar--left .nav.nav-stacked.collapsed li:not(:first-child){height:0;overflow:hidden;opacity:0;border:0;transition:height .4s linear}.sidebar--left .nav.nav-stacked>li+li{margin:0}.sidebar--left .nav li{transition:opacity .5s ease-in-out}.sidebar--left .nav li .fa.chevron{padding-right:10px}.sidebar--left .nav li .fa.unread{padding-left:10px;top:-1px;position:relative;-webkit-animation:blinker 1s infinite ease-in-out alternate;-moz-animation:blinker 1s infinite ease-in-out alternate;-ms-animation:blinker 1s infinite ease-in-out alternate;-o-animation:blinker 1s infinite ease-in-out alternate;animation:blinker 1s infinite ease-in-out alternate}.sidebar--left .nav li>h4{font-size:1em;font-weight:600;margin:1.5em 0 .7em;padding:0 12px 0 17px;text-transform:uppercase}.sidebar--left .nav li.wvc-content div.dropdown{width:100%}.sidebar--left .nav li.wvc-content div.dropdown .dropdown-toggle{display:block}.sidebar--left .nav li .divider+.divider,.sidebar--left .nav li.wvc-content.collapse{display:none}.sidebar--left .nav li>div.dropdown.open>a,.sidebar--left .nav li>div.dropdown.open>a:focus,.sidebar--left .nav li>div.dropdown.open>a:hover{background:inherit}.sidebar--left .nav li>div.dropdown a,.sidebar--left .nav li>div.dropdown a:active,.sidebar--left .nav li>div.dropdown a:focus,.sidebar--left .nav li>div.dropdown a:hover,.sidebar--left .nav li>div.dropdown a:visited{text-decoration:none}.sidebar--left .nav li>div.dropdown .dropdown-menu a{max-height:60vh;padding:2px 0 2px 14px}.sidebar--left .nav li>div.dropdown li.wvc-sub-channel.unread-title .sidebar-item__name{font-weight:600}.sidebar--left .nav li>div.dropdown li.wvc-sub-channel .sidebar-item__name{max-width:135px}.sidebar--left .nav li>div.dropdown li.wvc-sub-channel .badge{top:auto}.sidebar--left .nav li .sub-wvc{display:inline-block;padding:0 5px 0 27px;font-size:13px}.sidebar--left .nav li .sub-wvc.has-message{font-weight:600}.sidebar--left .nav li>a{border-radius:0;line-height:1.5;outline:none;overflow:hidden;padding:5px 0 5px 17px;text-overflow:ellipsis;white-space:nowrap;display:block}.sidebar--left .nav li>a .icon.icon__globe,.sidebar--left .nav li>a .icon.icon__lock{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.sidebar--left .nav li>a.sidebar-wvc-item{padding:5px 0 5px 40px}.sidebar--left .nav li>a.sidebar-wvc-item .sidebar-item__name{max-width:132px}.sidebar--left .nav li>a.has-expand.has-badge .badge{right:40px}.sidebar--left .nav li>a.has-expand:hover .sidebar-item__name{max-width:152px}.sidebar--left .nav li>a.has-badge .sidebar-item__name{max-width:142px}.sidebar--left .nav li>a.has-close:hover .sidebar-item__name{max-width:152px}.sidebar--left .nav li>a.has-close:hover .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;display:block}.sidebar--left .nav li>a.has-close .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;display:none;font-family:Open Sans,sans-serif;font-size:21px;font-weight:600;position:absolute;right:15px;top:0}.sidebar--left .nav li>a.has-close .btn-close:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.sidebar--left .nav li>a.unread-title{font-weight:600}.sidebar--left .nav li.active a:before{background:#000;content:\"\";height:100%;left:0;position:absolute;top:0;width:3px}.sidebar--left .nav li.active .icon.icon__globe,.sidebar--left .nav li.active .icon.icon__lock{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.sidebar--left .nav li.active a,.sidebar--left .nav li.active a:focus,.sidebar--left .nav li.active a:hover{background-color:rgba(0,0,0,.1);border-radius:0;font-weight:400;position:relative}.sidebar--left .nav li.active a.unread-title,.sidebar--left .nav li.active a:focus.unread-title,.sidebar--left .nav li.active a:hover.unread-title{font-weight:600}.sidebar--left .modal-title{line-height:2em}.sidebar--left .add-channel-btn{float:right;font-size:1.9em;font-weight:700;line-height:18px;margin:-2px 0 0;outline:none;padding:0 5px;text-decoration:none}.sidebar--left .add-channel-btn:hover{color:#666}.sidebar--left .status-wrapper{height:36px;width:36px}.sidebar--left .status-wrapper .status{bottom:-4px;height:18px;right:-5px;width:18px}.sidebar--left .status-wrapper .status.status-edit .fa{top:4px}.sidebar--left .status-wrapper .status .fa{position:relative;top:2px}.sidebar--left .status-wrapper .status .icon__container:after{border-radius:20px;content:\"\";height:10px;left:4px;position:absolute;top:4px;width:10px}.sidebar--left .status-wrapper .status svg{height:13px;left:3px;max-height:none;position:relative;top:3px;width:13px;z-index:1}.sidebar--left .team-header .team-header-wrapper{padding:15px 3px;background-color:rgba(0,0,0,.2)}.sidebar--left .list-item{display:block;height:50px;-webkit-tap-highlight-color:transparent;width:100%;padding:0}.sidebar--left .list-item .item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 8px;position:relative;height:inherit}.sidebar--left .list-item .item-content .avatar-icon{flex-shrink:0;width:36px;height:36px;box-sizing:content-box;padding:0;display:inline-block}.sidebar--left .list-item .item-content .avatar-icon.team-icon{width:44px;height:44px}.sidebar--left .list-item .item-content .avatar-icon.team-icon img{border-radius:5px}.sidebar--left .list-item .item-content .avatar-icon .status.status--group{font-size:18px;width:100%;height:100%;line-height:36px;left:unset;top:unset}.sidebar--left .list-item .item-content .avatar-icon img{border-radius:50%}.sidebar--left .list-item .item-content .list-btn-group,.sidebar--left .list-item .item-content .list-text{font-size:12px;display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding-right:0;padding-left:8px}.sidebar--left .list-item .item-content .list-btn-group .emoticon,.sidebar--left .list-item .item-content .list-text .emoticon{height:18px;width:18px}.sidebar--left .list-item .item-content .list-btn-group .icon,.sidebar--left .list-item .item-content .list-text .icon{margin-right:3px}.sidebar--left .list-item .item-content .list-btn-group .icon__globe,.sidebar--left .list-item .item-content .list-btn-group .icon__lock,.sidebar--left .list-item .item-content .list-text .icon__globe,.sidebar--left .list-item .item-content .list-text .icon__lock{top:1px}.sidebar--left .list-item .item-content .list-btn-group .status.fa-user,.sidebar--left .list-item .item-content .list-text .status.fa-user{top:0}.sidebar--left .list-item .item-content .list-btn-group .sidebar-item__name,.sidebar--left .list-item .item-content .list-text .sidebar-item__name{font-size:14px;font-weight:700}.sidebar--left .list-item .item-content .list-btn-group .message,.sidebar--left .list-item .item-content .list-text .message{overflow:hidden;text-overflow:ellipsis;vertical-align:top}.sidebar--left .list-item .item-content .list-btn-group .message.preview-message a,.sidebar--left .list-item .item-content .list-text .message.preview-message a{background:transparent!important}.sidebar--left .list-item .item-content .list-btn-group .message.preview-message a:hover,.sidebar--left .list-item .item-content .list-text .message.preview-message a:hover{text-decoration:none}.sidebar--left .list-item .item-content .list-btn-group .message.preview-message a:before,.sidebar--left .list-item .item-content .list-text .message.preview-message a:before{display:none}.sidebar--left .list-item .item-content .team-container{text-align:center}.sidebar--left .list-item .item-content .post-at{font-size:12px;align-self:flex-end}.sidebar--left .list-item .team-name-wrapper{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sidebar--left .list-item .team-name-wrapper .team-name{font-size:16px}.sidebar--left li.new-list a{padding-left:0}.channel-loading-gif{height:15px;margin-top:2px;width:15px}.join-channel-loading-gif{height:25px;margin-left:10px;margin-top:5px;width:25px}.new-layout .app__content{margin-left:285px}.sidebar--menu{-webkit-overflow-scrolling:touch;background:#fafafa;border-right:1px solid #ddd;display:none;height:100%;overflow:auto;padding:0 0 2em;position:absolute;right:0;width:220px}.sidebar--menu .nav-pills__container{padding-top:5px}.sidebar--menu .team__header{*zoom:1;display:none;padding:0 15px}.sidebar--menu .team__header:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.sidebar--menu .team__header a{color:#fff}.sidebar--menu .team__header .navbar-right{font-size:.85em;margin:16px -5px 0}.sidebar--menu .team__header .navbar-right .dropdown-toggle{padding:0 10px}.sidebar--menu .team__header .navbar-right .dropdown-menu li a{color:#555;padding:3 20px}.sidebar--menu .team__header .navbar-right .dropdown__icon{-webkit-background-size:100% 100%;-moz-background-size:100% 100%;-o-background-size:100% 100%;background-size:100% 100%;display:inline-block;height:16px;width:4px}.sidebar--menu .team__header .team__name{float:left;font-size:1.2em;font-weight:600;line-height:50px;max-width:80%;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.sidebar--menu .nav>li>a{background:none!important;color:inherit;font-size:15px;line-height:40px;padding:0 15px}.sidebar--menu .nav>li>a svg{fill-opacity:.85;position:relative;top:4px;width:18px}.sidebar--menu .nav>li>a .icon{display:inline-block;left:-5px;position:relative;text-align:center;width:25px}.sidebar--menu .nav>li>a .mentions{font-size:17px;font-weight:700}.sidebar--menu .nav .badge-unread{background:#d64946;position:absolute;top:11px;right:20px;z-index:100}.sidebar--right{-webkit-transform:translateX(400px);-moz-transform:translateX(400px);-ms-transform:translateX(400px);-o-transform:translateX(400px);transform:translateX(400px);background:#fff;height:100%;padding:0;position:fixed;right:0;width:400px;z-index:8}.error-bar--fixed .sidebar--right{height:calc(100% - 22px)}.sidebar--right.webrtc{z-index:5}.sidebar--right.sidebar--right--expanded{z-index:10}.sidebar--right .sidebar--right__bg{-webkit-transition:background-color .5s ease;-webkit-transition-delay:0s;-moz-transition:background-color .5s ease;-o-transition:background-color .5s ease;transition:background-color false .5s ease;background-color:transparent;height:100%;position:absolute;top:0;visibility:hidden;width:300%}.sidebar--right.move--left .sidebar--right__bg,.sidebar--right.webrtc--show .sidebar--right__bg{left:-100%}.sidebar--right .sidebar-right__table{display:table}.sidebar--right .sidebar-right__table>div:not(.sidebar-collapse__container){display:table-cell}.sidebar--right .sidebar-right__table>div:not(.sidebar-collapse__container):last-child .channel-header__icon{margin-right:10px}.sidebar--right .sidebar-right__table .search-form__container{padding-right:10px;width:100%}.sidebar--right .post-body img{max-height:200px}.sidebar--right .post.post--compact .post__pinned-badge{margin:0 0 0 5px}.sidebar--right .post .post__content{padding:0 10px 0 0}.sidebar--right .post .post__header .col__name .user-popover{max-width:120px}.sidebar--right .post .post__header .flag-icon__container{z-index:5}.sidebar--right .post-create__container form{padding:.5em 15px 0}.sidebar--right .post-create__container .post-create-footer{overflow:hidden;*zoom:1;font-size:13px;overflow:visible;position:relative;clear:both}.sidebar--right .post-create__container .post-create-footer .post-error{font-weight:400;margin-bottom:0;display:inline-block;font-size:.85em;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=55);opacity:.55;position:absolute;top:-25px}.sidebar--right .help__format-text{display:none}.sidebar--right .sidebar--right__content{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;height:100%}.sidebar--right .sidebar--right__back{-webkit-transition:all .2s ease-in;-webkit-transition-delay:0s;-moz-transition:all .2s ease-in;-o-transition:all .2s ease-in;transition:all false .2s ease-in;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;color:inherit;display:inline-block;font-size:26px;margin-left:-14px;text-align:center;vertical-align:top;width:30px}.sidebar--right .sidebar--right__back:active,.sidebar--right .sidebar--right__back:hover{color:inherit;opacity:.8}.sidebar--right .sidebar--right__back i{position:relative;top:-2px}.sidebar--right .sidebar-right__body{display:-webkit-flex;display:flex;-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-flex-direction:column;flex-direction:column;border-left:1px solid #ddd;height:calc(100% - 56px)}.sidebar--right .sidebar__overlay{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=10);opacity:.1;background-color:#ff0;height:100%;pointer-events:none;position:absolute;width:100%;z-index:5}.sidebar--right .input-group{word-break:break-word}.sidebar--right .sidebar--right__buttons{float:right}.sidebar--right .sidebar--right__close,.sidebar--right .sidebar--right__expand{-webkit-transition:all .2s ease-in;-webkit-transition-delay:0s;-moz-transition:all .2s ease-in;-o-transition:all .2s ease-in;transition:all false .2s ease-in;background:none;border:none;font-size:20px;height:22px;line-height:0;margin:11px 0 0;opacity:.5;outline:none;padding:0;width:30px}.sidebar--right .sidebar--right__close:active,.sidebar--right .sidebar--right__close:hover,.sidebar--right .sidebar--right__expand:active,.sidebar--right .sidebar--right__expand:hover{opacity:.8}.sidebar--right .sidebar--right__close i,.sidebar--right .sidebar--right__expand i{position:relative}.sidebar--right .sidebar--right__expand{font-size:17px}.sidebar--right .sidebar--right__expand i{top:-2px}.sidebar--right .sidebar--right__expand .fa-compress{display:none}.sidebar--right .sidebar--right__title{overflow:hidden;*zoom:1;padding-left:15px}.sidebar--right .sidebar--right__header{-webkit-flex:0 0 44px;flex:0 0 44px;border-bottom:1px solid;color:inherit;font-size:1em;height:44px;line-height:44px;overflow:hidden;padding:0 5px 0 0}.sidebar--right .sidebar--right__loading{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;text-align:center}.sidebar--right .sidebar--right__loading .fa{margin-right:5px}.sidebar--right .sidebar--right__subheader{font-size:1em;padding:.5em 1em 0}.sidebar--right .sidebar--right__subheader h4{font-size:1em}.sidebar--right .sidebar--right__subheader ul{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;padding:10px 0 0 30px}.sidebar--right .sidebar--right__subheader li{font-size:.95em;padding-bottom:10px}.sidebar--right .sidebar--right__subheader .usage__icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;margin:0 3px;position:relative;top:3px}.sidebar--right .suggestion-list__content{max-height:120px}.sidebar-right-container{height:100%}.sidebar-collapse__container{display:none}.sidebar-collapse{-webkit-transition:all .2s linear;-webkit-transition-delay:0s;-moz-transition:all .2s linear;-o-transition:all .2s linear;transition:all false .2s linear;-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);-o-transform:translateX(0);transform:translateX(0);cursor:pointer;font-size:16px;height:48px;line-height:0;padding-left:1px;text-align:center;width:50px;z-index:5}.sidebar-collapse .fa{position:relative;top:18px}.multi-teams .team-sidebar{height:100%;left:0;position:fixed;text-align:center;width:65px;z-index:5}.multi-teams .team-sidebar .team-wrapper{-webkit-overflow-scrolling:touch;background-color:rgba(0,0,0,.2);height:100%;overflow:auto;padding-top:15px}.multi-teams .team-sidebar .team-wrapper .team-container{display:table;margin-bottom:10px;position:relative;text-align:center;width:100%}.multi-teams .team-sidebar .team-wrapper .team-container a{display:block;margin-left:11px;text-decoration:none}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn{-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px;background-color:rgba(0,0,0,.3);display:table-cell;font-size:12px;font-weight:700;position:relative;text-align:center;vertical-align:top;width:40px}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn .team-btn__initials{text-align:left}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn .team-btn__content{bottom:4px;font-size:8.5px;font-weight:400;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:31px}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn .badge{font-size:10px;position:absolute;right:-6px;top:-3px}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn.team-btn__add{border:1px solid hsla(0,0%,100%,.2);height:39px;padding:4px 5px;vertical-align:middle}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn.team-btn__switch{border:1px solid hsla(0,0%,100%,.2);height:39px;padding:7px 5px 4px;vertical-align:middle}.multi-teams .team-sidebar .team-wrapper .team-container .team-btn .team-icon{-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;-o-border-radius:5px;border-radius:5px}.multi-teams .team-sidebar .team-wrapper .team-container.active .team-btn{border:1px solid hsla(0,0%,100%,.2);background-color:transparent;border-color:#fff}.multi-teams .team-sidebar .team-wrapper .team-container.active:before{background:#000;content:\"\";height:100%;left:0;position:absolute;top:0;width:5px}.multi-teams .team-sidebar .team-wrapper .team-container.unread:before{background:#000;border-radius:50%;content:\"\";height:5px;left:0;position:absolute;top:18px;width:5px}.multi-teams .team-sidebar .team-wrapper .team-container a.team-disabled{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;cursor:not-allowed}.multi-teams .team-sidebar .team-wrapper .team-container a:hover{text-decoration:none}.multi-teams .sidebar--left{left:65px}.multi-teams .sidebar--left.new-sidebar{left:0}.multi-teams .sidebar--left .nav-pills__unread-indicator{left:80px}.multi-teams .app__content{margin-left:285px}.webhooks__container{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:rgba(0,0,0,.1);border:1px solid;margin-top:10px;padding:0 13px 15px}.webhook__item{font-size:13px;position:relative}.webhook__item:last-child .divider-light:last-child{display:none}.webhook__item .webhook__remove{color:#e05f5d;font-size:22px;font-weight:700;height:30px;position:absolute;right:-7px;text-align:center;text-decoration:none;top:8px;width:30px}.webhook__item .webhook__url{padding-right:20px}.post.post--comment .attachment .attachment__body__wrap .btn-close{left:-11px}.post .attachment{margin-left:-20px;position:relative}.post .attachment:hover .attachment__body__wrap .btn-close{visibility:visible}.post .attachment.attachment--opengraph{max-width:800px}.post .attachment .attachment__content{border-radius:4px;border-style:solid;border-width:1px;margin:5px 0 5px 20px;padding:2px 5px}.post .attachment .attachment__thumb-pretext{background:transparent;border:none;margin-left:25px}.post .attachment .attachment__container{border-left-style:solid;border-left-width:4px;padding:10px}.post .attachment .attachment__container.attachment__container--good{border-left-color:#00c100}.post .attachment .attachment__container.attachment__container--warning{border-left-color:#dede01}.post .attachment .attachment__container.attachment__container--danger{border-left-color:#e40303}.post .attachment .attachment__container.attachment__container--opengraph{border-left-color:transparent;border-left-style:none;display:table;margin:0;padding-bottom:13px;padding-left:5px;table-layout:fixed;width:100%}.post .attachment .attachment__container.attachment__container--opengraph div{margin:0}.post .attachment .attachment__container .sitename{color:#a3a3a3}.post .attachment .attachment__body__wrap.attachment__body__wrap--opengraph{display:table-cell;vertical-align:top;width:100%}.post .attachment .attachment__body__wrap .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4;background:transparent;border:none;color:inherit;font-size:21px;font-weight:500;height:20px;left:-7px;line-height:20px;outline:none;padding:0;position:absolute;text-align:center;text-decoration:none;text-shadow:none;visibility:hidden;width:20px;z-index:5}.post .attachment .attachment__body__wrap .btn-close span{font-family:Open Sans,sans-serif;line-height:10px}.post .attachment .attachment__body__wrap .btn-close:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.post .attachment .attachment__body__wrap:hover .btn-close{visibility:visible}.post .attachment .attachment__body{float:left;overflow-x:auto;overflow-y:hidden;padding-right:5px;width:80%}.post .attachment .attachment__body.attachment__body--no_thumb{width:100%}.post .attachment .attachment__body.attachment__body--opengraph{float:none;padding-right:0;width:100%;word-wrap:break-word}.post .attachment .attachment__text p:last-of-type{display:inline-block}.post .attachment .attachment__image__container--openraph{display:table-cell;padding-left:15px;padding-top:3px;vertical-align:top;width:95px}.post .attachment .attachment__image{margin-bottom:1em;max-height:300px;max-width:500px}.post .attachment .attachment__image.attachment__image--openraph{margin-bottom:0;max-height:80px;max-width:100%}.post .attachment .attachment__image.attachment__image--openraph.loading{height:80px}.post .attachment .attachment__image.attachment__image--openraph.large_image{border-radius:3px;margin-top:10px;max-height:200px;max-width:400px;width:100%}.post .attachment .attachment__image.attachment__image--openraph.large_image.loading{height:150px}.post .attachment .attachment__author-name{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.post .attachment .attachment__title{font-size:14px;font-weight:600;height:22px;line-height:18px;margin:5px 0;padding:0}.post .attachment .attachment__title.has-link{color:#2f81b7;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .attachment .attachment__title.attachment__title--opengraph{height:auto;word-wrap:break-word}.post .attachment .attachment__title.attachment__title--opengraph.is-url{word-break:break-all}.post .attachment .attachment-link-more{display:inline-block;font-size:.9em;margin:5px 0}.post .attachment .attachment__author-icon{-webkit-border-radius:50px;-moz-border-radius:50px;-ms-border-radius:50px;-o-border-radius:50px;border-radius:50px;height:14px;margin-right:5px;width:14px}.post .attachment .attachment__thumb-container{float:right;text-align:right;width:80px}.post .attachment .attachment__thumb-container img{max-height:75px;max-width:100%}.post .attachment .attachment-fields{width:100%}.post .attachment .attachment-fields .attachment-field__caption{font-weight:600;padding-top:.7em}.post .attachment .attachment-fields .attachment-field p{margin:0}@media screen and (max-width:1800px){.inner-wrap.move--left .date-separator.hovered--comment:after,.inner-wrap.move--left .date-separator.hovered--comment:before,.inner-wrap.move--left .new-separator.hovered--comment:after,.inner-wrap.move--left .new-separator.hovered--comment:before,.inner-wrap.webrtc--show .date-separator.hovered--comment:after,.inner-wrap.webrtc--show .date-separator.hovered--comment:before,.inner-wrap.webrtc--show .new-separator.hovered--comment:after,.inner-wrap.webrtc--show .new-separator.hovered--comment:before{background:none}}@media screen and (max-width:1440px){.inner-wrap.move--left .help__format-text,.inner-wrap.webrtc--show .help__format-text{display:none}.date-separator.hovered--comment:after,.date-separator.hovered--comment:before,.new-separator.hovered--comment:after,.new-separator.hovered--comment:before{background:none!important}.backstage-content{margin:46px 46px 46px 150px}}@media screen and (max-width:1140px){.tip-overlay.tip-overlay--chat{margin:-10px 0 0 -10px}.tip-overlay.tip-overlay--chat .arrow{left:auto;right:15px}.help__format-text{display:none}.inner-wrap.move--left .file-overlay,.inner-wrap.webrtc--show .file-overlay{font-size:1.28571em}.inner-wrap.move--left .file-overlay .overlay__circle,.inner-wrap.webrtc--show .file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.inner-wrap.move--left .file-overlay .overlay__files,.inner-wrap.webrtc--show .file-overlay .overlay__files{margin:60px auto 15px;width:150px}}@media (max-width:1024px){.channel-header .search-bar__container .search__form{width:150px}.integration-option{width:280px}}@media (min-width:992px){.modal-lg{width:700px}}@media screen and (max-width:960px){.textarea-wrapper .textbox-help-link,.textarea-wrapper .textbox-preview-link{display:none}.post-right__scroll .post-create__container .post-create-body .icon__emoji_picker{display:none;top:-7px}.post-create__container .post-create.post-create--attachment-disabled .post-body__cell,.post-create__container .post-create.post-create--attachment-disabled .post-create-footer{padding-left:1em}.post-create__container form{padding:.5em 0 0}.post-create__container .post-create-footer{padding:0 45px 0 8px}.post-create__container .post-create-footer .post-error{position:relative;top:0}.sidebar--right .post-create__container .post-create-footer .post-error{left:0}.post-create__container .post-create-body{display:table;width:100%}.post-create__container .post-create-body .post-body__cell{display:table-cell;padding-left:65px}.sidebar--right .post-create__container .post-create-body .post-body__cell{padding-left:0}.app__content .post-create__container .post-create-body .btn-file{bottom:-2px;left:10px;line-height:36px;padding:0;top:auto;width:45px}.app__content .post-create__container .post-create-body .icon{position:relative;top:3px}.app__content .post-create__container .post-create-body .icon--emoji-picker{line-height:36px}.post-create__container .post-create-body .icon__emoji_picker{position:relative;display:none;top:1px;right:-1px}.post-create__container .post-create-body .send-button{display:table-cell}.post-create__container .post-create-body .btn-send-msg{display:none}.signup-team__container.branded{display:block;margin:0 auto;max-width:380px}.signup-team__container.branded .signup__markdown{display:none}.sidebar--right{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease;-webkit-transform:translateX(100%);-moz-transform:translateX(100%);-ms-transform:translateX(100%);-o-transform:translateX(100%);transform:translateX(100%);z-index:10}.sidebar--right.move--left,.sidebar--right.webrtc--show{-webkit-transform:translateX(0)!important;-moz-transform:translateX(0)!important;-ms-transform:translateX(0)!important;-o-transform:translateX(0)!important;transform:translateX(0)!important}.sidebar--right.move--left .search-bar__container,.sidebar--right.webrtc--show .search-bar__container{z-index:5}.backstage-content{margin:30px;max-width:100%;padding:0}.backstage-sidebar{height:auto;padding:30px 15px 0;position:relative;width:100%}.inner-wrap.move--left,.inner-wrap.webrtc--show,.inner-wrap:not(.move--left){margin-right:0!important}.inner-wrap.move--left .channel-header__links,.inner-wrap.webrtc--show .channel-header__links{position:relative;right:auto;top:auto}.inner-wrap.move--left .header-list__right,.inner-wrap.move--right .header-list__right,.inner-wrap.webrtc--show .header-list__right{z-index:-1}.post .attachment .attachment__image.attachment__image--openraph{max-height:70px;max-width:300px}.post .attachment .attachment__image.attachment__image--openraph.loading{height:70px}}@media screen and (min-width:768px){.col-sm-auto{float:left}.second-bar{display:none}.sidebar--right.move--left,.sidebar--right.webrtc--show{-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);-o-transform:translateX(0);transform:translateX(0)}.sidebar--right.sidebar--right--expanded{width:calc(100% - 280px)}.sidebar--right.sidebar--right--expanded .sidebar--right__bg{background-color:rgba(0,0,0,.4);visibility:visible}.sidebar--right.sidebar--right--expanded .search-bar__container{padding-left:10px}.sidebar--right.sidebar--right--expanded .sidebar-right-container{position:relative;z-index:5}.sidebar--right.sidebar--right--expanded .sidebar--right__expand .fa-expand{display:none}.sidebar--right.sidebar--right--expanded .sidebar--right__expand .fa-compress{display:inline-block}.sidebar--right .sidebar--right__title{display:inline-block;max-width:500px;text-overflow:ellipsis;white-space:nowrap}.inner-wrap.move--left,.inner-wrap.webrtc--show{margin-right:400px}.channel__wrap .post.post--compact .post__time{font-size:.85em;left:-79px;position:absolute;text-align:right;top:3px;width:60px}.channel__wrap .post.post--compact .star-icon__container{left:-65px;position:absolute;text-align:right;top:6px;width:60px}.post.post--compact .post__pinned-badge{margin-left:0;margin-right:5px}.post.post--compact:not(.post--thread){padding:0 .5em 0 77px}.post.post--compact:not(.post--thread) .post__link{margin:3px 0 7px;vertical-align:bottom}.post.post--compact:not(.post--thread) span p:last-child{margin-bottom:0}.post.post--compact:not(.post--thread) .post__header{float:left;height:21px;padding-top:2px}.post.post--compact:not(.post--thread) .post__header .col__name{font-weight:700;margin-right:2px;padding-right:5px;position:relative;z-index:1}.post.post--compact:not(.post--thread) .post__header .colon{display:inline}.post.post--compact:not(.post--thread) .post__header .col__reply{top:-1px}.post.post--compact:not(.post--thread).other--root .post__link+.post__body{clear:both}.post.post--compact:not(.post--thread).other--root.post--comment .post__header .col__reply{top:-1px}.post.post--compact:not(.post--thread) .post-code{clear:both}.post.post--compact:not(.post--thread) .post__body{width:100%}.post.post--compact:not(.post--thread) .post__content{padding-right:45px}.post.post--compact .flag-icon__container{left:-21px;position:absolute;top:4px}.sidebar--right .post.post--compact .flag-icon__container{left:auto;position:relative;top:1px}.post.post--compact.same--root.same--user{padding-left:77px;padding-top:0}.post.post--compact.same--root.same--user .flag-icon__container{left:-19px;position:absolute;top:4px}.post.post--compact.same--root.same--user .post__header .col__reply{top:-1px}.post.post--compact.same--root.same--user .post__img img{display:none}.post.post--compact.same--root.same--user.post--root .post__img img{display:block}.post.post--compact.same--root.same--user.post--root .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.post.post--compact.same--root.post--comment{padding-top:1px}.post.post--compact.same--root.post--comment.same--user .post__img img{display:none}.post.post--compact.same--root.post--comment .post__header{margin-left:12px}.post.same--root.same--user .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0}.post.same--root.same--user .post__header{float:left;padding-top:3px}.post.same--root.same--user .post__header .col__reply{top:-21px}.post.same--root.same--user .post__header .post__pinned-badge{margin-right:5px}.post.same--root.same--user.post--pinned .post__body:before{content:\"\";display:block;height:21px;width:1px}.post.same--root.same--user:not(.post--compact) .post__time{display:inline-block;font-size:11px;left:-14px;line-height:20px;position:absolute;text-align:right;text-rendering:auto;top:4px;width:51px}.post.same--root.same--user:not(.post--compact) .post__time:hover{text-decoration:underline}.post.same--root.post--comment:not(.post--compact) .post__pinned-badge{margin-left:10px}}@media screen and (max-width:768px){.channel-header .channel-header__icon{display:none}.member-drop .member-menu,.member-role .member-menu{right:0;top:30px}.post-code{word-wrap:normal}.table-responsive{border:none}.multi-select__container .btn{display:block;min-width:50px}.multi-select__container .Select-value-label{max-width:190px;text-overflow:ellipsis}.more-modal__list .more-modal__actions--round{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.post-create__container{padding-bottom:10px}.post-create__container .msg-typing{display:none}.suggestion-list__content{max-height:145px}.webrtc__notification--rhs{left:auto;right:0;top:47px;width:205px}.filtered-user-list .filter-button .btn{width:100%}.settings-modal .modal-body{overflow:auto}#header-popover{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease;-webkit-transform:translate3d(0,100%,0);-moz-transform:translate3d(0,100%,0);-ms-transform:translate3d(0,100%,0);-o-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;background:rgba(0,0,0,.8);border:none;height:calc(100% - 50px);max-width:100%;position:fixed;top:40px!important;width:100%}#header-popover.in{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}#header-popover .arrow{display:none}#header-popover .popover-content{color:#fff;font-size:15px;padding:15px 20px 100px}#header-popover .popover-content>div:first-child{-webkit-overflow-scrolling:touch;height:calc(100vh - 150px);overflow:auto}#header-popover .close{-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%;border-radius:50%;border:1px solid #fff;bottom:25px;color:#fff;display:block;font-family:Open Sans,sans-serif;font-size:23px;font-weight:200;height:30px;left:50%;line-height:0;margin-left:-15px;opacity:1;padding-top:13px;position:fixed;text-align:center;text-shadow:none;width:30px}.app__body .edit-modal-body .custom-textarea{max-height:30vh}.video-div.embed-responsive-item{height:0;padding-bottom:75%}.video-div.embed-responsive-item iframe{height:100%;left:0;position:absolute;top:0;width:100%}.tutorial-steps__container .tutorial__content .tutorial__steps{margin-top:15%;margin-bottom:15%;max-height:70%;padding-bottom:0}.prompt .prompt__heading{display:block}.prompt .prompt__heading>div:first-child{display:block;margin:0 0 1em}.scrollbar--view{margin-right:0!important}.post-code__language{-webkit-transition:none;-moz-transition:none;-o-transition:none;transition:none;display:block;position:relative}.post-code:hover .post-code__language,.post-code__language{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.backstage-filters{display:block}.backstage-filters .backstage-filter__search{margin:10px 0;width:100%}.audit-panel .row>.form-group,.compliance-panel .row>.form-group{padding-left:15px}.user-popover{cursor:pointer;display:inline-block}.signup-team__container{font-size:1em}.sidebar--left .team__header .user__picture,.sidebar--menu .team__header .user__picture{display:none}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after,.payment-separator.hovered--after:before,.payment-separator.hovered--before:after{background:none!important}.channel-intro{margin:0 0 35px}.post:not(.post--compact) .bot-indicator{left:6px;position:absolute;top:31px}.post .reacticon__container{display:none}.post .post__dropdown{display:inline-block;height:28px;line-height:21px;text-align:center;text-decoration:none;width:28px}.post .post__dropdown:after{content:\"...\";font-size:20px;top:-3px}.post .post__remove{margin-right:10px;visibility:visible}.post.post--compact .post__img{padding-top:0}.post.post--compact.same--root.same--user .post__header{height:auto}.post.post--compact .status-wrapper:after{bottom:3px}.sidebar--right .post.post--compact .status-wrapper:after{bottom:0}.post.post--compact blockquote{margin-top:0}.post.same--root.same--user .flag-icon__container{left:auto;position:relative;top:1px}.post .post__content{padding:0 10px 0 0}.post .post__header{margin-bottom:0;padding-right:70px}.post .post__header .col__reply{top:-3px;width:65px;z-index:auto}.post .post__header .col__name .user-popover{max-width:130px}.post .comment-icon__container,.post .social_network-icon__container{display:none;visibility:visible}.post .comment-icon__container.icon--show,.post .social_network-icon__container.icon--show,.sidebar--right .post .comment-icon__container,.sidebar--right .post .social_network-icon__container{display:inline-block}.post-list__content .post:hover{background:transparent}.post-list__content .post .comment-icon__container,.post-list__content .post .social_network-icon__container,.post .dropdown,.post .post__reply{visibility:visible}.post .post__body{width:100%}.post .post__reply{float:right;margin-right:20px}.post .post__reply svg{top:1px}.post.post--comment .post__body{margin-top:5px;padding:2px 0 0 7px}.post.other--root.post--comment .post__header .col__reply{top:-3px}.post.other--root .post__reply.post__reply--hide{visibility:hidden}.post.current--user .post__link{margin:0 0 8px}.post .star-icon__container{left:auto;position:relative;top:auto}.post .star-icon__container:not(.visible){display:none}.post.same--root .star-icon__container{left:auto;position:relative;top:auto}.post.same--root.same--user.post--compact .status-wrapper:after{bottom:-2px}.post.same--root.same--user .post__img img{display:block}.post.same--root.same--user .post__header{height:auto;margin-top:5px}.post.same--root.same--user .post__header .col__name{display:inline-block}.post .post__img{width:40px}.post .post__img img{height:32px;width:32px}.post-image__column{height:95px;width:200px}.form-control.min-height{min-height:100px}.img-div{max-width:100%}.tip-div{left:15px;right:auto}.tip-overlay.tip-overlay--chat{margin-left:10px}.tip-overlay.tip-overlay--chat .arrow{left:32px}.file-details__container{display:block}.file-details__container .file-details__preview{border-bottom:1px solid #ddd;border-right:none;display:block;height:150px;width:100%}.file-details__container .file-details__preview img{height:64px;width:64px}.file-details__container .file-details{height:auto;width:100%}.search-help-popover{left:55px;max-width:calc(100% - 80px)}.modal-direct-channels .member-count,.more-channel__modal .member-count{display:block;float:none;margin-top:10px}.file-overlay{font-size:1.28571em}.file-overlay.center-file-overlay .overlay__indent{margin-left:0}.file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.file-overlay .overlay__files{margin:60px auto 15px;width:150px}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after,.payment-separator.hovered--after:before,.payment-separator.hovered--before:after{background:none}.post-list__timestamp{display:block}.signup-team__container{font-size:.9em;margin-bottom:30px;padding:60px 10px 0}.signup-team__container .signup-team__name{font-size:2em}.signup-team__container .btn.btn-full{padding-left:10px}.signup-team__container .btn .fa,.signup-team__container .btn .icon{margin-right:6px}.app__body .row--invite .col-sm-6:first-child{padding-right:15px}.app__body .modal .modal--scroll .modal-body{max-height:calc(100vh - 62px);overflow:auto}.app__body .modal .nav-pills>li.active a{background:transparent}.app__body .modal .nav-pills>li.active a:before{display:none}.app__body .modal .info__label{padding-bottom:5px;text-align:left}.app__body .modal .modal-image .modal-button-bar{line-height:30px;padding:5px}.app__body .modal .modal-image .modal-image__wrapper>div{font-size:12px;min-width:250px}.app__body .modal .modal-image .modal-button-bar,.app__body .modal .modal-image .modal-image__wrapper .modal-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-image .modal-button-bar{padding-right:10px}.app__body .modal .modal-header .modal-action{margin-top:10px}.app__body .modal .modal-header .close{font-size:27px;font-weight:400;margin-top:-2px}.app__body .modal .modal-header .modal-title{float:none;max-width:90%}.app__body .modal .modal-header .btn.btn-primary{display:block;float:none;margin:10px 0 6px;width:100%}.app__body .modal .settings-modal .modal-body{min-height:100%}.app__body .modal .settings-modal .nav-pills>li:hover a{background:transparent!important}.app__body .modal .settings-modal.display--content .modal-header{display:none}.app__body .modal .settings-modal.display--content .settings-table{display:block}.app__body .modal .settings-modal.display--content .settings-table .settings-content .section-title{padding-right:15px}.app__body .modal .settings-modal.display--content .settings-table .settings-content .section-edit{position:relative;right:0;text-align:left;top:0}.app__body .modal .settings-modal.display--content .settings-table .settings-content .appearance-section .theme-elements .element,.app__body .modal .settings-modal.display--content .settings-table .settings-content .appearance-section .theme-elements .element:nth-child(2n){margin-right:10px}.app__body .modal .settings-modal.display--content .settings-table .settings-content.minimize-settings{display:block}.app__body .modal .settings-modal.display--content .settings-table .settings-content .section-min:hover{background:none}.app__body .modal .settings-modal.display--content .settings-table .settings-content .no-padding--left{padding-left:15px}.app__body .modal .settings-modal.display--content .settings-table .settings-links{display:none}.app__body .modal .settings-modal.display--content .settings-table .modal-header{display:block;position:absolute;top:0;width:100%;z-index:5}.app__body .modal .settings-modal.display--content .settings-table .modal-header .modal-title{max-width:100%;padding:0 40px;text-align:center;width:100%}.app__body .modal .settings-modal.display--content .settings-table .modal-header .modal-title>span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.app__body .modal .settings-modal.display--content .settings-table .user-settings .divider-dark.first,.app__body .modal .settings-modal.display--content .settings-table .user-settings .tab-header{display:none}.app__body .modal .settings-modal .settings-table{padding:0}.app__body .modal .settings-modal .settings-table .nav{position:relative;top:auto;width:100%}.app__body .modal .settings-modal .settings-table .nav.position--top{top:auto}.app__body .modal .settings-modal .settings-table .settings-content .section-edit{text-align:left}.app__body .modal .settings-modal .settings-table .settings-content .section-edit .fa{display:inline-block}.app__body .modal .settings-modal .settings-table .settings-content.minimize-settings{display:none;padding:0}.app__body .modal .settings-modal .settings-table .settings-content.minimize-settings .user-settings{padding:70px 20px 30px}.app__body .modal .settings-modal .settings-table .settings-content .section-min:hover{background:none!important}.app__body .modal .settings-modal .settings-table .nav>li>a{border-bottom:1px solid transparent;font-size:1.1em;line-height:2.7}.app__body .modal .settings-modal .settings-table .nav>li>a .icon{margin:0 7px}.file-preview__container{margin:5px 0 0}.admin-sidebar .navbar-nav,.file-preview{margin-top:0}.admin-sidebar .navbar-nav>li{float:left}.admin-sidebar .navbar-nav .dropdown-menu{background:#fff;left:auto;position:absolute;right:0}#navbar .navbar-default .navbar-header{float:none;margin:0 -15px}#navbar .navbar-default .navbar-header .dropdown__icon{-webkit-background-size:100% 100%;-moz-background-size:100% 100%;-o-background-size:100% 100%;background-size:100% 100%;display:inline-block;height:16px;width:4px}#navbar .navbar-default .navbar-toggle{display:block}#navbar .navbar-default .navbar-brand{white-space:nowrap}#navbar .navbar-default .navbar-brand .heading{font-size:17px;font-weight:400;line-height:50px;position:relative;vertical-align:top}.ios #navbar .navbar-default .navbar-brand .heading{line-height:48px}#navbar .navbar-default .navbar-brand .header-dropdown__icon{font-size:12px;line-height:50px;margin-left:5px;top:0;vertical-align:top}#navbar .navbar-default .dropdown.open .dropdown-menu{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0);visibility:visible}#navbar .navbar-default .dropdown-menu{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease;-webkit-transform:translate3d(0,100%,0);-moz-transform:translate3d(0,100%,0);-ms-transform:translate3d(0,100%,0);-o-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);background:rgba(0,0,0,.9);display:block;height:calc(100% - 48px);left:0;overflow:auto;padding:1.4em 0 0;position:fixed;top:48px;visibility:hidden;width:100%}#navbar .navbar-default .dropdown-menu .close{-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%;border-radius:50%;border:1px solid #fff;bottom:25px;color:#fff;display:block;font-family:Open Sans,sans-serif;font-size:23px;font-weight:200;height:30px;left:50%;line-height:0;margin-left:-15px;opacity:1;padding-top:13px;position:fixed;text-align:center;text-shadow:none;width:30px}#navbar .navbar-default .dropdown-menu>li>a{border-bottom:1px solid hsla(0,0%,100%,.3);color:#fff;font-weight:600;line-height:35px;margin:0 auto;text-align:center;width:90%}#navbar .navbar-default .dropdown-menu>li>a:hover{background:transparent}#navbar .navbar-default .status{margin:0 5px 0 3px;top:2px;width:16px}#navbar .navbar-default .status svg{max-height:20px;width:16px}body.white .inner-wrap>.row.content{margin-bottom:-185px}.footer,.footer-pane,.footer-push{height:187px}.footer-pane .footer-link{line-height:1.7;padding:0;text-align:right;width:100%}.footer-pane .footer-link.copyright{width:100%}.search-bar__container{-webkit-flex:0 0 50px;flex:0 0 50px;background:#2389d7;color:#fff;padding:0}.search-bar__container .search-form__container{padding:0}.search-bar__container .search__form{-webkit-transition:all .2s linear;-webkit-transition-delay:0s;-moz-transition:all .2s linear;-o-transition:all .2s linear;transition:all false .2s linear;-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);-o-transform:translateX(0);transform:translateX(0);border:none;margin-top:9px;width:100%}.search-bar__container .search__form .fa-spin{font-size:1.1em;top:9px}.search-bar__container .search__form .search-bar{font-size:14px;height:32px;padding:0 40px}.search-bar__container .search__form .search__icon{left:15px;top:7px}.search-bar__container .search__form .search__icon svg{width:17px}.search-bar__container .search__form .icon--refresh{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;right:16px;top:9px}.search-bar__container .search__form .form-control{-webkit-border-radius:3px;-moz-border-radius:3px;-ms-border-radius:3px;-o-border-radius:3px;border-radius:3px;background:#fff;border:none;color:rgba(0,0,0,.5);padding:0 31px}.search-bar__container .channel-header__links{display:none}.sidebar--menu{-webkit-transition:-webkit-transform .35s ease;-webkit-transition-delay:0s;-moz-transition:-moz-transform .35s ease;-o-transition:-o-transform .35s ease;transition:transform false .35s ease;-webkit-transform:translate3d(290px,0,0);-moz-transform:translate3d(290px,0,0);-ms-transform:translate3d(290px,0,0);-o-transform:translate3d(290px,0,0);transform:translate3d(290px,0,0);border:none;visibility:hidden;width:290px}.sidebar--menu.visible{display:block;visibility:visible}.sidebar--menu.move--left,.sidebar--menu.webrtc--show{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0);display:block;visibility:visible}.sidebar--left{-webkit-transition:-webkit-transform .35s ease;-webkit-transition-delay:0s;-moz-transition:-moz-transform .35s ease;-o-transition:-o-transform .35s ease;transition:transform false .35s ease;-webkit-transform:translate3d(-290px,0,0);-moz-transform:translate3d(-290px,0,0);-ms-transform:translate3d(-290px,0,0);-o-transform:translate3d(-290px,0,0);transform:translate3d(-290px,0,0);border:none;width:290px}.sidebar--left.sidebar--padded{padding-top:0}.sidebar--left.move--right{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.sidebar--left .nav-pills__container{height:calc(100% - 55px)}.sidebar--left.new-sidebar.move--right{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.sidebar--left.new-sidebar .team__header-container{display:none}.sidebar--left.new-sidebar .nav-pills__container{height:calc(100% - 55px)}.sidebar--left.new-sidebar .nav-pills__unread-indicator-top{width:190px;top:90px}.sidebar--left.new-sidebar .nav li>a{line-height:1.5}.sidebar--left>div{padding-bottom:70px}.sidebar--left .nav-pills__unread-indicator{width:260px}.sidebar--left .badge{top:13px}.sidebar--left .profile-background{display:none}.sidebar--left .team__header{overflow:hidden;*zoom:1;pointer-events:none;height:auto;padding:16px 40px 12px 12px}.sidebar--left .team__header .user__name,.sidebar--left .team__header .user__nickname{display:none}.sidebar--left .team__header .team__name{display:block;margin:10px 0}.sidebar--left .team__header .sidebar-header-dropdown{display:none}.sidebar--left .search__form{display:block}.sidebar--left .nav li.dropdown.open{padding-bottom:25px}.sidebar--left .nav li.dropdown.open ul{background:#fff;border-radius:3px;clear:both;position:relative;top:5px}.sidebar--left .nav li.dropdown.open ul li a{line-height:30px}.sidebar--left .nav li h4{margin:2em 0 1.5em}.sidebar--left .nav li>a{font-size:15px;line-height:2.5;margin:0}.sidebar--left .nav li>a:focus,.sidebar--left .nav li>a:hover{background:transparent!important}.sidebar--left .nav li>a.has-close .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:block;right:0;text-align:center;width:40px}.sidebar--left .sidebar__switcher{display:block}.sidebar--right{-webkit-transform:translate3d(100%,0,0);-moz-transform:translate3d(100%,0,0);-ms-transform:translate3d(100%,0,0);-o-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);right:0;width:100%}.sidebar--right .post-create__container form{padding:.5em 1em}.sidebar--right .post-create__container .emoji-rhs{display:inline-block;position:relative;right:-1px;top:1px}.sidebar--right .post-create__container .msg-typing:empty{display:none}.sidebar--right .post-create__container .post-create-footer .control-label{margin:.5em 0;top:0}.sidebar--right .post-create__container .post-create-footer .post-error{left:0;top:0}.sidebar--right .sidebar-collapse__container{display:table-cell;vertical-align:top}.sidebar--right .sidebar__search-clear{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;color:inherit;display:block;height:32px;margin-right:0;text-align:center;top:0;width:42px}.sidebar--right .sidebar__search-clear.visible{visibility:visible}.sidebar--right .sidebar__search-clear-x{font-size:21px;font-weight:700;line-height:0;position:relative;top:9px}.sidebar--right .sidebar--right__close,.sidebar--right .sidebar--right__expand{display:none}.search-items-container,.sidebar--right .sidebar-right__body{height:calc(100% - 56px)}.inner-wrap{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease}.app__body .inner-wrap:before{background-color:transparent;content:\"\";height:100%;left:-15px;position:absolute;top:0;transition:background-color .35s ease,z-index 0s ease .35s;width:calc(100% + 30px);z-index:0}.inner-wrap.move--right{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.inner-wrap.move--right:before{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease;background-color:rgba(0,0,0,.4);z-index:9999}.inner-wrap.move--left-small{-webkit-transform:translate3d(-290px,0,0);-moz-transform:translate3d(-290px,0,0);-ms-transform:translate3d(-290px,0,0);-o-transform:translate3d(-290px,0,0);transform:translate3d(-290px,0,0)}.inner-wrap.move--left-small:before{-webkit-transition:all .35s ease;-webkit-transition-delay:0s;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all false .35s ease;background-color:rgba(0,0,0,.4);z-index:9999}.inner-wrap.move--left,.inner-wrap.webrtc--show{margin:0;-webkit-transform:translate3d(-100%,0,0);-moz-transform:translate3d(-100%,0,0);-ms-transform:translate3d(-100%,0,0);-o-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.integration-option{height:auto;margin-left:0;width:100%}.app__content{margin:0}.app__content,.channel__wrap .app__content{padding-top:50px}.app__content #channel-header{display:none}.channel__wrap .row.header{display:block}.post-comments{padding:9px 21px 10px 10px!important}.multi-teams .app__content,.new-layout .app__content{margin-left:0}.multi-teams .sidebar--left{left:0}.multi-teams .sidebar--left.move--right{left:65px}.multi-teams .sidebar--left .nav-pills__unread-indicator{left:15px}.multi-teams .team-sidebar{display:none}.multi-teams .team-sidebar.move--right{display:block;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.post .attachment .attachment__body__wrap .btn-close{height:30px;left:-15px;top:7px;visibility:visible;width:30px}.post .attachment .attachment__image.attachment__image--openraph{max-width:200px}}@media screen and (max-width:640px){.filtered-user-list{height:calc(100vh - 80px)}.more-modal--action .filtered-user-list{height:calc(100vh - 110px)}.app__body .modal .more-modal .modal-body{max-height:calc(100vh - 62px);padding-bottom:5px}.app__body .post .open>.dropdown-menu__content{display:table}.app__body .post .open>.dropdown-menu__content>.dropdown-menu{display:table-cell}.app__body .post .dropdown-menu__content{height:100%;left:0;position:fixed;top:0;width:100%;z-index:9999}.app__body .post .dropdown-menu__content:before{background:rgba(0,0,0,.3);content:\"\";height:100%;left:0;position:fixed;top:0;width:100%}.app__body .post .dropdown-menu{background:transparent;border:none;bottom:auto;box-shadow:none;float:none;height:100%;left:0;margin:0;padding:0 2em;position:relative;top:0;vertical-align:middle;width:100%;z-index:9999}.app__body .post .dropdown-menu.bottom{bottom:auto;top:0}.app__body .post .dropdown-menu>li:last-child a{border:none}.app__body .post .dropdown-menu a{border-bottom:1px solid;line-height:45px;position:relative;text-align:center}.app__body .modal{overflow:hidden;padding:0!important}.app__body .modal .modal-dialog{height:100%;margin:0;max-width:100%}.app__body .modal .modal-dialog .modal-content{height:100%}.app__body .modal .modal-footer{bottom:0;position:fixed;width:100%}.app__body .modal .about-modal .about-modal__content{display:block}.app__body .modal .about-modal .about-modal__hash p{word-break:break-all}.app__body .modal .about-modal .about-modal__hash p:first-child{float:none}.app__body .modal .about-modal .about-modal__logo{float:none;padding:0;text-align:center;width:100%}.app__body .modal .about-modal .about-modal__logo svg{height:100px;width:100px}.app__body .modal .about-modal .about-modal__logo+div{padding:2em 0 0}.access-history__table>div{display:block}.access-history__table .access__report{margin:0 0 15px 15px}.access-history__table .access__date div{margin-bottom:15px}.activity-log__table>div{display:block}.activity-log__table .activity-log__report{width:100%}.activity-log__table .activity-log__action{margin-top:10px;text-align:left}.post .attachment .attachment__image.attachment__image--openraph{max-width:200px}}@media screen and (max-width:550px){.app__body .more-modal.more-system-members .filter-row{min-height:80px;width:100%}.app__body .more-modal.more-direct-channels .member-show{display:none}.app__body .more-modal.more-direct-channels select{margin:0;width:100%}.member-select__container{left:15px;top:60px;width:calc(100% - 30px)}.post .attachment .attachment__image.attachment__image--openraph{max-width:180px}}@media screen and (max-width:480px){#user-profile-popover{left:50px!important}.post .img-div{max-width:100%}.nav-tabs{margin-top:1em}.nav-tabs>li{margin-right:0}.nav-tabs>li a{font-size:.9em;padding:6px 11px}.sidebar--right .post.post--compact .post__header{height:auto}.backstage-header h1{float:none;margin-bottom:15px}.backstage-header .add-integrations-link{float:none}.backstage-list__item{display:block}.backstage-list__item .actions,.backstage-list__item .item-actions{margin-top:15px;padding:0}.app__body .modal .settings-modal.display--content .modal-body{max-height:90%}.app__body .modal .settings-modal .modal-body{max-height:70%;padding-bottom:0}.app__body .modal .settings-modal .settings-table .security-links{display:block;margin-bottom:10px}.app__body .modal .settings-modal .settings-table .security-links:last-child{margin-bottom:0}.tip-overlay.tip-overlay--sidebar{min-height:350px}.member-div{padding:8px 0}.member-div .member-drop,.member-div .member-role{margin:0 0 0 44px;padding:5px 0;position:relative;right:0;top:0}.member-div .open>.dropdown-menu{left:0;right:auto}.sidebar--left{width:260px}.sidebar--left.new-sidebar{-webkit-transform:translate3d(-285px,0,0);-moz-transform:translate3d(-285px,0,0);-ms-transform:translate3d(-285px,0,0);-o-transform:translate3d(-285px,0,0);transform:translate3d(-285px,0,0)}.sidebar--left:not(.new-sidebar){-webkit-transform:translate3d(-260px,0,0);-moz-transform:translate3d(-260px,0,0);-ms-transform:translate3d(-260px,0,0);-o-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0)}.sidebar--left .nav-pills__unread-indicator{width:230px}.inner-wrap.move--right{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.integration__icon{display:none}.post .attachment .attachment__image.attachment__image--openraph{max-width:120px}.post-namecard__thumbnail{display:none}.post-namecard__column,.post-namecard__column.is-rhs{width:97%}.post-namecard__column.is-rhs .post-namecard__details,.post-namecard__column .post-namecard__details,.post-namecard__details{width:100%}}@media screen and (max-height:640px){.signup-team__container{font-size:.9em;margin-bottom:30px}.signup-team__container .signup-team__name{font-size:2em}}@media screen and (max-width:320px){.multi-teams .sidebar--left{width:220px}.multi-teams .sidebar--left.new-sidebar{width:285px}.multi-teams .sidebar--left .nav-pills__unread-indicator{width:190px}.post .post__header .col__name .user-popover{max-width:105px}.post .attachment .attachment__image.attachment__image--openraph{max-width:80px}.tutorial-steps__container{left:0;position:fixed;top:0;z-index:9999}.tutorial-steps__container .tutorial__content .tutorial__steps{margin-top:20px;min-height:auto;padding:0 20px;width:100%}.tutorial-steps__container .tutorial__content .tutorial__steps h1{font-size:2em;margin:-5px 0 20px}.tutorial-steps__container .tutorial__content .tutorial__steps h3{font-size:1.5em;margin-bottom:10px}.tutorial-steps__container .tutorial__content .tutorial__steps .tutorial__app-icons{margin:10px 0}.tutorial-steps__container .tutorial__content .tutorial__steps .tutorial__circles{bottom:auto;margin:15px 0 20px;position:relative}.tutorial-steps__container .tutorial__content .tutorial__steps .tutorial__footer{bottom:auto;position:relative}.tip-overlay.tip-overlay--sidebar{min-height:440px}}@media screen and (max-width:380px) and (max-height:580px){#navbar .navbar-default .dropdown-menu{padding-top:1em}#navbar .navbar-default .dropdown-menu>li>a{border:none;font-size:13px;line-height:27px}}label span{pointer-events:none}label span a{pointer-events:all}@media screen and (-webkit-min-device-pixel-ratio:0){input,select,textarea{font-size:16px}}", ""]);

// exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(451) + ");src:url(" + __webpack_require__(451) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1116) + ") format(\"woff2\"),url(" + __webpack_require__(1117) + ") format(\"woff\"),url(" + __webpack_require__(1118) + ") format(\"truetype\"),url(" + __webpack_require__(1119) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:transparent;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);

// exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/89889688147bd7575d6327160d64e760.svg";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Jasny Bootstrap v3.1.3 (http://jasny.github.io/bootstrap)\n * Copyright 2012-2014 Arnold Daniels\n * Licensed under Apache-2.0 (https://github.com/jasny/bootstrap/blob/master/LICENSE)\n */.container-smooth{max-width:1170px}@media (min-width:1px){.container-smooth{width:auto}}.btn-labeled{padding-top:0;padding-bottom:0}.btn-label{position:relative;left:-12px;display:inline-block;padding:6px 12px;background:transparent;background:rgba(0,0,0,.15);border-radius:3px 0 0 3px}.btn-label.btn-label-right{right:-12px;left:auto;border-radius:0 3px 3px 0}.btn-lg .btn-label{left:-16px;padding:10px 16px;border-radius:5px 0 0 5px}.btn-lg .btn-label.btn-label-right{right:-16px;left:auto;border-radius:0 5px 5px 0}.btn-sm .btn-label{left:-10px;padding:5px 10px;border-radius:2px 0 0 2px}.btn-sm .btn-label.btn-label-right{right:-10px;left:auto;border-radius:0 2px 2px 0}.btn-xs .btn-label{left:-5px;padding:1px 5px;border-radius:2px 0 0 2px}.btn-xs .btn-label.btn-label-right{right:-5px;left:auto;border-radius:0 2px 2px 0}.nav-tabs-bottom{border-top:1px solid #ddd;border-bottom:0}.nav-tabs-bottom>li{margin-top:-1px;margin-bottom:0}.nav-tabs-bottom>li>a{border-radius:0 0 4px 4px}.nav-tabs-bottom>li.active>a,.nav-tabs-bottom>li.active>a:focus,.nav-tabs-bottom>li.active>a:hover,.nav-tabs-bottom>li>a:focus,.nav-tabs-bottom>li>a:hover{border:1px solid #ddd;border-top-color:transparent}.nav-tabs-left{border-right:1px solid #ddd;border-bottom:0}.nav-tabs-left>li{float:none;margin-right:-1px;margin-bottom:0}.nav-tabs-left>li>a{margin-right:0;margin-bottom:2px;border-radius:4px 0 0 4px}.nav-tabs-left>li.active>a,.nav-tabs-left>li.active>a:focus,.nav-tabs-left>li.active>a:hover,.nav-tabs-left>li>a:focus,.nav-tabs-left>li>a:hover{border:1px solid #ddd;border-right-color:transparent}.row>.nav-tabs-left{position:relative;z-index:1;padding-right:0;padding-left:15px;margin-right:-1px}.nav-tabs-right,.row>.nav-tabs-left+.tab-content{border-left:1px solid #ddd}.nav-tabs-right{border-bottom:0}.nav-tabs-right>li{float:none;margin-bottom:0;margin-left:-1px}.nav-tabs-right>li>a{margin-bottom:2px;margin-left:0;border-radius:0 4px 4px 0}.nav-tabs-right>li.active>a,.nav-tabs-right>li.active>a:focus,.nav-tabs-right>li.active>a:hover,.nav-tabs-right>li>a:focus,.nav-tabs-right>li>a:hover{border:1px solid #ddd;border-left-color:transparent}.row>.nav-tabs-right{padding-right:15px;padding-left:0}.navbar-offcanvas,.navmenu{width:300px;height:auto;border-style:solid;border-width:1px;border-radius:4px}.navbar-offcanvas,.navmenu-fixed-left,.navmenu-fixed-right{position:fixed;top:0;bottom:0;z-index:1050;overflow-y:auto;border-radius:0}.navbar-offcanvas.navmenu-fixed-left,.navmenu-fixed-left{right:auto;left:0;border-width:0 1px 0 0}.navbar-offcanvas,.navmenu-fixed-right{right:0;left:auto;border-width:0 0 0 1px}.navmenu-nav{margin-bottom:10px}.navmenu-nav.dropdown-menu{position:static;float:none;padding-top:0;margin:0;border:none;border-radius:0;-webkit-box-shadow:none;box-shadow:none}.navbar-offcanvas .navbar-nav{margin:0}@media (min-width:768px){.navbar-offcanvas{width:auto;border-top:0;box-shadow:none}.navbar-offcanvas.offcanvas{position:static;display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-offcanvas .navbar-nav.navbar-left:first-child{margin-left:-15px}.navbar-offcanvas .navbar-nav.navbar-right:last-child{margin-right:-15px}.navbar-offcanvas .navmenu-brand{display:none}}.navmenu-brand{display:block;padding:10px 15px;margin:10px 0;font-size:18px;line-height:20px}.navmenu-brand:focus,.navmenu-brand:hover{text-decoration:none}.navbar-default .navbar-offcanvas,.navmenu-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-brand,.navmenu-default .navmenu-brand{color:#777}.navbar-default .navbar-offcanvas .navmenu-brand:focus,.navbar-default .navbar-offcanvas .navmenu-brand:hover,.navmenu-default .navmenu-brand:focus,.navmenu-default .navmenu-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-offcanvas .navmenu-text,.navmenu-default .navmenu-text{color:#777}.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a:focus .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a:hover .caret,.navmenu-default .navmenu-nav>.dropdown>a:focus .caret,.navmenu-default .navmenu-nav>.dropdown>a:hover .caret{border-top-color:#333;border-bottom-color:#333}.navbar-default .navbar-offcanvas .navmenu-nav>.open>a,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:hover,.navmenu-default .navmenu-nav>.open>a,.navmenu-default .navmenu-nav>.open>a:focus,.navmenu-default .navmenu-nav>.open>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav>.open>a .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:focus .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:hover .caret,.navmenu-default .navmenu-nav>.open>a .caret,.navmenu-default .navmenu-nav>.open>a:focus .caret,.navmenu-default .navmenu-nav>.open>a:hover .caret{border-top-color:#555;border-bottom-color:#555}.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a .caret,.navmenu-default .navmenu-nav>.dropdown>a .caret{border-top-color:#777;border-bottom-color:#777}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu,.navmenu-default .navmenu-nav.dropdown-menu{background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.divider,.navmenu-default .navmenu-nav.dropdown-menu>.divider{background-color:#f8f8f8}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a,.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:hover,.navmenu-default .navmenu-nav.dropdown-menu>.active>a,.navmenu-default .navmenu-nav.dropdown-menu>.active>a:focus,.navmenu-default .navmenu-nav.dropdown-menu>.active>a:hover{background-color:#d7d7d7}.navbar-default .navbar-offcanvas .navmenu-nav>li>a,.navmenu-default .navmenu-nav>li>a{color:#777}.navbar-default .navbar-offcanvas .navmenu-nav>li>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>li>a:hover,.navmenu-default .navmenu-nav>li>a:focus,.navmenu-default .navmenu-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-offcanvas .navmenu-nav>.active>a,.navbar-default .navbar-offcanvas .navmenu-nav>.active>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.active>a:hover,.navmenu-default .navmenu-nav>.active>a,.navmenu-default .navmenu-nav>.active>a:focus,.navmenu-default .navmenu-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a,.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a:hover,.navmenu-default .navmenu-nav>.disabled>a,.navmenu-default .navmenu-nav>.disabled>a:focus,.navmenu-default .navmenu-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-inverse .navbar-offcanvas,.navmenu-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-brand,.navmenu-inverse .navmenu-brand{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-brand:focus,.navbar-inverse .navbar-offcanvas .navmenu-brand:hover,.navmenu-inverse .navmenu-brand:focus,.navmenu-inverse .navmenu-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-offcanvas .navmenu-text,.navmenu-inverse .navmenu-text{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a:focus .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a:hover .caret,.navmenu-inverse .navmenu-nav>.dropdown>a:focus .caret,.navmenu-inverse .navmenu-nav>.dropdown>a:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:hover,.navmenu-inverse .navmenu-nav>.open>a,.navmenu-inverse .navmenu-nav>.open>a:focus,.navmenu-inverse .navmenu-nav>.open>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:focus .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:hover .caret,.navmenu-inverse .navmenu-nav>.open>a .caret,.navmenu-inverse .navmenu-nav>.open>a:focus .caret,.navmenu-inverse .navmenu-nav>.open>a:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a .caret,.navmenu-inverse .navmenu-nav>.dropdown>a .caret{border-top-color:#999;border-bottom-color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu,.navmenu-inverse .navmenu-nav.dropdown-menu{background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.divider,.navmenu-inverse .navmenu-nav.dropdown-menu>.divider{background-color:#222}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a,.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:hover,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a:focus,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a:hover{background-color:#000}.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a,.navmenu-inverse .navmenu-nav>li>a{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a:hover,.navmenu-inverse .navmenu-nav>li>a:focus,.navmenu-inverse .navmenu-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a:hover,.navmenu-inverse .navmenu-nav>.active>a,.navmenu-inverse .navmenu-nav>.active>a:focus,.navmenu-inverse .navmenu-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a:hover,.navmenu-inverse .navmenu-nav>.disabled>a,.navmenu-inverse .navmenu-nav>.disabled>a:focus,.navmenu-inverse .navmenu-nav>.disabled>a:hover{color:#444;background-color:transparent}.alert-fixed-bottom,.alert-fixed-top{position:fixed;left:0;z-index:1035;width:100%;margin:0;border-radius:0}@media (min-width:992px){.alert-fixed-bottom,.alert-fixed-top{left:50%;width:992px;margin-left:-496px}}.alert-fixed-top{top:0;border-width:0 0 1px}@media (min-width:992px){.alert-fixed-top{border-width:0 1px 1px;border-bottom-right-radius:4px;border-bottom-left-radius:4px}}.alert-fixed-bottom{bottom:0;border-width:1px 0 0}@media (min-width:992px){.alert-fixed-bottom{border-width:1px 1px 0;border-top-left-radius:4px;border-top-right-radius:4px}}.offcanvas{display:none}.offcanvas.in{display:block}@media (max-width:767px){.offcanvas-xs{display:none}.offcanvas-xs.in{display:block}}@media (max-width:991px){.offcanvas-sm{display:none}.offcanvas-sm.in{display:block}}@media (max-width:1199px){.offcanvas-md{display:none}.offcanvas-md.in{display:block}}.offcanvas-lg{display:none}.offcanvas-lg.in{display:block}.canvas-sliding{-webkit-transition:top .35s,left .35s,bottom .35s,right .35s;transition:top .35s,left .35s,bottom .35s,right .35s}.offcanvas-clone{position:absolute!important;top:auto!important;right:0!important;bottom:0!important;left:auto!important;width:0!important;height:0!important;padding:0!important;margin:0!important;overflow:hidden!important;border:none!important;opacity:0!important}.table.rowlink td:not(.rowlink-skip),.table .rowlink td:not(.rowlink-skip){cursor:pointer}.table.rowlink td:not(.rowlink-skip) a,.table .rowlink td:not(.rowlink-skip) a{font:inherit;color:inherit;text-decoration:inherit}.table-hover.rowlink tr:hover td,.table-hover .rowlink tr:hover td{background-color:#cfcfcf}.btn-file{position:relative;overflow:hidden;vertical-align:middle}.btn-file>input{position:absolute;top:0;right:0;width:100%;height:100%;margin:0;font-size:23px;cursor:pointer;filter:alpha(opacity=0);opacity:0;direction:ltr}.fileinput{display:inline-block;margin-bottom:9px}.fileinput .form-control{display:inline-block;padding-top:7px;padding-bottom:5px;margin-bottom:0;vertical-align:middle;cursor:text}.fileinput .thumbnail{display:inline-block;margin-bottom:5px;overflow:hidden;text-align:center;vertical-align:middle}.fileinput .thumbnail>img{max-height:100%}.fileinput .btn{vertical-align:middle}.fileinput-exists .fileinput-new,.fileinput-new .fileinput-exists{display:none}.fileinput-inline .fileinput-controls{display:inline}.fileinput-filename{display:inline-block;overflow:hidden;vertical-align:middle}.form-control .fileinput-filename{vertical-align:bottom}.fileinput.input-group{display:table}.fileinput.input-group>*{position:relative;z-index:2}.fileinput.input-group>.btn-file{z-index:1}.fileinput-new.input-group .btn-file,.fileinput-new .input-group .btn-file{border-radius:0 4px 4px 0}.fileinput-new.input-group .btn-file.btn-sm,.fileinput-new .input-group .btn-file.btn-sm,.fileinput-new.input-group .btn-file.btn-xs,.fileinput-new .input-group .btn-file.btn-xs{border-radius:0 3px 3px 0}.fileinput-new.input-group .btn-file.btn-lg,.fileinput-new .input-group .btn-file.btn-lg{border-radius:0 6px 6px 0}.form-group.has-warning .fileinput .fileinput-preview{color:#8a6d3b}.form-group.has-warning .fileinput .thumbnail{border-color:#faebcc}.form-group.has-error .fileinput .fileinput-preview{color:#a94442}.form-group.has-error .fileinput .thumbnail{border-color:#ebccd1}.form-group.has-success .fileinput .fileinput-preview{color:#3c763d}.form-group.has-success .fileinput .thumbnail{border-color:#d6e9c6}.input-group-addon:not(:first-child){border-left:0}", ""]);

// exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, ".ps{-ms-touch-action:auto;touch-action:auto;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}.ps.ps--active-x>.ps__scrollbar-x-rail,.ps.ps--active-y>.ps__scrollbar-y-rail{display:block;background-color:transparent}.ps.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{background-color:#eee;opacity:.9}.ps.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail>.ps__scrollbar-x{background-color:#999;height:11px}.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail{background-color:#eee;opacity:.9}.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:#999;width:11px}.ps>.ps__scrollbar-x-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:0;height:15px}.ps>.ps__scrollbar-x-rail>.ps__scrollbar-x{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;bottom:2px;height:6px}.ps>.ps__scrollbar-x-rail:active>.ps__scrollbar-x,.ps>.ps__scrollbar-x-rail:hover>.ps__scrollbar-x{height:11px}.ps>.ps__scrollbar-y-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:0;width:15px}.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;right:2px;width:6px}.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y{width:11px}.ps:hover.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{background-color:#eee;opacity:.9}.ps:hover.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail>.ps__scrollbar-x{background-color:#999;height:11px}.ps:hover.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail{background-color:#eee;opacity:.9}.ps:hover.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:#999;width:11px}.ps:hover>.ps__scrollbar-x-rail,.ps:hover>.ps__scrollbar-y-rail{opacity:.6}.ps:hover>.ps__scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps:hover>.ps__scrollbar-x-rail:hover>.ps__scrollbar-x{background-color:#999}.ps:hover>.ps__scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y{background-color:#999}", ""]);

// exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(1123) + ");src:url(" + __webpack_require__(1124) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(1125) + ") format(\"woff2\"),url(" + __webpack_require__(1126) + ") format(\"woff\"),url(" + __webpack_require__(1127) + ") format(\"truetype\"),url(" + __webpack_require__(1128) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);

// exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/912ec66d7572ff821749319396470bde.svg";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, ".Select{position:relative}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:14px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ea284cc760cad1896d4c917f1e546210.woff2";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3b3cbaef084e27f7fa05d9fe31afb287.woff";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1bf71be111189e76987a4bb9b3115cb7.ttf";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/41ef8e5d0ac53654511397e6f165eb0f.svg";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3ea4cffdf67ebf2ad373fb96b903065d.woff2";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9c9017a313819aa54e959ffe8e7d27ea.woff";

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/6943fb6fd4200f3d073469325c6acdc9.ttf";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/b348357e35677da79b5ca21270e2633d.svg";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/6fd1f924cd0bea5d5f74a1365e12184d.woff2";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/60bdb28dc8230486c5b0e868c82fb5dc.woff";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/629a55a7e793da068dc580d184cc0e31.ttf";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d9bee607e42329e3ae452342fd8500fb.svg";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f01a4402103c9ef9350607c0f739b49d.woff2";

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/7aee35e0d937a1fa3456645603d200e6.woff";

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/c7dcce084c445260a266f92db56f5517.ttf";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3e2b2e91221492e315c4e7970065a287.svg";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/aa22ff6fd92ecdf402f09a8180354751.woff2";

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2418db91905ed032bf3a30ee72dd6a1a.woff";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/33f225b8f5f7d6b34a0926f58f96c1e9.ttf";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/400ab808e8b3ba053d41d8dc72ea3aff.svg";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ca4d226c2c041ce9d9e946e7f7eb297e.woff2";

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/cc62fb5c139ff4ec74ef7b3474dcc7f2.woff";

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/73f7301a9cd7a086295401eefe0c998f.ttf";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/7350876ed9eaf44d9555c8d5674d2790.svg";

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f78b8bf800e4836d75ce79d947a235c4.png";

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/dbb5f0d4e6a127c694d08d24528ba435.png";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/6aebc8a4331d19618706a547d8cccffe.png";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ed5c6414e8795741a1418e4772629e00.png";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8a0b9aa58d323f8f9b8232c8713a1bb1.png";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/31f48873f1db920ffaa8392fa691489c.png";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/84b76dee6b27b795e89e3649078a11c2.png";

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/31f15875975aab69085470aabbfec802.png";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(220)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./katex.min.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./katex.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(91)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:KaTeX_AMS;src:url(" + __webpack_require__(458) + ");src:url(" + __webpack_require__(458) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1164) + ") format(\"woff2\"),url(" + __webpack_require__(1165) + ") format(\"woff\"),url(" + __webpack_require__(1166) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Caligraphic;src:url(" + __webpack_require__(459) + ");src:url(" + __webpack_require__(459) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1167) + ") format(\"woff2\"),url(" + __webpack_require__(1168) + ") format(\"woff\"),url(" + __webpack_require__(1169) + ") format(\"ttf\");font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Caligraphic;src:url(" + __webpack_require__(460) + ");src:url(" + __webpack_require__(460) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1170) + ") format(\"woff2\"),url(" + __webpack_require__(1171) + ") format(\"woff\"),url(" + __webpack_require__(1172) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Fraktur;src:url(" + __webpack_require__(461) + ");src:url(" + __webpack_require__(461) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1173) + ") format(\"woff2\"),url(" + __webpack_require__(1174) + ") format(\"woff\"),url(" + __webpack_require__(1175) + ") format(\"ttf\");font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Fraktur;src:url(" + __webpack_require__(462) + ");src:url(" + __webpack_require__(462) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1176) + ") format(\"woff2\"),url(" + __webpack_require__(1177) + ") format(\"woff\"),url(" + __webpack_require__(1178) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(463) + ");src:url(" + __webpack_require__(463) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1179) + ") format(\"woff2\"),url(" + __webpack_require__(1180) + ") format(\"woff\"),url(" + __webpack_require__(1181) + ") format(\"ttf\");font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(464) + ");src:url(" + __webpack_require__(464) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1182) + ") format(\"woff2\"),url(" + __webpack_require__(1183) + ") format(\"woff\"),url(" + __webpack_require__(1184) + ") format(\"ttf\");font-weight:400;font-style:italic}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(465) + ");src:url(" + __webpack_require__(465) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1185) + ") format(\"woff2\"),url(" + __webpack_require__(1186) + ") format(\"woff\"),url(" + __webpack_require__(1187) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Math;src:url(" + __webpack_require__(466) + ");src:url(" + __webpack_require__(466) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1188) + ") format(\"woff2\"),url(" + __webpack_require__(1189) + ") format(\"woff\"),url(" + __webpack_require__(1190) + ") format(\"ttf\");font-weight:400;font-style:italic}@font-face{font-family:KaTeX_SansSerif;src:url(" + __webpack_require__(467) + ");src:url(" + __webpack_require__(467) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1191) + ") format(\"woff2\"),url(" + __webpack_require__(1192) + ") format(\"woff\"),url(" + __webpack_require__(1193) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Script;src:url(" + __webpack_require__(468) + ");src:url(" + __webpack_require__(468) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1194) + ") format(\"woff2\"),url(" + __webpack_require__(1195) + ") format(\"woff\"),url(" + __webpack_require__(1196) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size1;src:url(" + __webpack_require__(469) + ");src:url(" + __webpack_require__(469) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1197) + ") format(\"woff2\"),url(" + __webpack_require__(1198) + ") format(\"woff\"),url(" + __webpack_require__(1199) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size2;src:url(" + __webpack_require__(470) + ");src:url(" + __webpack_require__(470) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1200) + ") format(\"woff2\"),url(" + __webpack_require__(1201) + ") format(\"woff\"),url(" + __webpack_require__(1202) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size3;src:url(" + __webpack_require__(471) + ");src:url(" + __webpack_require__(471) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1203) + ") format(\"woff2\"),url(" + __webpack_require__(1204) + ") format(\"woff\"),url(" + __webpack_require__(1205) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size4;src:url(" + __webpack_require__(472) + ");src:url(" + __webpack_require__(472) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1206) + ") format(\"woff2\"),url(" + __webpack_require__(1207) + ") format(\"woff\"),url(" + __webpack_require__(1208) + ") format(\"ttf\");font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Typewriter;src:url(" + __webpack_require__(473) + ");src:url(" + __webpack_require__(473) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1209) + ") format(\"woff2\"),url(" + __webpack_require__(1210) + ") format(\"woff\"),url(" + __webpack_require__(1211) + ") format(\"ttf\");font-weight:400;font-style:normal}.katex-display{display:block;margin:1em 0;text-align:center}.katex-display>.katex{display:inline-block;text-align:initial}.katex{font:400 1.21em KaTeX_Main;line-height:1.2;white-space:nowrap;text-indent:0}.katex .katex-html{display:inline-block}.katex .katex-mathml{position:absolute;clip:rect(1px,1px,1px,1px);padding:0;border:0;height:1px;width:1px;overflow:hidden}.katex .base,.katex .strut{display:inline-block}.katex .mathit{font-family:KaTeX_Math;font-style:italic}.katex .mathbf{font-family:KaTeX_Main;font-weight:700}.katex .amsrm,.katex .mathbb{font-family:KaTeX_AMS}.katex .mathcal{font-family:KaTeX_Caligraphic}.katex .mathfrak{font-family:KaTeX_Fraktur}.katex .mathtt{font-family:KaTeX_Typewriter}.katex .mathscr{font-family:KaTeX_Script}.katex .mathsf{font-family:KaTeX_SansSerif}.katex .mainit{font-family:KaTeX_Main;font-style:italic}.katex .textstyle>.mord+.mop{margin-left:.16667em}.katex .textstyle>.mord+.mbin{margin-left:.22222em}.katex .textstyle>.mord+.mrel{margin-left:.27778em}.katex .textstyle>.mop+.mop,.katex .textstyle>.mop+.mord,.katex .textstyle>.mord+.minner{margin-left:.16667em}.katex .textstyle>.mop+.mrel{margin-left:.27778em}.katex .textstyle>.mop+.minner{margin-left:.16667em}.katex .textstyle>.mbin+.minner,.katex .textstyle>.mbin+.mop,.katex .textstyle>.mbin+.mopen,.katex .textstyle>.mbin+.mord{margin-left:.22222em}.katex .textstyle>.mrel+.minner,.katex .textstyle>.mrel+.mop,.katex .textstyle>.mrel+.mopen,.katex .textstyle>.mrel+.mord{margin-left:.27778em}.katex .textstyle>.mclose+.mop{margin-left:.16667em}.katex .textstyle>.mclose+.mbin{margin-left:.22222em}.katex .textstyle>.mclose+.mrel{margin-left:.27778em}.katex .textstyle>.mclose+.minner,.katex .textstyle>.minner+.mop,.katex .textstyle>.minner+.mord,.katex .textstyle>.mpunct+.mclose,.katex .textstyle>.mpunct+.minner,.katex .textstyle>.mpunct+.mop,.katex .textstyle>.mpunct+.mopen,.katex .textstyle>.mpunct+.mord,.katex .textstyle>.mpunct+.mpunct,.katex .textstyle>.mpunct+.mrel{margin-left:.16667em}.katex .textstyle>.minner+.mbin{margin-left:.22222em}.katex .textstyle>.minner+.mrel{margin-left:.27778em}.katex .mclose+.mop,.katex .minner+.mop,.katex .mop+.mop,.katex .mop+.mord,.katex .mord+.mop,.katex .textstyle>.minner+.minner,.katex .textstyle>.minner+.mopen,.katex .textstyle>.minner+.mpunct{margin-left:.16667em}.katex .reset-textstyle.textstyle{font-size:1em}.katex .reset-textstyle.scriptstyle{font-size:.7em}.katex .reset-textstyle.scriptscriptstyle{font-size:.5em}.katex .reset-scriptstyle.textstyle{font-size:1.42857em}.katex .reset-scriptstyle.scriptstyle{font-size:1em}.katex .reset-scriptstyle.scriptscriptstyle{font-size:.71429em}.katex .reset-scriptscriptstyle.textstyle{font-size:2em}.katex .reset-scriptscriptstyle.scriptstyle{font-size:1.4em}.katex .reset-scriptscriptstyle.scriptscriptstyle{font-size:1em}.katex .style-wrap{position:relative}.katex .vlist{display:inline-block}.katex .vlist>span{display:block;height:0;position:relative}.katex .vlist>span>span{display:inline-block}.katex .vlist .baseline-fix{display:inline-table;table-layout:fixed}.katex .msupsub{text-align:left}.katex .mfrac>span>span{text-align:center}.katex .mfrac .frac-line{width:100%}.katex .mfrac .frac-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .mfrac .frac-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .mspace{display:inline-block}.katex .mspace.negativethinspace{margin-left:-.16667em}.katex .mspace.thinspace{width:.16667em}.katex .mspace.mediumspace{width:.22222em}.katex .mspace.thickspace{width:.27778em}.katex .mspace.enspace{width:.5em}.katex .mspace.quad{width:1em}.katex .mspace.qquad{width:2em}.katex .llap,.katex .rlap{width:0;position:relative}.katex .llap>.inner,.katex .rlap>.inner{position:absolute}.katex .llap>.fix,.katex .rlap>.fix{display:inline-block}.katex .llap>.inner{right:0}.katex .rlap>.inner{left:0}.katex .katex-logo .a{font-size:.75em;margin-left:-.32em;position:relative;top:-.2em}.katex .katex-logo .t{margin-left:-.23em}.katex .katex-logo .e{margin-left:-.1667em;position:relative;top:.2155em}.katex .katex-logo .x{margin-left:-.125em}.katex .rule{display:inline-block;border:0 solid;position:relative}.katex .overline .overline-line{width:100%}.katex .overline .overline-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .overline .overline-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .sqrt>.sqrt-sign{position:relative}.katex .sqrt .sqrt-line{width:100%}.katex .sqrt .sqrt-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .sqrt .sqrt-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .sqrt>.root{margin-left:.27777778em;margin-right:-.55555556em}.katex .fontsize-ensurer,.katex .sizing{display:inline-block}.katex .fontsize-ensurer.reset-size1.size1,.katex .sizing.reset-size1.size1{font-size:1em}.katex .fontsize-ensurer.reset-size1.size2,.katex .sizing.reset-size1.size2{font-size:1.4em}.katex .fontsize-ensurer.reset-size1.size3,.katex .sizing.reset-size1.size3{font-size:1.6em}.katex .fontsize-ensurer.reset-size1.size4,.katex .sizing.reset-size1.size4{font-size:1.8em}.katex .fontsize-ensurer.reset-size1.size5,.katex .sizing.reset-size1.size5{font-size:2em}.katex .fontsize-ensurer.reset-size1.size6,.katex .sizing.reset-size1.size6{font-size:2.4em}.katex .fontsize-ensurer.reset-size1.size7,.katex .sizing.reset-size1.size7{font-size:2.88em}.katex .fontsize-ensurer.reset-size1.size8,.katex .sizing.reset-size1.size8{font-size:3.46em}.katex .fontsize-ensurer.reset-size1.size9,.katex .sizing.reset-size1.size9{font-size:4.14em}.katex .fontsize-ensurer.reset-size1.size10,.katex .sizing.reset-size1.size10{font-size:4.98em}.katex .fontsize-ensurer.reset-size2.size1,.katex .sizing.reset-size2.size1{font-size:.71428571em}.katex .fontsize-ensurer.reset-size2.size2,.katex .sizing.reset-size2.size2{font-size:1em}.katex .fontsize-ensurer.reset-size2.size3,.katex .sizing.reset-size2.size3{font-size:1.14285714em}.katex .fontsize-ensurer.reset-size2.size4,.katex .sizing.reset-size2.size4{font-size:1.28571429em}.katex .fontsize-ensurer.reset-size2.size5,.katex .sizing.reset-size2.size5{font-size:1.42857143em}.katex .fontsize-ensurer.reset-size2.size6,.katex .sizing.reset-size2.size6{font-size:1.71428571em}.katex .fontsize-ensurer.reset-size2.size7,.katex .sizing.reset-size2.size7{font-size:2.05714286em}.katex .fontsize-ensurer.reset-size2.size8,.katex .sizing.reset-size2.size8{font-size:2.47142857em}.katex .fontsize-ensurer.reset-size2.size9,.katex .sizing.reset-size2.size9{font-size:2.95714286em}.katex .fontsize-ensurer.reset-size2.size10,.katex .sizing.reset-size2.size10{font-size:3.55714286em}.katex .fontsize-ensurer.reset-size3.size1,.katex .sizing.reset-size3.size1{font-size:.625em}.katex .fontsize-ensurer.reset-size3.size2,.katex .sizing.reset-size3.size2{font-size:.875em}.katex .fontsize-ensurer.reset-size3.size3,.katex .sizing.reset-size3.size3{font-size:1em}.katex .fontsize-ensurer.reset-size3.size4,.katex .sizing.reset-size3.size4{font-size:1.125em}.katex .fontsize-ensurer.reset-size3.size5,.katex .sizing.reset-size3.size5{font-size:1.25em}.katex .fontsize-ensurer.reset-size3.size6,.katex .sizing.reset-size3.size6{font-size:1.5em}.katex .fontsize-ensurer.reset-size3.size7,.katex .sizing.reset-size3.size7{font-size:1.8em}.katex .fontsize-ensurer.reset-size3.size8,.katex .sizing.reset-size3.size8{font-size:2.1625em}.katex .fontsize-ensurer.reset-size3.size9,.katex .sizing.reset-size3.size9{font-size:2.5875em}.katex .fontsize-ensurer.reset-size3.size10,.katex .sizing.reset-size3.size10{font-size:3.1125em}.katex .fontsize-ensurer.reset-size4.size1,.katex .sizing.reset-size4.size1{font-size:.55555556em}.katex .fontsize-ensurer.reset-size4.size2,.katex .sizing.reset-size4.size2{font-size:.77777778em}.katex .fontsize-ensurer.reset-size4.size3,.katex .sizing.reset-size4.size3{font-size:.88888889em}.katex .fontsize-ensurer.reset-size4.size4,.katex .sizing.reset-size4.size4{font-size:1em}.katex .fontsize-ensurer.reset-size4.size5,.katex .sizing.reset-size4.size5{font-size:1.11111111em}.katex .fontsize-ensurer.reset-size4.size6,.katex .sizing.reset-size4.size6{font-size:1.33333333em}.katex .fontsize-ensurer.reset-size4.size7,.katex .sizing.reset-size4.size7{font-size:1.6em}.katex .fontsize-ensurer.reset-size4.size8,.katex .sizing.reset-size4.size8{font-size:1.92222222em}.katex .fontsize-ensurer.reset-size4.size9,.katex .sizing.reset-size4.size9{font-size:2.3em}.katex .fontsize-ensurer.reset-size4.size10,.katex .sizing.reset-size4.size10{font-size:2.76666667em}.katex .fontsize-ensurer.reset-size5.size1,.katex .sizing.reset-size5.size1{font-size:.5em}.katex .fontsize-ensurer.reset-size5.size2,.katex .sizing.reset-size5.size2{font-size:.7em}.katex .fontsize-ensurer.reset-size5.size3,.katex .sizing.reset-size5.size3{font-size:.8em}.katex .fontsize-ensurer.reset-size5.size4,.katex .sizing.reset-size5.size4{font-size:.9em}.katex .fontsize-ensurer.reset-size5.size5,.katex .sizing.reset-size5.size5{font-size:1em}.katex .fontsize-ensurer.reset-size5.size6,.katex .sizing.reset-size5.size6{font-size:1.2em}.katex .fontsize-ensurer.reset-size5.size7,.katex .sizing.reset-size5.size7{font-size:1.44em}.katex .fontsize-ensurer.reset-size5.size8,.katex .sizing.reset-size5.size8{font-size:1.73em}.katex .fontsize-ensurer.reset-size5.size9,.katex .sizing.reset-size5.size9{font-size:2.07em}.katex .fontsize-ensurer.reset-size5.size10,.katex .sizing.reset-size5.size10{font-size:2.49em}.katex .fontsize-ensurer.reset-size6.size1,.katex .sizing.reset-size6.size1{font-size:.41666667em}.katex .fontsize-ensurer.reset-size6.size2,.katex .sizing.reset-size6.size2{font-size:.58333333em}.katex .fontsize-ensurer.reset-size6.size3,.katex .sizing.reset-size6.size3{font-size:.66666667em}.katex .fontsize-ensurer.reset-size6.size4,.katex .sizing.reset-size6.size4{font-size:.75em}.katex .fontsize-ensurer.reset-size6.size5,.katex .sizing.reset-size6.size5{font-size:.83333333em}.katex .fontsize-ensurer.reset-size6.size6,.katex .sizing.reset-size6.size6{font-size:1em}.katex .fontsize-ensurer.reset-size6.size7,.katex .sizing.reset-size6.size7{font-size:1.2em}.katex .fontsize-ensurer.reset-size6.size8,.katex .sizing.reset-size6.size8{font-size:1.44166667em}.katex .fontsize-ensurer.reset-size6.size9,.katex .sizing.reset-size6.size9{font-size:1.725em}.katex .fontsize-ensurer.reset-size6.size10,.katex .sizing.reset-size6.size10{font-size:2.075em}.katex .fontsize-ensurer.reset-size7.size1,.katex .sizing.reset-size7.size1{font-size:.34722222em}.katex .fontsize-ensurer.reset-size7.size2,.katex .sizing.reset-size7.size2{font-size:.48611111em}.katex .fontsize-ensurer.reset-size7.size3,.katex .sizing.reset-size7.size3{font-size:.55555556em}.katex .fontsize-ensurer.reset-size7.size4,.katex .sizing.reset-size7.size4{font-size:.625em}.katex .fontsize-ensurer.reset-size7.size5,.katex .sizing.reset-size7.size5{font-size:.69444444em}.katex .fontsize-ensurer.reset-size7.size6,.katex .sizing.reset-size7.size6{font-size:.83333333em}.katex .fontsize-ensurer.reset-size7.size7,.katex .sizing.reset-size7.size7{font-size:1em}.katex .fontsize-ensurer.reset-size7.size8,.katex .sizing.reset-size7.size8{font-size:1.20138889em}.katex .fontsize-ensurer.reset-size7.size9,.katex .sizing.reset-size7.size9{font-size:1.4375em}.katex .fontsize-ensurer.reset-size7.size10,.katex .sizing.reset-size7.size10{font-size:1.72916667em}.katex .fontsize-ensurer.reset-size8.size1,.katex .sizing.reset-size8.size1{font-size:.28901734em}.katex .fontsize-ensurer.reset-size8.size2,.katex .sizing.reset-size8.size2{font-size:.40462428em}.katex .fontsize-ensurer.reset-size8.size3,.katex .sizing.reset-size8.size3{font-size:.46242775em}.katex .fontsize-ensurer.reset-size8.size4,.katex .sizing.reset-size8.size4{font-size:.52023121em}.katex .fontsize-ensurer.reset-size8.size5,.katex .sizing.reset-size8.size5{font-size:.57803468em}.katex .fontsize-ensurer.reset-size8.size6,.katex .sizing.reset-size8.size6{font-size:.69364162em}.katex .fontsize-ensurer.reset-size8.size7,.katex .sizing.reset-size8.size7{font-size:.83236994em}.katex .fontsize-ensurer.reset-size8.size8,.katex .sizing.reset-size8.size8{font-size:1em}.katex .fontsize-ensurer.reset-size8.size9,.katex .sizing.reset-size8.size9{font-size:1.19653179em}.katex .fontsize-ensurer.reset-size8.size10,.katex .sizing.reset-size8.size10{font-size:1.43930636em}.katex .fontsize-ensurer.reset-size9.size1,.katex .sizing.reset-size9.size1{font-size:.24154589em}.katex .fontsize-ensurer.reset-size9.size2,.katex .sizing.reset-size9.size2{font-size:.33816425em}.katex .fontsize-ensurer.reset-size9.size3,.katex .sizing.reset-size9.size3{font-size:.38647343em}.katex .fontsize-ensurer.reset-size9.size4,.katex .sizing.reset-size9.size4{font-size:.43478261em}.katex .fontsize-ensurer.reset-size9.size5,.katex .sizing.reset-size9.size5{font-size:.48309179em}.katex .fontsize-ensurer.reset-size9.size6,.katex .sizing.reset-size9.size6{font-size:.57971014em}.katex .fontsize-ensurer.reset-size9.size7,.katex .sizing.reset-size9.size7{font-size:.69565217em}.katex .fontsize-ensurer.reset-size9.size8,.katex .sizing.reset-size9.size8{font-size:.83574879em}.katex .fontsize-ensurer.reset-size9.size9,.katex .sizing.reset-size9.size9{font-size:1em}.katex .fontsize-ensurer.reset-size9.size10,.katex .sizing.reset-size9.size10{font-size:1.20289855em}.katex .fontsize-ensurer.reset-size10.size1,.katex .sizing.reset-size10.size1{font-size:.20080321em}.katex .fontsize-ensurer.reset-size10.size2,.katex .sizing.reset-size10.size2{font-size:.2811245em}.katex .fontsize-ensurer.reset-size10.size3,.katex .sizing.reset-size10.size3{font-size:.32128514em}.katex .fontsize-ensurer.reset-size10.size4,.katex .sizing.reset-size10.size4{font-size:.36144578em}.katex .fontsize-ensurer.reset-size10.size5,.katex .sizing.reset-size10.size5{font-size:.40160643em}.katex .fontsize-ensurer.reset-size10.size6,.katex .sizing.reset-size10.size6{font-size:.48192771em}.katex .fontsize-ensurer.reset-size10.size7,.katex .sizing.reset-size10.size7{font-size:.57831325em}.katex .fontsize-ensurer.reset-size10.size8,.katex .sizing.reset-size10.size8{font-size:.69477912em}.katex .fontsize-ensurer.reset-size10.size9,.katex .sizing.reset-size10.size9{font-size:.8313253em}.katex .fontsize-ensurer.reset-size10.size10,.katex .sizing.reset-size10.size10{font-size:1em}.katex .delimsizing.size1{font-family:KaTeX_Size1}.katex .delimsizing.size2{font-family:KaTeX_Size2}.katex .delimsizing.size3{font-family:KaTeX_Size3}.katex .delimsizing.size4{font-family:KaTeX_Size4}.katex .delimsizing.mult .delim-size1>span{font-family:KaTeX_Size1}.katex .delimsizing.mult .delim-size4>span{font-family:KaTeX_Size4}.katex .nulldelimiter{display:inline-block;width:.12em}.katex .op-symbol{position:relative}.katex .op-symbol.small-op{font-family:KaTeX_Size1}.katex .op-symbol.large-op{font-family:KaTeX_Size2}.katex .accent>.vlist>span,.katex .op-limits>.vlist>span{text-align:center}.katex .accent .accent-body>span{width:0}.katex .accent .accent-body.accent-vec>span{position:relative;left:.326em}.katex .mtable .vertical-separator{display:inline-block;margin:0 -.025em;border-right:.05em solid #000}.katex .mtable .arraycolsep{display:inline-block}.katex .mtable .col-align-c>.vlist{text-align:center}.katex .mtable .col-align-l>.vlist{text-align:left}.katex .mtable .col-align-r>.vlist{text-align:right}", ""]);

// exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f4c3270b2710ca9e0d537bea35ca5f06.woff2";

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/e78f217c38267703d444fb8f3940a431.woff";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/9971d2707241bb6c19cb1141e3b35d76.ttf";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a2e0522575c10759bcf3332c5db0260f.woff2";

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bac61997af03ef4747cd73b3757749ca.woff";

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/743b42a3ace84553402144b6b186eb99.ttf";

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/479a68ec912f41b8a28b1b1f3000b889.woff2";

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/a64e134208e4b556aa9adfd286aa46ab.woff";

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/244db27f9e25edd519486604c233902f.ttf";

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8e5f883e14f473f6be1dfa8c51bf277b.woff2";

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/0a0aa194aa39cc284a3d8826cd23cfa9.woff";

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ad26cc83c0ff84ac3afc867f58848783.ttf";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ae2b6f4374a0e6ad9f7cfd75b3b68fd3.woff2";

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f980ca72a0d0876d0451f9e8d7b25c02.woff";

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d459632ec35250277328388039edc45d.ttf";

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/83f8b326ade537b52c54593f448e980e.woff2";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d8a629d21894b90448b5f42f457c2060.woff";

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/e69b9513bba6b6a563bad05e8a0de80c.ttf";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/07510ed019e317ee10bb5a26012e1069.woff2";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8dd42e02d20082db960018b6488338f7.woff";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/1b226149c7920e96e4c47faf0ff73d8c.ttf";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bd65225294e9ad1114ded0a8bde4d38b.woff2";

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2dffc87573a6d6dd440e801b5cce5c8e.woff";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d9162dfe8f36db18b8d4ef7ffa75692d.ttf";

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/afeebb76a0201bf468f5e0b1a9622c09.woff2";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/da586018a5f1b55beb343d53bf804007.woff";

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/55fbb3ac09b79fc554f78b4fa51d9bf4.ttf";

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/7d5fa3e2a370f59774cd189cf6ca2e59.woff2";

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/48c7df6f4d3d4df25748a666d0520b5c.woff";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8075d14aa49687aad5e147668cc3402a.ttf";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/c472b57029cc804912e0380dcbf72491.woff2";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5acb381b12b66ca6afef5d9edb948672.woff";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/abb12fc254db7db04627ecccf005eba6.ttf";

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/feed6c70fde629d6eb61e1ed2bb93537.woff2";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bdd0d5e034ab4a8641bd05736d5ed84f.woff";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8cc60fd5985fceea2e8c7cbadb731eaf.ttf";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8a86a0afd5a0b172bdc93be1e3d53866.woff2";

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fd67fb35731da39667ae210a98c60ef4.woff";

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/5976fffdaa1b8e6eed853f3dc3ba1330.ttf";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2c1ea03043d76fc65767eb60aa6e0015.woff2";

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/943c94f89c864bae86f603aee2bf83ea.woff";

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/e929f5d97ac36718e3a66218f45925d8.ttf";

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/680d35e3c073a84a91283a283e47fb0c.woff2";

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/68537743d23b63655387918e39fe65c1.woff";

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/81ab95e4bae239656034b9e6e62dcaaf.ttf";

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/8a6d8ed89749165e1f09044215edb958.woff2";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3e9e27f043e770a8690883e26599133f.woff";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/29017475281a903951aa79c83e38caf7.ttf";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

var _root = __webpack_require__(1213);

var _root2 = _interopRequireDefault(_root);

var _route_claim = __webpack_require__(1215);

var _route_claim2 = _interopRequireDefault(_route_claim);

var _route_mfa = __webpack_require__(1216);

var _route_mfa2 = _interopRequireDefault(_route_mfa);

var _route_create_public_team = __webpack_require__(1217);

var _route_create_public_team2 = _interopRequireDefault(_route_create_public_team);

var _route_create_private_team = __webpack_require__(1218);

var _route_create_private_team2 = _interopRequireDefault(_route_create_private_team);

var _route_team = __webpack_require__(1219);

var _route_team2 = _interopRequireDefault(_route_team);

var _route_help = __webpack_require__(1223);

var _route_help2 = _interopRequireDefault(_route_help);

var _route_talkto = __webpack_require__(1224);

var _route_talkto2 = _interopRequireDefault(_route_talkto);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _error_store = __webpack_require__(216);

var _error_store2 = _interopRequireDefault(_error_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _user_agent = __webpack_require__(167);

var UserAgent = _interopRequireWildcard(_user_agent);

var _es = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// import createTeamRoute from 'routes/route_create_team.jsx';
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function preLogin(nextState, replace, callback) {
    // redirect to the mobile landing page if the user hasn't seen it before
    if (window.mm_config.IosAppDownloadLink && UserAgent.isIosWeb() && !_browser_store2.default.hasSeenLandingPage()) {
        replace('/get_ios_app');
        _browser_store2.default.setLandingPageSeen(true);
    } else if (window.mm_config.AndroidAppDownloadLink && UserAgent.isAndroidWeb() && !_browser_store2.default.hasSeenLandingPage()) {
        replace('/get_android_app');
        _browser_store2.default.setLandingPageSeen(true);
    }

    callback();
}

function preLoggedIn(nextState, replace, callback) {
    if (RouteUtils.checkIfMFARequired(nextState)) {
        _es.browserHistory.push('/mfa/setup');
        return;
    }

    _error_store2.default.clearLastError();
    callback();
}

function preGetUser(nextState, replace, callback) {
    var user = _user_store2.default.getCurrentUser();
    if (!user) {
        _es.browserHistory.push('/?redirect_to=' + encodeURIComponent(nextState.location.pathname));
        return;
    }
    callback();
}

exports.default = {
    path: '/',
    component: _root2.default,
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 309)).then(RouteUtils.importComponentSuccess(callback));
        },
        getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
            path: 'login',
            onEnter: preLogin,
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1297)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'reset_password',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1298)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'reset_password_complete',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1299)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, _route_claim2.default, {
            path: 'signup_user_complete',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1300)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'signup_mobile',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 551)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'signup_email',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 551)).then(RouteUtils.importComponentSuccess(callback));
            }
        },
        // +++ Alan - include custom signup
        // {
        //     path: 'signup_oauth/:service',
        //     getComponents: (location, callback) => {
        //         System.import('components/signup/components/signup_oauth.jsx').then(RouteUtils.importComponentSuccess(callback));
        //     }
        // },
        // ---
        {
            path: 'signup_ldap',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1301)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'should_verify_email',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1302)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'should_verify',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1303)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'do_verify_email',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1304)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'do_verify_mobile',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1305)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, _route_help2.default])
    }, {
        path: 'get_ios_app',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1306)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'get_android_app',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1307)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'error',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1308)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1309)).then(RouteUtils.importComponentSuccess(callback));
        },
        onEnter: preLoggedIn,
        getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
            path: 'admin_console',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1310)).then(RouteUtils.importComponentSuccess(callback));
            },
            indexRoute: { onEnter: function onEnter(nextState, replace) {
                    return replace('/admin_console/system_analytics');
                } },
            getChildRoutes: function getChildRoutes(location, callback) {
                __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1311)).then(function (comp) {
                    return callback(null, comp.default);
                });
            }
        }, {
            path: 'order',
            onEnter: preGetUser,
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1312)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, _route_talkto2.default, {
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 309)).then(RouteUtils.importComponentSuccess(callback));
            },
            getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
                path: 'select_team',
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1313)).then(RouteUtils.importComponentSuccess(callback));
                }
            }, {
                path: 'join_team',
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1314)).then(RouteUtils.importComponentSuccess(callback));
                }
            }, {
                path: '*authorize',
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1315)).then(RouteUtils.importComponentSuccess(callback));
                }
            }, _route_create_public_team2.default, _route_create_private_team2.default])
        }, _route_team2.default, _route_mfa2.default])
    }, {
        path: '*',
        onEnter: function onEnter(nextState, replace) {
            replace({
                pathname: 'error',
                query: RouteUtils.notFoundParams
            });
        }
    }])
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(57);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(34);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(55);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(56);

var _inherits3 = _interopRequireDefault(_inherits2);

var _global_actions = __webpack_require__(143);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _localization_store = __webpack_require__(172);

var _localization_store2 = _interopRequireDefault(_localization_store);

var _client = __webpack_require__(22);

var _reactIntl = __webpack_require__(212);

var _propTypes = __webpack_require__(163);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(16);

var _react2 = _interopRequireDefault(_react);

var _fastclick = __webpack_require__(1214);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _es = __webpack_require__(49);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Root = function (_React$Component) {
    (0, _inherits3.default)(Root, _React$Component);

    function Root(props) {
        (0, _classCallCheck3.default)(this, Root);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).call(this, props));

        _this.state = {
            locale: _localization_store2.default.getLocale(),
            translations: _localization_store2.default.getTranslations()
        };

        _this.localizationChanged = _this.localizationChanged.bind(_this);
        _this.redirectIfNecessary = _this.redirectIfNecessary.bind(_this);

        var segmentKey = _constants2.default.DIAGNOSTICS_SEGMENT_KEY;
        var dropboxAppKey = window.mm_config.DropboxAppKey;

        // Ya....
        /*eslint-disable */
        if (segmentKey != null && segmentKey !== '' && window.mm_config.DiagnosticsEnabled === 'true') {
            !function () {
                var analytics = global.window.analytics = global.window.analytics || [];if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
                    analytics.invoked = !0;analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "group", "track", "ready", "alias", "page", "once", "off", "on"];analytics.factory = function (t) {
                        return function () {
                            var e = Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics;
                        };
                    };for (var t = 0; t < analytics.methods.length; t++) {
                        var e = analytics.methods[t];analytics[e] = analytics.factory(e);
                    }analytics.load = function (t) {
                        var e = document.createElement("script");e.type = "text/javascript";e.async = !0;e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";var n = document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e, n);
                    };analytics.SNIPPET_VERSION = "3.0.1";
                    analytics.load(segmentKey);

                    analytics.page('ApplicationLoaded', {
                        path: '',
                        referrer: '',
                        search: '',
                        title: '',
                        url: ''
                    }, {
                        context: {
                            ip: '0.0.0.0'
                        },
                        anonymousId: '00000000000000000000000000'
                    });
                }
            }();
        }
        /*eslint-enable */

        // Baidu Map
        if (window.mm_config.EnableBaiduMap === 'true' && window.mm_config.BaiduMapApiKey !== '') {

            window.baiduMapAsyncInit = function () {
                var event = new Event('baidu_map_loaded');
                window.dispatchEvent(event);
            };

            !function () {

                var g = document.getElementById('baiduMapApi');

                if (g) {
                    window.console && console.error && console.error("Baidu map api included twice.");
                } else {

                    var key = '';

                    if (window.mm_config.BaiduMapApiKey) {
                        key = '&ak=' + window.mm_config.BaiduMapApiKey;
                    }
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src = " https://api.map.baidu.com/api?v=3.0" + key + "&callback=baiduMapAsyncInit"; //&key=您的JS API开发者Key

                    e.id = "baiduMapApi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                }
            }();
        }
        // google drive || google map
        if (window.mm_config.EnableGoogleDrive === 'true') {

            !function () {

                var g = document.getElementById('googleapi');

                if (g) {
                    window.console && console.error && console.error("google api included twice.");
                } else {
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src = "https://apis.google.com/js/api.js";
                    e.id = "googleapi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                }
            }();
        }
        if (window.mm_config.EnableGoogleMap === 'true') {

            window.gapiLoaded = function () {
                var event = new Event('gapi_loaded');
                window.dispatchEvent(event);
            };

            !function () {

                var g = document.getElementById('googleMapApi');

                if (g) {
                    window.console && console.error && console.error("google map api included twice.");
                } else {
                    var key = '';
                    if (window.mm_config.GoogleMapApiKey) {
                        key = window.mm_config.GoogleMapApiKey;
                    }

                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.defer = true;
                    e.src = "https://maps.googleapis.com/maps/api/js?key=" + key + "&callback=gapiLoaded";
                    e.id = "googleMapApi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                }
            }();
        }

        // dropbox chooser
        if (dropboxAppKey != null && dropboxAppKey !== '' && window.mm_config.EnableDropbox === 'true') {
            !function () {

                var d = document.getElementById('dropboxjs');

                if (d) {
                    window.console && console.error && console.error("dropboxjs chooser included twice.");
                } else {

                    var load = function load(t) {
                        var e = document.createElement("script");
                        e.type = "text/javascript";
                        e.async = !0;
                        e.src = "https://www.dropbox.com/static/api/2/dropins.js";
                        e.id = "dropboxjs";
                        e.setAttribute("data-app-key", t);
                        var n = document.getElementsByTagName("script")[0];
                        n.parentNode.insertBefore(e, n);
                    };

                    load(dropboxAppKey);
                }
            }();
        }

        // Jitsi Meet
        if (global.mm_config.EnableWebrtc === 'true') {
            !function () {
                var d = document.getElementById('jitsimeetapi');
                if (d) {
                    window.console && console.error && console.error("jitsimeetapi included twice.");
                } else {
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.src = "https://" + global.mm_config.MeetingServer + "/external_api.min.js";
                    e.id = "jitsimeetapi";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                }
            }();
        }

        if (global.window.mm_config.EnableShareToFacebook === 'true' && global.window.mm_config.FacebookAppId) {

            window.fbAsyncInit = function () {
                FB.init({
                    appId: global.window.mm_config.FacebookAppId,
                    autoLogAppEvents: true,
                    xfbml: false,
                    version: global.window.mm_config.FacebookSDKVersion
                });
            };

            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                // js.src = "https://connect.facebook.net/en_US/sdk/debug.js";
                fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'facebook-jssdk');
        }

        if (global.window.mm_config.EnableSignUpWithApple === 'true') {
            var locale = navigator.language || '';

            locale = locale.replace('-', '_');

            if (locale.indexOf('_') >= 0) {
                var temp = locale.split("_");
                temp[1] = temp[1].toUpperCase();
                locale = temp.join("_");
            }

            var supportedLocale = ["ar_SA", "ca_ES", "cs_CZ", "da_DK", "de_DE", "el_GR", "en_GB", "en_US", "es_ES", "es_MX", "fi_FI", "fr_CA", "fr_FR", "hr_HR", "hu_HU", "id_ID", "it_IT", "iw_IL", "ja_JP", "ko_KR", "ms_MY", "nl_NL", "no_NO", "pl_PL", "pt_BR", "pt_PT", "ro_RO", "ru_RU", "sk_SK", "sv_SE", "th_TH", "tr_TR", "uk_UA", "vi_VI", "zh_CN", "zh_HK", "zh_TW"];

            if (supportedLocale.indexOf(locale) === -1) {
                locale = 'en_US';
            }

            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;

                js = d.createElement(s);js.id = id;
                js.async = !0;
                js.defer = true;
                js.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/' + locale + '/appleid.auth.js';
                js.onload = function () {
                    var event = new Event('appleid.auth_loaded');
                    window.dispatchEvent(event);
                };
                fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'apple-authjs');
        }

        if (global.window.mm_license.IsCordchatEnterprise === 'false') {
            !function () {
                var s = document.getElementById('stripe-js');
                if (s) {
                    window.console && console.error && console.error("stripe-js included twice.");
                } else {
                    var e = document.createElement("script");
                    e.type = "text/javascript";
                    e.async = !0;
                    e.src = "https://js.stripe.com/v3/";
                    e.id = "stripe-js";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n);
                }
            }();
        }

        // if (global.window.mm_config.EnableShareToWeibo === 'true') {
        //     (function(d, s, id){
        //         var js, fjs = d.getElementsByTagName(s)[0];
        //         if (d.getElementById(id)) return;
        //         js = d.createElement(s); js.id = id;
        //         js.src = "http://tjs.sjs.sinajs.cn/open/api/js/wb.js?appkey=3456376465";
        //         js.type = "text/javascript";
        //         js.charset = "utf-8";
        //         fjs.parentNode.insertBefore(js, fjs);
        //     }(document, 'script', 'weibo-jssdk'));
        // }


        // Force logout of all tabs if one tab is logged out
        (0, _jquery2.default)(window).bind('storage', function (e) {
            // when one tab on a browser logs out, it sets __logout__ in localStorage to trigger other tabs to log out
            if (e.originalEvent.key === '__logout__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (_browser_store2.default.isSignallingLogout(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected logout from a different tab'); //eslint-disable-line no-console
                GlobalActions.emitUserLoggedOutEvent('/', false);
            }

            if (e.originalEvent.key === '__login__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
                // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
                if (_browser_store2.default.isSignallingLogin(e.originalEvent.newValue)) {
                    return;
                }

                console.log('detected login from a different tab'); //eslint-disable-line no-console
                location.reload();
            }
        });

        // Fastclick
        _fastclick2.default.attach(document.body);
        return _this;
    }

    (0, _createClass3.default)(Root, [{
        key: 'localizationChanged',
        value: function localizationChanged() {
            var locale = _localization_store2.default.getLocale();

            _client.Client4.setAcceptLanguage(locale);
            this.setState({ locale: locale, translations: _localization_store2.default.getTranslations() });
        }
    }, {
        key: 'redirectIfNecessary',
        value: function redirectIfNecessary(props) {
            if (props.location.pathname === '/') {
                if (_user_store2.default.getNoAccounts()) {
                    _es.browserHistory.push('/signup_user_complete');
                } else if (_user_store2.default.getCurrentUser()) {
                    GlobalActions.redirectUserToDefaultTeam();
                } else {
                    _es.browserHistory.push('/login' + window.location.search);
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.redirectIfNecessary(newProps);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            // Redirect if Necessary
            this.redirectIfNecessary(this.props);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Setup localization listener
            _localization_store2.default.addChangeListener(this.localizationChanged);

            // Get our localizaiton
            GlobalActions.loadCurrentLocale();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _localization_store2.default.removeChangeListener(this.localizationChanged);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.translations == null || this.props.children == null) {
                return _react2.default.createElement('div', null);
            }

            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                {
                    locale: this.state.locale,
                    messages: this.state.translations,
                    key: this.state.locale
                },
                this.props.children
            );
        }
    }]);
    return Root;
}(_react2.default.Component);

exports.default = Root;


Root.defaultProps = {};

Root.propTypes = {
    children: _propTypes2.default.object
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return FastClick;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());



/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'claim',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1254)).then(RouteUtils.importComponentSuccess(callback));
    },
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        path: 'oauth_to_email',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1255)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'email_to_oauth',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1256)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'ldap_to_email',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1257)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'email_to_ldap',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1258)).then(RouteUtils.importComponentSuccess(callback));
        }
    }])
};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'mfa',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1259)).then(RouteUtils.importComponentSuccess(callback));
    },
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        path: 'setup',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1260)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'confirm',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1261)).then(RouteUtils.importComponentSuccess(callback));
        }
    }])
};

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'create_public_team',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 545)).then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: { onEnter: function onEnter(nextState, replace) {
            return replace('/create_public_team/display_name');
        } },
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        path: 'display_name',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 546)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'team_url',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 547)).then(RouteUtils.importComponentSuccess(callback));
        }
    }])
};

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'create_private_team',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 545)).then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: { onEnter: function onEnter(nextState, replace) {
            return replace('/create_private_team/display_name');
        } },
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        path: 'display_name',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 546)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'team_url',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 547)).then(RouteUtils.importComponentSuccess(callback));
        }
    }])
};

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(171);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(47);

var _extends3 = _interopRequireDefault(_extends2);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

var _es = __webpack_require__(49);

var _team_store = __webpack_require__(48);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _global_actions = __webpack_require__(143);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _status_actions = __webpack_require__(177);

var _channel_actions = __webpack_require__(166);

var _websocket_actions = __webpack_require__(223);

var _app_dispatcher = __webpack_require__(28);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _constants = __webpack_require__(12);

var _constants2 = _interopRequireDefault(_constants);

var _channel_store = __webpack_require__(23);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _browser_store = __webpack_require__(92);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _utils = __webpack_require__(24);

var Utils = _interopRequireWildcard(_utils);

var _route_emoji = __webpack_require__(1220);

var _route_emoji2 = _interopRequireDefault(_route_emoji);

var _route_checkout = __webpack_require__(1221);

var _route_checkout2 = _interopRequireDefault(_route_checkout);

var _route_integrations = __webpack_require__(1222);

var _route_integrations2 = _interopRequireDefault(_route_integrations);

var _user_actions = __webpack_require__(123);

var _redux_store = __webpack_require__(35);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _channels = __webpack_require__(89);

var _channels2 = __webpack_require__(176);

var _teams = __webpack_require__(144);

var _users = __webpack_require__(78);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = _constants2.default.ActionTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// Redux actions

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

function onChannelEnter(nextState, replace, callback) {
    doChannelChange(nextState, replace, callback);
}

function doChannelChange(state, replace, callback) {
    var channel = void 0;
    if (state.location.query.fakechannel) {
        channel = JSON.parse(state.location.query.fakechannel);
    } else {
        var team = _team_store2.default.getByName(state.params.team);
        // assume GM
        if (state.params.channel.length >= 40) {
            channel = _channel_store2.default.getByName(state.params.channel);
        } else {
            var tempChannel = _channel_store2.default.getByTeamIdAndName(team.id, state.params.channel);
            if (tempChannel.id) {
                channel = tempChannel;
            }
        }

        if (channel && channel.type === _constants2.default.DM_CHANNEL) {
            (0, _user_actions.loadNewDMIfNeeded)(channel.id);
        } else if (channel && channel.type === _constants2.default.GM_CHANNEL) {
            (0, _user_actions.loadNewGMIfNeeded)(channel.id);
        }

        if (!channel) {
            (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId(), null, state.params.channel)(dispatch, getState).then(function (result) {
                if (result.data) {
                    GlobalActions.emitChannelClickEvent(result.data.channel);
                } else if (result.error) {
                    if (state.params.team) {
                        replace('/' + state.params.team + '/channels/town-square');
                    } else {
                        replace('/');
                    }
                }
                callback();
            });
            return;
        }
    }
    GlobalActions.emitChannelClickEvent(channel);
    callback();
}

var wakeUpInterval = void 0;
var lastTime = new Date().getTime();
var WAKEUP_CHECK_INTERVAL = 30000; // 30 seconds
var WAKEUP_THRESHOLD = 60000; // 60 seconds

function preNeedsTeam(nextState, replace, callback) {
    if (RouteUtils.checkIfMFARequired(nextState)) {
        _es.browserHistory.push('/mfa/setup');
        return;
    }

    clearInterval(wakeUpInterval);

    wakeUpInterval = setInterval(function () {
        var currentTime = new Date().getTime();
        if (currentTime > lastTime + WAKEUP_THRESHOLD) {
            // ignore small delays
            console.log('computer woke up - fetching latest'); //eslint-disable-line no-console
            (0, _websocket_actions.reconnect)(false);
        }
        lastTime = currentTime;
    }, WAKEUP_CHECK_INTERVAL);

    // First check to make sure you're in the current team
    // for the current url.
    var teamName = nextState.params.team;
    var team = _team_store2.default.getByName(teamName);

    if (!team) {
        _es.browserHistory.push('/?redirect_to=' + encodeURIComponent(nextState.location.pathname));
        return;
    }

    // If current team is set, then this is not first load
    // The first load action pulls team unreads
    if (_team_store2.default.getCurrentId()) {
        (0, _teams.getMyTeamUnreads)()(dispatch, getState);
    }

    _team_store2.default.saveMyTeam(team);
    _browser_store2.default.setGlobalItem('team', team.id);
    _team_store2.default.emitChange();
    GlobalActions.emitSwitchTeamForSearch();

    var d1 = _jquery2.default.Deferred(); //eslint-disable-line new-cap

    (0, _channels2.fetchAllMyChannelsAndMembers)(team.id)(dispatch, getState).then(function () {
        (0, _status_actions.loadStatusesForChannelAndSidebar)();
        (0, _user_actions.loadProfilesForSidebar)();

        d1.resolve();
    });

    _jquery2.default.when(d1).done(function () {
        callback();
    });
}

function selectLastChannel(nextState, replace, callback) {
    var team = _team_store2.default.getByName(nextState.params.team);
    var channelId = _browser_store2.default.getGlobalItem(team.id);
    var channel = _channel_store2.default.getChannelById(channelId);

    var channelName = 'town-square';
    if (channel) {
        channelName = channel.name;
    }

    replace('/' + team.name + '/channels/' + channelName);
    callback();
}

function onPermalinkEnter(nextState, replace, callback) {
    var postId = nextState.params.postid;
    GlobalActions.emitPostFocusEvent(postId, function () {
        return callback();
    });
}

/**
* identifier may either be:
* - A DM user_id length 26 chars
* - A DM channel_id (id1_id2) length 54 chars
* - A GM generated_id length 40 chars
* - A username that starts with an @ sign
* - An email containing an @ sign
**/
function onChannelByIdentifierEnter(state, replace, callback) {
    var identifier = state.params.identifier;

    if (identifier.indexOf('@') === -1) {
        // DM user_id or id1_id2 identifier
        if (identifier.length === 26 || identifier.length === 54) {
            var userId = identifier.length === 26 ? identifier : Utils.getUserIdFromChannelId(identifier);
            var teammate = _user_store2.default.getProfile(userId);
            if (teammate) {
                replace('/' + state.params.team + '/messages/@' + teammate.username);
                callback();
            } else {
                (0, _users.getUser)(userId)(dispatch, getState).then(function (profile) {
                    if (profile) {
                        replace('/' + state.params.team + '/messages/@' + profile.username);
                        callback();
                    } else if (profile == null) {
                        handleError(state, replace, callback);
                    }
                });
            }

            // GM generated_id identifier
        } else if (identifier.length === 40) {
            var channel = _channel_store2.default.getByName(identifier);
            if (channel) {
                (0, _user_actions.loadNewGMIfNeeded)(channel.id);
                GlobalActions.emitChannelClickEvent(channel);
                callback();
            } else {
                (0, _channels.joinChannel)(_user_store2.default.getCurrentId(), _team_store2.default.getCurrentId(), null, identifier)(dispatch, getState).then(function (result) {
                    if (result.data) {
                        GlobalActions.emitChannelClickEvent(result.data.channel);
                        callback();
                    } else if (result.error) {
                        handleError(state, replace, callback);
                    }
                });
            }
        } else {
            handleError(state, replace, callback);
        }
    } else {
        var success = function success(profile) {
            _app_dispatcher2.default.handleServerAction({
                type: ActionTypes.RECEIVED_PROFILE,
                profile: profile
            });
            directChannelToUser(profile, state, replace, callback);
        };

        var error = function error() {
            handleError(state, replace, callback);
        };

        if (identifier.indexOf('@') === 0) {
            // @username identifier
            var username = identifier.slice(1, identifier.length);
            var _teammate = _user_store2.default.getProfileByUsername(username);
            if (_teammate) {
                directChannelToUser(_teammate, state, replace, callback);
            } else {
                (0, _users.getUserByUsername)(username)(dispatch, getState).then(function (data) {
                    if (data && success) {
                        success(data);
                    } else if (data == null && error) {
                        var serverError = getState().requests.users.getUserByUsername.error;
                        error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
                    }
                });
            }
        } else if (identifier.indexOf('@') > 0) {
            // email identifier
            var email = identifier;
            var _teammate2 = _user_store2.default.getProfileByEmail(email);
            if (_teammate2) {
                directChannelToUser(_teammate2, state, replace, callback);
            } else {
                (0, _users.getUserByEmail)(email)(dispatch, getState).then(function (data) {
                    if (data && success) {
                        success(data);
                    } else if (data == null && error) {
                        var serverError = getState().requests.users.getUser.error;
                        error((0, _extends3.default)({ id: serverError.server_error_id }, serverError));
                    }
                });
            }
        }
    }
}

function directChannelToUser(profile, state, replace, callback) {
    (0, _channel_actions.openDirectChannelToUser)(profile.id, function (channel) {
        GlobalActions.emitChannelClickEvent(channel);
        callback();
    }, function () {
        handleError(state, replace, callback);
    });
}

function handleError(state, replace, callback) {
    if (state.params.team) {
        replace('/' + state.params.team + '/channels/' + _constants2.default.DEFAULT_CHANNEL);
    } else {
        replace('/');
    }
    callback();
}

exports.default = {
    path: ':team',
    onEnter: preNeedsTeam,
    indexRoute: { onEnter: selectLastChannel },
    childRoutes: [_route_integrations2.default, _route_emoji2.default, _route_checkout2.default, {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 309)).then(RouteUtils.importComponentSuccess(callback));
        },
        getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
            path: 'select_theme',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1281)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'team_picture',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1282)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'create_team_landing',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1283)).then(RouteUtils.importComponentSuccess(callback));
            }
        }])
    }, {
        path: 'invoice',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1284)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1285)).then(RouteUtils.importComponentSuccess(callback));
        },
        childRoutes: [{
            path: 'channels/:channel',
            onEnter: onChannelEnter,
            getComponents: function getComponents(location, callback) {
                _promise2.default.all([__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 224)), __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 225)), __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 550)), __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 226))]).then(function (comarr) {
                    return callback(null, { team_sidebar: comarr[0].default, sidebar: comarr[1].default, center: comarr[2].default, new_sidebar: comarr[3].default });
                });
            }
        }, {
            path: 'pl/:postid',
            onEnter: onPermalinkEnter,
            getComponents: function getComponents(location, callback) {
                _promise2.default.all([__webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 224)), __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 225)), __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1286)), __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 226))]).then(function (comarr) {
                    return callback(null, { team_sidebar: comarr[0].default, sidebar: comarr[1].default, center: comarr[2].default, new_sidebar: comarr[3].default });
                });
            }
        }, {
            path: 'messages/:identifier',
            onEnter: onChannelByIdentifierEnter,
            getComponents: function getComponents(location, callback) {
                _promise2.default.all([__webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 224)), __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 225)), __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 550)), __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 226))]).then(function (comarr) {
                    return callback(null, { team_sidebar: comarr[0].default, sidebar: comarr[1].default, center: comarr[2].default, new_sidebar: comarr[3].default });
                });
            }
        }, {
            path: 'tutorial',
            getComponents: function getComponents(location, callback) {
                _promise2.default.all([__webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 224)), __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 225)), __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1252)), __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 226))]).then(function (comarr) {
                    return callback(null, { team_sidebar: comarr[0].default, sidebar: comarr[1].default, center: comarr[2].default, new_sidebar: comarr[3].default });
                });
            }
        }]
    }]
};

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'emoji',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 548)).then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1262)).then(RouteUtils.importComponentSuccess(callback));
        }
    },
    childRoutes: [{
        path: 'add',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1263)).then(RouteUtils.importComponentSuccess(callback));
        }
    }]
}; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'billing',
    getComponents: function getComponents(location, callback) {
        // System.import('components/checkout/checkout_controller.jsx').then(RouteUtils.importComponentSuccess(callback));
        __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1264)).then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1265)).then(RouteUtils.importComponentSuccess(callback));
        }
    },
    // indexRoute: {onEnter: (nextState, replace) => replace('/create_team/display_name')},
    getChildRoutes: RouteUtils.createGetChildComponentsFunction([{
        path: 'address',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1266)).then(RouteUtils.importComponentSuccess(callback));
        }
    }, {
        path: 'checkout',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1267)).then(RouteUtils.importComponentSuccess(callback));
        }

        // ,
        // {
        //     path: 'team_url',
        //     getComponents: (location, callback) => {
        //         System.import('components/create_team/components/team_url.jsx').then(RouteUtils.importComponentSuccess(callback));
        //     }
        // }
    }])
};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'integrations',
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 548)).then(RouteUtils.importComponentSuccess(callback));
    },
    indexRoute: {
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1268)).then(RouteUtils.importComponentSuccess(callback));
        }
    },
    childRoutes: [{
        path: 'incoming_webhooks',
        indexRoute: {
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1269)).then(RouteUtils.importComponentSuccess(callback));
            }
        },
        childRoutes: [{
            path: 'add',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1270)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'edit',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1271)).then(RouteUtils.importComponentSuccess(callback));
            }
        }]
    }, {
        path: 'outgoing_webhooks',
        indexRoute: {
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1272)).then(RouteUtils.importComponentSuccess(callback));
            }
        },
        childRoutes: [{
            path: 'add',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1273)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'edit',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1274)).then(RouteUtils.importComponentSuccess(callback));
            }
        }]
    }, {
        path: 'commands',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1275)).then(RouteUtils.importComponentSuccess(callback));
        },
        indexRoute: { onEnter: function onEnter(nextState, replace) {
                return replace(nextState.location.pathname + '/installed');
            } },
        childRoutes: [{
            path: 'installed',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1276)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'add',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1277)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'edit',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1278)).then(RouteUtils.importComponentSuccess(callback));
            }
        }, {
            path: 'confirm',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 549)).then(RouteUtils.importComponentSuccess(callback));
            }
        }]
    }, {
        path: 'oauth2-apps',
        indexRoute: {
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1279)).then(RouteUtils.importComponentSuccess(callback));
            }
        },
        childRoutes: [{
            path: 'add',
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1280)).then(RouteUtils.importComponentSuccess(callback));
            }
        }]
    }, {
        path: 'confirm',
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 549)).then(RouteUtils.importComponentSuccess(callback));
        }
    }]
}; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    path: 'help',
    indexRoute: { onEnter: function onEnter(nextState, replace) {
            return replace('/help/messaging');
        } },
    childRoutes: [{
        getComponents: function getComponents(location, callback) {
            __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1287)).then(RouteUtils.importComponentSuccess(callback));
        },
        childRoutes: [{
            path: 'messaging',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1288)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'composing',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1289)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'mentioning',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1290)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'formatting',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1291)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'attaching',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1292)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'commands',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1293)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }, {
            path: 'keyboard_shortcut',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1294)).then(RouteUtils.importComponentSuccess(callback));
                }
                // },{
                //     path: 'theme-colors',
                //     indexRoute: {
                //         getComponents: (location, callback) => {
                //             System.import('components/help/components/settings/theme_colors.jsx').then(RouteUtils.importComponentSuccess(callback));
                //         }
                //     }
                // },{
                //     path: 'web-visitor-center',
                //     indexRoute: {
                //         getComponents: (location, callback) => {
                //             System.import('components/help/components/web_visitor_center.jsx').then(RouteUtils.importComponentSuccess(callback));
                //         }
                //     }
            } }, {
            path: 'photo-compression',
            indexRoute: {
                getComponents: function getComponents(location, callback) {
                    __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1295)).then(RouteUtils.importComponentSuccess(callback));
                }
            }
        }]
    }]
}; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_utils = __webpack_require__(59);

var RouteUtils = _interopRequireWildcard(_route_utils);

var _user_store = __webpack_require__(21);

var _user_store2 = _interopRequireDefault(_user_store);

var _es = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function preGetUser(nextState, replace, callback) {
    var user = _user_store2.default.getCurrentUser();
    if (!user) {
        _es.browserHistory.push('/?redirect_to=' + encodeURIComponent(nextState.location.pathname));
        return;
    }
    callback();
}

exports.default = {
    path: 'talkto/:target',
    onEnter: preGetUser,
    getComponents: function getComponents(location, callback) {
        __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1296)).then(RouteUtils.importComponentSuccess(callback));
    }

};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = __webpack_require__(1226);



/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var ps = __webpack_require__(1227);
var psInstances = __webpack_require__(46);

function mountJQuery(jQuery) {
  jQuery.fn.perfectScrollbar = function (settingOrCommand) {
    return this.each(function () {
      if (typeof settingOrCommand === 'object' ||
          typeof settingOrCommand === 'undefined') {
        // If it's an object or none, initialize.
        var settings = settingOrCommand;

        if (!psInstances.get(this)) {
          ps.initialize(this, settings);
        }
      } else {
        // Unless, it may be a command.
        var command = settingOrCommand;

        if (command === 'update') {
          ps.update(this);
        } else if (command === 'destroy') {
          ps.destroy(this);
        }
      }
    });
  };
}

if (true) {
  // AMD. Register as an anonymous module.
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mountJQuery),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  var jq = window.jQuery ? window.jQuery : window.$;
  if (typeof jq !== 'undefined') {
    mountJQuery(jq);
  }
}

module.exports = mountJQuery;



/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var destroy = __webpack_require__(1228);
var initialize = __webpack_require__(1232);
var update = __webpack_require__(1240);

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};



/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var dom = __webpack_require__(121);
var instances = __webpack_require__(46);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  dom.remove(i.scrollbarX);
  dom.remove(i.scrollbarY);
  dom.remove(i.scrollbarXRail);
  dom.remove(i.scrollbarYRail);
  _.removePsClasses(element);

  instances.remove(element);
};



/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = {
  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};



/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;



/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();



/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var cls = __webpack_require__(211);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);

// Handlers
var handlers = {
  'click-rail': __webpack_require__(1233),
  'drag-scrollbar': __webpack_require__(1234),
  'keyboard': __webpack_require__(1235),
  'wheel': __webpack_require__(1236),
  'touch': __webpack_require__(1237),
  'selection': __webpack_require__(1238)
};
var nativeScrollHandler = __webpack_require__(1239);

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = _.extend(i.settings, userSettings);
  cls.add(element, 'ps--theme_' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  nativeScrollHandler(element);

  updateGeometry(element);
};



/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = function (e) { e.stopPropagation(); };

  i.event.bind(i.scrollbarY, 'click', stopPropagation);
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
    updateGeometry(element);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'click', stopPropagation);
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};



/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var dom = __webpack_require__(121);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
    _.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
    _.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};



/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var dom = __webpack_require__(121);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
      return;
    }

    var focused = dom.matches(i.scrollbarX, ':focus') ||
                  dom.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (_.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      if (e.metaKey) {
        deltaX = -i.contentWidth;
      } else if (e.altKey) {
        deltaX = -i.containerWidth;
      } else {
        deltaX = -30;
      }
      break;
    case 38: // up
      if (e.metaKey) {
        deltaY = i.contentHeight;
      } else if (e.altKey) {
        deltaY = i.containerHeight;
      } else {
        deltaY = 30;
      }
      break;
    case 39: // right
      if (e.metaKey) {
        deltaX = i.contentWidth;
      } else if (e.altKey) {
        deltaX = i.containerWidth;
      } else {
        deltaX = 30;
      }
      break;
    case 40: // down
      if (e.metaKey) {
        deltaY = -i.contentHeight;
      } else if (e.altKey) {
        deltaY = -i.containerHeight;
      } else {
        deltaY = -30;
      }
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};



/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(deltaX, deltaY) {
    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
    if (child) {
      var style = window.getComputedStyle(child);
      var overflow = [
        style.overflow,
        style.overflowX,
        style.overflowY
      ].join('');

      if (!overflow.match(/(scroll|auto)/)) {
        // if not scrollable
        return false;
      }

      var maxScrollTop = child.scrollHeight - child.clientHeight;
      if (maxScrollTop > 0) {
        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = child.scrollLeft - child.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByChild(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};



/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inLocalTouch && i.settings.swipePropagation) {
      touchStart(e);
    }
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      if (i.settings.swipeEasing) {
        clearInterval(easingLoop);
        easingLoop = setInterval(function () {
          if (!instances.get(element)) {
            clearInterval(easingLoop);
            return;
          }

          if (!speed.x && !speed.y) {
            clearInterval(easingLoop);
            return;
          }

          if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
            clearInterval(easingLoop);
            return;
          }

          applyTouchMove(speed.x * 30, speed.y * 30);

          speed.x *= 0.8;
          speed.y *= 0.8;
        }, 10);
      }
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element) {
  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
    return;
  }

  var i = instances.get(element);
  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
};



/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    _.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'keyup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        _.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        _.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        _.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        _.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};



/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};



/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var $ = __webpack_require__(0);
var jQuery = __webpack_require__(0);

'use strict';

var _ = __webpack_require__(86);
var dom = __webpack_require__(121);
var instances = __webpack_require__(46);
var updateGeometry = __webpack_require__(87);
var updateScroll = __webpack_require__(102);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  dom.css(i.scrollbarXRail, 'display', 'none');
  dom.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  dom.css(i.scrollbarXRail, 'display', '');
  dom.css(i.scrollbarYRail, 'display', '');
};



/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<!DOCTYPE html> <html> <head> <meta http-equiv=X-UA-Compatible content=\"IE=edge\"> <meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=0\"> <meta name=robots content=\"noindex, nofollow\"> <meta name=referrer content=no-referrer> <title>Cordchat</title> <meta name=apple-mobile-web-app-capable content=yes> <meta name=apple-mobile-web-app-status-bar-style content=default> <meta name=mobile-web-app-capable content=yes> <meta name=apple-mobile-web-app-title content=Cordchat> <meta name=application-name content=Cordchat> <meta name=format-detection content=\"telephone=no\"> <meta property=og:type content=website /> <meta property=og:title content=\"Cordchat - Communication Tool\"/> <meta property=og:image content=http://saas.cordchat.com/static/images/favicon/favicon-96x96.png /> <meta property=og:site_name content=Cordchat /> <meta property=og:description content=\"Respect employee privacy and let personal message tool stay personal.\"/> <link rel=apple-touch-icon sizes=57x57 href=" + __webpack_require__(1242) + "> <link rel=apple-touch-icon sizes=60x60 href=" + __webpack_require__(1243) + "> <link rel=apple-touch-icon sizes=72x72 href=" + __webpack_require__(1244) + "> <link rel=apple-touch-icon sizes=76x76 href=" + __webpack_require__(1245) + "> <link rel=apple-touch-icon sizes=144x144 href=" + __webpack_require__(1246) + "> <link rel=apple-touch-icon sizes=120x120 href=" + __webpack_require__(1247) + "> <link rel=apple-touch-icon sizes=152x152 href=" + __webpack_require__(1248) + "> <link rel=icon type=image/png sizes=16x16 href=" + __webpack_require__(538) + "> <link rel=icon type=image/png sizes=32x32 href=" + __webpack_require__(1249) + "> <link rel=icon type=image/png sizes=96x96 href=" + __webpack_require__(1250) + "> <link rel=icon type=image/png sizes=192x192 href=" + __webpack_require__(552) + "> <link rel=manifest href=" + __webpack_require__(1251) + "> <link rel=stylesheet class=code_theme> <style>.error-screen{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;padding-top:50px;max-width:750px;font-size:14px;color:#333;margin:auto;display:none;line-height:1.5}.error-screen h2{font-size:30px;font-weight:400;line-height:1.2}.error-screen ul{padding-left:15px;line-height:1.7;margin-top:0;margin-bottom:10px}.error-screen hr{color:#ddd;margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.error-screen-visible{display:block}</style> </head> <body class=font--open_sans> <div id=root> <div class=error-screen> <h2>Cannot connect to Cordchat</h2> <hr/> <p>We’re having trouble connecting to Cordchat. If refreshing this page (Ctrl+R or Command+R) does not work, please verify that your computer is connected to the internet.</p> <br/> </div> <div class=loading-screen style=position:relative> <div class=loading__content> <div class=\"round round-1\"></div> <div class=\"round round-2\"></div> <div class=\"round round-3\"></div> </div> </div> </div> <script>\"function\"!=typeof window.setup_root&&document.querySelector(\".error-screen\").classList.add(\"error-screen-visible\"),window.setup_root()</script> <noscript> To use Cordchat, please enable JavaScript. </noscript> </body> </html> ";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/604bf4d36ace40d1690cf583e802769e.png";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fe030a26c83e1ec08846779d5d315acc.png";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ffe292cf22f42eb2d5d54fcc1cc73a98.png";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/bdd468b46f094a1c3b429d90fd8b2b22.png";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/532a32234ef60aa02cfb492a2b44e24c.png";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/0119fe47ed9daa195d94acd6692e579d.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/c7b1f26c59130a66e3366338aa76482e.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/04cabd153198c72a77c6c4a22136caf4.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/c7c2b3534d79c699a86d92505b75d0e9.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/3f694dd643b6c7cbc4b3b009690db4e1.json";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.8791eac700b3a6db452c.js